'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React$2 = require('react');
var PropTypes$2 = require('prop-types');
var ReactDOM = require('react-dom');
var events = require('events');
var ReactDOMServer = require('react-dom/server');
var crypto = require('crypto');
var util = require('util');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React$2);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes$2);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
var events__default = /*#__PURE__*/_interopDefaultLegacy(events);
var ReactDOMServer__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOMServer);
var crypto__default = /*#__PURE__*/_interopDefaultLegacy(crypto);
var util__default = /*#__PURE__*/_interopDefaultLegacy(util);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@keyframes Avatar_fadein__1ILNY {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes Avatar_fadein__1ILNY {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes Avatar_fadein__1ILNY {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes Avatar_fadein__1ILNY {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes Avatar_fadein__1ILNY {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.Avatar_ls-avatar__XtF3v {\n  display: inline-block;\n  background: #4eb3d4;\n  color: #ffffff;\n  line-height: normal;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: 500;\n  font-family: 'tyepaloon', monospace;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n  .Avatar_ls-avatar__XtF3v .Avatar_rounded-circle__3prmT {\n    border-radius: 50%; }\n  .Avatar_ls-avatar__XtF3v.Avatar_sm__L9_Zv {\n    width: 25px;\n    height: 25px;\n    font-size: 10px; }\n    .Avatar_ls-avatar__XtF3v.Avatar_sm__L9_Zv img {\n      width: 100%;\n      height: 100%; }\n    .Avatar_ls-avatar__XtF3v.Avatar_sm__L9_Zv .Avatar_initials-avatar__HcjAj {\n      line-height: 22px;\n      height: 100%; }\n    .Avatar_ls-avatar__XtF3v.Avatar_sm__L9_Zv i {\n      line-height: 22px;\n      height: 100%; }\n  .Avatar_ls-avatar__XtF3v.Avatar_md__1c9dV {\n    width: 45px;\n    height: 45px;\n    font-size: 18px; }\n    .Avatar_ls-avatar__XtF3v.Avatar_md__1c9dV img {\n      width: 100%;\n      height: 100%; }\n    .Avatar_ls-avatar__XtF3v.Avatar_md__1c9dV .Avatar_initials-avatar__HcjAj {\n      line-height: 45px;\n      height: 100%; }\n    .Avatar_ls-avatar__XtF3v.Avatar_md__1c9dV i {\n      line-height: 45px;\n      height: 100%; }\n  .Avatar_ls-avatar__XtF3v.Avatar_lg__109lw {\n    width: 75px;\n    height: 75px;\n    font-size: 36px; }\n    .Avatar_ls-avatar__XtF3v.Avatar_lg__109lw img {\n      width: 100%;\n      height: 100%; }\n    .Avatar_ls-avatar__XtF3v.Avatar_lg__109lw .Avatar_initials-avatar__HcjAj {\n      line-height: 74px;\n      height: 100%; }\n    .Avatar_ls-avatar__XtF3v.Avatar_lg__109lw i {\n      line-height: 74px;\n      height: 100%; }\n";
styleInject(css_248z);

var Avatar = /*#__PURE__*/function (_React$Component) {
  _inherits(Avatar, _React$Component);

  var _super = _createSuper(Avatar);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _super.apply(this, arguments);
  }

  _createClass(Avatar, [{
    key: "getUserInitials",
    value: function getUserInitials() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return name.toUpperCase().split(' ').map(function (n) {
        return n[0];
      });
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      var _this$props = this.props,
          styles = _this$props.styles,
          background = _this$props.background,
          color = _this$props.color,
          onClick = _this$props.onClick;
      var newStyles = Object.assign({}, styles);

      if (onClick) {
        newStyles.cursor = 'pointer';
      }

      if (background) {
        newStyles.background = background;
      }

      if (color) {
        newStyles.color = color;
      }

      return newStyles;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          profilePic = _this$props2.profilePic,
          name = _this$props2.name,
          icon = _this$props2.icon,
          size = _this$props2.size,
          onClick = _this$props2.onClick;
      var newStyles = this.getStyles();
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ls-avatar ".concat(className, " ").concat(size),
        style: newStyles,
        onClick: onClick
      }, profilePic ? /*#__PURE__*/React__default['default'].createElement("img", {
        src: profilePic,
        className: "rounded-circle",
        alt: "user avatar"
      }) : name ? /*#__PURE__*/React__default['default'].createElement("div", {
        className: "initials-avatar"
      }, this.getUserInitials(name)) : /*#__PURE__*/React__default['default'].createElement("div", {
        className: "empty-avatar"
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: icon
      })));
    }
  }]);

  return Avatar;
}(React__default['default'].Component);
Avatar.propTypes = {
  className: PropTypes__default['default'].string,
  styles: PropTypes__default['default'].object,
  profilePic: PropTypes__default['default'].string,
  name: PropTypes__default['default'].string,
  icon: PropTypes__default['default'].string,
  background: PropTypes__default['default'].string,
  color: PropTypes__default['default'].string,
  size: PropTypes__default['default'].oneOf(['sm', 'md', 'lg']),
  onClick: PropTypes__default['default'].func
};
Avatar.defaultProps = {
  className: '',
  styles: {
    background: ''
  },
  icon: 'fas fa-user',
  size: 'md'
};

var css_248z$1 = "@keyframes Banner_fadein__25k9N {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes Banner_fadein__25k9N {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes Banner_fadein__25k9N {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes Banner_fadein__25k9N {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes Banner_fadein__25k9N {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.Banner_banner__P-AO9 {\n  padding: 1rem;\n  background-color: #00acc1;\n  filter: drop-shadow(0rem 0.05rem 0.75rem grey);\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.Banner_banner-copy__3rB58 {\n  color: white;\n  font-size: 1.25rem;\n  margin: 0;\n  font-weight: 700; }\n";
styleInject(css_248z$1);

var Banner = function Banner(_ref) {
  var copy = _ref.copy;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "banner"
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: "banner-copy"
  }, copy));
};

var css_248z$2 = "@keyframes Button_fadein__2vbG_ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes Button_fadein__2vbG_ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes Button_fadein__2vbG_ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes Button_fadein__2vbG_ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes Button_fadein__2vbG_ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.Button_ls-button__3edBN {\n  font: 14px \"GothamMedium\", sans-serif;\n  line-height: normal;\n  font-weight: 900;\n  padding: 10px 40px;\n  background: #4eb3d4;\n  color: #ffffff;\n  border-color: transparent;\n  border-radius: 60px;\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 14px;\n  cursor: pointer;\n  outline: none !important;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  min-height: 24px;\n  line-height: normal;\n  outline: none !important; }\n  .Button_ls-button__3edBN:hover {\n    opacity: 0.9; }\n  .Button_ls-button__3edBN.Button_clear__NJ1Nn {\n    background: transparent;\n    color: #4eb3d4;\n    border: 2px solid #4eb3d4; }\n    .Button_ls-button__3edBN.Button_clear__NJ1Nn:hover {\n      background: #4eb3d4;\n      color: #ffffff; }\n  .Button_ls-button__3edBN.Button_clear__NJ1Nn.Button_salmon__1-kkG {\n    background: transparent;\n    color: #f16153;\n    border: 2px solid #f16153; }\n    .Button_ls-button__3edBN.Button_clear__NJ1Nn.Button_salmon__1-kkG:hover {\n      background: #f16153;\n      color: #ffffff; }\n  .Button_ls-button__3edBN.Button_clear__NJ1Nn.Button_slate__yckL- {\n    background: transparent;\n    color: #212126;\n    border: 2px solid #212126; }\n    .Button_ls-button__3edBN.Button_clear__NJ1Nn.Button_slate__yckL-:hover {\n      background: #212126;\n      color: #ffffff; }\n  .Button_ls-button__3edBN:focus, .Button_ls-button__3edBN:active {\n    outline: 0; }\n  .Button_ls-button__3edBN.Button_small__2g5Iv {\n    padding: 5px 20px !important; }\n  .Button_ls-button__3edBN:disabled {\n    opacity: 0.5;\n    cursor: not-allowed; }\n  .Button_ls-button__3edBN:active {\n    outline: none !important; }\n";
styleInject(css_248z$2);

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function () {
      if (!_this.props.disabled) {
        try {
          _this.props.onClick(_this.props.name || '');
        } catch (e) {
          console.error('No onClick handler defined');
        }
      }
    });

    var _this$props = _this.props,
        color = _this$props.color,
        background = _this$props.background,
        size = _this$props.size;
    _this.styles = {
      background: background,
      color: color,
      fontSize: Button.sizes[size]
    };
    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          size = _this$props2.size,
          styles = _this$props2.styles,
          children = _this$props2.children,
          disabled = _this$props2.disabled;
      return /*#__PURE__*/React__default['default'].createElement("button", {
        className: "ls-button ".concat(classes, " ").concat(size),
        style: _objectSpread2({}, Object.assign(styles, this.styles)),
        type: "button",
        onClick: this.handleOnClick,
        disabled: disabled
      }, children);
    }
  }]);

  return Button;
}(React__default['default'].Component);
Button.propTypes = {
  classes: PropTypes__default['default'].string,
  background: PropTypes__default['default'].string,
  color: PropTypes__default['default'].string,
  size: PropTypes__default['default'].oneOf(['small', 'normal', 'large']),
  styles: PropTypes__default['default'].object,
  onClick: PropTypes__default['default'].func,
  children: PropTypes__default['default'].any.isRequired
};
Button.defaultProps = {
  classes: '',
  size: 'normal',
  styles: {}
};
Button.sizes = {
  small: '12px',
  normal: '14px',
  large: '20px'
};

var css_248z$3 = "@keyframes Card_fadein__5PFBn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes Card_fadein__5PFBn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes Card_fadein__5PFBn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes Card_fadein__5PFBn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes Card_fadein__5PFBn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.Card_ls-card__3O-8Z {\n  font: 14px \"Gotham\", sans-serif;\n  line-height: normal;\n  font-weight: 400;\n  position: relative;\n  display: inline-block;\n  margin-bottom: 24px;\n  cursor: default;\n  min-width: 200px;\n  background: #ffffff;\n  box-shadow: 0 0 10px 0 #eaeaea;\n  border-radius: 13px;\n  overflow: hidden; }\n  .Card_ls-card__3O-8Z.Card_cutout-right__1xGwQ {\n    overflow: visible; }\n    .Card_ls-card__3O-8Z.Card_cutout-right__1xGwQ:after {\n      display: block;\n      content: '';\n      position: absolute;\n      top: 55px;\n      right: -10px;\n      width: 52px;\n      height: 60%;\n      border-radius: 13px;\n      background: #f4f7f9;\n      z-index: 999; }\n    .Card_ls-card__3O-8Z.Card_cutout-right__1xGwQ .Card_cutout__3CgC6 {\n      display: block;\n      position: absolute;\n      top: 55px;\n      right: -10px;\n      width: 52px;\n      height: 60%;\n      border-radius: 13px;\n      background: #f4f7f9;\n      z-index: 999; }\n  .Card_ls-card__3O-8Z.Card_cutout-left__1YW7Q {\n    overflow: visible; }\n    .Card_ls-card__3O-8Z.Card_cutout-left__1YW7Q:after {\n      display: block;\n      content: '';\n      position: absolute;\n      top: 55px;\n      left: -10px;\n      width: 52px;\n      height: 60%;\n      border-radius: 13px;\n      background: #f4f7f9;\n      z-index: 999; }\n    .Card_ls-card__3O-8Z.Card_cutout-left__1YW7Q .Card_cutout__3CgC6 {\n      display: block;\n      position: absolute;\n      top: 55px;\n      left: -10px;\n      width: 52px;\n      height: 60%;\n      border-radius: 13px;\n      background: #f4f7f9;\n      z-index: 999; }\n  .Card_ls-card__3O-8Z .Card_card-image__3RwyZ {\n    max-height: 270px;\n    border-top-left-radius: 13px;\n    border-top-right-radius: 13px;\n    overflow: hidden; }\n  .Card_ls-card__3O-8Z img {\n    height: 202px;\n    width: 101%;\n    margin: 0 -2px -5px;\n    cursor: pointer; }\n  .Card_ls-card__3O-8Z .Card_card-body__1DdVt {\n    position: relative;\n    padding: 20px 20px 15px; }\n    .Card_ls-card__3O-8Z .Card_card-body__1DdVt .Card_card-title__3vk_e,\n    .Card_ls-card__3O-8Z .Card_card-body__1DdVt .Card_card-header__hFiat {\n      margin-top: 0;\n      font-weight: 500; }\n  .Card_ls-card__3O-8Z .Card_card-footer__1JKiG {\n    position: relative;\n    padding: 15px 20px;\n    font-size: 14px;\n    min-height: 18px; }\n    .Card_ls-card__3O-8Z .Card_card-footer__1JKiG .Card_card-icon__4LqNq i {\n      position: absolute;\n      top: 14px;\n      right: 20px;\n      font-size: 20px;\n      color: #212126;\n      cursor: pointer; }\n    .Card_ls-card__3O-8Z .Card_card-footer__1JKiG .Card_card-icon__4LqNq i.Card_left__3Rnzg {\n      left: 20px; }\n    .Card_ls-card__3O-8Z .Card_card-footer__1JKiG .Card_card-icon__4LqNq:focus, .Card_ls-card__3O-8Z .Card_card-footer__1JKiG .Card_card-icon__4LqNq:active {\n      opacity: 0.6; }\n";
styleInject(css_248z$3);

function Card(props) {
  var className = props.className,
      styles = props.styles,
      children = props.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ls-card ".concat(className),
    style: styles
  }, children);
}
Card.propTypes = {
  className: PropTypes__default['default'].string,
  styles: PropTypes__default['default'].object,
  children: PropTypes__default['default'].any
};
Card.defaultProps = {
  className: '',
  styles: {},
  children: null
};

function CardImage(props) {
  var className = props.className,
      styles = props.styles,
      imgUrl = props.imgUrl,
      linkUrl = props.linkUrl,
      newTab = props.newTab,
      children = props.children;
  return imgUrl && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "card-image ".concat(className),
    style: styles
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: linkUrl,
    target: newTab ? '_blank' : '_self',
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    className: "card-img-top img-fluid",
    src: imgUrl,
    alt: "Card cap",
    style: {
      cursor: "".concat(linkUrl ? 'cursor' : 'default')
    }
  })), children);
}
CardImage.propTypes = {
  className: PropTypes__default['default'].string,
  styles: PropTypes__default['default'].object,
  imgUrl: PropTypes__default['default'].string,
  linkUrl: PropTypes__default['default'].string,
  newTab: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].array
};
CardImage.defaultProps = {
  className: '',
  styles: {},
  imgUrl: null,
  linkUrl: null,
  newTab: false,
  children: null
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var bundle = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e(React__default['default']);}("undefined"!=typeof self?self:commonjsGlobal,function(t){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i});},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/dist/",e(e.s=0)}([function(t,e,n){function i(t){return t&&t.__esModule?t:{default:t}}function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e);}Object.defineProperty(e,"__esModule",{value:!0});var u=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i);}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),a=n(1),c=n(2),l=i(c),f=n(4),p=i(f),h=function(t){function e(t){r(this,e);var n=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.isSupportNativeClamp=!1,n.truncate=n.truncate.bind(n),n.process=n.process.bind(n),n.debounceProcess=(0, l.default)(n.process,n.props.debounceTimeoutOnResize),n.text="",n.lineHeight=0,n.splitOnChars=[".","-","–","—"," "],n.splitChar=n.splitOnChars[0],n.chunks=null,n.lastChunk=null,n}return s(e,t),u(e,[{key:"componentDidMount",value:function(){this.isSupportNativeClamp=!this.props.useJsOnly&&"webkitLineClamp"in document.body.style,this.text=this.container.innerHTML,this.process(),window.addEventListener("resize",this.debounceProcess,!1);}},{key:"componentDidUpdate",value:function(){this.text=this.container.innerHTML,this.process();}},{key:"componentWillUnmount",value:function(){window.removeEventListener("resize",this.debounceProcess,!1);}},{key:"onResult",value:function(){this.container.scrollWidth>this.container.clientWidth||this.container.scrollHeight>this.container.clientHeight?this.props.onResult(e.RESULT.TRUNCATED):this.props.onResult(e.RESULT.NOT_TRUNCATED);}},{key:"getLineHeight",value:function(){var t=this.computedStyle("line-height");return "normal"===t?Math.ceil(1.2*parseFloat(this.computedStyle("font-size"))):Math.ceil(parseFloat(t))}},{key:"truncate",value:function(){if(this.chunks||(this.splitOnChars.length>0?this.splitChar=this.splitOnChars.shift():this.splitChar="",this.chunks=this.container.innerHTML.split(this.splitChar)),this.chunks.length>1?(this.lastChunk=this.chunks.pop(),this.container.innerHTML=this.chunks.join(this.splitChar)+this.props.ellipsisChars):this.chunks=null,this.chunks){if(this.container.offsetHeight<=this.lineHeight*this.props.lines){if(!(this.splitOnChars.length>=0&&""!==this.splitChar))return;this.container.innerHTML=this.chunks.join(this.splitChar)+this.splitChar+this.lastChunk,this.chunks=null;}}else if(""===this.splitChar)return;this.truncate();}},{key:"process",value:function(){if(this.isSupportNativeClamp){var t=this.container.style;t.overflow="hidden",t.textOverflow="ellipsis",t.webkitBoxOrient="vertical",t.display="-webkit-box",t.webkitLineClamp=this.props.lines,this.onResult();}else this.lineHeight=this.getLineHeight(),this.container.offsetHeight<this.lineHeight*this.props.lines?this.onResult():this.truncate();}},{key:"computedStyle",value:function(t){return document.defaultView.getComputedStyle(this.container,null).getPropertyValue(t)}},{key:"render",value:function(){var t=this;return (0, a.createElement)(this.props.tag,{ref:function(e){t.container=e;},className:this.props.tagClass,style:Object.assign({width:"100%",wordWrap:"break-word"},this.props.style)},this.props.children)}}]),e}(a.PureComponent);h.RESULT={TRUNCATED:"TRUNCATED",NOT_TRUNCATED:"NOT_TRUNCATED"},h.propTypes={lines:p.default.number.isRequired,children:p.default.element.isRequired,tag:p.default.string,ellipsisChars:p.default.string,tagClass:p.default.string,debounceTimeoutOnResize:p.default.number,useJsOnly:p.default.bool,onResult:p.default.func,style:p.default.object},h.defaultProps={tag:"div",ellipsisChars:"...",tagClass:"",debounceTimeoutOnResize:200,useJsOnly:!1,style:{},onResult:function(){}},e.default=h;},function(e,n){e.exports=t;},function(t,e,n){(function(e){function n(t,e,n){function r(e){var n=y,i=b;return y=b=void 0,w=e,m=t.apply(i,n)}function o(t){return w=t,T=setTimeout(l,e),x?r(t):m}function a(t){var n=t-R,i=t-w,r=e-n;return k?O(r,v-i):r}function c(t){var n=t-R,i=t-w;return void 0===R||n>=e||n<0||k&&i>=v}function l(){var t=C();if(c(t))return f(t);T=setTimeout(l,a(t));}function f(t){return T=void 0,j&&y?r(t):(y=b=void 0,m)}function p(){void 0!==T&&clearTimeout(T),w=0,y=R=b=T=void 0;}function h(){return void 0===T?m:f(C())}function d(){var t=C(),n=c(t);if(y=arguments,b=this,R=t,n){if(void 0===T)return o(R);if(k)return T=setTimeout(l,e),r(R)}return void 0===T&&(T=setTimeout(l,e)),m}var y,b,v,m,T,R,w=0,x=!1,k=!1,j=!0;if("function"!=typeof t)throw new TypeError(u);return e=s(e)||0,i(n)&&(x=!!n.leading,k="maxWait"in n,v=k?g(s(n.maxWait)||0,e):v,j="trailing"in n?!!n.trailing:j),d.cancel=p,d.flush=h,d}function i(t){var e=typeof t;return !!t&&("object"==e||"function"==e)}function r(t){return !!t&&"object"==typeof t}function o(t){return "symbol"==typeof t||r(t)&&T.call(t)==c}function s(t){if("number"==typeof t)return t;if(o(t))return a;if(i(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=i(e)?e+"":e;}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(l,"");var n=p.test(t);return n||h.test(t)?d(t.slice(2),n?2:8):f.test(t)?a:+t}var u="Expected a function",a=NaN,c="[object Symbol]",l=/^\s+|\s+$/g,f=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,h=/^0o[0-7]+$/i,d=parseInt,y="object"==typeof e&&e&&e.Object===Object&&e,b="object"==typeof self&&self&&self.Object===Object&&self,v=y||b||Function("return this")(),m=Object.prototype,T=m.toString,g=Math.max,O=Math.min,C=function(){return v.Date.now()};t.exports=n;}).call(e,n(3));},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this");}catch(t){"object"==typeof window&&(n=window);}t.exports=n;},function(t,e,n){t.exports=n(5)();},function(t,e,n){var i=n(6),r=n(7),o=n(8);t.exports=function(){function t(t,e,n,i,s,u){u!==o&&r(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e};return n.checkPropTypes=i,n.PropTypes=n,n};},function(t,e,n){function i(t){return function(){return t}}var r=function(){};r.thatReturns=i,r.thatReturnsFalse=i(!1),r.thatReturnsTrue=i(!0),r.thatReturnsNull=i(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(t){return t},t.exports=r;},function(t,e,n){function i(t,e,n,i,o,s,u,a){if(!t){var c;if(void 0===e)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var l=[n,i,o,s,u,a],f=0;c=new Error(e.replace(/%s/g,function(){return l[f++]})),c.name="Invariant Violation";}throw c.framesToPop=1,c}}t.exports=i;},function(t,e,n){t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";}])});
});

var TextEllipsis = unwrapExports(bundle);
var bundle_1 = bundle.TextEllipsis;

function CardBody(props) {
  var className = props.className,
      styles = props.styles,
      title = props.title,
      body = props.body,
      children = props.children;
  return (children || title || body) && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "card-body ".concat(className),
    style: styles
  }, children || /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("h2", {
    className: "card-title"
  }, title), /*#__PURE__*/React__default['default'].createElement(TextEllipsis, {
    lines: 3,
    tag: "div",
    ellipsisChars: "...",
    tagClass: "card-text",
    debounceTimeoutOnResize: 200,
    useJsOnly: true
  }, body)));
}
CardBody.propTypes = {
  className: PropTypes__default['default'].string,
  styles: PropTypes__default['default'].object,
  title: PropTypes__default['default'].string,
  body: PropTypes__default['default'].string,
  children: PropTypes__default['default'].any
};
CardBody.defaultProps = {
  className: '',
  styles: {},
  title: null,
  body: null,
  children: null
};

function CardFooter(props) {
  var className = props.className,
      styles = props.styles,
      footer = props.footer,
      linkUrl = props.linkUrl,
      icon = props.icon,
      newTab = props.newTab;
  return footer && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "card-footer ".concat(className),
    style: styles
  }, footer, icon && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "card-icon"
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: linkUrl,
    target: "".concat(newTab ? '_blank' : '_self'),
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "".concat(icon)
  }))));
}
CardFooter.propTypes = {
  className: PropTypes__default['default'].string,
  styles: PropTypes__default['default'].object,
  footer: PropTypes__default['default'].any,
  linkUrl: PropTypes__default['default'].string,
  icon: PropTypes__default['default'].string,
  newTab: PropTypes__default['default'].bool
};
CardFooter.defaultProps = {
  className: '',
  styles: {},
  footer: null,
  linkUrl: null,
  icon: 'far fa-chevron-right',
  newTab: false
};

var css_248z$4 = "@keyframes ConfigDropdown_fadein__24Gxx {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes ConfigDropdown_fadein__24Gxx {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes ConfigDropdown_fadein__24Gxx {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes ConfigDropdown_fadein__24Gxx {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes ConfigDropdown_fadein__24Gxx {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.ConfigDropdown_Dropdown--container__1v6bj {\n  width: 100%;\n  min-width: 10rem;\n  max-width: 20rem;\n  position: relative; }\n\n.ConfigDropdown_Dropdown--toggle__ZCwdl {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  border: 1px solid #00acc1;\n  color: black;\n  font-size: 1rem;\n  cursor: pointer; }\n\n.ConfigDropdown_Dropdown--menu-container__2Jlg4 {\n  transform: scale(1);\n  transform-origin: top center;\n  position: absolute;\n  z-index: 20;\n  background: #fff;\n  width: 100%;\n  min-width: 10rem;\n  max-width: 20rem;\n  transition: 0.1s;\n  box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 0 0 2px 2px;\n  max-height: 20rem;\n  overflow-y: auto;\n  padding: 0.5rem 0;\n  margin: 0; }\n\n.ConfigDropdown_Dropdown--menu__2FCwM {\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n  .ConfigDropdown_Dropdown--menu__2FCwM .ConfigDropdown_Dropdown--menu-item__2mW4B {\n    font-size: 1rem;\n    padding: 0.5rem 1rem;\n    color: #474f55; }\n  .ConfigDropdown_Dropdown--menu__2FCwM .ConfigDropdown_Dropdown--menu-item__2mW4B:hover {\n    color: #00acc1;\n    background-color: #f8f9fa; }\n";
styleInject(css_248z$4);

var ConfigDropdown = function ConfigDropdown(_ref) {
  var itemType = _ref.itemType,
      items = _ref.items,
      handleClick = _ref.handleClick,
      value = _ref.value;

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } //  Dropdown State


  var _useState = React$2.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownOpen = _useState2[0],
      setDropdownOpen = _useState2[1];

  var toggle = function toggle() {
    return setDropdownOpen(function (prevState) {
      return !prevState;
    });
  };

  var _useState3 = React$2.useState(value || ''),
      _useState4 = _slicedToArray(_useState3, 2),
      dropdownValue = _useState4[0],
      setDropdownValue = _useState4[1]; // * Components
  // DropdownToggle


  var DropdownToggle = function DropdownToggle(_ref2) {
    var value = _ref2.value;
    return /*#__PURE__*/React__default['default'].createElement("div", {
      onClick: toggle,
      className: "Dropdown--toggle"
    }, capitalizeFirstLetter(value), /*#__PURE__*/React__default['default'].createElement("i", {
      className: "fas fa-caret-down fa-xs"
    }));
  }; // DropdownMenu


  var DropdownMenu = function DropdownMenu(_ref3) {
    var items = _ref3.items,
        handleClick = _ref3.handleClick,
        itemType = _ref3.itemType;
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "Dropdown--menu-container"
    }, /*#__PURE__*/React__default['default'].createElement("ul", {
      className: "Dropdown--menu"
    }, items.map(function (item, idx) {
      return /*#__PURE__*/React__default['default'].createElement(DropdownItem, {
        itemType: itemType,
        key: idx,
        item: item,
        handleClick: handleClick
      });
    })));
  }; // DropdownItem


  var DropdownItem = function DropdownItem(_ref4) {
    var item = _ref4.item,
        handleClick = _ref4.handleClick,
        itemType = _ref4.itemType;
    return /*#__PURE__*/React__default['default'].createElement("li", {
      className: "Dropdown--menu-item",
      onClick: function onClick() {
        if (itemType === 'emails') {
          setDropdownValue(item[Object.keys(item)[0]]);
          handleClick(item[Object.keys(item)[0]]);
          toggle();
        } else {
          setDropdownValue(item);
          handleClick(item);
          toggle();
        }
      }
    }, itemType === 'emails' ? Object.keys(item)[0] === 'default' ? 'Use Default' : capitalizeFirstLetter(Object.keys(item)[0]) : itemType === 'campaigns' ? capitalizeFirstLetter(item) : 'Default Setting');
  }; // items && Object.keys(items[0])[0] === 'default' ? 'Use Default' : Object.keys(items[0])[0]


  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "Dropdown--container"
  }, /*#__PURE__*/React__default['default'].createElement(DropdownToggle, {
    value: dropdownValue || (items && Object.keys(items[0])[0] === 'default' ? 'Use Default' : items && itemType === 'emails' ? 'Select an email' : items && itemType === 'campaigns' ? 'Select a campaign' : 'Default Setting')
  }), dropdownOpen && /*#__PURE__*/React__default['default'].createElement(DropdownMenu, {
    itemType: itemType,
    items: items,
    handleClick: handleClick
  }));
};

ConfigDropdown.propTypes = {
  items: PropTypes__default['default'].array.isRequired,
  handleClick: PropTypes__default['default'].func.isRequired
};

var css_248z$5 = "@keyframes ContentFilterDropdowns_fadein__2TeTX {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes ContentFilterDropdowns_fadein__2TeTX {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes ContentFilterDropdowns_fadein__2TeTX {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes ContentFilterDropdowns_fadein__2TeTX {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes ContentFilterDropdowns_fadein__2TeTX {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.ContentFilterDropdowns_content-dropdowns--container__2acGp {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0;\n  float: left;\n  margin-bottom: 10px;\n  box-sizing: border-box; }\n\n.ContentFilterDropdowns_content-dropdowns__16OGm,\n.ContentFilterDropdowns_content-dropdowns--current-container__1cldV {\n  display: flex; }\n\n.ContentFilterDropdowns_content-dropdowns--dropdown__3gfvB {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  cursor: pointer; }\n  .ContentFilterDropdowns_content-dropdowns--dropdown__3gfvB .ContentFilterDropdowns_content-dropdowns-icon__3BtUm {\n    color: #4eb3d4;\n    margin-right: 1.5rem; }\n\n.ContentFilterDropdowns_content-dropdowns--label__1YgHk {\n  color: #96a6b3;\n  font-weight: 700;\n  margin-right: 0.5rem; }\n\n.ContentFilterDropdowns_content-dropdowns--current__28tZ4 {\n  color: #4eb3d4;\n  margin-right: 0.5rem; }\n\n.ContentFilterDropdowns_content-dropdowns--dropdown__3gfvB:hover .ContentFilterDropdowns_content-dropdowns--label__1YgHk {\n  color: #4eb3d4; }\n\n.ContentFilterDropdowns_content-dropdowns--dropdown__3gfvB:hover .ContentFilterDropdowns_content-dropdowns--current__28tZ4,\n.ContentFilterDropdowns_content-dropdowns--dropdown__3gfvB:hover .ContentFilterDropdowns_content-dropdowns-icon__3BtUm {\n  color: #4eb3d4; }\n\n.ContentFilterDropdowns_content-dropdowns--list__1zB5u {\n  transform: scale(1);\n  transform-origin: top center;\n  position: absolute;\n  z-index: 20;\n  background: #fff;\n  width: 12rem;\n  transition: 0.1s;\n  box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 0 0 2px 2px;\n  max-height: 20rem;\n  overflow-y: auto;\n  padding: 0.5rem 0;\n  margin: 0.5rem 0 0; }\n\n.ContentFilterDropdowns_content-dropdowns--list-item__3c5hH {\n  color: #151515;\n  padding: 0.5rem 1rem; }\n\n.ContentFilterDropdowns_content-dropdowns--list-item__3c5hH:hover {\n  color: #00acc1;\n  background-color: #f8f9fa;\n  cursor: pointer; }\n\n.ContentFilterDropdowns_content-dropdowns--list-background__KXxzm {\n  top: 0;\n  left: 0;\n  position: absolute;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0);\n  z-index: 19; }\n\n.ContentFilterDropdowns_content-dropdowns--filter-button__3K37C {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #96a6b3; }\n\n.ContentFilterDropdowns_content-dropdowns--filter-button__3K37C:hover {\n  color: #00acc1; }\n";
styleInject(css_248z$5);

var ContentFilterDropdowns = function ContentFilterDropdowns(_ref) {
  var filters = _ref.filters,
      handleItemClick = _ref.handleItemClick;

  var _useState = React$2.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      categoryDropdownOpen = _useState2[0],
      setCategoryDropdownOpen = _useState2[1];

  var _useState3 = React$2.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      conceptDropdownOpen = _useState4[0],
      setConceptDropdownOpen = _useState4[1];

  var _useState5 = React$2.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      typeDropdownOpen = _useState6[0],
      setTypeDropdownOpen = _useState6[1];

  var _useState7 = React$2.useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      difficultyDropdownOpen = _useState8[0],
      setDifficultyDropdownOpen = _useState8[1];

  var _useState9 = React$2.useState({
    categories: [],
    concepts: [],
    types: [],
    difficulties: []
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      activeFilter = _useState10[0],
      setActiveFilter = _useState10[1];

  var firstUpdate = React$2.useRef(true);
  React$2.useEffect(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    if (activeFilter) {
      Object.keys(activeFilter).forEach(function (filterSet) {
        if (activeFilter[filterSet].length) {
          return activeFilter[filterSet][0].guid && true;
        }
      });
    }

    handleItemClick({
      filter: activeFilter
    });
  }, [activeFilter, handleItemClick]);

  var closeAllDropdowns = function closeAllDropdowns() {
    setCategoryDropdownOpen(false);
    setConceptDropdownOpen(false);
    setTypeDropdownOpen(false);
    setDifficultyDropdownOpen(false);
  };

  var setActiveFilters = function setActiveFilters(filterType, item) {
    selectToggle(filterType);

    switch (filterType) {
      case 'categories':
        setActiveFilter(function (prevState) {
          return _objectSpread2(_objectSpread2({}, prevState), {}, {
            categories: [item]
          });
        });
        break;

      case 'concepts':
        setActiveFilter(function (prevState) {
          return _objectSpread2(_objectSpread2({}, prevState), {}, {
            concepts: [item]
          });
        });
        break;

      case 'types':
        setActiveFilter(function (prevState) {
          return _objectSpread2(_objectSpread2({}, prevState), {}, {
            types: [item]
          });
        });
        break;

      case 'difficulties':
        setActiveFilter(function (prevState) {
          return _objectSpread2(_objectSpread2({}, prevState), {}, {
            difficulties: [item]
          });
        });
        break;
    }
  };

  var selectToggle = function selectToggle(value) {
    switch (value) {
      case 'categories':
        if (categoryDropdownOpen) {
          setCategoryDropdownOpen(function (prevState) {
            return !prevState;
          });
        } else {
          closeAllDropdowns();
          setCategoryDropdownOpen(function (prevState) {
            return !prevState;
          });
        }

        break;

      case 'concepts':
        if (conceptDropdownOpen) {
          setConceptDropdownOpen(function (prevState) {
            return !prevState;
          });
        } else {
          closeAllDropdowns();
          setConceptDropdownOpen(function (prevState) {
            return !prevState;
          });
        }

        break;

      case 'types':
        if (typeDropdownOpen) {
          setTypeDropdownOpen(function (prevState) {
            return !prevState;
          });
        } else {
          closeAllDropdowns();
          setTypeDropdownOpen(function (prevState) {
            return !prevState;
          });
        }

        break;

      case 'difficulties':
        if (difficultyDropdownOpen) {
          setDifficultyDropdownOpen(function (prevState) {
            return !prevState;
          });
        } else {
          closeAllDropdowns();
          setDifficultyDropdownOpen(function (prevState) {
            return !prevState;
          });
        }

        break;
    }
  };

  var truncate = function truncate(str) {
    return str.length > 15 ? str.substr(0, 15 - 1) + '...' : str;
  }; // * Dropdown Current Value


  var Dropdown = function Dropdown(_ref2) {
    var defaultValue = _ref2.defaultValue,
        toggle = _ref2.toggle;
    var formattedLabelValue = defaultValue.charAt(0).toUpperCase() + defaultValue.slice(1);
    return /*#__PURE__*/React__default['default'].createElement("div", {
      onClick: function onClick() {
        toggle(defaultValue);
      },
      className: "content-dropdowns--dropdown"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "content-dropdowns--current-container"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "content-dropdowns--label"
    }, formattedLabelValue), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "content-dropdowns--current"
    }, activeFilter[defaultValue] && !!activeFilter[defaultValue].length ? truncate(activeFilter[defaultValue][0].value) : activeFilter[defaultValue] && activeFilter[defaultValue].includes('All') ? "All ".concat(formattedLabelValue) : "All ".concat(formattedLabelValue))), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "content-dropdowns-icon"
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      className: "fas fa-chevron-down fa-xs"
    })));
  }; // * Dropdown List


  var DropdownList = function DropdownList(_ref3) {
    var filterType = _ref3.filterType,
        items = _ref3.items,
        handleClick = _ref3.handleClick;
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "content-dropdowns--list-background",
      onClick: function onClick() {
        return selectToggle(filterType);
      }
    }), /*#__PURE__*/React__default['default'].createElement("ul", {
      className: "content-dropdowns--list"
    }, !!items.length && items.map(function (item) {
      return /*#__PURE__*/React__default['default'].createElement(DropdownListItem, {
        filterType: filterType,
        key: item.value,
        item: item,
        handleClick: handleClick
      });
    })));
  }; // * Dropdown List Item


  var DropdownListItem = function DropdownListItem(_ref4) {
    var filterType = _ref4.filterType,
        item = _ref4.item,
        handleClick = _ref4.handleClick;
    return /*#__PURE__*/React__default['default'].createElement("li", {
      onClick: function onClick() {
        setActiveFilters(filterType, item);
      },
      className: "content-dropdowns--list-item"
    }, item.value);
  };

  return /*#__PURE__*/React__default['default'].createElement("section", {
    className: "content-dropdowns--container"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "content-dropdowns"
  }, Object.keys(filters).map(function (filterType, idx) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      key: idx
    }, /*#__PURE__*/React__default['default'].createElement(Dropdown, {
      defaultValue: filterType,
      toggle: selectToggle
    }), filterType === 'categories' && !!categoryDropdownOpen || filterType === 'concepts' && !!conceptDropdownOpen || filterType === 'types' && !!typeDropdownOpen || filterType === 'difficulties' && !!difficultyDropdownOpen ? /*#__PURE__*/React__default['default'].createElement(DropdownList, {
      filterType: filterType,
      items: filters[filterType]
    }) : null);
  })), /*#__PURE__*/React__default['default'].createElement("button", {
    className: "content-dropdowns--filter-button",
    onClick: function onClick() {
      return setActiveFilter({
        categories: [],
        concepts: [],
        types: [],
        difficulties: []
      });
    }
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fal fa-undo"
  }), " Reset Filters"));
};

ContentFilterDropdowns.propTypes = {
  filters: PropTypes__default['default'].object.isRequired,
  handleItemClick: PropTypes__default['default'].func.isRequired
};

//! moment.js
//! version : 2.29.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

var hookCallback;

function hooks() {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback(callback) {
    hookCallback = callback;
}

function isArray(input) {
    return (
        input instanceof Array ||
        Object.prototype.toString.call(input) === '[object Array]'
    );
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return (
        input != null &&
        Object.prototype.toString.call(input) === '[object Object]'
    );
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
    } else {
        var k;
        for (k in obj) {
            if (hasOwnProp(obj, k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return (
        typeof input === 'number' ||
        Object.prototype.toString.call(input) === '[object Number]'
    );
}

function isDate(input) {
    return (
        input instanceof Date ||
        Object.prototype.toString.call(input) === '[object Date]'
    );
}

function map(arr, fn) {
    var res = [],
        i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false,
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this),
            len = t.length >>> 0,
            i;

        for (i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m),
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            }),
            isNowValid =
                !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid =
                isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid(flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    } else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = (hooks.momentProperties = []),
    updateInProgress = false;

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment(obj) {
    return (
        obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
    );
}

function warn(msg) {
    if (
        hooks.suppressDeprecationWarnings === false &&
        typeof console !== 'undefined' &&
        console.warn
    ) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [],
                arg,
                i,
                key;
            for (i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (key in arguments[0]) {
                        if (hasOwnProp(arguments[0], key)) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(
                msg +
                    '\nArguments: ' +
                    Array.prototype.slice.call(args).join('') +
                    '\n' +
                    new Error().stack
            );
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return (
        (typeof Function !== 'undefined' && input instanceof Function) ||
        Object.prototype.toString.call(input) === '[object Function]'
    );
}

function set(config) {
    var prop, i;
    for (i in config) {
        if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' +
            /\d{1,2}/.source
    );
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig),
        prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (
            hasOwnProp(parentConfig, prop) &&
            !hasOwnProp(childConfig, prop) &&
            isObject(parentConfig[prop])
        ) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i,
            res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L',
};

function calendar(key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (
        (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
        absNumber
    );
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
    localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
    formatFunctions = {},
    formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(
                func.apply(this, arguments),
                token
            );
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens),
        i,
        length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '',
            i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i])
                ? array[i].call(mom, format)
                : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] =
        formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(
            localFormattingTokens,
            replaceLongDateFormatTokens
        );
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A',
};

function longDateFormat(key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper
        .match(formattingTokens)
        .map(function (tok) {
            if (
                tok === 'MMMM' ||
                tok === 'MM' ||
                tok === 'DD' ||
                tok === 'dddd'
            ) {
                return tok.slice(1);
            }
            return tok;
        })
        .join('');

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate() {
    return this._invalidDate;
}

var defaultOrdinal = '%d',
    defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal(number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    w: 'a week',
    ww: '%d weeks',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years',
};

function relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return isFunction(output)
        ? output(number, withoutSuffix, string, isFuture)
        : output.replace(/%d/i, number);
}

function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias(unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string'
        ? aliases[units] || aliases[units.toLowerCase()]
        : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [],
        u;
    for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
            units.push({ unit: u, priority: priorities[u] });
        }
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

function absFloor(number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

function makeGetSet(unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get(mom, unit) {
    return mom.isValid()
        ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
        : NaN;
}

function set$1(mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (
            unit === 'FullYear' &&
            isLeapYear(mom.year()) &&
            mom.month() === 1 &&
            mom.date() === 29
        ) {
            value = toInt(value);
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                value,
                mom.month(),
                daysInMonth(value, mom.month())
            );
        } else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet(units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}

function stringSet(units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units),
            i;
        for (i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

var match1 = /\d/, //       0 - 9
    match2 = /\d\d/, //      00 - 99
    match3 = /\d{3}/, //     000 - 999
    match4 = /\d{4}/, //    0000 - 9999
    match6 = /[+-]?\d{6}/, // -999999 - 999999
    match1to2 = /\d\d?/, //       0 - 99
    match3to4 = /\d\d\d\d?/, //     999 - 9999
    match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
    match1to3 = /\d{1,3}/, //       0 - 999
    match1to4 = /\d{1,4}/, //       0 - 9999
    match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
    matchUnsigned = /\d+/, //       0 - inf
    matchSigned = /[+-]?\d+/, //    -inf - inf
    matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
    matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
    matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
    regexes;

regexes = {};

function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex)
        ? regex
        : function (isStrict, localeData) {
              return isStrict && strictRegex ? strictRegex : regex;
          };
}

function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(
        s
            .replace('\\', '')
            .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                matched,
                p1,
                p2,
                p3,
                p4
            ) {
                return p1 || p2 || p3 || p4;
            })
    );
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken(token, callback) {
    var i,
        func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken(token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0,
    MONTH = 1,
    DATE = 2,
    HOUR = 3,
    MINUTE = 4,
    SECOND = 5,
    MILLISECOND = 6,
    WEEK = 7,
    WEEKDAY = 8;

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1
        ? isLeapYear(year)
            ? 29
            : 28
        : 31 - ((modMonth % 7) % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M', match1to2);
addRegexToken('MM', match1to2, match2);
addRegexToken('MMM', function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
        '_'
    ),
    defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
        '_'
    ),
    MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
    defaultMonthsShortRegex = matchWord,
    defaultMonthsRegex = matchWord;

function localeMonths(m, format) {
    if (!m) {
        return isArray(this._months)
            ? this._months
            : this._months['standalone'];
    }
    return isArray(this._months)
        ? this._months[m.month()]
        : this._months[
              (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                  ? 'format'
                  : 'standalone'
          ][m.month()];
}

function localeMonthsShort(m, format) {
    if (!m) {
        return isArray(this._monthsShort)
            ? this._monthsShort
            : this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort)
        ? this._monthsShort[m.month()]
        : this._monthsShort[
              MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
          ][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(
                mom,
                ''
            ).toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp(
                '^' + this.months(mom, '').replace('.', '') + '$',
                'i'
            );
            this._shortMonthsParse[i] = new RegExp(
                '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                'i'
            );
        }
        if (!strict && !this._monthsParse[i]) {
            regex =
                '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (
            strict &&
            format === 'MMMM' &&
            this._longMonthsParse[i].test(monthName)
        ) {
            return i;
        } else if (
            strict &&
            format === 'MMM' &&
            this._shortMonthsParse[i].test(monthName)
        ) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth(mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth(value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
}

function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict
            ? this._monthsShortStrictRegex
            : this._monthsShortRegex;
    }
}

function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict
            ? this._monthsStrictRegex
            : this._monthsRegex;
    }
}

function computeMonthsParse() {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp(
        '^(' + longPieces.join('|') + ')',
        'i'
    );
    this._monthsShortStrictRegex = new RegExp(
        '^(' + shortPieces.join('|') + ')',
        'i'
    );
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? zeroFill(y, 4) : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY', 4], 0, 'year');
addFormatToken(0, ['YYYYY', 5], 0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y', matchSigned);
addRegexToken('YY', match1to2, match2);
addRegexToken('YYYY', match1to4, match4);
addRegexToken('YYYYY', match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] =
        input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear() {
    return isLeapYear(this.year());
}

function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date;
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
    } else {
        date = new Date(y, m, d, h, M, s, ms);
    }

    return date;
}

function createUTCDate(y) {
    var date, args;
    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        // preserve leap years using a full 400 year cycle, then reset
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
    } else {
        date = new Date(Date.UTC.apply(null, arguments));
    }

    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear,
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear,
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w', match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W', match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
    input,
    week,
    config,
    token
) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow: 0, // Sunday is the first day of the week.
    doy: 6, // The week that contains Jan 6th is the first week of the year.
};

function localeFirstDayOfWeek() {
    return this._week.dow;
}

function localeFirstDayOfYear() {
    return this._week.doy;
}

// MOMENTS

function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d', match1to2);
addRegexToken('e', match1to2);
addRegexToken('E', match1to2);
addRegexToken('dd', function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd', function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd', function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES
function shiftWeekdays(ws, n) {
    return ws.slice(n, 7).concat(ws.slice(0, n));
}

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
        '_'
    ),
    defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    defaultWeekdaysRegex = matchWord,
    defaultWeekdaysShortRegex = matchWord,
    defaultWeekdaysMinRegex = matchWord;

function localeWeekdays(m, format) {
    var weekdays = isArray(this._weekdays)
        ? this._weekdays
        : this._weekdays[
              m && m !== true && this._weekdays.isFormat.test(format)
                  ? 'format'
                  : 'standalone'
          ];
    return m === true
        ? shiftWeekdays(weekdays, this._week.dow)
        : m
        ? weekdays[m.day()]
        : weekdays;
}

function localeWeekdaysShort(m) {
    return m === true
        ? shiftWeekdays(this._weekdaysShort, this._week.dow)
        : m
        ? this._weekdaysShort[m.day()]
        : this._weekdaysShort;
}

function localeWeekdaysMin(m) {
    return m === true
        ? shiftWeekdays(this._weekdaysMin, this._week.dow)
        : m
        ? this._weekdaysMin[m.day()]
        : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(
                mom,
                ''
            ).toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(
                mom,
                ''
            ).toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp(
                '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                'i'
            );
            this._shortWeekdaysParse[i] = new RegExp(
                '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                'i'
            );
            this._minWeekdaysParse[i] = new RegExp(
                '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                'i'
            );
        }
        if (!this._weekdaysParse[i]) {
            regex =
                '^' +
                this.weekdays(mom, '') +
                '|^' +
                this.weekdaysShort(mom, '') +
                '|^' +
                this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (
            strict &&
            format === 'dddd' &&
            this._fullWeekdaysParse[i].test(weekdayName)
        ) {
            return i;
        } else if (
            strict &&
            format === 'ddd' &&
            this._shortWeekdaysParse[i].test(weekdayName)
        ) {
            return i;
        } else if (
            strict &&
            format === 'dd' &&
            this._minWeekdaysParse[i].test(weekdayName)
        ) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict
            ? this._weekdaysStrictRegex
            : this._weekdaysRegex;
    }
}

function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict
            ? this._weekdaysShortStrictRegex
            : this._weekdaysShortRegex;
    }
}

function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict
            ? this._weekdaysMinStrictRegex
            : this._weekdaysMinRegex;
    }
}

function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ''));
        shortp = regexEscape(this.weekdaysShort(mom, ''));
        longp = regexEscape(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp(
        '^(' + longPieces.join('|') + ')',
        'i'
    );
    this._weekdaysShortStrictRegex = new RegExp(
        '^(' + shortPieces.join('|') + ')',
        'i'
    );
    this._weekdaysMinStrictRegex = new RegExp(
        '^(' + minPieces.join('|') + ')',
        'i'
    );
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return (
        '' +
        hFormat.apply(this) +
        zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2)
    );
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return (
        '' +
        this.hours() +
        zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2)
    );
});

function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(
            this.hours(),
            this.minutes(),
            lowercase
        );
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a', matchMeridiem);
addRegexToken('A', matchMeridiem);
addRegexToken('H', match1to2);
addRegexToken('h', match1to2);
addRegexToken('k', match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
        pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
        pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return (input + '').toLowerCase().charAt(0) === 'p';
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);

function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}

var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse,
};

// internal storage for locale config files
var locales = {},
    localeFamilies = {},
    globalLocale;

function commonPrefix(arr1, arr2) {
    var i,
        minl = Math.min(arr1.length, arr2.length);
    for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
            return i;
        }
    }
    return minl;
}

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0,
        j,
        next,
        locale,
        split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (
                next &&
                next.length >= j &&
                commonPrefix(split, next) >= j - 1
            ) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return globalLocale;
}

function loadLocale(name) {
    var oldLocale = null,
        aliasedRequire;
    // TODO: Find a better way to register and load all the locales in Node
    if (
        locales[name] === undefined &&
        typeof module !== 'undefined' &&
        module &&
        module.exports
    ) {
        try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = require;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale(key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        } else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        } else {
            if (typeof console !== 'undefined' && console.warn) {
                //warn user if arguments are passed but the locale could not be set
                console.warn(
                    'Locale ' + key + ' not found. Did you forget to load it?'
                );
            }
        }
    }

    return globalLocale._abbr;
}

function defineLocale(name, config) {
    if (config !== null) {
        var locale,
            parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple(
                'defineLocaleOverride',
                'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
            );
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                locale = loadLocale(config.parentLocale);
                if (locale != null) {
                    parentConfig = locale._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config,
                    });
                    return null;
                }
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);

        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale,
            tmpLocale,
            parentConfig = baseConfig;

        if (locales[name] != null && locales[name].parentLocale != null) {
            // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            if (tmpLocale == null) {
                // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
            }
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;
        }

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) {
                    getSetGlobalLocale(name);
                }
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale(key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow(m) {
    var overflow,
        a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH] < 0 || a[MONTH] > 11
                ? MONTH
                : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                ? DATE
                : a[HOUR] < 0 ||
                  a[HOUR] > 24 ||
                  (a[HOUR] === 24 &&
                      (a[MINUTE] !== 0 ||
                          a[SECOND] !== 0 ||
                          a[MILLISECOND] !== 0))
                ? HOUR
                : a[MINUTE] < 0 || a[MINUTE] > 59
                ? MINUTE
                : a[SECOND] < 0 || a[SECOND] > 59
                ? SECOND
                : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                ? MILLISECOND
                : -1;

        if (
            getParsingFlags(m)._overflowDayOfYear &&
            (overflow < YEAR || overflow > DATE)
        ) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
    isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/],
        ['YYYYMM', /\d{6}/, false],
        ['YYYY', /\d{4}/, false],
    ],
    // iso time formats and regexes
    isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/],
    ],
    aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
    obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60,
    };

// date from iso format
function configFromISO(config) {
    var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

function extractFromRFC2822Strings(
    yearStr,
    monthStr,
    dayStr,
    hourStr,
    minuteStr,
    secondStr
) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10),
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s
        .replace(/\([^)]*\)|[\n\t]/g, ' ')
        .replace(/(\s\s+)/g, ' ')
        .replace(/^\s\s*/, '')
        .replace(/\s\s*$/, '');
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(
                parsedInput[0],
                parsedInput[1],
                parsedInput[2]
            ).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10),
            m = hm % 100,
            h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;
    if (match) {
        parsedArray = extractFromRFC2822Strings(
            match[4],
            match[3],
            match[2],
            match[5],
            match[6],
            match[7]
        );
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);
    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    if (config._strict) {
        config._isValid = false;
    } else {
        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate(),
        ];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray(config) {
    var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (
            config._dayOfYear > daysInYear(yearToUse) ||
            config._dayOfYear === 0
        ) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] =
            config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (
        config._a[HOUR] === 24 &&
        config._a[MINUTE] === 0 &&
        config._a[SECOND] === 0 &&
        config._a[MILLISECOND] === 0
    ) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(
        null,
        input
    );
    expectedWeekday = config._useUTC
        ? config._d.getUTCDay()
        : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (
        config._w &&
        typeof config._w.d !== 'undefined' &&
        config._w.d !== expectedWeekday
    ) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(
            w.GG,
            config._a[YEAR],
            weekOfYear(createLocal(), 1, 4).year
        );
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from beginning of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to beginning of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era;

    tokens =
        expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) ||
            [])[0];
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(
                string.indexOf(parsedInput) + parsedInput.length
            );
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            } else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver =
        stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (
        config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0
    ) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(
        config._locale,
        config._a[HOUR],
        config._meridiem
    );

    // handle era
    era = getParsingFlags(config).era;
    if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
    }

    configFromArray(config);
    checkOverflow(config);
}

function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (isValid(tempConfig)) {
            validFormatFound = true;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (!bestFormatIsValid) {
            if (
                scoreToBeat == null ||
                currentScore < scoreToBeat ||
                validFormatFound
            ) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
                if (validFormatFound) {
                    bestFormatIsValid = true;
                }
            }
        } else {
            if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
    config._a = map(
        [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
        function (obj) {
            return obj && parseInt(obj, 10);
        }
    );

    configFromArray(config);
}

function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig(config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({ nullInput: true });
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    } else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};

    if (format === true || format === false) {
        strict = format;
        format = undefined;
    }

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if (
        (isObject(input) && isObjectEmpty(input)) ||
        (isArray(input) && input.length === 0)
    ) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    ),
    prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min() {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max() {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +new Date();
};

var ordering = [
    'year',
    'quarter',
    'month',
    'week',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond',
];

function isDurationValid(m) {
    var key,
        unitHasDecimal = false,
        i;
    for (key in m) {
        if (
            hasOwnProp(m, key) &&
            !(
                indexOf.call(ordering, key) !== -1 &&
                (m[key] == null || !isNaN(m[key]))
            )
        ) {
            return false;
        }
    }

    for (i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds =
        +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days + weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months + quarters * 3 + years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration(obj) {
    return obj instanceof Duration;
}

function absRound(number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if (
            (dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
        ) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

// FORMATTING

function offset(token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
            sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return (
            sign +
            zeroFill(~~(offset / 60), 2) +
            separator +
            zeroFill(~~offset % 60, 2)
        );
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z', matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;

    if (matches === null) {
        return null;
    }

    chunk = matches[matches.length - 1] || [];
    parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff =
            (isMoment(input) || isDate(input)
                ? input.valueOf()
                : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset());
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(
                    this,
                    createDuration(input - offset, 'm'),
                    1,
                    false
                );
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone(input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset() {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        } else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime() {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {},
        other;

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted =
            this.isValid() && compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal() {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
}

function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration(input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months,
        };
    } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
            duration[key] = +input;
        } else {
            duration.milliseconds = +input;
        }
    } else if ((match = aspNetRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
            y: 0,
            d: toInt(match[DATE]) * sign,
            h: toInt(match[HOUR]) * sign,
            m: toInt(match[MINUTE]) * sign,
            s: toInt(match[SECOND]) * sign,
            ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
        };
    } else if ((match = isoRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
            y: parseIso(match[2], sign),
            M: parseIso(match[3], sign),
            w: parseIso(match[4], sign),
            d: parseIso(match[5], sign),
            h: parseIso(match[6], sign),
            m: parseIso(match[7], sign),
            s: parseIso(match[8], sign),
        };
    } else if (duration == null) {
        // checks for null or undefined
        duration = {};
    } else if (
        typeof duration === 'object' &&
        ('from' in duration || 'to' in duration)
    ) {
        diffRes = momentsDifference(
            createLocal(duration.from),
            createLocal(duration.to)
        );

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {};

    res.months =
        other.month() - base.month() + (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +base.clone().add(res.months, 'M');

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return { milliseconds: 0, months: 0 };
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(
                name,
                'moment().' +
                    name +
                    '(period, number) is deprecated. Please use moment().' +
                    name +
                    '(number, period). ' +
                    'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
            );
            tmp = val;
            val = period;
            period = tmp;
        }

        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add = createAdder(1, 'add'),
    subtract = createAdder(-1, 'subtract');

function isString(input) {
    return typeof input === 'string' || input instanceof String;
}

// type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
function isMomentInput(input) {
    return (
        isMoment(input) ||
        isDate(input) ||
        isString(input) ||
        isNumber(input) ||
        isNumberOrStringArray(input) ||
        isMomentInputObject(input) ||
        input === null ||
        input === undefined
    );
}

function isMomentInputObject(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms',
        ],
        i,
        property;

    for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
    }

    return objectTest && propertyTest;
}

function isNumberOrStringArray(input) {
    var arrayTest = isArray(input),
        dataTypeTest = false;
    if (arrayTest) {
        dataTypeTest =
            input.filter(function (item) {
                return !isNumber(item) && isString(input);
            }).length === 0;
    }
    return arrayTest && dataTypeTest;
}

function isCalendarSpec(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse',
        ],
        i,
        property;

    for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
    }

    return objectTest && propertyTest;
}

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6
        ? 'sameElse'
        : diff < -1
        ? 'lastWeek'
        : diff < 0
        ? 'lastDay'
        : diff < 1
        ? 'sameDay'
        : diff < 2
        ? 'nextDay'
        : diff < 7
        ? 'nextWeek'
        : 'sameElse';
}

function calendar$1(time, formats) {
    // Support for single parameter, formats only overload to the calendar function
    if (arguments.length === 1) {
        if (!arguments[0]) {
            time = undefined;
            formats = undefined;
        } else if (isMomentInput(arguments[0])) {
            time = arguments[0];
            formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
            formats = arguments[0];
            time = undefined;
        }
    }
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output =
            formats &&
            (isFunction(formats[format])
                ? formats[format].call(this, now)
                : formats[format]);

    return this.format(
        output || this.localeData().calendar(format, this, createLocal(now))
    );
}

function clone() {
    return new Moment(this);
}

function isAfter(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween(from, to, units, inclusivity) {
    var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);
    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
    }
    inclusivity = inclusivity || '()';
    return (
        (inclusivity[0] === '('
            ? this.isAfter(localFrom, units)
            : !this.isBefore(localFrom, units)) &&
        (inclusivity[1] === ')'
            ? this.isBefore(localTo, units)
            : !this.isAfter(localTo, units))
    );
}

function isSame(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return (
            this.clone().startOf(units).valueOf() <= inputMs &&
            inputMs <= this.clone().endOf(units).valueOf()
        );
    }
}

function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
}

function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
}

function diff(input, units, asFloat) {
    var that, zoneDelta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year':
            output = monthDiff(this, that) / 12;
            break;
        case 'month':
            output = monthDiff(this, that);
            break;
        case 'quarter':
            output = monthDiff(this, that) / 3;
            break;
        case 'second':
            output = (this - that) / 1e3;
            break; // 1000
        case 'minute':
            output = (this - that) / 6e4;
            break; // 1000 * 60
        case 'hour':
            output = (this - that) / 36e5;
            break; // 1000 * 60 * 60
        case 'day':
            output = (this - that - zoneDelta) / 864e5;
            break; // 1000 * 60 * 60 * 24, negate dst
        case 'week':
            output = (this - that - zoneDelta) / 6048e5;
            break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default:
            output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff(a, b) {
    if (a.date() < b.date()) {
        // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
    }
    // difference in months
    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString() {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(
            m,
            utc
                ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                .toISOString()
                .replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(
        m,
        utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
    );
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect() {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    prefix = '[' + func + '("]';
    year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
    datetime = '-MM-DD[T]HH:mm:ss.SSS';
    suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format(inputString) {
    if (!inputString) {
        inputString = this.isUtc()
            ? hooks.defaultFormatUtc
            : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from(time, withoutSuffix) {
    if (
        this.isValid() &&
        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
    ) {
        return createDuration({ to: this, from: time })
            .locale(this.locale())
            .humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow(withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to(time, withoutSuffix) {
    if (
        this.isValid() &&
        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
    ) {
        return createDuration({ from: this, to: time })
            .locale(this.locale())
            .humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow(withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale(key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData() {
    return this._locale;
}

var MS_PER_SECOND = 1000,
    MS_PER_MINUTE = 60 * MS_PER_SECOND,
    MS_PER_HOUR = 60 * MS_PER_MINUTE,
    MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

// actual modulo - handles negative numbers (for dates before 1970):
function mod$1(dividend, divisor) {
    return ((dividend % divisor) + divisor) % divisor;
}

function localStartOfDate(y, m, d) {
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
        return new Date(y, m, d).valueOf();
    }
}

function utcStartOfDate(y, m, d) {
    // Date.UTC remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
        return Date.UTC(y, m, d);
    }
}

function startOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
    }

    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

    switch (units) {
        case 'year':
            time = startOfDate(this.year(), 0, 1);
            break;
        case 'quarter':
            time = startOfDate(
                this.year(),
                this.month() - (this.month() % 3),
                1
            );
            break;
        case 'month':
            time = startOfDate(this.year(), this.month(), 1);
            break;
        case 'week':
            time = startOfDate(
                this.year(),
                this.month(),
                this.date() - this.weekday()
            );
            break;
        case 'isoWeek':
            time = startOfDate(
                this.year(),
                this.month(),
                this.date() - (this.isoWeekday() - 1)
            );
            break;
        case 'day':
        case 'date':
            time = startOfDate(this.year(), this.month(), this.date());
            break;
        case 'hour':
            time = this._d.valueOf();
            time -= mod$1(
                time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                MS_PER_HOUR
            );
            break;
        case 'minute':
            time = this._d.valueOf();
            time -= mod$1(time, MS_PER_MINUTE);
            break;
        case 'second':
            time = this._d.valueOf();
            time -= mod$1(time, MS_PER_SECOND);
            break;
    }

    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
}

function endOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
    }

    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

    switch (units) {
        case 'year':
            time = startOfDate(this.year() + 1, 0, 1) - 1;
            break;
        case 'quarter':
            time =
                startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3) + 3,
                    1
                ) - 1;
            break;
        case 'month':
            time = startOfDate(this.year(), this.month() + 1, 1) - 1;
            break;
        case 'week':
            time =
                startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday() + 7
                ) - 1;
            break;
        case 'isoWeek':
            time =
                startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1) + 7
                ) - 1;
            break;
        case 'day':
        case 'date':
            time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
            break;
        case 'hour':
            time = this._d.valueOf();
            time +=
                MS_PER_HOUR -
                mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                ) -
                1;
            break;
        case 'minute':
            time = this._d.valueOf();
            time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
            break;
        case 'second':
            time = this._d.valueOf();
            time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
            break;
    }

    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
}

function valueOf() {
    return this._d.valueOf() - (this._offset || 0) * 60000;
}

function unix() {
    return Math.floor(this.valueOf() / 1000);
}

function toDate() {
    return new Date(this.valueOf());
}

function toArray() {
    var m = this;
    return [
        m.year(),
        m.month(),
        m.date(),
        m.hour(),
        m.minute(),
        m.second(),
        m.millisecond(),
    ];
}

function toObject() {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds(),
    };
}

function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2() {
    return isValid(this);
}

function parsingFlags() {
    return extend({}, getParsingFlags(this));
}

function invalidAt() {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict,
    };
}

addFormatToken('N', 0, 0, 'eraAbbr');
addFormatToken('NN', 0, 0, 'eraAbbr');
addFormatToken('NNN', 0, 0, 'eraAbbr');
addFormatToken('NNNN', 0, 0, 'eraName');
addFormatToken('NNNNN', 0, 0, 'eraNarrow');

addFormatToken('y', ['y', 1], 'yo', 'eraYear');
addFormatToken('y', ['yy', 2], 0, 'eraYear');
addFormatToken('y', ['yyy', 3], 0, 'eraYear');
addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

addRegexToken('N', matchEraAbbr);
addRegexToken('NN', matchEraAbbr);
addRegexToken('NNN', matchEraAbbr);
addRegexToken('NNNN', matchEraName);
addRegexToken('NNNNN', matchEraNarrow);

addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
    input,
    array,
    config,
    token
) {
    var era = config._locale.erasParse(input, token, config._strict);
    if (era) {
        getParsingFlags(config).era = era;
    } else {
        getParsingFlags(config).invalidEra = input;
    }
});

addRegexToken('y', matchUnsigned);
addRegexToken('yy', matchUnsigned);
addRegexToken('yyy', matchUnsigned);
addRegexToken('yyyy', matchUnsigned);
addRegexToken('yo', matchEraYearOrdinal);

addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
addParseToken(['yo'], function (input, array, config, token) {
    var match;
    if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
    }

    if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
    } else {
        array[YEAR] = parseInt(input, 10);
    }
});

function localeEras(m, format) {
    var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;
    for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
            case 'string':
                // truncate time
                date = hooks(eras[i].since).startOf('day');
                eras[i].since = date.valueOf();
                break;
        }

        switch (typeof eras[i].until) {
            case 'undefined':
                eras[i].until = +Infinity;
                break;
            case 'string':
                // truncate time
                date = hooks(eras[i].until).startOf('day').valueOf();
                eras[i].until = date.valueOf();
                break;
        }
    }
    return eras;
}

function localeErasParse(eraName, format, strict) {
    var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
    eraName = eraName.toUpperCase();

    for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();

        if (strict) {
            switch (format) {
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) {
                        return eras[i];
                    }
                    break;

                case 'NNNN':
                    if (name === eraName) {
                        return eras[i];
                    }
                    break;

                case 'NNNNN':
                    if (narrow === eraName) {
                        return eras[i];
                    }
                    break;
            }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
            return eras[i];
        }
    }
}

function localeErasConvertYear(era, year) {
    var dir = era.since <= era.until ? +1 : -1;
    if (year === undefined) {
        return hooks(era.since).year();
    } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
    }
}

function getEraName() {
    var i,
        l,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].name;
        }
    }

    return '';
}

function getEraNarrow() {
    var i,
        l,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].narrow;
        }
    }

    return '';
}

function getEraAbbr() {
    var i,
        l,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].abbr;
        }
    }

    return '';
}

function getEraYear() {
    var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1;

        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (
            (eras[i].since <= val && val <= eras[i].until) ||
            (eras[i].until <= val && val <= eras[i].since)
        ) {
            return (
                (this.year() - hooks(eras[i].since).year()) * dir +
                eras[i].offset
            );
        }
    }

    return this.year();
}

function erasNameRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this);
    }
    return isStrict ? this._erasNameRegex : this._erasRegex;
}

function erasAbbrRegex(isStrict) {
    if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
    }
    return isStrict ? this._erasAbbrRegex : this._erasRegex;
}

function erasNarrowRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
    }
    return isStrict ? this._erasNarrowRegex : this._erasRegex;
}

function matchEraAbbr(isStrict, locale) {
    return locale.erasAbbrRegex(isStrict);
}

function matchEraName(isStrict, locale) {
    return locale.erasNameRegex(isStrict);
}

function matchEraNarrow(isStrict, locale) {
    return locale.erasNarrowRegex(isStrict);
}

function matchEraYearOrdinal(isStrict, locale) {
    return locale._eraYearOrdinalRegex || matchUnsigned;
}

function computeErasParse() {
    var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();

    for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name));
        abbrPieces.push(regexEscape(eras[i].abbr));
        narrowPieces.push(regexEscape(eras[i].narrow));

        mixedPieces.push(regexEscape(eras[i].name));
        mixedPieces.push(regexEscape(eras[i].abbr));
        mixedPieces.push(regexEscape(eras[i].narrow));
    }

    this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
    this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
    this._erasNarrowRegex = new RegExp(
        '^(' + narrowPieces.join('|') + ')',
        'i'
    );
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg', 'weekYear');
addWeekYearFormatToken('ggggg', 'weekYear');
addWeekYearFormatToken('GGGG', 'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);

// PARSING

addRegexToken('G', matchSigned);
addRegexToken('g', matchSigned);
addRegexToken('GG', match1to2, match2);
addRegexToken('gg', match1to2, match2);
addRegexToken('GGGG', match1to4, match4);
addRegexToken('gggg', match1to4, match4);
addRegexToken('GGGGG', match1to6, match6);
addRegexToken('ggggg', match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
    input,
    week,
    config,
    token
) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(
        this,
        input,
        this.week(),
        this.weekday(),
        this.localeData()._week.dow,
        this.localeData()._week.doy
    );
}

function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(
        this,
        input,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
    );
}

function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
}

function getISOWeeksInISOWeekYear() {
    return weeksInYear(this.isoWeekYear(), 1, 4);
}

function getWeeksInYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getWeeksInWeekYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter(input) {
    return input == null
        ? Math.ceil((this.month() + 1) / 3)
        : this.month((input - 1) * 3 + (this.month() % 3));
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIORITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D', match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict
        ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
        : locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD', match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear(input) {
    var dayOfYear =
        Math.round(
            (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
        ) + 1;
    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m', match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s', match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});

// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S', match1to3, match1);
addRegexToken('SS', match1to3, match2);
addRegexToken('SSS', match1to3, match3);

var token, getSetMillisecond;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}

getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z', 0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr() {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName() {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
if (typeof Symbol !== 'undefined' && Symbol.for != null) {
    proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
    };
}
proto.toJSON = toJSON;
proto.toString = toString;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
    'dates accessor is deprecated. Use date instead.',
    getSetDayOfMonth
);
proto.months = deprecate(
    'months accessor is deprecated. Use month instead',
    getSetMonth
);
proto.years = deprecate(
    'years accessor is deprecated. Use year instead',
    getSetYear
);
proto.zone = deprecate(
    'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
    getSetZone
);
proto.isDSTShifted = deprecate(
    'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
    isDaylightSavingTimeShifted
);

function createUnix(input) {
    return createLocal(input * 1000);
}

function createInZone() {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat(string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;

proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;

proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;

proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1(format, index, field, setter) {
    var locale = getLocale(),
        utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl(format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i,
        out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths(format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort(format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    eras: [
        {
            since: '0001-01-01',
            until: +Infinity,
            offset: 1,
            name: 'Anno Domini',
            narrow: 'AD',
            abbr: 'AD',
        },
        {
            since: '0000-12-31',
            until: -Infinity,
            offset: 1,
            name: 'Before Christ',
            narrow: 'BC',
            abbr: 'BC',
        },
    ],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function (number) {
        var b = number % 10,
            output =
                toInt((number % 100) / 10) === 1
                    ? 'th'
                    : b === 1
                    ? 'st'
                    : b === 2
                    ? 'nd'
                    : b === 3
                    ? 'rd'
                    : 'th';
        return number + output;
    },
});

// Side effect imports

hooks.lang = deprecate(
    'moment.lang is deprecated. Use moment.locale instead.',
    getSetGlobalLocale
);
hooks.langData = deprecate(
    'moment.langData is deprecated. Use moment.localeData instead.',
    getLocale
);

var mathAbs = Math.abs;

function abs() {
    var data = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);

    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);

    return this;
}

function addSubtract$1(duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1(input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1(input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil(number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble() {
    var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (
        !(
            (milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0)
        )
    ) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;

    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;

    hours = absFloor(minutes / 60);
    data.hours = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days = days;
    data.months = months;
    data.years = years;

    return this;
}

function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return (days * 4800) / 146097;
}

function monthsToDays(months) {
    // the reverse of daysToMonths
    return (months * 146097) / 4800;
}

function as(units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days,
        months,
        milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
            case 'month':
                return months;
            case 'quarter':
                return months / 3;
            case 'year':
                return months / 12;
        }
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week':
                return days / 7 + milliseconds / 6048e5;
            case 'day':
                return days + milliseconds / 864e5;
            case 'hour':
                return days * 24 + milliseconds / 36e5;
            case 'minute':
                return days * 1440 + milliseconds / 6e4;
            case 'second':
                return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond':
                return Math.floor(days * 864e5) + milliseconds;
            default:
                throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1() {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs(alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms'),
    asSeconds = makeAs('s'),
    asMinutes = makeAs('m'),
    asHours = makeAs('h'),
    asDays = makeAs('d'),
    asWeeks = makeAs('w'),
    asMonths = makeAs('M'),
    asQuarters = makeAs('Q'),
    asYears = makeAs('y');

function clone$1() {
    return createDuration(this);
}

function get$2(units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds'),
    seconds = makeGetter('seconds'),
    minutes = makeGetter('minutes'),
    hours = makeGetter('hours'),
    days = makeGetter('days'),
    months = makeGetter('months'),
    years = makeGetter('years');

function weeks() {
    return absFloor(this.days() / 7);
}

var round = Math.round,
    thresholds = {
        ss: 44, // a few seconds to seconds
        s: 45, // seconds to minute
        m: 45, // minutes to hour
        h: 22, // hours to day
        d: 26, // days to month/week
        w: null, // weeks to month
        M: 11, // months to year
    };

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
    var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a =
            (seconds <= thresholds.ss && ['s', seconds]) ||
            (seconds < thresholds.s && ['ss', seconds]) ||
            (minutes <= 1 && ['m']) ||
            (minutes < thresholds.m && ['mm', minutes]) ||
            (hours <= 1 && ['h']) ||
            (hours < thresholds.h && ['hh', hours]) ||
            (days <= 1 && ['d']) ||
            (days < thresholds.d && ['dd', days]);

    if (thresholds.w != null) {
        a =
            a ||
            (weeks <= 1 && ['w']) ||
            (weeks < thresholds.w && ['ww', weeks]);
    }
    a = a ||
        (months <= 1 && ['M']) ||
        (months < thresholds.M && ['MM', months]) ||
        (years <= 1 && ['y']) || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize(argWithSuffix, argThresholds) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var withSuffix = false,
        th = thresholds,
        locale,
        output;

    if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
    }
    if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
    }
    if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
            th.ss = argThresholds.s - 1;
        }
    }

    locale = this.localeData();
    output = relativeTime$1(this, !withSuffix, th, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return (x > 0) - (x < 0) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

    totalSign = total < 0 ? '-' : '';
    ymSign = sign(this._months) !== sign(total) ? '-' : '';
    daysSign = sign(this._days) !== sign(total) ? '-' : '';
    hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return (
        totalSign +
        'P' +
        (years ? ymSign + years + 'Y' : '') +
        (months ? ymSign + months + 'M' : '') +
        (days ? daysSign + days + 'D' : '') +
        (hours || minutes || seconds ? 'T' : '') +
        (hours ? hmsSign + hours + 'H' : '') +
        (minutes ? hmsSign + minutes + 'M' : '') +
        (seconds ? hmsSign + s + 'S' : '')
    );
}

var proto$2 = Duration.prototype;

proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;

proto$2.toIsoString = deprecate(
    'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
    toISOString$1
);
proto$2.lang = lang;

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

//! moment.js

hooks.version = '2.29.0';

setHookCallback(createLocal);

hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD', // <input type="date" />
    TIME: 'HH:mm', // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
    WEEK: 'GGGG-[W]WW', // <input type="week" />
    MONTH: 'YYYY-MM', // <input type="month" />
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  polyfill: polyfill
});

function mergeClassNames() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (classList, arg) {
    return typeof arg === 'string' || arg instanceof Array ? classList.concat(arg) : classList;
  }, []).filter(Boolean).join(' ');
}

var dates = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYear = getYear;
exports.getMonth = getMonth;
exports.getMonthIndex = getMonthIndex;
exports.getDay = getDay;
exports.getDayOfWeek = getDayOfWeek;
exports.getBeginOfCenturyYear = getBeginOfCenturyYear;
exports.getBeginOfCentury = getBeginOfCentury;
exports.getEndOfCentury = getEndOfCentury;
exports.getCenturyRange = getCenturyRange;
exports.getBeginOfPreviousCentury = getBeginOfPreviousCentury;
exports.getEndOfPreviousCentury = getEndOfPreviousCentury;
exports.getBeginOfNextCentury = getBeginOfNextCentury;
exports.getBeginOfDecadeYear = getBeginOfDecadeYear;
exports.getBeginOfDecade = getBeginOfDecade;
exports.getEndOfDecade = getEndOfDecade;
exports.getDecadeRange = getDecadeRange;
exports.getBeginOfPreviousDecade = getBeginOfPreviousDecade;
exports.getEndOfPreviousDecade = getEndOfPreviousDecade;
exports.getBeginOfNextDecade = getBeginOfNextDecade;
exports.getBeginOfYear = getBeginOfYear;
exports.getEndOfYear = getEndOfYear;
exports.getYearRange = getYearRange;
exports.getBeginOfPreviousYear = getBeginOfPreviousYear;
exports.getEndOfPreviousYear = getEndOfPreviousYear;
exports.getBeginOfNextYear = getBeginOfNextYear;
exports.getBeginOfMonth = getBeginOfMonth;
exports.getEndOfMonth = getEndOfMonth;
exports.getBeginOfWeek = getBeginOfWeek;
exports.getMonthRange = getMonthRange;
exports.getBeginOfPreviousMonth = getBeginOfPreviousMonth;
exports.getEndOfPreviousMonth = getEndOfPreviousMonth;
exports.getBeginOfNextMonth = getBeginOfNextMonth;
exports.getBeginOfDay = getBeginOfDay;
exports.getEndOfDay = getEndOfDay;
exports.getDayRange = getDayRange;
exports.getWeekNumber = getWeekNumber;
exports.getBegin = getBegin;
exports.getBeginPrevious = getBeginPrevious;
exports.getBeginNext = getBeginNext;
exports.getEnd = getEnd;
exports.getEndPrevious = getEndPrevious;
exports.getRange = getRange;
exports.getValueRange = getValueRange;
exports.getDaysInMonth = getDaysInMonth;
exports.getCenturyLabel = getCenturyLabel;
exports.getDecadeLabel = getDecadeLabel;
exports.isWeekend = isWeekend;
exports.getISOLocalMonth = getISOLocalMonth;
exports.getISOLocalDate = getISOLocalDate;
exports.getEndPrevious2 = exports.getBeginNext2 = exports.getBeginPrevious2 = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _map = _toConsumableArray(Array(7)).map(function (el, index) {
  return index;
}),
    _map2 = _slicedToArray(_map, 7),
    // eslint-disable-next-line no-unused-vars
SUNDAY = _map2[0],
    MONDAY = _map2[1],
    TUESDAY = _map2[2],
    WEDNESDAY = _map2[3],
    THURSDAY = _map2[4],
    FRIDAY = _map2[5],
    SATURDAY = _map2[6];
/* Simple getters - getting a property of a given point in time */


function getYear(date) {
  if (date instanceof Date) {
    return date.getFullYear();
  }

  if (typeof date === 'number') {
    return date;
  }

  var year = parseInt(date, 10);

  if (typeof date === 'string' && !isNaN(year)) {
    return year;
  }

  throw new Error("Failed to get year from date: ".concat(date, "."));
}

function getMonth(date) {
  return date.getMonth() + 1;
}

function getMonthIndex(date) {
  return date.getMonth();
}

function getDay(date) {
  return date.getDate();
}

function getDayOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var weekday = date.getDay();

  switch (calendarType) {
    case 'ISO 8601':
      // Shifts days of the week so that Monday is 0, Sunday is 6
      return (weekday + 6) % 7;

    case 'Arabic':
      return (weekday + 1) % 7;

    case 'Hebrew':
    case 'US':
      return weekday;

    default:
      throw new Error('Unsupported calendar type.');
  }
}
/* Complex getters - getting a property somehow related to a given point in time */


function getBeginOfCenturyYear(date) {
  var year = getYear(date) - 1;
  return year + -year % 100 + 1;
}

function getBeginOfCentury(date) {
  var beginOfCenturyYear = getBeginOfCenturyYear(date);
  return new Date(beginOfCenturyYear, 0, 1);
}

function getEndOfCentury(date) {
  var beginOfCenturyYear = getBeginOfCenturyYear(date);
  return new Date(beginOfCenturyYear + 100, 0, 1, 0, 0, 0, -1);
}

function getCenturyRange(date) {
  return [getBeginOfCentury(date), getEndOfCentury(date)];
}

function getBeginOfPreviousCentury(date) {
  var previousCenturyYear = getYear(date) - 100;
  return getBeginOfCentury(previousCenturyYear);
}

function getEndOfPreviousCentury(date) {
  var previousCenturyYear = getYear(date) - 100;
  return getEndOfCentury(previousCenturyYear);
}

function getBeginOfNextCentury(date) {
  var nextCenturyYear = getYear(date) + 100;
  return getBeginOfCentury(nextCenturyYear);
}

function getBeginOfDecadeYear(date) {
  var year = getYear(date) - 1;
  return year + -year % 10 + 1;
}

function getBeginOfDecade(date) {
  var beginOfDecadeYear = getBeginOfDecadeYear(date);
  return new Date(beginOfDecadeYear, 0, 1);
}

function getEndOfDecade(date) {
  var beginOfDecadeYear = getBeginOfDecadeYear(date);
  return new Date(beginOfDecadeYear + 10, 0, 1, 0, 0, 0, -1);
}

function getDecadeRange(date) {
  return [getBeginOfDecade(date), getEndOfDecade(date)];
}

function getBeginOfPreviousDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
  return getBeginOfDecade(previousDecadeYear);
}

function getEndOfPreviousDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
  return getEndOfDecade(previousDecadeYear);
}

function getBeginOfNextDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var nextDecadeYear = getBeginOfDecadeYear(date) + offset;
  return getBeginOfDecade(nextDecadeYear);
}
/**
 * Returns the beginning of a given year.
 *
 * @param {Date} date Date.
 */


function getBeginOfYear(date) {
  var year = getYear(date);
  return new Date(year, 0, 1);
}
/**
 * Returns the end of a given year.
 *
 * @param {Date} date Date.
 */


function getEndOfYear(date) {
  var year = getYear(date);
  return new Date(year + 1, 0, 1, 0, 0, 0, -1);
}
/**
 * Returns an array with the beginning and the end of a given year.
 *
 * @param {Date} date Date.
 */


function getYearRange(date) {
  return [getBeginOfYear(date), getEndOfYear(date)];
}

function getBeginOfPreviousYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousYear = getYear(date) - offset;
  return getBeginOfYear(previousYear);
}

function getEndOfPreviousYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousYear = getYear(date) - offset;
  return getEndOfYear(previousYear);
}

function getBeginOfNextYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var nextYear = getYear(date) + offset;
  return getBeginOfYear(nextYear);
}
/**
 * Returns the beginning of a given month.
 *
 * @param {Date} date Date.
 */


function getBeginOfMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex, 1);
}
/**
 * Returns the end of a given month.
 *
 * @param {Date} date Date.
 */


function getEndOfMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex + 1, 1, 0, 0, 0, -1);
}
/**
 * Returns the beginning of a given week.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */


function getBeginOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = date.getDate() - getDayOfWeek(date, calendarType);
  return new Date(year, monthIndex, day);
}
/**
 * Returns an array with the beginning and the end of a given month.
 *
 * @param {Date} date Date.
 */


function getMonthRange(date) {
  return [getBeginOfMonth(date), getEndOfMonth(date)];
}

function getDifferentMonth(date, offset) {
  var year = getYear(date);
  var previousMonthIndex = getMonthIndex(date) + offset;
  return new Date(year, previousMonthIndex, 1);
}

function getBeginOfPreviousMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousMonth = getDifferentMonth(date, -offset);
  return getBeginOfMonth(previousMonth);
}

function getEndOfPreviousMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousMonth = getDifferentMonth(date, -offset);
  return getEndOfMonth(previousMonth);
}

function getBeginOfNextMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var nextMonth = getDifferentMonth(date, offset);
  return getBeginOfMonth(nextMonth);
}

function getBeginOfDay(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = getDay(date);
  return new Date(year, monthIndex, day);
}

function getEndOfDay(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = getDay(date);
  return new Date(year, monthIndex, day + 1, 0, 0, 0, -1);
}
/**
 * Returns an array with the beginning and the end of a given day.
 *
 * @param {Date} date Date.
 */


function getDayRange(date) {
  return [getBeginOfDay(date), getEndOfDay(date)];
}
/**
 * Gets week number according to ISO 8601 or US standard.
 * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
 * In US calendar week 1 is the one with January 1.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */


function getWeekNumber(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var calendarTypeForWeekNumber = calendarType === 'US' ? 'US' : 'ISO 8601';
  var beginOfWeek = getBeginOfWeek(date, calendarTypeForWeekNumber);
  var year = getYear(date) + 1;
  var dayInWeekOne;
  var beginOfFirstWeek; // Look for the first week one that does not come after a given date

  do {
    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === 'ISO 8601' ? 4 : 1);
    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarTypeForWeekNumber);
    year -= 1;
  } while (date - beginOfFirstWeek < 0);

  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
}
/**
 * Returns the beginning of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */


function getBegin(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfCentury(date);

    case 'decade':
      return getBeginOfDecade(date);

    case 'year':
      return getBeginOfYear(date);

    case 'month':
      return getBeginOfMonth(date);

    case 'day':
      return getBeginOfDay(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

function getBeginPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfPreviousCentury(date);

    case 'decade':
      return getBeginOfPreviousDecade(date);

    case 'year':
      return getBeginOfPreviousYear(date);

    case 'month':
      return getBeginOfPreviousMonth(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

function getBeginNext(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfNextCentury(date);

    case 'decade':
      return getBeginOfNextDecade(date);

    case 'year':
      return getBeginOfNextYear(date);

    case 'month':
      return getBeginOfNextMonth(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getBeginOfPreviousDecade(date, 100);

    case 'year':
      return getBeginOfPreviousYear(date, 10);

    case 'month':
      return getBeginOfPreviousMonth(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};

exports.getBeginPrevious2 = getBeginPrevious2;

var getBeginNext2 = function getBeginNext2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getBeginOfNextDecade(date, 100);

    case 'year':
      return getBeginOfNextYear(date, 10);

    case 'month':
      return getBeginOfNextMonth(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
/**
 * Returns the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */


exports.getBeginNext2 = getBeginNext2;

function getEnd(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getEndOfCentury(date);

    case 'decade':
      return getEndOfDecade(date);

    case 'year':
      return getEndOfYear(date);

    case 'month':
      return getEndOfMonth(date);

    case 'day':
      return getEndOfDay(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

function getEndPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getEndOfPreviousCentury(date);

    case 'decade':
      return getEndOfPreviousDecade(date);

    case 'year':
      return getEndOfPreviousYear(date);

    case 'month':
      return getEndOfPreviousMonth(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getEndOfPreviousDecade(date, 100);

    case 'year':
      return getEndOfPreviousYear(date, 10);

    case 'month':
      return getEndOfPreviousMonth(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
/**
 * Returns an array with the beginning and the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */


exports.getEndPrevious2 = getEndPrevious2;

function getRange(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyRange(date);

    case 'decade':
      return getDecadeRange(date);

    case 'year':
      return getYearRange(date);

    case 'month':
      return getMonthRange(date);

    case 'day':
      return getDayRange(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
/**
 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date1 First date.
 * @param {Date} date2 Second date.
 */


function getValueRange(rangeType, date1, date2) {
  var rawNextValue = [date1, date2].sort(function (a, b) {
    return a - b;
  });
  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
}
/**
 * Returns a number of days in a month of a given date.
 *
 * @param {Date} date Date.
 */


function getDaysInMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex + 1, 0).getDate();
}

function toYearLabel(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      start = _ref2[0],
      end = _ref2[1];

  return "".concat(getYear(start), " \u2013 ").concat(getYear(end));
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2001-2100.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */


function getCenturyLabel(date) {
  return toYearLabel(getCenturyRange(date));
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2011-2020.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */


function getDecadeLabel(date) {
  return toYearLabel(getDecadeRange(date));
}
/**
 * Returns a boolean determining whether a given date is on Saturday or Sunday.
 *
 * @param {Date} date Date.
 */


function isWeekend(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var weekday = date.getDay();

  switch (calendarType) {
    case 'Arabic':
    case 'Hebrew':
      return weekday === FRIDAY || weekday === SATURDAY;

    case 'ISO 8601':
    case 'US':
      return weekday === SATURDAY || weekday === SUNDAY;

    default:
      throw new Error('Unsupported calendar type.');
  }
}
/**
 * Returns local month in ISO-like format (YYYY-MM).
 */


function getISOLocalMonth(value) {
  if (!value) {
    return value;
  }

  var date = new Date(value);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  var year = getYear(date);
  var month = "0".concat(getMonth(date)).slice(-2);
  return "".concat(year, "-").concat(month);
}
/**
 * Returns local date in ISO-like format (YYYY-MM-DD).
 */


function getISOLocalDate(value) {
  if (!value) {
    return value;
  }

  var date = new Date(value);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  var year = getYear(date);
  var month = "0".concat(getMonth(date)).slice(-2);
  var day = "0".concat(getDay(date)).slice(-2);
  return "".concat(year, "-").concat(month, "-").concat(day);
}
});

unwrapExports(dates);
var dates_1 = dates.getYear;
var dates_2 = dates.getMonth;
var dates_3 = dates.getMonthIndex;
var dates_4 = dates.getDay;
var dates_5 = dates.getDayOfWeek;
var dates_6 = dates.getBeginOfCenturyYear;
var dates_7 = dates.getBeginOfCentury;
var dates_8 = dates.getEndOfCentury;
var dates_9 = dates.getCenturyRange;
var dates_10 = dates.getBeginOfPreviousCentury;
var dates_11 = dates.getEndOfPreviousCentury;
var dates_12 = dates.getBeginOfNextCentury;
var dates_13 = dates.getBeginOfDecadeYear;
var dates_14 = dates.getBeginOfDecade;
var dates_15 = dates.getEndOfDecade;
var dates_16 = dates.getDecadeRange;
var dates_17 = dates.getBeginOfPreviousDecade;
var dates_18 = dates.getEndOfPreviousDecade;
var dates_19 = dates.getBeginOfNextDecade;
var dates_20 = dates.getBeginOfYear;
var dates_21 = dates.getEndOfYear;
var dates_22 = dates.getYearRange;
var dates_23 = dates.getBeginOfPreviousYear;
var dates_24 = dates.getEndOfPreviousYear;
var dates_25 = dates.getBeginOfNextYear;
var dates_26 = dates.getBeginOfMonth;
var dates_27 = dates.getEndOfMonth;
var dates_28 = dates.getBeginOfWeek;
var dates_29 = dates.getMonthRange;
var dates_30 = dates.getBeginOfPreviousMonth;
var dates_31 = dates.getEndOfPreviousMonth;
var dates_32 = dates.getBeginOfNextMonth;
var dates_33 = dates.getBeginOfDay;
var dates_34 = dates.getEndOfDay;
var dates_35 = dates.getDayRange;
var dates_36 = dates.getWeekNumber;
var dates_37 = dates.getBegin;
var dates_38 = dates.getBeginPrevious;
var dates_39 = dates.getBeginNext;
var dates_40 = dates.getEnd;
var dates_41 = dates.getEndPrevious;
var dates_42 = dates.getRange;
var dates_43 = dates.getValueRange;
var dates_44 = dates.getDaysInMonth;
var dates_45 = dates.getCenturyLabel;
var dates_46 = dates.getDecadeLabel;
var dates_47 = dates.isWeekend;
var dates_48 = dates.getISOLocalMonth;
var dates_49 = dates.getISOLocalDate;
var dates_50 = dates.getEndPrevious2;
var dates_51 = dates.getBeginNext2;
var dates_52 = dates.getBeginPrevious2;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_once = once;

function filterDuplicates(arr) {
  return arr.filter(function (el, index, self) {
    return self.indexOf(el) === index;
  });
}

function fixLowercaseProperties(arr) {
  return arr.map(function (el) {
    if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
      return el;
    }

    var splitEl = el.split('-');
    return "".concat(splitEl[0], "-").concat(splitEl[1].toUpperCase());
  });
}

function getUserLocalesInternal() {
  var languageList = [];

  if (typeof window !== 'undefined') {
    if (window.navigator.languages) {
      languageList = languageList.concat(window.navigator.languages);
    }

    if (window.navigator.language) {
      languageList.push(window.navigator.language);
    }

    if (window.navigator.userLanguage) {
      languageList.push(window.navigator.userLanguage);
    }

    if (window.navigator.browserLanguage) {
      languageList.push(window.navigator.browserLanguage);
    }

    if (window.navigator.systemLanguage) {
      languageList.push(window.navigator.systemLanguage);
    }
  }

  languageList.push('en-US'); // Fallback

  return fixLowercaseProperties(filterDuplicates(languageList));
}

var getUserLocales = lodash_once(getUserLocalesInternal);

function getUserLocaleInternal() {
  return getUserLocales()[0];
}

var getUserLocale = lodash_once(getUserLocaleInternal);

var dateFormatter = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatShortWeekday = exports.formatWeekday = exports.formatMonth = exports.formatMonthYear = exports.formatLongDate = exports.formatDate = void 0;

var _getUserLocale = _interopRequireDefault(getUserLocale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getFormatter(options) {
  return function (locale, date) {
    return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
  };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 */


function toSafeHour(date) {
  var safeDate = new Date(date);
  return new Date(safeDate.setHours(12));
}

function getSafeFormatter(options) {
  return function (locale, date) {
    return getFormatter(options)(locale, toSafeHour(date));
  };
}

var formatDateOptions = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric'
};
var formatLongDateOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
};
var formatMonthYearOptions = {
  month: 'long',
  year: 'numeric'
};
var formatMonthOptions = {
  month: 'long'
};
var formatWeekdayOptions = {
  weekday: 'long'
};
var formatShortWeekdayOptions = {
  weekday: 'short'
};
var formatDate = getSafeFormatter(formatDateOptions);
exports.formatDate = formatDate;
var formatLongDate = getSafeFormatter(formatLongDateOptions);
exports.formatLongDate = formatLongDate;
var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
exports.formatMonthYear = formatMonthYear;
var formatMonth = getSafeFormatter(formatMonthOptions);
exports.formatMonth = formatMonth;
var formatWeekday = getSafeFormatter(formatWeekdayOptions);
exports.formatWeekday = formatWeekday;
var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
exports.formatShortWeekday = formatShortWeekday;
});

unwrapExports(dateFormatter);
var dateFormatter_1 = dateFormatter.formatShortWeekday;
var dateFormatter_2 = dateFormatter.formatWeekday;
var dateFormatter_3 = dateFormatter.formatMonth;
var dateFormatter_4 = dateFormatter.formatMonthYear;
var dateFormatter_5 = dateFormatter.formatLongDate;
var dateFormatter_6 = dateFormatter.formatDate;

var propTypes = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tileProps = exports.tileGroupProps = exports.isView = exports.isClassName = exports.isViews = exports.isValue = exports.isMaxDate = exports.isMinDate = exports.isCalendarType = void 0;

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var calendarTypes = ['ISO 8601', 'US', 'Arabic', 'Hebrew'];
var allViews = ['century', 'decade', 'year', 'month'];

var isCalendarType = _propTypes["default"].oneOf(calendarTypes);

exports.isCalendarType = isCalendarType;

var isMinDate = function isMinDate(props, propName, componentName) {
  var minDate = props[propName];

  if (minDate) {
    if (!(minDate instanceof Date)) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    }

    var maxDate = props.maxDate;

    if (maxDate && minDate > maxDate) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
    }
  } // Everything is fine


  return null;
};

exports.isMinDate = isMinDate;

var isMaxDate = function isMaxDate(props, propName, componentName) {
  var maxDate = props[propName];

  if (maxDate) {
    if (!(maxDate instanceof Date)) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    }

    var minDate = props.minDate;

    if (minDate && maxDate < minDate) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
    }
  } // Everything is fine


  return null;
};

exports.isMaxDate = isMaxDate;

var isValue = _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Date))]);

exports.isValue = isValue;

var isViews = _propTypes["default"].arrayOf(_propTypes["default"].oneOf(allViews));

exports.isViews = isViews;

var isClassName = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]);

exports.isClassName = isClassName;

var isView = function isView(props, propName, componentName) {
  var view = props[propName];
  var views = props.views;
  var allowedViews = views || allViews;

  if (view !== undefined && allowedViews.indexOf(view) === -1) {
    return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function (a) {
      return "\"".concat(a, "\"");
    }).join(', '), "]."));
  } // Everything is fine


  return null;
};

exports.isView = isView;

isView.isRequired = function (props, propName, componentName) {
  var view = props[propName];

  if (!view) {
    return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
  }

  return isView(props, propName, componentName);
};

var tileGroupProps = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  hover: _propTypes["default"].instanceOf(Date),
  locale: _propTypes["default"].string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: _propTypes["default"].func,
  onMouseOver: _propTypes["default"].func,
  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, isClassName]),
  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  value: isValue,
  valueType: _propTypes["default"].string
};
exports.tileGroupProps = tileGroupProps;
var tileProps = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  classes: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  date: _propTypes["default"].instanceOf(Date).isRequired,
  locale: _propTypes["default"].string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: _propTypes["default"].func,
  onMouseOver: _propTypes["default"].func,
  style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, isClassName]),
  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  tileDisabled: _propTypes["default"].func
};
exports.tileProps = tileProps;
});

unwrapExports(propTypes);
var propTypes_1 = propTypes.tileProps;
var propTypes_2 = propTypes.tileGroupProps;
var propTypes_3 = propTypes.isView;
var propTypes_4 = propTypes.isClassName;
var propTypes_5 = propTypes.isViews;
var propTypes_6 = propTypes.isValue;
var propTypes_7 = propTypes.isMaxDate;
var propTypes_8 = propTypes.isMinDate;
var propTypes_9 = propTypes.isCalendarType;

var Navigation_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Navigation;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);







function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var className = 'react-calendar__navigation';

function Navigation(_ref) {
  var date = _ref.activeStartDate,
      drillUp = _ref.drillUp,
      formatMonthYear = _ref.formatMonthYear,
      locale = _ref.locale,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      navigationAriaLabel = _ref.navigationAriaLabel,
      navigationLabel = _ref.navigationLabel,
      next2AriaLabel = _ref.next2AriaLabel,
      next2Label = _ref.next2Label,
      nextAriaLabel = _ref.nextAriaLabel,
      nextLabel = _ref.nextLabel,
      prev2AriaLabel = _ref.prev2AriaLabel,
      prev2Label = _ref.prev2Label,
      prevAriaLabel = _ref.prevAriaLabel,
      prevLabel = _ref.prevLabel,
      setActiveStartDate = _ref.setActiveStartDate,
      view = _ref.view,
      views = _ref.views;
  var drillUpAvailable = views.indexOf(view) > 0;
  var shouldShowPrevNext2Buttons = view !== 'century';
  var previousActiveStartDate = (0, dates.getBeginPrevious)(view, date);
  var previousActiveStartDate2 = shouldShowPrevNext2Buttons && (0, dates.getBeginPrevious2)(view, date);
  var nextActiveStartDate = (0, dates.getBeginNext)(view, date);
  var nextActiveStartDate2 = shouldShowPrevNext2Buttons && (0, dates.getBeginNext2)(view, date);

  var prevButtonDisabled = function () {
    if (previousActiveStartDate.getFullYear() < 1000) {
      return true;
    }

    var previousActiveEndDate = (0, dates.getEndPrevious)(view, date);
    return minDate && minDate >= previousActiveEndDate;
  }();

  var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function () {
    if (previousActiveStartDate2.getFullYear() < 1000) {
      return true;
    }

    var previousActiveEndDate = (0, dates.getEndPrevious2)(view, date);
    return minDate && minDate >= previousActiveEndDate;
  }();

  var nextButtonDisabled = maxDate && maxDate <= nextActiveStartDate;
  var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate <= nextActiveStartDate2;

  function onClickPrevious() {
    setActiveStartDate(previousActiveStartDate);
  }

  function onClickPrevious2() {
    setActiveStartDate(previousActiveStartDate2);
  }

  function onClickNext() {
    setActiveStartDate(nextActiveStartDate);
  }

  function onClickNext2() {
    setActiveStartDate(nextActiveStartDate2);
  }

  var label = function () {
    switch (view) {
      case 'century':
        return (0, dates.getCenturyLabel)(date);

      case 'decade':
        return (0, dates.getDecadeLabel)(date);

      case 'year':
        return (0, dates.getYear)(date);

      case 'month':
        return formatMonthYear(locale, date);

      default:
        throw new Error("Invalid view: ".concat(view, "."));
    }
  }();

  return _react["default"].createElement("div", {
    className: className,
    style: {
      display: 'flex'
    }
  }, prev2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
    "aria-label": prev2AriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__prev2-button"),
    disabled: prev2ButtonDisabled,
    onClick: onClickPrevious2,
    type: "button"
  }, prev2Label), _react["default"].createElement("button", {
    "aria-label": prevAriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__prev-button"),
    disabled: prevButtonDisabled,
    onClick: onClickPrevious,
    type: "button"
  }, prevLabel), _react["default"].createElement("button", {
    "aria-label": navigationAriaLabel,
    className: "react-calendar__navigation__label",
    disabled: !drillUpAvailable,
    onClick: drillUp,
    style: {
      flexGrow: 1
    },
    type: "button"
  }, navigationLabel ? navigationLabel({
    date: date,
    view: view,
    label: label
  }) : label), _react["default"].createElement("button", {
    "aria-label": nextAriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__next-button"),
    disabled: nextButtonDisabled,
    onClick: onClickNext,
    type: "button"
  }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
    "aria-label": next2AriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__next2-button"),
    disabled: next2ButtonDisabled,
    onClick: onClickNext2,
    type: "button"
  }, next2Label));
}

Navigation.defaultProps = {
  formatMonthYear: dateFormatter.formatMonthYear,
  navigationAriaLabel: '',
  next2AriaLabel: '',
  next2Label: '»',
  nextAriaLabel: '',
  nextLabel: '›',
  prev2AriaLabel: '',
  prev2Label: '«',
  prevAriaLabel: '',
  prevLabel: '‹'
};
Navigation.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  drillUp: _propTypes["default"].func.isRequired,
  formatMonthYear: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  maxDate: _propTypes["default"].instanceOf(Date),
  minDate: _propTypes["default"].instanceOf(Date),
  navigationAriaLabel: _propTypes["default"].string,
  navigationLabel: _propTypes["default"].func,
  next2AriaLabel: _propTypes["default"].string,
  next2Label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  nextAriaLabel: _propTypes["default"].string,
  nextLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  prev2AriaLabel: _propTypes["default"].string,
  prev2Label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  prevAriaLabel: _propTypes["default"].string,
  prevLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  setActiveStartDate: _propTypes["default"].func.isRequired,
  view: propTypes.isView.isRequired,
  views: propTypes.isViews.isRequired
};
});

unwrapExports(Navigation_1);

var Flex_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Flex;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function toPercent(num) {
  return "".concat(num, "%");
}

function Flex(_ref) {
  var children = _ref.children,
      className = _ref.className,
      direction = _ref.direction,
      count = _ref.count,
      offset = _ref.offset,
      style = _ref.style,
      wrap = _ref.wrap,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "direction", "count", "offset", "style", "wrap"]);

  return _react["default"].createElement("div", _extends({
    className: className,
    style: _objectSpread({
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap ? 'wrap' : 'no-wrap'
    }, style)
  }, otherProps), _react["default"].Children.map(children, function (child, index) {
    return _react["default"].cloneElement(child, _objectSpread({}, child.props, {
      style: {
        flexBasis: toPercent(100 / count),
        maxWidth: toPercent(100 / count),
        overflow: 'hidden',
        marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
      }
    }));
  }));
}

Flex.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  count: _propTypes["default"].number.isRequired,
  direction: _propTypes["default"].string,
  offset: _propTypes["default"].number,
  style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  wrap: _propTypes["default"].bool
};
});

unwrapExports(Flex_1);

var utils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTileClasses = exports.between = exports.doRangesOverlap = exports.isRangeWithinRange = exports.isValueWithinRange = exports.callIfDefined = exports.mergeFunctions = void 0;



/**
 * Returns a function that, when called, calls all the functions
 * passed to it, applying its arguments to them.
 *
 * @param {Function[]} functions
 */
var mergeFunctions = function mergeFunctions() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return functions.filter(Boolean).forEach(function (f) {
      return f.apply(void 0, args);
    });
  };
};
/**
 * Calls a function, if it's defined, with specified arguments
 * @param {Function} fn
 * @param {Object} args
 */


exports.mergeFunctions = mergeFunctions;

var callIfDefined = function callIfDefined(fn) {
  if (fn && typeof fn === 'function') {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    fn.apply(void 0, args);
  }
};

exports.callIfDefined = callIfDefined;

var isValueWithinRange = function isValueWithinRange(value, range) {
  return range[0] <= value && range[1] >= value;
};

exports.isValueWithinRange = isValueWithinRange;

var isRangeWithinRange = function isRangeWithinRange(greaterRange, smallerRange) {
  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
};

exports.isRangeWithinRange = isRangeWithinRange;

var doRangesOverlap = function doRangesOverlap(range1, range2) {
  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
};
/**
 * Returns a value no smaller than min and no larger than max.
 *
 * @param {*} value Value to return.
 * @param {*} min Minimum return value.
 * @param {*} max Maximum return value.
 */


exports.doRangesOverlap = doRangesOverlap;

var between = function between(value, min, max) {
  if (min && min > value) {
    return min;
  }

  if (max && max < value) {
    return max;
  }

  return value;
};

exports.between = between;

var getTileClasses = function getTileClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref.value,
      valueType = _ref.valueType,
      date = _ref.date,
      dateType = _ref.dateType,
      hover = _ref.hover;

  var className = 'react-calendar__tile';
  var classes = [className];

  if (!date) {
    return classes;
  }

  if (!(date instanceof Array) && !dateType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var now = new Date();
  var dateRange = date instanceof Array ? date : (0, dates.getRange)(dateType, date);

  if (isValueWithinRange(now, dateRange)) {
    classes.push("".concat(className, "--now"));
  }

  if (!value) {
    return classes;
  }

  if (!(value instanceof Array) && !valueType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var valueRange = value instanceof Array ? value : (0, dates.getRange)(valueType, value);

  if (isRangeWithinRange(valueRange, dateRange)) {
    classes.push("".concat(className, "--active"));
  } else if (doRangesOverlap(valueRange, dateRange)) {
    classes.push("".concat(className, "--hasActive"));
  } else if (hover && ( // Date before value
  dateRange[1] < valueRange[0] && doRangesOverlap(dateRange, [hover, valueRange[0]]) || // Date after value
  dateRange[0] > valueRange[1] && doRangesOverlap(dateRange, [valueRange[1], hover]))) {
    classes.push("".concat(className, "--hover"));
  }

  var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
  var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);

  if (isRangeStart) {
    classes.push("".concat(className, "--rangeStart"));
  }

  if (isRangeEnd) {
    classes.push("".concat(className, "--rangeEnd"));
  }

  if (isRangeStart && isRangeEnd) {
    classes.push("".concat(className, "--rangeBothEnds"));
  }

  return classes;
};

exports.getTileClasses = getTileClasses;
});

unwrapExports(utils);
var utils_1 = utils.getTileClasses;
var utils_2 = utils.between;
var utils_3 = utils.doRangesOverlap;
var utils_4 = utils.isRangeWithinRange;
var utils_5 = utils.isValueWithinRange;
var utils_6 = utils.callIfDefined;
var utils_7 = utils.mergeFunctions;

var TileGroup_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TileGroup;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _Flex = _interopRequireDefault(Flex_1);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TileGroup(_ref) {
  var className = _ref.className,
      count = _ref.count,
      dateTransform = _ref.dateTransform,
      dateType = _ref.dateType,
      end = _ref.end,
      hover = _ref.hover,
      offset = _ref.offset,
      start = _ref.start,
      step = _ref.step,
      Tile = _ref.tile,
      value = _ref.value,
      valueType = _ref.valueType,
      tileProps = _objectWithoutProperties(_ref, ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"]);

  var tiles = [];

  for (var point = start; point <= end; point += step) {
    var date = dateTransform(point);
    tiles.push(_react["default"].createElement(Tile, _extends({
      key: date.getTime(),
      classes: (0, utils.getTileClasses)({
        value: value,
        valueType: valueType,
        date: date,
        dateType: dateType,
        hover: hover
      }),
      date: date,
      point: point
    }, tileProps)));
  }

  return _react["default"].createElement(_Flex["default"], {
    className: className,
    count: count,
    offset: offset,
    wrap: true
  }, tiles);
}

TileGroup.propTypes = _objectSpread({}, propTypes.tileGroupProps, {
  activeStartDate: _propTypes["default"].instanceOf(Date),
  count: _propTypes["default"].number,
  dateTransform: _propTypes["default"].func.isRequired,
  offset: _propTypes["default"].number,
  step: _propTypes["default"].number,
  tile: _propTypes["default"].func.isRequired
});
TileGroup.defaultProps = {
  count: 3,
  step: 1
};
});

unwrapExports(TileGroup_1);

var Tile_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _mergeClassNames = _interopRequireDefault(mergeClassNames);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tile =
/*#__PURE__*/
function (_Component) {
  _inherits(Tile, _Component);

  function Tile() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(Tile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeStartDate = _this$props.activeStartDate,
          children = _this$props.children,
          classes = _this$props.classes,
          date = _this$props.date,
          formatAbbr = _this$props.formatAbbr,
          locale = _this$props.locale,
          maxDate = _this$props.maxDate,
          maxDateTransform = _this$props.maxDateTransform,
          minDate = _this$props.minDate,
          minDateTransform = _this$props.minDateTransform,
          onClick = _this$props.onClick,
          onMouseOver = _this$props.onMouseOver,
          style = _this$props.style,
          tileDisabled = _this$props.tileDisabled,
          view = _this$props.view;
      var _this$state = this.state,
          tileClassName = _this$state.tileClassName,
          tileContent = _this$state.tileContent;
      return _react["default"].createElement("button", {
        className: (0, _mergeClassNames["default"])(classes, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
          activeStartDate: activeStartDate,
          date: date,
          view: view
        }),
        onClick: onClick && function () {
          return onClick(date);
        },
        onFocus: onMouseOver && function () {
          return onMouseOver(date);
        },
        onMouseOver: onMouseOver && function () {
          return onMouseOver(date);
        },
        style: style,
        type: "button"
      }, formatAbbr ? _react["default"].createElement("abbr", {
        "aria-label": formatAbbr(locale, date)
      }, children) : children, tileContent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var date = nextProps.date,
          tileClassName = nextProps.tileClassName,
          tileContent = nextProps.tileContent,
          view = nextProps.view;
      var nextState = {};

      if (tileClassName !== prevState.tileClassNameProps) {
        nextState.tileClassName = typeof tileClassName === 'function' ? tileClassName({
          date: date,
          view: view
        }) : tileClassName;
        nextState.tileClassNameProps = tileClassName;
      }

      if (tileContent !== prevState.tileContentProps) {
        nextState.tileContent = typeof tileContent === 'function' ? tileContent({
          date: date,
          view: view
        }) : tileContent;
        nextState.tileContentProps = tileContent;
      }

      return nextState;
    }
  }]);

  return Tile;
}(_react.Component);

exports["default"] = Tile;
Tile.propTypes = _objectSpread({}, propTypes.tileProps, {
  children: _propTypes["default"].node.isRequired,
  formatAbbr: _propTypes["default"].func,
  maxDateTransform: _propTypes["default"].func.isRequired,
  minDateTransform: _propTypes["default"].func.isRequired
});
});

unwrapExports(Tile_1);

var Decade_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Decade;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _Tile = _interopRequireDefault(Tile_1);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__century-view__decades__decade';

function Decade(_ref) {
  var classes = _ref.classes,
      point = _ref.point,
      otherProps = _objectWithoutProperties(_ref, ["classes", "point"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    maxDateTransform: dates.getEndOfDecade,
    minDateTransform: dates.getBeginOfDecade,
    view: "century"
  }), (0, dates.getDecadeLabel)(point));
}

Decade.propTypes = _objectSpread({}, propTypes.tileProps, {
  point: _propTypes["default"].number.isRequired
});
});

unwrapExports(Decade_1);

var Decades_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Decades;

var _react = _interopRequireDefault(React__default['default']);

var _TileGroup = _interopRequireDefault(TileGroup_1);

var _Decade = _interopRequireDefault(Decade_1);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Decades(props) {
  var activeStartDate = props.activeStartDate;
  var start = (0, dates.getBeginOfCenturyYear)(activeStartDate);
  var end = start + 99;
  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
    className: "react-calendar__century-view__decades",
    dateTransform: dates.getBeginOfDecade,
    dateType: "decade",
    end: end,
    start: start,
    step: 10,
    tile: _Decade["default"]
  }));
}

Decades.propTypes = _objectSpread({}, propTypes.tileGroupProps);
});

unwrapExports(Decades_1);

var CenturyView_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CenturyView;

var _react = _interopRequireDefault(React__default['default']);

var _Decades = _interopRequireDefault(Decades_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function CenturyView(props) {
  function renderDecades() {
    return _react["default"].createElement(_Decades["default"], props);
  }

  return _react["default"].createElement("div", {
    className: "react-calendar__century-view"
  }, renderDecades());
}
});

unwrapExports(CenturyView_1);

var Year_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Year;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _Tile = _interopRequireDefault(Tile_1);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__decade-view__years__year';

function Year(_ref) {
  var classes = _ref.classes,
      point = _ref.point,
      otherProps = _objectWithoutProperties(_ref, ["classes", "point"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    maxDateTransform: dates.getEndOfYear,
    minDateTransform: dates.getBeginOfYear,
    view: "decade"
  }), point);
}

Year.propTypes = _objectSpread({}, propTypes.tileProps, {
  point: _propTypes["default"].number.isRequired
});
});

unwrapExports(Year_1);

var Years_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Years;

var _react = _interopRequireDefault(React__default['default']);

var _TileGroup = _interopRequireDefault(TileGroup_1);

var _Year = _interopRequireDefault(Year_1);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Years(props) {
  var activeStartDate = props.activeStartDate;
  var start = (0, dates.getBeginOfDecadeYear)(activeStartDate);
  var end = start + 9;
  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
    className: "react-calendar__decade-view__years",
    dateTransform: function dateTransform(year) {
      return new Date(year, 0, 1);
    },
    dateType: "year",
    end: end,
    start: start,
    tile: _Year["default"]
  }));
}

Years.propTypes = _objectSpread({}, propTypes.tileGroupProps);
});

unwrapExports(Years_1);

var DecadeView_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DecadeView;

var _react = _interopRequireDefault(React__default['default']);

var _Years = _interopRequireDefault(Years_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function DecadeView(props) {
  function renderYears() {
    return _react["default"].createElement(_Years["default"], props);
  }

  return _react["default"].createElement("div", {
    className: "react-calendar__decade-view"
  }, renderYears());
}
});

unwrapExports(DecadeView_1);

var Month_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Month;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _Tile = _interopRequireDefault(Tile_1);







function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__year-view__months__month';

function Month(_ref) {
  var classes = _ref.classes,
      date = _ref.date,
      formatMonth = _ref.formatMonth,
      locale = _ref.locale,
      otherProps = _objectWithoutProperties(_ref, ["classes", "date", "formatMonth", "locale"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    date: date,
    formatAbbr: dateFormatter.formatMonthYear,
    locale: locale,
    maxDateTransform: dates.getEndOfMonth,
    minDateTransform: dates.getBeginOfMonth,
    view: "year"
  }), formatMonth(locale, date));
}

Month.defaultProps = {
  formatMonth: dateFormatter.formatMonth
};
Month.propTypes = _objectSpread({}, propTypes.tileProps, {
  formatMonth: _propTypes["default"].func
});
});

unwrapExports(Month_1);

var Months_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Months;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _TileGroup = _interopRequireDefault(TileGroup_1);

var _Month = _interopRequireDefault(Month_1);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Months(props) {
  var activeStartDate = props.activeStartDate;
  var start = 0;
  var end = 11;
  var year = (0, dates.getYear)(activeStartDate);
  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
    className: "react-calendar__year-view__months",
    dateTransform: function dateTransform(monthIndex) {
      return new Date(year, monthIndex, 1);
    },
    dateType: "month",
    end: end,
    start: start,
    tile: _Month["default"]
  }));
}

Months.propTypes = _objectSpread({}, propTypes.tileGroupProps, {
  locale: _propTypes["default"].string
});
});

unwrapExports(Months_1);

var YearView_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = YearView;

var _react = _interopRequireDefault(React__default['default']);

var _Months = _interopRequireDefault(Months_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function YearView(props) {
  function renderMonths() {
    return _react["default"].createElement(_Months["default"], props);
  }

  return _react["default"].createElement("div", {
    className: "react-calendar__year-view"
  }, renderMonths());
}
});

unwrapExports(YearView_1);

var Day_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Day;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _Tile = _interopRequireDefault(Tile_1);







function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__month-view__days__day';

function Day(_ref) {
  var calendarType = _ref.calendarType,
      classes = _ref.classes,
      currentMonthIndex = _ref.currentMonthIndex,
      date = _ref.date,
      otherProps = _objectWithoutProperties(_ref, ["calendarType", "classes", "currentMonthIndex", "date"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className, (0, dates.isWeekend)(date, calendarType) ? "".concat(className, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className, "--neighboringMonth") : null),
    date: date,
    formatAbbr: dateFormatter.formatLongDate,
    maxDateTransform: dates.getEndOfDay,
    minDateTransform: dates.getBeginOfDay,
    view: "month"
  }), (0, dates.getDay)(date));
}

Day.propTypes = _objectSpread({}, propTypes.tileProps, {
  currentMonthIndex: _propTypes["default"].number.isRequired
});
});

unwrapExports(Day_1);

var Days_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Days;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _TileGroup = _interopRequireDefault(TileGroup_1);

var _Day = _interopRequireDefault(Day_1);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Days(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType;

  var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks,
      showNeighboringMonth = props.showNeighboringMonth,
      otherProps = _objectWithoutProperties(props, ["showFixedNumberOfWeeks", "showNeighboringMonth"]);

  var year = (0, dates.getYear)(activeStartDate);
  var monthIndex = (0, dates.getMonthIndex)(activeStartDate);
  var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
  var dayOfWeek = (0, dates.getDayOfWeek)(activeStartDate, calendarType);
  var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
  /**
   * Defines on which day of the month the grid shall start. If we simply show current
   * month, we obviously start on day one, but if showNeighboringMonth is set to
   * true, we need to find the beginning of the week the first day of the month is in.
   */

  var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
  /**
   * Defines on which day of the month the grid shall end. If we simply show current
   * month, we need to stop on the last day of the month, but if showNeighboringMonth
   * is set to true, we need to find the end of the week the last day of the month is in.
   */

  var end = function () {
    if (showFixedNumberOfWeeks) {
      // Always show 6 weeks
      return start + 6 * 7 - 1;
    }

    var daysInMonth = (0, dates.getDaysInMonth)(activeStartDate);

    if (showNeighboringMonth) {
      var activeEndDate = new Date(year, monthIndex, daysInMonth);
      return daysInMonth + (7 - (0, dates.getDayOfWeek)(activeEndDate, calendarType) - 1);
    }

    return daysInMonth;
  }();

  return _react["default"].createElement(_TileGroup["default"], _extends({}, otherProps, {
    className: "react-calendar__month-view__days",
    count: 7,
    currentMonthIndex: monthIndex,
    dateTransform: function dateTransform(day) {
      return new Date(year, monthIndex, day);
    },
    dateType: "day",
    end: end,
    offset: offset,
    start: start,
    tile: _Day["default"]
  }));
}

Days.propTypes = _objectSpread({
  calendarType: propTypes.isCalendarType.isRequired,
  showFixedNumberOfWeeks: _propTypes["default"].bool,
  showNeighboringMonth: _propTypes["default"].bool
}, propTypes.tileGroupProps);
});

unwrapExports(Days_1);

var Weekdays_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Weekdays;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _Flex = _interopRequireDefault(Flex_1);







function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Weekdays(props) {
  var calendarType = props.calendarType,
      formatShortWeekday = props.formatShortWeekday,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave;
  var anyDate = new Date();
  var beginOfMonth = (0, dates.getBeginOfMonth)(anyDate);
  var year = (0, dates.getYear)(beginOfMonth);
  var monthIndex = (0, dates.getMonthIndex)(beginOfMonth);
  var weekdays = [];

  for (var weekday = 1; weekday <= 7; weekday += 1) {
    var weekdayDate = new Date(year, monthIndex, weekday - (0, dates.getDayOfWeek)(beginOfMonth, calendarType));
    var abbr = (0, dateFormatter.formatWeekday)(locale, weekdayDate);
    weekdays.push(_react["default"].createElement("div", {
      key: weekday,
      className: "react-calendar__month-view__weekdays__weekday"
    }, _react["default"].createElement("abbr", {
      "aria-label": abbr,
      title: abbr
    }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
  }

  return _react["default"].createElement(_Flex["default"], {
    className: "react-calendar__month-view__weekdays",
    count: 7,
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave
  }, weekdays);
}

Weekdays.defaultProps = {
  formatShortWeekday: dateFormatter.formatShortWeekday
};
Weekdays.propTypes = {
  calendarType: propTypes.isCalendarType.isRequired,
  formatShortWeekday: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  onMouseLeave: _propTypes["default"].func
};
});

unwrapExports(Weekdays_1);

var WeekNumber_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WeekNumber;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function WeekNumber(_ref) {
  var date = _ref.date,
      onClickWeekNumber = _ref.onClickWeekNumber,
      weekNumber = _ref.weekNumber;
  return onClickWeekNumber ? _react["default"].createElement("button", {
    className: "react-calendar__tile",
    onClick: function onClick() {
      return onClickWeekNumber(weekNumber, date);
    },
    style: {
      flexGrow: 1
    },
    type: "button"
  }, _react["default"].createElement("span", null, weekNumber)) : _react["default"].createElement("div", {
    className: "react-calendar__tile",
    style: {
      flexGrow: 1
    }
  }, _react["default"].createElement("span", null, weekNumber));
}

WeekNumber.propTypes = {
  date: _propTypes["default"].instanceOf(Date).isRequired,
  onClickWeekNumber: _propTypes["default"].func,
  weekNumber: _propTypes["default"].number.isRequired
};
});

unwrapExports(WeekNumber_1);

var WeekNumbers_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WeekNumbers;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _WeekNumber = _interopRequireDefault(WeekNumber_1);

var _Flex = _interopRequireDefault(Flex_1);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function WeekNumbers(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType,
      onClickWeekNumber = props.onClickWeekNumber,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

  var numberOfWeeks = function () {
    if (showFixedNumberOfWeeks) {
      return 6;
    }

    var numberOfDays = (0, dates.getDaysInMonth)(activeStartDate);
    var startWeekday = (0, dates.getDayOfWeek)(activeStartDate, calendarType);
    var days = numberOfDays - (7 - startWeekday);
    return 1 + Math.ceil(days / 7);
  }();

  var dates$1 = function () {
    var year = (0, dates.getYear)(activeStartDate);
    var monthIndex = (0, dates.getMonthIndex)(activeStartDate);
    var day = (0, dates.getDay)(activeStartDate);
    var result = [];

    for (var index = 0; index < numberOfWeeks; index += 1) {
      result.push((0, dates.getBeginOfWeek)(new Date(year, monthIndex, day + index * 7), calendarType));
    }

    return result;
  }();

  var weekNumbers = dates$1.map(function (date) {
    return (0, dates.getWeekNumber)(date, calendarType);
  });
  return _react["default"].createElement(_Flex["default"], {
    className: "react-calendar__month-view__weekNumbers",
    count: numberOfWeeks,
    direction: "column",
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave,
    style: {
      flexBasis: 'calc(100% * (1 / 8)',
      flexShrink: 0
    }
  }, weekNumbers.map(function (weekNumber, weekIndex) {
    return _react["default"].createElement(_WeekNumber["default"], {
      key: weekNumber,
      date: dates$1[weekIndex],
      onClickWeekNumber: onClickWeekNumber,
      weekNumber: weekNumber
    });
  }));
}

WeekNumbers.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  calendarType: propTypes.isCalendarType.isRequired,
  onClickWeekNumber: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  showFixedNumberOfWeeks: _propTypes["default"].bool
};
});

unwrapExports(WeekNumbers_1);

var MonthView_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MonthView;

var _react = _interopRequireDefault(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _Days = _interopRequireDefault(Days_1);

var _Weekdays = _interopRequireDefault(Weekdays_1);

var _WeekNumbers = _interopRequireDefault(WeekNumbers_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function MonthView(props) {
  var activeStartDate = props.activeStartDate,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

  var calendarTypeProps = props.calendarType,
      formatShortWeekday = props.formatShortWeekday,
      onClickWeekNumber = props.onClickWeekNumber,
      showWeekNumbers = props.showWeekNumbers,
      childProps = _objectWithoutProperties(props, ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers"]);

  var calendarType = function () {
    if (calendarTypeProps) {
      return calendarTypeProps;
    }

    switch (locale) {
      case 'en-CA':
      case 'en-US':
      case 'es-AR':
      case 'es-BO':
      case 'es-CL':
      case 'es-CO':
      case 'es-CR':
      case 'es-DO':
      case 'es-EC':
      case 'es-GT':
      case 'es-HN':
      case 'es-MX':
      case 'es-NI':
      case 'es-PA':
      case 'es-PE':
      case 'es-PR':
      case 'es-SV':
      case 'es-VE':
      case 'pt-BR':
        return 'US';
      // ar-LB, ar-MA intentionally missing

      case 'ar':
      case 'ar-AE':
      case 'ar-BH':
      case 'ar-DZ':
      case 'ar-EG':
      case 'ar-IQ':
      case 'ar-JO':
      case 'ar-KW':
      case 'ar-LY':
      case 'ar-OM':
      case 'ar-QA':
      case 'ar-SA':
      case 'ar-SD':
      case 'ar-SY':
      case 'ar-YE':
      case 'dv':
      case 'dv-MV':
      case 'ps':
      case 'ps-AR':
        return 'Arabic';

      case 'he':
      case 'he-IL':
        return 'Hebrew';

      default:
        return 'ISO 8601';
    }
  }();

  function renderWeekdays() {
    return _react["default"].createElement(_Weekdays["default"], {
      calendarType: calendarType,
      formatShortWeekday: formatShortWeekday,
      locale: locale,
      onMouseLeave: onMouseLeave
    });
  }

  function renderWeekNumbers() {
    if (!showWeekNumbers) {
      return null;
    }

    return _react["default"].createElement(_WeekNumbers["default"], {
      activeStartDate: activeStartDate,
      calendarType: calendarType,
      onClickWeekNumber: onClickWeekNumber,
      onMouseLeave: onMouseLeave,
      showFixedNumberOfWeeks: showFixedNumberOfWeeks
    });
  }

  function renderDays() {
    return _react["default"].createElement(_Days["default"], _extends({
      calendarType: calendarType
    }, childProps));
  }

  var className = 'react-calendar__month-view';
  return _react["default"].createElement("div", {
    className: [className, showWeekNumbers ? "".concat(className, "--weekNumbers") : ''].join(' ')
  }, _react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, renderWeekNumbers(), _react["default"].createElement("div", {
    style: {
      flexGrow: 1,
      width: '100%'
    }
  }, renderWeekdays(), renderDays())));
}

MonthView.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  calendarType: propTypes.isCalendarType,
  formatShortWeekday: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  maxDate: propTypes.isMaxDate,
  minDate: propTypes.isMinDate,
  onChange: _propTypes["default"].func,
  onClickWeekNumber: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  setActiveRange: _propTypes["default"].func,
  showFixedNumberOfWeeks: _propTypes["default"].bool,
  showNeighboringMonth: _propTypes["default"].bool,
  showWeekNumbers: _propTypes["default"].bool,
  value: propTypes.isValue,
  valueType: _propTypes["default"].string
};
});

unwrapExports(MonthView_1);

var Calendar_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(React__default['default']);

var _propTypes = _interopRequireDefault(PropTypes__default['default']);



var _mergeClassNames = _interopRequireDefault(mergeClassNames);

var _Navigation = _interopRequireDefault(Navigation_1);

var _CenturyView = _interopRequireDefault(CenturyView_1);

var _DecadeView = _interopRequireDefault(DecadeView_1);

var _YearView = _interopRequireDefault(YearView_1);

var _MonthView = _interopRequireDefault(MonthView_1);







function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var baseClassName = 'react-calendar';
var allViews = ['century', 'decade', 'year', 'month'];
var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);

var datesAreDifferent = function datesAreDifferent(date1, date2) {
  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
};
/**
 * Returns views array with disallowed values cut off.
 */


var getLimitedViews = function getLimitedViews(minDetail, maxDetail) {
  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
};
/**
 * Determines whether a given view is allowed with currently applied settings.
 */


var isViewAllowed = function isViewAllowed(view, minDetail, maxDetail) {
  var views = getLimitedViews(minDetail, maxDetail);
  return views.indexOf(view) !== -1;
};
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */


var getView = function getView(view, minDetail, maxDetail) {
  if (isViewAllowed(view, minDetail, maxDetail)) {
    return view;
  }

  return getLimitedViews(minDetail, maxDetail).pop();
};
/**
 * Returns value type that can be returned with currently applied settings.
 */


var getValueType = function getValueType(maxDetail) {
  return allValueTypes[allViews.indexOf(maxDetail)];
};

var getValueFrom = function getValueFrom(value) {
  if (!value) {
    return null;
  }

  var rawValueFrom = value instanceof Array && value.length === 2 ? value[0] : value;

  if (!rawValueFrom) {
    return null;
  }

  var valueFromDate = new Date(rawValueFrom);

  if (isNaN(valueFromDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  return valueFromDate;
};

var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate, maxDetail) {
  var valueFrom = getValueFrom(value);

  if (!valueFrom) {
    return null;
  }

  var detailValueFrom = (0, dates.getBegin)(getValueType(maxDetail), valueFrom);
  return (0, utils.between)(detailValueFrom, minDate, maxDate);
};

var getValueTo = function getValueTo(value) {
  if (!value) {
    return null;
  }

  var rawValueTo = value instanceof Array && value.length === 2 ? value[1] : value;

  if (!rawValueTo) {
    return null;
  }

  var valueToDate = new Date(rawValueTo);

  if (isNaN(valueToDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  return valueToDate;
};

var getDetailValueTo = function getDetailValueTo(value, minDate, maxDate, maxDetail) {
  var valueTo = getValueTo(value);

  if (!valueTo) {
    return null;
  }

  var detailValueTo = (0, dates.getEnd)(getValueType(maxDetail), valueTo);
  return (0, utils.between)(detailValueTo, minDate, maxDate);
};

var getDetailValueArray = function getDetailValueArray(value, minDate, maxDate, maxDetail) {
  if (value instanceof Array) {
    return value;
  }

  return [getDetailValueFrom(value, minDate, maxDate, maxDetail), getDetailValueTo(value, minDate, maxDate, maxDetail)];
};

var getActiveStartDate = function getActiveStartDate(props) {
  var activeStartDate = props.activeStartDate,
      maxDate = props.maxDate,
      maxDetail = props.maxDetail,
      minDate = props.minDate,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view;
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = getDetailValueFrom(value, minDate, maxDate, maxDetail) || activeStartDate || new Date();
  return (0, dates.getBegin)(rangeType, valueFrom);
};

var Calendar =
/*#__PURE__*/
function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "setActiveStartDate", function (activeStartDate) {
      var onActiveDateChange = _this.props.onActiveDateChange;

      _this.setState({
        activeStartDate: activeStartDate
      }, function () {
        var view = _this.state.view;
        (0, utils.callIfDefined)(onActiveDateChange, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "drillDown", function (activeStartDate) {
      if (!_this.drillDownAvailable) {
        return;
      }

      var _this$props = _this.props,
          maxDetail = _this$props.maxDetail,
          minDetail = _this$props.minDetail,
          onDrillDown = _this$props.onDrillDown;
      var views = getLimitedViews(minDetail, maxDetail);

      _this.setState(function (prevState) {
        var nextView = views[views.indexOf(prevState.view) + 1];
        return {
          activeStartDate: activeStartDate,
          view: nextView
        };
      }, function () {
        var view = _this.state.view;
        (0, utils.callIfDefined)(onDrillDown, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "drillUp", function () {
      if (!_this.drillUpAvailable) {
        return;
      }

      var _this$props2 = _this.props,
          maxDetail = _this$props2.maxDetail,
          minDetail = _this$props2.minDetail,
          onDrillUp = _this$props2.onDrillUp;
      var views = getLimitedViews(minDetail, maxDetail);

      _this.setState(function (prevState) {
        var nextView = views[views.indexOf(prevState.view) - 1];
        var activeStartDate = (0, dates.getBegin)(nextView, prevState.activeStartDate);
        return {
          activeStartDate: activeStartDate,
          view: nextView
        };
      }, function () {
        var _this$state = _this.state,
            activeStartDate = _this$state.activeStartDate,
            view = _this$state.view;
        (0, utils.callIfDefined)(onDrillUp, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          selectRange = _this$props3.selectRange;
      var nextValue;
      var callback;

      if (selectRange) {
        var previousValue = _this.state.value; // Range selection turned on

        if (!previousValue || [].concat(previousValue).length !== 1 // 0 or 2 - either way we're starting a new array
        ) {
            // First value
            nextValue = (0, dates.getBegin)(_this.valueType, value);
          } else {
          // Second value
          nextValue = (0, dates.getValueRange)(_this.valueType, previousValue, value);

          callback = function callback() {
            return (0, utils.callIfDefined)(onChange, nextValue);
          };
        }
      } else {
        // Range selection turned off
        nextValue = _this.getProcessedValue(value);

        callback = function callback() {
          return (0, utils.callIfDefined)(onChange, nextValue);
        };
      }

      _this.setState({
        value: nextValue
      }, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function (value) {
      _this.setState(function (prevState) {
        if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
          return null;
        }

        return {
          hover: value
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        hover: null
      });
    });

    return _this;
  }

  _createClass(Calendar, [{
    key: "getProcessedValue",

    /**
     * Gets current value in a desired format.
     */
    value: function getProcessedValue(value) {
      var _this$props4 = this.props,
          minDate = _this$props4.minDate,
          maxDate = _this$props4.maxDate,
          maxDetail = _this$props4.maxDetail,
          returnValue = _this$props4.returnValue;

      var processFunction = function () {
        switch (returnValue) {
          case 'start':
            return getDetailValueFrom;

          case 'end':
            return getDetailValueTo;

          case 'range':
            return getDetailValueArray;

          default:
            throw new Error('Invalid returnValue.');
        }
      }();

      return processFunction(value, minDate, maxDate, maxDetail);
    }
    /**
     * Called when the user uses navigation buttons.
     */

  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props5 = this.props,
          calendarType = _this$props5.calendarType,
          locale = _this$props5.locale,
          maxDate = _this$props5.maxDate,
          minDate = _this$props5.minDate,
          renderChildren = _this$props5.renderChildren,
          selectRange = _this$props5.selectRange,
          tileClassName = _this$props5.tileClassName,
          tileContent = _this$props5.tileContent,
          tileDisabled = _this$props5.tileDisabled;
      var _this$state2 = this.state,
          activeStartDate = _this$state2.activeStartDate,
          hover = _this$state2.hover,
          value = _this$state2.value,
          view = _this$state2.view;
      var onMouseOver = this.onMouseOver,
          valueType = this.valueType;
      var commonProps = {
        activeStartDate: activeStartDate,
        hover: hover,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        onMouseOver: selectRange ? onMouseOver : null,
        tileClassName: tileClassName,
        tileContent: tileContent || renderChildren,
        // For backwards compatibility
        tileDisabled: tileDisabled,
        value: value,
        valueType: valueType
      };
      var clickAction = this.drillDownAvailable ? this.drillDown : this.onChange;

      switch (view) {
        case 'century':
          {
            var onClickDecade = this.props.onClickDecade;
            return _react["default"].createElement(_CenturyView["default"], _extends({
              onClick: (0, utils.mergeFunctions)(clickAction, onClickDecade)
            }, commonProps));
          }

        case 'decade':
          {
            var onClickYear = this.props.onClickYear;
            return _react["default"].createElement(_DecadeView["default"], _extends({
              onClick: (0, utils.mergeFunctions)(clickAction, onClickYear)
            }, commonProps));
          }

        case 'year':
          {
            var _this$props6 = this.props,
                formatMonth = _this$props6.formatMonth,
                onClickMonth = _this$props6.onClickMonth;
            return _react["default"].createElement(_YearView["default"], _extends({
              formatMonth: formatMonth,
              onClick: (0, utils.mergeFunctions)(clickAction, onClickMonth)
            }, commonProps));
          }

        case 'month':
          {
            var _this$props7 = this.props,
                formatShortWeekday = _this$props7.formatShortWeekday,
                onClickDay = _this$props7.onClickDay,
                onClickWeekNumber = _this$props7.onClickWeekNumber,
                showFixedNumberOfWeeks = _this$props7.showFixedNumberOfWeeks,
                showNeighboringMonth = _this$props7.showNeighboringMonth,
                showWeekNumbers = _this$props7.showWeekNumbers;
            var onMouseLeave = this.onMouseLeave;
            return _react["default"].createElement(_MonthView["default"], _extends({
              calendarType: calendarType,
              formatShortWeekday: formatShortWeekday,
              onClick: (0, utils.mergeFunctions)(clickAction, onClickDay),
              onClickWeekNumber: onClickWeekNumber,
              onMouseLeave: onMouseLeave,
              showFixedNumberOfWeeks: showFixedNumberOfWeeks,
              showNeighboringMonth: showNeighboringMonth,
              showWeekNumbers: showWeekNumbers
            }, commonProps));
          }

        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var showNavigation = this.props.showNavigation;

      if (!showNavigation) {
        return null;
      }

      var _this$props8 = this.props,
          formatMonthYear = _this$props8.formatMonthYear,
          locale = _this$props8.locale,
          maxDate = _this$props8.maxDate,
          maxDetail = _this$props8.maxDetail,
          minDate = _this$props8.minDate,
          minDetail = _this$props8.minDetail,
          navigationAriaLabel = _this$props8.navigationAriaLabel,
          navigationLabel = _this$props8.navigationLabel,
          next2AriaLabel = _this$props8.next2AriaLabel,
          next2Label = _this$props8.next2Label,
          nextAriaLabel = _this$props8.nextAriaLabel,
          nextLabel = _this$props8.nextLabel,
          prev2AriaLabel = _this$props8.prev2AriaLabel,
          prev2Label = _this$props8.prev2Label,
          prevAriaLabel = _this$props8.prevAriaLabel,
          prevLabel = _this$props8.prevLabel;
      var _this$state3 = this.state,
          activeStartDate = _this$state3.activeStartDate,
          view = _this$state3.view;
      return _react["default"].createElement(_Navigation["default"], {
        activeStartDate: activeStartDate,
        drillUp: this.drillUp,
        formatMonthYear: formatMonthYear,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        navigationAriaLabel: navigationAriaLabel,
        navigationLabel: navigationLabel,
        next2AriaLabel: next2AriaLabel,
        next2Label: next2Label,
        nextAriaLabel: nextAriaLabel,
        nextLabel: nextLabel,
        prev2AriaLabel: prev2AriaLabel,
        prev2Label: prev2Label,
        prevAriaLabel: prevAriaLabel,
        prevLabel: prevLabel,
        setActiveStartDate: this.setActiveStartDate,
        view: view,
        views: getLimitedViews(minDetail, maxDetail)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          className = _this$props9.className,
          selectRange = _this$props9.selectRange;
      var value = this.state.value;
      var onMouseLeave = this.onMouseLeave;
      var valueArray = [].concat(value);
      return _react["default"].createElement("div", {
        className: (0, _mergeClassNames["default"])(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), className)
      }, this.renderNavigation(), _react["default"].createElement("div", {
        className: "".concat(baseClassName, "__viewContainer"),
        onBlur: selectRange ? onMouseLeave : null,
        onMouseLeave: selectRange ? onMouseLeave : null
      }, this.renderContent()));
    }
  }, {
    key: "drillDownAvailable",
    get: function get() {
      var _this$props10 = this.props,
          maxDetail = _this$props10.maxDetail,
          minDetail = _this$props10.minDetail;
      var view = this.state.view;
      var views = getLimitedViews(minDetail, maxDetail);
      return views.indexOf(view) < views.length - 1;
    }
  }, {
    key: "drillUpAvailable",
    get: function get() {
      var _this$props11 = this.props,
          maxDetail = _this$props11.maxDetail,
          minDetail = _this$props11.minDetail;
      var view = this.state.view;
      var views = getLimitedViews(minDetail, maxDetail);
      return views.indexOf(view) > 0;
    }
  }, {
    key: "valueType",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      return getValueType(maxDetail);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var minDate = nextProps.minDate,
          maxDate = nextProps.maxDate,
          minDetail = nextProps.minDetail,
          maxDetail = nextProps.maxDetail;
      var nextState = {};
      /**
       * If the next activeStartDate is different from the current one, update
       * activeStartDate (for display) and activeStartDateProps (for future comparisons)
       */

      var nextActiveStartDate = getActiveStartDate(nextProps);

      if (datesAreDifferent(nextActiveStartDate, prevState.activeStartDateProps)) {
        nextState.activeStartDate = nextActiveStartDate;
        nextState.activeStartDateProps = nextActiveStartDate;
      }
      /**
       * If the next view is different from the current one, and the previously set view is not
       * valid based on minDetail and maxDetail, get a new one.
       */


      var nextView = getView(nextProps.view, minDetail, maxDetail);

      if (nextView !== prevState.viewProps && !isViewAllowed(prevState.view, minDetail, maxDetail)) {
        nextState.view = nextView;
        nextState.viewProps = nextView;
      }
      /**
       * If the next value is different from the current one (with an exception of situation in
       * which values provided are limited by minDate and maxDate so that the dates are the same),
       * get a new one.
       */


      var values = [nextProps.value, prevState.valueProps];

      if (nextState.view // Allowed view changed
      || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
        return getValueFrom(value);
      }))) || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
        return getValueTo(value);
      })))) {
        nextState.value = nextProps.value;
        nextState.valueProps = nextProps.value;
      }

      if (!nextProps.selectRange && prevState.hover) {
        nextState.hover = null;
      }

      return nextState;
    }
  }]);

  return Calendar;
}(_react.Component);

exports["default"] = Calendar;
Calendar.defaultProps = {
  maxDetail: 'month',
  minDetail: 'century',
  returnValue: 'start',
  showNavigation: true,
  showNeighboringMonth: true,
  view: 'month'
};
Calendar.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date),
  calendarType: propTypes.isCalendarType,
  className: propTypes.isClassName,
  formatMonth: _propTypes["default"].func,
  formatMonthYear: _propTypes["default"].func,
  formatShortWeekday: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  maxDate: propTypes.isMaxDate,
  maxDetail: _propTypes["default"].oneOf(allViews),
  minDate: propTypes.isMinDate,
  minDetail: _propTypes["default"].oneOf(allViews),
  navigationAriaLabel: _propTypes["default"].string,
  navigationLabel: _propTypes["default"].func,
  next2AriaLabel: _propTypes["default"].string,
  next2Label: _propTypes["default"].node,
  nextAriaLabel: _propTypes["default"].string,
  nextLabel: _propTypes["default"].node,
  onActiveDateChange: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClickDay: _propTypes["default"].func,
  onClickDecade: _propTypes["default"].func,
  onClickMonth: _propTypes["default"].func,
  onClickWeekNumber: _propTypes["default"].func,
  onClickYear: _propTypes["default"].func,
  onDrillDown: _propTypes["default"].func,
  onDrillUp: _propTypes["default"].func,
  prev2AriaLabel: _propTypes["default"].string,
  prev2Label: _propTypes["default"].node,
  prevAriaLabel: _propTypes["default"].string,
  prevLabel: _propTypes["default"].node,
  renderChildren: _propTypes["default"].func,
  // For backwards compatibility
  returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
  selectRange: _propTypes["default"].bool,
  showFixedNumberOfWeeks: _propTypes["default"].bool,
  showNavigation: _propTypes["default"].bool,
  showNeighboringMonth: _propTypes["default"].bool,
  showWeekNumbers: _propTypes["default"].bool,
  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, propTypes.isClassName]),
  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  tileDisabled: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, propTypes.isValue]),
  view: _propTypes["default"].oneOf(allViews)
};
(0, reactLifecyclesCompat_es.polyfill)(Calendar);
});

unwrapExports(Calendar_1);

var css_248z$6 = ".Calendar_react-calendar__28k-7 {\n  width: 350px;\n  max-width: 100%;\n  background: white;\n  border: 1px solid #a0a096;\n  font-family: Arial, Helvetica, sans-serif;\n  line-height: 1.125em;\n}\n.Calendar_react-calendar__28k-7,\n.Calendar_react-calendar__28k-7 *,\n.Calendar_react-calendar__28k-7 *:before,\n.Calendar_react-calendar__28k-7 *:after {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.Calendar_react-calendar__28k-7 button {\n  margin: 0;\n  border: 0;\n  outline: none;\n}\n.Calendar_react-calendar__28k-7 button:enabled:hover {\n  cursor: pointer;\n}\n.Calendar_react-calendar__navigation__1oywf {\n  height: 44px;\n  margin-bottom: 1em;\n}\n.Calendar_react-calendar__navigation__1oywf button {\n  min-width: 44px;\n  background: none;\n}\n.Calendar_react-calendar__navigation__1oywf button:enabled:hover,\n.Calendar_react-calendar__navigation__1oywf button:enabled:focus {\n  background-color: #e6e6e6;\n}\n.Calendar_react-calendar__navigation__1oywf button[disabled] {\n  background-color: #f0f0f0;\n}\n.Calendar_react-calendar__month-view__weekdays__2AxtY {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 0.75em;\n}\n.Calendar_react-calendar__month-view__weekdays__weekday__2zxz5 {\n  padding: 0.5em;\n}\n.Calendar_react-calendar__month-view__weekNumbers__1UbYq {\n  font-weight: bold;\n}\n.Calendar_react-calendar__month-view__weekNumbers__1UbYq .Calendar_react-calendar__tile__W4jMC {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75em;\n  padding: calc(0.75em / 0.75) calc(0.5em / 0.75);\n}\n.Calendar_react-calendar__month-view__days__day--weekend__2wEsg {\n  color: #d10000;\n}\n.Calendar_react-calendar__month-view__days__day--neighboringMonth__3NkNK {\n  color: #757575;\n}\n.Calendar_react-calendar__year-view__6igQC .Calendar_react-calendar__tile__W4jMC,\n.Calendar_react-calendar__decade-view__23H7n .Calendar_react-calendar__tile__W4jMC,\n.Calendar_react-calendar__century-view__GDCWm .Calendar_react-calendar__tile__W4jMC {\n  padding: 2em 0.5em;\n}\n.Calendar_react-calendar__tile__W4jMC {\n  max-width: 100%;\n  text-align: center;\n  padding: 0.75em 0.5em;\n  background: none;\n}\n.Calendar_react-calendar__tile__W4jMC:disabled {\n  background-color: #f0f0f0;\n}\n.Calendar_react-calendar__tile__W4jMC:enabled:hover,\n.Calendar_react-calendar__tile__W4jMC:enabled:focus {\n  background-color: #e6e6e6;\n}\n.Calendar_react-calendar__tile--hasActive__3OPgc {\n  background: #76baff;\n}\n.Calendar_react-calendar__tile--hasActive__3OPgc:enabled:hover,\n.Calendar_react-calendar__tile--hasActive__3OPgc:enabled:focus {\n  background: #a9d4ff;\n}\n.Calendar_react-calendar__tile--active__1T0Es {\n  background: #006edc;\n  color: white;\n}\n.Calendar_react-calendar__tile--active__1T0Es:enabled:hover,\n.Calendar_react-calendar__tile--active__1T0Es:enabled:focus {\n  background: #1087ff;\n}\n.Calendar_react-calendar--selectRange__1WerO .Calendar_react-calendar__tile--hover__no8UL {\n  background-color: #e6e6e6;\n}\n";
var Calendar = {"react-calendar":"Calendar_react-calendar__28k-7","react-calendar__navigation":"Calendar_react-calendar__navigation__1oywf","react-calendar__month-view__weekdays":"Calendar_react-calendar__month-view__weekdays__2AxtY","react-calendar__month-view__weekdays__weekday":"Calendar_react-calendar__month-view__weekdays__weekday__2zxz5","react-calendar__month-view__weekNumbers":"Calendar_react-calendar__month-view__weekNumbers__1UbYq","react-calendar__tile":"Calendar_react-calendar__tile__W4jMC","react-calendar__month-view__days__day--weekend":"Calendar_react-calendar__month-view__days__day--weekend__2wEsg","react-calendar__month-view__days__day--neighboringMonth":"Calendar_react-calendar__month-view__days__day--neighboringMonth__3NkNK","react-calendar__year-view":"Calendar_react-calendar__year-view__6igQC","react-calendar__decade-view":"Calendar_react-calendar__decade-view__23H7n","react-calendar__century-view":"Calendar_react-calendar__century-view__GDCWm","react-calendar__tile--hasActive":"Calendar_react-calendar__tile--hasActive__3OPgc","react-calendar__tile--active":"Calendar_react-calendar__tile--active__1T0Es","react-calendar--selectRange":"Calendar_react-calendar--selectRange__1WerO","react-calendar__tile--hover":"Calendar_react-calendar__tile--hover__no8UL"};
var stylesheet=".Calendar_react-calendar__28k-7 {\n  width: 350px;\n  max-width: 100%;\n  background: white;\n  border: 1px solid #a0a096;\n  font-family: Arial, Helvetica, sans-serif;\n  line-height: 1.125em;\n}\n.Calendar_react-calendar__28k-7,\n.Calendar_react-calendar__28k-7 *,\n.Calendar_react-calendar__28k-7 *:before,\n.Calendar_react-calendar__28k-7 *:after {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.Calendar_react-calendar__28k-7 button {\n  margin: 0;\n  border: 0;\n  outline: none;\n}\n.Calendar_react-calendar__28k-7 button:enabled:hover {\n  cursor: pointer;\n}\n.Calendar_react-calendar__navigation__1oywf {\n  height: 44px;\n  margin-bottom: 1em;\n}\n.Calendar_react-calendar__navigation__1oywf button {\n  min-width: 44px;\n  background: none;\n}\n.Calendar_react-calendar__navigation__1oywf button:enabled:hover,\n.Calendar_react-calendar__navigation__1oywf button:enabled:focus {\n  background-color: #e6e6e6;\n}\n.Calendar_react-calendar__navigation__1oywf button[disabled] {\n  background-color: #f0f0f0;\n}\n.Calendar_react-calendar__month-view__weekdays__2AxtY {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 0.75em;\n}\n.Calendar_react-calendar__month-view__weekdays__weekday__2zxz5 {\n  padding: 0.5em;\n}\n.Calendar_react-calendar__month-view__weekNumbers__1UbYq {\n  font-weight: bold;\n}\n.Calendar_react-calendar__month-view__weekNumbers__1UbYq .Calendar_react-calendar__tile__W4jMC {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75em;\n  padding: calc(0.75em / 0.75) calc(0.5em / 0.75);\n}\n.Calendar_react-calendar__month-view__days__day--weekend__2wEsg {\n  color: #d10000;\n}\n.Calendar_react-calendar__month-view__days__day--neighboringMonth__3NkNK {\n  color: #757575;\n}\n.Calendar_react-calendar__year-view__6igQC .Calendar_react-calendar__tile__W4jMC,\n.Calendar_react-calendar__decade-view__23H7n .Calendar_react-calendar__tile__W4jMC,\n.Calendar_react-calendar__century-view__GDCWm .Calendar_react-calendar__tile__W4jMC {\n  padding: 2em 0.5em;\n}\n.Calendar_react-calendar__tile__W4jMC {\n  max-width: 100%;\n  text-align: center;\n  padding: 0.75em 0.5em;\n  background: none;\n}\n.Calendar_react-calendar__tile__W4jMC:disabled {\n  background-color: #f0f0f0;\n}\n.Calendar_react-calendar__tile__W4jMC:enabled:hover,\n.Calendar_react-calendar__tile__W4jMC:enabled:focus {\n  background-color: #e6e6e6;\n}\n.Calendar_react-calendar__tile--hasActive__3OPgc {\n  background: #76baff;\n}\n.Calendar_react-calendar__tile--hasActive__3OPgc:enabled:hover,\n.Calendar_react-calendar__tile--hasActive__3OPgc:enabled:focus {\n  background: #a9d4ff;\n}\n.Calendar_react-calendar__tile--active__1T0Es {\n  background: #006edc;\n  color: white;\n}\n.Calendar_react-calendar__tile--active__1T0Es:enabled:hover,\n.Calendar_react-calendar__tile--active__1T0Es:enabled:focus {\n  background: #1087ff;\n}\n.Calendar_react-calendar--selectRange__1WerO .Calendar_react-calendar__tile--hover__no8UL {\n  background-color: #e6e6e6;\n}\n";
styleInject(css_248z$6);

var Calendar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Calendar,
  stylesheet: stylesheet
});

getCjsExportFromNamespace(Calendar$1);

var entry = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function get() {
    return _Calendar["default"];
  }
});
Object.defineProperty(exports, "CenturyView", {
  enumerable: true,
  get: function get() {
    return _CenturyView["default"];
  }
});
Object.defineProperty(exports, "DecadeView", {
  enumerable: true,
  get: function get() {
    return _DecadeView["default"];
  }
});
Object.defineProperty(exports, "YearView", {
  enumerable: true,
  get: function get() {
    return _YearView["default"];
  }
});
Object.defineProperty(exports, "MonthView", {
  enumerable: true,
  get: function get() {
    return _MonthView["default"];
  }
});
exports["default"] = void 0;

var _Calendar = _interopRequireDefault(Calendar_1);

var _CenturyView = _interopRequireDefault(CenturyView_1);

var _DecadeView = _interopRequireDefault(DecadeView_1);

var _YearView = _interopRequireDefault(YearView_1);

var _MonthView = _interopRequireDefault(MonthView_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// File is created during build phase and placed in dist directory
// eslint-disable-next-line import/no-unresolved
var _default = _Calendar["default"];
exports["default"] = _default;
});

var ReactCalendar = unwrapExports(entry);

var useOutsideClickHook = (function (onOuterClick, innerRef) {
  React$2.useEffect(function () {
    if (innerRef.current) {
      document.addEventListener('click', handleClick);
    } // unmount previous first in case input have changed


    return function () {
      return document.removeEventListener('click', handleClick);
    };

    function handleClick(e) {
      innerRef.current && !innerRef.current.contains(e.target) && onOuterClick(e);
    }
  }, [onOuterClick, innerRef] // invoke again, if inputs have changed
  );
});

function useToggleBoolean() {
  var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = React$2.useState(initial),
      _useState2 = _slicedToArray(_useState, 2),
      isTrue = _useState2[0],
      setIsTrue = _useState2[1];

  function toggle(forceValue) {
    setIsTrue(typeof forceValue === 'boolean' ? forceValue : !isTrue);
  }

  return [isTrue, toggle];
}

/** @license React v17.0.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden");}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;var ContextConsumer=h;var ContextProvider=z;var Element$1=A;var ForwardRef=B;var Fragment=C;var Lazy=D;var Memo=E;var Portal=F;var Profiler=G;var StrictMode=H;
var Suspense=I;var isAsyncMode=function(){return !1};var isConcurrentMode=function(){return !1};var isContextConsumer=function(a){return y(a)===h};var isContextProvider=function(a){return y(a)===g};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};var isForwardRef=function(a){return y(a)===k};var isFragment=function(a){return y(a)===d};var isLazy=function(a){return y(a)===p};var isMemo=function(a){return y(a)===n};
var isPortal=function(a){return y(a)===c};var isProfiler=function(a){return y(a)===f};var isStrictMode=function(a){return y(a)===e};var isSuspense=function(a){return y(a)===l};var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
var typeOf=y;

var reactIs_production_min = {
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
var reactIs_development_1 = reactIs_development.ContextConsumer;
var reactIs_development_2 = reactIs_development.ContextProvider;
var reactIs_development_3 = reactIs_development.Element;
var reactIs_development_4 = reactIs_development.ForwardRef;
var reactIs_development_5 = reactIs_development.Fragment;
var reactIs_development_6 = reactIs_development.Lazy;
var reactIs_development_7 = reactIs_development.Memo;
var reactIs_development_8 = reactIs_development.Portal;
var reactIs_development_9 = reactIs_development.Profiler;
var reactIs_development_10 = reactIs_development.StrictMode;
var reactIs_development_11 = reactIs_development.Suspense;
var reactIs_development_12 = reactIs_development.isAsyncMode;
var reactIs_development_13 = reactIs_development.isConcurrentMode;
var reactIs_development_14 = reactIs_development.isContextConsumer;
var reactIs_development_15 = reactIs_development.isContextProvider;
var reactIs_development_16 = reactIs_development.isElement;
var reactIs_development_17 = reactIs_development.isForwardRef;
var reactIs_development_18 = reactIs_development.isFragment;
var reactIs_development_19 = reactIs_development.isLazy;
var reactIs_development_20 = reactIs_development.isMemo;
var reactIs_development_21 = reactIs_development.isPortal;
var reactIs_development_22 = reactIs_development.isProfiler;
var reactIs_development_23 = reactIs_development.isStrictMode;
var reactIs_development_24 = reactIs_development.isSuspense;
var reactIs_development_25 = reactIs_development.isValidElementType;
var reactIs_development_26 = reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});
var reactIs_1 = reactIs.isElement;
var reactIs_2 = reactIs.isValidElementType;
var reactIs_3 = reactIs.ForwardRef;
var reactIs_4 = reactIs.typeOf;

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c$1=b$1?Symbol.for("react.element"):60103,d$1=b$1?Symbol.for("react.portal"):60106,e$1=b$1?Symbol.for("react.fragment"):60107,f$1=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l$1=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n$1=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q$1=b$1?
Symbol.for("react.suspense_list"):60120,r$1=b$1?Symbol.for("react.memo"):60115,t=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w$1=b$1?Symbol.for("react.fundamental"):60117,x$1=b$1?Symbol.for("react.responder"):60118,y$1=b$1?Symbol.for("react.scope"):60119;
function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$1:switch(a=a.type,a){case l$1:case m$1:case e$1:case g$1:case f$1:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$1:case t:case r$1:case h$1:return a;default:return u}}case d$1:return u}}}function A$1(a){return z$1(a)===m$1}var AsyncMode=l$1;var ConcurrentMode=m$1;var ContextConsumer$1=k$1;var ContextProvider$1=h$1;var Element$2=c$1;var ForwardRef$1=n$1;var Fragment$1=e$1;var Lazy$1=t;var Memo$1=r$1;var Portal$1=d$1;
var Profiler$1=g$1;var StrictMode$1=f$1;var Suspense$1=p$1;var isAsyncMode$1=function(a){return A$1(a)||z$1(a)===l$1};var isConcurrentMode$1=A$1;var isContextConsumer$1=function(a){return z$1(a)===k$1};var isContextProvider$1=function(a){return z$1(a)===h$1};var isElement$1=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$1};var isForwardRef$1=function(a){return z$1(a)===n$1};var isFragment$1=function(a){return z$1(a)===e$1};var isLazy$1=function(a){return z$1(a)===t};
var isMemo$1=function(a){return z$1(a)===r$1};var isPortal$1=function(a){return z$1(a)===d$1};var isProfiler$1=function(a){return z$1(a)===g$1};var isStrictMode$1=function(a){return z$1(a)===f$1};var isSuspense$1=function(a){return z$1(a)===p$1};
var isValidElementType$1=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$1||a===g$1||a===f$1||a===p$1||a===q$1||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r$1||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===n$1||a.$$typeof===w$1||a.$$typeof===x$1||a.$$typeof===y$1||a.$$typeof===v$1)};var typeOf$1=z$1;

var reactIs_production_min$1 = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer$1,
	ContextProvider: ContextProvider$1,
	Element: Element$2,
	ForwardRef: ForwardRef$1,
	Fragment: Fragment$1,
	Lazy: Lazy$1,
	Memo: Memo$1,
	Portal: Portal$1,
	Profiler: Profiler$1,
	StrictMode: StrictMode$1,
	Suspense: Suspense$1,
	isAsyncMode: isAsyncMode$1,
	isConcurrentMode: isConcurrentMode$1,
	isContextConsumer: isContextConsumer$1,
	isContextProvider: isContextProvider$1,
	isElement: isElement$1,
	isForwardRef: isForwardRef$1,
	isFragment: isFragment$1,
	isLazy: isLazy$1,
	isMemo: isMemo$1,
	isPortal: isPortal$1,
	isProfiler: isProfiler$1,
	isStrictMode: isStrictMode$1,
	isSuspense: isSuspense$1,
	isValidElementType: isValidElementType$1,
	typeOf: typeOf$1
};

var reactIs_development$1 = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
var reactIs_development_1$1 = reactIs_development$1.AsyncMode;
var reactIs_development_2$1 = reactIs_development$1.ConcurrentMode;
var reactIs_development_3$1 = reactIs_development$1.ContextConsumer;
var reactIs_development_4$1 = reactIs_development$1.ContextProvider;
var reactIs_development_5$1 = reactIs_development$1.Element;
var reactIs_development_6$1 = reactIs_development$1.ForwardRef;
var reactIs_development_7$1 = reactIs_development$1.Fragment;
var reactIs_development_8$1 = reactIs_development$1.Lazy;
var reactIs_development_9$1 = reactIs_development$1.Memo;
var reactIs_development_10$1 = reactIs_development$1.Portal;
var reactIs_development_11$1 = reactIs_development$1.Profiler;
var reactIs_development_12$1 = reactIs_development$1.StrictMode;
var reactIs_development_13$1 = reactIs_development$1.Suspense;
var reactIs_development_14$1 = reactIs_development$1.isAsyncMode;
var reactIs_development_15$1 = reactIs_development$1.isConcurrentMode;
var reactIs_development_16$1 = reactIs_development$1.isContextConsumer;
var reactIs_development_17$1 = reactIs_development$1.isContextProvider;
var reactIs_development_18$1 = reactIs_development$1.isElement;
var reactIs_development_19$1 = reactIs_development$1.isForwardRef;
var reactIs_development_20$1 = reactIs_development$1.isFragment;
var reactIs_development_21$1 = reactIs_development$1.isLazy;
var reactIs_development_22$1 = reactIs_development$1.isMemo;
var reactIs_development_23$1 = reactIs_development$1.isPortal;
var reactIs_development_24$1 = reactIs_development$1.isProfiler;
var reactIs_development_25$1 = reactIs_development$1.isStrictMode;
var reactIs_development_26$1 = reactIs_development$1.isSuspense;
var reactIs_development_27 = reactIs_development$1.isValidElementType;
var reactIs_development_28 = reactIs_development$1.typeOf;

var reactIs$1 = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min$1;
} else {
  module.exports = reactIs_development$1;
}
});

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs$1.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function v$2(){return (v$2=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e}).apply(this,arguments)}var y$2=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g$2=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!reactIs_4(t)},S=Object.freeze([]),w$2=Object.freeze({});function E$1(e){return "function"==typeof e}function b$2(e){return "production"!==process.env.NODE_ENV&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function N(e){return e&&"string"==typeof e.styledComponentId}var _="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A$2="undefined"!=typeof window&&"HTMLElement"in window,I$1=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!==process.env.NODE_ENV),O="production"!==process.env.NODE_ENV?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"}:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t);})),e}function D$1(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw "production"===process.env.NODE_ENV?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):new Error(R.apply(void 0,[O[e]].concat(n)).trim())}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e;}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D$1(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0;}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++);},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n);}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x$2=new Map,k$2=1,V=function(e){if(T.has(e))return T.get(e);for(;x$2.has(k$2);)k$2++;var t=k$2++;return "production"!==process.env.NODE_ENV&&((0|t)<0||t>1<<30)&&D$1(16,""+t),T.set(e,t),x$2.set(t,e),t},M=function(e){return x$2.get(e)},B$1=function(e,t){T.set(e,t),x$2.set(t,e);},z$2="style["+_+'][data-styled-version="5.2.1"]',L=new RegExp("^"+_+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),G$1=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r);},F$1=function(e,t){for(var n=t.innerHTML.split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(L);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(B$1(u,c),G$1(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0;}else r.push(i);}}},Y=function(){return "undefined"!=typeof __webpack_nonce__?__webpack_nonce__:null},q$2=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(_))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(_,"active"),r.setAttribute("data-styled-version","5.2.1");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H$1=function(){function e(e){var t=this.element=q$2(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D$1(17);}(t),this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return !1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--;},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q$2(e);this.nodes=t.childNodes,this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return !1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--;},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--;},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=A$2,J={isServer:!A$2,useCSSOMInjection:!I$1},Z=function(){function e(e,t,n){void 0===e&&(e=w$2),void 0===t&&(t={}),this.options=v$2({},J,{},e),this.gs=t,this.names=new Map(n),!this.options.isServer&&A$2&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(z$2),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(_)&&(F$1(e,o),o.parentNode&&o.parentNode.removeChild(o));}}(this));}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(v$2({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H$1(o):new $(o),new j(e)));var e,t,n,r,o;},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else {var n=new Set;n.add(t),this.names.set(e,n);}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n);},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear();},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e);},t.clearTag=function(){this.tag=void 0;},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=M(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(void 0!==i&&0!==a.length){var c=_+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",");})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n';}}}return r}(this)},e}(),X=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return (K(t%52)+n).replace(X,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E$1(n)&&!N(n))return !1}return !0}var re=te("5.2.1"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"===process.env.NODE_ENV&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,Z.registerId(t);}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else {var s=Ne(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s.length)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a);}o.push(i),this.staticRulesId=i;}else {for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h,"production"!==process.env.NODE_ENV&&(u=ee(u,h+d));else if(h){var p=Ne(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f;}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var v=n(l,"."+m,void 0,r);t.insertRules(r,m,v);}o.push(m);}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w$2:e,i=s.options,a=void 0===i?w$2:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_min(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}");}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t);}}}((function(e){d.push(e);})),f=function(e,r,s){return 0===r&&ie.includes(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f));},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D$1(15),ee(e,t.name)}),5381).toString():"",m}var ce=React__default['default'].createContext(),ue=ce.Consumer,le=React__default['default'].createContext(),de=(le.Consumer,new Z),he=ae();function pe(){return React$2.useContext(ce)||de}function fe(){return React$2.useContext(le)||he}var ve=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"));},this.toString=function(){return D$1(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t;}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ye=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return "-"+e.toLowerCase()};function Ee(e){return ye.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function Ne(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=Ne(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return "";if(N(e))return "."+e.styledComponentId;if(E$1(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return "production"!==process.env.NODE_ENV&&reactIs_1(u)&&console.warn(b$2(e)+" is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."),Ne(u,n,r,o)}var l;return e instanceof ve?r?(e.inject(r,o),e.getName(o)):e:g$2(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(g$2(t[i])?s.push.apply(s,e(t[i],i)):E$1(t[i])?s.push(Ee(i)+":",t[i],";"):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitlessKeys?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}function _e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E$1(e)||g$2(e)?Ne(y$2(S,[e].concat(n))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(y$2(e,n))}var Ce=/invalid hook call/i,Ae=new Set,Ie=function(e,t){if("production"!==process.env.NODE_ENV){var n="The component "+e+(t?' with the id of "'+t+'"':"")+" has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.";try{React$2.useRef(),Ae.has(n)||(console.warn(n),Ae.add(n));}catch(e){Ce.test(e.message)&&Ae.delete(n);}}},Pe=function(e,t,n){return void 0===n&&(n=w$2),e.theme!==n.theme&&e.theme||t||n.theme},Oe=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,Re=/(^-|-$)/g;function De(e){return e.replace(Oe,"-").replace(Re,"")}var je=function(e){return Q(te(e)>>>0)};function Te(e){return "string"==typeof e&&("production"===process.env.NODE_ENV||e.charAt(0)===e.charAt(0).toLowerCase())}var xe=function(e){return "function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},ke=function(e){return "__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Ve(e,t,n){var r=e[n];xe(t)&&xe(r)?Me(r,t):e[n]=t;}function Me(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(xe(i))for(var a in i)ke(a)&&Ve(e,i[a],a);}return e}var Be=React__default['default'].createContext(),ze=Be.Consumer;var Ge={};function Fe(e,t,n){var o=N(e),i=!Te(e),a=t.attrs,c=void 0===a?S:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":De(e);Ge[n]=(Ge[n]||0)+1;var r=n+"-"+je("5.2.1"+n+Ge[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,y=void 0===p?function(e){return Te(e)?"styled."+e:"Styled("+b$2(e)+")"}(e):p,g=t.displayName&&t.componentId?De(t.displayName)+"-"+t.componentId:t.componentId||h,_=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,C=t.shouldForwardProp;o&&e.shouldForwardProp&&(C=t.shouldForwardProp?function(n,r){return e.shouldForwardProp(n,r)&&t.shouldForwardProp(n,r)}:e.shouldForwardProp);var A,I=new oe(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target;"production"!==process.env.NODE_ENV&&React$2.useDebugValue(h);var m=function(e,t,n){void 0===e&&(e=w$2);var r=v$2({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E$1(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t];})),[r,o]}(Pe(t,React$2.useContext(Be),a)||w$2,t,o),y=m[0],g=m[1],S=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w$2,o,s):e.generateAndInjectStyles(n,o,s);return "production"!==process.env.NODE_ENV&&React$2.useDebugValue(i),"production"!==process.env.NODE_ENV&&!t&&r&&r(i),i}(i,r,y,"production"!==process.env.NODE_ENV?e.warnTooManyClasses:void 0),b=n,N=g.$as||t.$as||g.as||t.as||p,_=Te(N),C=g!==t?v$2({},t,{},g):t,A={};for(var I in C)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?A.as=C[I]:(d?d(I,index):!_||index(I))&&(A[I]=C[I]));return t.style&&g.style!==t.style&&(A.style=v$2({},t.style,{},g.style)),A.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),A.ref=b,React$2.createElement(N,A)}(A,e,t,P)};return O.displayName=y,(A=React__default['default'].forwardRef(O)).attrs=_,A.componentStyle=I,A.displayName=y,A.shouldForwardProp=C,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=g,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return {};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(Te(e)?e:De(b$2(e)));return Fe(e,v$2({},o,{attrs:_,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Me({},e.defaultProps,t):t;}}),"production"!==process.env.NODE_ENV&&(Ie(y,g),A.warnTooManyClasses=function(e,t){var n={},r=!1;return function(o){if(!r&&(n[o]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'+t+'"':"";console.warn("Over 200 classes were generated for component "+e+s+".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),r=!0,n={};}}}(y,g)),A.toString=function(){return "."+A.styledComponentId},i&&hoistNonReactStatics_cjs(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var Ye=function(e){return function e(t,r,o){if(void 0===o&&(o=w$2),!reactIs_2(r))return D$1(1,String(r));var s=function(){return t(r,o,_e.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,v$2({},o,{},n))},s.attrs=function(n){return e(t,r,v$2({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Fe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","tspan"].forEach((function(e){Ye[e]=Ye(e);}));function $e(e){"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=_e.apply(void 0,[e].concat(n)).join(""),s=je(o);return new ve(s,o)}"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"),"production"!==process.env.NODE_ENV&&process.env.NODE_ENV;

var COLORS_CONFIG = {
  //PLATFORM V2
  PRIMARY: {
    LS_CYAN: '#4EB3D4',
    POPPY_RED: '#F16153',
    LS_BLACK: '#373636',
    SANDY_GRAY: '#EAEAEA'
  },
  FEEDBACK: {
    SUCCESS: '#4ED4B2',
    INFO: '#3D68D3',
    WARNING: '#E1DB5F',
    DANGER: '#EB6383'
  },
  SECONDARY: {
    OFF_WHITE: '#F4F7F9',
    CRYSTAL: '#EDF7FB',
    SKY: '#DFEEF2',
    IRON: '#A2ACB3',
    WHITE: '#FFFFFF',
    DEEP_SEA: '#173042',
    STEEL: '#626E76'
  },
  GRADIENTS: {
    LAKE_TRAVIS: 'linear-gradient(to right,#4EB3D4,#79DEFF)',
    GRASS: 'linear-gradient(to right,#7CD88B,#AAFFB8)',
    UVA: 'linear-gradient(to right,#3D68D3,#F4E0FB)',
    SUNNY_SIDE_UP: 'linear-gradient(to right,#E1DB5F,#F4EE7F)'
  },
  TRANSPARENT: 'transparent',

  /* Black colors group */
  PUZZLE_MODAL_BORDER: 'rgba(0, 0, 0, 0.2)',
  BLACK$50: 'rgba(0, 0, 0, 0.5)',
  BLACK$70: 'rgba(0, 0, 0, 0.7)',
  BLACK_1: 'rgba(17, 20, 26, 0.7)',
  BLACK: '#000000',

  /* White colors group */
  WHITE$72: 'rgba(255, 255, 255, 0.72)',
  WHITE$30: 'rgba(255, 255, 255, 0.30)',
  WHITE: '#FFFFFF',
  WHITE_TWO: '#fcf9f9',

  /* Grey colors group */
  PUZZLE_MODAL_BACKDROP: 'rgba(0, 0, 0, 0.8)',
  GREY_CUSTOM_1: 'rgba(255, 255, 255, 0.15)',
  GREY_CUSTOM_2: 'rgba(34, 39, 52, 0.75)',
  GREY_CUSTOM_3: 'rgba(34, 39, 52, 0.98)',
  GREY_CUSTOM_4: 'rgba(34, 39, 52, 0.05)',
  GREY_CUSTOM_5: '#acacac',
  GREY_CUSTOM_6: '#797979',
  DARK_GREY: '#212126',
  SILVER: '#eaeaea',
  SILVER_LIGHT: '#d8d8d8',
  SILVER_CUSTOM_1: '#bbbbbb',
  BG_GREY: '#f4f7f9',

  /* Blue colors group */
  PUZZLE_BG_COLOR_DARK: '#0b2431',
  PUZZLE_BG_COLOR_LIGHT: '#4e9bd6',
  PUZZLE_BG_COLOR_INFO: '#265f83',
  PUZZLE_OUTER_GLOW: 'rgba(78, 155, 214, 0.8)',
  BLUE_NEON: '#3034ED',
  DEEP_SKY_BLUE: '#00ACED',
  SKY_BLUE: '#4eb3d4',
  SKY_BLUE$50: 'rgba(78, 179, 212, 0.5)',
  LIGHT_SEA_GREEN: 'rgb(36,151,193)',

  /* Brown colors group */
  SMOOTH_BROWN: '#373636',
  SMOOTH_BROWN$70: 'rgba(55, 54, 54, 0.7)',
  DARK_SMOOTH_BROWN: '#2c2b2b',

  /* Red colors group */
  RED_AMARANTH: '#FA254C',
  ORANGE: '#F16153',

  /* Green colors group */
  GREEN_EMERALD: '#30ED79',
  LIGHT_GREEN: '#4BD059',
  SHADOWS: {
    BLACK$10: '0 0 14px 0 rgba(0, 0, 0, 0.1)',
    BLACK$10_10: '0 10px 14px 0 rgba(0, 0, 0, 0.1)',
    BLACK$10_20: '0 0 14px 0 rgba(0, 0, 0, 0.1)',
    TOOLTIP_SHADOW: '0px 15px 25px rgba(0, 0, 0, 0.31)',
    CONFIRM_SHADOW: '0px 6px 11px rgba(0, 0, 0, 0.1)',
    MIDDLE_SHADOW: '0 2px 16px 0 rgba(0, 0, 0, 0.5)',
    BACKDROP_BROWN: 'rgba(55, 54, 54, 0.6)'
  }
};
var AVAILABLE_COLORS = Object.values(COLORS_CONFIG);

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  ", "\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Circle = Ye.div(_templateObject(), function (_ref) {
  var autoSize = _ref.autoSize;
  return autoSize && _e(["width:60%;height:60%;"]);
}, function (_ref2) {
  var active = _ref2.active,
      color = _ref2.color,
      colorInactive = _ref2.colorInactive;
  return active ? color : colorInactive;
});

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  & ", " {\n    width: 6px;\n    height: 6px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  font-size: 16px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var Content = Ye.div(_templateObject$1(), COLORS_CONFIG.SMOOTH_BROWN);
var Cell = Ye.div(_templateObject2(), function (_ref) {
  var hasEvent = _ref.hasEvent;
  return hasEvent && _e(["", "{border:1.5px solid ", ";border-radius:50%;}"], Content, COLORS_CONFIG.SKY_BLUE);
});
var Wrapper = Ye.div(_templateObject3(), Circle);

function Cell$1(_ref) {
  var day = _ref.day,
      hasEvent = _ref.hasEvent;
  return /*#__PURE__*/React__default['default'].createElement(Wrapper, null, /*#__PURE__*/React__default['default'].createElement(Cell, {
    hasEvent: hasEvent
  }, /*#__PURE__*/React__default['default'].createElement(Content, null, day)));
}

Cell$1.propTypes = {
  day: PropTypes__default['default'].string.isRequired,
  hasEvent: PropTypes__default['default'].bool.isRequired
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 0 4px 6px;\n  border-color: transparent transparent transparent ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var Triangle = Ye.div(_templateObject$2(), function (_ref) {
  var color = _ref.color;
  return color;
});

function ForwardTriangle(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default['default'].createElement(Triangle, {
    color: color
  });
}

ForwardTriangle.propTypes = {
  color: PropTypes__default['default'].oneOf(_toConsumableArray(AVAILABLE_COLORS))
};
ForwardTriangle.defaultProps = {
  color: COLORS_CONFIG.SMOOTH_BROWN
};

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  height: 24px;\n  width: 24px;\n  ", "\n  border-radius: 50%;\n  border: 1.5px solid ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var Circle$1 = Ye.div(_templateObject$3(), function (_ref) {
  var autoSize = _ref.autoSize;
  return autoSize && _e(["width:60%;height:60%;"]);
}, function (_ref2) {
  var color = _ref2.color;
  return color;
});

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n  border-color: ", ";\n  & ", " {\n    color: ", ";\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  color: ", ";\n  font-size: 21px;\n  font-weight: bold;\n  line-height: 1;\n\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var Sign = Ye.div(_templateObject$4(), COLORS_CONFIG.SKY_BLUE);
var Circle$2 = Ye(Circle$1)(_templateObject2$1(), function (_ref) {
  var color = _ref.color;
  return color;
}, Sign, function (_ref2) {
  var color = _ref2.color;
  return color;
});

function CircleWithSign(_ref) {
  var sign = _ref.sign,
      color = _ref.color,
      onClick = _ref.onClick;
  return /*#__PURE__*/React__default['default'].createElement(Circle$2, {
    onClick: onClick,
    color: color
  }, /*#__PURE__*/React__default['default'].createElement(Sign, null, sign));
}

CircleWithSign.propTypes = {
  sign: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].node]).isRequired,
  color: PropTypes__default['default'].oneOf(_toConsumableArray(AVAILABLE_COLORS)),
  onClick: PropTypes__default['default'].func
};
CircleWithSign.defaultProps = {
  color: COLORS_CONFIG.SKY_BLUE,
  onClick: null
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  & ", " {\n    width: 26px;\n    height: 26px;\n    border-width: 1px;\n  }\n  & ", " {\n    left: 55%;\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$1 = Ye.div(_templateObject$5(), Circle$2, Sign);

function CircleForward(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick;
  return /*#__PURE__*/React__default['default'].createElement(Wrapper$1, {
    onClick: onClick
  }, /*#__PURE__*/React__default['default'].createElement(CircleWithSign, {
    color: color,
    sign: /*#__PURE__*/React__default['default'].createElement(ForwardTriangle, {
      color: color
    })
  }));
}

CircleForward.propTypes = {
  color: PropTypes__default['default'].oneOf(_toConsumableArray(AVAILABLE_COLORS)),
  onClick: PropTypes__default['default'].func
};
CircleForward.defaultProps = {
  color: COLORS_CONFIG.SMOOTH_BROWN,
  onClick: null
};

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 6px 4px 0;\n  border-color: transparent ", " transparent transparent;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var Triangle$1 = Ye.div(_templateObject$6(), function (_ref) {
  var color = _ref.color;
  return color;
});

function BackTriangle(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default['default'].createElement(Triangle$1, {
    color: color
  });
}

BackTriangle.propTypes = {
  color: PropTypes__default['default'].oneOf(_toConsumableArray(AVAILABLE_COLORS))
};
BackTriangle.defaultProps = {
  color: COLORS_CONFIG.SMOOTH_BROWN
};

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  & ", " {\n    width: 26px;\n    height: 26px;\n    border-width: 1px;\n  }\n  & ", " {\n    left: 45%;\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$2 = Ye.div(_templateObject$7(), Circle$2, Sign);

function CircleBack(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick;
  return /*#__PURE__*/React__default['default'].createElement(Wrapper$2, {
    onClick: onClick
  }, /*#__PURE__*/React__default['default'].createElement(CircleWithSign, {
    color: color,
    sign: /*#__PURE__*/React__default['default'].createElement(BackTriangle, {
      color: color
    })
  }));
}

CircleBack.propTypes = {
  color: PropTypes__default['default'].oneOf(_toConsumableArray(AVAILABLE_COLORS)),
  onClick: PropTypes__default['default'].func
};
CircleBack.defaultProps = {
  color: COLORS_CONFIG.SMOOTH_BROWN,
  onClick: null
};

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  ", "\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$3 = Ye.div(_templateObject$8());
var Image = Ye.div(_templateObject2$2(), function (_ref) {
  var img = _ref.img;
  return _e(["background-image:url(", ");"], img);
}, function (_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      relative = _ref2.relative;
  return _e(["height:", " ", ";width:", " ", ";"], height, relative ? '%' : 'px', width, relative ? '%' : 'px');
});

function Img(_ref) {
  var src = _ref.src,
      size = _ref.size,
      relative = _ref.relative,
      onClick = _ref.onClick;

  var _size = _slicedToArray(size, 2),
      width = _size[0],
      height = _size[1];

  return /*#__PURE__*/React__default['default'].createElement(Wrapper$3, null, /*#__PURE__*/React__default['default'].createElement(Image, {
    relative: relative,
    img: src,
    width: width,
    height: height,
    onClick: onClick
  }));
}

Img.propTypes = {
  src: PropTypes__default['default'].string,
  size: PropTypes__default['default'].arrayOf(PropTypes__default['default'].number),
  onClick: PropTypes__default['default'].func,
  relative: PropTypes__default['default'].bool
};
Img.defaultProps = {
  onClick: null,
  src: null,
  size: [75, 75],
  relative: false
};

function _interopDefault$1(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault$1(React__default['default']);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r);}return e}function _extends$1(){return (_extends$1=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t);}function _objectWithoutPropertiesLoose$1(e,t){if(null==e)return {};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized$1(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation";}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else {var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select();}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else {var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length));}return {start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return {maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1);}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return -1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return !1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return !u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return !0;if(++s>=l.length)return !1}var t,n,a,i;return !isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return !1;var t,n;return (isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h);}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction$1(e){return "function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return (!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e);}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop);},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop();},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null);},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=ReactDOM__default['default'].findDOMNode(_assertThisInitialized$1(_assertThisInitialized$1(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e);},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t);},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t);}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)});},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e);},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return {mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return !0}catch(r){}return !f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized$1(_assertThisInitialized$1(f)).beforePasteState,n=_assertThisInitialized$1(_assertThisInitialized$1(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction$1(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection;}f.setInputValue(c),isFunction$1(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end);},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else {var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction$1(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection;}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction$1(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end);}f.runSaveSelectionLoop();}isFunction$1(f.props.onFocus)&&f.props.onFocus(e);},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction$1(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction$1(f.props.onChange)&&f.props.onChange(e);}isFunction$1(f.props.onBlur)&&f.props.onBlur(e);},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd();}};document.addEventListener("mouseup",r);}isFunction$1(f.props.onMouseDown)&&f.props.onMouseDown(e);},f.onPaste=function(e){isFunction$1(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""));},f.handleRef=function(e){null==f.props.children&&isFunction$1(f.props.inputRef)&&f.props.inputRef(e);};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction$1(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value;}return f.value=l,f}_inheritsLoose(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value));},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p));}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction$1(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection;}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end);}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate());},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop();},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose$1(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction$1(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends$1({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1);}else t=React.createElement("input",_extends$1({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);var reactInputMask_production_min=InputElement;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant$1 = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1$1 = invariant$1;

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__$1 = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__$1) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

function _interopDefault$2 (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React$1 = _interopDefault$2(React__default['default']);

var invariant$2 = _interopDefault$2(invariant_1$1);
var warning$1 = _interopDefault$2(warning_1);

function _defaults2$1(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _defaults2$1(subClass, superClass);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function setInputSelection$1(input, start, end) {
  if ('selectionStart' in input && 'selectionEnd' in input) {
    input.selectionStart = start;
    input.selectionEnd = end;
  } else {
    var range = input.createTextRange();
    range.collapse(true);
    range.moveStart('character', start);
    range.moveEnd('character', end - start);
    range.select();
  }
}
function getInputSelection$1(input) {
  var start = 0;
  var end = 0;

  if ('selectionStart' in input && 'selectionEnd' in input) {
    start = input.selectionStart;
    end = input.selectionEnd;
  } else {
    var range = document.selection.createRange();

    if (range.parentElement() === input) {
      start = -range.moveStart('character', -input.value.length);
      end = -range.moveEnd('character', -input.value.length);
    }
  }

  return {
    start: start,
    end: end,
    length: end - start
  };
}

var defaultFormatChars$1 = {
  '9': '[0-9]',
  'a': '[A-Za-z]',
  '*': '[A-Za-z0-9]'
};
var defaultMaskChar$1 = '_';

function parseMask$1 (mask, maskChar, formatChars) {
  var parsedMaskString = '';
  var prefix = '';
  var lastEditablePosition = null;
  var permanents = [];

  if (maskChar === undefined) {
    maskChar = defaultMaskChar$1;
  }

  if (formatChars == null) {
    formatChars = defaultFormatChars$1;
  }

  if (!mask || typeof mask !== 'string') {
    return {
      maskChar: maskChar,
      formatChars: formatChars,
      mask: null,
      prefix: null,
      lastEditablePosition: null,
      permanents: []
    };
  }

  var isPermanent = false;
  mask.split('').forEach(function (character) {
    if (!isPermanent && character === '\\') {
      isPermanent = true;
    } else {
      if (isPermanent || !formatChars[character]) {
        permanents.push(parsedMaskString.length);

        if (parsedMaskString.length === permanents.length - 1) {
          prefix += character;
        }
      } else {
        lastEditablePosition = parsedMaskString.length + 1;
      }

      parsedMaskString += character;
      isPermanent = false;
    }
  });
  return {
    maskChar: maskChar,
    formatChars: formatChars,
    prefix: prefix,
    mask: parsedMaskString,
    lastEditablePosition: lastEditablePosition,
    permanents: permanents
  };
}

/* eslint no-use-before-define: ["error", { functions: false }] */
function isPermanentCharacter$1(maskOptions, pos) {
  return maskOptions.permanents.indexOf(pos) !== -1;
}
function isAllowedCharacter$1(maskOptions, pos, character) {
  var mask = maskOptions.mask,
      formatChars = maskOptions.formatChars;

  if (!character) {
    return false;
  }

  if (isPermanentCharacter$1(maskOptions, pos)) {
    return mask[pos] === character;
  }

  var ruleChar = mask[pos];
  var charRule = formatChars[ruleChar];
  return new RegExp(charRule).test(character);
}
function isEmpty$1(maskOptions, value) {
  return value.split('').every(function (character, i) {
    return isPermanentCharacter$1(maskOptions, i) || !isAllowedCharacter$1(maskOptions, i, character);
  });
}
function getFilledLength$1(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    while (value.length > prefix.length && isPermanentCharacter$1(maskOptions, value.length - 1)) {
      value = value.slice(0, value.length - 1);
    }

    return value.length;
  }

  var filledLength = prefix.length;

  for (var i = value.length; i >= prefix.length; i--) {
    var character = value[i];
    var isEnteredCharacter = !isPermanentCharacter$1(maskOptions, i) && isAllowedCharacter$1(maskOptions, i, character);

    if (isEnteredCharacter) {
      filledLength = i + 1;
      break;
    }
  }

  return filledLength;
}
function isFilled$1(maskOptions, value) {
  return getFilledLength$1(maskOptions, value) === maskOptions.mask.length;
}
function formatValue$1(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    value = insertString$1(maskOptions, '', value, 0);

    if (value.length < prefix.length) {
      value = prefix;
    }

    while (value.length < mask.length && isPermanentCharacter$1(maskOptions, value.length)) {
      value += mask[value.length];
    }

    return value;
  }

  if (value) {
    var emptyValue = formatValue$1(maskOptions, '');
    return insertString$1(maskOptions, emptyValue, value, 0);
  }

  for (var i = 0; i < mask.length; i++) {
    if (isPermanentCharacter$1(maskOptions, i)) {
      value += mask[i];
    } else {
      value += maskChar;
    }
  }

  return value;
}
function clearRange$1(maskOptions, value, start, len) {
  var end = start + len;
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;
  var arrayValue = value.split('');

  if (!maskChar) {
    // remove any permanent chars after clear range, they will be added back by formatValue
    for (var i = end; i < arrayValue.length; i++) {
      if (isPermanentCharacter$1(maskOptions, i)) {
        arrayValue[i] = '';
      }
    }

    start = Math.max(prefix.length, start);
    arrayValue.splice(start, end - start);
    value = arrayValue.join('');
    return formatValue$1(maskOptions, value);
  }

  return arrayValue.map(function (character, i) {
    if (i < start || i >= end) {
      return character;
    }

    if (isPermanentCharacter$1(maskOptions, i)) {
      return mask[i];
    }

    return maskChar;
  }).join('');
}
function insertString$1(maskOptions, value, insertStr, insertPosition) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;
  var arrayInsertStr = insertStr.split('');
  var isInputFilled = isFilled$1(maskOptions, value);

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentCharacter$1(maskOptions, pos) || character === mask[pos];
  };

  var isUsableCharacter = function isUsableCharacter(character, pos) {
    return !maskChar || !isPermanentCharacter$1(maskOptions, pos) || character !== maskChar;
  };

  if (!maskChar && insertPosition > value.length) {
    value += mask.slice(value.length, insertPosition);
  }

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPosition, insertCharacter)) {
      if (insertPosition >= value.length) {
        value += mask[insertPosition];
      }

      if (!isUsableCharacter(insertCharacter, insertPosition)) {
        return true;
      }

      insertPosition++; // stop iteration if maximum value length reached

      if (insertPosition >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedCharacter$1(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

    if (!isAllowed) {
      return true;
    }

    if (insertPosition < value.length) {
      if (maskChar || isInputFilled || insertPosition < prefix.length) {
        value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition + 1);
      } else {
        value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition);
        value = formatValue$1(maskOptions, value);
      }
    } else if (!maskChar) {
      value += insertCharacter;
    }

    insertPosition++; // stop iteration if maximum value length reached

    return insertPosition < mask.length;
  });
  return value;
}
function getInsertStringLength$1(maskOptions, value, insertStr, insertPosition) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar;
  var arrayInsertStr = insertStr.split('');
  var initialInsertPosition = insertPosition;

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentCharacter$1(maskOptions, pos) || character === mask[pos];
  };

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPosition, insertCharacter)) {
      insertPosition++; // stop iteration if maximum value length reached

      if (insertPosition >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedCharacter$1(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

    if (isAllowed) {
      insertPosition++;
    } // stop iteration if maximum value length reached


    return insertPosition < mask.length;
  });
  return insertPosition - initialInsertPosition;
}
function getLeftEditablePosition$1(maskOptions, pos) {
  for (var i = pos; i >= 0; --i) {
    if (!isPermanentCharacter$1(maskOptions, i)) {
      return i;
    }
  }

  return null;
}
function getRightEditablePosition$1(maskOptions, pos) {
  var mask = maskOptions.mask;

  for (var i = pos; i < mask.length; ++i) {
    if (!isPermanentCharacter$1(maskOptions, i)) {
      return i;
    }
  }

  return null;
}
function getStringValue$1(value) {
  return !value && value !== 0 ? '' : value + '';
}

function processChange$1(maskOptions, value, selection, previousValue, previousSelection) {
  var mask = maskOptions.mask,
      prefix = maskOptions.prefix,
      lastEditablePosition = maskOptions.lastEditablePosition;
  var newValue = value;
  var enteredString = '';
  var formattedEnteredStringLength = 0;
  var removedLength = 0;
  var cursorPosition = Math.min(previousSelection.start, selection.start);

  if (selection.end > previousSelection.start) {
    enteredString = newValue.slice(previousSelection.start, selection.end);
    formattedEnteredStringLength = getInsertStringLength$1(maskOptions, previousValue, enteredString, cursorPosition);

    if (!formattedEnteredStringLength) {
      removedLength = 0;
    } else {
      removedLength = previousSelection.length;
    }
  } else if (newValue.length < previousValue.length) {
    removedLength = previousValue.length - newValue.length;
  }

  newValue = previousValue;

  if (removedLength) {
    if (removedLength === 1 && !previousSelection.length) {
      var deleteFromRight = previousSelection.start === selection.start;
      cursorPosition = deleteFromRight ? getRightEditablePosition$1(maskOptions, selection.start) : getLeftEditablePosition$1(maskOptions, selection.start);
    }

    newValue = clearRange$1(maskOptions, newValue, cursorPosition, removedLength);
  }

  newValue = insertString$1(maskOptions, newValue, enteredString, cursorPosition);
  cursorPosition = cursorPosition + formattedEnteredStringLength;

  if (cursorPosition >= mask.length) {
    cursorPosition = mask.length;
  } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
    cursorPosition = prefix.length;
  } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
    cursorPosition = getRightEditablePosition$1(maskOptions, cursorPosition);
  }

  newValue = formatValue$1(maskOptions, newValue);

  if (!enteredString) {
    enteredString = null;
  }

  return {
    value: newValue,
    enteredString: enteredString,
    selection: {
      start: cursorPosition,
      end: cursorPosition
    }
  };
}

function isWindowsPhoneBrowser$1() {
  var windows = new RegExp('windows', 'i');
  var phone = new RegExp('phone', 'i');
  var ua = navigator.userAgent;
  return windows.test(ua) && phone.test(ua);
}

function isFunction$2(value) {
  return typeof value === 'function';
}

function getRequestAnimationFrame$1() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
}

function getCancelAnimationFrame$1() {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
}

function defer$1(fn) {
  var hasCancelAnimationFrame = !!getCancelAnimationFrame$1();
  var deferFn;

  if (hasCancelAnimationFrame) {
    deferFn = getRequestAnimationFrame$1();
  } else {
    deferFn = function deferFn() {
      return setTimeout(fn, 1000 / 60);
    };
  }

  return deferFn(fn);
}
function cancelDefer$1(deferId) {
  var cancelFn = getCancelAnimationFrame$1() || clearTimeout;
  cancelFn(deferId);
}

var InputElement$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(InputElement, _React$Component);

  function InputElement(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.focused = false;
    _this.mounted = false;
    _this.previousSelection = null;
    _this.selectionDeferId = null;
    _this.saveSelectionLoopDeferId = null;

    _this.saveSelectionLoop = function () {
      _this.previousSelection = _this.getSelection();
      _this.saveSelectionLoopDeferId = defer$1(_this.saveSelectionLoop);
    };

    _this.runSaveSelectionLoop = function () {
      if (_this.saveSelectionLoopDeferId === null) {
        _this.saveSelectionLoop();
      }
    };

    _this.stopSaveSelectionLoop = function () {
      if (_this.saveSelectionLoopDeferId !== null) {
        cancelDefer$1(_this.saveSelectionLoopDeferId);
        _this.saveSelectionLoopDeferId = null;
        _this.previousSelection = null;
      }
    };

    _this.getInputDOMNode = function () {
      if (!_this.mounted) {
        return null;
      }

      var input = ReactDOM__default['default'].findDOMNode(_assertThisInitialized$2(_assertThisInitialized$2(_this)));
      var isDOMNode = typeof window !== 'undefined' && input instanceof window.Element; // workaround for react-test-renderer
      // https://github.com/sanniassin/react-input-mask/issues/147

      if (input && !isDOMNode) {
        return null;
      }

      if (input.nodeName !== 'INPUT') {
        input = input.querySelector('input');
      }

      if (!input) {
        throw new Error('react-input-mask: inputComponent doesn\'t contain input node');
      }

      return input;
    };

    _this.getInputValue = function () {
      var input = _this.getInputDOMNode();

      if (!input) {
        return null;
      }

      return input.value;
    };

    _this.setInputValue = function (value) {
      var input = _this.getInputDOMNode();

      if (!input) {
        return;
      }

      _this.value = value;
      input.value = value;
    };

    _this.setCursorToEnd = function () {
      var filledLength = getFilledLength$1(_this.maskOptions, _this.value);
      var pos = getRightEditablePosition$1(_this.maskOptions, filledLength);

      if (pos !== null) {
        _this.setCursorPosition(pos);
      }
    };

    _this.setSelection = function (start, end, options) {
      if (options === void 0) {
        options = {};
      }

      var input = _this.getInputDOMNode();

      var isFocused = _this.isFocused(); // don't change selection on unfocused input
      // because Safari sets focus on selection change (#154)


      if (!input || !isFocused) {
        return;
      }

      var _options = options,
          deferred = _options.deferred;

      if (!deferred) {
        setInputSelection$1(input, start, end);
      }

      if (_this.selectionDeferId !== null) {
        cancelDefer$1(_this.selectionDeferId);
      } // deferred selection update is required for pre-Lollipop Android browser,
      // but for consistent behavior we do it for all browsers


      _this.selectionDeferId = defer$1(function () {
        _this.selectionDeferId = null;
        setInputSelection$1(input, start, end);
      });
      _this.previousSelection = {
        start: start,
        end: end,
        length: Math.abs(end - start)
      };
    };

    _this.getSelection = function () {
      var input = _this.getInputDOMNode();

      return getInputSelection$1(input);
    };

    _this.getCursorPosition = function () {
      return _this.getSelection().start;
    };

    _this.setCursorPosition = function (pos) {
      _this.setSelection(pos, pos);
    };

    _this.isFocused = function () {
      return _this.focused;
    };

    _this.getBeforeMaskedValueChangeConfig = function () {
      var _this$maskOptions = _this.maskOptions,
          mask = _this$maskOptions.mask,
          maskChar = _this$maskOptions.maskChar,
          permanents = _this$maskOptions.permanents,
          formatChars = _this$maskOptions.formatChars;
      var alwaysShowMask = _this.props.alwaysShowMask;
      return {
        mask: mask,
        maskChar: maskChar,
        permanents: permanents,
        alwaysShowMask: !!alwaysShowMask,
        formatChars: formatChars
      };
    };

    _this.isInputAutofilled = function (value, selection, previousValue, previousSelection) {
      var input = _this.getInputDOMNode(); // only check for positive match because it will be false negative
      // in case of autofill simulation in tests
      //
      // input.matches throws an exception if selector isn't supported


      try {
        if (input.matches(':-webkit-autofill')) {
          return true;
        }
      } catch (e) {} // if input isn't focused then change event must have been triggered
      // either by autofill or event simulation in tests


      if (!_this.focused) {
        return true;
      } // if cursor has moved to the end while previousSelection forbids it
      // then it must be autofill


      return previousSelection.end < previousValue.length && selection.end === value.length;
    };

    _this.onChange = function (event) {
      var _assertThisInitialize = _assertThisInitialized$2(_assertThisInitialized$2(_this)),
          beforePasteState = _assertThisInitialize.beforePasteState;

      var _assertThisInitialize2 = _assertThisInitialized$2(_assertThisInitialized$2(_this)),
          previousSelection = _assertThisInitialize2.previousSelection;

      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;

      var value = _this.getInputValue();

      var previousValue = _this.value;

      var selection = _this.getSelection(); // autofill replaces entire value, ignore old one
      // https://github.com/sanniassin/react-input-mask/issues/113


      if (_this.isInputAutofilled(value, selection, previousValue, previousSelection)) {
        previousValue = formatValue$1(_this.maskOptions, '');
        previousSelection = {
          start: 0,
          end: 0,
          length: 0
        };
      } // set value and selection as if we haven't
      // cleared input in onPaste handler


      if (beforePasteState) {
        previousSelection = beforePasteState.selection;
        previousValue = beforePasteState.value;
        selection = {
          start: previousSelection.start + value.length,
          end: previousSelection.start + value.length,
          length: 0
        };
        value = previousValue.slice(0, previousSelection.start) + value + previousValue.slice(previousSelection.end);
        _this.beforePasteState = null;
      }

      var changedState = processChange$1(_this.maskOptions, value, selection, previousValue, previousSelection);
      var enteredString = changedState.enteredString;
      var newSelection = changedState.selection;
      var newValue = changedState.value;

      if (isFunction$2(beforeMaskedValueChange)) {
        var modifiedValue = beforeMaskedValueChange({
          value: newValue,
          selection: newSelection
        }, {
          value: previousValue,
          selection: previousSelection
        }, enteredString, _this.getBeforeMaskedValueChangeConfig());
        newValue = modifiedValue.value;
        newSelection = modifiedValue.selection;
      }

      _this.setInputValue(newValue);

      if (isFunction$2(_this.props.onChange)) {
        _this.props.onChange(event);
      }

      if (_this.isWindowsPhoneBrowser) {
        _this.setSelection(newSelection.start, newSelection.end, {
          deferred: true
        });
      } else {
        _this.setSelection(newSelection.start, newSelection.end);
      }
    };

    _this.onFocus = function (event) {
      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
      var _this$maskOptions2 = _this.maskOptions,
          mask = _this$maskOptions2.mask,
          prefix = _this$maskOptions2.prefix;
      _this.focused = true; // if autoFocus is set, onFocus triggers before componentDidMount

      _this.mounted = true;

      if (mask) {
        if (!_this.value) {
          var emptyValue = formatValue$1(_this.maskOptions, prefix);
          var newValue = formatValue$1(_this.maskOptions, emptyValue);
          var filledLength = getFilledLength$1(_this.maskOptions, newValue);
          var cursorPosition = getRightEditablePosition$1(_this.maskOptions, filledLength);
          var newSelection = {
            start: cursorPosition,
            end: cursorPosition
          };

          if (isFunction$2(beforeMaskedValueChange)) {
            var modifiedValue = beforeMaskedValueChange({
              value: newValue,
              selection: newSelection
            }, {
              value: _this.value,
              selection: null
            }, null, _this.getBeforeMaskedValueChangeConfig());
            newValue = modifiedValue.value;
            newSelection = modifiedValue.selection;
          }

          var isInputValueChanged = newValue !== _this.getInputValue();

          if (isInputValueChanged) {
            _this.setInputValue(newValue);
          }

          if (isInputValueChanged && isFunction$2(_this.props.onChange)) {
            _this.props.onChange(event);
          }

          _this.setSelection(newSelection.start, newSelection.end);
        } else if (getFilledLength$1(_this.maskOptions, _this.value) < _this.maskOptions.mask.length) {
          _this.setCursorToEnd();
        }

        _this.runSaveSelectionLoop();
      }

      if (isFunction$2(_this.props.onFocus)) {
        _this.props.onFocus(event);
      }
    };

    _this.onBlur = function (event) {
      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
      var mask = _this.maskOptions.mask;

      _this.stopSaveSelectionLoop();

      _this.focused = false;

      if (mask && !_this.props.alwaysShowMask && isEmpty$1(_this.maskOptions, _this.value)) {
        var newValue = '';

        if (isFunction$2(beforeMaskedValueChange)) {
          var modifiedValue = beforeMaskedValueChange({
            value: newValue,
            selection: null
          }, {
            value: _this.value,
            selection: _this.previousSelection
          }, null, _this.getBeforeMaskedValueChangeConfig());
          newValue = modifiedValue.value;
        }

        var isInputValueChanged = newValue !== _this.getInputValue();

        if (isInputValueChanged) {
          _this.setInputValue(newValue);
        }

        if (isInputValueChanged && isFunction$2(_this.props.onChange)) {
          _this.props.onChange(event);
        }
      }

      if (isFunction$2(_this.props.onBlur)) {
        _this.props.onBlur(event);
      }
    };

    _this.onMouseDown = function (event) {
      // tiny unintentional mouse movements can break cursor
      // position on focus, so we have to restore it in that case
      //
      // https://github.com/sanniassin/react-input-mask/issues/108
      if (!_this.focused && document.addEventListener) {
        _this.mouseDownX = event.clientX;
        _this.mouseDownY = event.clientY;
        _this.mouseDownTime = new Date().getTime();

        var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
          document.removeEventListener('mouseup', mouseUpHandler);

          if (!_this.focused) {
            return;
          }

          var deltaX = Math.abs(mouseUpEvent.clientX - _this.mouseDownX);
          var deltaY = Math.abs(mouseUpEvent.clientY - _this.mouseDownY);
          var axisDelta = Math.max(deltaX, deltaY);

          var timeDelta = new Date().getTime() - _this.mouseDownTime;

          if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
            _this.setCursorToEnd();
          }
        };

        document.addEventListener('mouseup', mouseUpHandler);
      }

      if (isFunction$2(_this.props.onMouseDown)) {
        _this.props.onMouseDown(event);
      }
    };

    _this.onPaste = function (event) {
      if (isFunction$2(_this.props.onPaste)) {
        _this.props.onPaste(event);
      } // event.clipboardData might not work in Android browser
      // cleaning input to get raw text inside onChange handler


      if (!event.defaultPrevented) {
        _this.beforePasteState = {
          value: _this.getInputValue(),
          selection: _this.getSelection()
        };

        _this.setInputValue('');
      }
    };

    _this.handleRef = function (ref) {
      if (_this.props.children == null && isFunction$2(_this.props.inputRef)) {
        _this.props.inputRef(ref);
      }
    };

    var _mask = props.mask,
        _maskChar = props.maskChar,
        _formatChars = props.formatChars,
        _alwaysShowMask = props.alwaysShowMask,
        _beforeMaskedValueChange = props.beforeMaskedValueChange;
    var defaultValue = props.defaultValue,
        _value = props.value;
    _this.maskOptions = parseMask$1(_mask, _maskChar, _formatChars);

    if (defaultValue == null) {
      defaultValue = '';
    }

    if (_value == null) {
      _value = defaultValue;
    }

    var _newValue = getStringValue$1(_value);

    if (_this.maskOptions.mask && (_alwaysShowMask || _newValue)) {
      _newValue = formatValue$1(_this.maskOptions, _newValue);

      if (isFunction$2(_beforeMaskedValueChange)) {
        var oldValue = props.value;

        if (props.value == null) {
          oldValue = defaultValue;
        }

        oldValue = getStringValue$1(oldValue);

        var modifiedValue = _beforeMaskedValueChange({
          value: _newValue,
          selection: null
        }, {
          value: oldValue,
          selection: null
        }, null, _this.getBeforeMaskedValueChangeConfig());

        _newValue = modifiedValue.value;
      }
    }

    _this.value = _newValue;
    return _this;
  }

  var _proto = InputElement.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true; // workaround for react-test-renderer
    // https://github.com/sanniassin/react-input-mask/issues/147

    if (!this.getInputDOMNode()) {
      return;
    }

    this.isWindowsPhoneBrowser = isWindowsPhoneBrowser$1();

    if (this.maskOptions.mask && this.getInputValue() !== this.value) {
      this.setInputValue(this.value);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var previousSelection = this.previousSelection;
    var _this$props = this.props,
        beforeMaskedValueChange = _this$props.beforeMaskedValueChange,
        alwaysShowMask = _this$props.alwaysShowMask,
        mask = _this$props.mask,
        maskChar = _this$props.maskChar,
        formatChars = _this$props.formatChars;
    var previousMaskOptions = this.maskOptions;
    var showEmpty = alwaysShowMask || this.isFocused();
    var hasValue = this.props.value != null;
    var newValue = hasValue ? getStringValue$1(this.props.value) : this.value;
    var cursorPosition = previousSelection ? previousSelection.start : null;
    this.maskOptions = parseMask$1(mask, maskChar, formatChars);

    if (!this.maskOptions.mask) {
      if (previousMaskOptions.mask) {
        this.stopSaveSelectionLoop(); // render depends on this.maskOptions and this.value,
        // call forceUpdate to keep it in sync

        this.forceUpdate();
      }

      return;
    } else if (!previousMaskOptions.mask && this.isFocused()) {
      this.runSaveSelectionLoop();
    }

    var isMaskChanged = this.maskOptions.mask && this.maskOptions.mask !== previousMaskOptions.mask;

    if (!previousMaskOptions.mask && !hasValue) {
      newValue = this.getInputValue();
    }

    if (isMaskChanged || this.maskOptions.mask && (newValue || showEmpty)) {
      newValue = formatValue$1(this.maskOptions, newValue);
    }

    if (isMaskChanged) {
      var filledLength = getFilledLength$1(this.maskOptions, newValue);

      if (cursorPosition === null || filledLength < cursorPosition) {
        if (isFilled$1(this.maskOptions, newValue)) {
          cursorPosition = filledLength;
        } else {
          cursorPosition = getRightEditablePosition$1(this.maskOptions, filledLength);
        }
      }
    }

    if (this.maskOptions.mask && isEmpty$1(this.maskOptions, newValue) && !showEmpty && (!hasValue || !this.props.value)) {
      newValue = '';
    }

    var newSelection = {
      start: cursorPosition,
      end: cursorPosition
    };

    if (isFunction$2(beforeMaskedValueChange)) {
      var modifiedValue = beforeMaskedValueChange({
        value: newValue,
        selection: newSelection
      }, {
        value: this.value,
        selection: this.previousSelection
      }, null, this.getBeforeMaskedValueChangeConfig());
      newValue = modifiedValue.value;
      newSelection = modifiedValue.selection;
    }

    this.value = newValue;
    var isValueChanged = this.getInputValue() !== this.value; // render depends on this.maskOptions and this.value,
    // call forceUpdate to keep it in sync

    if (isValueChanged) {
      this.setInputValue(this.value);
      this.forceUpdate();
    } else if (isMaskChanged) {
      this.forceUpdate();
    }

    var isSelectionChanged = false;

    if (newSelection.start != null && newSelection.end != null) {
      isSelectionChanged = !previousSelection || previousSelection.start !== newSelection.start || previousSelection.end !== newSelection.end;
    }

    if (isSelectionChanged || isValueChanged) {
      this.setSelection(newSelection.start, newSelection.end);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;

    if (this.selectionDeferId !== null) {
      cancelDefer$1(this.selectionDeferId);
    }

    this.stopSaveSelectionLoop();
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        mask = _this$props2.mask,
        alwaysShowMask = _this$props2.alwaysShowMask,
        maskChar = _this$props2.maskChar,
        formatChars = _this$props2.formatChars,
        inputRef = _this$props2.inputRef,
        beforeMaskedValueChange = _this$props2.beforeMaskedValueChange,
        children = _this$props2.children,
        restProps = _objectWithoutPropertiesLoose$2(_this$props2, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);

    var inputElement;
    process.env.NODE_ENV !== "production" ? warning$1( // parse mask to test against actual mask prop as this.maskOptions
    // will be updated later in componentDidUpdate
    !restProps.maxLength || !parseMask$1(mask, maskChar, formatChars).mask, 'react-input-mask: maxLength property shouldn\'t be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.') : void 0;

    if (children) {
      !isFunction$2(children) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'react-input-mask: children must be a function') : invariant$2(false) : void 0;
      var controlledProps = ['onChange', 'onPaste', 'onMouseDown', 'onFocus', 'onBlur', 'value', 'disabled', 'readOnly'];

      var childrenProps = _extends$2({}, restProps);

      controlledProps.forEach(function (propId) {
        return delete childrenProps[propId];
      });
      inputElement = children(childrenProps);
      var conflictProps = controlledProps.filter(function (propId) {
        return inputElement.props[propId] != null && inputElement.props[propId] !== restProps[propId];
      });
      !!conflictProps.length ? process.env.NODE_ENV !== "production" ? invariant$2(false, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + conflictProps.join(', ')) : invariant$2(false) : void 0;
      process.env.NODE_ENV !== "production" ? warning$1(!inputRef, 'react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead') : void 0;
    } else {
      inputElement = React$1.createElement("input", _extends$2({
        ref: this.handleRef
      }, restProps));
    }

    var changedProps = {
      onFocus: this.onFocus,
      onBlur: this.onBlur
    };

    if (this.maskOptions.mask) {
      if (!restProps.disabled && !restProps.readOnly) {
        changedProps.onChange = this.onChange;
        changedProps.onPaste = this.onPaste;
        changedProps.onMouseDown = this.onMouseDown;
      }

      if (restProps.value != null) {
        changedProps.value = this.value;
      }
    }

    inputElement = React$1.cloneElement(inputElement, changedProps);
    return inputElement;
  };

  return InputElement;
}(React$1.Component);

var reactInputMask_development = InputElement$1;

var reactInputMask = createCommonjsModule(function (module) {
if (process.env.NODE_ENV === 'production') {
  module.exports = reactInputMask_production_min;
} else {
  module.exports = reactInputMask_development;
}
});

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  ", "\n  width: 100%;\n  height: 48px;\n  font-size: 16px;\n  padding: 0px 15px;\n  ", "\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  line-height: 12px;\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  width: 100%;\n  display: none;\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var Error$1 = Ye.div(_templateObject$9(), COLORS_CONFIG.ORANGE);
var Input = Ye(reactInputMask)(_templateObject2$3(), COLORS_CONFIG.WHITE, COLORS_CONFIG.SMOOTH_BROWN, function (_ref) {
  var showPlaceholder = _ref.showPlaceholder;
  return showPlaceholder && _e(["color:", ";"], COLORS_CONFIG.SMOOTH_BROWN$70);
}, function (_ref2) {
  var hasError = _ref2.hasError;
  return _e(["border:1px solid ", ";"], hasError ? 'red' : COLORS_CONFIG.SKY_BLUE);
});
var Wrapper$4 = Ye.div(_templateObject3$1(), function (_ref3) {
  var onClick = _ref3.onClick;
  return onClick && _e(["", "{cursor:pointer;}"], Input);
}, function (_ref4) {
  var hasIcon = _ref4.hasIcon;
  return hasIcon && _e(["", "{padding-right:40px;}", "{", " position:absolute;right:20px;top:50%;transform:translateY(-50%);}"], Input, Wrapper$3, function (_ref5) {
    var isIconClickable = _ref5.isIconClickable;
    return isIconClickable && _e(["cursor:pointer;"]);
  });
}, function (_ref6) {
  var hasError = _ref6.hasError;
  return hasError && _e(["", "{border-color:", ";color:", ";}", "{display:block;}"], Input, COLORS_CONFIG.ORANGE, COLORS_CONFIG.ORANGE, Error$1);
}, function (_ref7) {
  var hasError = _ref7.hasError;
  return hasError === false && _e(["", "{border-color:", ";}"], Input, COLORS_CONFIG.LIGHT_GREEN);
});

function MaskInput(_ref) {
  var icon = _ref.icon,
      name = _ref.name,
      value = _ref.value,
      mask = _ref.mask,
      error = _ref.error,
      onClick = _ref.onClick,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      onIconClick = _ref.onIconClick;
  return /*#__PURE__*/React__default['default'].createElement(Wrapper$4, {
    hasError: error,
    hasIcon: !!icon,
    onClick: onClick,
    isIconClickable: !!onIconClick
  }, /*#__PURE__*/React__default['default'].createElement(Input, {
    value: value || '',
    name: name,
    disabled: !onChange,
    onChange: onChange,
    mask: mask,
    placeholder: placeholder
  }), icon && /*#__PURE__*/React__default['default'].createElement(Img, {
    size: [18, 18],
    src: icon,
    onClick: onIconClick
  }), /*#__PURE__*/React__default['default'].createElement(Error$1, null, error && error));
}

MaskInput.propTypes = {
  mask: PropTypes__default['default'].string.isRequired,
  value: PropTypes__default['default'].string,
  error: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].string]),
  placeholder: PropTypes__default['default'].string,
  onIconClick: PropTypes__default['default'].func,
  onChange: PropTypes__default['default'].func,
  onClick: PropTypes__default['default'].func,
  icon: PropTypes__default['default'].string,
  name: PropTypes__default['default'].string
};
MaskInput.defaultProps = {
  value: '',
  error: null,
  placeholder: '',
  onIconClick: null,
  onChange: null,
  onClick: null,
  icon: null,
  name: ''
};

var DATE_SETTINGS = {
  FORMAT: {
    DAY: 'DD',
    DAY_MONTH: 'DD.MM',
    TIMER_FORMAT: 'HH:mm:ss',
    TIMER_FORMAT_EXPIRED: 'HH:mm:ss.SSS',
    MONTH_DAY_SHORT: 'MM.DD',
    MONTH_DAY: 'MMMM DD',
    HOURS_MINUTES: 'HH:mm',
    MONTH_YEAR: 'MMMM YYYY',
    YEAR_MONTH_DAY: 'YYYY-MM-DD',
    MONTH_DAY_YEAR: 'MM/DD/YYYY',
    DAY_MONTH_DATE: 'dddd, MMMM D',
    HOURS_MINUTES_MERIDIEM: 'hh:mm A',
    HOURS_MINUTES_SECONDS: 'HH:mm:ss',
    MONTH_DAY_YEAR_HYPHEN: 'MM-DD-YYYY',
    YEAR_MONTH_DAY_HOURS_MINUTES: 'YYYY-MM-DD HH:mm',
    DAY_MONTH_DATE_AT_TIME: 'dddd, MMM DD [at] hh:mm a',
    YEAR_MONTH_DAY_HOURS_MINUTES_SECONDS: 'YYYY-MM-DD HH:mm:ss',
    TIMEZONE_OFFSET: '[(GTM]Z[)]',
    MONTH_SHORT_DAY_SHORT: 'MMM D',
    MINUTES_SECONDS: 'mm:ss'
  }
};

var CALENDAR = "data:image/svg+xml,%3Csvg%20width%3D%2217%22%20height%3D%2218%22%20viewBox%3D%220%200%2017%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M15.7744%202.85228C15.5289%202.60651%2015.2376%202.4836%2014.9013%202.4836H13.6597V1.55224C13.6597%201.12546%2013.5076%200.760012%2013.2036%200.456034C12.8995%200.152057%2012.5343%200%2012.1073%200H11.4866C11.0596%200%2010.6942%200.152057%2010.3902%200.456068C10.0862%200.760012%209.93418%201.12549%209.93418%201.55227V2.48364H6.20905V1.55227C6.20905%201.12549%206.05699%200.760046%205.75298%200.456068C5.44903%200.152057%205.08362%200%204.65667%200H4.03584C3.60899%200%203.24355%200.152057%202.93954%200.456068C2.63559%200.760012%202.4835%201.12549%202.4835%201.55227V2.48364H1.24184C0.905443%202.48364%200.614445%202.60654%200.368674%202.85231C0.122903%203.09805%200%203.38918%200%203.72548V16.1433C0%2016.4793%200.122903%2016.7704%200.368674%2017.0163C0.614411%2017.262%200.905409%2017.3849%201.24184%2017.3849H14.9011C15.2374%2017.3849%2015.5287%2017.262%2015.7741%2017.0163C16.02%2016.7705%2016.1429%2016.4793%2016.1429%2016.1433V3.72544C16.1429%203.38905%2016.0201%203.09805%2015.7744%202.85228ZM11.1761%201.55237C11.1761%201.46175%2011.205%201.3873%2011.2631%201.32923C11.3212%201.27109%2011.3957%201.24197%2011.4863%201.24197H12.1071C12.1978%201.24197%2012.272%201.27099%2012.3303%201.32923C12.3885%201.3874%2012.4175%201.46185%2012.4175%201.55237V4.34627C12.4175%204.43686%2012.3885%204.51118%2012.3303%204.56942C12.2719%204.62749%2012.1978%204.65667%2012.1071%204.65667H11.4863C11.3957%204.65667%2011.3212%204.62762%2011.2631%204.56942C11.205%204.51114%2011.1761%204.43686%2011.1761%204.34627V1.55237ZM3.72544%201.55237C3.72544%201.46175%203.75449%201.3873%203.8127%201.32923C3.87094%201.27109%203.94525%201.24197%204.03584%201.24197H4.65667C4.7473%201.24197%204.82174%201.27099%204.87982%201.32923C4.93795%201.3874%204.96714%201.46185%204.96714%201.55237V4.34627C4.96714%204.43686%204.93809%204.51128%204.87982%204.56942C4.82161%204.62749%204.7473%204.65667%204.65667%204.65667H4.03584C3.94525%204.65667%203.87084%204.62762%203.8127%204.56942C3.75463%204.51114%203.72544%204.43686%203.72544%204.34627V1.55237ZM14.9011%2016.1431H1.24184V6.20894H14.9011V16.1431Z%22%20fill%3D%22%23373636%22%2F%3E%3C%2Fsvg%3E";

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n\n  & .react-calendar {\n    min-width: 300px;\n    padding: 0px 10px 10px 10px;\n    width: 80%;\n    margin: auto;\n    &__navigation {\n      & button:disabled {\n        background-color: ", ";\n      }\n      &__arrow {\n        display: flex !important;\n        align-items: center !important;\n        justify-items: center !important;\n        &:hover,\n        &:focus {\n          background-color: initial !important;\n        }\n      }\n      &__label {\n        order: -1;\n        text-align: left;\n        cursor: initial;\n        padding-left: 5px;\n        width: 225px;\n        color: ", ";\n        font-family: GothamBold;\n        font-size: 18px;\n        line-height: 18px;\n        background-color: initial !important;\n        &:hover {\n          background-color: initial !important;\n        }\n      }\n    }\n    &__tile {\n      position: relative;\n      cursor: initial;\n      font-size: 10px;\n      & ", ":hover {\n        background-color: ", ";\n      }\n      &:enabled:focus,\n      &:enabled:hover {\n        cursor: initial;\n        background: none;\n      }\n      & > abbr {\n        display: none;\n      }\n      min-width: 42px;\n      height: 37px;\n      padding: 0px;\n      text-align: center;\n      display: flex;\n      justify-content: center;\n\n      &--active {\n        background: none;\n        & ", " {\n          background-color: ", "!important;\n          color: ", ";\n          font-family: GothamBold;\n        }\n      }\n      &:disabled {\n        background-color: ", ";\n        & ", " {\n          &:hover {\n            background-color: ", ";\n          }\n          cursor: not-allowed;\n          color: ", ";\n        }\n      }\n      ", "\n    }\n    &__month-view {\n      &__weekdays__weekday {\n        padding: 0;\n        font-size: 14px;\n        color: ", ";\n        font-family: GothamBold;\n        & > abbr {\n          text-decoration: none;\n        }\n      }\n      &__days__day--neighboringMonth {\n        & ", " {\n          color: ", ";\n          font-family: GothamBold;\n        }\n      }\n    }\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  position: absolute;\n  z-index: 5;\n  background-color: ", ";\n  top: calc(100% + 4px);\n  box-sizing: border-box;\n  min-width: 345px;\n  moz-box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);\n  -webkit-box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);\n\n  ", "\n  ", "\n\n    width: 100%;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var Calendar$2 = Ye.div(_templateObject$a(), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? 'block' : 'none';
}, COLORS_CONFIG.WHITE, function (_ref2) {
  var position = _ref2.position;
  return position === 'right' && _e(["right:0;"]);
}, function (_ref3) {
  var position = _ref3.position;
  return position === 'center' && _e(["left:50%;transform:translateX(-45%);"]);
});
var Wrapper$5 = Ye.div(_templateObject2$4(), COLORS_CONFIG.TRANSPARENT, COLORS_CONFIG.SMOOTH_BROWN, Content, COLORS_CONFIG.SILVER, Content, COLORS_CONFIG.SKY_BLUE, COLORS_CONFIG.WHITE, COLORS_CONFIG.TRANSPARENT, Content, COLORS_CONFIG.TRANSPARENT, COLORS_CONFIG.SILVER, function (_ref4) {
  var currentView = _ref4.currentView;
  return currentView === 'year' && _e(["", "{position:absolute;width:100%;height:100%;& *{width:100%;height:100%;}top:50%;left:50%;transform:translate(-50%,-50%);}& ", "{border-radius:initial;}"], Wrapper, Content);
}, COLORS_CONFIG.SMOOTH_BROWN, Content, COLORS_CONFIG.SILVER_CUSTOM_1);

var VIEWS = {
  MONTH: 'month',
  YEAR: 'year'
};

function DatePicker(_ref) {
  var name = _ref.name,
      value = _ref.value,
      error = _ref.error,
      onChange = _ref.onChange,
      position = _ref.position,
      checkDates = _ref.checkDates,
      placeholder = _ref.placeholder,
      closeOnClick = _ref.closeOnClick,
      availableDates = _ref.availableDates,
      editable = _ref.editable,
      pickable = _ref.pickable,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate;

  var _useToggleBooleanHook = useToggleBoolean(false),
      _useToggleBooleanHook2 = _slicedToArray(_useToggleBooleanHook, 2),
      isOpened = _useToggleBooleanHook2[0],
      toggle = _useToggleBooleanHook2[1];

  var _useState = React$2.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = React$2.useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      inputError = _useState4[0],
      setInputError = _useState4[1];

  var _useState5 = React$2.useState(VIEWS.MONTH),
      _useState6 = _slicedToArray(_useState5, 2),
      currentView = _useState6[0],
      setView = _useState6[1];

  React$2.useEffect(function () {
    var momentObj = hooks(value, [DATE_SETTINGS.FORMAT.YEAR_MONTH_DAY, DATE_SETTINGS.FORMAT.MONTH_DAY_YEAR, DATE_SETTINGS.FORMAT.MONTH_DAY_YEAR_HYPHEN], null, true);
    var isDateValid = momentObj.isValid();
    setInputValue(isDateValid ? momentObj.format(DATE_SETTINGS.FORMAT.MONTH_DAY_YEAR) : value);
    setInputError(error);
  }, [value, error]);

  function handleInputChange(_ref2) {
    var newValue = _ref2.target.value;
    var momentObject = hooks(newValue, DATE_SETTINGS.FORMAT.MONTH_DAY_YEAR, true);
    onChange({
      target: {
        name: name,
        value: momentObject.isValid() ? momentObject.format(DATE_SETTINGS.FORMAT.YEAR_MONTH_DAY) : newValue
      }
    });
  }

  var calendarRef = React$2.useRef(null);
  useOutsideClickHook(function () {
    return toggle(false);
  }, calendarRef);
  var preparedValue = hooks(value, [DATE_SETTINGS.FORMAT.YEAR_MONTH_DAY, DATE_SETTINGS.FORMAT.MONTH_DAY_YEAR], true);

  var dateIsAvailable = function dateIsAvailable(date) {
    if (!checkDates) return true;
    return availableDates.some(function (availableDate) {
      return hooks(availableDate).isSame(date, 'day');
    });
  };

  return /*#__PURE__*/React__default['default'].createElement(Wrapper$5, {
    ref: calendarRef,
    currentView: currentView
  }, /*#__PURE__*/React__default['default'].createElement(MaskInput, {
    value: inputValue,
    name: name,
    error: inputError || error,
    onChange: editable ? handleInputChange : undefined,
    mask: "99/99/9999",
    placeholder: placeholder,
    icon: CALENDAR,
    onClick: pickable && !editable ? toggle : undefined,
    onIconClick: pickable ? toggle : undefined
  }), /*#__PURE__*/React__default['default'].createElement(Calendar$2, {
    isOpen: isOpened,
    position: position
  }, /*#__PURE__*/React__default['default'].createElement(ReactCalendar, {
    locale: "en",
    onClickDay: function onClickDay(date) {
      onChange({
        target: {
          name: name,
          value: hooks(date).format(DATE_SETTINGS.FORMAT.YEAR_MONTH_DAY)
        }
      });
      closeOnClick && toggle();
    },
    value: preparedValue.isValid() && new Date(value) || undefined,
    nextLabel: /*#__PURE__*/React__default['default'].createElement(CircleForward, null),
    prevLabel: /*#__PURE__*/React__default['default'].createElement(CircleBack, null),
    showFixedNumberOfWeeks: true,
    calendarType: "US",
    onDrillDown: function onDrillDown(_ref3) {
      var view = _ref3.view;
      return setView(view);
    },
    onDrillUp: function onDrillUp(_ref4) {
      var view = _ref4.view;
      return setView(view);
    },
    minDetail: "year",
    maxDetail: "month",
    next2Label: null,
    prev2Label: null,
    navigationLabel: function navigationLabel(_ref5) {
      var date = _ref5.date;
      return hooks(date).format(DATE_SETTINGS.FORMAT.MONTH_YEAR);
    },
    tileDisabled: function tileDisabled(_ref6) {
      var date = _ref6.date;
      return checkDates && currentView === VIEWS.MONTH ? !dateIsAvailable(date) : false;
    },
    tileContent: function tileContent(_ref7) {
      var date = _ref7.date;
      return /*#__PURE__*/React__default['default'].createElement(Cell$1, {
        day: hooks(date).format(currentView === VIEWS.YEAR ? 'MMM' : 'D'),
        hasEvent: checkDates ? dateIsAvailable(date) : false
      });
    },
    name: name,
    minDate: minDate,
    maxDate: maxDate
  })));
}

DatePicker.propTypes = {
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].instanceOf(Date)]),
  onChange: PropTypes__default['default'].func.isRequired,
  editable: function editable(props, propName, componentName) {
    if (!props.pickable && !props[propName]) {
      return new Error("Prop ".concat(propName, " should be enabled if pickable prop is disabled in component ").concat(componentName, "."));
    }
  },
  pickable: function pickable(props, propName, componentName) {
    if (!props.editable && !props[propName]) {
      return new Error("Prop ".concat(propName, " should be enabled if editable prop is disabled in component ").concat(componentName, "."));
    }
  },
  name: PropTypes__default['default'].string.isRequired,
  checkDates: PropTypes__default['default'].bool,
  availableDates: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  placeholder: PropTypes__default['default'].string,
  // TODO: style placeholder with errors
  closeOnClick: PropTypes__default['default'].bool,
  error: PropTypes__default['default'].any,
  // TODO
  position: PropTypes__default['default'].oneOf(['left', 'center', 'right'])
};
DatePicker.defaultProps = {
  value: null,
  events: [],
  checkDates: false,
  availableDates: [],
  position: 'left',
  error: null,
  placeholder: '',
  editable: true,
  pickable: true,
  closeOnClick: true,
  withIcon: false
};

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var globalCssModule;
function mapToCssModules(className, cssModule) {
  if (className === void 0) {
    className = '';
  }

  if (cssModule === void 0) {
    cssModule = globalCssModule;
  }

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */

function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */

function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }

  return result;
}

var Element$3 = typeof window === 'object' && window.Element || function () {};

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element$3)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}
var targetPropType = PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].func, DOMElement, PropTypes__default['default'].shape({
  current: PropTypes__default['default'].any
})]);
var tagPropType = PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].string, PropTypes__default['default'].shape({
  $$typeof: PropTypes__default['default'].symbol,
  render: PropTypes__default['default'].func
}), PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].string, PropTypes__default['default'].shape({
  $$typeof: PropTypes__default['default'].symbol,
  render: PropTypes__default['default'].func
})]))]);
/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss

var TransitionTimeouts = {
  Fade: 150,
  // $transition-fade
  Collapse: 350,
  // $transition-collapse
  Modal: 300,
  // $modal-transition
  Carousel: 600 // $carousel-transition

}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.

var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
var keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};
var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function isReactRefObj(target) {
  if (target && typeof target === 'object') {
    return 'current' in target;
  }

  return false;
}

function getTag(value) {
  if (value == null) {
    return value === undefined ? '[object Undefined]' : '[object Null]';
  }

  return Object.prototype.toString.call(value);
}
function isObject$2(value) {
  var type = typeof value;
  return value != null && (type === 'object' || type === 'function');
}
function isFunction$3(value) {
  if (!isObject$2(value)) {
    return false;
  }

  var tag = getTag(value);
  return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
}
function findDOMElements(target) {
  if (isReactRefObj(target)) {
    return target.current;
  }

  if (isFunction$3(target)) {
    return target();
  }

  if (typeof target === 'string' && canUseDOM) {
    var selection = document.querySelectorAll(target);

    if (!selection.length) {
      selection = document.querySelectorAll("#" + target);
    }

    if (!selection.length) {
      throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
    }

    return selection;
  }

  return target;
}
function isArrayOrNodeList(els) {
  if (els === null) {
    return false;
  }

  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
}
function getTarget(target, allElements) {
  var els = findDOMElements(target);

  if (allElements) {
    if (isArrayOrNodeList(els)) {
      return els;
    }

    if (els === null) {
      return [];
    }

    return [els];
  } else {
    if (isArrayOrNodeList(els)) {
      return els[0];
    }

    return els;
  }
}

var rowColWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var rowColsPropType = PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]);
var propTypes$1 = {
  tag: tagPropType,
  noGutters: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].string,
  cssModule: PropTypes__default['default'].object,
  form: PropTypes__default['default'].bool,
  xs: rowColsPropType,
  sm: rowColsPropType,
  md: rowColsPropType,
  lg: rowColsPropType,
  xl: rowColsPropType
};
var defaultProps = {
  tag: 'div',
  widths: rowColWidths
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      form = props.form,
      widths = props.widths,
      attributes = _objectWithoutPropertiesLoose$3(props, ["className", "cssModule", "noGutters", "tag", "form", "widths"]);

  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var colSize = props[colWidth];
    delete attributes[colWidth];

    if (!colSize) {
      return;
    }

    var isXs = !i;
    colClasses.push(isXs ? "row-cols-" + colSize : "row-cols-" + colWidth + "-" + colSize);
  });
  var classes = mapToCssModules(classnames(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row', colClasses), cssModule);
  return /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({}, attributes, {
    className: classes
  }));
};

Row.propTypes = propTypes$1;
Row.defaultProps = defaultProps;

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]);
var columnProps = PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].number, PropTypes__default['default'].string, PropTypes__default['default'].shape({
  size: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].number, PropTypes__default['default'].string]),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);
var propTypes$2 = {
  tag: tagPropType,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: PropTypes__default['default'].string,
  cssModule: PropTypes__default['default'].object,
  widths: PropTypes__default['default'].array
};
var defaultProps$1 = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : "col-" + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
  }

  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose$3(props, ["className", "cssModule", "widths", "tag"]);

  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];
    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;

    if (isObject$2(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
      colClasses.push(mapToCssModules(classnames((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);

      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push('col');
  }

  var classes = mapToCssModules(classnames(className, colClasses), cssModule);
  return /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({}, attributes, {
    className: classes
  }));
};

Col.propTypes = propTypes$2;
Col.defaultProps = defaultProps$1;

function _assertThisInitialized$3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var propTypes$3 = {
  active: PropTypes__default['default'].bool,
  'aria-label': PropTypes__default['default'].string,
  block: PropTypes__default['default'].bool,
  color: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  outline: PropTypes__default['default'].bool,
  tag: tagPropType,
  innerRef: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].func, PropTypes__default['default'].string]),
  onClick: PropTypes__default['default'].func,
  size: PropTypes__default['default'].string,
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  cssModule: PropTypes__default['default'].object,
  close: PropTypes__default['default'].bool
};
var defaultProps$2 = {
  color: 'secondary',
  tag: 'button'
};

var Button$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(Button, _React$Component);

  function Button(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  var _proto = Button.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      return this.props.onClick(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        ariaLabel = _this$props['aria-label'],
        block = _this$props.block,
        className = _this$props.className,
        close = _this$props.close,
        cssModule = _this$props.cssModule,
        color = _this$props.color,
        outline = _this$props.outline,
        size = _this$props.size,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = _objectWithoutPropertiesLoose$3(_this$props, ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"]);

    if (close && typeof attributes.children === 'undefined') {
      attributes.children = /*#__PURE__*/React__default['default'].createElement("span", {
        "aria-hidden": true
      }, "\xD7");
    }

    var btnOutlineColor = "btn" + (outline ? '-outline' : '') + "-" + color;
    var classes = mapToCssModules(classnames(className, {
      close: close
    }, close || 'btn', close || btnOutlineColor, size ? "btn-" + size : false, block ? 'btn-block' : false, {
      active: active,
      disabled: this.props.disabled
    }), cssModule);

    if (attributes.href && Tag === 'button') {
      Tag = 'a';
    }

    var defaultAriaLabel = close ? 'Close' : null;
    return /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({
      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
    }, attributes, {
      className: classes,
      ref: innerRef,
      onClick: this.onClick,
      "aria-label": ariaLabel || defaultAriaLabel
    }));
  };

  return Button;
}(React__default['default'].Component);

Button$1.propTypes = propTypes$3;
Button$1.defaultProps = defaultProps$2;

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose$4;

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _assertThisInitialized$4(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized$4;

function _inheritsLoose$3(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var inheritsLoose = _inheritsLoose$3;

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty$1 = _defineProperty$1;

var toStr = Object.prototype.toString;

var isArguments = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr$1 = Object.prototype.toString;
	var isArgs = isArguments; // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr$1.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr$1.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
var implementation = keysShim;

var slice = Array.prototype.slice;


var origKeys = Object.keys;
var keysShim$1 = origKeys ? function keys(o) { return origKeys(o); } : implementation;

var originalKeys = Object.keys;

keysShim$1.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArguments(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim$1;
	}
	return Object.keys || keysShim$1;
};

var objectKeys = keysShim$1;

var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var toStr$2 = Object.prototype.toString;

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return toStr$2.call(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		toStr$2.call(value) !== '[object Array]' &&
		toStr$2.call(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$3 = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction$4 = function (fn) {
	return typeof fn === 'function' && toStr$3.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty$2 = function (object, name, value, predicate) {
	if (name in object && (!isFunction$4(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = objectKeys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty$2(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

var defineProperties_1 = defineProperties;

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice$1 = Array.prototype.slice;
var toStr$4 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$4.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice$1.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice$1.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice$1.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var functionBind = Function.prototype.bind || implementation$1;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = commonjsGlobal.Symbol;


var hasSymbols$1 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return shams();
};

var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

/* globals
	AggregateError,
	Atomics,
	FinalizationRegistry,
	SharedArrayBuffer,
	WeakRef,
*/

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		// eslint-disable-next-line no-new-func
		return Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$2 = hasSymbols$1();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var asyncGenFunction = getEvalledConstructor('async function* () {}');
var asyncGenFunctionPrototype = asyncGenFunction ? asyncGenFunction.prototype : undefined$1;
var asyncGenPrototype = asyncGenFunctionPrototype ? asyncGenFunctionPrototype.prototype : undefined$1;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$2 ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': getEvalledConstructor('async function () {}'),
	'%AsyncGenerator%': asyncGenFunctionPrototype,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncIteratorPrototype%': asyncGenPrototype ? getProto(asyncGenPrototype) : undefined$1,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': getEvalledConstructor('function* () {}'),
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$2 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$2 ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols$2 ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
var $replace = functionBind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var GetIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				if (!allowMissing && !(part in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind = createCommonjsModule(function (module) {





var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind() {
	return $reflectApply(functionBind, $call, arguments);
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});
var callBind_1 = callBind.apply;

var numberIsNaN = function (value) {
	return value !== value;
};

var implementation$2 = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};

var polyfill$1 = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation$2;
};

var shim = function shimObjectIs() {
	var polyfill = polyfill$1();
	defineProperties_1(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};

var polyfill$2 = callBind(polyfill$1(), Object);

defineProperties_1(polyfill$2, {
	getPolyfill: polyfill$1,
	implementation: implementation$2,
	shim: shim
});

var objectIs = polyfill$2;

var hasSymbols$3 = hasSymbols$1();
var hasToStringTag$1 = hasSymbols$3 && typeof Symbol.toStringTag === 'symbol';
var hasOwnProperty;
var regexExec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$1) {
	hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
	regexExec = Function.call.bind(RegExp.prototype.exec);
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var toStr$5 = Object.prototype.toString;
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

var isRegex = hasToStringTag$1
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && hasOwnProperty(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			regexExec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return toStr$5.call(value) === regexClass;
	};

/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined$2;

var $TypeError$1 = TypeError;

var $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1) {
	try {
		$gOPD$1({}, '');
	} catch (e) {
		$gOPD$1 = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError$1 = function () { throw new $TypeError$1(); };
var ThrowTypeError$1 = $gOPD$1
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError$1;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD$1(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError$1;
			}
		}
	}())
	: throwTypeError$1;

var hasSymbols$4 = hasSymbols$1();

var getProto$1 = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
var generatorFunction =  undefined$2;
var asyncFunction =  undefined$2;
var asyncGenFunction$1 =  undefined$2;

var TypedArray$1 = typeof Uint8Array === 'undefined' ? undefined$2 : getProto$1(Uint8Array);

var INTRINSICS$1 = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$2 : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined$2 : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols$4 ? getProto$1([][Symbol.iterator]()) : undefined$2,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined$2,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%':  undefined$2,
	'%AsyncGenerator%':  undefined$2,
	'%AsyncGeneratorFunction%': asyncGenFunction$1,
	'%AsyncGeneratorPrototype%':  undefined$2,
	'%AsyncIteratorPrototype%':  undefined$2,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$2 : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined$2 : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined$2 : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$2 : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined$2 : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$2 : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined$2 : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%':  undefined$2,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%':  undefined$2,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$2 : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined$2 : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$2 : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined$2 : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$2 : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined$2 : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$4 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$2,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$2,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined$2,
	'%Map%': typeof Map === 'undefined' ? undefined$2 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$4 ? undefined$2 : getProto$1(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined$2 : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$2 : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined$2 : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined$2 : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined$2 : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined$2 : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined$2 : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$2 : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$2 : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined$2 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$4 ? undefined$2 : getProto$1(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined$2 : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$2 : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined$2 : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$4 ? getProto$1(''[Symbol.iterator]()) : undefined$2,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols$4 ? Symbol : undefined$2,
	'%SymbolPrototype%': hasSymbols$4 ? Symbol.prototype : undefined$2,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError$1,
	'%TypedArray%': TypedArray$1,
	'%TypedArrayPrototype%': TypedArray$1 ? TypedArray$1.prototype : undefined$2,
	'%TypeError%': $TypeError$1,
	'%TypeErrorPrototype%': $TypeError$1.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$2 : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined$2 : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$2 : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined$2 : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$2 : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined$2 : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$2 : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined$2 : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$2 : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined$2 : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$2 : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined$2 : WeakSet.prototype
};


var $replace$1 = functionBind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$1 = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath$1 = function stringToPath(string) {
	var result = [];
	$replace$1(string, rePropName$1, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$1(subString, reEscapeChar$1, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic$1 = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS$1)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS$1[name] === 'undefined' && !allowMissing) {
		throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS$1[name];
};

var GetIntrinsic$1 = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath$1(name);

	var value = getBaseIntrinsic$1('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD$1 && (i + 1) >= parts.length) {
				var desc = $gOPD$1(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				value = desc && 'get' in desc && !('originalValue' in desc.get) ? desc.get : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};

var callBind$1 = createCommonjsModule(function (module) {





var $apply = GetIntrinsic$1('%Function.prototype.apply%');
var $call = GetIntrinsic$1('%Function.prototype.call%');
var $reflectApply = GetIntrinsic$1('%Reflect.apply%', true) || functionBind.call($call, $apply);

var $defineProperty = GetIntrinsic$1('%Object.defineProperty%', true);

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind() {
	return $reflectApply(functionBind, $call, arguments);
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});
var callBind_1$1 = callBind$1.apply;

var $Object = Object;
var $TypeError$2 = TypeError;

var implementation$3 = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError$2('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD$2 = Object.getOwnPropertyDescriptor;
var $TypeError$3 = TypeError;

var polyfill$3 = function getPolyfill() {
	if (!supportsDescriptors$1) {
		throw new $TypeError$3('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if ((/a/mig).flags === 'gim') {
		var descriptor = $gOPD$2(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation$3;
};

var supportsDescriptors$2 = defineProperties_1.supportsDescriptors;

var gOPD$1 = Object.getOwnPropertyDescriptor;
var defineProperty$3 = Object.defineProperty;
var TypeErr = TypeError;
var getProto$2 = Object.getPrototypeOf;
var regex = /a/;

var shim$1 = function shimFlags() {
	if (!supportsDescriptors$2 || !getProto$2) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = polyfill$3();
	var proto = getProto$2(regex);
	var descriptor = gOPD$1(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty$3(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};

var flagsBound = callBind$1(implementation$3);

defineProperties_1(flagsBound, {
	getPolyfill: polyfill$3,
	implementation: implementation$3,
	shim: shim$1
});

var regexp_prototype_flags = flagsBound;

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr$6 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$2 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag$2 ? tryDateObject(value) : toStr$6.call(value) === dateClass;
};

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? objectIs(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? objectIs(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments$1(a) !== isArguments$1(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && regexp_prototype_flags(a) === regexp_prototype_flags(b);
  }

  if (isDateObject(a) && isDateObject(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

var deepEqual_1 = deepEqual;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction$5(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty$4 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends$4({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$4({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction$5(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$4({}, attributes, data.attributes);
  data.styles = _extends$4({}, styles, data.styles);
  data.arrowStyles = _extends$4({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty$4(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty$4(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$4({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset$1(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty$4({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty$4({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$4({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty$4({}, side, reference[side]),
      end: defineProperty$4({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends$4({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset$1,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$4({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$4({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$4({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$4({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction$5(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

var key = '__global_unique_id__';

var gud = function() {
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__$2 = process.env.NODE_ENV !== 'production';

var warning$2 = function() {};

if (__DEV__$2) {
  var printWarning$1 = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$2 = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning$1.apply(null, [format].concat(args));
    }
  };
}

var warning_1$1 = warning$2;

var implementation$4 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _gud2 = _interopRequireDefault(gud);



var _warning2 = _interopRequireDefault(warning_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (process.env.NODE_ENV !== 'production') {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(React__default['default'].Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(React__default['default'].Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];
});

unwrapExports(implementation$4);

var lib = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _react2 = _interopRequireDefault(React__default['default']);



var _implementation2 = _interopRequireDefault(implementation$4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];
});

var createContext = unwrapExports(lib);

var ManagerReferenceNodeContext = createContext();
var ManagerReferenceNodeSetterContext = createContext();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  inheritsLoose(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    defineProperty$1(assertThisInitialized(_this), "referenceNode", void 0);

    defineProperty$1(assertThisInitialized(_this), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return React$2.createElement(ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, React$2.createElement(ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(React$2.Component);

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  inheritsLoose(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    defineProperty$1(assertThisInitialized(_this), "state", {
      data: undefined,
      placement: undefined
    });

    defineProperty$1(assertThisInitialized(_this), "popperInstance", void 0);

    defineProperty$1(assertThisInitialized(_this), "popperNode", null);

    defineProperty$1(assertThisInitialized(_this), "arrowNode", null);

    defineProperty$1(assertThisInitialized(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      setRef(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    defineProperty$1(assertThisInitialized(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    defineProperty$1(assertThisInitialized(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    defineProperty$1(assertThisInitialized(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: _extends_1({}, _this.props.modifiers, {
          arrow: _extends_1({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    defineProperty$1(assertThisInitialized(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : _extends_1({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    defineProperty$1(assertThisInitialized(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    defineProperty$1(assertThisInitialized(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    defineProperty$1(assertThisInitialized(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    defineProperty$1(assertThisInitialized(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    defineProperty$1(assertThisInitialized(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = assertThisInitialized(_this),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new Popper(referenceElement, popperNode, _this.getOptions());
    });

    defineProperty$1(assertThisInitialized(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !deepEqual_1(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (process.env.NODE_ENV === "development") {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(React$2.Component);

defineProperty$1(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});
function Popper$1(_ref) {
  var referenceElement = _ref.referenceElement,
      props = objectWithoutPropertiesLoose(_ref, ["referenceElement"]);

  return React$2.createElement(ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
    return React$2.createElement(InnerPopper, _extends_1({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__$3 = process.env.NODE_ENV !== 'production';

var warning$3 = function() {};

if (__DEV__$3) {
  var printWarning$2 = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$3 = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning$2.apply(null, [format].concat(args));
    }
  };
}

var warning_1$2 = warning$3;

var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  inheritsLoose(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    defineProperty$1(assertThisInitialized(_this), "refHandler", function (node) {
      setRef(_this.props.innerRef, node);
      safeInvoke(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
  };

  _proto.render = function render() {
    warning_1$2(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return unwrapArray(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(React$2.Component);

function Reference(props) {
  return React$2.createElement(ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
    return React$2.createElement(InnerReference, _extends_1({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/**
 * DropdownContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  isOpen: PropTypes.bool.isRequired,
 *  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
 *  inNavbar: PropTypes.bool.isRequired,
 *  disabled: PropTypes.bool
 * }
 */

var DropdownContext = /*#__PURE__*/React__default['default'].createContext({});

var propTypes$4 = {
  a11y: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  direction: PropTypes__default['default'].oneOf(['up', 'down', 'left', 'right']),
  group: PropTypes__default['default'].bool,
  isOpen: PropTypes__default['default'].bool,
  nav: PropTypes__default['default'].bool,
  active: PropTypes__default['default'].bool,
  addonType: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].oneOf(['prepend', 'append'])]),
  size: PropTypes__default['default'].string,
  tag: tagPropType,
  toggle: PropTypes__default['default'].func,
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  cssModule: PropTypes__default['default'].object,
  inNavbar: PropTypes__default['default'].bool,
  setActiveFromChild: PropTypes__default['default'].bool
};
var defaultProps$3 = {
  a11y: true,
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  addonType: false,
  inNavbar: false,
  setActiveFromChild: false
};
var preventDefaultKeys = [keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down, keyCodes.end, keyCodes.home];

var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(Dropdown, _React$Component);

  function Dropdown(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.addEvents = _this.addEvents.bind(_assertThisInitialized$3(_this));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_assertThisInitialized$3(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized$3(_this));
    _this.removeEvents = _this.removeEvents.bind(_assertThisInitialized$3(_this));
    _this.toggle = _this.toggle.bind(_assertThisInitialized$3(_this));
    _this.containerRef = /*#__PURE__*/React__default['default'].createRef();
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.getContextValue = function getContextValue() {
    return {
      toggle: this.toggle,
      isOpen: this.props.isOpen,
      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
      inNavbar: this.props.inNavbar,
      disabled: this.props.disabled
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.handleProps();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.handleProps();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeEvents();
  };

  _proto.getContainer = function getContainer() {
    return this.containerRef.current;
  };

  _proto.getMenuCtrl = function getMenuCtrl() {
    if (this._$menuCtrl) return this._$menuCtrl;
    this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
    return this._$menuCtrl;
  };

  _proto.getMenuItems = function getMenuItems() {
    return [].slice.call(this.getContainer().querySelectorAll('[role="menuitem"]'));
  };

  _proto.addEvents = function addEvents() {
    var _this2 = this;

    ['click', 'touchstart', 'keyup'].forEach(function (event) {
      return document.addEventListener(event, _this2.handleDocumentClick, true);
    });
  };

  _proto.removeEvents = function removeEvents() {
    var _this3 = this;

    ['click', 'touchstart', 'keyup'].forEach(function (event) {
      return document.removeEventListener(event, _this3.handleDocumentClick, true);
    });
  };

  _proto.handleDocumentClick = function handleDocumentClick(e) {
    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
    var container = this.getContainer();

    if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
      return;
    }

    this.toggle(e);
  };

  _proto.handleKeyDown = function handleKeyDown(e) {
    var _this4 = this;

    if (/input|textarea/i.test(e.target.tagName) || keyCodes.tab === e.which && (e.target.getAttribute('role') !== 'menuitem' || !this.props.a11y)) {
      return;
    }

    if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) {
      e.preventDefault();
    }

    if (this.props.disabled) return;

    if (this.getMenuCtrl() === e.target) {
      if (!this.props.isOpen && [keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down].indexOf(e.which) > -1) {
        this.toggle(e);
        setTimeout(function () {
          return _this4.getMenuItems()[0].focus();
        });
      } else if (this.props.isOpen && e.which === keyCodes.esc) {
        this.toggle(e);
      }
    }

    if (this.props.isOpen && e.target.getAttribute('role') === 'menuitem') {
      if ([keyCodes.tab, keyCodes.esc].indexOf(e.which) > -1) {
        this.toggle(e);
        this.getMenuCtrl().focus();
      } else if ([keyCodes.space, keyCodes.enter].indexOf(e.which) > -1) {
        e.target.click();
        this.getMenuCtrl().focus();
      } else if ([keyCodes.down, keyCodes.up].indexOf(e.which) > -1 || [keyCodes.n, keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
        var $menuitems = this.getMenuItems();
        var index = $menuitems.indexOf(e.target);

        if (keyCodes.up === e.which || keyCodes.p === e.which && e.ctrlKey) {
          index = index !== 0 ? index - 1 : $menuitems.length - 1;
        } else if (keyCodes.down === e.which || keyCodes.n === e.which && e.ctrlKey) {
          index = index === $menuitems.length - 1 ? 0 : index + 1;
        }

        $menuitems[index].focus();
      } else if (keyCodes.end === e.which) {
        var _$menuitems = this.getMenuItems();

        _$menuitems[_$menuitems.length - 1].focus();
      } else if (keyCodes.home === e.which) {
        var _$menuitems2 = this.getMenuItems();

        _$menuitems2[0].focus();
      } else if (e.which >= 48 && e.which <= 90) {
        var _$menuitems3 = this.getMenuItems();

        var charPressed = String.fromCharCode(e.which).toLowerCase();

        for (var i = 0; i < _$menuitems3.length; i += 1) {
          var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();

          if (firstLetter === charPressed) {
            _$menuitems3[i].focus();

            break;
          }
        }
      }
    }
  };

  _proto.handleProps = function handleProps() {
    if (this.props.isOpen) {
      this.addEvents();
    } else {
      this.removeEvents();
    }
  };

  _proto.toggle = function toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  };

  _proto.render = function render() {
    var _classNames, _ref;

    var _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar', 'a11y']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        direction = _omit.direction,
        isOpen = _omit.isOpen,
        group = _omit.group,
        size = _omit.size,
        nav = _omit.nav,
        setActiveFromChild = _omit.setActiveFromChild,
        active = _omit.active,
        addonType = _omit.addonType,
        tag = _omit.tag,
        attrs = _objectWithoutPropertiesLoose$3(_omit, ["className", "cssModule", "direction", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "addonType", "tag"]);

    var Tag = tag || (nav ? 'li' : 'div');
    var subItemIsActive = false;

    if (setActiveFromChild) {
      React__default['default'].Children.map(this.props.children[1].props.children, function (dropdownItem) {
        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
      });
    }

    var classes = mapToCssModules(classnames(className, direction !== 'down' && "drop" + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames['btn-group'] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames['nav-item'] = nav, _classNames)), cssModule);
    return /*#__PURE__*/React__default['default'].createElement(DropdownContext.Provider, {
      value: this.getContextValue()
    }, /*#__PURE__*/React__default['default'].createElement(Manager, null, /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({}, attrs, (_ref = {}, _ref[typeof Tag === 'string' ? 'ref' : 'innerRef'] = this.containerRef, _ref), {
      onKeyDown: this.handleKeyDown,
      className: classes
    }))));
  };

  return Dropdown;
}(React__default['default'].Component);

Dropdown.propTypes = propTypes$4;
Dropdown.defaultProps = defaultProps$3;

var propTypes$5 = {
  children: PropTypes__default['default'].node,
  active: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  divider: PropTypes__default['default'].bool,
  tag: tagPropType,
  header: PropTypes__default['default'].bool,
  onClick: PropTypes__default['default'].func,
  className: PropTypes__default['default'].string,
  cssModule: PropTypes__default['default'].object,
  toggle: PropTypes__default['default'].bool
};
var defaultProps$4 = {
  tag: 'button',
  toggle: true
};

var DropdownItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(DropdownItem, _React$Component);

  function DropdownItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(_assertThisInitialized$3(_this));
    _this.getTabIndex = _this.getTabIndex.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  var _proto = DropdownItem.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled || this.props.header || this.props.divider) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    if (this.props.toggle) {
      this.context.toggle(e);
    }
  };

  _proto.getTabIndex = function getTabIndex() {
    if (this.props.disabled || this.props.header || this.props.divider) {
      return '-1';
    }

    return '0';
  };

  _proto.render = function render() {
    var tabIndex = this.getTabIndex();
    var role = tabIndex > -1 ? 'menuitem' : undefined;

    var _omit = omit(this.props, ['toggle']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        divider = _omit.divider,
        Tag = _omit.tag,
        header = _omit.header,
        active = _omit.active,
        props = _objectWithoutPropertiesLoose$3(_omit, ["className", "cssModule", "divider", "tag", "header", "active"]);

    var classes = mapToCssModules(classnames(className, {
      disabled: props.disabled,
      'dropdown-item': !divider && !header,
      active: active,
      'dropdown-header': header,
      'dropdown-divider': divider
    }), cssModule);

    if (Tag === 'button') {
      if (header) {
        Tag = 'h6';
      } else if (divider) {
        Tag = 'div';
      } else if (props.href) {
        Tag = 'a';
      }
    }

    return /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({
      type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
    }, props, {
      tabIndex: tabIndex,
      role: role,
      className: classes,
      onClick: this.onClick
    }));
  };

  return DropdownItem;
}(React__default['default'].Component);

DropdownItem.propTypes = propTypes$5;
DropdownItem.defaultProps = defaultProps$4;
DropdownItem.contextType = DropdownContext;

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var propTypes$6 = {
  tag: tagPropType,
  children: PropTypes__default['default'].node.isRequired,
  right: PropTypes__default['default'].bool,
  flip: PropTypes__default['default'].bool,
  modifiers: PropTypes__default['default'].object,
  className: PropTypes__default['default'].string,
  cssModule: PropTypes__default['default'].object,
  persist: PropTypes__default['default'].bool,
  positionFixed: PropTypes__default['default'].bool
};
var defaultProps$5 = {
  tag: 'div',
  flip: true
};
var noFlipModifier = {
  flip: {
    enabled: false
  }
};
var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};

var DropdownMenu = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(DropdownMenu, _React$Component);

  function DropdownMenu() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownMenu.prototype;

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        right = _this$props.right,
        tag = _this$props.tag,
        flip = _this$props.flip,
        modifiers = _this$props.modifiers,
        persist = _this$props.persist,
        positionFixed = _this$props.positionFixed,
        attrs = _objectWithoutPropertiesLoose$3(_this$props, ["className", "cssModule", "right", "tag", "flip", "modifiers", "persist", "positionFixed"]);

    var classes = mapToCssModules(classnames(className, 'dropdown-menu', {
      'dropdown-menu-right': right,
      show: this.context.isOpen
    }), cssModule);
    var Tag = tag;

    if (persist || this.context.isOpen && !this.context.inNavbar) {
      var position1 = directionPositionMap[this.context.direction] || 'bottom';
      var position2 = right ? 'end' : 'start';
      var poperPlacement = position1 + "-" + position2;
      var poperModifiers = !flip ? _objectSpread(_objectSpread({}, modifiers), noFlipModifier) : modifiers;
      var popperPositionFixed = !!positionFixed;
      return /*#__PURE__*/React__default['default'].createElement(Popper$1, {
        placement: poperPlacement,
        modifiers: poperModifiers,
        positionFixed: popperPositionFixed
      }, function (_ref) {
        var ref = _ref.ref,
            style = _ref.style,
            placement = _ref.placement;
        return /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({
          tabIndex: "-1",
          role: "menu",
          ref: ref,
          style: style
        }, attrs, {
          "aria-hidden": !_this.context.isOpen,
          className: classes,
          "x-placement": placement
        }));
      });
    }

    return /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({
      tabIndex: "-1",
      role: "menu"
    }, attrs, {
      "aria-hidden": !this.context.isOpen,
      className: classes,
      "x-placement": attrs.placement
    }));
  };

  return DropdownMenu;
}(React__default['default'].Component);
DropdownMenu.propTypes = propTypes$6;
DropdownMenu.defaultProps = defaultProps$5;
DropdownMenu.contextType = DropdownContext;

var propTypes$7 = {
  caret: PropTypes__default['default'].bool,
  color: PropTypes__default['default'].string,
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  cssModule: PropTypes__default['default'].object,
  disabled: PropTypes__default['default'].bool,
  onClick: PropTypes__default['default'].func,
  'aria-haspopup': PropTypes__default['default'].bool,
  split: PropTypes__default['default'].bool,
  tag: tagPropType,
  nav: PropTypes__default['default'].bool
};
var defaultProps$6 = {
  'aria-haspopup': true,
  color: 'secondary'
};

var DropdownToggle = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(_assertThisInitialized$3(_this));
    return _this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled || this.context.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.nav && !this.props.tag) {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    this.context.toggle(e);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        color = _this$props.color,
        cssModule = _this$props.cssModule,
        caret = _this$props.caret,
        split = _this$props.split,
        nav = _this$props.nav,
        tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        props = _objectWithoutPropertiesLoose$3(_this$props, ["className", "color", "cssModule", "caret", "split", "nav", "tag", "innerRef"]);

    var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
    var classes = mapToCssModules(classnames(className, {
      'dropdown-toggle': caret || split,
      'dropdown-toggle-split': split,
      'nav-link': nav
    }), cssModule);
    var children = typeof props.children !== 'undefined' ? props.children : /*#__PURE__*/React__default['default'].createElement("span", {
      className: "sr-only"
    }, ariaLabel);
    var Tag;

    if (nav && !tag) {
      Tag = 'a';
      props.href = '#';
    } else if (!tag) {
      Tag = Button$1;
      props.color = color;
      props.cssModule = cssModule;
    } else {
      Tag = tag;
    }

    if (this.context.inNavbar) {
      return /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({}, props, {
        className: classes,
        onClick: this.onClick,
        "aria-expanded": this.context.isOpen,
        children: children
      }));
    }

    return /*#__PURE__*/React__default['default'].createElement(Reference, {
      innerRef: innerRef
    }, function (_ref) {
      var _ref2;

      var ref = _ref.ref;
      return /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({}, props, (_ref2 = {}, _ref2[typeof Tag === 'string' ? 'ref' : 'innerRef'] = ref, _ref2), {
        className: classes,
        onClick: _this2.onClick,
        "aria-expanded": _this2.context.isOpen,
        children: children
      }));
    });
  };

  return DropdownToggle;
}(React__default['default'].Component);

DropdownToggle.propTypes = propTypes$7;
DropdownToggle.defaultProps = defaultProps$6;
DropdownToggle.contextType = DropdownContext;

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
});

unwrapExports(interopRequireDefault);

var hasClass_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];
});

unwrapExports(hasClass_1);

var addClass_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = addClass;

var _hasClass = interopRequireDefault(hasClass_1);

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];
});

unwrapExports(addClass_1);

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

var removeClass = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

var PropTypes = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape = process.env.NODE_ENV !== 'production' ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape = process.env.NODE_ENV !== 'production' ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;
});

unwrapExports(PropTypes);
var PropTypes_1 = PropTypes.classNamesShape;
var PropTypes_2 = PropTypes.timeoutsShape;

var Transition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes$1 = _interopRequireWildcard(PropTypes__default['default']);

var _react = _interopRequireDefault(React__default['default']);

var _reactDom = _interopRequireDefault(ReactDOM__default['default']);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes$1.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes$1.oneOfType([PropTypes$1.func.isRequired, PropTypes$1.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes$1.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes$1.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes$1.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes$1.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes$1.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes$1.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes$1.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes$1.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes$1.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes$1.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes$1.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes$1.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes$1.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, reactLifecyclesCompat_es.polyfill)(Transition);

exports.default = _default;
});

unwrapExports(Transition_1);
var Transition_2 = Transition_1.EXITING;
var Transition_3 = Transition_1.ENTERED;
var Transition_4 = Transition_1.ENTERING;
var Transition_5 = Transition_1.EXITED;
var Transition_6 = Transition_1.UNMOUNTED;

var CSSTransition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var PropTypes$1 = _interopRequireWildcard(PropTypes__default['default']);

var _addClass = _interopRequireDefault(addClass_1);

var _removeClass = _interopRequireDefault(removeClass);

var _react = _interopRequireDefault(React__default['default']);

var _Transition = _interopRequireDefault(Transition_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass$1 = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass$1(node, className);
    activeClassName && removeClass$1(node, activeClassName);
    doneClassName && removeClass$1(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes$1.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(CSSTransition_1);

var ChildMapping = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;



/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, React__default['default'].isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) React__default['default'].Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, React__default['default'].cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, React__default['default'].isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, React__default['default'].isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, React__default['default'].cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, React__default['default'].cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, React__default['default'].isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, React__default['default'].cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
});

unwrapExports(ChildMapping);
var ChildMapping_1 = ChildMapping.getChildMapping;
var ChildMapping_2 = ChildMapping.mergeChildMappings;
var ChildMapping_3 = ChildMapping.getInitialChildMapping;
var ChildMapping_4 = ChildMapping.getNextChildMapping;

var TransitionGroup_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _react = _interopRequireDefault(React__default['default']);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, reactLifecyclesCompat_es.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(TransitionGroup_1);

var ReplaceTransition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _react = _interopRequireDefault(React__default['default']);



var _TransitionGroup = _interopRequireDefault(TransitionGroup_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, ReactDOM__default['default'].findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(ReplaceTransition_1);

var reactTransitionGroup = createCommonjsModule(function (module) {

var _CSSTransition = _interopRequireDefault(CSSTransition_1);

var _ReplaceTransition = _interopRequireDefault(ReplaceTransition_1);

var _TransitionGroup = _interopRequireDefault(TransitionGroup_1);

var _Transition = _interopRequireDefault(Transition_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};
});

unwrapExports(reactTransitionGroup);
var reactTransitionGroup_1 = reactTransitionGroup.Transition;
var reactTransitionGroup_2 = reactTransitionGroup.TransitionGroup;
var reactTransitionGroup_3 = reactTransitionGroup.ReplaceTransition;
var reactTransitionGroup_4 = reactTransitionGroup.CSSTransition;

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes$8 = _objectSpread$1(_objectSpread$1({}, reactTransitionGroup_1.propTypes), {}, {
  children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].node), PropTypes__default['default'].node]),
  tag: tagPropType,
  baseClass: PropTypes__default['default'].string,
  baseClassActive: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  cssModule: PropTypes__default['default'].object,
  innerRef: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].string, PropTypes__default['default'].func])
});

var defaultProps$7 = _objectSpread$1(_objectSpread$1({}, reactTransitionGroup_1.defaultProps), {}, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      innerRef = props.innerRef,
      otherProps = _objectWithoutPropertiesLoose$3(props, ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"]);

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);
  return /*#__PURE__*/React__default['default'].createElement(reactTransitionGroup_1, transitionProps, function (status) {
    var isActive = status === 'entered';
    var classes = mapToCssModules(classnames(className, baseClass, isActive && baseClassActive), cssModule);
    return /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({
      className: classes
    }, childProps, {
      ref: innerRef
    }), children);
  });
}

Fade.propTypes = propTypes$8;
Fade.defaultProps = defaultProps$7;

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function noop() {}

var propTypes$9 = {
  children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].node, PropTypes__default['default'].func]).isRequired,
  popperClassName: PropTypes__default['default'].string,
  placement: PropTypes__default['default'].string,
  placementPrefix: PropTypes__default['default'].string,
  arrowClassName: PropTypes__default['default'].string,
  hideArrow: PropTypes__default['default'].bool,
  tag: tagPropType,
  isOpen: PropTypes__default['default'].bool.isRequired,
  cssModule: PropTypes__default['default'].object,
  offset: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),
  fallbackPlacement: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].array]),
  flip: PropTypes__default['default'].bool,
  container: targetPropType,
  target: targetPropType.isRequired,
  modifiers: PropTypes__default['default'].object,
  boundariesElement: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, DOMElement]),
  onClosed: PropTypes__default['default'].func,
  fade: PropTypes__default['default'].bool,
  transition: PropTypes__default['default'].shape(Fade.propTypes)
};
var defaultProps$8 = {
  boundariesElement: 'scrollParent',
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body',
  modifiers: {},
  onClosed: noop,
  fade: true,
  transition: _objectSpread$2({}, Fade.defaultProps)
};

var PopperContent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(PopperContent, _React$Component);

  function PopperContent(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.setTargetNode = _this.setTargetNode.bind(_assertThisInitialized$3(_this));
    _this.getTargetNode = _this.getTargetNode.bind(_assertThisInitialized$3(_this));
    _this.getRef = _this.getRef.bind(_assertThisInitialized$3(_this));
    _this.onClosed = _this.onClosed.bind(_assertThisInitialized$3(_this));
    _this.state = {
      isOpen: props.isOpen
    };
    return _this;
  }

  PopperContent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        isOpen: props.isOpen
      };
    } else return null;
  };

  var _proto = PopperContent.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
      this._element.childNodes[0].focus();
    }
  };

  _proto.setTargetNode = function setTargetNode(node) {
    this.targetNode = typeof node === 'string' ? getTarget(node) : node;
  };

  _proto.getTargetNode = function getTargetNode() {
    return this.targetNode;
  };

  _proto.getContainerNode = function getContainerNode() {
    return getTarget(this.props.container);
  };

  _proto.getRef = function getRef(ref) {
    this._element = ref;
  };

  _proto.onClosed = function onClosed() {
    this.props.onClosed();
    this.setState({
      isOpen: false
    });
  };

  _proto.renderChildren = function renderChildren() {
    var _this$props = this.props,
        cssModule = _this$props.cssModule,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        flip = _this$props.flip,
        target = _this$props.target,
        offset = _this$props.offset,
        fallbackPlacement = _this$props.fallbackPlacement,
        placementPrefix = _this$props.placementPrefix,
        _arrowClassName = _this$props.arrowClassName,
        hideArrow = _this$props.hideArrow,
        _popperClassName = _this$props.popperClassName,
        tag = _this$props.tag,
        container = _this$props.container,
        modifiers = _this$props.modifiers,
        boundariesElement = _this$props.boundariesElement,
        onClosed = _this$props.onClosed,
        fade = _this$props.fade,
        transition = _this$props.transition,
        placement = _this$props.placement,
        attrs = _objectWithoutPropertiesLoose$3(_this$props, ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacement", "placementPrefix", "arrowClassName", "hideArrow", "popperClassName", "tag", "container", "modifiers", "boundariesElement", "onClosed", "fade", "transition", "placement"]);

    var arrowClassName = mapToCssModules(classnames('arrow', _arrowClassName), cssModule);
    var popperClassName = mapToCssModules(classnames(_popperClassName, placementPrefix ? placementPrefix + "-auto" : ''), this.props.cssModule);

    var extendedModifiers = _objectSpread$2({
      offset: {
        offset: offset
      },
      flip: {
        enabled: flip,
        behavior: fallbackPlacement
      },
      preventOverflow: {
        boundariesElement: boundariesElement
      }
    }, modifiers);

    var popperTransition = _objectSpread$2(_objectSpread$2(_objectSpread$2({}, Fade.defaultProps), transition), {}, {
      baseClass: fade ? transition.baseClass : '',
      timeout: fade ? transition.timeout : 0
    });

    return /*#__PURE__*/React__default['default'].createElement(Fade, _extends$3({}, popperTransition, attrs, {
      in: isOpen,
      onExited: this.onClosed,
      tag: tag
    }), /*#__PURE__*/React__default['default'].createElement(Popper$1, {
      referenceElement: this.targetNode,
      modifiers: extendedModifiers,
      placement: placement
    }, function (_ref) {
      var ref = _ref.ref,
          style = _ref.style,
          placement = _ref.placement,
          outOfBoundaries = _ref.outOfBoundaries,
          arrowProps = _ref.arrowProps,
          scheduleUpdate = _ref.scheduleUpdate;
      return /*#__PURE__*/React__default['default'].createElement("div", {
        ref: ref,
        style: style,
        className: popperClassName,
        "x-placement": placement,
        "x-out-of-boundaries": outOfBoundaries ? 'true' : undefined
      }, typeof children === 'function' ? children({
        scheduleUpdate: scheduleUpdate
      }) : children, !hideArrow && /*#__PURE__*/React__default['default'].createElement("span", {
        ref: arrowProps.ref,
        className: arrowClassName,
        style: arrowProps.style
      }));
    }));
  };

  _proto.render = function render() {
    this.setTargetNode(this.props.target);

    if (this.state.isOpen) {
      return this.props.container === 'inline' ? this.renderChildren() : /*#__PURE__*/ReactDOM__default['default'].createPortal( /*#__PURE__*/React__default['default'].createElement("div", {
        ref: this.getRef
      }, this.renderChildren()), this.getContainerNode());
    }

    return null;
  };

  return PopperContent;
}(React__default['default'].Component);

PopperContent.propTypes = propTypes$9;
PopperContent.defaultProps = defaultProps$8;

var propTypes$a = {
  children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].node, PropTypes__default['default'].func]),
  placement: PropTypes__default['default'].oneOf(PopperPlacements),
  target: targetPropType.isRequired,
  container: targetPropType,
  isOpen: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  hideArrow: PropTypes__default['default'].bool,
  boundariesElement: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, DOMElement]),
  className: PropTypes__default['default'].string,
  innerClassName: PropTypes__default['default'].string,
  arrowClassName: PropTypes__default['default'].string,
  popperClassName: PropTypes__default['default'].string,
  cssModule: PropTypes__default['default'].object,
  toggle: PropTypes__default['default'].func,
  autohide: PropTypes__default['default'].bool,
  placementPrefix: PropTypes__default['default'].string,
  delay: PropTypes__default['default'].oneOfType([PropTypes__default['default'].shape({
    show: PropTypes__default['default'].number,
    hide: PropTypes__default['default'].number
  }), PropTypes__default['default'].number]),
  modifiers: PropTypes__default['default'].object,
  offset: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),
  innerRef: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].string, PropTypes__default['default'].object]),
  trigger: PropTypes__default['default'].string,
  fade: PropTypes__default['default'].bool,
  flip: PropTypes__default['default'].bool
};
var DEFAULT_DELAYS = {
  show: 0,
  hide: 50
};
var defaultProps$9 = {
  isOpen: false,
  hideArrow: false,
  autohide: false,
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {},
  trigger: 'click',
  fade: true
};

function isInDOMSubtree(element, subtreeRoot) {
  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}

function isInDOMSubtrees(element, subtreeRoots) {
  if (subtreeRoots === void 0) {
    subtreeRoots = [];
  }

  return subtreeRoots && subtreeRoots.length && subtreeRoots.filter(function (subTreeRoot) {
    return isInDOMSubtree(element, subTreeRoot);
  })[0];
}

var TooltipPopoverWrapper = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(TooltipPopoverWrapper, _React$Component);

  function TooltipPopoverWrapper(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._targets = [];
    _this.currentTargetElement = null;
    _this.addTargetEvents = _this.addTargetEvents.bind(_assertThisInitialized$3(_this));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_assertThisInitialized$3(_this));
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_assertThisInitialized$3(_this));
    _this.toggle = _this.toggle.bind(_assertThisInitialized$3(_this));
    _this.showWithDelay = _this.showWithDelay.bind(_assertThisInitialized$3(_this));
    _this.hideWithDelay = _this.hideWithDelay.bind(_assertThisInitialized$3(_this));
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_assertThisInitialized$3(_this));
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_assertThisInitialized$3(_this));
    _this.show = _this.show.bind(_assertThisInitialized$3(_this));
    _this.hide = _this.hide.bind(_assertThisInitialized$3(_this));
    _this.onEscKeyDown = _this.onEscKeyDown.bind(_assertThisInitialized$3(_this));
    _this.getRef = _this.getRef.bind(_assertThisInitialized$3(_this));
    _this.state = {
      isOpen: props.isOpen
    };
    _this._isMounted = false;
    return _this;
  }

  var _proto = TooltipPopoverWrapper.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.updateTarget();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this.removeTargetEvents();
    this._targets = null;
    this.clearShowTimeout();
    this.clearHideTimeout();
  };

  TooltipPopoverWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        isOpen: props.isOpen
      };
    } else return null;
  };

  _proto.onMouseOverTooltipContent = function onMouseOverTooltipContent() {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (this.state.isOpen && !this.props.isOpen) {
        this.toggle();
      }
    }
  };

  _proto.onMouseLeaveTooltipContent = function onMouseLeaveTooltipContent(e) {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }

      e.persist();
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  };

  _proto.onEscKeyDown = function onEscKeyDown(e) {
    if (e.key === 'Escape') {
      this.hide(e);
    }
  };

  _proto.getRef = function getRef(ref) {
    var innerRef = this.props.innerRef;

    if (innerRef) {
      if (typeof innerRef === 'function') {
        innerRef(ref);
      } else if (typeof innerRef === 'object') {
        innerRef.current = ref;
      }
    }

    this._popover = ref;
  };

  _proto.getDelay = function getDelay(key) {
    var delay = this.props.delay;

    if (typeof delay === 'object') {
      return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
    }

    return delay;
  };

  _proto.show = function show(e) {
    if (!this.props.isOpen) {
      this.clearShowTimeout();
      this.currentTargetElement = e ? e.currentTarget || e.target : null;

      if (e && e.composedPath && typeof e.composedPath === 'function') {
        var path = e.composedPath();
        this.currentTargetElement = path && path[0] || this.currentTargetElement;
      }

      this.toggle(e);
    }
  };

  _proto.showWithDelay = function showWithDelay(e) {
    if (this._hideTimeout) {
      this.clearHideTimeout();
    }

    this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
  };

  _proto.hide = function hide(e) {
    if (this.props.isOpen) {
      this.clearHideTimeout();
      this.currentTargetElement = null;
      this.toggle(e);
    }
  };

  _proto.hideWithDelay = function hideWithDelay(e) {
    if (this._showTimeout) {
      this.clearShowTimeout();
    }

    this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
  };

  _proto.clearShowTimeout = function clearShowTimeout() {
    clearTimeout(this._showTimeout);
    this._showTimeout = undefined;
  };

  _proto.clearHideTimeout = function clearHideTimeout() {
    clearTimeout(this._hideTimeout);
    this._hideTimeout = undefined;
  };

  _proto.handleDocumentClick = function handleDocumentClick(e) {
    var triggers = this.props.trigger.split(' ');

    if (triggers.indexOf('legacy') > -1 && (this.props.isOpen || isInDOMSubtrees(e.target, this._targets))) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) {
        this.hideWithDelay(e);
      } else if (!this.props.isOpen) {
        this.showWithDelay(e);
      }
    } else if (triggers.indexOf('click') > -1 && isInDOMSubtrees(e.target, this._targets)) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (!this.props.isOpen) {
        this.showWithDelay(e);
      } else {
        this.hideWithDelay(e);
      }
    }
  };

  _proto.addEventOnTargets = function addEventOnTargets(type, handler, isBubble) {
    this._targets.forEach(function (target) {
      target.addEventListener(type, handler, isBubble);
    });
  };

  _proto.removeEventOnTargets = function removeEventOnTargets(type, handler, isBubble) {
    this._targets.forEach(function (target) {
      target.removeEventListener(type, handler, isBubble);
    });
  };

  _proto.addTargetEvents = function addTargetEvents() {
    if (this.props.trigger) {
      var triggers = this.props.trigger.split(' ');

      if (triggers.indexOf('manual') === -1) {
        if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) {
          document.addEventListener('click', this.handleDocumentClick, true);
        }

        if (this._targets && this._targets.length) {
          if (triggers.indexOf('hover') > -1) {
            this.addEventOnTargets('mouseover', this.showWithDelay, true);
            this.addEventOnTargets('mouseout', this.hideWithDelay, true);
          }

          if (triggers.indexOf('focus') > -1) {
            this.addEventOnTargets('focusin', this.show, true);
            this.addEventOnTargets('focusout', this.hide, true);
          }

          this.addEventOnTargets('keydown', this.onEscKeyDown, true);
        }
      }
    }
  };

  _proto.removeTargetEvents = function removeTargetEvents() {
    if (this._targets) {
      this.removeEventOnTargets('mouseover', this.showWithDelay, true);
      this.removeEventOnTargets('mouseout', this.hideWithDelay, true);
      this.removeEventOnTargets('keydown', this.onEscKeyDown, true);
      this.removeEventOnTargets('focusin', this.show, true);
      this.removeEventOnTargets('focusout', this.hide, true);
    }

    document.removeEventListener('click', this.handleDocumentClick, true);
  };

  _proto.updateTarget = function updateTarget() {
    var newTarget = getTarget(this.props.target, true);

    if (newTarget !== this._targets) {
      this.removeTargetEvents();
      this._targets = newTarget ? Array.from(newTarget) : [];
      this.currentTargetElement = this.currentTargetElement || this._targets[0];
      this.addTargetEvents();
    }
  };

  _proto.toggle = function toggle(e) {
    if (this.props.disabled || !this._isMounted) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  };

  _proto.render = function render() {
    var _this2 = this;

    if (!this.props.isOpen) {
      return null;
    }

    this.updateTarget();
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        innerClassName = _this$props.innerClassName,
        isOpen = _this$props.isOpen,
        hideArrow = _this$props.hideArrow,
        boundariesElement = _this$props.boundariesElement,
        placement = _this$props.placement,
        placementPrefix = _this$props.placementPrefix,
        arrowClassName = _this$props.arrowClassName,
        popperClassName = _this$props.popperClassName,
        container = _this$props.container,
        modifiers = _this$props.modifiers,
        offset = _this$props.offset,
        fade = _this$props.fade,
        flip = _this$props.flip,
        children = _this$props.children;
    var attributes = omit(this.props, Object.keys(propTypes$a));
    var popperClasses = mapToCssModules(popperClassName, cssModule);
    var classes = mapToCssModules(innerClassName, cssModule);
    return /*#__PURE__*/React__default['default'].createElement(PopperContent, {
      className: className,
      target: this.currentTargetElement || this._targets[0],
      isOpen: isOpen,
      hideArrow: hideArrow,
      boundariesElement: boundariesElement,
      placement: placement,
      placementPrefix: placementPrefix,
      arrowClassName: arrowClassName,
      popperClassName: popperClasses,
      container: container,
      modifiers: modifiers,
      offset: offset,
      cssModule: cssModule,
      fade: fade,
      flip: flip
    }, function (_ref) {
      var scheduleUpdate = _ref.scheduleUpdate;
      return /*#__PURE__*/React__default['default'].createElement("div", _extends$3({}, attributes, {
        ref: _this2.getRef,
        className: classes,
        role: "tooltip",
        onMouseOver: _this2.onMouseOverTooltipContent,
        onMouseLeave: _this2.onMouseLeaveTooltipContent,
        onKeyDown: _this2.onEscKeyDown
      }), typeof children === 'function' ? children({
        scheduleUpdate: scheduleUpdate
      }) : children);
    });
  };

  return TooltipPopoverWrapper;
}(React__default['default'].Component);

TooltipPopoverWrapper.propTypes = propTypes$a;
TooltipPopoverWrapper.defaultProps = defaultProps$9;

var defaultProps$a = {
  placement: 'right',
  placementPrefix: 'bs-popover',
  trigger: 'click'
};

var Popover = function Popover(props) {
  var popperClasses = classnames('popover', 'show', props.popperClassName);
  var classes = classnames('popover-inner', props.innerClassName);
  return /*#__PURE__*/React__default['default'].createElement(TooltipPopoverWrapper, _extends$3({}, props, {
    popperClassName: popperClasses,
    innerClassName: classes
  }));
};

Popover.propTypes = propTypes$a;
Popover.defaultProps = defaultProps$a;

var propTypes$b = {
  tag: tagPropType,
  className: PropTypes__default['default'].string,
  cssModule: PropTypes__default['default'].object
};
var defaultProps$b = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose$3(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(classnames(className, 'popover-body'), cssModule);
  return /*#__PURE__*/React__default['default'].createElement(Tag, _extends$3({}, attributes, {
    className: classes
  }));
};

PopoverBody.propTypes = propTypes$b;
PopoverBody.defaultProps = defaultProps$b;

function makeString(object) {
  if (object === null) {
    return '';
  }

  return '' + object;
}

function capitalizeFirstLetter(str) {
  var lowercaseRest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  str = makeString(str);
  var remainingChars = !lowercaseRest ? str.slice(1) : str.slice(1).toLowerCase();
  return str.charAt(0).toUpperCase() + remainingChars;
}

var css_248z$7 = "@keyframes Dropdown_fadein__1bUoc {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes Dropdown_fadein__1bUoc {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes Dropdown_fadein__1bUoc {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes Dropdown_fadein__1bUoc {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes Dropdown_fadein__1bUoc {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.Dropdown_cyber-dropdown__3BqWx {\n  overflow: hidden; }\n\n.Dropdown_cyber-dropdown-item__1s83g {\n  padding: 10px 20px; }\n  .Dropdown_cyber-dropdown-item__1s83g.Dropdown_active__2fc-X, .Dropdown_cyber-dropdown-item__1s83g:active {\n    background-color: #4eb3d4; }\n\nbutton:focus {\n  outline: 3px auto #4eb3d4 !important; }\n";
styleInject(css_248z$7);

var isEmpty$2 = function isEmpty(value) {
  return value === undefined || value === null || value === '';
};

function Drodown(_ref) {
  var _this = this;

  var title = _ref.title,
      items = _ref.items,
      dropdown = _ref.dropdown,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["title", "items", "dropdown", "type"]);

  var _useState = React$2.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownOpen = _useState2[0],
      setDropdownOpen = _useState2[1];

  var toggle = function toggle() {
    return setDropdownOpen(function (prevState) {
      return !prevState;
    });
  };

  return /*#__PURE__*/React__default['default'].createElement("div", null, !isEmpty$2(title) && /*#__PURE__*/React__default['default'].createElement("div", null, title), /*#__PURE__*/React__default['default'].createElement(Dropdown, _extends({}, dropdown, {
    isOpen: dropdownOpen,
    toggle: toggle
  }), /*#__PURE__*/React__default['default'].createElement(DropdownToggle, {
    caret: true,
    className: "btn btn-light"
  }, type === 'CAMPAIGN' ? dropdown.value : capitalizeFirstLetter(dropdown.value)), /*#__PURE__*/React__default['default'].createElement(DropdownMenu, {
    className: "cyber-dropdown ".concat(dropdown.className || '')
  }, items.map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement(DropdownItem, {
      key: index,
      header: item.header,
      disabled: item.disabled,
      divider: item.divider,
      active: item.active,
      className: "cyber-dropdown-item",
      onClick: dropdown.onChange.bind(_this, {
        target: {
          name: dropdown.name,
          value: item
        }
      })
    }, type === 'CAMPAIGN' ? item.name : capitalizeFirstLetter(item.name));
  }))));
}

Drodown.propTypes = {
  title: PropTypes__default['default'].string,
  items: PropTypes__default['default'].object,
  dropdown: PropTypes__default['default'].shape({
    value: PropTypes__default['default'].string.isRequired,
    onChange: PropTypes__default['default'].func.isRequired,
    a11y: PropTypes__default['default'].bool,
    // defaults to true. Set to false to enable more bootstrap like tabbing behavior
    disabled: PropTypes__default['default'].bool,
    direction: PropTypes__default['default'].oneOf(['up', 'down', 'left', 'right']),
    group: PropTypes__default['default'].bool,
    isOpen: PropTypes__default['default'].bool,
    nav: PropTypes__default['default'].bool,
    // For Dropdown usage inside a Nav
    active: PropTypes__default['default'].bool,
    inNavbar: PropTypes__default['default'].bool,
    // For Dropdown usage inside a Navbar (disables popper)
    tag: PropTypes__default['default'].string,
    // default: 'div' unless nav=true, then 'li'
    toggle: PropTypes__default['default'].func,
    name: PropTypes__default['default'].string.isRequired,
    setActiveFromChild: PropTypes__default['default'].bool
  }).isRequired
};
Drodown.defaultProps = {
  dropdown: {
    a11y: true,
    direction: 'down',
    isOpen: false,
    nav: false,
    active: false,
    inNavbar: false
  }
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                    ? getDataTransferFiles(evt.dataTransfer, evt.type)
                    : getInputFiles(evt)];
        });
    });
}
function isDragEvt(value) {
    return !!value.dataTransfer;
}
function getInputFiles(evt) {
    var files = isInput(evt.target)
        ? evt.target.files
            ? fromList(evt.target.files)
            : []
        : [];
    return files.map(function (file) { return toFileWithPath(file); });
}
function isInput(value) {
    return value !== null;
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var es = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};
});

var accepts = unwrapExports(es);

// that MIME type will always be accepted

function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || accepts(file, accept);
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) return file.size >= minSize && file.size <= maxSize;else if (isDefined(minSize)) return file.size >= minSize;else if (isDefined(maxSize)) return file.size <= maxSize;
  }

  return true;
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple;

  if (!multiple && files.length > 1) {
    return false;
  }

  return files.every(function (file) {
    return fileAccepted(file, accept) && fileMatchSize(file, minSize, maxSize);
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$1(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$1(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = React$2.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties$1(_ref, ["children"]);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties$1(_useDropzone, ["open"]);

  React$2.useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return React__default['default'].createElement(React$2.Fragment, null, children(_objectSpread$3({}, props, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone';
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {File[]} params.rejectedFiles Rejected files
   */
  children: PropTypes__default['default'].func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes__default['default'].bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes__default['default'].bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes__default['default'].bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes__default['default'].bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes__default['default'].bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes__default['default'].bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes__default['default'].number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes__default['default'].number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes__default['default'].bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes__default['default'].func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes__default['default'].func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes__default['default'].func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes__default['default'].func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes__default['default'].func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {File[]} rejectedFiles
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes__default['default'].func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes__default['default'].func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {object[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes__default['default'].func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {File[]} rejectedFiles List of rejected files
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {File[]} rejectedFiles Rejected files
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  rejectedFiles: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are droppped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accept = _ref2.accept,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$getFilesFromEve = _ref2.getFilesFromEvent,
      getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? fromEvent : _ref2$getFilesFromEve,
      _ref2$maxSize = _ref2.maxSize,
      maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize,
      _ref2$minSize = _ref2.minSize,
      minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? true : _ref2$multiple,
      onDragEnter = _ref2.onDragEnter,
      onDragLeave = _ref2.onDragLeave,
      onDragOver = _ref2.onDragOver,
      onDrop = _ref2.onDrop,
      onDropAccepted = _ref2.onDropAccepted,
      onDropRejected = _ref2.onDropRejected,
      onFileDialogCancel = _ref2.onFileDialogCancel,
      _ref2$preventDropOnDo = _ref2.preventDropOnDocument,
      preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo,
      _ref2$noClick = _ref2.noClick,
      noClick = _ref2$noClick === void 0 ? false : _ref2$noClick,
      _ref2$noKeyboard = _ref2.noKeyboard,
      noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard,
      _ref2$noDrag = _ref2.noDrag,
      noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag,
      _ref2$noDragEventsBub = _ref2.noDragEventsBubbling,
      noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;

  var rootRef = React$2.useRef(null);
  var inputRef = React$2.useRef(null);

  var _useReducer = React$2.useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray$1(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = React$2.useCallback(function () {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch]); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  React$2.useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = React$2.useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = React$2.useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = React$2.useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = React$2.useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);
  var dragTargetsRef = React$2.useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  React$2.useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = React$2.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event); // Count the dropzone and any children that are entered.

    if (dragTargetsRef.current.indexOf(event.target) === -1) {
      dragTargetsRef.current = [].concat(_toConsumableArray$1(dragTargetsRef.current), [event.target]);
    }

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = React$2.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);

    if (event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (isEvtWithFiles(event) && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = React$2.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return target !== event.target && rootRef.current && rootRef.current.contains(target);
    });
    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = React$2.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var rejectedFiles = [];
        files.forEach(function (file) {
          if (fileAccepted(file, accept) && fileMatchSize(file, minSize, maxSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple && acceptedFiles.length > 1) {
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray$1(acceptedFiles.splice(0))); // Reject everything and empty accepted files
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          rejectedFiles: rejectedFiles,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, rejectedFiles, event);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected(rejectedFiles, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [multiple, accept, minSize, maxSize, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = React$2.useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onKeyDown = _ref3.onKeyDown,
          onFocus = _ref3.onFocus,
          onBlur = _ref3.onBlur,
          onClick = _ref3.onClick,
          onDragEnter = _ref3.onDragEnter,
          onDragOver = _ref3.onDragOver,
          onDragLeave = _ref3.onDragLeave,
          onDrop = _ref3.onDrop,
          rest = _objectWithoutProperties$1(_ref3, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return _objectSpread$3(_defineProperty$3({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}, {}, rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = React$2.useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = React$2.useMemo(function () {
    return function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$refKey = _ref4.refKey,
          refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
          onChange = _ref4.onChange,
          onClick = _ref4.onClick,
          rest = _objectWithoutProperties$1(_ref4, ["refKey", "onChange", "onClick"]);

      var inputProps = _defineProperty$3({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread$3({}, inputProps, {}, rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread$3({}, state, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread$3({}, state, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread$3({}, state, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread$3({}, state, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread$3({}, state, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread$3({}, state, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread$3({}, state, {
        acceptedFiles: action.acceptedFiles,
        rejectedFiles: action.rejectedFiles
      });

    case 'reset':
      return _objectSpread$3({}, state, {
        isFileDialogActive: false,
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: [],
        rejectedFiles: []
      });

    default:
      return state;
  }
}

/* global FileReader */

function Dropzone$1(props) {
  var onDrop = React$2.useCallback(function (acceptedFiles) {
    acceptedFiles.forEach(function (file) {
      var reader = new FileReader();

      reader.onabort = function () {
        console.error('file reading was aborted');
        props.onAbort && props.onAbort();
      };

      reader.onerror = function () {
        console.error('file reading has failed');
        props.onError && props.onError();
      };

      reader.onload = function () {
        props.onLoad({
          file: file,
          binary: reader.result
        });
      };

      reader.readAsArrayBuffer(file);
    });
  });

  var _useDropzone = useDropzone(_objectSpread2({
    onDrop: onDrop
  }, props)),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragAccept = _useDropzone.isDragAccept,
      isDragReject = _useDropzone.isDragReject;

  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: "dropzone-container ".concat(props.containerClass)
  }, getRootProps()), /*#__PURE__*/React__default['default'].createElement("input", _extends({
    className: "dropzone-input ".concat(props.inputClass)
  }, getInputProps())), isDragAccept ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "dropzone-inner hovered ".concat(props.innerClass)
  }, props.hoverRender || /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fal fa-copy"
  })), /*#__PURE__*/React__default['default'].createElement("div", null, "Drop file"))) : isDragReject ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "dropzone-inner rejected ".concat(props.innerClass)
  }, props.invalidRender || /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fal fa-copy"
  })), /*#__PURE__*/React__default['default'].createElement("div", null, "Invalid File"))) : /*#__PURE__*/React__default['default'].createElement("div", {
    className: "dropzone-inner ".concat(props.innerClass)
  }, props.defaultRender || /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fal fa-copy"
  })), /*#__PURE__*/React__default['default'].createElement("div", null, "Upload CSV file"))));
}
Dropzone$1.propTypes = {
  onLoad: PropTypes__default['default'].func.isRequired,
  onError: PropTypes__default['default'].func,
  onAbort: PropTypes__default['default'].func,
  containerClass: PropTypes__default['default'].string,
  inputClass: PropTypes__default['default'].string,
  innerClass: PropTypes__default['default'].string
};
Dropzone$1.defaultProps = {
  containerClass: '',
  inputClass: '',
  innerClass: ''
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      console.error(error);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return this.props.errorComponent || /*#__PURE__*/React__default['default'].createElement("div", null);
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(React__default['default'].Component);

var DynamicImport = /*#__PURE__*/function (_React$Component) {
  _inherits(DynamicImport, _React$Component);

  var _super = _createSuper(DynamicImport);

  function DynamicImport() {
    var _this;

    _classCallCheck(this, DynamicImport);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      component: null
    });

    return _this;
  }

  _createClass(DynamicImport, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.load().then(function (component) {
        _this2.setState(function () {
          return {
            component: component.default ? component.default : component
          };
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement(ErrorBoundary, null, this.props.children(this.state.component));
    }
  }]);

  return DynamicImport;
}(React__default['default'].Component);

var css_248z$8 = "@keyframes IconButton_fadein__3NXcJ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes IconButton_fadein__3NXcJ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes IconButton_fadein__3NXcJ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes IconButton_fadein__3NXcJ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes IconButton_fadein__3NXcJ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.IconButton_puzzle-icon-button--container__OkEtz {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-size: 30px; }\n  .IconButton_puzzle-icon-button--container__OkEtz .IconButton_puzzle-icon-button__GXc8e {\n    border: 1px solid #4eb3d4;\n    box-shadow: 3px 4px 0 #4eb3d4;\n    -moz-box-shadow: 3px 4px 0 0 #4eb3d4;\n    -webkit-box-shadow: 3px 4px 0 0 #4eb3d4;\n    box-shadow: 3px 4px 0 0 #4eb3d4;\n    padding: 5px;\n    margin: 5px;\n    background: white;\n    color: #4eb3d4;\n    cursor: pointer; }\n  .IconButton_puzzle-icon-button--container__OkEtz .IconButton_puzzle-icon-button__GXc8e:active {\n    transform: translate(3px, 4px);\n    box-shadow: none; }\n";
styleInject(css_248z$8);

var IconButton = /*#__PURE__*/function (_Component) {
  _inherits(IconButton, _Component);

  var _super = _createSuper(IconButton);

  function IconButton() {
    var _this;

    _classCallCheck(this, IconButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(IconButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          iconClass = _this$props.iconClass,
          handleOnClick = _this$props.handleOnClick,
          iconContainerClass = _this$props.iconContainerClass,
          iconButtonClass = _this$props.iconButtonClass,
          styles = _this$props.styles,
          dataTip = _this$props.dataTip;
      return iconClass ? /*#__PURE__*/React__default['default'].createElement("div", {
        "data-tip": dataTip,
        className: "".concat(iconContainerClass || 'puzzle-icon-button--container'),
        onClick: handleOnClick,
        style: styles
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: "".concat(iconButtonClass ? iconButtonClass + ' ' + iconClass : iconClass && 'puzzle-icon-button')
      })) : null;
    }
  }]);

  return IconButton;
}(React$2.Component);
IconButton.propTypes = {
  handleOnClick: PropTypes__default['default'].func,
  iconClass: PropTypes__default['default'].string
};
IconButton.defaultProps = {
  iconClass: ''
};

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  color: ", ";\n  font-size: 14px;\n  font-family: Gotham;\n  padding: 15px 34px 15px 24px;\n  outline: none;\n  border: 1px solid ", ";\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 10px;\n  letter-spacing: 0.83px;\n  color: ", ";\n  text-transform: uppercase;\n  position: absolute;\n  right: 0px;\n  bottom: 50px;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 30px;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: 48px;\n  position: relative;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$6 = Ye.div(_templateObject$b());
var Title = Ye.div(_templateObject2$5());
var Optional = Ye.div(_templateObject3$2(), COLORS_CONFIG.SMOOTH_BROWN);
var Input$1 = Ye.input(_templateObject4(), COLORS_CONFIG.SMOOTH_BROWN, COLORS_CONFIG.SKY_BLUE, function (_ref) {
  var disabled = _ref.disabled;
  return disabled && _e(["background-color:", ";"], COLORS_CONFIG.SILVER);
});

var isEmpty$3 = function isEmpty(value) {
  return value === undefined || value === null || value === '';
};

function Input$2(_ref) {
  var placeholder = _ref.placeholder,
      status = _ref.status,
      title = _ref.title,
      type = _ref.type,
      name = _ref.name,
      value = _ref.value,
      optional = _ref.optional,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["placeholder", "status", "title", "type", "name", "value", "optional", "disabled"]);

  return /*#__PURE__*/React__default['default'].createElement(Wrapper$6, null, optional && /*#__PURE__*/React__default['default'].createElement(Optional, null, "optional"), !isEmpty$3(title) && /*#__PURE__*/React__default['default'].createElement(Title, null, title), /*#__PURE__*/React__default['default'].createElement(Input$1, _extends({
    placeholder: placeholder,
    type: type,
    name: name,
    value: value || '',
    disabled: disabled,
    autoComplete: false
  }, rest)));
}

Input$2.propTypes = {
  autoComplete: PropTypes__default['default'].oneOf(['on', 'off', 'new-password']),
  placeholder: PropTypes__default['default'].string,
  onChange: PropTypes__default['default'].func.isRequired,
  status: PropTypes__default['default'].shape({
    valid: PropTypes__default['default'].bool,
    error: PropTypes__default['default'].string
  }),
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),
  title: PropTypes__default['default'].string,
  name: PropTypes__default['default'].string.isRequired,
  optional: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  type: PropTypes__default['default'].oneOf(['text', 'password', 'email'])
};
Input$2.defaultProps = {
  autoComplete: 'new-password',
  type: 'text',
  optional: false,
  value: '',
  title: '',
  placeholder: '',
  disabled: false,
  status: null
};

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var Image$1 = Ye.img(_templateObject$c(), function (_ref) {
  var width = _ref.width,
      height = _ref.height,
      relative = _ref.relative,
      disabled = _ref.disabled;
  return _e(["height:", " ", ";width:", " ", ";", ";"], height, relative ? '%' : 'px', width, relative ? '%' : 'px', disabled && _e(["filter:invert(0.8);pointer-events:none;cursor:default;"]));
});

function Img$1(_ref) {
  var src = _ref.src,
      size = _ref.size,
      restProps = _objectWithoutProperties(_ref, ["src", "size"]);

  var _size = _slicedToArray(size, 2),
      width = _size[0],
      height = _size[1];

  return /*#__PURE__*/React__default['default'].createElement(Image$1, _extends({
    src: src,
    width: width,
    height: height
  }, restProps));
}
/* Img type of props */


Img$1.propTypes = {
  src: PropTypes__default['default'].string,
  size: PropTypes__default['default'].arrayOf(PropTypes__default['default'].number)
};
/* Img default props */

Img$1.defaultProps = {
  src: null,
  size: [50, 50]
};

var css_248z$9 = "@keyframes LeaderboardDropdowns_fadein__2En_r {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes LeaderboardDropdowns_fadein__2En_r {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes LeaderboardDropdowns_fadein__2En_r {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes LeaderboardDropdowns_fadein__2En_r {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes LeaderboardDropdowns_fadein__2En_r {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.LeaderboardDropdowns_leaderboard-dropdown--container__3Kh4v {\n  width: 20rem;\n  min-width: 10rem;\n  margin-right: 2rem;\n  padding: 0.5rem 0 0;\n  position: relative; }\n\n.LeaderboardDropdowns_dropdown--container__2Qlug {\n  width: 100%;\n  color: #00acc1;\n  font-size: 1.25rem;\n  position: relative;\n  cursor: pointer;\n  padding: 0;\n  border: 1px solid #00acc1; }\n\n.LeaderboardDropdowns_dropdown--value-container__3BtH2 {\n  transition: all 0.2s;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  font-size: 0.9rem;\n  padding: 0.7rem 1.5rem 0.7rem 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center; }\n  .LeaderboardDropdowns_dropdown--value-container__3BtH2 .LeaderboardDropdowns_fa-sort__1hbPU {\n    margin-left: 2rem;\n    color: #474f55; }\n  .LeaderboardDropdowns_dropdown--value-container__3BtH2 .LeaderboardDropdowns_fa-sort__1hbPU:hover {\n    color: #00acc1; }\n\n.LeaderboardDropdowns_dropdown--list__38LEk {\n  transform: scale(1);\n  transform-origin: top center;\n  position: absolute;\n  z-index: 20;\n  background: #fff;\n  min-width: 100%;\n  transition: 0.1s;\n  box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 0 0 2px 2px;\n  max-height: 20rem;\n  overflow-y: auto;\n  padding: 0.5rem 0;\n  margin: 0; }\n\n.LeaderboardDropdowns_dropdown--list-item__DuI36 {\n  font-size: 1rem;\n  padding: 0.5rem 1rem;\n  color: #474f55; }\n\n.LeaderboardDropdowns_dropdown--list-item__DuI36:hover {\n  color: #00acc1; }\n\nlabel {\n  padding: 0 1rem;\n  margin: 0; }\n  label i {\n    font-size: 0.75rem; }\n";
styleInject(css_248z$9);

function LeaderboardDropdowns(_ref) {
  var contents = _ref.contents,
      handleClick = _ref.handleClick;

  var _useState = React$2.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      seriesDropdownOpen = _useState2[0],
      setSeriesDropdownOpen = _useState2[1];

  var _useState3 = React$2.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      moduleDropdownOpen = _useState4[0],
      setModuleDropdownOpen = _useState4[1];

  var _useState5 = React$2.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      campaignDropdownOpen = _useState6[0],
      setCampaignDropdownOpen = _useState6[1];

  var toggleSeriesDropdown = function toggleSeriesDropdown() {
    if (seriesDropdownOpen) {
      setSeriesDropdownOpen(function (prevState) {
        return !prevState;
      });
    } else {
      closeAllDropdowns();
      setSeriesDropdownOpen(function (prevState) {
        return !prevState;
      });
    }
  };

  var toggleModuleDropdown = function toggleModuleDropdown() {
    if (moduleDropdownOpen) {
      setModuleDropdownOpen(function (prevState) {
        return !prevState;
      });
    } else {
      closeAllDropdowns();
      setModuleDropdownOpen(function (prevState) {
        return !prevState;
      });
    }
  };

  var toggleCampaignDropdown = function toggleCampaignDropdown() {
    if (campaignDropdownOpen) {
      setCampaignDropdownOpen(function (prevState) {
        return !prevState;
      });
    } else {
      closeAllDropdowns();
      setCampaignDropdownOpen(function (prevState) {
        return !prevState;
      });
    }
  };

  var closeAllDropdowns = function closeAllDropdowns() {
    setSeriesDropdownOpen(false);
    setModuleDropdownOpen(false);
    setCampaignDropdownOpen(false);
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: "view-by-row"
  }, contents.map(function (content, idx) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      key: idx,
      className: "leaderboard-dropdown--container"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      title: "Leaderboard Dropdown",
      className: "dropdown--container"
    }, /*#__PURE__*/React__default['default'].createElement(CurrentValueContainer, {
      toggle: content.contentType === 'SERIES' ? toggleSeriesDropdown : content.contentType === 'MODULES' ? toggleModuleDropdown : toggleCampaignDropdown,
      value: content.defaultValue
    }), content.contentType === 'SERIES' && seriesDropdownOpen || content.contentType === 'MODULES' && moduleDropdownOpen || content.contentType === 'CAMPAIGNS' && campaignDropdownOpen ? /*#__PURE__*/React__default['default'].createElement(DropdownList, {
      items: content.list,
      contentType: content.contentType,
      handleClick: handleClick
    }) : null));
  }));
}

var CurrentValueContainer = function CurrentValueContainer(_ref2) {
  var value = _ref2.value,
      toggle = _ref2.toggle;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    onClick: toggle,
    className: "dropdown--value-container"
  }, value, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fas fa-chevron-down fa-xs"
  }));
};

var DropdownList = function DropdownList(_ref3) {
  var contentType = _ref3.contentType,
      items = _ref3.items,
      handleClick = _ref3.handleClick;
  return /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "dropdown--list"
  }, items.map(function (item) {
    return /*#__PURE__*/React__default['default'].createElement(DropdownListItem, {
      key: item.id,
      item: item,
      contentType: contentType,
      handleClick: handleClick
    });
  }));
};

var DropdownListItem = function DropdownListItem(_ref4) {
  var contentType = _ref4.contentType,
      item = _ref4.item,
      handleClick = _ref4.handleClick;
  return /*#__PURE__*/React__default['default'].createElement("li", {
    key: item.id,
    onClick: function onClick() {
      return item ? handleClick({
        target: {
          name: contentType,
          value: item
        }
      }) : '';
    },
    className: "dropdown--list-item"
  }, item ? contentType === 'SERIES' ? item.gameDefinitionName : contentType === 'MODULES' ? item.name : item.campaign : "No ".concat(contentType === 'CAMPAIGNS' ? 'active' + contentType.toLowerCase() : contentType.toLowerCase(), " available"));
};

LeaderboardDropdowns.propTypes = {
  contents: PropTypes__default['default'].array.isRequired,
  handleClick: PropTypes__default['default'].func.isRequired
};

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 22px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 70px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 23.6px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 8px;\n  height: 15px;\n  width: 15px;\n  background-color: #000;\n  border-radius: 50%;\n  display: inline-block;\n  position: relative;\n  top: 3px;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-content: flex-start;\n  margin-left: 20px;\n  margin-bottom: 8px;\n  padding: 10px;\n  border: 1px solid gray;\n  border-radius: 4px;\n  background: ", ";\n  color: ", ";\n  margin-left: 10px;\n  position: relative;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  color: #000;\n  font-size: 14px;\n  position: relative;\n  left: 40px;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  color: #fff;\n  font-size: 14px;\n  position: relative;\n  left: -40px;\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var Rank = Ye.span(_templateObject$d());
var Icon = Ye.span(_templateObject2$6());
var Item = Ye.div(_templateObject3$3(), function (props) {
  return props.isCurrentPlayer ? '#2D98D4' : '#fafafa';
}, function (props) {
  return props.isCurrentPlayer ? '#fff' : '#000';
});
var Avatar$1 = Ye.span(_templateObject4$1());
var Name = Ye.span(_templateObject5());
var Trophy = Ye.span(_templateObject6());
var Points = Ye.span(_templateObject7());

var trophy1 = "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.72953%207.875C2.26562%207.875%201%206.75%201%204.78125V1.96875H3.53125%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%2F%3E%3Cpath%20d%3D%22M13.6561%201.96875H16.1874V4.78125C16.1874%206.75%2014.9217%207.875%2013.4592%207.875%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%2F%3E%3Cpath%20d%3D%22M8.59375%2014.9062V12.9375%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M8.59375%2011.5312C7.25109%2011.5312%205.96342%2010.9979%205.01402%2010.0485C4.06462%209.09907%203.53125%207.81141%203.53125%206.46875V0.84375H13.6562V6.46875C13.6562%207.81141%2013.1229%209.09907%2012.1735%2010.0485C11.2241%2010.9979%209.93641%2011.5312%208.59375%2011.5312V11.5312Z%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M4.65625%2017.1562C4.65625%2015.9137%205.5%2014.9062%207.46875%2014.9062H9.71875C11.6875%2014.9062%2012.5312%2015.9137%2012.5312%2017.1562H4.65625Z%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M9.33203%209H8.20312V4.64844L6.85547%205.06641V4.14844L9.21094%203.30469H9.33203V9Z%22%20fill%3D%22black%22%2F%3E%3C%2Fsvg%3E";

var trophy2 = "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.72953%207.875C2.26562%207.875%201%206.75%201%204.78125V1.96875H3.53125%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%2F%3E%3Cpath%20d%3D%22M13.6561%201.96875H16.1874V4.78125C16.1874%206.75%2014.9217%207.875%2013.4592%207.875%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%2F%3E%3Cpath%20d%3D%22M8.59375%2014.9062V12.9375%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M8.59375%2011.5312C7.25109%2011.5312%205.96342%2010.9979%205.01402%2010.0485C4.06462%209.09907%203.53125%207.81141%203.53125%206.46875V0.84375H13.6562V6.46875C13.6562%207.81141%2013.1229%209.09907%2012.1735%2010.0485C11.2241%2010.9979%209.93641%2011.5312%208.59375%2011.5312V11.5312Z%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M4.65625%2017.1562C4.65625%2015.9137%205.5%2014.9062%207.46875%2014.9062H9.71875C11.6875%2014.9062%2012.5312%2015.9137%2012.5312%2017.1562H4.65625Z%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M10.4883%209H6.58984V8.22656L8.42969%206.26562C8.68229%205.98958%208.86849%205.7487%208.98828%205.54297C9.11068%205.33724%209.17188%205.14193%209.17188%204.95703C9.17188%204.70443%209.10807%204.50651%208.98047%204.36328C8.85286%204.21745%208.67057%204.14453%208.43359%204.14453C8.17839%204.14453%207.97656%204.23307%207.82812%204.41016C7.68229%204.58464%207.60938%204.8151%207.60938%205.10156H6.47656C6.47656%204.75521%206.55859%204.4388%206.72266%204.15234C6.88932%203.86589%207.1237%203.64193%207.42578%203.48047C7.72786%203.31641%208.07031%203.23438%208.45312%203.23438C9.03906%203.23438%209.49349%203.375%209.81641%203.65625C10.1419%203.9375%2010.3047%204.33464%2010.3047%204.84766C10.3047%205.12891%2010.2318%205.41536%2010.0859%205.70703C9.9401%205.9987%209.6901%206.33854%209.33594%206.72656L8.04297%208.08984H10.4883V9Z%22%20fill%3D%22black%22%2F%3E%3C%2Fsvg%3E";

var trophy3 = "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.72953%207.875C2.26562%207.875%201%206.75%201%204.78125V1.96875H3.53125%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%2F%3E%3Cpath%20d%3D%22M13.6561%201.96875H16.1874V4.78125C16.1874%206.75%2014.9217%207.875%2013.4592%207.875%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%2F%3E%3Cpath%20d%3D%22M8.59375%2014.9062V12.9375%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M8.59375%2011.5312C7.25109%2011.5312%205.96342%2010.9979%205.01402%2010.0485C4.06462%209.09907%203.53125%207.81141%203.53125%206.46875V0.84375H13.6562V6.46875C13.6562%207.81141%2013.1229%209.09907%2012.1735%2010.0485C11.2241%2010.9979%209.93641%2011.5312%208.59375%2011.5312V11.5312Z%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M4.65625%2017.1562C4.65625%2015.9137%205.5%2014.9062%207.46875%2014.9062H9.71875C11.6875%2014.9062%2012.5312%2015.9137%2012.5312%2017.1562H4.65625Z%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M7.73828%205.65625H8.33984C8.6263%205.65625%208.83854%205.58464%208.97656%205.44141C9.11458%205.29818%209.18359%205.10807%209.18359%204.87109C9.18359%204.64193%209.11458%204.46354%208.97656%204.33594C8.84115%204.20833%208.65365%204.14453%208.41406%204.14453C8.19792%204.14453%208.01693%204.20443%207.87109%204.32422C7.72526%204.44141%207.65234%204.59505%207.65234%204.78516H6.52344C6.52344%204.48828%206.60286%204.22266%206.76172%203.98828C6.92318%203.7513%207.14714%203.56641%207.43359%203.43359C7.72266%203.30078%208.04036%203.23438%208.38672%203.23438C8.98828%203.23438%209.45964%203.37891%209.80078%203.66797C10.1419%203.95443%2010.3125%204.35026%2010.3125%204.85547C10.3125%205.11589%2010.2331%205.35547%2010.0742%205.57422C9.91536%205.79297%209.70703%205.96094%209.44922%206.07812C9.76953%206.19271%2010.0078%206.36458%2010.1641%206.59375C10.3229%206.82292%2010.4023%207.09375%2010.4023%207.40625C10.4023%207.91146%2010.2174%208.31641%209.84766%208.62109C9.48047%208.92578%208.99349%209.07812%208.38672%209.07812C7.81901%209.07812%207.35417%208.92839%206.99219%208.62891C6.63281%208.32943%206.45312%207.93359%206.45312%207.44141H7.58203C7.58203%207.65495%207.66146%207.82943%207.82031%207.96484C7.98177%208.10026%208.17969%208.16797%208.41406%208.16797C8.68229%208.16797%208.89193%208.09766%209.04297%207.95703C9.19661%207.8138%209.27344%207.625%209.27344%207.39062C9.27344%206.82292%208.96094%206.53906%208.33594%206.53906H7.73828V5.65625Z%22%20fill%3D%22black%22%2F%3E%3C%2Fsvg%3E";

function Trophy$1(props) {
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, props.rank && props.rank === 1 && /*#__PURE__*/React__default['default'].createElement("img", {
    src: trophy1,
    alt: "trophy 1"
  }), props.rank && props.rank === 2 && /*#__PURE__*/React__default['default'].createElement("img", {
    src: trophy2,
    alt: "trophy 2"
  }), props.rank && props.rank === 3 && /*#__PURE__*/React__default['default'].createElement("img", {
    src: trophy3,
    alt: "trophy 3"
  }));
}

function LeaderboardItem(props) {
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(Item, {
    isCurrentPlayer: props.isCurrentPlayer
  }, /*#__PURE__*/React__default['default'].createElement(Rank, null, props.rank), /*#__PURE__*/React__default['default'].createElement(Avatar$1, null, props.avatar), /*#__PURE__*/React__default['default'].createElement(Name, null, props.name), /*#__PURE__*/React__default['default'].createElement(Points, null, props.rank > 0 && props.rank < props.maxVariableSize && /*#__PURE__*/React__default['default'].createElement(Trophy, null, /*#__PURE__*/React__default['default'].createElement(Trophy$1, {
    rank: props.rank
  })), props.points)));
}
LeaderboardItem.propTypes = {
  id: PropTypes__default['default'].number.isRequired,
  avatar: PropTypes__default['default'].string,
  name: PropTypes__default['default'].string.isRequired,
  points: PropTypes__default['default'].number,
  isCurrentPlayer: PropTypes__default['default'].bool.isRequired
};

var Leaderboard = function Leaderboard(props) {
  return /*#__PURE__*/React__default['default'].createElement(LeaderboardItem, {
    id: props.id,
    rank: props.rank,
    maxVariableSize: 4,
    avatar: props.avatar,
    name: props.name,
    points: props.points,
    isCurrentPlayer: props.isCurrentPlayer
  });
};

Leaderboard.propTypes = {
  id: PropTypes__default['default'].number.isRequired,
  rank: PropTypes__default['default'].number,
  maxVariableSize: PropTypes__default['default'].number.isRequired,
  avatar: PropTypes__default['default'].string,
  name: PropTypes__default['default'].string.isRequired,
  points: PropTypes__default['default'].number,
  isCurrentPlayer: PropTypes__default['default'].bool.isRequired
};

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  height: 45px;\n  padding: 10px 15px;\n  background-color: #2d98d4;\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$7 = Ye.div(_templateObject$e());

var StarCircle = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2211.5%22%20stroke%3D%22%23F28916%22%2F%3E%3Cpath%20d%3D%22M12%206L13.854%209.80906L18%2010.42L15%2013.3848L15.708%2017.5714L12%2015.5948L8.292%2017.5714L9%2013.3848L6%2010.42L10.146%209.80906L12%206Z%22%20stroke%3D%22%23F28916%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3C%2Fsvg%3E";

var Alert = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M16.556%201H7.444L1%207.444V16.556L7.444%2023H16.556L23%2016.556V7.444L16.556%201Z%22%20stroke%3D%22%23F16153%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M12%207V13%22%20stroke%3D%22%23F16153%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22square%22%2F%3E%3Cpath%20d%3D%22M12%2018C12.5523%2018%2013%2017.5523%2013%2017C13%2016.4477%2012.5523%2016%2012%2016C11.4477%2016%2011%2016.4477%2011%2017C11%2017.5523%2011.4477%2018%2012%2018Z%22%20fill%3D%22%23F16153%22%2F%3E%3C%2Fsvg%3E";

var ArrowDown = "data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%225%22%20viewBox%3D%220%200%2010%205%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M5%205L0.669872%200.5L9.33013%200.5L5%205Z%22%20fill%3D%22black%22%2F%3E%3C%2Fsvg%3E";

var Play = "data:image/svg+xml,%3Csvg%20width%3D%2213%22%20height%3D%2216%22%20viewBox%3D%220%200%2013%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M0.5%200.741821L12.5%208.08603L0.5%2015.4302V0.741821Z%22%20stroke%3D%22%23111111%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var CaretDown = "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2210%22%20viewBox%3D%220%200%2016%2010%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M0.666748%200.801147L8.00008%208.63498L15.3334%200.801147%22%20stroke%3D%22%23111111%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-right: 20px;\n  width: 30px;\n  border: none;\n  border-radius: 50%;\n  background-color: #fff;\n  cursor: pointer;\n  &:not(#play) {\n    margin-right: 0;\n  }\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  color: #fff;\n  position: absolute;\n  right: '30px';\n  height: '40px';\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  color: #fff;\n  margin: 0 10px;\n  & p {\n    margin-bottom: 10px;\n    margin-top: 0;\n    line-height: 1.15;\n  }\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: 95px;\n  width: 500px;\n  background-color: #1e3042;\n  padding: 10px;\n  border-radius: 4px;\n  position: relative;\n  margin-bottom: 10px;\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$8 = Ye.div(_templateObject$f());
var AssignmentContent = Ye.div(_templateObject2$7());
var AssignmentButtons = Ye.div(_templateObject3$4());
var IconWrapper = Ye.button(_templateObject4$2());

var formatTime = function formatTime(ms) {
  var seconds = ms / 1000;
  var mins = Math.floor(seconds / 60).toString().padStart(2, '0');
  var secs = (seconds % 60).toString().padStart(2, '0');
  return "".concat(mins, ":").concat(secs);
};
var isPastDue = function isPastDue(dueDate) {
  return hooks().isAfter(dueDate);
};

var AssignmentCard = function AssignmentCard(props) {
  var handleClick = function handleClick() {
    console.log('clicked');
  };

  var type = props.type,
      image = props.image,
      campaignTitle = props.campaignTitle,
      seriesTitle = props.seriesTitle,
      duration = props.duration,
      dueDate = props.dueDate;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Wrapper$8, null, image && /*#__PURE__*/React__default['default'].createElement(Img$1, {
    src: image,
    alt: "",
    size: [95, 95],
    style: {
      borderRadius: '4px'
    }
  }), /*#__PURE__*/React__default['default'].createElement(AssignmentContent, null, campaignTitle && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("p", null, campaignTitle)), seriesTitle && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("p", null, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "past-due",
    style: {
      color: 'red',
      fontWeight: 'bold'
    }
  }, isPastDue(dueDate) && type === 'BONUS' ? 'EXPIRED:' : "PAST DUE:"), ' ', seriesTitle)), duration && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("p", null, duration)), dueDate && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("p", null, "Deadline: ", hooks(dueDate).format('MMM M')))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "assignment-buttons",
    style: {
      display: 'flex',
      color: '#fff',
      position: 'absolute',
      right: '30px',
      height: '40px'
    }
  }, /*#__PURE__*/React__default['default'].createElement(IconWrapper, {
    id: "play",
    onClick: function onClick() {
      return handleClick();
    }
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      position: 'absolute',
      top: '10px',
      left: '13px'
    }
  }, /*#__PURE__*/React__default['default'].createElement(Img$1, {
    src: Play,
    size: [20, 20],
    alt: "play"
  }))), /*#__PURE__*/React__default['default'].createElement(IconWrapper, {
    id: "arrow-down",
    onClick: function onClick() {
      return handleClick();
    }
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      position: 'absolute',
      top: '12px',
      left: '11px'
    }
  }, /*#__PURE__*/React__default['default'].createElement(Img$1, {
    src: CaretDown,
    size: [20, 20],
    alt: "expand"
  }))))));
};

AssignmentCard.propTypes = {
  type: PropTypes__default['default'].oneOf(['REQUIRED', 'BONUS']),
  image: PropTypes__default['default'].string,
  campaignTitle: PropTypes__default['default'].string,
  seriesTitle: PropTypes__default['default'].string,
  duration: PropTypes__default['default'].string,
  dueDate: PropTypes__default['default'].number
};
AssignmentCard.defaultProps = {
  // type: 'REQUIRED',
  image: 'https://via.placeholder.com/95x75',
  campaignTitle: 'Campaign Title 2',
  seriesTitle: 'Series Title 1' // duration: '60 min',
  // dueDate: 1504687352542,

};

var css_248z$a = ".styles_popover__3WsQa.styles_show__5j6t2.styles_bs-popover-auto__332g_ {\n  min-width: 545px;\n  margin-top: 1.5rem; }\n";
styleInject(css_248z$a);

var ButtonDropdown = function ButtonDropdown(props) {
  var assignments = props.assignments;
  var assignmentCount = props.assignments && props.assignments.length;

  var _useState = React$2.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      popoverOpen = _useState2[0],
      setPopoverOpen = _useState2[1];

  var _useState3 = React$2.useState(assignmentCount === 0 ? true : false),
      _useState4 = _slicedToArray(_useState3, 1),
      isDisabled = _useState4[0];

  var toggle = function toggle() {
    return setPopoverOpen(!popoverOpen);
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Button$1, {
    id: props._id,
    type: "button",
    style: {
      background: '#FFF',
      padding: '5px 10px',
      border: '1px solid #FAFAFA',
      borderRadius: '8px',
      marginRight: '15px',
      color: '#000'
    },
    disabled: isDisabled
  }, props.title && props.title === 'Required Assignments' && /*#__PURE__*/React__default['default'].createElement(Img$1, {
    src: Alert,
    size: [30, 30],
    title: props.title,
    style: {
      position: 'relative',
      top: '-2px'
    }
  }), props.title && props.title === 'Bonus Assignments' && /*#__PURE__*/React__default['default'].createElement(Img$1, {
    src: StarCircle,
    size: [30, 30],
    title: props.title,
    style: {
      position: 'relative',
      top: '-2px'
    }
  }), props.title && /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      marginLeft: '8px'
    }
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      fontWeight: '600',
      fontSize: '20px'
    }
  }, assignmentCount), " ", props.title, " \xA0\xA0", /*#__PURE__*/React__default['default'].createElement(Img$1, {
    src: ArrowDown,
    size: [15, 15]
  }))), /*#__PURE__*/React__default['default'].createElement(Popover, {
    placement: "bottom",
    isOpen: popoverOpen,
    target: props._id,
    toggle: isDisabled ? function () {} : toggle,
    trigger: "legacy",
    style: {
      minWidth: '520px'
    }
  }, /*#__PURE__*/React__default['default'].createElement(PopoverBody, {
    style: {
      padding: '0.5rem 0.75rem 0',
      minWidth: '520px'
    }
  }, assignments && assignments.map(function (assignment) {
    return /*#__PURE__*/React__default['default'].createElement(AssignmentCard, {
      key: assignment.id,
      type: assignment.type,
      image: assignment.image,
      campaignTitle: assignment.campaignTitle,
      seriesTitle: assignment.seriesTitle,
      duration: assignment.duration,
      dueDate: assignment.dueDate
    });
  }))));
};

ButtonDropdown.propTypes = {
  assignments: PropTypes__default['default'].array.isRequired,
  title: PropTypes__default['default'].string
};

var AssignmentsBanner = function AssignmentsBanner(props) {
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Row, null, /*#__PURE__*/React__default['default'].createElement(Col, null, /*#__PURE__*/React__default['default'].createElement(Wrapper$7, null, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(ButtonDropdown, {
    _id: 'Required',
    title: 'Required Assignments',
    assignments: props.required,
    header: 'Continue where you left off'
  }), /*#__PURE__*/React__default['default'].createElement(ButtonDropdown, {
    _id: 'Bonus',
    title: 'Bonus Assignments',
    assignments: props.bonus,
    header: 'Get started!'
  }))))));
};

AssignmentsBanner.propTypes = {
  required: PropTypes__default['default'].array.isRequired,
  bonus: PropTypes__default['default'].array.isRequired
};

function Logo(props) {
  var width = props.width,
      theme = props.theme;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ls-logo"
  }, /*#__PURE__*/React__default['default'].createElement("img", {
    src: theme === 'light' ? 'https://design-livingsecurity.s3.amazonaws.com/images/LogoDark.png' : theme === 'blur' ? 'https://design-livingsecurity.s3.amazonaws.com/images/LogoBlur.png' : 'https://design-livingsecurity.s3.amazonaws.com/images/LogoLight.png',
    width: width,
    alt: "Living Security Logo"
  }));
}
Logo.propTypes = {
  theme: PropTypes__default['default'].oneOf(['light', 'dark', 'blur']),
  width: PropTypes__default['default'].number
};
Logo.defaultProps = {
  theme: 'light',
  width: 175
};

var css_248z$b = "@keyframes Navbar_fadein__1XAIa {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes Navbar_fadein__1XAIa {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes Navbar_fadein__1XAIa {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes Navbar_fadein__1XAIa {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes Navbar_fadein__1XAIa {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.Navbar_ls-navbar__3Q8e4 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 60px;\n  margin: 0;\n  z-index: 999;\n  border-bottom: 1px solid #dee2e6;\n  font: 14px \"Gotham\", sans-serif;\n  line-height: normal;\n  font-weight: 400;\n  -moz-box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);\n  -webkit-box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n  .Navbar_ls-navbar__3Q8e4.Navbar_light__17ZX2 {\n    background: #ffffff;\n    color: #212126; }\n  .Navbar_ls-navbar__3Q8e4.Navbar_dark__3xHMe {\n    background: #212126;\n    color: #ffffff; }\n  .Navbar_ls-navbar__3Q8e4.Navbar_blur__yAeED {\n    background-color: rgba(77, 188, 222, 0.7);\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n    color: #ffffff; }\n  .Navbar_ls-navbar__3Q8e4.Navbar_clear__2LIXP {\n    color: #ffffff; }\n  .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-logo__2cjlA {\n    display: flex;\n    align-items: center;\n    height: 100%; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-logo__2cjlA.Navbar_align-left__2bZWl {\n      justify-content: flex-start;\n      margin-left: 20px; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-logo__2cjlA.Navbar_align-center__3oZAA {\n      justify-content: center; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-logo__2cjlA.Navbar_align-right__v9Azh {\n      justify-content: flex-end;\n      margin-right: 20px; }\n  .Navbar_ls-navbar__3Q8e4 .Navbar_full-menu__1V9AV {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 60px;\n    margin: 0; }\n  .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu-btn__3Ywno {\n    position: absolute;\n    display: inline-block;\n    top: 24px;\n    cursor: pointer;\n    z-index: 999; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu-btn__3Ywno.Navbar_align-left__2bZWl, .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu-btn__3Ywno.Navbar_align-center__3oZAA {\n      right: 0;\n      margin-right: 25px; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu-btn__3Ywno.Navbar_align-right__v9Azh {\n      left: 0;\n      margin-left: 25px; }\n  .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu___uroI {\n    position: absolute;\n    top: 62px;\n    padding: 10px;\n    min-width: 150px;\n    height: auto;\n    z-index: 999;\n    -moz-box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);\n    -webkit-box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);\n    box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1); }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu___uroI.Navbar_align-left__2bZWl, .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu___uroI.Navbar_align-center__3oZAA {\n      right: 0; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu___uroI.Navbar_align-right__v9Azh {\n      left: 0; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu___uroI.Navbar_light__17ZX2 {\n      background: #ffffff;\n      color: #212126; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu___uroI.Navbar_dark__3xHMe {\n      background: #212126;\n      color: #ffffff; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu___uroI.Navbar_blur__yAeED {\n      background-color: rgba(77, 188, 222, 0.7);\n      -webkit-backdrop-filter: blur(10px);\n      backdrop-filter: blur(10px);\n      color: #ffffff; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_mobile-menu___uroI.Navbar_clear__2LIXP {\n      color: #ffffff; }\n  .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 100%; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ.Navbar_align-left__2bZWl {\n      justify-content: flex-start;\n      margin-left: 10px; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ.Navbar_align-center__3oZAA {\n      justify-content: center; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ.Navbar_align-right__v9Azh {\n      justify-content: flex-end;\n      margin-right: 10px; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ .Navbar_nav-item__REXIv {\n      display: inline-block;\n      margin: 0 -20px;\n      font-size: 15px;\n      line-height: 17px;\n      cursor: pointer;\n      -webkit-touch-callout: none;\n      -webkit-user-select: none;\n      -khtml-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none; }\n      .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ .Navbar_nav-item__REXIv a,\n      .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ .Navbar_nav-item__REXIv div {\n        position: relative;\n        display: flex;\n        -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n        justify-content: space-between;\n        -webkit-box-align: center;\n        padding: 21px 2.375rem; }\n      .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ .Navbar_nav-item__REXIv a:after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 50%;\n        -webkit-transform: translate(-50%);\n        transform: translate(-50%);\n        height: 4px;\n        width: 0;\n        background: #f16153;\n        -webkit-transition-duration: 0.3s;\n        transition-duration: 0.3s; }\n      .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ .Navbar_nav-item__REXIv a:hover:after {\n        width: calc(100% - 66px); }\n      .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ .Navbar_nav-item__REXIv a.Navbar_active__CMp9a:after {\n        width: calc(100% - 66px); }\n\n@media only screen and (min-width: 1000px) {\n  .Navbar_mobile-menu-btn__3Ywno {\n    display: none !important; }\n  .Navbar_mobile-menu___uroI {\n    display: none !important; } }\n\n@media only screen and (max-width: 1000px) {\n  .Navbar_mobile-menu-btn__3Ywno {\n    display: inline-block; }\n  .Navbar_full-menu__1V9AV {\n    display: none !important; }\n  .Navbar_mobile-menu___uroI {\n    display: block;\n    overflow-y: auto; }\n  .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    height: auto; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ.Navbar_align-left__2bZWl {\n      margin-left: 0; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ.Navbar_align-right__v9Azh {\n      margin-right: 0; }\n    .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ .Navbar_nav-item__REXIv {\n      display: block !important; }\n      .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ .Navbar_nav-item__REXIv a,\n      .Navbar_ls-navbar__3Q8e4 .Navbar_navbar-nav__2RlTJ .Navbar_nav-item__REXIv div {\n        position: relative;\n        display: flex;\n        -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n        justify-content: space-between;\n        -webkit-box-align: center;\n        padding: 22px 2.375rem; } }\n";
styleInject(css_248z$b);

var Navbar = /*#__PURE__*/function (_React$Component) {
  _inherits(Navbar, _React$Component);

  var _super = _createSuper(Navbar);

  function Navbar(props) {
    var _this;

    _classCallCheck(this, Navbar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "updateWindowSize", function () {
      _this.setState({
        width: window.innerWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleMobileMenu", function () {
      _this.setState({
        showMobileMenu: !_this.state.showMobileMenu
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenu", function (showMobileMenu, theme, classes, children) {
      return showMobileMenu ? /*#__PURE__*/React__default['default'].createElement("div", {
        className: "mobile-menu ".concat(classes.logoClass, " ").concat(theme)
      }, _this.renderMenuItems(classes, children)) : /*#__PURE__*/React__default['default'].createElement("div", {
        className: "full-menu"
      }, _this.renderMenuItems(classes, children));
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenuItems", function (classes, children) {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "navbar-nav ".concat(classes.navClass)
      }, children.length && children.map(function (child, key) {
        return /*#__PURE__*/React__default['default'].createElement("div", {
          key: key,
          className: "nav-item"
        }, child);
      }) || /*#__PURE__*/React__default['default'].createElement("div", {
        className: "nav-item"
      }, children));
    });

    _this.state = {
      showMobileMenu: false,
      width: window.innerWidth
    };
    return _this;
  }

  _createClass(Navbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowSize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowSize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var minWidth = this.props.minWidth;

      if (prevState.width < minWidth && this.state.width > minWidth) {
        this.setState({
          showMobileMenu: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          logo = _this$props.logo,
          theme = _this$props.theme,
          children = _this$props.children;
      var showMobileMenu = this.state.showMobileMenu;
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ls-navbar ".concat(theme, " ").concat(classes.mainClass)
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "navbar-logo ".concat(classes.logoClass)
      }, logo || /*#__PURE__*/React__default['default'].createElement(Logo, {
        theme: theme
      })), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "mobile-menu-btn ".concat(classes.logoClass, " ").concat(theme),
        onClick: this.handleToggleMobileMenu
      }, /*#__PURE__*/React__default['default'].createElement("i", {
        className: "far fa-bars"
      })), this.renderMenu(showMobileMenu, theme, classes, children));
    }
  }]);

  return Navbar;
}(React__default['default'].Component);
Navbar.propTypes = {
  classes: PropTypes__default['default'].shape({
    mainClass: PropTypes__default['default'].string,
    logoClass: PropTypes__default['default'].string,
    navClass: PropTypes__default['default'].string,
    activeClass: PropTypes__default['default'].bool
  }),
  logo: PropTypes__default['default'].object,
  theme: PropTypes__default['default'].oneOf(['light', 'dark', 'blur']),
  minWidth: PropTypes__default['default'].number,
  children: PropTypes__default['default'].any
};
Navbar.defaultProps = {
  classes: {
    logoClass: 'align-left',
    navClass: 'align-right'
  },
  theme: 'light',
  minWidth: 750,
  children: []
};

var _const = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SORT_ASC: 'asc',
  SORT_DESC: 'desc',
  ROW_SELECT_SINGLE: 'radio',
  ROW_SELECT_MULTIPLE: 'checkbox',
  ROW_SELECT_DISABLED: 'ROW_SELECT_DISABLED',
  CHECKBOX_STATUS_CHECKED: 'checked',
  CHECKBOX_STATUS_INDETERMINATE: 'indeterminate',
  CHECKBOX_STATUS_UNCHECKED: 'unchecked',
  INDICATOR_POSITION_LEFT: 'left',
  INDICATOR_POSITION_RIGHT: 'right',
  TYPE_STRING: 'string',
  TYPE_NUMBER: 'number',
  TYPE_BOOLEAN: 'bool',
  TYPE_DATE: 'date',
  FILTERS_POSITION_INLINE: 'inline',
  FILTERS_POSITION_TOP: 'top',
  FILTERS_POSITION_BOTTOM: 'bottom'
};
});

unwrapExports(_const);

var bootstrap = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BootstrapContext = undefined;



var _react2 = _interopRequireDefault(React__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BootstrapContext = exports.BootstrapContext = _react2.default.createContext({
  bootstrap4: false
});
});

unwrapExports(bootstrap);
var bootstrap_1 = bootstrap.BootstrapContext;

var symbol = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortSymbol = function SortSymbol() {
  return _react2.default.createElement(
    bootstrap.BootstrapContext.Consumer,
    null,
    function (_ref) {
      var bootstrap4 = _ref.bootstrap4;
      return bootstrap4 ? _react2.default.createElement('span', { className: 'order-4' }) : _react2.default.createElement(
        'span',
        { className: 'order' },
        _react2.default.createElement(
          'span',
          { className: 'dropdown' },
          _react2.default.createElement('span', { className: 'caret' })
        ),
        _react2.default.createElement(
          'span',
          { className: 'dropup' },
          _react2.default.createElement('span', { className: 'caret' })
        )
      );
    }
  );
};

exports.default = SortSymbol;
});

unwrapExports(symbol);

var caret = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _classnames2 = _interopRequireDefault(classnames);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _const2 = _interopRequireDefault(_const);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortCaret = function SortCaret(_ref) {
  var order = _ref.order;

  var orderClass = (0, _classnames2.default)('react-bootstrap-table-sort-order', {
    dropup: order === _const2.default.SORT_ASC
  });

  return _react2.default.createElement(
    bootstrap.BootstrapContext.Consumer,
    null,
    function (_ref2) {
      var bootstrap4 = _ref2.bootstrap4;
      return bootstrap4 ? _react2.default.createElement('span', { className: 'caret-4-' + order }) : _react2.default.createElement(
        'span',
        { className: orderClass },
        _react2.default.createElement('span', { className: 'caret' })
      );
    }
  );
};

SortCaret.propTypes = {
  order: _propTypes2.default.oneOf([_const2.default.SORT_ASC, _const2.default.SORT_DESC]).isRequired
};

exports.default = SortCaret;
});

unwrapExports(caret);

var underscore = createCommonjsModule(function (module, exports) {
//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof commonjsGlobal == 'object' && commonjsGlobal.global === commonjsGlobal && commonjsGlobal ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if ( !exports.nodeType) {
    if ( !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  };

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };
}());
});
var underscore_1 = underscore._;

var utils$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _underscore2 = _interopRequireDefault(underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function splitNested(str) {
  return [str].join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
} /* eslint no-empty: 0 */
/* eslint no-param-reassign: 0 */
/* eslint prefer-rest-params: 0 */


function get(target, field) {
  var pathArray = splitNested(field);
  var result = void 0;
  try {
    result = pathArray.reduce(function (curr, path) {
      return curr[path];
    }, target);
  } catch (e) {}
  return result;
}

function set(target, field, value) {
  var safe = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var pathArray = splitNested(field);
  var level = 0;
  pathArray.reduce(function (a, b) {
    level += 1;
    if (typeof a[b] === 'undefined') {
      if (!safe) throw new Error(a + '.' + b + ' is undefined');
      a[b] = {};
      return a[b];
    }

    if (level === pathArray.length) {
      a[b] = value;
      return value;
    }
    return a[b];
  }, target);
}

function isEmptyObject(obj) {
  if (!_underscore2.default.isObject(obj)) return false;

  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var keys = Object.keys(obj);

  for (var i = 0; i < keys.length; i += 1) {
    if (hasOwnProperty.call(obj, keys[i])) return false;
  }

  return true;
}

function isDefined(value) {
  return typeof value !== 'undefined' && value !== null;
}

function sleep(fn, ms) {
  return setTimeout(function () {
    return fn();
  }, ms);
}

function debounce(func, wait, immediate) {
  var _this = this,
      _arguments = arguments;

  var timeout = void 0;

  return function () {
    var later = function later() {
      timeout = null;

      if (!immediate) {
        func.apply(_this, _arguments);
      }
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait || 0);

    if (callNow) {
      func.apply(_this, _arguments);
    }
  };
}

exports.default = Object.assign(_underscore2.default, { get: get, set: set, isDefined: isDefined, isEmptyObject: isEmptyObject, sleep: sleep, debounce: debounce });
});

unwrapExports(utils$1);

var cellEventDelegater = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _utils2 = _interopRequireDefault(utils$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = ['onClick', 'onDoubleClick', 'onMouseEnter', 'onMouseLeave', 'onContextMenu'];

exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(CellEventDelegater, _ExtendBase);

    function CellEventDelegater(props) {
      _classCallCheck(this, CellEventDelegater);

      var _this = _possibleConstructorReturn(this, (CellEventDelegater.__proto__ || Object.getPrototypeOf(CellEventDelegater)).call(this, props));

      _this.createDefaultEventHandler = _this.createDefaultEventHandler.bind(_this);
      return _this;
    }

    _createClass(CellEventDelegater, [{
      key: 'createDefaultEventHandler',
      value: function createDefaultEventHandler(cb) {
        var _this2 = this;

        return function (e) {
          var _props = _this2.props,
              column = _props.column,
              columnIndex = _props.columnIndex,
              index = _props.index;

          cb(e, column, typeof columnIndex !== 'undefined' ? columnIndex : index);
        };
      }
    }, {
      key: 'delegate',
      value: function delegate() {
        var _this3 = this;

        var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var newAttrs = _extends({}, attrs);
        Object.keys(attrs).forEach(function (attr) {
          if (_utils2.default.contains(events, attr)) {
            newAttrs[attr] = _this3.createDefaultEventHandler(attrs[attr]);
          }
        });
        return newAttrs;
      }
    }]);

    return CellEventDelegater;
  }(ExtendBase);
};
});

unwrapExports(cellEventDelegater);

var headerCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _classnames2 = _interopRequireDefault(classnames);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _const2 = _interopRequireDefault(_const);



var _symbol2 = _interopRequireDefault(symbol);



var _caret2 = _interopRequireDefault(caret);



var _utils2 = _interopRequireDefault(utils$1);



var _cellEventDelegater2 = _interopRequireDefault(cellEventDelegater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */


var HeaderCell = function (_eventDelegater) {
  _inherits(HeaderCell, _eventDelegater);

  function HeaderCell() {
    _classCallCheck(this, HeaderCell);

    return _possibleConstructorReturn(this, (HeaderCell.__proto__ || Object.getPrototypeOf(HeaderCell)).apply(this, arguments));
  }

  _createClass(HeaderCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          column = _props.column,
          index = _props.index,
          onSort = _props.onSort,
          sorting = _props.sorting,
          sortOrder = _props.sortOrder,
          isLastSorting = _props.isLastSorting,
          onFilter = _props.onFilter,
          currFilters = _props.currFilters,
          filterPosition = _props.filterPosition,
          onExternalFilter = _props.onExternalFilter,
          globalSortCaret = _props.globalSortCaret;
      var text = column.text,
          sort = column.sort,
          sortCaret = column.sortCaret,
          filter = column.filter,
          filterRenderer = column.filterRenderer,
          headerTitle = column.headerTitle,
          headerAlign = column.headerAlign,
          headerFormatter = column.headerFormatter,
          headerEvents = column.headerEvents,
          headerClasses = column.headerClasses,
          headerStyle = column.headerStyle,
          headerAttrs = column.headerAttrs,
          headerSortingClasses = column.headerSortingClasses,
          headerSortingStyle = column.headerSortingStyle;


      var sortCaretfunc = sortCaret || globalSortCaret;

      var delegateEvents = this.delegate(headerEvents);

      var customAttrs = _utils2.default.isFunction(headerAttrs) ? headerAttrs(column, index) : headerAttrs || {};

      var cellAttrs = _extends({}, customAttrs, delegateEvents, {
        tabIndex: _utils2.default.isDefined(customAttrs.tabIndex) ? customAttrs.tabIndex : 0
      });

      var sortSymbol = void 0;
      var filterElm = void 0;
      var cellStyle = {};
      var cellClasses = _utils2.default.isFunction(headerClasses) ? headerClasses(column, index) : headerClasses;

      if (headerStyle) {
        cellStyle = _utils2.default.isFunction(headerStyle) ? headerStyle(column, index) : headerStyle;
        cellStyle = cellStyle ? _extends({}, cellStyle) : cellStyle;
      }

      if (headerTitle) {
        cellAttrs.title = _utils2.default.isFunction(headerTitle) ? headerTitle(column, index) : text;
      }

      if (headerAlign) {
        cellStyle.textAlign = _utils2.default.isFunction(headerAlign) ? headerAlign(column, index) : headerAlign;
      }

      if (sort) {
        var customClick = cellAttrs.onClick;
        cellAttrs['aria-label'] = sorting ? text + ' sort ' + sortOrder : text + ' sortable';
        cellAttrs.onKeyUp = function (e) {
          if (e.key === 'Enter') {
            onSort(column);
            if (_utils2.default.isFunction(customClick)) customClick(e);
          }
        };
        cellAttrs.onClick = function (e) {
          onSort(column);
          if (_utils2.default.isFunction(customClick)) customClick(e);
        };
        cellAttrs.className = (0, _classnames2.default)(cellAttrs.className, 'sortable');

        if (sorting) {
          sortSymbol = sortCaretfunc ? sortCaretfunc(sortOrder, column) : _react2.default.createElement(_caret2.default, { order: sortOrder });

          // append customized classes or style if table was sorting based on the current column.
          cellClasses = (0, _classnames2.default)(cellClasses, _utils2.default.isFunction(headerSortingClasses) ? headerSortingClasses(column, sortOrder, isLastSorting, index) : headerSortingClasses);

          cellStyle = _extends({}, cellStyle, _utils2.default.isFunction(headerSortingStyle) ? headerSortingStyle(column, sortOrder, isLastSorting, index) : headerSortingStyle);
        } else {
          sortSymbol = sortCaretfunc ? sortCaretfunc(undefined, column) : _react2.default.createElement(_symbol2.default, null);
        }
      }

      if (cellClasses) cellAttrs.className = (0, _classnames2.default)(cellAttrs.className, cellClasses);
      if (!_utils2.default.isEmptyObject(cellStyle)) cellAttrs.style = cellStyle;

      if (filterPosition === _const2.default.FILTERS_POSITION_INLINE) {
        if (filterRenderer) {
          var onCustomFilter = onExternalFilter(column, filter.props.type);
          filterElm = filterRenderer(onCustomFilter, column);
        } else if (filter) {
          filterElm = _react2.default.createElement(filter.Filter, _extends({}, filter.props, {
            filterState: currFilters[column.dataField],
            onFilter: onFilter,
            column: column
          }));
        }
      }

      var children = headerFormatter ? headerFormatter(column, index, { sortElement: sortSymbol, filterElement: filterElm }) : text;

      if (headerFormatter) {
        return _react2.default.createElement('th', cellAttrs, children);
      }

      return _react2.default.createElement('th', cellAttrs, children, sortSymbol, filterElm);
    }
  }]);

  return HeaderCell;
}((0, _cellEventDelegater2.default)(_react2.default.Component));

HeaderCell.propTypes = {
  column: _propTypes2.default.shape({
    dataField: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.oneOf([_const2.default.TYPE_STRING, _const2.default.TYPE_NUMBER, _const2.default.TYPE_BOOLEAN, _const2.default.TYPE_DATE]),
    isDummyField: _propTypes2.default.bool,
    hidden: _propTypes2.default.bool,
    headerFormatter: _propTypes2.default.func,
    formatter: _propTypes2.default.func,
    formatExtraData: _propTypes2.default.any,
    headerClasses: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    classes: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    headerStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    headerTitle: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    title: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    headerEvents: _propTypes2.default.object,
    events: _propTypes2.default.object,
    headerAlign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    align: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    headerAttrs: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    attrs: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    sort: _propTypes2.default.bool,
    sortFunc: _propTypes2.default.func,
    onSort: _propTypes2.default.func,
    editor: _propTypes2.default.object,
    editable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    editCellStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    editCellClasses: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    editorStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    editorClasses: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    editorRenderer: _propTypes2.default.func,
    validator: _propTypes2.default.func,
    filter: _propTypes2.default.object,
    filterRenderer: _propTypes2.default.func,
    filterValue: _propTypes2.default.func,
    searchable: _propTypes2.default.bool
  }).isRequired,
  index: _propTypes2.default.number.isRequired,
  onSort: _propTypes2.default.func,
  sorting: _propTypes2.default.bool,
  sortOrder: _propTypes2.default.oneOf([_const2.default.SORT_ASC, _const2.default.SORT_DESC]),
  sortCaret: _propTypes2.default.func,
  isLastSorting: _propTypes2.default.bool,
  onFilter: _propTypes2.default.func,
  filterPosition: _propTypes2.default.oneOf([_const2.default.FILTERS_POSITION_INLINE, _const2.default.FILTERS_POSITION_BOTTOM, _const2.default.FILTERS_POSITION_TOP]),
  currFilters: _propTypes2.default.object,
  onExternalFilter: _propTypes2.default.func
};

exports.default = HeaderCell;
});

unwrapExports(headerCell);

var selectionHeaderCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBox = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _const2 = _interopRequireDefault(_const);





var _utils2 = _interopRequireDefault(utils$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */


var CheckBox = exports.CheckBox = function CheckBox(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      indeterminate = _ref.indeterminate;
  return _react2.default.createElement('input', {
    type: 'checkbox',
    checked: checked,
    className: className,
    ref: function ref(input) {
      if (input) input.indeterminate = indeterminate; // eslint-disable-line no-param-reassign
    },
    onChange: function onChange() {}
  });
};

CheckBox.propTypes = {
  checked: _propTypes2.default.bool.isRequired,
  indeterminate: _propTypes2.default.bool.isRequired,
  className: _propTypes2.default.string
};

var SelectionHeaderCell = function (_Component) {
  _inherits(SelectionHeaderCell, _Component);

  function SelectionHeaderCell() {
    _classCallCheck(this, SelectionHeaderCell);

    var _this = _possibleConstructorReturn(this, (SelectionHeaderCell.__proto__ || Object.getPrototypeOf(SelectionHeaderCell)).call(this));

    _this.handleCheckBoxClick = _this.handleCheckBoxClick.bind(_this);
    return _this;
  }

  /**
   * avoid updating if button is
   * 1. radio
   * 2. status was not changed.
   */


  _createClass(SelectionHeaderCell, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var ROW_SELECT_SINGLE = _const2.default.ROW_SELECT_SINGLE;
      var _props = this.props,
          mode = _props.mode,
          checkedStatus = _props.checkedStatus;


      if (mode === ROW_SELECT_SINGLE) return false;

      return nextProps.checkedStatus !== checkedStatus;
    }
  }, {
    key: 'handleCheckBoxClick',
    value: function handleCheckBoxClick(e) {
      var _props2 = this.props,
          onAllRowsSelect = _props2.onAllRowsSelect,
          checkedStatus = _props2.checkedStatus;

      var isUnSelect = checkedStatus === _const2.default.CHECKBOX_STATUS_CHECKED || checkedStatus === _const2.default.CHECKBOX_STATUS_INDETERMINATE;

      onAllRowsSelect(e, isUnSelect);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var CHECKBOX_STATUS_CHECKED = _const2.default.CHECKBOX_STATUS_CHECKED,
          CHECKBOX_STATUS_INDETERMINATE = _const2.default.CHECKBOX_STATUS_INDETERMINATE,
          ROW_SELECT_MULTIPLE = _const2.default.ROW_SELECT_MULTIPLE;
      var _props3 = this.props,
          mode = _props3.mode,
          checkedStatus = _props3.checkedStatus,
          selectionHeaderRenderer = _props3.selectionHeaderRenderer,
          hideSelectAll = _props3.hideSelectAll,
          headerColumnStyle = _props3.headerColumnStyle;

      if (hideSelectAll) {
        return _react2.default.createElement('th', { 'data-row-selection': true });
      }

      var checked = checkedStatus === CHECKBOX_STATUS_CHECKED;

      var indeterminate = checkedStatus === CHECKBOX_STATUS_INDETERMINATE;

      var attrs = {};
      var content = void 0;
      if (selectionHeaderRenderer || mode === ROW_SELECT_MULTIPLE) {
        attrs.onClick = this.handleCheckBoxClick;
      }

      attrs.style = _utils2.default.isFunction(headerColumnStyle) ? headerColumnStyle(checkedStatus) : headerColumnStyle;

      return _react2.default.createElement(
        bootstrap.BootstrapContext.Consumer,
        null,
        function (_ref2) {
          var bootstrap4 = _ref2.bootstrap4;

          if (selectionHeaderRenderer) {
            content = selectionHeaderRenderer({
              mode: mode,
              checked: checked,
              indeterminate: indeterminate
            });
          } else if (mode === ROW_SELECT_MULTIPLE) {
            content = _react2.default.createElement(CheckBox, _extends({}, _this2.props, {
              checked: checked,
              className: bootstrap4 ? 'selection-input-4' : '',
              indeterminate: indeterminate
            }));
          }
          return _react2.default.createElement(
            'th',
            _extends({ className: 'selection-cell-header', 'data-row-selection': true }, attrs),
            content
          );
        }
      );
    }
  }]);

  return SelectionHeaderCell;
}(React__default['default'].Component);

SelectionHeaderCell.propTypes = {
  mode: _propTypes2.default.string.isRequired,
  checkedStatus: _propTypes2.default.string,
  onAllRowsSelect: _propTypes2.default.func,
  hideSelectAll: _propTypes2.default.bool,
  selectionHeaderRenderer: _propTypes2.default.func,
  headerColumnStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
};
exports.default = SelectionHeaderCell;
});

unwrapExports(selectionHeaderCell);
var selectionHeaderCell_1 = selectionHeaderCell.CheckBox;

var expandHeaderCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */
/* eslint no-nested-ternary: 0 */


var ExpansionHeaderCell = function (_Component) {
  _inherits(ExpansionHeaderCell, _Component);

  function ExpansionHeaderCell() {
    _classCallCheck(this, ExpansionHeaderCell);

    var _this = _possibleConstructorReturn(this, (ExpansionHeaderCell.__proto__ || Object.getPrototypeOf(ExpansionHeaderCell)).call(this));

    _this.handleCheckBoxClick = _this.handleCheckBoxClick.bind(_this);
    return _this;
  }

  _createClass(ExpansionHeaderCell, [{
    key: 'handleCheckBoxClick',
    value: function handleCheckBoxClick(e) {
      var _props = this.props,
          isAnyExpands = _props.isAnyExpands,
          onAllRowExpand = _props.onAllRowExpand;


      onAllRowExpand(e, !isAnyExpands);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isAnyExpands = _props2.isAnyExpands,
          expandHeaderColumnRenderer = _props2.expandHeaderColumnRenderer;

      var attrs = {
        onClick: this.handleCheckBoxClick
      };

      return _react2.default.createElement(
        'th',
        _extends({ className: 'expand-cell-header', 'data-row-selection': true }, attrs),
        expandHeaderColumnRenderer ? expandHeaderColumnRenderer({ isAnyExpands: isAnyExpands }) : isAnyExpands ? '(-)' : '(+)'
      );
    }
  }]);

  return ExpansionHeaderCell;
}(React__default['default'].Component);

ExpansionHeaderCell.propTypes = {
  isAnyExpands: _propTypes2.default.bool.isRequired,
  onAllRowExpand: _propTypes2.default.func.isRequired,
  expandHeaderColumnRenderer: _propTypes2.default.func
};
exports.default = ExpansionHeaderCell;
});

unwrapExports(expandHeaderCell);

var rows = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRowByRowId = exports.matchRow = undefined;



var _utils2 = _interopRequireDefault(utils$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchRow = exports.matchRow = function matchRow(keyField, id) {
  return function (row) {
    return _utils2.default.get(row, keyField) === id;
  };
};

var getRowByRowId = exports.getRowByRowId = function getRowByRowId(data, keyField, id) {
  return data.find(matchRow(keyField, id));
};
});

unwrapExports(rows);
var rows_1 = rows.getRowByRowId;
var rows_2 = rows.matchRow;

var selection = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedRows = exports.unSelectableKeys = exports.selectableKeys = exports.getSelectionSummary = undefined;



var _utils2 = _interopRequireDefault(utils$1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSelectionSummary = exports.getSelectionSummary = function getSelectionSummary() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyField = arguments[1];
  var selected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var allRowsSelected = data.length > 0;
  var allRowsNotSelected = true;

  var rowKeys = data.map(function (d) {
    return _utils2.default.get(d, keyField);
  });

  var _loop = function _loop(i) {
    var curr = rowKeys[i];
    if (typeof selected.find(function (x) {
      return x === curr;
    }) === 'undefined') {
      allRowsSelected = false;
    } else {
      allRowsNotSelected = false;
    }
  };

  for (var i = 0; i < rowKeys.length; i += 1) {
    _loop(i);
  }
  return {
    allRowsSelected: allRowsSelected,
    allRowsNotSelected: allRowsNotSelected
  };
};

var selectableKeys = exports.selectableKeys = function selectableKeys() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyField = arguments[1];
  var skips = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (skips.length === 0) {
    return data.map(function (row) {
      return _utils2.default.get(row, keyField);
    });
  }
  return data.filter(function (row) {
    return !_utils2.default.contains(skips, _utils2.default.get(row, keyField));
  }).map(function (row) {
    return _utils2.default.get(row, keyField);
  });
};

var unSelectableKeys = exports.unSelectableKeys = function unSelectableKeys(selected) {
  var skips = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skips.length === 0) {
    return [];
  }
  return selected.filter(function (x) {
    return _utils2.default.contains(skips, x);
  });
};

var getSelectedRows = exports.getSelectedRows = function getSelectedRows() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyField = arguments[1];
  var selected = arguments[2];
  return selected.map(function (k) {
    return (0, rows.getRowByRowId)(data, keyField, k);
  }).filter(function (x) {
    return !!x;
  });
};
});

unwrapExports(selection);
var selection_1 = selection.getSelectedRows;
var selection_2 = selection.unSelectableKeys;
var selection_3 = selection.selectableKeys;
var selection_4 = selection.getSelectionSummary;

var expand = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExpandedRows = exports.expandableKeys = exports.isAnyExpands = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var _utils2 = _interopRequireDefault(utils$1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAnyExpands = exports.isAnyExpands = function isAnyExpands(data, keyField) {
  var expanded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var _loop = function _loop(i) {
    var rowKey = _utils2.default.get(data[i], keyField);
    if (typeof expanded.find(function (x) {
      return x === rowKey;
    }) !== 'undefined') {
      return {
        v: true
      };
    }
  };

  for (var i = 0; i < data.length; i += 1) {
    var _ret = _loop(i);

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
  return false;
};

var expandableKeys = exports.expandableKeys = function expandableKeys(data, keyField) {
  var skips = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (skips.length === 0) {
    return data.map(function (row) {
      return _utils2.default.get(row, keyField);
    });
  }
  return data.filter(function (row) {
    return !_utils2.default.contains(skips, _utils2.default.get(row, keyField));
  }).map(function (row) {
    return _utils2.default.get(row, keyField);
  });
};

var getExpandedRows = exports.getExpandedRows = function getExpandedRows(data, keyField, expanded) {
  return expanded.map(function (k) {
    return (0, rows.getRowByRowId)(data, keyField, k);
  });
};
});

unwrapExports(expand);
var expand_1 = expand.getExpandedRows;
var expand_2 = expand.expandableKeys;
var expand_3 = expand.isAnyExpands;

var mutate = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editCell = undefined;



var _utils2 = _interopRequireDefault(utils$1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var editCell = exports.editCell = function editCell(data, keyField, rowId, dataField, newValue) {
  var row = (0, rows.getRowByRowId)(data, keyField, rowId);
  if (row) _utils2.default.set(row, dataField, newValue);
};
});

unwrapExports(mutate);
var mutate_1 = mutate.editCell;

var sort_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nextOrder = exports.sort = undefined;



var _utils2 = _interopRequireDefault(utils$1);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint no-nested-ternary: 0 */
/* eslint no-lonely-if: 0 */
/* eslint no-underscore-dangle: 0 */


function comparator(a, b) {
  var result = void 0;
  if (typeof b === 'string') {
    result = b.localeCompare(a);
  } else {
    result = a > b ? -1 : a < b ? 1 : 0;
  }
  return result;
}

var sort = exports.sort = function sort(data, sortOrder, _ref) {
  var dataField = _ref.dataField,
      sortFunc = _ref.sortFunc,
      sortValue = _ref.sortValue;

  var _data = [].concat(_toConsumableArray(data));
  _data.sort(function (a, b) {
    var result = void 0;
    var valueA = _utils2.default.get(a, dataField);
    var valueB = _utils2.default.get(b, dataField);
    if (sortValue) {
      valueA = sortValue(valueA, a);
      valueB = sortValue(valueB, b);
    } else {
      valueA = _utils2.default.isDefined(valueA) ? valueA : '';
      valueB = _utils2.default.isDefined(valueB) ? valueB : '';
    }

    if (sortFunc) {
      result = sortFunc(valueA, valueB, sortOrder, dataField, a, b);
    } else {
      if (sortOrder === _const2.default.SORT_DESC) {
        result = comparator(valueA, valueB);
      } else {
        result = comparator(valueB, valueA);
      }
    }
    return result;
  });
  return _data;
};

var nextOrder = exports.nextOrder = function nextOrder(currentSortColumn, _ref2) {
  var sortOrder = _ref2.sortOrder,
      sortColumn = _ref2.sortColumn;
  var defaultOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const2.default.SORT_DESC;

  if (!sortColumn || currentSortColumn.dataField !== sortColumn.dataField) return defaultOrder;
  return sortOrder === _const2.default.SORT_DESC ? _const2.default.SORT_ASC : _const2.default.SORT_DESC;
};
});

unwrapExports(sort_1);
var sort_2 = sort_1.nextOrder;
var sort_3 = sort_1.sort;

var type = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeConvert = undefined;



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var typeConvert = exports.typeConvert = function typeConvert(type, value) {
  if (type === _const2.default.TYPE_STRING) {
    return String(value);
  } else if (type === _const2.default.TYPE_NUMBER) {
    return Number(value);
  } else if (type === _const2.default.TYPE_BOOLEAN) {
    if (typeof value === 'boolean') {
      return value;
    }
    return value === 'true';
  } else if (type === _const2.default.TYPE_DATE) {
    return new Date(value);
  }
  return value;
};
});

unwrapExports(type);
var type_1 = type.typeConvert;

var operators = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var rows$1 = _interopRequireWildcard(rows);



var selection$1 = _interopRequireWildcard(selection);



var expand$1 = _interopRequireWildcard(expand);



var mutate$1 = _interopRequireWildcard(mutate);



var sort = _interopRequireWildcard(sort_1);



var type$1 = _interopRequireWildcard(type);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = _extends({}, rows$1, selection$1, expand$1, mutate$1, sort, type$1);
});

unwrapExports(operators);

var selectionContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _const2 = _interopRequireDefault(_const);



var _utils2 = _interopRequireDefault(utils$1);



var _operators2 = _interopRequireDefault(operators);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */
/* eslint react/prop-types: 0 */


var SelectionContext = _react2.default.createContext();

var SelectionProvider = function (_React$Component) {
  _inherits(SelectionProvider, _React$Component);

  function SelectionProvider(props) {
    _classCallCheck(this, SelectionProvider);

    var _this = _possibleConstructorReturn(this, (SelectionProvider.__proto__ || Object.getPrototypeOf(SelectionProvider)).call(this, props));

    _this.handleRowSelect = function (rowKey, checked, rowIndex, e) {
      var _this$props = _this.props,
          data = _this$props.data,
          keyField = _this$props.keyField,
          _this$props$selectRow = _this$props.selectRow,
          mode = _this$props$selectRow.mode,
          onSelect = _this$props$selectRow.onSelect;
      var ROW_SELECT_SINGLE = _const2.default.ROW_SELECT_SINGLE;


      var currSelected = [].concat(_toConsumableArray(_this.selected));

      var result = true;
      if (onSelect) {
        var row = _operators2.default.getRowByRowId(data, keyField, rowKey);
        result = onSelect(row, checked, rowIndex, e);
      }

      if (result === true || result === undefined) {
        if (mode === ROW_SELECT_SINGLE) {
          // when select mode is radio
          currSelected = [rowKey];
        } else if (checked) {
          // when select mode is checkbox
          currSelected.push(rowKey);
        } else {
          currSelected = currSelected.filter(function (value) {
            return value !== rowKey;
          });
        }
      }
      _this.selected = currSelected;
      _this.forceUpdate();
    };

    _this.handleAllRowsSelect = function (e, isUnSelect) {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          keyField = _this$props2.keyField,
          _this$props2$selectRo = _this$props2.selectRow,
          onSelectAll = _this$props2$selectRo.onSelectAll,
          nonSelectable = _this$props2$selectRo.nonSelectable;
      var selected = _this.selected;


      var currSelected = void 0;

      if (!isUnSelect) {
        currSelected = selected.concat(_operators2.default.selectableKeys(data, keyField, nonSelectable));
      } else {
        currSelected = selected.filter(function (s) {
          return typeof data.find(function (d) {
            return _utils2.default.get(d, keyField) === s;
          }) === 'undefined';
        });
      }

      var result = void 0;
      if (onSelectAll) {
        result = onSelectAll(!isUnSelect, _operators2.default.getSelectedRows(data, keyField, isUnSelect ? selected : currSelected), e);
        if (Array.isArray(result)) {
          currSelected = result;
        }
      }
      _this.selected = currSelected;
      _this.forceUpdate();
    };

    _this.selected = props.selectRow.selected || [];
    return _this;
  }

  // exposed API


  _createClass(SelectionProvider, [{
    key: 'getSelected',
    value: function getSelected() {
      return this.selected;
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.selectRow) {
        this.selected = nextProps.selectRow.selected || this.selected;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _getSelectionSummary = (0, selection.getSelectionSummary)(this.props.data, this.props.keyField, this.selected),
          allRowsSelected = _getSelectionSummary.allRowsSelected,
          allRowsNotSelected = _getSelectionSummary.allRowsNotSelected;

      var checkedStatus = void 0;

      // checkbox status depending on selected rows counts
      if (allRowsSelected) checkedStatus = _const2.default.CHECKBOX_STATUS_CHECKED;else if (allRowsNotSelected) checkedStatus = _const2.default.CHECKBOX_STATUS_UNCHECKED;else checkedStatus = _const2.default.CHECKBOX_STATUS_INDETERMINATE;

      return _react2.default.createElement(
        SelectionContext.Provider,
        {
          value: _extends({}, this.props.selectRow, {
            selected: this.selected,
            onRowSelect: this.handleRowSelect,
            onAllRowsSelect: this.handleAllRowsSelect,
            allRowsSelected: allRowsSelected,
            allRowsNotSelected: allRowsNotSelected,
            checkedStatus: checkedStatus
          })
        },
        this.props.children
      );
    }
  }]);

  return SelectionProvider;
}(_react2.default.Component);

SelectionProvider.propTypes = {
  children: _propTypes2.default.node.isRequired,
  data: _propTypes2.default.array.isRequired,
  keyField: _propTypes2.default.string.isRequired
};
exports.default = {
  Provider: SelectionProvider,
  Consumer: SelectionContext.Consumer
};
});

unwrapExports(selectionContext);

var selectionHeaderCellConsumer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _selectionContext2 = _interopRequireDefault(selectionContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
  return function () {
    return _react2.default.createElement(
      _selectionContext2.default.Consumer,
      null,
      function (selectRow) {
        return _react2.default.createElement(Component, selectRow);
      }
    );
  };
};
});

unwrapExports(selectionHeaderCellConsumer);

var rowExpandContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _operators2 = _interopRequireDefault(operators);



var _utils2 = _interopRequireDefault(utils$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */
/* eslint react/prop-types: 0 */


var RowExpandContext = _react2.default.createContext();

var RowExpandProvider = function (_React$Component) {
  _inherits(RowExpandProvider, _React$Component);

  function RowExpandProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RowExpandProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RowExpandProvider.__proto__ || Object.getPrototypeOf(RowExpandProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = { expanded: _this.props.expandRow.expanded || [],
      isClosing: _this.props.expandRow.isClosing || [] }, _this.onClosed = function (closedRow) {
      _this.setState({ isClosing: _this.state.isClosing.filter(function (value) {
          return value !== closedRow;
        }) });
    }, _this.handleRowExpand = function (rowKey, expanded, rowIndex, e) {
      var _this$props = _this.props,
          data = _this$props.data,
          keyField = _this$props.keyField,
          _this$props$expandRow = _this$props.expandRow,
          onExpand = _this$props$expandRow.onExpand,
          onlyOneExpanding = _this$props$expandRow.onlyOneExpanding,
          nonExpandable = _this$props$expandRow.nonExpandable;

      if (nonExpandable && _utils2.default.contains(nonExpandable, rowKey)) {
        return;
      }

      var currExpanded = [].concat(_toConsumableArray(_this.state.expanded));
      var isClosing = [].concat(_toConsumableArray(_this.state.isClosing));

      if (expanded) {
        if (onlyOneExpanding) {
          isClosing = isClosing.concat(currExpanded);
          currExpanded = [rowKey];
        } else currExpanded.push(rowKey);
      } else {
        isClosing.push(rowKey);
        currExpanded = currExpanded.filter(function (value) {
          return value !== rowKey;
        });
      }

      if (onExpand) {
        var row = _operators2.default.getRowByRowId(data, keyField, rowKey);
        onExpand(row, expanded, rowIndex, e);
      }
      _this.setState(function () {
        return { expanded: currExpanded, isClosing: isClosing };
      });
    }, _this.handleAllRowExpand = function (e, expandAll) {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          keyField = _this$props2.keyField,
          _this$props2$expandRo = _this$props2.expandRow,
          onExpandAll = _this$props2$expandRo.onExpandAll,
          nonExpandable = _this$props2$expandRo.nonExpandable;
      var expanded = _this.state.expanded;


      var currExpanded = void 0;

      if (expandAll) {
        currExpanded = expanded.concat(_operators2.default.expandableKeys(data, keyField, nonExpandable));
      } else {
        currExpanded = expanded.filter(function (s) {
          return typeof data.find(function (d) {
            return _utils2.default.get(d, keyField) === s;
          }) === 'undefined';
        });
      }

      if (onExpandAll) {
        onExpandAll(expandAll, _operators2.default.getExpandedRows(data, keyField, currExpanded), e);
      }

      _this.setState(function () {
        return { expanded: currExpanded };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RowExpandProvider, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.expandRow) {
        var nextExpanded = nextProps.expandRow.expanded || this.state.expanded;
        var isClosing = this.state.expanded.reduce(function (acc, cur) {
          if (!_utils2.default.contains(nextExpanded, cur)) {
            acc.push(cur);
          }
          return acc;
        }, []);
        this.setState(function () {
          return {
            expanded: nextExpanded,
            isClosing: isClosing
          };
        });
      } else {
        this.setState(function () {
          return {
            expanded: _this2.state.expanded
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          keyField = _props.keyField;

      return _react2.default.createElement(
        RowExpandContext.Provider,
        {
          value: _extends({}, this.props.expandRow, {
            nonExpandable: this.props.expandRow.nonExpandable,
            expanded: this.state.expanded,
            isClosing: this.state.isClosing,
            onClosed: this.onClosed,
            isAnyExpands: _operators2.default.isAnyExpands(data, keyField, this.state.expanded),
            onRowExpand: this.handleRowExpand,
            onAllRowExpand: this.handleAllRowExpand
          })
        },
        this.props.children
      );
    }
  }]);

  return RowExpandProvider;
}(_react2.default.Component);

RowExpandProvider.propTypes = {
  children: _propTypes2.default.node.isRequired,
  data: _propTypes2.default.array.isRequired,
  keyField: _propTypes2.default.string.isRequired
};
exports.default = {
  Provider: RowExpandProvider,
  Consumer: RowExpandContext.Consumer
};
});

unwrapExports(rowExpandContext);

var expandHeaderCellConsumer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _rowExpandContext2 = _interopRequireDefault(rowExpandContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
  return function () {
    return _react2.default.createElement(
      _rowExpandContext2.default.Consumer,
      null,
      function (expandRow) {
        return _react2.default.createElement(Component, expandRow);
      }
    );
  };
};
});

unwrapExports(expandHeaderCellConsumer);

var header = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _headerCell2 = _interopRequireDefault(headerCell);



var _selectionHeaderCell2 = _interopRequireDefault(selectionHeaderCell);



var _expandHeaderCell2 = _interopRequireDefault(expandHeaderCell);



var _selectionHeaderCellConsumer2 = _interopRequireDefault(selectionHeaderCellConsumer);



var _expandHeaderCellConsumer2 = _interopRequireDefault(expandHeaderCellConsumer);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint react/require-default-props: 0 */
var Header = function Header(props) {
  var className = props.className,
      columns = props.columns,
      onSort = props.onSort,
      onFilter = props.onFilter,
      sortField = props.sortField,
      sortOrder = props.sortOrder,
      selectRow = props.selectRow,
      expandRow = props.expandRow,
      currFilters = props.currFilters,
      onExternalFilter = props.onExternalFilter,
      filterPosition = props.filterPosition,
      globalSortCaret = props.globalSortCaret,
      wrapperClasses = props.wrapperClasses;


  var SelectionHeaderCellComp = function SelectionHeaderCellComp() {
    return null;
  };
  var ExpansionHeaderCellComp = function ExpansionHeaderCellComp() {
    return null;
  };

  if (expandRow.showExpandColumn) {
    ExpansionHeaderCellComp = (0, _expandHeaderCellConsumer2.default)(_expandHeaderCell2.default);
  }

  if (selectRow) {
    SelectionHeaderCellComp = (0, _selectionHeaderCellConsumer2.default)(_selectionHeaderCell2.default);
  }

  var isRenderFunctionColumnInLeft = function isRenderFunctionColumnInLeft() {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _const2.default.INDICATOR_POSITION_LEFT;
    return position === _const2.default.INDICATOR_POSITION_LEFT;
  };

  var childrens = [columns.map(function (column, i) {
    var currSort = column.dataField === sortField;
    var isLastSorting = column.dataField === sortField;

    return _react2.default.createElement(_headerCell2.default, {
      index: i,
      key: column.dataField,
      column: column,
      onSort: onSort,
      sorting: currSort,
      sortOrder: sortOrder,
      globalSortCaret: globalSortCaret,
      isLastSorting: isLastSorting,
      onFilter: onFilter,
      currFilters: currFilters,
      onExternalFilter: onExternalFilter,
      filterPosition: filterPosition
    });
  })];

  if (!selectRow.hideSelectColumn) {
    if (isRenderFunctionColumnInLeft(selectRow.selectColumnPosition)) {
      childrens.unshift(_react2.default.createElement(SelectionHeaderCellComp, { key: 'selection' }));
    } else {
      childrens.push(_react2.default.createElement(SelectionHeaderCellComp, { key: 'selection' }));
    }
  }

  if (expandRow.showExpandColumn) {
    if (isRenderFunctionColumnInLeft(expandRow.expandColumnPosition)) {
      childrens.unshift(_react2.default.createElement(ExpansionHeaderCellComp, { key: 'expansion' }));
    } else {
      childrens.push(_react2.default.createElement(ExpansionHeaderCellComp, { key: 'expansion' }));
    }
  }

  return _react2.default.createElement(
    'thead',
    { className: wrapperClasses },
    _react2.default.createElement(
      'tr',
      { className: className },
      childrens
    )
  );
};

Header.propTypes = {
  columns: _propTypes2.default.array.isRequired,
  onSort: _propTypes2.default.func,
  onFilter: _propTypes2.default.func,
  sortField: _propTypes2.default.string,
  sortOrder: _propTypes2.default.string,
  selectRow: _propTypes2.default.object,
  currFilters: _propTypes2.default.object,
  onExternalFilter: _propTypes2.default.func,
  globalSortCaret: _propTypes2.default.func,
  className: _propTypes2.default.string,
  wrapperClasses: _propTypes2.default.string,
  expandRow: _propTypes2.default.object,
  filterPosition: _propTypes2.default.oneOf([_const2.default.FILTERS_POSITION_TOP, _const2.default.FILTERS_POSITION_INLINE, _const2.default.FILTERS_POSITION_BOTTOM])
};

exports.default = Header;
});

unwrapExports(header);

var filtersCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _utils2 = _interopRequireDefault(utils$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FiltersCell = function FiltersCell(props) {
  var index = props.index,
      column = props.column,
      onExternalFilter = props.onExternalFilter,
      currFilters = props.currFilters,
      onFilter = props.onFilter;
  var filterRenderer = column.filterRenderer,
      filter = column.filter;

  var filterElm = void 0;
  var cellAttrs = {};
  var cellStyle = {};
  cellAttrs.style = cellStyle;
  if (column.headerAlign) {
    cellStyle.textAlign = _utils2.default.isFunction(column.headerAlign) ? column.headerAlign(column, index) : column.headerAlign;
  }
  if (column.filterRenderer) {
    var onCustomFilter = onExternalFilter(column, filter.props.type);
    filterElm = filterRenderer(onCustomFilter, column);
  } else if (filter) {
    filterElm = _react2.default.createElement(filter.Filter, _extends({}, filter.props, {
      filterState: currFilters[column.dataField],
      onFilter: onFilter,
      column: column
    }));
  }
  return _react2.default.createElement('th', cellAttrs, filterElm);
};

FiltersCell.propTypes = {
  index: _propTypes2.default.number.isRequired,
  column: _propTypes2.default.object.isRequired,
  currFilters: _propTypes2.default.object.isRequired,
  onFilter: _propTypes2.default.func,
  onExternalFilter: _propTypes2.default.func
};

FiltersCell.defaultProps = {
  onFilter: function onFilter() {},
  onExternalFilter: function onExternalFilter() {}
};

exports.default = FiltersCell;
});

unwrapExports(filtersCell);

var rowTemplate = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint react/require-default-props: 0 */


var RowTemplate = function RowTemplate(props) {
  var renderContent = props.renderContent,
      selectRow = props.selectRow,
      expandRow = props.expandRow,
      cellEl = props.cellEl,
      rest = _objectWithoutProperties(props, ['renderContent', 'selectRow', 'expandRow', 'cellEl']);

  var isRenderFunctionColumnInLeft = function isRenderFunctionColumnInLeft() {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _const2.default.INDICATOR_POSITION_LEFT;
    return position === _const2.default.INDICATOR_POSITION_LEFT;
  };

  var childrens = renderContent() || [];

  if (selectRow && selectRow.hideSelectColumn !== true) {
    if (isRenderFunctionColumnInLeft(selectRow.selectColumnPosition)) {
      childrens.unshift(_react2.default.createElement(cellEl, { key: 'selection' }));
    } else {
      childrens.push(_react2.default.createElement(cellEl, { key: 'selection' }));
    }
  }

  if (expandRow.showExpandColumn) {
    if (isRenderFunctionColumnInLeft(expandRow.expandColumnPosition)) {
      childrens.unshift(_react2.default.createElement(cellEl, { key: 'expansion' }));
    } else {
      childrens.push(_react2.default.createElement(cellEl, { key: 'expansion' }));
    }
  }

  return _react2.default.createElement(
    'tr',
    rest,
    childrens
  );
};

RowTemplate.propTypes = {
  renderContent: _propTypes2.default.func.isRequired,
  cellEl: _propTypes2.default.string.isRequired,
  selectRow: _propTypes2.default.object,
  expandRow: _propTypes2.default.object
};

exports.default = RowTemplate;
});

unwrapExports(rowTemplate);

var filters = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _filtersCell2 = _interopRequireDefault(filtersCell);



var _const2 = _interopRequireDefault(_const);



var _rowTemplate2 = _interopRequireDefault(rowTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Filters = function Filters(props) {
  var columns = props.columns,
      onFilter = props.onFilter,
      currFilters = props.currFilters,
      filterPosition = props.filterPosition,
      onExternalFilter = props.onExternalFilter,
      className = props.className,
      selectRow = props.selectRow,
      expandRow = props.expandRow;


  function renderContent() {
    var filterColumns = [];

    columns.forEach(function (column, i) {
      filterColumns.push(_react2.default.createElement(_filtersCell2.default, {
        index: i,
        key: column.dataField,
        column: column,
        currFilters: currFilters,
        onExternalFilter: onExternalFilter,
        onFilter: onFilter
      }));

      if (column.filterRenderer || column.filter) ;
    });
    return filterColumns;
  }

  return _react2.default.createElement(
    'tbody',
    {
      className: className,
      style: {
        display: filterPosition === _const2.default.FILTERS_POSITION_TOP ? 'table-header-group' : 'table-footer-group'
      }
    },
    _react2.default.createElement(_rowTemplate2.default, {
      renderContent: renderContent,
      selectRow: selectRow,
      expandRow: expandRow,
      cellEl: 'td'
    })
  );
}; /* eslint react/require-default-props: 0 */


Filters.propTypes = {
  columns: _propTypes2.default.array.isRequired,
  onFilter: _propTypes2.default.func,
  filterPosition: _propTypes2.default.oneOf([_const2.default.FILTERS_POSITION_TOP, _const2.default.FILTERS_POSITION_INLINE, _const2.default.FILTERS_POSITION_BOTTOM]),
  currFilters: _propTypes2.default.object,
  onExternalFilter: _propTypes2.default.func,
  className: _propTypes2.default.string,
  selectRow: _propTypes2.default.object,
  expandRow: _propTypes2.default.object
};

Filters.defaultProps = {
  position: _const2.default.FILTERS_POSITION_TOP
};

exports.default = Filters;
});

unwrapExports(filters);

var caption = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint react/require-default-props: 0 */
var Caption = function Caption(props) {
  if (!props.children) return null;

  var caption = props.bootstrap4 ? _react2.default.createElement(
    'caption',
    { style: { captionSide: 'top' } },
    props.children
  ) : _react2.default.createElement(
    'caption',
    null,
    props.children
  );

  return caption;
};

Caption.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  bootstrap4: _propTypes2.default.bool
};

exports.default = Caption;
});

unwrapExports(caption);

var cell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _cellEventDelegater2 = _interopRequireDefault(cellEventDelegater);



var _utils2 = _interopRequireDefault(utils$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var Cell = function (_eventDelegater) {
  _inherits(Cell, _eventDelegater);

  function Cell(props) {
    _classCallCheck(this, Cell);

    var _this = _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).call(this, props));

    _this.createHandleEditingCell = function (originFunc) {
      return function (e) {
        var _this$props = _this.props,
            onStart = _this$props.onStart,
            rowIndex = _this$props.rowIndex,
            columnIndex = _this$props.columnIndex,
            clickToEdit = _this$props.clickToEdit,
            dbclickToEdit = _this$props.dbclickToEdit;

        if ((clickToEdit || dbclickToEdit) && _utils2.default.isFunction(originFunc)) {
          originFunc(e);
        }
        if (onStart) {
          onStart(rowIndex, columnIndex);
        }
      };
    };

    _this.createHandleEditingCell = _this.createHandleEditingCell.bind(_this);
    return _this;
  }

  _createClass(Cell, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var shouldUpdate = false;
      if (nextProps.column.isDummyField) {
        shouldUpdate = !_utils2.default.isEqual(this.props.row, nextProps.row);
      } else {
        shouldUpdate = _utils2.default.get(this.props.row, this.props.column.dataField) !== _utils2.default.get(nextProps.row, nextProps.column.dataField);
      }

      if (shouldUpdate) return true;

      // if (nextProps.formatter)

      shouldUpdate = (nextProps.column.formatter ? !_utils2.default.isEqual(this.props.row, nextProps.row) : false) || this.props.column.hidden !== nextProps.column.hidden || this.props.column.isDummyField !== nextProps.column.isDummyField || this.props.rowIndex !== nextProps.rowIndex || this.props.columnIndex !== nextProps.columnIndex || this.props.className !== nextProps.className || this.props.title !== nextProps.title || this.props.editable !== nextProps.editable || this.props.clickToEdit !== nextProps.clickToEdit || this.props.dbclickToEdit !== nextProps.dbclickToEdit || !_utils2.default.isEqual(this.props.style, nextProps.style) || !_utils2.default.isEqual(this.props.column.formatExtraData, nextProps.column.formatExtraData) || !_utils2.default.isEqual(this.props.column.events, nextProps.column.events) || !_utils2.default.isEqual(this.props.column.attrs, nextProps.column.attrs) || this.props.tabIndex !== nextProps.tabIndex;
      return shouldUpdate;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          row = _props.row,
          rowIndex = _props.rowIndex,
          column = _props.column,
          columnIndex = _props.columnIndex,
          onStart = _props.onStart,
          editable = _props.editable,
          clickToEdit = _props.clickToEdit,
          dbclickToEdit = _props.dbclickToEdit,
          rest = _objectWithoutProperties(_props, ['row', 'rowIndex', 'column', 'columnIndex', 'onStart', 'editable', 'clickToEdit', 'dbclickToEdit']);

      var dataField = column.dataField,
          formatter = column.formatter,
          formatExtraData = column.formatExtraData;

      var attrs = this.delegate(_extends({}, rest));
      var content = column.isDummyField ? null : _utils2.default.get(row, dataField);

      if (formatter) {
        content = column.formatter(content, row, rowIndex, formatExtraData);
      }

      if (clickToEdit && editable) {
        attrs.onClick = this.createHandleEditingCell(attrs.onClick);
      } else if (dbclickToEdit && editable) {
        attrs.onDoubleClick = this.createHandleEditingCell(attrs.onDoubleClick);
      }

      return _react2.default.createElement(
        'td',
        attrs,
        typeof content === 'boolean' ? '' + content : content
      );
    }
  }]);

  return Cell;
}((0, _cellEventDelegater2.default)(React__default['default'].Component));

Cell.propTypes = {
  row: _propTypes2.default.object.isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  column: _propTypes2.default.object.isRequired,
  columnIndex: _propTypes2.default.number.isRequired
};

exports.default = Cell;
});

unwrapExports(cell);

var rowPureContent = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _utils2 = _interopRequireDefault(utils$1);



var _cell2 = _interopRequireDefault(cell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/no-array-index-key: 0 */
/* eslint no-plusplus: 0 */


var RowPureContent = function (_React$Component) {
  _inherits(RowPureContent, _React$Component);

  function RowPureContent() {
    _classCallCheck(this, RowPureContent);

    return _possibleConstructorReturn(this, (RowPureContent.__proto__ || Object.getPrototypeOf(RowPureContent)).apply(this, arguments));
  }

  _createClass(RowPureContent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (typeof nextProps.shouldUpdate !== 'undefined') {
        return nextProps.shouldUpdate;
      }
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          row = _props.row,
          keyField = _props.keyField,
          columns = _props.columns,
          rowIndex = _props.rowIndex,
          editable = _props.editable,
          editingRowIdx = _props.editingRowIdx,
          editingColIdx = _props.editingColIdx,
          onStart = _props.onStart,
          clickToEdit = _props.clickToEdit,
          dbclickToEdit = _props.dbclickToEdit,
          EditingCellComponent = _props.EditingCellComponent,
          tabIndexStart = _props.tabIndexStart;


      var tabIndex = tabIndexStart;

      return columns.map(function (column, index) {
        var dataField = column.dataField;

        var content = _utils2.default.get(row, dataField);
        if (rowIndex === editingRowIdx && index === editingColIdx) {
          return _react2.default.createElement(EditingCellComponent, {
            key: content + '-' + index + '-editing',
            row: row,
            rowIndex: rowIndex,
            column: column,
            columnIndex: index
          });
        }
        // render cell
        var cellTitle = void 0;
        var cellStyle = {};
        var cellAttrs = _extends({}, _utils2.default.isFunction(column.attrs) ? column.attrs(content, row, rowIndex, index) : column.attrs);

        if (column.events) {
          var events = Object.assign({}, column.events);
          Object.keys(Object.assign({}, column.events)).forEach(function (key) {
            var originFn = events[key];
            events[key] = function () {
              for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
                rest[_key] = arguments[_key];
              }

              return originFn.apply(undefined, rest.concat([row, rowIndex]));
            };
          });
          cellAttrs = _extends({}, cellAttrs, events);
        }

        var cellClasses = _utils2.default.isFunction(column.classes) ? column.classes(content, row, rowIndex, index) : column.classes;

        if (column.style) {
          cellStyle = _utils2.default.isFunction(column.style) ? column.style(content, row, rowIndex, index) : column.style;
          cellStyle = Object.assign({}, cellStyle) || {};
        }

        if (column.title) {
          cellTitle = _utils2.default.isFunction(column.title) ? column.title(content, row, rowIndex, index) : content;
          cellAttrs.title = cellTitle;
        }

        if (column.align) {
          cellStyle.textAlign = _utils2.default.isFunction(column.align) ? column.align(content, row, rowIndex, index) : column.align;
        }

        if (cellClasses) cellAttrs.className = cellClasses;
        if (!_utils2.default.isEmptyObject(cellStyle)) cellAttrs.style = cellStyle;

        var editableCell = _utils2.default.isDefined(column.editable) ? column.editable : true;
        if (column.dataField === keyField || !editable) editableCell = false;
        if (_utils2.default.isFunction(column.editable)) {
          editableCell = column.editable(content, row, rowIndex, index);
        }

        if (tabIndexStart !== -1) {
          cellAttrs.tabIndex = tabIndex++;
        }

        return _react2.default.createElement(_cell2.default, _extends({
          key: content + '-' + index,
          row: row,
          editable: editableCell,
          rowIndex: rowIndex,
          columnIndex: index,
          column: column,
          onStart: onStart,
          clickToEdit: clickToEdit,
          dbclickToEdit: dbclickToEdit
        }, cellAttrs));
      });
    }
  }]);

  return RowPureContent;
}(_react2.default.Component);

exports.default = RowPureContent;
});

unwrapExports(rowPureContent);

var eventDelegater = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _utils2 = _interopRequireDefault(utils$1);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = ['onClick', 'onDoubleClick', 'onMouseEnter', 'onMouseLeave', 'onContextMenu'];

exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(RowEventDelegater, _ExtendBase);

    function RowEventDelegater(props) {
      _classCallCheck(this, RowEventDelegater);

      var _this = _possibleConstructorReturn(this, (RowEventDelegater.__proto__ || Object.getPrototypeOf(RowEventDelegater)).call(this, props));

      _this.clickNum = 0;
      _this.createDefaultEventHandler = _this.createDefaultEventHandler.bind(_this);
      _this.createClickEventHandler = _this.createClickEventHandler.bind(_this);
      return _this;
    }

    _createClass(RowEventDelegater, [{
      key: 'createClickEventHandler',
      value: function createClickEventHandler(cb) {
        var _this2 = this;

        return function (e) {
          var _props = _this2.props,
              row = _props.row,
              selected = _props.selected,
              keyField = _props.keyField,
              selectable = _props.selectable,
              expandable = _props.expandable,
              rowIndex = _props.rowIndex,
              expanded = _props.expanded,
              expandRow = _props.expandRow,
              selectRow = _props.selectRow,
              DELAY_FOR_DBCLICK = _props.DELAY_FOR_DBCLICK;

          var clickFn = function clickFn() {
            if (cb) {
              cb(e, row, rowIndex);
            }
            var key = _utils2.default.get(row, keyField);
            if (expandRow && expandable && !expandRow.expandByColumnOnly) {
              if (selectRow.mode !== _const2.default.ROW_SELECT_DISABLED && selectRow.clickToExpand || selectRow.mode === _const2.default.ROW_SELECT_DISABLED) {
                expandRow.onRowExpand(key, !expanded, rowIndex, e);
              }
            }
            if (selectRow.clickToSelect && selectable) {
              selectRow.onRowSelect(key, !selected, rowIndex, e);
            }
          };

          if (DELAY_FOR_DBCLICK) {
            _this2.clickNum += 1;
            _utils2.default.debounce(function () {
              if (_this2.clickNum === 1) {
                clickFn();
              }
              _this2.clickNum = 0;
            }, DELAY_FOR_DBCLICK)();
          } else {
            clickFn();
          }
        };
      }
    }, {
      key: 'createDefaultEventHandler',
      value: function createDefaultEventHandler(cb) {
        var _this3 = this;

        return function (e) {
          var _props2 = _this3.props,
              row = _props2.row,
              rowIndex = _props2.rowIndex;

          cb(e, row, rowIndex);
        };
      }
    }, {
      key: 'delegate',
      value: function delegate() {
        var _this4 = this;

        var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var newAttrs = _extends({}, attrs);
        Object.keys(attrs).forEach(function (attr) {
          if (_utils2.default.contains(events, attr)) {
            newAttrs[attr] = _this4.createDefaultEventHandler(attrs[attr]);
          }
        });
        return newAttrs;
      }
    }]);

    return RowEventDelegater;
  }(ExtendBase);
};
});

unwrapExports(eventDelegater);

var shouldUpdater = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _utils2 = _interopRequireDefault(utils$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(RowShouldUpdater, _ExtendBase);

    function RowShouldUpdater() {
      _classCallCheck(this, RowShouldUpdater);

      return _possibleConstructorReturn(this, (RowShouldUpdater.__proto__ || Object.getPrototypeOf(RowShouldUpdater)).apply(this, arguments));
    }

    _createClass(RowShouldUpdater, [{
      key: 'shouldUpdateByCellEditing',
      value: function shouldUpdateByCellEditing(nextProps) {
        if (!(this.props.clickToEdit || this.props.dbclickToEdit)) return false;
        return nextProps.editingRowIdx === nextProps.rowIndex || this.props.editingRowIdx === nextProps.rowIndex && nextProps.editingRowIdx === null || this.props.editingRowIdx === nextProps.rowIndex;
      }
    }, {
      key: 'shouldUpdatedBySelfProps',
      value: function shouldUpdatedBySelfProps(nextProps) {
        return this.props.className !== nextProps.className || !_utils2.default.isEqual(this.props.style, nextProps.style) || !_utils2.default.isEqual(this.props.attrs, nextProps.attrs);
      }

      // Only use for simple-row

    }, {
      key: 'shouldUpdateByColumnsForSimpleCheck',
      value: function shouldUpdateByColumnsForSimpleCheck(nextProps) {
        if (this.props.columns.length !== nextProps.columns.length) {
          return true;
        }
        for (var i = 0; i < this.props.columns.length; i += 1) {
          if (!_utils2.default.isEqual(this.props.columns[i], nextProps.columns[i])) {
            return true;
          }
        }
        return false;
      }
    }, {
      key: 'shouldUpdatedByNormalProps',
      value: function shouldUpdatedByNormalProps(nextProps) {
        var shouldUpdate = this.props.rowIndex !== nextProps.rowIndex || this.props.editable !== nextProps.editable || !_utils2.default.isEqual(this.props.row, nextProps.row) || this.props.columns.length !== nextProps.columns.length;

        return shouldUpdate;
      }
    }, {
      key: 'shouldUpdateChild',
      value: function shouldUpdateChild(nextProps) {
        return this.shouldUpdateByCellEditing(nextProps) || this.shouldUpdatedByNormalProps(nextProps);
      }
    }, {
      key: 'shouldRowContentUpdate',
      value: function shouldRowContentUpdate(nextProps) {
        return this.shouldUpdateChild(nextProps) || this.shouldUpdateByColumnsForSimpleCheck(nextProps);
      }
    }]);

    return RowShouldUpdater;
  }(ExtendBase);
};
});

unwrapExports(shouldUpdater);

var simpleRow = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _rowPureContent2 = _interopRequireDefault(rowPureContent);



var _eventDelegater2 = _interopRequireDefault(eventDelegater);



var _shouldUpdater3 = _interopRequireDefault(shouldUpdater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/no-array-index-key: 0 */


var SimpleRow = function (_shouldUpdater) {
  _inherits(SimpleRow, _shouldUpdater);

  function SimpleRow(props) {
    _classCallCheck(this, SimpleRow);

    var _this = _possibleConstructorReturn(this, (SimpleRow.__proto__ || Object.getPrototypeOf(SimpleRow)).call(this, props));

    _this.shouldUpdateRowContent = false;
    return _this;
  }

  _createClass(SimpleRow, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      this.shouldUpdateRowContent = false;
      this.shouldUpdateRowContent = this.shouldRowContentUpdate(nextProps);
      if (this.shouldUpdateRowContent) return true;

      return this.shouldUpdatedBySelfProps(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          attrs = _props.attrs,
          visibleColumnSize = _props.visibleColumnSize,
          tabIndexCell = _props.tabIndexCell,
          rest = _objectWithoutProperties(_props, ['className', 'style', 'attrs', 'visibleColumnSize', 'tabIndexCell']);

      var trAttrs = this.delegate(attrs);
      var tabIndexStart = this.props.rowIndex * visibleColumnSize + 1;

      return _react2.default.createElement(
        'tr',
        _extends({ style: style, className: className }, trAttrs),
        _react2.default.createElement(_rowPureContent2.default, _extends({
          shouldUpdate: this.shouldUpdateRowContent,
          tabIndexStart: tabIndexCell ? tabIndexStart : -1
        }, rest))
      );
    }
  }]);

  return SimpleRow;
}((0, _shouldUpdater3.default)((0, _eventDelegater2.default)(React__default['default'].Component)));

SimpleRow.propTypes = {
  row: _propTypes2.default.object.isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  columns: _propTypes2.default.array.isRequired,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  attrs: _propTypes2.default.object
};

SimpleRow.defaultProps = {
  editable: true,
  style: {},
  className: null,
  attrs: {}
};

exports.default = SimpleRow;
});

unwrapExports(simpleRow);

var expandCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 react/require-default-props: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 jsx-a11y/no-noninteractive-element-interactions: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
/* eslint no-nested-ternary: 0 */


var ExpandCell = function (_Component) {
  _inherits(ExpandCell, _Component);

  function ExpandCell() {
    _classCallCheck(this, ExpandCell);

    var _this = _possibleConstructorReturn(this, (ExpandCell.__proto__ || Object.getPrototypeOf(ExpandCell)).call(this));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(ExpandCell, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var shouldUpdate = this.props.rowIndex !== nextProps.rowIndex || this.props.expanded !== nextProps.expanded || this.props.rowKey !== nextProps.rowKey || this.props.tabIndex !== nextProps.tabIndex;

      return shouldUpdate;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _props = this.props,
          rowKey = _props.rowKey,
          expanded = _props.expanded,
          onRowExpand = _props.onRowExpand,
          rowIndex = _props.rowIndex;

      e.stopPropagation();
      onRowExpand(rowKey, !expanded, rowIndex, e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          expanded = _props2.expanded,
          expandable = _props2.expandable,
          expandColumnRenderer = _props2.expandColumnRenderer,
          tabIndex = _props2.tabIndex,
          rowKey = _props2.rowKey;

      var attrs = {};
      if (tabIndex !== -1) attrs.tabIndex = tabIndex;

      return _react2.default.createElement(
        'td',
        _extends({ className: 'expand-cell', onClick: this.handleClick }, attrs),
        expandColumnRenderer ? expandColumnRenderer({
          expandable: expandable,
          expanded: expanded,
          rowKey: rowKey
        }) : expandable ? expanded ? '(-)' : '(+)' : ''
      );
    }
  }]);

  return ExpandCell;
}(React__default['default'].Component);

ExpandCell.propTypes = {
  rowKey: _propTypes2.default.any,
  expanded: _propTypes2.default.bool.isRequired,
  expandable: _propTypes2.default.bool.isRequired,
  onRowExpand: _propTypes2.default.func.isRequired,
  expandColumnRenderer: _propTypes2.default.func,
  rowIndex: _propTypes2.default.number,
  tabIndex: _propTypes2.default.number
};
exports.default = ExpandCell;
});

unwrapExports(expandCell);

var selectionCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _const2 = _interopRequireDefault(_const);



var _utils2 = _interopRequireDefault(utils$1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 react/require-default-props: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 jsx-a11y/no-noninteractive-element-interactions: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var SelectionCell = function (_Component) {
  _inherits(SelectionCell, _Component);

  function SelectionCell() {
    _classCallCheck(this, SelectionCell);

    var _this = _possibleConstructorReturn(this, (SelectionCell.__proto__ || Object.getPrototypeOf(SelectionCell)).call(this));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(SelectionCell, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var shouldUpdate = this.props.rowIndex !== nextProps.rowIndex || this.props.selected !== nextProps.selected || this.props.disabled !== nextProps.disabled || this.props.rowKey !== nextProps.rowKey || this.props.tabIndex !== nextProps.tabIndex || this.props.selectColumnStyle !== nextProps.selectColumnStyle;

      return shouldUpdate;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _props = this.props,
          inputType = _props.mode,
          rowKey = _props.rowKey,
          selected = _props.selected,
          onRowSelect = _props.onRowSelect,
          disabled = _props.disabled,
          rowIndex = _props.rowIndex;

      e.stopPropagation();
      if (disabled) return;

      var checked = inputType === _const2.default.ROW_SELECT_SINGLE ? true : !selected;

      onRowSelect(rowKey, checked, rowIndex, e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          rowKey = _props2.rowKey,
          inputType = _props2.mode,
          selected = _props2.selected,
          disabled = _props2.disabled,
          tabIndex = _props2.tabIndex,
          rowIndex = _props2.rowIndex,
          selectionRenderer = _props2.selectionRenderer,
          selectColumnStyle = _props2.selectColumnStyle;


      var attrs = {};
      if (tabIndex !== -1) attrs.tabIndex = tabIndex;

      attrs.style = _utils2.default.isFunction(selectColumnStyle) ? selectColumnStyle({
        checked: selected,
        disabled: disabled,
        rowIndex: rowIndex,
        rowKey: rowKey
      }) : selectColumnStyle;

      return _react2.default.createElement(
        bootstrap.BootstrapContext.Consumer,
        null,
        function (_ref) {
          var bootstrap4 = _ref.bootstrap4;
          return _react2.default.createElement(
            'td',
            _extends({ className: 'selection-cell', onClick: _this2.handleClick }, attrs),
            selectionRenderer ? selectionRenderer({
              mode: inputType,
              checked: selected,
              disabled: disabled,
              rowIndex: rowIndex
            }) : _react2.default.createElement('input', {
              type: inputType,
              checked: selected,
              disabled: disabled,
              className: bootstrap4 ? 'selection-input-4' : '',
              onChange: function onChange() {}
            })
          );
        }
      );
    }
  }]);

  return SelectionCell;
}(React__default['default'].Component);

SelectionCell.propTypes = {
  mode: _propTypes2.default.string.isRequired,
  rowKey: _propTypes2.default.any,
  selected: _propTypes2.default.bool,
  onRowSelect: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  rowIndex: _propTypes2.default.number,
  tabIndex: _propTypes2.default.number,
  clickToSelect: _propTypes2.default.bool,
  selectionRenderer: _propTypes2.default.func,
  selectColumnStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
};
exports.default = SelectionCell;
});

unwrapExports(selectionCell);

var aggregateRow = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _utils2 = _interopRequireDefault(utils$1);



var _expandCell2 = _interopRequireDefault(expandCell);



var _selectionCell2 = _interopRequireDefault(selectionCell);



var _shouldUpdater3 = _interopRequireDefault(shouldUpdater);



var _eventDelegater2 = _interopRequireDefault(eventDelegater);



var _rowPureContent2 = _interopRequireDefault(rowPureContent);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint class-methods-use-this: 0 */
/* eslint react/prop-types: 0 */
/* eslint no-plusplus: 0 */


var RowAggregator = function (_shouldUpdater) {
  _inherits(RowAggregator, _shouldUpdater);

  function RowAggregator(props) {
    _classCallCheck(this, RowAggregator);

    var _this = _possibleConstructorReturn(this, (RowAggregator.__proto__ || Object.getPrototypeOf(RowAggregator)).call(this, props));

    _this.clickNum = 0;
    _this.shouldUpdateRowContent = false;
    _this.createClickEventHandler = _this.createClickEventHandler.bind(_this);
    return _this;
  }

  _createClass(RowAggregator, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.selected !== nextProps.selected || this.props.expanded !== nextProps.expanded || this.props.expandable !== nextProps.expandable || this.props.selectable !== nextProps.selectable || this.props.selectRow.hideSelectColumn !== nextProps.selectRow.hideSelectColumn || this.shouldUpdatedBySelfProps(nextProps)) {
        this.shouldUpdateRowContent = this.shouldRowContentUpdate(nextProps);
        return true;
      }
      this.shouldUpdateRowContent = this.shouldRowContentUpdate(nextProps);

      return this.shouldUpdateRowContent;
    }
  }, {
    key: 'isRenderFunctionColumnInLeft',
    value: function isRenderFunctionColumnInLeft() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _const2.default.INDICATOR_POSITION_LEFT;

      return position === _const2.default.INDICATOR_POSITION_LEFT;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          row = _props.row,
          columns = _props.columns,
          keyField = _props.keyField,
          rowIndex = _props.rowIndex,
          style = _props.style,
          className = _props.className,
          attrs = _props.attrs,
          selectRow = _props.selectRow,
          expandRow = _props.expandRow,
          expanded = _props.expanded,
          expandable = _props.expandable,
          selected = _props.selected,
          selectable = _props.selectable,
          visibleColumnSize = _props.visibleColumnSize,
          tabIndexCell = _props.tabIndexCell,
          rest = _objectWithoutProperties(_props, ['row', 'columns', 'keyField', 'rowIndex', 'style', 'className', 'attrs', 'selectRow', 'expandRow', 'expanded', 'expandable', 'selected', 'selectable', 'visibleColumnSize', 'tabIndexCell']);

      var key = _utils2.default.get(row, keyField);
      var hideSelectColumn = selectRow.hideSelectColumn,
          selectColumnPosition = selectRow.selectColumnPosition,
          clickToSelect = selectRow.clickToSelect;
      var showExpandColumn = expandRow.showExpandColumn,
          expandColumnPosition = expandRow.expandColumnPosition;


      var newAttrs = this.delegate(_extends({}, attrs));
      if (clickToSelect || !!expandRow.renderer) {
        newAttrs.onClick = this.createClickEventHandler(newAttrs.onClick);
      }

      var tabIndexStart = rowIndex * visibleColumnSize + 1;

      var childrens = [_react2.default.createElement(_rowPureContent2.default, _extends({
        key: 'row',
        row: row,
        columns: columns,
        keyField: keyField,
        rowIndex: rowIndex,
        shouldUpdate: this.shouldUpdateRowContent,
        tabIndexStart: tabIndexCell ? tabIndexStart : -1
      }, rest))];

      if (!hideSelectColumn) {
        var selectCell = _react2.default.createElement(_selectionCell2.default, _extends({}, selectRow, {
          key: 'selection-cell',
          rowKey: key,
          rowIndex: rowIndex,
          selected: selected,
          disabled: !selectable,
          tabIndex: tabIndexCell ? tabIndexStart++ : -1
        }));
        if (this.isRenderFunctionColumnInLeft(selectColumnPosition)) {
          childrens.unshift(selectCell);
        } else {
          childrens.push(selectCell);
        }
      }

      if (showExpandColumn) {
        var expandCell = _react2.default.createElement(_expandCell2.default, _extends({}, expandRow, {
          key: 'expand-cell',
          rowKey: key,
          rowIndex: rowIndex,
          expanded: expanded,
          expandable: expandable,
          tabIndex: tabIndexCell ? tabIndexStart++ : -1
        }));
        if (this.isRenderFunctionColumnInLeft(expandColumnPosition)) {
          childrens.unshift(expandCell);
        } else {
          childrens.push(expandCell);
        }
      }

      return _react2.default.createElement(
        'tr',
        _extends({
          style: style,
          className: className
        }, newAttrs),
        childrens
      );
    }
  }]);

  return RowAggregator;
}((0, _shouldUpdater3.default)((0, _eventDelegater2.default)(_react2.default.Component)));

RowAggregator.propTypes = {
  attrs: _propTypes2.default.object,
  style: _propTypes2.default.object
};
RowAggregator.defaultProps = {
  attrs: {},
  style: {}
};
exports.default = RowAggregator;
});

unwrapExports(aggregateRow);

var rowSection = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RowSection = function RowSection(_ref) {
  var content = _ref.content,
      colSpan = _ref.colSpan;
  return _react2.default.createElement(
    'tr',
    null,
    _react2.default.createElement(
      'td',
      {
        'data-toggle': 'collapse',
        colSpan: colSpan,
        className: 'react-bs-table-no-data'
      },
      content
    )
  );
};

RowSection.propTypes = {
  content: _propTypes2.default.any,
  colSpan: _propTypes2.default.number
};

RowSection.defaultProps = {
  content: null,
  colSpan: 1
};

exports.default = RowSection;
});

unwrapExports(rowSection);

var rowConsumer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint react/prop-types: 0 */




var _react2 = _interopRequireDefault(React__default['default']);



var _classnames2 = _interopRequireDefault(classnames);



var _utils2 = _interopRequireDefault(utils$1);



var _selectionContext2 = _interopRequireDefault(selectionContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
  var renderWithSelection = function renderWithSelection(props, selectRow) {
    var key = props.value;
    var selected = _utils2.default.contains(selectRow.selected, key);
    var selectable = !selectRow.nonSelectable || !_utils2.default.contains(selectRow.nonSelectable, key);
    var notSelectable = _utils2.default.contains(selectRow.nonSelectable, key);

    var style = props.style,
        className = props.className;


    if (selected) {
      var selectedStyle = _utils2.default.isFunction(selectRow.style) ? selectRow.style(props.row, props.rowIndex) : selectRow.style;

      var selectedClasses = _utils2.default.isFunction(selectRow.classes) ? selectRow.classes(props.row, props.rowIndex) : selectRow.classes;

      style = _extends({}, style, selectedStyle);
      className = (0, _classnames2.default)(className, selectedClasses) || undefined;

      if (selectRow.bgColor) {
        style = style || {};
        style.backgroundColor = _utils2.default.isFunction(selectRow.bgColor) ? selectRow.bgColor(props.row, props.rowIndex) : selectRow.bgColor;
      }
    }

    if (notSelectable) {
      var notSelectableStyle = _utils2.default.isFunction(selectRow.nonSelectableStyle) ? selectRow.nonSelectableStyle(props.row, props.rowIndex) : selectRow.nonSelectableStyle;

      var notSelectableClasses = _utils2.default.isFunction(selectRow.nonSelectableClasses) ? selectRow.nonSelectableClasses(props.row, props.rowIndex) : selectRow.nonSelectableClasses;

      style = _extends({}, style, notSelectableStyle);
      className = (0, _classnames2.default)(className, notSelectableClasses) || undefined;
    }

    return _react2.default.createElement(Component, _extends({}, props, {
      style: style,
      className: className,
      selectRow: selectRow,
      selected: selected,
      selectable: selectable
    }));
  };

  function withConsumer(props) {
    return _react2.default.createElement(
      _selectionContext2.default.Consumer,
      null,
      function (selectRow) {
        return renderWithSelection(props, selectRow);
      }
    );
  }

  withConsumer.displayName = 'WithSelectionRowConsumer';
  return withConsumer;
};
});

unwrapExports(rowConsumer);

var PropTypes$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape = process.env.NODE_ENV !== 'production' ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape = process.env.NODE_ENV !== 'production' ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;
});

unwrapExports(PropTypes$1);
var PropTypes_1$1 = PropTypes$1.classNamesShape;
var PropTypes_2$1 = PropTypes$1.timeoutsShape;

var Transition_1$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(PropTypes__default['default']);

var _react = _interopRequireDefault(React__default['default']);

var _reactDom = _interopRequireDefault(ReactDOM__default['default']);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? PropTypes$1.timeoutsShape : {};    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, reactLifecyclesCompat_es.polyfill)(Transition);

exports.default = _default;
});

unwrapExports(Transition_1$1);
var Transition_2$1 = Transition_1$1.EXITING;
var Transition_3$1 = Transition_1$1.ENTERED;
var Transition_4$1 = Transition_1$1.ENTERING;
var Transition_5$1 = Transition_1$1.EXITED;
var Transition_6$1 = Transition_1$1.UNMOUNTED;

var CSSTransition_1$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(PropTypes__default['default']);

var _addClass = _interopRequireDefault(addClass_1);

var _removeClass = _interopRequireDefault(removeClass);

var _react = _interopRequireDefault(React__default['default']);

var _Transition = _interopRequireDefault(Transition_1$1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass$1 = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass$1(node, className);
    activeClassName && removeClass$1(node, activeClassName);
    doneClassName && removeClass$1(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: PropTypes$1.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(CSSTransition_1$1);

var ChildMapping$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;



/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, React__default['default'].isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) React__default['default'].Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, React__default['default'].cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, React__default['default'].isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, React__default['default'].isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, React__default['default'].cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, React__default['default'].cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, React__default['default'].isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, React__default['default'].cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
});

unwrapExports(ChildMapping$1);
var ChildMapping_1$1 = ChildMapping$1.getChildMapping;
var ChildMapping_2$1 = ChildMapping$1.mergeChildMappings;
var ChildMapping_3$1 = ChildMapping$1.getInitialChildMapping;
var ChildMapping_4$1 = ChildMapping$1.getNextChildMapping;

var TransitionGroup_1$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _react = _interopRequireDefault(React__default['default']);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, ChildMapping$1.getInitialChildMapping)(nextProps, handleExited) : (0, ChildMapping$1.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, ChildMapping$1.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, reactLifecyclesCompat_es.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(TransitionGroup_1$1);

var ReplaceTransition_1$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(PropTypes__default['default']);

var _react = _interopRequireDefault(React__default['default']);



var _TransitionGroup = _interopRequireDefault(TransitionGroup_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, ReactDOM__default['default'].findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(ReplaceTransition_1$1);

var reactTransitionGroup$1 = createCommonjsModule(function (module) {

var _CSSTransition = _interopRequireDefault(CSSTransition_1$1);

var _ReplaceTransition = _interopRequireDefault(ReplaceTransition_1$1);

var _TransitionGroup = _interopRequireDefault(TransitionGroup_1$1);

var _Transition = _interopRequireDefault(Transition_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};
});

unwrapExports(reactTransitionGroup$1);
var reactTransitionGroup_1$1 = reactTransitionGroup$1.Transition;
var reactTransitionGroup_2$1 = reactTransitionGroup$1.TransitionGroup;
var reactTransitionGroup_3$1 = reactTransitionGroup$1.ReplaceTransition;
var reactTransitionGroup_4$1 = reactTransitionGroup$1.CSSTransition;

var expandRow = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _classnames2 = _interopRequireDefault(classnames);



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ExpandRow = function ExpandRow(_ref) {
  var children = _ref.children,
      expanded = _ref.expanded,
      onClosed = _ref.onClosed,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['children', 'expanded', 'onClosed', 'className']);

  return _react2.default.createElement(
    'tr',
    null,
    _react2.default.createElement(
      'td',
      _extends({ className: (0, _classnames2.default)('reset-expansion-style', className) }, rest),
      _react2.default.createElement(
        reactTransitionGroup$1.CSSTransition,
        {
          appear: true,
          'in': expanded,
          timeout: 400,
          classNames: 'row-expand-slide',
          onExited: onClosed
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'row-expansion-style' },
            children
          )
        )
      )
    )
  );
};

ExpandRow.propTypes = {
  children: _propTypes2.default.node,
  expanded: _propTypes2.default.bool,
  onClosed: _propTypes2.default.func,
  className: _propTypes2.default.string
};

ExpandRow.defaultProps = {
  children: null,
  expanded: false,
  onClosed: null,
  className: ''
};

exports.default = ExpandRow;
});

unwrapExports(expandRow);

var rowConsumer$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint react/prop-types: 0 */




var _react2 = _interopRequireDefault(React__default['default']);



var _classnames2 = _interopRequireDefault(classnames);



var _expandRow2 = _interopRequireDefault(expandRow);



var _utils2 = _interopRequireDefault(utils$1);



var _rowExpandContext2 = _interopRequireDefault(rowExpandContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
  var renderWithExpansion = function renderWithExpansion(props, expandRow) {
    var parentClassName = '';
    var className = '';
    var key = props.value;

    var expanded = _utils2.default.contains(expandRow.expanded, key);
    var isClosing = _utils2.default.contains(expandRow.isClosing, key);
    var expandable = !expandRow.nonExpandable || !_utils2.default.contains(expandRow.nonExpandable, key);
    if (expanded) {
      parentClassName = _utils2.default.isFunction(expandRow.parentClassName) ? expandRow.parentClassName(expanded, props.row, props.rowIndex) : expandRow.parentClassName || '';

      className = _utils2.default.isFunction(expandRow.className) ? expandRow.className(expanded, props.row, props.rowIndex) : expandRow.className || '';
    }

    return [_react2.default.createElement(Component, _extends({}, props, {
      key: key,
      expanded: expanded,
      expandable: expandable,
      expandRow: _extends({}, expandRow),
      className: (0, _classnames2.default)(props.className, parentClassName)
    })), expanded || isClosing ? _react2.default.createElement(
      _expandRow2.default,
      {
        key: key + '-expanding',
        colSpan: props.visibleColumnSize,
        expanded: expanded,
        onClosed: function onClosed() {
          return expandRow.onClosed(key);
        },
        className: className
      },
      expandRow.renderer(props.row, props.rowIndex)
    ) : null];
  };
  return function (props) {
    return _react2.default.createElement(
      _rowExpandContext2.default.Consumer,
      null,
      function (expandRow) {
        return renderWithExpansion(props, expandRow);
      }
    );
  };
};
});

unwrapExports(rowConsumer$1);

var body = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _utils2 = _interopRequireDefault(utils$1);



var _simpleRow2 = _interopRequireDefault(simpleRow);



var _aggregateRow2 = _interopRequireDefault(aggregateRow);



var _rowSection2 = _interopRequireDefault(rowSection);



var _const2 = _interopRequireDefault(_const);



var _rowConsumer2 = _interopRequireDefault(rowConsumer);



var _rowConsumer4 = _interopRequireDefault(rowConsumer$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/require-default-props: 0 */

var Body = function (_React$Component) {
  _inherits(Body, _React$Component);

  function Body(props) {
    _classCallCheck(this, Body);

    var _this = _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).call(this, props));

    var keyField = props.keyField,
        cellEdit = props.cellEdit,
        selectRow = props.selectRow,
        expandRow = props.expandRow;

    // Construct Editing Cell Component

    if (cellEdit.createContext) {
      _this.EditingCell = cellEdit.createEditingCell(_utils2.default, cellEdit.options.onStartEdit);
    }

    // Construct Row Component
    var RowComponent = _simpleRow2.default;
    var selectRowEnabled = selectRow.mode !== _const2.default.ROW_SELECT_DISABLED;
    var expandRowEnabled = !!expandRow.renderer;

    if (expandRowEnabled) {
      RowComponent = (0, _rowConsumer4.default)(_aggregateRow2.default);
    }

    if (selectRowEnabled) {
      RowComponent = (0, _rowConsumer2.default)(expandRowEnabled ? RowComponent : _aggregateRow2.default);
    }

    if (cellEdit.createContext) {
      RowComponent = cellEdit.withRowLevelCellEdit(RowComponent, selectRowEnabled, keyField, _utils2.default);
    }
    _this.RowComponent = RowComponent;
    return _this;
  }

  _createClass(Body, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          columns = _props.columns,
          data = _props.data,
          tabIndexCell = _props.tabIndexCell,
          keyField = _props.keyField,
          isEmpty = _props.isEmpty,
          noDataIndication = _props.noDataIndication,
          visibleColumnSize = _props.visibleColumnSize,
          cellEdit = _props.cellEdit,
          selectRow = _props.selectRow,
          rowStyle = _props.rowStyle,
          rowClasses = _props.rowClasses,
          rowEvents = _props.rowEvents,
          expandRow = _props.expandRow,
          className = _props.className;


      var content = void 0;

      if (isEmpty) {
        var indication = _utils2.default.isFunction(noDataIndication) ? noDataIndication() : noDataIndication;
        if (!indication) {
          return null;
        }
        content = _react2.default.createElement(_rowSection2.default, { content: indication, colSpan: visibleColumnSize });
      } else {
        var selectRowEnabled = selectRow.mode !== _const2.default.ROW_SELECT_DISABLED;
        var expandRowEnabled = !!expandRow.renderer;

        var additionalRowProps = {};

        if (cellEdit.createContext) {
          additionalRowProps.EditingCellComponent = this.EditingCell;
        }

        if (selectRowEnabled || expandRowEnabled) {
          additionalRowProps.expandRow = expandRow;
          additionalRowProps.selectRow = selectRow;
        }

        content = data.map(function (row, index) {
          var key = _utils2.default.get(row, keyField);
          var baseRowProps = _extends({
            key: key,
            row: row,
            tabIndexCell: tabIndexCell,
            columns: columns,
            keyField: keyField,
            cellEdit: cellEdit,
            value: key,
            rowIndex: index,
            visibleColumnSize: visibleColumnSize,
            attrs: rowEvents || {}
          }, additionalRowProps);

          baseRowProps.style = _utils2.default.isFunction(rowStyle) ? rowStyle(row, index) : rowStyle;
          baseRowProps.className = _utils2.default.isFunction(rowClasses) ? rowClasses(row, index) : rowClasses;

          return _react2.default.createElement(_this2.RowComponent, baseRowProps);
        });
      }

      return _react2.default.createElement(
        'tbody',
        { className: className },
        content
      );
    }
  }]);

  return Body;
}(_react2.default.Component);

Body.propTypes = {
  keyField: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.array.isRequired,
  columns: _propTypes2.default.array.isRequired,
  selectRow: _propTypes2.default.object
};

exports.default = Body;
});

unwrapExports(body);

var footerCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _classnames2 = _interopRequireDefault(classnames);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _utils2 = _interopRequireDefault(utils$1);



var _cellEventDelegater2 = _interopRequireDefault(cellEventDelegater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */


var FooterCell = function (_eventDelegater) {
  _inherits(FooterCell, _eventDelegater);

  function FooterCell() {
    _classCallCheck(this, FooterCell);

    return _possibleConstructorReturn(this, (FooterCell.__proto__ || Object.getPrototypeOf(FooterCell)).apply(this, arguments));
  }

  _createClass(FooterCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          index = _props.index,
          column = _props.column,
          columnData = _props.columnData;
      var footer = column.footer,
          footerTitle = column.footerTitle,
          footerAlign = column.footerAlign,
          footerFormatter = column.footerFormatter,
          footerEvents = column.footerEvents,
          footerClasses = column.footerClasses,
          footerStyle = column.footerStyle,
          footerAttrs = column.footerAttrs;


      var delegateEvents = this.delegate(footerEvents);
      var cellAttrs = _extends({}, _utils2.default.isFunction(footerAttrs) ? footerAttrs(column, index) : footerAttrs, delegateEvents);

      var text = '';
      if (_utils2.default.isString(footer)) {
        text = footer;
      } else if (_utils2.default.isFunction(footer)) {
        text = footer(columnData, column, index);
      }

      var cellStyle = {};
      var cellClasses = _utils2.default.isFunction(footerClasses) ? footerClasses(column, index) : footerClasses;

      if (footerStyle) {
        cellStyle = _utils2.default.isFunction(footerStyle) ? footerStyle(column, index) : footerStyle;
        cellStyle = cellStyle ? _extends({}, cellStyle) : cellStyle;
      }

      if (footerTitle) {
        cellAttrs.title = _utils2.default.isFunction(footerTitle) ? footerTitle(column, index) : text;
      }

      if (footerAlign) {
        cellStyle.textAlign = _utils2.default.isFunction(footerAlign) ? footerAlign(column, index) : footerAlign;
      }

      if (cellClasses) cellAttrs.className = (0, _classnames2.default)(cellAttrs.className, cellClasses);
      if (!_utils2.default.isEmptyObject(cellStyle)) cellAttrs.style = cellStyle;

      var children = footerFormatter ? footerFormatter(column, index) : text;

      return _react2.default.createElement('th', cellAttrs, children);
    }
  }]);

  return FooterCell;
}((0, _cellEventDelegater2.default)(_react2.default.Component));

FooterCell.propTypes = {
  columnData: _propTypes2.default.array,
  index: _propTypes2.default.number,
  column: _propTypes2.default.object
};

exports.default = FooterCell;
});

unwrapExports(footerCell);

var footer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _rowTemplate2 = _interopRequireDefault(rowTemplate);



var _footerCell2 = _interopRequireDefault(footerCell);



var _utils2 = _interopRequireDefault(utils$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(props) {
  var data = props.data,
      className = props.className,
      columns = props.columns,
      selectRow = props.selectRow,
      expandRow = props.expandRow;


  function renderContent() {
    return columns.map(function (column, i) {
      if (column.footer === undefined || column.footer === null) {
        return false;
      }

      var columnData = _utils2.default.pluck(data, column.dataField);

      return _react2.default.createElement(_footerCell2.default, {
        index: i,
        key: column.dataField,
        column: column,
        columnData: columnData
      });
    });
  }

  return _react2.default.createElement(
    'tfoot',
    null,
    _react2.default.createElement(_rowTemplate2.default, {
      renderContent: renderContent,
      selectRow: selectRow,
      expandRow: expandRow,
      className: className,
      cellEl: 'th'
    })
  );
}; /* eslint react/require-default-props: 0 */


Footer.propTypes = {
  data: _propTypes2.default.array,
  className: _propTypes2.default.string,
  columns: _propTypes2.default.array,
  selectRow: _propTypes2.default.object,
  expandRow: _propTypes2.default.object
};

exports.default = Footer;
});

unwrapExports(footer);

var columnResolver = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(ColumnResolver, _ExtendBase);

    function ColumnResolver() {
      _classCallCheck(this, ColumnResolver);

      return _possibleConstructorReturn(this, (ColumnResolver.__proto__ || Object.getPrototypeOf(ColumnResolver)).apply(this, arguments));
    }

    _createClass(ColumnResolver, [{
      key: "visibleColumnSize",
      value: function visibleColumnSize() {
        var includeSelectColumn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        var columnLen = void 0;
        if (this.props.columnToggle && this.props.columnToggle.toggles) {
          var columns = this.props.columnToggle.toggles;
          columnLen = Object.keys(columns).filter(function (name) {
            return columns[name];
          }).length;
        } else {
          columnLen = this.props.columns.filter(function (c) {
            return !c.hidden;
          }).length;
        }
        if (!includeSelectColumn) return columnLen;
        if (this.props.selectRow && !this.props.selectRow.hideSelectColumn) {
          columnLen += 1;
        }
        if (this.props.expandRow && this.props.expandRow.showExpandColumn) {
          columnLen += 1;
        }
        return columnLen;
      }
    }]);

    return ColumnResolver;
  }(ExtendBase);
};
});

unwrapExports(columnResolver);

var propsResolver = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _utils2 = _interopRequireDefault(utils$1);



var _columnResolver2 = _interopRequireDefault(columnResolver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (ExtendBase) {
  return function (_ColumnResolver) {
    _inherits(TableResolver, _ColumnResolver);

    function TableResolver() {
      _classCallCheck(this, TableResolver);

      return _possibleConstructorReturn(this, (TableResolver.__proto__ || Object.getPrototypeOf(TableResolver)).apply(this, arguments));
    }

    _createClass(TableResolver, [{
      key: 'validateProps',
      value: function validateProps() {
        var keyField = this.props.keyField;

        if (!keyField) {
          throw new Error('Please specify a field as key via keyField');
        }
        if (this.visibleColumnSize(false) <= 0) {
          throw new Error('No visible columns detected');
        }
      }
    }, {
      key: 'isEmpty',
      value: function isEmpty() {
        return this.props.data.length === 0;
      }
    }, {
      key: 'visibleRows',
      value: function visibleRows() {
        var _props = this.props,
            data = _props.data,
            hiddenRows = _props.hiddenRows,
            keyField = _props.keyField;

        if (!hiddenRows || hiddenRows.length === 0) return data;
        return data.filter(function (row) {
          var key = _utils2.default.get(row, keyField);
          return !_utils2.default.contains(hiddenRows, key);
        });
      }
    }]);

    return TableResolver;
  }((0, _columnResolver2.default)(ExtendBase));
};
});

unwrapExports(propsResolver);

var bootstrapTable = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _classnames2 = _interopRequireDefault(classnames);



var _header2 = _interopRequireDefault(header);



var _filters2 = _interopRequireDefault(filters);



var _caption2 = _interopRequireDefault(caption);



var _body2 = _interopRequireDefault(body);



var _footer2 = _interopRequireDefault(footer);



var _propsResolver2 = _interopRequireDefault(propsResolver);



var _const2 = _interopRequireDefault(_const);



var _utils2 = _interopRequireDefault(utils$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */
/* eslint arrow-body-style: 0 */

var BootstrapTable = function (_PropsBaseResolver) {
  _inherits(BootstrapTable, _PropsBaseResolver);

  function BootstrapTable(props) {
    _classCallCheck(this, BootstrapTable);

    var _this = _possibleConstructorReturn(this, (BootstrapTable.__proto__ || Object.getPrototypeOf(BootstrapTable)).call(this, props));

    _this.getData = function () {
      return _this.visibleRows();
    };

    _this.validateProps();
    return _this;
  }

  _createClass(BootstrapTable, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.onDataSizeChange && !nextProps.pagination) {
        if (nextProps.data.length !== this.props.data.length) {
          nextProps.onDataSizeChange({ dataSize: nextProps.data.length });
        }
      }
    }

    // Exposed APIs

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          overlay = _props.overlay;

      if (overlay) {
        var LoadingOverlay = overlay(loading);
        return _react2.default.createElement(
          LoadingOverlay,
          null,
          this.renderTable()
        );
      }
      return this.renderTable();
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      var _props2 = this.props,
          columns = _props2.columns,
          keyField = _props2.keyField,
          tabIndexCell = _props2.tabIndexCell,
          id = _props2.id,
          classes = _props2.classes,
          bootstrap4 = _props2.bootstrap4,
          striped = _props2.striped,
          hover = _props2.hover,
          bordered = _props2.bordered,
          condensed = _props2.condensed,
          noDataIndication = _props2.noDataIndication,
          caption = _props2.caption,
          rowStyle = _props2.rowStyle,
          rowClasses = _props2.rowClasses,
          wrapperClasses = _props2.wrapperClasses,
          rowEvents = _props2.rowEvents,
          selectRow = _props2.selectRow,
          expandRow = _props2.expandRow,
          cellEdit = _props2.cellEdit,
          filterPosition = _props2.filterPosition;


      var tableWrapperClass = (0, _classnames2.default)('react-bootstrap-table', wrapperClasses);

      var tableClass = (0, _classnames2.default)('table', _defineProperty({
        'table-striped': striped,
        'table-hover': hover,
        'table-bordered': bordered
      }, bootstrap4 ? 'table-sm' : 'table-condensed', condensed), classes);

      var hasFilters = columns.some(function (col) {
        return col.filter || col.filterRenderer;
      });

      var hasFooter = _utils2.default.filter(columns, function (col) {
        return _utils2.default.has(col, 'footer');
      }).length > 0;

      var tableCaption = caption && _react2.default.createElement(
        _caption2.default,
        { bootstrap4: bootstrap4 },
        caption
      );

      return _react2.default.createElement(
        'div',
        { className: tableWrapperClass },
        _react2.default.createElement(
          'table',
          { id: id, className: tableClass },
          tableCaption,
          _react2.default.createElement(_header2.default, {
            columns: columns,
            className: this.props.headerClasses,
            wrapperClasses: this.props.headerWrapperClasses,
            sortField: this.props.sortField,
            sortOrder: this.props.sortOrder,
            onSort: this.props.onSort,
            globalSortCaret: this.props.sort && this.props.sort.sortCaret,
            onFilter: this.props.onFilter,
            currFilters: this.props.currFilters,
            onExternalFilter: this.props.onExternalFilter,
            selectRow: selectRow,
            expandRow: expandRow,
            filterPosition: filterPosition
          }),
          hasFilters && filterPosition !== _const2.default.FILTERS_POSITION_INLINE && _react2.default.createElement(_filters2.default, {
            columns: columns,
            className: this.props.filtersClasses,
            onSort: this.props.onSort,
            onFilter: this.props.onFilter,
            currFilters: this.props.currFilters,
            filterPosition: this.props.filterPosition,
            onExternalFilter: this.props.onExternalFilter,
            selectRow: selectRow,
            expandRow: expandRow
          }),
          _react2.default.createElement(_body2.default, {
            className: this.props.bodyClasses,
            data: this.getData(),
            keyField: keyField,
            tabIndexCell: tabIndexCell,
            columns: columns,
            isEmpty: this.isEmpty(),
            visibleColumnSize: this.visibleColumnSize(),
            noDataIndication: noDataIndication,
            cellEdit: cellEdit,
            selectRow: selectRow,
            expandRow: expandRow,
            rowStyle: rowStyle,
            rowClasses: rowClasses,
            rowEvents: rowEvents
          }),
          hasFooter && _react2.default.createElement(_footer2.default, {
            data: this.getData(),
            columns: columns,
            selectRow: selectRow,
            expandRow: expandRow,
            className: this.props.footerClasses
          })
        )
      );
    }
  }]);

  return BootstrapTable;
}((0, _propsResolver2.default)(React__default['default'].Component));

BootstrapTable.propTypes = {
  keyField: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.array.isRequired,
  columns: _propTypes2.default.array.isRequired,
  bootstrap4: _propTypes2.default.bool,
  remote: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    pagination: _propTypes2.default.bool
  })]),
  noDataIndication: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  striped: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  hover: _propTypes2.default.bool,
  tabIndexCell: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  classes: _propTypes2.default.string,
  headerClasses: _propTypes2.default.string,
  bodyClasses: _propTypes2.default.string,
  wrapperClasses: _propTypes2.default.string,
  headerWrapperClasses: _propTypes2.default.string,
  condensed: _propTypes2.default.bool,
  caption: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  pagination: _propTypes2.default.object,
  filter: _propTypes2.default.object,
  cellEdit: _propTypes2.default.object,
  selectRow: _propTypes2.default.shape({
    mode: _propTypes2.default.oneOf([_const2.default.ROW_SELECT_SINGLE, _const2.default.ROW_SELECT_MULTIPLE, _const2.default.ROW_SELECT_DISABLED]).isRequired,
    clickToSelect: _propTypes2.default.bool,
    clickToExpand: _propTypes2.default.bool,
    clickToEdit: _propTypes2.default.bool,
    hideSelectAll: _propTypes2.default.bool,
    onSelect: _propTypes2.default.func,
    onSelectAll: _propTypes2.default.func,
    style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    classes: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    nonSelectable: _propTypes2.default.array,
    nonSelectableStyle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    nonSelectableClasses: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    bgColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    hideSelectColumn: _propTypes2.default.bool,
    selectionRenderer: _propTypes2.default.func,
    selectionHeaderRenderer: _propTypes2.default.func,
    headerColumnStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    selectColumnStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    selectColumnPosition: _propTypes2.default.oneOf([_const2.default.INDICATOR_POSITION_LEFT, _const2.default.INDICATOR_POSITION_RIGHT])
  }),
  expandRow: _propTypes2.default.shape({
    renderer: _propTypes2.default.func,
    expanded: _propTypes2.default.array,
    onExpand: _propTypes2.default.func,
    onExpandAll: _propTypes2.default.func,
    nonExpandable: _propTypes2.default.array,
    showExpandColumn: _propTypes2.default.bool,
    onlyOneExpanding: _propTypes2.default.bool,
    expandByColumnOnly: _propTypes2.default.bool,
    expandColumnRenderer: _propTypes2.default.func,
    expandHeaderColumnRenderer: _propTypes2.default.func,
    expandColumnPosition: _propTypes2.default.oneOf([_const2.default.INDICATOR_POSITION_LEFT, _const2.default.INDICATOR_POSITION_RIGHT]),
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    parentClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
  }),
  rowStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  rowEvents: _propTypes2.default.object,
  rowClasses: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  filtersClasses: _propTypes2.default.string,
  filterPosition: _propTypes2.default.oneOf([_const2.default.FILTERS_POSITION_TOP, _const2.default.FILTERS_POSITION_INLINE, _const2.default.FILTERS_POSITION_BOTTOM]),
  footerClasses: _propTypes2.default.string,
  defaultSorted: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    dataField: _propTypes2.default.string.isRequired,
    order: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC]).isRequired
  })),
  sort: _propTypes2.default.shape({
    dataField: _propTypes2.default.string,
    order: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC]),
    sortFunc: _propTypes2.default.func,
    sortCaret: _propTypes2.default.func
  }),
  defaultSortDirection: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC]),
  overlay: _propTypes2.default.func,
  onTableChange: _propTypes2.default.func,
  onSort: _propTypes2.default.func,
  onFilter: _propTypes2.default.func,
  onExternalFilter: _propTypes2.default.func,
  onDataSizeChange: _propTypes2.default.func,
  // Inject from toolkit
  search: _propTypes2.default.shape({
    searchText: _propTypes2.default.string,
    searchContext: _propTypes2.default.func
  }),
  setDependencyModules: _propTypes2.default.func
};

BootstrapTable.defaultProps = {
  bootstrap4: false,
  remote: false,
  striped: false,
  bordered: true,
  hover: false,
  condensed: false,
  noDataIndication: null,
  selectRow: {
    mode: _const2.default.ROW_SELECT_DISABLED,
    selected: [],
    hideSelectColumn: true
  },
  expandRow: {
    renderer: undefined,
    expanded: [],
    nonExpandable: []
  },
  cellEdit: {
    mode: null,
    nonEditableRows: []
  },
  filterPosition: _const2.default.FILTERS_POSITION_INLINE
};

exports.default = BootstrapTable;
});

unwrapExports(bootstrapTable);

var dataContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */


exports.default = function () {
  var DataContext = _react2.default.createContext();

  var DataProvider = function (_Component) {
    _inherits(DataProvider, _Component);

    function DataProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, DataProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataProvider.__proto__ || Object.getPrototypeOf(DataProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = { data: _this.props.data }, _this.getData = function (filterProps, searchProps, sortProps, paginationProps) {
        if (paginationProps) return paginationProps.data;else if (sortProps) return sortProps.data;else if (searchProps) return searchProps.data;else if (filterProps) return filterProps.data;
        return _this.props.data;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DataProvider, [{
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState(function () {
          return { data: nextProps.data };
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          DataContext.Provider,
          {
            value: {
              data: this.state.data,
              getData: this.getData
            }
          },
          this.props.children
        );
      }
    }]);

    return DataProvider;
  }(React__default['default'].Component);

  DataProvider.propTypes = {
    data: _propTypes2.default.array.isRequired,
    children: _propTypes2.default.node.isRequired
  };

  return {
    Provider: DataProvider,
    Consumer: DataContext.Consumer
  };
};
});

unwrapExports(dataContext);

var columnContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/prefer-stateless-function: 0 */


exports.default = function () {
  var ColumnManagementContext = _react2.default.createContext();

  var ColumnManagementProvider = function (_React$Component) {
    _inherits(ColumnManagementProvider, _React$Component);

    function ColumnManagementProvider() {
      _classCallCheck(this, ColumnManagementProvider);

      return _possibleConstructorReturn(this, (ColumnManagementProvider.__proto__ || Object.getPrototypeOf(ColumnManagementProvider)).apply(this, arguments));
    }

    _createClass(ColumnManagementProvider, [{
      key: 'render',
      value: function render() {
        var toggleColumn = void 0;
        var _props = this.props,
            columns = _props.columns,
            toggles = _props.toggles;

        if (toggles) {
          toggleColumn = columns.filter(function (column) {
            return toggles[column.dataField];
          });
        } else {
          toggleColumn = columns.filter(function (column) {
            return !column.hidden;
          });
        }
        return _react2.default.createElement(
          ColumnManagementContext.Provider,
          { value: { columns: toggleColumn } },
          this.props.children
        );
      }
    }]);

    return ColumnManagementProvider;
  }(_react2.default.Component);

  ColumnManagementProvider.propTypes = {
    columns: _propTypes2.default.array.isRequired,
    toggles: _propTypes2.default.object
  };
  ColumnManagementProvider.defaultProps = {
    toggles: null
  };


  return {
    Provider: ColumnManagementProvider,
    Consumer: ColumnManagementContext.Consumer
  };
};
});

unwrapExports(columnContext);

var sortContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */
/* eslint react/require-default-props: 0 */


exports.default = function (dataOperator, isRemoteSort, handleSortChange) {
  var SortContext = _react2.default.createContext();

  var SortProvider = function (_React$Component) {
    _inherits(SortProvider, _React$Component);

    function SortProvider(props) {
      _classCallCheck(this, SortProvider);

      var _this = _possibleConstructorReturn(this, (SortProvider.__proto__ || Object.getPrototypeOf(SortProvider)).call(this, props));

      _initialiseProps.call(_this);

      var sortOrder = void 0;
      var sortColumn = void 0;
      var defaultSorted = props.defaultSorted,
          defaultSortDirection = props.defaultSortDirection,
          sort = props.sort;


      if (defaultSorted && defaultSorted.length > 0) {
        sortOrder = defaultSorted[0].order || defaultSortDirection;
        sortColumn = _this.initSort(defaultSorted[0].dataField, sortOrder);
      } else if (sort && sort.dataField && sort.order) {
        sortOrder = sort.order;
        sortColumn = _this.initSort(sort.dataField, sortOrder);
      }
      _this.state = { sortOrder: sortOrder, sortColumn: sortColumn };
      return _this;
    }

    _createClass(SortProvider, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _state = this.state,
            sortOrder = _state.sortOrder,
            sortColumn = _state.sortColumn;

        if (isRemoteSort() && sortOrder && sortColumn) {
          handleSortChange(sortColumn.dataField, sortOrder);
        }
      }
    }, {
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var sort = nextProps.sort,
            columns = nextProps.columns;

        if (sort && sort.dataField && sort.order) {
          this.setState({
            sortOrder: sort.order,
            sortColumn: columns.find(function (col) {
              return col.dataField === sort.dataField;
            })
          });
        }
      }
    }, {
      key: 'initSort',
      value: function initSort(sortField, sortOrder) {
        var sortColumn = void 0;
        var columns = this.props.columns;

        var sortColumns = columns.filter(function (col) {
          return col.dataField === sortField;
        });
        if (sortColumns.length > 0) {
          sortColumn = sortColumns[0];

          if (sortColumn.onSort) {
            sortColumn.onSort(sortField, sortOrder);
          }
        }
        return sortColumn;
      }
    }, {
      key: 'render',
      value: function render() {
        var data = this.props.data;
        var sort = this.props.sort;
        var _state2 = this.state,
            sortOrder = _state2.sortOrder,
            sortColumn = _state2.sortColumn;

        if (!isRemoteSort() && sortColumn) {
          var sortFunc = sortColumn.sortFunc ? sortColumn.sortFunc : sort && sort.sortFunc;
          data = dataOperator.sort(data, sortOrder, _extends({}, sortColumn, { sortFunc: sortFunc }));
        }

        return _react2.default.createElement(
          SortContext.Provider,
          {
            value: {
              data: data,
              sortOrder: sortOrder,
              onSort: this.handleSort,
              sortField: sortColumn ? sortColumn.dataField : null
            }
          },
          this.props.children
        );
      }
    }]);

    return SortProvider;
  }(_react2.default.Component);

  SortProvider.propTypes = {
    data: _propTypes2.default.array.isRequired,
    columns: _propTypes2.default.array.isRequired,
    children: _propTypes2.default.node.isRequired,
    defaultSorted: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      dataField: _propTypes2.default.string.isRequired,
      order: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC]).isRequired
    })),
    sort: _propTypes2.default.shape({
      dataField: _propTypes2.default.string,
      order: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC]),
      sortFunc: _propTypes2.default.func
    }),
    defaultSortDirection: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC])
  };

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handleSort = function (column) {
      var sortOrder = dataOperator.nextOrder(column, _this2.state, _this2.props.defaultSortDirection);

      if (column.onSort) {
        column.onSort(column.dataField, sortOrder);
      }

      if (isRemoteSort()) {
        handleSortChange(column.dataField, sortOrder);
      }
      _this2.setState(function () {
        return {
          sortOrder: sortOrder,
          sortColumn: column
        };
      });
    };
  };

  return {
    Provider: SortProvider,
    Consumer: SortContext.Consumer
  };
};
});

unwrapExports(sortContext);

var remoteResolver = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _events2 = _interopRequireDefault(events__default['default']);



var _utils2 = _interopRequireDefault(utils$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(RemoteResolver, _ExtendBase);

    function RemoteResolver(props) {
      _classCallCheck(this, RemoteResolver);

      var _this = _possibleConstructorReturn(this, (RemoteResolver.__proto__ || Object.getPrototypeOf(RemoteResolver)).call(this, props));

      _this.getNewestState = function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var sortOrder = void 0;
        var sortField = void 0;
        var page = void 0;
        var sizePerPage = void 0;
        var searchText = void 0;
        var filters = {};

        if (_this.sortContext) {
          sortOrder = _this.sortContext.state.sortOrder;
          sortField = _this.sortContext.state.sortColumn ? _this.sortContext.state.sortColumn.dataField : null;
        }

        if (_this.filterContext) {
          filters = _this.filterContext.currFilters;
        }

        if (_this.paginationContext) {
          page = _this.paginationContext.currPage;
          sizePerPage = _this.paginationContext.currSizePerPage;
        }

        if (_this.searchContext) {
          searchText = _this.props.search.searchText;
        }

        return _extends({
          sortOrder: sortOrder,
          sortField: sortField,
          filters: filters,
          page: page,
          sizePerPage: sizePerPage,
          searchText: searchText
        }, state, {
          data: _this.props.data
        });
      };

      _this.isRemoteSearch = function () {
        var remote = _this.props.remote;

        return remote === true || _utils2.default.isObject(remote) && remote.search || _this.isRemotePagination();
      };

      _this.isRemotePagination = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var remote = _this.props.remote;

        e.result = remote === true || _utils2.default.isObject(remote) && remote.pagination;
        return e.result;
      };

      _this.isRemoteFiltering = function () {
        var remote = _this.props.remote;

        return remote === true || _utils2.default.isObject(remote) && remote.filter || _this.isRemotePagination();
      };

      _this.isRemoteSort = function () {
        var remote = _this.props.remote;

        return remote === true || _utils2.default.isObject(remote) && remote.sort || _this.isRemotePagination();
      };

      _this.isRemoteCellEdit = function () {
        var remote = _this.props.remote;

        return remote === true || _utils2.default.isObject(remote) && remote.cellEdit;
      };

      _this.handleRemotePageChange = function (page, sizePerPage) {
        _this.props.onTableChange('pagination', _this.getNewestState({ page: page, sizePerPage: sizePerPage }));
      };

      _this.handleRemoteFilterChange = function (filters) {
        var newState = { filters: filters };
        if (_this.isRemotePagination()) {
          var options = _this.props.pagination.options || {};
          newState.page = _utils2.default.isDefined(options.pageStartIndex) ? options.pageStartIndex : 1;
        }
        _this.props.onTableChange('filter', _this.getNewestState(newState));
      };

      _this.handleRemoteSortChange = function (sortField, sortOrder) {
        _this.props.onTableChange('sort', _this.getNewestState({ sortField: sortField, sortOrder: sortOrder }));
      };

      _this.handleRemoteCellChange = function (rowId, dataField, newValue) {
        var cellEdit = { rowId: rowId, dataField: dataField, newValue: newValue };
        _this.props.onTableChange('cellEdit', _this.getNewestState({ cellEdit: cellEdit }));
      };

      _this.handleRemoteSearchChange = function (searchText) {
        _this.props.onTableChange('search', _this.getNewestState({ searchText: searchText }));
      };

      _this.remoteEmitter = new _events2.default();
      _this.remoteEmitter.on('paginationChange', _this.handleRemotePageChange);
      _this.remoteEmitter.on('isRemotePagination', _this.isRemotePagination);
      return _this;
    }

    return RemoteResolver;
  }(ExtendBase);
};
});

unwrapExports(remoteResolver);

var contexts = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _events2 = _interopRequireDefault(events__default['default']);



var _utils2 = _interopRequireDefault(utils$1);



var _dataContext2 = _interopRequireDefault(dataContext);



var _columnContext2 = _interopRequireDefault(columnContext);



var _sortContext2 = _interopRequireDefault(sortContext);



var _selectionContext2 = _interopRequireDefault(selectionContext);



var _rowExpandContext2 = _interopRequireDefault(rowExpandContext);



var _remoteResolver3 = _interopRequireDefault(remoteResolver);





var _operators2 = _interopRequireDefault(operators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */
/* eslint no-return-assign: 0 */
/* eslint no-param-reassign: 0 */
/* eslint class-methods-use-this: 0 */


var withContext = function withContext(Base) {
  return function (_remoteResolver) {
    _inherits(BootstrapTableContainer, _remoteResolver);

    function BootstrapTableContainer(props) {
      _classCallCheck(this, BootstrapTableContainer);

      var _this = _possibleConstructorReturn(this, (BootstrapTableContainer.__proto__ || Object.getPrototypeOf(BootstrapTableContainer)).call(this, props));

      _this.DataContext = (0, _dataContext2.default)();

      if (props.registerExposedAPI) {
        var exposedAPIEmitter = new _events2.default();
        exposedAPIEmitter.on('get.table.data', function (payload) {
          return payload.result = _this.table.getData();
        });
        exposedAPIEmitter.on('get.selected.rows', function (payload) {
          return payload.result = _this.selectionContext.getSelected();
        });
        exposedAPIEmitter.on('get.filtered.rows', function (payload) {
          if (_this.searchContext) {
            payload.result = _this.searchContext.getSearched();
          } else if (_this.filterContext) {
            payload.result = _this.filterContext.getFiltered();
          } else {
            payload.result = _this.table.getData();
          }
        });
        props.registerExposedAPI(exposedAPIEmitter);
      }

      if (props.columns.filter(function (col) {
        return col.sort;
      }).length > 0) {
        _this.SortContext = (0, _sortContext2.default)(_operators2.default, _this.isRemoteSort, _this.handleRemoteSortChange);
      }

      if (props.columnToggle || props.columns.filter(function (col) {
        return col.hidden;
      }).length > 0) {
        _this.ColumnManagementContext = (0, _columnContext2.default)();
      }

      if (props.selectRow) {
        _this.SelectionContext = _selectionContext2.default;
      }

      if (props.expandRow) {
        _this.RowExpandContext = _rowExpandContext2.default;
      }

      if (props.cellEdit && props.cellEdit.createContext) {
        _this.CellEditContext = props.cellEdit.createContext(_utils2.default, _operators2.default, _this.isRemoteCellEdit, _this.handleRemoteCellChange);
      }

      if (props.filter) {
        _this.FilterContext = props.filter.createContext(_utils2.default, _this.isRemoteFiltering, _this.handleRemoteFilterChange);
      }

      if (props.pagination) {
        _this.PaginationContext = props.pagination.createContext();
      }

      if (props.search && props.search.searchContext) {
        _this.SearchContext = props.search.searchContext(_utils2.default, _this.isRemoteSearch, _this.handleRemoteSearchChange);
      }

      if (props.setDependencyModules) {
        props.setDependencyModules(_utils2.default);
      }

      if (props.setPaginationRemoteEmitter) {
        props.setPaginationRemoteEmitter(_this.remoteEmitter);
      }
      return _this;
    }

    _createClass(BootstrapTableContainer, [{
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.columns.filter(function (col) {
          return col.sort;
        }).length <= 0) {
          this.SortContext = null;
        } else if (!this.SortContext) {
          this.SortContext = (0, _sortContext2.default)(_operators2.default, this.isRemoteSort, this.handleRemoteSortChange);
        }
        if (!nextProps.pagination && this.props.pagination) {
          this.PaginationContext = null;
        }
        if (nextProps.pagination && !this.props.pagination) {
          this.PaginationContext = nextProps.pagination.createContext(this.isRemotePagination, this.handleRemotePageChange);
        }
        if (!nextProps.cellEdit && this.props.cellEdit) {
          this.CellEditContext = null;
        }
        if (nextProps.cellEdit && !this.props.cellEdit) {
          this.CellEditContext = nextProps.cellEdit.createContext(_utils2.default, _operators2.default, this.isRemoteCellEdit, this.handleRemoteCellChange);
        }
      }
    }, {
      key: 'renderBase',
      value: function renderBase() {
        var _this2 = this;

        return function (rootProps, filterProps, searchProps, sortProps, paginationProps, columnToggleProps) {
          return _react2.default.createElement(Base, _extends({
            ref: function ref(n) {
              return _this2.table = n;
            }
          }, _this2.props, sortProps, filterProps, searchProps, paginationProps, columnToggleProps, {
            data: rootProps.getData(filterProps, searchProps, sortProps, paginationProps)
          }));
        };
      }
    }, {
      key: 'renderWithColumnManagementCtx',
      value: function renderWithColumnManagementCtx(base, baseProps) {
        var _this3 = this;

        return function (rootProps, filterProps, searchProps, sortProps, paginationProps) {
          return _react2.default.createElement(
            _this3.ColumnManagementContext.Provider,
            _extends({}, baseProps, {
              toggles: _this3.props.columnToggle ? _this3.props.columnToggle.toggles : null
            }),
            _react2.default.createElement(
              _this3.ColumnManagementContext.Consumer,
              null,
              function (columnToggleProps) {
                return base(rootProps, filterProps, searchProps, sortProps, paginationProps, columnToggleProps);
              }
            )
          );
        };
      }
    }, {
      key: 'renderWithSelectionCtx',
      value: function renderWithSelectionCtx(base, baseProps) {
        var _this4 = this;

        return function (rootProps, filterProps, searchProps, sortProps, paginationProps) {
          return _react2.default.createElement(
            _this4.SelectionContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this4.selectionContext = n;
              },
              selectRow: _this4.props.selectRow,
              data: rootProps.getData(filterProps, searchProps, sortProps, paginationProps)
            }),
            base(rootProps, filterProps, searchProps, sortProps, paginationProps)
          );
        };
      }
    }, {
      key: 'renderWithRowExpandCtx',
      value: function renderWithRowExpandCtx(base, baseProps) {
        var _this5 = this;

        return function (rootProps, filterProps, searchProps, sortProps, paginationProps) {
          return _react2.default.createElement(
            _this5.RowExpandContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this5.rowExpandContext = n;
              },
              expandRow: _this5.props.expandRow,
              data: rootProps.getData(filterProps, searchProps, sortProps, paginationProps)
            }),
            base(rootProps, filterProps, searchProps, sortProps, paginationProps)
          );
        };
      }
    }, {
      key: 'renderWithPaginationCtx',
      value: function renderWithPaginationCtx(base) {
        var _this6 = this;

        return function (rootProps, filterProps, searchProps, sortProps) {
          return _react2.default.createElement(
            _this6.PaginationContext.Provider,
            {
              ref: function ref(n) {
                return _this6.paginationContext = n;
              },
              pagination: _this6.props.pagination,
              data: rootProps.getData(filterProps, searchProps, sortProps),
              bootstrap4: _this6.props.bootstrap4,
              isRemotePagination: _this6.isRemotePagination,
              remoteEmitter: _this6.remoteEmitter,
              onDataSizeChange: _this6.props.onDataSizeChange
            },
            _react2.default.createElement(
              _this6.PaginationContext.Consumer,
              null,
              function (paginationProps) {
                return base(rootProps, filterProps, searchProps, sortProps, paginationProps);
              }
            )
          );
        };
      }
    }, {
      key: 'renderWithSortCtx',
      value: function renderWithSortCtx(base, baseProps) {
        var _this7 = this;

        return function (rootProps, filterProps, searchProps) {
          return _react2.default.createElement(
            _this7.SortContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this7.sortContext = n;
              },
              defaultSorted: _this7.props.defaultSorted,
              defaultSortDirection: _this7.props.defaultSortDirection,
              sort: _this7.props.sort,
              data: rootProps.getData(filterProps, searchProps)
            }),
            _react2.default.createElement(
              _this7.SortContext.Consumer,
              null,
              function (sortProps) {
                return base(rootProps, filterProps, searchProps, sortProps);
              }
            )
          );
        };
      }
    }, {
      key: 'renderWithSearchCtx',
      value: function renderWithSearchCtx(base, baseProps) {
        var _this8 = this;

        return function (rootProps, filterProps) {
          return _react2.default.createElement(
            _this8.SearchContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this8.searchContext = n;
              },
              data: rootProps.getData(filterProps),
              searchText: _this8.props.search.searchText,
              dataChangeListener: _this8.props.dataChangeListener
            }),
            _react2.default.createElement(
              _this8.SearchContext.Consumer,
              null,
              function (searchProps) {
                return base(rootProps, filterProps, searchProps);
              }
            )
          );
        };
      }
    }, {
      key: 'renderWithFilterCtx',
      value: function renderWithFilterCtx(base, baseProps) {
        var _this9 = this;

        return function (rootProps) {
          return _react2.default.createElement(
            _this9.FilterContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this9.filterContext = n;
              },
              data: rootProps.getData(),
              dataChangeListener: _this9.props.dataChangeListener
            }),
            _react2.default.createElement(
              _this9.FilterContext.Consumer,
              null,
              function (filterProps) {
                return base(rootProps, filterProps);
              }
            )
          );
        };
      }
    }, {
      key: 'renderWithCellEditCtx',
      value: function renderWithCellEditCtx(base, baseProps) {
        var _this10 = this;

        return function (rootProps) {
          return _react2.default.createElement(
            _this10.CellEditContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this10.cellEditContext = n;
              },
              selectRow: _this10.props.selectRow,
              cellEdit: _this10.props.cellEdit,
              data: rootProps.getData()
            }),
            base(rootProps)
          );
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            keyField = _props.keyField,
            columns = _props.columns,
            bootstrap4 = _props.bootstrap4;

        var baseProps = { keyField: keyField, columns: columns };

        var base = this.renderBase();

        if (this.ColumnManagementContext) {
          base = this.renderWithColumnManagementCtx(base, baseProps);
        }

        if (this.SelectionContext) {
          base = this.renderWithSelectionCtx(base, baseProps);
        }

        if (this.RowExpandContext) {
          base = this.renderWithRowExpandCtx(base, baseProps);
        }

        if (this.PaginationContext) {
          base = this.renderWithPaginationCtx(base, baseProps);
        }

        if (this.SortContext) {
          base = this.renderWithSortCtx(base, baseProps);
        }

        if (this.SearchContext) {
          base = this.renderWithSearchCtx(base, baseProps);
        }

        if (this.FilterContext) {
          base = this.renderWithFilterCtx(base, baseProps);
        }

        if (this.CellEditContext) {
          base = this.renderWithCellEditCtx(base, baseProps);
        }

        return _react2.default.createElement(
          bootstrap.BootstrapContext.Provider,
          { value: { bootstrap4: bootstrap4 } },
          _react2.default.createElement(
            this.DataContext.Provider,
            _extends({}, baseProps, {
              data: this.props.data
            }),
            _react2.default.createElement(
              this.DataContext.Consumer,
              null,
              base
            )
          )
        );
      }
    }]);

    return BootstrapTableContainer;
  }((0, _remoteResolver3.default)(React__default['default'].Component));
};

exports.default = withContext;
});

unwrapExports(contexts);

var lib$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _bootstrapTable2 = _interopRequireDefault(bootstrapTable);



var _contexts2 = _interopRequireDefault(contexts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _contexts2.default)(_bootstrapTable2.default);
});

var BootstrapTable = unwrapExports(lib$1);

var _const$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  PAGINATION_SIZE: 5,
  PAGE_START_INDEX: 1,
  With_FIRST_AND_LAST: true,
  SHOW_ALL_PAGE_BTNS: false,
  SHOW_TOTAL: false,
  PAGINATION_TOTAL: null,
  FIRST_PAGE_TEXT: '<<',
  PRE_PAGE_TEXT: '<',
  NEXT_PAGE_TEXT: '>',
  LAST_PAGE_TEXT: '>>',
  NEXT_PAGE_TITLE: 'next page',
  LAST_PAGE_TITLE: 'last page',
  PRE_PAGE_TITLE: 'previous page',
  FIRST_PAGE_TITLE: 'first page',
  SIZE_PER_PAGE_LIST: [10, 25, 30, 50],
  HIDE_SIZE_PER_PAGE: false,
  HIDE_PAGE_LIST_ONLY_ONE_PAGE: false
};
});

unwrapExports(_const$1);

var page = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getByCurrPage = exports.alignPage = undefined;



var _const2 = _interopRequireDefault(_const$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNormalizedPage = function getNormalizedPage(page, pageStartIndex) {
  var offset = Math.abs(1 - pageStartIndex);
  return page + offset;
};

var endIndex = function endIndex(page, sizePerPage, pageStartIndex) {
  return getNormalizedPage(page, pageStartIndex) * sizePerPage - 1;
};

var startIndex = function startIndex(end, sizePerPage) {
  return end - (sizePerPage - 1);
};

var alignPage = exports.alignPage = function alignPage(dataSize, prevDataSize, page, sizePerPage, pageStartIndex) {
  if (prevDataSize < dataSize) return page;
  if (page < pageStartIndex) return pageStartIndex;
  if (dataSize <= 0) return pageStartIndex;
  if (page >= Math.floor(dataSize / sizePerPage) + pageStartIndex && pageStartIndex === 1) {
    return Math.ceil(dataSize / sizePerPage);
  }
  if (page >= Math.floor(dataSize / sizePerPage) && pageStartIndex === 0) {
    var newPage = Math.ceil(dataSize / sizePerPage);
    return newPage - Math.abs(_const2.default.PAGE_START_INDEX - pageStartIndex);
  }
  return page;
};

var getByCurrPage = exports.getByCurrPage = function getByCurrPage(data, page, sizePerPage, pageStartIndex) {
  var dataSize = data.length;
  if (!dataSize) return [];

  var end = endIndex(page, sizePerPage, pageStartIndex);
  var start = startIndex(end, sizePerPage);

  var result = [];
  for (var i = start; i <= end; i += 1) {
    result.push(data[i]);
    if (i + 1 === dataSize) break;
  }
  return result;
};
});

unwrapExports(page);
var page_1 = page.getByCurrPage;
var page_2 = page.alignPage;

var stateContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _events2 = _interopRequireDefault(events__default['default']);



var _const2 = _interopRequireDefault(_const$1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/require-default-props: 0 */
/* eslint no-lonely-if: 0 */
/* eslint camelcase: 0 */


var StateContext = _react2.default.createContext();

var StateProvider = function (_React$Component) {
  _inherits(StateProvider, _React$Component);

  function StateProvider(props) {
    _classCallCheck(this, StateProvider);

    var _this = _possibleConstructorReturn(this, (StateProvider.__proto__ || Object.getPrototypeOf(StateProvider)).call(this, props));

    _initialiseProps.call(_this);

    _this.handleChangePage = _this.handleChangePage.bind(_this);
    _this.handleDataSizeChange = _this.handleDataSizeChange.bind(_this);
    _this.handleChangeSizePerPage = _this.handleChangeSizePerPage.bind(_this);

    var currPage = void 0;
    var currSizePerPage = void 0;
    var options = props.pagination.options;

    var sizePerPageList = options.sizePerPageList || _const2.default.SIZE_PER_PAGE_LIST;

    // initialize current page
    if (typeof options.page !== 'undefined') {
      currPage = options.page;
    } else if (typeof options.pageStartIndex !== 'undefined') {
      currPage = options.pageStartIndex;
    } else {
      currPage = _const2.default.PAGE_START_INDEX;
    }

    // initialize current sizePerPage
    if (typeof options.sizePerPage !== 'undefined') {
      currSizePerPage = options.sizePerPage;
    } else if (_typeof(sizePerPageList[0]) === 'object') {
      currSizePerPage = sizePerPageList[0].value;
    } else {
      currSizePerPage = sizePerPageList[0];
    }

    _this.currPage = currPage;
    _this.dataSize = options.totalSize;
    _this.currSizePerPage = currSizePerPage;
    _this.dataChangeListener = new _events2.default();
    _this.dataChangeListener.on('filterChanged', _this.handleDataSizeChange);
    return _this;
  }

  _createClass(StateProvider, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var custom = nextProps.pagination.options.custom;

      // user should align the page when the page is not fit to the data size when remote enable

      if (this.isRemotePagination() || custom) {
        if (typeof nextProps.pagination.options.page !== 'undefined') {
          this.currPage = nextProps.pagination.options.page;
        }
        if (typeof nextProps.pagination.options.sizePerPage !== 'undefined') {
          this.currSizePerPage = nextProps.pagination.options.sizePerPage;
        }
        if (typeof nextProps.pagination.options.totalSize !== 'undefined') {
          this.dataSize = nextProps.pagination.options.totalSize;
        }
      }
    }
  }, {
    key: 'handleDataSizeChange',
    value: function handleDataSizeChange(newDataSize) {
      var options = this.props.pagination.options;

      var pageStartIndex = typeof options.pageStartIndex === 'undefined' ? _const2.default.PAGE_START_INDEX : options.pageStartIndex;
      this.currPage = (0, page.alignPage)(newDataSize, this.dataSize, this.currPage, this.currSizePerPage, pageStartIndex);
      this.dataSize = newDataSize;
      this.forceUpdate();
    }
  }, {
    key: 'handleChangePage',
    value: function handleChangePage(currPage) {
      var currSizePerPage = this.currSizePerPage;
      var options = this.props.pagination.options;


      if (options.onPageChange) {
        options.onPageChange(currPage, currSizePerPage);
      }

      this.currPage = currPage;

      if (this.isRemotePagination()) {
        this.getPaginationRemoteEmitter().emit('paginationChange', currPage, currSizePerPage);
        return;
      }
      this.forceUpdate();
    }
  }, {
    key: 'handleChangeSizePerPage',
    value: function handleChangeSizePerPage(currSizePerPage, currPage) {
      var options = this.props.pagination.options;


      if (options.onSizePerPageChange) {
        options.onSizePerPageChange(currSizePerPage, currPage);
      }

      this.currPage = currPage;
      this.currSizePerPage = currSizePerPage;

      if (this.isRemotePagination()) {
        this.getPaginationRemoteEmitter().emit('paginationChange', currPage, currSizePerPage);
        return;
      }
      this.forceUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      var paginationProps = this.getPaginationProps();
      var pagination = _extends({}, this.props.pagination, {
        options: paginationProps
      });

      return _react2.default.createElement(
        StateContext.Provider,
        {
          value: {
            paginationProps: paginationProps,
            paginationTableProps: {
              pagination: pagination,
              setPaginationRemoteEmitter: this.setPaginationRemoteEmitter,
              dataChangeListener: this.dataChangeListener
            }
          }
        },
        this.props.children
      );
    }
  }]);

  return StateProvider;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getPaginationProps = function () {
    var _props = _this2.props,
        options = _props.pagination.options,
        bootstrap4 = _props.bootstrap4,
        tableId = _props.tableId;
    var currPage = _this2.currPage,
        currSizePerPage = _this2.currSizePerPage,
        dataSize = _this2.dataSize;

    var withFirstAndLast = typeof options.withFirstAndLast === 'undefined' ? _const2.default.With_FIRST_AND_LAST : options.withFirstAndLast;
    var alwaysShowAllBtns = typeof options.alwaysShowAllBtns === 'undefined' ? _const2.default.SHOW_ALL_PAGE_BTNS : options.alwaysShowAllBtns;
    var hideSizePerPage = typeof options.hideSizePerPage === 'undefined' ? _const2.default.HIDE_SIZE_PER_PAGE : options.hideSizePerPage;
    var hidePageListOnlyOnePage = typeof options.hidePageListOnlyOnePage === 'undefined' ? _const2.default.HIDE_PAGE_LIST_ONLY_ONE_PAGE : options.hidePageListOnlyOnePage;
    var pageStartIndex = typeof options.pageStartIndex === 'undefined' ? _const2.default.PAGE_START_INDEX : options.pageStartIndex;
    return _extends({}, options, {
      bootstrap4: bootstrap4,
      tableId: tableId,
      page: currPage,
      sizePerPage: currSizePerPage,
      pageStartIndex: pageStartIndex,
      hidePageListOnlyOnePage: hidePageListOnlyOnePage,
      hideSizePerPage: hideSizePerPage,
      alwaysShowAllBtns: alwaysShowAllBtns,
      withFirstAndLast: withFirstAndLast,
      dataSize: dataSize,
      sizePerPageList: options.sizePerPageList || _const2.default.SIZE_PER_PAGE_LIST,
      paginationSize: options.paginationSize || _const2.default.PAGINATION_SIZE,
      showTotal: options.showTotal,
      pageListRenderer: options.pageListRenderer,
      pageButtonRenderer: options.pageButtonRenderer,
      sizePerPageRenderer: options.sizePerPageRenderer,
      paginationTotalRenderer: options.paginationTotalRenderer,
      sizePerPageOptionRenderer: options.sizePerPageOptionRenderer,
      firstPageText: options.firstPageText || _const2.default.FIRST_PAGE_TEXT,
      prePageText: options.prePageText || _const2.default.PRE_PAGE_TEXT,
      nextPageText: options.nextPageText || _const2.default.NEXT_PAGE_TEXT,
      lastPageText: options.lastPageText || _const2.default.LAST_PAGE_TEXT,
      prePageTitle: options.prePageTitle || _const2.default.PRE_PAGE_TITLE,
      nextPageTitle: options.nextPageTitle || _const2.default.NEXT_PAGE_TITLE,
      firstPageTitle: options.firstPageTitle || _const2.default.FIRST_PAGE_TITLE,
      lastPageTitle: options.lastPageTitle || _const2.default.LAST_PAGE_TITLE,
      onPageChange: _this2.handleChangePage,
      onSizePerPageChange: _this2.handleChangeSizePerPage
    });
  };

  this.setPaginationRemoteEmitter = function (remoteEmitter) {
    _this2.remoteEmitter = remoteEmitter;
  };

  this.getPaginationRemoteEmitter = function () {
    return _this2.remoteEmitter || _this2.props.remoteEmitter;
  };

  this.isRemotePagination = function () {
    var e = {};
    _this2.remoteEmitter.emit('isRemotePagination', e);
    return e.result;
  };
};

exports.default = function () {
  return {
    Provider: StateProvider,
    Consumer: StateContext.Consumer
  };
};
});

unwrapExports(stateContext);

var pageResolver = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _const2 = _interopRequireDefault(_const$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-mixed-operators: 0 */


exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(PageResolver, _ExtendBase);

    function PageResolver() {
      _classCallCheck(this, PageResolver);

      return _possibleConstructorReturn(this, (PageResolver.__proto__ || Object.getPrototypeOf(PageResolver)).apply(this, arguments));
    }

    _createClass(PageResolver, [{
      key: 'backToPrevPage',
      value: function backToPrevPage() {
        var _props = this.props,
            currPage = _props.currPage,
            pageStartIndex = _props.pageStartIndex;

        return currPage - 1 < pageStartIndex ? pageStartIndex : currPage - 1;
      }
    }, {
      key: 'initialState',
      value: function initialState() {
        var totalPages = this.calculateTotalPage();
        var lastPage = this.calculateLastPage(totalPages);
        return { totalPages: totalPages, lastPage: lastPage };
      }
    }, {
      key: 'calculateTotalPage',
      value: function calculateTotalPage() {
        var sizePerPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.currSizePerPage;
        var dataSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.dataSize;

        return Math.ceil(dataSize / sizePerPage);
      }
    }, {
      key: 'calculateLastPage',
      value: function calculateLastPage(totalPages) {
        var pageStartIndex = this.props.pageStartIndex;

        return pageStartIndex + totalPages - 1;
      }
    }, {
      key: 'calculateFromTo',
      value: function calculateFromTo() {
        var _props2 = this.props,
            dataSize = _props2.dataSize,
            currPage = _props2.currPage,
            currSizePerPage = _props2.currSizePerPage,
            pageStartIndex = _props2.pageStartIndex;

        var offset = Math.abs(_const2.default.PAGE_START_INDEX - pageStartIndex);

        var from = (currPage - pageStartIndex) * currSizePerPage;
        from = dataSize === 0 ? 0 : from + 1;
        var to = Math.min(currSizePerPage * (currPage + offset), dataSize);
        if (to > dataSize) to = dataSize;

        return [from, to];
      }
    }, {
      key: 'calculatePages',
      value: function calculatePages(totalPages, lastPage) {
        var _props3 = this.props,
            currPage = _props3.currPage,
            paginationSize = _props3.paginationSize,
            pageStartIndex = _props3.pageStartIndex,
            withFirstAndLast = _props3.withFirstAndLast,
            firstPageText = _props3.firstPageText,
            prePageText = _props3.prePageText,
            nextPageText = _props3.nextPageText,
            lastPageText = _props3.lastPageText,
            alwaysShowAllBtns = _props3.alwaysShowAllBtns;


        var pages = [];
        var endPage = totalPages;
        if (endPage <= 0) return [];

        var startPage = Math.max(currPage - Math.floor(paginationSize / 2), pageStartIndex);
        endPage = startPage + paginationSize - 1;

        if (endPage > lastPage) {
          endPage = lastPage;
          startPage = endPage - paginationSize + 1;
        }

        if (alwaysShowAllBtns) {
          if (withFirstAndLast) {
            pages = [firstPageText, prePageText];
          } else {
            pages = [prePageText];
          }
        }

        if (startPage !== pageStartIndex && totalPages > paginationSize && withFirstAndLast && pages.length === 0) {
          pages = [firstPageText, prePageText];
        } else if (totalPages > 1 && pages.length === 0) {
          pages = [prePageText];
        }

        for (var i = startPage; i <= endPage; i += 1) {
          if (i >= pageStartIndex) pages.push(i);
        }

        if (alwaysShowAllBtns || endPage <= lastPage && pages.length > 1) {
          pages.push(nextPageText);
        }
        if (endPage !== lastPage && withFirstAndLast || withFirstAndLast && alwaysShowAllBtns) {
          pages.push(lastPageText);
        }

        // if ((endPage <= lastPage && pages.length > 1) || alwaysShowAllBtns) {
        //   pages.push(nextPageText);
        // }
        // if (endPage !== lastPage && withFirstAndLast) {
        //   pages.push(lastPageText);
        // }

        return pages;
      }
    }, {
      key: 'calculatePageStatus',
      value: function calculatePageStatus() {
        var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var _this2 = this;

        var lastPage = arguments[1];
        var disablePageTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var _props4 = this.props,
            currPage = _props4.currPage,
            pageStartIndex = _props4.pageStartIndex,
            firstPageText = _props4.firstPageText,
            prePageText = _props4.prePageText,
            nextPageText = _props4.nextPageText,
            lastPageText = _props4.lastPageText,
            alwaysShowAllBtns = _props4.alwaysShowAllBtns;

        var isStart = function isStart(page) {
          return currPage === pageStartIndex && (page === firstPageText || page === prePageText);
        };
        var isEnd = function isEnd(page) {
          return currPage === lastPage && (page === nextPageText || page === lastPageText);
        };

        return pages.filter(function (page) {
          if (alwaysShowAllBtns) {
            return true;
          }
          return !(isStart(page) || isEnd(page));
        }).map(function (page) {
          var title = void 0;
          var active = page === currPage;
          var disabled = isStart(page) || isEnd(page);

          if (page === nextPageText) {
            title = _this2.props.nextPageTitle;
          } else if (page === prePageText) {
            title = _this2.props.prePageTitle;
          } else if (page === firstPageText) {
            title = _this2.props.firstPageTitle;
          } else if (page === lastPageText) {
            title = _this2.props.lastPageTitle;
          } else {
            title = '' + page;
          }

          var pageResult = { page: page, active: active, disabled: disabled };
          if (!disablePageTitle) {
            pageResult.title = title;
          }
          return pageResult;
        });
      }
    }, {
      key: 'calculateSizePerPageStatus',
      value: function calculateSizePerPageStatus() {
        var sizePerPageList = this.props.sizePerPageList;

        return sizePerPageList.map(function (_sizePerPage) {
          var pageText = typeof _sizePerPage.text !== 'undefined' ? _sizePerPage.text : _sizePerPage;
          var pageNumber = typeof _sizePerPage.value !== 'undefined' ? _sizePerPage.value : _sizePerPage;
          return {
            text: '' + pageText,
            page: pageNumber
          };
        });
      }
    }]);

    return PageResolver;
  }(ExtendBase);
};
});

unwrapExports(pageResolver);

var paginationHandler = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _pageResolver3 = _interopRequireDefault(pageResolver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint camelcase: 0 */


exports.default = function (WrappedComponent) {
  return function (_pageResolver) {
    _inherits(PaginationHandler, _pageResolver);

    function PaginationHandler(props) {
      _classCallCheck(this, PaginationHandler);

      var _this = _possibleConstructorReturn(this, (PaginationHandler.__proto__ || Object.getPrototypeOf(PaginationHandler)).call(this, props));

      _this.handleChangePage = _this.handleChangePage.bind(_this);
      _this.handleChangeSizePerPage = _this.handleChangeSizePerPage.bind(_this);
      _this.state = _this.initialState();
      return _this;
    }

    _createClass(PaginationHandler, [{
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var dataSize = nextProps.dataSize,
            currSizePerPage = nextProps.currSizePerPage;

        if (currSizePerPage !== this.props.currSizePerPage || dataSize !== this.props.dataSize) {
          var totalPages = this.calculateTotalPage(currSizePerPage, dataSize);
          var lastPage = this.calculateLastPage(totalPages);
          this.setState({ totalPages: totalPages, lastPage: lastPage });
        }
      }
    }, {
      key: 'handleChangeSizePerPage',
      value: function handleChangeSizePerPage(sizePerPage) {
        var _props = this.props,
            currSizePerPage = _props.currSizePerPage,
            onSizePerPageChange = _props.onSizePerPageChange;

        var selectedSize = typeof sizePerPage === 'string' ? parseInt(sizePerPage, 10) : sizePerPage;
        var currPage = this.props.currPage;

        if (selectedSize !== currSizePerPage) {
          var newTotalPages = this.calculateTotalPage(selectedSize);
          var newLastPage = this.calculateLastPage(newTotalPages);
          if (currPage > newLastPage) currPage = newLastPage;
          onSizePerPageChange(selectedSize, currPage);
        }
      }
    }, {
      key: 'handleChangePage',
      value: function handleChangePage(newPage) {
        var page = void 0;
        var _props2 = this.props,
            currPage = _props2.currPage,
            pageStartIndex = _props2.pageStartIndex,
            prePageText = _props2.prePageText,
            nextPageText = _props2.nextPageText,
            lastPageText = _props2.lastPageText,
            firstPageText = _props2.firstPageText,
            onPageChange = _props2.onPageChange;
        var lastPage = this.state.lastPage;


        if (newPage === prePageText) {
          page = this.backToPrevPage();
        } else if (newPage === nextPageText) {
          page = currPage + 1 > lastPage ? lastPage : currPage + 1;
        } else if (newPage === lastPageText) {
          page = lastPage;
        } else if (newPage === firstPageText) {
          page = pageStartIndex;
        } else {
          page = parseInt(newPage, 10);
        }
        if (page !== currPage) {
          onPageChange(page);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
          lastPage: this.state.lastPage,
          totalPages: this.state.totalPages,
          onPageChange: this.handleChangePage,
          onSizePerPageChange: this.handleChangeSizePerPage
        }));
      }
    }]);

    return PaginationHandler;
  }((0, _pageResolver3.default)(React__default['default'].Component));
};
});

unwrapExports(paginationHandler);

var sizePerPageOption = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint jsx-a11y/href-no-hash: 0 */
var SizePerPageOption = function SizePerPageOption(_ref) {
  var text = _ref.text,
      page = _ref.page,
      onSizePerPageChange = _ref.onSizePerPageChange,
      bootstrap4 = _ref.bootstrap4;
  return bootstrap4 ? _react2.default.createElement(
    'a',
    {
      href: '#',
      tabIndex: '-1',
      role: 'menuitem',
      className: 'dropdown-item',
      'data-page': page,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        onSizePerPageChange(page);
      }
    },
    text
  ) : _react2.default.createElement(
    'li',
    {
      key: text,
      role: 'presentation',
      className: 'dropdown-item'
    },
    _react2.default.createElement(
      'a',
      {
        href: '#',
        tabIndex: '-1',
        role: 'menuitem',
        'data-page': page,
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
          onSizePerPageChange(page);
        }
      },
      text
    )
  );
};

SizePerPageOption.propTypes = {
  text: _propTypes2.default.string.isRequired,
  page: _propTypes2.default.number.isRequired,
  onSizePerPageChange: _propTypes2.default.func.isRequired,
  bootstrap4: _propTypes2.default.bool
};

SizePerPageOption.defaultProps = {
  bootstrap4: false
};

exports.default = SizePerPageOption;
});

unwrapExports(sizePerPageOption);

var sizePerPageDropdown = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default['default']);



var _classnames2 = _interopRequireDefault(classnames);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _sizePerPageOption2 = _interopRequireDefault(sizePerPageOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizePerPageDefaultClass = 'react-bs-table-sizePerPage-dropdown';

var SizePerPageDropDown = function SizePerPageDropDown(props) {
  var open = props.open,
      tableId = props.tableId,
      hidden = props.hidden,
      onClick = props.onClick,
      onBlur = props.onBlur,
      options = props.options,
      className = props.className,
      variation = props.variation,
      bootstrap4 = props.bootstrap4,
      btnContextual = props.btnContextual,
      optionRenderer = props.optionRenderer,
      currSizePerPage = props.currSizePerPage,
      onSizePerPageChange = props.onSizePerPageChange;


  var dropDownStyle = { visibility: hidden ? 'hidden' : 'visible' };
  var openClass = open ? 'open show' : '';
  var dropdownClasses = (0, _classnames2.default)(openClass, sizePerPageDefaultClass, variation, className);

  var id = tableId ? tableId + '-pageDropDown' : 'pageDropDown';

  return _react2.default.createElement(
    'span',
    {
      style: dropDownStyle,
      className: dropdownClasses
    },
    _react2.default.createElement(
      'button',
      {
        id: id,
        type: 'button',
        className: 'btn ' + btnContextual + ' dropdown-toggle',
        'data-toggle': 'dropdown',
        'aria-expanded': open,
        onClick: onClick,
        onBlur: onBlur
      },
      currSizePerPage,
      ' ',
      bootstrap4 ? null : _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('span', { className: 'caret' })
      )
    ),
    _react2.default.createElement(
      'ul',
      {
        className: 'dropdown-menu ' + openClass,
        role: 'menu',
        'aria-labelledby': id
      },
      options.map(function (option) {
        if (optionRenderer) {
          return optionRenderer(_extends({}, option, {
            onSizePerPageChange: onSizePerPageChange
          }));
        }
        return _react2.default.createElement(_sizePerPageOption2.default, _extends({}, option, {
          key: option.text,
          bootstrap4: bootstrap4,
          onSizePerPageChange: onSizePerPageChange
        }));
      })
    )
  );
};

SizePerPageDropDown.propTypes = {
  currSizePerPage: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.array.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  onSizePerPageChange: _propTypes2.default.func.isRequired,
  bootstrap4: _propTypes2.default.bool,
  tableId: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  btnContextual: _propTypes2.default.string,
  variation: _propTypes2.default.oneOf(['dropdown', 'dropup']),
  className: _propTypes2.default.string,
  optionRenderer: _propTypes2.default.func
};
SizePerPageDropDown.defaultProps = {
  open: false,
  hidden: false,
  btnContextual: 'btn-default btn-secondary',
  variation: 'dropdown',
  className: '',
  optionRenderer: null,
  bootstrap4: false,
  tableId: null
};

exports.default = SizePerPageDropDown;
});

unwrapExports(sizePerPageDropdown);

var sizePerPageDropdownAdapter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizePerPageDropdownWithAdapter = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _pageResolver3 = _interopRequireDefault(pageResolver);



var _sizePerPageDropdown2 = _interopRequireDefault(sizePerPageDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var sizePerPageDropdownAdapter = function sizePerPageDropdownAdapter(WrappedComponent) {
  return function (_pageResolver) {
    _inherits(SizePerPageDropdownAdapter, _pageResolver);

    function SizePerPageDropdownAdapter(props) {
      _classCallCheck(this, SizePerPageDropdownAdapter);

      var _this = _possibleConstructorReturn(this, (SizePerPageDropdownAdapter.__proto__ || Object.getPrototypeOf(SizePerPageDropdownAdapter)).call(this, props));

      _this.closeDropDown = _this.closeDropDown.bind(_this);
      _this.toggleDropDown = _this.toggleDropDown.bind(_this);
      _this.handleChangeSizePerPage = _this.handleChangeSizePerPage.bind(_this);
      _this.state = { dropdownOpen: false };
      return _this;
    }

    _createClass(SizePerPageDropdownAdapter, [{
      key: 'toggleDropDown',
      value: function toggleDropDown() {
        var dropdownOpen = !this.state.dropdownOpen;
        this.setState(function () {
          return { dropdownOpen: dropdownOpen };
        });
      }
    }, {
      key: 'closeDropDown',
      value: function closeDropDown() {
        this.setState(function () {
          return { dropdownOpen: false };
        });
      }
    }, {
      key: 'handleChangeSizePerPage',
      value: function handleChangeSizePerPage(sizePerPage) {
        this.props.onSizePerPageChange(sizePerPage);
        this.closeDropDown();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            tableId = _props.tableId,
            bootstrap4 = _props.bootstrap4,
            sizePerPageList = _props.sizePerPageList,
            currSizePerPage = _props.currSizePerPage,
            hideSizePerPage = _props.hideSizePerPage,
            sizePerPageRenderer = _props.sizePerPageRenderer,
            sizePerPageOptionRenderer = _props.sizePerPageOptionRenderer;
        var open = this.state.dropdownOpen;


        if (sizePerPageList.length > 1 && !hideSizePerPage) {
          if (sizePerPageRenderer) {
            return sizePerPageRenderer({
              options: this.calculateSizePerPageStatus(),
              currSizePerPage: '' + currSizePerPage,
              onSizePerPageChange: this.handleChangeSizePerPage
            });
          }
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
            currSizePerPage: '' + currSizePerPage,
            options: this.calculateSizePerPageStatus(),
            optionRenderer: sizePerPageOptionRenderer,
            onSizePerPageChange: this.handleChangeSizePerPage,
            onClick: this.toggleDropDown,
            onBlur: this.closeDropDown,
            open: open,
            tableId: tableId,
            bootstrap4: bootstrap4
          }));
        }
        return null;
      }
    }]);

    return SizePerPageDropdownAdapter;
  }((0, _pageResolver3.default)(React__default['default'].Component));
};

var SizePerPageDropdownWithAdapter = exports.SizePerPageDropdownWithAdapter = sizePerPageDropdownAdapter(_sizePerPageDropdown2.default);
exports.default = sizePerPageDropdownAdapter;
});

unwrapExports(sizePerPageDropdownAdapter_1);
var sizePerPageDropdownAdapter_2 = sizePerPageDropdownAdapter_1.SizePerPageDropdownWithAdapter;

var pageButton = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _classnames2 = _interopRequireDefault(classnames);



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */
/* eslint jsx-a11y/href-no-hash: 0 */


var PageButton = function (_Component) {
  _inherits(PageButton, _Component);

  function PageButton(props) {
    _classCallCheck(this, PageButton);

    var _this = _possibleConstructorReturn(this, (PageButton.__proto__ || Object.getPrototypeOf(PageButton)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(PageButton, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.props.onPageChange(this.props.page);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          page = _props.page,
          title = _props.title,
          active = _props.active,
          disabled = _props.disabled,
          className = _props.className;

      var classes = (0, _classnames2.default)({
        active: active,
        disabled: disabled,
        'page-item': true
      }, className);

      return _react2.default.createElement(
        'li',
        { className: classes, title: title },
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.handleClick, className: 'page-link' },
          page
        )
      );
    }
  }]);

  return PageButton;
}(React__default['default'].Component);

PageButton.propTypes = {
  onPageChange: _propTypes2.default.func.isRequired,
  page: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]).isRequired,
  active: _propTypes2.default.bool.isRequired,
  disabled: _propTypes2.default.bool.isRequired,
  className: _propTypes2.default.string,
  title: _propTypes2.default.string
};

exports.default = PageButton;
});

unwrapExports(pageButton);

var paginationList = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _pageButton2 = _interopRequireDefault(pageButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginatonList = function PaginatonList(props) {
  return _react2.default.createElement(
    'ul',
    { className: 'pagination react-bootstrap-table-page-btns-ul' },
    props.pages.map(function (pageProps) {
      if (props.pageButtonRenderer) {
        return props.pageButtonRenderer(_extends({}, pageProps, {
          onPageChange: props.onPageChange
        }));
      }
      return _react2.default.createElement(_pageButton2.default, _extends({
        key: pageProps.page
      }, pageProps, {
        onPageChange: props.onPageChange
      }));
    })
  );
};

PaginatonList.propTypes = {
  pages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    page: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]),
    active: _propTypes2.default.bool,
    disable: _propTypes2.default.bool,
    title: _propTypes2.default.string
  })).isRequired,
  onPageChange: _propTypes2.default.func.isRequired,
  pageButtonRenderer: _propTypes2.default.func
};

PaginatonList.defaultProps = {
  pageButtonRenderer: null
};

exports.default = PaginatonList;
});

unwrapExports(paginationList);

var paginationListAdapter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationListWithAdapter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _pageResolver3 = _interopRequireDefault(pageResolver);



var _paginationList2 = _interopRequireDefault(paginationList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var paginationListAdapter = function paginationListAdapter(WrappedComponent) {
  return function (_pageResolver) {
    _inherits(PaginationListAdapter, _pageResolver);

    function PaginationListAdapter() {
      _classCallCheck(this, PaginationListAdapter);

      return _possibleConstructorReturn(this, (PaginationListAdapter.__proto__ || Object.getPrototypeOf(PaginationListAdapter)).apply(this, arguments));
    }

    _createClass(PaginationListAdapter, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            lastPage = _props.lastPage,
            totalPages = _props.totalPages,
            pageButtonRenderer = _props.pageButtonRenderer,
            onPageChange = _props.onPageChange,
            disablePageTitle = _props.disablePageTitle,
            hidePageListOnlyOnePage = _props.hidePageListOnlyOnePage;

        var pages = this.calculatePageStatus(this.calculatePages(totalPages, lastPage), lastPage, disablePageTitle);
        if (totalPages === 1 && hidePageListOnlyOnePage) {
          return null;
        }
        return _react2.default.createElement(WrappedComponent, {
          pageButtonRenderer: pageButtonRenderer,
          onPageChange: onPageChange,
          pages: pages
        });
      }
    }]);

    return PaginationListAdapter;
  }((0, _pageResolver3.default)(React__default['default'].Component));
};

var PaginationListWithAdapter = exports.PaginationListWithAdapter = paginationListAdapter(_paginationList2.default);
exports.default = paginationListAdapter;
});

unwrapExports(paginationListAdapter_1);
var paginationListAdapter_2 = paginationListAdapter_1.PaginationListWithAdapter;

var paginationTotal = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationTotal = function PaginationTotal(props) {
  if (props.paginationTotalRenderer) {
    return props.paginationTotalRenderer(props.from, props.to, props.dataSize);
  }
  return _react2.default.createElement(
    'span',
    { className: 'react-bootstrap-table-pagination-total' },
    '\xA0Showing rows ',
    props.from,
    ' to\xA0',
    props.to,
    ' of\xA0',
    props.dataSize
  );
};

PaginationTotal.propTypes = {
  from: _propTypes2.default.number.isRequired,
  to: _propTypes2.default.number.isRequired,
  dataSize: _propTypes2.default.number.isRequired,
  paginationTotalRenderer: _propTypes2.default.func
};

PaginationTotal.defaultProps = {
  paginationTotalRenderer: undefined
};

exports.default = PaginationTotal;
});

unwrapExports(paginationTotal);

var paginationTotalAdapter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationTotalWithAdapter = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _pageResolver3 = _interopRequireDefault(pageResolver);



var _paginationTotal2 = _interopRequireDefault(paginationTotal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var paginationTotalAdapter = function paginationTotalAdapter(WrappedComponent) {
  return function (_pageResolver) {
    _inherits(PaginationTotalAdapter, _pageResolver);

    function PaginationTotalAdapter() {
      _classCallCheck(this, PaginationTotalAdapter);

      return _possibleConstructorReturn(this, (PaginationTotalAdapter.__proto__ || Object.getPrototypeOf(PaginationTotalAdapter)).apply(this, arguments));
    }

    _createClass(PaginationTotalAdapter, [{
      key: 'render',
      value: function render() {
        var _calculateFromTo = this.calculateFromTo(),
            _calculateFromTo2 = _slicedToArray(_calculateFromTo, 2),
            from = _calculateFromTo2[0],
            to = _calculateFromTo2[1];

        return _react2.default.createElement(WrappedComponent, {
          from: from,
          to: to,
          dataSize: this.props.dataSize,
          paginationTotalRenderer: this.props.paginationTotalRenderer
        });
      }
    }]);

    return PaginationTotalAdapter;
  }((0, _pageResolver3.default)(React__default['default'].Component));
};

var PaginationTotalWithAdapter = exports.PaginationTotalWithAdapter = paginationTotalAdapter(_paginationTotal2.default);
exports.default = paginationTotalAdapter;
});

unwrapExports(paginationTotalAdapter_1);
var paginationTotalAdapter_2 = paginationTotalAdapter_1.PaginationTotalWithAdapter;

var pagination = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _classnames2 = _interopRequireDefault(classnames);



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _pageResolver3 = _interopRequireDefault(pageResolver);



var _paginationHandler2 = _interopRequireDefault(paginationHandler);









var _const2 = _interopRequireDefault(_const$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */
/* eslint arrow-body-style: 0 */


var Pagination = function (_pageResolver) {
  _inherits(Pagination, _pageResolver);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).apply(this, arguments));
  }

  _createClass(Pagination, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          tableId = _props.tableId,
          currPage = _props.currPage,
          pageStartIndex = _props.pageStartIndex,
          showTotal = _props.showTotal,
          dataSize = _props.dataSize,
          pageListRenderer = _props.pageListRenderer,
          pageButtonRenderer = _props.pageButtonRenderer,
          paginationTotalRenderer = _props.paginationTotalRenderer,
          hidePageListOnlyOnePage = _props.hidePageListOnlyOnePage,
          totalPages = _props.totalPages,
          lastPage = _props.lastPage,
          onPageChange = _props.onPageChange,
          sizePerPageList = _props.sizePerPageList,
          currSizePerPage = _props.currSizePerPage,
          hideSizePerPage = _props.hideSizePerPage,
          sizePerPageRenderer = _props.sizePerPageRenderer,
          sizePerPageOptionRenderer = _props.sizePerPageOptionRenderer,
          onSizePerPageChange = _props.onSizePerPageChange,
          bootstrap4 = _props.bootstrap4,
          rest = _objectWithoutProperties(_props, ['tableId', 'currPage', 'pageStartIndex', 'showTotal', 'dataSize', 'pageListRenderer', 'pageButtonRenderer', 'paginationTotalRenderer', 'hidePageListOnlyOnePage', 'totalPages', 'lastPage', 'onPageChange', 'sizePerPageList', 'currSizePerPage', 'hideSizePerPage', 'sizePerPageRenderer', 'sizePerPageOptionRenderer', 'onSizePerPageChange', 'bootstrap4']);

      var pages = this.calculatePageStatus(this.calculatePages(totalPages, lastPage), lastPage);
      var pageListClass = (0, _classnames2.default)('react-bootstrap-table-pagination-list', 'col-md-6 col-xs-6 col-sm-6 col-lg-6', {
        'react-bootstrap-table-pagination-list-hidden': hidePageListOnlyOnePage && totalPages === 1
      });
      return _react2.default.createElement(
        'div',
        { className: 'row react-bootstrap-table-pagination' },
        _react2.default.createElement(
          'div',
          { className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
          _react2.default.createElement(sizePerPageDropdownAdapter_1.SizePerPageDropdownWithAdapter, {
            bootstrap4: bootstrap4,
            tableId: tableId,
            sizePerPageList: sizePerPageList,
            currSizePerPage: currSizePerPage,
            hideSizePerPage: hideSizePerPage,
            sizePerPageRenderer: sizePerPageRenderer,
            sizePerPageOptionRenderer: sizePerPageOptionRenderer,
            onSizePerPageChange: onSizePerPageChange
          }),
          showTotal ? _react2.default.createElement(paginationTotalAdapter_1.PaginationTotalWithAdapter, {
            currPage: currPage,
            currSizePerPage: currSizePerPage,
            pageStartIndex: pageStartIndex,
            dataSize: dataSize,
            paginationTotalRenderer: paginationTotalRenderer
          }) : null
        ),
        pageListRenderer ? pageListRenderer({
          pages: pages,
          onPageChange: onPageChange
        }) : _react2.default.createElement(
          'div',
          { className: pageListClass },
          _react2.default.createElement(paginationListAdapter_1.PaginationListWithAdapter, _extends({}, rest, {
            currPage: currPage,
            currSizePerPage: currSizePerPage,
            pageStartIndex: pageStartIndex,
            lastPage: lastPage,
            totalPages: totalPages,
            pageButtonRenderer: pageButtonRenderer,
            onPageChange: onPageChange
          }))
        )
      );
    }
  }]);

  return Pagination;
}((0, _pageResolver3.default)(React__default['default'].Component));

Pagination.propTypes = {
  dataSize: _propTypes2.default.number.isRequired,
  sizePerPageList: _propTypes2.default.array.isRequired,
  currPage: _propTypes2.default.number.isRequired,
  currSizePerPage: _propTypes2.default.number.isRequired,
  onPageChange: _propTypes2.default.func.isRequired,
  onSizePerPageChange: _propTypes2.default.func.isRequired,
  disablePageTitle: _propTypes2.default.bool,
  pageStartIndex: _propTypes2.default.number,
  paginationSize: _propTypes2.default.number,
  showTotal: _propTypes2.default.bool,
  pageListRenderer: _propTypes2.default.func,
  pageButtonRenderer: _propTypes2.default.func,
  sizePerPageRenderer: _propTypes2.default.func,
  paginationTotalRenderer: _propTypes2.default.func,
  sizePerPageOptionRenderer: _propTypes2.default.func,
  firstPageText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  prePageText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  nextPageText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  lastPageText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  nextPageTitle: _propTypes2.default.string,
  prePageTitle: _propTypes2.default.string,
  firstPageTitle: _propTypes2.default.string,
  lastPageTitle: _propTypes2.default.string,
  withFirstAndLast: _propTypes2.default.bool,
  alwaysShowAllBtns: _propTypes2.default.bool,
  hideSizePerPage: _propTypes2.default.bool,
  hidePageListOnlyOnePage: _propTypes2.default.bool,
  bootstrap4: _propTypes2.default.bool
};

Pagination.defaultProps = {
  disablePageTitle: false,
  bootstrap4: false,
  pageStartIndex: _const2.default.PAGE_START_INDEX,
  paginationSize: _const2.default.PAGINATION_SIZE,
  withFirstAndLast: _const2.default.With_FIRST_AND_LAST,
  alwaysShowAllBtns: _const2.default.SHOW_ALL_PAGE_BTNS,
  showTotal: _const2.default.SHOW_TOTAL,
  pageListRenderer: null,
  pageButtonRenderer: null,
  sizePerPageRenderer: null,
  paginationTotalRenderer: _const2.default.PAGINATION_TOTAL,
  sizePerPageOptionRenderer: null,
  firstPageText: _const2.default.FIRST_PAGE_TEXT,
  prePageText: _const2.default.PRE_PAGE_TEXT,
  nextPageText: _const2.default.NEXT_PAGE_TEXT,
  lastPageText: _const2.default.LAST_PAGE_TEXT,
  sizePerPageList: _const2.default.SIZE_PER_PAGE_LIST,
  nextPageTitle: _const2.default.NEXT_PAGE_TITLE,
  prePageTitle: _const2.default.PRE_PAGE_TITLE,
  firstPageTitle: _const2.default.FIRST_PAGE_TITLE,
  lastPageTitle: _const2.default.LAST_PAGE_TITLE,
  hideSizePerPage: _const2.default.HIDE_SIZE_PER_PAGE,
  hidePageListOnlyOnePage: _const2.default.HIDE_PAGE_LIST_ONLY_ONE_PAGE
};

exports.default = (0, _paginationHandler2.default)(Pagination);
});

unwrapExports(pagination);

var dataContext$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _const2 = _interopRequireDefault(_const$1);



var _pagination2 = _interopRequireDefault(pagination);





var _stateContext2 = _interopRequireDefault(stateContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/require-default-props: 0 */
/* eslint no-lonely-if: 0 */


var _createBaseContext = (0, _stateContext2.default)(),
    Provider = _createBaseContext.Provider;

var PaginationDataContext = _react2.default.createContext();

var PaginationDataProvider = function (_Provider) {
  _inherits(PaginationDataProvider, _Provider);

  function PaginationDataProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaginationDataProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationDataProvider.__proto__ || Object.getPrototypeOf(PaginationDataProvider)).call.apply(_ref, [this].concat(args))), _this), _this.isRemotePagination = function () {
      return _this.props.isRemotePagination();
    }, _this.renderDefaultPagination = function () {
      if (!_this.props.pagination.options.custom) {
        var _this$getPaginationPr = _this.getPaginationProps(),
            currPage = _this$getPaginationPr.page,
            currSizePerPage = _this$getPaginationPr.sizePerPage,
            dataSize = _this$getPaginationPr.dataSize,
            rest = _objectWithoutProperties(_this$getPaginationPr, ['page', 'sizePerPage', 'dataSize']);

        return _react2.default.createElement(_pagination2.default, _extends({}, rest, {
          key: 'pagination',
          dataSize: dataSize || _this.props.data.length,
          currPage: currPage,
          currSizePerPage: currSizePerPage
        }));
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaginationDataProvider, [{
    key: 'UNSAFE_componentWillReceiveProps',


    // eslint-disable-next-line camelcase, react/sort-comp
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      _get(PaginationDataProvider.prototype.__proto__ || Object.getPrototypeOf(PaginationDataProvider.prototype), 'UNSAFE_componentWillReceiveProps', this).call(this, nextProps);
      var currSizePerPage = this.currSizePerPage;
      var _nextProps$pagination = nextProps.pagination.options,
          custom = _nextProps$pagination.custom,
          onPageChange = _nextProps$pagination.onPageChange;


      var pageStartIndex = typeof nextProps.pagination.options.pageStartIndex !== 'undefined' ? nextProps.pagination.options.pageStartIndex : _const2.default.PAGE_START_INDEX;

      // user should align the page when the page is not fit to the data size when remote enable
      if (!this.isRemotePagination() && !custom) {
        var newPage = (0, page.alignPage)(nextProps.data.length, this.props.data.length, this.currPage, currSizePerPage, pageStartIndex);

        if (this.currPage !== newPage) {
          if (onPageChange) {
            onPageChange(newPage, currSizePerPage);
          }
          this.currPage = newPage;
        }
      }
      if (nextProps.onDataSizeChange && nextProps.data.length !== this.props.data.length) {
        nextProps.onDataSizeChange({ dataSize: nextProps.data.length });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;
      var options = this.props.pagination.options;
      var currPage = this.currPage,
          currSizePerPage = this.currSizePerPage;

      var pageStartIndex = typeof options.pageStartIndex === 'undefined' ? _const2.default.PAGE_START_INDEX : options.pageStartIndex;

      data = this.isRemotePagination() ? data : (0, page.getByCurrPage)(data, currPage, currSizePerPage, pageStartIndex);

      return _react2.default.createElement(
        PaginationDataContext.Provider,
        { value: { data: data, setRemoteEmitter: this.setRemoteEmitter } },
        this.props.children,
        this.renderDefaultPagination()
      );
    }
  }]);

  return PaginationDataProvider;
}(Provider);

PaginationDataProvider.propTypes = {
  data: _propTypes2.default.array.isRequired,
  remoteEmitter: _propTypes2.default.object.isRequired,
  isRemotePagination: _propTypes2.default.func.isRequired };

exports.default = function () {
  return {
    Provider: PaginationDataProvider,
    Consumer: PaginationDataContext.Consumer
  };
};
});

unwrapExports(dataContext$1);

var standaloneAdapter = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint react/prop-types: 0 */


exports.default = function (WrappedComponent) {
  return function (_ref) {
    var page = _ref.page,
        sizePerPage = _ref.sizePerPage,
        rest = _objectWithoutProperties(_ref, ['page', 'sizePerPage']);

    return _react2.default.createElement(WrappedComponent, _extends({}, rest, {
      currPage: page,
      currSizePerPage: sizePerPage
    }));
  };
};
});

unwrapExports(standaloneAdapter);

var paginationListStandalone = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _paginationList2 = _interopRequireDefault(paginationList);



var _standaloneAdapter2 = _interopRequireDefault(standaloneAdapter);



var _paginationHandler2 = _interopRequireDefault(paginationHandler);



var _paginationListAdapter2 = _interopRequireDefault(paginationListAdapter_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationListStandalone = function PaginationListStandalone(props) {
  return _react2.default.createElement(_paginationList2.default, props);
};

exports.default = (0, _standaloneAdapter2.default)((0, _paginationHandler2.default)((0, _paginationListAdapter2.default)(PaginationListStandalone)));
});

unwrapExports(paginationListStandalone);

var sizePerPageDropdownStandalone = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _sizePerPageDropdown2 = _interopRequireDefault(sizePerPageDropdown);



var _standaloneAdapter2 = _interopRequireDefault(standaloneAdapter);



var _paginationHandler2 = _interopRequireDefault(paginationHandler);



var _sizePerPageDropdownAdapter2 = _interopRequireDefault(sizePerPageDropdownAdapter_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizePerPageDropdownStandalone = function SizePerPageDropdownStandalone(props) {
  return _react2.default.createElement(_sizePerPageDropdown2.default, props);
};

exports.default = (0, _standaloneAdapter2.default)((0, _paginationHandler2.default)((0, _sizePerPageDropdownAdapter2.default)(SizePerPageDropdownStandalone)));
});

unwrapExports(sizePerPageDropdownStandalone);

var paginationTotalStandalone = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default['default']);



var _paginationTotal2 = _interopRequireDefault(paginationTotal);



var _standaloneAdapter2 = _interopRequireDefault(standaloneAdapter);



var _paginationTotalAdapter2 = _interopRequireDefault(paginationTotalAdapter_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationTotalStandalone = function PaginationTotalStandalone(props) {
  return _react2.default.createElement(_paginationTotal2.default, props);
};

exports.default = (0, _standaloneAdapter2.default)((0, _paginationTotalAdapter2.default)(PaginationTotalStandalone));
});

unwrapExports(paginationTotalStandalone);

var lib$2 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationTotalStandalone = exports.SizePerPageDropdownStandalone = exports.PaginationListStandalone = exports.PaginationProvider = undefined;



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



var _stateContext2 = _interopRequireDefault(stateContext);



var _dataContext2 = _interopRequireDefault(dataContext$1);



var _paginationListStandalone2 = _interopRequireDefault(paginationListStandalone);



var _sizePerPageDropdownStandalone2 = _interopRequireDefault(sizePerPageDropdownStandalone);



var _paginationTotalStandalone2 = _interopRequireDefault(paginationTotalStandalone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    createContext: _dataContext2.default,
    options: options
  };
};

var _createBaseContext = (0, _stateContext2.default)(),
    Provider = _createBaseContext.Provider,
    Consumer = _createBaseContext.Consumer;

var CustomizableProvider = function CustomizableProvider(props) {
  return _react2.default.createElement(
    Provider,
    props,
    _react2.default.createElement(
      Consumer,
      null,
      function (paginationProps) {
        return props.children(paginationProps);
      }
    )
  );
};

CustomizableProvider.propTypes = {
  children: _propTypes2.default.func.isRequired
};

var PaginationProvider = exports.PaginationProvider = CustomizableProvider;
exports.PaginationListStandalone = _paginationListStandalone2.default;
exports.SizePerPageDropdownStandalone = _sizePerPageDropdownStandalone2.default;
exports.PaginationTotalStandalone = _paginationTotalStandalone2.default;
});

var paginationFactory = unwrapExports(lib$2);
var lib_1 = lib$2.PaginationTotalStandalone;
var lib_2 = lib$2.SizePerPageDropdownStandalone;
var lib_3 = lib$2.PaginationListStandalone;
var lib_4 = lib$2.PaginationProvider;

var css_248z$c = "/*!\n * Bootstrap v4.5.3 (https://getbootstrap.com/)\n * Copyright 2011-2020 The Bootstrap Authors\n * Copyright 2011-2020 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#007bff;--secondary:#6c757d;--success:#28a745;--info:#17a2b8;--warning:#ffc107;--danger:#dc3545;--light:#f8f9fa;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*,::after,::before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}article,aside,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex=\"-1\"]:focus:not(:focus-visible){outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}dl,ol,ul{margin-top:0;margin-bottom:1rem}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent}a:hover{color:#0056b3;text-decoration:underline}a:not([href]):not([class]){color:inherit;text-decoration:none}a:not([href]):not([class]):hover{color:inherit;text-decoration:none}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg{overflow:hidden;vertical-align:middle}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit;text-align:-webkit-match-parent}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[role=button]{cursor:pointer}select{word-wrap:normal}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled),button:not(:disabled){cursor:pointer}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.bootstrap-min_h1__JLbN0,.bootstrap-min_h2__1Yx4I,.bootstrap-min_h3__2tb_F,.bootstrap-min_h4__mJbUm,.bootstrap-min_h5__pPsEc,.bootstrap-min_h6__2NPYy,h1,h2,h3,h4,h5,h6{margin-bottom:.5rem;font-weight:500;line-height:1.2}.bootstrap-min_h1__JLbN0,h1{font-size:2.5rem}.bootstrap-min_h2__1Yx4I,h2{font-size:2rem}.bootstrap-min_h3__2tb_F,h3{font-size:1.75rem}.bootstrap-min_h4__mJbUm,h4{font-size:1.5rem}.bootstrap-min_h5__pPsEc,h5{font-size:1.25rem}.bootstrap-min_h6__2NPYy,h6{font-size:1rem}.bootstrap-min_lead__3zmFd{font-size:1.25rem;font-weight:300}.bootstrap-min_display-1__106EL{font-size:6rem;font-weight:300;line-height:1.2}.bootstrap-min_display-2__mHrDh{font-size:5.5rem;font-weight:300;line-height:1.2}.bootstrap-min_display-3__3uUy7{font-size:4.5rem;font-weight:300;line-height:1.2}.bootstrap-min_display-4__NrGcs{font-size:3.5rem;font-weight:300;line-height:1.2}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.bootstrap-min_small__2gJYW,small{font-size:80%;font-weight:400}.bootstrap-min_mark__1gm-C,mark{padding:.2em;background-color:#fcf8e3}.bootstrap-min_list-unstyled__3EX6R{padding-left:0;list-style:none}.bootstrap-min_list-inline__TCNFj{padding-left:0;list-style:none}.bootstrap-min_list-inline-item__3W8W2{display:inline-block}.bootstrap-min_list-inline-item__3W8W2:not(:last-child){margin-right:.5rem}.bootstrap-min_initialism__3zCIV{font-size:90%;text-transform:uppercase}.bootstrap-min_blockquote__2-erm{margin-bottom:1rem;font-size:1.25rem}.bootstrap-min_blockquote-footer__1Wn9S{display:block;font-size:80%;color:#6c757d}.bootstrap-min_blockquote-footer__1Wn9S::before{content:\"\\2014\\A0\"}.bootstrap-min_img-fluid__ZUm7A{max-width:100%;height:auto}.bootstrap-min_img-thumbnail__2LZov{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.bootstrap-min_figure__2GcEm{display:inline-block}.bootstrap-min_figure-img__2L-Fx{margin-bottom:.5rem;line-height:1}.bootstrap-min_figure-caption__1zehO{font-size:90%;color:#6c757d}code{font-size:87.5%;color:#e83e8c;word-wrap:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.bootstrap-min_pre-scrollable__1sRNU{max-height:340px;overflow-y:scroll}.bootstrap-min_container__3i4Ca,.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_container-md__kncAJ,.bootstrap-min_container-sm__tKUII,.bootstrap-min_container-xl__2wVN4{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.bootstrap-min_container__3i4Ca,.bootstrap-min_container-sm__tKUII{max-width:540px}}@media (min-width:768px){.bootstrap-min_container__3i4Ca,.bootstrap-min_container-md__kncAJ,.bootstrap-min_container-sm__tKUII{max-width:720px}}@media (min-width:992px){.bootstrap-min_container__3i4Ca,.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_container-md__kncAJ,.bootstrap-min_container-sm__tKUII{max-width:960px}}@media (min-width:1200px){.bootstrap-min_container__3i4Ca,.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_container-md__kncAJ,.bootstrap-min_container-sm__tKUII,.bootstrap-min_container-xl__2wVN4{max-width:1140px}}.bootstrap-min_row__2048F{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.bootstrap-min_no-gutters__2cHQS{margin-right:0;margin-left:0}.bootstrap-min_no-gutters__2cHQS>.bootstrap-min_col__RU1cZ,.bootstrap-min_no-gutters__2cHQS>[class*=col-]{padding-right:0;padding-left:0}.bootstrap-min_col__RU1cZ,.bootstrap-min_col-1__6Qqlk,.bootstrap-min_col-10__3qdzx,.bootstrap-min_col-11__humUF,.bootstrap-min_col-12__16adp,.bootstrap-min_col-2__t1tH5,.bootstrap-min_col-3__2Qh34,.bootstrap-min_col-4__1uyBp,.bootstrap-min_col-5__1Cc2H,.bootstrap-min_col-6__3mVHX,.bootstrap-min_col-7__3z3Qw,.bootstrap-min_col-8__2v9P1,.bootstrap-min_col-9__Xi24b,.bootstrap-min_col-auto__2A5d2,.bootstrap-min_col-lg__1w0iC,.bootstrap-min_col-lg-1__3uad4,.bootstrap-min_col-lg-10__1yTjU,.bootstrap-min_col-lg-11__foFwG,.bootstrap-min_col-lg-12__1Vspn,.bootstrap-min_col-lg-2__1b4lq,.bootstrap-min_col-lg-3__3KCMa,.bootstrap-min_col-lg-4__3gZYS,.bootstrap-min_col-lg-5__2ewkc,.bootstrap-min_col-lg-6__15QrV,.bootstrap-min_col-lg-7__vKsWR,.bootstrap-min_col-lg-8__AZTLn,.bootstrap-min_col-lg-9__2459q,.bootstrap-min_col-lg-auto__11W6e,.bootstrap-min_col-md__AwNqC,.bootstrap-min_col-md-1__3I_2A,.bootstrap-min_col-md-10__1j5LU,.bootstrap-min_col-md-11__1RZFk,.bootstrap-min_col-md-12__2ymaN,.bootstrap-min_col-md-2__p0Q41,.bootstrap-min_col-md-3__1gEUG,.bootstrap-min_col-md-4__A8ARb,.bootstrap-min_col-md-5__15DVD,.bootstrap-min_col-md-6__1vbTi,.bootstrap-min_col-md-7__2QmfU,.bootstrap-min_col-md-8__3iK48,.bootstrap-min_col-md-9__2Apy1,.bootstrap-min_col-md-auto__Eh3F2,.bootstrap-min_col-sm__2eezo,.bootstrap-min_col-sm-1__2zUq3,.bootstrap-min_col-sm-10__36KiQ,.bootstrap-min_col-sm-11__2NDic,.bootstrap-min_col-sm-12__2voWg,.bootstrap-min_col-sm-2__1tKJK,.bootstrap-min_col-sm-3__28kxC,.bootstrap-min_col-sm-4__1jB7H,.bootstrap-min_col-sm-5__223ow,.bootstrap-min_col-sm-6__1V2Ts,.bootstrap-min_col-sm-7__1TWhA,.bootstrap-min_col-sm-8__p8PTP,.bootstrap-min_col-sm-9__3y-wC,.bootstrap-min_col-sm-auto__3eXkk,.bootstrap-min_col-xl__3x8LH,.bootstrap-min_col-xl-1__2VwYK,.bootstrap-min_col-xl-10__2ZUYg,.bootstrap-min_col-xl-11__3TMI9,.bootstrap-min_col-xl-12__3jtDi,.bootstrap-min_col-xl-2__1B8HE,.bootstrap-min_col-xl-3__1O7op,.bootstrap-min_col-xl-4__2_zwC,.bootstrap-min_col-xl-5__2-83a,.bootstrap-min_col-xl-6__3A7tk,.bootstrap-min_col-xl-7__2hvqJ,.bootstrap-min_col-xl-8__3K2Mi,.bootstrap-min_col-xl-9__1BHV0,.bootstrap-min_col-xl-auto__1bfNf{position:relative;width:100%;padding-right:15px;padding-left:15px}.bootstrap-min_col__RU1cZ{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.bootstrap-min_row-cols-1__17s3x>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-min_row-cols-2__3HOa1>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-min_row-cols-3__1VtF9>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.bootstrap-min_row-cols-4__3Z8ZM>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-min_row-cols-5__2gesp>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.bootstrap-min_row-cols-6__3pUo8>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.bootstrap-min_col-auto__2A5d2{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.bootstrap-min_col-1__6Qqlk{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.bootstrap-min_col-2__t1tH5{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.bootstrap-min_col-3__2Qh34{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-min_col-4__1uyBp{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.bootstrap-min_col-5__1Cc2H{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.bootstrap-min_col-6__3mVHX{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-min_col-7__3z3Qw{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.bootstrap-min_col-8__2v9P1{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.bootstrap-min_col-9__Xi24b{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.bootstrap-min_col-10__3qdzx{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.bootstrap-min_col-11__humUF{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.bootstrap-min_col-12__16adp{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-min_order-first__28lWR{-ms-flex-order:-1;order:-1}.bootstrap-min_order-last__3g_t_{-ms-flex-order:13;order:13}.bootstrap-min_order-0__3cuZw{-ms-flex-order:0;order:0}.bootstrap-min_order-1__2KDdd{-ms-flex-order:1;order:1}.bootstrap-min_order-2__30UBH{-ms-flex-order:2;order:2}.bootstrap-min_order-3__2c9Qo{-ms-flex-order:3;order:3}.bootstrap-min_order-4__1qR7U{-ms-flex-order:4;order:4}.bootstrap-min_order-5__1-g8r{-ms-flex-order:5;order:5}.bootstrap-min_order-6__2fzs6{-ms-flex-order:6;order:6}.bootstrap-min_order-7__3sTcN{-ms-flex-order:7;order:7}.bootstrap-min_order-8__3vwOs{-ms-flex-order:8;order:8}.bootstrap-min_order-9__2aDvf{-ms-flex-order:9;order:9}.bootstrap-min_order-10__3taRp{-ms-flex-order:10;order:10}.bootstrap-min_order-11__2l38Z{-ms-flex-order:11;order:11}.bootstrap-min_order-12__2SSvU{-ms-flex-order:12;order:12}.bootstrap-min_offset-1__3mzBL{margin-left:8.333333%}.bootstrap-min_offset-2__3maGy{margin-left:16.666667%}.bootstrap-min_offset-3__1nSf-{margin-left:25%}.bootstrap-min_offset-4__3yZ-m{margin-left:33.333333%}.bootstrap-min_offset-5__q9yNr{margin-left:41.666667%}.bootstrap-min_offset-6__TvaUa{margin-left:50%}.bootstrap-min_offset-7__2M1zt{margin-left:58.333333%}.bootstrap-min_offset-8__2RgJK{margin-left:66.666667%}.bootstrap-min_offset-9__1uFuD{margin-left:75%}.bootstrap-min_offset-10__h18sf{margin-left:83.333333%}.bootstrap-min_offset-11__zX4oX{margin-left:91.666667%}@media (min-width:576px){.bootstrap-min_col-sm__2eezo{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.bootstrap-min_row-cols-sm-1__1YI-->*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-min_row-cols-sm-2__1rG6J>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-min_row-cols-sm-3__AHK-_>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.bootstrap-min_row-cols-sm-4__lhzlF>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-min_row-cols-sm-5__2n7yS>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.bootstrap-min_row-cols-sm-6__2XI-H>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.bootstrap-min_col-sm-auto__3eXkk{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.bootstrap-min_col-sm-1__2zUq3{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.bootstrap-min_col-sm-2__1tKJK{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.bootstrap-min_col-sm-3__28kxC{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-min_col-sm-4__1jB7H{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.bootstrap-min_col-sm-5__223ow{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.bootstrap-min_col-sm-6__1V2Ts{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-min_col-sm-7__1TWhA{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.bootstrap-min_col-sm-8__p8PTP{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.bootstrap-min_col-sm-9__3y-wC{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.bootstrap-min_col-sm-10__36KiQ{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.bootstrap-min_col-sm-11__2NDic{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.bootstrap-min_col-sm-12__2voWg{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-min_order-sm-first__2k17P{-ms-flex-order:-1;order:-1}.bootstrap-min_order-sm-last__3q1xs{-ms-flex-order:13;order:13}.bootstrap-min_order-sm-0__2M61G{-ms-flex-order:0;order:0}.bootstrap-min_order-sm-1__2_70j{-ms-flex-order:1;order:1}.bootstrap-min_order-sm-2__3EAm4{-ms-flex-order:2;order:2}.bootstrap-min_order-sm-3__1mq1Y{-ms-flex-order:3;order:3}.bootstrap-min_order-sm-4__OCbRg{-ms-flex-order:4;order:4}.bootstrap-min_order-sm-5__1fPNh{-ms-flex-order:5;order:5}.bootstrap-min_order-sm-6__2VW6d{-ms-flex-order:6;order:6}.bootstrap-min_order-sm-7__3rWwI{-ms-flex-order:7;order:7}.bootstrap-min_order-sm-8__3kR4-{-ms-flex-order:8;order:8}.bootstrap-min_order-sm-9__1BsBm{-ms-flex-order:9;order:9}.bootstrap-min_order-sm-10__1Dw2N{-ms-flex-order:10;order:10}.bootstrap-min_order-sm-11__MsvfW{-ms-flex-order:11;order:11}.bootstrap-min_order-sm-12__37zpc{-ms-flex-order:12;order:12}.bootstrap-min_offset-sm-0__n3CzS{margin-left:0}.bootstrap-min_offset-sm-1__6tb4G{margin-left:8.333333%}.bootstrap-min_offset-sm-2__2bc2d{margin-left:16.666667%}.bootstrap-min_offset-sm-3__2DS7I{margin-left:25%}.bootstrap-min_offset-sm-4__3tUmd{margin-left:33.333333%}.bootstrap-min_offset-sm-5__WtsaI{margin-left:41.666667%}.bootstrap-min_offset-sm-6__1W2G-{margin-left:50%}.bootstrap-min_offset-sm-7__2i9yj{margin-left:58.333333%}.bootstrap-min_offset-sm-8__1O0yq{margin-left:66.666667%}.bootstrap-min_offset-sm-9__3xR1G{margin-left:75%}.bootstrap-min_offset-sm-10__B-s1V{margin-left:83.333333%}.bootstrap-min_offset-sm-11__3jxwU{margin-left:91.666667%}}@media (min-width:768px){.bootstrap-min_col-md__AwNqC{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.bootstrap-min_row-cols-md-1__-k6Y6>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-min_row-cols-md-2__2TOZg>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-min_row-cols-md-3__3UoEo>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.bootstrap-min_row-cols-md-4__ZsNCQ>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-min_row-cols-md-5__1Yybp>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.bootstrap-min_row-cols-md-6__1XtR5>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.bootstrap-min_col-md-auto__Eh3F2{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.bootstrap-min_col-md-1__3I_2A{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.bootstrap-min_col-md-2__p0Q41{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.bootstrap-min_col-md-3__1gEUG{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-min_col-md-4__A8ARb{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.bootstrap-min_col-md-5__15DVD{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.bootstrap-min_col-md-6__1vbTi{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-min_col-md-7__2QmfU{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.bootstrap-min_col-md-8__3iK48{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.bootstrap-min_col-md-9__2Apy1{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.bootstrap-min_col-md-10__1j5LU{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.bootstrap-min_col-md-11__1RZFk{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.bootstrap-min_col-md-12__2ymaN{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-min_order-md-first__1WWCe{-ms-flex-order:-1;order:-1}.bootstrap-min_order-md-last__mR5Bp{-ms-flex-order:13;order:13}.bootstrap-min_order-md-0__28tzJ{-ms-flex-order:0;order:0}.bootstrap-min_order-md-1__223p3{-ms-flex-order:1;order:1}.bootstrap-min_order-md-2__XCAHB{-ms-flex-order:2;order:2}.bootstrap-min_order-md-3__2271W{-ms-flex-order:3;order:3}.bootstrap-min_order-md-4__9OXRm{-ms-flex-order:4;order:4}.bootstrap-min_order-md-5__3wS7j{-ms-flex-order:5;order:5}.bootstrap-min_order-md-6__384rx{-ms-flex-order:6;order:6}.bootstrap-min_order-md-7__1GQjS{-ms-flex-order:7;order:7}.bootstrap-min_order-md-8__16Cus{-ms-flex-order:8;order:8}.bootstrap-min_order-md-9__1bqgE{-ms-flex-order:9;order:9}.bootstrap-min_order-md-10__wGaq4{-ms-flex-order:10;order:10}.bootstrap-min_order-md-11__1DvqF{-ms-flex-order:11;order:11}.bootstrap-min_order-md-12__Sl-FS{-ms-flex-order:12;order:12}.bootstrap-min_offset-md-0__SPrVN{margin-left:0}.bootstrap-min_offset-md-1__1kjsF{margin-left:8.333333%}.bootstrap-min_offset-md-2__1Z5-x{margin-left:16.666667%}.bootstrap-min_offset-md-3__E0BCz{margin-left:25%}.bootstrap-min_offset-md-4__1ffco{margin-left:33.333333%}.bootstrap-min_offset-md-5__1G_Uz{margin-left:41.666667%}.bootstrap-min_offset-md-6__1cQki{margin-left:50%}.bootstrap-min_offset-md-7__nXnvU{margin-left:58.333333%}.bootstrap-min_offset-md-8__3E9v2{margin-left:66.666667%}.bootstrap-min_offset-md-9__3Gqfq{margin-left:75%}.bootstrap-min_offset-md-10__9higS{margin-left:83.333333%}.bootstrap-min_offset-md-11__19ak1{margin-left:91.666667%}}@media (min-width:992px){.bootstrap-min_col-lg__1w0iC{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.bootstrap-min_row-cols-lg-1__pJ1M5>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-min_row-cols-lg-2__Yzghm>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-min_row-cols-lg-3__32Drx>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.bootstrap-min_row-cols-lg-4__E7tDH>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-min_row-cols-lg-5__HwOOz>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.bootstrap-min_row-cols-lg-6__1g-CY>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.bootstrap-min_col-lg-auto__11W6e{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.bootstrap-min_col-lg-1__3uad4{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.bootstrap-min_col-lg-2__1b4lq{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.bootstrap-min_col-lg-3__3KCMa{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-min_col-lg-4__3gZYS{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.bootstrap-min_col-lg-5__2ewkc{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.bootstrap-min_col-lg-6__15QrV{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-min_col-lg-7__vKsWR{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.bootstrap-min_col-lg-8__AZTLn{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.bootstrap-min_col-lg-9__2459q{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.bootstrap-min_col-lg-10__1yTjU{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.bootstrap-min_col-lg-11__foFwG{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.bootstrap-min_col-lg-12__1Vspn{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-min_order-lg-first__3zjdY{-ms-flex-order:-1;order:-1}.bootstrap-min_order-lg-last__ZajyN{-ms-flex-order:13;order:13}.bootstrap-min_order-lg-0__3jzDG{-ms-flex-order:0;order:0}.bootstrap-min_order-lg-1__1aowm{-ms-flex-order:1;order:1}.bootstrap-min_order-lg-2__3e2tv{-ms-flex-order:2;order:2}.bootstrap-min_order-lg-3__32qP5{-ms-flex-order:3;order:3}.bootstrap-min_order-lg-4__2tFzW{-ms-flex-order:4;order:4}.bootstrap-min_order-lg-5__10eHM{-ms-flex-order:5;order:5}.bootstrap-min_order-lg-6__3D81p{-ms-flex-order:6;order:6}.bootstrap-min_order-lg-7__2yqLZ{-ms-flex-order:7;order:7}.bootstrap-min_order-lg-8__n02o0{-ms-flex-order:8;order:8}.bootstrap-min_order-lg-9__2R-MI{-ms-flex-order:9;order:9}.bootstrap-min_order-lg-10__Sp1WV{-ms-flex-order:10;order:10}.bootstrap-min_order-lg-11__1TOZ6{-ms-flex-order:11;order:11}.bootstrap-min_order-lg-12__3V7kY{-ms-flex-order:12;order:12}.bootstrap-min_offset-lg-0__26L4O{margin-left:0}.bootstrap-min_offset-lg-1__32GA9{margin-left:8.333333%}.bootstrap-min_offset-lg-2__2URYH{margin-left:16.666667%}.bootstrap-min_offset-lg-3__23Skv{margin-left:25%}.bootstrap-min_offset-lg-4__13--v{margin-left:33.333333%}.bootstrap-min_offset-lg-5__1i8tr{margin-left:41.666667%}.bootstrap-min_offset-lg-6__poDMj{margin-left:50%}.bootstrap-min_offset-lg-7__2mMsa{margin-left:58.333333%}.bootstrap-min_offset-lg-8__10gUw{margin-left:66.666667%}.bootstrap-min_offset-lg-9__1bD10{margin-left:75%}.bootstrap-min_offset-lg-10___S191{margin-left:83.333333%}.bootstrap-min_offset-lg-11__mlrVt{margin-left:91.666667%}}@media (min-width:1200px){.bootstrap-min_col-xl__3x8LH{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.bootstrap-min_row-cols-xl-1__3NXKH>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-min_row-cols-xl-2__3dSan>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-min_row-cols-xl-3__2x4F8>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.bootstrap-min_row-cols-xl-4__19pch>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-min_row-cols-xl-5__1fm4s>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.bootstrap-min_row-cols-xl-6__2NiAs>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.bootstrap-min_col-xl-auto__1bfNf{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.bootstrap-min_col-xl-1__2VwYK{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.bootstrap-min_col-xl-2__1B8HE{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.bootstrap-min_col-xl-3__1O7op{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.bootstrap-min_col-xl-4__2_zwC{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.bootstrap-min_col-xl-5__2-83a{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.bootstrap-min_col-xl-6__3A7tk{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.bootstrap-min_col-xl-7__2hvqJ{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.bootstrap-min_col-xl-8__3K2Mi{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.bootstrap-min_col-xl-9__1BHV0{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.bootstrap-min_col-xl-10__2ZUYg{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.bootstrap-min_col-xl-11__3TMI9{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.bootstrap-min_col-xl-12__3jtDi{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.bootstrap-min_order-xl-first__ABKvU{-ms-flex-order:-1;order:-1}.bootstrap-min_order-xl-last__1ZQll{-ms-flex-order:13;order:13}.bootstrap-min_order-xl-0__3ctkz{-ms-flex-order:0;order:0}.bootstrap-min_order-xl-1__1hivV{-ms-flex-order:1;order:1}.bootstrap-min_order-xl-2__A8Fn-{-ms-flex-order:2;order:2}.bootstrap-min_order-xl-3__2iYrp{-ms-flex-order:3;order:3}.bootstrap-min_order-xl-4__2KWup{-ms-flex-order:4;order:4}.bootstrap-min_order-xl-5__19az2{-ms-flex-order:5;order:5}.bootstrap-min_order-xl-6__woc4X{-ms-flex-order:6;order:6}.bootstrap-min_order-xl-7__1kC3g{-ms-flex-order:7;order:7}.bootstrap-min_order-xl-8__2_Gls{-ms-flex-order:8;order:8}.bootstrap-min_order-xl-9__2ySo7{-ms-flex-order:9;order:9}.bootstrap-min_order-xl-10__zDPAG{-ms-flex-order:10;order:10}.bootstrap-min_order-xl-11__2-I-m{-ms-flex-order:11;order:11}.bootstrap-min_order-xl-12__1DZgb{-ms-flex-order:12;order:12}.bootstrap-min_offset-xl-0__3Ppx4{margin-left:0}.bootstrap-min_offset-xl-1__38A2i{margin-left:8.333333%}.bootstrap-min_offset-xl-2__1astV{margin-left:16.666667%}.bootstrap-min_offset-xl-3__3RLKt{margin-left:25%}.bootstrap-min_offset-xl-4__17-jt{margin-left:33.333333%}.bootstrap-min_offset-xl-5__1PhYG{margin-left:41.666667%}.bootstrap-min_offset-xl-6__1fV-o{margin-left:50%}.bootstrap-min_offset-xl-7__3DDhO{margin-left:58.333333%}.bootstrap-min_offset-xl-8__2lsdA{margin-left:66.666667%}.bootstrap-min_offset-xl-9__2nccN{margin-left:75%}.bootstrap-min_offset-xl-10__2wDrA{margin-left:83.333333%}.bootstrap-min_offset-xl-11__2E-O3{margin-left:91.666667%}}.bootstrap-min_table__GrZsg{width:100%;margin-bottom:1rem;color:#212529}.bootstrap-min_table__GrZsg td,.bootstrap-min_table__GrZsg th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.bootstrap-min_table__GrZsg thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.bootstrap-min_table__GrZsg tbody+tbody{border-top:2px solid #dee2e6}.bootstrap-min_table-sm__1Ill8 td,.bootstrap-min_table-sm__1Ill8 th{padding:.3rem}.bootstrap-min_table-bordered__jf6La{border:1px solid #dee2e6}.bootstrap-min_table-bordered__jf6La td,.bootstrap-min_table-bordered__jf6La th{border:1px solid #dee2e6}.bootstrap-min_table-bordered__jf6La thead td,.bootstrap-min_table-bordered__jf6La thead th{border-bottom-width:2px}.bootstrap-min_table-borderless__anXdR tbody+tbody,.bootstrap-min_table-borderless__anXdR td,.bootstrap-min_table-borderless__anXdR th,.bootstrap-min_table-borderless__anXdR thead th{border:0}.bootstrap-min_table-striped__15ObI tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.bootstrap-min_table-hover__2boCp tbody tr:hover{color:#212529;background-color:rgba(0,0,0,.075)}.bootstrap-min_table-primary__3SO7x,.bootstrap-min_table-primary__3SO7x>td,.bootstrap-min_table-primary__3SO7x>th{background-color:#b8daff}.bootstrap-min_table-primary__3SO7x tbody+tbody,.bootstrap-min_table-primary__3SO7x td,.bootstrap-min_table-primary__3SO7x th,.bootstrap-min_table-primary__3SO7x thead th{border-color:#7abaff}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-primary__3SO7x:hover{background-color:#9fcdff}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-primary__3SO7x:hover>td,.bootstrap-min_table-hover__2boCp .bootstrap-min_table-primary__3SO7x:hover>th{background-color:#9fcdff}.bootstrap-min_table-secondary__1ZpUz,.bootstrap-min_table-secondary__1ZpUz>td,.bootstrap-min_table-secondary__1ZpUz>th{background-color:#d6d8db}.bootstrap-min_table-secondary__1ZpUz tbody+tbody,.bootstrap-min_table-secondary__1ZpUz td,.bootstrap-min_table-secondary__1ZpUz th,.bootstrap-min_table-secondary__1ZpUz thead th{border-color:#b3b7bb}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-secondary__1ZpUz:hover{background-color:#c8cbcf}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-secondary__1ZpUz:hover>td,.bootstrap-min_table-hover__2boCp .bootstrap-min_table-secondary__1ZpUz:hover>th{background-color:#c8cbcf}.bootstrap-min_table-success__3AAEa,.bootstrap-min_table-success__3AAEa>td,.bootstrap-min_table-success__3AAEa>th{background-color:#c3e6cb}.bootstrap-min_table-success__3AAEa tbody+tbody,.bootstrap-min_table-success__3AAEa td,.bootstrap-min_table-success__3AAEa th,.bootstrap-min_table-success__3AAEa thead th{border-color:#8fd19e}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-success__3AAEa:hover{background-color:#b1dfbb}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-success__3AAEa:hover>td,.bootstrap-min_table-hover__2boCp .bootstrap-min_table-success__3AAEa:hover>th{background-color:#b1dfbb}.bootstrap-min_table-info__x680H,.bootstrap-min_table-info__x680H>td,.bootstrap-min_table-info__x680H>th{background-color:#bee5eb}.bootstrap-min_table-info__x680H tbody+tbody,.bootstrap-min_table-info__x680H td,.bootstrap-min_table-info__x680H th,.bootstrap-min_table-info__x680H thead th{border-color:#86cfda}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-info__x680H:hover{background-color:#abdde5}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-info__x680H:hover>td,.bootstrap-min_table-hover__2boCp .bootstrap-min_table-info__x680H:hover>th{background-color:#abdde5}.bootstrap-min_table-warning__3DXJT,.bootstrap-min_table-warning__3DXJT>td,.bootstrap-min_table-warning__3DXJT>th{background-color:#ffeeba}.bootstrap-min_table-warning__3DXJT tbody+tbody,.bootstrap-min_table-warning__3DXJT td,.bootstrap-min_table-warning__3DXJT th,.bootstrap-min_table-warning__3DXJT thead th{border-color:#ffdf7e}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-warning__3DXJT:hover{background-color:#ffe8a1}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-warning__3DXJT:hover>td,.bootstrap-min_table-hover__2boCp .bootstrap-min_table-warning__3DXJT:hover>th{background-color:#ffe8a1}.bootstrap-min_table-danger__9FPT1,.bootstrap-min_table-danger__9FPT1>td,.bootstrap-min_table-danger__9FPT1>th{background-color:#f5c6cb}.bootstrap-min_table-danger__9FPT1 tbody+tbody,.bootstrap-min_table-danger__9FPT1 td,.bootstrap-min_table-danger__9FPT1 th,.bootstrap-min_table-danger__9FPT1 thead th{border-color:#ed969e}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-danger__9FPT1:hover{background-color:#f1b0b7}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-danger__9FPT1:hover>td,.bootstrap-min_table-hover__2boCp .bootstrap-min_table-danger__9FPT1:hover>th{background-color:#f1b0b7}.bootstrap-min_table-light__16t3P,.bootstrap-min_table-light__16t3P>td,.bootstrap-min_table-light__16t3P>th{background-color:#fdfdfe}.bootstrap-min_table-light__16t3P tbody+tbody,.bootstrap-min_table-light__16t3P td,.bootstrap-min_table-light__16t3P th,.bootstrap-min_table-light__16t3P thead th{border-color:#fbfcfc}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-light__16t3P:hover{background-color:#ececf6}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-light__16t3P:hover>td,.bootstrap-min_table-hover__2boCp .bootstrap-min_table-light__16t3P:hover>th{background-color:#ececf6}.bootstrap-min_table-dark__ip9nb,.bootstrap-min_table-dark__ip9nb>td,.bootstrap-min_table-dark__ip9nb>th{background-color:#c6c8ca}.bootstrap-min_table-dark__ip9nb tbody+tbody,.bootstrap-min_table-dark__ip9nb td,.bootstrap-min_table-dark__ip9nb th,.bootstrap-min_table-dark__ip9nb thead th{border-color:#95999c}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-dark__ip9nb:hover{background-color:#b9bbbe}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-dark__ip9nb:hover>td,.bootstrap-min_table-hover__2boCp .bootstrap-min_table-dark__ip9nb:hover>th{background-color:#b9bbbe}.bootstrap-min_table-active__3Q_TP,.bootstrap-min_table-active__3Q_TP>td,.bootstrap-min_table-active__3Q_TP>th{background-color:rgba(0,0,0,.075)}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-active__3Q_TP:hover{background-color:rgba(0,0,0,.075)}.bootstrap-min_table-hover__2boCp .bootstrap-min_table-active__3Q_TP:hover>td,.bootstrap-min_table-hover__2boCp .bootstrap-min_table-active__3Q_TP:hover>th{background-color:rgba(0,0,0,.075)}.bootstrap-min_table__GrZsg .bootstrap-min_thead-dark__269Fy th{color:#fff;background-color:#343a40;border-color:#454d55}.bootstrap-min_table__GrZsg .bootstrap-min_thead-light__3mJqb th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.bootstrap-min_table-dark__ip9nb{color:#fff;background-color:#343a40}.bootstrap-min_table-dark__ip9nb td,.bootstrap-min_table-dark__ip9nb th,.bootstrap-min_table-dark__ip9nb thead th{border-color:#454d55}.bootstrap-min_table-dark__ip9nb.bootstrap-min_table-bordered__jf6La{border:0}.bootstrap-min_table-dark__ip9nb.bootstrap-min_table-striped__15ObI tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,.05)}.bootstrap-min_table-dark__ip9nb.bootstrap-min_table-hover__2boCp tbody tr:hover{color:#fff;background-color:rgba(255,255,255,.075)}@media (max-width:575.98px){.bootstrap-min_table-responsive-sm__337J0{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.bootstrap-min_table-responsive-sm__337J0>.bootstrap-min_table-bordered__jf6La{border:0}}@media (max-width:767.98px){.bootstrap-min_table-responsive-md__3g9P4{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.bootstrap-min_table-responsive-md__3g9P4>.bootstrap-min_table-bordered__jf6La{border:0}}@media (max-width:991.98px){.bootstrap-min_table-responsive-lg__bpkWR{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.bootstrap-min_table-responsive-lg__bpkWR>.bootstrap-min_table-bordered__jf6La{border:0}}@media (max-width:1199.98px){.bootstrap-min_table-responsive-xl__1QLe-{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.bootstrap-min_table-responsive-xl__1QLe->.bootstrap-min_table-bordered__jf6La{border:0}}.bootstrap-min_table-responsive__3JORC{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.bootstrap-min_table-responsive__3JORC>.bootstrap-min_table-bordered__jf6La{border:0}.bootstrap-min_form-control__fANnP{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.bootstrap-min_form-control__fANnP{transition:none}}.bootstrap-min_form-control__fANnP::-ms-expand{background-color:transparent;border:0}.bootstrap-min_form-control__fANnP:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.bootstrap-min_form-control__fANnP:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.bootstrap-min_form-control__fANnP::-webkit-input-placeholder{color:#6c757d;opacity:1}.bootstrap-min_form-control__fANnP::-moz-placeholder{color:#6c757d;opacity:1}.bootstrap-min_form-control__fANnP:-ms-input-placeholder{color:#6c757d;opacity:1}.bootstrap-min_form-control__fANnP::-ms-input-placeholder{color:#6c757d;opacity:1}.bootstrap-min_form-control__fANnP::placeholder{color:#6c757d;opacity:1}.bootstrap-min_form-control__fANnP:disabled,.bootstrap-min_form-control__fANnP[readonly]{background-color:#e9ecef;opacity:1}input[type=date].bootstrap-min_form-control__fANnP,input[type=datetime-local].bootstrap-min_form-control__fANnP,input[type=month].bootstrap-min_form-control__fANnP,input[type=time].bootstrap-min_form-control__fANnP{-webkit-appearance:none;-moz-appearance:none;appearance:none}select.bootstrap-min_form-control__fANnP:focus::-ms-value{color:#495057;background-color:#fff}.bootstrap-min_form-control-file__3Hngc,.bootstrap-min_form-control-range__1n97V{display:block;width:100%}.bootstrap-min_col-form-label__1z8uf{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.bootstrap-min_col-form-label-lg__2Qksr{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.bootstrap-min_col-form-label-sm__2wdq-{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.bootstrap-min_form-control-plaintext__3Vm1h{display:block;width:100%;padding:.375rem 0;margin-bottom:0;font-size:1rem;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.bootstrap-min_form-control-plaintext__3Vm1h.bootstrap-min_form-control-lg__3soHr,.bootstrap-min_form-control-plaintext__3Vm1h.bootstrap-min_form-control-sm__2nCKg{padding-right:0;padding-left:0}.bootstrap-min_form-control-sm__2nCKg{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.bootstrap-min_form-control-lg__3soHr{height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}select.bootstrap-min_form-control__fANnP[multiple],select.bootstrap-min_form-control__fANnP[size]{height:auto}textarea.bootstrap-min_form-control__fANnP{height:auto}.bootstrap-min_form-group__1njHb{margin-bottom:1rem}.bootstrap-min_form-text__306pf{display:block;margin-top:.25rem}.bootstrap-min_form-row__24oCs{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.bootstrap-min_form-row__24oCs>.bootstrap-min_col__RU1cZ,.bootstrap-min_form-row__24oCs>[class*=col-]{padding-right:5px;padding-left:5px}.bootstrap-min_form-check__3sVw_{position:relative;display:block;padding-left:1.25rem}.bootstrap-min_form-check-input__3DDZ-{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.bootstrap-min_form-check-input__3DDZ-:disabled~.bootstrap-min_form-check-label__3xBdx,.bootstrap-min_form-check-input__3DDZ-[disabled]~.bootstrap-min_form-check-label__3xBdx{color:#6c757d}.bootstrap-min_form-check-label__3xBdx{margin-bottom:0}.bootstrap-min_form-check-inline__2b2Vf{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;padding-left:0;margin-right:.75rem}.bootstrap-min_form-check-inline__2b2Vf .bootstrap-min_form-check-input__3DDZ-{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.bootstrap-min_valid-feedback__14GzG{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.bootstrap-min_valid-tooltip__NuBPF{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(40,167,69,.9);border-radius:.25rem}.bootstrap-min_is-valid__SWhYo~.bootstrap-min_valid-feedback__14GzG,.bootstrap-min_is-valid__SWhYo~.bootstrap-min_valid-tooltip__NuBPF,.bootstrap-min_was-validated__3iU3L :valid~.bootstrap-min_valid-feedback__14GzG,.bootstrap-min_was-validated__3iU3L :valid~.bootstrap-min_valid-tooltip__NuBPF{display:block}.bootstrap-min_form-control__fANnP.bootstrap-min_is-valid__SWhYo,.bootstrap-min_was-validated__3iU3L .bootstrap-min_form-control__fANnP:valid{border-color:#28a745;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.bootstrap-min_form-control__fANnP.bootstrap-min_is-valid__SWhYo:focus,.bootstrap-min_was-validated__3iU3L .bootstrap-min_form-control__fANnP:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.bootstrap-min_was-validated__3iU3L textarea.bootstrap-min_form-control__fANnP:valid,textarea.bootstrap-min_form-control__fANnP.bootstrap-min_is-valid__SWhYo{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.bootstrap-min_custom-select__14GRb.bootstrap-min_is-valid__SWhYo,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-select__14GRb:valid{border-color:#28a745;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem)}.bootstrap-min_custom-select__14GRb.bootstrap-min_is-valid__SWhYo:focus,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-select__14GRb:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.bootstrap-min_form-check-input__3DDZ-.bootstrap-min_is-valid__SWhYo~.bootstrap-min_form-check-label__3xBdx,.bootstrap-min_was-validated__3iU3L .bootstrap-min_form-check-input__3DDZ-:valid~.bootstrap-min_form-check-label__3xBdx{color:#28a745}.bootstrap-min_form-check-input__3DDZ-.bootstrap-min_is-valid__SWhYo~.bootstrap-min_valid-feedback__14GzG,.bootstrap-min_form-check-input__3DDZ-.bootstrap-min_is-valid__SWhYo~.bootstrap-min_valid-tooltip__NuBPF,.bootstrap-min_was-validated__3iU3L .bootstrap-min_form-check-input__3DDZ-:valid~.bootstrap-min_valid-feedback__14GzG,.bootstrap-min_was-validated__3iU3L .bootstrap-min_form-check-input__3DDZ-:valid~.bootstrap-min_valid-tooltip__NuBPF{display:block}.bootstrap-min_custom-control-input__j1ZQf.bootstrap-min_is-valid__SWhYo~.bootstrap-min_custom-control-label__fKECc,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-control-input__j1ZQf:valid~.bootstrap-min_custom-control-label__fKECc{color:#28a745}.bootstrap-min_custom-control-input__j1ZQf.bootstrap-min_is-valid__SWhYo~.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-control-input__j1ZQf:valid~.bootstrap-min_custom-control-label__fKECc::before{border-color:#28a745}.bootstrap-min_custom-control-input__j1ZQf.bootstrap-min_is-valid__SWhYo:checked~.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-control-input__j1ZQf:valid:checked~.bootstrap-min_custom-control-label__fKECc::before{border-color:#34ce57;background-color:#34ce57}.bootstrap-min_custom-control-input__j1ZQf.bootstrap-min_is-valid__SWhYo:focus~.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-control-input__j1ZQf:valid:focus~.bootstrap-min_custom-control-label__fKECc::before{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.bootstrap-min_custom-control-input__j1ZQf.bootstrap-min_is-valid__SWhYo:focus:not(:checked)~.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-control-input__j1ZQf:valid:focus:not(:checked)~.bootstrap-min_custom-control-label__fKECc::before{border-color:#28a745}.bootstrap-min_custom-file-input__36AJ8.bootstrap-min_is-valid__SWhYo~.bootstrap-min_custom-file-label__2PmAt,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-file-input__36AJ8:valid~.bootstrap-min_custom-file-label__2PmAt{border-color:#28a745}.bootstrap-min_custom-file-input__36AJ8.bootstrap-min_is-valid__SWhYo:focus~.bootstrap-min_custom-file-label__2PmAt,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-file-input__36AJ8:valid:focus~.bootstrap-min_custom-file-label__2PmAt{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.bootstrap-min_invalid-feedback__2rYSE{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.bootstrap-min_invalid-tooltip__3Xb-8{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.bootstrap-min_is-invalid__P7W0T~.bootstrap-min_invalid-feedback__2rYSE,.bootstrap-min_is-invalid__P7W0T~.bootstrap-min_invalid-tooltip__3Xb-8,.bootstrap-min_was-validated__3iU3L :invalid~.bootstrap-min_invalid-feedback__2rYSE,.bootstrap-min_was-validated__3iU3L :invalid~.bootstrap-min_invalid-tooltip__3Xb-8{display:block}.bootstrap-min_form-control__fANnP.bootstrap-min_is-invalid__P7W0T,.bootstrap-min_was-validated__3iU3L .bootstrap-min_form-control__fANnP:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.bootstrap-min_form-control__fANnP.bootstrap-min_is-invalid__P7W0T:focus,.bootstrap-min_was-validated__3iU3L .bootstrap-min_form-control__fANnP:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.bootstrap-min_was-validated__3iU3L textarea.bootstrap-min_form-control__fANnP:invalid,textarea.bootstrap-min_form-control__fANnP.bootstrap-min_is-invalid__P7W0T{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.bootstrap-min_custom-select__14GRb.bootstrap-min_is-invalid__P7W0T,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-select__14GRb:invalid{border-color:#dc3545;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem)}.bootstrap-min_custom-select__14GRb.bootstrap-min_is-invalid__P7W0T:focus,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-select__14GRb:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.bootstrap-min_form-check-input__3DDZ-.bootstrap-min_is-invalid__P7W0T~.bootstrap-min_form-check-label__3xBdx,.bootstrap-min_was-validated__3iU3L .bootstrap-min_form-check-input__3DDZ-:invalid~.bootstrap-min_form-check-label__3xBdx{color:#dc3545}.bootstrap-min_form-check-input__3DDZ-.bootstrap-min_is-invalid__P7W0T~.bootstrap-min_invalid-feedback__2rYSE,.bootstrap-min_form-check-input__3DDZ-.bootstrap-min_is-invalid__P7W0T~.bootstrap-min_invalid-tooltip__3Xb-8,.bootstrap-min_was-validated__3iU3L .bootstrap-min_form-check-input__3DDZ-:invalid~.bootstrap-min_invalid-feedback__2rYSE,.bootstrap-min_was-validated__3iU3L .bootstrap-min_form-check-input__3DDZ-:invalid~.bootstrap-min_invalid-tooltip__3Xb-8{display:block}.bootstrap-min_custom-control-input__j1ZQf.bootstrap-min_is-invalid__P7W0T~.bootstrap-min_custom-control-label__fKECc,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-control-input__j1ZQf:invalid~.bootstrap-min_custom-control-label__fKECc{color:#dc3545}.bootstrap-min_custom-control-input__j1ZQf.bootstrap-min_is-invalid__P7W0T~.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-control-input__j1ZQf:invalid~.bootstrap-min_custom-control-label__fKECc::before{border-color:#dc3545}.bootstrap-min_custom-control-input__j1ZQf.bootstrap-min_is-invalid__P7W0T:checked~.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-control-input__j1ZQf:invalid:checked~.bootstrap-min_custom-control-label__fKECc::before{border-color:#e4606d;background-color:#e4606d}.bootstrap-min_custom-control-input__j1ZQf.bootstrap-min_is-invalid__P7W0T:focus~.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-control-input__j1ZQf:invalid:focus~.bootstrap-min_custom-control-label__fKECc::before{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.bootstrap-min_custom-control-input__j1ZQf.bootstrap-min_is-invalid__P7W0T:focus:not(:checked)~.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-control-input__j1ZQf:invalid:focus:not(:checked)~.bootstrap-min_custom-control-label__fKECc::before{border-color:#dc3545}.bootstrap-min_custom-file-input__36AJ8.bootstrap-min_is-invalid__P7W0T~.bootstrap-min_custom-file-label__2PmAt,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-file-input__36AJ8:invalid~.bootstrap-min_custom-file-label__2PmAt{border-color:#dc3545}.bootstrap-min_custom-file-input__36AJ8.bootstrap-min_is-invalid__P7W0T:focus~.bootstrap-min_custom-file-label__2PmAt,.bootstrap-min_was-validated__3iU3L .bootstrap-min_custom-file-input__36AJ8:invalid:focus~.bootstrap-min_custom-file-label__2PmAt{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.bootstrap-min_form-inline__1XVYA{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center}.bootstrap-min_form-inline__1XVYA .bootstrap-min_form-check__3sVw_{width:100%}@media (min-width:576px){.bootstrap-min_form-inline__1XVYA label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;margin-bottom:0}.bootstrap-min_form-inline__1XVYA .bootstrap-min_form-group__1njHb{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center;margin-bottom:0}.bootstrap-min_form-inline__1XVYA .bootstrap-min_form-control__fANnP{display:inline-block;width:auto;vertical-align:middle}.bootstrap-min_form-inline__1XVYA .bootstrap-min_form-control-plaintext__3Vm1h{display:inline-block}.bootstrap-min_form-inline__1XVYA .bootstrap-min_custom-select__14GRb,.bootstrap-min_form-inline__1XVYA .bootstrap-min_input-group__3jA_e{width:auto}.bootstrap-min_form-inline__1XVYA .bootstrap-min_form-check__3sVw_{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-left:0}.bootstrap-min_form-inline__1XVYA .bootstrap-min_form-check-input__3DDZ-{position:relative;-ms-flex-negative:0;flex-shrink:0;margin-top:0;margin-right:.25rem;margin-left:0}.bootstrap-min_form-inline__1XVYA .bootstrap-min_custom-control__1tp0t{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.bootstrap-min_form-inline__1XVYA .bootstrap-min_custom-control-label__fKECc{margin-bottom:0}}.bootstrap-min_btn__33rIN{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.bootstrap-min_btn__33rIN{transition:none}}.bootstrap-min_btn__33rIN:hover{color:#212529;text-decoration:none}.bootstrap-min_btn__33rIN.bootstrap-min_focus__35glV,.bootstrap-min_btn__33rIN:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.bootstrap-min_btn__33rIN.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn__33rIN:disabled{opacity:.65}.bootstrap-min_btn__33rIN:not(:disabled):not(.bootstrap-min_disabled__fTMRt){cursor:pointer}a.bootstrap-min_btn__33rIN.bootstrap-min_disabled__fTMRt,fieldset:disabled a.bootstrap-min_btn__33rIN{pointer-events:none}.bootstrap-min_btn-primary__1uK5i{color:#fff;background-color:#007bff;border-color:#007bff}.bootstrap-min_btn-primary__1uK5i:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.bootstrap-min_btn-primary__1uK5i.bootstrap-min_focus__35glV,.bootstrap-min_btn-primary__1uK5i:focus{color:#fff;background-color:#0069d9;border-color:#0062cc;box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.bootstrap-min_btn-primary__1uK5i.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-primary__1uK5i:disabled{color:#fff;background-color:#007bff;border-color:#007bff}.bootstrap-min_btn-primary__1uK5i:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-primary__1uK5i:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-primary__1uK5i.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#0062cc;border-color:#005cbf}.bootstrap-min_btn-primary__1uK5i:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-primary__1uK5i:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-primary__1uK5i.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.bootstrap-min_btn-secondary__147J1{color:#fff;background-color:#6c757d;border-color:#6c757d}.bootstrap-min_btn-secondary__147J1:hover{color:#fff;background-color:#5a6268;border-color:#545b62}.bootstrap-min_btn-secondary__147J1.bootstrap-min_focus__35glV,.bootstrap-min_btn-secondary__147J1:focus{color:#fff;background-color:#5a6268;border-color:#545b62;box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.bootstrap-min_btn-secondary__147J1.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-secondary__147J1:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.bootstrap-min_btn-secondary__147J1:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-secondary__147J1:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-secondary__147J1.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#545b62;border-color:#4e555b}.bootstrap-min_btn-secondary__147J1:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-secondary__147J1:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-secondary__147J1.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.bootstrap-min_btn-success__2Ish5{color:#fff;background-color:#28a745;border-color:#28a745}.bootstrap-min_btn-success__2Ish5:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.bootstrap-min_btn-success__2Ish5.bootstrap-min_focus__35glV,.bootstrap-min_btn-success__2Ish5:focus{color:#fff;background-color:#218838;border-color:#1e7e34;box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.bootstrap-min_btn-success__2Ish5.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-success__2Ish5:disabled{color:#fff;background-color:#28a745;border-color:#28a745}.bootstrap-min_btn-success__2Ish5:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-success__2Ish5:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-success__2Ish5.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#1e7e34;border-color:#1c7430}.bootstrap-min_btn-success__2Ish5:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-success__2Ish5:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-success__2Ish5.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.bootstrap-min_btn-info__3XM44{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.bootstrap-min_btn-info__3XM44:hover{color:#fff;background-color:#138496;border-color:#117a8b}.bootstrap-min_btn-info__3XM44.bootstrap-min_focus__35glV,.bootstrap-min_btn-info__3XM44:focus{color:#fff;background-color:#138496;border-color:#117a8b;box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.bootstrap-min_btn-info__3XM44.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-info__3XM44:disabled{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.bootstrap-min_btn-info__3XM44:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-info__3XM44:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-info__3XM44.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#117a8b;border-color:#10707f}.bootstrap-min_btn-info__3XM44:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-info__3XM44:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-info__3XM44.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.bootstrap-min_btn-warning__3IE29{color:#212529;background-color:#ffc107;border-color:#ffc107}.bootstrap-min_btn-warning__3IE29:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.bootstrap-min_btn-warning__3IE29.bootstrap-min_focus__35glV,.bootstrap-min_btn-warning__3IE29:focus{color:#212529;background-color:#e0a800;border-color:#d39e00;box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.bootstrap-min_btn-warning__3IE29.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-warning__3IE29:disabled{color:#212529;background-color:#ffc107;border-color:#ffc107}.bootstrap-min_btn-warning__3IE29:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-warning__3IE29:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-warning__3IE29.bootstrap-min_dropdown-toggle__1nQ3V{color:#212529;background-color:#d39e00;border-color:#c69500}.bootstrap-min_btn-warning__3IE29:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-warning__3IE29:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-warning__3IE29.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.bootstrap-min_btn-danger__1PX1f{color:#fff;background-color:#dc3545;border-color:#dc3545}.bootstrap-min_btn-danger__1PX1f:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.bootstrap-min_btn-danger__1PX1f.bootstrap-min_focus__35glV,.bootstrap-min_btn-danger__1PX1f:focus{color:#fff;background-color:#c82333;border-color:#bd2130;box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.bootstrap-min_btn-danger__1PX1f.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-danger__1PX1f:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.bootstrap-min_btn-danger__1PX1f:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-danger__1PX1f:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-danger__1PX1f.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#bd2130;border-color:#b21f2d}.bootstrap-min_btn-danger__1PX1f:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-danger__1PX1f:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-danger__1PX1f.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.bootstrap-min_btn-light__3CaQW{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.bootstrap-min_btn-light__3CaQW:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.bootstrap-min_btn-light__3CaQW.bootstrap-min_focus__35glV,.bootstrap-min_btn-light__3CaQW:focus{color:#212529;background-color:#e2e6ea;border-color:#dae0e5;box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.bootstrap-min_btn-light__3CaQW.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-light__3CaQW:disabled{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.bootstrap-min_btn-light__3CaQW:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-light__3CaQW:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-light__3CaQW.bootstrap-min_dropdown-toggle__1nQ3V{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.bootstrap-min_btn-light__3CaQW:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-light__3CaQW:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-light__3CaQW.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.bootstrap-min_btn-dark__2Sqzj{color:#fff;background-color:#343a40;border-color:#343a40}.bootstrap-min_btn-dark__2Sqzj:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.bootstrap-min_btn-dark__2Sqzj.bootstrap-min_focus__35glV,.bootstrap-min_btn-dark__2Sqzj:focus{color:#fff;background-color:#23272b;border-color:#1d2124;box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.bootstrap-min_btn-dark__2Sqzj.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-dark__2Sqzj:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.bootstrap-min_btn-dark__2Sqzj:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-dark__2Sqzj:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-dark__2Sqzj.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#1d2124;border-color:#171a1d}.bootstrap-min_btn-dark__2Sqzj:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-dark__2Sqzj:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-dark__2Sqzj.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.bootstrap-min_btn-outline-primary__1PhQ7{color:#007bff;border-color:#007bff}.bootstrap-min_btn-outline-primary__1PhQ7:hover{color:#fff;background-color:#007bff;border-color:#007bff}.bootstrap-min_btn-outline-primary__1PhQ7.bootstrap-min_focus__35glV,.bootstrap-min_btn-outline-primary__1PhQ7:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.bootstrap-min_btn-outline-primary__1PhQ7.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-outline-primary__1PhQ7:disabled{color:#007bff;background-color:transparent}.bootstrap-min_btn-outline-primary__1PhQ7:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-outline-primary__1PhQ7:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-primary__1PhQ7.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#007bff;border-color:#007bff}.bootstrap-min_btn-outline-primary__1PhQ7:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-outline-primary__1PhQ7:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-primary__1PhQ7.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.bootstrap-min_btn-outline-secondary__3EK6n{color:#6c757d;border-color:#6c757d}.bootstrap-min_btn-outline-secondary__3EK6n:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.bootstrap-min_btn-outline-secondary__3EK6n.bootstrap-min_focus__35glV,.bootstrap-min_btn-outline-secondary__3EK6n:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.bootstrap-min_btn-outline-secondary__3EK6n.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-outline-secondary__3EK6n:disabled{color:#6c757d;background-color:transparent}.bootstrap-min_btn-outline-secondary__3EK6n:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-outline-secondary__3EK6n:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-secondary__3EK6n.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#6c757d;border-color:#6c757d}.bootstrap-min_btn-outline-secondary__3EK6n:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-outline-secondary__3EK6n:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-secondary__3EK6n.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.bootstrap-min_btn-outline-success__hmqmA{color:#28a745;border-color:#28a745}.bootstrap-min_btn-outline-success__hmqmA:hover{color:#fff;background-color:#28a745;border-color:#28a745}.bootstrap-min_btn-outline-success__hmqmA.bootstrap-min_focus__35glV,.bootstrap-min_btn-outline-success__hmqmA:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.bootstrap-min_btn-outline-success__hmqmA.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-outline-success__hmqmA:disabled{color:#28a745;background-color:transparent}.bootstrap-min_btn-outline-success__hmqmA:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-outline-success__hmqmA:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-success__hmqmA.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#28a745;border-color:#28a745}.bootstrap-min_btn-outline-success__hmqmA:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-outline-success__hmqmA:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-success__hmqmA.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.bootstrap-min_btn-outline-info__d5m4a{color:#17a2b8;border-color:#17a2b8}.bootstrap-min_btn-outline-info__d5m4a:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.bootstrap-min_btn-outline-info__d5m4a.bootstrap-min_focus__35glV,.bootstrap-min_btn-outline-info__d5m4a:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.bootstrap-min_btn-outline-info__d5m4a.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-outline-info__d5m4a:disabled{color:#17a2b8;background-color:transparent}.bootstrap-min_btn-outline-info__d5m4a:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-outline-info__d5m4a:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-info__d5m4a.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.bootstrap-min_btn-outline-info__d5m4a:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-outline-info__d5m4a:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-info__d5m4a.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.bootstrap-min_btn-outline-warning__ktVaW{color:#ffc107;border-color:#ffc107}.bootstrap-min_btn-outline-warning__ktVaW:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.bootstrap-min_btn-outline-warning__ktVaW.bootstrap-min_focus__35glV,.bootstrap-min_btn-outline-warning__ktVaW:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.bootstrap-min_btn-outline-warning__ktVaW.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-outline-warning__ktVaW:disabled{color:#ffc107;background-color:transparent}.bootstrap-min_btn-outline-warning__ktVaW:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-outline-warning__ktVaW:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-warning__ktVaW.bootstrap-min_dropdown-toggle__1nQ3V{color:#212529;background-color:#ffc107;border-color:#ffc107}.bootstrap-min_btn-outline-warning__ktVaW:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-outline-warning__ktVaW:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-warning__ktVaW.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.bootstrap-min_btn-outline-danger__219up{color:#dc3545;border-color:#dc3545}.bootstrap-min_btn-outline-danger__219up:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.bootstrap-min_btn-outline-danger__219up.bootstrap-min_focus__35glV,.bootstrap-min_btn-outline-danger__219up:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.bootstrap-min_btn-outline-danger__219up.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-outline-danger__219up:disabled{color:#dc3545;background-color:transparent}.bootstrap-min_btn-outline-danger__219up:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-outline-danger__219up:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-danger__219up.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#dc3545;border-color:#dc3545}.bootstrap-min_btn-outline-danger__219up:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-outline-danger__219up:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-danger__219up.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.bootstrap-min_btn-outline-light__qbKU0{color:#f8f9fa;border-color:#f8f9fa}.bootstrap-min_btn-outline-light__qbKU0:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.bootstrap-min_btn-outline-light__qbKU0.bootstrap-min_focus__35glV,.bootstrap-min_btn-outline-light__qbKU0:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.bootstrap-min_btn-outline-light__qbKU0.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-outline-light__qbKU0:disabled{color:#f8f9fa;background-color:transparent}.bootstrap-min_btn-outline-light__qbKU0:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-outline-light__qbKU0:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-light__qbKU0.bootstrap-min_dropdown-toggle__1nQ3V{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.bootstrap-min_btn-outline-light__qbKU0:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-outline-light__qbKU0:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-light__qbKU0.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.bootstrap-min_btn-outline-dark__1zkgz{color:#343a40;border-color:#343a40}.bootstrap-min_btn-outline-dark__1zkgz:hover{color:#fff;background-color:#343a40;border-color:#343a40}.bootstrap-min_btn-outline-dark__1zkgz.bootstrap-min_focus__35glV,.bootstrap-min_btn-outline-dark__1zkgz:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.bootstrap-min_btn-outline-dark__1zkgz.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-outline-dark__1zkgz:disabled{color:#343a40;background-color:transparent}.bootstrap-min_btn-outline-dark__1zkgz:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW,.bootstrap-min_btn-outline-dark__1zkgz:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-dark__1zkgz.bootstrap-min_dropdown-toggle__1nQ3V{color:#fff;background-color:#343a40;border-color:#343a40}.bootstrap-min_btn-outline-dark__1zkgz:not(:disabled):not(.bootstrap-min_disabled__fTMRt).bootstrap-min_active__tKiHW:focus,.bootstrap-min_btn-outline-dark__1zkgz:not(:disabled):not(.bootstrap-min_disabled__fTMRt):active:focus,.bootstrap-min_show__21bZy>.bootstrap-min_btn-outline-dark__1zkgz.bootstrap-min_dropdown-toggle__1nQ3V:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.bootstrap-min_btn-link__3yKvN{font-weight:400;color:#007bff;text-decoration:none}.bootstrap-min_btn-link__3yKvN:hover{color:#0056b3;text-decoration:underline}.bootstrap-min_btn-link__3yKvN.bootstrap-min_focus__35glV,.bootstrap-min_btn-link__3yKvN:focus{text-decoration:underline}.bootstrap-min_btn-link__3yKvN.bootstrap-min_disabled__fTMRt,.bootstrap-min_btn-link__3yKvN:disabled{color:#6c757d;pointer-events:none}.bootstrap-min_btn-group-lg__1whjW>.bootstrap-min_btn__33rIN,.bootstrap-min_btn-lg__1NEsE{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.bootstrap-min_btn-group-sm__yebtv>.bootstrap-min_btn__33rIN,.bootstrap-min_btn-sm__3Jksh{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.bootstrap-min_btn-block__36r0B{display:block;width:100%}.bootstrap-min_btn-block__36r0B+.bootstrap-min_btn-block__36r0B{margin-top:.5rem}input[type=button].bootstrap-min_btn-block__36r0B,input[type=reset].bootstrap-min_btn-block__36r0B,input[type=submit].bootstrap-min_btn-block__36r0B{width:100%}.bootstrap-min_fade__1rBDU{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.bootstrap-min_fade__1rBDU{transition:none}}.bootstrap-min_fade__1rBDU:not(.bootstrap-min_show__21bZy){opacity:0}.bootstrap-min_collapse__EYjfW:not(.bootstrap-min_show__21bZy){display:none}.bootstrap-min_collapsing__1zNEv{position:relative;height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.bootstrap-min_collapsing__1zNEv{transition:none}}.bootstrap-min_dropdown__24B3o,.bootstrap-min_dropleft__2Od7v,.bootstrap-min_dropright__2m7GB,.bootstrap-min_dropup__2vLDm{position:relative}.bootstrap-min_dropdown-toggle__1nQ3V{white-space:nowrap}.bootstrap-min_dropdown-toggle__1nQ3V::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.bootstrap-min_dropdown-toggle__1nQ3V:empty::after{margin-left:0}.bootstrap-min_dropdown-menu__1u94g{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.bootstrap-min_dropdown-menu-left__3h_I_{right:auto;left:0}.bootstrap-min_dropdown-menu-right__3Qt2w{right:0;left:auto}@media (min-width:576px){.bootstrap-min_dropdown-menu-sm-left__Dzh69{right:auto;left:0}.bootstrap-min_dropdown-menu-sm-right__2louD{right:0;left:auto}}@media (min-width:768px){.bootstrap-min_dropdown-menu-md-left__zHGYv{right:auto;left:0}.bootstrap-min_dropdown-menu-md-right__3gZ65{right:0;left:auto}}@media (min-width:992px){.bootstrap-min_dropdown-menu-lg-left__1v5Wo{right:auto;left:0}.bootstrap-min_dropdown-menu-lg-right__3Pb7w{right:0;left:auto}}@media (min-width:1200px){.bootstrap-min_dropdown-menu-xl-left__1ja3T{right:auto;left:0}.bootstrap-min_dropdown-menu-xl-right__21VN_{right:0;left:auto}}.bootstrap-min_dropup__2vLDm .bootstrap-min_dropdown-menu__1u94g{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.bootstrap-min_dropup__2vLDm .bootstrap-min_dropdown-toggle__1nQ3V::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.bootstrap-min_dropup__2vLDm .bootstrap-min_dropdown-toggle__1nQ3V:empty::after{margin-left:0}.bootstrap-min_dropright__2m7GB .bootstrap-min_dropdown-menu__1u94g{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.bootstrap-min_dropright__2m7GB .bootstrap-min_dropdown-toggle__1nQ3V::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.bootstrap-min_dropright__2m7GB .bootstrap-min_dropdown-toggle__1nQ3V:empty::after{margin-left:0}.bootstrap-min_dropright__2m7GB .bootstrap-min_dropdown-toggle__1nQ3V::after{vertical-align:0}.bootstrap-min_dropleft__2Od7v .bootstrap-min_dropdown-menu__1u94g{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.bootstrap-min_dropleft__2Od7v .bootstrap-min_dropdown-toggle__1nQ3V::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.bootstrap-min_dropleft__2Od7v .bootstrap-min_dropdown-toggle__1nQ3V::after{display:none}.bootstrap-min_dropleft__2Od7v .bootstrap-min_dropdown-toggle__1nQ3V::before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.bootstrap-min_dropleft__2Od7v .bootstrap-min_dropdown-toggle__1nQ3V:empty::after{margin-left:0}.bootstrap-min_dropleft__2Od7v .bootstrap-min_dropdown-toggle__1nQ3V::before{vertical-align:0}.bootstrap-min_dropdown-menu__1u94g[x-placement^=bottom],.bootstrap-min_dropdown-menu__1u94g[x-placement^=left],.bootstrap-min_dropdown-menu__1u94g[x-placement^=right],.bootstrap-min_dropdown-menu__1u94g[x-placement^=top]{right:auto;bottom:auto}.bootstrap-min_dropdown-divider__1U5Zc{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.bootstrap-min_dropdown-item__2YDDX{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.bootstrap-min_dropdown-item__2YDDX:focus,.bootstrap-min_dropdown-item__2YDDX:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.bootstrap-min_dropdown-item__2YDDX.bootstrap-min_active__tKiHW,.bootstrap-min_dropdown-item__2YDDX:active{color:#fff;text-decoration:none;background-color:#007bff}.bootstrap-min_dropdown-item__2YDDX.bootstrap-min_disabled__fTMRt,.bootstrap-min_dropdown-item__2YDDX:disabled{color:#6c757d;pointer-events:none;background-color:transparent}.bootstrap-min_dropdown-menu__1u94g.bootstrap-min_show__21bZy{display:block}.bootstrap-min_dropdown-header__1L0Zd{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.bootstrap-min_dropdown-item-text__58RV7{display:block;padding:.25rem 1.5rem;color:#212529}.bootstrap-min_btn-group__3RVt3,.bootstrap-min_btn-group-vertical__HGkYe{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn__33rIN,.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn__33rIN:hover,.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN:hover{z-index:1}.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn__33rIN.bootstrap-min_active__tKiHW,.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn__33rIN:active,.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn__33rIN:focus,.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN.bootstrap-min_active__tKiHW,.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN:active,.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN:focus{z-index:1}.bootstrap-min_btn-toolbar__3SE_R{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:start;justify-content:flex-start}.bootstrap-min_btn-toolbar__3SE_R .bootstrap-min_input-group__3jA_e{width:auto}.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn-group__3RVt3:not(:first-child),.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN:not(:first-child){margin-left:-1px}.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn-group__3RVt3:not(:last-child)>.bootstrap-min_btn__33rIN,.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN:not(:last-child):not(.bootstrap-min_dropdown-toggle__1nQ3V){border-top-right-radius:0;border-bottom-right-radius:0}.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn-group__3RVt3:not(:first-child)>.bootstrap-min_btn__33rIN,.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.bootstrap-min_dropdown-toggle-split__2m7Jq{padding-right:.5625rem;padding-left:.5625rem}.bootstrap-min_dropdown-toggle-split__2m7Jq::after,.bootstrap-min_dropright__2m7GB .bootstrap-min_dropdown-toggle-split__2m7Jq::after,.bootstrap-min_dropup__2vLDm .bootstrap-min_dropdown-toggle-split__2m7Jq::after{margin-left:0}.bootstrap-min_dropleft__2Od7v .bootstrap-min_dropdown-toggle-split__2m7Jq::before{margin-right:0}.bootstrap-min_btn-group-sm__yebtv>.bootstrap-min_btn__33rIN+.bootstrap-min_dropdown-toggle-split__2m7Jq,.bootstrap-min_btn-sm__3Jksh+.bootstrap-min_dropdown-toggle-split__2m7Jq{padding-right:.375rem;padding-left:.375rem}.bootstrap-min_btn-group-lg__1whjW>.bootstrap-min_btn__33rIN+.bootstrap-min_dropdown-toggle-split__2m7Jq,.bootstrap-min_btn-lg__1NEsE+.bootstrap-min_dropdown-toggle-split__2m7Jq{padding-right:.75rem;padding-left:.75rem}.bootstrap-min_btn-group-vertical__HGkYe{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:center;justify-content:center}.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn__33rIN,.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn-group__3RVt3{width:100%}.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn-group__3RVt3:not(:first-child),.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn__33rIN:not(:first-child){margin-top:-1px}.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn-group__3RVt3:not(:last-child)>.bootstrap-min_btn__33rIN,.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn__33rIN:not(:last-child):not(.bootstrap-min_dropdown-toggle__1nQ3V){border-bottom-right-radius:0;border-bottom-left-radius:0}.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn-group__3RVt3:not(:first-child)>.bootstrap-min_btn__33rIN,.bootstrap-min_btn-group-vertical__HGkYe>.bootstrap-min_btn__33rIN:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.bootstrap-min_btn-group-toggle__JJedm>.bootstrap-min_btn__33rIN,.bootstrap-min_btn-group-toggle__JJedm>.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN{margin-bottom:0}.bootstrap-min_btn-group-toggle__JJedm>.bootstrap-min_btn__33rIN input[type=checkbox],.bootstrap-min_btn-group-toggle__JJedm>.bootstrap-min_btn__33rIN input[type=radio],.bootstrap-min_btn-group-toggle__JJedm>.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN input[type=checkbox],.bootstrap-min_btn-group-toggle__JJedm>.bootstrap-min_btn-group__3RVt3>.bootstrap-min_btn__33rIN input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.bootstrap-min_input-group__3jA_e{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:stretch;align-items:stretch;width:100%}.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-file___5Bw0,.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-select__14GRb,.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control__fANnP,.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control-plaintext__3Vm1h{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0}.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-file___5Bw0+.bootstrap-min_custom-file___5Bw0,.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-file___5Bw0+.bootstrap-min_custom-select__14GRb,.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-file___5Bw0+.bootstrap-min_form-control__fANnP,.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-select__14GRb+.bootstrap-min_custom-file___5Bw0,.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-select__14GRb+.bootstrap-min_custom-select__14GRb,.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-select__14GRb+.bootstrap-min_form-control__fANnP,.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control__fANnP+.bootstrap-min_custom-file___5Bw0,.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control__fANnP+.bootstrap-min_custom-select__14GRb,.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control__fANnP+.bootstrap-min_form-control__fANnP,.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control-plaintext__3Vm1h+.bootstrap-min_custom-file___5Bw0,.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control-plaintext__3Vm1h+.bootstrap-min_custom-select__14GRb,.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control-plaintext__3Vm1h+.bootstrap-min_form-control__fANnP{margin-left:-1px}.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-file___5Bw0 .bootstrap-min_custom-file-input__36AJ8:focus~.bootstrap-min_custom-file-label__2PmAt,.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-select__14GRb:focus,.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control__fANnP:focus{z-index:3}.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-file___5Bw0 .bootstrap-min_custom-file-input__36AJ8:focus{z-index:4}.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-select__14GRb:not(:last-child),.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control__fANnP:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-select__14GRb:not(:first-child),.bootstrap-min_input-group__3jA_e>.bootstrap-min_form-control__fANnP:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-file___5Bw0{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-file___5Bw0:not(:last-child) .bootstrap-min_custom-file-label__2PmAt,.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-file___5Bw0:not(:last-child) .bootstrap-min_custom-file-label__2PmAt::after{border-top-right-radius:0;border-bottom-right-radius:0}.bootstrap-min_input-group__3jA_e>.bootstrap-min_custom-file___5Bw0:not(:first-child) .bootstrap-min_custom-file-label__2PmAt{border-top-left-radius:0;border-bottom-left-radius:0}.bootstrap-min_input-group-append__1O8Y5,.bootstrap-min_input-group-prepend__1yylP{display:-ms-flexbox;display:flex}.bootstrap-min_input-group-append__1O8Y5 .bootstrap-min_btn__33rIN,.bootstrap-min_input-group-prepend__1yylP .bootstrap-min_btn__33rIN{position:relative;z-index:2}.bootstrap-min_input-group-append__1O8Y5 .bootstrap-min_btn__33rIN:focus,.bootstrap-min_input-group-prepend__1yylP .bootstrap-min_btn__33rIN:focus{z-index:3}.bootstrap-min_input-group-append__1O8Y5 .bootstrap-min_btn__33rIN+.bootstrap-min_btn__33rIN,.bootstrap-min_input-group-append__1O8Y5 .bootstrap-min_btn__33rIN+.bootstrap-min_input-group-text__eKdwB,.bootstrap-min_input-group-append__1O8Y5 .bootstrap-min_input-group-text__eKdwB+.bootstrap-min_btn__33rIN,.bootstrap-min_input-group-append__1O8Y5 .bootstrap-min_input-group-text__eKdwB+.bootstrap-min_input-group-text__eKdwB,.bootstrap-min_input-group-prepend__1yylP .bootstrap-min_btn__33rIN+.bootstrap-min_btn__33rIN,.bootstrap-min_input-group-prepend__1yylP .bootstrap-min_btn__33rIN+.bootstrap-min_input-group-text__eKdwB,.bootstrap-min_input-group-prepend__1yylP .bootstrap-min_input-group-text__eKdwB+.bootstrap-min_btn__33rIN,.bootstrap-min_input-group-prepend__1yylP .bootstrap-min_input-group-text__eKdwB+.bootstrap-min_input-group-text__eKdwB{margin-left:-1px}.bootstrap-min_input-group-prepend__1yylP{margin-right:-1px}.bootstrap-min_input-group-append__1O8Y5{margin-left:-1px}.bootstrap-min_input-group-text__eKdwB{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.bootstrap-min_input-group-text__eKdwB input[type=checkbox],.bootstrap-min_input-group-text__eKdwB input[type=radio]{margin-top:0}.bootstrap-min_input-group-lg__3ts2N>.bootstrap-min_custom-select__14GRb,.bootstrap-min_input-group-lg__3ts2N>.bootstrap-min_form-control__fANnP:not(textarea){height:calc(1.5em + 1rem + 2px)}.bootstrap-min_input-group-lg__3ts2N>.bootstrap-min_custom-select__14GRb,.bootstrap-min_input-group-lg__3ts2N>.bootstrap-min_form-control__fANnP,.bootstrap-min_input-group-lg__3ts2N>.bootstrap-min_input-group-append__1O8Y5>.bootstrap-min_btn__33rIN,.bootstrap-min_input-group-lg__3ts2N>.bootstrap-min_input-group-append__1O8Y5>.bootstrap-min_input-group-text__eKdwB,.bootstrap-min_input-group-lg__3ts2N>.bootstrap-min_input-group-prepend__1yylP>.bootstrap-min_btn__33rIN,.bootstrap-min_input-group-lg__3ts2N>.bootstrap-min_input-group-prepend__1yylP>.bootstrap-min_input-group-text__eKdwB{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.bootstrap-min_input-group-sm__1YLWo>.bootstrap-min_custom-select__14GRb,.bootstrap-min_input-group-sm__1YLWo>.bootstrap-min_form-control__fANnP:not(textarea){height:calc(1.5em + .5rem + 2px)}.bootstrap-min_input-group-sm__1YLWo>.bootstrap-min_custom-select__14GRb,.bootstrap-min_input-group-sm__1YLWo>.bootstrap-min_form-control__fANnP,.bootstrap-min_input-group-sm__1YLWo>.bootstrap-min_input-group-append__1O8Y5>.bootstrap-min_btn__33rIN,.bootstrap-min_input-group-sm__1YLWo>.bootstrap-min_input-group-append__1O8Y5>.bootstrap-min_input-group-text__eKdwB,.bootstrap-min_input-group-sm__1YLWo>.bootstrap-min_input-group-prepend__1yylP>.bootstrap-min_btn__33rIN,.bootstrap-min_input-group-sm__1YLWo>.bootstrap-min_input-group-prepend__1yylP>.bootstrap-min_input-group-text__eKdwB{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.bootstrap-min_input-group-lg__3ts2N>.bootstrap-min_custom-select__14GRb,.bootstrap-min_input-group-sm__1YLWo>.bootstrap-min_custom-select__14GRb{padding-right:1.75rem}.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-append__1O8Y5:last-child>.bootstrap-min_btn__33rIN:not(:last-child):not(.bootstrap-min_dropdown-toggle__1nQ3V),.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-append__1O8Y5:last-child>.bootstrap-min_input-group-text__eKdwB:not(:last-child),.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-append__1O8Y5:not(:last-child)>.bootstrap-min_btn__33rIN,.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-append__1O8Y5:not(:last-child)>.bootstrap-min_input-group-text__eKdwB,.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-prepend__1yylP>.bootstrap-min_btn__33rIN,.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-prepend__1yylP>.bootstrap-min_input-group-text__eKdwB{border-top-right-radius:0;border-bottom-right-radius:0}.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-append__1O8Y5>.bootstrap-min_btn__33rIN,.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-append__1O8Y5>.bootstrap-min_input-group-text__eKdwB,.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-prepend__1yylP:first-child>.bootstrap-min_btn__33rIN:not(:first-child),.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-prepend__1yylP:first-child>.bootstrap-min_input-group-text__eKdwB:not(:first-child),.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-prepend__1yylP:not(:first-child)>.bootstrap-min_btn__33rIN,.bootstrap-min_input-group__3jA_e>.bootstrap-min_input-group-prepend__1yylP:not(:first-child)>.bootstrap-min_input-group-text__eKdwB{border-top-left-radius:0;border-bottom-left-radius:0}.bootstrap-min_custom-control__1tp0t{position:relative;z-index:1;display:block;min-height:1.5rem;padding-left:1.5rem;-webkit-print-color-adjust:exact;color-adjust:exact}.bootstrap-min_custom-control-inline__2cZ13{display:-ms-inline-flexbox;display:inline-flex;margin-right:1rem}.bootstrap-min_custom-control-input__j1ZQf{position:absolute;left:0;z-index:-1;width:1rem;height:1.25rem;opacity:0}.bootstrap-min_custom-control-input__j1ZQf:checked~.bootstrap-min_custom-control-label__fKECc::before{color:#fff;border-color:#007bff;background-color:#007bff}.bootstrap-min_custom-control-input__j1ZQf:focus~.bootstrap-min_custom-control-label__fKECc::before{box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.bootstrap-min_custom-control-input__j1ZQf:focus:not(:checked)~.bootstrap-min_custom-control-label__fKECc::before{border-color:#80bdff}.bootstrap-min_custom-control-input__j1ZQf:not(:disabled):active~.bootstrap-min_custom-control-label__fKECc::before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.bootstrap-min_custom-control-input__j1ZQf:disabled~.bootstrap-min_custom-control-label__fKECc,.bootstrap-min_custom-control-input__j1ZQf[disabled]~.bootstrap-min_custom-control-label__fKECc{color:#6c757d}.bootstrap-min_custom-control-input__j1ZQf:disabled~.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_custom-control-input__j1ZQf[disabled]~.bootstrap-min_custom-control-label__fKECc::before{background-color:#e9ecef}.bootstrap-min_custom-control-label__fKECc{position:relative;margin-bottom:0;vertical-align:top}.bootstrap-min_custom-control-label__fKECc::before{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;pointer-events:none;content:\"\";background-color:#fff;border:#adb5bd solid 1px}.bootstrap-min_custom-control-label__fKECc::after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:\"\";background:no-repeat 50%/50% 50%}.bootstrap-min_custom-checkbox__2KOad .bootstrap-min_custom-control-label__fKECc::before{border-radius:.25rem}.bootstrap-min_custom-checkbox__2KOad .bootstrap-min_custom-control-input__j1ZQf:checked~.bootstrap-min_custom-control-label__fKECc::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\")}.bootstrap-min_custom-checkbox__2KOad .bootstrap-min_custom-control-input__j1ZQf:indeterminate~.bootstrap-min_custom-control-label__fKECc::before{border-color:#007bff;background-color:#007bff}.bootstrap-min_custom-checkbox__2KOad .bootstrap-min_custom-control-input__j1ZQf:indeterminate~.bootstrap-min_custom-control-label__fKECc::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.bootstrap-min_custom-checkbox__2KOad .bootstrap-min_custom-control-input__j1ZQf:disabled:checked~.bootstrap-min_custom-control-label__fKECc::before{background-color:rgba(0,123,255,.5)}.bootstrap-min_custom-checkbox__2KOad .bootstrap-min_custom-control-input__j1ZQf:disabled:indeterminate~.bootstrap-min_custom-control-label__fKECc::before{background-color:rgba(0,123,255,.5)}.bootstrap-min_custom-radio__2JbKQ .bootstrap-min_custom-control-label__fKECc::before{border-radius:50%}.bootstrap-min_custom-radio__2JbKQ .bootstrap-min_custom-control-input__j1ZQf:checked~.bootstrap-min_custom-control-label__fKECc::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.bootstrap-min_custom-radio__2JbKQ .bootstrap-min_custom-control-input__j1ZQf:disabled:checked~.bootstrap-min_custom-control-label__fKECc::before{background-color:rgba(0,123,255,.5)}.bootstrap-min_custom-switch__3anO_{padding-left:2.25rem}.bootstrap-min_custom-switch__3anO_ .bootstrap-min_custom-control-label__fKECc::before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.bootstrap-min_custom-switch__3anO_ .bootstrap-min_custom-control-label__fKECc::after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out}@media (prefers-reduced-motion:reduce){.bootstrap-min_custom-switch__3anO_ .bootstrap-min_custom-control-label__fKECc::after{transition:none}}.bootstrap-min_custom-switch__3anO_ .bootstrap-min_custom-control-input__j1ZQf:checked~.bootstrap-min_custom-control-label__fKECc::after{background-color:#fff;-webkit-transform:translateX(.75rem);transform:translateX(.75rem)}.bootstrap-min_custom-switch__3anO_ .bootstrap-min_custom-control-input__j1ZQf:disabled:checked~.bootstrap-min_custom-control-label__fKECc::before{background-color:rgba(0,123,255,.5)}.bootstrap-min_custom-select__14GRb{display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.bootstrap-min_custom-select__14GRb:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.bootstrap-min_custom-select__14GRb:focus::-ms-value{color:#495057;background-color:#fff}.bootstrap-min_custom-select__14GRb[multiple],.bootstrap-min_custom-select__14GRb[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.bootstrap-min_custom-select__14GRb:disabled{color:#6c757d;background-color:#e9ecef}.bootstrap-min_custom-select__14GRb::-ms-expand{display:none}.bootstrap-min_custom-select__14GRb:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.bootstrap-min_custom-select-sm__2m6aP{height:calc(1.5em + .5rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.bootstrap-min_custom-select-lg__1Zlsp{height:calc(1.5em + 1rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.bootstrap-min_custom-file___5Bw0{position:relative;display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);margin-bottom:0}.bootstrap-min_custom-file-input__36AJ8{position:relative;z-index:2;width:100%;height:calc(1.5em + .75rem + 2px);margin:0;opacity:0}.bootstrap-min_custom-file-input__36AJ8:focus~.bootstrap-min_custom-file-label__2PmAt{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.bootstrap-min_custom-file-input__36AJ8:disabled~.bootstrap-min_custom-file-label__2PmAt,.bootstrap-min_custom-file-input__36AJ8[disabled]~.bootstrap-min_custom-file-label__2PmAt{background-color:#e9ecef}.bootstrap-min_custom-file-input__36AJ8:lang(en)~.bootstrap-min_custom-file-label__2PmAt::after{content:\"Browse\"}.bootstrap-min_custom-file-input__36AJ8~.bootstrap-min_custom-file-label__2PmAt[data-browse]::after{content:attr(data-browse)}.bootstrap-min_custom-file-label__2PmAt{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.bootstrap-min_custom-file-label__2PmAt::after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:calc(1.5em + .75rem);padding:.375rem .75rem;line-height:1.5;color:#495057;content:\"Browse\";background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.bootstrap-min_custom-range__Qwkss{width:100%;height:1.4rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.bootstrap-min_custom-range__Qwkss:focus{outline:0}.bootstrap-min_custom-range__Qwkss:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.bootstrap-min_custom-range__Qwkss:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.bootstrap-min_custom-range__Qwkss:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.bootstrap-min_custom-range__Qwkss::-moz-focus-outer{border:0}.bootstrap-min_custom-range__Qwkss::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.bootstrap-min_custom-range__Qwkss::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.bootstrap-min_custom-range__Qwkss::-webkit-slider-thumb:active{background-color:#b3d7ff}.bootstrap-min_custom-range__Qwkss::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.bootstrap-min_custom-range__Qwkss::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.bootstrap-min_custom-range__Qwkss::-moz-range-thumb{-moz-transition:none;transition:none}}.bootstrap-min_custom-range__Qwkss::-moz-range-thumb:active{background-color:#b3d7ff}.bootstrap-min_custom-range__Qwkss::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.bootstrap-min_custom-range__Qwkss::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;-ms-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.bootstrap-min_custom-range__Qwkss::-ms-thumb{-ms-transition:none;transition:none}}.bootstrap-min_custom-range__Qwkss::-ms-thumb:active{background-color:#b3d7ff}.bootstrap-min_custom-range__Qwkss::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.bootstrap-min_custom-range__Qwkss::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.bootstrap-min_custom-range__Qwkss::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.bootstrap-min_custom-range__Qwkss:disabled::-webkit-slider-thumb{background-color:#adb5bd}.bootstrap-min_custom-range__Qwkss:disabled::-webkit-slider-runnable-track{cursor:default}.bootstrap-min_custom-range__Qwkss:disabled::-moz-range-thumb{background-color:#adb5bd}.bootstrap-min_custom-range__Qwkss:disabled::-moz-range-track{cursor:default}.bootstrap-min_custom-range__Qwkss:disabled::-ms-thumb{background-color:#adb5bd}.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_custom-file-label__2PmAt,.bootstrap-min_custom-select__14GRb{transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.bootstrap-min_custom-control-label__fKECc::before,.bootstrap-min_custom-file-label__2PmAt,.bootstrap-min_custom-select__14GRb{transition:none}}.bootstrap-min_nav__1KQTZ{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.bootstrap-min_nav-link__3iORz{display:block;padding:.5rem 1rem}.bootstrap-min_nav-link__3iORz:focus,.bootstrap-min_nav-link__3iORz:hover{text-decoration:none}.bootstrap-min_nav-link__3iORz.bootstrap-min_disabled__fTMRt{color:#6c757d;pointer-events:none;cursor:default}.bootstrap-min_nav-tabs__1DJRQ{border-bottom:1px solid #dee2e6}.bootstrap-min_nav-tabs__1DJRQ .bootstrap-min_nav-item__1G8h7{margin-bottom:-1px}.bootstrap-min_nav-tabs__1DJRQ .bootstrap-min_nav-link__3iORz{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.bootstrap-min_nav-tabs__1DJRQ .bootstrap-min_nav-link__3iORz:focus,.bootstrap-min_nav-tabs__1DJRQ .bootstrap-min_nav-link__3iORz:hover{border-color:#e9ecef #e9ecef #dee2e6}.bootstrap-min_nav-tabs__1DJRQ .bootstrap-min_nav-link__3iORz.bootstrap-min_disabled__fTMRt{color:#6c757d;background-color:transparent;border-color:transparent}.bootstrap-min_nav-tabs__1DJRQ .bootstrap-min_nav-item__1G8h7.bootstrap-min_show__21bZy .bootstrap-min_nav-link__3iORz,.bootstrap-min_nav-tabs__1DJRQ .bootstrap-min_nav-link__3iORz.bootstrap-min_active__tKiHW{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.bootstrap-min_nav-tabs__1DJRQ .bootstrap-min_dropdown-menu__1u94g{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.bootstrap-min_nav-pills__1ffn9 .bootstrap-min_nav-link__3iORz{border-radius:.25rem}.bootstrap-min_nav-pills__1ffn9 .bootstrap-min_nav-link__3iORz.bootstrap-min_active__tKiHW,.bootstrap-min_nav-pills__1ffn9 .bootstrap-min_show__21bZy>.bootstrap-min_nav-link__3iORz{color:#fff;background-color:#007bff}.bootstrap-min_nav-fill__3Ger5 .bootstrap-min_nav-item__1G8h7,.bootstrap-min_nav-fill__3Ger5>.bootstrap-min_nav-link__3iORz{-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}.bootstrap-min_nav-justified__1auPN .bootstrap-min_nav-item__1G8h7,.bootstrap-min_nav-justified__1auPN>.bootstrap-min_nav-link__3iORz{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;text-align:center}.bootstrap-min_tab-content__3y46z>.bootstrap-min_tab-pane__2dZcs{display:none}.bootstrap-min_tab-content__3y46z>.bootstrap-min_active__tKiHW{display:block}.bootstrap-min_navbar__3LmOW{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;padding:.5rem 1rem}.bootstrap-min_navbar__3LmOW .bootstrap-min_container__3i4Ca,.bootstrap-min_navbar__3LmOW .bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar__3LmOW .bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar__3LmOW .bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar__3LmOW .bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar__3LmOW .bootstrap-min_container-xl__2wVN4{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.bootstrap-min_navbar-brand__3b-gG{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.bootstrap-min_navbar-brand__3b-gG:focus,.bootstrap-min_navbar-brand__3b-gG:hover{text-decoration:none}.bootstrap-min_navbar-nav__1QAGq{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz{padding-right:0;padding-left:0}.bootstrap-min_navbar-nav__1QAGq .bootstrap-min_dropdown-menu__1u94g{position:static;float:none}.bootstrap-min_navbar-text__1YpP7{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.bootstrap-min_navbar-collapse__1jtm0{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center}.bootstrap-min_navbar-toggler__DLkkw{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.bootstrap-min_navbar-toggler__DLkkw:focus,.bootstrap-min_navbar-toggler__DLkkw:hover{text-decoration:none}.bootstrap-min_navbar-toggler-icon__2r4bQ{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat center center;background-size:100% 100%}@media (max-width:575.98px){.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container__3i4Ca,.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container-xl__2wVN4{padding-right:0;padding-left:0}}@media (min-width:576px){.bootstrap-min_navbar-expand-sm__j4DXU{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.bootstrap-min_navbar-expand-sm__j4DXU .bootstrap-min_navbar-nav__1QAGq{-ms-flex-direction:row;flex-direction:row}.bootstrap-min_navbar-expand-sm__j4DXU .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_dropdown-menu__1u94g{position:absolute}.bootstrap-min_navbar-expand-sm__j4DXU .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz{padding-right:.5rem;padding-left:.5rem}.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container__3i4Ca,.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar-expand-sm__j4DXU>.bootstrap-min_container-xl__2wVN4{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.bootstrap-min_navbar-expand-sm__j4DXU .bootstrap-min_navbar-collapse__1jtm0{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.bootstrap-min_navbar-expand-sm__j4DXU .bootstrap-min_navbar-toggler__DLkkw{display:none}}@media (max-width:767.98px){.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container__3i4Ca,.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container-xl__2wVN4{padding-right:0;padding-left:0}}@media (min-width:768px){.bootstrap-min_navbar-expand-md__3bbmV{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.bootstrap-min_navbar-expand-md__3bbmV .bootstrap-min_navbar-nav__1QAGq{-ms-flex-direction:row;flex-direction:row}.bootstrap-min_navbar-expand-md__3bbmV .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_dropdown-menu__1u94g{position:absolute}.bootstrap-min_navbar-expand-md__3bbmV .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz{padding-right:.5rem;padding-left:.5rem}.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container__3i4Ca,.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar-expand-md__3bbmV>.bootstrap-min_container-xl__2wVN4{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.bootstrap-min_navbar-expand-md__3bbmV .bootstrap-min_navbar-collapse__1jtm0{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.bootstrap-min_navbar-expand-md__3bbmV .bootstrap-min_navbar-toggler__DLkkw{display:none}}@media (max-width:991.98px){.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container__3i4Ca,.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container-xl__2wVN4{padding-right:0;padding-left:0}}@media (min-width:992px){.bootstrap-min_navbar-expand-lg__2kfZt{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.bootstrap-min_navbar-expand-lg__2kfZt .bootstrap-min_navbar-nav__1QAGq{-ms-flex-direction:row;flex-direction:row}.bootstrap-min_navbar-expand-lg__2kfZt .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_dropdown-menu__1u94g{position:absolute}.bootstrap-min_navbar-expand-lg__2kfZt .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz{padding-right:.5rem;padding-left:.5rem}.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container__3i4Ca,.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar-expand-lg__2kfZt>.bootstrap-min_container-xl__2wVN4{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.bootstrap-min_navbar-expand-lg__2kfZt .bootstrap-min_navbar-collapse__1jtm0{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.bootstrap-min_navbar-expand-lg__2kfZt .bootstrap-min_navbar-toggler__DLkkw{display:none}}@media (max-width:1199.98px){.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container__3i4Ca,.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container-xl__2wVN4{padding-right:0;padding-left:0}}@media (min-width:1200px){.bootstrap-min_navbar-expand-xl__8Tsm5{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.bootstrap-min_navbar-expand-xl__8Tsm5 .bootstrap-min_navbar-nav__1QAGq{-ms-flex-direction:row;flex-direction:row}.bootstrap-min_navbar-expand-xl__8Tsm5 .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_dropdown-menu__1u94g{position:absolute}.bootstrap-min_navbar-expand-xl__8Tsm5 .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz{padding-right:.5rem;padding-left:.5rem}.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container__3i4Ca,.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar-expand-xl__8Tsm5>.bootstrap-min_container-xl__2wVN4{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.bootstrap-min_navbar-expand-xl__8Tsm5 .bootstrap-min_navbar-collapse__1jtm0{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.bootstrap-min_navbar-expand-xl__8Tsm5 .bootstrap-min_navbar-toggler__DLkkw{display:none}}.bootstrap-min_navbar-expand__1ABOo{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container__3i4Ca,.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container-xl__2wVN4{padding-right:0;padding-left:0}.bootstrap-min_navbar-expand__1ABOo .bootstrap-min_navbar-nav__1QAGq{-ms-flex-direction:row;flex-direction:row}.bootstrap-min_navbar-expand__1ABOo .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_dropdown-menu__1u94g{position:absolute}.bootstrap-min_navbar-expand__1ABOo .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz{padding-right:.5rem;padding-left:.5rem}.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container__3i4Ca,.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container-fluid__Jx8Kl,.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container-lg__2yBBQ,.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container-md__kncAJ,.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container-sm__tKUII,.bootstrap-min_navbar-expand__1ABOo>.bootstrap-min_container-xl__2wVN4{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.bootstrap-min_navbar-expand__1ABOo .bootstrap-min_navbar-collapse__1jtm0{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.bootstrap-min_navbar-expand__1ABOo .bootstrap-min_navbar-toggler__DLkkw{display:none}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-brand__3b-gG{color:rgba(0,0,0,.9)}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-brand__3b-gG:focus,.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-brand__3b-gG:hover{color:rgba(0,0,0,.9)}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz{color:rgba(0,0,0,.5)}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz:focus,.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz:hover{color:rgba(0,0,0,.7)}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz.bootstrap-min_disabled__fTMRt{color:rgba(0,0,0,.3)}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_active__tKiHW>.bootstrap-min_nav-link__3iORz,.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz.bootstrap-min_active__tKiHW,.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz.bootstrap-min_show__21bZy,.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_show__21bZy>.bootstrap-min_nav-link__3iORz{color:rgba(0,0,0,.9)}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-toggler__DLkkw{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-toggler-icon__2r4bQ{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-text__1YpP7{color:rgba(0,0,0,.5)}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-text__1YpP7 a{color:rgba(0,0,0,.9)}.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-text__1YpP7 a:focus,.bootstrap-min_navbar-light__2VTxL .bootstrap-min_navbar-text__1YpP7 a:hover{color:rgba(0,0,0,.9)}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-brand__3b-gG{color:#fff}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-brand__3b-gG:focus,.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-brand__3b-gG:hover{color:#fff}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz{color:rgba(255,255,255,.5)}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz:focus,.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz:hover{color:rgba(255,255,255,.75)}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz.bootstrap-min_disabled__fTMRt{color:rgba(255,255,255,.25)}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_active__tKiHW>.bootstrap-min_nav-link__3iORz,.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz.bootstrap-min_active__tKiHW,.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_nav-link__3iORz.bootstrap-min_show__21bZy,.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-nav__1QAGq .bootstrap-min_show__21bZy>.bootstrap-min_nav-link__3iORz{color:#fff}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-toggler__DLkkw{color:rgba(255,255,255,.5);border-color:rgba(255,255,255,.1)}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-toggler-icon__2r4bQ{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-text__1YpP7{color:rgba(255,255,255,.5)}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-text__1YpP7 a{color:#fff}.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-text__1YpP7 a:focus,.bootstrap-min_navbar-dark__2kzdG .bootstrap-min_navbar-text__1YpP7 a:hover{color:#fff}.bootstrap-min_card__1W6lu{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.bootstrap-min_card__1W6lu>hr{margin-right:0;margin-left:0}.bootstrap-min_card__1W6lu>.bootstrap-min_list-group__2z24x{border-top:inherit;border-bottom:inherit}.bootstrap-min_card__1W6lu>.bootstrap-min_list-group__2z24x:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.bootstrap-min_card__1W6lu>.bootstrap-min_list-group__2z24x:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.bootstrap-min_card__1W6lu>.bootstrap-min_card-header__1mHyC+.bootstrap-min_list-group__2z24x,.bootstrap-min_card__1W6lu>.bootstrap-min_list-group__2z24x+.bootstrap-min_card-footer__2xRSL{border-top:0}.bootstrap-min_card-body__OSqJu{-ms-flex:1 1 auto;flex:1 1 auto;min-height:1px;padding:1.25rem}.bootstrap-min_card-title__x9kqU{margin-bottom:.75rem}.bootstrap-min_card-subtitle__2HQjg{margin-top:-.375rem;margin-bottom:0}.bootstrap-min_card-text__BPqCR:last-child{margin-bottom:0}.bootstrap-min_card-link__WliIv:hover{text-decoration:none}.bootstrap-min_card-link__WliIv+.bootstrap-min_card-link__WliIv{margin-left:1.25rem}.bootstrap-min_card-header__1mHyC{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.bootstrap-min_card-header__1mHyC:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.bootstrap-min_card-footer__2xRSL{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.bootstrap-min_card-footer__2xRSL:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.bootstrap-min_card-header-tabs__NVwcZ{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.bootstrap-min_card-header-pills__15tG_{margin-right:-.625rem;margin-left:-.625rem}.bootstrap-min_card-img-overlay__3v-4X{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem;border-radius:calc(.25rem - 1px)}.bootstrap-min_card-img__259ep,.bootstrap-min_card-img-bottom__mi0ah,.bootstrap-min_card-img-top__12-LF{-ms-flex-negative:0;flex-shrink:0;width:100%}.bootstrap-min_card-img__259ep,.bootstrap-min_card-img-top__12-LF{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.bootstrap-min_card-img__259ep,.bootstrap-min_card-img-bottom__mi0ah{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.bootstrap-min_card-deck__3T7fK .bootstrap-min_card__1W6lu{margin-bottom:15px}@media (min-width:576px){.bootstrap-min_card-deck__3T7fK{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.bootstrap-min_card-deck__3T7fK .bootstrap-min_card__1W6lu{-ms-flex:1 0 0%;flex:1 0 0%;margin-right:15px;margin-bottom:0;margin-left:15px}}.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu{margin-bottom:15px}@media (min-width:576px){.bootstrap-min_card-group__2xjxT{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu{-ms-flex:1 0 0%;flex:1 0 0%;margin-bottom:0}.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu+.bootstrap-min_card__1W6lu{margin-left:0;border-left:0}.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu:not(:last-child) .bootstrap-min_card-header__1mHyC,.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu:not(:last-child) .bootstrap-min_card-img-top__12-LF{border-top-right-radius:0}.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu:not(:last-child) .bootstrap-min_card-footer__2xRSL,.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu:not(:last-child) .bootstrap-min_card-img-bottom__mi0ah{border-bottom-right-radius:0}.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu:not(:first-child) .bootstrap-min_card-header__1mHyC,.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu:not(:first-child) .bootstrap-min_card-img-top__12-LF{border-top-left-radius:0}.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu:not(:first-child) .bootstrap-min_card-footer__2xRSL,.bootstrap-min_card-group__2xjxT>.bootstrap-min_card__1W6lu:not(:first-child) .bootstrap-min_card-img-bottom__mi0ah{border-bottom-left-radius:0}}.bootstrap-min_card-columns__E7sQX .bootstrap-min_card__1W6lu{margin-bottom:.75rem}@media (min-width:576px){.bootstrap-min_card-columns__E7sQX{-webkit-column-count:3;-moz-column-count:3;column-count:3;-webkit-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.bootstrap-min_card-columns__E7sQX .bootstrap-min_card__1W6lu{display:inline-block;width:100%}}.bootstrap-min_accordion__2Hfd6{overflow-anchor:none}.bootstrap-min_accordion__2Hfd6>.bootstrap-min_card__1W6lu{overflow:hidden}.bootstrap-min_accordion__2Hfd6>.bootstrap-min_card__1W6lu:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.bootstrap-min_accordion__2Hfd6>.bootstrap-min_card__1W6lu:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.bootstrap-min_accordion__2Hfd6>.bootstrap-min_card__1W6lu>.bootstrap-min_card-header__1mHyC{border-radius:0;margin-bottom:-1px}.bootstrap-min_breadcrumb__3RoW_{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.bootstrap-min_breadcrumb-item__19aZc{display:-ms-flexbox;display:flex}.bootstrap-min_breadcrumb-item__19aZc+.bootstrap-min_breadcrumb-item__19aZc{padding-left:.5rem}.bootstrap-min_breadcrumb-item__19aZc+.bootstrap-min_breadcrumb-item__19aZc::before{display:inline-block;padding-right:.5rem;color:#6c757d;content:\"/\"}.bootstrap-min_breadcrumb-item__19aZc+.bootstrap-min_breadcrumb-item__19aZc:hover::before{text-decoration:underline}.bootstrap-min_breadcrumb-item__19aZc+.bootstrap-min_breadcrumb-item__19aZc:hover::before{text-decoration:none}.bootstrap-min_breadcrumb-item__19aZc.bootstrap-min_active__tKiHW{color:#6c757d}.bootstrap-min_pagination__3r29R{display:-ms-flexbox;display:flex;padding-left:0;list-style:none;border-radius:.25rem}.bootstrap-min_page-link__3lh7Q{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.bootstrap-min_page-link__3lh7Q:hover{z-index:2;color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.bootstrap-min_page-link__3lh7Q:focus{z-index:3;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.bootstrap-min_page-item__CYikG:first-child .bootstrap-min_page-link__3lh7Q{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.bootstrap-min_page-item__CYikG:last-child .bootstrap-min_page-link__3lh7Q{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.bootstrap-min_page-item__CYikG.bootstrap-min_active__tKiHW .bootstrap-min_page-link__3lh7Q{z-index:3;color:#fff;background-color:#007bff;border-color:#007bff}.bootstrap-min_page-item__CYikG.bootstrap-min_disabled__fTMRt .bootstrap-min_page-link__3lh7Q{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.bootstrap-min_pagination-lg__3X4yd .bootstrap-min_page-link__3lh7Q{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.bootstrap-min_pagination-lg__3X4yd .bootstrap-min_page-item__CYikG:first-child .bootstrap-min_page-link__3lh7Q{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.bootstrap-min_pagination-lg__3X4yd .bootstrap-min_page-item__CYikG:last-child .bootstrap-min_page-link__3lh7Q{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.bootstrap-min_pagination-sm__Y_oRl .bootstrap-min_page-link__3lh7Q{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.bootstrap-min_pagination-sm__Y_oRl .bootstrap-min_page-item__CYikG:first-child .bootstrap-min_page-link__3lh7Q{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.bootstrap-min_pagination-sm__Y_oRl .bootstrap-min_page-item__CYikG:last-child .bootstrap-min_page-link__3lh7Q{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.bootstrap-min_badge__3pcZA{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.bootstrap-min_badge__3pcZA{transition:none}}a.bootstrap-min_badge__3pcZA:focus,a.bootstrap-min_badge__3pcZA:hover{text-decoration:none}.bootstrap-min_badge__3pcZA:empty{display:none}.bootstrap-min_btn__33rIN .bootstrap-min_badge__3pcZA{position:relative;top:-1px}.bootstrap-min_badge-pill__EPoYU{padding-right:.6em;padding-left:.6em;border-radius:10rem}.bootstrap-min_badge-primary__1AFI5{color:#fff;background-color:#007bff}a.bootstrap-min_badge-primary__1AFI5:focus,a.bootstrap-min_badge-primary__1AFI5:hover{color:#fff;background-color:#0062cc}a.bootstrap-min_badge-primary__1AFI5.bootstrap-min_focus__35glV,a.bootstrap-min_badge-primary__1AFI5:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.bootstrap-min_badge-secondary__3ciN-{color:#fff;background-color:#6c757d}a.bootstrap-min_badge-secondary__3ciN-:focus,a.bootstrap-min_badge-secondary__3ciN-:hover{color:#fff;background-color:#545b62}a.bootstrap-min_badge-secondary__3ciN-.bootstrap-min_focus__35glV,a.bootstrap-min_badge-secondary__3ciN-:focus{outline:0;box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.bootstrap-min_badge-success__3vQvw{color:#fff;background-color:#28a745}a.bootstrap-min_badge-success__3vQvw:focus,a.bootstrap-min_badge-success__3vQvw:hover{color:#fff;background-color:#1e7e34}a.bootstrap-min_badge-success__3vQvw.bootstrap-min_focus__35glV,a.bootstrap-min_badge-success__3vQvw:focus{outline:0;box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.bootstrap-min_badge-info__2oNTf{color:#fff;background-color:#17a2b8}a.bootstrap-min_badge-info__2oNTf:focus,a.bootstrap-min_badge-info__2oNTf:hover{color:#fff;background-color:#117a8b}a.bootstrap-min_badge-info__2oNTf.bootstrap-min_focus__35glV,a.bootstrap-min_badge-info__2oNTf:focus{outline:0;box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.bootstrap-min_badge-warning__1J-wg{color:#212529;background-color:#ffc107}a.bootstrap-min_badge-warning__1J-wg:focus,a.bootstrap-min_badge-warning__1J-wg:hover{color:#212529;background-color:#d39e00}a.bootstrap-min_badge-warning__1J-wg.bootstrap-min_focus__35glV,a.bootstrap-min_badge-warning__1J-wg:focus{outline:0;box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.bootstrap-min_badge-danger__3aeia{color:#fff;background-color:#dc3545}a.bootstrap-min_badge-danger__3aeia:focus,a.bootstrap-min_badge-danger__3aeia:hover{color:#fff;background-color:#bd2130}a.bootstrap-min_badge-danger__3aeia.bootstrap-min_focus__35glV,a.bootstrap-min_badge-danger__3aeia:focus{outline:0;box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.bootstrap-min_badge-light__2Elso{color:#212529;background-color:#f8f9fa}a.bootstrap-min_badge-light__2Elso:focus,a.bootstrap-min_badge-light__2Elso:hover{color:#212529;background-color:#dae0e5}a.bootstrap-min_badge-light__2Elso.bootstrap-min_focus__35glV,a.bootstrap-min_badge-light__2Elso:focus{outline:0;box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.bootstrap-min_badge-dark__3D-UI{color:#fff;background-color:#343a40}a.bootstrap-min_badge-dark__3D-UI:focus,a.bootstrap-min_badge-dark__3D-UI:hover{color:#fff;background-color:#1d2124}a.bootstrap-min_badge-dark__3D-UI.bootstrap-min_focus__35glV,a.bootstrap-min_badge-dark__3D-UI:focus{outline:0;box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.bootstrap-min_jumbotron__2S1z9{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.bootstrap-min_jumbotron__2S1z9{padding:4rem 2rem}}.bootstrap-min_jumbotron-fluid__2yObt{padding-right:0;padding-left:0;border-radius:0}.bootstrap-min_alert__GSk2G{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.bootstrap-min_alert-heading__1M4LW{color:inherit}.bootstrap-min_alert-link__2LKI0{font-weight:700}.bootstrap-min_alert-dismissible__19VOn{padding-right:4rem}.bootstrap-min_alert-dismissible__19VOn .bootstrap-min_close__2HFpO{position:absolute;top:0;right:0;z-index:2;padding:.75rem 1.25rem;color:inherit}.bootstrap-min_alert-primary__1Jqr7{color:#004085;background-color:#cce5ff;border-color:#b8daff}.bootstrap-min_alert-primary__1Jqr7 hr{border-top-color:#9fcdff}.bootstrap-min_alert-primary__1Jqr7 .bootstrap-min_alert-link__2LKI0{color:#002752}.bootstrap-min_alert-secondary__w5yJb{color:#383d41;background-color:#e2e3e5;border-color:#d6d8db}.bootstrap-min_alert-secondary__w5yJb hr{border-top-color:#c8cbcf}.bootstrap-min_alert-secondary__w5yJb .bootstrap-min_alert-link__2LKI0{color:#202326}.bootstrap-min_alert-success__2MpsS{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.bootstrap-min_alert-success__2MpsS hr{border-top-color:#b1dfbb}.bootstrap-min_alert-success__2MpsS .bootstrap-min_alert-link__2LKI0{color:#0b2e13}.bootstrap-min_alert-info__29gK4{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.bootstrap-min_alert-info__29gK4 hr{border-top-color:#abdde5}.bootstrap-min_alert-info__29gK4 .bootstrap-min_alert-link__2LKI0{color:#062c33}.bootstrap-min_alert-warning__1fK7e{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.bootstrap-min_alert-warning__1fK7e hr{border-top-color:#ffe8a1}.bootstrap-min_alert-warning__1fK7e .bootstrap-min_alert-link__2LKI0{color:#533f03}.bootstrap-min_alert-danger__1wh1S{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.bootstrap-min_alert-danger__1wh1S hr{border-top-color:#f1b0b7}.bootstrap-min_alert-danger__1wh1S .bootstrap-min_alert-link__2LKI0{color:#491217}.bootstrap-min_alert-light__1xbPN{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.bootstrap-min_alert-light__1xbPN hr{border-top-color:#ececf6}.bootstrap-min_alert-light__1xbPN .bootstrap-min_alert-link__2LKI0{color:#686868}.bootstrap-min_alert-dark__23eW0{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.bootstrap-min_alert-dark__23eW0 hr{border-top-color:#b9bbbe}.bootstrap-min_alert-dark__23eW0 .bootstrap-min_alert-link__2LKI0{color:#040505}@-webkit-keyframes bootstrap-min_progress-bar-stripes__23bHI{from{background-position:1rem 0}to{background-position:0 0}}@keyframes bootstrap-min_progress-bar-stripes__23bHI{from{background-position:1rem 0}to{background-position:0 0}}.bootstrap-min_progress__V1G4m{display:-ms-flexbox;display:flex;height:1rem;overflow:hidden;line-height:0;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.bootstrap-min_progress-bar___HHv8{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#007bff;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.bootstrap-min_progress-bar___HHv8{transition:none}}.bootstrap-min_progress-bar-striped__2Muim{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:1rem 1rem}.bootstrap-min_progress-bar-animated__128kx{-webkit-animation:bootstrap-min_progress-bar-stripes__23bHI 1s linear infinite;animation:bootstrap-min_progress-bar-stripes__23bHI 1s linear infinite}@media (prefers-reduced-motion:reduce){.bootstrap-min_progress-bar-animated__128kx{-webkit-animation:none;animation:none}}.bootstrap-min_media__1P6zp{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.bootstrap-min_media-body__2-cp2{-ms-flex:1;flex:1}.bootstrap-min_list-group__2z24x{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.bootstrap-min_list-group-item-action__UJuCg{width:100%;color:#495057;text-align:inherit}.bootstrap-min_list-group-item-action__UJuCg:focus,.bootstrap-min_list-group-item-action__UJuCg:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.bootstrap-min_list-group-item-action__UJuCg:active{color:#212529;background-color:#e9ecef}.bootstrap-min_list-group-item__fxIKy{position:relative;display:block;padding:.75rem 1.25rem;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.bootstrap-min_list-group-item__fxIKy:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.bootstrap-min_list-group-item__fxIKy:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.bootstrap-min_list-group-item__fxIKy.bootstrap-min_disabled__fTMRt,.bootstrap-min_list-group-item__fxIKy:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy{border-top-width:0}.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-top:-1px;border-top-width:1px}.bootstrap-min_list-group-horizontal__VSJMZ{-ms-flex-direction:row;flex-direction:row}.bootstrap-min_list-group-horizontal__VSJMZ>.bootstrap-min_list-group-item__fxIKy:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.bootstrap-min_list-group-horizontal__VSJMZ>.bootstrap-min_list-group-item__fxIKy:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.bootstrap-min_list-group-horizontal__VSJMZ>.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-top:0}.bootstrap-min_list-group-horizontal__VSJMZ>.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy{border-top-width:1px;border-left-width:0}.bootstrap-min_list-group-horizontal__VSJMZ>.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.bootstrap-min_list-group-horizontal-sm__3RY8t{-ms-flex-direction:row;flex-direction:row}.bootstrap-min_list-group-horizontal-sm__3RY8t>.bootstrap-min_list-group-item__fxIKy:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.bootstrap-min_list-group-horizontal-sm__3RY8t>.bootstrap-min_list-group-item__fxIKy:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.bootstrap-min_list-group-horizontal-sm__3RY8t>.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-top:0}.bootstrap-min_list-group-horizontal-sm__3RY8t>.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy{border-top-width:1px;border-left-width:0}.bootstrap-min_list-group-horizontal-sm__3RY8t>.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.bootstrap-min_list-group-horizontal-md__buSDB{-ms-flex-direction:row;flex-direction:row}.bootstrap-min_list-group-horizontal-md__buSDB>.bootstrap-min_list-group-item__fxIKy:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.bootstrap-min_list-group-horizontal-md__buSDB>.bootstrap-min_list-group-item__fxIKy:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.bootstrap-min_list-group-horizontal-md__buSDB>.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-top:0}.bootstrap-min_list-group-horizontal-md__buSDB>.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy{border-top-width:1px;border-left-width:0}.bootstrap-min_list-group-horizontal-md__buSDB>.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.bootstrap-min_list-group-horizontal-lg__3OMYb{-ms-flex-direction:row;flex-direction:row}.bootstrap-min_list-group-horizontal-lg__3OMYb>.bootstrap-min_list-group-item__fxIKy:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.bootstrap-min_list-group-horizontal-lg__3OMYb>.bootstrap-min_list-group-item__fxIKy:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.bootstrap-min_list-group-horizontal-lg__3OMYb>.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-top:0}.bootstrap-min_list-group-horizontal-lg__3OMYb>.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy{border-top-width:1px;border-left-width:0}.bootstrap-min_list-group-horizontal-lg__3OMYb>.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.bootstrap-min_list-group-horizontal-xl__2MZIl{-ms-flex-direction:row;flex-direction:row}.bootstrap-min_list-group-horizontal-xl__2MZIl>.bootstrap-min_list-group-item__fxIKy:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.bootstrap-min_list-group-horizontal-xl__2MZIl>.bootstrap-min_list-group-item__fxIKy:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.bootstrap-min_list-group-horizontal-xl__2MZIl>.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-top:0}.bootstrap-min_list-group-horizontal-xl__2MZIl>.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy{border-top-width:1px;border-left-width:0}.bootstrap-min_list-group-horizontal-xl__2MZIl>.bootstrap-min_list-group-item__fxIKy+.bootstrap-min_list-group-item__fxIKy.bootstrap-min_active__tKiHW{margin-left:-1px;border-left-width:1px}}.bootstrap-min_list-group-flush__29obn{border-radius:0}.bootstrap-min_list-group-flush__29obn>.bootstrap-min_list-group-item__fxIKy{border-width:0 0 1px}.bootstrap-min_list-group-flush__29obn>.bootstrap-min_list-group-item__fxIKy:last-child{border-bottom-width:0}.bootstrap-min_list-group-item-primary__nEPIc{color:#004085;background-color:#b8daff}.bootstrap-min_list-group-item-primary__nEPIc.bootstrap-min_list-group-item-action__UJuCg:focus,.bootstrap-min_list-group-item-primary__nEPIc.bootstrap-min_list-group-item-action__UJuCg:hover{color:#004085;background-color:#9fcdff}.bootstrap-min_list-group-item-primary__nEPIc.bootstrap-min_list-group-item-action__UJuCg.bootstrap-min_active__tKiHW{color:#fff;background-color:#004085;border-color:#004085}.bootstrap-min_list-group-item-secondary__2VKHU{color:#383d41;background-color:#d6d8db}.bootstrap-min_list-group-item-secondary__2VKHU.bootstrap-min_list-group-item-action__UJuCg:focus,.bootstrap-min_list-group-item-secondary__2VKHU.bootstrap-min_list-group-item-action__UJuCg:hover{color:#383d41;background-color:#c8cbcf}.bootstrap-min_list-group-item-secondary__2VKHU.bootstrap-min_list-group-item-action__UJuCg.bootstrap-min_active__tKiHW{color:#fff;background-color:#383d41;border-color:#383d41}.bootstrap-min_list-group-item-success__18JZ0{color:#155724;background-color:#c3e6cb}.bootstrap-min_list-group-item-success__18JZ0.bootstrap-min_list-group-item-action__UJuCg:focus,.bootstrap-min_list-group-item-success__18JZ0.bootstrap-min_list-group-item-action__UJuCg:hover{color:#155724;background-color:#b1dfbb}.bootstrap-min_list-group-item-success__18JZ0.bootstrap-min_list-group-item-action__UJuCg.bootstrap-min_active__tKiHW{color:#fff;background-color:#155724;border-color:#155724}.bootstrap-min_list-group-item-info__30jiO{color:#0c5460;background-color:#bee5eb}.bootstrap-min_list-group-item-info__30jiO.bootstrap-min_list-group-item-action__UJuCg:focus,.bootstrap-min_list-group-item-info__30jiO.bootstrap-min_list-group-item-action__UJuCg:hover{color:#0c5460;background-color:#abdde5}.bootstrap-min_list-group-item-info__30jiO.bootstrap-min_list-group-item-action__UJuCg.bootstrap-min_active__tKiHW{color:#fff;background-color:#0c5460;border-color:#0c5460}.bootstrap-min_list-group-item-warning__3EfCM{color:#856404;background-color:#ffeeba}.bootstrap-min_list-group-item-warning__3EfCM.bootstrap-min_list-group-item-action__UJuCg:focus,.bootstrap-min_list-group-item-warning__3EfCM.bootstrap-min_list-group-item-action__UJuCg:hover{color:#856404;background-color:#ffe8a1}.bootstrap-min_list-group-item-warning__3EfCM.bootstrap-min_list-group-item-action__UJuCg.bootstrap-min_active__tKiHW{color:#fff;background-color:#856404;border-color:#856404}.bootstrap-min_list-group-item-danger__3AWVv{color:#721c24;background-color:#f5c6cb}.bootstrap-min_list-group-item-danger__3AWVv.bootstrap-min_list-group-item-action__UJuCg:focus,.bootstrap-min_list-group-item-danger__3AWVv.bootstrap-min_list-group-item-action__UJuCg:hover{color:#721c24;background-color:#f1b0b7}.bootstrap-min_list-group-item-danger__3AWVv.bootstrap-min_list-group-item-action__UJuCg.bootstrap-min_active__tKiHW{color:#fff;background-color:#721c24;border-color:#721c24}.bootstrap-min_list-group-item-light__1G--1{color:#818182;background-color:#fdfdfe}.bootstrap-min_list-group-item-light__1G--1.bootstrap-min_list-group-item-action__UJuCg:focus,.bootstrap-min_list-group-item-light__1G--1.bootstrap-min_list-group-item-action__UJuCg:hover{color:#818182;background-color:#ececf6}.bootstrap-min_list-group-item-light__1G--1.bootstrap-min_list-group-item-action__UJuCg.bootstrap-min_active__tKiHW{color:#fff;background-color:#818182;border-color:#818182}.bootstrap-min_list-group-item-dark__34A8R{color:#1b1e21;background-color:#c6c8ca}.bootstrap-min_list-group-item-dark__34A8R.bootstrap-min_list-group-item-action__UJuCg:focus,.bootstrap-min_list-group-item-dark__34A8R.bootstrap-min_list-group-item-action__UJuCg:hover{color:#1b1e21;background-color:#b9bbbe}.bootstrap-min_list-group-item-dark__34A8R.bootstrap-min_list-group-item-action__UJuCg.bootstrap-min_active__tKiHW{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.bootstrap-min_close__2HFpO{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.bootstrap-min_close__2HFpO:hover{color:#000;text-decoration:none}.bootstrap-min_close__2HFpO:not(:disabled):not(.bootstrap-min_disabled__fTMRt):focus,.bootstrap-min_close__2HFpO:not(:disabled):not(.bootstrap-min_disabled__fTMRt):hover{opacity:.75}button.bootstrap-min_close__2HFpO{padding:0;background-color:transparent;border:0}a.bootstrap-min_close__2HFpO.bootstrap-min_disabled__fTMRt{pointer-events:none}.bootstrap-min_toast__3SN_E{-ms-flex-preferred-size:350px;flex-basis:350px;max-width:350px;font-size:.875rem;background-color:rgba(255,255,255,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem rgba(0,0,0,.1);opacity:0;border-radius:.25rem}.bootstrap-min_toast__3SN_E:not(:last-child){margin-bottom:.75rem}.bootstrap-min_toast__3SN_E.bootstrap-min_showing__2U8hP{opacity:1}.bootstrap-min_toast__3SN_E.bootstrap-min_show__21bZy{display:block;opacity:1}.bootstrap-min_toast__3SN_E.bootstrap-min_hide__2WhOT{display:none}.bootstrap-min_toast-header__1lTHf{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.25rem .75rem;color:#6c757d;background-color:rgba(255,255,255,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.bootstrap-min_toast-body__2ASHM{padding:.75rem}.bootstrap-min_modal-open__3XYl4{overflow:hidden}.bootstrap-min_modal-open__3XYl4 .bootstrap-min_modal__mFY3C{overflow-x:hidden;overflow-y:auto}.bootstrap-min_modal__mFY3C{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.bootstrap-min_modal-dialog__-nZgb{position:relative;width:auto;margin:.5rem;pointer-events:none}.bootstrap-min_modal__mFY3C.bootstrap-min_fade__1rBDU .bootstrap-min_modal-dialog__-nZgb{transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform:translate(0,-50px);transform:translate(0,-50px)}@media (prefers-reduced-motion:reduce){.bootstrap-min_modal__mFY3C.bootstrap-min_fade__1rBDU .bootstrap-min_modal-dialog__-nZgb{transition:none}}.bootstrap-min_modal__mFY3C.bootstrap-min_show__21bZy .bootstrap-min_modal-dialog__-nZgb{-webkit-transform:none;transform:none}.bootstrap-min_modal__mFY3C.bootstrap-min_modal-static__2c183 .bootstrap-min_modal-dialog__-nZgb{-webkit-transform:scale(1.02);transform:scale(1.02)}.bootstrap-min_modal-dialog-scrollable__1E0aC{display:-ms-flexbox;display:flex;max-height:calc(100% - 1rem)}.bootstrap-min_modal-dialog-scrollable__1E0aC .bootstrap-min_modal-content__35cuO{max-height:calc(100vh - 1rem);overflow:hidden}.bootstrap-min_modal-dialog-scrollable__1E0aC .bootstrap-min_modal-footer__3C3H3,.bootstrap-min_modal-dialog-scrollable__1E0aC .bootstrap-min_modal-header__3JiLK{-ms-flex-negative:0;flex-shrink:0}.bootstrap-min_modal-dialog-scrollable__1E0aC .bootstrap-min_modal-body__2DLlt{overflow-y:auto}.bootstrap-min_modal-dialog-centered__2FJEK{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:calc(100% - 1rem)}.bootstrap-min_modal-dialog-centered__2FJEK::before{display:block;height:calc(100vh - 1rem);height:-webkit-min-content;height:-moz-min-content;height:min-content;content:\"\"}.bootstrap-min_modal-dialog-centered__2FJEK.bootstrap-min_modal-dialog-scrollable__1E0aC{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.bootstrap-min_modal-dialog-centered__2FJEK.bootstrap-min_modal-dialog-scrollable__1E0aC .bootstrap-min_modal-content__35cuO{max-height:none}.bootstrap-min_modal-dialog-centered__2FJEK.bootstrap-min_modal-dialog-scrollable__1E0aC::before{content:none}.bootstrap-min_modal-content__35cuO{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.bootstrap-min_modal-backdrop__3yf-q{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.bootstrap-min_modal-backdrop__3yf-q.bootstrap-min_fade__1rBDU{opacity:0}.bootstrap-min_modal-backdrop__3yf-q.bootstrap-min_show__21bZy{opacity:.5}.bootstrap-min_modal-header__3JiLK{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:justify;justify-content:space-between;padding:1rem 1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.bootstrap-min_modal-header__3JiLK .bootstrap-min_close__2HFpO{padding:1rem 1rem;margin:-1rem -1rem -1rem auto}.bootstrap-min_modal-title__12Qxl{margin-bottom:0;line-height:1.5}.bootstrap-min_modal-body__2DLlt{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem}.bootstrap-min_modal-footer__3C3H3{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.bootstrap-min_modal-footer__3C3H3>*{margin:.25rem}.bootstrap-min_modal-scrollbar-measure__3UbHX{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.bootstrap-min_modal-dialog__-nZgb{max-width:500px;margin:1.75rem auto}.bootstrap-min_modal-dialog-scrollable__1E0aC{max-height:calc(100% - 3.5rem)}.bootstrap-min_modal-dialog-scrollable__1E0aC .bootstrap-min_modal-content__35cuO{max-height:calc(100vh - 3.5rem)}.bootstrap-min_modal-dialog-centered__2FJEK{min-height:calc(100% - 3.5rem)}.bootstrap-min_modal-dialog-centered__2FJEK::before{height:calc(100vh - 3.5rem);height:-webkit-min-content;height:-moz-min-content;height:min-content}.bootstrap-min_modal-sm__2YqWF{max-width:300px}}@media (min-width:992px){.bootstrap-min_modal-lg__2TdQn,.bootstrap-min_modal-xl__1QWjR{max-width:800px}}@media (min-width:1200px){.bootstrap-min_modal-xl__1QWjR{max-width:1140px}}.bootstrap-min_tooltip__3yKeV{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.bootstrap-min_tooltip__3yKeV.bootstrap-min_show__21bZy{opacity:.9}.bootstrap-min_tooltip__3yKeV .bootstrap-min_arrow__2j1Ku{position:absolute;display:block;width:.8rem;height:.4rem}.bootstrap-min_tooltip__3yKeV .bootstrap-min_arrow__2j1Ku::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=top],.bootstrap-min_bs-tooltip-top__2vFUG{padding:.4rem 0}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=top] .bootstrap-min_arrow__2j1Ku,.bootstrap-min_bs-tooltip-top__2vFUG .bootstrap-min_arrow__2j1Ku{bottom:0}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=top] .bootstrap-min_arrow__2j1Ku::before,.bootstrap-min_bs-tooltip-top__2vFUG .bootstrap-min_arrow__2j1Ku::before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=right],.bootstrap-min_bs-tooltip-right__2SfLr{padding:0 .4rem}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=right] .bootstrap-min_arrow__2j1Ku,.bootstrap-min_bs-tooltip-right__2SfLr .bootstrap-min_arrow__2j1Ku{left:0;width:.4rem;height:.8rem}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=right] .bootstrap-min_arrow__2j1Ku::before,.bootstrap-min_bs-tooltip-right__2SfLr .bootstrap-min_arrow__2j1Ku::before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=bottom],.bootstrap-min_bs-tooltip-bottom__ngWVn{padding:.4rem 0}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=bottom] .bootstrap-min_arrow__2j1Ku,.bootstrap-min_bs-tooltip-bottom__ngWVn .bootstrap-min_arrow__2j1Ku{top:0}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=bottom] .bootstrap-min_arrow__2j1Ku::before,.bootstrap-min_bs-tooltip-bottom__ngWVn .bootstrap-min_arrow__2j1Ku::before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=left],.bootstrap-min_bs-tooltip-left__2nb6L{padding:0 .4rem}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=left] .bootstrap-min_arrow__2j1Ku,.bootstrap-min_bs-tooltip-left__2nb6L .bootstrap-min_arrow__2j1Ku{right:0;width:.4rem;height:.8rem}.bootstrap-min_bs-tooltip-auto__3O7Yp[x-placement^=left] .bootstrap-min_arrow__2j1Ku::before,.bootstrap-min_bs-tooltip-left__2nb6L .bootstrap-min_arrow__2j1Ku::before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.bootstrap-min_tooltip-inner__2gLo2{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.bootstrap-min_popover__3vSiu{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.bootstrap-min_popover__3vSiu .bootstrap-min_arrow__2j1Ku{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.bootstrap-min_popover__3vSiu .bootstrap-min_arrow__2j1Ku::after,.bootstrap-min_popover__3vSiu .bootstrap-min_arrow__2j1Ku::before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=top],.bootstrap-min_bs-popover-top__2aCBB{margin-bottom:.5rem}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=top]>.bootstrap-min_arrow__2j1Ku,.bootstrap-min_bs-popover-top__2aCBB>.bootstrap-min_arrow__2j1Ku{bottom:calc(-.5rem - 1px)}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=top]>.bootstrap-min_arrow__2j1Ku::before,.bootstrap-min_bs-popover-top__2aCBB>.bootstrap-min_arrow__2j1Ku::before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=top]>.bootstrap-min_arrow__2j1Ku::after,.bootstrap-min_bs-popover-top__2aCBB>.bootstrap-min_arrow__2j1Ku::after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=right],.bootstrap-min_bs-popover-right__1ZCV5{margin-left:.5rem}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=right]>.bootstrap-min_arrow__2j1Ku,.bootstrap-min_bs-popover-right__1ZCV5>.bootstrap-min_arrow__2j1Ku{left:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=right]>.bootstrap-min_arrow__2j1Ku::before,.bootstrap-min_bs-popover-right__1ZCV5>.bootstrap-min_arrow__2j1Ku::before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=right]>.bootstrap-min_arrow__2j1Ku::after,.bootstrap-min_bs-popover-right__1ZCV5>.bootstrap-min_arrow__2j1Ku::after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=bottom],.bootstrap-min_bs-popover-bottom__1_tfk{margin-top:.5rem}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=bottom]>.bootstrap-min_arrow__2j1Ku,.bootstrap-min_bs-popover-bottom__1_tfk>.bootstrap-min_arrow__2j1Ku{top:calc(-.5rem - 1px)}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=bottom]>.bootstrap-min_arrow__2j1Ku::before,.bootstrap-min_bs-popover-bottom__1_tfk>.bootstrap-min_arrow__2j1Ku::before{top:0;border-width:0 .5rem .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=bottom]>.bootstrap-min_arrow__2j1Ku::after,.bootstrap-min_bs-popover-bottom__1_tfk>.bootstrap-min_arrow__2j1Ku::after{top:1px;border-width:0 .5rem .5rem .5rem;border-bottom-color:#fff}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=bottom] .bootstrap-min_popover-header__26TxA::before,.bootstrap-min_bs-popover-bottom__1_tfk .bootstrap-min_popover-header__26TxA::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=left],.bootstrap-min_bs-popover-left__KN478{margin-right:.5rem}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=left]>.bootstrap-min_arrow__2j1Ku,.bootstrap-min_bs-popover-left__KN478>.bootstrap-min_arrow__2j1Ku{right:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=left]>.bootstrap-min_arrow__2j1Ku::before,.bootstrap-min_bs-popover-left__KN478>.bootstrap-min_arrow__2j1Ku::before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bootstrap-min_bs-popover-auto__3nbMA[x-placement^=left]>.bootstrap-min_arrow__2j1Ku::after,.bootstrap-min_bs-popover-left__KN478>.bootstrap-min_arrow__2j1Ku::after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.bootstrap-min_popover-header__26TxA{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.bootstrap-min_popover-header__26TxA:empty{display:none}.bootstrap-min_popover-body__1FdsA{padding:.5rem .75rem;color:#212529}.bootstrap-min_carousel__28ccy{position:relative}.bootstrap-min_carousel__28ccy.bootstrap-min_pointer-event__aeIPK{-ms-touch-action:pan-y;touch-action:pan-y}.bootstrap-min_carousel-inner__2YIqg{position:relative;width:100%;overflow:hidden}.bootstrap-min_carousel-inner__2YIqg::after{display:block;clear:both;content:\"\"}.bootstrap-min_carousel-item__1Uxs2{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;transition:transform .6s ease-in-out,-webkit-transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.bootstrap-min_carousel-item__1Uxs2{transition:none}}.bootstrap-min_carousel-item-next__2aTjE,.bootstrap-min_carousel-item-prev__1pVia,.bootstrap-min_carousel-item__1Uxs2.bootstrap-min_active__tKiHW{display:block}.bootstrap-min_active__tKiHW.bootstrap-min_carousel-item-right__Q3wXf,.bootstrap-min_carousel-item-next__2aTjE:not(.bootstrap-min_carousel-item-left__UYYUu){-webkit-transform:translateX(100%);transform:translateX(100%)}.bootstrap-min_active__tKiHW.bootstrap-min_carousel-item-left__UYYUu,.bootstrap-min_carousel-item-prev__1pVia:not(.bootstrap-min_carousel-item-right__Q3wXf){-webkit-transform:translateX(-100%);transform:translateX(-100%)}.bootstrap-min_carousel-fade__1GMgF .bootstrap-min_carousel-item__1Uxs2{opacity:0;transition-property:opacity;-webkit-transform:none;transform:none}.bootstrap-min_carousel-fade__1GMgF .bootstrap-min_carousel-item-next__2aTjE.bootstrap-min_carousel-item-left__UYYUu,.bootstrap-min_carousel-fade__1GMgF .bootstrap-min_carousel-item-prev__1pVia.bootstrap-min_carousel-item-right__Q3wXf,.bootstrap-min_carousel-fade__1GMgF .bootstrap-min_carousel-item__1Uxs2.bootstrap-min_active__tKiHW{z-index:1;opacity:1}.bootstrap-min_carousel-fade__1GMgF .bootstrap-min_active__tKiHW.bootstrap-min_carousel-item-left__UYYUu,.bootstrap-min_carousel-fade__1GMgF .bootstrap-min_active__tKiHW.bootstrap-min_carousel-item-right__Q3wXf{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.bootstrap-min_carousel-fade__1GMgF .bootstrap-min_active__tKiHW.bootstrap-min_carousel-item-left__UYYUu,.bootstrap-min_carousel-fade__1GMgF .bootstrap-min_active__tKiHW.bootstrap-min_carousel-item-right__Q3wXf{transition:none}}.bootstrap-min_carousel-control-next__3BvG6,.bootstrap-min_carousel-control-prev__PsTwF{position:absolute;top:0;bottom:0;z-index:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.bootstrap-min_carousel-control-next__3BvG6,.bootstrap-min_carousel-control-prev__PsTwF{transition:none}}.bootstrap-min_carousel-control-next__3BvG6:focus,.bootstrap-min_carousel-control-next__3BvG6:hover,.bootstrap-min_carousel-control-prev__PsTwF:focus,.bootstrap-min_carousel-control-prev__PsTwF:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.bootstrap-min_carousel-control-prev__PsTwF{left:0}.bootstrap-min_carousel-control-next__3BvG6{right:0}.bootstrap-min_carousel-control-next-icon__1jhLG,.bootstrap-min_carousel-control-prev-icon__20GXI{display:inline-block;width:20px;height:20px;background:no-repeat 50%/100% 100%}.bootstrap-min_carousel-control-prev-icon__20GXI{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\")}.bootstrap-min_carousel-control-next-icon__1jhLG{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\")}.bootstrap-min_carousel-indicators__3yTKT{position:absolute;right:0;bottom:0;left:0;z-index:15;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.bootstrap-min_carousel-indicators__3yTKT li{box-sizing:content-box;-ms-flex:0 1 auto;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.bootstrap-min_carousel-indicators__3yTKT li{transition:none}}.bootstrap-min_carousel-indicators__3yTKT .bootstrap-min_active__tKiHW{opacity:1}.bootstrap-min_carousel-caption__3MivW{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}@-webkit-keyframes bootstrap-min_spinner-border__2J2XQ{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes bootstrap-min_spinner-border__2J2XQ{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.bootstrap-min_spinner-border__2J2XQ{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:bootstrap-min_spinner-border__2J2XQ .75s linear infinite;animation:bootstrap-min_spinner-border__2J2XQ .75s linear infinite}.bootstrap-min_spinner-border-sm__24oA_{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes bootstrap-min_spinner-grow__1qFPa{0%{-webkit-transform:scale(0);transform:scale(0)}50%{opacity:1;-webkit-transform:none;transform:none}}@keyframes bootstrap-min_spinner-grow__1qFPa{0%{-webkit-transform:scale(0);transform:scale(0)}50%{opacity:1;-webkit-transform:none;transform:none}}.bootstrap-min_spinner-grow__1qFPa{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:bootstrap-min_spinner-grow__1qFPa .75s linear infinite;animation:bootstrap-min_spinner-grow__1qFPa .75s linear infinite}.bootstrap-min_spinner-grow-sm__3AYJj{width:1rem;height:1rem}.bootstrap-min_align-baseline__1xtfe{vertical-align:baseline!important}.bootstrap-min_align-top__3_Lip{vertical-align:top!important}.bootstrap-min_align-middle__F9beq{vertical-align:middle!important}.bootstrap-min_align-bottom__35JSB{vertical-align:bottom!important}.bootstrap-min_align-text-bottom__1cGlM{vertical-align:text-bottom!important}.bootstrap-min_align-text-top__lZKpF{vertical-align:text-top!important}.bootstrap-min_bg-primary__35XSE{background-color:#007bff!important}a.bootstrap-min_bg-primary__35XSE:focus,a.bootstrap-min_bg-primary__35XSE:hover,button.bootstrap-min_bg-primary__35XSE:focus,button.bootstrap-min_bg-primary__35XSE:hover{background-color:#0062cc!important}.bootstrap-min_bg-secondary__1HSi2{background-color:#6c757d!important}a.bootstrap-min_bg-secondary__1HSi2:focus,a.bootstrap-min_bg-secondary__1HSi2:hover,button.bootstrap-min_bg-secondary__1HSi2:focus,button.bootstrap-min_bg-secondary__1HSi2:hover{background-color:#545b62!important}.bootstrap-min_bg-success__1oQGL{background-color:#28a745!important}a.bootstrap-min_bg-success__1oQGL:focus,a.bootstrap-min_bg-success__1oQGL:hover,button.bootstrap-min_bg-success__1oQGL:focus,button.bootstrap-min_bg-success__1oQGL:hover{background-color:#1e7e34!important}.bootstrap-min_bg-info__u_Bhs{background-color:#17a2b8!important}a.bootstrap-min_bg-info__u_Bhs:focus,a.bootstrap-min_bg-info__u_Bhs:hover,button.bootstrap-min_bg-info__u_Bhs:focus,button.bootstrap-min_bg-info__u_Bhs:hover{background-color:#117a8b!important}.bootstrap-min_bg-warning__1CCgu{background-color:#ffc107!important}a.bootstrap-min_bg-warning__1CCgu:focus,a.bootstrap-min_bg-warning__1CCgu:hover,button.bootstrap-min_bg-warning__1CCgu:focus,button.bootstrap-min_bg-warning__1CCgu:hover{background-color:#d39e00!important}.bootstrap-min_bg-danger__2vxiN{background-color:#dc3545!important}a.bootstrap-min_bg-danger__2vxiN:focus,a.bootstrap-min_bg-danger__2vxiN:hover,button.bootstrap-min_bg-danger__2vxiN:focus,button.bootstrap-min_bg-danger__2vxiN:hover{background-color:#bd2130!important}.bootstrap-min_bg-light__pxLEz{background-color:#f8f9fa!important}a.bootstrap-min_bg-light__pxLEz:focus,a.bootstrap-min_bg-light__pxLEz:hover,button.bootstrap-min_bg-light__pxLEz:focus,button.bootstrap-min_bg-light__pxLEz:hover{background-color:#dae0e5!important}.bootstrap-min_bg-dark__CWPPk{background-color:#343a40!important}a.bootstrap-min_bg-dark__CWPPk:focus,a.bootstrap-min_bg-dark__CWPPk:hover,button.bootstrap-min_bg-dark__CWPPk:focus,button.bootstrap-min_bg-dark__CWPPk:hover{background-color:#1d2124!important}.bootstrap-min_bg-white__fEOV8{background-color:#fff!important}.bootstrap-min_bg-transparent__VFCXE{background-color:transparent!important}.bootstrap-min_border__1DR_R{border:1px solid #dee2e6!important}.bootstrap-min_border-top__1AbBB{border-top:1px solid #dee2e6!important}.bootstrap-min_border-right__3Mur6{border-right:1px solid #dee2e6!important}.bootstrap-min_border-bottom___9wxD{border-bottom:1px solid #dee2e6!important}.bootstrap-min_border-left__QR8bq{border-left:1px solid #dee2e6!important}.bootstrap-min_border-0__3PWbA{border:0!important}.bootstrap-min_border-top-0__3MtwM{border-top:0!important}.bootstrap-min_border-right-0__1K3OZ{border-right:0!important}.bootstrap-min_border-bottom-0__10XoC{border-bottom:0!important}.bootstrap-min_border-left-0__296Ad{border-left:0!important}.bootstrap-min_border-primary__2fhvV{border-color:#007bff!important}.bootstrap-min_border-secondary__2raZm{border-color:#6c757d!important}.bootstrap-min_border-success___ocBi{border-color:#28a745!important}.bootstrap-min_border-info__2PYTN{border-color:#17a2b8!important}.bootstrap-min_border-warning__2dPrX{border-color:#ffc107!important}.bootstrap-min_border-danger__39-Pe{border-color:#dc3545!important}.bootstrap-min_border-light__2A967{border-color:#f8f9fa!important}.bootstrap-min_border-dark__1o1qw{border-color:#343a40!important}.bootstrap-min_border-white__tV70f{border-color:#fff!important}.bootstrap-min_rounded-sm__1ID-k{border-radius:.2rem!important}.bootstrap-min_rounded__3JDEy{border-radius:.25rem!important}.bootstrap-min_rounded-top__3woLq{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.bootstrap-min_rounded-right__3Ptc5{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.bootstrap-min_rounded-bottom__2szXd{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.bootstrap-min_rounded-left__2X7hF{border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.bootstrap-min_rounded-lg__32iyd{border-radius:.3rem!important}.bootstrap-min_rounded-circle__203GV{border-radius:50%!important}.bootstrap-min_rounded-pill__1u_Jp{border-radius:50rem!important}.bootstrap-min_rounded-0__cPjyK{border-radius:0!important}.bootstrap-min_clearfix__2h-1v::after{display:block;clear:both;content:\"\"}.bootstrap-min_d-none__3xbXj{display:none!important}.bootstrap-min_d-inline__2Da8f{display:inline!important}.bootstrap-min_d-inline-block__3AIfG{display:inline-block!important}.bootstrap-min_d-block__2ZkZ_{display:block!important}.bootstrap-min_d-table__3FU6J{display:table!important}.bootstrap-min_d-table-row__2TIce{display:table-row!important}.bootstrap-min_d-table-cell__1rueI{display:table-cell!important}.bootstrap-min_d-flex__1df3v{display:-ms-flexbox!important;display:flex!important}.bootstrap-min_d-inline-flex__1P9k2{display:-ms-inline-flexbox!important;display:inline-flex!important}@media (min-width:576px){.bootstrap-min_d-sm-none__1syem{display:none!important}.bootstrap-min_d-sm-inline__31xrf{display:inline!important}.bootstrap-min_d-sm-inline-block__3k-xU{display:inline-block!important}.bootstrap-min_d-sm-block__14wip{display:block!important}.bootstrap-min_d-sm-table__sFkq1{display:table!important}.bootstrap-min_d-sm-table-row__yXeeW{display:table-row!important}.bootstrap-min_d-sm-table-cell__2nq1-{display:table-cell!important}.bootstrap-min_d-sm-flex__2kXrZ{display:-ms-flexbox!important;display:flex!important}.bootstrap-min_d-sm-inline-flex__2FSU1{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:768px){.bootstrap-min_d-md-none__2jna-{display:none!important}.bootstrap-min_d-md-inline__1mgWb{display:inline!important}.bootstrap-min_d-md-inline-block__1GLqQ{display:inline-block!important}.bootstrap-min_d-md-block__1fmlf{display:block!important}.bootstrap-min_d-md-table__i8usl{display:table!important}.bootstrap-min_d-md-table-row__3UsSZ{display:table-row!important}.bootstrap-min_d-md-table-cell__3SrIC{display:table-cell!important}.bootstrap-min_d-md-flex__2k_TZ{display:-ms-flexbox!important;display:flex!important}.bootstrap-min_d-md-inline-flex__1Ic9k{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:992px){.bootstrap-min_d-lg-none__3b9Vf{display:none!important}.bootstrap-min_d-lg-inline__3GgaD{display:inline!important}.bootstrap-min_d-lg-inline-block__3REnf{display:inline-block!important}.bootstrap-min_d-lg-block__504oi{display:block!important}.bootstrap-min_d-lg-table__3tdPX{display:table!important}.bootstrap-min_d-lg-table-row__3AOMg{display:table-row!important}.bootstrap-min_d-lg-table-cell__18pOv{display:table-cell!important}.bootstrap-min_d-lg-flex__1ytLq{display:-ms-flexbox!important;display:flex!important}.bootstrap-min_d-lg-inline-flex__3r-Ji{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:1200px){.bootstrap-min_d-xl-none__1qPIc{display:none!important}.bootstrap-min_d-xl-inline__19dFg{display:inline!important}.bootstrap-min_d-xl-inline-block__1GD5X{display:inline-block!important}.bootstrap-min_d-xl-block__3DEsy{display:block!important}.bootstrap-min_d-xl-table__R4tHu{display:table!important}.bootstrap-min_d-xl-table-row__2EZJX{display:table-row!important}.bootstrap-min_d-xl-table-cell__3Lpuu{display:table-cell!important}.bootstrap-min_d-xl-flex__3rnSX{display:-ms-flexbox!important;display:flex!important}.bootstrap-min_d-xl-inline-flex__1VYyQ{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media print{.bootstrap-min_d-print-none__48AXr{display:none!important}.bootstrap-min_d-print-inline__36Y7f{display:inline!important}.bootstrap-min_d-print-inline-block__3rTtx{display:inline-block!important}.bootstrap-min_d-print-block__2vbS3{display:block!important}.bootstrap-min_d-print-table__3fCYa{display:table!important}.bootstrap-min_d-print-table-row__3pET6{display:table-row!important}.bootstrap-min_d-print-table-cell__21bRy{display:table-cell!important}.bootstrap-min_d-print-flex__3xBFB{display:-ms-flexbox!important;display:flex!important}.bootstrap-min_d-print-inline-flex__3K_kB{display:-ms-inline-flexbox!important;display:inline-flex!important}}.bootstrap-min_embed-responsive__2mWeb{position:relative;display:block;width:100%;padding:0;overflow:hidden}.bootstrap-min_embed-responsive__2mWeb::before{display:block;content:\"\"}.bootstrap-min_embed-responsive__2mWeb .bootstrap-min_embed-responsive-item__7oAaw,.bootstrap-min_embed-responsive__2mWeb embed,.bootstrap-min_embed-responsive__2mWeb iframe,.bootstrap-min_embed-responsive__2mWeb object,.bootstrap-min_embed-responsive__2mWeb video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.bootstrap-min_embed-responsive-21by9__1-Qz6::before{padding-top:42.857143%}.bootstrap-min_embed-responsive-16by9__-ZZ25::before{padding-top:56.25%}.bootstrap-min_embed-responsive-4by3__WhFn2::before{padding-top:75%}.bootstrap-min_embed-responsive-1by1__2aMfC::before{padding-top:100%}.bootstrap-min_flex-row__2CP7x{-ms-flex-direction:row!important;flex-direction:row!important}.bootstrap-min_flex-column__33Qrn{-ms-flex-direction:column!important;flex-direction:column!important}.bootstrap-min_flex-row-reverse__2eTVw{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.bootstrap-min_flex-column-reverse__2bsg6{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.bootstrap-min_flex-wrap__3XB5r{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.bootstrap-min_flex-nowrap__Kpjdg{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.bootstrap-min_flex-wrap-reverse__18bJ7{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.bootstrap-min_flex-fill__3zQV6{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.bootstrap-min_flex-grow-0__RkPJM{-ms-flex-positive:0!important;flex-grow:0!important}.bootstrap-min_flex-grow-1__2cY8z{-ms-flex-positive:1!important;flex-grow:1!important}.bootstrap-min_flex-shrink-0__2XPzb{-ms-flex-negative:0!important;flex-shrink:0!important}.bootstrap-min_flex-shrink-1__1-sTp{-ms-flex-negative:1!important;flex-shrink:1!important}.bootstrap-min_justify-content-start__OIAf5{-ms-flex-pack:start!important;justify-content:flex-start!important}.bootstrap-min_justify-content-end__3331y{-ms-flex-pack:end!important;justify-content:flex-end!important}.bootstrap-min_justify-content-center__3oIG1{-ms-flex-pack:center!important;justify-content:center!important}.bootstrap-min_justify-content-between__MEI8a{-ms-flex-pack:justify!important;justify-content:space-between!important}.bootstrap-min_justify-content-around__2Vm02{-ms-flex-pack:distribute!important;justify-content:space-around!important}.bootstrap-min_align-items-start__2I-r3{-ms-flex-align:start!important;align-items:flex-start!important}.bootstrap-min_align-items-end__3yW_2{-ms-flex-align:end!important;align-items:flex-end!important}.bootstrap-min_align-items-center__Sje_5{-ms-flex-align:center!important;align-items:center!important}.bootstrap-min_align-items-baseline__qD8Ds{-ms-flex-align:baseline!important;align-items:baseline!important}.bootstrap-min_align-items-stretch__JqcVm{-ms-flex-align:stretch!important;align-items:stretch!important}.bootstrap-min_align-content-start__1DYlo{-ms-flex-line-pack:start!important;align-content:flex-start!important}.bootstrap-min_align-content-end__3bURH{-ms-flex-line-pack:end!important;align-content:flex-end!important}.bootstrap-min_align-content-center__TVVe4{-ms-flex-line-pack:center!important;align-content:center!important}.bootstrap-min_align-content-between__1JJSA{-ms-flex-line-pack:justify!important;align-content:space-between!important}.bootstrap-min_align-content-around__dq0LN{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.bootstrap-min_align-content-stretch__2Ir5Z{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.bootstrap-min_align-self-auto__2NRcs{-ms-flex-item-align:auto!important;align-self:auto!important}.bootstrap-min_align-self-start__Qtid7{-ms-flex-item-align:start!important;align-self:flex-start!important}.bootstrap-min_align-self-end__1PoaK{-ms-flex-item-align:end!important;align-self:flex-end!important}.bootstrap-min_align-self-center__3Pv5e{-ms-flex-item-align:center!important;align-self:center!important}.bootstrap-min_align-self-baseline__3T_Co{-ms-flex-item-align:baseline!important;align-self:baseline!important}.bootstrap-min_align-self-stretch__2q5R4{-ms-flex-item-align:stretch!important;align-self:stretch!important}@media (min-width:576px){.bootstrap-min_flex-sm-row__BuMCh{-ms-flex-direction:row!important;flex-direction:row!important}.bootstrap-min_flex-sm-column__1Bduy{-ms-flex-direction:column!important;flex-direction:column!important}.bootstrap-min_flex-sm-row-reverse__2XDSI{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.bootstrap-min_flex-sm-column-reverse__36lGH{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.bootstrap-min_flex-sm-wrap__253TD{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.bootstrap-min_flex-sm-nowrap__1xji0{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.bootstrap-min_flex-sm-wrap-reverse__1Km8_{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.bootstrap-min_flex-sm-fill__1ChP_{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.bootstrap-min_flex-sm-grow-0__OES31{-ms-flex-positive:0!important;flex-grow:0!important}.bootstrap-min_flex-sm-grow-1__2SUWr{-ms-flex-positive:1!important;flex-grow:1!important}.bootstrap-min_flex-sm-shrink-0__3nNO2{-ms-flex-negative:0!important;flex-shrink:0!important}.bootstrap-min_flex-sm-shrink-1__23GWI{-ms-flex-negative:1!important;flex-shrink:1!important}.bootstrap-min_justify-content-sm-start__2fwaI{-ms-flex-pack:start!important;justify-content:flex-start!important}.bootstrap-min_justify-content-sm-end__33QBR{-ms-flex-pack:end!important;justify-content:flex-end!important}.bootstrap-min_justify-content-sm-center__13C7z{-ms-flex-pack:center!important;justify-content:center!important}.bootstrap-min_justify-content-sm-between__1q0Uk{-ms-flex-pack:justify!important;justify-content:space-between!important}.bootstrap-min_justify-content-sm-around__26Tt-{-ms-flex-pack:distribute!important;justify-content:space-around!important}.bootstrap-min_align-items-sm-start__3sOpE{-ms-flex-align:start!important;align-items:flex-start!important}.bootstrap-min_align-items-sm-end__3zlhM{-ms-flex-align:end!important;align-items:flex-end!important}.bootstrap-min_align-items-sm-center__2R71e{-ms-flex-align:center!important;align-items:center!important}.bootstrap-min_align-items-sm-baseline__2J1ii{-ms-flex-align:baseline!important;align-items:baseline!important}.bootstrap-min_align-items-sm-stretch__E-_eP{-ms-flex-align:stretch!important;align-items:stretch!important}.bootstrap-min_align-content-sm-start__3X2J4{-ms-flex-line-pack:start!important;align-content:flex-start!important}.bootstrap-min_align-content-sm-end__11NPY{-ms-flex-line-pack:end!important;align-content:flex-end!important}.bootstrap-min_align-content-sm-center__3AMj5{-ms-flex-line-pack:center!important;align-content:center!important}.bootstrap-min_align-content-sm-between__mjSA_{-ms-flex-line-pack:justify!important;align-content:space-between!important}.bootstrap-min_align-content-sm-around__3in-V{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.bootstrap-min_align-content-sm-stretch__3kd11{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.bootstrap-min_align-self-sm-auto__3_85S{-ms-flex-item-align:auto!important;align-self:auto!important}.bootstrap-min_align-self-sm-start__34lgk{-ms-flex-item-align:start!important;align-self:flex-start!important}.bootstrap-min_align-self-sm-end__2TSI4{-ms-flex-item-align:end!important;align-self:flex-end!important}.bootstrap-min_align-self-sm-center__3dM2u{-ms-flex-item-align:center!important;align-self:center!important}.bootstrap-min_align-self-sm-baseline__3oNa7{-ms-flex-item-align:baseline!important;align-self:baseline!important}.bootstrap-min_align-self-sm-stretch__3oAUE{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:768px){.bootstrap-min_flex-md-row__YJxuQ{-ms-flex-direction:row!important;flex-direction:row!important}.bootstrap-min_flex-md-column__YaYMl{-ms-flex-direction:column!important;flex-direction:column!important}.bootstrap-min_flex-md-row-reverse__32D9t{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.bootstrap-min_flex-md-column-reverse__3VtQS{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.bootstrap-min_flex-md-wrap__WXErw{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.bootstrap-min_flex-md-nowrap__dxPO6{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.bootstrap-min_flex-md-wrap-reverse__MPlE1{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.bootstrap-min_flex-md-fill__33CdU{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.bootstrap-min_flex-md-grow-0__2a2Z9{-ms-flex-positive:0!important;flex-grow:0!important}.bootstrap-min_flex-md-grow-1__vLQ_h{-ms-flex-positive:1!important;flex-grow:1!important}.bootstrap-min_flex-md-shrink-0__2MNLY{-ms-flex-negative:0!important;flex-shrink:0!important}.bootstrap-min_flex-md-shrink-1__h_wUP{-ms-flex-negative:1!important;flex-shrink:1!important}.bootstrap-min_justify-content-md-start__1rAoy{-ms-flex-pack:start!important;justify-content:flex-start!important}.bootstrap-min_justify-content-md-end__2xUdd{-ms-flex-pack:end!important;justify-content:flex-end!important}.bootstrap-min_justify-content-md-center__2OBLh{-ms-flex-pack:center!important;justify-content:center!important}.bootstrap-min_justify-content-md-between__2600V{-ms-flex-pack:justify!important;justify-content:space-between!important}.bootstrap-min_justify-content-md-around__3fITg{-ms-flex-pack:distribute!important;justify-content:space-around!important}.bootstrap-min_align-items-md-start__bGKR3{-ms-flex-align:start!important;align-items:flex-start!important}.bootstrap-min_align-items-md-end__1M7i8{-ms-flex-align:end!important;align-items:flex-end!important}.bootstrap-min_align-items-md-center__3kIb-{-ms-flex-align:center!important;align-items:center!important}.bootstrap-min_align-items-md-baseline__hF_DA{-ms-flex-align:baseline!important;align-items:baseline!important}.bootstrap-min_align-items-md-stretch__lXWM-{-ms-flex-align:stretch!important;align-items:stretch!important}.bootstrap-min_align-content-md-start__6TMB1{-ms-flex-line-pack:start!important;align-content:flex-start!important}.bootstrap-min_align-content-md-end__1CV0T{-ms-flex-line-pack:end!important;align-content:flex-end!important}.bootstrap-min_align-content-md-center__3mAsE{-ms-flex-line-pack:center!important;align-content:center!important}.bootstrap-min_align-content-md-between__1w9D9{-ms-flex-line-pack:justify!important;align-content:space-between!important}.bootstrap-min_align-content-md-around__25pXm{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.bootstrap-min_align-content-md-stretch__wkcVs{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.bootstrap-min_align-self-md-auto__T7yIV{-ms-flex-item-align:auto!important;align-self:auto!important}.bootstrap-min_align-self-md-start__2TeLN{-ms-flex-item-align:start!important;align-self:flex-start!important}.bootstrap-min_align-self-md-end__7eaNG{-ms-flex-item-align:end!important;align-self:flex-end!important}.bootstrap-min_align-self-md-center__xF1P5{-ms-flex-item-align:center!important;align-self:center!important}.bootstrap-min_align-self-md-baseline__3EYq3{-ms-flex-item-align:baseline!important;align-self:baseline!important}.bootstrap-min_align-self-md-stretch__3QCHq{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:992px){.bootstrap-min_flex-lg-row__1XCRF{-ms-flex-direction:row!important;flex-direction:row!important}.bootstrap-min_flex-lg-column__1gnXU{-ms-flex-direction:column!important;flex-direction:column!important}.bootstrap-min_flex-lg-row-reverse__2015n{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.bootstrap-min_flex-lg-column-reverse__1srcD{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.bootstrap-min_flex-lg-wrap__3LhkU{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.bootstrap-min_flex-lg-nowrap__2D1ZJ{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.bootstrap-min_flex-lg-wrap-reverse__3MO5N{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.bootstrap-min_flex-lg-fill__25QF2{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.bootstrap-min_flex-lg-grow-0__bvrDx{-ms-flex-positive:0!important;flex-grow:0!important}.bootstrap-min_flex-lg-grow-1__1raGb{-ms-flex-positive:1!important;flex-grow:1!important}.bootstrap-min_flex-lg-shrink-0__1Mf-E{-ms-flex-negative:0!important;flex-shrink:0!important}.bootstrap-min_flex-lg-shrink-1__1-TPG{-ms-flex-negative:1!important;flex-shrink:1!important}.bootstrap-min_justify-content-lg-start__11Hjx{-ms-flex-pack:start!important;justify-content:flex-start!important}.bootstrap-min_justify-content-lg-end__2ChGY{-ms-flex-pack:end!important;justify-content:flex-end!important}.bootstrap-min_justify-content-lg-center__28cu2{-ms-flex-pack:center!important;justify-content:center!important}.bootstrap-min_justify-content-lg-between__2GIx0{-ms-flex-pack:justify!important;justify-content:space-between!important}.bootstrap-min_justify-content-lg-around__lkeZH{-ms-flex-pack:distribute!important;justify-content:space-around!important}.bootstrap-min_align-items-lg-start__IAjtU{-ms-flex-align:start!important;align-items:flex-start!important}.bootstrap-min_align-items-lg-end__3GYqo{-ms-flex-align:end!important;align-items:flex-end!important}.bootstrap-min_align-items-lg-center__25jJc{-ms-flex-align:center!important;align-items:center!important}.bootstrap-min_align-items-lg-baseline__3ovYl{-ms-flex-align:baseline!important;align-items:baseline!important}.bootstrap-min_align-items-lg-stretch__17GAa{-ms-flex-align:stretch!important;align-items:stretch!important}.bootstrap-min_align-content-lg-start__3wxxM{-ms-flex-line-pack:start!important;align-content:flex-start!important}.bootstrap-min_align-content-lg-end__25YRZ{-ms-flex-line-pack:end!important;align-content:flex-end!important}.bootstrap-min_align-content-lg-center__303ZB{-ms-flex-line-pack:center!important;align-content:center!important}.bootstrap-min_align-content-lg-between__3XKb9{-ms-flex-line-pack:justify!important;align-content:space-between!important}.bootstrap-min_align-content-lg-around__22n4E{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.bootstrap-min_align-content-lg-stretch__2-77Y{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.bootstrap-min_align-self-lg-auto__3l56Z{-ms-flex-item-align:auto!important;align-self:auto!important}.bootstrap-min_align-self-lg-start__3F4H5{-ms-flex-item-align:start!important;align-self:flex-start!important}.bootstrap-min_align-self-lg-end__1srWG{-ms-flex-item-align:end!important;align-self:flex-end!important}.bootstrap-min_align-self-lg-center__2dkqZ{-ms-flex-item-align:center!important;align-self:center!important}.bootstrap-min_align-self-lg-baseline__D1v4L{-ms-flex-item-align:baseline!important;align-self:baseline!important}.bootstrap-min_align-self-lg-stretch__1G0z-{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:1200px){.bootstrap-min_flex-xl-row__2nWGY{-ms-flex-direction:row!important;flex-direction:row!important}.bootstrap-min_flex-xl-column__1_jQz{-ms-flex-direction:column!important;flex-direction:column!important}.bootstrap-min_flex-xl-row-reverse__3ofKI{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.bootstrap-min_flex-xl-column-reverse__1RtpE{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.bootstrap-min_flex-xl-wrap__JZzgm{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.bootstrap-min_flex-xl-nowrap__BQBxU{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.bootstrap-min_flex-xl-wrap-reverse__2cALv{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.bootstrap-min_flex-xl-fill__3mLvT{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.bootstrap-min_flex-xl-grow-0__10ki9{-ms-flex-positive:0!important;flex-grow:0!important}.bootstrap-min_flex-xl-grow-1__338x9{-ms-flex-positive:1!important;flex-grow:1!important}.bootstrap-min_flex-xl-shrink-0__1zyMJ{-ms-flex-negative:0!important;flex-shrink:0!important}.bootstrap-min_flex-xl-shrink-1__Ht6CD{-ms-flex-negative:1!important;flex-shrink:1!important}.bootstrap-min_justify-content-xl-start__1MzTP{-ms-flex-pack:start!important;justify-content:flex-start!important}.bootstrap-min_justify-content-xl-end__2lQ9s{-ms-flex-pack:end!important;justify-content:flex-end!important}.bootstrap-min_justify-content-xl-center__3Qps1{-ms-flex-pack:center!important;justify-content:center!important}.bootstrap-min_justify-content-xl-between__1UllS{-ms-flex-pack:justify!important;justify-content:space-between!important}.bootstrap-min_justify-content-xl-around__1vbdx{-ms-flex-pack:distribute!important;justify-content:space-around!important}.bootstrap-min_align-items-xl-start__3T39x{-ms-flex-align:start!important;align-items:flex-start!important}.bootstrap-min_align-items-xl-end__3qu7y{-ms-flex-align:end!important;align-items:flex-end!important}.bootstrap-min_align-items-xl-center__1QhcT{-ms-flex-align:center!important;align-items:center!important}.bootstrap-min_align-items-xl-baseline__13PBI{-ms-flex-align:baseline!important;align-items:baseline!important}.bootstrap-min_align-items-xl-stretch__2yFew{-ms-flex-align:stretch!important;align-items:stretch!important}.bootstrap-min_align-content-xl-start__1NCye{-ms-flex-line-pack:start!important;align-content:flex-start!important}.bootstrap-min_align-content-xl-end__3o4kB{-ms-flex-line-pack:end!important;align-content:flex-end!important}.bootstrap-min_align-content-xl-center__YpkUo{-ms-flex-line-pack:center!important;align-content:center!important}.bootstrap-min_align-content-xl-between__oXZeY{-ms-flex-line-pack:justify!important;align-content:space-between!important}.bootstrap-min_align-content-xl-around__2ZbsS{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.bootstrap-min_align-content-xl-stretch__2Utnu{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.bootstrap-min_align-self-xl-auto__1dSy9{-ms-flex-item-align:auto!important;align-self:auto!important}.bootstrap-min_align-self-xl-start__ZxcrV{-ms-flex-item-align:start!important;align-self:flex-start!important}.bootstrap-min_align-self-xl-end__3NcjW{-ms-flex-item-align:end!important;align-self:flex-end!important}.bootstrap-min_align-self-xl-center__2CbbL{-ms-flex-item-align:center!important;align-self:center!important}.bootstrap-min_align-self-xl-baseline__3X_mG{-ms-flex-item-align:baseline!important;align-self:baseline!important}.bootstrap-min_align-self-xl-stretch__1kjF4{-ms-flex-item-align:stretch!important;align-self:stretch!important}}.bootstrap-min_float-left__cPkT0{float:left!important}.bootstrap-min_float-right__2HyDy{float:right!important}.bootstrap-min_float-none__38Yw7{float:none!important}@media (min-width:576px){.bootstrap-min_float-sm-left__H7pJJ{float:left!important}.bootstrap-min_float-sm-right__2UbUX{float:right!important}.bootstrap-min_float-sm-none__28pKi{float:none!important}}@media (min-width:768px){.bootstrap-min_float-md-left__rtydc{float:left!important}.bootstrap-min_float-md-right__2h552{float:right!important}.bootstrap-min_float-md-none___REKx{float:none!important}}@media (min-width:992px){.bootstrap-min_float-lg-left__3Vzd6{float:left!important}.bootstrap-min_float-lg-right__3ZLS1{float:right!important}.bootstrap-min_float-lg-none__2FqEB{float:none!important}}@media (min-width:1200px){.bootstrap-min_float-xl-left__3d1-0{float:left!important}.bootstrap-min_float-xl-right__1jHc7{float:right!important}.bootstrap-min_float-xl-none__lw9Wl{float:none!important}}.bootstrap-min_user-select-all__3QAru{-webkit-user-select:all!important;-moz-user-select:all!important;-ms-user-select:all!important;user-select:all!important}.bootstrap-min_user-select-auto__3K5S-{-webkit-user-select:auto!important;-moz-user-select:auto!important;-ms-user-select:auto!important;user-select:auto!important}.bootstrap-min_user-select-none__1G7ZS{-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.bootstrap-min_overflow-auto__SkipV{overflow:auto!important}.bootstrap-min_overflow-hidden__5akq5{overflow:hidden!important}.bootstrap-min_position-static__2KIiR{position:static!important}.bootstrap-min_position-relative__1RPOp{position:relative!important}.bootstrap-min_position-absolute__2MW5b{position:absolute!important}.bootstrap-min_position-fixed__2eZ16{position:fixed!important}.bootstrap-min_position-sticky__2UJ7i{position:-webkit-sticky!important;position:sticky!important}.bootstrap-min_fixed-top__YRjrG{position:fixed;top:0;right:0;left:0;z-index:1030}.bootstrap-min_fixed-bottom__3gEfg{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports ((position:-webkit-sticky) or (position:sticky)){.bootstrap-min_sticky-top__39hyL{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.bootstrap-min_sr-only__3wlTd{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.bootstrap-min_sr-only-focusable__3Y7wD:active,.bootstrap-min_sr-only-focusable__3Y7wD:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.bootstrap-min_shadow-sm__2r6KM{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.bootstrap-min_shadow__3cbYX{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.bootstrap-min_shadow-lg__5xa6b{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.bootstrap-min_shadow-none__3glcx{box-shadow:none!important}.bootstrap-min_w-25__3foLz{width:25%!important}.bootstrap-min_w-50__2Kwwf{width:50%!important}.bootstrap-min_w-75__1c-Bu{width:75%!important}.bootstrap-min_w-100__1KKYa{width:100%!important}.bootstrap-min_w-auto__2uf0M{width:auto!important}.bootstrap-min_h-25__1YO69{height:25%!important}.bootstrap-min_h-50__3KFih{height:50%!important}.bootstrap-min_h-75__2vP6h{height:75%!important}.bootstrap-min_h-100__1Kgav{height:100%!important}.bootstrap-min_h-auto__1xnmI{height:auto!important}.bootstrap-min_mw-100__1fxuS{max-width:100%!important}.bootstrap-min_mh-100__C3bL1{max-height:100%!important}.bootstrap-min_min-vw-100__3mFdt{min-width:100vw!important}.bootstrap-min_min-vh-100__3EWEb{min-height:100vh!important}.bootstrap-min_vw-100__MznRo{width:100vw!important}.bootstrap-min_vh-100__V_emT{height:100vh!important}.bootstrap-min_m-0__3kbbd{margin:0!important}.bootstrap-min_mt-0__xfdvo,.bootstrap-min_my-0__1A0KQ{margin-top:0!important}.bootstrap-min_mr-0__1H-sU,.bootstrap-min_mx-0__2oZ-8{margin-right:0!important}.bootstrap-min_mb-0__2-fFq,.bootstrap-min_my-0__1A0KQ{margin-bottom:0!important}.bootstrap-min_ml-0__4VnOg,.bootstrap-min_mx-0__2oZ-8{margin-left:0!important}.bootstrap-min_m-1__b1X1L{margin:.25rem!important}.bootstrap-min_mt-1__mB9m5,.bootstrap-min_my-1__3Xj93{margin-top:.25rem!important}.bootstrap-min_mr-1__1odpH,.bootstrap-min_mx-1__HbHpc{margin-right:.25rem!important}.bootstrap-min_mb-1__1HytV,.bootstrap-min_my-1__3Xj93{margin-bottom:.25rem!important}.bootstrap-min_ml-1__3vL9R,.bootstrap-min_mx-1__HbHpc{margin-left:.25rem!important}.bootstrap-min_m-2__-hSQq{margin:.5rem!important}.bootstrap-min_mt-2__FgwhN,.bootstrap-min_my-2__XocYr{margin-top:.5rem!important}.bootstrap-min_mr-2__2Je_M,.bootstrap-min_mx-2__3q4WO{margin-right:.5rem!important}.bootstrap-min_mb-2__14Nlw,.bootstrap-min_my-2__XocYr{margin-bottom:.5rem!important}.bootstrap-min_ml-2__2LKEQ,.bootstrap-min_mx-2__3q4WO{margin-left:.5rem!important}.bootstrap-min_m-3__1DfZn{margin:1rem!important}.bootstrap-min_mt-3__3JFcX,.bootstrap-min_my-3__16PNZ{margin-top:1rem!important}.bootstrap-min_mr-3__2LO4p,.bootstrap-min_mx-3__3VDf8{margin-right:1rem!important}.bootstrap-min_mb-3__eddn3,.bootstrap-min_my-3__16PNZ{margin-bottom:1rem!important}.bootstrap-min_ml-3__10N_M,.bootstrap-min_mx-3__3VDf8{margin-left:1rem!important}.bootstrap-min_m-4__3u1qn{margin:1.5rem!important}.bootstrap-min_mt-4__37fwV,.bootstrap-min_my-4__369wi{margin-top:1.5rem!important}.bootstrap-min_mr-4__2K7ZG,.bootstrap-min_mx-4__Tibcj{margin-right:1.5rem!important}.bootstrap-min_mb-4__27mE3,.bootstrap-min_my-4__369wi{margin-bottom:1.5rem!important}.bootstrap-min_ml-4__RjhRP,.bootstrap-min_mx-4__Tibcj{margin-left:1.5rem!important}.bootstrap-min_m-5__3twjl{margin:3rem!important}.bootstrap-min_mt-5__PsGNt,.bootstrap-min_my-5__37D-H{margin-top:3rem!important}.bootstrap-min_mr-5__-9-1o,.bootstrap-min_mx-5__1fbh8{margin-right:3rem!important}.bootstrap-min_mb-5__kdV56,.bootstrap-min_my-5__37D-H{margin-bottom:3rem!important}.bootstrap-min_ml-5__2avzT,.bootstrap-min_mx-5__1fbh8{margin-left:3rem!important}.bootstrap-min_p-0__33fMn{padding:0!important}.bootstrap-min_pt-0__1c5U2,.bootstrap-min_py-0__2uU6i{padding-top:0!important}.bootstrap-min_pr-0__2HOdm,.bootstrap-min_px-0__1SF4g{padding-right:0!important}.bootstrap-min_pb-0__SAp-O,.bootstrap-min_py-0__2uU6i{padding-bottom:0!important}.bootstrap-min_pl-0__3IZsT,.bootstrap-min_px-0__1SF4g{padding-left:0!important}.bootstrap-min_p-1__3aT2Z{padding:.25rem!important}.bootstrap-min_pt-1__dCGYB,.bootstrap-min_py-1__3p_VK{padding-top:.25rem!important}.bootstrap-min_pr-1__1AtZd,.bootstrap-min_px-1__1akff{padding-right:.25rem!important}.bootstrap-min_pb-1__1852x,.bootstrap-min_py-1__3p_VK{padding-bottom:.25rem!important}.bootstrap-min_pl-1__1ATV5,.bootstrap-min_px-1__1akff{padding-left:.25rem!important}.bootstrap-min_p-2__zsQ_f{padding:.5rem!important}.bootstrap-min_pt-2__9v4OL,.bootstrap-min_py-2__pLxa4{padding-top:.5rem!important}.bootstrap-min_pr-2__1mwEg,.bootstrap-min_px-2__38nOV{padding-right:.5rem!important}.bootstrap-min_pb-2__2c_S5,.bootstrap-min_py-2__pLxa4{padding-bottom:.5rem!important}.bootstrap-min_pl-2__3JhQ6,.bootstrap-min_px-2__38nOV{padding-left:.5rem!important}.bootstrap-min_p-3__2ickh{padding:1rem!important}.bootstrap-min_pt-3__3JVa7,.bootstrap-min_py-3__J2iAq{padding-top:1rem!important}.bootstrap-min_pr-3__1i9Qw,.bootstrap-min_px-3__3Rpzg{padding-right:1rem!important}.bootstrap-min_pb-3__2Sz6F,.bootstrap-min_py-3__J2iAq{padding-bottom:1rem!important}.bootstrap-min_pl-3__YIGQW,.bootstrap-min_px-3__3Rpzg{padding-left:1rem!important}.bootstrap-min_p-4__36BRa{padding:1.5rem!important}.bootstrap-min_pt-4__3INIx,.bootstrap-min_py-4__13g-u{padding-top:1.5rem!important}.bootstrap-min_pr-4__3WCbC,.bootstrap-min_px-4__31Emi{padding-right:1.5rem!important}.bootstrap-min_pb-4__kZMl8,.bootstrap-min_py-4__13g-u{padding-bottom:1.5rem!important}.bootstrap-min_pl-4__2HFia,.bootstrap-min_px-4__31Emi{padding-left:1.5rem!important}.bootstrap-min_p-5__16h6p{padding:3rem!important}.bootstrap-min_pt-5__2F3b1,.bootstrap-min_py-5__1JxIt{padding-top:3rem!important}.bootstrap-min_pr-5__3B6e3,.bootstrap-min_px-5__U1_cm{padding-right:3rem!important}.bootstrap-min_pb-5__2iN6L,.bootstrap-min_py-5__1JxIt{padding-bottom:3rem!important}.bootstrap-min_pl-5__3H-Q8,.bootstrap-min_px-5__U1_cm{padding-left:3rem!important}.bootstrap-min_m-n1__3elIa{margin:-.25rem!important}.bootstrap-min_mt-n1__VzOFj,.bootstrap-min_my-n1__2BSQy{margin-top:-.25rem!important}.bootstrap-min_mr-n1__bubJi,.bootstrap-min_mx-n1__20kCl{margin-right:-.25rem!important}.bootstrap-min_mb-n1__16cAH,.bootstrap-min_my-n1__2BSQy{margin-bottom:-.25rem!important}.bootstrap-min_ml-n1__1JWii,.bootstrap-min_mx-n1__20kCl{margin-left:-.25rem!important}.bootstrap-min_m-n2__2fpPl{margin:-.5rem!important}.bootstrap-min_mt-n2__3fhP9,.bootstrap-min_my-n2__17PVE{margin-top:-.5rem!important}.bootstrap-min_mr-n2__aaTZP,.bootstrap-min_mx-n2__znYOd{margin-right:-.5rem!important}.bootstrap-min_mb-n2__67PVG,.bootstrap-min_my-n2__17PVE{margin-bottom:-.5rem!important}.bootstrap-min_ml-n2__Uk6O7,.bootstrap-min_mx-n2__znYOd{margin-left:-.5rem!important}.bootstrap-min_m-n3__36TEU{margin:-1rem!important}.bootstrap-min_mt-n3__qHg5j,.bootstrap-min_my-n3__eccvp{margin-top:-1rem!important}.bootstrap-min_mr-n3__3NW1v,.bootstrap-min_mx-n3__3NAb6{margin-right:-1rem!important}.bootstrap-min_mb-n3__1gMRS,.bootstrap-min_my-n3__eccvp{margin-bottom:-1rem!important}.bootstrap-min_ml-n3__h8vt0,.bootstrap-min_mx-n3__3NAb6{margin-left:-1rem!important}.bootstrap-min_m-n4___b7Hn{margin:-1.5rem!important}.bootstrap-min_mt-n4__pAggf,.bootstrap-min_my-n4__24UqF{margin-top:-1.5rem!important}.bootstrap-min_mr-n4__1YA3M,.bootstrap-min_mx-n4__qopJO{margin-right:-1.5rem!important}.bootstrap-min_mb-n4__3jBsD,.bootstrap-min_my-n4__24UqF{margin-bottom:-1.5rem!important}.bootstrap-min_ml-n4__1lJRf,.bootstrap-min_mx-n4__qopJO{margin-left:-1.5rem!important}.bootstrap-min_m-n5__3YWo6{margin:-3rem!important}.bootstrap-min_mt-n5__3uFzB,.bootstrap-min_my-n5__1LKx3{margin-top:-3rem!important}.bootstrap-min_mr-n5__2mPr-,.bootstrap-min_mx-n5__14tFQ{margin-right:-3rem!important}.bootstrap-min_mb-n5__12Mex,.bootstrap-min_my-n5__1LKx3{margin-bottom:-3rem!important}.bootstrap-min_ml-n5__1HdeP,.bootstrap-min_mx-n5__14tFQ{margin-left:-3rem!important}.bootstrap-min_m-auto__GSqcq{margin:auto!important}.bootstrap-min_mt-auto__30Kb9,.bootstrap-min_my-auto__PqUDw{margin-top:auto!important}.bootstrap-min_mr-auto__2BOD-,.bootstrap-min_mx-auto__-PUlj{margin-right:auto!important}.bootstrap-min_mb-auto__1YGQP,.bootstrap-min_my-auto__PqUDw{margin-bottom:auto!important}.bootstrap-min_ml-auto__TEqF8,.bootstrap-min_mx-auto__-PUlj{margin-left:auto!important}@media (min-width:576px){.bootstrap-min_m-sm-0__2GHVp{margin:0!important}.bootstrap-min_mt-sm-0__v9Gdz,.bootstrap-min_my-sm-0__annru{margin-top:0!important}.bootstrap-min_mr-sm-0__3lyv4,.bootstrap-min_mx-sm-0__3TbAy{margin-right:0!important}.bootstrap-min_mb-sm-0__3SZ32,.bootstrap-min_my-sm-0__annru{margin-bottom:0!important}.bootstrap-min_ml-sm-0__3HGyF,.bootstrap-min_mx-sm-0__3TbAy{margin-left:0!important}.bootstrap-min_m-sm-1__2ko2g{margin:.25rem!important}.bootstrap-min_mt-sm-1__2PF4F,.bootstrap-min_my-sm-1__3XhcH{margin-top:.25rem!important}.bootstrap-min_mr-sm-1__3hWtr,.bootstrap-min_mx-sm-1__3CjrE{margin-right:.25rem!important}.bootstrap-min_mb-sm-1__t31hg,.bootstrap-min_my-sm-1__3XhcH{margin-bottom:.25rem!important}.bootstrap-min_ml-sm-1__21WQS,.bootstrap-min_mx-sm-1__3CjrE{margin-left:.25rem!important}.bootstrap-min_m-sm-2__2Gtdg{margin:.5rem!important}.bootstrap-min_mt-sm-2__3kOkj,.bootstrap-min_my-sm-2__gxOK3{margin-top:.5rem!important}.bootstrap-min_mr-sm-2__2JNXg,.bootstrap-min_mx-sm-2__38v1E{margin-right:.5rem!important}.bootstrap-min_mb-sm-2__24uN0,.bootstrap-min_my-sm-2__gxOK3{margin-bottom:.5rem!important}.bootstrap-min_ml-sm-2__3ti4J,.bootstrap-min_mx-sm-2__38v1E{margin-left:.5rem!important}.bootstrap-min_m-sm-3__1IwQx{margin:1rem!important}.bootstrap-min_mt-sm-3__22lF6,.bootstrap-min_my-sm-3__3WhnH{margin-top:1rem!important}.bootstrap-min_mr-sm-3__3WPXe,.bootstrap-min_mx-sm-3__2BTkb{margin-right:1rem!important}.bootstrap-min_mb-sm-3__1PLZt,.bootstrap-min_my-sm-3__3WhnH{margin-bottom:1rem!important}.bootstrap-min_ml-sm-3__eWtPF,.bootstrap-min_mx-sm-3__2BTkb{margin-left:1rem!important}.bootstrap-min_m-sm-4__3ea-_{margin:1.5rem!important}.bootstrap-min_mt-sm-4__1V9_w,.bootstrap-min_my-sm-4__2yNVm{margin-top:1.5rem!important}.bootstrap-min_mr-sm-4__1YDRm,.bootstrap-min_mx-sm-4__2AINU{margin-right:1.5rem!important}.bootstrap-min_mb-sm-4__V4P_G,.bootstrap-min_my-sm-4__2yNVm{margin-bottom:1.5rem!important}.bootstrap-min_ml-sm-4__39A5O,.bootstrap-min_mx-sm-4__2AINU{margin-left:1.5rem!important}.bootstrap-min_m-sm-5__1pI53{margin:3rem!important}.bootstrap-min_mt-sm-5__3p6le,.bootstrap-min_my-sm-5__ozsTy{margin-top:3rem!important}.bootstrap-min_mr-sm-5__1m_e0,.bootstrap-min_mx-sm-5__YXPvT{margin-right:3rem!important}.bootstrap-min_mb-sm-5__3PiN1,.bootstrap-min_my-sm-5__ozsTy{margin-bottom:3rem!important}.bootstrap-min_ml-sm-5__2IdY5,.bootstrap-min_mx-sm-5__YXPvT{margin-left:3rem!important}.bootstrap-min_p-sm-0__3Y0DC{padding:0!important}.bootstrap-min_pt-sm-0__1SGks,.bootstrap-min_py-sm-0___Rn2C{padding-top:0!important}.bootstrap-min_pr-sm-0__VD9xu,.bootstrap-min_px-sm-0__34OZ6{padding-right:0!important}.bootstrap-min_pb-sm-0__CwXOD,.bootstrap-min_py-sm-0___Rn2C{padding-bottom:0!important}.bootstrap-min_pl-sm-0__1r-RZ,.bootstrap-min_px-sm-0__34OZ6{padding-left:0!important}.bootstrap-min_p-sm-1__2B7pw{padding:.25rem!important}.bootstrap-min_pt-sm-1__S7-G0,.bootstrap-min_py-sm-1__1gR77{padding-top:.25rem!important}.bootstrap-min_pr-sm-1__13gpm,.bootstrap-min_px-sm-1__2w7OT{padding-right:.25rem!important}.bootstrap-min_pb-sm-1__1Z7d5,.bootstrap-min_py-sm-1__1gR77{padding-bottom:.25rem!important}.bootstrap-min_pl-sm-1__16Fam,.bootstrap-min_px-sm-1__2w7OT{padding-left:.25rem!important}.bootstrap-min_p-sm-2__xxTVj{padding:.5rem!important}.bootstrap-min_pt-sm-2__2bR0N,.bootstrap-min_py-sm-2__2u97t{padding-top:.5rem!important}.bootstrap-min_pr-sm-2__3f9DE,.bootstrap-min_px-sm-2__2ZAV_{padding-right:.5rem!important}.bootstrap-min_pb-sm-2__1S6qd,.bootstrap-min_py-sm-2__2u97t{padding-bottom:.5rem!important}.bootstrap-min_pl-sm-2__3xGLF,.bootstrap-min_px-sm-2__2ZAV_{padding-left:.5rem!important}.bootstrap-min_p-sm-3__2s5SD{padding:1rem!important}.bootstrap-min_pt-sm-3__2p5Cy,.bootstrap-min_py-sm-3__3dZRL{padding-top:1rem!important}.bootstrap-min_pr-sm-3__58_yW,.bootstrap-min_px-sm-3__9dnUw{padding-right:1rem!important}.bootstrap-min_pb-sm-3__1l3zH,.bootstrap-min_py-sm-3__3dZRL{padding-bottom:1rem!important}.bootstrap-min_pl-sm-3__1mBfB,.bootstrap-min_px-sm-3__9dnUw{padding-left:1rem!important}.bootstrap-min_p-sm-4__2mWCX{padding:1.5rem!important}.bootstrap-min_pt-sm-4__2JOXc,.bootstrap-min_py-sm-4__3j84j{padding-top:1.5rem!important}.bootstrap-min_pr-sm-4__1KdGe,.bootstrap-min_px-sm-4__3hJ7m{padding-right:1.5rem!important}.bootstrap-min_pb-sm-4__2iOyd,.bootstrap-min_py-sm-4__3j84j{padding-bottom:1.5rem!important}.bootstrap-min_pl-sm-4__yKwXi,.bootstrap-min_px-sm-4__3hJ7m{padding-left:1.5rem!important}.bootstrap-min_p-sm-5__11QoJ{padding:3rem!important}.bootstrap-min_pt-sm-5__1kwyw,.bootstrap-min_py-sm-5__1ob1N{padding-top:3rem!important}.bootstrap-min_pr-sm-5__3k_TZ,.bootstrap-min_px-sm-5__1FnBM{padding-right:3rem!important}.bootstrap-min_pb-sm-5__2R23Z,.bootstrap-min_py-sm-5__1ob1N{padding-bottom:3rem!important}.bootstrap-min_pl-sm-5__21Xnl,.bootstrap-min_px-sm-5__1FnBM{padding-left:3rem!important}.bootstrap-min_m-sm-n1__34ndX{margin:-.25rem!important}.bootstrap-min_mt-sm-n1__1AcUQ,.bootstrap-min_my-sm-n1__1D1nj{margin-top:-.25rem!important}.bootstrap-min_mr-sm-n1__32pzI,.bootstrap-min_mx-sm-n1__yYauG{margin-right:-.25rem!important}.bootstrap-min_mb-sm-n1__2NVKU,.bootstrap-min_my-sm-n1__1D1nj{margin-bottom:-.25rem!important}.bootstrap-min_ml-sm-n1__iWZeK,.bootstrap-min_mx-sm-n1__yYauG{margin-left:-.25rem!important}.bootstrap-min_m-sm-n2__27dEJ{margin:-.5rem!important}.bootstrap-min_mt-sm-n2__227mR,.bootstrap-min_my-sm-n2__j1Rcy{margin-top:-.5rem!important}.bootstrap-min_mr-sm-n2__1qMZM,.bootstrap-min_mx-sm-n2__3XAtp{margin-right:-.5rem!important}.bootstrap-min_mb-sm-n2__3kEJ0,.bootstrap-min_my-sm-n2__j1Rcy{margin-bottom:-.5rem!important}.bootstrap-min_ml-sm-n2__A-Jk1,.bootstrap-min_mx-sm-n2__3XAtp{margin-left:-.5rem!important}.bootstrap-min_m-sm-n3__1Piu3{margin:-1rem!important}.bootstrap-min_mt-sm-n3__2IKJb,.bootstrap-min_my-sm-n3__Fa8gK{margin-top:-1rem!important}.bootstrap-min_mr-sm-n3__3joHB,.bootstrap-min_mx-sm-n3__2heav{margin-right:-1rem!important}.bootstrap-min_mb-sm-n3__38Pwc,.bootstrap-min_my-sm-n3__Fa8gK{margin-bottom:-1rem!important}.bootstrap-min_ml-sm-n3__2kCHi,.bootstrap-min_mx-sm-n3__2heav{margin-left:-1rem!important}.bootstrap-min_m-sm-n4__2Q_oV{margin:-1.5rem!important}.bootstrap-min_mt-sm-n4__2DqYW,.bootstrap-min_my-sm-n4__xXV6o{margin-top:-1.5rem!important}.bootstrap-min_mr-sm-n4__N6IHI,.bootstrap-min_mx-sm-n4__2e1Rl{margin-right:-1.5rem!important}.bootstrap-min_mb-sm-n4__5w3SF,.bootstrap-min_my-sm-n4__xXV6o{margin-bottom:-1.5rem!important}.bootstrap-min_ml-sm-n4__2-Xcq,.bootstrap-min_mx-sm-n4__2e1Rl{margin-left:-1.5rem!important}.bootstrap-min_m-sm-n5__2ku-A{margin:-3rem!important}.bootstrap-min_mt-sm-n5__1XyuO,.bootstrap-min_my-sm-n5__2UEOs{margin-top:-3rem!important}.bootstrap-min_mr-sm-n5__2rth1,.bootstrap-min_mx-sm-n5__3SHhn{margin-right:-3rem!important}.bootstrap-min_mb-sm-n5__1ZtDY,.bootstrap-min_my-sm-n5__2UEOs{margin-bottom:-3rem!important}.bootstrap-min_ml-sm-n5__3weKg,.bootstrap-min_mx-sm-n5__3SHhn{margin-left:-3rem!important}.bootstrap-min_m-sm-auto__1bnmD{margin:auto!important}.bootstrap-min_mt-sm-auto__3enII,.bootstrap-min_my-sm-auto__B5jWj{margin-top:auto!important}.bootstrap-min_mr-sm-auto__SuOhb,.bootstrap-min_mx-sm-auto__3LNte{margin-right:auto!important}.bootstrap-min_mb-sm-auto__2uhf4,.bootstrap-min_my-sm-auto__B5jWj{margin-bottom:auto!important}.bootstrap-min_ml-sm-auto__3qdvi,.bootstrap-min_mx-sm-auto__3LNte{margin-left:auto!important}}@media (min-width:768px){.bootstrap-min_m-md-0__1nCS6{margin:0!important}.bootstrap-min_mt-md-0__3KiGH,.bootstrap-min_my-md-0__2igB-{margin-top:0!important}.bootstrap-min_mr-md-0__1Gc6X,.bootstrap-min_mx-md-0__cGmaJ{margin-right:0!important}.bootstrap-min_mb-md-0__2_pVn,.bootstrap-min_my-md-0__2igB-{margin-bottom:0!important}.bootstrap-min_ml-md-0__VrI48,.bootstrap-min_mx-md-0__cGmaJ{margin-left:0!important}.bootstrap-min_m-md-1__1qtxz{margin:.25rem!important}.bootstrap-min_mt-md-1__XPNru,.bootstrap-min_my-md-1__znPWP{margin-top:.25rem!important}.bootstrap-min_mr-md-1__2tlTR,.bootstrap-min_mx-md-1__1nukR{margin-right:.25rem!important}.bootstrap-min_mb-md-1__3xdhG,.bootstrap-min_my-md-1__znPWP{margin-bottom:.25rem!important}.bootstrap-min_ml-md-1__2nT0T,.bootstrap-min_mx-md-1__1nukR{margin-left:.25rem!important}.bootstrap-min_m-md-2__19WzS{margin:.5rem!important}.bootstrap-min_mt-md-2__1m7yn,.bootstrap-min_my-md-2__H8DZz{margin-top:.5rem!important}.bootstrap-min_mr-md-2__3JfbU,.bootstrap-min_mx-md-2__3-0XL{margin-right:.5rem!important}.bootstrap-min_mb-md-2__2zVz8,.bootstrap-min_my-md-2__H8DZz{margin-bottom:.5rem!important}.bootstrap-min_ml-md-2__AWBzY,.bootstrap-min_mx-md-2__3-0XL{margin-left:.5rem!important}.bootstrap-min_m-md-3__2Z8hn{margin:1rem!important}.bootstrap-min_mt-md-3__37g2X,.bootstrap-min_my-md-3__1rEwf{margin-top:1rem!important}.bootstrap-min_mr-md-3__30-_n,.bootstrap-min_mx-md-3__2LNdx{margin-right:1rem!important}.bootstrap-min_mb-md-3__1TUmo,.bootstrap-min_my-md-3__1rEwf{margin-bottom:1rem!important}.bootstrap-min_ml-md-3__Nw_jf,.bootstrap-min_mx-md-3__2LNdx{margin-left:1rem!important}.bootstrap-min_m-md-4__1Pg11{margin:1.5rem!important}.bootstrap-min_mt-md-4__2SpRO,.bootstrap-min_my-md-4__ZQzFO{margin-top:1.5rem!important}.bootstrap-min_mr-md-4__1gdcU,.bootstrap-min_mx-md-4__2UTJu{margin-right:1.5rem!important}.bootstrap-min_mb-md-4__1QTMd,.bootstrap-min_my-md-4__ZQzFO{margin-bottom:1.5rem!important}.bootstrap-min_ml-md-4__2qDVW,.bootstrap-min_mx-md-4__2UTJu{margin-left:1.5rem!important}.bootstrap-min_m-md-5__fEiqb{margin:3rem!important}.bootstrap-min_mt-md-5__m9LnR,.bootstrap-min_my-md-5__2cWQU{margin-top:3rem!important}.bootstrap-min_mr-md-5__3JbvU,.bootstrap-min_mx-md-5__3MI0A{margin-right:3rem!important}.bootstrap-min_mb-md-5__1h5Zy,.bootstrap-min_my-md-5__2cWQU{margin-bottom:3rem!important}.bootstrap-min_ml-md-5__1G_qo,.bootstrap-min_mx-md-5__3MI0A{margin-left:3rem!important}.bootstrap-min_p-md-0__1KqDA{padding:0!important}.bootstrap-min_pt-md-0__6_tfI,.bootstrap-min_py-md-0__1AmpJ{padding-top:0!important}.bootstrap-min_pr-md-0__2BRSX,.bootstrap-min_px-md-0__3vshK{padding-right:0!important}.bootstrap-min_pb-md-0__3RRgg,.bootstrap-min_py-md-0__1AmpJ{padding-bottom:0!important}.bootstrap-min_pl-md-0__ath6R,.bootstrap-min_px-md-0__3vshK{padding-left:0!important}.bootstrap-min_p-md-1__D0N3Z{padding:.25rem!important}.bootstrap-min_pt-md-1__30IzU,.bootstrap-min_py-md-1__1viW5{padding-top:.25rem!important}.bootstrap-min_pr-md-1__74unF,.bootstrap-min_px-md-1__3AEiK{padding-right:.25rem!important}.bootstrap-min_pb-md-1__18_UX,.bootstrap-min_py-md-1__1viW5{padding-bottom:.25rem!important}.bootstrap-min_pl-md-1__2pwU7,.bootstrap-min_px-md-1__3AEiK{padding-left:.25rem!important}.bootstrap-min_p-md-2__3_Iwu{padding:.5rem!important}.bootstrap-min_pt-md-2__3zbde,.bootstrap-min_py-md-2__1cjO7{padding-top:.5rem!important}.bootstrap-min_pr-md-2__2cjsU,.bootstrap-min_px-md-2__I4Omo{padding-right:.5rem!important}.bootstrap-min_pb-md-2__3FFIZ,.bootstrap-min_py-md-2__1cjO7{padding-bottom:.5rem!important}.bootstrap-min_pl-md-2__U4UDm,.bootstrap-min_px-md-2__I4Omo{padding-left:.5rem!important}.bootstrap-min_p-md-3__2S0Vs{padding:1rem!important}.bootstrap-min_pt-md-3__65v_w,.bootstrap-min_py-md-3__3Hb_v{padding-top:1rem!important}.bootstrap-min_pr-md-3__3ce7o,.bootstrap-min_px-md-3__RYom3{padding-right:1rem!important}.bootstrap-min_pb-md-3__1QcQ0,.bootstrap-min_py-md-3__3Hb_v{padding-bottom:1rem!important}.bootstrap-min_pl-md-3__1wEWs,.bootstrap-min_px-md-3__RYom3{padding-left:1rem!important}.bootstrap-min_p-md-4__3RqFo{padding:1.5rem!important}.bootstrap-min_pt-md-4__2BuhA,.bootstrap-min_py-md-4__yyZeZ{padding-top:1.5rem!important}.bootstrap-min_pr-md-4__1X20D,.bootstrap-min_px-md-4__1mIIf{padding-right:1.5rem!important}.bootstrap-min_pb-md-4__1NalS,.bootstrap-min_py-md-4__yyZeZ{padding-bottom:1.5rem!important}.bootstrap-min_pl-md-4__10TSx,.bootstrap-min_px-md-4__1mIIf{padding-left:1.5rem!important}.bootstrap-min_p-md-5__251Ok{padding:3rem!important}.bootstrap-min_pt-md-5__1Qb-R,.bootstrap-min_py-md-5__29S9e{padding-top:3rem!important}.bootstrap-min_pr-md-5__21FL3,.bootstrap-min_px-md-5__2gODS{padding-right:3rem!important}.bootstrap-min_pb-md-5__3J4FH,.bootstrap-min_py-md-5__29S9e{padding-bottom:3rem!important}.bootstrap-min_pl-md-5__2zJG6,.bootstrap-min_px-md-5__2gODS{padding-left:3rem!important}.bootstrap-min_m-md-n1__1tEl6{margin:-.25rem!important}.bootstrap-min_mt-md-n1__3oT0l,.bootstrap-min_my-md-n1__1b4iz{margin-top:-.25rem!important}.bootstrap-min_mr-md-n1__t-Rke,.bootstrap-min_mx-md-n1__3ppct{margin-right:-.25rem!important}.bootstrap-min_mb-md-n1__EoAba,.bootstrap-min_my-md-n1__1b4iz{margin-bottom:-.25rem!important}.bootstrap-min_ml-md-n1__1Vmwp,.bootstrap-min_mx-md-n1__3ppct{margin-left:-.25rem!important}.bootstrap-min_m-md-n2__1IeTx{margin:-.5rem!important}.bootstrap-min_mt-md-n2__1LyXG,.bootstrap-min_my-md-n2__1TLyU{margin-top:-.5rem!important}.bootstrap-min_mr-md-n2__34-YR,.bootstrap-min_mx-md-n2__1O6zv{margin-right:-.5rem!important}.bootstrap-min_mb-md-n2__2THEU,.bootstrap-min_my-md-n2__1TLyU{margin-bottom:-.5rem!important}.bootstrap-min_ml-md-n2__2bn1P,.bootstrap-min_mx-md-n2__1O6zv{margin-left:-.5rem!important}.bootstrap-min_m-md-n3__yurGT{margin:-1rem!important}.bootstrap-min_mt-md-n3__bulHj,.bootstrap-min_my-md-n3__Fc5Ds{margin-top:-1rem!important}.bootstrap-min_mr-md-n3__wqZYo,.bootstrap-min_mx-md-n3__3SMnK{margin-right:-1rem!important}.bootstrap-min_mb-md-n3__qYQDs,.bootstrap-min_my-md-n3__Fc5Ds{margin-bottom:-1rem!important}.bootstrap-min_ml-md-n3__3MLWT,.bootstrap-min_mx-md-n3__3SMnK{margin-left:-1rem!important}.bootstrap-min_m-md-n4__YLlgJ{margin:-1.5rem!important}.bootstrap-min_mt-md-n4__2VcmG,.bootstrap-min_my-md-n4__1n2cW{margin-top:-1.5rem!important}.bootstrap-min_mr-md-n4__3UtQT,.bootstrap-min_mx-md-n4__53yBs{margin-right:-1.5rem!important}.bootstrap-min_mb-md-n4__ObYwt,.bootstrap-min_my-md-n4__1n2cW{margin-bottom:-1.5rem!important}.bootstrap-min_ml-md-n4__3iJ9D,.bootstrap-min_mx-md-n4__53yBs{margin-left:-1.5rem!important}.bootstrap-min_m-md-n5__GosZK{margin:-3rem!important}.bootstrap-min_mt-md-n5__3zUQK,.bootstrap-min_my-md-n5__1EQFV{margin-top:-3rem!important}.bootstrap-min_mr-md-n5__2554R,.bootstrap-min_mx-md-n5__gfc1q{margin-right:-3rem!important}.bootstrap-min_mb-md-n5__1xCdJ,.bootstrap-min_my-md-n5__1EQFV{margin-bottom:-3rem!important}.bootstrap-min_ml-md-n5__H6fog,.bootstrap-min_mx-md-n5__gfc1q{margin-left:-3rem!important}.bootstrap-min_m-md-auto__uiIqU{margin:auto!important}.bootstrap-min_mt-md-auto__1-RVh,.bootstrap-min_my-md-auto__1WgRH{margin-top:auto!important}.bootstrap-min_mr-md-auto__22EZu,.bootstrap-min_mx-md-auto__2yr1M{margin-right:auto!important}.bootstrap-min_mb-md-auto__3pYNh,.bootstrap-min_my-md-auto__1WgRH{margin-bottom:auto!important}.bootstrap-min_ml-md-auto__-I-Gk,.bootstrap-min_mx-md-auto__2yr1M{margin-left:auto!important}}@media (min-width:992px){.bootstrap-min_m-lg-0__2ITEU{margin:0!important}.bootstrap-min_mt-lg-0__20UQv,.bootstrap-min_my-lg-0__2Qjkq{margin-top:0!important}.bootstrap-min_mr-lg-0__31mZK,.bootstrap-min_mx-lg-0__JzI58{margin-right:0!important}.bootstrap-min_mb-lg-0__30kef,.bootstrap-min_my-lg-0__2Qjkq{margin-bottom:0!important}.bootstrap-min_ml-lg-0__3rWbW,.bootstrap-min_mx-lg-0__JzI58{margin-left:0!important}.bootstrap-min_m-lg-1__29l_J{margin:.25rem!important}.bootstrap-min_mt-lg-1__XaL4H,.bootstrap-min_my-lg-1__2qFvk{margin-top:.25rem!important}.bootstrap-min_mr-lg-1__1yArd,.bootstrap-min_mx-lg-1__31AIW{margin-right:.25rem!important}.bootstrap-min_mb-lg-1__3ajCA,.bootstrap-min_my-lg-1__2qFvk{margin-bottom:.25rem!important}.bootstrap-min_ml-lg-1__3bw7U,.bootstrap-min_mx-lg-1__31AIW{margin-left:.25rem!important}.bootstrap-min_m-lg-2__1UsP-{margin:.5rem!important}.bootstrap-min_mt-lg-2__2UEmF,.bootstrap-min_my-lg-2__33E8V{margin-top:.5rem!important}.bootstrap-min_mr-lg-2__19iND,.bootstrap-min_mx-lg-2__mILZV{margin-right:.5rem!important}.bootstrap-min_mb-lg-2__2Iag1,.bootstrap-min_my-lg-2__33E8V{margin-bottom:.5rem!important}.bootstrap-min_ml-lg-2__1tZ3C,.bootstrap-min_mx-lg-2__mILZV{margin-left:.5rem!important}.bootstrap-min_m-lg-3__3AsLd{margin:1rem!important}.bootstrap-min_mt-lg-3__3makX,.bootstrap-min_my-lg-3__2zxDq{margin-top:1rem!important}.bootstrap-min_mr-lg-3__12qo1,.bootstrap-min_mx-lg-3__1L4xn{margin-right:1rem!important}.bootstrap-min_mb-lg-3__8TFxZ,.bootstrap-min_my-lg-3__2zxDq{margin-bottom:1rem!important}.bootstrap-min_ml-lg-3__3PCmW,.bootstrap-min_mx-lg-3__1L4xn{margin-left:1rem!important}.bootstrap-min_m-lg-4__ax_kP{margin:1.5rem!important}.bootstrap-min_mt-lg-4__UZrqR,.bootstrap-min_my-lg-4__25wAF{margin-top:1.5rem!important}.bootstrap-min_mr-lg-4__1Q7C0,.bootstrap-min_mx-lg-4__3ASyG{margin-right:1.5rem!important}.bootstrap-min_mb-lg-4__DluXz,.bootstrap-min_my-lg-4__25wAF{margin-bottom:1.5rem!important}.bootstrap-min_ml-lg-4__1Gbgm,.bootstrap-min_mx-lg-4__3ASyG{margin-left:1.5rem!important}.bootstrap-min_m-lg-5__3ShYG{margin:3rem!important}.bootstrap-min_mt-lg-5__19mti,.bootstrap-min_my-lg-5__VJm7m{margin-top:3rem!important}.bootstrap-min_mr-lg-5__3hDqQ,.bootstrap-min_mx-lg-5__1fGex{margin-right:3rem!important}.bootstrap-min_mb-lg-5__XCMhi,.bootstrap-min_my-lg-5__VJm7m{margin-bottom:3rem!important}.bootstrap-min_ml-lg-5__2avvW,.bootstrap-min_mx-lg-5__1fGex{margin-left:3rem!important}.bootstrap-min_p-lg-0__1YEld{padding:0!important}.bootstrap-min_pt-lg-0__1oaA9,.bootstrap-min_py-lg-0__3Ulkb{padding-top:0!important}.bootstrap-min_pr-lg-0__3m4To,.bootstrap-min_px-lg-0__3m4YX{padding-right:0!important}.bootstrap-min_pb-lg-0__2ln4b,.bootstrap-min_py-lg-0__3Ulkb{padding-bottom:0!important}.bootstrap-min_pl-lg-0__3EUcq,.bootstrap-min_px-lg-0__3m4YX{padding-left:0!important}.bootstrap-min_p-lg-1__20Fj_{padding:.25rem!important}.bootstrap-min_pt-lg-1__1TTsv,.bootstrap-min_py-lg-1__O_L8X{padding-top:.25rem!important}.bootstrap-min_pr-lg-1__2HiBQ,.bootstrap-min_px-lg-1__1PNQ5{padding-right:.25rem!important}.bootstrap-min_pb-lg-1__1NNR-,.bootstrap-min_py-lg-1__O_L8X{padding-bottom:.25rem!important}.bootstrap-min_pl-lg-1__13tlD,.bootstrap-min_px-lg-1__1PNQ5{padding-left:.25rem!important}.bootstrap-min_p-lg-2__2rWW3{padding:.5rem!important}.bootstrap-min_pt-lg-2__3e-Dz,.bootstrap-min_py-lg-2__32-dO{padding-top:.5rem!important}.bootstrap-min_pr-lg-2__1XcVQ,.bootstrap-min_px-lg-2__1OFN1{padding-right:.5rem!important}.bootstrap-min_pb-lg-2__2uXfP,.bootstrap-min_py-lg-2__32-dO{padding-bottom:.5rem!important}.bootstrap-min_pl-lg-2__3flvs,.bootstrap-min_px-lg-2__1OFN1{padding-left:.5rem!important}.bootstrap-min_p-lg-3__2ZkMm{padding:1rem!important}.bootstrap-min_pt-lg-3__CXqcY,.bootstrap-min_py-lg-3__2qQyi{padding-top:1rem!important}.bootstrap-min_pr-lg-3__3m-Hb,.bootstrap-min_px-lg-3__ugJIj{padding-right:1rem!important}.bootstrap-min_pb-lg-3__r33xW,.bootstrap-min_py-lg-3__2qQyi{padding-bottom:1rem!important}.bootstrap-min_pl-lg-3__3RS-f,.bootstrap-min_px-lg-3__ugJIj{padding-left:1rem!important}.bootstrap-min_p-lg-4__2mzlF{padding:1.5rem!important}.bootstrap-min_pt-lg-4__1l_MH,.bootstrap-min_py-lg-4__29MPs{padding-top:1.5rem!important}.bootstrap-min_pr-lg-4__3XxH4,.bootstrap-min_px-lg-4__3XUBN{padding-right:1.5rem!important}.bootstrap-min_pb-lg-4__24VKg,.bootstrap-min_py-lg-4__29MPs{padding-bottom:1.5rem!important}.bootstrap-min_pl-lg-4__3YqG5,.bootstrap-min_px-lg-4__3XUBN{padding-left:1.5rem!important}.bootstrap-min_p-lg-5__2Fsig{padding:3rem!important}.bootstrap-min_pt-lg-5__1Ogzb,.bootstrap-min_py-lg-5__3g39X{padding-top:3rem!important}.bootstrap-min_pr-lg-5__1dBHS,.bootstrap-min_px-lg-5__1vFmL{padding-right:3rem!important}.bootstrap-min_pb-lg-5__3GJOb,.bootstrap-min_py-lg-5__3g39X{padding-bottom:3rem!important}.bootstrap-min_pl-lg-5__2YG7G,.bootstrap-min_px-lg-5__1vFmL{padding-left:3rem!important}.bootstrap-min_m-lg-n1__3g5rN{margin:-.25rem!important}.bootstrap-min_mt-lg-n1__28VDg,.bootstrap-min_my-lg-n1__ycaDs{margin-top:-.25rem!important}.bootstrap-min_mr-lg-n1__1bVWh,.bootstrap-min_mx-lg-n1__2DBJq{margin-right:-.25rem!important}.bootstrap-min_mb-lg-n1__SekPy,.bootstrap-min_my-lg-n1__ycaDs{margin-bottom:-.25rem!important}.bootstrap-min_ml-lg-n1__29K1p,.bootstrap-min_mx-lg-n1__2DBJq{margin-left:-.25rem!important}.bootstrap-min_m-lg-n2__1yu0O{margin:-.5rem!important}.bootstrap-min_mt-lg-n2__3EWHF,.bootstrap-min_my-lg-n2__3xOzy{margin-top:-.5rem!important}.bootstrap-min_mr-lg-n2__39ACn,.bootstrap-min_mx-lg-n2__33hmK{margin-right:-.5rem!important}.bootstrap-min_mb-lg-n2__3Plbd,.bootstrap-min_my-lg-n2__3xOzy{margin-bottom:-.5rem!important}.bootstrap-min_ml-lg-n2__3KHvu,.bootstrap-min_mx-lg-n2__33hmK{margin-left:-.5rem!important}.bootstrap-min_m-lg-n3__3CLnv{margin:-1rem!important}.bootstrap-min_mt-lg-n3__16UUf,.bootstrap-min_my-lg-n3__30fxG{margin-top:-1rem!important}.bootstrap-min_mr-lg-n3__2ShHt,.bootstrap-min_mx-lg-n3__YGzsk{margin-right:-1rem!important}.bootstrap-min_mb-lg-n3__DF7ML,.bootstrap-min_my-lg-n3__30fxG{margin-bottom:-1rem!important}.bootstrap-min_ml-lg-n3__2aukz,.bootstrap-min_mx-lg-n3__YGzsk{margin-left:-1rem!important}.bootstrap-min_m-lg-n4__1eTcO{margin:-1.5rem!important}.bootstrap-min_mt-lg-n4__aFhkk,.bootstrap-min_my-lg-n4__2A-H-{margin-top:-1.5rem!important}.bootstrap-min_mr-lg-n4__sw1OO,.bootstrap-min_mx-lg-n4__2US1y{margin-right:-1.5rem!important}.bootstrap-min_mb-lg-n4__12BjP,.bootstrap-min_my-lg-n4__2A-H-{margin-bottom:-1.5rem!important}.bootstrap-min_ml-lg-n4__2XWO0,.bootstrap-min_mx-lg-n4__2US1y{margin-left:-1.5rem!important}.bootstrap-min_m-lg-n5__1STB3{margin:-3rem!important}.bootstrap-min_mt-lg-n5__2skXc,.bootstrap-min_my-lg-n5__3MvzK{margin-top:-3rem!important}.bootstrap-min_mr-lg-n5__1JOhg,.bootstrap-min_mx-lg-n5__2hZIN{margin-right:-3rem!important}.bootstrap-min_mb-lg-n5__1CY0f,.bootstrap-min_my-lg-n5__3MvzK{margin-bottom:-3rem!important}.bootstrap-min_ml-lg-n5___qNdZ,.bootstrap-min_mx-lg-n5__2hZIN{margin-left:-3rem!important}.bootstrap-min_m-lg-auto__2zQ75{margin:auto!important}.bootstrap-min_mt-lg-auto__aYceM,.bootstrap-min_my-lg-auto__2VX45{margin-top:auto!important}.bootstrap-min_mr-lg-auto__1Ut_b,.bootstrap-min_mx-lg-auto__3z97a{margin-right:auto!important}.bootstrap-min_mb-lg-auto__2xQPS,.bootstrap-min_my-lg-auto__2VX45{margin-bottom:auto!important}.bootstrap-min_ml-lg-auto__2B0kn,.bootstrap-min_mx-lg-auto__3z97a{margin-left:auto!important}}@media (min-width:1200px){.bootstrap-min_m-xl-0__38S7J{margin:0!important}.bootstrap-min_mt-xl-0__vm_BP,.bootstrap-min_my-xl-0__2ZbFp{margin-top:0!important}.bootstrap-min_mr-xl-0__3Rsf4,.bootstrap-min_mx-xl-0__3ql3l{margin-right:0!important}.bootstrap-min_mb-xl-0__1MTJs,.bootstrap-min_my-xl-0__2ZbFp{margin-bottom:0!important}.bootstrap-min_ml-xl-0__2iatn,.bootstrap-min_mx-xl-0__3ql3l{margin-left:0!important}.bootstrap-min_m-xl-1__15n3n{margin:.25rem!important}.bootstrap-min_mt-xl-1__7JTMj,.bootstrap-min_my-xl-1__3AQIC{margin-top:.25rem!important}.bootstrap-min_mr-xl-1__3dpcr,.bootstrap-min_mx-xl-1__v1R6R{margin-right:.25rem!important}.bootstrap-min_mb-xl-1__3IFzC,.bootstrap-min_my-xl-1__3AQIC{margin-bottom:.25rem!important}.bootstrap-min_ml-xl-1__2GfUU,.bootstrap-min_mx-xl-1__v1R6R{margin-left:.25rem!important}.bootstrap-min_m-xl-2__2Skfk{margin:.5rem!important}.bootstrap-min_mt-xl-2__3B_1k,.bootstrap-min_my-xl-2__3aSib{margin-top:.5rem!important}.bootstrap-min_mr-xl-2__254N4,.bootstrap-min_mx-xl-2__WKzBP{margin-right:.5rem!important}.bootstrap-min_mb-xl-2__ShgK6,.bootstrap-min_my-xl-2__3aSib{margin-bottom:.5rem!important}.bootstrap-min_ml-xl-2__2XiUz,.bootstrap-min_mx-xl-2__WKzBP{margin-left:.5rem!important}.bootstrap-min_m-xl-3__2CCOn{margin:1rem!important}.bootstrap-min_mt-xl-3__eI3pX,.bootstrap-min_my-xl-3__2POPU{margin-top:1rem!important}.bootstrap-min_mr-xl-3__HH8w-,.bootstrap-min_mx-xl-3__1iHMG{margin-right:1rem!important}.bootstrap-min_mb-xl-3__1k2Mk,.bootstrap-min_my-xl-3__2POPU{margin-bottom:1rem!important}.bootstrap-min_ml-xl-3__2nKxV,.bootstrap-min_mx-xl-3__1iHMG{margin-left:1rem!important}.bootstrap-min_m-xl-4__2NCXc{margin:1.5rem!important}.bootstrap-min_mt-xl-4__1ehCe,.bootstrap-min_my-xl-4__3XUwO{margin-top:1.5rem!important}.bootstrap-min_mr-xl-4__opVLF,.bootstrap-min_mx-xl-4__8SS2Q{margin-right:1.5rem!important}.bootstrap-min_mb-xl-4__2F0re,.bootstrap-min_my-xl-4__3XUwO{margin-bottom:1.5rem!important}.bootstrap-min_ml-xl-4__1ygAL,.bootstrap-min_mx-xl-4__8SS2Q{margin-left:1.5rem!important}.bootstrap-min_m-xl-5__2F6e0{margin:3rem!important}.bootstrap-min_mt-xl-5__f0fjV,.bootstrap-min_my-xl-5__256f-{margin-top:3rem!important}.bootstrap-min_mr-xl-5__1Moos,.bootstrap-min_mx-xl-5__Yzq2x{margin-right:3rem!important}.bootstrap-min_mb-xl-5__3ijSk,.bootstrap-min_my-xl-5__256f-{margin-bottom:3rem!important}.bootstrap-min_ml-xl-5__1z4kr,.bootstrap-min_mx-xl-5__Yzq2x{margin-left:3rem!important}.bootstrap-min_p-xl-0__2YMkS{padding:0!important}.bootstrap-min_pt-xl-0__17VRq,.bootstrap-min_py-xl-0__1u-aU{padding-top:0!important}.bootstrap-min_pr-xl-0__Wg6we,.bootstrap-min_px-xl-0__fqULh{padding-right:0!important}.bootstrap-min_pb-xl-0__2iULp,.bootstrap-min_py-xl-0__1u-aU{padding-bottom:0!important}.bootstrap-min_pl-xl-0__3YiEr,.bootstrap-min_px-xl-0__fqULh{padding-left:0!important}.bootstrap-min_p-xl-1__2ZOUm{padding:.25rem!important}.bootstrap-min_pt-xl-1__16Lsf,.bootstrap-min_py-xl-1__Ulj0K{padding-top:.25rem!important}.bootstrap-min_pr-xl-1__1TdKt,.bootstrap-min_px-xl-1__35dfA{padding-right:.25rem!important}.bootstrap-min_pb-xl-1__2vYMv,.bootstrap-min_py-xl-1__Ulj0K{padding-bottom:.25rem!important}.bootstrap-min_pl-xl-1__KU81p,.bootstrap-min_px-xl-1__35dfA{padding-left:.25rem!important}.bootstrap-min_p-xl-2__3ybjk{padding:.5rem!important}.bootstrap-min_pt-xl-2__1lV8T,.bootstrap-min_py-xl-2__3Hjmc{padding-top:.5rem!important}.bootstrap-min_pr-xl-2__3ud1r,.bootstrap-min_px-xl-2__26tvH{padding-right:.5rem!important}.bootstrap-min_pb-xl-2__2R3aC,.bootstrap-min_py-xl-2__3Hjmc{padding-bottom:.5rem!important}.bootstrap-min_pl-xl-2__HW5kp,.bootstrap-min_px-xl-2__26tvH{padding-left:.5rem!important}.bootstrap-min_p-xl-3__1sjtR{padding:1rem!important}.bootstrap-min_pt-xl-3__2SJ8u,.bootstrap-min_py-xl-3__KmxjD{padding-top:1rem!important}.bootstrap-min_pr-xl-3__1O0Ko,.bootstrap-min_px-xl-3__3yv5A{padding-right:1rem!important}.bootstrap-min_pb-xl-3__3MSQ2,.bootstrap-min_py-xl-3__KmxjD{padding-bottom:1rem!important}.bootstrap-min_pl-xl-3__CZJKs,.bootstrap-min_px-xl-3__3yv5A{padding-left:1rem!important}.bootstrap-min_p-xl-4__52_du{padding:1.5rem!important}.bootstrap-min_pt-xl-4__3vk8h,.bootstrap-min_py-xl-4__14uEU{padding-top:1.5rem!important}.bootstrap-min_pr-xl-4__KChN1,.bootstrap-min_px-xl-4__sRmEG{padding-right:1.5rem!important}.bootstrap-min_pb-xl-4__do-yw,.bootstrap-min_py-xl-4__14uEU{padding-bottom:1.5rem!important}.bootstrap-min_pl-xl-4__2akKB,.bootstrap-min_px-xl-4__sRmEG{padding-left:1.5rem!important}.bootstrap-min_p-xl-5__2wpnV{padding:3rem!important}.bootstrap-min_pt-xl-5__2Tuov,.bootstrap-min_py-xl-5__3bJvA{padding-top:3rem!important}.bootstrap-min_pr-xl-5__2M8GE,.bootstrap-min_px-xl-5__1cZlH{padding-right:3rem!important}.bootstrap-min_pb-xl-5__13vTw,.bootstrap-min_py-xl-5__3bJvA{padding-bottom:3rem!important}.bootstrap-min_pl-xl-5__2nwKV,.bootstrap-min_px-xl-5__1cZlH{padding-left:3rem!important}.bootstrap-min_m-xl-n1__2ZjPD{margin:-.25rem!important}.bootstrap-min_mt-xl-n1__1H_uk,.bootstrap-min_my-xl-n1__2pcHM{margin-top:-.25rem!important}.bootstrap-min_mr-xl-n1__2N3xm,.bootstrap-min_mx-xl-n1__3fMe6{margin-right:-.25rem!important}.bootstrap-min_mb-xl-n1__1meUo,.bootstrap-min_my-xl-n1__2pcHM{margin-bottom:-.25rem!important}.bootstrap-min_ml-xl-n1__3yri-,.bootstrap-min_mx-xl-n1__3fMe6{margin-left:-.25rem!important}.bootstrap-min_m-xl-n2__W2fXa{margin:-.5rem!important}.bootstrap-min_mt-xl-n2__1xYje,.bootstrap-min_my-xl-n2__1K8nI{margin-top:-.5rem!important}.bootstrap-min_mr-xl-n2__17Z5X,.bootstrap-min_mx-xl-n2__n8sRj{margin-right:-.5rem!important}.bootstrap-min_mb-xl-n2__25KLP,.bootstrap-min_my-xl-n2__1K8nI{margin-bottom:-.5rem!important}.bootstrap-min_ml-xl-n2__1DDgt,.bootstrap-min_mx-xl-n2__n8sRj{margin-left:-.5rem!important}.bootstrap-min_m-xl-n3__2nTL3{margin:-1rem!important}.bootstrap-min_mt-xl-n3__3bLru,.bootstrap-min_my-xl-n3__uiHkD{margin-top:-1rem!important}.bootstrap-min_mr-xl-n3__gfyXP,.bootstrap-min_mx-xl-n3__3v1-q{margin-right:-1rem!important}.bootstrap-min_mb-xl-n3__4wseR,.bootstrap-min_my-xl-n3__uiHkD{margin-bottom:-1rem!important}.bootstrap-min_ml-xl-n3__3fjAe,.bootstrap-min_mx-xl-n3__3v1-q{margin-left:-1rem!important}.bootstrap-min_m-xl-n4__2vK_f{margin:-1.5rem!important}.bootstrap-min_mt-xl-n4__3n3QV,.bootstrap-min_my-xl-n4__2f37r{margin-top:-1.5rem!important}.bootstrap-min_mr-xl-n4__3dWFk,.bootstrap-min_mx-xl-n4__3xZct{margin-right:-1.5rem!important}.bootstrap-min_mb-xl-n4__1TtSA,.bootstrap-min_my-xl-n4__2f37r{margin-bottom:-1.5rem!important}.bootstrap-min_ml-xl-n4__3EG5D,.bootstrap-min_mx-xl-n4__3xZct{margin-left:-1.5rem!important}.bootstrap-min_m-xl-n5__3Og15{margin:-3rem!important}.bootstrap-min_mt-xl-n5__zecLC,.bootstrap-min_my-xl-n5__3pSEp{margin-top:-3rem!important}.bootstrap-min_mr-xl-n5__dwWEx,.bootstrap-min_mx-xl-n5__3NnDp{margin-right:-3rem!important}.bootstrap-min_mb-xl-n5__2Hu40,.bootstrap-min_my-xl-n5__3pSEp{margin-bottom:-3rem!important}.bootstrap-min_ml-xl-n5__1vxEE,.bootstrap-min_mx-xl-n5__3NnDp{margin-left:-3rem!important}.bootstrap-min_m-xl-auto__3PpCg{margin:auto!important}.bootstrap-min_mt-xl-auto__3Qjmw,.bootstrap-min_my-xl-auto__rcjXw{margin-top:auto!important}.bootstrap-min_mr-xl-auto__1QMcO,.bootstrap-min_mx-xl-auto__Dz9Xy{margin-right:auto!important}.bootstrap-min_mb-xl-auto__2BUV_,.bootstrap-min_my-xl-auto__rcjXw{margin-bottom:auto!important}.bootstrap-min_ml-xl-auto__3KSoq,.bootstrap-min_mx-xl-auto__Dz9Xy{margin-left:auto!important}}.bootstrap-min_stretched-link__7EIlO::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:\"\";background-color:rgba(0,0,0,0)}.bootstrap-min_text-monospace__2jOo9{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace!important}.bootstrap-min_text-justify__fIDtr{text-align:justify!important}.bootstrap-min_text-wrap__oi-kb{white-space:normal!important}.bootstrap-min_text-nowrap__2y79v{white-space:nowrap!important}.bootstrap-min_text-truncate__vmrs-{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bootstrap-min_text-left__oR3hZ{text-align:left!important}.bootstrap-min_text-right__3bwyt{text-align:right!important}.bootstrap-min_text-center__2R-s3{text-align:center!important}@media (min-width:576px){.bootstrap-min_text-sm-left__i_5vy{text-align:left!important}.bootstrap-min_text-sm-right__rZSKR{text-align:right!important}.bootstrap-min_text-sm-center__2dCzy{text-align:center!important}}@media (min-width:768px){.bootstrap-min_text-md-left__19D04{text-align:left!important}.bootstrap-min_text-md-right__OnowN{text-align:right!important}.bootstrap-min_text-md-center__2IBq1{text-align:center!important}}@media (min-width:992px){.bootstrap-min_text-lg-left__hg2ov{text-align:left!important}.bootstrap-min_text-lg-right__6Mahj{text-align:right!important}.bootstrap-min_text-lg-center__2_Nfe{text-align:center!important}}@media (min-width:1200px){.bootstrap-min_text-xl-left__AxZoA{text-align:left!important}.bootstrap-min_text-xl-right__2QUIZ{text-align:right!important}.bootstrap-min_text-xl-center__3kAIZ{text-align:center!important}}.bootstrap-min_text-lowercase__2fjX6{text-transform:lowercase!important}.bootstrap-min_text-uppercase__3Barn{text-transform:uppercase!important}.bootstrap-min_text-capitalize__35PZS{text-transform:capitalize!important}.bootstrap-min_font-weight-light__2qjBR{font-weight:300!important}.bootstrap-min_font-weight-lighter__3-RmR{font-weight:lighter!important}.bootstrap-min_font-weight-normal__2Hy4X{font-weight:400!important}.bootstrap-min_font-weight-bold__1Sb5w{font-weight:700!important}.bootstrap-min_font-weight-bolder__AlF4w{font-weight:bolder!important}.bootstrap-min_font-italic__wwR49{font-style:italic!important}.bootstrap-min_text-white__ZjomA{color:#fff!important}.bootstrap-min_text-primary__s5dEU{color:#007bff!important}a.bootstrap-min_text-primary__s5dEU:focus,a.bootstrap-min_text-primary__s5dEU:hover{color:#0056b3!important}.bootstrap-min_text-secondary__1p6oV{color:#6c757d!important}a.bootstrap-min_text-secondary__1p6oV:focus,a.bootstrap-min_text-secondary__1p6oV:hover{color:#494f54!important}.bootstrap-min_text-success__1ZQ5o{color:#28a745!important}a.bootstrap-min_text-success__1ZQ5o:focus,a.bootstrap-min_text-success__1ZQ5o:hover{color:#19692c!important}.bootstrap-min_text-info__1AU5u{color:#17a2b8!important}a.bootstrap-min_text-info__1AU5u:focus,a.bootstrap-min_text-info__1AU5u:hover{color:#0f6674!important}.bootstrap-min_text-warning__3cRPX{color:#ffc107!important}a.bootstrap-min_text-warning__3cRPX:focus,a.bootstrap-min_text-warning__3cRPX:hover{color:#ba8b00!important}.bootstrap-min_text-danger__2DWla{color:#dc3545!important}a.bootstrap-min_text-danger__2DWla:focus,a.bootstrap-min_text-danger__2DWla:hover{color:#a71d2a!important}.bootstrap-min_text-light__3kx6P{color:#f8f9fa!important}a.bootstrap-min_text-light__3kx6P:focus,a.bootstrap-min_text-light__3kx6P:hover{color:#cbd3da!important}.bootstrap-min_text-dark__2atyF{color:#343a40!important}a.bootstrap-min_text-dark__2atyF:focus,a.bootstrap-min_text-dark__2atyF:hover{color:#121416!important}.bootstrap-min_text-body__2NyaM{color:#212529!important}.bootstrap-min_text-muted__1yR3q{color:#6c757d!important}.bootstrap-min_text-black-50__1693W{color:rgba(0,0,0,.5)!important}.bootstrap-min_text-white-50__2pS_o{color:rgba(255,255,255,.5)!important}.bootstrap-min_text-hide__20Ia5{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.bootstrap-min_text-decoration-none__54Z-K{text-decoration:none!important}.bootstrap-min_text-break__2_H0Y{word-break:break-word!important;word-wrap:break-word!important}.bootstrap-min_text-reset__tqcXV{color:inherit!important}.bootstrap-min_visible__1afj1{visibility:visible!important}.bootstrap-min_invisible__2DJ28{visibility:hidden!important}@media print{*,::after,::before{text-shadow:none!important;box-shadow:none!important}a:not(.bootstrap-min_btn__33rIN){text-decoration:underline}abbr[title]::after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #adb5bd;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}body{min-width:992px!important}.bootstrap-min_container__3i4Ca{min-width:992px!important}.bootstrap-min_navbar__3LmOW{display:none}.bootstrap-min_badge__3pcZA{border:1px solid #000}.bootstrap-min_table__GrZsg{border-collapse:collapse!important}.bootstrap-min_table__GrZsg td,.bootstrap-min_table__GrZsg th{background-color:#fff!important}.bootstrap-min_table-bordered__jf6La td,.bootstrap-min_table-bordered__jf6La th{border:1px solid #dee2e6!important}.bootstrap-min_table-dark__ip9nb{color:inherit}.bootstrap-min_table-dark__ip9nb tbody+tbody,.bootstrap-min_table-dark__ip9nb td,.bootstrap-min_table-dark__ip9nb th,.bootstrap-min_table-dark__ip9nb thead th{border-color:#dee2e6}.bootstrap-min_table__GrZsg .bootstrap-min_thead-dark__269Fy th{color:inherit;border-color:#dee2e6}}";
styleInject(css_248z$c);

var css_248z$d = ".react-bootstrap-table2-min_react-bootstrap-table__368CJ table{table-layout:fixed}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th.react-bootstrap-table2-min_sortable__2evz-{cursor:pointer}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th .react-bootstrap-table2-min_order__31hWv>.react-bootstrap-table2-min_dropdown__1Rfzm>.react-bootstrap-table2-min_caret__QG2tq{margin:10px 0 10px 5px;color:#ccc}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th .react-bootstrap-table2-min_order__31hWv>.react-bootstrap-table2-min_dropup__31Jl8>.react-bootstrap-table2-min_caret__QG2tq{margin:10px 0;color:#ccc}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th>.react-bootstrap-table2-min_react-bootstrap-table-sort-order__2gQo5>.react-bootstrap-table2-min_caret__QG2tq{margin:10px 6.5px}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th .react-bootstrap-table2-min_order-4__bRUY5:before{margin-left:3.5px;content:\"\\2191\";opacity:.4}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th .react-bootstrap-table2-min_order-4__bRUY5:after{content:\"\\2193\";opacity:.4}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th .react-bootstrap-table2-min_caret-4-asc__1hBOw:before{margin-left:3.5px;content:\"\\2191\"}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th .react-bootstrap-table2-min_caret-4-asc__1hBOw:after{content:\"\\2193\";opacity:.4}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th .react-bootstrap-table2-min_caret-4-desc__2lYvv:before{margin-left:3.5px;content:\"\\2191\";opacity:.4}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th .react-bootstrap-table2-min_caret-4-desc__2lYvv:after{content:\"\\2193\"}.react-bootstrap-table2-min_react-bootstrap-table__368CJ th[data-row-selection]{width:30px}.react-bootstrap-table2-min_react-bootstrap-table__368CJ td>.react-bootstrap-table2-min_selection-input-4__3Rfh3,.react-bootstrap-table2-min_react-bootstrap-table__368CJ th>.react-bootstrap-table2-min_selection-input-4__3Rfh3{margin:-4px}.react-bootstrap-table2-min_react-bootstrap-table__368CJ td.react-bootstrap-table2-min_react-bs-table-no-data__3ZV17{text-align:center}.react-bootstrap-table2-min_react-bootstrap-table__368CJ td.react-bootstrap-table2-min_react-bootstrap-table-editing-cell__1CdtQ .react-bootstrap-table2-min_animated__1jcOF{animation-fill-mode:both}.react-bootstrap-table2-min_react-bootstrap-table__368CJ td.react-bootstrap-table2-min_react-bootstrap-table-editing-cell__1CdtQ .react-bootstrap-table2-min_animated__1jcOF.react-bootstrap-table2-min_bounceIn__VXLDV,.react-bootstrap-table2-min_react-bootstrap-table__368CJ td.react-bootstrap-table2-min_react-bootstrap-table-editing-cell__1CdtQ .react-bootstrap-table2-min_animated__1jcOF.react-bootstrap-table2-min_bounceOut__34fPW{animation-duration:.75s}.react-bootstrap-table2-min_react-bootstrap-table__368CJ td.react-bootstrap-table2-min_react-bootstrap-table-editing-cell__1CdtQ .react-bootstrap-table2-min_animated__1jcOF.react-bootstrap-table2-min_shake__1PJZK{animation-duration:.3s}@keyframes react-bootstrap-table2-min_shake__1PJZK{from,to{transform:translate3d(0,0,0)}10%,50%,90%{transform:translate3d(-10px,0,0)}30%,70%{transform:translate3d(10px,0,0)}}.react-bootstrap-table2-min_react-bootstrap-table__368CJ td.react-bootstrap-table2-min_react-bootstrap-table-editing-cell__1CdtQ .react-bootstrap-table2-min_shake__1PJZK{animation-name:react-bootstrap-table2-min_shake__1PJZK}@keyframes react-bootstrap-table2-min_bounceIn__VXLDV{20%,40%,60%,80%,from,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:scale3d(.3,.3,.3)}20%{transform:scale3d(1.1,1.1,1.1)}40%{transform:scale3d(.9,.9,.9)}60%{opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{transform:scale3d(.97,.97,.97)}to{opacity:1;transform:scale3d(1,1,1)}}.react-bootstrap-table2-min_react-bootstrap-table__368CJ td.react-bootstrap-table2-min_react-bootstrap-table-editing-cell__1CdtQ .react-bootstrap-table2-min_bounceIn__VXLDV{animation-name:react-bootstrap-table2-min_bounceIn__VXLDV}@keyframes react-bootstrap-table2-min_bounceOut__34fPW{20%{transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1)}to{opacity:0;transform:scale3d(.3,.3,.3)}}.react-bootstrap-table2-min_react-bootstrap-table__368CJ td.react-bootstrap-table2-min_react-bootstrap-table-editing-cell__1CdtQ .react-bootstrap-table2-min_bounceOut__34fPW{animation-name:react-bootstrap-table2-min_bounceOut__34fPW}.react-bootstrap-table2-min_react-bootstrap-table__368CJ .react-bootstrap-table2-min_reset-expansion-style__ss0Jy{padding:0}.react-bootstrap-table2-min_react-bootstrap-table__368CJ .react-bootstrap-table2-min_row-expansion-style__25xUw{padding:8px}.react-bootstrap-table2-min_react-bootstrap-table__368CJ .react-bootstrap-table2-min_row-expand-slide-appear__3rtzP{max-height:0;overflow:hidden}.react-bootstrap-table2-min_react-bootstrap-table__368CJ .react-bootstrap-table2-min_row-expand-slide-appear-active__17QS4{max-height:1000px;transition:max-height 3s linear}.react-bootstrap-table2-min_react-bootstrap-table__368CJ .react-bootstrap-table2-min_row-expand-slide-exit__iChDb{max-height:1000px}.react-bootstrap-table2-min_react-bootstrap-table__368CJ .react-bootstrap-table2-min_row-expand-slide-exit-active__UqHvT{max-height:0;overflow:hidden;transition:max-height .4s cubic-bezier(0,.95,0,.95)}";
styleInject(css_248z$d);

var css_248z$e = ".react-bootstrap-table2-paginator-min_react-bootstrap-table-page-btns-ul__2C6PZ{float:right;margin-top:0!important}.react-bootstrap-table2-paginator-min_react-bootstrap-table-pagination-list-hidden__3-mo7{display:none}";
styleInject(css_248z$e);

var css_248z$f = "@keyframes PaginatedTable_fadein__2awty {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes PaginatedTable_fadein__2awty {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes PaginatedTable_fadein__2awty {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes PaginatedTable_fadein__2awty {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes PaginatedTable_fadein__2awty {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.PaginatedTable_paginated-table-container__2tXOc {\n  cursor: default !important;\n  outline: none !important; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_table-striped__3YnMV tbody tr:nth-of-type(odd) {\n    background-color: #eff7fc; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_table-bordered__3wOY3 thead td,\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_table-bordered__3wOY3 thead th {\n    outline: none; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_col-lg-6__D985q {\n    max-width: 25%; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_react-bootstrap-table-pagination-list__2mYxQ {\n    display: inline-block; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_pagination__WEm3F {\n    display: inline-block;\n    padding-left: 0;\n    margin: 20px 0;\n    border-radius: 4px; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_dropdown__2j9P6 .PaginatedTable_btn-secondary__AEpeI {\n    background-color: #fff;\n    border: 1px solid #4eb3d4;\n    color: #4eb3d4;\n    outline: none; }\n    .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_dropdown__2j9P6 .PaginatedTable_btn-secondary__AEpeI:active {\n      background-color: #fff;\n      border: 1px solid #4eb3d4;\n      color: #4eb3d4;\n      outline: none; }\n    .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_dropdown__2j9P6 .PaginatedTable_btn-secondary__AEpeI:focus {\n      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_dropdown-menu__3F6h2 {\n    min-width: 0;\n    text-align: center; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_dropdown-item__1oK5j {\n    max-width: 100%;\n    padding: 0.25rem 0;\n    width: auto;\n    cursor: pointer; }\n    .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_dropdown-item__1oK5j:active {\n      background-color: #4eb3d4; }\n    .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_dropdown-item__1oK5j:focus {\n      outline: none; }\n    .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_dropdown-item__1oK5j a {\n      color: #4eb3d4 !important;\n      padding: 0 1.5em;\n      cursor: pointer; }\n      .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_dropdown-item__1oK5j a:hover {\n        color: #4eb3d4; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_react-bootstrap-table-page-btns-ul__2uU0d {\n    float: right;\n    margin-top: 0 !important; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_pagination__WEm3F > li {\n    display: inline;\n    outline: none;\n    cursor: pointer; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_pagination__WEm3F > li > a,\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_pagination__WEm3F > li > span {\n    position: relative;\n    float: left;\n    padding: 6px 12px;\n    margin-left: -1px;\n    line-height: 1.42857143;\n    color: #4eb3d4;\n    text-decoration: none;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    cursor: pointer; }\n  .PaginatedTable_paginated-table-container__2tXOc .PaginatedTable_page-item__6kmZL.PaginatedTable_active__i4tbf .PaginatedTable_page-link__1DsWj {\n    z-index: 1;\n    color: #fff;\n    background-color: #4eb3d4;\n    border-color: #4eb3d4; }\n";
styleInject(css_248z$f);

/*
 * https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/getting-started.html
 */

var PaginatedTable = /*#__PURE__*/function (_React$Component) {
  _inherits(PaginatedTable, _React$Component);

  var _super = _createSuper(PaginatedTable);

  function PaginatedTable() {
    var _this;

    _classCallCheck(this, PaginatedTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "buildCustomPagination", function () {
      var options = _this.props.options;
      return /*#__PURE__*/React__default['default'].createElement(lib_4, {
        pagination: paginationFactory(options)
      }, function (_ref) {
        var paginationProps = _ref.paginationProps,
            paginationTableProps = _ref.paginationTableProps;

        var props = _objectSpread2(_objectSpread2({}, paginationProps), {}, {
          dataSize: options.dataSize || 0
        });

        var tableProps = {
          keyField: _this.props.keyField,
          data: _this.props.data,
          columns: _this.props.columns,
          dataChangeListener: paginationTableProps.dataChangeListener,
          setPaginationRemoteEmitter: paginationTableProps.setPaginationRemoteEmitter
        };
        return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(BootstrapTable, _extends({}, tableProps, _this.props)), options.showSizeDropdown && /*#__PURE__*/React__default['default'].createElement(lib_2, props), options.showTotal && /*#__PURE__*/React__default['default'].createElement(lib_1, props), /*#__PURE__*/React__default['default'].createElement(lib_3, props));
      });
    });

    return _this;
  }

  _createClass(PaginatedTable, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "paginated-table-container ".concat(this.props.className || '')
      }, this.props.options ? this.buildCustomPagination() : /*#__PURE__*/React__default['default'].createElement(BootstrapTable, _extends({}, this.props, {
        pagination: paginationFactory({
          sizePerPage: 50
        })
      })));
    }
  }]);

  return PaginatedTable;
}(React__default['default'].Component);

function Spinner(props) {
  var top = props.top || '20%';
  var left = props.left || '40%';
  var color = props.color || '#000';
  var size = props.size || 5;
  var speed = props.speed || '1';
  var width = props.width || '3';
  var height = props.height || '3';
  return /*#__PURE__*/React__default['default'].createElement("i", {
    className: "spinner ".concat(props.className),
    style: {
      top: top,
      left: left,
      width: "".concat(width, "em"),
      height: "".concat(height, "em"),
      animation: "spinnerFrame ".concat(speed, "s linear infinite"),
      border: "solid ".concat(size, "px transparent"),
      borderTop: "solid ".concat(size, "px ").concat(color)
    }
  });
}

var css_248z$g = "@keyframes Subnav_fadein__W1IN_ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes Subnav_fadein__W1IN_ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes Subnav_fadein__W1IN_ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes Subnav_fadein__W1IN_ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes Subnav_fadein__W1IN_ {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n#Subnav_subnav-container__p4KPt {\n  font: 14px 'Avenir', sans-serif;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  background: #e8f1f3;\n  box-shadow: 3px 0 10px 0 #d1d6d9; }\n  #Subnav_subnav-container__p4KPt.Subnav_closed__37qPR {\n    transition: all 1s; }\n    #Subnav_subnav-container__p4KPt.Subnav_closed__37qPR .Subnav_subnav-content__22OLF .Subnav_subnav-title__3KKqv {\n      transition: all 0s;\n      visibility: hidden;\n      opacity: 0;\n      height: 25px; }\n    #Subnav_subnav-container__p4KPt.Subnav_closed__37qPR .Subnav_subnav-content__22OLF .Subnav_subnav-section__1QtEz {\n      transition: all 0s;\n      margin: 5px 0 10px; }\n    #Subnav_subnav-container__p4KPt.Subnav_closed__37qPR .Subnav_subnav-content__22OLF .Subnav_subnav-item-title__32urQ {\n      -webkit-transition: opacity 0s ease-in-out;\n      -moz-transition: opacity 0s ease-in-out;\n      -ms-transition: opacity 0s ease-in-out;\n      -o-transition: opacity 0s ease-in-out;\n      opacity: 0; }\n    #Subnav_subnav-container__p4KPt.Subnav_closed__37qPR .Subnav_subnav-content__22OLF .Subnav_subnav-item__3HZSn {\n      transition: all 0.9s;\n      margin-left: -30px;\n      width: 45px; }\n      #Subnav_subnav-container__p4KPt.Subnav_closed__37qPR .Subnav_subnav-content__22OLF .Subnav_subnav-item__3HZSn.Subnav_active__1FRf2 {\n        padding: 0 8px;\n        margin-left: -28px; }\n        #Subnav_subnav-container__p4KPt.Subnav_closed__37qPR .Subnav_subnav-content__22OLF .Subnav_subnav-item__3HZSn.Subnav_active__1FRf2 .Subnav_subnav-item-chevron___FmI2 {\n          right: 11px; }\n  #Subnav_subnav-container__p4KPt.Subnav_open__3BBXg {\n    transition: all 0.2s; }\n    #Subnav_subnav-container__p4KPt.Subnav_open__3BBXg .Subnav_subnav-content__22OLF .Subnav_subnav-item-title__32urQ {\n      -webkit-transition: opacity 1s ease-in-out;\n      -moz-transition: opacity 1s ease-in-out;\n      -ms-transition: opacity 1s ease-in-out;\n      -o-transition: opacity 1s ease-in-out;\n      opacity: 1; }\n    #Subnav_subnav-container__p4KPt.Subnav_open__3BBXg .Subnav_subnav-content__22OLF .Subnav_subnav-item__3HZSn {\n      transition: all 0.2s; }\n  #Subnav_subnav-container__p4KPt .Subnav_subnav-minimize-btn__P6cn4 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    right: -12px;\n    top: 40px;\n    background: #ffffff;\n    border-radius: 30px;\n    width: 24px;\n    height: 24px;\n    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.5);\n    border: solid 0 #173042;\n    cursor: pointer; }\n    #Subnav_subnav-container__p4KPt .Subnav_subnav-minimize-btn__P6cn4 .Subnav_far__2S4jb {\n      font-size: 14px; }\n  #Subnav_subnav-container__p4KPt .Subnav_subnav-content__22OLF {\n    margin: 45px 0;\n    padding: 0 28px;\n    cursor: default; }\n    #Subnav_subnav-container__p4KPt .Subnav_subnav-content__22OLF .Subnav_subnav-title__3KKqv {\n      font-size: 11px;\n      font-weight: bold;\n      color: #173042; }\n    #Subnav_subnav-container__p4KPt .Subnav_subnav-content__22OLF .Subnav_subnav-section__1QtEz {\n      margin: 15px 0 50px; }\n    #Subnav_subnav-container__p4KPt .Subnav_subnav-content__22OLF .Subnav_subnav-item__3HZSn {\n      position: relative;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      width: 219px;\n      height: 42px;\n      margin: 7px 0;\n      padding: 0 10px;\n      font-size: 18px;\n      line-height: 15px;\n      cursor: pointer;\n      color: #373636; }\n      #Subnav_subnav-container__p4KPt .Subnav_subnav-content__22OLF .Subnav_subnav-item__3HZSn .Subnav_subnav-item-chevron___FmI2 {\n        visibility: hidden;\n        position: absolute;\n        right: 20px;\n        font-size: 11px; }\n      #Subnav_subnav-container__p4KPt .Subnav_subnav-content__22OLF .Subnav_subnav-item__3HZSn.Subnav_active__1FRf2 {\n        color: #173042;\n        font-weight: bold;\n        box-shadow: 0 0 10px 0 #eaeaea;\n        background-color: #ffffff;\n        border-radius: 13px; }\n        #Subnav_subnav-container__p4KPt .Subnav_subnav-content__22OLF .Subnav_subnav-item__3HZSn.Subnav_active__1FRf2 .Subnav_subnav-item-chevron___FmI2 {\n          visibility: visible; }\n      #Subnav_subnav-container__p4KPt .Subnav_subnav-content__22OLF .Subnav_subnav-item__3HZSn .Subnav_subnav-item-title__32urQ {\n        margin-left: 7px; }\n";
styleInject(css_248z$g);

function Subnav(props) {
  var width = props.width || '242px';
  var height = props.height || '100%';
  var currentWidth, setWidth;

  if (props.setWidth) {
    setWidth = props.setWidth;
    currentWidth = props.currentWidth;
  } else {
    var _useState = React$2.useState(width);

    var _useState2 = _slicedToArray(_useState, 2);

    currentWidth = _useState2[0];
    setWidth = _useState2[1];
  }

  var isMinimized = currentWidth !== width;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: "subnav-container",
    className: isMinimized ? 'closed' : 'open',
    style: {
      width: currentWidth,
      height: height
    }
  }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, props.allowMinimize && /*#__PURE__*/React__default['default'].createElement(IconButton, {
    iconContainerClass: "subnav-minimize-btn",
    iconButtonClass: "far",
    iconClass: isMinimized ? 'fa-chevron-right' : 'fa-chevron-left',
    handleOnClick: setWidth.bind(this, currentWidth === width ? '45px' : width)
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "subnav-content"
  }, props.children));
}

function SubnavTitle(props) {
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "subnav-section"
  }, props.children);
}

function SubnavTitle$1(props) {
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "subnav-title"
  }, props.children);
}

var cloneSvg = function cloneSvg(sourceSvg) {
  return sourceSvg.cloneNode(true);
};

var isLocal$1 = function isLocal() {
  return window.location.protocol === 'file:';
};

var svgCache = new Map();

var requestQueue = {};
var queueRequest = function queueRequest(url, callback) {
  requestQueue[url] = requestQueue[url] || [];
  requestQueue[url].push(callback);
};
var processRequestQueue = function processRequestQueue(url) {
  var _loop_1 = function _loop_1(i, len) {
    setTimeout(function () {
      if (Array.isArray(requestQueue[url])) {
        var cacheValue = svgCache.get(url);
        var callback = requestQueue[url][i];

        if (cacheValue instanceof SVGElement) {
          callback(null, cloneSvg(cacheValue));
        }

        if (cacheValue instanceof Error) {
          callback(cacheValue);
        }

        if (i === requestQueue[url].length - 1) {
          delete requestQueue[url];
        }
      }
    }, 0);
  };

  for (var i = 0, len = requestQueue[url].length; i < len; i++) {
    _loop_1(i);
  }
};

var loadSvg = function loadSvg(url, callback) {
  if (svgCache.has(url)) {
    var cacheValue = svgCache.get(url);

    if (cacheValue instanceof SVGElement) {
      callback(null, cloneSvg(cacheValue));
      return;
    }

    if (cacheValue instanceof Error) {
      callback(cacheValue);
      return;
    }

    queueRequest(url, callback);
    return;
  }

  svgCache.set(url, undefined);
  queueRequest(url, callback);
  var httpRequest = new XMLHttpRequest();

  httpRequest.onreadystatechange = function () {
    try {
      if (httpRequest.readyState === 4) {
        if (httpRequest.status === 404 || httpRequest.responseXML === null) {
          throw new Error(isLocal$1() ? 'Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver.' : 'Unable to load SVG file: ' + url);
        }

        if (httpRequest.status === 200 || isLocal$1() && httpRequest.status === 0) {
          if (httpRequest.responseXML instanceof Document) {
            if (httpRequest.responseXML.documentElement) {
              svgCache.set(url, httpRequest.responseXML.documentElement);
            }
          }

          processRequestQueue(url);
        } else {
          throw new Error('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
        }
      }
    } catch (error) {
      svgCache.set(url, error);
      processRequestQueue(url);
    }
  };

  httpRequest.open('GET', url);

  if (httpRequest.overrideMimeType) {
    httpRequest.overrideMimeType('text/xml');
  }

  httpRequest.send();
};

var idCounter = 0;

var uniqueId = function uniqueId() {
  return ++idCounter;
};

var __spreadArrays =  function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};
var injectedElements = [];
var ranScripts = {};
var svgNamespace = 'http://www.w3.org/2000/svg';
var xlinkNamespace = 'http://www.w3.org/1999/xlink';

var injectElement = function injectElement(el, evalScripts, renumerateIRIElements, beforeEach, callback) {
  var imgUrl = el.getAttribute('data-src') || el.getAttribute('src');

  if (!imgUrl || !/\.svg/i.test(imgUrl)) {
    callback(new Error('Attempted to inject a file with a non-svg extension: ' + imgUrl));
    return;
  }

  if (injectedElements.indexOf(el) !== -1) {
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    return;
  }

  injectedElements.push(el);
  el.setAttribute('src', '');
  loadSvg(imgUrl, function (error, svg) {
    if (!svg) {
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(error);
      return;
    }

    var imgId = el.getAttribute('id');

    if (imgId) {
      svg.setAttribute('id', imgId);
    }

    var imgTitle = el.getAttribute('title');

    if (imgTitle) {
      svg.setAttribute('title', imgTitle);
    }

    var imgWidth = el.getAttribute('width');

    if (imgWidth) {
      svg.setAttribute('width', imgWidth);
    }

    var imgHeight = el.getAttribute('height');

    if (imgHeight) {
      svg.setAttribute('height', imgHeight);
    }

    var mergedClasses = Array.from(new Set(__spreadArrays((svg.getAttribute('class') || '').split(' '), ['injected-svg'], (el.getAttribute('class') || '').split(' ')))).join(' ').trim();
    svg.setAttribute('class', mergedClasses);
    var imgStyle = el.getAttribute('style');

    if (imgStyle) {
      svg.setAttribute('style', imgStyle);
    }

    svg.setAttribute('data-src', imgUrl);
    var imgData = [].filter.call(el.attributes, function (at) {
      return /^data-\w[\w-]*$/.test(at.name);
    });
    Array.prototype.forEach.call(imgData, function (dataAttr) {
      if (dataAttr.name && dataAttr.value) {
        svg.setAttribute(dataAttr.name, dataAttr.value);
      }
    });

    if (renumerateIRIElements) {
      var iriElementsAndProperties_1 = {
        clipPath: ['clip-path'],
        'color-profile': ['color-profile'],
        cursor: ['cursor'],
        filter: ['filter'],
        linearGradient: ['fill', 'stroke'],
        marker: ['marker', 'marker-start', 'marker-mid', 'marker-end'],
        mask: ['mask'],
        path: [],
        pattern: ['fill', 'stroke'],
        radialGradient: ['fill', 'stroke']
      };
      var element_1;
      var elements_1;
      var properties_1;
      var currentId_1;
      var newId_1;
      Object.keys(iriElementsAndProperties_1).forEach(function (key) {
        element_1 = key;
        properties_1 = iriElementsAndProperties_1[key];
        elements_1 = svg.querySelectorAll(element_1 + '[id]');

        var _loop_1 = function _loop_1(a, elementsLen) {
          currentId_1 = elements_1[a].id;
          newId_1 = currentId_1 + '-' + uniqueId();
          var referencingElements;
          Array.prototype.forEach.call(properties_1, function (property) {
            referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId_1 + '"]');

            for (var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++) {
              var attrValue = referencingElements[b].getAttribute(property);

              if (attrValue && !attrValue.match(new RegExp('url\\("?#' + currentId_1 + '"?\\)'))) {
                continue;
              }

              referencingElements[b].setAttribute(property, 'url(#' + newId_1 + ')');
            }
          });
          var allLinks = svg.querySelectorAll('[*|href]');
          var links = [];

          for (var c = 0, allLinksLen = allLinks.length; c < allLinksLen; c++) {
            var href = allLinks[c].getAttributeNS(xlinkNamespace, 'href');

            if (href && href.toString() === '#' + elements_1[a].id) {
              links.push(allLinks[c]);
            }
          }

          for (var d = 0, linksLen = links.length; d < linksLen; d++) {
            links[d].setAttributeNS(xlinkNamespace, 'href', '#' + newId_1);
          }

          elements_1[a].id = newId_1;
        };

        for (var a = 0, elementsLen = elements_1.length; a < elementsLen; a++) {
          _loop_1(a);
        }
      });
    }

    svg.removeAttribute('xmlns:a');
    var scripts = svg.querySelectorAll('script');
    var scriptsToEval = [];
    var script;
    var scriptType;

    for (var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++) {
      scriptType = scripts[i].getAttribute('type');

      if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript' || scriptType === 'text/javascript') {
        script = scripts[i].innerText || scripts[i].textContent;

        if (script) {
          scriptsToEval.push(script);
        }

        svg.removeChild(scripts[i]);
      }
    }

    if (scriptsToEval.length > 0 && (evalScripts === 'always' || evalScripts === 'once' && !ranScripts[imgUrl])) {
      for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {
        new Function(scriptsToEval[l])(window);
      }

      ranScripts[imgUrl] = true;
    }

    var styleTags = svg.querySelectorAll('style');
    Array.prototype.forEach.call(styleTags, function (styleTag) {
      styleTag.textContent += '';
    });
    svg.setAttribute('xmlns', svgNamespace);
    svg.setAttribute('xmlns:xlink', xlinkNamespace);
    beforeEach(svg);

    if (el.parentNode) {
      el.parentNode.replaceChild(svg, el);
    }

    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    callback(null, svg);
  });
};

var SVGInjector = function SVGInjector(elements, _a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.afterAll,
      afterAll = _c === void 0 ? function () {
    return undefined;
  } : _c,
      _d = _b.afterEach,
      afterEach = _d === void 0 ? function () {
    return undefined;
  } : _d,
      _e = _b.beforeEach,
      beforeEach = _e === void 0 ? function () {
    return undefined;
  } : _e,
      _f = _b.evalScripts,
      evalScripts = _f === void 0 ? 'never' : _f,
      _g = _b.renumerateIRIElements,
      renumerateIRIElements = _g === void 0 ? true : _g;

  if (elements && 'length' in elements) {
    var elementsLoaded_1 = 0;

    for (var i = 0, j = elements.length; i < j; i++) {
      injectElement(elements[i], evalScripts, renumerateIRIElements, beforeEach, function (error, svg) {
        afterEach(error, svg);

        if (elements && 'length' in elements && elements.length === ++elementsLoaded_1) {
          afterAll(elementsLoaded_1);
        }
      });
    }
  } else if (elements) {
    injectElement(elements, evalScripts, renumerateIRIElements, beforeEach, function (error, svg) {
      afterEach(error, svg);
      afterAll(1);
      elements = null;
    });
  } else {
    afterAll(0);
  }
};

// Hat-tip: https://github.com/developit/preact-compat/blob/master/src/index.js#L402.
var shallowDiffers = function shallowDiffers(a, b) {
  for (var i in a) {
    if (!(i in b)) {
      return true;
    }
  }

  for (var _i in b) {
    if (a[_i] !== b[_i]) {
      return true;
    }
  }

  return false;
};

var ReactSVG = /*#__PURE__*/function (_React$Component) {
  inheritsLoose(ReactSVG, _React$Component);

  function ReactSVG() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.initialState = {
      hasError: false,
      isLoading: true
    };
    _this.state = _this.initialState;
    _this._isMounted = false;

    _this.refCallback = function (container) {
      _this.container = container;
    };

    return _this;
  }

  var _proto = ReactSVG.prototype;

  _proto.renderSVG = function renderSVG() {
    var _this2 = this;

    /* istanbul ignore else */
    if (this.container instanceof Node) {
      var _this$props = this.props,
          beforeInjection = _this$props.beforeInjection,
          evalScripts = _this$props.evalScripts,
          renumerateIRIElements = _this$props.renumerateIRIElements,
          src = _this$props.src;
      /* eslint-disable @typescript-eslint/no-non-null-assertion */

      var afterInjection = this.props.afterInjection;
      var Wrapper = this.props.wrapper;
      /* eslint-enable @typescript-eslint/no-non-null-assertion */

      var wrapper = document.createElement(Wrapper);
      wrapper.innerHTML = ReactDOMServer__default['default'].renderToStaticMarkup( /*#__PURE__*/React$2.createElement(Wrapper, null, /*#__PURE__*/React$2.createElement(Wrapper, {
        "data-src": src
      })));
      this.svgWrapper = this.container.appendChild(wrapper.firstChild);

      var afterEach = function afterEach(error, svg) {
        if (error) {
          _this2.removeSVG();
        } // TODO: It'd be better to cleanly unsubscribe from SVGInjector
        // callbacks instead of tracking a property like this.


        if (_this2._isMounted) {
          _this2.setState(function () {
            return {
              hasError: !!error,
              isLoading: false
            };
          }, function () {
            afterInjection(error, svg);
          });
        }
      };

      SVGInjector(this.svgWrapper.firstChild, {
        afterEach: afterEach,
        beforeEach: beforeInjection,
        evalScripts: evalScripts,
        renumerateIRIElements: renumerateIRIElements
      });
    }
  };

  _proto.removeSVG = function removeSVG() {
    if (this.container instanceof Node && this.svgWrapper instanceof Node) {
      this.container.removeChild(this.svgWrapper);
      this.svgWrapper = null;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.renderSVG();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this3 = this;

    if (shallowDiffers(prevProps, this.props)) {
      this.setState(function () {
        return _this3.initialState;
      }, function () {
        _this3.removeSVG();

        _this3.renderSVG();
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this.removeSVG();
  };

  _proto.render = function render() {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    var _this$props2 = this.props,
        afterInjection = _this$props2.afterInjection,
        beforeInjection = _this$props2.beforeInjection,
        evalScripts = _this$props2.evalScripts,
        Fallback = _this$props2.fallback,
        Loading = _this$props2.loading,
        renumerateIRIElements = _this$props2.renumerateIRIElements,
        src = _this$props2.src,
        wrapper = _this$props2.wrapper,
        rest = objectWithoutPropertiesLoose(_this$props2, ["afterInjection", "beforeInjection", "evalScripts", "fallback", "loading", "renumerateIRIElements", "src", "wrapper"]);
    /* eslint-enable @typescript-eslint/no-unused-vars */
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion


    var Wrapper = wrapper;
    return /*#__PURE__*/React$2.createElement(Wrapper, Object.assign({}, rest, {
      ref: this.refCallback
    }), this.state.isLoading && Loading && /*#__PURE__*/React$2.createElement(Loading, null), this.state.hasError && Fallback && /*#__PURE__*/React$2.createElement(Fallback, null));
  };

  return ReactSVG;
}(React$2.Component);
ReactSVG.defaultProps = {
  afterInjection: function afterInjection() {
    return undefined;
  },
  beforeInjection: function beforeInjection() {
    return undefined;
  },
  evalScripts: 'never',
  fallback: null,
  loading: null,
  renumerateIRIElements: true,
  wrapper: 'div'
};
ReactSVG.propTypes =  {
  afterInjection: PropTypes$2.func,
  beforeInjection: PropTypes$2.func,
  evalScripts: PropTypes$2.oneOf(['always', 'once', 'never']),
  fallback: PropTypes$2.oneOfType([PropTypes$2.func, PropTypes$2.object, PropTypes$2.string]),
  loading: PropTypes$2.oneOfType([PropTypes$2.func, PropTypes$2.object, PropTypes$2.string]),
  renumerateIRIElements: PropTypes$2.bool,
  src: PropTypes$2.string.isRequired,
  wrapper: PropTypes$2.oneOf(['div', 'span'])
} ;

function SubnavItem(props) {
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "subnav-item ".concat(props.isActive ? 'active' : ''),
    onClick: props.onClick
  }, props.icon ? /*#__PURE__*/React__default['default'].createElement(ReactSVG, {
    src: props.icon
  }) : props.iconClass ? /*#__PURE__*/React__default['default'].createElement(IconButton, {
    iconContainerClass: "subnav-item-icon",
    iconButtonClass: props.iconButtonClass || 'far',
    iconClass: props.iconClass,
    styles: {
      fontSize: '24px'
    }
  }) : null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "subnav-item-title"
  }, props.children), /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(IconButton, {
    iconContainerClass: "subnav-item-chevron",
    iconButtonClass: "fas",
    iconClass: "fa-chevron-right"
  })));
}

var reactSwitch_min = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});function _extends(){return (_extends=Object.assign||function(t){for(var i=1;i<arguments.length;i++){var o=arguments[i];for(var s in o)Object.prototype.hasOwnProperty.call(o,s)&&(t[s]=o[s]);}return t}).apply(this,arguments)}var uncheckedIcon=React__default['default'].createElement("svg",{viewBox:"-2 -5 14 20",height:"100%",width:"100%",style:{position:"absolute",top:0}},React__default['default'].createElement("path",{d:"M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",fill:"#fff",fillRule:"evenodd"})),checkedIcon=React__default['default'].createElement("svg",{height:"100%",width:"100%",viewBox:"-2 -5 17 21",style:{position:"absolute",top:0}},React__default['default'].createElement("path",{d:"M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",fill:"#fff",fillRule:"evenodd"}));function createBackgroundColor(t,i,o,s,n){var e=(t-o)/(i-o);if(0===e)return s;if(1===e)return n;for(var h="#",r=1;r<6;r+=2){var a=parseInt(s.substr(r,2),16),c=parseInt(n.substr(r,2),16),l=Math.round((1-e)*a+e*c).toString(16);1===l.length&&(l="0"+l),h+=l;}return h}function convertShorthandColor(t){if(7===t.length)return t;for(var i="#",o=1;o<4;o+=1)i+=t[o]+t[o];return i}function getBackgroundColor(t,i,o,s,n){return createBackgroundColor(t,i,o,convertShorthandColor(s),convertShorthandColor(n))}function objectWithoutProperties(t,i){var o={};for(var s in t)Object.prototype.hasOwnProperty.call(t,s)&&-1===i.indexOf(s)&&(o[s]=t[s]);return o}var ReactSwitch=function(n){function t(t){n.call(this,t);var i=t.height,o=t.width,s=t.checked;this.t=t.handleDiameter||i-2,this.i=Math.max(o-i,o-(i+this.t)/2),this.o=Math.max(0,(i-this.t)/2),this.state={s:s?this.i:this.o},this.n=0,this.e=0,this.h=this.h.bind(this),this.r=this.r.bind(this),this.a=this.a.bind(this),this.c=this.c.bind(this),this.l=this.l.bind(this),this.u=this.u.bind(this),this.f=this.f.bind(this),this.p=this.p.bind(this),this.b=this.b.bind(this),this.g=this.g.bind(this),this.v=this.v.bind(this),this.w=this.w.bind(this);}return n&&(t.__proto__=n),((t.prototype=Object.create(n&&n.prototype)).constructor=t).prototype.componentDidUpdate=function(t){t.checked!==this.props.checked&&this.setState({s:this.props.checked?this.i:this.o});},t.prototype.k=function(t){this.y.focus(),this.setState({C:t,M:!0,m:Date.now()});},t.prototype.x=function(t){var i=this.state,o=i.C,s=i.s,n=(this.props.checked?this.i:this.o)+t-o;i.R||t===o||this.setState({R:!0});var e=Math.min(this.i,Math.max(this.o,n));e!==s&&this.setState({s:e});},t.prototype.S=function(t){var i=this.state,o=i.s,s=i.R,n=i.m,e=this.props.checked,h=(this.i+this.o)/2,r=Date.now()-n;!s||r<250?this.T(t):e?h<o?this.setState({s:this.i}):this.T(t):o<h?this.setState({s:this.o}):this.T(t),this.setState({R:!1,M:!1}),this.n=Date.now();},t.prototype.h=function(t){t.preventDefault(),"number"==typeof t.button&&0!==t.button||(this.k(t.clientX),window.addEventListener("mousemove",this.r),window.addEventListener("mouseup",this.a));},t.prototype.r=function(t){t.preventDefault(),this.x(t.clientX);},t.prototype.a=function(t){this.S(t),window.removeEventListener("mousemove",this.r),window.removeEventListener("mouseup",this.a);},t.prototype.c=function(t){this.$=null,this.k(t.touches[0].clientX);},t.prototype.l=function(t){this.x(t.touches[0].clientX);},t.prototype.u=function(t){t.preventDefault(),this.S(t);},t.prototype.p=function(t){50<Date.now()-this.n&&(this.T(t),50<Date.now()-this.e&&this.setState({M:!1}));},t.prototype.b=function(){this.e=Date.now();},t.prototype.g=function(){this.setState({M:!0});},t.prototype.v=function(){this.setState({M:!1});},t.prototype.w=function(t){this.y=t;},t.prototype.f=function(t){t.preventDefault(),this.y.focus(),this.T(t),this.setState({M:!1});},t.prototype.T=function(t){var i=this.props;(0, i.onChange)(!i.checked,t,i.id);},t.prototype.render=function(){var t=this.props,i=t.disabled,o=t.className,s=t.offColor,n=t.onColor,e=t.offHandleColor,h=t.onHandleColor,r=t.checkedIcon,a=t.uncheckedIcon,c=t.boxShadow,l=t.activeBoxShadow,u=t.height,d=t.width,f=objectWithoutProperties(t,["disabled","className","offColor","onColor","offHandleColor","onHandleColor","checkedIcon","uncheckedIcon","boxShadow","activeBoxShadow","height","width","handleDiameter"]),p=this.state,b=p.s,g=p.R,v=p.M,w={position:"relative",display:"inline-block",textAlign:"left",opacity:i?.5:1,direction:"ltr",borderRadius:u/2,WebkitTransition:"opacity 0.25s",MozTransition:"opacity 0.25s",transition:"opacity 0.25s",touchAction:"none",WebkitTapHighlightColor:"rgba(0, 0, 0, 0)",WebkitUserSelect:"none",MozUserSelect:"none",msUserSelect:"none",userSelect:"none"},k={height:u,width:d,margin:Math.max(0,(this.t-u)/2),position:"relative",background:getBackgroundColor(b,this.i,this.o,s,n),borderRadius:u/2,cursor:i?"default":"pointer",WebkitTransition:g?null:"background 0.25s",MozTransition:g?null:"background 0.25s",transition:g?null:"background 0.25s"},y={height:u,width:Math.min(1.5*u,d-(this.t+u)/2+1),position:"relative",opacity:(b-this.o)/(this.i-this.o),pointerEvents:"none",WebkitTransition:g?null:"opacity 0.25s",MozTransition:g?null:"opacity 0.25s",transition:g?null:"opacity 0.25s"},C={height:u,width:Math.min(1.5*u,d-(this.t+u)/2+1),position:"absolute",opacity:1-(b-this.o)/(this.i-this.o),right:0,top:0,pointerEvents:"none",WebkitTransition:g?null:"opacity 0.25s",MozTransition:g?null:"opacity 0.25s",transition:g?null:"opacity 0.25s"},M={height:this.t,width:this.t,background:getBackgroundColor(b,this.i,this.o,e,h),display:"inline-block",cursor:i?"default":"pointer",borderRadius:"50%",position:"absolute",transform:"translateX("+b+"px)",top:Math.max(0,(u-this.t)/2),outline:0,boxShadow:v?l:c,border:0,WebkitTransition:g?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",MozTransition:g?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",transition:g?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s"};return React__default['default'].createElement("div",{className:o,style:w},React__default['default'].createElement("div",{className:"react-switch-bg",style:k,onClick:i?null:this.f,onMouseDown:function(t){return t.preventDefault()}},r&&React__default['default'].createElement("div",{style:y},r),a&&React__default['default'].createElement("div",{style:C},a)),React__default['default'].createElement("div",{className:"react-switch-handle",style:M,onClick:function(t){return t.preventDefault()},onMouseDown:i?null:this.h,onTouchStart:i?null:this.c,onTouchMove:i?null:this.l,onTouchEnd:i?null:this.u,onTouchCancel:i?null:this.v}),React__default['default'].createElement("input",_extends({},{type:"checkbox",role:"switch",disabled:i,style:{border:0,clip:"rect(0 0 0 0)",height:1,margin:-1,overflow:"hidden",padding:0,position:"absolute",width:1}},f,{ref:this.w,onFocus:this.g,onBlur:this.v,onKeyUp:this.b,onChange:this.p})))},t}(React__default['default'].Component);ReactSwitch.defaultProps={disabled:!1,offColor:"#888",onColor:"#080",offHandleColor:"#fff",onHandleColor:"#fff",uncheckedIcon:uncheckedIcon,checkedIcon:checkedIcon,boxShadow:null,activeBoxShadow:"0 0 2px 3px #3bf",height:28,width:56},exports.default=ReactSwitch;
});

unwrapExports(reactSwitch_min);

var reactSwitch_dev = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, '__esModule', { value: true });




function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/*
The MIT License (MIT)

Copyright (c) 2015 instructure-react

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
var uncheckedIcon = React__default['default'].createElement('svg', {
  viewBox: "-2 -5 14 20",
  height: "100%",
  width: "100%",
  style: {
    position: "absolute",
    top: 0
  }
}, React__default['default'].createElement('path', {
  d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
  fill: "#fff",
  fillRule: "evenodd"
}));
var checkedIcon = React__default['default'].createElement('svg', {
  height: "100%",
  width: "100%",
  viewBox: "-2 -5 17 21",
  style: {
    position: "absolute",
    top: 0
  }
}, React__default['default'].createElement('path', {
  d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
  fill: "#fff",
  fillRule: "evenodd"
}));

function createBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
  var relativePos = (pos - uncheckedPos) / (checkedPos - uncheckedPos);

  if (relativePos === 0) {
    return offColor;
  }

  if (relativePos === 1) {
    return onColor;
  }

  var newColor = "#";

  for (var i = 1; i < 6; i += 2) {
    var offComponent = parseInt(offColor.substr(i, 2), 16);
    var onComponent = parseInt(onColor.substr(i, 2), 16);
    var weightedValue = Math.round((1 - relativePos) * offComponent + relativePos * onComponent);
    var newComponent = weightedValue.toString(16);

    if (newComponent.length === 1) {
      newComponent = "0" + newComponent;
    }

    newColor += newComponent;
  }

  return newColor;
}

function convertShorthandColor(color) {
  if (color.length === 7) {
    return color;
  }

  var sixDigitColor = "#";

  for (var i = 1; i < 4; i += 1) {
    sixDigitColor += color[i] + color[i];
  }

  return sixDigitColor;
}

function getBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
  var sixDigitOffColor = convertShorthandColor(offColor);
  var sixDigitOnColor = convertShorthandColor(onColor);
  return createBackgroundColor(pos, checkedPos, uncheckedPos, sixDigitOffColor, sixDigitOnColor);
}

// Make sure color props are strings that start with "#" since other ways to write colors are not supported.
var hexColorPropType = function (props, propName, componentName) {
  var prop = props[propName];

  if (typeof prop !== "string" || prop[0] !== "#" || prop.length !== 4 && prop.length !== 7) {
    return new Error("Invalid prop '" + propName + "' supplied to '" + componentName + "'. '" + propName + "' has to be either a 3-digit or 6-digit hex-color string. Valid examples: '#abc', '#123456'");
  }

  return null;
};

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];

  return target;
}

var ReactSwitch =
/*@__PURE__*/
function (Component) {
  function ReactSwitch(props) {
    Component.call(this, props);
    var height = props.height;
    var width = props.width;
    var handleDiameter = props.handleDiameter;
    var checked = props.checked;
    this.$handleDiameter = handleDiameter || height - 2;
    this.$checkedPos = Math.max(width - height, width - (height + this.$handleDiameter) / 2);
    this.$uncheckedPos = Math.max(0, (height - this.$handleDiameter) / 2);
    this.state = {
      $pos: checked ? this.$checkedPos : this.$uncheckedPos
    };
    this.$lastDragAt = 0;
    this.$lastKeyUpAt = 0;
    this.$onMouseDown = this.$onMouseDown.bind(this);
    this.$onMouseMove = this.$onMouseMove.bind(this);
    this.$onMouseUp = this.$onMouseUp.bind(this);
    this.$onTouchStart = this.$onTouchStart.bind(this);
    this.$onTouchMove = this.$onTouchMove.bind(this);
    this.$onTouchEnd = this.$onTouchEnd.bind(this);
    this.$onClick = this.$onClick.bind(this);
    this.$onInputChange = this.$onInputChange.bind(this);
    this.$onKeyUp = this.$onKeyUp.bind(this);
    this.$setHasOutline = this.$setHasOutline.bind(this);
    this.$unsetHasOutline = this.$unsetHasOutline.bind(this);
    this.$getInputRef = this.$getInputRef.bind(this);
  }

  if (Component) ReactSwitch.__proto__ = Component;
  ReactSwitch.prototype = Object.create(Component && Component.prototype);
  ReactSwitch.prototype.constructor = ReactSwitch;

  ReactSwitch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.checked === this.props.checked) {
      return;
    }

    var $pos = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
    this.setState({
      $pos: $pos
    });
  };

  ReactSwitch.prototype.$onDragStart = function $onDragStart(clientX) {
    this.$inputRef.focus();
    this.setState({
      $startX: clientX,
      $hasOutline: true,
      $dragStartingTime: Date.now()
    });
  };

  ReactSwitch.prototype.$onDrag = function $onDrag(clientX) {
    var ref = this.state;
    var $startX = ref.$startX;
    var $isDragging = ref.$isDragging;
    var $pos = ref.$pos;
    var ref$1 = this.props;
    var checked = ref$1.checked;
    var startPos = checked ? this.$checkedPos : this.$uncheckedPos;
    var mousePos = startPos + clientX - $startX; // We need this check to fix a windows glitch where onDrag is triggered onMouseDown in some cases

    if (!$isDragging && clientX !== $startX) {
      this.setState({
        $isDragging: true
      });
    }

    var newPos = Math.min(this.$checkedPos, Math.max(this.$uncheckedPos, mousePos)); // Prevent unnecessary rerenders

    if (newPos !== $pos) {
      this.setState({
        $pos: newPos
      });
    }
  };

  ReactSwitch.prototype.$onDragStop = function $onDragStop(event) {
    var ref = this.state;
    var $pos = ref.$pos;
    var $isDragging = ref.$isDragging;
    var $dragStartingTime = ref.$dragStartingTime;
    var ref$1 = this.props;
    var checked = ref$1.checked;
    var halfwayCheckpoint = (this.$checkedPos + this.$uncheckedPos) / 2; // Simulate clicking the handle

    var timeSinceStart = Date.now() - $dragStartingTime;

    if (!$isDragging || timeSinceStart < 250) {
      this.$onChange(event); // Handle dragging from checked position
    } else if (checked) {
      if ($pos > halfwayCheckpoint) {
        this.setState({
          $pos: this.$checkedPos
        });
      } else {
        this.$onChange(event);
      } // Handle dragging from unchecked position

    } else if ($pos < halfwayCheckpoint) {
      this.setState({
        $pos: this.$uncheckedPos
      });
    } else {
      this.$onChange(event);
    }

    this.setState({
      $isDragging: false,
      $hasOutline: false
    });
    this.$lastDragAt = Date.now();
  };

  ReactSwitch.prototype.$onMouseDown = function $onMouseDown(event) {
    event.preventDefault(); // Ignore right click and scroll

    if (typeof event.button === "number" && event.button !== 0) {
      return;
    }

    this.$onDragStart(event.clientX);
    window.addEventListener("mousemove", this.$onMouseMove);
    window.addEventListener("mouseup", this.$onMouseUp);
  };

  ReactSwitch.prototype.$onMouseMove = function $onMouseMove(event) {
    event.preventDefault();
    this.$onDrag(event.clientX);
  };

  ReactSwitch.prototype.$onMouseUp = function $onMouseUp(event) {
    this.$onDragStop(event);
    window.removeEventListener("mousemove", this.$onMouseMove);
    window.removeEventListener("mouseup", this.$onMouseUp);
  };

  ReactSwitch.prototype.$onTouchStart = function $onTouchStart(event) {
    this.$checkedStateFromDragging = null;
    this.$onDragStart(event.touches[0].clientX);
  };

  ReactSwitch.prototype.$onTouchMove = function $onTouchMove(event) {
    this.$onDrag(event.touches[0].clientX);
  };

  ReactSwitch.prototype.$onTouchEnd = function $onTouchEnd(event) {
    event.preventDefault();
    this.$onDragStop(event);
  };

  ReactSwitch.prototype.$onInputChange = function $onInputChange(event) {
    // This condition is unfortunately needed in some browsers where the input's change event might get triggered
    // right after the dragstop event is triggered (occurs when dropping over a label element)
    if (Date.now() - this.$lastDragAt > 50) {
      this.$onChange(event); // Prevent clicking label, but not key activation from setting outline to true - yes, this is absurd

      if (Date.now() - this.$lastKeyUpAt > 50) {
        this.setState({
          $hasOutline: false
        });
      }
    }
  };

  ReactSwitch.prototype.$onKeyUp = function $onKeyUp() {
    this.$lastKeyUpAt = Date.now();
  };

  ReactSwitch.prototype.$setHasOutline = function $setHasOutline() {
    this.setState({
      $hasOutline: true
    });
  };

  ReactSwitch.prototype.$unsetHasOutline = function $unsetHasOutline() {
    this.setState({
      $hasOutline: false
    });
  };

  ReactSwitch.prototype.$getInputRef = function $getInputRef(el) {
    this.$inputRef = el;
  };

  ReactSwitch.prototype.$onClick = function $onClick(event) {
    event.preventDefault();
    this.$inputRef.focus();
    this.$onChange(event);
    this.setState({
      $hasOutline: false
    });
  };

  ReactSwitch.prototype.$onChange = function $onChange(event) {
    var ref = this.props;
    var checked = ref.checked;
    var onChange = ref.onChange;
    var id = ref.id;
    onChange(!checked, event, id);
  };

  ReactSwitch.prototype.render = function render() {
    var ref = this.props;
    var disabled = ref.disabled;
    var className = ref.className;
    var offColor = ref.offColor;
    var onColor = ref.onColor;
    var offHandleColor = ref.offHandleColor;
    var onHandleColor = ref.onHandleColor;
    var checkedIcon$$1 = ref.checkedIcon;
    var uncheckedIcon$$1 = ref.uncheckedIcon;
    var boxShadow = ref.boxShadow;
    var activeBoxShadow = ref.activeBoxShadow;
    var height = ref.height;
    var width = ref.width;
    var handleDiameter = ref.handleDiameter;
    var rest$1 = objectWithoutProperties(ref, ["disabled", "className", "offColor", "onColor", "offHandleColor", "onHandleColor", "checkedIcon", "uncheckedIcon", "boxShadow", "activeBoxShadow", "height", "width", "handleDiameter"]);
    var rest = rest$1;
    var ref$1 = this.state;
    var $pos = ref$1.$pos;
    var $isDragging = ref$1.$isDragging;
    var $hasOutline = ref$1.$hasOutline;
    var rootStyle = {
      position: "relative",
      display: "inline-block",
      textAlign: "left",
      opacity: disabled ? 0.5 : 1,
      direction: "ltr",
      borderRadius: height / 2,
      WebkitTransition: "opacity 0.25s",
      MozTransition: "opacity 0.25s",
      transition: "opacity 0.25s",
      touchAction: "none",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      userSelect: "none"
    };
    var backgroundStyle = {
      height: height,
      width: width,
      margin: Math.max(0, (this.$handleDiameter - height) / 2),
      position: "relative",
      background: getBackgroundColor($pos, this.$checkedPos, this.$uncheckedPos, offColor, onColor),
      borderRadius: height / 2,
      cursor: disabled ? "default" : "pointer",
      WebkitTransition: $isDragging ? null : "background 0.25s",
      MozTransition: $isDragging ? null : "background 0.25s",
      transition: $isDragging ? null : "background 0.25s"
    };
    var checkedIconStyle = {
      height: height,
      width: Math.min(height * 1.5, width - (this.$handleDiameter + height) / 2 + 1),
      position: "relative",
      opacity: ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
      pointerEvents: "none",
      WebkitTransition: $isDragging ? null : "opacity 0.25s",
      MozTransition: $isDragging ? null : "opacity 0.25s",
      transition: $isDragging ? null : "opacity 0.25s"
    };
    var uncheckedIconStyle = {
      height: height,
      width: Math.min(height * 1.5, width - (this.$handleDiameter + height) / 2 + 1),
      position: "absolute",
      opacity: 1 - ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
      right: 0,
      top: 0,
      pointerEvents: "none",
      WebkitTransition: $isDragging ? null : "opacity 0.25s",
      MozTransition: $isDragging ? null : "opacity 0.25s",
      transition: $isDragging ? null : "opacity 0.25s"
    };
    var handleStyle = {
      height: this.$handleDiameter,
      width: this.$handleDiameter,
      background: getBackgroundColor($pos, this.$checkedPos, this.$uncheckedPos, offHandleColor, onHandleColor),
      display: "inline-block",
      cursor: disabled ? "default" : "pointer",
      borderRadius: "50%",
      position: "absolute",
      transform: "translateX(" + $pos + "px)",
      top: Math.max(0, (height - this.$handleDiameter) / 2),
      outline: 0,
      boxShadow: $hasOutline ? activeBoxShadow : boxShadow,
      border: 0,
      WebkitTransition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
      MozTransition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
      transition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
    };
    var inputStyle = {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: 1
    };
    return React__default['default'].createElement('div', {
      className: className,
      style: rootStyle
    }, React__default['default'].createElement('div', {
      className: "react-switch-bg",
      style: backgroundStyle,
      onClick: disabled ? null : this.$onClick,
      onMouseDown: function (e) {
        return e.preventDefault();
      }
    }, checkedIcon$$1 && React__default['default'].createElement('div', {
      style: checkedIconStyle
    }, checkedIcon$$1), uncheckedIcon$$1 && React__default['default'].createElement('div', {
      style: uncheckedIconStyle
    }, uncheckedIcon$$1)), React__default['default'].createElement('div', {
      className: "react-switch-handle",
      style: handleStyle,
      onClick: function (e) {
        return e.preventDefault();
      },
      onMouseDown: disabled ? null : this.$onMouseDown,
      onTouchStart: disabled ? null : this.$onTouchStart,
      onTouchMove: disabled ? null : this.$onTouchMove,
      onTouchEnd: disabled ? null : this.$onTouchEnd,
      onTouchCancel: disabled ? null : this.$unsetHasOutline
    }), React__default['default'].createElement('input', _extends({}, {
      type: "checkbox",
      role: "switch",
      disabled: disabled,
      style: inputStyle
    }, rest, {
      ref: this.$getInputRef,
      onFocus: this.$setHasOutline,
      onBlur: this.$unsetHasOutline,
      onKeyUp: this.$onKeyUp,
      onChange: this.$onInputChange
    })));
  };

  return ReactSwitch;
}(React__default['default'].Component);

ReactSwitch.propTypes = {
  checked: PropTypes__default['default'].bool.isRequired,
  onChange: PropTypes__default['default'].func.isRequired,
  disabled: PropTypes__default['default'].bool,
  offColor: hexColorPropType,
  onColor: hexColorPropType,
  offHandleColor: hexColorPropType,
  onHandleColor: hexColorPropType,
  handleDiameter: PropTypes__default['default'].number,
  uncheckedIcon: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].element]),
  checkedIcon: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].element]),
  boxShadow: PropTypes__default['default'].string,
  activeBoxShadow: PropTypes__default['default'].string,
  height: PropTypes__default['default'].number,
  width: PropTypes__default['default'].number,
  id: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string
};
ReactSwitch.defaultProps = {
  disabled: false,
  offColor: "#888",
  onColor: "#080",
  offHandleColor: "#fff",
  onHandleColor: "#fff",
  uncheckedIcon: uncheckedIcon,
  checkedIcon: checkedIcon,
  boxShadow: null,
  activeBoxShadow: "0 0 2px 3px #3bf",
  height: 28,
  width: 56
};

exports.default = ReactSwitch;
});

unwrapExports(reactSwitch_dev);

var reactSwitch = createCommonjsModule(function (module) {
if (process.env.NODE_ENV === "production") {
  module.exports = reactSwitch_min;
} else {
  module.exports = reactSwitch_dev;
}
});

function Switcher(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      checkedText = _ref.checkedText,
      uncheckedText = _ref.uncheckedText,
      alignTextLeft = _ref.alignTextLeft,
      checkedIcon = _ref.checkedIcon,
      uncheckedIcon = _ref.uncheckedIcon,
      onColor = _ref.onColor,
      offColor = _ref.offColor,
      onHandleColor = _ref.onHandleColor,
      offHandleColor = _ref.offHandleColor,
      rest = _objectWithoutProperties(_ref, ["checked", "onChange", "disabled", "checkedText", "uncheckedText", "alignTextLeft", "checkedIcon", "uncheckedIcon", "onColor", "offColor", "onHandleColor", "offHandleColor"]);

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "switcher-wrapper"
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    className: "switcher-label"
  }, (checkedText || uncheckedText) && alignTextLeft && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "switcher-wrapper"
  }, checked ? checkedText : uncheckedText), /*#__PURE__*/React__default['default'].createElement(reactSwitch, _extends({}, rest, {
    checked: checked,
    onChange: !disabled ? onChange : null,
    uncheckedIcon: uncheckedIcon,
    checkedIcon: checkedIcon,
    onHandleColor: onHandleColor,
    offHandleColor: offHandleColor,
    className: "react-switch ".concat(disabled ? 'disabled' : ''),
    onColor: !disabled ? onColor : COLORS_CONFIG.SILVER,
    offColor: offColor
  })), (checkedText || uncheckedText) && !alignTextLeft && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "switcher-wrapper"
  }, checked ? checkedText : uncheckedText)));
}

Switcher.propTypes = {
  checked: PropTypes__default['default'].bool.isRequired,
  onChange: PropTypes__default['default'].func.isRequired,
  disabled: PropTypes__default['default'].bool,
  checkedText: PropTypes__default['default'].string,
  uncheckedText: PropTypes__default['default'].string,
  onColor: PropTypes__default['default'].oneOf(_toConsumableArray(AVAILABLE_COLORS)),
  offColor: PropTypes__default['default'].oneOf(_toConsumableArray(AVAILABLE_COLORS)),
  onHandleColor: PropTypes__default['default'].oneOf(_toConsumableArray(AVAILABLE_COLORS)),
  offHandleColor: PropTypes__default['default'].oneOf(_toConsumableArray(AVAILABLE_COLORS)),
  checkedIcon: PropTypes__default['default'].node,
  uncheckedIcon: PropTypes__default['default'].node
};
Switcher.defaultProps = {
  checkedText: null,
  uncheckedText: null,
  checkedIcon: false,
  uncheckedIcon: false,
  onColor: COLORS_CONFIG.SKY_BLUE,
  offColor: COLORS_CONFIG.SILVER,
  onHandleColor: COLORS_CONFIG.WHITE,
  offHandleColor: COLORS_CONFIG.WHITE
};

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].shape({
  enter: PropTypes__default['default'].number,
  exit: PropTypes__default['default'].number,
  appear: PropTypes__default['default'].number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].shape({
  enter: PropTypes__default['default'].string,
  exit: PropTypes__default['default'].string,
  active: PropTypes__default['default'].string
}), PropTypes__default['default'].shape({
  enter: PropTypes__default['default'].string,
  enterDone: PropTypes__default['default'].string,
  enterActive: PropTypes__default['default'].string,
  exit: PropTypes__default['default'].string,
  exitDone: PropTypes__default['default'].string,
  exitActive: PropTypes__default['default'].string
})]) : null;

var TransitionGroupContext = React__default['default'].createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default['default'].findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default['default'].findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default['default'].findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = _objectWithoutPropertiesLoose$3(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default['default'].createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default['default'].cloneElement(React__default['default'].Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default['default'].Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes__default['default'].shape({
    current: typeof Element === 'undefined' ? PropTypes__default['default'].any : PropTypes__default['default'].instanceOf(Element)
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func.isRequired, PropTypes__default['default'].element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes__default['default'].bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes__default['default'].bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes__default['default'].bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes__default['default'].bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes__default['default'].bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes__default['default'].bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes__default['default'].func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes__default['default'].func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes__default['default'].func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes__default['default'].func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes__default['default'].func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes__default['default'].func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes__default['default'].func
} : {}; // Name the function so it is clearer in the documentation

function noop$1() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$1,
  onEntering: noop$1,
  onEntered: noop$1,
  onExit: noop$1,
  onExiting: noop$1,
  onExited: noop$1
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

function _templateObject6$1() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 3;\n  height: calc(100% - 17px);\n  right: -400px;\n  top: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  ", "\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  padding-top: 32px;\n  z-index: 1000;\n  min-width: 400px;\n  height: 100%;\n  background-color: ", ";\n  background-repeat: no-repeat;\n  box-shadow: ", ";\n  overflow: hidden;\n  opacity: 1;\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100%;\n  background-color: ", ";\n  opacity: 0;\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 22px;\n  right: 8px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  width: 100px;\n  border: 2px solid ", ";\n  margin: 3px 30px;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px 32px;\n  font-size: 24px;\n  line-height: 26px;\n  color: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: 0;\n  margin-bottom: 0;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var Title$1 = Ye.p(_templateObject$g(), COLORS_CONFIG.SMOOTH_BROWN);
var Underline = Ye.div(_templateObject2$8(), COLORS_CONFIG.SKY_BLUE);
var CancelIconWrapper = Ye.div(_templateObject3$5());
var Backdrop = Ye.div(_templateObject4$3(), COLORS_CONFIG.WHITE$72);
var Sidebar = Ye.div(_templateObject5$1(), COLORS_CONFIG.WHITE, COLORS_CONFIG.SHADOWS.BLACK$10_10);
var SidebarFadeIn = $e(["from{right:-100%;}to{right:0px;}"]);
var SidebarFadeOut = $e(["from{right:0px;}to{right:-100%;}"]);
var BackdropFadeIn = $e(["0%{opacity:0;}1%{opacity:0;}100%{opacity:1;}"]);
var BackdropFadeOut = $e(["0%{opacity:1;}1%{opacity:1;}100%{opacity:0;}"]);
var OverallSidebarWrapper = Ye.div(_templateObject6$1(), function (_ref) {
  var state = _ref.state;

  if (state === 'entered') {
    return _e(["animation:", " 0.25s ease both;", "{animation:", " 0.5s ease both;}"], SidebarFadeIn, Backdrop, BackdropFadeIn);
  }

  if (state === 'exiting' || state === 'exited') {
    return _e(["animation:", " 0.25s ease both;animation-delay:0.1s;", "{animation:", " 0.5s ease both;}"], SidebarFadeOut, Backdrop, BackdropFadeOut);
  }
});

var TableActionSidebar = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TableActionSidebar, _React$PureComponent);

  var _super = _createSuper(TableActionSidebar);

  function TableActionSidebar() {
    var _this;

    _classCallCheck(this, TableActionSidebar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "element", null);

    _defineProperty(_assertThisInitialized(_this), "onEscape", _this.onEscape.bind(_assertThisInitialized(_this)));

    return _this;
  }

  _createClass(TableActionSidebar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.onEscape);
      this.element = document.getElementById(this.props.id);
      this.forceUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.open) {
        this.element.classList.add('TableActionSidebar-open');
      } else {
        this.element.classList.remove('TableActionSidebar-open');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.onEscape);
      this.element.classList.remove('TableActionSidebar-open');
    }
  }, {
    key: "onEscape",
    value: function onEscape(_ref) {
      var keyCode = _ref.keyCode;

      if (this.props.onClose && this.props.open && keyCode === 27) {
        this.props.onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onlyContentCloseClick = _this$props.onlyContentCloseClick,
          children = _this$props.children,
          onClose = _this$props.onClose,
          title = _this$props.title,
          style = _this$props.style,
          open = _this$props.open;
      if (!this.element) return null;
      return /*#__PURE__*/ReactDOM__default['default'].createPortal( /*#__PURE__*/React__default['default'].createElement(Transition, {
        in: open,
        timeout: 300
      }, function (state) {
        return state !== 'exited' && /*#__PURE__*/React__default['default'].createElement(OverallSidebarWrapper, {
          state: state
        }, /*#__PURE__*/React__default['default'].createElement(Backdrop, {
          onClick: !onlyContentCloseClick ? onClose : null
        }), /*#__PURE__*/React__default['default'].createElement(Sidebar, {
          style: style
        }, title && /*#__PURE__*/React__default['default'].createElement(Title$1, null, title), title && /*#__PURE__*/React__default['default'].createElement(Underline, null), !onlyContentCloseClick && /*#__PURE__*/React__default['default'].createElement(CancelIconWrapper, {
          onClick: onClose
        }, /*#__PURE__*/React__default['default'].createElement("i", {
          className: "fal fa-times",
          style: {
            fontSize: '22px'
          }
        })), children));
      }), this.element);
    }
  }]);

  return TableActionSidebar;
}(React__default['default'].PureComponent);

_defineProperty(TableActionSidebar, "propTypes", {
  onlyContentCloseClick: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].node.isRequired,
  onClose: PropTypes__default['default'].func.isRequired,
  style: PropTypes__default['default'].object,
  title: PropTypes__default['default'].string,
  open: PropTypes__default['default'].bool.isRequired
});

_defineProperty(TableActionSidebar, "defaultProps", {});

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 3;\n  width: 100%;\n  min-height: 150px;\n  padding: 15px 24px 15px 24px;\n  border: 1px solid #4eb3d4;\n  background-color: #fff;\n  font-size: 16px;\n  line-height: 22px;\n  color: #373636;\n  resize: none;\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 8px;\n  font-size: 14px;\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  min-height: 150px;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper$9 = Ye.div(_templateObject$h());
var Title$2 = Ye.div(_templateObject2$9());
var Textarea = Ye.textarea(_templateObject3$6());

function TextArea(_ref) {
  var placeholder = _ref.placeholder,
      status = _ref.status,
      title = _ref.title,
      name = _ref.name,
      rest = _objectWithoutProperties(_ref, ["placeholder", "status", "title", "name"]);

  return /*#__PURE__*/React__default['default'].createElement(Wrapper$9, null, title && /*#__PURE__*/React__default['default'].createElement(Title$2, null, title), /*#__PURE__*/React__default['default'].createElement(Textarea, _extends({
    placeholder: placeholder,
    name: name
  }, rest)));
} // Type of props


TextArea.propTypes = {
  placeholder: PropTypes__default['default'].string,
  onChange: PropTypes__default['default'].func.isRequired,
  status: PropTypes__default['default'].object,
  value: PropTypes__default['default'].string.isRequired,
  title: PropTypes__default['default'].string,
  name: PropTypes__default['default'].string.isRequired
}; // Default value for props

TextArea.defaultProps = {
  title: null
};
var index$1 = /*#__PURE__*/React$2.memo(TextArea);

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n  padding: 0px 36px;\n  border-radius: 16px;\n  color: ", ";\n  cursor: pointer;\n  text-transform: capitalize;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  ", "\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: 32px;\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 16px;\n  display: inline-block;\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$a = Ye.div(_templateObject$i(), COLORS_CONFIG.SILVER);
var Inline = Ye.div(_templateObject2$a());
var Item$1 = Ye.div(_templateObject3$7(), COLORS_CONFIG.SMOOTH_BROWN, function (_ref) {
  var active = _ref.active;
  return active && _e(["color:", ";cursor:default;background-color:", ";"], COLORS_CONFIG.WHITE, COLORS_CONFIG.SKY_BLUE);
});

function ToggleBar(_ref) {
  var name = _ref.name,
      onChange = _ref.onChange,
      active = _ref.active,
      options = _ref.options;

  if (!Array.isArray(options)) {
    return null;
  }

  var clickHandler = function clickHandler(option) {
    if (active === option) return;
    onChange({
      target: {
        name: name,
        value: option
      }
    });
  };

  return /*#__PURE__*/React__default['default'].createElement(Wrapper$a, null, /*#__PURE__*/React__default['default'].createElement(Inline, null, options.map(function (option, id) {
    return /*#__PURE__*/React__default['default'].createElement(Item$1, {
      key: id,
      active: active === option,
      onClick: function onClick() {
        return clickHandler(option);
      }
    }, option);
  })));
}
/* ToggleBar type of props */


ToggleBar.propTypes = {
  name: PropTypes__default['default'].string.isRequired,
  onChange: PropTypes__default['default'].func.isRequired,
  active: PropTypes__default['default'].string.isRequired,
  options: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string.isRequired).isRequired
};

var css_248z$h = "@keyframes UserStats_fadein__3K32H {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes UserStats_fadein__3K32H {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes UserStats_fadein__3K32H {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes UserStats_fadein__3K32H {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes UserStats_fadein__3K32H {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.UserStats_UserStats__container__1aBl3 {\n  display: flex;\n  flex-direction: column;\n  max-width: 150px;\n  padding: 0.25rem 1.25rem;\n  font-family: sans-serif;\n  border: 2px solid #00acc1; }\n  .UserStats_UserStats__container__1aBl3 .UserStats_UserStats__header__1BQ7O {\n    color: #00acc1; }\n  .UserStats_UserStats__container__1aBl3 .UserStats_UserStats_AllData__container__1hE2A {\n    display: flex;\n    justify-content: space-between;\n    width: 100%; }\n  .UserStats_UserStats__container__1aBl3 .UserStats_UserStats_data__container__1IjKP {\n    text-align: center; }\n  .UserStats_UserStats__container__1aBl3 .UserStats_UserStats_data__label__3qBiR {\n    font-weight: 600; }\n";
styleInject(css_248z$h);

var UserStats = function UserStats(_ref) {
  var positionLabel = _ref.positionLabel,
      scoreLabel = _ref.scoreLabel,
      position = _ref.position,
      score = _ref.score;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "UserStats__container"
  }, /*#__PURE__*/React__default['default'].createElement("h2", {
    className: "UserStats__header"
  }, "My Stats"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "UserStats_AllData__container"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "UserStats_data__container"
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    htmlFor: "position",
    className: "UserStats_data__label"
  }, positionLabel), /*#__PURE__*/React__default['default'].createElement("p", {
    name: "position",
    className: "UserStats_data"
  }, position && score ? position : 'No')), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "UserStats_data__container"
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    htmlFor: "score",
    className: "UserStats_data__label"
  }, scoreLabel), /*#__PURE__*/React__default['default'].createElement("p", {
    name: "score",
    className: "UserStats_data"
  }, score && position ? score : 'Score'))));
};

UserStats.propTypes = {
  position: PropTypes__default['default'].number,
  positionLabel: PropTypes__default['default'].string.isRequired,
  score: PropTypes__default['default'].number,
  scoreLabel: PropTypes__default['default'].string.isRequired
};

var PuzzleInstructionModal = function PuzzleInstructionModal(props) {
  var updateStep = props.updateStep,
      totalSlides = props.totalSlides,
      step = props.step,
      useBackdrop = props.useBackdrop,
      title = props.title,
      text = props.text,
      copy = props.copy,
      demo = props.demo,
      caption = props.caption,
      buttonText = props.buttonText,
      copyPasscode = props.copyPasscode;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, useBackdrop && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "puzzleinstructionsmodal-backdrop"
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    id: "puzzle-modal",
    className: "puzzleinstructionsmodal-container"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "puzzleinstructionsmodal-progress"
  }, ' ', /*#__PURE__*/React__default['default'].createElement("p", null, "".concat(step + 1, " of ").concat(totalSlides))), title && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "puzzleinstructionsmodal-title"
  }, /*#__PURE__*/React__default['default'].createElement("h2", null, title)), text && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "puzzleinstructionsmodal-text"
  }, /*#__PURE__*/React__default['default'].createElement("p", null, text)), demo && /*#__PURE__*/React__default['default'].createElement("img", {
    src: demo,
    alt: "puzzle gameplay demo"
  }), caption && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "puzzleinstructionsmodal-caption"
  }, caption), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "puzzleinstructionsmodal-button--container"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    onClick: updateStep,
    className: "puzzleinstructionsmodal-button"
  }, buttonText || 'Next')), copy && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "puzzleinstructionsmodal-copy--button",
    onClick: copyPasscode
  }, "Click to Copy")));
};

function _templateObject3$8() {
  var data = _taggedTemplateLiteral(["\n", "\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\nposition: ", ";\ntop: 0;\nbottom: 0;\nleft: 0;\nright: 0;\nz-index: 2;\nbackground: ", ";\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\nposition: absolute;\ndisplay: flex;\njustify-content: center;\nalign-items: flex-start;\nheight: 100%;\nwidth: 100%;\nfont-family: 'Gotham Book', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,\n  'Open Sans', 'Helvetica Neue', sans-serif;\n\n.PuzzleModal__passcode {\n  color: ", ";\n  padding: 1rem;\n  text-align: center;\n  font-family: monospace;\n  font-size: 1.2rem;\n\n  -webkit-user-select: all;\n  -moz-user-select: all;\n  -ms-user-select: all;\n  user-select: all;\n\n  &::-moz-selection {\n    background: ", ";\n  }\n\n  &::selection {\n    background: ", ";\n  }\n}\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}
var PuzzleModalContainer = Ye.div(_templateObject$j(), function (_ref) {
  var puzzleVariation = _ref.puzzleVariation;
  return puzzleVariation !== 'standalone' ? 'white' : 'black';
}, function (_ref2) {
  var theme = _ref2.theme,
      puzzleVariation = _ref2.puzzleVariation;
  return puzzleVariation !== 'standalone' ? COLORS_CONFIG.PUZZLE_BG_COLOR_LIGHT : theme.SKY_BLUE;
}, function (_ref3) {
  var theme = _ref3.theme,
      puzzleVariation = _ref3.puzzleVariation;
  return puzzleVariation !== 'standalone' ? COLORS_CONFIG.PUZZLE_BG_COLOR_LIGHT : theme.SKY_BLUE;
});
var PuzzleModalBackground = Ye.div(_templateObject2$b(), function (props) {
  return props.isEmbedded ? 'absolute' : 'fixed';
}, COLORS_CONFIG.PUZZLE_MODAL_BACKDROP);
var StyledPuzzleModal = Ye.div(_templateObject3$8(), function (_ref4) {
  var puzzleVariation = _ref4.puzzleVariation;
  return getPuzzleModalStyles(puzzleVariation);
});

function getPuzzleModalStyles(puzzleVariation) {
  switch (puzzleVariation) {
    case 'trainingGrounds':
      return _e(["position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:", ";background-clip:padding-box;border:1px solid;border-color:transparent;border-radius:18px;outline:0;box-shadow:0 0px 10px ", ";z-index:3;@media (min-width:30em){max-width:500px;margin:3rem auto;}header{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:justify;justify-content:space-between;padding:1rem 1rem;border-bottom:none;border-top-left-radius:17px;border-top-right-radius:17px;background:", ";color:#fff;font-size:1.25rem;font-weight:700;line-height:1.5;}section{color:#fff;position:relative;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem;}.dots{display:flex;justify-content:center;}.dot{width:8px;height:8px;background:", ";margin:16px 8px;border-radius:100%;display:inline-block;cursor:pointer;&.activeDot{background:", ";}}.PuzzleModal__button{text-transform:uppercase;color:", ";background:transparent;border:none;cursor:pointer;width:80px;text-align:center;}footer{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:space-between;align-items:center;padding:1rem;border-top:none;border-bottom-right-radius:18px;border-bottom-left-radius:18px;}"], COLORS_CONFIG.PUZZLE_BG_COLOR_DARK, COLORS_CONFIG.PUZZLE_OUTER_GLOW, COLORS_CONFIG.PUZZLE_BG_COLOR_LIGHT, COLORS_CONFIG.PUZZLE_BG_COLOR_INFO, COLORS_CONFIG.PUZZLE_BG_COLOR_LIGHT, COLORS_CONFIG.PUZZLE_BG_COLOR_LIGHT);

    case 'entranceExam':
      return _e(["position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:", ";background-clip:padding-box;border:1px solid;border-color:transparent;border-radius:18px;outline:0;box-shadow:0 0px 10px ", ";z-index:3;@media (min-width:30em){max-width:500px;margin:3rem auto;}header{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:justify;justify-content:space-between;padding:1rem 1rem;border-bottom:none;border-top-left-radius:17px;border-top-right-radius:17px;background:", ";color:#fff;font-size:1.25rem;font-weight:700;line-height:1.5;}section{color:#fff;position:relative;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem;}.dots{display:flex;justify-content:center;}.dot{width:8px;height:8px;background:", ";margin:16px 8px;border-radius:100%;display:inline-block;cursor:pointer;&.activeDot{background:", ";}}.PuzzleModal__button{text-transform:uppercase;color:", ";background:transparent;border:none;cursor:pointer;width:80px;text-align:center;}footer{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:space-between;align-items:center;padding:1rem;border-top:none;border-bottom-right-radius:18px;border-bottom-left-radius:18px;}"], COLORS_CONFIG.PUZZLE_BG_COLOR_DARK, COLORS_CONFIG.PUZZLE_OUTER_GLOW, COLORS_CONFIG.PUZZLE_BG_COLOR_LIGHT, COLORS_CONFIG.PUZZLE_BG_COLOR_INFO, COLORS_CONFIG.PUZZLE_BG_COLOR_LIGHT, COLORS_CONFIG.PUZZLE_BG_COLOR_LIGHT);

    default:
      return _e(["background:", ";min-width:30rem;max-width:35rem;padding:2rem;position:fixed;display:flex;flex-direction:column;align-items:center;overflow:hidden;z-index:2;font-size:1rem;line-height:1.5rem;@media (min-width:30em){min-width:500px;margin:3rem auto;}section{padding:0 1rem;margin:1rem 0;text-align:center;font-size:16px;line-height:22px;}footer{width:100%;display:flex;justify-content:center;.PuzzleModal__button{padding:10px 40px;background:", ";color:", ";border-color:transparent;border-radius:60px;display:inline-block;vertical-align:middle;font-size:14px;font-weight:900;cursor:pointer;outline:none !important;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;&:hover{opacity:0.9;}}}.PuzzleModal__progress_container{transform:translateY(-4.5rem);background:", ";width:5rem;height:5rem;border-radius:50%;display:flex;justify-content:center;align-items:center;font-size:0.75rem;font-weight:700;margin-bottom:-4rem;p{margin:2rem 0 0;}}"], function (_ref5) {
        var theme = _ref5.theme;
        return theme.WHITE;
      }, function (_ref6) {
        var theme = _ref6.theme;
        return theme.SKY_BLUE;
      }, function (_ref7) {
        var theme = _ref7.theme;
        return theme.WHITE;
      }, function (_ref8) {
        var theme = _ref8.theme;
        return theme.BG_GREY;
      });
  }
}

var CORRECT = 'CORRECT';
var INCORRECT = 'INCORRECT';
var CONCLUSION = 'CONCLUSION';
/* global alert */

var PuzzleModal = function PuzzleModal(_ref) {
  var title = _ref.title,
      text = _ref.text,
      demo = _ref.demo,
      buttonText = _ref.buttonText,
      step = _ref.step,
      updateStep = _ref.updateStep,
      increaseStep = _ref.increaseStep,
      decreaseStep = _ref.decreaseStep,
      handleClick = _ref.handleClick,
      useBackdrop = _ref.useBackdrop,
      gameState = _ref.gameState,
      togglePuzzleModal = _ref.togglePuzzleModal,
      context = _ref.context,
      puzzleVariation = _ref.puzzleVariation,
      passcode = _ref.passcode,
      isEmbedded = _ref.isEmbedded;

  var copyPasscode = function copyPasscode() {
    if (passcode) {
      var textArea = document.createElement('textarea');
      textArea.style.height = '0';
      textArea.value = passcode;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');

      try {
        document.execCommand('copy');
      } catch (err) {
        alert('Oops, unable to copy');
      }

      alert('Copied');
      document.body.removeChild(textArea);
    }
  };

  var renderButton = function renderButton() {
    if (gameState === CONCLUSION && passcode) {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        onClick: copyPasscode,
        className: "PuzzleModal__button"
      }, "Copy Passcode");
    } else if (buttonText) {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        onClick: gameState === INCORRECT ? handleClick : increaseStep,
        className: "PuzzleModal__button"
      }, buttonText);
    } else {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        onClick: gameState === CORRECT && step + 1 > context.length - 1 ? '' : increaseStep,
        className: "PuzzleModal__button"
      }, "NEXT");
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, useBackdrop && /*#__PURE__*/React__default['default'].createElement(PuzzleModalBackground, {
    isEmbedded: isEmbedded,
    onClick: togglePuzzleModal
  }), /*#__PURE__*/React__default['default'].createElement(PuzzleModalContainer, {
    puzzleVariation: puzzleVariation
  }, /*#__PURE__*/React__default['default'].createElement(StyledPuzzleModal, {
    puzzleVariation: puzzleVariation
  }, (!puzzleVariation === '' || puzzleVariation === 'standalone') && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "PuzzleModal__progress_container"
  }, /*#__PURE__*/React__default['default'].createElement("p", null, "".concat(step + 1, " of ").concat(context.length))), title && /*#__PURE__*/React__default['default'].createElement("header", null, title), text && /*#__PURE__*/React__default['default'].createElement("section", null, text), gameState === CONCLUSION && passcode && /*#__PURE__*/React__default['default'].createElement("p", {
    className: "PuzzleModal__passcode"
  }, passcode), demo && /*#__PURE__*/React__default['default'].createElement("img", {
    src: demo,
    alt: "puzzle gameplay demo"
  }), /*#__PURE__*/React__default['default'].createElement("footer", null, puzzleVariation !== '' && puzzleVariation !== 'standalone' && /*#__PURE__*/React__default['default'].createElement("div", {
    onClick: decreaseStep,
    className: "PuzzleModal__button"
  }, step > 0 && !(gameState === CORRECT) && 'Prev'), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "dots"
  }, context && context.length > 1 && context.map(function (slide, idx) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      onClick: function onClick() {
        return updateStep(idx);
      },
      key: idx,
      className: "".concat(step === idx ? 'activeDot' : '', " dot")
    });
  })), renderButton()))));
};

PuzzleModal.propTypes = {
  title: PropTypes__default['default'].string,
  text: PropTypes__default['default'].string,
  buttonText: PropTypes__default['default'].string,
  gameState: PropTypes__default['default'].string,
  puzzleVariation: PropTypes__default['default'].string,
  passcode: PropTypes__default['default'].string,
  step: PropTypes__default['default'].number,
  useBackdrop: PropTypes__default['default'].bool,
  context: PropTypes__default['default'].array,
  togglePuzzleModal: PropTypes__default['default'].func,
  updateStep: PropTypes__default['default'].func,
  increaseStep: PropTypes__default['default'].func,
  decreaseStep: PropTypes__default['default'].func,
  handleClick: PropTypes__default['default'].func,
  isEmbedded: PropTypes__default['default'].bool
};

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  height: 50px;\n  background-color: white;\n  padding: 0 1rem;\n\n  line-height: 50px;\n  font-size: 24px;\n\n  text-align: center;\n  color: ", ";\n\n  grid-column: 1 / 3;\n\n  h2 {\n    margin: 0;\n    font-weight: 700;\n  }\n\n  i {\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}
var StyledPuzzleNav = Ye.div(_templateObject$k(), COLORS_CONFIG.PUZZLE_BG_COLOR_DARK);

var PuzzleNav = function PuzzleNav(_ref) {
  var title = _ref.title,
      togglePuzzleModal = _ref.togglePuzzleModal;
  return /*#__PURE__*/React__default['default'].createElement(StyledPuzzleNav, null, /*#__PURE__*/React__default['default'].createElement("h2", null, title), togglePuzzleModal && /*#__PURE__*/React__default['default'].createElement("i", {
    onClick: togglePuzzleModal,
    className: "fal fa-info-circle"
  }));
};

PuzzleNav.propTypes = {
  title: PropTypes__default['default'].string.isRequired,
  togglePuzzleModal: PropTypes__default['default'].func
};

var PuzzleStates = {
  INTRO: 'INTRO',
  PLAYING: 'PLAYING',
  INCORRECT: 'INCORRECT',
  CONCLUSION: 'CONCLUSION',
  TIMEISUP: 'TIMEISUP',
  RESTART: 'RESTART'
}; // ReactDnd Item Types

var SINGLE_LIST_ITEM = 'SINGLE_LIST_ITEM';
var PuzzleProviders = {
  FIREBASE: 'FIREBASE',
  SOCKET_IO: 'SOCKET_IO',
  LOCAL: 'LOCAL'
};

var isLocal$2 = window.location.href.indexOf('localhost') > -1;
var isLeader = window.location.href.indexOf('6006') > -1;

var UPDATE_STATE = 'UPDATE_STATE';

function useSocketIOMouseState(socket, initialState) {
  var _useState = React$2.useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      response = _useState2[0],
      setResponse = _useState2[1];

  React$2.useEffect(function () {
    socket && socket.on('mouseUpdate', function (data) {
      setResponse(data);
    });
    return function () {
      return socket && socket.disconnect();
    };
  }, []);
  return response;
}
function useSocketIOPuzzleState(socket, initialState) {
  var _useState3 = React$2.useState(initialState),
      _useState4 = _slicedToArray(_useState3, 2),
      response = _useState4[0],
      setResponse = _useState4[1];

  React$2.useEffect(function () {
    socket && socket.on('stateUpdate', function (data) {
      setResponse(data);
    });
    return function () {
      return socket && socket.disconnect();
    };
  }, []);
  return response;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$1(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read$1(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread$1() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read$1(arguments[i]));
    return ar;
}

function __spreadArrays$1() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray: function (input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, webSafe) {
        this.init_();
        var charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.reject = function () { };
        this.resolve = function () { };
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    try {
        return (Object.prototype.toString.call(global.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser$1() {
    return typeof self === 'object' && self.self === self;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return  CONSTANTS.NODE_ADMIN === true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var FirebaseError = /** @class */ (function (_super) {
    __extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
        }
        return _this;
    }
    return FirebaseError;
}(Error));
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function (code) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for (var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++) {
            var key = _b[_a];
            if (key.slice(-1) !== '_') {
                if (key in error) {
                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
                }
                error[key] = customData[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}());
function replaceTemplate(template, data) {
    return template.replace(PATTERN, function (_, key) {
        var value = data[key];
        return value != null ? String(value) : "<" + key + "?>";
    });
}
var PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty$4(obj) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map$1(obj, fn, contextObj) {
    var res = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    var params = [];
    var _loop_1 = function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    };
    for (var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return params.length ? '&' + params.join('&') : '';
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function () {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (var i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, offset) {
        if (!offset) {
            offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}());

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop$2;
        }
        if (observer.error === undefined) {
            observer.error = noop$2;
        }
        if (observer.complete === undefined) {
            observer.complete = noop$2;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop$2() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argumentNumber The index of the argument
 * @param optional Whether or not the argument is optional
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
function validateCallback(fnName, argumentNumber, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
var Component = /** @class */ (function () {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    function Component(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */;
    }
    Component.prototype.setInstantiationMode = function (mode) {
        this.instantiationMode = mode;
        return this;
    };
    Component.prototype.setMultipleInstances = function (multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    };
    Component.prototype.setServiceProps = function (props) {
        this.serviceProps = props;
        return this;
    };
    return Component;
}());

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
var Provider = /** @class */ (function () {
    function Provider(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    Provider.prototype.get = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            var deferred = new Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            // If the service instance is available, resolve the promise with it immediately
            try {
                var instance = this.getOrInitializeService(normalizedIdentifier);
                if (instance) {
                    deferred.resolve(instance);
                }
            }
            catch (e) {
                // when the instance factory throws an exception during get(), it should not cause
                // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    };
    Provider.prototype.getImmediate = function (options) {
        var _a = __assign({ identifier: DEFAULT_ENTRY_NAME, optional: false }, options), identifier = _a.identifier, optional = _a.optional;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        try {
            var instance = this.getOrInitializeService(normalizedIdentifier);
            if (!instance) {
                if (optional) {
                    return null;
                }
                throw Error("Service " + this.name + " is not available");
            }
            return instance;
        }
        catch (e) {
            if (optional) {
                return null;
            }
            else {
                throw e;
            }
        }
    };
    Provider.prototype.getComponent = function () {
        return this.component;
    };
    Provider.prototype.setComponent = function (component) {
        var e_1, _a;
        if (component.name !== this.name) {
            throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
        }
        if (this.component) {
            throw Error("Component for " + this.name + " has already been provided");
        }
        this.component = component;
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService(DEFAULT_ENTRY_NAME);
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        try {
            // Create service instances for the pending promises and resolve them
            // NOTE: if this.multipleInstances is false, only the default instance will be created
            // and all promises with resolve with it regardless of the identifier.
            for (var _b = __values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read$1(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                try {
                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                    var instance = this.getOrInitializeService(normalizedIdentifier);
                    instanceDeferred.resolve(instance);
                }
                catch (e) {
                    // when the instance factory throws an exception, it should not cause
                    // a fatal error. We just leave the promise unresolved.
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Provider.prototype.clearInstance = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        this.instancesDeferred.delete(identifier);
        this.instances.delete(identifier);
    };
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    Provider.prototype.delete = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var services;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        services = Array.from(this.instances.values());
                        return [4 /*yield*/, Promise.all(__spread$1(services
                                .filter(function (service) { return 'INTERNAL' in service; }) // legacy services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) { return service.INTERNAL.delete(); }), services
                                .filter(function (service) { return '_delete' in service; }) // modularized services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) { return service._delete(); })))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Provider.prototype.isComponentSet = function () {
        return this.component != null;
    };
    Provider.prototype.getOrInitializeService = function (identifier) {
        var instance = this.instances.get(identifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, normalizeIdentifierForFactory(identifier));
            this.instances.set(identifier, instance);
        }
        return instance || null;
    };
    Provider.prototype.normalizeInstanceIdentifier = function (identifier) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    };
    return Provider;
}());
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
var ComponentContainer = /** @class */ (function () {
    function ComponentContainer(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    ComponentContainer.prototype.addComponent = function (component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error("Component " + component.name + " has already been registered with " + this.name);
        }
        provider.setComponent(component);
    };
    ComponentContainer.prototype.addOrOverwriteComponent = function (component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    };
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    ComponentContainer.prototype.getProvider = function (name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        var provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    };
    ComponentContainer.prototype.getProviders = function () {
        return Array.from(this.providers.values());
    };
    return ComponentContainer;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays$2() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
var levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
var ConsoleMethod = (_a = {},
    _a[LogLevel.DEBUG] = 'log',
    _a[LogLevel.VERBOSE] = 'log',
    _a[LogLevel.INFO] = 'info',
    _a[LogLevel.WARN] = 'warn',
    _a[LogLevel.ERROR] = 'error',
    _a);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel) {
        return;
    }
    var now = new Date().toISOString();
    var method = ConsoleMethod[logType];
    if (method) {
        console[method].apply(console, __spreadArrays$2(["[" + now + "]  " + instance.name + ":"], args));
    }
    else {
        throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError("Invalid value \"" + val + "\" assigned to `logLevel`");
            }
            this._logLevel = val;
        },
        enumerable: false,
        configurable: true
    });
    // Workaround for setter/getter having to be the same type.
    Logger.prototype.setLogLevel = function (val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    };
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "userLogHandler", {
        get: function () {
            return this._userLogHandler;
        },
        set: function (val) {
            this._userLogHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays$2([this, LogLevel.DEBUG], args));
        this._logHandler.apply(this, __spreadArrays$2([this, LogLevel.DEBUG], args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays$2([this, LogLevel.VERBOSE], args));
        this._logHandler.apply(this, __spreadArrays$2([this, LogLevel.VERBOSE], args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays$2([this, LogLevel.INFO], args));
        this._logHandler.apply(this, __spreadArrays$2([this, LogLevel.INFO], args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays$2([this, LogLevel.WARN], args));
        this._logHandler.apply(this, __spreadArrays$2([this, LogLevel.WARN], args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays$2([this, LogLevel.ERROR], args));
        this._logHandler.apply(this, __spreadArrays$2([this, LogLevel.ERROR], args));
    };
    return Logger;
}());
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    var _loop_1 = function (instance) {
        var customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = function (instance, level) {
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                var message = args
                    .map(function (arg) {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(function (arg) { return arg; })
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message: message,
                        args: args,
                        type: instance.name
                    });
                }
            };
        }
    };
    for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
        var instance = instances_1[_i];
        _loop_1(instance);
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$1;
var ERRORS = (_a$1 = {},
    _a$1["no-app" /* NO_APP */] = "No Firebase App '{$appName}' has been created - " +
        'call Firebase App.initializeApp()',
    _a$1["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$appName}",
    _a$1["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$appName}' already exists",
    _a$1["app-deleted" /* APP_DELETED */] = "Firebase App named '{$appName}' already deleted",
    _a$1["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    _a$1["invalid-log-argument" /* INVALID_LOG_ARGUMENT */] = 'First argument to `onLog` must be null or a function.',
    _a$1);
var ERROR_FACTORY = new ErrorFactory('app', 'Firebase', ERRORS);

var name$1 = "@firebase/app";
var version = "0.6.11";

var name$2 = "@firebase/analytics";

var name$3 = "@firebase/auth";

var name$4 = "@firebase/database";

var name$5 = "@firebase/functions";

var name$6 = "@firebase/installations";

var name$7 = "@firebase/messaging";

var name$8 = "@firebase/performance";

var name$9 = "@firebase/remote-config";

var name$a = "@firebase/storage";

var name$b = "@firebase/firestore";

var name$c = "firebase-wrapper";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$1$1;
var DEFAULT_ENTRY_NAME$1 = '[DEFAULT]';
var PLATFORM_LOG_STRING = (_a$1$1 = {},
    _a$1$1[name$1] = 'fire-core',
    _a$1$1[name$2] = 'fire-analytics',
    _a$1$1[name$3] = 'fire-auth',
    _a$1$1[name$4] = 'fire-rtdb',
    _a$1$1[name$5] = 'fire-fn',
    _a$1$1[name$6] = 'fire-iid',
    _a$1$1[name$7] = 'fire-fcm',
    _a$1$1[name$8] = 'fire-perf',
    _a$1$1[name$9] = 'fire-rc',
    _a$1$1[name$a] = 'fire-gcs',
    _a$1$1[name$b] = 'fire-fst',
    _a$1$1['fire-js'] = 'fire-js',
    _a$1$1[name$c] = 'fire-js-all',
    _a$1$1);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new Logger('@firebase/app');

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        var e_1, _a;
        var _this = this;
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ =
            config.automaticDataCollectionEnabled || false;
        this.options_ = deepCopy(options);
        this.container = new ComponentContainer(config.name);
        // add itself to container
        this._addComponent(new Component('app', function () { return _this; }, "PUBLIC" /* PUBLIC */));
        try {
            // populate ComponentContainer with existing components
            for (var _b = __values(this.firebase_.INTERNAL.components.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var component = _c.value;
                this._addComponent(component);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function (val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: false,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            return Promise.all(_this.container.getProviders().map(function (provider) { return provider.delete(); }));
        })
            .then(function () {
            _this.isDeleted_ = true;
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME$1; }
        this.checkDestroyed_();
        // getImmediate will always succeed because _getService is only called for registered components.
        return this.container.getProvider(name).getImmediate({
            identifier: instanceIdentifier
        });
    };
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get this service again.
     *
     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */
    FirebaseAppImpl.prototype._removeServiceInstance = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME$1; }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.container.getProvider(name).clearInstance(instanceIdentifier);
    };
    /**
     * @param component the component being added to this app's container
     */
    FirebaseAppImpl.prototype._addComponent = function (component) {
        try {
            this.container.addComponent(component);
        }
        catch (e) {
            logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
        }
    };
    FirebaseAppImpl.prototype._addOrOverwriteComponent = function (component) {
        this.container.addOrOverwriteComponent(component);
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');

var version$1 = "7.20.0";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var components = new Map();
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        registerVersion: registerVersion,
        setLogLevel: setLogLevel,
        onLog: onLog,
        // @ts-ignore
        apps: null,
        SDK_VERSION: version$1,
        INTERNAL: {
            registerComponent: registerComponent,
            removeApp: removeApp,
            components: components,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME$1;
        if (!contains(apps, name)) {
            throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
        }
        return apps[name];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME$1;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
                appName: String(name)
            });
        }
        if (contains(apps, name)) {
            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
        }
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name] = app;
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function (name) { return apps[name]; });
    }
    function registerComponent(component) {
        var e_1, _a;
        var componentName = component.name;
        if (components.has(componentName)) {
            logger.debug("There were multiple attempts to register component " + componentName + ".");
            return component.type === "PUBLIC" /* PUBLIC */
                ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    namespace[componentName]
                : null;
        }
        components.set(componentName, component);
        // create service namespace for public components
        if (component.type === "PUBLIC" /* PUBLIC */) {
            // The Service namespace is an accessor function ...
            var serviceNamespace = function (appArg) {
                if (appArg === void 0) { appArg = app(); }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentName] !== 'function') {
                    // Invalid argument.
                    // This happens in the following case: firebase.storage('gs:/')
                    throw ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */, {
                        appName: componentName
                    });
                }
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentName]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) {
                deepExtend(serviceNamespace, component.serviceProps);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentName] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentName] =
                // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
                // option added to the no-explicit-any rule when ESlint releases it.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var serviceFxn = this._getService.bind(this, componentName);
                    return serviceFxn.apply(this, component.multipleInstances ? args : []);
                };
        }
        try {
            // add the component to existing app instances
            for (var _b = __values(Object.keys(apps)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var appName = _c.value;
                apps[appName]._addComponent(component);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return component.type === "PUBLIC" /* PUBLIC */
            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                namespace[componentName]
            : null;
    }
    function registerVersion(libraryKeyOrName, version, variant) {
        var _a;
        // TODO: We can use this check to whitelist strings when/if we set up
        // a good whitelist system.
        var library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
        if (variant) {
            library += "-" + variant;
        }
        var libraryMismatch = library.match(/\s|\//);
        var versionMismatch = version.match(/\s|\//);
        if (libraryMismatch || versionMismatch) {
            var warning = [
                "Unable to register library \"" + library + "\" with version \"" + version + "\":"
            ];
            if (libraryMismatch) {
                warning.push("library name \"" + library + "\" contains illegal characters (whitespace or \"/\")");
            }
            if (libraryMismatch && versionMismatch) {
                warning.push('and');
            }
            if (versionMismatch) {
                warning.push("version name \"" + version + "\" contains illegal characters (whitespace or \"/\")");
            }
            logger.warn(warning.join(' '));
            return;
        }
        registerComponent(new Component(library + "-version", function () { return ({ library: library, version: version }); }, "VERSION" /* VERSION */));
    }
    function onLog(logCallback, options) {
        if (logCallback !== null && typeof logCallback !== 'function') {
            throw ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */, {
                appName: name
            });
        }
        setUserLogHandler(logCallback, options);
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        return useService;
    }
    return namespace;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
    namespace.INTERNAL = __assign(__assign({}, namespace.INTERNAL), { createFirebaseNamespace: createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: createSubscribe,
        ErrorFactory: ErrorFactory,
        deepExtend: deepExtend });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        deepExtend(namespace, props);
    }
    return namespace;
}
var firebase = createFirebaseNamespace();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PlatformLoggerService = /** @class */ (function () {
    function PlatformLoggerService(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    PlatformLoggerService.prototype.getPlatformInfoString = function () {
        var providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(function (provider) {
            if (isVersionServiceProvider(provider)) {
                var service = provider.getImmediate();
                return service.library + "/" + service.version;
            }
            else {
                return null;
            }
        })
            .filter(function (logString) { return logString; })
            .join(' ');
    };
    return PlatformLoggerService;
}());
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(firebase, variant) {
    firebase.INTERNAL.registerComponent(new Component('platform-logger', function (container) { return new PlatformLoggerService(container); }, "PRIVATE" /* PRIVATE */));
    // Register `app` package.
    firebase.registerVersion(name$1, version, variant);
    // Register platform SDK identifier (no version).
    firebase.registerVersion('fire-js', '');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Firebase Lite detection test
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (isBrowser$1() && self.firebase !== undefined) {
    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
    }
}
var initializeApp = firebase.initializeApp;
// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
// the no-explicit-any rule when ESlint releases it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
firebase.initializeApp = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if (isNode()) {
        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
    }
    return initializeApp.apply(undefined, args);
};
var firebase$1 = firebase;
registerCoreComponents(firebase$1);

var name$d = "firebase";
var version$2 = "7.24.0";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
firebase$1.registerVersion(name$d, version$2, 'app');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

var isObject$3 = function (val) {
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
};
var snapshotToData = function (snapshot, keyField) {
    if (!snapshot.exists) {
        return undefined;
    }
    var val = snapshot.val();
    if (isObject$3(val)) {
        return __assign$1({}, val, (keyField ? (_a = {}, _a[keyField] = snapshot.key, _a) : null));
    }
    return val;
    var _a;
};

var defaultState = function (defaultValue) {
    return {
        loading: defaultValue === undefined || defaultValue === null,
        value: defaultValue,
    };
};
var reducer$1 = function () { return function (state, action) {
    switch (action.type) {
        case 'error':
            return __assign$1({}, state, { error: action.error, loading: false, value: undefined });
        case 'reset':
            return defaultState(action.defaultValue);
        case 'value':
            return __assign$1({}, state, { error: undefined, loading: false, value: action.value });
        default:
            return state;
    }
}; };
var useLoadingValue = (function (getDefaultValue) {
    var defaultValue = getDefaultValue ? getDefaultValue() : undefined;
    var _a = React$2.useReducer(reducer$1(), defaultState(defaultValue)), state = _a[0], dispatch = _a[1];
    var reset = function () {
        var defaultValue = getDefaultValue ? getDefaultValue() : undefined;
        dispatch({ type: 'reset', defaultValue: defaultValue });
    };
    var setError = function (error) {
        dispatch({ type: 'error', error: error });
    };
    var setValue = function (value) {
        dispatch({ type: 'value', value: value });
    };
    return {
        error: state.error,
        loading: state.loading,
        reset: reset,
        setError: setError,
        setValue: setValue,
        value: state.value,
    };
});

var useComparatorRef = function (value, isEqual, onChange) {
    var ref = React$2.useRef(value);
    React$2.useEffect(function () {
        if (!isEqual(value, ref.current)) {
            ref.current = value;
            if (onChange) {
                onChange();
            }
        }
    });
    return ref;
};
var isEqual = function (v1, v2) {
    var bothNull = !v1 && !v2;
    var equal = !!v1 && !!v2 && v1.isEqual(v2);
    return bothNull || equal;
};
var useIsEqualRef = function (value, onChange) {
    return useComparatorRef(value, isEqual, onChange);
};

var useObject = function (query) {
    var _a = useLoadingValue(), error = _a.error, loading = _a.loading, reset = _a.reset, setError = _a.setError, setValue = _a.setValue, value = _a.value;
    var ref = useIsEqualRef(query, reset);
    React$2.useEffect(function () {
        var query = ref.current;
        if (!query) {
            setValue(undefined);
            return;
        }
        query.on('value', setValue, setError);
        return function () {
            query.off('value', setValue);
        };
    }, [ref.current]);
    return [value, loading, error];
};
var useObjectVal = function (query, options) {
    var _a = useObject(query), snapshot = _a[0], loading = _a[1], error = _a[2];
    var value = React$2.useMemo(function () {
        return snapshot
            ? snapshotToData(snapshot, options ? options.keyField : undefined)
            : undefined;
    }, [snapshot, options && options.keyField]);
    return [value, loading, error];
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */
var DOMStorageWrapper = /** @class */ (function () {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */
    function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */
    DOMStorageWrapper.prototype.set = function (key, value) {
        if (value == null) {
            this.domStorage_.removeItem(this.prefixedName_(key));
        }
        else {
            this.domStorage_.setItem(this.prefixedName_(key), stringify(value));
        }
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */
    DOMStorageWrapper.prototype.get = function (key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) {
            return null;
        }
        else {
            return jsonEval(storedVal);
        }
    };
    /**
     * @param {string} key
     */
    DOMStorageWrapper.prototype.remove = function (key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */
    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function () {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function (key, value) {
        if (value == null) {
            delete this.cache_[key];
        }
        else {
            this.cache_[key] = value;
        }
    };
    MemoryStorage.prototype.get = function (key) {
        if (contains(this.cache_, key)) {
            return this.cache_[key];
        }
        return null;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */
var createStoragefor = function (domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' &&
            typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new DOMStorageWrapper(domStorage);
        }
    }
    catch (e) { }
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new MemoryStorage();
};
/** A storage object that lasts across sessions */
var PersistentStorage = createStoragefor('localStorage');
/** A storage object that only lasts one session */
var SessionStorage = createStoragefor('sessionStorage');

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new Logger('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */
var LUIDGenerator = (function () {
    var id = 1;
    return function () {
        return id++;
    };
})();
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */
var sha1 = function (str) {
    var utf8Bytes = stringToByteArray$1(str);
    var sha1 = new Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} varArgs
 * @return {string}
 * @private
 */
var buildLogMessage_ = function () {
    var varArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        varArgs[_i] = arguments[_i];
    }
    var message = '';
    for (var i = 0; i < varArgs.length; i++) {
        var arg = varArgs[i];
        if (Array.isArray(arg) ||
            (arg &&
                typeof arg === 'object' &&
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                typeof arg.length === 'number')) {
            message += buildLogMessage_.apply(null, arg);
        }
        else if (typeof arg === 'object') {
            message += stringify(arg);
        }
        else {
            message += arg;
        }
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */
var logger$1 = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */
var firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */
var enableLogging = function (logger_, persistent) {
    assert(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        logClient.logLevel = LogLevel.VERBOSE;
        logger$1 = logClient.log.bind(logClient);
        if (persistent) {
            SessionStorage.set('logging_enabled', true);
        }
    }
    else if (typeof logger_ === 'function') {
        logger$1 = logger_;
    }
    else {
        logger$1 = null;
        SessionStorage.remove('logging_enabled');
    }
};
/**
 *
 * @param {...(string|Arguments)} varArgs
 */
var log = function () {
    var varArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        varArgs[_i] = arguments[_i];
    }
    if (firstLog_ === true) {
        firstLog_ = false;
        if (logger$1 === null && SessionStorage.get('logging_enabled') === true) {
            enableLogging(true);
        }
    }
    if (logger$1) {
        var message = buildLogMessage_.apply(null, varArgs);
        logger$1(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */
var logWrapper = function (prefix) {
    return function () {
        var varArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            varArgs[_i] = arguments[_i];
        }
        log.apply(void 0, __spread$1([prefix], varArgs));
    };
};
/**
 * @param {...string} varArgs
 */
var error = function () {
    var varArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        varArgs[_i] = arguments[_i];
    }
    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, __spread$1(varArgs));
    logClient.error(message);
};
/**
 * @param {...string} varArgs
 */
var fatal = function () {
    var varArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        varArgs[_i] = arguments[_i];
    }
    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, __spread$1(varArgs));
    logClient.error(message);
    throw new Error(message);
};
/**
 * @param {...*} varArgs
 */
var warn$1 = function () {
    var varArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        varArgs[_i] = arguments[_i];
    }
    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, __spread$1(varArgs));
    logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */
var warnIfPageIsSecure = function () {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' &&
        window.location &&
        window.location.protocol &&
        window.location.protocol.indexOf('https:') !== -1) {
        warn$1('Insecure Firebase access from a secure page. ' +
            'Please use https in calls to new Firebase().');
    }
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */
var isInvalidJSONNumber = function (data) {
    return (typeof data === 'number' &&
        (data !== data || // NaN
            data === Number.POSITIVE_INFINITY ||
            data === Number.NEGATIVE_INFINITY));
};
/**
 * @param {function()} fn
 */
var executeWhenDOMReady = function (fn) {
    if ( document.readyState === 'complete') {
        fn();
    }
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function () {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn_1, false);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent('onreadystatechange', function () {
                if (document.readyState === 'complete') {
                    wrappedFn_1();
                }
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent('onload', wrappedFn_1);
            // jQuery has an extra hack for IE that we could employ (based on
            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
            // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */
var MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */
var MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */
var nameCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === MIN_NAME || b === MAX_NAME) {
        return -1;
    }
    else if (b === MIN_NAME || a === MAX_NAME) {
        return 1;
    }
    else {
        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) {
                return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            }
            else {
                return -1;
            }
        }
        else if (bAsInt !== null) {
            return 1;
        }
        else {
            return a < b ? -1 : 1;
        }
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */
var stringCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a < b) {
        return -1;
    }
    else {
        return 1;
    }
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */
var requireKey = function (key, obj) {
    if (obj && key in obj) {
        return obj[key];
    }
    else {
        throw new Error('Missing required key (' + key + ') in object: ' + stringify(obj));
    }
};
/**
 * @param {*} obj
 * @return {string}
 */
var ObjectToUniqueKey = function (obj) {
    if (typeof obj !== 'object' || obj === null) {
        return stringify(obj);
    }
    var keys = [];
    // eslint-disable-next-line guard-for-in
    for (var k in obj) {
        keys.push(k);
    }
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = '{';
    for (var i = 0; i < keys.length; i++) {
        if (i !== 0) {
            key += ',';
        }
        key += stringify(keys[i]);
        key += ':';
        key += ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */
var splitStringBySize = function (str, segsize) {
    var len = str.length;
    if (len <= segsize) {
        return [str];
    }
    var dataSegs = [];
    for (var c = 0; c < len; c += segsize) {
        if (c + segsize > len) {
            dataSegs.push(str.substring(c, len));
        }
        else {
            dataSegs.push(str.substring(c, c + segsize));
        }
    }
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj The object or array to iterate over
 * @param fn The function to apply
 */
function each(obj, fn) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            fn(key, obj[key]);
        }
    }
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */
var doubleToIEEE754String = function (v) {
    assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << (ebits - 1)) - 1;
    var s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    }
    else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        }
        else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    var bits = [];
    for (i = fbits; i; i -= 1) {
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for (i = ebits; i; i -= 1) {
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    var str = bits.join('');
    // Return the data as a hex string. --MJL
    var hexByteString = '';
    for (i = 0; i < 64; i += 8) {
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) {
            hexByte = '0' + hexByte;
        }
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */
var isChromeExtensionContentScript = function () {
    return !!(typeof window === 'object' &&
        window['chrome'] &&
        window['chrome']['extension'] &&
        !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */
var isWindowsStoreApp = function () {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */
var errorForServerCode = function (code, query) {
    var reason = 'Unknown Error';
    if (code === 'too_big') {
        reason =
            'The data requested exceeds the maximum size ' +
                'that can be accessed with a single request.';
    }
    else if (code === 'permission_denied') {
        reason = "Client doesn't have permission to access the desired data.";
    }
    else if (code === 'unavailable') {
        reason = 'The service is unavailable';
    }
    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */
var INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */
var tryParseInt = function (str) {
    if (INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) {
            return intVal;
        }
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */
var exceptionGuard = function (fn) {
    try {
        fn();
    }
    catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function () {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || '';
            warn$1('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */
var beingCrawled = function () {
    var userAgent = (typeof window === 'object' &&
        window['navigator'] &&
        window['navigator']['userAgent']) ||
        '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */
var setTimeoutNonBlocking = function (fn, time) {
    var timeout = setTimeout(fn, time);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof timeout === 'object' && timeout['unref']) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        timeout['unref']();
    }
    return timeout;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */
var Path = /** @class */ (function () {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */
    function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            var copyTo = 0;
            for (var i = 0; i < this.pieces_.length; i++) {
                if (this.pieces_[i].length > 0) {
                    this.pieces_[copyTo] = this.pieces_[i];
                    copyTo++;
                }
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        }
        else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */
        get: function () {
            return new Path('');
        },
        enumerable: false,
        configurable: true
    });
    Path.prototype.getFront = function () {
        if (this.pieceNum_ >= this.pieces_.length) {
            return null;
        }
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */
    Path.prototype.getLength = function () {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */
    Path.prototype.popFront = function () {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) {
            pieceNum++;
        }
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */
    Path.prototype.getBack = function () {
        if (this.pieceNum_ < this.pieces_.length) {
            return this.pieces_[this.pieces_.length - 1];
        }
        return null;
    };
    Path.prototype.toString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '') {
                pathString += '/' + this.pieces_[i];
            }
        }
        return pathString || '/';
    };
    Path.prototype.toUrlEncodedString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '') {
                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
            }
        }
        return pathString || '/';
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */
    Path.prototype.slice = function (begin) {
        if (begin === void 0) { begin = 0; }
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */
    Path.prototype.parent = function () {
        if (this.pieceNum_ >= this.pieces_.length) {
            return null;
        }
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++) {
            pieces.push(this.pieces_[i]);
        }
        return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */
    Path.prototype.child = function (childPathObj) {
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            pieces.push(this.pieces_[i]);
        }
        if (childPathObj instanceof Path) {
            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
                pieces.push(childPathObj.pieces_[i]);
            }
        }
        else {
            var childPieces = childPathObj.split('/');
            for (var i = 0; i < childPieces.length; i++) {
                if (childPieces[i].length > 0) {
                    pieces.push(childPieces[i]);
                }
            }
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */
    Path.prototype.isEmpty = function () {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */
    Path.relativePath = function (outerPath, innerPath) {
        var outer = outerPath.getFront(), inner = innerPath.getFront();
        if (outer === null) {
            return innerPath;
        }
        else if (outer === inner) {
            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        }
        else {
            throw new Error('INTERNAL ERROR: innerPath (' +
                innerPath +
                ') is not within ' +
                'outerPath (' +
                outerPath +
                ')');
        }
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */
    Path.comparePaths = function (left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
            if (cmp !== 0) {
                return cmp;
            }
        }
        if (leftKeys.length === rightKeys.length) {
            return 0;
        }
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */
    Path.prototype.equals = function (other) {
        if (this.getLength() !== other.getLength()) {
            return false;
        }
        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */
    Path.prototype.contains = function (other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) {
            return false;
        }
        while (i < this.pieces_.length) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}()); // end Path
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */
var ValidationPath = /** @class */ (function () {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */
    function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */
        this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */
        this.byteLength_ = Math.max(1, this.parts_.length);
        for (var i = 0; i < this.parts_.length; i++) {
            this.byteLength_ += stringLength(this.parts_[i]);
        }
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */
        get: function () {
            return 32;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
        get: function () {
            return 768;
        },
        enumerable: false,
        configurable: true
    });
    /** @param {string} child */
    ValidationPath.prototype.push = function (child) {
        // Count the needed '/'
        if (this.parts_.length > 0) {
            this.byteLength_ += 1;
        }
        this.parts_.push(child);
        this.byteLength_ += stringLength(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function () {
        var last = this.parts_.pop();
        this.byteLength_ -= stringLength(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) {
            this.byteLength_ -= 1;
        }
    };
    ValidationPath.prototype.checkValid_ = function () {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
            throw new Error(this.errorPrefix_ +
                'has a key path longer than ' +
                ValidationPath.MAX_PATH_LENGTH_BYTES +
                ' bytes (' +
                this.byteLength_ +
                ').');
        }
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
            throw new Error(this.errorPrefix_ +
                'path specified exceeds the maximum depth that can be written (' +
                ValidationPath.MAX_PATH_DEPTH +
                ') or object contains a cycle ' +
                this.toErrorString());
        }
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */
    ValidationPath.prototype.toErrorString = function () {
        if (this.parts_.length === 0) {
            return '';
        }
        return "in property '" + this.parts_.join('.') + "'";
    };
    return ValidationPath;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PROTOCOL_VERSION = '5';
var VERSION_PARAM = 'v';
var TRANSPORT_SESSION_PARAM = 's';
var REFERER_PARAM = 'r';
var FORGE_REF = 'f';
var FORGE_DOMAIN = 'firebaseio.com';
var LAST_SESSION_PARAM = 'ls';
var APPLICATION_ID_PARAM = 'p';
var WEBSOCKET = 'websocket';
var LONG_POLLING = 'long_polling';

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */
var RepoInfo = /** @class */ (function () {
    /**
     * @param host Hostname portion of the url for the repo
     * @param secure Whether or not this repo is accessed over ssl
     * @param namespace The namespace represented by the repo
     * @param webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin Whether this instance uses Admin SDK credentials
     * @param persistenceKey Override the default session persistence storage key
     */
    function RepoInfo(host, secure, namespace, webSocketOnly, nodeAdmin, persistenceKey, includeNamespaceInQueryParams) {
        if (nodeAdmin === void 0) { nodeAdmin = false; }
        if (persistenceKey === void 0) { persistenceKey = ''; }
        if (includeNamespaceInQueryParams === void 0) { includeNamespaceInQueryParams = false; }
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf('.') + 1);
        this.internalHost =
            PersistentStorage.get('host:' + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function () {
        return (this.host !== this.internalHost ||
            this.isCustomHost() ||
            this.includeNamespaceInQueryParams);
    };
    RepoInfo.prototype.isCacheableHost = function () {
        return this.internalHost.substr(0, 2) === 's-';
    };
    RepoInfo.prototype.isDemoHost = function () {
        return this.domain === 'firebaseio-demo.com';
    };
    RepoInfo.prototype.isCustomHost = function () {
        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
    };
    RepoInfo.prototype.updateHost = function (newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) {
                PersistentStorage.set('host:' + this.host, this.internalHost);
            }
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */
    RepoInfo.prototype.connectionURL = function (type, params) {
        assert(typeof type === 'string', 'typeof type must == string');
        assert(typeof params === 'object', 'typeof params must == object');
        var connURL;
        if (type === WEBSOCKET) {
            connURL =
                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
        }
        else if (type === LONG_POLLING) {
            connURL =
                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
        }
        else {
            throw new Error('Unknown connection type: ' + type);
        }
        if (this.needsQueryParam()) {
            params['ns'] = this.namespace;
        }
        var pairs = [];
        each(params, function (key, value) {
            pairs.push(key + '=' + value);
        });
        return connURL + pairs.join('&');
    };
    /** @return {string} */
    RepoInfo.prototype.toString = function () {
        var str = this.toURLString();
        if (this.persistenceKey) {
            str += '<' + this.persistenceKey + '>';
        }
        return str;
    };
    /** @return {string} */
    RepoInfo.prototype.toURLString = function () {
        return (this.secure ? 'https://' : 'http://') + this.host;
    };
    return RepoInfo;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!string} pathString
 * @return {string}
 */
function decodePath(pathString) {
    var pathStringDecoded = '';
    var pieces = pathString.split('/');
    for (var i = 0; i < pieces.length; i++) {
        if (pieces[i].length > 0) {
            var piece = pieces[i];
            try {
                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
            }
            catch (e) { }
            pathStringDecoded += '/' + piece;
        }
    }
    return pathStringDecoded;
}
/**
 * @param {!string} queryString
 * @return {!{[key:string]:string}} key value hash
 */
function decodeQuery(queryString) {
    var e_1, _a;
    var results = {};
    if (queryString.charAt(0) === '?') {
        queryString = queryString.substring(1);
    }
    try {
        for (var _b = __values(queryString.split('&')), _c = _b.next(); !_c.done; _c = _b.next()) {
            var segment = _c.value;
            if (segment.length === 0) {
                continue;
            }
            var kv = segment.split('=');
            if (kv.length === 2) {
                results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
            }
            else {
                warn$1("Invalid query segment '" + segment + "' in query '" + queryString + "'");
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return results;
}
var parseRepoInfo = function (dataURL, nodeAdmin) {
    var parsedUrl = parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === 'firebase.com') {
        fatal(parsedUrl.host +
            ' is no longer supported. ' +
            'Please use <YOUR FIREBASE>.firebaseio.com instead');
    }
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === 'undefined') &&
        parsedUrl.domain !== 'localhost') {
        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    }
    if (!parsedUrl.secure) {
        warnIfPageIsSecure();
    }
    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, nodeAdmin, webSocketOnly, 
        /*persistenceKey=*/ '', 
        /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string, namespace: string}}
 */
var parseDatabaseURL = function (dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = '', domain = '', subdomain = '', pathString = '', namespace = '';
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        var colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf('/');
        if (slashInd === -1) {
            slashInd = dataURL.length;
        }
        var questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) {
            questionMarkInd = dataURL.length;
        }
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) {
            // For pathString, questionMarkInd will always come after slashInd
            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
        }
        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        }
        else {
            colonInd = host.length;
        }
        var hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === 'localhost') {
            domain = 'localhost';
        }
        else if (hostWithoutPort.split('.').length <= 2) {
            domain = hostWithoutPort;
        }
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            var dotInd = host.indexOf('.');
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ('ns' in queryParams) {
            namespace = queryParams['ns'];
        }
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */
var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */
var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */
var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
/**
 * @param {*} key
 * @return {boolean}
 */
var isValidKey = function (key) {
    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidPathString = function (pathString) {
    return (typeof pathString === 'string' &&
        pathString.length !== 0 &&
        !INVALID_PATH_REGEX_.test(pathString));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidRootPathString = function (pathString) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    return isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */
var isValidPriority = function (priority) {
    return (priority === null ||
        typeof priority === 'string' ||
        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
        (priority &&
            typeof priority === 'object' &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            contains(priority, '.sv')));
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined) {
        return;
    }
    validateFirebaseData(errorPrefix(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */
var validateFirebaseData = function (errorPrefix, data, path_) {
    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) {
        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
    }
    if (typeof data === 'function') {
        throw new Error(errorPrefix +
            'contains a function ' +
            path.toErrorString() +
            ' with contents = ' +
            data.toString());
    }
    if (isInvalidJSONNumber(data)) {
        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
    }
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' &&
        data.length > MAX_LEAF_SIZE_ / 3 &&
        stringLength(data) > MAX_LEAF_SIZE_) {
        throw new Error(errorPrefix +
            'contains a string greater than ' +
            MAX_LEAF_SIZE_ +
            ' utf8 bytes ' +
            path.toErrorString() +
            " ('" +
            data.substring(0, 50) +
            "...')");
    }
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        var hasDotValue_1 = false;
        var hasActualChild_1 = false;
        each(data, function (key, value) {
            if (key === '.value') {
                hasDotValue_1 = true;
            }
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild_1 = true;
                if (!isValidKey(key)) {
                    throw new Error(errorPrefix +
                        ' contains an invalid key (' +
                        key +
                        ') ' +
                        path.toErrorString() +
                        '.  Keys must be non-empty strings ' +
                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
                }
            }
            path.push(key);
            validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) {
            throw new Error(errorPrefix +
                ' contains ".value" child ' +
                path.toErrorString() +
                ' in addition to actual children.');
        }
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */
var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
    var i, curPath;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for (var j = 0; j < keys.length; j++) {
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!isValidKey(keys[j])) {
                throw new Error(errorPrefix +
                    'contains an invalid key (' +
                    keys[j] +
                    ') in path ' +
                    curPath.toString() +
                    '. Keys must be non-empty strings ' +
                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort(Path.comparePaths);
    var prevPath = null;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) {
            throw new Error(errorPrefix +
                'contains a path ' +
                prevPath.toString() +
                ' that is ancestor of another path ' +
                curPath.toString());
        }
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined) {
        return;
    }
    var errorPrefix$1 = errorPrefix(fnName, argumentNumber, optional);
    if (!(data && typeof data === 'object') || Array.isArray(data)) {
        throw new Error(errorPrefix$1 + ' must be an object containing the children to replace.');
    }
    var mergePaths = [];
    each(data, function (key, value) {
        var curPath = new Path(key);
        validateFirebaseData(errorPrefix$1, value, path.child(curPath));
        if (curPath.getBack() === '.priority') {
            if (!isValidPriority(value)) {
                throw new Error(errorPrefix$1 +
                    "contains an invalid value for '" +
                    curPath.toString() +
                    "', which must be a valid " +
                    'Firebase priority (a string, finite number, server value, or null).');
            }
        }
        mergePaths.push(curPath);
    });
    validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
var validatePriority = function (fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined) {
        return;
    }
    if (isInvalidJSONNumber(priority)) {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'is ' +
            priority.toString() +
            ', but must be a valid Firebase priority (a string, finite number, ' +
            'server value, or null).');
    }
    // Special case to allow importing data with a .sv.
    if (!isValidPriority(priority)) {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid Firebase priority ' +
            '(a string, finite number, server value, or null).');
    }
};
var validateEventType = function (fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined) {
        return;
    }
    switch (eventType) {
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error(errorPrefix(fnName, argumentNumber, optional) +
                'must be a valid event type = "value", "child_added", "child_removed", ' +
                '"child_changed", or "child_moved".');
    }
};
var validateKey = function (fnName, argumentNumber, key, optional) {
    if (optional && key === undefined) {
        return;
    }
    if (!isValidKey(key)) {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid key = "' +
            key +
            '".  Firebase keys must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "/", "[", or "]").');
    }
};
var validatePathString = function (fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined) {
        return;
    }
    if (!isValidPathString(pathString)) {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid path = "' +
            pathString +
            '". Paths must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "[", or "]"');
    }
};
var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    validatePathString(fnName, argumentNumber, pathString, optional);
};
var validateWritablePath = function (fnName, path) {
    if (path.getFront() === '.info') {
        throw new Error(fnName + " failed = Can't modify data under /.info/");
    }
};
var validateUrl = function (fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
        parsedUrl.repoInfo.host.length === 0 ||
        (!isValidKey(parsedUrl.repoInfo.namespace) &&
            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
        throw new Error(errorPrefix(fnName, argumentNumber, false) +
            'must be a valid firebase URL and ' +
            'the path can\'t contain ".", "#", "$", "[", or "]".');
    }
};
var validateBoolean = function (fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined) {
        return;
    }
    if (typeof bool !== 'boolean') {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
    }
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var OnDisconnect = /** @class */ (function () {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */
    function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.cancel = function (onComplete) {
        validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
        validateCallback('OnDisconnect.cancel', 1, onComplete, true);
        var deferred = new Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.remove = function (onComplete) {
        validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
        validateWritablePath('OnDisconnect.remove', this.path_);
        validateCallback('OnDisconnect.remove', 1, onComplete, true);
        var deferred = new Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.set = function (value, onComplete) {
        validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.set', this.path_);
        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
        validateCallback('OnDisconnect.set', 2, onComplete, true);
        var deferred = new Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
        validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
        validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
        var deferred = new Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
        validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.update', this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn$1('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
        }
        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
        validateCallback('OnDisconnect.update', 2, onComplete, true);
        var deferred = new Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TransactionResult = /** @class */ (function () {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */
    function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function () {
        validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
    };
    return TransactionResult;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */
var nextPushId = (function () {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function (now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for (i = 7; i >= 0; i--) {
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        assert(now === 0, 'Cannot push at time == 0');
        var id = timeStampChars.join('');
        if (!duplicateTime) {
            for (i = 0; i < 12; i++) {
                lastRandChars[i] = Math.floor(Math.random() * 64);
            }
        }
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                lastRandChars[i] = 0;
            }
            lastRandChars[i]++;
        }
        for (i = 0; i < 12; i++) {
            id += PUSH_CHARS.charAt(lastRandChars[i]);
        }
        assert(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
})();

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */
var NamedNode = /** @class */ (function () {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    /**
     *
     * @param {!string} name
     * @param {!Node} node
     * @return {NamedNode}
     */
    NamedNode.Wrap = function (name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @constructor
 */
var Index = /** @class */ (function () {
    function Index() {
    }
    /**
     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
     * this index
     */
    Index.prototype.getCompare = function () {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     * @param {!Node} oldNode
     * @param {!Node} newNode
     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
     */
    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
        var newWrapped = new NamedNode(MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @return {!NamedNode} a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */
    Index.prototype.minPost = function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return NamedNode.MIN;
    };
    return Index;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __EMPTY_NODE;
var KeyIndex = /** @class */ (function (_super) {
    __extends(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function () {
            return __EMPTY_NODE;
        },
        set: function (val) {
            __EMPTY_NODE = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.compare = function (a, b) {
        return nameCompare(a.name, b.name);
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.isDefinedOn = function (node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw assertionError('KeyIndex.isDefinedOn not expected to be called.');
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.minPost = function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.maxPost = function () {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new NamedNode(MAX_NAME, __EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    KeyIndex.prototype.makePost = function (indexValue, name) {
        assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new NamedNode(indexValue, __EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    KeyIndex.prototype.toString = function () {
        return '.key';
    };
    return KeyIndex;
}(Index));
var KEY_INDEX = new KeyIndex();

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_NODE;
function setMaxNode(val) {
    MAX_NODE = val;
}
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */
var priorityHashText = function (priority) {
    if (typeof priority === 'number') {
        return 'number:' + doubleToIEEE754String(priority);
    }
    else {
        return 'string:' + priority;
    }
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */
var validatePriorityNode = function (priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        assert(typeof val === 'string' ||
            typeof val === 'number' ||
            (typeof val === 'object' && contains(val, '.sv')), 'Priority must be a string or number.');
    }
    else {
        assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
    }
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */
var LeafNode = /** @class */ (function () {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */
    function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function () {
            return __childrenNodeConstructor;
        },
        set: function (val) {
            __childrenNodeConstructor = val;
        },
        enumerable: false,
        configurable: true
    });
    /** @inheritDoc */
    LeafNode.prototype.isLeafNode = function () {
        return true;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPriority = function () {
        return this.priorityNode_;
    };
    /** @inheritDoc */
    LeafNode.prototype.updatePriority = function (newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */
    LeafNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.getChild = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else if (path.getFront() === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.hasChild = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
        return null;
    };
    /** @inheritDoc */
    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else if (newChildNode.isEmpty() && childName !== '.priority') {
            return this;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else if (newChildNode.isEmpty() && front !== '.priority') {
            return this;
        }
        else {
            assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.isEmpty = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.numChildren = function () {
        return 0;
    };
    /** @inheritDoc */
    LeafNode.prototype.forEachChild = function (index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.val = function (exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) {
            return {
                '.value': this.getValue(),
                '.priority': this.getPriority().val()
            };
        }
        else {
            return this.getValue();
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash = '';
            if (!this.priorityNode_.isEmpty()) {
                toHash +=
                    'priority:' +
                        priorityHashText(this.priorityNode_.val()) +
                        ':';
            }
            var type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') {
                toHash += doubleToIEEE754String(this.value_);
            }
            else {
                toHash += this.value_;
            }
            this.lazyHash_ = sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */
    LeafNode.prototype.getValue = function () {
        return this.value_;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.compareTo = function (other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
            return 1;
        }
        else if (other instanceof LeafNode.__childrenNodeConstructor) {
            return -1;
        }
        else {
            assert(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */
    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') {
                // Deferred value nodes are all equal, but we should also never get to this point...
                return 0;
            }
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) {
                    return -1;
                }
                else if (this.value_ === otherLeaf.value_) {
                    return 0;
                }
                else {
                    return 1;
                }
            }
        }
        else {
            return thisIndex - otherIndex;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.withIndex = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.isIndexed = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.equals = function (other) {
        /**
         * @inheritDoc
         */
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return (this.value_ === otherLeaf.value_ &&
                this.priorityNode_.equals(otherLeaf.priorityNode_));
        }
        else {
            return false;
        }
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */
    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
    return LeafNode;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var nodeFromJSON;
var MAX_NODE$1;
function setNodeFromJSON(val) {
    nodeFromJSON = val;
}
function setMaxNode$1(val) {
    MAX_NODE$1 = val;
}
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var PriorityIndex = /** @class */ (function (_super) {
    __extends(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.compare = function (a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.isDefinedOn = function (node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.minPost = function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.maxPost = function () {
        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    PriorityIndex.prototype.makePost = function (indexValue, name) {
        var priorityNode = nodeFromJSON(indexValue);
        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    PriorityIndex.prototype.toString = function () {
        return '.priority';
    };
    return PriorityIndex;
}(Index));
var PRIORITY_INDEX = new PriorityIndex();

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An iterator over an LLRBNode.
 */
var SortedMapIterator = /** @class */ (function () {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */
    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */
        this.nodeStack_ = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            node = node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) {
                cmp *= -1;
            }
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        if (this.nodeStack_.length === 0) {
            return null;
        }
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_) {
            result = this.resultGenerator_(node.key, node.value);
        }
        else {
            result = { key: node.key, value: node.value };
        }
        if (this.isReverse_) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack_.length === 0) {
            return null;
        }
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) {
            return this.resultGenerator_(node.key, node.value);
        }
        else {
            return { key: node.key, value: node.value };
        }
    };
    return SortedMapIterator;
}());
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */
var LLRBNode = /** @class */ (function () {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left =
            left != null ? left : SortedMap.EMPTY_NODE;
        this.right =
            right != null ? right : SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBNode.prototype.count = function () {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            !!action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */
    LLRBNode.prototype.min_ = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min_();
        }
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.minKey = function () {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var n = this;
        var cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */
    LLRBNode.prototype.removeMin_ = function () {
        if (this.left.isEmpty()) {
            return SortedMap.EMPTY_NODE;
        }
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) {
            n = n.moveRedLeft_();
        }
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */
    LLRBNode.prototype.remove = function (key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
                n = n.moveRedLeft_();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed_()) {
                n = n.rotateRight_();
            }
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
                n = n.moveRedRight_();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return SortedMap.EMPTY_NODE;
                }
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */
    LLRBNode.prototype.isRed_ = function () {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */
    LLRBNode.prototype.fixUp_ = function () {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_()) {
            n = n.rotateLeft_();
        }
        if (n.left.isRed_() && n.left.left.isRed_()) {
            n = n.rotateRight_();
        }
        if (n.left.isRed_() && n.right.isRed_()) {
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */
    LLRBNode.prototype.moveRedLeft_ = function () {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */
    LLRBNode.prototype.moveRedRight_ = function () {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */
    LLRBNode.prototype.rotateLeft_ = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */
    LLRBNode.prototype.rotateRight_ = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */
    LLRBNode.prototype.colorFlip_ = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */
    LLRBNode.prototype.checkMaxDepth_ = function () {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBNode.prototype.check_ = function () {
        if (this.isRed_() && this.left.isRed_()) {
            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed_()) {
            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        var blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) {
            throw new Error('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed_() ? 0 : 1);
        }
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}());
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
    }
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBEmptyNode.prototype.count = function () {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBEmptyNode.prototype.check_ = function () {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */
    LLRBEmptyNode.prototype.isRed_ = function () {
        return false;
    };
    return LLRBEmptyNode;
}());
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */
var SortedMap = /** @class */ (function () {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */
    function SortedMap(comparator_, root_) {
        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator_, this.root_
            .insert(key, value, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator_, this.root_
            .remove(key, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */
    SortedMap.prototype.get = function (key) {
        var cmp;
        var node = this.root_;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */
    SortedMap.prototype.getPredecessorKey = function (key) {
        var cmp, node = this.root_, rightParent = null;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while (!node.right.isEmpty()) {
                        node = node.right;
                    }
                    return node.key;
                }
                else if (rightParent) {
                    return rightParent.key;
                }
                else {
                    return null; // first item.
                }
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    };
    /**
     * @return {boolean} True if the map is empty.
     */
    SortedMap.prototype.isEmpty = function () {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */
    SortedMap.prototype.count = function () {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */
    SortedMap.prototype.minKey = function () {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */
    SortedMap.prototype.maxKey = function () {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */
    SortedMap.prototype.getIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */
    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
    return SortedMap;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_2 = Math.log(2);
/**
 * @constructor
 */
var Base12Num = /** @class */ (function () {
    /**
     * @param {number} length
     */
    function Base12Num(length) {
        var logBase2 = function (num) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return parseInt((Math.log(num) / LOG_2), 10);
        };
        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = (length + 1) & mask;
    }
    /**
     * @return {boolean}
     */
    Base12Num.prototype.nextBitIsOne = function () {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & (0x1 << this.current_));
        this.current_--;
        return result;
    };
    return Base12Num;
}());
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */
var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function (low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length === 0) {
            return null;
        }
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var middle = parseInt((length / 2), 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function (base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function (chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function (pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            }
            else {
                root = pennant;
                node = pennant;
            }
        };
        for (var i = 0; i < base12.count; ++i) {
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) {
                buildPennant(chunkSize, LLRBNode.BLACK);
            }
            else {
                // current == 2
                buildPennant(chunkSize, LLRBNode.BLACK);
                buildPennant(chunkSize, LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new SortedMap(mapSortFn || cmp, root);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _defaultIndexMap;
var fallbackObject = {};
var IndexMap = /** @class */ (function () {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         */
        get: function () {
            assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
            _defaultIndexMap =
                _defaultIndexMap ||
                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
            return _defaultIndexMap;
        },
        enumerable: false,
        configurable: true
    });
    IndexMap.prototype.get = function (indexKey) {
        var sortedMap = safeGet(this.indexes_, indexKey);
        if (!sortedMap) {
            throw new Error('No index defined for ' + indexKey);
        }
        if (sortedMap instanceof SortedMap) {
            return sortedMap;
        }
        else {
            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
            // regular child map
            return null;
        }
    };
    IndexMap.prototype.hasIndex = function (indexDefinition) {
        return contains(this.indexSet_, indexDefinition.toString());
    };
    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
        assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator(NamedNode.Wrap);
        var next = iter.getNext();
        while (next) {
            sawIndexedValue =
                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) {
            newIndex = buildChildSet(childList, indexDefinition.getCompare());
        }
        else {
            newIndex = fallbackObject;
        }
        var indexName = indexDefinition.toString();
        var newIndexSet = __assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = __assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */
    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
        var _this = this;
        var newIndexes = map$1(this.indexes_, function (indexedChildren, indexName) {
            var index = safeGet(_this.indexSet_, indexName);
            assert(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator(NamedNode.Wrap);
                    var next = iter.getNext();
                    while (next) {
                        if (next.name !== namedNode.name) {
                            childList.push(next);
                        }
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return buildChildSet(childList, index.getCompare());
                }
                else {
                    // No change, this remains a fallback
                    return fallbackObject;
                }
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) {
                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     */
    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
        var newIndexes = map$1(this.indexes_, function (indexedChildren) {
            if (indexedChildren === fallbackObject) {
                // This is the fallback. Just return it, nothing to do in this case
                return indexedChildren;
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) {
                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                else {
                    // No record of this child
                    return indexedChildren;
                }
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function NAME_ONLY_COMPARATOR(left, right) {
    return nameCompare(left.name, right.name);
}
function NAME_COMPARATOR(left, right) {
    return nameCompare(left, right);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: For memory savings, don't store priorityNode_ if it's empty.
var EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */
var ChildrenNode = /** @class */ (function () {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */
    function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */
        if (this.priorityNode_) {
            validatePriorityNode(this.priorityNode_);
        }
        if (this.children_.isEmpty()) {
            assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
        }
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function () {
            return (EMPTY_NODE ||
                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
        },
        enumerable: false,
        configurable: true
    });
    /** @inheritDoc */
    ChildrenNode.prototype.isLeafNode = function () {
        return false;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPriority = function () {
        return this.priorityNode_ || EMPTY_NODE;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
        if (this.children_.isEmpty()) {
            // Don't allow priorities on empty nodes
            return this;
        }
        else {
            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.getPriority();
        }
        else {
            var child = this.children_.get(childName);
            return child === null ? EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getChild = function (path) {
        var front = path.getFront();
        if (front === null) {
            return this;
        }
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hasChild = function (childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        assert(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else {
            var namedNode = new NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            }
            else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            var newPriority = newChildren.isEmpty()
                ? EMPTY_NODE
                : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else {
            assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.isEmpty = function () {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.numChildren = function () {
        return this.children_.count();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.val = function (exportFormat) {
        if (this.isEmpty()) {
            return null;
        }
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
                maxKey = Math.max(maxKey, Number(key));
            }
            else {
                allIntegerKeys = false;
            }
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            // eslint-disable-next-line guard-for-in
            for (var key in obj) {
                array[key] = obj[key];
            }
            return array;
        }
        else {
            if (exportFormat && !this.getPriority().isEmpty()) {
                obj['.priority'] = this.getPriority().val();
            }
            return obj;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash_1 = '';
            if (!this.getPriority().isEmpty()) {
                toHash_1 +=
                    'priority:' +
                        priorityHashText(this.getPriority().val()) +
                        ':';
            }
            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== '') {
                    toHash_1 += ':' + key + ':' + childHash;
                }
            });
            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        }
        else {
            return this.children_.getPredecessorKey(childName);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        }
        else {
            return this.children_.minKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) {
            return new NamedNode(minKey, this.children_.get(minKey));
        }
        else {
            return null;
        }
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        }
        else {
            return this.children_.maxKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) {
            return new NamedNode(maxKey, this.children_.get(maxKey));
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.forEachChild = function (index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            return idx.inorderTraversal(function (wrappedNode) {
                return action(wrappedNode.name, wrappedNode.node);
            });
        }
        else {
            return this.children_.inorderTraversal(action);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */
    ChildrenNode.prototype.getIterator = function (indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getIteratorFrom(startPost, function (key) { return key; });
        }
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, startPost) < 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getReverseIteratorFrom(endPost, function (key) {
                return key;
            });
        }
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, endPost) > 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.compareTo = function (other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) {
                return 0;
            }
            else {
                return -1;
            }
        }
        else if (other.isLeafNode() || other.isEmpty()) {
            return 1;
        }
        else if (other === MAX_NODE$2) {
            return -1;
        }
        else {
            // Must be another node with children.
            return 0;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.withIndex = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX ||
            this.indexMap_.hasIndex(indexDefinition)) {
            return this;
        }
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.isIndexed = function (index) {
        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.equals = function (other) {
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            return false;
        }
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
                return false;
            }
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator(PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while (thisCurrent && otherCurrent) {
                    if (thisCurrent.name !== otherCurrent.name ||
                        !thisCurrent.node.equals(otherCurrent.node)) {
                        return false;
                    }
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            }
            else {
                return false;
            }
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */
    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX) {
            return null;
        }
        else {
            return this.indexMap_.get(indexDefinition.toString());
        }
    };
    /**
     * @private
     * @type {RegExp}
     */
    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}());
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */
var MaxNode = /** @class */ (function (_super) {
    __extends(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function (other) {
        if (other === this) {
            return 0;
        }
        else {
            return 1;
        }
    };
    MaxNode.prototype.equals = function (other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function () {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function (childName) {
        return ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function () {
        return false;
    };
    return MaxNode;
}(ChildrenNode));
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */
var MAX_NODE$2 = new MaxNode();
Object.defineProperties(NamedNode, {
    MIN: {
        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new NamedNode(MAX_NAME, MAX_NODE$2)
    }
});
/**
 * Reference Extensions
 */
KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
LeafNode.__childrenNodeConstructor = ChildrenNode;
setMaxNode(MAX_NODE$2);
setMaxNode$1(MAX_NODE$2);

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */
function nodeFromJSON$1(json, priority) {
    if (priority === void 0) { priority = null; }
    if (json === null) {
        return ChildrenNode.EMPTY_NODE;
    }
    if (typeof json === 'object' && '.priority' in json) {
        priority = json['.priority'];
    }
    assert(priority === null ||
        typeof priority === 'string' ||
        typeof priority === 'number' ||
        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
        json = json['.value'];
    }
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        var jsonLeaf = json;
        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
    }
    if (!(json instanceof Array) && USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj = json;
        each(hinzeJsonObj, function (key, child) {
            if (key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                var childNode = nodeFromJSON$1(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 =
                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length === 0) {
            return ChildrenNode.EMPTY_NODE;
        }
        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
        }
        else {
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
        }
    }
    else {
        var node_1 = ChildrenNode.EMPTY_NODE;
        each(json, function (key, childData) {
            if (contains(json, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    var childNode = nodeFromJSON$1(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) {
                        node_1 = node_1.updateImmediateChild(key, childNode);
                    }
                }
            }
        });
        return node_1.updatePriority(nodeFromJSON$1(priority));
    }
}
setNodeFromJSON(nodeFromJSON$1);

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var ValueIndex = /** @class */ (function (_super) {
    __extends(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.compare = function (a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.isDefinedOn = function (node) {
        return true;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.minPost = function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.maxPost = function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    ValueIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        return new NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    ValueIndex.prototype.toString = function () {
        return '.value';
    };
    return ValueIndex;
}(Index));
var VALUE_INDEX = new ValueIndex();

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */
var PathIndex = /** @class */ (function (_super) {
    __extends(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */
    PathIndex.prototype.extractChild = function (snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.isDefinedOn = function (node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.compare = function (a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.maxPost = function () {
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
        return new NamedNode(MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.toString = function () {
        return this.indexPath_.slice().join('/');
    };
    return PathIndex;
}(Index));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */
var DataSnapshot = /** @class */ (function () {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */
    function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.val = function () {
        validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.exportVal = function () {
        validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function () {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */
    DataSnapshot.prototype.exists = function () {
        validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */
    DataSnapshot.prototype.child = function (childPathString) {
        validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        validatePathString('DataSnapshot.child', 1, childPathString, false);
        var childPath = new Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */
    DataSnapshot.prototype.hasChild = function (childPathString) {
        validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
        var childPath = new Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */
    DataSnapshot.prototype.getPriority = function () {
        validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */
    DataSnapshot.prototype.forEach = function (action) {
        var _this = this;
        validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
        validateCallback('DataSnapshot.forEach', 1, action, false);
        if (this.node_.isLeafNode()) {
            return false;
        }
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function (key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */
    DataSnapshot.prototype.hasChildren = function () {
        validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
        if (this.node_.isLeafNode()) {
            return false;
        }
        else {
            return !this.node_.isEmpty();
        }
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function () {
            return this.ref_.getKey();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */
    DataSnapshot.prototype.numChildren = function () {
        validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */
    DataSnapshot.prototype.getRef = function () {
        validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: false,
        configurable: true
    });
    return DataSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */ (function () {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */
    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getPath = function () {
        var ref = this.snapshot.getRef();
        if (this.eventType === 'value') {
            return ref.path;
        }
        else {
            return ref.getParent().path;
        }
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventType = function () {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.toString = function () {
        return (this.getPath().toString() +
            ':' +
            this.eventType +
            ':' +
            stringify(this.snapshot.exportVal()));
    };
    return DataEvent;
}());
var CancelEvent = /** @class */ (function () {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */
    function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getPath = function () {
        return this.path;
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventType = function () {
        return 'cancel';
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.toString = function () {
        return this.path.toString() + ':cancel';
    };
    return CancelEvent;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents registration for 'value' events.
 */
var ValueEventRegistration = /** @class */ (function () {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */
    function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.respondsTo = function (eventType) {
        return eventType === 'value';
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createEvent = function (change, query) {
        var index = query.getQueryParams().getIndex();
        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_1 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        }
        else {
            var cb_1 = this.callback_;
            return function () {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.matches = function (other) {
        if (!(other instanceof ValueEventRegistration)) {
            return false;
        }
        else if (!other.callback_ || !this.callback_) {
            // If no callback specified, we consider it to match any callback.
            return true;
        }
        else {
            return (other.callback_ === this.callback_ && other.context_ === this.context_);
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.hasAnyCallback = function () {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}());
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */
var ChildEventRegistration = /** @class */ (function () {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */
    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.respondsTo = function (eventType) {
        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck =
            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return contains(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createEvent = function (change, query) {
        assert(change.childName != null, 'Child events should have a childName.');
        var ref = query.getRef().child(/** @type {!string} */ change.childName);
        var index = query.getQueryParams().getIndex();
        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_2 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        }
        else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function () {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.matches = function (other) {
        var _this = this;
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) {
                return true;
            }
            else if (this.context_ === other.context_) {
                var otherKeys = Object.keys(other.callbacks_);
                var thisKeys = Object.keys(this.callbacks_);
                var otherCount = otherKeys.length;
                var thisCount = thisKeys.length;
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    // If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey = otherKeys[0];
                        var thisKey = thisKeys[0];
                        return (thisKey === otherKey &&
                            (!other.callbacks_[otherKey] ||
                                !this.callbacks_[thisKey] ||
                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
                    }
                    else {
                        // Exact match on each key.
                        return thisKeys.every(function (eventType) {
                            return other.callbacks_[eventType] === _this.callbacks_[eventType];
                        });
                    }
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.hasAnyCallback = function () {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */
var Query = /** @class */ (function () {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function () {
            assert(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function (val) {
            __referenceConstructor = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */
    Query.validateQueryEndpoints_ = function (params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) {
            startNode = params.getIndexStartValue();
        }
        if (params.hasEnd()) {
            endNode = params.getIndexEndValue();
        }
        if (params.getIndex() === KEY_INDEX) {
            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
                'startAt(), endAt(), or equalTo().';
            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
                'or equalTo() must be a string.';
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName !== MIN_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof startNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName !== MAX_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof endNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
        }
        else if (params.getIndex() === PRIORITY_INDEX) {
            if ((startNode != null && !isValidPriority(startNode)) ||
                (endNode != null && !isValidPriority(endNode))) {
                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
            }
        }
        else {
            assert(params.getIndex() instanceof PathIndex ||
                params.getIndex() === VALUE_INDEX, 'unknown index type.');
            if ((startNode != null && typeof startNode === 'object') ||
                (endNode != null && typeof endNode === 'object')) {
                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
                    'an object.');
            }
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */
    Query.validateLimit_ = function (params) {
        if (params.hasStart() &&
            params.hasEnd() &&
            params.hasLimit() &&
            !params.hasAnchoredLimit()) {
            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
        }
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */
    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
        if (this.orderByCalled_ === true) {
            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
        }
    };
    /**
     * @return {!QueryParams}
     */
    Query.prototype.getQueryParams = function () {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */
    Query.prototype.getRef = function () {
        validateArgCount('Query.ref', 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */
    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
        validateArgCount('Query.on', 2, 4, arguments.length);
        validateEventType('Query.on', 1, eventType, false);
        validateCallback('Query.on', 2, callback, false);
        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        if (eventType === 'value') {
            this.onValueEvent(callback, ret.cancel, ret.context);
        }
        else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */
    Query.prototype.off = function (eventType, callback, context) {
        validateArgCount('Query.off', 0, 3, arguments.length);
        validateEventType('Query.off', 1, eventType, true);
        validateCallback('Query.off', 2, callback, true);
        validateContextObject('Query.off', 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === 'value') {
            var valueCallback = callback || null;
            container = new ValueEventRegistration(valueCallback, null, context || null);
        }
        else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param failureCallbackOrContext
     * @param context
     * @return {!firebase.Promise}
     */
    Query.prototype.once = function (eventType, userCallback, failureCallbackOrContext, context) {
        var _this = this;
        validateArgCount('Query.once', 1, 4, arguments.length);
        validateEventType('Query.once', 1, eventType, false);
        validateCallback('Query.once', 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new Deferred();
        // A dummy error handler in case a user wasn't expecting promises
        deferred.promise.catch(function () { });
        var onceCallback = function (snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) {
                    userCallback.bind(ret.context)(snapshot);
                }
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback, 
        /*cancel=*/ function (err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel) {
                ret.cancel.bind(ret.context)(err);
            }
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToFirst = function (limit) {
        validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToLast = function (limit) {
        validateArgCount('Query.limitToLast', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToLast: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */
    Query.prototype.orderByChild = function (path) {
        validateArgCount('Query.orderByChild', 1, 1, arguments.length);
        if (path === '$key') {
            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        }
        else if (path === '$priority') {
            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        }
        else if (path === '$value') {
            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        }
        validatePathString('Query.orderByChild', 1, path, false);
        this.validateNoPreviousOrderByCall_('Query.orderByChild');
        var parsedPath = new Path(path);
        if (parsedPath.isEmpty()) {
            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
        }
        var index = new PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */
    Query.prototype.orderByKey = function () {
        validateArgCount('Query.orderByKey', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByKey');
        var newParams = this.queryParams_.orderBy(KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */
    Query.prototype.orderByPriority = function () {
        validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */
    Query.prototype.orderByValue = function () {
        validateArgCount('Query.orderByValue', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByValue');
        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.startAt = function (value, name) {
        if (value === void 0) { value = null; }
        validateArgCount('Query.startAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
        validateKey('Query.startAt', 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
                'or equalTo).');
        }
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.endAt = function (value, name) {
        if (value === void 0) { value = null; }
        validateArgCount('Query.endAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
        validateKey('Query.endAt', 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */
    Query.prototype.equalTo = function (value, name) {
        validateArgCount('Query.equalTo', 1, 2, arguments.length);
        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
        validateKey('Query.equalTo', 2, name, true);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
                'equalTo).');
        }
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */
    Query.prototype.toString = function () {
        validateArgCount('Query.toString', 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function () {
        // An optional spacer argument is unnecessary for a string.
        validateArgCount('Query.toJSON', 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */
    Query.prototype.queryObject = function () {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */
    Query.prototype.queryIdentifier = function () {
        var obj = this.queryObject();
        var id = ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */
    Query.prototype.isEqual = function (other) {
        validateArgCount('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */
    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
        var ret = { cancel: null, context: null };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            validateCallback(fnName, 3, ret.cancel, true);
            ret.context = context;
            validateContextObject(fnName, 4, ret.context, true);
        }
        else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
                // it's a context!
                ret.context = cancelOrContext;
            }
            else if (typeof cancelOrContext === 'function') {
                ret.cancel = cancelOrContext;
            }
            else {
                throw new Error(errorPrefix(fnName, 3, true) +
                    ' must either be a cancel callback or a context object.');
            }
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: false,
        configurable: true
    });
    return Query;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ExistingValueProvider = /** @class */ (function () {
    function ExistingValueProvider(node_) {
        this.node_ = node_;
    }
    ExistingValueProvider.prototype.getImmediateChild = function (childName) {
        var child = this.node_.getImmediateChild(childName);
        return new ExistingValueProvider(child);
    };
    ExistingValueProvider.prototype.node = function () {
        return this.node_;
    };
    return ExistingValueProvider;
}());
var DeferredValueProvider = /** @class */ (function () {
    function DeferredValueProvider(syncTree, path) {
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    DeferredValueProvider.prototype.getImmediateChild = function (childName) {
        var childPath = this.path_.child(childName);
        return new DeferredValueProvider(this.syncTree_, childPath);
    };
    DeferredValueProvider.prototype.node = function () {
        return this.syncTree_.calcCompleteEventCache(this.path_);
    };
    return DeferredValueProvider;
}());
/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */
var generateWithValues = function (values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */
var resolveDeferredLeafValue = function (value, existingVal, serverValues) {
    if (!value || typeof value !== 'object') {
        return value;
    }
    assert('.sv' in value, 'Unexpected leaf node or priority contents');
    if (typeof value['.sv'] === 'string') {
        return resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
    }
    else if (typeof value['.sv'] === 'object') {
        return resolveComplexDeferredValue(value['.sv'], existingVal);
    }
    else {
        assert(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
    }
};
var resolveScalarDeferredValue = function (op, existing, serverValues) {
    switch (op) {
        case 'timestamp':
            return serverValues['timestamp'];
        default:
            assert(false, 'Unexpected server value: ' + op);
    }
};
var resolveComplexDeferredValue = function (op, existing, unused) {
    if (!op.hasOwnProperty('increment')) {
        assert(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
    }
    var delta = op['increment'];
    if (typeof delta !== 'number') {
        assert(false, 'Unexpected increment value: ' + delta);
    }
    var existingNode = existing.node();
    assert(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) {
        return delta;
    }
    var leaf = existingNode;
    var existingVal = leaf.getValue();
    if (typeof existingVal !== 'number') {
        return delta;
    }
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!Path} path path to which write is relative
 * @param {!Node} node new data written at path
 * @param {!SyncTree} syncTree current data
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */
var resolveDeferredValueTree = function (path, node, syncTree, serverValues) {
    return resolveDeferredValue(node, new DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */
var resolveDeferredValueSnapshot = function (node, existing, serverValues) {
    return resolveDeferredValue(node, new ExistingValueProvider(existing), serverValues);
};
function resolveDeferredValue(node, existingVal, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() ||
            priority !== leafNode.getPriority().val()) {
            return new LeafNode(value, nodeFromJSON$1(priority));
        }
        else {
            return node;
        }
    }
    else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) {
            newNode = newNode.updatePriority(new LeafNode(priority));
        }
        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
            var newChildNode = resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) {
                newNode = newNode.updateImmediateChild(childName, newChildNode);
            }
        });
        return newNode;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper class to store a sparse set of snapshots.
 */
var SparseSnapshotTree = /** @class */ (function () {
    function SparseSnapshotTree() {
        this.value = null;
        this.children = new Map();
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param path Path to look up snapshot for.
     * @return The retrieved node, or null.
     */
    SparseSnapshotTree.prototype.find = function (path) {
        if (this.value != null) {
            return this.value.getChild(path);
        }
        else if (!path.isEmpty() && this.children.size > 0) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children.has(childKey)) {
                var childTree = this.children.get(childKey);
                return childTree.find(path);
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param path Path to look up snapshot for.
     * @param data The new data, or null.
     */
    SparseSnapshotTree.prototype.remember = function (path, data) {
        if (path.isEmpty()) {
            this.value = data;
            this.children.clear();
        }
        else if (this.value !== null) {
            this.value = this.value.updateChild(path, data);
        }
        else {
            var childKey = path.getFront();
            if (!this.children.has(childKey)) {
                this.children.set(childKey, new SparseSnapshotTree());
            }
            var child = this.children.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param path Path to look up snapshot for.
     * @return True if this node should now be removed.
     */
    SparseSnapshotTree.prototype.forget = function (path) {
        if (path.isEmpty()) {
            this.value = null;
            this.children.clear();
            return true;
        }
        else {
            if (this.value !== null) {
                if (this.value.isLeafNode()) {
                    // We're trying to forget a node that doesn't exist
                    return false;
                }
                else {
                    var value = this.value;
                    this.value = null;
                    var self_1 = this;
                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
                        self_1.remember(new Path(key), tree);
                    });
                    return this.forget(path);
                }
            }
            else if (this.children.size > 0) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children.has(childKey)) {
                    var safeToRemove = this.children.get(childKey).forget(path);
                    if (safeToRemove) {
                        this.children.delete(childKey);
                    }
                }
                return this.children.size === 0;
            }
            else {
                return true;
            }
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param prefixPath Path to look up node for.
     * @param func The function to invoke for each tree.
     */
    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
        if (this.value !== null) {
            func(prefixPath, this.value);
        }
        else {
            this.forEachChild(function (key, tree) {
                var path = new Path(prefixPath.toString() + '/' + key);
                tree.forEachTree(path, func);
            });
        }
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param func The function to invoke for each child.
     */
    SparseSnapshotTree.prototype.forEachChild = function (func) {
        this.children.forEach(function (tree, key) {
            func(key, tree);
        });
    };
    return SparseSnapshotTree;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @enum
 */
var OperationType;
(function (OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})(OperationType || (OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */
var OperationSource = /** @class */ (function () {
    function OperationSource(fromUser, fromServer, queryId, tagged) {
        this.fromUser = fromUser;
        this.fromServer = fromServer;
        this.queryId = queryId;
        this.tagged = tagged;
        assert(!tagged || fromServer, 'Tagged queries must be from server.');
    }
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.User = new OperationSource(
    /*fromUser=*/ true, false, null, 
    /*tagged=*/ false);
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.Server = new OperationSource(false, 
    /*fromServer=*/ true, null, 
    /*tagged=*/ false);
    /**
     * @param {string} queryId
     * @return {!OperationSource}
     */
    OperationSource.forServerTaggedQuery = function (queryId) {
        return new OperationSource(false, 
        /*fromServer=*/ true, queryId, 
        /*tagged=*/ true);
    };
    return OperationSource;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AckUserWrite = /** @class */ (function () {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */
    function AckUserWrite(
    /** @inheritDoc */ path, 
    /** @inheritDoc */ affectedTree, 
    /** @inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */
        this.type = OperationType.ACK_USER_WRITE;
        /** @inheritDoc */
        this.source = OperationSource.User;
    }
    /**
     * @inheritDoc
     */
    AckUserWrite.prototype.operationForChild = function (childName) {
        if (!this.path.isEmpty()) {
            assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        }
        else if (this.affectedTree.value != null) {
            assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        }
        else {
            var childTree = this.affectedTree.subtree(new Path(childName));
            return new AckUserWrite(Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */
var EmptyChildren = function () {
    if (!emptyChildrenSingleton) {
        emptyChildrenSingleton = new SortedMap(stringCompare);
    }
    return emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */
var ImmutableTree = /** @class */ (function () {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */
    function ImmutableTree(value, children) {
        if (children === void 0) { children = EmptyChildren(); }
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */
    ImmutableTree.fromObject = function (obj) {
        var tree = ImmutableTree.Empty;
        each(obj, function (childPath, childSnap) {
            tree = tree.set(new Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */
    ImmutableTree.prototype.isEmpty = function () {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */
    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
        if (this.value != null && predicate(this.value)) {
            return { path: Path.Empty, value: this.value };
        }
        else {
            if (relativePath.isEmpty()) {
                return null;
            }
            else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
                        return { path: fullPath, value: childExistingPathAndValue.value };
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */
    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */
    ImmutableTree.prototype.subtree = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this;
        }
        else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) {
                return childTree.subtree(relativePath.popFront());
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.set = function (relativePath, toSet) {
        if (relativePath.isEmpty()) {
            return new ImmutableTree(toSet, this.children);
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.remove = function (relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) {
                return ImmutableTree.Empty;
            }
            else {
                return new ImmutableTree(null, this.children);
            }
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) {
                    newChildren = this.children.remove(front);
                }
                else {
                    newChildren = this.children.insert(front, newChild);
                }
                if (this.value === null && newChildren.isEmpty()) {
                    return ImmutableTree.Empty;
                }
                else {
                    return new ImmutableTree(this.value, newChildren);
                }
            }
            else {
                return this;
            }
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */
    ImmutableTree.prototype.get = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this.value;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                return child.get(relativePath.popFront());
            }
            else {
                return null;
            }
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */
    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
        if (relativePath.isEmpty()) {
            return newTree;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) {
                newChildren = this.children.remove(front);
            }
            else {
                newChildren = this.children.insert(front, newChild);
            }
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */
    ImmutableTree.prototype.fold = function (fn) {
        return this.fold_(Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */
    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function (childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */
    ImmutableTree.prototype.findOnPath = function (path, f) {
        return this.findOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) {
            return result;
        }
        else {
            if (pathToFollow.isEmpty()) {
                return null;
            }
            else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) {
                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */
    ImmutableTree.prototype.foreachOnPath = function (path, f) {
        return this.foreachOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) {
            return this;
        }
        else {
            if (this.value) {
                f(currentRelativePath, this.value);
            }
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) {
                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */
    ImmutableTree.prototype.foreach = function (f) {
        this.foreach_(Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
        this.children.inorderTraversal(function (childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) {
            f(currentRelativePath, this.value);
        }
    };
    /**
     *
     * @param {function(string, !T)} f
     */
    ImmutableTree.prototype.foreachChild = function (f) {
        this.children.inorderTraversal(function (childName, childTree) {
            if (childTree.value) {
                f(childName, childTree.value);
            }
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */
var ListenComplete = /** @class */ (function () {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */
        this.type = OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new ListenComplete(this.source, Path.Empty);
        }
        else {
            return new ListenComplete(this.source, this.path.popFront());
        }
    };
    return ListenComplete;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */
var Overwrite = /** @class */ (function () {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */
        this.type = OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
        }
        else {
            return new Overwrite(this.source, this.path.popFront(), this.snap);
        }
    };
    return Overwrite;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */
var Merge = /** @class */ (function () {
    function Merge(
    /** @inheritDoc */ source, 
    /** @inheritDoc */ path, 
    /** @inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */
        this.type = OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */
    Merge.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new Path(childName));
            if (childTree.isEmpty()) {
                // This child is unaffected
                return null;
            }
            else if (childTree.value) {
                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
                return new Overwrite(this.source, Path.Empty, childTree.value);
            }
            else {
                // This is a merge at a deeper level
                return new Merge(this.source, Path.Empty, childTree);
            }
        }
        else {
            assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */
    Merge.prototype.toString = function () {
        return ('Operation(' +
            this.path +
            ': ' +
            this.source.toString() +
            ' merge: ' +
            this.children.toString() +
            ')');
    };
    return Merge;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */
var CacheNode = /** @class */ (function () {
    /**
     * @param {!Node} node_
     * @param {boolean} fullyInitialized_
     * @param {boolean} filtered_
     */
    function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     * @return {boolean}
     */
    CacheNode.prototype.isFullyInitialized = function () {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     * @return {boolean}
     */
    CacheNode.prototype.isFiltered = function () {
        return this.filtered_;
    };
    /**
     * @param {!Path} path
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForPath = function (path) {
        if (path.isEmpty()) {
            return this.isFullyInitialized() && !this.filtered_;
        }
        var childKey = path.getFront();
        return this.isCompleteForChild(childKey);
    };
    /**
     * @param {!string} key
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForChild = function (key) {
        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
    };
    /**
     * @return {!Node}
     */
    CacheNode.prototype.getNode = function () {
        return this.node_;
    };
    return CacheNode;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */
var ViewCache = /** @class */ (function () {
    /**
     *
     * @param {!CacheNode} eventCache_
     * @param {!CacheNode} serverCache_
     */
    function ViewCache(eventCache_, serverCache_) {
        this.eventCache_ = eventCache_;
        this.serverCache_ = serverCache_;
    }
    /**
     * @param {!Node} eventSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
    };
    /**
     * @param {!Node} serverSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getEventCache = function () {
        return this.eventCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteEventSnap = function () {
        return this.eventCache_.isFullyInitialized()
            ? this.eventCache_.getNode()
            : null;
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getServerCache = function () {
        return this.serverCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteServerSnap = function () {
        return this.serverCache_.isFullyInitialized()
            ? this.serverCache_.getNode()
            : null;
    };
    /**
     * @const
     * @type {ViewCache}
     */
    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false));
    return ViewCache;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */
var Change = /** @class */ (function () {
    function Change(type, snapshotNode, childName, oldSnap, prevName) {
        this.type = type;
        this.snapshotNode = snapshotNode;
        this.childName = childName;
        this.oldSnap = oldSnap;
        this.prevName = prevName;
    }
    /**
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.valueChange = function (snapshot) {
        return new Change(Change.VALUE, snapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childAddedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_ADDED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childRemovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} newSnapshot
     * @param {!Node} oldSnapshot
     * @return {!Change}
     */
    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childMovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_MOVED, snapshot, childKey);
    };
    //event types
    /** Event type for a child added */
    Change.CHILD_ADDED = 'child_added';
    /** Event type for a child removed */
    Change.CHILD_REMOVED = 'child_removed';
    /** Event type for a child changed */
    Change.CHILD_CHANGED = 'child_changed';
    /** Event type for a child moved */
    Change.CHILD_MOVED = 'child_moved';
    /** Event type for a value change */
    Change.VALUE = 'value';
    return Change;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */
var IndexedFilter = /** @class */ (function () {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) {
                // Nothing changed.
                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
                return snap;
            }
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) {
                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
                }
                else {
                    assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
                }
            }
            else if (oldChild.isEmpty()) {
                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
            }
            else {
                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
            }
        }
        if (snap.isLeafNode() && newChild.isEmpty()) {
            return snap;
        }
        else {
            // Make sure the node is indexed
            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) {
                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (!newSnap.hasChild(key)) {
                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
                    }
                });
            }
            if (!newSnap.isLeafNode()) {
                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (oldSnap.hasChild(key)) {
                        var oldChild = oldSnap.getImmediateChild(key);
                        if (!oldChild.equals(childNode)) {
                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
                        }
                    }
                    else {
                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
                    }
                });
            }
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        if (oldSnap.isEmpty()) {
            return ChildrenNode.EMPTY_NODE;
        }
        else {
            return oldSnap.updatePriority(newPriority);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.filtersNodes = function () {
        return false;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndexedFilter = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    return IndexedFilter;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ChildChangeAccumulator = /** @class */ (function () {
    function ChildChangeAccumulator() {
        this.changeMap = new Map();
    }
    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
        var type = change.type;
        var childKey = change.childName;
        assert(type === Change.CHILD_ADDED ||
            type === Change.CHILD_CHANGED ||
            type === Change.CHILD_REMOVED, 'Only child changes supported for tracking');
        assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        var oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type === Change.CHILD_ADDED && oldType === Change.CHILD_REMOVED) {
                this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode));
            }
            else if (type === Change.CHILD_REMOVED &&
                oldType === Change.CHILD_ADDED) {
                this.changeMap.delete(childKey);
            }
            else if (type === Change.CHILD_REMOVED &&
                oldType === Change.CHILD_CHANGED) {
                this.changeMap.set(childKey, Change.childRemovedChange(childKey, oldChange.oldSnap));
            }
            else if (type === Change.CHILD_CHANGED &&
                oldType === Change.CHILD_ADDED) {
                this.changeMap.set(childKey, Change.childAddedChange(childKey, change.snapshotNode));
            }
            else if (type === Change.CHILD_CHANGED &&
                oldType === Change.CHILD_CHANGED) {
                this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap));
            }
            else {
                throw assertionError('Illegal combination of changes: ' +
                    change +
                    ' occurred after ' +
                    oldChange);
            }
        }
        else {
            this.changeMap.set(childKey, change);
        }
    };
    ChildChangeAccumulator.prototype.getChanges = function () {
        return Array.from(this.changeMap.values());
    };
    return ChildChangeAccumulator;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
var NoCompleteChildSource_ = /** @class */ (function () {
    function NoCompleteChildSource_() {
    }
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}());
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */
var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */ (function () {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */
    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) {
            return node.getNode().getImmediateChild(childKey);
        }
        else {
            var serverNode = this.optCompleteServerCache_ != null
                ? new CacheNode(this.optCompleteServerCache_, true, false)
                : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null
            ? this.optCompleteServerCache_
            : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) {
            return null;
        }
        else {
            return nodes[0];
        }
    };
    return WriteTreeCompleteChildSource;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 */
var ProcessorResult = /** @class */ (function () {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */
    function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}());
/**
 * @constructor
 */
var ViewProcessor = /** @class */ (function () {
    /**
     * @param {!NodeFilter} filter_
     */
    function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */
    ViewProcessor.prototype.assertIndexed = function (viewCache) {
        assert(viewCache.getEventCache().getNode().isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
        assert(viewCache.getServerCache().getNode().isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */
    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) {
                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            }
            else {
                assert(overwrite.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode =
                    overwrite.source.tagged ||
                        (oldViewCache.getServerCache().isFiltered() &&
                            !overwrite.path.isEmpty());
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) {
                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            }
            else {
                assert(merge.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode =
                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) {
                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            }
            else {
                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
            }
        }
        else if (operation.type === OperationType.LISTEN_COMPLETE) {
            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        }
        else {
            throw assertionError('Unknown operation type: ' + operation.type);
        }
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */
    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 ||
                !oldViewCache.getEventCache().isFullyInitialized() ||
                (isLeafOrEmpty &&
                    !eventSnap.getNode().equals(/** @type {!Node} */ oldCompleteSnap)) ||
                !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) {
                accumulator.push(Change.valueChange(
                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
            }
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) {
            // we have a shadowing write, ignore changes
            return viewCache;
        }
        else {
            var newEventCache = void 0, serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof ChildrenNode
                        ? serverCache
                        : ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                }
                else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            }
            else {
                var childKey = changePath.getFront();
                if (childKey === '.priority') {
                    assert(changePath.getLength() === 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) {
                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    }
                    else {
                        // priority didn't change, keep old node
                        newEventCache = oldEventSnap.getNode();
                    }
                }
                else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) {
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey)
                                .updateChild(childChangePath, eventChildUpdate);
                        }
                        else {
                            // Nothing changed, just keep the old child
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey);
                        }
                    }
                    else {
                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    }
                    if (newEventChild != null) {
                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    }
                    else {
                        // no complete child available or no change
                        newEventCache = oldEventSnap.getNode();
                    }
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode
            ? this.filter_
            : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) {
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        }
        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap
                .getNode()
                .updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        }
        else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) &&
                changePath.getLength() > 1) {
                // We don't update incomplete nodes with updates intended for other listeners
                return oldViewCache;
            }
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey === '.priority') {
                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            }
            else {
                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
            }
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        }
        else {
            var childKey = changePath.getFront();
            if (childKey === '.priority') {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            }
            else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) {
                    // Child overwrite, we can replace the child
                    newChild = changedSnap;
                }
                else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === '.priority' &&
                            childNode.getChild(childChangePath.parent()).isEmpty()) {
                            // This is a priority update on an empty node. If this node exists on the server, the
                            // server will send down the priority in the update, so ignore for now
                            newChild = childNode;
                        }
                        else {
                            newChild = childNode.updateChild(childChangePath, changedSnap);
                        }
                    }
                    else {
                        // There is no complete child node available
                        newChild = ChildrenNode.EMPTY_NODE;
                    }
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                }
                else {
                    newViewCache = oldViewCache;
                }
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */
    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */
    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
        merge.foreach(function (relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache.getServerCache().getNode().isEmpty() &&
            !viewCache.getServerCache().isFullyInitialized()) {
            return viewCache;
        }
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) {
            viewMergeTree = changedChildren;
        }
        else {
            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
        }
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
                childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) {
            return viewCache;
        }
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
                serverCache.isCompleteForPath(ackPath)) {
                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            }
            else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = ImmutableTree.Empty;
                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            }
            else {
                return viewCache;
            }
        }
        else {
            // This is a merge.
            var changedChildren_2 = ImmutableTree.Empty;
            affectedTree.foreach(function (mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) {
                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
                }
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) {
            return viewCache;
        }
        else {
            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === '.priority') {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) {
                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                }
                else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode = newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            }
            else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null &&
                    viewCache.getServerCache().isCompleteForChild(childKey)) {
                    newChild = oldEventCache.getImmediateChild(childKey);
                }
                if (newChild != null) {
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                }
                else if (viewCache.getEventCache().getNode().hasChild(childKey)) {
                    // No complete child available, delete the existing one, if any
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                }
                else {
                    newEventCache = oldEventCache;
                }
                if (newEventCache.isEmpty() &&
                    viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) {
                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                    }
                }
            }
            complete =
                viewCache.getServerCache().isFullyInitialized() ||
                    writesCache.shadowingWrite(Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */
var EventGenerator = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     */
    function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */
        this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */
    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function (change) {
            if (change.type === Change.CHILD_CHANGED &&
                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
            }
        });
        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */
    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function (change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function (registration) {
                if (registration.respondsTo(change.type)) {
                    events.push(registration.createEvent(materializedChange, _this.query_));
                }
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */
    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
        if (change.type === 'value' || change.type === 'child_removed') {
            return change;
        }
        else {
            change.prevName = eventCache.getPredecessorChildName(
            /** @type {!string} */
            change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */
    EventGenerator.prototype.compareChanges_ = function (a, b) {
        if (a.childName == null || b.childName == null) {
            throw assertionError('Should only compare child_ events.');
        }
        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */
var View = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */
    function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */
        this.processor_ = new ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */
        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */
        this.eventGenerator_ = new EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */
    View.prototype.getQuery = function () {
        return this.query_;
    };
    /**
     * @return {?Node}
     */
    View.prototype.getServerCache = function () {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */
    View.prototype.getCompleteServerCache = function (path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() ||
                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
                return cache.getChild(path);
            }
        }
        return null;
    };
    /**
     * @return {boolean}
     */
    View.prototype.isEmpty = function () {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */
    View.prototype.addEventRegistration = function (eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function (registration) {
                cancelError /** @type {!Error} */ = cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) {
                    cancelEvents.push(maybeEvent);
                }
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) {
                    remaining.push(existing);
                }
                else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        }
        else {
            this.eventRegistrations_ = [];
        }
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */
    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
        if (operation.type === OperationType.MERGE &&
            operation.source.queryId !== null) {
            assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
            assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        assert(result.viewCache.getServerCache().isFullyInitialized() ||
            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */
    View.prototype.getInitialEvents = function (registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                initialChanges.push(Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) {
            initialChanges.push(Change.valueChange(eventSnap.getNode()));
        }
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */
    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
        var registrations = eventRegistration
            ? [eventRegistration]
            : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */
var SyncPoint = /** @class */ (function () {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */
        this.views = new Map();
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function () {
            assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
            return __referenceConstructor$1;
        },
        set: function (val) {
            assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
            __referenceConstructor$1 = val;
        },
        enumerable: false,
        configurable: true
    });
    SyncPoint.prototype.isEmpty = function () {
        return this.views.size === 0;
    };
    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
        var e_1, _a;
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = this.views.get(queryId);
            assert(view != null, 'SyncTree gave us an op for an invalid query.');
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        }
        else {
            var events = [];
            try {
                for (var _b = __values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var view = _c.value;
                    events = events.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return events;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = this.views.get(queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) {
                eventCacheComplete = true;
            }
            else if (serverCache instanceof ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            }
            else {
                eventCache = ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new ViewCache(new CacheNode(
            /** @type {!Node} */ eventCache, eventCacheComplete, false), new CacheNode(
            /** @type {!Node} */ serverCache, serverCacheComplete, false));
            view = new View(query, viewCache);
            this.views.set(queryId, view);
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */
    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var e_2, _a;
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === 'default') {
            try {
                // When you do ref.off(...), we search all views for the registration to remove.
                for (var _b = __values(this.views.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read$1(_c.value, 2), viewQueryId = _d[0], view = _d[1];
                    cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                    if (view.isEmpty()) {
                        this.views.delete(viewQueryId);
                        // We'll deal with complete views later.
                        if (!view.getQuery().getQueryParams().loadsAllData()) {
                            removed.push(view.getQuery());
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        else {
            // remove the callback from the specific view.
            var view = this.views.get(queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    this.views.delete(queryId);
                    // We'll deal with complete views later.
                    if (!view.getQuery().getQueryParams().loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) {
            // We removed our last complete view.
            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        }
        return { removed: removed, events: cancelEvents };
    };
    SyncPoint.prototype.getQueryViews = function () {
        var e_3, _a;
        var result = [];
        try {
            for (var _b = __values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var view = _c.value;
                if (!view.getQuery().getQueryParams().loadsAllData()) {
                    result.push(view);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return result;
    };
    /**
     * @param path The path to the desired complete snapshot
     * @return A complete cache, if it exists
     */
    SyncPoint.prototype.getCompleteServerCache = function (path) {
        var e_4, _a;
        var serverCache = null;
        try {
            for (var _b = __values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var view = _c.value;
                serverCache = serverCache || view.getCompleteServerCache(path);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return serverCache;
    };
    SyncPoint.prototype.viewForQuery = function (query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) {
            return this.getCompleteView();
        }
        else {
            var queryId = query.queryIdentifier();
            return this.views.get(queryId);
        }
    };
    SyncPoint.prototype.viewExistsForQuery = function (query) {
        return this.viewForQuery(query) != null;
    };
    SyncPoint.prototype.hasCompleteView = function () {
        return this.getCompleteView() != null;
    };
    SyncPoint.prototype.getCompleteView = function () {
        var e_5, _a;
        try {
            for (var _b = __values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var view = _c.value;
                if (view.getQuery().getQueryParams().loadsAllData()) {
                    return view;
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return null;
    };
    return SyncPoint;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */
var CompoundWrite = /** @class */ (function () {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    CompoundWrite.prototype.addWrite = function (path, node) {
        if (path.isEmpty()) {
            return new CompoundWrite(new ImmutableTree(node));
        }
        else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            }
            else {
                var subtree = new ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    CompoundWrite.prototype.addWrites = function (path, updates) {
        var newWrite = this;
        each(updates, function (childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */
    CompoundWrite.prototype.removeWrite = function (path) {
        if (path.isEmpty()) {
            return CompoundWrite.Empty;
        }
        else {
            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param path The path to check for
     * @return Whether there is a complete write at that path
     */
    CompoundWrite.prototype.hasCompleteWrite = function (path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param path The path to get a complete write
     * @return The node if complete at that path, or null otherwise.
     */
    CompoundWrite.prototype.getCompleteNode = function (path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            return this.writeTree_
                .get(rootmost.path)
                .getChild(Path.relativePath(rootmost.path, path));
        }
        else {
            return null;
        }
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return A list of all complete children.
     */
    CompoundWrite.prototype.getCompleteChildren = function () {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) {
            // If it's a leaf node, it has no children; so nothing to do.
            if (!node.isLeafNode()) {
                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                    children.push(new NamedNode(childName, childNode));
                });
            }
        }
        else {
            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
                if (childTree.value != null) {
                    children.push(new NamedNode(childName, childTree.value));
                }
            });
        }
        return children;
    };
    CompoundWrite.prototype.childCompoundWrite = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) {
                return new CompoundWrite(new ImmutableTree(shadowingNode));
            }
            else {
                return new CompoundWrite(this.writeTree_.subtree(path));
            }
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return Whether this CompoundWrite is empty
     */
    CompoundWrite.prototype.isEmpty = function () {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param node The node to apply this CompoundWrite to
     * @return The node with all writes applied
     */
    CompoundWrite.prototype.apply = function (node) {
        return applySubtreeWrite(Path.Empty, this.writeTree_, node);
    };
    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
    return CompoundWrite;
}());
function applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) {
        // Since there a write is always a leaf, we're done here
        return node.updateChild(relativePath, writeTree.value);
    }
    else {
        var priorityWrite_1 = null;
        writeTree.children.inorderTraversal(function (childKey, childTree) {
            if (childKey === '.priority') {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
                priorityWrite_1 = childTree.value;
            }
            else {
                node = applySubtreeWrite(relativePath.child(childKey), childTree, node);
            }
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
            node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
        }
        return node;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */
var WriteTree = /** @class */ (function () {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */
        this.visibleWrites_ = CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */
        this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */
    WriteTree.prototype.childWrites = function (path) {
        return new WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */
    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
        assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
        if (visible === undefined) {
            visible = true;
        }
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) {
            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        }
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */
    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
        assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */
    WriteTree.prototype.getWrite = function (writeId) {
        for (var i = 0; i < this.allWrites_.length; i++) {
            var record = this.allWrites_[i];
            if (record.writeId === writeId) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */
    WriteTree.prototype.removeWrite = function (writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function (s) {
            return s.writeId === writeId;
        });
        assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while (removedWriteWasVisible && i >= 0) {
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx &&
                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
                    // The removed write was completely shadowed by a subsequent write.
                    removedWriteWasVisible = false;
                }
                else if (writeToRemove.path.contains(currentWrite.path)) {
                    // Either we're covering some writes or they're covering part of us (depending on which came first).
                    removedWriteOverlapsWithOtherWrites = true;
                }
            }
            i--;
        }
        if (!removedWriteWasVisible) {
            return false;
        }
        else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        }
        else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) {
                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            }
            else {
                var children = writeToRemove.children;
                each(children, function (childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.getCompleteWriteData = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) {
                return shadowingNode;
            }
            else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) {
                    return completeServerCache;
                }
                else if (completeServerCache == null &&
                    !subMerge.hasCompleteWrite(Path.Empty)) {
                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                    return null;
                }
                else {
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        }
        else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) {
                return completeServerCache;
            }
            else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites &&
                    completeServerCache == null &&
                    !merge.hasCompleteWrite(Path.Empty)) {
                    return null;
                }
                else {
                    var filter = function (write) {
                        return ((write.visible || includeHiddenWrites) &&
                            (!writeIdsToExclude ||
                                !~writeIdsToExclude.indexOf(write.writeId)) &&
                            (write.path.contains(treePath) || treePath.contains(write.path)));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
        var completeChildren = ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) {
                // we're shadowing everything. Return the children.
                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
                });
            }
            return completeChildren;
        }
        else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                var node = merge_1
                    .childCompoundWrite(new Path(childName))
                    .apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
        else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
        assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) {
            // At this point we can probably guarantee that we're in case 2, meaning no events
            // May need to check visibility while doing the findRootMostValueAndPath call
            return null;
        }
        else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) {
                // We're not shadowing at all. Case 1
                return existingServerSnap.getChild(childPath);
            }
            else {
                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
                // However this is tricky to find out, since user updates don't necessary change the server
                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
                // only check if the updates change the serverNode.
                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
                return childMerge.apply(existingServerSnap.getChild(childPath));
            }
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) {
            return shadowingNode;
        }
        else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            }
            else {
                return null;
            }
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     */
    WriteTree.prototype.shadowingWrite = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     */
    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode(Path.Empty);
        if (shadowingNode != null) {
            toIterate = shadowingNode;
        }
        else if (completeServerData != null) {
            toIterate = merge.apply(completeServerData);
        }
        else {
            // no children to iterate on
            return [];
        }
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse
                ? toIterate.getReverseIteratorFrom(startPost, index)
                : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while (next && nodes.length < count) {
                if (cmp(next, startPost) !== 0) {
                    nodes.push(next);
                }
                next = iter.getNext();
            }
            return nodes;
        }
        else {
            return [];
        }
    };
    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
        if (writeRecord.snap) {
            return writeRecord.path.contains(path);
        }
        else {
            for (var childName in writeRecord.children) {
                if (writeRecord.children.hasOwnProperty(childName) &&
                    writeRecord.path.child(childName).contains(path)) {
                    return true;
                }
            }
            return false;
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     */
    WriteTree.prototype.resetTree_ = function () {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
        if (this.allWrites_.length > 0) {
            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        }
        else {
            this.lastWriteId_ = -1;
        }
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     */
    WriteTree.DefaultFilter_ = function (write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     */
    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
        var compoundWrite = CompoundWrite.Empty;
        for (var i = 0; i < writes.length; ++i) {
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
                    }
                    else ;
                }
                else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) {
                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
                        }
                        else {
                            var child = safeGet(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
                            }
                        }
                    }
                    else ;
                }
                else {
                    throw assertionError('WriteRecord should have .snap or .children');
                }
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}());
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */
var WriteTreeRef = /** @class */ (function () {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */
    function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTreeRef.prototype.shadowingWrite = function (path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */
    WriteTreeRef.prototype.child = function (childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */
var SyncTree = /** @class */ (function () {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */
    function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */
        this.syncPointTree_ = ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */
        this.pendingWriteTree_ = new WriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) {
            return [];
        }
        else {
            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
        }
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param revert True if the given write failed and needs to be reverted
     * @return Events to raise.
     */
    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
        if (revert === void 0) { revert = false; }
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) {
            return [];
        }
        else {
            var affectedTree_1 = ImmutableTree.Empty;
            if (write.snap != null) {
                // overwrite
                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
            }
            else {
                each(write.children, function (pathString, node) {
                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
                });
            }
            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyListenComplete = function (path) {
        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // Query must have been removed already
            return [];
        }
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var changeTree = ImmutableTree.fromObject(changedChildren);
            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @return Events to raise.
     */
    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
            var relativePath = Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView =
                foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        }
        else {
            foundAncestorDefaultView =
                foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) {
            serverCacheComplete = true;
        }
        else {
            serverCacheComplete = false;
            serverCache = ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function (childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
                if (completeCache) {
                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
                }
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            assert(!this.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap.set(queryKey, tag);
            this.tagToQueryMap.set(tag, queryKey);
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */ = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param eventRegistration If null, all callbacks are removed.
     * @param cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return Cancel events, if cancelError was provided.
     */
    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint &&
            (query.queryIdentifier() === 'default' ||
                maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */
            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) {
                this.syncPointTree_ = this.syncPointTree_.remove(path);
            }
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !==
                removed.findIndex(function (query) {
                    return query.getQueryParams().loadsAllData();
                });
            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for (var i = 0; i < newViews.length; ++i) {
                        var view = newViews[i], newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                }
                else {
                    removed.forEach(function (queryToRemove) {
                        var tagToRemove = _this.queryToTagMap.get(SyncTree.makeQueryKey_(queryToRemove));
                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                    });
                }
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
     * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
     * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
     *     <incremented total> as the write is applied locally and then acknowledged at the server.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     *
     * @param path The path to the data we want
     * @param writeIdsToExclude A specific set to be excluded
     */
    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
            var relativePath = Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) {
                return serverCache;
            }
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     */
    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [completeView];
            }
            else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) {
                    views_1 = maybeChildSyncPoint.getQueryViews();
                }
                each(childMap, function (_key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    SyncTree.prototype.removeTags_ = function (queries) {
        for (var j = 0; j < queries.length; ++j) {
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap.get(removedQueryKey);
                this.queryToTagMap.delete(removedQueryKey);
                this.tagToQueryMap.delete(removedQueryTag);
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     *
     * @return The normalized query
     */
    SyncTree.queryForListening_ = function (query) {
        if (query.getQueryParams().loadsAllData() &&
            !query.getQueryParams().isDefault()) {
            // We treat queries that load all data as default queries
            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
            // from Query
            return query.getRef();
        }
        else {
            return query;
        }
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @return This method can return events to support synchronous data sources
     */
    SyncTree.prototype.setupListener_ = function (query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) {
            assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        }
        else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() &&
                    maybeChildSyncPoint &&
                    maybeChildSyncPoint.hasCompleteView()) {
                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
                }
                else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) {
                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
                    }
                    each(childMap, function (_key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for (var i = 0; i < queriesToStop.length; ++i) {
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    SyncTree.prototype.createListenerForView_ = function (view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function () {
                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function (status) {
                if (status === 'ok') {
                    if (tag) {
                        return _this.applyTaggedListenComplete(query.path, tag);
                    }
                    else {
                        return _this.applyListenComplete(query.path);
                    }
                }
                else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error = errorForServerCode(status, query);
                    return _this.removeEventRegistration(query, 
                    /*eventRegistration*/ null, error);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     */
    SyncTree.makeQueryKey_ = function (query) {
        return query.path.toString() + '$' + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     */
    SyncTree.parseQueryKey_ = function (queryKey) {
        var splitIndex = queryKey.indexOf('$');
        assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     */
    SyncTree.prototype.queryKeyForTag_ = function (tag) {
        return this.tagToQueryMap.get(tag);
    };
    /**
     * Return the tag associated with the given query.
     */
    SyncTree.prototype.tagForQuery_ = function (query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return this.queryToTagMap.get(queryKey);
    };
    /**
     * Static accessor for query tags.
     */
    SyncTree.getNextQueryTag_ = function () {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     */
    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        assert(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache, 
        /*serverCache=*/ null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
     *
     * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
     *
     * - We concatenate all of the events returned by each SyncPoint and return the result.
     */
    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_, 
        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     */
    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) {
            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        }
        else {
            var syncPoint = syncPointTree.get(Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) {
                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
            }
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache
                    ? serverCache.getImmediateChild(childName)
                    : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) {
                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            }
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     */
    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get(Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) {
            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
        }
        var events = [];
        syncPointTree.children.inorderTraversal(function (childName, childTree) {
            var childServerCache = serverCache
                ? serverCache.getImmediateChild(childName)
                : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) {
                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
        });
        if (syncPoint) {
            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        }
        return events;
    };
    /**
     * Static tracker for next query tag.
     */
    SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */ (function () {
    function SnapshotHolder() {
        this.rootNode_ = ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function (path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Tracks a collection of stats.
 *
 * @constructor
 */
var StatsCollection = /** @class */ (function () {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function (name, amount) {
        if (amount === void 0) { amount = 1; }
        if (!contains(this.counters_, name)) {
            this.counters_[name] = 0;
        }
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function () {
        return deepCopy(this.counters_);
    };
    return StatsCollection;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsManager = /** @class */ (function () {
    function StatsManager() {
    }
    StatsManager.getCollection = function (repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) {
            this.collections_[hashString] = new StatsCollection();
        }
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) {
            this.reporters_[hashString] = creatorFunction();
        }
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */
var StatsListener = /** @class */ (function () {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function () {
        var newStats = this.collection_.get();
        var delta = __assign({}, newStats);
        if (this.last_) {
            each(this.last_, function (stat, value) {
                delta[stat] = delta[stat] - value;
            });
        }
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000;
var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */ (function () {
    /**
     * @param collection
     * @param server_
     */
    function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new StatsListener(collection);
        var timeout = FIRST_STATS_MIN_TIME +
            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function (stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function () {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        each(stats, function (stat, value) {
            if (value > 0 && contains(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) {
            this.server_.reportStats(reportedStats);
        }
        // queue our next run.
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */
var EventQueue = /** @class */ (function () {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */
        this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */
    EventQueue.prototype.queueEvents = function (eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for (var i = 0; i < eventDataList.length; i++) {
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) {
                currList = new EventList(eventPath);
            }
            currList.add(eventData);
        }
        if (currList) {
            this.eventLists_.push(currList);
        }
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */
    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */
    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */
    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for (var i = 0; i < this.eventLists_.length; i++) {
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                }
                else {
                    sentAll = false;
                }
            }
        }
        if (sentAll) {
            this.eventLists_ = [];
        }
        this.recursionDepth_--;
    };
    return EventQueue;
}());
/**
 * @param {!Path} path
 * @constructor
 */
var EventList = /** @class */ (function () {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */
        this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */
    EventList.prototype.add = function (eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */
    EventList.prototype.raise = function () {
        for (var i = 0; i < this.events_.length; i++) {
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if (logger$1) {
                    log('event: ' + eventData.toString());
                }
                exceptionGuard(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */
    EventList.prototype.getPath = function () {
        return this.path_;
    };
    return EventList;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */
var EventEmitter = /** @class */ (function () {
    /**
     * @param {!Array.<string>} allowedEvents_
     */
    function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} varArgs
     */
    EventEmitter.prototype.trigger = function (eventType) {
        var varArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            varArgs[_i - 1] = arguments[_i];
        }
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = __spread$1(this.listeners_[eventType]);
            for (var i = 0; i < listeners.length; i++) {
                listeners[i].callback.apply(listeners[i].context, varArgs);
            }
        }
    };
    EventEmitter.prototype.on = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({ callback: callback, context: context });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) {
            callback.apply(context, eventData);
        }
    };
    EventEmitter.prototype.off = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for (var i = 0; i < listeners.length; i++) {
            if (listeners[i].callback === callback &&
                (!context || context === listeners[i].context)) {
                listeners.splice(i, 1);
                return;
            }
        }
    };
    EventEmitter.prototype.validateEventType_ = function (eventType) {
        assert(this.allowedEvents_.find(function (et) {
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    };
    return EventEmitter;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */ (function (_super) {
    __extends(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, ['visible']) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== 'undefined' &&
            typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            }
            else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            }
            else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            }
            else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) {
            document.addEventListener(visibilityChange, function () {
                var visible = !document[hidden];
                if (visible !== _this.visible_) {
                    _this.visible_ = visible;
                    _this.trigger('visible', visible);
                }
            }, false);
        }
        return _this;
    }
    VisibilityMonitor.getInstance = function () {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
        assert(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [this.visible_];
    };
    return VisibilityMonitor;
}(EventEmitter));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */
var OnlineMonitor = /** @class */ (function (_super) {
    __extends(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, ['online']) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' &&
            typeof window.addEventListener !== 'undefined' &&
            !isMobileCordova()) {
            window.addEventListener('online', function () {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', function () {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger('online', false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function () {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
        assert(eventType === 'online', 'Unknown event type: ' + eventType);
        return [this.online_];
    };
    /**
     * @return {boolean}
     */
    OnlineMonitor.prototype.currentlyOnline = function () {
        return this.online_;
    };
    return OnlineMonitor;
}(EventEmitter));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */
var PacketReceiver = /** @class */ (function () {
    /**
     * @param onMessage_
     */
    function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */
    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function () {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function (i) {
                if (toProcess[i]) {
                    exceptionGuard(function () {
                        _this.onMessage_(toProcess[i]);
                    });
                }
            };
            for (var i = 0; i < toProcess.length; ++i) {
                _loop_2(i);
            }
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while (this.pendingResponses[this.currentResponseNum]) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
    };
    return PacketReceiver;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// URL query parameters associated with longpolling
var FIREBASE_LONGPOLL_START_PARAM = 'start';
var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
var FIREBASE_LONGPOLL_ID_PARAM = 'id';
var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var MAX_URL_DATA_SIZE = 1870;
var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */
var KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */
var LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */
var BrowserPollConnection = /** @class */ (function () {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */
    function BrowserPollConnection(connId, repoInfo, applicationId, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = logWrapper(connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.urlFn = function (params) {
            return repoInfo.connectionURL(LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */
    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function () {
            _this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        executeWhenDOMReady(function () {
            if (_this.isClosed_) {
                return;
            }
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _a = __read$1(args, 5), command = _a[0], arg1 = _a[1], arg2 = _a[2], arg3 = _a[3], arg4 = _a[4];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder) {
                    return; // we closed the connection.
                }
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command === FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                }
                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function () {
                            _this.onClosed_();
                        });
                    }
                    else {
                        _this.onClosed_();
                    }
                }
                else {
                    throw new Error('Unrecognized command received: ' + command);
                }
            }, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _a = __read$1(args, 2), pN = _a[0], data = _a[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function () {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier) {
                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            }
            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
            if (_this.transportSessionId) {
                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            }
            if (_this.lastSessionId) {
                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
            }
            if (_this.applicationId) {
                urlParams[APPLICATION_ID_PARAM] = _this.applicationId;
            }
            if (typeof location !== 'undefined' &&
                location.href &&
                location.href.indexOf(FORGE_DOMAIN) !== -1) {
                urlParams[REFERER_PARAM] = FORGE_REF;
            }
            var connectURL = _this.urlFn(urlParams);
            _this.log_('Connecting via long-poll to ' + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function () {
                /* do nothing */
            });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */
    BrowserPollConnection.prototype.start = function () {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */
    BrowserPollConnection.forceAllow = function () {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */
    BrowserPollConnection.forceDisallow = function () {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function () {
        if (BrowserPollConnection.forceAllow_) {
            return true;
        }
        else {
            // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
            // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
            return (!BrowserPollConnection.forceDisallow_ &&
                typeof document !== 'undefined' &&
                document.createElement != null &&
                !isChromeExtensionContentScript() &&
                !isWindowsStoreApp());
        }
    };
    /**
     * No-op for polling
     */
    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
    /**
     * Stops polling and cleans up the iframe
     * @private
     */
    BrowserPollConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */
    BrowserPollConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */
    BrowserPollConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */
    BrowserPollConnection.prototype.send = function (data) {
        var dataStr = stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = base64Encode(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for (var i = 0; i < dataSegs.length; i++) {
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */
    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
        this.myDisconnFrame = document.createElement('iframe');
        var urlParams = {};
        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */
    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = stringify(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    };
    return BrowserPollConnection;
}());
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/
var FirebaseIFrameScriptHolder = /** @class */ (function () {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */
    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = LUIDGenerator();
            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src &&
                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            }
            catch (e) {
                log('frame writing exception');
                if (e.stack) {
                    log(e.stack);
                }
                log(e);
            }
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */
    FirebaseIFrameScriptHolder.createIFrame_ = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) {
                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                    log('No IE domain setting required');
                }
            }
            catch (e) {
                var domain = document.domain;
                iframe.src =
                    "javascript:void((function(){document.open();document.domain='" +
                        domain +
                        "';document.close();})())";
            }
        }
        else {
            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
            // never gets hit.
            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        }
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) {
            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        }
        else if (iframe.contentWindow) {
            iframe.doc = iframe.contentWindow.document; // Internet Explorer
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        else if (iframe.document) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            iframe.doc = iframe.document; //others?
        }
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */
    FirebaseIFrameScriptHolder.prototype.close = function () {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = '';
            setTimeout(function () {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */
    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while (this.newRequest_()) { }
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */
    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive &&
            this.sendNewPolls &&
            this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = '';
            var i = 0;
            while (this.pendingSegs.length > 0) {
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length +
                    SEG_HEADER_SIZE +
                    curDataString.length <=
                    MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString =
                        curDataString +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
                            i +
                            '=' +
                            theSeg.seg +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
                            i +
                            '=' +
                            theSeg.ts +
                            '&' +
                            FIREBASE_LONGPOLL_DATA_PARAM +
                            i +
                            '=' +
                            theSeg.d;
                    i++;
                }
                else {
                    break;
                }
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */
    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) {
            this.newRequest_();
        }
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */
    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        var doNewRequest = function () {
            _this.outstandingRequests.delete(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function () {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */
    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
        var _this = this;
        {
            setTimeout(function () {
                try {
                    // if we're already closed, don't add this poll
                    if (!_this.sendNewPolls) {
                        return;
                    }
                    var newScript_1 = _this.myIFrame.doc.createElement('script');
                    newScript_1.type = 'text/javascript';
                    newScript_1.async = true;
                    newScript_1.src = url;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    newScript_1.onload = newScript_1.onreadystatechange = function () {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var rstate = newScript_1.readyState;
                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            newScript_1.onload = newScript_1.onreadystatechange = null;
                            if (newScript_1.parentNode) {
                                newScript_1.parentNode.removeChild(newScript_1);
                            }
                            loadCB();
                        }
                    };
                    newScript_1.onerror = function () {
                        log('Long-poll script failed to load: ' + url);
                        _this.sendNewPolls = false;
                        _this.close();
                    };
                    _this.myIFrame.doc.body.appendChild(newScript_1);
                }
                catch (e) {
                    // TODO: we should make this error visible somehow
                }
            }, Math.floor(1));
        }
    };
    return FirebaseIFrameScriptHolder;
}());

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** The semver (www.semver.org) version of the SDK. */
var SDK_VERSION = '';
// SDK_VERSION should be set before any database instance is created
function setSDKVersion(version) {
    SDK_VERSION = version;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WEBSOCKET_MAX_FRAME_SIZE = 16384;
var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') {
    WebSocketImpl = MozWebSocket;
}
else if (typeof WebSocket !== 'undefined') {
    WebSocketImpl = WebSocket;
}
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */
var WebSocketConnection = /** @class */ (function () {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId Optional lastSessionId if there was a previous connection
     */
    function WebSocketConnection(connId, repoInfo, applicationId, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.applicationId = applicationId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = logWrapper(this.connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */
    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
        if (
            typeof location !== 'undefined' &&
            location.href &&
            location.href.indexOf(FORGE_DOMAIN) !== -1) {
            urlParams[REFERER_PARAM] = FORGE_REF;
        }
        if (transportSessionId) {
            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
        }
        if (lastSessionId) {
            urlParams[LAST_SESSION_PARAM] = lastSessionId;
        }
        return repoInfo.connectionURL(WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */
    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        PersistentStorage.set('previous_websocket_failure', true);
        try {
            var device, options, env, proxy; if (isNodeSdk()) ;
            else {
                var options = {
                    headers: {
                        'X-Firebase-GMPID': this.applicationId || ''
                    }
                };
                this.mySock = new WebSocketImpl(this.connURL, [], options);
            }
        }
        catch (e) {
            this.log_('Error instantiating WebSocket.');
            var error = e.message || e.data;
            if (error) {
                this.log_(error);
            }
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function () {
            _this.log_('Websocket connected.');
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function () {
            _this.log_('Websocket connection was disconnected.');
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function (m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function (e) {
            _this.log_('WebSocket error.  Closing connection.');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var error = e.message || e.data;
            if (error) {
                _this.log_(error);
            }
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */
    WebSocketConnection.prototype.start = function () { };
    WebSocketConnection.forceDisallow = function () {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function () {
        var isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
                    isOldAndroid = true;
                }
            }
        }
        return (!isOldAndroid &&
            WebSocketImpl !== null &&
            !WebSocketConnection.forceDisallow_);
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */
    WebSocketConnection.previouslyFailed = function () {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return (PersistentStorage.isInMemoryStorage ||
            PersistentStorage.get('previous_websocket_failure') === true);
    };
    WebSocketConnection.prototype.markConnectionHealthy = function () {
        PersistentStorage.remove('previous_websocket_failure');
    };
    WebSocketConnection.prototype.appendFrame_ = function (data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            var fullMess = this.frames.join('');
            this.frames = null;
            var jsonMess = jsonEval(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */
    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */
    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
        assert(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */
    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
        if (this.mySock === null) {
            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        }
        var data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) {
            // we're buffering
            this.appendFrame_(data);
        }
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) {
                this.appendFrame_(remainingData);
            }
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */
    WebSocketConnection.prototype.send = function (data) {
        this.resetKeepAlive();
        var dataStr = stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) {
            this.sendString_(String(dataSegs.length));
        }
        //Send the actual data in segments.
        for (var i = 0; i < dataSegs.length; i++) {
            this.sendString_(dataSegs[i]);
        }
    };
    WebSocketConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */
    WebSocketConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */
    WebSocketConnection.prototype.resetKeepAlive = function () {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function () {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) {
                _this.sendString_('0');
            }
            _this.resetKeepAlive();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */
    WebSocketConnection.prototype.sendString_ = function (str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        }
        catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */
    WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */
    WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */
var TransportManager = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */
    function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */
        get: function () {
            return [BrowserPollConnection, WebSocketConnection];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */
    TransportManager.prototype.initTransports_ = function (repoInfo) {
        var e_1, _a;
        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) {
                warn$1("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            }
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) {
            this.transports_ = [WebSocketConnection];
        }
        else {
            var transports = (this.transports_ = []);
            try {
                for (var _b = __values(TransportManager.ALL_TRANSPORTS), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var transport = _c.value;
                    if (transport && transport['isAvailable']()) {
                        transports.push(transport);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */
    TransportManager.prototype.initialTransport = function () {
        if (this.transports_.length > 0) {
            return this.transports_[0];
        }
        else {
            throw new Error('No transports available');
        }
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */
    TransportManager.prototype.upgradeTransport = function () {
        if (this.transports_.length > 1) {
            return this.transports_[1];
        }
        else {
            return null;
        }
    };
    return TransportManager;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Abort upgrade attempt if it takes longer than 60s.
var UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
var MESSAGE_TYPE = 't';
var MESSAGE_DATA = 'd';
var CONTROL_SHUTDOWN = 's';
var CONTROL_RESET = 'r';
var CONTROL_ERROR = 'e';
var CONTROL_PONG = 'o';
var SWITCH_ACK = 'a';
var END_TRANSMISSION = 'n';
var PING = 'p';
var SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */
var Connection = /** @class */ (function () {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */
    function Connection(id, repoInfo_, applicationId_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */;
        this.log_ = logWrapper('c:' + this.id + ':');
        this.transportManager_ = new TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */
    Connection.prototype.start_ = function () {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */
        setTimeout(function () {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeoutMS = conn['healthyTimeout'] || 0;
        if (healthyTimeoutMS > 0) {
            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
                _this.healthyTimeout_ = null;
                if (!_this.isHealthy_) {
                    if (_this.conn_ &&
                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has received ' +
                            _this.conn_.bytesReceived +
                            ' bytes.  Marking connection healthy.');
                        _this.isHealthy_ = true;
                        _this.conn_.markConnectionHealthy();
                    }
                    else if (_this.conn_ &&
                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has sent ' +
                            _this.conn_.bytesSent +
                            ' bytes.  Leaving connection alive.');
                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
                        // the server.
                    }
                    else {
                        _this.log_('Closing unhealthy connection after timeout.');
                        _this.close();
                    }
                }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, Math.floor(healthyTimeoutMS));
        }
    };
    /**
     * @return {!string}
     * @private
     */
    Connection.prototype.nextTransportId_ = function () {
        return 'c:' + this.id + ':' + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function (conn) {
        var _this = this;
        return function (everConnected) {
            if (conn === _this.conn_) {
                _this.onConnectionLost_(everConnected);
            }
            else if (conn === _this.secondaryConn_) {
                _this.log_('Secondary connection lost.');
                _this.onSecondaryConnectionLost_();
            }
            else {
                _this.log_('closing an old connection');
            }
        };
    };
    Connection.prototype.connReceiver_ = function (conn) {
        var _this = this;
        return function (message) {
            if (_this.state_ !== 2 /* DISCONNECTED */) {
                if (conn === _this.rx_) {
                    _this.onPrimaryMessageReceived_(message);
                }
                else if (conn === _this.secondaryConn_) {
                    _this.onSecondaryMessageReceived_(message);
                }
                else {
                    _this.log_('message on old connection');
                }
            }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */
    Connection.prototype.sendRequest = function (dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = { t: 'd', d: dataMsg };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function () {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
            // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function (controlData) {
        if (MESSAGE_TYPE in controlData) {
            var cmd = controlData[MESSAGE_TYPE];
            if (cmd === SWITCH_ACK) {
                this.upgradeIfSecondaryHealthy_();
            }
            else if (cmd === CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ ||
                    this.rx_ === this.secondaryConn_) {
                    this.close();
                }
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer === 'c') {
            this.onSecondaryControl_(data);
        }
        else if (layer === 'd') {
            // got a data message, but we're still second connection. Need to buffer it up
            this.pendingDataMessages.push(data);
        }
        else {
            throw new Error('Unknown protocol layer: ' + layer);
        }
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        }
        else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function () {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer === 'c') {
            this.onControl_(data);
        }
        else if (layer === 'd') {
            this.onDataMessage_(data);
        }
    };
    Connection.prototype.onDataMessage_ = function (message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function () {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function (controlData) {
        var cmd = requireKey(MESSAGE_TYPE, controlData);
        if (MESSAGE_DATA in controlData) {
            var payload = controlData[MESSAGE_DATA];
            if (cmd === SERVER_HELLO) {
                this.onHandshake_(payload);
            }
            else if (cmd === END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
                    this.onDataMessage_(this.pendingDataMessages[i]);
                }
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            }
            else if (cmd === CONTROL_SHUTDOWN) {
                // This was previously the 'onKill' callback passed to the lower-level connection
                // payload in this case is the reason for the shutdown. Generally a human-readable error
                this.onConnectionShutdown_(payload);
            }
            else if (cmd === CONTROL_RESET) {
                // payload in this case is the host we should contact
                this.onReset_(payload);
            }
            else if (cmd === CONTROL_ERROR) {
                error('Server Error: ' + payload);
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            }
            else {
                error('Unknown control packet command: ' + cmd);
            }
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */
    Connection.prototype.onHandshake_ = function (handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* CONNECTING */) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if (PROTOCOL_VERSION !== version) {
                warn$1('Protocol version mismatch detected');
            }
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function () {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) {
            this.startUpgrade_(conn);
        }
    };
    Connection.prototype.startUpgrade_ = function (conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ =
            conn['responsesRequiredToBeHealthy'] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        setTimeoutNonBlocking(function () {
            if (_this.secondaryConn_) {
                _this.log_('Timed out trying to upgrade.');
                _this.secondaryConn_.close();
            }
        }, Math.floor(UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function (host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */) {
            this.close();
        }
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
        var _this = this;
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        }
        else {
            setTimeoutNonBlocking(function () {
                _this.sendPingOnPrimaryIfNecessary_();
            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
        }
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
            this.log_('sending ping on primary.');
            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function () {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) {
            // we are relying on this connection already in some capacity. Therefore, a failure is real
            this.close();
        }
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */
    Connection.prototype.onConnectionLost_ = function (everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        }
        else if (this.state_ === 1 /* CONNECTED */) {
            this.log_('Realtime connection lost.');
        }
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */
    Connection.prototype.onConnectionShutdown_ = function (reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function (data) {
        if (this.state_ !== 1 /* CONNECTED */) {
            throw 'Connection is not connected';
        }
        else {
            this.tx_.send(data);
        }
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */
    Connection.prototype.close = function () {
        if (this.state_ !== 2 /* DISCONNECTED */) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* DISCONNECTED */;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     *
     * @private
     */
    Connection.prototype.closeConnections_ = function () {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */
var ServerActions = /** @class */ (function () {
    function ServerActions() {
    }
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, ?string)} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
    /**
     * Refreshes the auth token for the current connection.
     * @param {string} token The authentication token
     */
    ServerActions.prototype.refreshAuthToken = function (token) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
    /**
     * @param {Object.<string, *>} stats
     */
    ServerActions.prototype.reportStats = function (stats) { };
    return ServerActions;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RECONNECT_MIN_DELAY = 1000;
var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
var RECONNECT_DELAY_MULTIPLIER = 1.3;
var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */
var PersistentConnection = /** @class */ (function (_super) {
    __extends(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param repoInfo_ Data about the namespace we are connecting to
     * @param applicationId_ The Firebase App ID for this project
     * @param onDataUpdate_ A callback for new data from the server
     */
    function PersistentConnection(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.applicationId_ = applicationId_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = logWrapper('p:' + _this.id + ':');
        _this.interruptReasons_ = {};
        /** Map<path, Map<queryId, ListenSpec>> */
        _this.listens = new Map();
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        _this.establishConnectionTimer_ = null;
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        _this.realtime_ = null;
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !isNodeSdk()) {
            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        }
        _this.scheduleConnect_(0);
        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
        if (repoInfo_.host.indexOf('fblocal') === -1) {
            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
        }
        return _this;
    }
    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = { r: curReqNum, a: action, b: body };
        this.log_(stringify(msg));
        assert(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) {
            this.requestCBHash_[curReqNum] = onResponse;
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        if (!this.listens.has(pathString)) {
            this.listens.set(pathString, new Map());
        }
        assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
        assert(!this.listens.get(pathString).has(queryId), 'listen() called twice for same path/queryId.');
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) {
            this.sendListen_(listenSpec);
        }
    };
    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query.queryObject();
            req['t'] = listenSpec.tag;
        }
        req[ /*hash*/'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, function (message) {
            var payload = message[ /*data*/'d'];
            var status = message[ /*status*/'s'];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens.get(pathString) &&
                _this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_('listen response', message);
                if (status !== 'ok') {
                    _this.removeListen_(pathString, queryId);
                }
                if (listenSpec.onComplete) {
                    listenSpec.onComplete(status, payload);
                }
            }
        });
    };
    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
        if (payload && typeof payload === 'object' && contains(payload, 'w')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var warnings = safeGet(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                var indexSpec = '".indexOn": "' + query.getQueryParams().getIndex().toString() + '"';
                var indexPath = query.path.toString();
                warn$1("Using an unspecified index. Your data will be downloaded and " +
                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
                    (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.refreshAuthToken = function (token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) {
            this.tryAuth();
        }
        else {
            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
            //the credential so we dont become authenticated next time we connect.
            if (this.connected_) {
                this.sendRequest('unauth', {}, function () { });
            }
        }
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || isAdmin(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */
    PersistentConnection.prototype.tryAuth = function () {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = isValidFormat(token_1) ? 'auth' : 'gauth';
            var requestData = { cred: token_1 };
            if (this.authOverride_ === null) {
                requestData['noauth'] = true;
            }
            else if (typeof this.authOverride_ === 'object') {
                requestData['authvar'] = this.authOverride_;
            }
            this.sendRequest(authMethod, requestData, function (res) {
                var status = res[ /*status*/'s'];
                var data = res[ /*data*/'d'] || 'error';
                if (_this.authToken_ === token_1) {
                    if (status === 'ok') {
                        _this.invalidAuthTokenCount_ = 0;
                    }
                    else {
                        // Triggers reconnect and force refresh for auth token
                        _this.onAuthRevoked_(status, data);
                    }
                }
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.unlisten = function (query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) {
            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
        }
    };
    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('o', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'o',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('om', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'om',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('oc', pathString, null, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'oc',
                data: null,
                onComplete: onComplete
            });
        }
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
        var request = { /*path*/ p: pathString, /*data*/ d: data };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, function (response) {
            if (onComplete) {
                setTimeout(function () {
                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
                }, Math.floor(0));
            }
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) {
            request[ /*hash*/'h'] = hash;
        }
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) {
            this.sendPut_(index);
        }
        else {
            this.log_('Buffering put: ' + pathString);
        }
    };
    PersistentConnection.prototype.sendPut_ = function (index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function (message) {
            _this.log_(action + ' response', message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) {
                _this.outstandingPuts_ = [];
            }
            if (onComplete) {
                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
            }
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.reportStats = function (stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = { /*counters*/ c: stats };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, function (result) {
                var status = result[ /*status*/'s'];
                if (status !== 'ok') {
                    var errorReason = result[ /* data */'d'];
                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    };
    PersistentConnection.prototype.onDataMessage_ = function (message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + stringify(message));
            var reqNum = message['r'];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[ /*body*/'b']);
            }
        }
        else if ('error' in message) {
            throw 'A server-side error has occurred: ' + message['error'];
        }
        else if ('a' in message) {
            // a and b are action and body, respectively
            this.onDataPush_(message['a'], message['b']);
        }
    };
    PersistentConnection.prototype.onDataPush_ = function (action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd') {
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge*/ false, body['t']);
        }
        else if (action === 'm') {
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge=*/ true, body['t']);
        }
        else if (action === 'c') {
            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
        }
        else if (action === 'ac') {
            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
        }
        else if (action === 'sd') {
            this.onSecurityDebugPacket_(body);
        }
        else {
            error('Unrecognized action received from server: ' +
                stringify(action) +
                '\nAre you using the latest client?');
        }
    };
    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) {
            this.sendConnectStats_();
        }
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
        var _this = this;
        assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) {
            clearTimeout(this.establishConnectionTimer_);
        }
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function () {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    };
    PersistentConnection.prototype.onVisible_ = function (visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible &&
            !this.visible_ &&
            this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function (online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) {
                this.realtime_.close();
            }
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            }
            else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT) {
                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
                }
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function () {
        var _this = this;
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function () {
                if (connection_1) {
                    connection_1.close();
                }
                else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function (msg) {
                assert(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_
                .getToken(forceRefresh)
                .then(function (result) {
                if (!canceled_1) {
                    log('getToken() completed. Creating connection.');
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new Connection(connId_1, self_1.repoInfo_, self_1.applicationId_, onDataMessage_1, onReady_1, onDisconnect_1, 
                    /* onKill= */ function (reason) {
                        warn$1(reason + ' (' + self_1.repoInfo_.toString() + ')');
                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                }
                else {
                    log('getToken() completed but was canceled');
                }
            })
                .then(null, function (error) {
                self_1.log_('Failed to get token: ' + error);
                if (!canceled_1) {
                    if (_this.repoInfo_.nodeAdmin) {
                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
                        // But getToken() may also just have temporarily failed, so we still want to
                        // continue retrying.
                        warn$1(error);
                    }
                    closeFn_1();
                }
            });
        }
    };
    PersistentConnection.prototype.interrupt = function (reason) {
        log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) {
            this.realtime_.close();
        }
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) {
                this.onRealtimeDisconnect_();
            }
        }
    };
    PersistentConnection.prototype.resume = function (reason) {
        log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if (isEmpty$4(this.interruptReasons_)) {
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({ serverTimeOffset: delta });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function () {
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete) {
                    put.onComplete('disconnect');
                }
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) {
            this.outstandingPuts_ = [];
        }
    };
    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) {
            queryId = 'default';
        }
        else {
            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
        }
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) {
            listen.onComplete('permission_denied');
        }
    };
    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
        var normalizedPathString = new Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens.has(normalizedPathString)) {
            var map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) {
                this.listens.delete(normalizedPathString);
            }
        }
        else {
            // all listens for this path has already been removed
            listen = undefined;
        }
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
        log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
        if (this.securityDebugCallback_) {
            this.securityDebugCallback_(body);
        }
        else {
            if ('msg' in body) {
                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
            }
        }
    };
    PersistentConnection.prototype.restoreState_ = function () {
        var e_1, _a, e_2, _b;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        try {
            // Puts depend on having received the corresponding data update from the server before they complete, so we must
            // make sure to send listens before puts.
            for (var _c = __values(this.listens.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var queries = _d.value;
                try {
                    for (var _e = (e_2 = void 0, __values(queries.values())), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var listenSpec = _f.value;
                        this.sendListen_(listenSpec);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            if (this.outstandingPuts_[i]) {
                this.sendPut_(i);
            }
        }
        while (this.onDisconnectRequestQueue_.length) {
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     */
    PersistentConnection.prototype.sendConnectStats_ = function () {
        var stats = {};
        var clientName = 'js';
        stats['sdk.' + clientName + '.' + SDK_VERSION.replace(/\./g, '-')] = 1;
        if (isMobileCordova()) {
            stats['framework.cordova'] = 1;
        }
        else if (isReactNative()) {
            stats['framework.reactnative'] = 1;
        }
        this.reportStats(stats);
    };
    PersistentConnection.prototype.shouldReconnect_ = function () {
        var online = OnlineMonitor.getInstance().currentlyOnline();
        return isEmpty$4(this.interruptReasons_) && online;
    };
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     */
    PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}(ServerActions));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */ (function (_super) {
    __extends(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */
    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */
        _this.log_ = logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */
        _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function (stats) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */
    ReadonlyRestClient.getListenId_ = function (query, tag) {
        if (tag !== undefined) {
            return 'tag$' + tag;
        }
        else {
            assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParameters = query
            .getQueryParams()
            .toRestQueryStringParameters();
        this.restRequest_(pathString + '.json', queryStringParameters, function (error, result) {
            var data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            }
            if (safeGet(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error) {
                    status_1 = 'ok';
                }
                else if (error === 401) {
                    status_1 = 'permission_denied';
                }
                else {
                    status_1 = 'rest_error:' + error;
                }
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
        // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */
    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) { queryStringParameters = {}; }
        queryStringParameters['format'] = 'export';
        this.authTokenProvider_
            .getToken(/*forceRefresh=*/ false)
            .then(function (authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) {
                queryStringParameters['auth'] = authToken;
            }
            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
                _this.repoInfo_.host +
                pathString +
                '?' +
                'ns=' +
                _this.repoInfo_.namespace +
                querystring(queryStringParameters);
            _this.log_('Sending REST request for ' + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (callback && xhr.readyState === 4) {
                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = jsonEval(xhr.responseText);
                        }
                        catch (e) {
                            warn$1('Failed to parse JSON response for ' +
                                url +
                                ': ' +
                                xhr.responseText);
                        }
                        callback(null, res);
                    }
                    else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) {
                            warn$1('Got unsuccessful REST response for ' +
                                url +
                                ' Status: ' +
                                xhr.status);
                        }
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}(ServerActions));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INTERRUPT_REASON = 'repo_interrupt';
/**
 * A connection to a single data repository.
 */
var Repo = /** @class */ (function () {
    function Repo(repoInfo_, forceRestClient, app, authTokenProvider) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */
        this.onDisconnect_ = new SparseSnapshotTree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        this.stats_ = StatsManager.getCollection(repoInfo_);
        if (forceRestClient || beingCrawled()) {
            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        }
        else {
            var authOverride = app.options['databaseAuthVariableOverride'];
            // Validate authOverride
            if (typeof authOverride !== 'undefined' && authOverride !== null) {
                if (typeof authOverride !== 'object') {
                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
                }
                try {
                    stringify(authOverride);
                }
                catch (e) {
                    throw new Error('Invalid authOverride provided: ' + e);
                }
            }
            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, app.options.appId, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function (token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
        this.transactionsInit_();
        // Used for .info.
        this.infoData_ = new SnapshotHolder();
        this.infoSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function () {
                        onComplete('ok');
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function () { }
        });
        this.updateInfo_('connected', false);
        this.serverSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function (query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return The URL corresponding to the root of this Firebase.
     */
    Repo.prototype.toString = function () {
        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
    };
    /**
     * @return The namespace represented by the repo.
     */
    Repo.prototype.name = function () {
        return this.repoInfo_.namespace;
    };
    /**
     * @return The time in milliseconds, taking the server offset into account if we have one.
     */
    Repo.prototype.serverTime = function () {
        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     */
    Repo.prototype.generateServerValues = function () {
        return generateWithValues({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     */
    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new Path(pathString);
        data = this.interceptServerDataCallback_
            ? this.interceptServerDataCallback_(pathString, data)
            : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = map$1(data, function (raw) { return nodeFromJSON$1(raw); });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            }
            else {
                var taggedSnap = nodeFromJSON$1(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        }
        else if (isMerge) {
            var changedChildren = map$1(data, function (raw) { return nodeFromJSON$1(raw); });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        }
        else {
            var snap = nodeFromJSON$1(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) {
            // Since we have a listener outstanding for each transaction, receiving any events
            // is a proxy for some change having occurred.
            affectedPath = this.rerunTransactions_(path);
        }
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    // TODO: This should be @private but it's used by test_access.js and internal.js
    Repo.prototype.interceptServerData_ = function (callback) {
        this.interceptServerDataCallback_ = callback;
    };
    Repo.prototype.onConnectStatus_ = function (connectStatus) {
        this.updateInfo_('connected', connectStatus);
        if (connectStatus === false) {
            this.runOnDisconnectEvents_();
        }
    };
    Repo.prototype.onServerInfoUpdate_ = function (updates) {
        var _this = this;
        each(updates, function (key, value) {
            _this.updateInfo_(key, value);
        });
    };
    Repo.prototype.updateInfo_ = function (pathString, value) {
        var path = new Path('/.info/' + pathString);
        var newNode = nodeFromJSON$1(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    Repo.prototype.getNextWriteId_ = function () {
        return this.nextWriteId_++;
    };
    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_('set', {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
        var existing = this.serverSyncTree_.calcCompleteEventCache(path);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
            var success = status === 'ok';
            if (!success) {
                warn$1('set at ' + path + ' failed: ' + status);
            }
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_('update', { path: path.toString(), value: childrenToMerge });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        each(childrenToMerge, function (changedKey, changedValue) {
            empty = false;
            changedChildren[changedKey] = resolveDeferredValueTree(path.child(changedKey), nodeFromJSON$1(changedValue), _this.serverSyncTree_, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
                var success = status === 'ok';
                if (!success) {
                    warn$1('update at ' + path + ' failed: ' + status);
                }
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            each(childrenToMerge, function (changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        }
        else {
            log("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     */
    Repo.prototype.runOnDisconnectEvents_ = function () {
        var _this = this;
        this.log_('onDisconnectEvents');
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = new SparseSnapshotTree();
        this.onDisconnect_.forEachTree(Path.Empty, function (path, node) {
            var resolved = resolveDeferredValueTree(path, node, _this.serverSyncTree_, serverValues);
            resolvedOnDisconnectTree.remember(path, resolved);
        });
        var events = [];
        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
    };
    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.forget(path);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
        var _this = this;
        if (isEmpty$4(childrenToMerge)) {
            log("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
            if (status === 'ok') {
                each(childrenToMerge, function (childName, childNode) {
                    var newChildNode = nodeFromJSON$1(childNode);
                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
                });
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.interrupt(INTERRUPT_REASON);
        }
    };
    Repo.prototype.resume = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.resume(INTERRUPT_REASON);
        }
    };
    Repo.prototype.stats = function (showDelta) {
        if (showDelta === void 0) { showDelta = false; }
        if (typeof console === 'undefined') {
            return;
        }
        var stats;
        if (showDelta) {
            if (!this.statsListener_) {
                this.statsListener_ = new StatsListener(this.stats_);
            }
            stats = this.statsListener_.get();
        }
        else {
            stats = this.stats_.get();
        }
        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        each(stats, function (stat, value) {
            var paddedStat = stat;
            // pad stat names to be the same length (plus 2 extra spaces).
            for (var i = stat.length; i < longestName + 2; i++) {
                paddedStat += ' ';
            }
            console.log(paddedStat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function (metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    Repo.prototype.log_ = function () {
        var varArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            varArgs[_i] = arguments[_i];
        }
        var prefix = '';
        if (this.persistentConnection_) {
            prefix = this.persistentConnection_.id + ':';
        }
        log.apply(void 0, __spread$1([prefix], varArgs));
    };
    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
        if (callback) {
            exceptionGuard(function () {
                if (status === 'ok') {
                    callback(null);
                }
                else {
                    var code = (status || 'error').toUpperCase();
                    var message = code;
                    if (errorReason) {
                        message += ': ' + errorReason;
                    }
                    var error = new Error(message);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    error.code = code;
                    callback(error);
                }
            });
        }
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function () {
            return this.__database || (this.__database = new Database(this));
        },
        enumerable: false,
        configurable: true
    });
    return Repo;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */
var RangedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function RangedFilter(params) {
        this.indexedFilter_ = new IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getStartPost = function () {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getEndPost = function () {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */
    RangedFilter.prototype.matches = function (node) {
        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
            this.index_.compare(node, this.getEndPost()) <= 0);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            newSnap = ChildrenNode.EMPTY_NODE;
        }
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            if (!self.matches(new NamedNode(key, childNode))) {
                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
            }
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndexedFilter = function () {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getStartPost_ = function (params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        }
        else {
            return params.getIndex().minPost();
        }
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getEndPost_ = function (params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        }
        else {
            return params.getIndex().maxPost();
        }
    };
    return RangedFilter;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */
var LimitedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function LimitedFilter(params) {
        this.rangedFilter_ = new RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        if (snap.getImmediateChild(key).equals(newChild)) {
            // No change
            return snap;
        }
        else if (snap.numChildren() < this.limit_) {
            return this.rangedFilter_
                .getIndexedFilter()
                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        }
        else {
            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
        }
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        }
        else {
            if (this.limit_ * 2 < newSnap.numChildren() &&
                newSnap.isIndexed(this.index_)) {
                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
                // anchor to the startPost, endPost, or last element as appropriate
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
                }
                else {
                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
                }
                var count = 0;
                while (iterator.hasNext() && count < this.limit_) {
                    var next = iterator.getNext();
                    var inRange = void 0;
                    if (this.reverse_) {
                        inRange =
                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                    }
                    else {
                        inRange =
                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                    }
                    if (inRange) {
                        filtered = filtered.updateImmediateChild(next.name, next.node);
                        count++;
                    }
                    else {
                        // if we have reached the end post, we cannot keep adding elemments
                        break;
                    }
                }
            }
            else {
                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
                filtered = newSnap.withIndex(this.index_);
                // Don't support priorities on queries
                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
                var startPost = void 0;
                var endPost = void 0;
                var cmp = void 0;
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = filtered.getReverseIterator(this.index_);
                    startPost = this.rangedFilter_.getEndPost();
                    endPost = this.rangedFilter_.getStartPost();
                    var indexCompare_1 = this.index_.getCompare();
                    cmp = function (a, b) { return indexCompare_1(b, a); };
                }
                else {
                    iterator = filtered.getIterator(this.index_);
                    startPost = this.rangedFilter_.getStartPost();
                    endPost = this.rangedFilter_.getEndPost();
                    cmp = this.index_.getCompare();
                }
                var count = 0;
                var foundStartPost = false;
                while (iterator.hasNext()) {
                    var next = iterator.getNext();
                    if (!foundStartPost && cmp(startPost, next) <= 0) {
                        // start adding
                        foundStartPost = true;
                    }
                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                    if (inRange) {
                        count++;
                    }
                    else {
                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
                    }
                }
            }
        }
        return this.rangedFilter_
            .getIndexedFilter()
            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndexedFilter = function () {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */
    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function (a, b) { return indexCmp_1(b, a); };
        }
        else {
            cmp = this.index_.getCompare();
        }
        var oldEventCache = snap;
        assert(oldEventCache.numChildren() === this.limit_, '');
        var newChildNamedNode = new NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_
            ? oldEventCache.getFirstChild(this.index_)
            : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while (nextChild != null &&
                (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name))) {
                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
                // been applied to the limited filter yet. Ignore this next child which will be updated later in
                // the limited filter...
                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            }
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            }
            else {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
                }
                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) {
                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
                    }
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                }
                else {
                    return newEventCache;
                }
            }
        }
        else if (childSnap.isEmpty()) {
            // we're deleting a node, but it was not in the window, so ignore it
            return snap;
        }
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache
                    .updateImmediateChild(childKey, childSnap)
                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
            }
            else {
                return snap;
            }
        }
        else {
            return snap;
        }
    };
    return LimitedFilter;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */
var QueryParams = /** @class */ (function () {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasStart = function () {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */
    QueryParams.prototype.isViewFromLeft = function () {
        if (this.viewFrom_ === '') {
            // limit(), rather than limitToFirst or limitToLast was called.
            // This means that only one of startSet_ and endSet_ is true. Use them
            // to calculate which side of the view to anchor to. If neither is set,
            // anchor to the end.
            return this.startSet_;
        }
        else {
            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
        }
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */
    QueryParams.prototype.getIndexStartValue = function () {
        assert(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexStartName = function () {
        assert(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) {
            return this.indexStartName_;
        }
        else {
            return MIN_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasEnd = function () {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */
    QueryParams.prototype.getIndexEndValue = function () {
        assert(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexEndName = function () {
        assert(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) {
            return this.indexEndName_;
        }
        else {
            return MAX_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasLimit = function () {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */
    QueryParams.prototype.hasAnchoredLimit = function () {
        return this.limitSet_ && this.viewFrom_ !== '';
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */
    QueryParams.prototype.getLimit = function () {
        assert(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    };
    /**
     * @return {!Index}
     */
    QueryParams.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */
    QueryParams.prototype.copy_ = function () {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limit = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = '';
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToFirst = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToLast = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.startAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (indexValue === undefined) {
            indexValue = null;
        }
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        }
        else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = '';
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.endAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (indexValue === undefined) {
            indexValue = null;
        }
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        }
        else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = '';
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */
    QueryParams.prototype.orderBy = function (index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */
    QueryParams.prototype.getQueryObject = function () {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
            }
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
            }
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === '') {
                if (this.isViewFromLeft()) {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                }
                else {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
                }
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== PRIORITY_INDEX) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        }
        return obj;
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.loadsAllData = function () {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.isDefault = function () {
        return this.loadsAllData() && this.index_ === PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */
    QueryParams.prototype.getNodeFilter = function () {
        if (this.loadsAllData()) {
            return new IndexedFilter(this.getIndex());
        }
        else if (this.hasLimit()) {
            return new LimitedFilter(this);
        }
        else {
            return new RangedFilter(this);
        }
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */
    QueryParams.prototype.toRestQueryStringParameters = function () {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) {
            return qs;
        }
        var orderBy;
        if (this.index_ === PRIORITY_INDEX) {
            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        }
        else if (this.index_ === VALUE_INDEX) {
            orderBy = REST_CONSTANTS.VALUE_INDEX;
        }
        else if (this.index_ === KEY_INDEX) {
            orderBy = REST_CONSTANTS.KEY_INDEX;
        }
        else {
            assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = stringify(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = stringify(this.indexStartValue_);
            if (this.startNameSet_) {
                qs[REST_CONSTANTS.START_AT] += ',' + stringify(this.indexStartName_);
            }
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = stringify(this.indexEndValue_);
            if (this.endNameSet_) {
                qs[REST_CONSTANTS.END_AT] += ',' + stringify(this.indexEndName_);
            }
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) {
                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            }
            else {
                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
            }
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: 'sp',
        INDEX_START_NAME: 'sn',
        INDEX_END_VALUE: 'ep',
        INDEX_END_NAME: 'en',
        LIMIT: 'l',
        VIEW_FROM: 'vf',
        VIEW_FROM_LEFT: 'l',
        VIEW_FROM_RIGHT: 'r',
        INDEX: 'i'
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: 'orderBy',
        PRIORITY_INDEX: '$priority',
        VALUE_INDEX: '$value',
        KEY_INDEX: '$key',
        START_AT: 'startAt',
        END_AT: 'endAt',
        LIMIT_TO_FIRST: 'limitToFirst',
        LIMIT_TO_LAST: 'limitToLast'
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */
    QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Reference$1 = /** @class */ (function (_super) {
    __extends(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */
    function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof Repo)) {
            throw new Error('new Reference() no longer supported - use app.database().');
        }
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */
    Reference.prototype.getKey = function () {
        validateArgCount('Reference.key', 0, 0, arguments.length);
        if (this.path.isEmpty()) {
            return null;
        }
        else {
            return this.path.getBack();
        }
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */
    Reference.prototype.child = function (pathString) {
        validateArgCount('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') {
            pathString = String(pathString);
        }
        else if (!(pathString instanceof Path)) {
            if (this.path.getFront() === null) {
                validateRootPathString('Reference.child', 1, pathString, false);
            }
            else {
                validatePathString('Reference.child', 1, pathString, false);
            }
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */
    Reference.prototype.getParent = function () {
        validateArgCount('Reference.parent', 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */
    Reference.prototype.getRoot = function () {
        validateArgCount('Reference.root', 0, 0, arguments.length);
        var ref = this;
        while (ref.getParent() !== null) {
            ref = ref.getParent();
        }
        return ref;
    };
    /** @return {!Database} */
    Reference.prototype.databaseProp = function () {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.set = function (newVal, onComplete) {
        validateArgCount('Reference.set', 1, 2, arguments.length);
        validateWritablePath('Reference.set', this.path);
        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
        validateCallback('Reference.set', 2, onComplete, true);
        var deferred = new Deferred();
        this.repo.setWithPriority(this.path, newVal, 
        /*priority=*/ null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.update = function (objectToMerge, onComplete) {
        validateArgCount('Reference.update', 1, 2, arguments.length);
        validateWritablePath('Reference.update', this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn$1('Passing an Array to Firebase.update() is deprecated. ' +
                'Use set() if you want to overwrite the existing data, or ' +
                'an Object with integer keys if you really do want to ' +
                'only update some of the children.');
        }
        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
        validateCallback('Reference.update', 2, onComplete, true);
        var deferred = new Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
        validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('Reference.setWithPriority', this.path);
        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
        validatePriority('Reference.setWithPriority', 2, newPriority, false);
        validateCallback('Reference.setWithPriority', 3, onComplete, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys') {
            throw ('Reference.setWithPriority failed: ' +
                this.getKey() +
                ' is a read-only object.');
        }
        var deferred = new Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.remove = function (onComplete) {
        validateArgCount('Reference.remove', 0, 1, arguments.length);
        validateWritablePath('Reference.remove', this.path);
        validateCallback('Reference.remove', 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */
    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
        validateArgCount('Reference.transaction', 1, 3, arguments.length);
        validateWritablePath('Reference.transaction', this.path);
        validateCallback('Reference.transaction', 1, transactionUpdate, false);
        validateCallback('Reference.transaction', 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        validateBoolean('Reference.transaction', 3, applyLocally, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys') {
            throw ('Reference.transaction failed: ' +
                this.getKey() +
                ' is a read-only object.');
        }
        if (applyLocally === undefined) {
            applyLocally = true;
        }
        var deferred = new Deferred();
        if (typeof onComplete === 'function') {
            deferred.promise.catch(function () { });
        }
        var promiseComplete = function (error, committed, snapshot) {
            if (error) {
                deferred.reject(error);
            }
            else {
                deferred.resolve(new TransactionResult(committed, snapshot));
            }
            if (typeof onComplete === 'function') {
                onComplete(error, committed, snapshot);
            }
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setPriority = function (priority, onComplete) {
        validateArgCount('Reference.setPriority', 1, 2, arguments.length);
        validateWritablePath('Reference.setPriority', this.path);
        validatePriority('Reference.setPriority', 1, priority, false);
        validateCallback('Reference.setPriority', 2, onComplete, true);
        var deferred = new Deferred();
        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */
    Reference.prototype.push = function (value, onComplete) {
        validateArgCount('Reference.push', 0, 2, arguments.length);
        validateWritablePath('Reference.push', this.path);
        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
        validateCallback('Reference.push', 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = nextPushId(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) {
            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
        }
        else {
            promise = Promise.resolve(pushRef);
        }
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === 'function') {
            promise.catch(function () { });
        }
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */
    Reference.prototype.onDisconnect = function () {
        validateWritablePath('Reference.onDisconnect', this.path);
        return new OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function () {
            return this.databaseProp();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function () {
            return this.getKey();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function () {
            return this.getParent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function () {
            return this.getRoot();
        },
        enumerable: false,
        configurable: true
    });
    return Reference;
}(Query));
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */
Query.__referenceConstructor = Reference$1;
SyncPoint.__referenceConstructor = Reference$1;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Node in a Tree.
 */
var TreeNode = /** @class */ (function () {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}());
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */
var Tree = /** @class */ (function () {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */
    function Tree(name_, parent_, node_) {
        if (name_ === void 0) { name_ = ''; }
        if (parent_ === void 0) { parent_ = null; }
        if (node_ === void 0) { node_ = new TreeNode(); }
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */
    Tree.prototype.subTree = function (pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
        var child = this, next = path.getFront();
        while (next !== null) {
            var childNode = safeGet(child.node_.children, next) || new TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
            next = path.getFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */
    Tree.prototype.getValue = function () {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */
    Tree.prototype.setValue = function (value) {
        assert(typeof value !== 'undefined', 'Cannot set value to undefined');
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */
    Tree.prototype.clear = function () {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */
    Tree.prototype.hasChildren = function () {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */
    Tree.prototype.isEmpty = function () {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachChild = function (action) {
        var _this = this;
        each(this.node_.children, function (child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */
    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst) {
            action(this);
        }
        this.forEachChild(function (child) {
            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
        });
        if (includeSelf && childrenFirst) {
            action(this);
        }
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */
    Tree.prototype.forEachAncestor = function (action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while (node !== null) {
            if (action(node)) {
                return true;
            }
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
        this.forEachChild(function (child) {
            if (child.getValue() !== null) {
                action(child);
            }
            else {
                child.forEachImmediateDescendantWithValue(action);
            }
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */
    Tree.prototype.path = function () {
        return new Path(this.parent_ === null
            ? this.name_
            : this.parent_.path() + '/' + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */
    Tree.prototype.name = function () {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */
    Tree.prototype.parent = function () {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */
    Tree.prototype.updateParents_ = function () {
        if (this.parent_ !== null) {
            this.parent_.updateChild_(this.name_, this);
        }
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */
    Tree.prototype.updateChild_ = function (childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = contains(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        }
        else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */
var TransactionStatus;
(function (TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus || (TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.transactionsInit_ = function () {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */
    this.transactionQueueTree_ = new Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */
Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
    this.log_('transaction on ' + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function () { };
    var watchRef = new Reference$1(this, path);
    watchRef.on('value', valueCallback);
    var unwatcher = function () {
        watchRef.off('value', valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference$1(this, transaction.path), PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    }
    else {
        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === 'object' &&
            newVal !== null &&
            contains(newVal, '.priority')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = safeGet(newVal, '.priority');
            assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
                'Priority must be a valid string, finite number, server value, or null.');
        }
        else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
                ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode /** @type {null|number|string} */ = priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.getLatestState_ = function (path, excludeSets) {
    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
        ChildrenNode.EMPTY_NODE);
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.sendReadyTransactions_ = function (node) {
    var _this = this;
    if (node === void 0) { node = this.transactionQueueTree_; }
    // Before recursing, make sure any completed transactions are removed.
    if (!node) {
        this.pruneCompletedTransactionsBelowNode_(node);
    }
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        assert(queue.length > 0, 'Sending zero length transaction queue');
        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) {
            this.sendTransactionQueue_(node.path(), queue);
        }
    }
    else if (node.hasChildren()) {
        node.forEachChild(function (childNode) {
            _this.sendReadyTransactions_(childNode);
        });
    }
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.sendTransactionQueue_ = function (path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function (txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for (var i = 0; i < queue.length; i++) {
        var txn = queue[i];
        assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */, txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
        _this.log_('transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for (var i = 0; i < queue.length; i++) {
                queue[i].status = TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new Reference$1(_this, queue[i].path);
                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for (var i = 0; i < callbacks.length; i++) {
                exceptionGuard(callbacks[i]);
            }
        }
        else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for (var i = 0; i < queue.length; i++) {
                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
                        queue[i].status = TransactionStatus.NEEDS_ABORT;
                    }
                    else {
                        queue[i].status = TransactionStatus.RUN;
                    }
                }
            }
            else {
                warn$1('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for (var i = 0; i < queue.length; i++) {
                    queue[i].status = TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.rerunTransactions_ = function (changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
    if (queue.length === 0) {
        return; // Nothing to do!
    }
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function (q) {
        return q.status === TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function (q) {
        return q.currentWriteId;
    });
    for (var i = 0; i < queue.length; i++) {
        var transaction = queue[i];
        var relativePath = Path.relativePath(path, transaction.path);
        var abortTransaction = false, abortReason = void 0;
        assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        }
        else if (transaction.status === TransactionStatus.RUN) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            }
            else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    var newDataNode = nodeFromJSON$1(newData);
                    var hasExplicitPriority = typeof newData === 'object' &&
                        newData != null &&
                        contains(newData, '.priority');
                    if (!hasExplicitPriority) {
                        // Keep the old priority if there wasn't a priority explicitly specified.
                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    }
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                }
                else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function (unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') {
                    var ref = new Reference$1(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                }
                else {
                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
                }
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for (var i = 0; i < callbacks.length; i++) {
        exceptionGuard(callbacks[i]);
    }
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.getAncestorTransactionNode_ = function (path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    front = path.getFront();
    while (front !== null && transactionNode.getValue() === null) {
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
        front = path.getFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function (a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) {
        for (var i = 0; i < nodeQueue.length; i++) {
            queue.push(nodeQueue[i]);
        }
    }
    node.forEachChild(function (child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for (var from = 0; from < queue.length; from++) {
            if (queue[from].status !== TransactionStatus.COMPLETED) {
                queue[to] = queue[from];
                to++;
            }
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function (childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.abortTransactions_ = function (path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Repo.prototype.abortTransactionsOnNode_ = function (node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for (var i = 0; i < queue.length; i++) {
            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) ;
            else if (queue[i].status === TransactionStatus.SENT) {
                assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = 'set';
            }
            else {
                assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
                }
            }
        }
        if (lastSent === -1) {
            // We're not waiting for any sent transactions.  We can clear the queue.
            node.setValue(null);
        }
        else {
            // Remove the transactions we aborted.
            queue.length = lastSent + 1;
        }
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for (var i = 0; i < callbacks.length; i++) {
            exceptionGuard(callbacks[i]);
        }
    }
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */
var FirebaseAuthTokenProvider = /** @class */ (function () {
    function FirebaseAuthTokenProvider(app_, authProvider_) {
        var _this = this;
        this.app_ = app_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({ optional: true });
        if (!this.auth_) {
            authProvider_.get().then(function (auth) { return (_this.auth_ = auth); });
        }
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */
    FirebaseAuthTokenProvider.prototype.getToken = function (forceRefresh) {
        if (!this.auth_) {
            return Promise.resolve(null);
        }
        return this.auth_.getToken(forceRefresh).catch(function (error) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            }
            else {
                return Promise.reject(error);
            }
        });
    };
    FirebaseAuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) {
            this.auth_.addAuthTokenListener(listener);
        }
        else {
            setTimeout(function () { return listener(null); }, 0);
            this.authProvider_
                .get()
                .then(function (auth) { return auth.addAuthTokenListener(listener); });
        }
    };
    FirebaseAuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
        this.authProvider_
            .get()
            .then(function (auth) { return auth.removeAuthTokenListener(listener); });
    };
    FirebaseAuthTokenProvider.prototype.notifyForInvalidToken = function () {
        var errorMessage = 'Provided authentication credentials for the app named "' +
            this.app_.name +
            '" are invalid. This usually indicates your app was not ' +
            'initialized correctly. ';
        if ('credential' in this.app_.options) {
            errorMessage +=
                'Make sure the "credential" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else if ('serviceAccount' in this.app_.options) {
            errorMessage +=
                'Make sure the "serviceAccount" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else {
            errorMessage +=
                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
                    'initializeApp() match the values provided for your app at ' +
                    'https://console.firebase.google.com/.';
        }
        warn$1(errorMessage);
    };
    return FirebaseAuthTokenProvider;
}());
/* Auth token provider that the Admin SDK uses to connect to the Emulator. */
var EmulatorAdminTokenProvider = /** @class */ (function () {
    function EmulatorAdminTokenProvider() {
    }
    EmulatorAdminTokenProvider.prototype.getToken = function (forceRefresh) {
        return Promise.resolve({
            accessToken: EmulatorAdminTokenProvider.EMULATOR_AUTH_TOKEN
        });
    };
    EmulatorAdminTokenProvider.prototype.addTokenChangeListener = function (listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(EmulatorAdminTokenProvider.EMULATOR_AUTH_TOKEN);
    };
    EmulatorAdminTokenProvider.prototype.removeTokenChangeListener = function (listener) { };
    EmulatorAdminTokenProvider.prototype.notifyForInvalidToken = function () { };
    EmulatorAdminTokenProvider.EMULATOR_AUTH_TOKEN = 'owner';
    return EmulatorAdminTokenProvider;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This variable is also defined in the firebase node.js admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */
var FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
var _staticInstance;
/**
 * Creates and caches Repo instances.
 */
var RepoManager = /** @class */ (function () {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */
        this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */
        this.useRestClient_ = false;
    }
    RepoManager.getInstance = function () {
        if (!_staticInstance) {
            _staticInstance = new RepoManager();
        }
        return _staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function () {
        var e_1, _a, e_2, _b;
        try {
            for (var _c = __values(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var appName = _d.value;
                try {
                    for (var _e = (e_2 = void 0, __values(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var dbUrl = _f.value;
                        this.repos_[appName][dbUrl].interrupt();
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    RepoManager.prototype.resume = function () {
        var e_3, _a, e_4, _b;
        try {
            for (var _c = __values(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var appName = _d.value;
                try {
                    for (var _e = (e_4 = void 0, __values(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var dbUrl = _f.value;
                        this.repos_[appName][dbUrl].resume();
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */
    RepoManager.prototype.databaseFromApp = function (app, authProvider, url, nodeAdmin) {
        var dbUrl = url || app.options.databaseURL;
        if (dbUrl === undefined) {
            if (!app.options.projectId) {
                fatal("Can't determine Firebase Database URL. Be sure to include " +
                    ' a Project ID when calling firebase.initializeApp().');
            }
            log('Using default host for project ', app.options.projectId);
            dbUrl = app.options.projectId + "-default-rtdb.firebaseio.com";
        }
        var parsedUrl = parseRepoInfo(dbUrl, nodeAdmin);
        var repoInfo = parsedUrl.repoInfo;
        var isEmulator;
        var dbEmulatorHost = undefined;
        if (typeof process !== 'undefined') {
            dbEmulatorHost = process.env[FIREBASE_DATABASE_EMULATOR_HOST_VAR];
        }
        if (dbEmulatorHost) {
            isEmulator = true;
            dbUrl = "http://" + dbEmulatorHost + "?ns=" + repoInfo.namespace;
            parsedUrl = parseRepoInfo(dbUrl, nodeAdmin);
            repoInfo = parsedUrl.repoInfo;
        }
        else {
            isEmulator = !parsedUrl.repoInfo.secure;
        }
        var authTokenProvider = nodeAdmin && isEmulator
            ? new EmulatorAdminTokenProvider()
            : new FirebaseAuthTokenProvider(app, authProvider);
        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) {
            fatal('Database URL must point to the root of a Firebase Database ' +
                '(not including a child path).');
        }
        var repo = this.createRepo(repoInfo, app, authTokenProvider);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */
    RepoManager.prototype.deleteRepo = function (repo) {
        var appRepos = safeGet(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        }
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */
    RepoManager.prototype.createRepo = function (repoInfo, app, authTokenProvider) {
        var appRepos = safeGet(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = safeGet(appRepos, repoInfo.toURLString());
        if (repo) {
            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
        }
        repo = new Repo(repoInfo, this.useRestClient_, app, authTokenProvider);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */
    RepoManager.prototype.forceRestClient = function (forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */
var Database = /** @class */ (function () {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */
    function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof Repo)) {
            fatal("Don't call new Database() directly - please use firebase.database().");
        }
        /** @type {Reference} */
        this.root_ = new Reference$1(repo_, Path.Empty);
        this.INTERNAL = new DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function () {
            return this.repo_.app;
        },
        enumerable: false,
        configurable: true
    });
    Database.prototype.ref = function (path) {
        this.checkDeleted_('ref');
        validateArgCount('database.ref', 0, 1, arguments.length);
        if (path instanceof Reference$1) {
            return this.refFromURL(path.toString());
        }
        return path !== undefined ? this.root_.child(path) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.refFromURL = function (url) {
        /** @const {string} */
        var apiName = 'database.refFromURL';
        this.checkDeleted_(apiName);
        validateArgCount(apiName, 1, 1, arguments.length);
        var parsedURL = parseRepoInfo(url, this.repo_.repoInfo_.nodeAdmin);
        validateUrl(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) {
            fatal(apiName +
                ': Host name does not match the current database: ' +
                '(found ' +
                repoInfo.host +
                ' but expected ' +
                this.repo_.repoInfo_.host +
                ')');
        }
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */
    Database.prototype.checkDeleted_ = function (apiName) {
        if (this.repo_ === null) {
            fatal('Cannot call ' + apiName + ' on a deleted database.');
        }
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function () {
        validateArgCount('database.goOffline', 0, 0, arguments.length);
        this.checkDeleted_('goOffline');
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function () {
        validateArgCount('database.goOnline', 0, 0, arguments.length);
        this.checkDeleted_('goOnline');
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            '.sv': 'timestamp'
        },
        increment: function (delta) {
            return {
                '.sv': {
                    'increment': delta
                }
            };
        }
    };
    return Database;
}());
var DatabaseInternals = /** @class */ (function () {
    /** @param {!Database} database */
    function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */
    DatabaseInternals.prototype.delete = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.database.checkDeleted_('delete');
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                RepoManager.getInstance().deleteRepo(this.database.repo_);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.database.repo_ = null;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.database.root_ = null;
                this.database.INTERNAL = null;
                this.database = null;
                return [2 /*return*/];
            });
        });
    };
    return DatabaseInternals;
}());

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */
var forceLongPolling = function () {
    WebSocketConnection.forceDisallow();
    BrowserPollConnection.forceAllow();
};
var forceWebSockets = function () {
    BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */
var isWebSocketsAvailable = function () {
    return WebSocketConnection['isAvailable']();
};
var setSecurityDebugCallback = function (ref, callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var stats = function (ref, showDelta) {
    ref.repo.stats(showDelta);
};
var statsIncrementCounter = function (ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
var dataUpdateCount = function (ref) {
    return ref.repo.dataUpdateCount;
};
var interceptServerData = function (ref, callback) {
    return ref.repo.interceptServerData_(callback);
};

var INTERNAL = /*#__PURE__*/Object.freeze({
  __proto__: null,
  forceLongPolling: forceLongPolling,
  forceWebSockets: forceWebSockets,
  isWebSocketsAvailable: isWebSocketsAvailable,
  setSecurityDebugCallback: setSecurityDebugCallback,
  stats: stats,
  statsIncrementCounter: statsIncrementCounter,
  dataUpdateCount: dataUpdateCount,
  interceptServerData: interceptServerData
});

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataConnection = PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
    this.sendRequest('q', { p: pathString }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
PersistentConnection.prototype.echo = function (data, onEcho) {
    this.sendRequest('echo', { d: data }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var RealTimeConnection = Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */
var hijackHash = function (newHash) {
    var oldPut = PersistentConnection.prototype.put;
    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
        if (hash !== undefined) {
            hash = newHash();
        }
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function () {
        PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */
var ConnectionTarget = RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */
var queryIdentifier = function (query) {
    return query.queryIdentifier();
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */
var forceRestClient = function (forceRestClient) {
    RepoManager.getInstance().forceRestClient(forceRestClient);
};

var TEST_ACCESS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DataConnection: DataConnection,
  RealTimeConnection: RealTimeConnection,
  hijackHash: hijackHash,
  ConnectionTarget: ConnectionTarget,
  queryIdentifier: queryIdentifier,
  forceRestClient: forceRestClient
});

var name$e = "@firebase/database";
var version$3 = "0.6.13";

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ServerValue = Database.ServerValue;
function registerDatabase(instance) {
    // set SDK_VERSION
    setSDKVersion(instance.SDK_VERSION);
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerComponent(new Component('database', function (container, url) {
        /* Dependencies */
        // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider('app').getImmediate();
        var authProvider = container.getProvider('auth-internal');
        return RepoManager.getInstance().databaseFromApp(app, authProvider, url);
    }, "PUBLIC" /* PUBLIC */)
        .setServiceProps(
    // firebase.database namespace properties
    {
        Reference: Reference$1,
        Query: Query,
        Database: Database,
        DataSnapshot: DataSnapshot,
        enableLogging: enableLogging,
        INTERNAL: INTERNAL,
        ServerValue: ServerValue,
        TEST_ACCESS: TEST_ACCESS
    })
        .setMultipleInstances(true));
    instance.registerVersion(name$e, version$3);
}
registerDatabase(firebase$1);

var firebaseConfig = {
  apiKey: 'AIzaSyBjCAu7xKf-vGDWWAZvjdA8JdctVQLVt3I',
  authDomain: 'living-security-engineering.firebaseapp.com',
  databaseURL: 'https://living-security-engineering.firebaseio.com',
  projectId: 'living-security-engineering',
  appId: '1:419324971525:web:65d86aacc75c473d8d6a6c',
  measurementId: 'G-MV6X71M3ZR'
};

var ENTRANCE_EXAM_PUZZLES = 'puzzles/entrance-exam';
var MOUSE_ROUTE = 'mouse';
var STATE_ROUTE = 'state';
var FIREBASE_LS_KEY = 'GQMQk9REnc'; // Random string

if (firebase$1 && firebase$1.initializeApp) {
  firebase$1.initializeApp(firebaseConfig);
} // This function completely overwrites with the entire `route` branch with the `update` object you pass in


function updateRealtime() {
  var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_ROUTE;
  var roomId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var update = arguments.length > 2 ? arguments[2] : undefined;

  if (!firebase$1) {
    return;
  }

  return firebase$1.database().ref("".concat(ENTRANCE_EXAM_PUZZLES, "/").concat(roomId, "/").concat(route, "/")).update(_objectSpread2({
    key: FIREBASE_LS_KEY,
    lastUpdated: hooks().format('x')
  }, update));
}

function useFirebaseMouseState(roomId) {
  return useObjectVal(firebase$1.database().ref("".concat(ENTRANCE_EXAM_PUZZLES, "/").concat(roomId, "/").concat(MOUSE_ROUTE, "/")));
}
function useFirebasePuzzleState(roomId) {
  return useObjectVal(firebase$1.database().ref("".concat(ENTRANCE_EXAM_PUZZLES, "/").concat(roomId, "/").concat(STATE_ROUTE, "/")));
}

var throttle = function throttle(func, limit) {
  var inThrottle;
  return function () {
    var args = arguments;
    var context = this;

    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(function () {
        return inThrottle = false;
      }, limit);
    }
  };
};
var COLORS = {
  red: {
    default: '#FF3366',
    dim: '#501D2A'
  },
  yellow: {
    default: '#FFBB00',
    dim: '#503F10'
  },
  blue: {
    default: '#0088FF',
    dim: '#103250'
  },
  green: {
    default: '#22DD88',
    dim: '#194832'
  },
  orange: {
    default: '#FF8800',
    dim: '#503210'
  },
  pink: {
    default: '#FF0099',
    dim: '#501037'
  },
  purple: {
    default: '#AA44FF',
    dim: '#3B2150'
  }
};
function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

var MOUSE_DELAY = 150;
var GlobalContext = /*#__PURE__*/React$2.createContext({});
var PuzzleProvider = function PuzzleProvider(_ref) {
  var socket = _ref.socket,
      _ref$provider = _ref.provider,
      provider = _ref$provider === void 0 ? PuzzleProviders.LOCAL : _ref$provider,
      reducer = _ref.reducer,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? {} : _ref$state,
      children = _ref.children,
      roomId = _ref.roomId;
  var mouseState, latestState, dispatch, mouseLoading, stateLoading, mouseError, stateError;

  if (provider === PuzzleProviders.SOCKET_IO) {
    mouseState = useSocketIOMouseState(socket, state);
    latestState = useSocketIOPuzzleState(socket, state);

    dispatch = function dispatch() {};
  } else if (provider === PuzzleProviders.FIREBASE) {
    var _useFirebaseMouseStat = useFirebaseMouseState(roomId);

    var _useFirebaseMouseStat2 = _slicedToArray(_useFirebaseMouseStat, 3);

    mouseState = _useFirebaseMouseStat2[0];
    mouseLoading = _useFirebaseMouseStat2[1];
    mouseError = _useFirebaseMouseStat2[2];

    var _useFirebasePuzzleSta = useFirebasePuzzleState(roomId);

    var _useFirebasePuzzleSta2 = _slicedToArray(_useFirebasePuzzleSta, 3);

    latestState = _useFirebasePuzzleSta2[0];
    stateLoading = _useFirebasePuzzleSta2[1];
    stateError = _useFirebasePuzzleSta2[2];

    dispatch = function dispatch() {};
  } else {
    var _useReducer = React$2.useReducer(reducer, state),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        localState = _useReducer2[0],
        localDispatch = _useReducer2[1];

    latestState = localState;
    dispatch = localDispatch;
  }

  function connect(roomId) {
    if (provider === PuzzleProviders.SOCKET_IO) {
      socket && socket.emit('join', roomId);
    }
  }

  function updateState(newState) {
    if (provider === PuzzleProviders.SOCKET_IO) {
      socket && socket.emit('updateState', roomId, newState);
    } else if (provider === PuzzleProviders.FIREBASE) {
      updateRealtime(STATE_ROUTE, roomId, newState);
    } else {
      dispatch({
        type: UPDATE_STATE,
        payload: _objectSpread2({}, newState)
      });
    }
  }

  function onCursorPositionChanged(_ref2) {
    var x = _ref2.x,
        y = _ref2.y;

    if (provider === PuzzleProviders.SOCKET_IO) {
      socket && socket.emit('mouseMove', roomId, {
        x: x,
        y: y
      });
    } else if (provider === PuzzleProviders.FIREBASE) {
      updateRealtime(MOUSE_ROUTE, roomId, {
        x: x,
        y: y
      });
    }
  }

  var setMousePosition = React$2.useCallback(throttle(onCursorPositionChanged, MOUSE_DELAY), []);

  var _useState = React$2.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mouseVisible = _useState2[0],
      setMouseVisibility = _useState2[1];

  return /*#__PURE__*/React__default['default'].createElement(GlobalContext.Provider, {
    value: {
      connect: connect,
      updateState: updateState,
      setMousePosition: setMousePosition,
      setMouseVisibility: setMouseVisibility,
      state: _objectSpread2(_objectSpread2(_objectSpread2({
        mouseVisible: mouseVisible
      }, mouseState), latestState), {}, {
        mouseLoading: mouseLoading,
        stateLoading: stateLoading,
        mouseError: mouseError,
        stateError: stateError
      })
    }
  }, children);
};

function PuzzleView(props) {
  var _useContext = React$2.useContext(GlobalContext),
      connect = _useContext.connect,
      setMousePosition = _useContext.setMousePosition,
      setMouseVisibility = _useContext.setMouseVisibility,
      updateState = _useContext.updateState,
      state = _useContext.state;

  React$2.useEffect(function () {
    connect(props.roomId);
  }, []);

  function onMouseMove(e) {
    if (props.isLeader) {
      if (!state.mouseVisible) {
        setMouseVisibility(true);
      }

      setMousePosition({
        x: e.clientX,
        y: e.clientY
      });
    }
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    onMouseMove: onMouseMove.bind(this),
    onMouseLeave: function onMouseLeave() {
      return props.isLeader && setMouseVisibility(false);
    },
    onMouseEnter: function onMouseEnter() {
      return props.isLeader && setMouseVisibility(true);
    },
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      overflowX: 'hidden'
    }
  }, /*#__PURE__*/React__default['default'].createElement(DynamicImport, {
    load: props.load
  }, function (Component) {
    return Component === null ? /*#__PURE__*/React__default['default'].createElement("div", null) : !!state && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Component, _extends({
      updateState: updateState,
      context: GlobalContext
    }, props, state)));
  }));
}

function PuzzleWrapper(props) {
  return /*#__PURE__*/React__default['default'].createElement(PuzzleProvider, props, /*#__PURE__*/React__default['default'].createElement(PuzzleView, props));
}
PuzzleWrapper.propTypes = {
  load: PropTypes__default['default'].func.isRequired,
  socket: PropTypes__default['default'].object,
  roomId: PropTypes__default['default'].string,
  userId: PropTypes__default['default'].string,
  isLeader: PropTypes__default['default'].bool,
  provider: PropTypes__default['default'].string.isRequired,
  reducer: PropTypes__default['default'].func,
  children: PropTypes__default['default'].any
};
PuzzleWrapper.defaultProps = {
  roomId: isLocal$2 ? 'DEV-ROOM' : "ROOM-".concat(getRandomInt(200)),
  userId: "".concat(getRandomInt(200)),
  isLeader: isLocal$2 && isLeader,
  provider: PuzzleProviders.FIREBASE,
  reducer: function reducer() {}
};

var warning$4 = function () { };
var invariant$3 = function () { };
if (process.env.NODE_ENV !== 'production') {
    warning$4 = function (check, message) {
        if (!check && typeof console !== 'undefined') {
            console.warn(message);
        }
    };
    invariant$3 = function (check, message) {
        if (!check) {
            throw new Error(message);
        }
    };
}

var prevTime = 0;
var onNextFrame = typeof window !== 'undefined' && window.requestAnimationFrame !== undefined ? function (callback) {
    return window.requestAnimationFrame(callback);
} : function (callback) {
    var timestamp = Date.now();
    var timeToCall = Math.max(0, 16.7 - (timestamp - prevTime));
    prevTime = timestamp + timeToCall;
    setTimeout(function () {
        return callback(prevTime);
    }, timeToCall);
};

var createStep = function (setRunNextFrame) {
    var processToRun = [];
    var processToRunNextFrame = [];
    var numThisFrame = 0;
    var isProcessing = false;
    var i = 0;
    var cancelled = new WeakSet();
    var toKeepAlive = new WeakSet();
    var renderStep = {
        cancel: function (process) {
            var indexOfCallback = processToRunNextFrame.indexOf(process);
            cancelled.add(process);
            if (indexOfCallback !== -1) {
                processToRunNextFrame.splice(indexOfCallback, 1);
            }
        },
        process: function (frame) {
            var _a;
            isProcessing = true;
            _a = [processToRunNextFrame, processToRun], processToRun = _a[0], processToRunNextFrame = _a[1];
            processToRunNextFrame.length = 0;
            numThisFrame = processToRun.length;
            if (numThisFrame) {
                var process_1;
                for (i = 0; i < numThisFrame; i++) {
                    process_1 = processToRun[i];
                    process_1(frame);
                    if (toKeepAlive.has(process_1) === true && !cancelled.has(process_1)) {
                        renderStep.schedule(process_1);
                        setRunNextFrame(true);
                    }
                }
            }
            isProcessing = false;
        },
        schedule: function (process, keepAlive, immediate) {
            if (keepAlive === void 0) {
                keepAlive = false;
            }
            if (immediate === void 0) {
                immediate = false;
            }
            invariant$3(typeof process === "function", "Argument must be a function");
            var addToCurrentBuffer = immediate && isProcessing;
            var buffer = addToCurrentBuffer ? processToRun : processToRunNextFrame;
            cancelled.delete(process);
            if (keepAlive) toKeepAlive.add(process);
            if (buffer.indexOf(process) === -1) {
                buffer.push(process);
                if (addToCurrentBuffer) numThisFrame = processToRun.length;
            }
        }
    };
    return renderStep;
};

var maxElapsed = 40;
var defaultElapsed = 1 / 60 * 1000;
var useDefaultElapsed = true;
var willRunNextFrame = false;
var isProcessing = false;
var frame = {
    delta: 0,
    timestamp: 0
};
var stepsOrder = ["read", "update", "preRender", "render", "postRender"];
var setWillRunNextFrame = function (willRun) {
    return willRunNextFrame = willRun;
};
var steps = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = createStep(setWillRunNextFrame);
    return acc;
}, {});
var sync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    var step = steps[key];
    acc[key] = function (process, keepAlive, immediate) {
        if (keepAlive === void 0) {
            keepAlive = false;
        }
        if (immediate === void 0) {
            immediate = false;
        }
        if (!willRunNextFrame) startLoop();
        step.schedule(process, keepAlive, immediate);
        return process;
    };
    return acc;
}, {});
var cancelSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
var processStep = function (stepId) {
    return steps[stepId].process(frame);
};
var processFrame = function (timestamp) {
    willRunNextFrame = false;
    frame.delta = useDefaultElapsed ? defaultElapsed : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
    if (!useDefaultElapsed) defaultElapsed = frame.delta;
    frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (willRunNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
var startLoop = function () {
    willRunNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing) onNextFrame(processFrame);
};
var getFrameData = function () {
    return frame;
};

var clamp = function (min, max) { return function (v) {
    return Math.max(Math.min(v, max), min);
}; };
var sanitize = function (v) { return (v % 1 ? Number(v.toFixed(5)) : v); };
var floatRegex = /(-)?(\d[\d\.]*)/g;
var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;

var number = {
    test: function (v) { return typeof v === 'number'; },
    parse: parseFloat,
    transform: function (v) { return v; }
};
var alpha = __assign(__assign({}, number), { transform: clamp(0, 1) });
var scale = __assign(__assign({}, number), { default: 1 });

var createUnitType = function (unit) { return ({
    test: function (v) {
        return typeof v === 'string' && v.endsWith(unit) && v.split(' ').length === 1;
    },
    parse: parseFloat,
    transform: function (v) { return "" + v + unit; }
}); };
var degrees = createUnitType('deg');
var percent = createUnitType('%');
var px = createUnitType('px');
var vh = createUnitType('vh');
var vw = createUnitType('vw');
var progressPercentage = __assign(__assign({}, percent), { parse: function (v) { return percent.parse(v) / 100; }, transform: function (v) { return percent.transform(v * 100); } });

var getValueFromFunctionString = function (value) {
    return value.substring(value.indexOf('(') + 1, value.lastIndexOf(')'));
};
var clampRgbUnit = clamp(0, 255);
var isRgba = function (v) { return v.red !== undefined; };
var isHsla = function (v) { return v.hue !== undefined; };
function getValuesAsArray(value) {
    return getValueFromFunctionString(value)
        .replace(/(,|\/)/g, ' ')
        .split(/ \s*/);
}
var splitColorValues = function (terms) {
    return function (v) {
        if (typeof v !== 'string')
            return v;
        var values = {};
        var valuesArray = getValuesAsArray(v);
        for (var i = 0; i < 4; i++) {
            values[terms[i]] =
                valuesArray[i] !== undefined ? parseFloat(valuesArray[i]) : 1;
        }
        return values;
    };
};
var rgbaTemplate = function (_a) {
    var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha = _b === void 0 ? 1 : _b;
    return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
};
var hslaTemplate = function (_a) {
    var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha = _b === void 0 ? 1 : _b;
    return "hsla(" + hue + ", " + saturation + ", " + lightness + ", " + alpha + ")";
};
var rgbUnit = __assign(__assign({}, number), { transform: function (v) { return Math.round(clampRgbUnit(v)); } });
function isColorString(color, colorType) {
    return color.startsWith(colorType) && singleColorRegex.test(color);
}
var rgba = {
    test: function (v) { return (typeof v === 'string' ? isColorString(v, 'rgb') : isRgba(v)); },
    parse: splitColorValues(['red', 'green', 'blue', 'alpha']),
    transform: function (_a) {
        var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return rgbaTemplate({
            red: rgbUnit.transform(red),
            green: rgbUnit.transform(green),
            blue: rgbUnit.transform(blue),
            alpha: sanitize(alpha.transform(alpha$1))
        });
    }
};
var hsla = {
    test: function (v) { return (typeof v === 'string' ? isColorString(v, 'hsl') : isHsla(v)); },
    parse: splitColorValues(['hue', 'saturation', 'lightness', 'alpha']),
    transform: function (_a) {
        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return hslaTemplate({
            hue: Math.round(hue),
            saturation: percent.transform(sanitize(saturation)),
            lightness: percent.transform(sanitize(lightness)),
            alpha: sanitize(alpha.transform(alpha$1))
        });
    }
};
var hex = __assign(__assign({}, rgba), { test: function (v) { return typeof v === 'string' && isColorString(v, '#'); }, parse: function (v) {
        var r = '';
        var g = '';
        var b = '';
        if (v.length > 4) {
            r = v.substr(1, 2);
            g = v.substr(3, 2);
            b = v.substr(5, 2);
        }
        else {
            r = v.substr(1, 1);
            g = v.substr(2, 1);
            b = v.substr(3, 1);
            r += r;
            g += g;
            b += b;
        }
        return {
            red: parseInt(r, 16),
            green: parseInt(g, 16),
            blue: parseInt(b, 16),
            alpha: 1
        };
    } });
var color = {
    test: function (v) {
        return (typeof v === 'string' && singleColorRegex.test(v)) ||
            isRgba(v) ||
            isHsla(v);
    },
    parse: function (v) {
        if (rgba.test(v)) {
            return rgba.parse(v);
        }
        else if (hsla.test(v)) {
            return hsla.parse(v);
        }
        else if (hex.test(v)) {
            return hex.parse(v);
        }
        return v;
    },
    transform: function (v) {
        if (isRgba(v)) {
            return rgba.transform(v);
        }
        else if (isHsla(v)) {
            return hsla.transform(v);
        }
        return v;
    }
};

var COLOR_TOKEN = '${c}';
var NUMBER_TOKEN = '${n}';
var convertNumbersToZero = function (v) {
    return typeof v === 'number' ? 0 : v;
};
var complex = {
    test: function (v) {
        if (typeof v !== 'string' || !isNaN(v))
            return false;
        var numValues = 0;
        var foundNumbers = v.match(floatRegex);
        var foundColors = v.match(colorRegex);
        if (foundNumbers)
            numValues += foundNumbers.length;
        if (foundColors)
            numValues += foundColors.length;
        return numValues > 0;
    },
    parse: function (v) {
        var input = v;
        var parsed = [];
        var foundColors = input.match(colorRegex);
        if (foundColors) {
            input = input.replace(colorRegex, COLOR_TOKEN);
            parsed.push.apply(parsed, foundColors.map(color.parse));
        }
        var foundNumbers = input.match(floatRegex);
        if (foundNumbers) {
            parsed.push.apply(parsed, foundNumbers.map(number.parse));
        }
        return parsed;
    },
    createTransformer: function (prop) {
        var template = prop;
        var token = 0;
        var foundColors = prop.match(colorRegex);
        var numColors = foundColors ? foundColors.length : 0;
        if (foundColors) {
            for (var i = 0; i < numColors; i++) {
                template = template.replace(foundColors[i], COLOR_TOKEN);
                token++;
            }
        }
        var foundNumbers = template.match(floatRegex);
        var numNumbers = foundNumbers ? foundNumbers.length : 0;
        if (foundNumbers) {
            for (var i = 0; i < numNumbers; i++) {
                template = template.replace(foundNumbers[i], NUMBER_TOKEN);
                token++;
            }
        }
        return function (v) {
            var output = template;
            for (var i = 0; i < token; i++) {
                output = output.replace(i < numColors ? COLOR_TOKEN : NUMBER_TOKEN, i < numColors ? color.transform(v[i]) : sanitize(v[i]));
            }
            return output;
        };
    },
    getAnimatableNone: function (target) {
        var parsedTarget = complex.parse(target);
        var targetTransformer = complex.createTransformer(target);
        return targetTransformer(parsedTarget.map(convertNumbersToZero));
    }
};

var clamp$1 = function (min, max, v) {
    return Math.min(Math.max(v, min), max);
};

var safeMin = 0.001;
var minDuration = 0.01;
var maxDuration = 10.0;
var minDamping = 0.05;
var maxDamping = 1;
function findSpring(_a) {
    var _b = _a.duration,
        duration = _b === void 0 ? 800 : _b,
        _c = _a.bounce,
        bounce = _c === void 0 ? 0.25 : _c,
        _d = _a.velocity,
        velocity = _d === void 0 ? 0 : _d,
        _e = _a.mass,
        mass = _e === void 0 ? 1 : _e;
    var envelope;
    var derivative;
    warning$4(duration <= maxDuration * 1000, "Spring duration must be 10 seconds or less");
    var dampingRatio = 1 - bounce;
    dampingRatio = clamp$1(minDamping, maxDamping, dampingRatio);
    duration = clamp$1(minDuration, maxDuration, duration / 1000);
    if (dampingRatio < 1) {
        envelope = function (undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = calcAngularFreq(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return safeMin - a / b * c;
        };
        derivative = function (undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = function (undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = function (undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10
        };
    } else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness)
        };
    }
}
var rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for (var i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

var durationKeys = ["duration", "bounce"];
var physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some(function (key) {
        return options[key] !== undefined;
    });
}
function getSpringOptions(options) {
    var springOptions = __assign({ velocity: 0.0, stiffness: 100, damping: 10, mass: 1.0, isResolvedFromDuration: false }, options);
    if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
        var derived = findSpring(options);
        springOptions = __assign(__assign(__assign({}, springOptions), derived), { velocity: 0.0, mass: 1.0 });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function spring(_a) {
    var _b = _a.from,
        from = _b === void 0 ? 0.0 : _b,
        _c = _a.to,
        to = _c === void 0 ? 1.0 : _c,
        _d = _a.restSpeed,
        restSpeed = _d === void 0 ? 2 : _d,
        restDelta = _a.restDelta,
        options = __rest(_a, ["from", "to", "restSpeed", "restDelta"]);
    var state = { done: false, value: from };
    var _e = getSpringOptions(options),
        stiffness = _e.stiffness,
        damping = _e.damping,
        mass = _e.mass,
        velocity = _e.velocity,
        isResolvedFromDuration = _e.isResolvedFromDuration;
    var resolveSpring = zero;
    var resolveVelocity = zero;
    function createSpring() {
        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        var initialDelta = to - from;
        var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        restDelta !== null && restDelta !== void 0 ? restDelta : restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4;
        if (dampingRatio < 1) {
            var angularFreq_1 = calcAngularFreq(undampedAngularFreq, dampingRatio);
            resolveSpring = function (t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 * Math.sin(angularFreq_1 * t) + initialDelta * Math.cos(angularFreq_1 * t));
            };
            resolveVelocity = function (t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq_1 * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 + initialDelta * Math.cos(angularFreq_1 * t)) - envelope * (Math.cos(angularFreq_1 * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq_1 * initialDelta * Math.sin(angularFreq_1 * t));
            };
        } else if (dampingRatio === 1) {
            resolveSpring = function (t) {
                return to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
            };
        } else {
            var dampedAngularFreq_1 = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = function (t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                var freqForT = Math.min(dampedAngularFreq_1 * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq_1 * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq_1;
            };
        }
    }
    createSpring();
    return {
        next: function (t) {
            var current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity = resolveVelocity(t) * 1000;
                var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                var isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else {
                state.done = t >= options.duration;
            }
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: function () {
            var _a;
            velocity = -velocity;
            _a = [to, from], from = _a[0], to = _a[1];
            createSpring();
        }
    };
}
spring.needsInterpolation = function (a, b) {
    return typeof a === "string" || typeof b === "string";
};
var zero = function (_t) {
    return 0;
};

var progress = function (from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

var mix = function (from, to, progress) {
    return -progress * from + progress * to + from;
};

var mixLinearColor = function (from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
var colorTypes = [hex, rgba, hsla];
var getColorType = function (v) {
    return colorTypes.find(function (type) {
        return type.test(v);
    });
};
var notAnimatable = function (color) {
    return "'" + color + "' is not an animatable color. Use the equivalent color code instead.";
};
var mixColor = function (from, to) {
    var fromColorType = getColorType(from);
    var toColorType = getColorType(to);
    invariant$3(!!fromColorType, notAnimatable(from));
    invariant$3(!!toColorType, notAnimatable(to));
    invariant$3(fromColorType.transform === toColorType.transform, 'Both colors must be hex/RGBA, OR both must be HSLA.');
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);
    var blended = __assign({}, fromColor);
    var mixFunc = fromColorType === hsla ? mix : mixLinearColor;
    return function (v) {
        for (var key in blended) {
            if (key !== 'alpha') {
                blended[key] = mixFunc(fromColor[key], toColor[key], v);
            }
        }
        blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};
var isNum = function (v) {
    return typeof v === 'number';
};

var combineFunctions = function (a, b) {
    return function (v) {
        return b(a(v));
    };
};
var pipe = function () {
    var transformers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        transformers[_i] = arguments[_i];
    }
    return transformers.reduce(combineFunctions);
};

function getMixer(origin, target) {
    if (isNum(origin)) {
        return function (v) {
            return mix(origin, target, v);
        };
    } else if (color.test(origin)) {
        return mixColor(origin, target);
    } else {
        return mixComplex(origin, target);
    }
}
var mixArray = function (from, to) {
    var output = __spreadArrays$1(from);
    var numValues = output.length;
    var blendValue = from.map(function (fromThis, i) {
        return getMixer(fromThis, to[i]);
    });
    return function (v) {
        for (var i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
var mixObject = function (origin, target) {
    var output = __assign(__assign({}, origin), target);
    var blendValue = {};
    for (var key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer(origin[key], target[key]);
        }
    }
    return function (v) {
        for (var key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
function analyse(value) {
    var parsed = complex.parse(value);
    var numValues = parsed.length;
    var numNumbers = 0;
    var numRGB = 0;
    var numHSL = 0;
    for (var i = 0; i < numValues; i++) {
        if (numNumbers || typeof parsed[i] === 'number') {
            numNumbers++;
        } else {
            if (parsed[i].hue !== undefined) {
                numHSL++;
            } else {
                numRGB++;
            }
        }
    }
    return { parsed: parsed, numNumbers: numNumbers, numRGB: numRGB, numHSL: numHSL };
}
var mixComplex = function (origin, target) {
    var template = complex.createTransformer(target);
    var originStats = analyse(origin);
    var targetStats = analyse(target);
    invariant$3(originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
    return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
};

var mixNumber = function (from, to) {
    return function (p) {
        return mix(from, to, p);
    };
};
function detectMixerFactory(v) {
    if (typeof v === 'number') {
        return mixNumber;
    } else if (typeof v === 'string') {
        if (color.test(v)) {
            return mixColor;
        } else {
            return mixComplex;
        }
    } else if (Array.isArray(v)) {
        return mixArray;
    } else if (typeof v === 'object') {
        return mixObject;
    }
}
function createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || detectMixerFactory(output[0]);
    var numMixers = output.length - 1;
    for (var i = 0; i < numMixers; i++) {
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function fastInterpolate(_a, _b) {
    var from = _a[0],
        to = _a[1];
    var mixer = _b[0];
    return function (v) {
        return mixer(progress(from, to, v));
    };
}
function slowInterpolate(input, mixers) {
    var inputLength = input.length;
    var lastInputIndex = inputLength - 1;
    return function (v) {
        var mixerIndex = 0;
        var foundMixerIndex = false;
        if (v <= input[0]) {
            foundMixerIndex = true;
        } else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            var i = 1;
            for (; i < inputLength; i++) {
                if (input[i] > v || i === lastInputIndex) {
                    break;
                }
            }
            mixerIndex = i - 1;
        }
        var progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function interpolate(input, output, _a) {
    var _b = _a === void 0 ? {} : _a,
        _c = _b.clamp,
        isClamp = _c === void 0 ? true : _c,
        ease = _b.ease,
        mixer = _b.mixer;
    var inputLength = input.length;
    invariant$3(inputLength === output.length, 'Both input and output ranges must be the same length');
    invariant$3(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    var mixers = createMixers(output, ease, mixer);
    var interpolator = inputLength === 2 ? fastInterpolate(input, mixers) : slowInterpolate(input, mixers);
    return isClamp ? function (v) {
        return interpolator(clamp$1(input[0], input[inputLength - 1], v));
    } : interpolator;
}

var reverseEasing = function (easing) {
    return function (p) {
        return 1 - easing(1 - p);
    };
};
var mirrorEasing = function (easing) {
    return function (p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};
var createExpoIn = function (power) {
    return function (p) {
        return Math.pow(p, power);
    };
};
var createBackIn = function (power) {
    return function (p) {
        return p * p * ((power + 1) * p - power);
    };
};
var createAnticipate = function (power) {
    var backEasing = createBackIn(power);
    return function (p) {
        return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};

var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
var BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
var BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
var linear = function (p) {
    return p;
};
var easeIn = /*#__PURE__*/createExpoIn(2);
var easeOut = /*#__PURE__*/reverseEasing(easeIn);
var easeInOut = /*#__PURE__*/mirrorEasing(easeIn);
var circIn = function (p) {
    return 1 - Math.sin(Math.acos(p));
};
var circOut = /*#__PURE__*/reverseEasing(circIn);
var circInOut = /*#__PURE__*/mirrorEasing(circOut);
var backIn = /*#__PURE__*/createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
var backOut = /*#__PURE__*/reverseEasing(backIn);
var backInOut = /*#__PURE__*/mirrorEasing(backIn);
var anticipate = /*#__PURE__*/createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
var ca = 4356.0 / 361.0;
var cb = 35442.0 / 1805.0;
var cc = 16061.0 / 1805.0;
var bounceOut = function (p) {
    if (p === 1 || p === 0) return p;
    var p2 = p * p;
    return p < BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < BOUNCE_THIRD_THRESHOLD ? ca * p2 - cb * p + cc : 10.8 * p * p - 20.52 * p + 10.72;
};
var bounceIn = /*#__PURE__*/reverseEasing(bounceOut);
var bounceInOut = function (p) {
    return p < 0.5 ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0)) : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;
};

function defaultEasing(values, easing) {
    return values.map(function () {
        return easing || easeInOut;
    }).splice(0, values.length - 1);
}
function defaultOffset(values) {
    var numValues = values.length;
    return values.map(function (_value, i) {
        return i !== 0 ? i / (numValues - 1) : 0;
    });
}
function convertOffsetToTimes(offset, duration) {
    return offset.map(function (o) {
        return o * duration;
    });
}
function keyframes(_a) {
    var _b = _a.from,
        from = _b === void 0 ? 0 : _b,
        _c = _a.to,
        to = _c === void 0 ? 1 : _c,
        ease = _a.ease,
        offset = _a.offset,
        _d = _a.duration,
        duration = _d === void 0 ? 300 : _d;
    var state = { done: false, value: from };
    var values = Array.isArray(to) ? to : [from, to];
    var times = convertOffsetToTimes(offset !== null && offset !== void 0 ? offset : defaultOffset(values), duration);
    function createInterpolator() {
        return interpolate(times, values, {
            ease: Array.isArray(ease) ? ease : defaultEasing(values, ease)
        });
    }
    var interpolator = createInterpolator();
    return {
        next: function (t) {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: function () {
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}

function decay(_a) {
    var _b = _a.velocity,
        velocity = _b === void 0 ? 0 : _b,
        _c = _a.from,
        from = _c === void 0 ? 0 : _c,
        _d = _a.power,
        power = _d === void 0 ? 0.8 : _d,
        _e = _a.timeConstant,
        timeConstant = _e === void 0 ? 350 : _e,
        _f = _a.restDelta,
        restDelta = _f === void 0 ? 0.5 : _f,
        modifyTarget = _a.modifyTarget;
    var state = { done: false, value: from };
    var amplitude = power * velocity;
    var ideal = from + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: function (t) {
            var delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: function () {}
    };
}

var types = { keyframes: keyframes, spring: spring, decay: decay };
function detectAnimationFromOptions(config) {
    if (Array.isArray(config.to)) {
        return keyframes;
    } else if (types[config.type]) {
        return types[config.type];
    }
    var keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) {
        return keyframes;
    } else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) {
        return spring;
    }
    return keyframes;
}

function loopElapsed(elapsed, duration, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration, delay, isForwardPlayback) {
    if (delay === void 0) {
        delay = 0;
    }
    if (isForwardPlayback === void 0) {
        isForwardPlayback = true;
    }
    return isForwardPlayback ? loopElapsed(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}

var framesync = function (update) {
    var passTimestamp = function (_a) {
        var delta = _a.delta;
        return update(delta);
    };
    return {
        start: function () {
            return sync.update(passTimestamp, true, true);
        },
        stop: function () {
            return cancelSync.update(passTimestamp);
        }
    };
};
function animate(_a) {
    var _b, _c;
    var from = _a.from,
        _d = _a.autoplay,
        autoplay = _d === void 0 ? true : _d,
        _e = _a.driver,
        driver = _e === void 0 ? framesync : _e,
        _f = _a.elapsed,
        elapsed = _f === void 0 ? 0 : _f,
        _g = _a.repeat,
        repeatMax = _g === void 0 ? 0 : _g,
        _h = _a.repeatType,
        repeatType = _h === void 0 ? "loop" : _h,
        _j = _a.repeatDelay,
        repeatDelay = _j === void 0 ? 0 : _j,
        onPlay = _a.onPlay,
        onStop = _a.onStop,
        onComplete = _a.onComplete,
        onRepeat = _a.onRepeat,
        onUpdate = _a.onUpdate,
        options = __rest(_a, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
    var to = options.to;
    var driverControls;
    var repeatCount = 0;
    var computedDuration = options.duration;
    var latest;
    var isComplete = false;
    var isForwardPlayback = true;
    var interpolateFromNumber;
    var animator = detectAnimationFromOptions(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = interpolate([0, 100], [from, to], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    var animation = animator(__assign(__assign({}, options), { from: from, to: to }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            var state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) {
                hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            } else {
                complete();
            }
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 ? void 0 : onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: function () {
            onStop === null || onStop === void 0 ? void 0 : onStop();
            driverControls.stop();
        }
    };
}

function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

function inertia(_a) {
    var _b = _a.from,
        from = _b === void 0 ? 0 : _b,
        _c = _a.velocity,
        velocity = _c === void 0 ? 0 : _c,
        min = _a.min,
        max = _a.max,
        _d = _a.power,
        power = _d === void 0 ? 0.8 : _d,
        _e = _a.timeConstant,
        timeConstant = _e === void 0 ? 750 : _e,
        _f = _a.bounceStiffness,
        bounceStiffness = _f === void 0 ? 500 : _f,
        _g = _a.bounceDamping,
        bounceDamping = _g === void 0 ? 10 : _g,
        _h = _a.restDelta,
        restDelta = _h === void 0 ? 1 : _h,
        modifyTarget = _a.modifyTarget,
        driver = _a.driver,
        onUpdate = _a.onUpdate,
        onComplete = _a.onComplete;
    var currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        currentAnimation = animate(__assign(__assign({}, options), { driver: driver, onUpdate: function (v) {
                var _a;
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v);
            }, onComplete: onComplete }));
    }
    function startSpring(options) {
        startAnimation(__assign({ type: "spring", stiffness: bounceStiffness, damping: bounceDamping, restDelta: restDelta }, options));
    }
    if (isOutOfBounds(from)) {
        startSpring({ from: from, velocity: velocity, to: boundaryNearest(from) });
    } else {
        var target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        var boundary_1 = boundaryNearest(target);
        var heading_1 = boundary_1 === min ? -1 : 1;
        var prev_1;
        var current_1;
        var checkBoundary = function (v) {
            prev_1 = current_1;
            current_1 = v;
            velocity = velocityPerSecond(v - prev_1, getFrameData().delta);
            if (heading_1 === 1 && v > boundary_1 || heading_1 === -1 && v < boundary_1) {
                startSpring({ from: v, to: boundary_1, velocity: velocity });
            }
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: function () {
            return currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        }
    };
}

var isPoint = function (point) {
    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
};

var isPoint3D = function (point) {
    return isPoint(point) && point.hasOwnProperty('z');
};

var distance1D = function (a, b) {
    return Math.abs(a - b);
};
function distance(a, b) {
    if (isNum(a) && isNum(b)) {
        return distance1D(a, b);
    } else if (isPoint(a) && isPoint(b)) {
        var xDelta = distance1D(a.x, b.x);
        var yDelta = distance1D(a.y, b.y);
        var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}

var a = function (a1, a2) {
    return 1.0 - 3.0 * a2 + 3.0 * a1;
};
var b$3 = function (a1, a2) {
    return 3.0 * a2 - 6.0 * a1;
};
var c$2 = function (a1) {
    return 3.0 * a1;
};
var calcBezier = function (t, a1, a2) {
    return ((a(a1, a2) * t + b$3(a1, a2)) * t + c$2(a1)) * t;
};
var getSlope = function (t, a1, a2) {
    return 3.0 * a(a1, a2) * t * t + 2.0 * b$3(a1, a2) * t + c$2(a1);
};
var subdivisionPrecision = 0.0000001;
var subdivisionMaxIterations = 10;
function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) {
            aB = currentT;
        } else {
            aA = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
    return currentT;
}
var newtonIterations = 8;
var newtonMinSlope = 0.001;
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < newtonIterations; ++i) {
        var currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) {
            return aGuessT;
        }
        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
function cubicBezier(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return linear;
    var sampleValues = new Float32Array(kSplineTableSize);
    for (var i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = kSplineTableSize - 1;
        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += kSampleStepSize;
        }
        --currentSample;
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * kSampleStepSize;
        var initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= newtonMinSlope) {
            return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        } else if (initialSlope === 0.0) {
            return guessForT;
        } else {
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
    }
    return function (t) {
        return t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
    };
}

var isRefObject = function (ref) {
    return typeof ref === "object" && ref.hasOwnProperty("current");
};

/**
 * A generic subscription manager.
 */
var SubscriptionManager = /** @class */ (function () {
    function SubscriptionManager() {
        this.subscriptions = new Set();
    }
    SubscriptionManager.prototype.add = function (handler) {
        var _this = this;
        this.subscriptions.add(handler);
        return function () { return void _this.subscriptions.delete(handler); };
    };
    SubscriptionManager.prototype.notify = function (
    /**
     * Using ...args would be preferable but it's array creation and this
     * might be fired every frame.
     */
    a, b, c) {
        var e_1, _a;
        if (!this.subscriptions.size)
            return;
        try {
            for (var _b = __values(this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                var handler = _c.value;
                handler(a, b, c);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    SubscriptionManager.prototype.clear = function () {
        this.subscriptions.clear();
    };
    return SubscriptionManager;
}());

var isFloat = function (value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
var MotionValue = /** @class */ (function () {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    function MotionValue(init) {
        var _this = this;
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */
        this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */
        this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */
        this.updateSubscribers = new SubscriptionManager();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */
        this.renderSubscribers = new SubscriptionManager();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */
        this.canTrackVelocity = false;
        this.updateAndNotify = function (v, render) {
            if (render === void 0) { render = true; }
            _this.prev = _this.current;
            _this.current = v;
            if (_this.prev !== _this.current) {
                _this.updateSubscribers.notify(_this.current);
            }
            if (render) {
                _this.renderSubscribers.notify(_this.current);
            }
            // Update timestamp
            var _a = getFrameData(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                sync.postRender(_this.scheduleVelocityCheck);
            }
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.scheduleVelocityCheck = function () { return sync.postRender(_this.velocityCheck); };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.velocityCheck = function (_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
            }
        };
        this.set(init, false);
        this.canTrackVelocity = isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * @library
     *
     * ```jsx
     * function MyComponent() {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <Frame x={x} />
     * }
     * ```
     *
     * @motion
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @internalremarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */
    MotionValue.prototype.onChange = function (subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function () {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */
    MotionValue.prototype.onRenderRequest = function (subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
    MotionValue.prototype.attach = function (passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
    MotionValue.prototype.set = function (v, render) {
        if (render === void 0) { render = true; }
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
    MotionValue.prototype.get = function () {
        return this.current;
    };
    /**
     * @public
     */
    MotionValue.prototype.getPrevious = function () {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
    MotionValue.prototype.getVelocity = function () {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity
            ? // These casts could be avoided if parseFloat would be typed better
                velocityPerSecond(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
    MotionValue.prototype.start = function (animation) {
        var _this = this;
        this.stop();
        return new Promise(function (resolve) {
            _this.stopAnimation = animation(resolve);
        }).then(function () { return _this.clearAnimation(); });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */
    MotionValue.prototype.stop = function () {
        if (this.stopAnimation)
            this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
    MotionValue.prototype.isAnimating = function () {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function () {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
    MotionValue.prototype.destroy = function () {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}());
/**
 * @internal
 */
function motionValue(init) {
    return new MotionValue(init);
}

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
var secondsToMilliseconds = function (seconds) { return seconds * 1000; };

var easingLookup = {
    linear: linear,
    easeIn: easeIn,
    easeInOut: easeInOut,
    easeOut: easeOut,
    circIn: circIn,
    circInOut: circInOut,
    circOut: circOut,
    backIn: backIn,
    backInOut: backInOut,
    backOut: backOut,
    anticipate: anticipate,
    bounceIn: bounceIn,
    bounceInOut: bounceInOut,
    bounceOut: bounceOut,
};
var easingDefinitionToFunction = function (definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        invariant$3(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = __read$1(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        // Else lookup from table
        invariant$3(easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
        return easingLookup[definition];
    }
    return definition;
};
var isEasingArray = function (ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
var isAnimatable = function (key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex")
        return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" && // It's animatable if we have a string
        complex.test(value) && // And it contains numbers and/or colors
        !value.startsWith("url(") // Unless it starts with "url("
    ) {
        return true;
    }
    return false;
};

var isKeyframesTarget = function (v) {
    return Array.isArray(v);
};

var underDampedSpring = function () { return ({
    type: "spring",
    stiffness: 500,
    damping: 25,
    restDelta: 0.5,
    restSpeed: 10,
}); };
var overDampedSpring = function (to) { return ({
    type: "spring",
    stiffness: 550,
    damping: to === 0 ? 100 : 30,
    restDelta: 0.01,
    restSpeed: 10,
}); };
var linearTween = function () { return ({
    type: "keyframes",
    ease: "linear",
    duration: 0.3,
}); };
var keyframes$1 = function (values) { return ({
    type: "keyframes",
    duration: 0.8,
    values: values,
}); };
var defaultTransitions = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: overDampedSpring,
    scaleY: overDampedSpring,
    scale: overDampedSpring,
    opacity: linearTween,
    backgroundColor: linearTween,
    color: linearTween,
    default: overDampedSpring,
};
var getDefaultTransition = function (valueKey, to) {
    var transitionFactory;
    if (isKeyframesTarget(to)) {
        transitionFactory = keyframes$1;
    }
    else {
        transitionFactory =
            defaultTransitions[valueKey] || defaultTransitions.default;
    }
    return __assign({ to: to }, transitionFactory(to));
};

/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined(_a) {
    var when = _a.when, delay = _a.delay, delayChildren = _a.delayChildren, staggerChildren = _a.staggerChildren, staggerDirection = _a.staggerDirection, repeat = _a.repeat, repeatType = _a.repeatType, repeatDelay = _a.repeatDelay, from = _a.from, transition = __rest(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
    return !!Object.keys(transition).length;
}
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */
function convertTransitionToAnimationOptions(_a) {
    var yoyo = _a.yoyo, loop = _a.loop, flip = _a.flip, ease = _a.ease, times = _a.times, transition = __rest(_a, ["yoyo", "loop", "flip", "ease", "times"]);
    var options = __assign({}, transition);
    if (times) {
        options.offset = times;
    }
    /**
     * Convert any existing durations from seconds to milliseconds
     */
    if (transition.duration)
        options["duration"] = secondsToMilliseconds(transition.duration);
    if (transition.repeatDelay)
        options.repeatDelay = secondsToMilliseconds(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */
    if (ease) {
        options["ease"] = isEasingArray(ease)
            ? ease.map(easingDefinitionToFunction)
            : easingDefinitionToFunction(ease);
    }
    /**
     * Support legacy transition API
     */
    if (transition.type === "tween")
        options.type = "keyframes";
    if (yoyo) {
        options.repeatType = "reverse";
    }
    else if (loop) {
        options.repeatType = "loop";
    }
    else if (flip) {
        options.repeatType = "mirror";
    }
    options.repeat = loop || yoyo || flip || transition.repeat;
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */
    if (transition.type !== "spring")
        options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */
function getDelayFromTransition(transition, key) {
    var _a, _b, _c, _d, _e;
    return ((_e = (_d = (_b = (_a = transition[key]) === null || _a === void 0 ? void 0 : _a.delay) !== null && _b !== void 0 ? _b : (_c = transition["default"]) === null || _c === void 0 ? void 0 : _c.delay) !== null && _d !== void 0 ? _d : transition.delay) !== null && _e !== void 0 ? _e : 0);
}
function hydrateKeyframes(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = __spread$1(options.to);
        options.to[0] = options.from;
    }
    return options;
}
function getPopmotionAnimationOptions(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) {
        (_a = transition.duration) !== null && _a !== void 0 ? _a : (transition.duration = 0.8);
    }
    hydrateKeyframes(options);
    /**
     * Get a default transition if none is determined to be defined.
     */
    if (!isTransitionDefined(transition)) {
        transition = __assign(__assign({}, transition), getDefaultTransition(key, options.to));
    }
    return __assign(__assign({}, options), convertTransitionToAnimationOptions(transition));
}
/**
 *
 */
function getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = getValueTransition(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = isAnimatable(key, target);
    /**
     * If we're trying to animate from "none", try and get an animatable version
     * of the target. This could be improved to work both ways.
     */
    if (origin === "none" && isTargetAnimatable && typeof target === "string") {
        origin = complex.getAnimatableNone(target);
    }
    var isOriginAnimatable = isAnimatable(key, origin);
    warning$4(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + " from \"" + origin + "\" to \"" + target + "\". " + origin + " is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property.");
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function (v) { return value.set(v); },
        };
        return valueTransition.type === "inertia" ||
            valueTransition.type === "decay"
            ? inertia(__assign(__assign({}, options), valueTransition))
            : animate(__assign(__assign({}, getPopmotionAnimationOptions(valueTransition, options, key)), { onUpdate: function (v) {
                    var _a;
                    options.onUpdate(v);
                    (_a = valueTransition.onUpdate) === null || _a === void 0 ? void 0 : _a.call(valueTransition, v);
                }, onComplete: function () {
                    var _a;
                    options.onComplete();
                    (_a = valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
                } }));
    }
    function set() {
        var _a;
        value.set(target);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
        return { stop: function () { } };
    }
    return !isOriginAnimatable ||
        !isTargetAnimatable ||
        valueTransition.type === false
        ? set
        : start;
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 *
 * @internal
 */
function startAnimation(key, value, target, transition) {
    if (transition === void 0) { transition = {}; }
    return value.start(function (onComplete) {
        var delayTimer;
        var controls;
        var animation = getAnimation(key, value, target, transition, onComplete);
        var delay = getDelayFromTransition(transition, key);
        var start = function () { return (controls = animation()); };
        if (delay) {
            delayTimer = setTimeout(start, secondsToMilliseconds(delay));
        }
        else {
            start();
        }
        return function () {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 ? void 0 : controls.stop();
        };
    });
}
var resolveFinalValueInKeyframes = function (v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
var isNumericalString = function (v) { return /^\-?\d*\.?\d+$/.test(v); };

/**
 * ValueType for "auto"
 */
var auto = {
    test: function (v) { return v === "auto"; },
    parse: function (v) { return v; },
};
/**
 * ValueType for ints
 */
var int = __assign(__assign({}, number), { transform: Math.round });
/**
 * A map of default value types for common values
 */
var defaultValueTypes = {
    // Color props
    color: color,
    backgroundColor: color,
    outlineColor: color,
    fill: color,
    stroke: color,
    // Border props
    borderColor: color,
    borderTopColor: color,
    borderRightColor: color,
    borderBottomColor: color,
    borderLeftColor: color,
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    // Positioning props
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    // Spacing props
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    // Transform props
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale: scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    transformPerspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    // Misc
    zIndex: int,
    // SVG
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int,
};
/**
 * A list of value types commonly used for dimensions
 */
var dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a provided value against a ValueType
 */
var testValueType = function (v) { return function (type) { return type.test(v); }; };
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
var findDimensionValueType = function (v) {
    return dimensionValueTypes.find(testValueType(v));
};
/**
 * A list of all ValueTypes
 */
var valueTypes = __spread$1(dimensionValueTypes, [color, complex]);
/**
 * Tests a value against the list of ValueTypes
 */
var findValueType = function (v) { return valueTypes.find(testValueType(v)); };
/**
 * Gets the default ValueType for the provided value key
 */
var getDefaultValueType = function (key) { return defaultValueTypes[key]; };
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
var getValueAsType = function (value, type) {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};

/**
 * Decides if the supplied variable is a function that returns a variant
 */
function isVariantResolver(variant) {
    return typeof variant === "function";
}
/**
 * Decides if the supplied variable is an array of variant labels
 */
function isVariantLabels(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
    return typeof v === "string" || isVariantLabels(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */
function getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function (value, key) { return (current[key] = value.get()); });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */
function getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function (value, key) { return (velocity[key] = value.getVelocity()); });
    return velocity;
}
/**
 * Resovles a variant if it's a variant resolver
 */
function resolveVariant(visualElement, variant, custom) {
    var resolved = {};
    if (!variant) {
        return resolved;
    }
    else if (isVariantResolver(variant)) {
        resolved = variant(custom !== null && custom !== void 0 ? custom : visualElement.getVariantPayload(), getCurrent(visualElement), getVelocity(visualElement));
    }
    else {
        resolved = variant;
    }
    return __assign({ transition: visualElement.getDefaultTransition() }, resolved);
}

/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, motionValue(value));
    }
}
function setTarget(visualElement, definition, _a) {
    var priority = (_a === void 0 ? {} : _a).priority;
    var _b = visualElement.makeTargetAnimatable(resolveVariant(visualElement, definition), false), _c = _b.transitionEnd, transitionEnd = _c === void 0 ? {} : _c, transition = _b.transition, target = __rest(_b, ["transitionEnd", "transition"]);
    target = __assign(__assign({}, target), transitionEnd);
    for (var key in target) {
        var value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
        if (!priority)
            visualElement.baseTarget[key] = value;
    }
}
function setVariants(visualElement, variantLabels) {
    var reversedLabels = __spread$1(variantLabels).reverse();
    reversedLabels.forEach(function (key) {
        var _a;
        setTarget(visualElement, visualElement.getVariant(key));
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
            setVariants(child, variantLabels);
        });
    });
}
function setValues(visualElement, definition) {
    if (Array.isArray(definition)) {
        return setVariants(visualElement, definition);
    }
    else if (typeof definition === "string") {
        return setVariants(visualElement, [definition]);
    }
    else {
        setTarget(visualElement, definition);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b;
    var _c;
    var newValueKeys = Object.keys(target).filter(function (key) { return !visualElement.hasValue(key); });
    var numNewValues = newValueKeys.length;
    if (!numNewValues)
        return;
    for (var i = 0; i < numNewValues; i++) {
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        // If this is a keyframes value, we can attempt to use the first value in the
        // array as that's going to be the first value of the animation anyway
        if (Array.isArray(targetValue)) {
            value = targetValue[0];
        }
        // If it isn't a keyframes or the first keyframes value was set as `null`, read the
        // value from the DOM. It might be worth investigating whether to check props (for SVG)
        // or props.style (for HTML) if the value exists there before attempting to read.
        if (value === null) {
            var readValue = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readNativeValue(key);
            value = readValue !== undefined ? readValue : target[key];
            invariant$3(value !== null, "No initial value for \"" + key + "\" can be inferred. Ensure an initial value for \"" + key + "\" is defined on the component.");
        }
        if (typeof value === "string" && isNumericalString(value)) {
            // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
        }
        else if (!findValueType(value) && complex.test(targetValue)) {
            // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
            value = complex.getAnimatableNone(targetValue);
        }
        visualElement.addValue(key, motionValue(value));
        (_b = (_c = origin)[key]) !== null && _b !== void 0 ? _b : (_c[key] = value);
        visualElement.baseTarget[key] = value;
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition)
        return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for (var key in target) {
        origin[key] = (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    }
    return origin;
}

/**
 * @internal
 */
function startVisualElementAnimation(visualElement, definition, opts) {
    if (opts === void 0) { opts = {}; }
    if (opts.priority) {
        visualElement.activeOverrides.add(opts.priority);
    }
    visualElement.resetIsAnimating(opts.priority);
    var animation;
    if (isVariantLabels(definition)) {
        animation = animateVariantLabels(visualElement, definition, opts);
    }
    else if (isVariantLabel(definition)) {
        animation = animateVariant(visualElement, definition, opts);
    }
    else {
        animation = animateTarget(visualElement, definition, opts);
    }
    visualElement.onAnimationStart();
    return animation.then(function () { return visualElement.onAnimationComplete(); });
}
function animateVariantLabels(visualElement, variantLabels, opts) {
    var animations = __spread$1(variantLabels).reverse()
        .map(function (label) { return animateVariant(visualElement, label, opts); });
    return Promise.all(animations);
}
function animateVariant(visualElement, label, opts) {
    var _a;
    var priority = (opts && opts.priority) || 0;
    var variantDefinition = visualElement.getVariant(label);
    var variant = resolveVariant(visualElement, variantDefinition, opts && opts.custom);
    var transition = variant.transition || {};
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    var getAnimation = variantDefinition
        ? function () { return animateTarget(visualElement, variant, opts); }
        : function () { return Promise.resolve(); };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    var getChildrenAnimations = ((_a = visualElement.variantChildrenOrder) === null || _a === void 0 ? void 0 : _a.size) ? function (forwardDelay) {
        if (forwardDelay === void 0) { forwardDelay = 0; }
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a;
        return animateChildren(visualElement, label, delayChildren + forwardDelay, transition.staggerChildren, transition.staggerDirection, priority, opts === null || opts === void 0 ? void 0 : opts.custom);
    }
        : function () { return Promise.resolve(); };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */
    var when = transition.when;
    if (when) {
        var _b = __read$1(when === "beforeChildren"
            ? [getAnimation, getChildrenAnimations]
            : [getChildrenAnimations, getAnimation], 2), first = _b[0], last = _b[1];
        return first().then(last);
    }
    else {
        return Promise.all([getAnimation(), getChildrenAnimations(opts === null || opts === void 0 ? void 0 : opts.delay)]);
    }
}
function animateChildren(visualElement, variantLabel, delayChildren, staggerChildren, staggerDirection, priority, custom) {
    if (delayChildren === void 0) { delayChildren = 0; }
    if (staggerChildren === void 0) { staggerChildren = 0; }
    if (staggerDirection === void 0) { staggerDirection = 1; }
    if (priority === void 0) { priority = 0; }
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildrenOrder.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1
        ? function (i) { return i * staggerChildren; }
        : function (i) { return maxStaggerDuration - i * staggerChildren; };
    Array.from(visualElement.variantChildrenOrder).forEach(function (child, i) {
        var animation = animateVariant(child, variantLabel, {
            priority: priority,
            delay: delayChildren + generateStaggerDuration(i),
            custom: custom,
        });
        animations.push(animation);
    });
    return Promise.all(animations);
}
function stopAnimation(visualElement) {
    visualElement.forEachValue(function (value) { return value.stop(); });
}
function animateTarget(visualElement, definition, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.delay, delay = _c === void 0 ? 0 : _c, _d = _b.priority, priority = _d === void 0 ? 0 : _d, transitionOverride = _b.transitionOverride, custom = _b.custom;
    var targetAndTransition = resolveVariant(visualElement, definition, custom);
    if (transitionOverride)
        targetAndTransition.transition = transitionOverride;
    var _e = visualElement.makeTargetAnimatable(targetAndTransition), transitionEnd = _e.transitionEnd, transition = _e.transition, target = __rest(_e, ["transitionEnd", "transition"]);
    if (priority)
        visualElement.resolvedOverrides[priority] = target;
    var animations = [];
    for (var key in target) {
        var value = visualElement.getValue(key);
        if (!value || !target || target[key] === undefined)
            continue;
        var valueTarget = target[key];
        if (!priority) {
            visualElement.baseTarget[key] = resolveFinalValueInKeyframes(valueTarget);
        }
        if (visualElement.isAnimating.has(key))
            continue;
        visualElement.isAnimating.add(key);
        animations.push(startAnimation(key, value, valueTarget, __assign({ delay: delay }, transition)));
    }
    var allAnimations = Promise.all(animations);
    return transitionEnd
        ? allAnimations.then(function () {
            return setTarget(visualElement, transitionEnd, { priority: priority });
        })
        : allAnimations;
}

function setOverride(visualElement, definition, index) {
    var _a;
    visualElement.overrides[index] = definition;
    (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
        setOverride(child, definition, index);
    });
}
function startOverride(visualElement, index) {
    var override = visualElement.overrides[index];
    if (override) {
        return startVisualElementAnimation(visualElement, override, {
            priority: index,
        });
    }
}
function clearOverride(visualElement, index) {
    var _a;
    (_a = visualElement.variantChildrenOrder) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
        clearOverride(child, index);
    });
    var override = visualElement.overrides[index];
    if (!override)
        return;
    visualElement.activeOverrides.delete(index);
    var highest = getHighestOverridePriortiy(visualElement);
    visualElement.resetIsAnimating();
    if (highest) {
        var highestOverride = visualElement.overrides[highest];
        highestOverride && startOverride(visualElement, highest);
    }
    // Figure out which remaining values were affected by the override and animate those
    var overrideTarget = visualElement.resolvedOverrides[index];
    if (!overrideTarget)
        return;
    var remainingValues = {};
    for (var key in visualElement.baseTarget) {
        if (overrideTarget[key] !== undefined) {
            remainingValues[key] = visualElement.baseTarget[key];
        }
    }
    visualElement.onAnimationStart();
    animateTarget(visualElement, remainingValues).then(function () {
        visualElement.onAnimationComplete();
    });
}
function getHighestOverridePriortiy(visualElement) {
    if (!visualElement.activeOverrides.size)
        return 0;
    return Math.max.apply(Math, __spread$1(Array.from(visualElement.activeOverrides)));
}

/**
 * VisualElement is an abstract class that provides a generic animation-optimised interface to the
 * underlying renderer.
 *
 * Currently many features interact directly with HTMLVisualElement/SVGVisualElement
 * but the idea is we can create, for instance, a ThreeVisualElement that extends
 * VisualElement and we can quickly offer all the same features.
 */
var VisualElement = /** @class */ (function () {
    function VisualElement(parent, ref) {
        var _this = this;
        // An iterable list of current children
        this.children = new Set();
        /**
         * A set of values that we animate back to when a value is cleared of all overrides.
         */
        this.baseTarget = {};
        /**
         * A series of target overrides that we can animate to/from when overrides are set/cleared.
         */
        this.overrides = [];
        /**
         * A series of target overrides as they were originally resolved.
         */
        this.resolvedOverrides = [];
        /**
         * A Set of currently active override indexes
         */
        this.activeOverrides = new Set();
        /**
         * A Set of value keys that are currently animating.
         */
        this.isAnimating = new Set();
        // The latest resolved MotionValues
        this.latest = {};
        // A map of MotionValues used to animate this element
        this.values = new Map();
        // Unsubscription callbacks for MotionValue subscriptions
        this.valueSubscriptions = new Map();
        // A configuration for this VisualElement, each derived class can extend this.
        this.config = {};
        this.isMounted = false;
        // A pre-bound call to the user-provided `onUpdate` callback. This won't
        // be called more than once per frame.
        this.update = function () { return _this.config.onUpdate(_this.latest); };
        // Pre-bound version of render
        this.triggerRender = function () { return _this.render(); };
        // This function gets passed to the rendered component's `ref` prop
        // and is used to mount/unmount the VisualElement
        this.ref = function (element) {
            element ? _this.mount(element) : _this.unmount();
            if (!_this.externalRef)
                return;
            if (typeof _this.externalRef === "function") {
                _this.externalRef(element);
            }
            else if (isRefObject(_this.externalRef)) {
                _this.externalRef.current = element;
            }
        };
        // Create a relationship with the provided parent.
        this.parent = parent;
        this.rootParent = parent ? parent.rootParent : this;
        this.treePath = parent ? __spread$1(parent.treePath, [parent]) : [];
        // Calculate the depth of this node in the VisualElement graph
        this.depth = parent ? parent.depth + 1 : 0;
        // A reference to any externally-defined React ref. This might live better
        // outside the VisualElement and be handled in a hook.
        this.externalRef = ref;
    }
    VisualElement.prototype.getVariantPayload = function () {
        return this.config.custom;
    };
    VisualElement.prototype.getVariant = function (label) {
        var _a;
        return (_a = this.config.variants) === null || _a === void 0 ? void 0 : _a[label];
    };
    VisualElement.prototype.addVariantChild = function (visualElement) {
        if (!this.variantChildren)
            this.variantChildren = new Set();
        this.variantChildren.add(visualElement);
    };
    VisualElement.prototype.addVariantChildOrder = function (visualElement) {
        if (!this.variantChildrenOrder)
            this.variantChildrenOrder = new Set();
        this.variantChildrenOrder.add(visualElement);
    };
    VisualElement.prototype.onAnimationStart = function () {
        var _a, _b;
        (_b = (_a = this.config).onAnimationStart) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    VisualElement.prototype.onAnimationComplete = function () {
        var _a, _b;
        this.isMounted && ((_b = (_a = this.config).onAnimationComplete) === null || _b === void 0 ? void 0 : _b.call(_a));
    };
    VisualElement.prototype.getDefaultTransition = function () {
        return this.config.transition;
    };
    VisualElement.prototype.resetIsAnimating = function (priority) {
        var _a;
        if (priority === void 0) { priority = 0; }
        this.isAnimating.clear();
        // If this isn't the highest priority gesture, block the animation
        // of anything that's currently being animated
        if (priority < getHighestOverridePriortiy(this)) {
            this.checkOverrideIsAnimating(priority);
        }
        (_a = this.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
            return child.resetIsAnimating(priority);
        });
    };
    VisualElement.prototype.checkOverrideIsAnimating = function (priority) {
        var numOverrides = this.overrides.length;
        for (var i = priority + 1; i < numOverrides; i++) {
            var resolvedOverride = this.resolvedOverrides[i];
            if (resolvedOverride) {
                for (var key in resolvedOverride) {
                    this.isAnimating.add(key);
                }
            }
        }
    };
    VisualElement.prototype.subscribe = function (child) {
        var _this = this;
        this.children.add(child);
        return function () { return _this.children.delete(child); };
    };
    // Check whether this element has a MotionValue of the provided key
    VisualElement.prototype.hasValue = function (key) {
        return this.values.has(key);
    };
    // Add a MotionValue
    VisualElement.prototype.addValue = function (key, value) {
        if (this.hasValue(key))
            this.removeValue(key);
        this.values.set(key, value);
        this.setSingleStaticValue(key, value.get());
        this.subscribeToValue(key, value);
    };
    // Remove a MotionValue
    VisualElement.prototype.removeValue = function (key) {
        var _a;
        (_a = this.valueSubscriptions.get(key)) === null || _a === void 0 ? void 0 : _a();
        this.valueSubscriptions.delete(key);
        this.values.delete(key);
        delete this.latest[key];
    };
    VisualElement.prototype.getValue = function (key, defaultValue) {
        var value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = new MotionValue(defaultValue);
            this.addValue(key, value);
        }
        return value;
    };
    // Iterate over all MotionValues
    VisualElement.prototype.forEachValue = function (callback) {
        this.values.forEach(callback);
    };
    // Get the underlying rendered instance of this VisualElement. For instance in
    // HTMLVisualElement this will be a HTMLElement.
    VisualElement.prototype.getInstance = function () {
        return this.element;
    };
    VisualElement.prototype.updateConfig = function (config) {
        if (config === void 0) { config = {}; }
        this.config = __assign({}, config);
    };
    // Set a single `latest` value
    VisualElement.prototype.setSingleStaticValue = function (key, value) {
        this.latest[key] = value;
    };
    // Statically set values to `latest` without needing a MotionValue
    VisualElement.prototype.setStaticValues = function (values, value) {
        if (typeof values === "string") {
            this.setSingleStaticValue(values, value);
        }
        else {
            for (var key in values) {
                this.setSingleStaticValue(key, values[key]);
            }
        }
    };
    VisualElement.prototype.scheduleRender = function () {
        sync.render(this.triggerRender, false, true);
    };
    VisualElement.prototype.scheduleUpdateLayoutDelta = function () {
        sync.preRender(this.rootParent.updateLayoutDelta, false, true);
    };
    VisualElement.prototype.subscribeToValue = function (key, value) {
        var _this = this;
        var onChange = function (latest) {
            _this.setSingleStaticValue(key, latest);
            // Schedule onUpdate if we have an onUpdate listener and the component has mounted
            _this.element &&
                _this.config.onUpdate &&
                sync.update(_this.update, false, true);
        };
        var onRender = function () {
            _this.element && _this.scheduleRender();
        };
        var unsubscribeOnChange = value.onChange(onChange);
        var unsubscribeOnRender = value.onRenderRequest(onRender);
        this.valueSubscriptions.set(key, function () {
            unsubscribeOnChange();
            unsubscribeOnRender();
        });
    };
    // Mount the VisualElement with the actual DOM element
    VisualElement.prototype.mount = function (element) {
        invariant$3(!!element, "No ref found. Ensure components created with motion.custom forward refs using React.forwardRef");
        if (this.parent) {
            this.removeFromParent = this.parent.subscribe(this);
        }
        /**
         * Save the element to this.element as a semantic API, this.current to the VisualElement
         * is compatible with existing RefObject APIs.
         */
        this.element = this.current = element;
    };
    // Unmount the VisualElement and cancel any scheduled updates
    VisualElement.prototype.unmount = function () {
        var _this = this;
        this.forEachValue(function (_, key) { return _this.removeValue(key); });
        cancelSync.update(this.update);
        cancelSync.render(this.render);
        this.removeFromParent && this.removeFromParent();
    };
    return VisualElement;
}());

function noop$3(any) {
    return any;
}

/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToAxisBox(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertAxisBoxToBoundingBox(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        bottom: y.max,
        left: x.min,
        right: x.max,
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoundingBox(_a, transformPoint) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    if (transformPoint === void 0) { transformPoint = noop$3; }
    var topLeft = transformPoint({ x: left, y: top });
    var bottomRight = transformPoint({ x: right, y: bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}
/**
 * Create an empty axis box of zero size
 */
function axisBox() {
    return { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } };
}
function copyAxisBox(box) {
    return {
        x: __assign({}, box.x),
        y: __assign({}, box.y),
    };
}
/**
 * Create an empty box delta
 */
var zeroDelta = {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
};
function delta() {
    return {
        x: __assign({}, zeroDelta),
        y: __assign({}, zeroDelta),
    };
}

/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */
var transformAxes = ["", "X", "Y", "Z"];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */
var order = ["perspective", "translate", "scale", "rotate", "skew"];
/**
 * Used to store the keys of all transforms that will distorted a measured bounding box.
 */
var boxDistortingKeys = new Set();
/**
 * Generate a list of every possible transform key.
 */
var transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function (operationKey) {
    var isDistorting = new Set(["rotate", "skew"]).has(operationKey);
    transformAxes.forEach(function (axesKey) {
        var key = operationKey + axesKey;
        transformProps.push(key);
        isDistorting && boxDistortingKeys.add(key);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */
function sortTransformProps(a, b) {
    return transformProps.indexOf(a) - transformProps.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */
var transformPropSet = new Set(transformProps);
function isTransformProp(key) {
    return transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */
var transformOriginProps = new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(key) {
    return transformOriginProps.has(key);
}

var translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform(transform, transformKeys, transformTemplate, transformIsDefault, enableHardwareAcceleration, allowTransformNone) {
    if (enableHardwareAcceleration === void 0) { enableHardwareAcceleration = true; }
    if (allowTransformNone === void 0) { allowTransformNone = true; }
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort(sortTransformProps);
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for (var i = 0; i < numTransformKeys; i++) {
        var key = transformKeys[i];
        transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
        if (key === "z")
            transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) {
        transformString += "translateZ(0)";
    }
    else {
        transformString = transformString.trim();
    }
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (allowTransformNone && transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */
function buildTransformOrigin(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return originX + " " + originY + " " + originZ;
}
/**
 * Build a transform style that takes a calculated delta between the element's current
 * space on screen and projects it into the desired space.
 */
function buildLayoutProjectionTransform(_a, treeScale) {
    var x = _a.x, y = _a.y;
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */
    var xTranslate = x.translate / treeScale.x;
    var yTranslate = y.translate / treeScale.y;
    return "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) scale(" + x.scale + ", " + y.scale + ")";
}
var identityProjection = buildLayoutProjectionTransform(delta(), {
    x: 1,
    y: 1,
});
/**
 * Take the calculated delta origin and apply it as a transform string.
 */
function buildLayoutProjectionTransformOrigin(_a) {
    var x = _a.x, y = _a.y;
    return x.origin * 100 + "% " + y.origin * 100 + "% 0";
}
/**
 * Build a transform string only from the properties that distort bounding box measurements
 * (rotate and skew)
 */
function buildBoxDistortingTransforms(transform, transformKeys) {
    var transformString = "";
    transformKeys.sort(sortTransformProps);
    var numTransformKeys = transformKeys.length;
    for (var i = 0; i < numTransformKeys; i++) {
        var key = transformKeys[i];
        if (boxDistortingKeys.has(key)) {
            transformString += key + "(" + transform[key] + ") ";
        }
    }
    return transformString;
}

/**
 * Returns true if the provided key is a CSS variable
 */
function isCSSVariable(key) {
    return key.startsWith("--");
}

function isCSSVariable$1(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    var match = cssVariableRegex.exec(current);
    if (!match)
        return [,];
    var _a = __read$1(match, 3), token = _a[1], fallback = _a[2];
    return [token, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element, depth) {
    if (depth === void 0) { depth = 1; }
    invariant$3(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"" + current + "\". This may indicate a circular fallback dependency.");
    var _a = __read$1(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token)
        return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        return resolved.trim();
    }
    else if (isCSSVariable$1(fallback)) {
        // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
        return getVariableValue(fallback, element, depth + 1);
    }
    else {
        return fallback;
    }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */
function resolveCSSVariables(visualElement, _a, transitionEnd) {
    var _b;
    var target = __rest(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof HTMLElement))
        return { target: target, transitionEnd: transitionEnd };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) {
        transitionEnd = __assign({}, transitionEnd);
    }
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function (value) {
        var current = value.get();
        if (!isCSSVariable$1(current))
            return;
        var resolved = getVariableValue(current, element);
        if (resolved)
            value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for (var key in target) {
        var current = target[key];
        if (!isCSSVariable$1(current))
            continue;
        var resolved = getVariableValue(current, element);
        if (!resolved)
            continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd)
            (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : (transitionEnd[key] = current);
    }
    return { target: target, transitionEnd: transitionEnd };
}

function pixelsToPercent(pixels, axis) {
    return (pixels / (axis.max - axis.min)) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
function correctBorderRadius(latest, viewportBox) {
    /**
     * If latest is a string, if it's a percentage we can return immediately as it's
     * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
     */
    if (typeof latest === "string") {
        if (px.test(latest)) {
            latest = parseFloat(latest);
        }
        else {
            return latest;
        }
    }
    /**
     * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
     * pixel value as a percentage of each axis
     */
    var x = pixelsToPercent(latest, viewportBox.x);
    var y = pixelsToPercent(latest, viewportBox.y);
    return x + "% " + y + "%";
}
var varToken = "_$css";
function correctBoxShadow(latest, _viewportBox, delta, treeScale) {
    var original = latest;
    /**
     * We need to first strip and store CSS variables from the string.
     */
    var containsCSSVariables = latest.includes("var(");
    var cssVariables = [];
    if (containsCSSVariables) {
        latest = latest.replace(cssVariableRegex, function (match) {
            cssVariables.push(match);
            return varToken;
        });
    }
    var shadow = complex.parse(latest);
    // TODO: Doesn't support multiple shadows
    if (shadow.length > 5)
        return original;
    var template = complex.createTransformer(latest);
    var offset = typeof shadow[0] !== "number" ? 1 : 0;
    // Calculate the overall context scale
    var xScale = delta.x.scale * treeScale.x;
    var yScale = delta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    /**
     * Ideally we'd correct x and y scales individually, but because blur and
     * spread apply to both we have to take a scale average and apply that instead.
     * We could potentially improve the outcome of this by incorporating the ratio between
     * the two scales.
     */
    var averageScale = mix(xScale, yScale, 0.5);
    // Blur
    if (typeof shadow[2 + offset] === "number")
        shadow[2 + offset] /= averageScale;
    // Spread
    if (typeof shadow[3 + offset] === "number")
        shadow[3 + offset] /= averageScale;
    var output = template(shadow);
    if (containsCSSVariables) {
        var i_1 = 0;
        output = output.replace(varToken, function () {
            var cssVariable = cssVariables[i_1];
            i_1++;
            return cssVariable;
        });
    }
    return output;
}
var borderCorrectionDefinition = {
    process: correctBorderRadius,
};
var valueScaleCorrection = {
    borderRadius: __assign(__assign({}, borderCorrectionDefinition), { applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ] }),
    borderTopLeftRadius: borderCorrectionDefinition,
    borderTopRightRadius: borderCorrectionDefinition,
    borderBottomLeftRadius: borderCorrectionDefinition,
    borderBottomRightRadius: borderCorrectionDefinition,
    boxShadow: {
        process: correctBoxShadow,
    },
};

/**
 * Build style and CSS variables
 *
 * This function converts a Motion style prop:
 *
 * { x: 100, width: 100, originX: 0.5 }
 *
 * Into an object with default value types applied and default
 * transform order set:
 *
 * {
 *   transform: 'translateX(100px) translateZ(0)`,
 *   width: '100px',
 *   transformOrigin: '50% 50%'
 * }
 *
 * Styles are saved to `style` and CSS vars to `vars`.
 *
 * This function works with mutative data structures.
 */
function buildHTMLStyles(latest, style, vars, transform, transformOrigin, transformKeys, _a, isLayoutProjectionEnabled, delta, deltaFinal, treeScale, targetBox) {
    var enableHardwareAcceleration = _a.enableHardwareAcceleration, transformTemplate = _a.transformTemplate, allowTransformNone = _a.allowTransformNone;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable. Transforms and transform origins are kept seperately
     * for further processing
     */
    for (var key in latest) {
        var value = latest[key];
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = getDefaultValueType(key);
        var valueAsType = getValueAsType(value, valueType);
        if (isTransformProp(key)) {
            // If this is a transform, flag and enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            if (!transformIsNone)
                continue;
            // If all the transform keys we've so far encountered are their default value
            // then check to see if this one isn't
            var defaultValue = valueType.default !== undefined ? valueType.default : 0;
            if (value !== defaultValue)
                transformIsNone = false;
        }
        else if (isTransformOriginProp(key)) {
            // If this is a transform origin, flag and enable further transform-origin processing
            transformOrigin[key] = valueAsType;
            hasTransformOrigin = true;
        }
        else if (key !== "transform" || typeof value !== "function") {
            // Handle all remaining values. Decide which map to save to depending
            // on whether this is a CSS variable
            var bucket = isCSSVariable(key) ? vars : style;
            // If we need to perform scale correction, and we have a handler for this
            // value type (ie borderRadius), perform it
            if (isLayoutProjectionEnabled && valueScaleCorrection[key]) {
                var corrected = valueScaleCorrection[key].process(value, targetBox, delta, treeScale);
                /**
                 * Scale-correctable values can define a number of other values to break
                 * down into. For instance borderRadius needs applying to borderBottomLeftRadius etc
                 */
                var applyTo = valueScaleCorrection[key].applyTo;
                if (applyTo) {
                    var num = applyTo.length;
                    for (var i = 0; i < num; i++) {
                        bucket[applyTo[i]] = corrected;
                    }
                }
                else {
                    bucket[key] = corrected;
                }
            }
            else {
                bucket[key] = valueAsType;
            }
        }
    }
    /**
     * Build transform and transformOrigin. If we're performing layout projection these need
     * to be based off the deltaFinal data. Any user-set origins will have been pre-baked
     * into the deltaFinal.
     */
    if (isLayoutProjectionEnabled) {
        style.transform = buildLayoutProjectionTransform(deltaFinal, treeScale);
        if (style.transform === identityProjection)
            style.transform = "";
        /**
         * If we have transform styles, build only those that distort bounding boxes (rotate/skew)
         * as translations and scales will already have been used to calculate deltaFinal.
         */
        if (hasTransform) {
            style.transform +=
                " " + buildBoxDistortingTransforms(transform, transformKeys);
            style.transform = style.transform.trim();
        }
        if (transformTemplate) {
            style.transform = transformTemplate(transform, style.transform);
        }
        style.transformOrigin = buildLayoutProjectionTransformOrigin(deltaFinal);
    }
    else {
        if (hasTransform) {
            style.transform = buildTransform(transform, transformKeys, transformTemplate, transformIsNone, enableHardwareAcceleration, allowTransformNone);
        }
        if (hasTransformOrigin) {
            style.transformOrigin = buildTransformOrigin(transformOrigin);
        }
    }
}

/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function resetAxis(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function resetBox(box, originBox) {
    resetAxis(box.x, originBox.x);
    resetAxis(box.y, originBox.y);
}
/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) { translate = 0; }
    if (scale === void 0) { scale = 1; }
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, _a) {
    var x = _a.x, y = _a.y;
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function applyAxisTransforms(final, axis, transforms, _a) {
    var _b = __read$1(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    // Copy the current axis to the final axis before mutation
    final.min = axis.min;
    final.max = axis.max;
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = mix(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(final, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function applyBoxTransforms(finalBox, box, transforms) {
    applyAxisTransforms(finalBox.x, box.x, transforms, xKeys);
    applyAxisTransforms(finalBox.y, box.y, transforms, yKeys);
}
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis, translate, scale, origin, boxScale) {
    if (translate === void 0) { translate = 0; }
    if (scale === void 0) { scale = 1; }
    if (origin === void 0) { origin = 0.5; }
    var originPoint = mix(axis.min, axis.max, origin) - translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, _a) {
    var _b = __read$1(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale);
}
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms) {
    removeAxisTransforms(box.x, transforms, xKeys);
    removeAxisTransforms(box.y, transforms, yKeys);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within HTMLVisualElement.updateLayoutDelta
 */
function applyTreeDeltas(box, treePath) {
    var treeLength = treePath.length;
    for (var i = 0; i < treeLength; i++) {
        applyBoxDelta(box, treePath[i].delta);
    }
}

var clampProgress = function (v) { return clamp$1(0, 1, v); };
/**
 * Returns true if the provided value is within maxDistance of the provided target
 */
function isNear(value, target, maxDistance) {
    if (target === void 0) { target = 0; }
    if (maxDistance === void 0) { maxDistance = 0.01; }
    return distance(value, target) < maxDistance;
}
function calcLength(axis) {
    return axis.max - axis.min;
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function calcOrigin(source, target) {
    var origin = 0.5;
    var sourceLength = calcLength(source);
    var targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = progress(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = progress(source.min, source.max - targetLength, target.min);
    }
    return clampProgress(origin);
}
/**
 * Update the AxisDelta with a transform that projects source into target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */
function updateAxisDelta(delta, source, target, origin) {
    delta.origin = origin === undefined ? calcOrigin(source, target) : origin;
    delta.originPoint = mix(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001))
        delta.scale = 1;
    delta.translate =
        mix(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate))
        delta.translate = 0;
}
/**
 * Update the BoxDelta with a transform that projects the source into the target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */
function updateBoxDelta(delta, source, target, origin) {
    updateAxisDelta(delta.x, source.x, target.x, origin);
    updateAxisDelta(delta.y, source.y, target.y, origin);
}
/**
 * Update the treeScale by incorporating the parent's latest scale into its treeScale.
 */
function updateTreeScale(treeScale, parentTreeScale, parentDelta) {
    treeScale.x = parentTreeScale.x * parentDelta.x.scale;
    treeScale.y = parentTreeScale.y * parentDelta.y.scale;
}

// Call a handler once for each axis
function eachAxis(handler) {
    return [handler("x"), handler("y")];
}

/**
 * Measure and return the element bounding box.
 *
 * We convert the box into an AxisBox2D to make it easier to work with each axis
 * individually and programmatically.
 *
 * This function optionally accepts a transformPagePoint function which allows us to compensate
 * for, for instance, measuring the element within a scaled plane like a Framer devivce preview component.
 */
function getBoundingBox(element, transformPagePoint) {
    var box = element.getBoundingClientRect();
    return convertBoundingBoxToAxisBox(transformBoundingBox(box, transformPagePoint));
}

var positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
]);
var isPositionalKey = function (key) { return positionalKeys.has(key); };
var hasPositionalKey = function (target) {
    return Object.keys(target).some(isPositionalKey);
};
var setAndResetVelocity = function (value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var isNumOrPxType = function (v) {
    return v === number || v === px;
};
var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function (matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function (pos2, pos3) { return function (_bbox, _a) {
    var transform = _a.transform;
    if (transform === "none" || !transform)
        return 0;
    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
        return getPosFromMatrix(matrix3d[1], pos3);
    }
    else {
        var matrix = transform.match(/^matrix\((.+)\)$/);
        if (matrix) {
            return getPosFromMatrix(matrix[1], pos2);
        }
        else {
            return 0;
        }
    }
}; };
var transformKeys = new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformProps.filter(function (key) { return !transformKeys.has(key); });
function removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    nonTranslationalTransformKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length)
        visualElement.render();
    return removedTransforms;
}
var positionalValues = {
    // Dimensions
    width: function (_a) {
        var x = _a.x;
        return x.max - x.min;
    },
    height: function (_a) {
        var y = _a.y;
        return y.max - y.min;
    },
    top: function (_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function (_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function (_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function (_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
var convertChangedValueTypes = function (target, visualElement, changedKeys) {
    var originBbox = visualElement.getBoundingBox();
    var elementComputedStyle = visualElement.getComputedStyle();
    var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
    var originComputedStyle = { top: top, left: left, bottom: bottom, right: right, transform: transform };
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") {
        visualElement.setStaticValues("display", target.display || "block");
    }
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    var targetBbox = visualElement.getBoundingBox();
    changedKeys.forEach(function (key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        setAndResetVelocity(value, positionalValues[key](originBbox, originComputedStyle));
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var checkAndConvertChangedValueTypes = function (visualElement, target, origin, transitionEnd) {
    if (origin === void 0) { origin = {}; }
    if (transitionEnd === void 0) { transitionEnd = {}; }
    target = __assign({}, target);
    transitionEnd = __assign({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key))
            return;
        var from = origin[key];
        var to = target[key];
        var fromType = findDimensionValueType(from);
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if (isKeyframesTarget(to)) {
            var numKeyframes = to.length;
            for (var i = to[0] === null ? 1 : 0; i < numKeyframes; i++) {
                if (!toType) {
                    toType = findDimensionValueType(to[i]);
                    invariant$3(toType === fromType ||
                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
                }
                else {
                    invariant$3(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
                }
            }
        }
        else {
            toType = findDimensionValueType(to);
        }
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") {
                    value.set(parseFloat(current));
                }
                if (typeof to === "string") {
                    target[key] = parseFloat(to);
                }
                else if (Array.isArray(to) && toType === px) {
                    target[key] = to.map(parseFloat);
                }
            }
            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) {
                    value.set(toType.transform(from));
                }
                else {
                    target[key] = fromType.transform(to);
                }
            }
            else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] =
                    transitionEnd[key] !== undefined
                        ? transitionEnd[key]
                        : target[key];
                setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) {
            removedTransformValues.forEach(function (_a) {
                var _b = __read$1(_a, 2), key = _b[0], value = _b[1];
                visualElement.getValue(key).set(value);
            });
        }
        // Reapply original values
        visualElement.render();
        return { target: convertedTarget, transitionEnd: transitionEnd };
    }
    else {
        return { target: target, transitionEnd: transitionEnd };
    }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */
function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target)
        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
        : { target: target, transitionEnd: transitionEnd };
}

/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
var parseDomVariant = function (visualElement, target, origin, transitionEnd) {
    var resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};

/**
 * A VisualElement for HTMLElements
 */
var HTMLVisualElement = /** @class */ (function (_super) {
    __extends(HTMLVisualElement, _super);
    function HTMLVisualElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         *
         */
        _this.defaultConfig = {
            enableHardwareAcceleration: true,
            allowTransformNone: true,
        };
        /**
         * A mutable record of styles we want to apply directly to the rendered Element
         * every frame. We use a mutable data structure to reduce GC during animations.
         */
        _this.style = {};
        /**
         * A record of styles we only want to apply via React. This gets set in useMotionValues
         * and applied in the render function. I'd prefer this to live somewhere else to decouple
         * VisualElement from React but works for now.
         */
        _this.reactStyle = {};
        /**
         * A mutable record of CSS variables we want to apply directly to the rendered Element
         * every frame. We use a mutable data structure to reduce GC during animations.
         */
        _this.vars = {};
        /**
         * A mutable record of transforms we want to apply directly to the rendered Element
         * every frame. We use a mutable data structure to reduce GC during animations.
         */
        _this.transform = {};
        /**
         * A mutable record of transform origins we want to apply directly to the rendered Element
         * every frame. We use a mutable data structure to reduce GC during animations.
         */
        _this.transformOrigin = {};
        /**
         * A mutable record of transform keys we want to apply to the rendered Element. We order
         * this to order transforms in the desired order. We use a mutable data structure to reduce GC during animations.
         */
        _this.transformKeys = [];
        _this.config = _this.defaultConfig;
        /**
         * ========================================
         * Layout
         * ========================================
         */
        _this.isLayoutProjectionEnabled = false;
        /**
         * A set of layout update event handlers. These are only called once all layouts have been read,
         * making it safe to perform DOM write operations.
         */
        _this.layoutUpdateListeners = new SubscriptionManager();
        _this.layoutMeasureListeners = new SubscriptionManager();
        _this.viewportBoxUpdateListeners = new SubscriptionManager();
        /**
         * Keep track of whether the viewport box has been updated since the last render.
         * If it has, we want to fire the onViewportBoxUpdate listener.
         */
        _this.hasViewportBoxUpdated = false;
        /**
         * The visual target we want to project our component into on a given frame
         * before applying transforms defined in `animate` or `style`.
         *
         * This is considered mutable to avoid object creation on each frame.
         */
        _this.targetBoxFinal = axisBox();
        /**
         * The overall scale of the local coordinate system as transformed by all parents
         * of this component. We use this for scale correction on our calculated layouts
         * and scale-affected values like `boxShadow`.
         *
         * This is considered mutable to avoid object creation on each frame.
         */
        _this.treeScale = { x: 1, y: 1 };
        _this.prevTreeScale = { x: 1, y: 1 };
        /**
         * The delta between the boxCorrected and the desired
         * targetBox (before user-set transforms are applied). The calculated output will be
         * handed to the renderer and used as part of the style correction calculations, for
         * instance calculating how to display the desired border-radius correctly.
         *
         * This is considered mutable to avoid object creation on each frame.
         */
        _this.delta = delta();
        /**
         * The delta between the boxCorrected and the desired targetBoxFinal. The calculated
         * output will be handed to the renderer and used to project the boxCorrected into
         * the targetBoxFinal.
         *
         * This is considered mutable to avoid object creation on each frame.
         */
        _this.deltaFinal = delta();
        /**
         * The computed transform string to apply deltaFinal to the element. Currently this is only
         * being used to diff and decide whether to render on the current frame, but a minor optimisation
         * could be to provide this to the buildHTMLStyle function.
         */
        _this.deltaTransform = identityProjection;
        /**
         *
         */
        _this.stopLayoutAxisAnimation = {
            x: function () { },
            y: function () { },
        };
        _this.isTargetBoxLocked = false;
        /**
         *
         */
        _this.axisProgress = {
            x: motionValue(0),
            y: motionValue(0),
        };
        _this.updateLayoutDelta = function () {
            _this.isLayoutProjectionEnabled && _this.box && _this.updateLayoutDeltas();
            /**
             * Ensure all children layouts are also updated.
             *
             * This uses a pre-bound function executor rather than a lamda to avoid creating a new function
             * multiple times per frame (source of mid-animation GC)
             */
            _this.children.forEach(fireUpdateLayoutDelta);
        };
        return _this;
    }
    /**
     * When a value is removed, we want to make sure it's removed from all rendered data structures.
     */
    HTMLVisualElement.prototype.removeValue = function (key) {
        _super.prototype.removeValue.call(this, key);
        delete this.vars[key];
        delete this.style[key];
    };
    /**
     * Empty the mutable data structures by re-creating them. We can do this every React render
     * as the comparative workload to the rest of the render is very low and this is also when
     * we want to reflect values that might have been removed by the render.
     */
    HTMLVisualElement.prototype.clean = function () {
        this.style = {};
        this.vars = {};
        this.transform = {};
    };
    HTMLVisualElement.prototype.updateConfig = function (config) {
        if (config === void 0) { config = {}; }
        this.config = __assign(__assign({}, this.defaultConfig), config);
    };
    /**
     * Read a value directly from the HTMLElement style.
     */
    HTMLVisualElement.prototype.read = function (key) {
        return this.getComputedStyle()[key] || 0;
    };
    HTMLVisualElement.prototype.addValue = function (key, value) {
        _super.prototype.addValue.call(this, key, value);
        // If we have rotate values we want to foce the layoutOrigin used in layout projection
        // to the center of the element.
        if (key.startsWith("rotate"))
            this.layoutOrigin = 0.5;
    };
    /**
     * Read a value directly from the HTMLElement in case it's not defined by a Motion
     * prop. If it's a transform, we just return a pre-defined default value as reading these
     * out of a matrix is either error-prone or can incur a big payload for little benefit.
     */
    HTMLVisualElement.prototype.readNativeValue = function (key) {
        if (isTransformProp(key)) {
            var defaultValueType = getDefaultValueType(key);
            return defaultValueType ? defaultValueType.default || 0 : 0;
        }
        else {
            return this.read(key);
        }
    };
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */
    HTMLVisualElement.prototype.makeTargetAnimatable = function (_a, parseDOMValues) {
        if (parseDOMValues === void 0) { parseDOMValues = true; }
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = __rest(_a, ["transition", "transitionEnd"]);
        var transformValues = this.config.transformValues;
        var origin = getOrigin(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */
        if (transformValues) {
            if (transitionEnd)
                transitionEnd = transformValues(transitionEnd);
            if (target)
                target = transformValues(target);
            if (origin)
                origin = transformValues(origin);
        }
        if (parseDOMValues) {
            checkTargetForNewValues(this, target, origin);
            var parsed = parseDomVariant(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return __assign({ transition: transition,
            transitionEnd: transitionEnd }, target);
    };
    HTMLVisualElement.prototype.enableLayoutProjection = function () {
        this.isLayoutProjectionEnabled = true;
    };
    HTMLVisualElement.prototype.hide = function () {
        if (this.isVisible === false)
            return;
        this.isVisible = false;
        this.scheduleRender();
    };
    HTMLVisualElement.prototype.show = function () {
        if (this.isVisible === true)
            return;
        this.isVisible = true;
        this.scheduleRender();
    };
    /**
     * Register an event listener to fire when the layout is updated. We might want to expose support
     * for this via a `motion` prop.
     */
    HTMLVisualElement.prototype.onLayoutUpdate = function (callback) {
        return this.layoutUpdateListeners.add(callback);
    };
    HTMLVisualElement.prototype.onLayoutMeasure = function (callback) {
        return this.layoutMeasureListeners.add(callback);
    };
    HTMLVisualElement.prototype.onViewportBoxUpdate = function (callback) {
        return this.viewportBoxUpdateListeners.add(callback);
    };
    /**
     * To be called when all layouts are successfully updated. In turn we can notify layoutUpdate
     * subscribers.
     */
    HTMLVisualElement.prototype.layoutReady = function (config) {
        this.layoutUpdateListeners.notify(this.box, this.prevViewportBox || this.box, config);
    };
    /**
     * Measure and return the Element's bounding box. We convert it to a AxisBox2D
     * structure to make it easier to work on each individual axis generically.
     */
    HTMLVisualElement.prototype.getBoundingBox = function () {
        var transformPagePoint = this.config.transformPagePoint;
        return getBoundingBox(this.element, transformPagePoint);
    };
    HTMLVisualElement.prototype.getBoundingBoxWithoutTransforms = function () {
        var bbox = this.getBoundingBox();
        removeBoxTransforms(bbox, this.latest);
        return bbox;
    };
    /**
     * Return the computed style after a render.
     */
    HTMLVisualElement.prototype.getComputedStyle = function () {
        return window.getComputedStyle(this.element);
    };
    /**
     * Record the bounding box as it exists before a re-render.
     */
    HTMLVisualElement.prototype.snapshotBoundingBox = function () {
        this.prevViewportBox = this.getBoundingBoxWithoutTransforms();
        /**
         * Update targetBox to match the prevViewportBox. This is just to ensure
         * that targetBox is affected by scroll in the same way as the measured box
         */
        this.rebaseTargetBox(false, this.prevViewportBox);
    };
    HTMLVisualElement.prototype.rebaseTargetBox = function (force, box) {
        var _this = this;
        if (force === void 0) { force = false; }
        if (box === void 0) { box = this.box; }
        var _a = this.axisProgress, x = _a.x, y = _a.y;
        var shouldRebase = this.box &&
            !this.isTargetBoxLocked &&
            !x.isAnimating() &&
            !y.isAnimating();
        if (force || shouldRebase) {
            eachAxis(function (axis) {
                var _a = box[axis], min = _a.min, max = _a.max;
                _this.setAxisTarget(axis, min, max);
            });
        }
    };
    HTMLVisualElement.prototype.measureLayout = function () {
        var _this = this;
        this.box = this.getBoundingBox();
        this.boxCorrected = copyAxisBox(this.box);
        if (!this.targetBox)
            this.targetBox = copyAxisBox(this.box);
        this.layoutMeasureListeners.notify(this.box, this.prevViewportBox || this.box);
        sync.update(function () { return _this.rebaseTargetBox(); });
    };
    HTMLVisualElement.prototype.lockTargetBox = function () {
        this.isTargetBoxLocked = true;
    };
    HTMLVisualElement.prototype.unlockTargetBox = function () {
        this.stopLayoutAnimation();
        this.isTargetBoxLocked = false;
    };
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */
    HTMLVisualElement.prototype.resetTransform = function () {
        var transformTemplate = this.config.transformTemplate;
        this.element.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        // Ensure that whatever happens next, we restore our transform
        this.scheduleRender();
    };
    /**
     * Set new min/max boundaries to project an axis into
     */
    HTMLVisualElement.prototype.setAxisTarget = function (axis, min, max) {
        var targetAxis = this.targetBox[axis];
        targetAxis.min = min;
        targetAxis.max = max;
        // Flag that we want to fire the onViewportBoxUpdate event handler
        this.hasViewportBoxUpdated = true;
        this.rootParent.scheduleUpdateLayoutDelta();
    };
    /**
     *
     */
    HTMLVisualElement.prototype.startLayoutAxisAnimation = function (axis, transition) {
        var _this = this;
        var _a;
        var progress = this.axisProgress[axis];
        var _b = this.targetBox[axis], min = _b.min, max = _b.max;
        var length = max - min;
        progress.clearListeners();
        progress.set(min);
        progress.set(min); // Set twice to hard-reset velocity
        progress.onChange(function (v) { return _this.setAxisTarget(axis, v, v + length); });
        return (_a = this.animateMotionValue) === null || _a === void 0 ? void 0 : _a.call(this, axis, progress, 0, transition);
    };
    HTMLVisualElement.prototype.stopLayoutAnimation = function () {
        var _this = this;
        eachAxis(function (axis) { return _this.axisProgress[axis].stop(); });
    };
    /**
     * Update the layout deltas to reflect the relative positions of the layout
     * and the desired target box
     */
    HTMLVisualElement.prototype.updateLayoutDeltas = function () {
        /**
         * Reset the corrected box with the latest values from box, as we're then going
         * to perform mutative operations on it.
         */
        resetBox(this.boxCorrected, this.box);
        /**
         * If this component has a parent, update this treeScale by incorporating the parent's
         * delta into its treeScale.
         */
        if (this.parent) {
            this.prevTreeScale.x = this.treeScale.x;
            this.prevTreeScale.y = this.treeScale.y;
            updateTreeScale(this.treeScale, this.parent.treeScale, this.parent.delta);
        }
        /**
         * Apply all the parent deltas to this box to produce the corrected box. This
         * is the layout box, as it will appear on screen as a result of the transforms of its parents.
         */
        applyTreeDeltas(this.boxCorrected, this.treePath);
        /**
         * Update the delta between the corrected box and the target box before user-set transforms were applied.
         * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
         * for our layout reprojection, but still allow them to be scaled correctly by the user.
         * It might be that to simplify this we may want to accept that user-set scale is also corrected
         * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
         * to allow people to choose whether these styles are corrected based on just the
         * layout reprojection or the final bounding box.
         */
        updateBoxDelta(this.delta, this.boxCorrected, this.targetBox, this.layoutOrigin);
        /**
         * If we have a listener for the viewport box, fire it.
         */
        this.hasViewportBoxUpdated &&
            this.viewportBoxUpdateListeners.notify(this.targetBox, this.delta);
        this.hasViewportBoxUpdated = false;
        /**
         * Ensure this element renders on the next frame if the projection transform has changed.
         */
        var deltaTransform = buildLayoutProjectionTransform(this.delta, this.treeScale);
        if (deltaTransform !== this.deltaTransform ||
            // Also compare calculated treeScale, for values that rely on only this for scale correction.
            this.prevTreeScale.x !== this.treeScale.x ||
            this.prevTreeScale.y !== this.treeScale.y) {
            this.scheduleRender();
        }
        this.deltaTransform = deltaTransform;
    };
    HTMLVisualElement.prototype.updateTransformDeltas = function () {
        if (!this.isLayoutProjectionEnabled || !this.box)
            return;
        /**
         * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
         * This is the final box that we will then project into by calculating a transform delta and
         * applying it to the corrected box.
         */
        applyBoxTransforms(this.targetBoxFinal, this.targetBox, this.latest);
        /**
         * Update the delta between the corrected box and the final target box, after
         * user-set transforms are applied to it. This will be used by the renderer to
         * create a transform style that will reproject the element from its actual layout
         * into the desired bounding box.
         */
        updateBoxDelta(this.deltaFinal, this.boxCorrected, this.targetBoxFinal, this.layoutOrigin);
    };
    /**
     * ========================================
     * Build & render
     * ========================================
     */
    /**
     * Build a style prop using the latest resolved MotionValues
     */
    HTMLVisualElement.prototype.build = function () {
        this.updateTransformDeltas();
        if (this.isVisible !== undefined) {
            this.style.visibility = this.isVisible ? "visible" : "hidden";
        }
        buildHTMLStyles(this.latest, this.style, this.vars, this.transform, this.transformOrigin, this.transformKeys, this.config, this.isLayoutProjectionEnabled && !!this.box, this.delta, this.deltaFinal, this.treeScale, this.targetBoxFinal);
    };
    /**
     * Render the Element by rebuilding and applying the latest styles and vars.
     */
    HTMLVisualElement.prototype.render = function () {
        // Rebuild the latest animated values into style and vars caches.
        this.build();
        // Directly assign style into the Element's style prop. In tests Object.assign is the
        // fastest way to assign styles.
        Object.assign(this.element.style, this.style);
        // Loop over any CSS variables and assign those.
        for (var key in this.vars) {
            this.element.style.setProperty(key, this.vars[key]);
        }
    };
    return HTMLVisualElement;
}(VisualElement));
/**
 * Pre-bound version of updateLayoutDelta so we're not creating a new function multiple
 * times per frame.
 */
var fireUpdateLayoutDelta = function (child) {
    return child.updateLayoutDelta();
};

/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
    var ref = React$2.useRef(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}

function calcOrigin$1(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
    var pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
    var pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
    return pxOriginX + " " + pxOriginY;
}

// Convert a progress 0-1 to a pixels value based on the provided length
var progressToPixels = function (progress, length) {
    return px.transform(progress * length);
};
var dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
var camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, totalLength, length, spacing, offset, useDashCase) {
    if (spacing === void 0) { spacing = 1; }
    if (offset === void 0) { offset = 0; }
    if (useDashCase === void 0) { useDashCase = true; }
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = progressToPixels(-offset, totalLength);
    // Build the dash array
    var pathLength = progressToPixels(length, totalLength);
    var pathSpacing = progressToPixels(spacing, totalLength);
    attrs[keys.array] = pathLength + " " + pathSpacing;
}

var unmeasured = { x: 0, y: 0, width: 0, height: 0 };
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(_a, style, vars, attrs, transform, transformOrigin, transformKeys, config, dimensions, totalPathLength, isLayoutProjectionEnabled, delta, deltaFinal, treeScale, targetBox) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, 
    // This is object creation, which we try to avoid per-frame.
    latest = __rest(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
    /**
     * With SVG we treat all animated values as attributes rather than CSS, so we build into attrs
     */
    buildHTMLStyles(latest, attrs, vars, transform, transformOrigin, transformKeys, config, isLayoutProjectionEnabled, delta, deltaFinal, treeScale, targetBox);
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */
    if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (originX !== undefined || originY !== undefined || style.transform) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions || unmeasured, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    // Build SVG path if one has been measured
    if (totalPathLength !== undefined && pathLength !== undefined) {
        buildSVGPath(attrs, totalPathLength, pathLength, pathSpacing, pathOffset, false);
    }
    return attrs;
}

/**
 * A set of attribute names that are always read/written as camel case.
 */
var camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
]);

var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */
var camelToDash = function (str) {
    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};

/**
 * A VisualElement for SVGElements. Inherits from and extends HTMLVisualElement as the two
 * share data structures.
 */
var SVGVisualElement = /** @class */ (function (_super) {
    __extends(SVGVisualElement, _super);
    function SVGVisualElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * A mutable record of attributes we want to apply directly to the rendered Element
         * every frame. We use a mutable data structure to reduce GC during animations.
         */
        _this.attrs = {};
        /**
         * We disable hardware acceleration for SVG transforms as they're not currently able to be accelerated.
         */
        _this.defaultConfig = {
            enableHardwareAcceleration: false,
        };
        /**
         * Without duplicating this call from HTMLVisualElement we end up with HTMLVisualElement.defaultConfig
         * being assigned to config
         */
        _this.config = _this.defaultConfig;
        return _this;
    }
    /**
     * Measure the SVG element on mount. This can affect page rendering so there might be a
     * better time to perform this - for instance dynamically only if there's a transform-origin dependent
     * transform being set (like rotate)
     */
    SVGVisualElement.prototype.mount = function (element) {
        _super.prototype.mount.call(this, element);
        this.measure();
    };
    /**
     * Update the SVG dimensions and path length
     */
    SVGVisualElement.prototype.measure = function () {
        try {
            this.dimensions =
                typeof this.element.getBBox ===
                    "function"
                    ? this.element.getBBox()
                    : this.element.getBoundingClientRect();
        }
        catch (e) {
            // Most likely trying to measure an unrendered element under Firefox
            this.dimensions = { x: 0, y: 0, width: 0, height: 0 };
        }
        if (isPath(this.element)) {
            this.totalPathLength = this.element.getTotalLength();
        }
    };
    /**
     * Empty the mutable data structures in case attrs have been removed between renders.
     */
    SVGVisualElement.prototype.clean = function () {
        _super.prototype.clean.call(this);
        this.attrs = {};
    };
    /**
     * Read an attribute directly from the SVGElement
     */
    SVGVisualElement.prototype.read = function (key) {
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return this.element.getAttribute(key);
    };
    SVGVisualElement.prototype.build = function () {
        this.updateTransformDeltas();
        buildSVGAttrs(this.latest, this.style, this.vars, this.attrs, this.transform, this.transformOrigin, this.transformKeys, this.config, this.dimensions, this.totalPathLength, this.isLayoutProjectionEnabled && !!this.box, this.delta, this.deltaFinal, this.treeScale, this.targetBoxFinal);
    };
    SVGVisualElement.prototype.render = function () {
        // Update HTML styles and CSS variables
        _super.prototype.render.call(this);
        // Loop through attributes and apply them to the SVGElement
        for (var key in this.attrs) {
            this.element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, this.attrs[key]);
        }
    };
    return SVGVisualElement;
}(HTMLVisualElement));
function isPath(element) {
    return element.tagName === "path";
}

/**
 * @internal
 */
/**
 * @internal
 */
var svgElements = [
    "animate",
    "circle",
    "clipPath",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tspan",
    "use",
    "view",
];

var svgTagNames = new Set(svgElements);
/**
 * Determine whether this is a HTML or SVG component based on if the provided
 * Component is a string and a recognised SVG tag. A potentially better way to
 * do this would be to offer a `motion.customSVG` function and determine this
 * when we generate the `motion.circle` etc components.
 */
function isSVGComponent(Component) {
    return typeof Component === "string" && svgTagNames.has(Component);
}

/**
 * @public
 */
var PresenceContext = React$2.createContext(null);

var MotionContext = React$2.createContext({
    variantContext: {},
});
function useVariantContext() {
    return React$2.useContext(MotionContext).variantContext;
}
function useVisualElementContext() {
    return React$2.useContext(MotionContext).visualElement;
}

/**
 * DOM-flavoured variation of the useVisualElement hook. Used to create either a HTMLVisualElement
 * or SVGVisualElement for the component.
 *
 */
var useDomVisualElement = function (Component, props, isStatic, ref) {
    var parent = useVisualElementContext();
    var visualElement = useConstant(function () {
        var DOMVisualElement = isSVGComponent(Component)
            ? SVGVisualElement
            : HTMLVisualElement;
        return new DOMVisualElement(parent, ref);
    });
    visualElement.updateConfig(__assign(__assign(__assign({}, visualElement.config), { enableHardwareAcceleration: !isStatic }), props));
    visualElement.layoutId = props.layoutId;
    var presenceContext = React$2.useContext(PresenceContext);
    /**
     * Update VisualElement with presence data.
     */
    var isPresent = presenceContext === null ? true : presenceContext.isPresent;
    visualElement.isPresent =
        props.isPresent !== undefined ? props.isPresent : isPresent;
    /**
     *
     */
    var presenceId = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id;
    visualElement.isPresenceRoot = !parent || parent.presenceId !== presenceId;
    /**
     * TODO: Investigate if we need this
     */
    React$2.useEffect(function () {
        if (props.onViewportBoxUpdate) {
            return visualElement.onViewportBoxUpdate(props.onViewportBoxUpdate);
        }
    }, [props.onViewportBoxUpdate]);
    return visualElement;
};

/**
 * A list of all valid MotionProps.
 *
 * @internalremarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
var validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "onLayoutAnimationComplete",
    "onViewportBoxUpdate",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "whileHover",
    "whileTap",
    "onHoverEnd",
    "onHoverStart",
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
    return validMotionProps.has(key);
}

var isPropValid = function (key) { return !isValidMotionProp(key); };
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
    var emotionIsPropValid_1 = require("@emotion/is-prop-valid").default;
    isPropValid = function (key) {
        // Handle events explicitly as Emotion validates them all as true
        if (key.startsWith("on")) {
            return !isValidMotionProp(key);
        }
        else {
            return emotionIsPropValid_1(key);
        }
    };
}
catch (_a) {
    // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props) {
    var domProps = {};
    for (var key in props) {
        if (isPropValid(key))
            domProps[key] = props[key];
    }
    return domProps;
}

function buildHTMLProps(visualElement, _a) {
    var drag = _a.drag;
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {
        style: __assign(__assign(__assign({}, visualElement.reactStyle), visualElement.style), visualElement.vars),
    };
    if (!!drag) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        htmlProps.style.userSelect = "none";
        // Disable scrolling on the draggable direction
        htmlProps.style.touchAction =
            drag === true ? "none" : "pan-" + (drag === "x" ? "y" : "x");
    }
    return htmlProps;
}

/**
 * Build React props for SVG elements
 */
function buildSVGProps(visualElement) {
    return __assign(__assign({}, visualElement.attrs), { style: __assign({}, visualElement.reactStyle) });
}

function render(Component, props, visualElement) {
    // Only filter props from components we control, ie `motion.div`. If this
    // is a custom component pass along everything provided to it.
    var forwardedProps = typeof Component === "string" ? filterProps(props) : props;
    /**
     * Every render, empty and rebuild the animated values to be applied to our Element.
     * During animation these data structures are used in a mutable fashion to reduce
     * garbage collection, but between renders we can flush them to remove values
     * that might have been taken out of the provided props.
     */
    visualElement.clean();
    visualElement.build();
    // Generate props to visually render this component
    var visualProps = isSVGComponent(Component)
        ? buildSVGProps(visualElement)
        : buildHTMLProps(visualElement, props);
    return React$2.createElement(Component, __assign(__assign(__assign({}, forwardedProps), { ref: visualElement.ref }), visualProps));
}

var isMotionValue = function (value) {
    return value instanceof MotionValue;
};

function isForcedMotionValue(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (isTransformProp(key) ||
        isTransformOriginProp(key) ||
        ((layout || layoutId !== undefined) && !!valueScaleCorrection[key]));
}
/**
 * Scrape props for MotionValues and add/remove them to this component's
 * VisualElement
 */
function useMotionValues(visualElement, props) {
    var prev = useConstant(empty);
    /**
     * Remove MotionValues that are no longer present
     */
    for (var key in prev) {
        var isForced = isForcedMotionValue(key, props);
        var existsAsProp = props[key] !== undefined;
        var existsAsStyle = props.style && props.style[key] !== undefined;
        var propIsMotionValue = existsAsProp && isMotionValue(props[key]);
        var styleIsMotionValue = existsAsStyle && isMotionValue(props.style[key]);
        var transformRemoved = isForced && !existsAsProp && !existsAsStyle;
        var motionValueRemoved = !isForced && !propIsMotionValue && !styleIsMotionValue;
        if (transformRemoved || motionValueRemoved) {
            visualElement.removeValue(key);
            delete prev[key];
        }
    }
    /**
     * Add incoming MotionValues
     */
    addMotionValues(visualElement, prev, props, false, props);
    if (props.style)
        addMotionValues(visualElement, prev, props.style, true, props);
    /**
     * Transform custom values if provided a handler, ie size -> width/height
     * Ideally we'd ditch this by removing support for size and other custom values from Framer.
     */
    if (props.transformValues) {
        visualElement.reactStyle = props.transformValues(visualElement.reactStyle);
    }
}
/**
 * Add incoming MotionValues
 *
 * TODO: Type the VisualElements properly
 */
function addMotionValues(visualElement, prev, source, isStyle, props) {
    if (isStyle === void 0) { isStyle = false; }
    if (isStyle)
        visualElement.reactStyle = {};
    for (var key in source) {
        var value = source[key];
        var foundMotionValue = false;
        if (isMotionValue(value)) {
            // If this is a MotionValue, add it if it isn't a reserved key
            if (!reservedNames.has(key)) {
                visualElement.addValue(key, value);
                foundMotionValue = true;
            }
        }
        else if (isForcedMotionValue(key, props)) {
            // If this is a transform prop, always create a MotionValue
            // to ensure we can reconcile them all together.
            if (!visualElement.hasValue(key)) {
                visualElement.addValue(key, motionValue(value));
            }
            else if (value !== prev[key]) {
                if (isMotionValue(prev[key])) {
                    /**
                     * If the previous value was a MotionValue, and this value isn't,
                     * we want to create a new MotionValue rather than update one that's been removed.
                     */
                    visualElement.addValue(key, motionValue(value));
                }
                else {
                    /**
                     * Otherwise, we just want to ensure the MotionValue is of the latest value.
                     */
                    var motion = visualElement.getValue(key);
                    motion.set(value);
                }
            }
            foundMotionValue = true;
        }
        else if (isStyle) {
            visualElement.reactStyle[key] = value;
        }
        if (foundMotionValue)
            prev[key] = value;
    }
}
/**
 * These are props we accept as MotionValues but don't want to add
 * to the VisualElement
 */
var reservedNames = new Set([]);
var empty = function () { return ({}); };

/**
 * @public
 */
var MotionConfigContext = React$2.createContext({
    transformPagePoint: function (p) { return p; },
    features: [],
    isStatic: false,
});

function checkShouldInheritVariant(_a) {
    var animate = _a.animate, variants = _a.variants, inherit = _a.inherit;
    return inherit === undefined ? !!variants && !animate : inherit;
}

/**
 * Load features via renderless components based on the provided MotionProps
 */
function useFeatures(defaultFeatures, isStatic, visualElement, props) {
    var plugins = React$2.useContext(MotionConfigContext);
    // If this is a static component, or we're rendering on the server, we don't load
    // any feature components
    if (isStatic || typeof window === "undefined")
        return null;
    var allFeatures = __spread$1(defaultFeatures, plugins.features);
    var numFeatures = allFeatures.length;
    var features = [];
    // Decide which features we should render and add them to the returned array
    for (var i = 0; i < numFeatures; i++) {
        var _a = allFeatures[i], shouldRender = _a.shouldRender, key = _a.key, getComponent = _a.getComponent;
        if (shouldRender(props)) {
            var Component = getComponent(props);
            Component &&
                features.push(React$2.createElement(Component, __assign({ key: key }, props, { visualElement: visualElement, inherit: checkShouldInheritVariant(props) })));
        }
    }
    return features;
}

var Presence;
(function (Presence) {
    Presence[Presence["Entering"] = 0] = "Entering";
    Presence[Presence["Present"] = 1] = "Present";
    Presence[Presence["Exiting"] = 2] = "Exiting";
})(Presence || (Presence = {}));
var VisibilityAction;
(function (VisibilityAction) {
    VisibilityAction[VisibilityAction["Hide"] = 0] = "Hide";
    VisibilityAction[VisibilityAction["Show"] = 1] = "Show";
})(VisibilityAction || (VisibilityAction = {}));

/**
 * Default handlers for batching VisualElements
 */
var defaultHandler = {
    measureLayout: function (child) { return child.measureLayout(); },
    layoutReady: function (child) { return child.layoutReady(); },
};
/**
 * Sort VisualElements by tree depth, so we process the highest elements first.
 */
var sortByDepth = function (a, b) {
    return a.depth - b.depth;
};
/**
 * Create a batcher to process VisualElements
 */
function createBatcher() {
    var queue = new Set();
    var add = function (child) { return queue.add(child); };
    var flush = function (_a) {
        var _b = _a === void 0 ? defaultHandler : _a, measureLayout = _b.measureLayout, layoutReady = _b.layoutReady;
        var order = Array.from(queue).sort(sortByDepth);
        /**
         * Write: Reset any transforms on children elements so we can read their actual layout
         */
        order.forEach(function (child) { return child.resetTransform(); });
        /**
         * Read: Measure the actual layout
         */
        order.forEach(measureLayout);
        /**
         * Write: Notify the VisualElements they're ready for further write operations.
         */
        order.forEach(layoutReady);
        /**
         * After all children have started animating, ensure any Entering components are set to Present.
         * If we add deferred animations (set up all animations and then start them in two loops) this
         * could be moved to the start loop. But it needs to happen after all the animations configs
         * are generated in AnimateSharedLayout as this relies on presence data
         */
        order.forEach(function (child) {
            if (child.isPresent)
                child.presence = Presence.Present;
        });
        queue.clear();
    };
    return { add: add, flush: flush };
}
function isSharedLayout(context) {
    return !!context.forceUpdate;
}
var SharedLayoutContext = React$2.createContext(createBatcher());

var isBrowser$2 = typeof window !== "undefined";
var useIsomorphicLayoutEffect = isBrowser$2 ? React$2.useLayoutEffect : React$2.useEffect;

function useSnapshotOnUnmount(visualElement) {
    var syncLayout = React$2.useContext(SharedLayoutContext);
    useIsomorphicLayoutEffect(function () { return function () {
        if (isSharedLayout(syncLayout)) {
            syncLayout.remove(visualElement);
        }
    }; }, []);
}

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
    var context = React$2.useContext(PresenceContext);
    if (context === null)
        return [true, null];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useOpaqueId when released in React
    var id = useUniqueId();
    React$2.useEffect(function () { return register(id); }, []);
    var safeToRemove = function () { return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id); };
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
function isPresent(context) {
    return context === null ? true : context.isPresent;
}
var counter = 0;
var incrementId = function () { return counter++; };
var useUniqueId = function () { return useConstant(incrementId); };

/**
 * Use callback either only on the initial render or on all renders. In concurrent mode
 * the "initial" render might run multiple times
 *
 * @param callback - Callback to run
 * @param isInitialOnly - Set to `true` to only run on initial render, or `false` for all renders. Defaults to `false`.
 *
 * @public
 */
function useInitialOrEveryRender(callback, isInitialOnly) {
    if (isInitialOnly === void 0) { isInitialOnly = false; }
    var isInitialRender = React$2.useRef(true);
    if (!isInitialOnly || (isInitialOnly && isInitialRender.current)) {
        callback();
    }
    isInitialRender.current = false;
}

/**
 * This hook is resonsible for creating the variant-propagation tree
 * relationship between VisualElements.
 */
function useVariants(visualElement, _a, isStatic) {
    var _b, _c;
    var variants = _a.variants, initial = _a.initial, animate = _a.animate, whileTap = _a.whileTap, whileHover = _a.whileHover;
    var _d = useVariantContext(), parent = _d.parent, parentInitial = _d.initial, parentAnimate = _d.animate;
    var presenceContext = React$2.useContext(PresenceContext);
    /**
     * We only add this VisualElement to the variant tree *if* we're:
     * 1. Being provided a variants prop
     * 2. Being used to control variants (ie animate, whileHover etc)
     * 3. Or being passed animation controls, which we have to assume may control variants
     * Otherwise this component should be "invisible" to variant propagation. This is a concession
     * to Framer which uses a `motion` component in every `Frame` and it might be if we change that
     * in the future that this restriction is removed.
     */
    var controlsVariants = isVariantLabel$1(animate) ||
        isVariantLabel$1(whileTap) ||
        isVariantLabel$1(whileHover) ||
        isAnimationControls(animate);
    var isVariantNode = variants || controlsVariants;
    /**
     * Override initial with one from a parent `AnimatePresence`, if present
     */
    initial = (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) !== null && _b !== void 0 ? _b : initial;
    /**
     * If initial is false, and animate isn't animation controls, we assign animate
     * to initial and set our values to that for the initial render.
     */
    if (initial === false && !isAnimationControls(animate)) {
        initial = animate;
    }
    var context = React$2.useMemo(function () { return ({
        parent: isVariantNode ? visualElement : parent,
        initial: isVariantLabel$1(initial) ? initial : parentInitial,
        animate: isVariantLabel$1(animate) ? animate : parentAnimate,
    }); }, 
    /**
     * Only create a new context value (thereby re-rendering children) if this
     * is a static component and `initial` changes.
     */
    [isStatic ? initial : null]);
    // Set initial state. If this is a static component (ie in Framer canvas), respond to updates
    // in `initial`.
    useInitialOrEveryRender(function () {
        var initialToApply = initial || parentInitial;
        initialToApply && setValues(visualElement, initialToApply);
    }, !isStatic);
    /**
     * Subscribe to the parent visualElement if this is a participant in the variant tree
     */
    isVariantNode && !controlsVariants && (parent === null || parent === void 0 ? void 0 : parent.addVariantChild(visualElement));
    /**
     * If this component isn't exiting the tree, clear all the children in the render phase.
     * This will allow children to resubscribe in the correct order to ensure the correct stagger order.
     */
    isPresent(presenceContext) && ((_c = visualElement.variantChildrenOrder) === null || _c === void 0 ? void 0 : _c.clear());
    /**
     * Subscribe to the propagated parent.
     */
    React$2.useEffect(function () {
        isVariantNode && (parent === null || parent === void 0 ? void 0 : parent.addVariantChildOrder(visualElement));
    });
    /**
     * Track mount status so children can detect whether they were present during the
     * component's initial mount.
     */
    React$2.useEffect(function () {
        visualElement.isMounted = true;
        return function () {
            var _a;
            visualElement.isMounted = false;
            (_a = parent === null || parent === void 0 ? void 0 : parent.variantChildren) === null || _a === void 0 ? void 0 : _a.delete(visualElement);
        };
    }, []);
    /**
     * We want to update the "base" (or fallback) value on the initial render.
     */
    useInitialOrEveryRender(function () {
        visualElement.forEachValue(function (value, key) {
            visualElement.baseTarget[key] = value.get();
        });
    }, true);
    return context;
}
function isVariantLabel$1(v) {
    return typeof v === "string" || Array.isArray(v);
}
function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}

/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 *
 * @internal
 */
function createMotionComponent(Component, _a) {
    var defaultFeatures = _a.defaultFeatures, useVisualElement = _a.useVisualElement, render = _a.render;
    function MotionComponent(props, externalRef) {
        /**
         * If a component is static, we only visually update it as a
         * result of a React re-render, rather than any interactions or animations.
         * If this component or any ancestor is static, we disable hardware acceleration
         * and don't load any additional functionality.
         */
        var isStatic = React$2.useContext(MotionConfigContext).isStatic;
        /**
         * Create a VisualElement for this component. A VisualElement provides a common
         * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
         * providing a way of rendering to these APIs outside of the React render loop
         * for more performant animations and interactions
         */
        var visualElement = useVisualElement(Component, props, isStatic, externalRef);
        /**
         * Scrape MotionValues from props and add/remove them to/from the VisualElement.
         */
        useMotionValues(visualElement, props);
        /**
         * Add the visualElement as a node in the variant tree.
         */
        var variantContext = useVariants(visualElement, props, isStatic);
        /**
         * Load features as renderless components unless the component isStatic
         */
        var features = useFeatures(defaultFeatures, isStatic, visualElement, props);
        /**
         * Only create a new context value when the sub-contexts change.
         */
        var context = React$2.useMemo(function () { return ({ visualElement: visualElement, variantContext: variantContext }); }, [
            visualElement,
            variantContext,
        ]);
        var component = render(Component, props, visualElement);
        /**
         * If this component is a child of AnimateSharedLayout, we need to snapshot the component
         * before it's unmounted. This lives here rather than in features/layout/Measure because
         * as a child component its unmount effect runs after this component has been unmounted.
         */
        useSnapshotOnUnmount(visualElement);
        // The mount order and hierarchy is specific to ensure our element ref is hydrated by the time
        // all plugins and features has to execute.
        return (React$2.createElement(React$2.Fragment, null,
            React$2.createElement(MotionContext.Provider, { value: context }, component),
            features));
    }
    return React$2.forwardRef(MotionComponent);
}

function createLock(name) {
    var lock = null;
    return function () {
        var openLock = function () {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    var lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        var openHorizontal_1 = globalHorizontalLock();
        var openVertical_1 = globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) {
            lock = function () {
                openHorizontal_1();
                openVertical_1();
            };
        }
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1)
                openHorizontal_1();
            if (openVertical_1)
                openVertical_1();
        }
    }
    return lock;
}

function addDomEvent(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function () { return target.removeEventListener(eventName, handler, options); };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */
function useDomEvent(ref, eventName, handler, options) {
    React$2.useEffect(function () {
        var element = ref.current;
        if (handler && element) {
            return addDomEvent(element, eventName, handler, options);
        }
    }, [ref, eventName, handler, options]);
}

function isMouseEvent(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
        return !!(event.pointerType === "mouse");
    }
    return event instanceof MouseEvent;
}
function isTouchEvent(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}

/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */
function filterPrimaryPointer(eventHandler) {
    return function (event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent ||
            (isMouseEvent && event.button === 0);
        if (isPrimaryPointer) {
            eventHandler(event);
        }
    };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function pointFromMouse(point, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function extractEventInfo(event, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    return {
        point: isTouchEvent(event)
            ? pointFromTouch(event, pointType)
            : pointFromMouse(event, pointType),
    };
}
function getViewportPointFromEvent(event) {
    return extractEventInfo(event, "client");
}
var wrapHandler = function (handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) { shouldFilterPrimaryPointer = false; }
    var listener = function (event) {
        return handler(event, extractEventInfo(event));
    };
    return shouldFilterPrimaryPointer
        ? filterPrimaryPointer(listener)
        : listener;
};

var isBrowser$1$1 = typeof window !== "undefined";
// We check for event support via functions in case they've been mocked by a testing suite.
var supportsPointerEvents = function () {
    return isBrowser$1$1 && window.onpointerdown === null;
};
var supportsTouchEvents = function () {
    return isBrowser$1$1 && window.ontouchstart === null;
};
var supportsMouseEvents = function () {
    return isBrowser$1$1 && window.onmousedown === null;
};

var mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave",
};
var touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel",
};
function getPointerEventName(name) {
    if (supportsPointerEvents()) {
        return name;
    }
    else if (supportsTouchEvents()) {
        return touchEventNames[name];
    }
    else if (supportsMouseEvents()) {
        return mouseEventNames[name];
    }
    return name;
}
function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
    return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}

/**
 * @internal
 */
var PanSession = /** @class */ (function () {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var transformPagePoint = (_a === void 0 ? {} : _a).transformPagePoint;
        /**
         * @internal
         */
        this.startEvent = null;
        /**
         * @internal
         */
        this.lastMoveEvent = null;
        /**
         * @internal
         */
        this.lastMoveEventInfo = null;
        /**
         * @internal
         */
        this.handlers = {};
        this.updatePoint = function () {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo))
                return;
            var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = distance(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            var point = info.point;
            var timestamp = getFrameData().timestamp;
            _this.history.push(__assign(__assign({}, point), { timestamp: timestamp }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function (event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if (isMouseEvent(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            sync.update(_this.updatePoint, true);
        };
        this.handlePointerUp = function (event, info) {
            _this.end();
            var onEnd = _this.handlers.onEnd;
            if (!onEnd)
                return;
            var panInfo = getPanInfo(transformPoint(info, _this.transformPagePoint), _this.history);
            onEnd && onEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (isTouchEvent(event) && event.touches.length > 1)
            return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = extractEventInfo(event);
        var initialInfo = transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = getFrameData().timestamp;
        this.history = [__assign(__assign({}, point), { timestamp: timestamp })];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function (handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function () {
        this.removeListeners && this.removeListeners();
        cancelSync.update(this.updatePoint);
    };
    return PanSession;
}());
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity$1(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity$1(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            secondsToMilliseconds(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}

/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) {
        // If we have a min point defined, and this is outside of that, constrain
        point = elastic ? mix(min, point, elastic) : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        // If we have a max point defined, and this is outside of that, constrain
        point = elastic ? mix(max, point, elastic) : Math.min(point, max);
    }
    return point;
}
/**
 * Calculates a min projection point based on a pointer, pointer progress
 * within the drag target, and constraints.
 *
 * For instance if an element was 100px width, we were dragging from 0.25
 * along this axis, the pointer is at 200px, and there were no constraints,
 * we would calculate a min projection point of 175px.
 */
function calcConstrainedMinPoint(point, length, progress, constraints, elastic) {
    // Calculate a min point for this axis and apply it to the current pointer
    var min = point - length * progress;
    return constraints ? applyConstraints(min, constraints, elastic) : min;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        _a = __read$1([max, min], 2), min = _a[0], max = _a[1];
    }
    return {
        min: layoutAxis.min + min,
        max: layoutAxis.min + max,
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
/**
 * Calculate the an axis position based on two axes and a progress value.
 */
function calcPositionFromProgress(axis, constraints, progress) {
    var axisLength = axis.max - axis.min;
    var min = mix(constraints.min, constraints.max - axisLength, progress);
    return { min: min, max: min + axisLength };
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}

var elementDragControls = new WeakMap();
/**
 *
 */
var lastPointerEvent;
var VisualElementDragControls = /** @class */ (function () {
    function VisualElementDragControls(_a) {
        var visualElement = _a.visualElement;
        /**
         * Track whether we're currently dragging.
         *
         * @internal
         */
        this.isDragging = false;
        /**
         * The current direction of drag, or `null` if both.
         *
         * @internal
         */
        this.currentDirection = null;
        /**
         * The permitted boundaries of travel, in pixels.
         *
         * @internal
         */
        this.constraints = false;
        /**
         * A reference to the host component's latest props.
         *
         * @internal
         */
        this.props = {};
        /**
         * @internal
         */
        this.hasMutatedConstraints = false;
        /**
         * Track the initial position of the cursor relative to the dragging element
         * when dragging starts as a value of 0-1 on each axis. We then use this to calculate
         * an ideal bounding box for the VisualElement renderer to project into every frame.
         *
         * @internal
         */
        this.cursorProgress = {
            x: 0.5,
            y: 0.5,
        };
        // When updating _dragX, or _dragY instead of the VisualElement,
        // persist their values between drag gestures.
        this.originPoint = {};
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        /**
         * @internal
         */
        this.panSession = null;
        this.visualElement = visualElement;
        this.visualElement.enableLayoutProjection();
        elementDragControls.set(visualElement, this);
    }
    /**
     * Instantiate a PanSession for the drag gesture
     *
     * @public
     */
    VisualElementDragControls.prototype.start = function (originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c, cursorProgress = _b.cursorProgress;
        /**
         * If this drag session has been manually triggered by the user, it might be from an event
         * outside the draggable element. If snapToCursor is set to true, we need to measure the position
         * of the element and snap it to the cursor.
         */
        snapToCursor && this.snapToCursor(originEvent);
        var onSessionStart = function () {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopMotion();
        };
        var onStart = function (event, info) {
            var _a, _b;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _c = _this.props, drag = _c.drag, dragPropagation = _c.dragPropagation;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock)
                    _this.openGlobalLock();
                _this.openGlobalLock = getGlobalLock(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock)
                    return;
            }
            /**
             * Record the progress of the mouse within the draggable element on each axis.
             * onPan, we're going to use this to calculate a new bounding box for the element to
             * project into. This will ensure that even if the DOM element moves via a relayout, it'll
             * stick to the correct place under the pointer.
             */
            _this.prepareBoundingBox();
            _this.visualElement.lockTargetBox();
            /**
             * Resolve the drag constraints. These are either set as top/right/bottom/left constraints
             * relative to the element's layout, or a ref to another element. Both need converting to
             * viewport coordinates.
             */
            _this.resolveDragConstraints();
            /**
             * When dragging starts, we want to find where the cursor is relative to the bounding box
             * of the element. Every frame, we calculate a new bounding box using this relative position
             * and let the visualElement renderer figure out how to reproject the element into this bounding
             * box.
             *
             * By doing it this way, rather than applying an x/y transform directly to the element,
             * we can ensure the component always visually sticks to the cursor as we'd expect, even
             * if the DOM element itself changes layout as a result of React updates the user might
             * make based on the drag position.
             */
            var point = getViewportPointFromEvent(event).point;
            eachAxis(function (axis) {
                var _a = _this.visualElement.targetBox[axis], min = _a.min, max = _a.max;
                _this.cursorProgress[axis] = cursorProgress
                    ? cursorProgress[axis]
                    : progress(min, max, point[axis]);
                /**
                 * If we have external drag MotionValues, record their origin point. On pointermove
                 * we'll apply the pan gesture offset directly to this value.
                 */
                var axisValue = _this.getAxisMotionValue(axis);
                if (axisValue) {
                    _this.originPoint[axis] = axisValue.get();
                }
            });
            // Set current drag status
            _this.isDragging = true;
            _this.currentDirection = null;
            // Fire onDragStart event
            (_b = (_a = _this.props).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, event, info);
        };
        var onMove = function (event, info) {
            var _a, _b, _c, _d;
            var _e = _this.props, dragPropagation = _e.dragPropagation, dragDirectionLock = _e.dragDirectionLock;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock)
                return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) {
                    (_b = (_a = _this.props).onDirectionLock) === null || _b === void 0 ? void 0 : _b.call(_a, _this.currentDirection);
                }
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", event, offset);
            _this.updateAxis("y", event, offset);
            // Fire onDrag event
            (_d = (_c = _this.props).onDrag) === null || _d === void 0 ? void 0 : _d.call(_c, event, info);
            // Update the last pointer event
            lastPointerEvent = event;
        };
        var onEnd = function (event, info) { return _this.stop(event, info); };
        var transformPagePoint = this.props.transformPagePoint;
        this.panSession = new PanSession(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onEnd: onEnd,
        }, { transformPagePoint: transformPagePoint });
    };
    /**
     * Ensure the component's layout and target bounding boxes are up-to-date.
     */
    VisualElementDragControls.prototype.prepareBoundingBox = function () {
        var element = this.visualElement.getInstance();
        var transform = element.style.transform;
        this.visualElement.resetTransform();
        this.visualElement.measureLayout();
        element.style.transform = transform;
        this.visualElement.rebaseTargetBox(true, this.visualElement.getBoundingBoxWithoutTransforms());
    };
    VisualElementDragControls.prototype.resolveDragConstraints = function () {
        var _this = this;
        var dragConstraints = this.props.dragConstraints;
        if (dragConstraints) {
            this.constraints = isRefObject(dragConstraints)
                ? this.resolveRefConstraints(this.visualElement.box, dragConstraints)
                : calcRelativeConstraints(this.visualElement.box, dragConstraints);
        }
        else {
            this.constraints = false;
        }
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */
        if (this.constraints && !this.hasMutatedConstraints) {
            eachAxis(function (axis) {
                if (_this.getAxisMotionValue(axis)) {
                    _this.constraints[axis] = rebaseAxisConstraints(_this.visualElement.box[axis], _this.constraints[axis]);
                }
            });
        }
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function (layoutBox, constraints) {
        var _a = this.props, onMeasureDragConstraints = _a.onMeasureDragConstraints, transformPagePoint = _a.transformPagePoint;
        var constraintsElement = constraints.current;
        invariant$3(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        this.constraintsBox = getBoundingBox(constraintsElement, transformPagePoint);
        var measuredConstraints = calcViewportConstraints(layoutBox, this.constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */
        if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints(convertAxisBoxToBoundingBox(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = convertBoundingBoxToAxisBox(userConstraints);
            }
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.cancelDrag = function () {
        this.isDragging = false;
        this.panSession && this.panSession.end();
        this.panSession = null;
        if (!this.props.dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
    };
    VisualElementDragControls.prototype.stop = function (event, info) {
        var _a;
        this.visualElement.unlockTargetBox();
        (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
        this.panSession = null;
        var isDragging = this.isDragging;
        this.cancelDrag();
        if (!isDragging)
            return;
        var _b = this.props, dragMomentum = _b.dragMomentum, dragElastic = _b.dragElastic, onDragEnd = _b.onDragEnd;
        if (dragMomentum || dragElastic) {
            var velocity = info.velocity;
            this.animateDragEnd(velocity);
        }
        onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event, info);
    };
    VisualElementDragControls.prototype.snapToCursor = function (event) {
        var _this = this;
        this.prepareBoundingBox();
        eachAxis(function (axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var point = getViewportPointFromEvent(event).point;
                var box = _this.visualElement.box;
                var length_1 = box[axis].max - box[axis].min;
                var center = box[axis].min + length_1 / 2;
                var offset = point[axis] - center;
                _this.originPoint[axis] = point[axis];
                axisValue.set(offset);
            }
            else {
                _this.cursorProgress[axis] = 0.5;
                _this.updateVisualElementAxis(axis, event);
            }
        });
    };
    /**
     * Update the specified axis with the latest pointer information.
     */
    VisualElementDragControls.prototype.updateAxis = function (axis, event, offset) {
        var drag = this.props.drag;
        // If we're not dragging this axis, do an early return.
        if (!shouldDrag(axis, drag, this.currentDirection))
            return;
        return this.getAxisMotionValue(axis)
            ? this.updateAxisMotionValue(axis, offset)
            : this.updateVisualElementAxis(axis, event);
    };
    VisualElementDragControls.prototype.updateAxisMotionValue = function (axis, offset) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!offset || !axisValue)
            return;
        var dragElastic = this.props.dragElastic;
        var nextValue = this.originPoint[axis] + offset[axis];
        var update = this.constraints
            ? applyConstraints(nextValue, this.constraints[axis], dragElastic)
            : nextValue;
        axisValue.set(update);
    };
    VisualElementDragControls.prototype.updateVisualElementAxis = function (axis, event) {
        var _a;
        var dragElastic = this.props.dragElastic;
        // Get the actual layout bounding box of the element
        var axisLayout = this.visualElement.box[axis];
        // Calculate its current length. In the future we might want to lerp this to animate
        // between lengths if the layout changes as we change the DOM
        var axisLength = axisLayout.max - axisLayout.min;
        // Get the initial progress that the pointer sat on this axis on gesture start.
        var axisProgress = this.cursorProgress[axis];
        var point = getViewportPointFromEvent(event).point;
        // Calculate a new min point based on the latest pointer position, constraints and elastic
        var min = calcConstrainedMinPoint(point[axis], axisLength, axisProgress, (_a = this.constraints) === null || _a === void 0 ? void 0 : _a[axis], dragElastic);
        // Update the axis viewport target with this new min and the length
        this.visualElement.setAxisTarget(axis, min, min + axisLength);
    };
    VisualElementDragControls.prototype.updateProps = function (_a) {
        var _b = _a.drag, drag = _b === void 0 ? false : _b, _c = _a.dragDirectionLock, dragDirectionLock = _c === void 0 ? false : _c, _d = _a.dragPropagation, dragPropagation = _d === void 0 ? false : _d, _e = _a.dragConstraints, dragConstraints = _e === void 0 ? false : _e, _f = _a.dragElastic, dragElastic = _f === void 0 ? 0.35 : _f, _g = _a.dragMomentum, dragMomentum = _g === void 0 ? true : _g, remainingProps = __rest(_a, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
        this.props = __assign({ drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum }, remainingProps);
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - If the component will perform layout animations, we output the gesture to the component's
     *      visual bounding box
     * - Otherwise, we apply the delta to the x/y motion values.
     */
    VisualElementDragControls.prototype.getAxisMotionValue = function (axis) {
        var _a = this.props, layout = _a.layout, layoutId = _a.layoutId;
        var dragKey = "_drag" + axis.toUpperCase();
        if (this.props[dragKey]) {
            return this.props[dragKey];
        }
        else if (!layout && layoutId === undefined) {
            return this.visualElement.getValue(axis, 0);
        }
    };
    VisualElementDragControls.prototype.animateDragEnd = function (velocity) {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition;
        var momentumAnimations = eachAxis(function (axis) {
            if (!shouldDrag(axis, drag, _this.currentDirection)) {
                return;
            }
            var transition = _this.constraints ? _this.constraints[axis] : {};
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */
            var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = __assign(__assign({ type: "inertia", velocity: dragMomentum ? velocity[axis] : 0, bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping, timeConstant: 750, restDelta: 1, restSpeed: 10 }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.getAxisMotionValue(axis)
                ? _this.startAxisValueAnimation(axis, inertia)
                : _this.visualElement.startLayoutAxisAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(function () {
            var _a, _b;
            (_b = (_a = _this.props).onDragTransitionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    };
    VisualElementDragControls.prototype.stopMotion = function () {
        var _this = this;
        eachAxis(function (axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            axisValue
                ? axisValue.stop()
                : _this.visualElement.stopLayoutAnimation();
        });
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function (axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!axisValue)
            return;
        var currentValue = axisValue.get();
        axisValue.set(currentValue);
        axisValue.set(currentValue); // Set twice to hard-reset velocity
        return startAnimation(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.scalePoint = function () {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragConstraints = _a.dragConstraints;
        if (!isRefObject(dragConstraints) || !this.constraintsBox)
            return;
        // Stop any current animations as there can be some visual glitching if we resize mid animation
        this.stopMotion();
        // Record the relative progress of the targetBox relative to the constraintsBox
        var boxProgress = { x: 0, y: 0 };
        eachAxis(function (axis) {
            boxProgress[axis] = calcOrigin(_this.visualElement.targetBox[axis], _this.constraintsBox[axis]);
        });
        /**
         * For each axis, calculate the current progress of the layout axis within the constraints.
         * Then, using the latest layout and constraints measurements, reposition the new layout axis
         * proportionally within the constraints.
         */
        this.prepareBoundingBox();
        this.resolveDragConstraints();
        eachAxis(function (axis) {
            if (!shouldDrag(axis, drag, null))
                return;
            // Calculate the position of the targetBox relative to the constraintsBox using the
            // previously calculated progress
            var _a = calcPositionFromProgress(_this.visualElement.targetBox[axis], _this.constraintsBox[axis], boxProgress[axis]), min = _a.min, max = _a.max;
            _this.visualElement.setAxisTarget(axis, min, max);
        });
    };
    VisualElementDragControls.prototype.mount = function (visualElement) {
        var _this = this;
        var element = visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */
        var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
            var _a = _this.props, drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */
        var stopResizeListener = addDomEvent(window, "resize", function () {
            _this.scalePoint();
        });
        /**
         * Ensure drag constraints are resolved correctly relative to the dragging element
         * whenever its layout changes.
         */
        var stopLayoutUpdateListener = visualElement.onLayoutUpdate(function () {
            if (_this.isDragging)
                _this.resolveDragConstraints();
        });
        /**
         * If the previous component with this same layoutId was dragging at the time
         * it was unmounted, we want to continue the same gesture on this component.
         */
        var prevSnapshot = visualElement.prevSnapshot;
        (prevSnapshot === null || prevSnapshot === void 0 ? void 0 : prevSnapshot.isDragging) &&
            this.start(lastPointerEvent, {
                cursorProgress: prevSnapshot.cursorProgress,
            });
        /**
         * Return a function that will teardown the drag gesture
         */
        return function () {
            stopPointerListener === null || stopPointerListener === void 0 ? void 0 : stopPointerListener();
            stopResizeListener === null || stopResizeListener === void 0 ? void 0 : stopResizeListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 ? void 0 : stopLayoutUpdateListener();
            _this.cancelDrag();
        };
    };
    return VisualElementDragControls;
}());
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) { lockThreshold = 10; }
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}

/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */
function useDrag(props, visualElement) {
    var groupDragControls = props.dragControls;
    var transformPagePoint = React$2.useContext(MotionConfigContext).transformPagePoint;
    var dragControls = useConstant(function () {
        return new VisualElementDragControls({
            visualElement: visualElement,
        });
    });
    dragControls.updateProps(__assign(__assign({}, props), { transformPagePoint: transformPagePoint }));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    React$2.useEffect(function () { return groupDragControls && groupDragControls.subscribe(dragControls); }, [dragControls]);
    // Mount the drag controls with the visualElement
    React$2.useEffect(function () { return dragControls.mount(visualElement); }, []);
}

var makeRenderlessComponent = function (hook) { return function (props) {
    hook(props);
    return null;
}; };

var Component$1 = makeRenderlessComponent(function (_a) {
    var visualElement = _a.visualElement, props = __rest(_a, ["visualElement"]);
    return useDrag(props, visualElement);
});
/**
 * @public
 */
var Drag = {
    key: "drag",
    shouldRender: function (props) { return !!props.drag || !!props.dragControls; },
    getComponent: function () { return Component$1; },
};

function useUnmountEffect(callback) {
    return React$2.useEffect(function () { return function () { return callback(); }; }, []);
}

/**
 *
 * @param handlers -
 * @param ref -
 *
 * @internalremarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */
function usePanGesture(_a, ref) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = React$2.useRef(null);
    var transformPagePoint = React$2.useContext(MotionConfigContext).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function (event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        },
    };
    React$2.useEffect(function () {
        if (panSession.current !== null) {
            panSession.current.updateHandlers(handlers);
        }
    });
    function onPointerDown(event) {
        panSession.current = new PanSession(event, handlers, {
            transformPagePoint: transformPagePoint,
        });
    }
    usePointerEvent(ref, "pointerdown", hasPanEvents && onPointerDown);
    useUnmountEffect(function () { return panSession.current && panSession.current.end(); });
}

/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
var isNodeOrChild = function (parent, child) {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};

var order$1 = ["whileHover", "whileTap", "whileDrag"];
var getGesturePriority = function (gesture) {
    return order$1.indexOf(gesture) + 1;
};

var tapGesturePriority = getGesturePriority("whileTap");
/**
 * @param handlers -
 * @internal
 */
function useTapGesture(_a, visualElement) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap;
    var hasTapListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isTapping = React$2.useRef(false);
    var cancelPointerEventListener = React$2.useRef(null);
    function removePointerUp() {
        var _a;
        (_a = cancelPointerEventListener.current) === null || _a === void 0 ? void 0 : _a.call(cancelPointerEventListener);
        cancelPointerEventListener.current = null;
    }
    whileTap && setOverride(visualElement, whileTap, tapGesturePriority);
    // We load this event handler into a ref so we can later refer to
    // onPointerUp.current which will always have reference to the latest props
    var onPointerUp = React$2.useRef(null);
    onPointerUp.current = function (event, info) {
        var element = visualElement.getInstance();
        removePointerUp();
        if (!isTapping.current || !element)
            return;
        isTapping.current = false;
        whileTap && clearOverride(visualElement, tapGesturePriority);
        // Check the gesture lock - if we get it, it means no drag gesture is active
        // and we can safely fire the tap gesture.
        var openGestureLock = getGlobalLock(true);
        if (!openGestureLock)
            return;
        openGestureLock();
        if (!isNodeOrChild(element, event.target)) {
            onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
        }
        else {
            onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
        }
    };
    function onPointerDown(event, info) {
        removePointerUp();
        cancelPointerEventListener.current = pipe(addPointerEvent(window, "pointerup", function (event, info) { var _a; return (_a = onPointerUp.current) === null || _a === void 0 ? void 0 : _a.call(onPointerUp, event, info); }), addPointerEvent(window, "pointercancel", function (event, info) { var _a; return (_a = onPointerUp.current) === null || _a === void 0 ? void 0 : _a.call(onPointerUp, event, info); }));
        var element = visualElement.getInstance();
        if (!element || isTapping.current)
            return;
        isTapping.current = true;
        onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
        whileTap && startOverride(visualElement, tapGesturePriority);
    }
    usePointerEvent(visualElement, "pointerdown", hasTapListeners ? onPointerDown : undefined);
    useUnmountEffect(removePointerUp);
}

var hoverPriority = getGesturePriority("whileHover");
var filterTouch = function (listener) { return function (event, info) {
    if (isMouseEvent(event))
        listener(event, info);
}; };
/**
 *
 * @param props
 * @param ref
 * @internal
 */
function useHoverGesture(_a, visualElement) {
    var whileHover = _a.whileHover, onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd;
    if (whileHover) {
        setOverride(visualElement, whileHover, hoverPriority);
    }
    usePointerEvent(visualElement, "pointerenter", filterTouch(function (event, info) {
        onHoverStart === null || onHoverStart === void 0 ? void 0 : onHoverStart(event, info);
        whileHover && startOverride(visualElement, hoverPriority);
    }));
    usePointerEvent(visualElement, "pointerleave", filterTouch(function (event, info) {
        onHoverEnd === null || onHoverEnd === void 0 ? void 0 : onHoverEnd(event, info);
        whileHover && clearOverride(visualElement, hoverPriority);
    }));
}

/**
 * Add pan and tap gesture recognition to an element.
 *
 * @param props - Gesture event handlers
 * @param ref - React `ref` containing a DOM `Element`
 * @public
 */
function useGestures(props, visualElement) {
    usePanGesture(props, visualElement);
    useTapGesture(props, visualElement);
    useHoverGesture(props, visualElement);
}

var gestureProps = [
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "whileTap",
    "whileHover",
    "onHoverStart",
    "onHoverEnd",
];
var GestureComponent = makeRenderlessComponent(function (_a) {
    var visualElement = _a.visualElement, props = __rest(_a, ["visualElement"]);
    useGestures(props, visualElement);
});
/**
 * @public
 */
var Gestures = {
    key: "gestures",
    shouldRender: function (props) {
        return gestureProps.some(function (key) { return props.hasOwnProperty(key); });
    },
    getComponent: function () { return GestureComponent; },
};

/**
 * Control animations on one or more components.
 *
 * @public
 */
var AnimationControls = /** @class */ (function () {
    function AnimationControls() {
        /**
         * Track whether the host component has mounted.
         *
         * @internal
         */
        this.hasMounted = false;
        /**
         * Pending animations that are started before a component is mounted.
         *
         * @internal
         */
        this.pendingAnimations = [];
        /**
         * A collection of linked component animation controls.
         *
         * @internal
         */
        this.subscribers = new Set();
    }
    /**
     * Subscribes a component's animation controls to this.
     *
     * @param controls - The controls to subscribe
     * @returns An unsubscribe function.
     *
     * @internal
     */
    AnimationControls.prototype.subscribe = function (visualElement) {
        var _this = this;
        this.subscribers.add(visualElement);
        return function () { return _this.subscribers.delete(visualElement); };
    };
    /**
     * Starts an animation on all linked components.
     *
     * @remarks
     *
     * ```jsx
     * controls.start("variantLabel")
     * controls.start({
     *   x: 0,
     *   transition: { duration: 1 }
     * })
     * ```
     *
     * @param definition - Properties or variant label to animate to
     * @param transition - Optional `transtion` to apply to a variant
     * @returns - A `Promise` that resolves when all animations have completed.
     *
     * @public
     */
    AnimationControls.prototype.start = function (definition, transitionOverride) {
        var _this = this;
        if (this.hasMounted) {
            var animations_1 = [];
            this.subscribers.forEach(function (visualElement) {
                var animation = startVisualElementAnimation(visualElement, definition, { transitionOverride: transitionOverride });
                animations_1.push(animation);
            });
            return Promise.all(animations_1);
        }
        else {
            return new Promise(function (resolve) {
                _this.pendingAnimations.push({
                    animation: [definition, transitionOverride],
                    resolve: resolve,
                });
            });
        }
    };
    /**
     * Instantly set to a set of properties or a variant.
     *
     * ```jsx
     * // With properties
     * controls.set({ opacity: 0 })
     *
     * // With variants
     * controls.set("hidden")
     * ```
     *
     * @internalremarks
     * We could perform a similar trick to `.start` where this can be called before mount
     * and we maintain a list of of pending actions that get applied on mount. But the
     * expectation of `set` is that it happens synchronously and this would be difficult
     * to do before any children have even attached themselves. It's also poor practise
     * and we should discourage render-synchronous `.start` calls rather than lean into this.
     *
     * @public
     */
    AnimationControls.prototype.set = function (definition) {
        invariant$3(this.hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
        return this.subscribers.forEach(function (visualElement) {
            setValues(visualElement, definition);
        });
    };
    /**
     * Stops animations on all linked components.
     *
     * ```jsx
     * controls.stop()
     * ```
     *
     * @public
     */
    AnimationControls.prototype.stop = function () {
        this.subscribers.forEach(function (visualElement) {
            stopAnimation(visualElement);
        });
    };
    /**
     * Initialises the animation controls.
     *
     * @internal
     */
    AnimationControls.prototype.mount = function () {
        var _this = this;
        this.hasMounted = true;
        this.pendingAnimations.forEach(function (_a) {
            var animation = _a.animation, resolve = _a.resolve;
            _this.start.apply(_this, __spread$1(animation)).then(resolve);
        });
    };
    /**
     * Stops all child animations when the host component unmounts.
     *
     * @internal
     */
    AnimationControls.prototype.unmount = function () {
        this.hasMounted = false;
        this.stop();
    };
    return AnimationControls;
}());

var ExitComponent = makeRenderlessComponent(function (props) {
    var animate = props.animate, exit = props.exit, visualElement = props.visualElement;
    var _a = __read$1(usePresence(), 2), isPresent = _a[0], onExitComplete = _a[1];
    var presenceContext = React$2.useContext(PresenceContext);
    var isPlayingExitAnimation = React$2.useRef(false);
    var custom = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== undefined
        ? presenceContext.custom
        : props.custom;
    React$2.useEffect(function () {
        if (!isPresent) {
            if (!isPlayingExitAnimation.current && exit) {
                startVisualElementAnimation(visualElement, exit, {
                    custom: custom,
                }).then(onExitComplete);
            }
            isPlayingExitAnimation.current = true;
        }
        else if (isPlayingExitAnimation.current &&
            animate &&
            typeof animate !== "boolean" &&
            !(animate instanceof AnimationControls)) {
            startVisualElementAnimation(visualElement, animate);
        }
        if (isPresent) {
            isPlayingExitAnimation.current = false;
        }
    }, [animate, custom, exit, isPresent, onExitComplete, props]);
});
/**
 * @public
 */
var Exit = {
    key: "exit",
    shouldRender: function (props) { return !!props.exit && !checkShouldInheritVariant(props); },
    getComponent: function () { return ExitComponent; },
};

function shallowCompare(next, prev) {
    if (prev === null)
        return false;
    var prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (var i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}

var hasUpdated = function (prev, next) {
    return (next !== undefined &&
        (Array.isArray(prev) && Array.isArray(next)
            ? !shallowCompare(next, prev)
            : prev !== next));
};
function targetWithoutTransition(_a, mergeTransitionEnd) {
    if (mergeTransitionEnd === void 0) { mergeTransitionEnd = false; }
    var transition = _a.transition, transitionEnd = _a.transitionEnd, target = __rest(_a, ["transition", "transitionEnd"]);
    return mergeTransitionEnd
        ? __assign(__assign({}, target), transitionEnd)
        : target;
}
/**
 * Handle the `animate` prop when its an object of values, ie:
 *
 * ```jsx
 * <motion.div animate={{ opacity: 1 }} />
 * ```
 *
 * @internalremarks
 * It might be worth consolidating this with `use-variants`
 *
 * ```jsx
 * <motion.div animate="visible" />
 * ```
 *
 * @param target
 * @param controls
 * @param values
 * @param transition
 *
 * @internal
 */
function useAnimateProp(visualElement, targetAndTransition, defaultTransition) {
    var isInitialRender = React$2.useRef(true);
    var prevValues = React$2.useRef(null);
    if (!prevValues.current) {
        prevValues.current = targetWithoutTransition(targetAndTransition, true);
    }
    React$2.useEffect(function () {
        var targetToAnimate = {};
        // These are the values we're actually animating
        var animatingTarget = targetWithoutTransition(targetAndTransition);
        // This is the target as it'll be once transitionEnd values are applied
        var finalTarget = targetWithoutTransition(targetAndTransition, true);
        // Detect which values have changed between renders
        for (var key in animatingTarget) {
            // This value should animate on mount if this value doesn't already exist (wasn't
            // defined in `style` or `initial`) or if it does exist and it's already changed.
            var shouldAnimateOnMount = isInitialRender.current &&
                (!visualElement.hasValue(key) ||
                    visualElement.getValue(key).get() !== finalTarget[key]);
            // If this value has updated between renders or it's we're animating this value on mount,
            // add it to the animate target.
            var isValidValue = finalTarget[key] !== null;
            var valueHasUpdated = hasUpdated(prevValues.current[key], finalTarget[key]);
            if (isValidValue && (valueHasUpdated || shouldAnimateOnMount)) {
                targetToAnimate[key] = animatingTarget[key];
            }
        }
        isInitialRender.current = false;
        prevValues.current = __assign(__assign({}, prevValues.current), finalTarget);
        if (Object.keys(targetToAnimate).length) {
            startVisualElementAnimation(visualElement, __assign(__assign({}, targetToAnimate), { transition: targetAndTransition.transition || defaultTransition, transitionEnd: targetAndTransition.transitionEnd }));
        }
    }, [targetAndTransition]);
}

var labelsToArray = function (label) {
    if (!label) {
        return [];
    }
    if (Array.isArray(label)) {
        return label;
    }
    return [label];
};
var resolveVariantLabels = function (variant) {
    var unresolvedVariant = variant instanceof MotionValue ? variant.get() : variant;
    return Array.from(new Set(labelsToArray(unresolvedVariant)));
};
/**
 * Hooks in React sometimes accept a dependency array as their final argument. (ie useEffect/useMemo)
 * When values in this array change, React re-runs the dependency. However if the array
 * contains a variable number of items, React throws an error.
 */
var asDependencyList = function (list) { return [
    list.join(","),
]; };

var hasVariantChanged = function (oldVariant, newVariant) {
    return oldVariant.join(",") !== newVariant.join(",");
};
/**
 * Handle variants and the `animate` prop when its set as variant labels.
 *
 * @param initial - Initial variant(s)
 * @param animate - Variant(s) to animate to
 * @param inherit - `true` is inheriting animations from parent
 * @param controls - Animation controls
 *
 * @internal
 */
function useVariantAnimations(visualElement, initial, animate, inherit) {
    var _a;
    var targetVariants = resolveVariantLabels(animate);
    var context = useVariantContext();
    var parentAlreadyMounted = (_a = context.parent) === null || _a === void 0 ? void 0 : _a.isMounted;
    var hasMounted = React$2.useRef(false);
    React$2.useEffect(function () {
        var shouldAnimate = false;
        if (inherit) {
            // If we're inheriting variant changes and the parent has already
            // mounted when this component loads, we need to manually trigger
            // this animation.
            shouldAnimate = !!parentAlreadyMounted;
            targetVariants = resolveVariantLabels(context.animate);
        }
        else {
            shouldAnimate =
                hasMounted.current ||
                    hasVariantChanged(resolveVariantLabels(initial), targetVariants);
        }
        shouldAnimate &&
            startVisualElementAnimation(visualElement, targetVariants);
        hasMounted.current = true;
    }, asDependencyList(targetVariants));
}

/**
 * `useAnimationGroupSubscription` allows a component to subscribe to an
 * externally-created `AnimationControls`, created by the `useAnimation` hook.
 *
 * @param animation
 * @param controls
 *
 * @internal
 */
function useAnimationGroupSubscription(visualElement, animation) {
    var unsubscribe = React$2.useMemo(function () { return animation.subscribe(visualElement); }, [
        animation,
    ]);
    useUnmountEffect(function () { return unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe(); });
}

var target = {
    shouldRender: function (props) {
        return props.animate !== undefined &&
            !isVariantLabel(props.animate) &&
            !isAnimationControls(props.animate);
    },
    Component: makeRenderlessComponent(function (_a) {
        var animate = _a.animate, visualElement = _a.visualElement, transition = _a.transition;
        return useAnimateProp(visualElement, animate, transition);
    }),
};
var variant = {
    shouldRender: function (props) {
        return (props.variants && !isAnimationControls(props.animate)) ||
            isVariantLabel(props.animate);
    },
    Component: makeRenderlessComponent(function (_a) {
        var animate = _a.animate, _b = _a.inherit, inherit = _b === void 0 ? true : _b, visualElement = _a.visualElement, initial = _a.initial;
        return useVariantAnimations(visualElement, initial, animate, inherit);
    }),
};
var controls = {
    shouldRender: function (props) { return isAnimationControls(props.animate); },
    Component: makeRenderlessComponent(function (_a) {
        var animate = _a.animate, visualElement = _a.visualElement;
        return useAnimationGroupSubscription(visualElement, animate);
    }),
};
var getAnimationComponent = function (props) {
    if (target.shouldRender(props)) {
        return target.Component;
    }
    else if (variant.shouldRender(props)) {
        return variant.Component;
    }
    else if (controls.shouldRender(props)) {
        return controls.Component;
    }
};
/**
 * @public
 */
var Animation = {
    key: "animation",
    shouldRender: function () { return true; },
    getComponent: getAnimationComponent,
};

function tweenAxis(target, prev, next, p) {
    target.min = mix(prev.min, next.min, p);
    target.max = mix(prev.max, next.max, p);
}

var progressTarget = 1000;
var Animate = /** @class */ (function (_super) {
    __extends(Animate, _super);
    function Animate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.frameTarget = {
            x: { min: 0, max: 0 },
            y: { min: 0, max: 0 },
        };
        _this.stopAxisAnimation = {
            x: undefined,
            y: undefined,
        };
        _this.animate = function (target, origin, _a) {
            if (_a === void 0) { _a = {}; }
            var originBox = _a.originBox, targetBox = _a.targetBox, visibilityAction = _a.visibilityAction, shouldStackAnimate = _a.shouldStackAnimate, config = __rest(_a, ["originBox", "targetBox", "visibilityAction", "shouldStackAnimate"]);
            var _b = _this.props, visualElement = _b.visualElement, layout = _b.layout;
            /**
             * Early return if we've been instructed not to animate this render.
             */
            if (shouldStackAnimate === false)
                return _this.safeToRemove();
            /**
             * Allow the measured origin (prev bounding box) and target (actual layout) to be
             * overridden by the provided config.
             */
            origin = originBox || origin;
            target = targetBox || target;
            var boxHasMoved = hasMoved(origin, target);
            var animations = eachAxis(function (axis) {
                /**
                 * If layout is set to "position", we can resize the origin box based on the target
                 * box and only animate its position.
                 */
                if (layout === "position") {
                    var targetLength = target[axis].max - target[axis].min;
                    origin[axis].max = origin[axis].min + targetLength;
                }
                if (visualElement.isTargetBoxLocked) {
                    return;
                }
                else if (visibilityAction !== undefined) {
                    // If we're meant to show/hide the visualElement, do so
                    visibilityAction === VisibilityAction.Hide
                        ? visualElement.hide()
                        : visualElement.show();
                }
                else if (boxHasMoved) {
                    // If the box has moved, animate between it's current visual state and its
                    // final state
                    return _this.animateAxis(axis, target[axis], origin[axis], config);
                }
                else {
                    // If the box has remained in the same place, immediately set the axis target
                    // to the final desired state
                    return visualElement.setAxisTarget(axis, target[axis].min, target[axis].max);
                }
            });
            // Force a render to ensure there's no flash of uncorrected bounding box.
            visualElement.render();
            /**
             * If this visualElement isn't present (ie it's been removed from the tree by the user but
             * kept in by the tree by AnimatePresence) then call safeToRemove when all axis animations
             * have successfully finished.
             */
            return Promise.all(animations).then(function () {
                var _a, _b;
                (_b = (_a = _this.props).onLayoutAnimationComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
                if (visualElement.isPresent) {
                    visualElement.presence = Presence.Present;
                }
                else {
                    _this.safeToRemove();
                }
            });
        };
        return _this;
    }
    Animate.prototype.componentDidMount = function () {
        var _this = this;
        var visualElement = this.props.visualElement;
        visualElement.animateMotionValue = startAnimation;
        visualElement.enableLayoutProjection();
        this.unsubLayoutReady = visualElement.onLayoutUpdate(this.animate);
        visualElement.updateConfig(__assign(__assign({}, visualElement.config), { safeToRemove: function () { return _this.safeToRemove(); } }));
    };
    Animate.prototype.componentWillUnmount = function () {
        var _this = this;
        this.unsubLayoutReady();
        eachAxis(function (axis) { var _a, _b; return (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a); });
    };
    /**
     * TODO: This manually performs animations on the visualElement's layout progress
     * values. It'd be preferable to amend the HTMLVisualElement.startLayoutAxisAnimation
     * API to accept more custom animations like this.
     */
    Animate.prototype.animateAxis = function (axis, target, origin, _a) {
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, transition = _d.transition, crossfadeOpacity = _d.crossfadeOpacity;
        (_c = (_b = this.stopAxisAnimation)[axis]) === null || _c === void 0 ? void 0 : _c.call(_b);
        var visualElement = this.props.visualElement;
        var frameTarget = this.frameTarget[axis];
        var layoutProgress = visualElement.axisProgress[axis];
        /**
         * Set layout progress back to 0. We set it twice to hard-reset any velocity that might
         * be re-incoporated into a subsequent spring animation.
         */
        layoutProgress.clearListeners();
        layoutProgress.set(0);
        layoutProgress.set(0);
        /**
         * If this is a crossfade animation, create a function that updates both the opacity of this component
         * and the one being crossfaded out.
         */
        var crossfade;
        if (crossfadeOpacity) {
            crossfade = this.createCrossfadeAnimation(crossfadeOpacity);
            visualElement.show();
        }
        /**
         * Create an animation function to run once per frame. This will tween the visual bounding box from
         * origin to target using the latest progress value.
         */
        var frame = function () {
            // Convert the latest layoutProgress, which is a value from 0-1000, into a 0-1 progress
            var p = layoutProgress.get() / progressTarget;
            // Tween the axis and update the visualElement with the latest values
            tweenAxis(frameTarget, origin, target, p);
            visualElement.setAxisTarget(axis, frameTarget.min, frameTarget.max);
            // If this is a crossfade animation, update both elements.
            crossfade === null || crossfade === void 0 ? void 0 : crossfade(p);
        };
        // Synchronously run a frame to ensure there's no flash of the uncorrected bounding box.
        frame();
        // Ensure that the layout delta is updated for this frame.
        visualElement.updateLayoutDelta();
        // Create a function to stop animation on this specific axis
        var unsubscribeProgress = layoutProgress.onChange(frame);
        // Start the animation on this axis
        var animation = startAnimation(axis === "x" ? "layoutX" : "layoutY", layoutProgress, progressTarget, transition || this.props.transition || defaultTransition).then(unsubscribeProgress);
        this.stopAxisAnimation[axis] = function () {
            layoutProgress.stop();
            unsubscribeProgress();
        };
        return animation;
    };
    Animate.prototype.createCrossfadeAnimation = function (crossfadeOpacity) {
        var visualElement = this.props.visualElement;
        var opacity = visualElement.getValue("opacity", 0);
        return function (p) {
            opacity.set(easeCrossfadeIn(mix(0, 1, p)));
            crossfadeOpacity.set(easeCrossfadeOut(mix(1, 0, p)));
        };
    };
    Animate.prototype.safeToRemove = function () {
        var _a, _b;
        (_b = (_a = this.props).safeToRemove) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    Animate.prototype.render = function () {
        return null;
    };
    return Animate;
}(React$2.Component));
function AnimateLayoutContextProvider(props) {
    var _a = __read$1(usePresence(), 2), safeToRemove = _a[1];
    return React$2.createElement(Animate, __assign({}, props, { safeToRemove: safeToRemove }));
}
function hasMoved(a, b) {
    return hasAxisMoved(a.x, b.x) || hasAxisMoved(a.y, b.y);
}
function hasAxisMoved(a, b) {
    return a.min !== b.min || a.max !== b.max;
}
var defaultTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
function compress(min, max, easing) {
    return function (p) {
        // Could replace ifs with clamp
        if (p < min)
            return 0;
        if (p > max)
            return 1;
        return easing(progress(min, max, p));
    };
}
var easeCrossfadeIn = compress(0, 0.5, circOut);
var easeCrossfadeOut = compress(0.5, 0.95, linear);
/**
 * @public
 */
var AnimateLayout = {
    key: "animate-layout",
    shouldRender: function (props) { return !!props.layout || !!props.layoutId; },
    getComponent: function () { return AnimateLayoutContextProvider; },
};

/**
 * This component is responsible for scheduling the measuring of the motion component
 */
var Measure = /** @class */ (function (_super) {
    __extends(Measure, _super);
    function Measure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If this is a child of a SyncContext, register the VisualElement with it on mount.
     */
    Measure.prototype.componentDidMount = function () {
        var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
        isSharedLayout(syncLayout) && syncLayout.register(visualElement);
    };
    /**
     * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
     * handle the snapshotting.
     *
     * If it is stand-alone component, add it to the batcher.
     */
    Measure.prototype.getSnapshotBeforeUpdate = function () {
        var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
        if (isSharedLayout(syncLayout)) {
            syncLayout.syncUpdate();
        }
        else {
            visualElement.snapshotBoundingBox();
            syncLayout.add(visualElement);
        }
        return null;
    };
    Measure.prototype.componentDidUpdate = function () {
        var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
        if (!isSharedLayout(syncLayout))
            syncLayout.flush();
        /**
         * If this axis isn't animating as a result of this render we want to reset the targetBox
         * to the measured box
         */
        visualElement.rebaseTargetBox();
    };
    Measure.prototype.render = function () {
        return null;
    };
    return Measure;
}(React__default['default'].Component));
function MeasureContextProvider(props) {
    var syncLayout = React$2.useContext(SharedLayoutContext);
    return React__default['default'].createElement(Measure, __assign({}, props, { syncLayout: syncLayout }));
}
var MeasureLayout = {
    key: "measure-layout",
    shouldRender: function (props) {
        return !!props.drag || !!props.layout || !!props.layoutId;
    },
    getComponent: function () { return MeasureContextProvider; },
};

var allMotionFeatures = [
    MeasureLayout,
    Animation,
    Drag,
    Gestures,
    Exit,
    AnimateLayout,
];
var domBaseConfig = {
    useVisualElement: useDomVisualElement,
    render: render,
};
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion.custom(Component)
 * ```
 *
 * @public
 */
function createMotionProxy(defaultFeatures) {
    var config = __assign(__assign({}, domBaseConfig), { defaultFeatures: defaultFeatures });
    function custom(Component) {
        return createMotionComponent(Component, config);
    }
    var componentCache = new Map();
    function get(target, key) {
        if (key === "custom")
            return target.custom;
        if (!componentCache.has(key)) {
            componentCache.set(key, createMotionComponent(key, config));
        }
        return componentCache.get(key);
    }
    return new Proxy({ custom: custom }, { get: get });
}
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
var motion = /*@__PURE__*/ createMotionProxy(allMotionFeatures);

function createSwitchAnimation(child, stack) {
    if (stack && child !== stack.lead) {
        return { visibilityAction: VisibilityAction.Hide };
    }
    else if (stack &&
        child.presence !== Presence.Entering &&
        child === stack.lead &&
        stack.lead !== stack.prevLead) {
        return { visibilityAction: VisibilityAction.Show };
    }
    var originBox;
    var targetBox;
    if (child.presence === Presence.Entering) {
        originBox = stack === null || stack === void 0 ? void 0 : stack.getFollowOrigin();
    }
    else if (child.presence === Presence.Exiting) {
        targetBox = stack === null || stack === void 0 ? void 0 : stack.getFollowTarget();
    }
    return { originBox: originBox, targetBox: targetBox };
}
function createCrossfadeAnimation(child, stack) {
    var _a, _b, _c;
    var config = {};
    var stackLead = stack && stack.lead;
    var stackLeadPresence = stackLead === null || stackLead === void 0 ? void 0 : stackLead.presence;
    if (stack && child === stackLead) {
        if (child.presence === Presence.Entering) {
            config.originBox = stack.getFollowOrigin();
        }
        else if (child.presence === Presence.Exiting) {
            config.targetBox = stack.getFollowTarget();
        }
    }
    else if (stack && child === stack.follow) {
        config.transition = stack.getLeadTransition();
        if (stackLeadPresence === Presence.Entering) {
            config.targetBox = stack.getLeadTarget();
        }
        else if (stackLeadPresence === Presence.Exiting) {
            config.originBox = stack.getLeadOrigin();
        }
    }
    // If neither the lead or follow component is the root child of AnimatePresence,
    // don't handle crossfade animations
    if (!((_a = stack === null || stack === void 0 ? void 0 : stack.follow) === null || _a === void 0 ? void 0 : _a.isPresenceRoot) && !(stackLead === null || stackLead === void 0 ? void 0 : stackLead.isPresenceRoot)) {
        return config;
    }
    if (!stack || child === stackLead) {
        if (child.presence === Presence.Entering) {
            config.crossfadeOpacity = (_b = stack === null || stack === void 0 ? void 0 : stack.follow) === null || _b === void 0 ? void 0 : _b.getValue("opacity", 0);
        }
    }
    else if (stack && child === stack.follow) {
        if (!stackLead || stackLeadPresence === Presence.Entering) ;
        else if (stackLeadPresence === Presence.Exiting) {
            config.crossfadeOpacity = (_c = stack === null || stack === void 0 ? void 0 : stack.lead) === null || _c === void 0 ? void 0 : _c.getValue("opacity", 1);
        }
    }
    else {
        config.visibilityAction = VisibilityAction.Hide;
    }
    return config;
}

/**
 * For each layout animation, we want to identify two components
 * within a stack that will serve as the "lead" and "follow" components.
 *
 * In the switch animation, the lead component performs the entire animation.
 * It uses the follow bounding box to animate out from and back to. The follow
 * component is hidden.
 *
 * In the crossfade animation, both the lead and follow components perform
 * the entire animation, animating from the follow origin bounding box to the lead
 * target bounding box.
 *
 * Generalising a stack as First In Last Out, *searching from the end* we can
 * generally consider the lead component to be:
 *  - If the last child is present, the last child
 *  - If the last child is exiting, the last *encountered* exiting component
 */
function findLeadAndFollow(stack, _a) {
    var _b = __read$1(_a, 2), prevLead = _b[0], prevFollow = _b[1];
    var lead = undefined;
    var leadIndex = 0;
    var follow = undefined;
    // Find the lead child first
    var numInStack = stack.length;
    var lastIsPresent = false;
    for (var i = numInStack - 1; i >= 0; i--) {
        var child = stack[i];
        var isLastInStack = i === numInStack - 1;
        if (isLastInStack)
            lastIsPresent = child.isPresent;
        if (lastIsPresent) {
            lead = child;
        }
        else {
            // If the child before this will be present, make this the
            // lead.
            var prev = stack[i - 1];
            if (prev && prev.isPresent)
                lead = child;
        }
        if (lead) {
            leadIndex = i;
            break;
        }
    }
    if (!lead)
        lead = stack[0];
    // Find the follow child
    follow = stack[leadIndex - 1];
    // If the lead component is exiting, find the closest follow
    // present component
    if (lead) {
        for (var i = leadIndex - 1; i >= 0; i--) {
            var child = stack[i];
            if (child.isPresent) {
                follow = child;
                break;
            }
        }
    }
    // If the lead has changed and the previous lead still exists in the
    // stack, set it to the previous lead. This allows us to differentiate between
    // a, b, c(exit) -> a, b(exit), c(exit)
    // and
    // a, b(exit), c -> a, b(exit), c(exit)
    if (lead !== prevLead &&
        !lastIsPresent &&
        follow === prevFollow &&
        stack.find(function (stackChild) { return stackChild === prevLead; })) {
        lead = prevLead;
    }
    return [lead, follow];
}
var LayoutStack = /** @class */ (function () {
    function LayoutStack() {
        this.order = [];
        // Track whether we've ever had a child
        this.hasChildren = false;
    }
    LayoutStack.prototype.add = function (child) {
        var _a;
        this.order.push(child);
        // Load previous values from snapshot into this child
        // TODO Neaten up
        // TODO Double check when reimplementing move
        // TODO Add isDragging status and
        if (this.snapshot) {
            child.prevSnapshot = this.snapshot;
            // TODO Remove in favour of above
            child.prevViewportBox = this.snapshot.boundingBox;
            var latest = this.snapshot.latestMotionValues;
            for (var key in latest) {
                if (!child.hasValue(key)) {
                    child.addValue(key, motionValue(latest[key]));
                }
                else {
                    (_a = child.getValue(key)) === null || _a === void 0 ? void 0 : _a.set(latest[key]);
                }
            }
        }
        this.hasChildren = true;
    };
    LayoutStack.prototype.remove = function (child) {
        var index = this.order.findIndex(function (stackChild) { return child === stackChild; });
        if (index !== -1)
            this.order.splice(index, 1);
    };
    LayoutStack.prototype.updateLeadAndFollow = function () {
        this.prevLead = this.lead;
        this.prevFollow = this.follow;
        var _a = __read$1(findLeadAndFollow(this.order, [
            this.lead,
            this.follow,
        ]), 2), lead = _a[0], follow = _a[1];
        this.lead = lead;
        this.follow = follow;
    };
    LayoutStack.prototype.updateSnapshot = function () {
        if (!this.lead)
            return;
        var snapshot = {
            boundingBox: this.lead.prevViewportBox,
            latestMotionValues: {},
        };
        this.lead.forEachValue(function (value, key) {
            var latest = value.get();
            if (!isTransformProp(latest)) {
                snapshot.latestMotionValues[key] = latest;
            }
        });
        var dragControls = elementDragControls.get(this.lead);
        if (dragControls && dragControls.isDragging) {
            snapshot.isDragging = true;
            snapshot.cursorProgress = dragControls.cursorProgress;
        }
        this.snapshot = snapshot;
    };
    LayoutStack.prototype.isLeadPresent = function () {
        var _a;
        return this.lead && ((_a = this.lead) === null || _a === void 0 ? void 0 : _a.presence) !== Presence.Exiting;
    };
    LayoutStack.prototype.getFollowOrigin = function () {
        var _a;
        return this.follow
            ? this.follow.prevViewportBox
            : (_a = this.snapshot) === null || _a === void 0 ? void 0 : _a.boundingBox;
    };
    LayoutStack.prototype.getFollowTarget = function () {
        var _a;
        return (_a = this.follow) === null || _a === void 0 ? void 0 : _a.box;
    };
    LayoutStack.prototype.getLeadOrigin = function () {
        var _a;
        return (_a = this.lead) === null || _a === void 0 ? void 0 : _a.prevViewportBox;
    };
    LayoutStack.prototype.getLeadTarget = function () {
        var _a;
        return (_a = this.lead) === null || _a === void 0 ? void 0 : _a.box;
    };
    LayoutStack.prototype.getLeadTransition = function () {
        var _a;
        return (_a = this.lead) === null || _a === void 0 ? void 0 : _a.config.transition;
    };
    return LayoutStack;
}());

/**
 * @public
 */
var AnimateSharedLayout = /** @class */ (function (_super) {
    __extends(AnimateSharedLayout, _super);
    function AnimateSharedLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * A list of all the children in the shared layout
         */
        _this.children = new Set();
        /**
         * As animate components with a defined `layoutId` are added/removed to the tree,
         * we store them in order. When one is added, it will animate out from the
         * previous one, and when it's removed, it'll animate to the previous one.
         */
        _this.stacks = new Map();
        /**
         * Track whether the component has mounted. If it hasn't, the presence of added children
         * are set to Present, whereas if it has they're considered Entering
         */
        _this.hasMounted = false;
        /**
         * Track whether we already have an update scheduled. If we don't, we'll run snapshots
         * and schedule one.
         */
        _this.updateScheduled = false;
        /**
         * Tracks whether we already have a render scheduled. If we don't, we'll force one with this.forceRender
         */
        _this.renderScheduled = false;
        /**
         * The methods provided to all children in the shared layout tree.
         */
        _this.syncContext = __assign(__assign({}, createBatcher()), { syncUpdate: function (force) { return _this.scheduleUpdate(force); }, forceUpdate: function () {
                // By copying syncContext to itself, when this component re-renders it'll also re-render
                // all children subscribed to the SharedLayout context.
                _this.syncContext = __assign({}, _this.syncContext);
                _this.scheduleUpdate(true);
            }, register: function (child) { return _this.addChild(child); }, remove: function (child) { return _this.removeChild(child); } });
        return _this;
    }
    AnimateSharedLayout.prototype.componentDidMount = function () {
        this.hasMounted = true;
        this.updateStacks();
    };
    AnimateSharedLayout.prototype.componentDidUpdate = function () {
        this.startLayoutAnimation();
    };
    AnimateSharedLayout.prototype.shouldComponentUpdate = function () {
        this.renderScheduled = true;
        return true;
    };
    AnimateSharedLayout.prototype.startLayoutAnimation = function () {
        var _this = this;
        /**
         * Reset update and render scheduled status
         */
        this.renderScheduled = this.updateScheduled = false;
        var type = this.props.type;
        /**
         * Update presence metadata based on the latest AnimatePresence status.
         * This is a kind of goofy way of dealing with this, perhaps there's a better model to find.
         */
        this.children.forEach(function (child) {
            if (!child.isPresent) {
                child.presence = Presence.Exiting;
            }
            else if (child.presence !== Presence.Entering) {
                child.presence =
                    child.presence === Presence.Exiting
                        ? Presence.Entering
                        : Presence.Present;
            }
        });
        /**
         * In every layoutId stack, nominate a component to lead the animation and another
         * to follow
         */
        this.updateStacks();
        /**
         * Decide which animation to use between shared layoutId components
         */
        var createAnimation = type === "crossfade"
            ? createCrossfadeAnimation
            : createSwitchAnimation;
        /**
         * Create a handler which we can use to flush the children animations
         */
        var handler = {
            measureLayout: function (child) { return child.measureLayout(); },
            layoutReady: function (child) {
                var layoutId = child.layoutId;
                child.layoutReady(createAnimation(child, _this.getStack(layoutId)));
            },
        };
        /**
         * Shared layout animations can be used without the AnimateSharedLayout wrapping component.
         * This requires some co-ordination across components to stop layout thrashing
         * and ensure measurements are taken at the correct time.
         *
         * Here we use that same mechanism of schedule/flush.
         */
        this.children.forEach(function (child) { return _this.syncContext.add(child); });
        this.syncContext.flush(handler);
        /**
         * Clear snapshots so subsequent rerenders don't retain memory of outgoing components
         */
        this.stacks.forEach(function (stack) { return (stack.snapshot = undefined); });
    };
    AnimateSharedLayout.prototype.updateStacks = function () {
        this.stacks.forEach(function (stack) { return stack.updateLeadAndFollow(); });
    };
    AnimateSharedLayout.prototype.scheduleUpdate = function (force) {
        if (force === void 0) { force = false; }
        if (!(force || !this.updateScheduled))
            return;
        /**
         * Flag we've scheduled an update
         */
        this.updateScheduled = true;
        /**
         * Read: Snapshot children
         */
        this.children.forEach(function (child) { return child.snapshotBoundingBox(); });
        /**
         * Every child keeps a local snapshot, but we also want to record
         * snapshots of the visible children as, if they're are being removed
         * in this render, we can still access them.
         */
        this.stacks.forEach(function (stack) { return stack.updateSnapshot(); });
        /**
         * Force a rerender by setting state if we aren't already going to render.
         */
        if (force || !this.renderScheduled) {
            this.renderScheduled = true;
            this.forceUpdate();
        }
    };
    AnimateSharedLayout.prototype.addChild = function (child) {
        this.children.add(child);
        this.addToStack(child);
        child.presence = this.hasMounted ? Presence.Entering : Presence.Present;
    };
    AnimateSharedLayout.prototype.removeChild = function (child) {
        this.scheduleUpdate();
        this.children.delete(child);
        this.removeFromStack(child);
    };
    AnimateSharedLayout.prototype.addToStack = function (child) {
        var stack = this.getStack(child.layoutId);
        stack === null || stack === void 0 ? void 0 : stack.add(child);
    };
    AnimateSharedLayout.prototype.removeFromStack = function (child) {
        var stack = this.getStack(child.layoutId);
        stack === null || stack === void 0 ? void 0 : stack.remove(child);
    };
    /**
     * Return a stack of animate children based on the provided layoutId.
     * Will create a stack if none currently exists with that layoutId.
     */
    AnimateSharedLayout.prototype.getStack = function (id) {
        if (id === undefined)
            return;
        // Create stack if it doesn't already exist
        !this.stacks.has(id) && this.stacks.set(id, new LayoutStack());
        return this.stacks.get(id);
    };
    AnimateSharedLayout.prototype.render = function () {
        return (React$2.createElement(SharedLayoutContext.Provider, { value: this.syncContext }, this.props.children));
    };
    return AnimateSharedLayout;
}(React$2.Component));

/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * @library
 *
 * ```jsx
 * export function MyComponent() {
 *   const scale = useMotionValue(1)
 *
 *   return <Frame scale={scale} />
 * }
 * ```
 *
 * @motion
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    return useConstant(function () { return motionValue(initial); });
}

function createScrollMotionValues() {
    return {
        scrollX: motionValue(0),
        scrollY: motionValue(0),
        scrollXProgress: motionValue(0),
        scrollYProgress: motionValue(0),
    };
}

var viewportScrollValues = createScrollMotionValues();

// Does this device prefer reduced motion? Returns `null` server-side.
var prefersReducedMotion = motionValue(null);
if (typeof window !== "undefined") {
    if (window.matchMedia) {
        var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function () {
            return prefersReducedMotion.set(motionMediaQuery_1.matches);
        };
        motionMediaQuery_1.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    }
    else {
        prefersReducedMotion.set(false);
    }
}

/**
 * This is just a very basic VisualElement, more of a hack to keep supporting useAnimatedState with
 * the latest APIs.
 */
var StateVisualElement = /** @class */ (function (_super) {
    __extends(StateVisualElement, _super);
    function StateVisualElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initialState = {};
        return _this;
    }
    StateVisualElement.prototype.updateLayoutDelta = function () { };
    StateVisualElement.prototype.build = function () { };
    StateVisualElement.prototype.clean = function () { };
    StateVisualElement.prototype.makeTargetAnimatable = function (_a) {
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = __rest(_a, ["transition", "transitionEnd"]);
        var origin = getOrigin(target, transition || {}, this);
        checkTargetForNewValues(this, target, origin);
        return __assign({ transition: transition, transitionEnd: transitionEnd }, target);
    };
    StateVisualElement.prototype.getBoundingBox = function () {
        return { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
    };
    StateVisualElement.prototype.readNativeValue = function (key) {
        return this.initialState[key] || 0;
    };
    StateVisualElement.prototype.render = function () {
        this.build();
    };
    return StateVisualElement;
}(VisualElement));

var CURSOR_SIZE = 25;
var USERS = [{
  color: COLORS.red
}, {
  color: COLORS.red
}, {
  color: COLORS.pink
}, {
  color: COLORS.purple
}, {
  color: COLORS.orange
}, {
  color: COLORS.orange
}, {
  color: COLORS.yellow
}, {
  color: COLORS.yellow
}, {
  color: COLORS.green
}, {
  color: COLORS.blue
}];

var getUser = function getUser(userId) {
  var index = ((userId === null || userId === void 0 ? void 0 : userId.charCodeAt(0)) || 0) % USERS.length;
  return USERS[index];
};

function CustomCursor(_ref) {
  var _ref$userId = _ref.userId,
      userId = _ref$userId === void 0 ? '0' : _ref$userId,
      _ref$x = _ref.x,
      x = _ref$x === void 0 ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === void 0 ? 0 : _ref$y;
  var posX = useMotionValue(0);
  var posY = useMotionValue(0);
  React$2.useEffect(function () {
    posX.set(x - CURSOR_SIZE / 2);
  }, [x]);
  React$2.useEffect(function () {
    posY.set(y - CURSOR_SIZE / 2);
  }, [y]);
  return /*#__PURE__*/React__default['default'].createElement(motion.div, {
    style: {
      y: posY,
      x: posX,
      position: 'absolute',
      width: CURSOR_SIZE,
      height: CURSOR_SIZE,
      fontSize: 20,
      userSelect: 'none',
      background: getUser(userId).color.dim,
      boxShadow: "inset 0px 0px 0px 2px ".concat(getUser(userId).color.default, ", 0px 5px 8px rgba(0,0,0,0.4)"),
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default['default'].createElement("svg", {
    style: {
      position: 'absolute',
      bottom: -2,
      left: -2
    },
    width: "6",
    height: "6",
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M2 12H9.17157C10.9534 12 11.8457 9.84572 10.5858 8.58579L3.41421 1.41421C2.15428 0.154281 0 1.04662 0 2.82843V10C0 11.1046 0.89543 12 2 12Z",
    fill: getUser(userId).color.default
  })));
}

var Puzzle = {
  InstructionModal: PuzzleInstructionModal,
  Modal: PuzzleModal,
  TopNav: PuzzleNav,
  Wrapper: PuzzleWrapper,
  CustomCursor: CustomCursor
};

var css_248z$i = ".index_security-score-footer__1Wgrr {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; }\n  .index_security-score-footer__1Wgrr .index_level-container__1MK_K {\n    font-weight: 500; }\n    .index_security-score-footer__1Wgrr .index_level-container__1MK_K .index_fad__1jOQc {\n      margin-right: 5px; }\n  .index_security-score-footer__1Wgrr .index_change-container__2GcSv {\n    font-size: 13px;\n    line-height: 22px; }\n    .index_security-score-footer__1Wgrr .index_change-container__2GcSv .index_far__1V2Ku {\n      margin-left: 5px; }\n";
styleInject(css_248z$i);

var css_248z$j = "/*!\n * Font Awesome Pro 5.10.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n.fontawesome-all-min_fa__3gwnS,\n.fontawesome-all-min_fab__2R3sl,\n.fontawesome-all-min_fad__46Ygp,\n.fontawesome-all-min_fal__2OKLO,\n.fontawesome-all-min_far__1x4mk,\n.fontawesome-all-min_fas__3YAYC {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1;\n}\n.fontawesome-all-min_fa-lg__ROANe {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n.fontawesome-all-min_fa-xs__3OPmq {\n  font-size: 0.75em;\n}\n.fontawesome-all-min_fa-sm__9ZVfY {\n  font-size: 0.875em;\n}\n.fontawesome-all-min_fa-1x__2cSt2 {\n  font-size: 1em;\n}\n.fontawesome-all-min_fa-2x__3i87A {\n  font-size: 2em;\n}\n.fontawesome-all-min_fa-3x__zzoBj {\n  font-size: 3em;\n}\n.fontawesome-all-min_fa-4x__3pbUb {\n  font-size: 4em;\n}\n.fontawesome-all-min_fa-5x__2sToR {\n  font-size: 5em;\n}\n.fontawesome-all-min_fa-6x__hCLSX {\n  font-size: 6em;\n}\n.fontawesome-all-min_fa-7x__2yWW0 {\n  font-size: 7em;\n}\n.fontawesome-all-min_fa-8x__2XRIO {\n  font-size: 8em;\n}\n.fontawesome-all-min_fa-9x__2HZp5 {\n  font-size: 9em;\n}\n.fontawesome-all-min_fa-10x__3f8fb {\n  font-size: 10em;\n}\n.fontawesome-all-min_fa-fw__3MaQZ {\n  text-align: center;\n  width: 1.25em;\n}\n.fontawesome-all-min_fa-ul__1d3Az {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fontawesome-all-min_fa-ul__1d3Az > li {\n  position: relative;\n}\n.fontawesome-all-min_fa-li__ppYuw {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n.fontawesome-all-min_fa-border__1HU1s {\n  border: 0.08em solid #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n.fontawesome-all-min_fa-pull-left__3haF0 {\n  float: left;\n}\n.fontawesome-all-min_fa-pull-right__w2FBE {\n  float: right;\n}\n.fontawesome-all-min_fa__3gwnS.fontawesome-all-min_fa-pull-left__3haF0,\n.fontawesome-all-min_fab__2R3sl.fontawesome-all-min_fa-pull-left__3haF0,\n.fontawesome-all-min_fal__2OKLO.fontawesome-all-min_fa-pull-left__3haF0,\n.fontawesome-all-min_far__1x4mk.fontawesome-all-min_fa-pull-left__3haF0,\n.fontawesome-all-min_fas__3YAYC.fontawesome-all-min_fa-pull-left__3haF0 {\n  margin-right: 0.3em;\n}\n.fontawesome-all-min_fa__3gwnS.fontawesome-all-min_fa-pull-right__w2FBE,\n.fontawesome-all-min_fab__2R3sl.fontawesome-all-min_fa-pull-right__w2FBE,\n.fontawesome-all-min_fal__2OKLO.fontawesome-all-min_fa-pull-right__w2FBE,\n.fontawesome-all-min_far__1x4mk.fontawesome-all-min_fa-pull-right__w2FBE,\n.fontawesome-all-min_fas__3YAYC.fontawesome-all-min_fa-pull-right__w2FBE {\n  margin-left: 0.3em;\n}\n.fontawesome-all-min_fa-spin__7ti0T {\n  -webkit-animation: fontawesome-all-min_fa-spin__7ti0T 2s linear infinite;\n  animation: fontawesome-all-min_fa-spin__7ti0T 2s linear infinite;\n}\n.fontawesome-all-min_fa-pulse__1yZjQ {\n  -webkit-animation: fontawesome-all-min_fa-spin__7ti0T 1s steps(8) infinite;\n  animation: fontawesome-all-min_fa-spin__7ti0T 1s steps(8) infinite;\n}\n@-webkit-keyframes fontawesome-all-min_fa-spin__7ti0T {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n@keyframes fontawesome-all-min_fa-spin__7ti0T {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n.fontawesome-all-min_fa-rotate-90__2yLXU {\n  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.fontawesome-all-min_fa-rotate-180__7-kH- {\n  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.fontawesome-all-min_fa-rotate-270__2SQwC {\n  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.fontawesome-all-min_fa-flip-horizontal__2_L5z {\n  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)';\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n}\n.fontawesome-all-min_fa-flip-vertical__1k9OS {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n}\n.fontawesome-all-min_fa-flip-both__1dLhQ,\n.fontawesome-all-min_fa-flip-horizontal__2_L5z.fontawesome-all-min_fa-flip-vertical__1k9OS,\n.fontawesome-all-min_fa-flip-vertical__1k9OS {\n  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';\n}\n.fontawesome-all-min_fa-flip-both__1dLhQ,\n.fontawesome-all-min_fa-flip-horizontal__2_L5z.fontawesome-all-min_fa-flip-vertical__1k9OS {\n  -webkit-transform: scale(-1);\n  transform: scale(-1);\n}\n:root .fontawesome-all-min_fa-flip-both__1dLhQ,\n:root .fontawesome-all-min_fa-flip-horizontal__2_L5z,\n:root .fontawesome-all-min_fa-flip-vertical__1k9OS,\n:root .fontawesome-all-min_fa-rotate-90__2yLXU,\n:root .fontawesome-all-min_fa-rotate-180__7-kH-,\n:root .fontawesome-all-min_fa-rotate-270__2SQwC {\n  -webkit-filter: none;\n  filter: none;\n}\n.fontawesome-all-min_fa-stack__2eQ3x {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em;\n}\n.fontawesome-all-min_fa-stack-1x__wL62i,\n.fontawesome-all-min_fa-stack-2x__1OqYg {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n}\n.fontawesome-all-min_fa-stack-1x__wL62i {\n  line-height: inherit;\n}\n.fontawesome-all-min_fa-stack-2x__1OqYg {\n  font-size: 2em;\n}\n.fontawesome-all-min_fa-inverse__u-3vQ {\n  color: #fff;\n}\n.fontawesome-all-min_fa-500px__1PTGY:before {\n  content: '\\F26E';\n}\n.fontawesome-all-min_fa-abacus__13ZNc:before {\n  content: '\\F640';\n}\n.fontawesome-all-min_fa-accessible-icon__cThly:before {\n  content: '\\F368';\n}\n.fontawesome-all-min_fa-accusoft__2aj5E:before {\n  content: '\\F369';\n}\n.fontawesome-all-min_fa-acorn__16I_N:before {\n  content: '\\F6AE';\n}\n.fontawesome-all-min_fa-acquisitions-incorporated__1TILV:before {\n  content: '\\F6AF';\n}\n.fontawesome-all-min_fa-ad__1G7RH:before {\n  content: '\\F641';\n}\n.fontawesome-all-min_fa-address-book__2eU5r:before {\n  content: '\\F2B9';\n}\n.fontawesome-all-min_fa-address-card__2zHEE:before {\n  content: '\\F2BB';\n}\n.fontawesome-all-min_fa-adjust__CFqNP:before {\n  content: '\\F042';\n}\n.fontawesome-all-min_fa-adn__AY36K:before {\n  content: '\\F170';\n}\n.fontawesome-all-min_fa-adobe__2Tlgj:before {\n  content: '\\F778';\n}\n.fontawesome-all-min_fa-adversal__3T-xg:before {\n  content: '\\F36A';\n}\n.fontawesome-all-min_fa-affiliatetheme__26Fwz:before {\n  content: '\\F36B';\n}\n.fontawesome-all-min_fa-air-freshener__2r-XC:before {\n  content: '\\F5D0';\n}\n.fontawesome-all-min_fa-airbnb__2uVNs:before {\n  content: '\\F834';\n}\n.fontawesome-all-min_fa-alarm-clock__UU3zO:before {\n  content: '\\F34E';\n}\n.fontawesome-all-min_fa-alarm-exclamation__25oSb:before {\n  content: '\\F843';\n}\n.fontawesome-all-min_fa-alarm-plus__BovTv:before {\n  content: '\\F844';\n}\n.fontawesome-all-min_fa-alarm-snooze__1B7nA:before {\n  content: '\\F845';\n}\n.fontawesome-all-min_fa-algolia__1aKa_:before {\n  content: '\\F36C';\n}\n.fontawesome-all-min_fa-alicorn__gMUQy:before {\n  content: '\\F6B0';\n}\n.fontawesome-all-min_fa-align-center__tq6cz:before {\n  content: '\\F037';\n}\n.fontawesome-all-min_fa-align-justify__nmtR3:before {\n  content: '\\F039';\n}\n.fontawesome-all-min_fa-align-left__7vxH-:before {\n  content: '\\F036';\n}\n.fontawesome-all-min_fa-align-right__1mpdU:before {\n  content: '\\F038';\n}\n.fontawesome-all-min_fa-align-slash__AHLxV:before {\n  content: '\\F846';\n}\n.fontawesome-all-min_fa-alipay__NtVfj:before {\n  content: '\\F642';\n}\n.fontawesome-all-min_fa-allergies__sk3KQ:before {\n  content: '\\F461';\n}\n.fontawesome-all-min_fa-amazon__1bPvD:before {\n  content: '\\F270';\n}\n.fontawesome-all-min_fa-amazon-pay__2IUax:before {\n  content: '\\F42C';\n}\n.fontawesome-all-min_fa-ambulance__2bod8:before {\n  content: '\\F0F9';\n}\n.fontawesome-all-min_fa-american-sign-language-interpreting__3cpAU:before {\n  content: '\\F2A3';\n}\n.fontawesome-all-min_fa-amilia__3pCpD:before {\n  content: '\\F36D';\n}\n.fontawesome-all-min_fa-analytics__2KmLY:before {\n  content: '\\F643';\n}\n.fontawesome-all-min_fa-anchor__2LJy-:before {\n  content: '\\F13D';\n}\n.fontawesome-all-min_fa-android__1BpFX:before {\n  content: '\\F17B';\n}\n.fontawesome-all-min_fa-angel__LCi1C:before {\n  content: '\\F779';\n}\n.fontawesome-all-min_fa-angellist__cAQkH:before {\n  content: '\\F209';\n}\n.fontawesome-all-min_fa-angle-double-down__cWP7g:before {\n  content: '\\F103';\n}\n.fontawesome-all-min_fa-angle-double-left__1nn0X:before {\n  content: '\\F100';\n}\n.fontawesome-all-min_fa-angle-double-right__16zpD:before {\n  content: '\\F101';\n}\n.fontawesome-all-min_fa-angle-double-up__23GJ2:before {\n  content: '\\F102';\n}\n.fontawesome-all-min_fa-angle-down__3_iuJ:before {\n  content: '\\F107';\n}\n.fontawesome-all-min_fa-angle-left__15m5f:before {\n  content: '\\F104';\n}\n.fontawesome-all-min_fa-angle-right__1RkR9:before {\n  content: '\\F105';\n}\n.fontawesome-all-min_fa-angle-up__Gowfu:before {\n  content: '\\F106';\n}\n.fontawesome-all-min_fa-angry__3xNgk:before {\n  content: '\\F556';\n}\n.fontawesome-all-min_fa-angrycreative__2aprS:before {\n  content: '\\F36E';\n}\n.fontawesome-all-min_fa-angular__bxMH4:before {\n  content: '\\F420';\n}\n.fontawesome-all-min_fa-ankh__2eCaS:before {\n  content: '\\F644';\n}\n.fontawesome-all-min_fa-app-store__1ypjD:before {\n  content: '\\F36F';\n}\n.fontawesome-all-min_fa-app-store-ios__1ihS2:before {\n  content: '\\F370';\n}\n.fontawesome-all-min_fa-apper__3D6Cc:before {\n  content: '\\F371';\n}\n.fontawesome-all-min_fa-apple__2YA0m:before {\n  content: '\\F179';\n}\n.fontawesome-all-min_fa-apple-alt__2TIPN:before {\n  content: '\\F5D1';\n}\n.fontawesome-all-min_fa-apple-crate__3xBEB:before {\n  content: '\\F6B1';\n}\n.fontawesome-all-min_fa-apple-pay__1BNaT:before {\n  content: '\\F415';\n}\n.fontawesome-all-min_fa-archive__1OMUc:before {\n  content: '\\F187';\n}\n.fontawesome-all-min_fa-archway__2YB0s:before {\n  content: '\\F557';\n}\n.fontawesome-all-min_fa-arrow-alt-circle-down__zo5JQ:before {\n  content: '\\F358';\n}\n.fontawesome-all-min_fa-arrow-alt-circle-left__1kmyp:before {\n  content: '\\F359';\n}\n.fontawesome-all-min_fa-arrow-alt-circle-right__MiygU:before {\n  content: '\\F35A';\n}\n.fontawesome-all-min_fa-arrow-alt-circle-up__Ky3un:before {\n  content: '\\F35B';\n}\n.fontawesome-all-min_fa-arrow-alt-down__3NV4O:before {\n  content: '\\F354';\n}\n.fontawesome-all-min_fa-arrow-alt-from-bottom__1N0r5:before {\n  content: '\\F346';\n}\n.fontawesome-all-min_fa-arrow-alt-from-left__2JsaK:before {\n  content: '\\F347';\n}\n.fontawesome-all-min_fa-arrow-alt-from-right__7R7mz:before {\n  content: '\\F348';\n}\n.fontawesome-all-min_fa-arrow-alt-from-top__27I_j:before {\n  content: '\\F349';\n}\n.fontawesome-all-min_fa-arrow-alt-left__1aiLl:before {\n  content: '\\F355';\n}\n.fontawesome-all-min_fa-arrow-alt-right__1L5lG:before {\n  content: '\\F356';\n}\n.fontawesome-all-min_fa-arrow-alt-square-down__GqM5B:before {\n  content: '\\F350';\n}\n.fontawesome-all-min_fa-arrow-alt-square-left__32Olz:before {\n  content: '\\F351';\n}\n.fontawesome-all-min_fa-arrow-alt-square-right__5OCNV:before {\n  content: '\\F352';\n}\n.fontawesome-all-min_fa-arrow-alt-square-up__3vGGi:before {\n  content: '\\F353';\n}\n.fontawesome-all-min_fa-arrow-alt-to-bottom__3DOp_:before {\n  content: '\\F34A';\n}\n.fontawesome-all-min_fa-arrow-alt-to-left__2T6Kx:before {\n  content: '\\F34B';\n}\n.fontawesome-all-min_fa-arrow-alt-to-right__3W0mc:before {\n  content: '\\F34C';\n}\n.fontawesome-all-min_fa-arrow-alt-to-top__14gX7:before {\n  content: '\\F34D';\n}\n.fontawesome-all-min_fa-arrow-alt-up__3hBg9:before {\n  content: '\\F357';\n}\n.fontawesome-all-min_fa-arrow-circle-down__1p-M0:before {\n  content: '\\F0AB';\n}\n.fontawesome-all-min_fa-arrow-circle-left__B1c6F:before {\n  content: '\\F0A8';\n}\n.fontawesome-all-min_fa-arrow-circle-right__3uw7b:before {\n  content: '\\F0A9';\n}\n.fontawesome-all-min_fa-arrow-circle-up__-R6F5:before {\n  content: '\\F0AA';\n}\n.fontawesome-all-min_fa-arrow-down__3nzPq:before {\n  content: '\\F063';\n}\n.fontawesome-all-min_fa-arrow-from-bottom__M2vFi:before {\n  content: '\\F342';\n}\n.fontawesome-all-min_fa-arrow-from-left__XFAQs:before {\n  content: '\\F343';\n}\n.fontawesome-all-min_fa-arrow-from-right__1MxQ6:before {\n  content: '\\F344';\n}\n.fontawesome-all-min_fa-arrow-from-top__1h1O7:before {\n  content: '\\F345';\n}\n.fontawesome-all-min_fa-arrow-left__39v15:before {\n  content: '\\F060';\n}\n.fontawesome-all-min_fa-arrow-right__Jz5uZ:before {\n  content: '\\F061';\n}\n.fontawesome-all-min_fa-arrow-square-down__rDmR7:before {\n  content: '\\F339';\n}\n.fontawesome-all-min_fa-arrow-square-left__lUlq3:before {\n  content: '\\F33A';\n}\n.fontawesome-all-min_fa-arrow-square-right__2IXdP:before {\n  content: '\\F33B';\n}\n.fontawesome-all-min_fa-arrow-square-up__3WtCQ:before {\n  content: '\\F33C';\n}\n.fontawesome-all-min_fa-arrow-to-bottom__1px7E:before {\n  content: '\\F33D';\n}\n.fontawesome-all-min_fa-arrow-to-left__Cb8_n:before {\n  content: '\\F33E';\n}\n.fontawesome-all-min_fa-arrow-to-right__wS7b1:before {\n  content: '\\F340';\n}\n.fontawesome-all-min_fa-arrow-to-top__2xC_2:before {\n  content: '\\F341';\n}\n.fontawesome-all-min_fa-arrow-up__2ElFi:before {\n  content: '\\F062';\n}\n.fontawesome-all-min_fa-arrows__1Dn46:before {\n  content: '\\F047';\n}\n.fontawesome-all-min_fa-arrows-alt__1eJp5:before {\n  content: '\\F0B2';\n}\n.fontawesome-all-min_fa-arrows-alt-h__2P6Ze:before {\n  content: '\\F337';\n}\n.fontawesome-all-min_fa-arrows-alt-v__38hYl:before {\n  content: '\\F338';\n}\n.fontawesome-all-min_fa-arrows-h__3e3oX:before {\n  content: '\\F07E';\n}\n.fontawesome-all-min_fa-arrows-v__3Entu:before {\n  content: '\\F07D';\n}\n.fontawesome-all-min_fa-artstation__3Ff_1:before {\n  content: '\\F77A';\n}\n.fontawesome-all-min_fa-assistive-listening-systems__NU1-x:before {\n  content: '\\F2A2';\n}\n.fontawesome-all-min_fa-asterisk__2vtLh:before {\n  content: '\\F069';\n}\n.fontawesome-all-min_fa-asymmetrik__2sMIy:before {\n  content: '\\F372';\n}\n.fontawesome-all-min_fa-at__3S0zc:before {\n  content: '\\F1FA';\n}\n.fontawesome-all-min_fa-atlas__n72aV:before {\n  content: '\\F558';\n}\n.fontawesome-all-min_fa-atlassian__zIEho:before {\n  content: '\\F77B';\n}\n.fontawesome-all-min_fa-atom__3U5wc:before {\n  content: '\\F5D2';\n}\n.fontawesome-all-min_fa-atom-alt__6msHU:before {\n  content: '\\F5D3';\n}\n.fontawesome-all-min_fa-audible__3V8Yh:before {\n  content: '\\F373';\n}\n.fontawesome-all-min_fa-audio-description__3y-gY:before {\n  content: '\\F29E';\n}\n.fontawesome-all-min_fa-autoprefixer__3rJx-:before {\n  content: '\\F41C';\n}\n.fontawesome-all-min_fa-avianex__1QG31:before {\n  content: '\\F374';\n}\n.fontawesome-all-min_fa-aviato__3D-x4:before {\n  content: '\\F421';\n}\n.fontawesome-all-min_fa-award__1WH7c:before {\n  content: '\\F559';\n}\n.fontawesome-all-min_fa-aws__SSCtA:before {\n  content: '\\F375';\n}\n.fontawesome-all-min_fa-axe__1OjZh:before {\n  content: '\\F6B2';\n}\n.fontawesome-all-min_fa-axe-battle__3q8nk:before {\n  content: '\\F6B3';\n}\n.fontawesome-all-min_fa-baby__GxZ0p:before {\n  content: '\\F77C';\n}\n.fontawesome-all-min_fa-baby-carriage__3d6rB:before {\n  content: '\\F77D';\n}\n.fontawesome-all-min_fa-backpack__17nL9:before {\n  content: '\\F5D4';\n}\n.fontawesome-all-min_fa-backspace__ceFza:before {\n  content: '\\F55A';\n}\n.fontawesome-all-min_fa-backward__1-8Ir:before {\n  content: '\\F04A';\n}\n.fontawesome-all-min_fa-bacon__3NOUL:before {\n  content: '\\F7E5';\n}\n.fontawesome-all-min_fa-badge__21oqB:before {\n  content: '\\F335';\n}\n.fontawesome-all-min_fa-badge-check__28fwG:before {\n  content: '\\F336';\n}\n.fontawesome-all-min_fa-badge-dollar__1uvHs:before {\n  content: '\\F645';\n}\n.fontawesome-all-min_fa-badge-percent__3fhyl:before {\n  content: '\\F646';\n}\n.fontawesome-all-min_fa-badger-honey__1bVKB:before {\n  content: '\\F6B4';\n}\n.fontawesome-all-min_fa-bags-shopping__2YeBT:before {\n  content: '\\F847';\n}\n.fontawesome-all-min_fa-balance-scale__18eED:before {\n  content: '\\F24E';\n}\n.fontawesome-all-min_fa-balance-scale-left__vC94f:before {\n  content: '\\F515';\n}\n.fontawesome-all-min_fa-balance-scale-right__1b6_0:before {\n  content: '\\F516';\n}\n.fontawesome-all-min_fa-ball-pile__2JrxQ:before {\n  content: '\\F77E';\n}\n.fontawesome-all-min_fa-ballot__1Vo65:before {\n  content: '\\F732';\n}\n.fontawesome-all-min_fa-ballot-check__2o44s:before {\n  content: '\\F733';\n}\n.fontawesome-all-min_fa-ban__1ddug:before {\n  content: '\\F05E';\n}\n.fontawesome-all-min_fa-band-aid__2chWM:before {\n  content: '\\F462';\n}\n.fontawesome-all-min_fa-bandcamp__1rCjl:before {\n  content: '\\F2D5';\n}\n.fontawesome-all-min_fa-barcode__1euuG:before {\n  content: '\\F02A';\n}\n.fontawesome-all-min_fa-barcode-alt__3qVhR:before {\n  content: '\\F463';\n}\n.fontawesome-all-min_fa-barcode-read__3h0v1:before {\n  content: '\\F464';\n}\n.fontawesome-all-min_fa-barcode-scan__3CCic:before {\n  content: '\\F465';\n}\n.fontawesome-all-min_fa-bars__2Y8Hz:before {\n  content: '\\F0C9';\n}\n.fontawesome-all-min_fa-baseball__1StXW:before {\n  content: '\\F432';\n}\n.fontawesome-all-min_fa-baseball-ball__13B-c:before {\n  content: '\\F433';\n}\n.fontawesome-all-min_fa-basketball-ball__1acwH:before {\n  content: '\\F434';\n}\n.fontawesome-all-min_fa-basketball-hoop__2O4DM:before {\n  content: '\\F435';\n}\n.fontawesome-all-min_fa-bat__3mt1P:before {\n  content: '\\F6B5';\n}\n.fontawesome-all-min_fa-bath__2prqM:before {\n  content: '\\F2CD';\n}\n.fontawesome-all-min_fa-battery-bolt__5pCUa:before {\n  content: '\\F376';\n}\n.fontawesome-all-min_fa-battery-empty__RJhJJ:before {\n  content: '\\F244';\n}\n.fontawesome-all-min_fa-battery-full__1tzwM:before {\n  content: '\\F240';\n}\n.fontawesome-all-min_fa-battery-half__JlaVa:before {\n  content: '\\F242';\n}\n.fontawesome-all-min_fa-battery-quarter__f71cV:before {\n  content: '\\F243';\n}\n.fontawesome-all-min_fa-battery-slash__1bdsd:before {\n  content: '\\F377';\n}\n.fontawesome-all-min_fa-battery-three-quarters__3x21G:before {\n  content: '\\F241';\n}\n.fontawesome-all-min_fa-battle-net__2Djdz:before {\n  content: '\\F835';\n}\n.fontawesome-all-min_fa-bed__3pzdl:before {\n  content: '\\F236';\n}\n.fontawesome-all-min_fa-beer__3-jWz:before {\n  content: '\\F0FC';\n}\n.fontawesome-all-min_fa-behance__1CLaD:before {\n  content: '\\F1B4';\n}\n.fontawesome-all-min_fa-behance-square__1BmsP:before {\n  content: '\\F1B5';\n}\n.fontawesome-all-min_fa-bell__2dhYb:before {\n  content: '\\F0F3';\n}\n.fontawesome-all-min_fa-bell-exclamation__1sQja:before {\n  content: '\\F848';\n}\n.fontawesome-all-min_fa-bell-plus__1JdGk:before {\n  content: '\\F849';\n}\n.fontawesome-all-min_fa-bell-school__3nbnN:before {\n  content: '\\F5D5';\n}\n.fontawesome-all-min_fa-bell-school-slash__3qOef:before {\n  content: '\\F5D6';\n}\n.fontawesome-all-min_fa-bell-slash__2h9r_:before {\n  content: '\\F1F6';\n}\n.fontawesome-all-min_fa-bells__3wBd8:before {\n  content: '\\F77F';\n}\n.fontawesome-all-min_fa-bezier-curve__34MqU:before {\n  content: '\\F55B';\n}\n.fontawesome-all-min_fa-bible__1uYFR:before {\n  content: '\\F647';\n}\n.fontawesome-all-min_fa-bicycle__3A37_:before {\n  content: '\\F206';\n}\n.fontawesome-all-min_fa-biking__3wKAa:before {\n  content: '\\F84A';\n}\n.fontawesome-all-min_fa-biking-mountain__1z42_:before {\n  content: '\\F84B';\n}\n.fontawesome-all-min_fa-bimobject__mPopd:before {\n  content: '\\F378';\n}\n.fontawesome-all-min_fa-binoculars__Kbh-y:before {\n  content: '\\F1E5';\n}\n.fontawesome-all-min_fa-biohazard__1Ms15:before {\n  content: '\\F780';\n}\n.fontawesome-all-min_fa-birthday-cake__2iEL9:before {\n  content: '\\F1FD';\n}\n.fontawesome-all-min_fa-bitbucket__2KuT0:before {\n  content: '\\F171';\n}\n.fontawesome-all-min_fa-bitcoin__3_yQ1:before {\n  content: '\\F379';\n}\n.fontawesome-all-min_fa-bity__Um9S9:before {\n  content: '\\F37A';\n}\n.fontawesome-all-min_fa-black-tie__2r3LI:before {\n  content: '\\F27E';\n}\n.fontawesome-all-min_fa-blackberry__2GNlP:before {\n  content: '\\F37B';\n}\n.fontawesome-all-min_fa-blanket__1e1LD:before {\n  content: '\\F498';\n}\n.fontawesome-all-min_fa-blender__3sVS7:before {\n  content: '\\F517';\n}\n.fontawesome-all-min_fa-blender-phone__3vFKt:before {\n  content: '\\F6B6';\n}\n.fontawesome-all-min_fa-blind__1o19d:before {\n  content: '\\F29D';\n}\n.fontawesome-all-min_fa-blog__2PVy4:before {\n  content: '\\F781';\n}\n.fontawesome-all-min_fa-blogger__3vjBQ:before {\n  content: '\\F37C';\n}\n.fontawesome-all-min_fa-blogger-b__3RmCF:before {\n  content: '\\F37D';\n}\n.fontawesome-all-min_fa-bluetooth__21EyQ:before {\n  content: '\\F293';\n}\n.fontawesome-all-min_fa-bluetooth-b__yCIua:before {\n  content: '\\F294';\n}\n.fontawesome-all-min_fa-bold__1mYHv:before {\n  content: '\\F032';\n}\n.fontawesome-all-min_fa-bolt__1I_Bt:before {\n  content: '\\F0E7';\n}\n.fontawesome-all-min_fa-bomb__1k0r5:before {\n  content: '\\F1E2';\n}\n.fontawesome-all-min_fa-bone__1Z9R6:before {\n  content: '\\F5D7';\n}\n.fontawesome-all-min_fa-bone-break__3fEb9:before {\n  content: '\\F5D8';\n}\n.fontawesome-all-min_fa-bong__It2fT:before {\n  content: '\\F55C';\n}\n.fontawesome-all-min_fa-book__3gb6L:before {\n  content: '\\F02D';\n}\n.fontawesome-all-min_fa-book-alt__25-5F:before {\n  content: '\\F5D9';\n}\n.fontawesome-all-min_fa-book-dead__2vcd2:before {\n  content: '\\F6B7';\n}\n.fontawesome-all-min_fa-book-heart__1NkxO:before {\n  content: '\\F499';\n}\n.fontawesome-all-min_fa-book-medical__2YmrU:before {\n  content: '\\F7E6';\n}\n.fontawesome-all-min_fa-book-open__worc8:before {\n  content: '\\F518';\n}\n.fontawesome-all-min_fa-book-reader__1rENq:before {\n  content: '\\F5DA';\n}\n.fontawesome-all-min_fa-book-spells__2WXjj:before {\n  content: '\\F6B8';\n}\n.fontawesome-all-min_fa-book-user__3CMFU:before {\n  content: '\\F7E7';\n}\n.fontawesome-all-min_fa-bookmark__nGNCL:before {\n  content: '\\F02E';\n}\n.fontawesome-all-min_fa-books__2UzUI:before {\n  content: '\\F5DB';\n}\n.fontawesome-all-min_fa-books-medical__1jFB9:before {\n  content: '\\F7E8';\n}\n.fontawesome-all-min_fa-boot__3uDSR:before {\n  content: '\\F782';\n}\n.fontawesome-all-min_fa-booth-curtain__1--4z:before {\n  content: '\\F734';\n}\n.fontawesome-all-min_fa-bootstrap__3lWVD:before {\n  content: '\\F836';\n}\n.fontawesome-all-min_fa-border-all__8cscS:before {\n  content: '\\F84C';\n}\n.fontawesome-all-min_fa-border-bottom__3TTK3:before {\n  content: '\\F84D';\n}\n.fontawesome-all-min_fa-border-center-h__2_O8D:before {\n  content: '\\F89C';\n}\n.fontawesome-all-min_fa-border-center-v__1cxxT:before {\n  content: '\\F89D';\n}\n.fontawesome-all-min_fa-border-inner__2kwUD:before {\n  content: '\\F84E';\n}\n.fontawesome-all-min_fa-border-left__3vTB8:before {\n  content: '\\F84F';\n}\n.fontawesome-all-min_fa-border-none__2teSq:before {\n  content: '\\F850';\n}\n.fontawesome-all-min_fa-border-outer__30juG:before {\n  content: '\\F851';\n}\n.fontawesome-all-min_fa-border-right__25aXI:before {\n  content: '\\F852';\n}\n.fontawesome-all-min_fa-border-style__3R8Dt:before {\n  content: '\\F853';\n}\n.fontawesome-all-min_fa-border-style-alt__1PPdo:before {\n  content: '\\F854';\n}\n.fontawesome-all-min_fa-border-top__CPnxQ:before {\n  content: '\\F855';\n}\n.fontawesome-all-min_fa-bow-arrow__3Kgve:before {\n  content: '\\F6B9';\n}\n.fontawesome-all-min_fa-bowling-ball__2aa2R:before {\n  content: '\\F436';\n}\n.fontawesome-all-min_fa-bowling-pins__1oV0w:before {\n  content: '\\F437';\n}\n.fontawesome-all-min_fa-box__2bkf-:before {\n  content: '\\F466';\n}\n.fontawesome-all-min_fa-box-alt__15h3n:before {\n  content: '\\F49A';\n}\n.fontawesome-all-min_fa-box-ballot__3t1_o:before {\n  content: '\\F735';\n}\n.fontawesome-all-min_fa-box-check__2Sf6_:before {\n  content: '\\F467';\n}\n.fontawesome-all-min_fa-box-fragile__3K3M4:before {\n  content: '\\F49B';\n}\n.fontawesome-all-min_fa-box-full__1yAmL:before {\n  content: '\\F49C';\n}\n.fontawesome-all-min_fa-box-heart__3jxeM:before {\n  content: '\\F49D';\n}\n.fontawesome-all-min_fa-box-open__3Duzz:before {\n  content: '\\F49E';\n}\n.fontawesome-all-min_fa-box-up__1Q4bU:before {\n  content: '\\F49F';\n}\n.fontawesome-all-min_fa-box-usd__3wGM3:before {\n  content: '\\F4A0';\n}\n.fontawesome-all-min_fa-boxes__2aCrY:before {\n  content: '\\F468';\n}\n.fontawesome-all-min_fa-boxes-alt__zJWMP:before {\n  content: '\\F4A1';\n}\n.fontawesome-all-min_fa-boxing-glove__3KNBg:before {\n  content: '\\F438';\n}\n.fontawesome-all-min_fa-brackets__3oF56:before {\n  content: '\\F7E9';\n}\n.fontawesome-all-min_fa-brackets-curly__b7OR8:before {\n  content: '\\F7EA';\n}\n.fontawesome-all-min_fa-braille__3BFv5:before {\n  content: '\\F2A1';\n}\n.fontawesome-all-min_fa-brain__6ciSj:before {\n  content: '\\F5DC';\n}\n.fontawesome-all-min_fa-bread-loaf__3bVe5:before {\n  content: '\\F7EB';\n}\n.fontawesome-all-min_fa-bread-slice__2-ljO:before {\n  content: '\\F7EC';\n}\n.fontawesome-all-min_fa-briefcase__1Gn43:before {\n  content: '\\F0B1';\n}\n.fontawesome-all-min_fa-briefcase-medical__34pz8:before {\n  content: '\\F469';\n}\n.fontawesome-all-min_fa-bring-forward__1NSwN:before {\n  content: '\\F856';\n}\n.fontawesome-all-min_fa-bring-front__1RQJy:before {\n  content: '\\F857';\n}\n.fontawesome-all-min_fa-broadcast-tower__3PcVw:before {\n  content: '\\F519';\n}\n.fontawesome-all-min_fa-broom__7VfCG:before {\n  content: '\\F51A';\n}\n.fontawesome-all-min_fa-browser__SXC32:before {\n  content: '\\F37E';\n}\n.fontawesome-all-min_fa-brush__3Bgn9:before {\n  content: '\\F55D';\n}\n.fontawesome-all-min_fa-btc__1c1mc:before {\n  content: '\\F15A';\n}\n.fontawesome-all-min_fa-buffer__2171A:before {\n  content: '\\F837';\n}\n.fontawesome-all-min_fa-bug__3F8G5:before {\n  content: '\\F188';\n}\n.fontawesome-all-min_fa-building__18KED:before {\n  content: '\\F1AD';\n}\n.fontawesome-all-min_fa-bullhorn__1prfc:before {\n  content: '\\F0A1';\n}\n.fontawesome-all-min_fa-bullseye__32vre:before {\n  content: '\\F140';\n}\n.fontawesome-all-min_fa-bullseye-arrow__2Ifhw:before {\n  content: '\\F648';\n}\n.fontawesome-all-min_fa-bullseye-pointer__20Q9v:before {\n  content: '\\F649';\n}\n.fontawesome-all-min_fa-burger-soda__2vfli:before {\n  content: '\\F858';\n}\n.fontawesome-all-min_fa-burn__1Fwux:before {\n  content: '\\F46A';\n}\n.fontawesome-all-min_fa-buromobelexperte__4mStN:before {\n  content: '\\F37F';\n}\n.fontawesome-all-min_fa-burrito__32RUA:before {\n  content: '\\F7ED';\n}\n.fontawesome-all-min_fa-bus__36lOM:before {\n  content: '\\F207';\n}\n.fontawesome-all-min_fa-bus-alt__142Mp:before {\n  content: '\\F55E';\n}\n.fontawesome-all-min_fa-bus-school__2264p:before {\n  content: '\\F5DD';\n}\n.fontawesome-all-min_fa-business-time__3ARvS:before {\n  content: '\\F64A';\n}\n.fontawesome-all-min_fa-buysellads__JQUSL:before {\n  content: '\\F20D';\n}\n.fontawesome-all-min_fa-cabinet-filing__2qE5X:before {\n  content: '\\F64B';\n}\n.fontawesome-all-min_fa-calculator__1QDsO:before {\n  content: '\\F1EC';\n}\n.fontawesome-all-min_fa-calculator-alt__1hWWc:before {\n  content: '\\F64C';\n}\n.fontawesome-all-min_fa-calendar__1-G3Y:before {\n  content: '\\F133';\n}\n.fontawesome-all-min_fa-calendar-alt__1uRgF:before {\n  content: '\\F073';\n}\n.fontawesome-all-min_fa-calendar-check__3Fc2j:before {\n  content: '\\F274';\n}\n.fontawesome-all-min_fa-calendar-day__MdEU6:before {\n  content: '\\F783';\n}\n.fontawesome-all-min_fa-calendar-edit__1bCm3:before {\n  content: '\\F333';\n}\n.fontawesome-all-min_fa-calendar-exclamation__1UH78:before {\n  content: '\\F334';\n}\n.fontawesome-all-min_fa-calendar-minus__1agIP:before {\n  content: '\\F272';\n}\n.fontawesome-all-min_fa-calendar-plus__1frPh:before {\n  content: '\\F271';\n}\n.fontawesome-all-min_fa-calendar-star__k9lC_:before {\n  content: '\\F736';\n}\n.fontawesome-all-min_fa-calendar-times__U9LDD:before {\n  content: '\\F273';\n}\n.fontawesome-all-min_fa-calendar-week__2843H:before {\n  content: '\\F784';\n}\n.fontawesome-all-min_fa-camera__1L7lB:before {\n  content: '\\F030';\n}\n.fontawesome-all-min_fa-camera-alt__3KTu5:before {\n  content: '\\F332';\n}\n.fontawesome-all-min_fa-camera-retro__WM8YA:before {\n  content: '\\F083';\n}\n.fontawesome-all-min_fa-campfire__LcG4X:before {\n  content: '\\F6BA';\n}\n.fontawesome-all-min_fa-campground__JlA4F:before {\n  content: '\\F6BB';\n}\n.fontawesome-all-min_fa-canadian-maple-leaf__2X-MF:before {\n  content: '\\F785';\n}\n.fontawesome-all-min_fa-candle-holder__1V7Zb:before {\n  content: '\\F6BC';\n}\n.fontawesome-all-min_fa-candy-cane__1Fffd:before {\n  content: '\\F786';\n}\n.fontawesome-all-min_fa-candy-corn__JBaeu:before {\n  content: '\\F6BD';\n}\n.fontawesome-all-min_fa-cannabis__5gcq_:before {\n  content: '\\F55F';\n}\n.fontawesome-all-min_fa-capsules__28MFq:before {\n  content: '\\F46B';\n}\n.fontawesome-all-min_fa-car__3eACn:before {\n  content: '\\F1B9';\n}\n.fontawesome-all-min_fa-car-alt__2h2l8:before {\n  content: '\\F5DE';\n}\n.fontawesome-all-min_fa-car-battery__2Vaww:before {\n  content: '\\F5DF';\n}\n.fontawesome-all-min_fa-car-building__3hGCq:before {\n  content: '\\F859';\n}\n.fontawesome-all-min_fa-car-bump__Av3Xf:before {\n  content: '\\F5E0';\n}\n.fontawesome-all-min_fa-car-bus__26qXH:before {\n  content: '\\F85A';\n}\n.fontawesome-all-min_fa-car-crash__1BPgG:before {\n  content: '\\F5E1';\n}\n.fontawesome-all-min_fa-car-garage__2fXC9:before {\n  content: '\\F5E2';\n}\n.fontawesome-all-min_fa-car-mechanic__AvPZY:before {\n  content: '\\F5E3';\n}\n.fontawesome-all-min_fa-car-side__1bj_R:before {\n  content: '\\F5E4';\n}\n.fontawesome-all-min_fa-car-tilt__1633m:before {\n  content: '\\F5E5';\n}\n.fontawesome-all-min_fa-car-wash__37bQ-:before {\n  content: '\\F5E6';\n}\n.fontawesome-all-min_fa-caret-circle-down__2ZYHq:before {\n  content: '\\F32D';\n}\n.fontawesome-all-min_fa-caret-circle-left__D8mSf:before {\n  content: '\\F32E';\n}\n.fontawesome-all-min_fa-caret-circle-right__ZvKCJ:before {\n  content: '\\F330';\n}\n.fontawesome-all-min_fa-caret-circle-up__2ZNJY:before {\n  content: '\\F331';\n}\n.fontawesome-all-min_fa-caret-down__1ipSZ:before {\n  content: '\\F0D7';\n}\n.fontawesome-all-min_fa-caret-left__38xPV:before {\n  content: '\\F0D9';\n}\n.fontawesome-all-min_fa-caret-right__rrae-:before {\n  content: '\\F0DA';\n}\n.fontawesome-all-min_fa-caret-square-down__3oI4p:before {\n  content: '\\F150';\n}\n.fontawesome-all-min_fa-caret-square-left__Ayh-E:before {\n  content: '\\F191';\n}\n.fontawesome-all-min_fa-caret-square-right__3xdCb:before {\n  content: '\\F152';\n}\n.fontawesome-all-min_fa-caret-square-up__3Mahv:before {\n  content: '\\F151';\n}\n.fontawesome-all-min_fa-caret-up__1hPKc:before {\n  content: '\\F0D8';\n}\n.fontawesome-all-min_fa-carrot__YIwFZ:before {\n  content: '\\F787';\n}\n.fontawesome-all-min_fa-cars__12s8O:before {\n  content: '\\F85B';\n}\n.fontawesome-all-min_fa-cart-arrow-down__12Nx5:before {\n  content: '\\F218';\n}\n.fontawesome-all-min_fa-cart-plus__1MANs:before {\n  content: '\\F217';\n}\n.fontawesome-all-min_fa-cash-register__3Mk2d:before {\n  content: '\\F788';\n}\n.fontawesome-all-min_fa-cat__1gCXe:before {\n  content: '\\F6BE';\n}\n.fontawesome-all-min_fa-cauldron__1A3nJ:before {\n  content: '\\F6BF';\n}\n.fontawesome-all-min_fa-cc-amazon-pay__1MCoO:before {\n  content: '\\F42D';\n}\n.fontawesome-all-min_fa-cc-amex__29Yra:before {\n  content: '\\F1F3';\n}\n.fontawesome-all-min_fa-cc-apple-pay__1BcxT:before {\n  content: '\\F416';\n}\n.fontawesome-all-min_fa-cc-diners-club__8CGxK:before {\n  content: '\\F24C';\n}\n.fontawesome-all-min_fa-cc-discover__3C10Z:before {\n  content: '\\F1F2';\n}\n.fontawesome-all-min_fa-cc-jcb__1AKCE:before {\n  content: '\\F24B';\n}\n.fontawesome-all-min_fa-cc-mastercard__3VJHB:before {\n  content: '\\F1F1';\n}\n.fontawesome-all-min_fa-cc-paypal__1hXcE:before {\n  content: '\\F1F4';\n}\n.fontawesome-all-min_fa-cc-stripe__f7MYJ:before {\n  content: '\\F1F5';\n}\n.fontawesome-all-min_fa-cc-visa__c2hVK:before {\n  content: '\\F1F0';\n}\n.fontawesome-all-min_fa-centercode__2X5MD:before {\n  content: '\\F380';\n}\n.fontawesome-all-min_fa-centos__17Qti:before {\n  content: '\\F789';\n}\n.fontawesome-all-min_fa-certificate__2aSAY:before {\n  content: '\\F0A3';\n}\n.fontawesome-all-min_fa-chair__10SwP:before {\n  content: '\\F6C0';\n}\n.fontawesome-all-min_fa-chair-office__3i5uw:before {\n  content: '\\F6C1';\n}\n.fontawesome-all-min_fa-chalkboard__Wzofs:before {\n  content: '\\F51B';\n}\n.fontawesome-all-min_fa-chalkboard-teacher__3btim:before {\n  content: '\\F51C';\n}\n.fontawesome-all-min_fa-charging-station__FiKX5:before {\n  content: '\\F5E7';\n}\n.fontawesome-all-min_fa-chart-area__b5MhJ:before {\n  content: '\\F1FE';\n}\n.fontawesome-all-min_fa-chart-bar__yBCsb:before {\n  content: '\\F080';\n}\n.fontawesome-all-min_fa-chart-line__2Wznu:before {\n  content: '\\F201';\n}\n.fontawesome-all-min_fa-chart-line-down__2msDa:before {\n  content: '\\F64D';\n}\n.fontawesome-all-min_fa-chart-network__3DfnA:before {\n  content: '\\F78A';\n}\n.fontawesome-all-min_fa-chart-pie__1jxrT:before {\n  content: '\\F200';\n}\n.fontawesome-all-min_fa-chart-pie-alt__1nySx:before {\n  content: '\\F64E';\n}\n.fontawesome-all-min_fa-chart-scatter__1nrHg:before {\n  content: '\\F7EE';\n}\n.fontawesome-all-min_fa-check__3IYeD:before {\n  content: '\\F00C';\n}\n.fontawesome-all-min_fa-check-circle__2XixQ:before {\n  content: '\\F058';\n}\n.fontawesome-all-min_fa-check-double__TQEjz:before {\n  content: '\\F560';\n}\n.fontawesome-all-min_fa-check-square__3upGc:before {\n  content: '\\F14A';\n}\n.fontawesome-all-min_fa-cheese__32U2k:before {\n  content: '\\F7EF';\n}\n.fontawesome-all-min_fa-cheese-swiss__1_9Gj:before {\n  content: '\\F7F0';\n}\n.fontawesome-all-min_fa-cheeseburger__LqNBP:before {\n  content: '\\F7F1';\n}\n.fontawesome-all-min_fa-chess__XUs4u:before {\n  content: '\\F439';\n}\n.fontawesome-all-min_fa-chess-bishop__1l9kE:before {\n  content: '\\F43A';\n}\n.fontawesome-all-min_fa-chess-bishop-alt__3O5JE:before {\n  content: '\\F43B';\n}\n.fontawesome-all-min_fa-chess-board__1w7-8:before {\n  content: '\\F43C';\n}\n.fontawesome-all-min_fa-chess-clock__3r4z3:before {\n  content: '\\F43D';\n}\n.fontawesome-all-min_fa-chess-clock-alt__3HjqV:before {\n  content: '\\F43E';\n}\n.fontawesome-all-min_fa-chess-king__3q1mD:before {\n  content: '\\F43F';\n}\n.fontawesome-all-min_fa-chess-king-alt__3-FTN:before {\n  content: '\\F440';\n}\n.fontawesome-all-min_fa-chess-knight__1LpqL:before {\n  content: '\\F441';\n}\n.fontawesome-all-min_fa-chess-knight-alt__3cLzO:before {\n  content: '\\F442';\n}\n.fontawesome-all-min_fa-chess-pawn__27mZZ:before {\n  content: '\\F443';\n}\n.fontawesome-all-min_fa-chess-pawn-alt__3wT5m:before {\n  content: '\\F444';\n}\n.fontawesome-all-min_fa-chess-queen__1wLNI:before {\n  content: '\\F445';\n}\n.fontawesome-all-min_fa-chess-queen-alt__1EJ50:before {\n  content: '\\F446';\n}\n.fontawesome-all-min_fa-chess-rook__ArebW:before {\n  content: '\\F447';\n}\n.fontawesome-all-min_fa-chess-rook-alt__1Gs4e:before {\n  content: '\\F448';\n}\n.fontawesome-all-min_fa-chevron-circle-down__3cJ7k:before {\n  content: '\\F13A';\n}\n.fontawesome-all-min_fa-chevron-circle-left__1-FP-:before {\n  content: '\\F137';\n}\n.fontawesome-all-min_fa-chevron-circle-right__2pBA9:before {\n  content: '\\F138';\n}\n.fontawesome-all-min_fa-chevron-circle-up__1eD0B:before {\n  content: '\\F139';\n}\n.fontawesome-all-min_fa-chevron-double-down__2Yt53:before {\n  content: '\\F322';\n}\n.fontawesome-all-min_fa-chevron-double-left__V7UYO:before {\n  content: '\\F323';\n}\n.fontawesome-all-min_fa-chevron-double-right__2bZnc:before {\n  content: '\\F324';\n}\n.fontawesome-all-min_fa-chevron-double-up__2colD:before {\n  content: '\\F325';\n}\n.fontawesome-all-min_fa-chevron-down__1SKuX:before {\n  content: '\\F078';\n}\n.fontawesome-all-min_fa-chevron-left__Y_CF_:before {\n  content: '\\F053';\n}\n.fontawesome-all-min_fa-chevron-right__2O5pH:before {\n  content: '\\F054';\n}\n.fontawesome-all-min_fa-chevron-square-down__1T5QK:before {\n  content: '\\F329';\n}\n.fontawesome-all-min_fa-chevron-square-left__3hIRA:before {\n  content: '\\F32A';\n}\n.fontawesome-all-min_fa-chevron-square-right__3KFfC:before {\n  content: '\\F32B';\n}\n.fontawesome-all-min_fa-chevron-square-up__3oIWv:before {\n  content: '\\F32C';\n}\n.fontawesome-all-min_fa-chevron-up__3FZ54:before {\n  content: '\\F077';\n}\n.fontawesome-all-min_fa-child__zCp6M:before {\n  content: '\\F1AE';\n}\n.fontawesome-all-min_fa-chimney__3XCYE:before {\n  content: '\\F78B';\n}\n.fontawesome-all-min_fa-chrome__1IgLI:before {\n  content: '\\F268';\n}\n.fontawesome-all-min_fa-chromecast__2as-V:before {\n  content: '\\F838';\n}\n.fontawesome-all-min_fa-church__2NNOT:before {\n  content: '\\F51D';\n}\n.fontawesome-all-min_fa-circle__3Etzd:before {\n  content: '\\F111';\n}\n.fontawesome-all-min_fa-circle-notch__XHOgN:before {\n  content: '\\F1CE';\n}\n.fontawesome-all-min_fa-city__38vDr:before {\n  content: '\\F64F';\n}\n.fontawesome-all-min_fa-claw-marks__3ZmBZ:before {\n  content: '\\F6C2';\n}\n.fontawesome-all-min_fa-clinic-medical__m7I1C:before {\n  content: '\\F7F2';\n}\n.fontawesome-all-min_fa-clipboard__1rbO7:before {\n  content: '\\F328';\n}\n.fontawesome-all-min_fa-clipboard-check__3jXVa:before {\n  content: '\\F46C';\n}\n.fontawesome-all-min_fa-clipboard-list__33597:before {\n  content: '\\F46D';\n}\n.fontawesome-all-min_fa-clipboard-list-check__PTIg_:before {\n  content: '\\F737';\n}\n.fontawesome-all-min_fa-clipboard-prescription__cpj_W:before {\n  content: '\\F5E8';\n}\n.fontawesome-all-min_fa-clipboard-user__ZrG_Q:before {\n  content: '\\F7F3';\n}\n.fontawesome-all-min_fa-clock__18Zb5:before {\n  content: '\\F017';\n}\n.fontawesome-all-min_fa-clone__3DMrO:before {\n  content: '\\F24D';\n}\n.fontawesome-all-min_fa-closed-captioning__1XHh0:before {\n  content: '\\F20A';\n}\n.fontawesome-all-min_fa-cloud__H3yHi:before {\n  content: '\\F0C2';\n}\n.fontawesome-all-min_fa-cloud-download__3m2K3:before {\n  content: '\\F0ED';\n}\n.fontawesome-all-min_fa-cloud-download-alt__Z8Qe7:before {\n  content: '\\F381';\n}\n.fontawesome-all-min_fa-cloud-drizzle__3Mn77:before {\n  content: '\\F738';\n}\n.fontawesome-all-min_fa-cloud-hail__rX2Ig:before {\n  content: '\\F739';\n}\n.fontawesome-all-min_fa-cloud-hail-mixed__3dm-e:before {\n  content: '\\F73A';\n}\n.fontawesome-all-min_fa-cloud-meatball__3BoGL:before {\n  content: '\\F73B';\n}\n.fontawesome-all-min_fa-cloud-moon__3m88c:before {\n  content: '\\F6C3';\n}\n.fontawesome-all-min_fa-cloud-moon-rain__iksrY:before {\n  content: '\\F73C';\n}\n.fontawesome-all-min_fa-cloud-rain__DINgN:before {\n  content: '\\F73D';\n}\n.fontawesome-all-min_fa-cloud-rainbow__3IirY:before {\n  content: '\\F73E';\n}\n.fontawesome-all-min_fa-cloud-showers__2tz3z:before {\n  content: '\\F73F';\n}\n.fontawesome-all-min_fa-cloud-showers-heavy__3-qie:before {\n  content: '\\F740';\n}\n.fontawesome-all-min_fa-cloud-sleet__1aJhJ:before {\n  content: '\\F741';\n}\n.fontawesome-all-min_fa-cloud-snow__2Pa5Z:before {\n  content: '\\F742';\n}\n.fontawesome-all-min_fa-cloud-sun__1qH_N:before {\n  content: '\\F6C4';\n}\n.fontawesome-all-min_fa-cloud-sun-rain__290TK:before {\n  content: '\\F743';\n}\n.fontawesome-all-min_fa-cloud-upload__3ieQ2:before {\n  content: '\\F0EE';\n}\n.fontawesome-all-min_fa-cloud-upload-alt__1Jn7z:before {\n  content: '\\F382';\n}\n.fontawesome-all-min_fa-clouds__3WFA4:before {\n  content: '\\F744';\n}\n.fontawesome-all-min_fa-clouds-moon__2u-Sk:before {\n  content: '\\F745';\n}\n.fontawesome-all-min_fa-clouds-sun__t3cgJ:before {\n  content: '\\F746';\n}\n.fontawesome-all-min_fa-cloudscale__2N3ax:before {\n  content: '\\F383';\n}\n.fontawesome-all-min_fa-cloudsmith__2ZN1_:before {\n  content: '\\F384';\n}\n.fontawesome-all-min_fa-cloudversify__1WKbM:before {\n  content: '\\F385';\n}\n.fontawesome-all-min_fa-club__1y8bd:before {\n  content: '\\F327';\n}\n.fontawesome-all-min_fa-cocktail__o5ey9:before {\n  content: '\\F561';\n}\n.fontawesome-all-min_fa-code__oIeNj:before {\n  content: '\\F121';\n}\n.fontawesome-all-min_fa-code-branch__3MisO:before {\n  content: '\\F126';\n}\n.fontawesome-all-min_fa-code-commit__2nE96:before {\n  content: '\\F386';\n}\n.fontawesome-all-min_fa-code-merge__2ftns:before {\n  content: '\\F387';\n}\n.fontawesome-all-min_fa-codepen__3mC-2:before {\n  content: '\\F1CB';\n}\n.fontawesome-all-min_fa-codiepie__2EfWN:before {\n  content: '\\F284';\n}\n.fontawesome-all-min_fa-coffee__1VGNw:before {\n  content: '\\F0F4';\n}\n.fontawesome-all-min_fa-coffee-togo__nwYS2:before {\n  content: '\\F6C5';\n}\n.fontawesome-all-min_fa-coffin__Xv5Zo:before {\n  content: '\\F6C6';\n}\n.fontawesome-all-min_fa-cog__2CdJ4:before {\n  content: '\\F013';\n}\n.fontawesome-all-min_fa-cogs__1qXcx:before {\n  content: '\\F085';\n}\n.fontawesome-all-min_fa-coin__2ufz0:before {\n  content: '\\F85C';\n}\n.fontawesome-all-min_fa-coins__T5WFS:before {\n  content: '\\F51E';\n}\n.fontawesome-all-min_fa-columns__2QZcJ:before {\n  content: '\\F0DB';\n}\n.fontawesome-all-min_fa-comment__1BoCK:before {\n  content: '\\F075';\n}\n.fontawesome-all-min_fa-comment-alt__3nKWg:before {\n  content: '\\F27A';\n}\n.fontawesome-all-min_fa-comment-alt-check__12oZo:before {\n  content: '\\F4A2';\n}\n.fontawesome-all-min_fa-comment-alt-dollar__1-_Ar:before {\n  content: '\\F650';\n}\n.fontawesome-all-min_fa-comment-alt-dots__1YPv7:before {\n  content: '\\F4A3';\n}\n.fontawesome-all-min_fa-comment-alt-edit__2Ev7W:before {\n  content: '\\F4A4';\n}\n.fontawesome-all-min_fa-comment-alt-exclamation__1Zjup:before {\n  content: '\\F4A5';\n}\n.fontawesome-all-min_fa-comment-alt-lines__1-eCV:before {\n  content: '\\F4A6';\n}\n.fontawesome-all-min_fa-comment-alt-medical__2Ozts:before {\n  content: '\\F7F4';\n}\n.fontawesome-all-min_fa-comment-alt-minus__3Hx-1:before {\n  content: '\\F4A7';\n}\n.fontawesome-all-min_fa-comment-alt-plus__3eeSE:before {\n  content: '\\F4A8';\n}\n.fontawesome-all-min_fa-comment-alt-slash__13EPT:before {\n  content: '\\F4A9';\n}\n.fontawesome-all-min_fa-comment-alt-smile__2W9F6:before {\n  content: '\\F4AA';\n}\n.fontawesome-all-min_fa-comment-alt-times__13Ams:before {\n  content: '\\F4AB';\n}\n.fontawesome-all-min_fa-comment-check__TlGaB:before {\n  content: '\\F4AC';\n}\n.fontawesome-all-min_fa-comment-dollar__1ROqz:before {\n  content: '\\F651';\n}\n.fontawesome-all-min_fa-comment-dots__3LOvH:before {\n  content: '\\F4AD';\n}\n.fontawesome-all-min_fa-comment-edit__1Nluq:before {\n  content: '\\F4AE';\n}\n.fontawesome-all-min_fa-comment-exclamation__3Txjl:before {\n  content: '\\F4AF';\n}\n.fontawesome-all-min_fa-comment-lines__1_GvT:before {\n  content: '\\F4B0';\n}\n.fontawesome-all-min_fa-comment-medical__1nTe3:before {\n  content: '\\F7F5';\n}\n.fontawesome-all-min_fa-comment-minus__TV5vt:before {\n  content: '\\F4B1';\n}\n.fontawesome-all-min_fa-comment-plus__3q01w:before {\n  content: '\\F4B2';\n}\n.fontawesome-all-min_fa-comment-slash__1mYt2:before {\n  content: '\\F4B3';\n}\n.fontawesome-all-min_fa-comment-smile__1ImEa:before {\n  content: '\\F4B4';\n}\n.fontawesome-all-min_fa-comment-times__3Cpbk:before {\n  content: '\\F4B5';\n}\n.fontawesome-all-min_fa-comments__2iC84:before {\n  content: '\\F086';\n}\n.fontawesome-all-min_fa-comments-alt__1pfuz:before {\n  content: '\\F4B6';\n}\n.fontawesome-all-min_fa-comments-alt-dollar__1GgWj:before {\n  content: '\\F652';\n}\n.fontawesome-all-min_fa-comments-dollar__1oUPN:before {\n  content: '\\F653';\n}\n.fontawesome-all-min_fa-compact-disc__P79QZ:before {\n  content: '\\F51F';\n}\n.fontawesome-all-min_fa-compass__17aUS:before {\n  content: '\\F14E';\n}\n.fontawesome-all-min_fa-compass-slash__16pps:before {\n  content: '\\F5E9';\n}\n.fontawesome-all-min_fa-compress__3mlWI:before {\n  content: '\\F066';\n}\n.fontawesome-all-min_fa-compress-alt__8TylJ:before {\n  content: '\\F422';\n}\n.fontawesome-all-min_fa-compress-arrows-alt__3PlQD:before {\n  content: '\\F78C';\n}\n.fontawesome-all-min_fa-compress-wide__3JKSr:before {\n  content: '\\F326';\n}\n.fontawesome-all-min_fa-concierge-bell__2qqDe:before {\n  content: '\\F562';\n}\n.fontawesome-all-min_fa-confluence__39EfD:before {\n  content: '\\F78D';\n}\n.fontawesome-all-min_fa-connectdevelop__1OcxK:before {\n  content: '\\F20E';\n}\n.fontawesome-all-min_fa-construction__UA_ex:before {\n  content: '\\F85D';\n}\n.fontawesome-all-min_fa-container-storage__2OWJ4:before {\n  content: '\\F4B7';\n}\n.fontawesome-all-min_fa-contao__i5QJY:before {\n  content: '\\F26D';\n}\n.fontawesome-all-min_fa-conveyor-belt__1TnR1:before {\n  content: '\\F46E';\n}\n.fontawesome-all-min_fa-conveyor-belt-alt__1TVhi:before {\n  content: '\\F46F';\n}\n.fontawesome-all-min_fa-cookie__2B-Af:before {\n  content: '\\F563';\n}\n.fontawesome-all-min_fa-cookie-bite__KKabJ:before {\n  content: '\\F564';\n}\n.fontawesome-all-min_fa-copy__3TNuh:before {\n  content: '\\F0C5';\n}\n.fontawesome-all-min_fa-copyright__24IQj:before {\n  content: '\\F1F9';\n}\n.fontawesome-all-min_fa-corn__1HMSR:before {\n  content: '\\F6C7';\n}\n.fontawesome-all-min_fa-cotton-bureau__2oJ8P:before {\n  content: '\\F89E';\n}\n.fontawesome-all-min_fa-couch__2EbSV:before {\n  content: '\\F4B8';\n}\n.fontawesome-all-min_fa-cow__NzVmW:before {\n  content: '\\F6C8';\n}\n.fontawesome-all-min_fa-cpanel__1QDE6:before {\n  content: '\\F388';\n}\n.fontawesome-all-min_fa-creative-commons__3p-Lr:before {\n  content: '\\F25E';\n}\n.fontawesome-all-min_fa-creative-commons-by__O6U9m:before {\n  content: '\\F4E7';\n}\n.fontawesome-all-min_fa-creative-commons-nc__1bAwx:before {\n  content: '\\F4E8';\n}\n.fontawesome-all-min_fa-creative-commons-nc-eu__1NM-g:before {\n  content: '\\F4E9';\n}\n.fontawesome-all-min_fa-creative-commons-nc-jp__3A5jd:before {\n  content: '\\F4EA';\n}\n.fontawesome-all-min_fa-creative-commons-nd__Lz2Eg:before {\n  content: '\\F4EB';\n}\n.fontawesome-all-min_fa-creative-commons-pd__2D4zb:before {\n  content: '\\F4EC';\n}\n.fontawesome-all-min_fa-creative-commons-pd-alt__3gecG:before {\n  content: '\\F4ED';\n}\n.fontawesome-all-min_fa-creative-commons-remix__3udR8:before {\n  content: '\\F4EE';\n}\n.fontawesome-all-min_fa-creative-commons-sa__8DmAD:before {\n  content: '\\F4EF';\n}\n.fontawesome-all-min_fa-creative-commons-sampling__2yqxF:before {\n  content: '\\F4F0';\n}\n.fontawesome-all-min_fa-creative-commons-sampling-plus__35chn:before {\n  content: '\\F4F1';\n}\n.fontawesome-all-min_fa-creative-commons-share__21Ihz:before {\n  content: '\\F4F2';\n}\n.fontawesome-all-min_fa-creative-commons-zero__3J_7f:before {\n  content: '\\F4F3';\n}\n.fontawesome-all-min_fa-credit-card__2qGC6:before {\n  content: '\\F09D';\n}\n.fontawesome-all-min_fa-credit-card-blank__nIykQ:before {\n  content: '\\F389';\n}\n.fontawesome-all-min_fa-credit-card-front__3286O:before {\n  content: '\\F38A';\n}\n.fontawesome-all-min_fa-cricket__9SyUn:before {\n  content: '\\F449';\n}\n.fontawesome-all-min_fa-critical-role__2ZlV6:before {\n  content: '\\F6C9';\n}\n.fontawesome-all-min_fa-croissant__1k6h0:before {\n  content: '\\F7F6';\n}\n.fontawesome-all-min_fa-crop__3D1B_:before {\n  content: '\\F125';\n}\n.fontawesome-all-min_fa-crop-alt__1wOAQ:before {\n  content: '\\F565';\n}\n.fontawesome-all-min_fa-cross__2SzGJ:before {\n  content: '\\F654';\n}\n.fontawesome-all-min_fa-crosshairs__3bJAk:before {\n  content: '\\F05B';\n}\n.fontawesome-all-min_fa-crow__1mGfX:before {\n  content: '\\F520';\n}\n.fontawesome-all-min_fa-crown__2tj0b:before {\n  content: '\\F521';\n}\n.fontawesome-all-min_fa-crutch__3s3Jz:before {\n  content: '\\F7F7';\n}\n.fontawesome-all-min_fa-crutches__1p3CR:before {\n  content: '\\F7F8';\n}\n.fontawesome-all-min_fa-css3__R9QPP:before {\n  content: '\\F13C';\n}\n.fontawesome-all-min_fa-css3-alt__1cnVq:before {\n  content: '\\F38B';\n}\n.fontawesome-all-min_fa-cube__XQMGQ:before {\n  content: '\\F1B2';\n}\n.fontawesome-all-min_fa-cubes__2KJXC:before {\n  content: '\\F1B3';\n}\n.fontawesome-all-min_fa-curling__1-5yl:before {\n  content: '\\F44A';\n}\n.fontawesome-all-min_fa-cut__1dzwA:before {\n  content: '\\F0C4';\n}\n.fontawesome-all-min_fa-cuttlefish__3FIvF:before {\n  content: '\\F38C';\n}\n.fontawesome-all-min_fa-d-and-d__luyLm:before {\n  content: '\\F38D';\n}\n.fontawesome-all-min_fa-d-and-d-beyond__2_CbS:before {\n  content: '\\F6CA';\n}\n.fontawesome-all-min_fa-dagger__27sX5:before {\n  content: '\\F6CB';\n}\n.fontawesome-all-min_fa-dashcube__3-puN:before {\n  content: '\\F210';\n}\n.fontawesome-all-min_fa-database__3Umhv:before {\n  content: '\\F1C0';\n}\n.fontawesome-all-min_fa-deaf__IOw58:before {\n  content: '\\F2A4';\n}\n.fontawesome-all-min_fa-debug__3YRsf:before {\n  content: '\\F7F9';\n}\n.fontawesome-all-min_fa-deer__1PYKU:before {\n  content: '\\F78E';\n}\n.fontawesome-all-min_fa-deer-rudolph__2acU6:before {\n  content: '\\F78F';\n}\n.fontawesome-all-min_fa-delicious__e-5If:before {\n  content: '\\F1A5';\n}\n.fontawesome-all-min_fa-democrat__1ySAm:before {\n  content: '\\F747';\n}\n.fontawesome-all-min_fa-deploydog__2NW4Q:before {\n  content: '\\F38E';\n}\n.fontawesome-all-min_fa-deskpro__3Sx43:before {\n  content: '\\F38F';\n}\n.fontawesome-all-min_fa-desktop__SbWlN:before {\n  content: '\\F108';\n}\n.fontawesome-all-min_fa-desktop-alt__3Smpe:before {\n  content: '\\F390';\n}\n.fontawesome-all-min_fa-dev__3-f2u:before {\n  content: '\\F6CC';\n}\n.fontawesome-all-min_fa-deviantart__2-dyX:before {\n  content: '\\F1BD';\n}\n.fontawesome-all-min_fa-dewpoint__1Y9cg:before {\n  content: '\\F748';\n}\n.fontawesome-all-min_fa-dharmachakra__CWglU:before {\n  content: '\\F655';\n}\n.fontawesome-all-min_fa-dhl__pmSt2:before {\n  content: '\\F790';\n}\n.fontawesome-all-min_fa-diagnoses__1XClF:before {\n  content: '\\F470';\n}\n.fontawesome-all-min_fa-diamond__1BxuB:before {\n  content: '\\F219';\n}\n.fontawesome-all-min_fa-diaspora__2VRJJ:before {\n  content: '\\F791';\n}\n.fontawesome-all-min_fa-dice__1X01d:before {\n  content: '\\F522';\n}\n.fontawesome-all-min_fa-dice-d10__3uet4:before {\n  content: '\\F6CD';\n}\n.fontawesome-all-min_fa-dice-d12__2hQsm:before {\n  content: '\\F6CE';\n}\n.fontawesome-all-min_fa-dice-d20__2j1fS:before {\n  content: '\\F6CF';\n}\n.fontawesome-all-min_fa-dice-d4__20gZ1:before {\n  content: '\\F6D0';\n}\n.fontawesome-all-min_fa-dice-d6__2RqEL:before {\n  content: '\\F6D1';\n}\n.fontawesome-all-min_fa-dice-d8__oqzQM:before {\n  content: '\\F6D2';\n}\n.fontawesome-all-min_fa-dice-five__2ZkO4:before {\n  content: '\\F523';\n}\n.fontawesome-all-min_fa-dice-four__pcaqw:before {\n  content: '\\F524';\n}\n.fontawesome-all-min_fa-dice-one__69GqS:before {\n  content: '\\F525';\n}\n.fontawesome-all-min_fa-dice-six__1KD3s:before {\n  content: '\\F526';\n}\n.fontawesome-all-min_fa-dice-three__Jn-_S:before {\n  content: '\\F527';\n}\n.fontawesome-all-min_fa-dice-two__3O6Qa:before {\n  content: '\\F528';\n}\n.fontawesome-all-min_fa-digg__1HtXr:before {\n  content: '\\F1A6';\n}\n.fontawesome-all-min_fa-digging__2I8UH:before {\n  content: '\\F85E';\n}\n.fontawesome-all-min_fa-digital-ocean__2wOs_:before {\n  content: '\\F391';\n}\n.fontawesome-all-min_fa-digital-tachograph__1lSfY:before {\n  content: '\\F566';\n}\n.fontawesome-all-min_fa-diploma__GyyLH:before {\n  content: '\\F5EA';\n}\n.fontawesome-all-min_fa-directions__jAd2E:before {\n  content: '\\F5EB';\n}\n.fontawesome-all-min_fa-discord__Yi1uA:before {\n  content: '\\F392';\n}\n.fontawesome-all-min_fa-discourse__RUj3s:before {\n  content: '\\F393';\n}\n.fontawesome-all-min_fa-disease__3Qfb0:before {\n  content: '\\F7FA';\n}\n.fontawesome-all-min_fa-divide__2Wm2C:before {\n  content: '\\F529';\n}\n.fontawesome-all-min_fa-dizzy__189eC:before {\n  content: '\\F567';\n}\n.fontawesome-all-min_fa-dna__R6Wq1:before {\n  content: '\\F471';\n}\n.fontawesome-all-min_fa-do-not-enter__m4Ujf:before {\n  content: '\\F5EC';\n}\n.fontawesome-all-min_fa-dochub__1NnRc:before {\n  content: '\\F394';\n}\n.fontawesome-all-min_fa-docker__28qzF:before {\n  content: '\\F395';\n}\n.fontawesome-all-min_fa-dog__2LZ-D:before {\n  content: '\\F6D3';\n}\n.fontawesome-all-min_fa-dog-leashed__3ralt:before {\n  content: '\\F6D4';\n}\n.fontawesome-all-min_fa-dollar-sign__32AJM:before {\n  content: '\\F155';\n}\n.fontawesome-all-min_fa-dolly__1fk4Q:before {\n  content: '\\F472';\n}\n.fontawesome-all-min_fa-dolly-empty__1BtWs:before {\n  content: '\\F473';\n}\n.fontawesome-all-min_fa-dolly-flatbed__1rIV4:before {\n  content: '\\F474';\n}\n.fontawesome-all-min_fa-dolly-flatbed-alt__1gl8k:before {\n  content: '\\F475';\n}\n.fontawesome-all-min_fa-dolly-flatbed-empty__3xkMX:before {\n  content: '\\F476';\n}\n.fontawesome-all-min_fa-donate__3obsk:before {\n  content: '\\F4B9';\n}\n.fontawesome-all-min_fa-door-closed__1P4Ei:before {\n  content: '\\F52A';\n}\n.fontawesome-all-min_fa-door-open__29agg:before {\n  content: '\\F52B';\n}\n.fontawesome-all-min_fa-dot-circle__3WgEv:before {\n  content: '\\F192';\n}\n.fontawesome-all-min_fa-dove__2L11j:before {\n  content: '\\F4BA';\n}\n.fontawesome-all-min_fa-download__1-hb7:before {\n  content: '\\F019';\n}\n.fontawesome-all-min_fa-draft2digital__1Uu-R:before {\n  content: '\\F396';\n}\n.fontawesome-all-min_fa-drafting-compass__1MbRV:before {\n  content: '\\F568';\n}\n.fontawesome-all-min_fa-dragon__VJv8a:before {\n  content: '\\F6D5';\n}\n.fontawesome-all-min_fa-draw-circle__3T4oA:before {\n  content: '\\F5ED';\n}\n.fontawesome-all-min_fa-draw-polygon__3tRTc:before {\n  content: '\\F5EE';\n}\n.fontawesome-all-min_fa-draw-square__UBkoV:before {\n  content: '\\F5EF';\n}\n.fontawesome-all-min_fa-dreidel__235yv:before {\n  content: '\\F792';\n}\n.fontawesome-all-min_fa-dribbble__29tY3:before {\n  content: '\\F17D';\n}\n.fontawesome-all-min_fa-dribbble-square__2R_39:before {\n  content: '\\F397';\n}\n.fontawesome-all-min_fa-drone__2VQ4I:before {\n  content: '\\F85F';\n}\n.fontawesome-all-min_fa-drone-alt__38sAF:before {\n  content: '\\F860';\n}\n.fontawesome-all-min_fa-dropbox__2V7wm:before {\n  content: '\\F16B';\n}\n.fontawesome-all-min_fa-drum__3JhoW:before {\n  content: '\\F569';\n}\n.fontawesome-all-min_fa-drum-steelpan__3xms2:before {\n  content: '\\F56A';\n}\n.fontawesome-all-min_fa-drumstick__2QyBA:before {\n  content: '\\F6D6';\n}\n.fontawesome-all-min_fa-drumstick-bite__1wVxr:before {\n  content: '\\F6D7';\n}\n.fontawesome-all-min_fa-drupal__3dm4F:before {\n  content: '\\F1A9';\n}\n.fontawesome-all-min_fa-dryer__3YdrF:before {\n  content: '\\F861';\n}\n.fontawesome-all-min_fa-dryer-alt__s8LaU:before {\n  content: '\\F862';\n}\n.fontawesome-all-min_fa-duck__3BfnX:before {\n  content: '\\F6D8';\n}\n.fontawesome-all-min_fa-dumbbell__1JTwS:before {\n  content: '\\F44B';\n}\n.fontawesome-all-min_fa-dumpster__83yF6:before {\n  content: '\\F793';\n}\n.fontawesome-all-min_fa-dumpster-fire__3QDOW:before {\n  content: '\\F794';\n}\n.fontawesome-all-min_fa-dungeon__wZ5fu:before {\n  content: '\\F6D9';\n}\n.fontawesome-all-min_fa-dyalog__c-L18:before {\n  content: '\\F399';\n}\n.fontawesome-all-min_fa-ear__1H-0K:before {\n  content: '\\F5F0';\n}\n.fontawesome-all-min_fa-ear-muffs__2ibtA:before {\n  content: '\\F795';\n}\n.fontawesome-all-min_fa-earlybirds__33aFc:before {\n  content: '\\F39A';\n}\n.fontawesome-all-min_fa-ebay__3k6PK:before {\n  content: '\\F4F4';\n}\n.fontawesome-all-min_fa-eclipse__svxW0:before {\n  content: '\\F749';\n}\n.fontawesome-all-min_fa-eclipse-alt__3QyXt:before {\n  content: '\\F74A';\n}\n.fontawesome-all-min_fa-edge__2jCTv:before {\n  content: '\\F282';\n}\n.fontawesome-all-min_fa-edit__3XB_e:before {\n  content: '\\F044';\n}\n.fontawesome-all-min_fa-egg__1NzzN:before {\n  content: '\\F7FB';\n}\n.fontawesome-all-min_fa-egg-fried__3GjlG:before {\n  content: '\\F7FC';\n}\n.fontawesome-all-min_fa-eject__3e9__:before {\n  content: '\\F052';\n}\n.fontawesome-all-min_fa-elementor__2sM2Q:before {\n  content: '\\F430';\n}\n.fontawesome-all-min_fa-elephant__29av_:before {\n  content: '\\F6DA';\n}\n.fontawesome-all-min_fa-ellipsis-h__11NTJ:before {\n  content: '\\F141';\n}\n.fontawesome-all-min_fa-ellipsis-h-alt__3hfhS:before {\n  content: '\\F39B';\n}\n.fontawesome-all-min_fa-ellipsis-v__1BIgn:before {\n  content: '\\F142';\n}\n.fontawesome-all-min_fa-ellipsis-v-alt__1nts8:before {\n  content: '\\F39C';\n}\n.fontawesome-all-min_fa-ello__3NqdX:before {\n  content: '\\F5F1';\n}\n.fontawesome-all-min_fa-ember__38-FG:before {\n  content: '\\F423';\n}\n.fontawesome-all-min_fa-empire__ewxCP:before {\n  content: '\\F1D1';\n}\n.fontawesome-all-min_fa-empty-set__1BHAc:before {\n  content: '\\F656';\n}\n.fontawesome-all-min_fa-engine-warning__XBl4S:before {\n  content: '\\F5F2';\n}\n.fontawesome-all-min_fa-envelope__3v5Xa:before {\n  content: '\\F0E0';\n}\n.fontawesome-all-min_fa-envelope-open__1_ohI:before {\n  content: '\\F2B6';\n}\n.fontawesome-all-min_fa-envelope-open-dollar__4-Txj:before {\n  content: '\\F657';\n}\n.fontawesome-all-min_fa-envelope-open-text__1KBbH:before {\n  content: '\\F658';\n}\n.fontawesome-all-min_fa-envelope-square__3GvQg:before {\n  content: '\\F199';\n}\n.fontawesome-all-min_fa-envira__1ZlyO:before {\n  content: '\\F299';\n}\n.fontawesome-all-min_fa-equals__BwBb-:before {\n  content: '\\F52C';\n}\n.fontawesome-all-min_fa-eraser__uy_hQ:before {\n  content: '\\F12D';\n}\n.fontawesome-all-min_fa-erlang__3qiOZ:before {\n  content: '\\F39D';\n}\n.fontawesome-all-min_fa-ethereum__3N9KF:before {\n  content: '\\F42E';\n}\n.fontawesome-all-min_fa-ethernet__11Q7t:before {\n  content: '\\F796';\n}\n.fontawesome-all-min_fa-etsy__plFVS:before {\n  content: '\\F2D7';\n}\n.fontawesome-all-min_fa-euro-sign__1TYU-:before {\n  content: '\\F153';\n}\n.fontawesome-all-min_fa-evernote__11qc0:before {\n  content: '\\F839';\n}\n.fontawesome-all-min_fa-exchange__WHEym:before {\n  content: '\\F0EC';\n}\n.fontawesome-all-min_fa-exchange-alt__38Rq2:before {\n  content: '\\F362';\n}\n.fontawesome-all-min_fa-exclamation__311pb:before {\n  content: '\\F12A';\n}\n.fontawesome-all-min_fa-exclamation-circle__3Wpl0:before {\n  content: '\\F06A';\n}\n.fontawesome-all-min_fa-exclamation-square__2Z_rC:before {\n  content: '\\F321';\n}\n.fontawesome-all-min_fa-exclamation-triangle__3VmXJ:before {\n  content: '\\F071';\n}\n.fontawesome-all-min_fa-expand__3k2pU:before {\n  content: '\\F065';\n}\n.fontawesome-all-min_fa-expand-alt__2EDTT:before {\n  content: '\\F424';\n}\n.fontawesome-all-min_fa-expand-arrows__2JGkT:before {\n  content: '\\F31D';\n}\n.fontawesome-all-min_fa-expand-arrows-alt__3-L4H:before {\n  content: '\\F31E';\n}\n.fontawesome-all-min_fa-expand-wide__e25dW:before {\n  content: '\\F320';\n}\n.fontawesome-all-min_fa-expeditedssl__2kakg:before {\n  content: '\\F23E';\n}\n.fontawesome-all-min_fa-external-link__IffFC:before {\n  content: '\\F08E';\n}\n.fontawesome-all-min_fa-external-link-alt__ORAtl:before {\n  content: '\\F35D';\n}\n.fontawesome-all-min_fa-external-link-square__2sINh:before {\n  content: '\\F14C';\n}\n.fontawesome-all-min_fa-external-link-square-alt__2Ic1m:before {\n  content: '\\F360';\n}\n.fontawesome-all-min_fa-eye__2TogO:before {\n  content: '\\F06E';\n}\n.fontawesome-all-min_fa-eye-dropper__3zWNe:before {\n  content: '\\F1FB';\n}\n.fontawesome-all-min_fa-eye-evil__3Eflh:before {\n  content: '\\F6DB';\n}\n.fontawesome-all-min_fa-eye-slash__qwb0Q:before {\n  content: '\\F070';\n}\n.fontawesome-all-min_fa-facebook__18aWp:before {\n  content: '\\F09A';\n}\n.fontawesome-all-min_fa-facebook-f__JUheB:before {\n  content: '\\F39E';\n}\n.fontawesome-all-min_fa-facebook-messenger__b3uFb:before {\n  content: '\\F39F';\n}\n.fontawesome-all-min_fa-facebook-square__1rd_c:before {\n  content: '\\F082';\n}\n.fontawesome-all-min_fa-fan__2eXyx:before {\n  content: '\\F863';\n}\n.fontawesome-all-min_fa-fantasy-flight-games__1y_kb:before {\n  content: '\\F6DC';\n}\n.fontawesome-all-min_fa-farm__3_z5B:before {\n  content: '\\F864';\n}\n.fontawesome-all-min_fa-fast-backward__3XM3Z:before {\n  content: '\\F049';\n}\n.fontawesome-all-min_fa-fast-forward__2WBU5:before {\n  content: '\\F050';\n}\n.fontawesome-all-min_fa-fax__1gRwm:before {\n  content: '\\F1AC';\n}\n.fontawesome-all-min_fa-feather__MZWb6:before {\n  content: '\\F52D';\n}\n.fontawesome-all-min_fa-feather-alt__8dqJt:before {\n  content: '\\F56B';\n}\n.fontawesome-all-min_fa-fedex__17y5-:before {\n  content: '\\F797';\n}\n.fontawesome-all-min_fa-fedora__w00cq:before {\n  content: '\\F798';\n}\n.fontawesome-all-min_fa-female__1SGKO:before {\n  content: '\\F182';\n}\n.fontawesome-all-min_fa-field-hockey__KTEqi:before {\n  content: '\\F44C';\n}\n.fontawesome-all-min_fa-fighter-jet__29foC:before {\n  content: '\\F0FB';\n}\n.fontawesome-all-min_fa-figma__aNXe_:before {\n  content: '\\F799';\n}\n.fontawesome-all-min_fa-file__2qHZZ:before {\n  content: '\\F15B';\n}\n.fontawesome-all-min_fa-file-alt__MbqRF:before {\n  content: '\\F15C';\n}\n.fontawesome-all-min_fa-file-archive__3YhnR:before {\n  content: '\\F1C6';\n}\n.fontawesome-all-min_fa-file-audio__1hLm0:before {\n  content: '\\F1C7';\n}\n.fontawesome-all-min_fa-file-certificate__24EbA:before {\n  content: '\\F5F3';\n}\n.fontawesome-all-min_fa-file-chart-line__2fFni:before {\n  content: '\\F659';\n}\n.fontawesome-all-min_fa-file-chart-pie__e2TUt:before {\n  content: '\\F65A';\n}\n.fontawesome-all-min_fa-file-check__2KaGB:before {\n  content: '\\F316';\n}\n.fontawesome-all-min_fa-file-code__36nbs:before {\n  content: '\\F1C9';\n}\n.fontawesome-all-min_fa-file-contract__2mKfc:before {\n  content: '\\F56C';\n}\n.fontawesome-all-min_fa-file-csv__LMAfN:before {\n  content: '\\F6DD';\n}\n.fontawesome-all-min_fa-file-download__1GvmB:before {\n  content: '\\F56D';\n}\n.fontawesome-all-min_fa-file-edit__1ch2j:before {\n  content: '\\F31C';\n}\n.fontawesome-all-min_fa-file-excel__dH6QE:before {\n  content: '\\F1C3';\n}\n.fontawesome-all-min_fa-file-exclamation__3QjL9:before {\n  content: '\\F31A';\n}\n.fontawesome-all-min_fa-file-export__3Zhfo:before {\n  content: '\\F56E';\n}\n.fontawesome-all-min_fa-file-image__1b1r2:before {\n  content: '\\F1C5';\n}\n.fontawesome-all-min_fa-file-import__5wDcJ:before {\n  content: '\\F56F';\n}\n.fontawesome-all-min_fa-file-invoice__3BO_F:before {\n  content: '\\F570';\n}\n.fontawesome-all-min_fa-file-invoice-dollar__1j-el:before {\n  content: '\\F571';\n}\n.fontawesome-all-min_fa-file-medical__1__Dd:before {\n  content: '\\F477';\n}\n.fontawesome-all-min_fa-file-medical-alt__3ERJe:before {\n  content: '\\F478';\n}\n.fontawesome-all-min_fa-file-minus__n5Sb2:before {\n  content: '\\F318';\n}\n.fontawesome-all-min_fa-file-pdf__3qgPP:before {\n  content: '\\F1C1';\n}\n.fontawesome-all-min_fa-file-plus__3WJFj:before {\n  content: '\\F319';\n}\n.fontawesome-all-min_fa-file-powerpoint__4NnVa:before {\n  content: '\\F1C4';\n}\n.fontawesome-all-min_fa-file-prescription__1bnS_:before {\n  content: '\\F572';\n}\n.fontawesome-all-min_fa-file-search__2wqQC:before {\n  content: '\\F865';\n}\n.fontawesome-all-min_fa-file-signature__veQER:before {\n  content: '\\F573';\n}\n.fontawesome-all-min_fa-file-spreadsheet__3DwL7:before {\n  content: '\\F65B';\n}\n.fontawesome-all-min_fa-file-times__2I2xh:before {\n  content: '\\F317';\n}\n.fontawesome-all-min_fa-file-upload__1nqNG:before {\n  content: '\\F574';\n}\n.fontawesome-all-min_fa-file-user__3iDYa:before {\n  content: '\\F65C';\n}\n.fontawesome-all-min_fa-file-video__2LLWe:before {\n  content: '\\F1C8';\n}\n.fontawesome-all-min_fa-file-word__3dlFK:before {\n  content: '\\F1C2';\n}\n.fontawesome-all-min_fa-files-medical__2NRar:before {\n  content: '\\F7FD';\n}\n.fontawesome-all-min_fa-fill__2wK8r:before {\n  content: '\\F575';\n}\n.fontawesome-all-min_fa-fill-drip__YwrgZ:before {\n  content: '\\F576';\n}\n.fontawesome-all-min_fa-film__1-TWv:before {\n  content: '\\F008';\n}\n.fontawesome-all-min_fa-film-alt__Uwb9c:before {\n  content: '\\F3A0';\n}\n.fontawesome-all-min_fa-filter__YY3DW:before {\n  content: '\\F0B0';\n}\n.fontawesome-all-min_fa-fingerprint__1dWIj:before {\n  content: '\\F577';\n}\n.fontawesome-all-min_fa-fire__2RD4e:before {\n  content: '\\F06D';\n}\n.fontawesome-all-min_fa-fire-alt__1k921:before {\n  content: '\\F7E4';\n}\n.fontawesome-all-min_fa-fire-extinguisher__GYL6k:before {\n  content: '\\F134';\n}\n.fontawesome-all-min_fa-fire-smoke__3hUHp:before {\n  content: '\\F74B';\n}\n.fontawesome-all-min_fa-firefox__1gH1n:before {\n  content: '\\F269';\n}\n.fontawesome-all-min_fa-fireplace__YR9jZ:before {\n  content: '\\F79A';\n}\n.fontawesome-all-min_fa-first-aid__2JLYv:before {\n  content: '\\F479';\n}\n.fontawesome-all-min_fa-first-order__3y2mo:before {\n  content: '\\F2B0';\n}\n.fontawesome-all-min_fa-first-order-alt__3dnJt:before {\n  content: '\\F50A';\n}\n.fontawesome-all-min_fa-firstdraft__2HGWt:before {\n  content: '\\F3A1';\n}\n.fontawesome-all-min_fa-fish__2-JS3:before {\n  content: '\\F578';\n}\n.fontawesome-all-min_fa-fish-cooked__3elt2:before {\n  content: '\\F7FE';\n}\n.fontawesome-all-min_fa-fist-raised__1M1-y:before {\n  content: '\\F6DE';\n}\n.fontawesome-all-min_fa-flag__39JS8:before {\n  content: '\\F024';\n}\n.fontawesome-all-min_fa-flag-alt__CeslX:before {\n  content: '\\F74C';\n}\n.fontawesome-all-min_fa-flag-checkered__1xreO:before {\n  content: '\\F11E';\n}\n.fontawesome-all-min_fa-flag-usa__1697B:before {\n  content: '\\F74D';\n}\n.fontawesome-all-min_fa-flame__1CY4v:before {\n  content: '\\F6DF';\n}\n.fontawesome-all-min_fa-flask___DANW:before {\n  content: '\\F0C3';\n}\n.fontawesome-all-min_fa-flask-poison__1wVms:before {\n  content: '\\F6E0';\n}\n.fontawesome-all-min_fa-flask-potion__TTbSe:before {\n  content: '\\F6E1';\n}\n.fontawesome-all-min_fa-flickr__3hR_C:before {\n  content: '\\F16E';\n}\n.fontawesome-all-min_fa-flipboard__2iyD1:before {\n  content: '\\F44D';\n}\n.fontawesome-all-min_fa-flower__2QJ7H:before {\n  content: '\\F7FF';\n}\n.fontawesome-all-min_fa-flower-daffodil__1wOfJ:before {\n  content: '\\F800';\n}\n.fontawesome-all-min_fa-flower-tulip__3nITk:before {\n  content: '\\F801';\n}\n.fontawesome-all-min_fa-flushed__1cpBb:before {\n  content: '\\F579';\n}\n.fontawesome-all-min_fa-fly__2TH-z:before {\n  content: '\\F417';\n}\n.fontawesome-all-min_fa-fog__2ZAUC:before {\n  content: '\\F74E';\n}\n.fontawesome-all-min_fa-folder__iKK1s:before {\n  content: '\\F07B';\n}\n.fontawesome-all-min_fa-folder-minus__37CQS:before {\n  content: '\\F65D';\n}\n.fontawesome-all-min_fa-folder-open__24Z1M:before {\n  content: '\\F07C';\n}\n.fontawesome-all-min_fa-folder-plus__1PWvb:before {\n  content: '\\F65E';\n}\n.fontawesome-all-min_fa-folder-times__2k_yr:before {\n  content: '\\F65F';\n}\n.fontawesome-all-min_fa-folder-tree__2DM0j:before {\n  content: '\\F802';\n}\n.fontawesome-all-min_fa-folders__J3Mvy:before {\n  content: '\\F660';\n}\n.fontawesome-all-min_fa-font__25-wG:before {\n  content: '\\F031';\n}\n.fontawesome-all-min_fa-font-awesome__yXI4S:before {\n  content: '\\F2B4';\n}\n.fontawesome-all-min_fa-font-awesome-alt__2p2B5:before {\n  content: '\\F35C';\n}\n.fontawesome-all-min_fa-font-awesome-flag__3maFx:before {\n  content: '\\F425';\n}\n.fontawesome-all-min_fa-font-awesome-logo-full__55_Qj:before {\n  content: '\\F4E6';\n}\n.fontawesome-all-min_fa-font-case__zSyRM:before {\n  content: '\\F866';\n}\n.fontawesome-all-min_fa-fonticons__1Gaqf:before {\n  content: '\\F280';\n}\n.fontawesome-all-min_fa-fonticons-fi__3-ZwM:before {\n  content: '\\F3A2';\n}\n.fontawesome-all-min_fa-football-ball__3DGrr:before {\n  content: '\\F44E';\n}\n.fontawesome-all-min_fa-football-helmet__3-EbJ:before {\n  content: '\\F44F';\n}\n.fontawesome-all-min_fa-forklift__Cz6FP:before {\n  content: '\\F47A';\n}\n.fontawesome-all-min_fa-fort-awesome__Y7OZu:before {\n  content: '\\F286';\n}\n.fontawesome-all-min_fa-fort-awesome-alt__gqXTD:before {\n  content: '\\F3A3';\n}\n.fontawesome-all-min_fa-forumbee__2Xdly:before {\n  content: '\\F211';\n}\n.fontawesome-all-min_fa-forward__3Y3_X:before {\n  content: '\\F04E';\n}\n.fontawesome-all-min_fa-foursquare__2NF9l:before {\n  content: '\\F180';\n}\n.fontawesome-all-min_fa-fragile__2S0_f:before {\n  content: '\\F4BB';\n}\n.fontawesome-all-min_fa-free-code-camp__3BvgL:before {\n  content: '\\F2C5';\n}\n.fontawesome-all-min_fa-freebsd__2NwDF:before {\n  content: '\\F3A4';\n}\n.fontawesome-all-min_fa-french-fries__1gmhD:before {\n  content: '\\F803';\n}\n.fontawesome-all-min_fa-frog__12OGC:before {\n  content: '\\F52E';\n}\n.fontawesome-all-min_fa-frosty-head__1eB8y:before {\n  content: '\\F79B';\n}\n.fontawesome-all-min_fa-frown__3uaO4:before {\n  content: '\\F119';\n}\n.fontawesome-all-min_fa-frown-open__sCois:before {\n  content: '\\F57A';\n}\n.fontawesome-all-min_fa-fulcrum__1cSnc:before {\n  content: '\\F50B';\n}\n.fontawesome-all-min_fa-function__3SYHu:before {\n  content: '\\F661';\n}\n.fontawesome-all-min_fa-funnel-dollar__3q4cr:before {\n  content: '\\F662';\n}\n.fontawesome-all-min_fa-futbol__81vlX:before {\n  content: '\\F1E3';\n}\n.fontawesome-all-min_fa-galactic-republic__2WX6K:before {\n  content: '\\F50C';\n}\n.fontawesome-all-min_fa-galactic-senate__2sI7U:before {\n  content: '\\F50D';\n}\n.fontawesome-all-min_fa-game-board__3q5Im:before {\n  content: '\\F867';\n}\n.fontawesome-all-min_fa-game-board-alt__3RPe6:before {\n  content: '\\F868';\n}\n.fontawesome-all-min_fa-gamepad__CCsjJ:before {\n  content: '\\F11B';\n}\n.fontawesome-all-min_fa-gas-pump__1BfqV:before {\n  content: '\\F52F';\n}\n.fontawesome-all-min_fa-gas-pump-slash__3P4Me:before {\n  content: '\\F5F4';\n}\n.fontawesome-all-min_fa-gavel__2mU_R:before {\n  content: '\\F0E3';\n}\n.fontawesome-all-min_fa-gem__1ozo4:before {\n  content: '\\F3A5';\n}\n.fontawesome-all-min_fa-genderless__1x6B4:before {\n  content: '\\F22D';\n}\n.fontawesome-all-min_fa-get-pocket__yxtza:before {\n  content: '\\F265';\n}\n.fontawesome-all-min_fa-gg__2gHlo:before {\n  content: '\\F260';\n}\n.fontawesome-all-min_fa-gg-circle__2wzM1:before {\n  content: '\\F261';\n}\n.fontawesome-all-min_fa-ghost__3fcms:before {\n  content: '\\F6E2';\n}\n.fontawesome-all-min_fa-gift__3Kr1k:before {\n  content: '\\F06B';\n}\n.fontawesome-all-min_fa-gift-card__Cuzov:before {\n  content: '\\F663';\n}\n.fontawesome-all-min_fa-gifts__1EjfV:before {\n  content: '\\F79C';\n}\n.fontawesome-all-min_fa-gingerbread-man__9fpUB:before {\n  content: '\\F79D';\n}\n.fontawesome-all-min_fa-git__ky64h:before {\n  content: '\\F1D3';\n}\n.fontawesome-all-min_fa-git-alt__1tZGK:before {\n  content: '\\F841';\n}\n.fontawesome-all-min_fa-git-square__35WUr:before {\n  content: '\\F1D2';\n}\n.fontawesome-all-min_fa-github__2X5IS:before {\n  content: '\\F09B';\n}\n.fontawesome-all-min_fa-github-alt__2KsCW:before {\n  content: '\\F113';\n}\n.fontawesome-all-min_fa-github-square__12_TE:before {\n  content: '\\F092';\n}\n.fontawesome-all-min_fa-gitkraken__3XS6z:before {\n  content: '\\F3A6';\n}\n.fontawesome-all-min_fa-gitlab__LRoJO:before {\n  content: '\\F296';\n}\n.fontawesome-all-min_fa-gitter__34AUl:before {\n  content: '\\F426';\n}\n.fontawesome-all-min_fa-glass__3Qtzu:before {\n  content: '\\F804';\n}\n.fontawesome-all-min_fa-glass-champagne__1WExe:before {\n  content: '\\F79E';\n}\n.fontawesome-all-min_fa-glass-cheers__1fPAw:before {\n  content: '\\F79F';\n}\n.fontawesome-all-min_fa-glass-citrus__3k_VL:before {\n  content: '\\F869';\n}\n.fontawesome-all-min_fa-glass-martini__u72ET:before {\n  content: '\\F000';\n}\n.fontawesome-all-min_fa-glass-martini-alt__182_t:before {\n  content: '\\F57B';\n}\n.fontawesome-all-min_fa-glass-whiskey__2xunl:before {\n  content: '\\F7A0';\n}\n.fontawesome-all-min_fa-glass-whiskey-rocks__1rgyC:before {\n  content: '\\F7A1';\n}\n.fontawesome-all-min_fa-glasses__2YPwK:before {\n  content: '\\F530';\n}\n.fontawesome-all-min_fa-glasses-alt__3nIhv:before {\n  content: '\\F5F5';\n}\n.fontawesome-all-min_fa-glide__lvmlt:before {\n  content: '\\F2A5';\n}\n.fontawesome-all-min_fa-glide-g__1BWJy:before {\n  content: '\\F2A6';\n}\n.fontawesome-all-min_fa-globe__2ZMmh:before {\n  content: '\\F0AC';\n}\n.fontawesome-all-min_fa-globe-africa__3M9A3:before {\n  content: '\\F57C';\n}\n.fontawesome-all-min_fa-globe-americas__7BTyB:before {\n  content: '\\F57D';\n}\n.fontawesome-all-min_fa-globe-asia__3gROa:before {\n  content: '\\F57E';\n}\n.fontawesome-all-min_fa-globe-europe__kRlQt:before {\n  content: '\\F7A2';\n}\n.fontawesome-all-min_fa-globe-snow__h36TL:before {\n  content: '\\F7A3';\n}\n.fontawesome-all-min_fa-globe-stand__2Vgrq:before {\n  content: '\\F5F6';\n}\n.fontawesome-all-min_fa-gofore__3mVm1:before {\n  content: '\\F3A7';\n}\n.fontawesome-all-min_fa-golf-ball__235QF:before {\n  content: '\\F450';\n}\n.fontawesome-all-min_fa-golf-club__3p-Dw:before {\n  content: '\\F451';\n}\n.fontawesome-all-min_fa-goodreads__2wqEL:before {\n  content: '\\F3A8';\n}\n.fontawesome-all-min_fa-goodreads-g__Gkb1S:before {\n  content: '\\F3A9';\n}\n.fontawesome-all-min_fa-google__2-G4A:before {\n  content: '\\F1A0';\n}\n.fontawesome-all-min_fa-google-drive__3OAty:before {\n  content: '\\F3AA';\n}\n.fontawesome-all-min_fa-google-play__1RbrP:before {\n  content: '\\F3AB';\n}\n.fontawesome-all-min_fa-google-plus__1WjRy:before {\n  content: '\\F2B3';\n}\n.fontawesome-all-min_fa-google-plus-g__186nT:before {\n  content: '\\F0D5';\n}\n.fontawesome-all-min_fa-google-plus-square__2DPiM:before {\n  content: '\\F0D4';\n}\n.fontawesome-all-min_fa-google-wallet__2s3SE:before {\n  content: '\\F1EE';\n}\n.fontawesome-all-min_fa-gopuram__3yOO3:before {\n  content: '\\F664';\n}\n.fontawesome-all-min_fa-graduation-cap__2mq9v:before {\n  content: '\\F19D';\n}\n.fontawesome-all-min_fa-gratipay__3aqX1:before {\n  content: '\\F184';\n}\n.fontawesome-all-min_fa-grav__1mQQs:before {\n  content: '\\F2D6';\n}\n.fontawesome-all-min_fa-greater-than__k7mpH:before {\n  content: '\\F531';\n}\n.fontawesome-all-min_fa-greater-than-equal__3Sbi8:before {\n  content: '\\F532';\n}\n.fontawesome-all-min_fa-grimace__3JegM:before {\n  content: '\\F57F';\n}\n.fontawesome-all-min_fa-grin__35TtP:before {\n  content: '\\F580';\n}\n.fontawesome-all-min_fa-grin-alt__2ZRqp:before {\n  content: '\\F581';\n}\n.fontawesome-all-min_fa-grin-beam__dWHG7:before {\n  content: '\\F582';\n}\n.fontawesome-all-min_fa-grin-beam-sweat__3kk5o:before {\n  content: '\\F583';\n}\n.fontawesome-all-min_fa-grin-hearts__1HuAz:before {\n  content: '\\F584';\n}\n.fontawesome-all-min_fa-grin-squint__27kKF:before {\n  content: '\\F585';\n}\n.fontawesome-all-min_fa-grin-squint-tears__1BNND:before {\n  content: '\\F586';\n}\n.fontawesome-all-min_fa-grin-stars__1bgo2:before {\n  content: '\\F587';\n}\n.fontawesome-all-min_fa-grin-tears__QMuAc:before {\n  content: '\\F588';\n}\n.fontawesome-all-min_fa-grin-tongue__J3nhT:before {\n  content: '\\F589';\n}\n.fontawesome-all-min_fa-grin-tongue-squint__3KDAp:before {\n  content: '\\F58A';\n}\n.fontawesome-all-min_fa-grin-tongue-wink__31AAO:before {\n  content: '\\F58B';\n}\n.fontawesome-all-min_fa-grin-wink__3TV9B:before {\n  content: '\\F58C';\n}\n.fontawesome-all-min_fa-grip-horizontal__2aruh:before {\n  content: '\\F58D';\n}\n.fontawesome-all-min_fa-grip-lines__1UyUt:before {\n  content: '\\F7A4';\n}\n.fontawesome-all-min_fa-grip-lines-vertical__7FgcA:before {\n  content: '\\F7A5';\n}\n.fontawesome-all-min_fa-grip-vertical__3uVay:before {\n  content: '\\F58E';\n}\n.fontawesome-all-min_fa-gripfire__12_4M:before {\n  content: '\\F3AC';\n}\n.fontawesome-all-min_fa-grunt__2hZ7r:before {\n  content: '\\F3AD';\n}\n.fontawesome-all-min_fa-guitar__1nKNp:before {\n  content: '\\F7A6';\n}\n.fontawesome-all-min_fa-gulp__3UW7A:before {\n  content: '\\F3AE';\n}\n.fontawesome-all-min_fa-h-square__LGizd:before {\n  content: '\\F0FD';\n}\n.fontawesome-all-min_fa-h1__2ic8D:before {\n  content: '\\F313';\n}\n.fontawesome-all-min_fa-h2__luUYf:before {\n  content: '\\F314';\n}\n.fontawesome-all-min_fa-h3__22Py-:before {\n  content: '\\F315';\n}\n.fontawesome-all-min_fa-h4__XO19z:before {\n  content: '\\F86A';\n}\n.fontawesome-all-min_fa-hacker-news__2-jOk:before {\n  content: '\\F1D4';\n}\n.fontawesome-all-min_fa-hacker-news-square__1TMvY:before {\n  content: '\\F3AF';\n}\n.fontawesome-all-min_fa-hackerrank__1jmZh:before {\n  content: '\\F5F7';\n}\n.fontawesome-all-min_fa-hamburger__1Aw5V:before {\n  content: '\\F805';\n}\n.fontawesome-all-min_fa-hammer__qTRcQ:before {\n  content: '\\F6E3';\n}\n.fontawesome-all-min_fa-hammer-war__1II4C:before {\n  content: '\\F6E4';\n}\n.fontawesome-all-min_fa-hamsa__2vKz-:before {\n  content: '\\F665';\n}\n.fontawesome-all-min_fa-hand-heart__2oMt7:before {\n  content: '\\F4BC';\n}\n.fontawesome-all-min_fa-hand-holding__8e3KN:before {\n  content: '\\F4BD';\n}\n.fontawesome-all-min_fa-hand-holding-box__2DqwI:before {\n  content: '\\F47B';\n}\n.fontawesome-all-min_fa-hand-holding-heart__2F-pT:before {\n  content: '\\F4BE';\n}\n.fontawesome-all-min_fa-hand-holding-magic__PZjOb:before {\n  content: '\\F6E5';\n}\n.fontawesome-all-min_fa-hand-holding-seedling__WOrKo:before {\n  content: '\\F4BF';\n}\n.fontawesome-all-min_fa-hand-holding-usd__2f5ep:before {\n  content: '\\F4C0';\n}\n.fontawesome-all-min_fa-hand-holding-water__206Jq:before {\n  content: '\\F4C1';\n}\n.fontawesome-all-min_fa-hand-lizard__3kXKR:before {\n  content: '\\F258';\n}\n.fontawesome-all-min_fa-hand-middle-finger__11o9v:before {\n  content: '\\F806';\n}\n.fontawesome-all-min_fa-hand-paper__2dC15:before {\n  content: '\\F256';\n}\n.fontawesome-all-min_fa-hand-peace__z_MJQ:before {\n  content: '\\F25B';\n}\n.fontawesome-all-min_fa-hand-point-down__1Riow:before {\n  content: '\\F0A7';\n}\n.fontawesome-all-min_fa-hand-point-left__1N0k5:before {\n  content: '\\F0A5';\n}\n.fontawesome-all-min_fa-hand-point-right__1opZE:before {\n  content: '\\F0A4';\n}\n.fontawesome-all-min_fa-hand-point-up__JdCpK:before {\n  content: '\\F0A6';\n}\n.fontawesome-all-min_fa-hand-pointer__2yHIv:before {\n  content: '\\F25A';\n}\n.fontawesome-all-min_fa-hand-receiving__3vrRc:before {\n  content: '\\F47C';\n}\n.fontawesome-all-min_fa-hand-rock__QoRjU:before {\n  content: '\\F255';\n}\n.fontawesome-all-min_fa-hand-scissors__1S4W0:before {\n  content: '\\F257';\n}\n.fontawesome-all-min_fa-hand-spock__2Gc01:before {\n  content: '\\F259';\n}\n.fontawesome-all-min_fa-hands__10JEJ:before {\n  content: '\\F4C2';\n}\n.fontawesome-all-min_fa-hands-heart__1-Rlv:before {\n  content: '\\F4C3';\n}\n.fontawesome-all-min_fa-hands-helping__16Qau:before {\n  content: '\\F4C4';\n}\n.fontawesome-all-min_fa-hands-usd__u-gfY:before {\n  content: '\\F4C5';\n}\n.fontawesome-all-min_fa-handshake__WOrbZ:before {\n  content: '\\F2B5';\n}\n.fontawesome-all-min_fa-handshake-alt__2Be8L:before {\n  content: '\\F4C6';\n}\n.fontawesome-all-min_fa-hanukiah__sOdLV:before {\n  content: '\\F6E6';\n}\n.fontawesome-all-min_fa-hard-hat__C9j4G:before {\n  content: '\\F807';\n}\n.fontawesome-all-min_fa-hashtag__1wLSD:before {\n  content: '\\F292';\n}\n.fontawesome-all-min_fa-hat-chef__2QHFL:before {\n  content: '\\F86B';\n}\n.fontawesome-all-min_fa-hat-santa__3G-R1:before {\n  content: '\\F7A7';\n}\n.fontawesome-all-min_fa-hat-winter__2XWjl:before {\n  content: '\\F7A8';\n}\n.fontawesome-all-min_fa-hat-witch__3UCcu:before {\n  content: '\\F6E7';\n}\n.fontawesome-all-min_fa-hat-wizard__vWbw7:before {\n  content: '\\F6E8';\n}\n.fontawesome-all-min_fa-haykal__3zm-q:before {\n  content: '\\F666';\n}\n.fontawesome-all-min_fa-hdd__2TYh8:before {\n  content: '\\F0A0';\n}\n.fontawesome-all-min_fa-head-side__GNMce:before {\n  content: '\\F6E9';\n}\n.fontawesome-all-min_fa-head-side-brain__2tK4Q:before {\n  content: '\\F808';\n}\n.fontawesome-all-min_fa-head-side-medical__ond5z:before {\n  content: '\\F809';\n}\n.fontawesome-all-min_fa-head-vr__3wQt8:before {\n  content: '\\F6EA';\n}\n.fontawesome-all-min_fa-heading__2UR5z:before {\n  content: '\\F1DC';\n}\n.fontawesome-all-min_fa-headphones__3jE0c:before {\n  content: '\\F025';\n}\n.fontawesome-all-min_fa-headphones-alt__2hxrS:before {\n  content: '\\F58F';\n}\n.fontawesome-all-min_fa-headset__32xDE:before {\n  content: '\\F590';\n}\n.fontawesome-all-min_fa-heart__2zqmE:before {\n  content: '\\F004';\n}\n.fontawesome-all-min_fa-heart-broken__22rBs:before {\n  content: '\\F7A9';\n}\n.fontawesome-all-min_fa-heart-circle__1OUUl:before {\n  content: '\\F4C7';\n}\n.fontawesome-all-min_fa-heart-rate__3szRq:before {\n  content: '\\F5F8';\n}\n.fontawesome-all-min_fa-heart-square__3rp41:before {\n  content: '\\F4C8';\n}\n.fontawesome-all-min_fa-heartbeat__3oOXK:before {\n  content: '\\F21E';\n}\n.fontawesome-all-min_fa-helicopter__3oHOC:before {\n  content: '\\F533';\n}\n.fontawesome-all-min_fa-helmet-battle__2RYrT:before {\n  content: '\\F6EB';\n}\n.fontawesome-all-min_fa-hexagon__27uRP:before {\n  content: '\\F312';\n}\n.fontawesome-all-min_fa-highlighter__3mPjQ:before {\n  content: '\\F591';\n}\n.fontawesome-all-min_fa-hiking__2stNL:before {\n  content: '\\F6EC';\n}\n.fontawesome-all-min_fa-hippo__KqefN:before {\n  content: '\\F6ED';\n}\n.fontawesome-all-min_fa-hips__2p3Go:before {\n  content: '\\F452';\n}\n.fontawesome-all-min_fa-hire-a-helper__mu9VG:before {\n  content: '\\F3B0';\n}\n.fontawesome-all-min_fa-history__7rwK2:before {\n  content: '\\F1DA';\n}\n.fontawesome-all-min_fa-hockey-mask__zYzOn:before {\n  content: '\\F6EE';\n}\n.fontawesome-all-min_fa-hockey-puck__18qqa:before {\n  content: '\\F453';\n}\n.fontawesome-all-min_fa-hockey-sticks__12oq5:before {\n  content: '\\F454';\n}\n.fontawesome-all-min_fa-holly-berry__1VPWr:before {\n  content: '\\F7AA';\n}\n.fontawesome-all-min_fa-home__LEmvv:before {\n  content: '\\F015';\n}\n.fontawesome-all-min_fa-home-alt__3r4de:before {\n  content: '\\F80A';\n}\n.fontawesome-all-min_fa-home-heart__3Vr4h:before {\n  content: '\\F4C9';\n}\n.fontawesome-all-min_fa-home-lg__1XPMv:before {\n  content: '\\F80B';\n}\n.fontawesome-all-min_fa-home-lg-alt__2qIK5:before {\n  content: '\\F80C';\n}\n.fontawesome-all-min_fa-hood-cloak__3lrRI:before {\n  content: '\\F6EF';\n}\n.fontawesome-all-min_fa-hooli__1mjrI:before {\n  content: '\\F427';\n}\n.fontawesome-all-min_fa-horizontal-rule__2jioc:before {\n  content: '\\F86C';\n}\n.fontawesome-all-min_fa-hornbill__ivkg-:before {\n  content: '\\F592';\n}\n.fontawesome-all-min_fa-horse__1oHQJ:before {\n  content: '\\F6F0';\n}\n.fontawesome-all-min_fa-horse-head__3oax_:before {\n  content: '\\F7AB';\n}\n.fontawesome-all-min_fa-hospital__QwC-c:before {\n  content: '\\F0F8';\n}\n.fontawesome-all-min_fa-hospital-alt__3e4I3:before {\n  content: '\\F47D';\n}\n.fontawesome-all-min_fa-hospital-symbol__31x0p:before {\n  content: '\\F47E';\n}\n.fontawesome-all-min_fa-hospital-user__3-Wq1:before {\n  content: '\\F80D';\n}\n.fontawesome-all-min_fa-hospitals__2Ogc3:before {\n  content: '\\F80E';\n}\n.fontawesome-all-min_fa-hot-tub__jqVxY:before {\n  content: '\\F593';\n}\n.fontawesome-all-min_fa-hotdog__3TfpP:before {\n  content: '\\F80F';\n}\n.fontawesome-all-min_fa-hotel__2ZZ1s:before {\n  content: '\\F594';\n}\n.fontawesome-all-min_fa-hotjar__26yes:before {\n  content: '\\F3B1';\n}\n.fontawesome-all-min_fa-hourglass__2Fx9T:before {\n  content: '\\F254';\n}\n.fontawesome-all-min_fa-hourglass-end__aAC2j:before {\n  content: '\\F253';\n}\n.fontawesome-all-min_fa-hourglass-half__3LUaL:before {\n  content: '\\F252';\n}\n.fontawesome-all-min_fa-hourglass-start__goz5S:before {\n  content: '\\F251';\n}\n.fontawesome-all-min_fa-house-damage__2hrBE:before {\n  content: '\\F6F1';\n}\n.fontawesome-all-min_fa-house-flood__3R4oN:before {\n  content: '\\F74F';\n}\n.fontawesome-all-min_fa-houzz__3eCJ_:before {\n  content: '\\F27C';\n}\n.fontawesome-all-min_fa-hryvnia__3cFbo:before {\n  content: '\\F6F2';\n}\n.fontawesome-all-min_fa-html5__2oskC:before {\n  content: '\\F13B';\n}\n.fontawesome-all-min_fa-hubspot__3vq7q:before {\n  content: '\\F3B2';\n}\n.fontawesome-all-min_fa-humidity__1Y7DR:before {\n  content: '\\F750';\n}\n.fontawesome-all-min_fa-hurricane__w2q2d:before {\n  content: '\\F751';\n}\n.fontawesome-all-min_fa-i-cursor__3v4oL:before {\n  content: '\\F246';\n}\n.fontawesome-all-min_fa-ice-cream__2U-Gm:before {\n  content: '\\F810';\n}\n.fontawesome-all-min_fa-ice-skate__3X4MP:before {\n  content: '\\F7AC';\n}\n.fontawesome-all-min_fa-icicles__392y3:before {\n  content: '\\F7AD';\n}\n.fontawesome-all-min_fa-icons__2la_7:before {\n  content: '\\F86D';\n}\n.fontawesome-all-min_fa-icons-alt__M5TBA:before {\n  content: '\\F86E';\n}\n.fontawesome-all-min_fa-id-badge__Vxoaz:before {\n  content: '\\F2C1';\n}\n.fontawesome-all-min_fa-id-card__ok8S9:before {\n  content: '\\F2C2';\n}\n.fontawesome-all-min_fa-id-card-alt__dsq5j:before {\n  content: '\\F47F';\n}\n.fontawesome-all-min_fa-igloo__3LNPv:before {\n  content: '\\F7AE';\n}\n.fontawesome-all-min_fa-image__2CE3a:before {\n  content: '\\F03E';\n}\n.fontawesome-all-min_fa-images__2dHrC:before {\n  content: '\\F302';\n}\n.fontawesome-all-min_fa-imdb__1Yado:before {\n  content: '\\F2D8';\n}\n.fontawesome-all-min_fa-inbox__3nlvC:before {\n  content: '\\F01C';\n}\n.fontawesome-all-min_fa-inbox-in__ky31L:before {\n  content: '\\F310';\n}\n.fontawesome-all-min_fa-inbox-out__3weRy:before {\n  content: '\\F311';\n}\n.fontawesome-all-min_fa-indent__122Sa:before {\n  content: '\\F03C';\n}\n.fontawesome-all-min_fa-industry__1awoD:before {\n  content: '\\F275';\n}\n.fontawesome-all-min_fa-industry-alt__LrlAv:before {\n  content: '\\F3B3';\n}\n.fontawesome-all-min_fa-infinity__wMUKB:before {\n  content: '\\F534';\n}\n.fontawesome-all-min_fa-info__fK8fa:before {\n  content: '\\F129';\n}\n.fontawesome-all-min_fa-info-circle__rmvul:before {\n  content: '\\F05A';\n}\n.fontawesome-all-min_fa-info-square__3LaEY:before {\n  content: '\\F30F';\n}\n.fontawesome-all-min_fa-inhaler__2aXph:before {\n  content: '\\F5F9';\n}\n.fontawesome-all-min_fa-instagram__CsLB-:before {\n  content: '\\F16D';\n}\n.fontawesome-all-min_fa-integral__z4RDu:before {\n  content: '\\F667';\n}\n.fontawesome-all-min_fa-intercom__11PVD:before {\n  content: '\\F7AF';\n}\n.fontawesome-all-min_fa-internet-explorer__3oBcm:before {\n  content: '\\F26B';\n}\n.fontawesome-all-min_fa-intersection__1Hd09:before {\n  content: '\\F668';\n}\n.fontawesome-all-min_fa-inventory__1t2oq:before {\n  content: '\\F480';\n}\n.fontawesome-all-min_fa-invision__2DzlH:before {\n  content: '\\F7B0';\n}\n.fontawesome-all-min_fa-ioxhost__czWVx:before {\n  content: '\\F208';\n}\n.fontawesome-all-min_fa-island-tropical__3iSms:before {\n  content: '\\F811';\n}\n.fontawesome-all-min_fa-italic__2DCR6:before {\n  content: '\\F033';\n}\n.fontawesome-all-min_fa-itch-io__1NBn2:before {\n  content: '\\F83A';\n}\n.fontawesome-all-min_fa-itunes__2pmIp:before {\n  content: '\\F3B4';\n}\n.fontawesome-all-min_fa-itunes-note__AgLL6:before {\n  content: '\\F3B5';\n}\n.fontawesome-all-min_fa-jack-o-lantern__1-0_d:before {\n  content: '\\F30E';\n}\n.fontawesome-all-min_fa-java__1GkZ0:before {\n  content: '\\F4E4';\n}\n.fontawesome-all-min_fa-jedi__133wj:before {\n  content: '\\F669';\n}\n.fontawesome-all-min_fa-jedi-order__1ZBaX:before {\n  content: '\\F50E';\n}\n.fontawesome-all-min_fa-jenkins__1RqK2:before {\n  content: '\\F3B6';\n}\n.fontawesome-all-min_fa-jira__PGKwR:before {\n  content: '\\F7B1';\n}\n.fontawesome-all-min_fa-joget__SObY0:before {\n  content: '\\F3B7';\n}\n.fontawesome-all-min_fa-joint__3DtTM:before {\n  content: '\\F595';\n}\n.fontawesome-all-min_fa-joomla__3TFPV:before {\n  content: '\\F1AA';\n}\n.fontawesome-all-min_fa-journal-whills__23u-q:before {\n  content: '\\F66A';\n}\n.fontawesome-all-min_fa-js__-vbKI:before {\n  content: '\\F3B8';\n}\n.fontawesome-all-min_fa-js-square__2inkX:before {\n  content: '\\F3B9';\n}\n.fontawesome-all-min_fa-jsfiddle__ym3ll:before {\n  content: '\\F1CC';\n}\n.fontawesome-all-min_fa-kaaba__1BaxJ:before {\n  content: '\\F66B';\n}\n.fontawesome-all-min_fa-kaggle__266N7:before {\n  content: '\\F5FA';\n}\n.fontawesome-all-min_fa-kerning__hwg-W:before {\n  content: '\\F86F';\n}\n.fontawesome-all-min_fa-key__fKQec:before {\n  content: '\\F084';\n}\n.fontawesome-all-min_fa-key-skeleton__hWexa:before {\n  content: '\\F6F3';\n}\n.fontawesome-all-min_fa-keybase__bDTe_:before {\n  content: '\\F4F5';\n}\n.fontawesome-all-min_fa-keyboard__PWGZd:before {\n  content: '\\F11C';\n}\n.fontawesome-all-min_fa-keycdn__1tac2:before {\n  content: '\\F3BA';\n}\n.fontawesome-all-min_fa-keynote__dxd2N:before {\n  content: '\\F66C';\n}\n.fontawesome-all-min_fa-khanda__3-csE:before {\n  content: '\\F66D';\n}\n.fontawesome-all-min_fa-kickstarter__30sCU:before {\n  content: '\\F3BB';\n}\n.fontawesome-all-min_fa-kickstarter-k__1aDqc:before {\n  content: '\\F3BC';\n}\n.fontawesome-all-min_fa-kidneys__1IQxn:before {\n  content: '\\F5FB';\n}\n.fontawesome-all-min_fa-kiss__1uJB1:before {\n  content: '\\F596';\n}\n.fontawesome-all-min_fa-kiss-beam__2Tf4N:before {\n  content: '\\F597';\n}\n.fontawesome-all-min_fa-kiss-wink-heart__kCHFD:before {\n  content: '\\F598';\n}\n.fontawesome-all-min_fa-kite__QHGIC:before {\n  content: '\\F6F4';\n}\n.fontawesome-all-min_fa-kiwi-bird__1COv6:before {\n  content: '\\F535';\n}\n.fontawesome-all-min_fa-knife-kitchen__wi3DC:before {\n  content: '\\F6F5';\n}\n.fontawesome-all-min_fa-korvue__LIZZN:before {\n  content: '\\F42F';\n}\n.fontawesome-all-min_fa-lambda__3q8Yd:before {\n  content: '\\F66E';\n}\n.fontawesome-all-min_fa-lamp__3VLjp:before {\n  content: '\\F4CA';\n}\n.fontawesome-all-min_fa-landmark__3mfHV:before {\n  content: '\\F66F';\n}\n.fontawesome-all-min_fa-landmark-alt__3Hp2I:before {\n  content: '\\F752';\n}\n.fontawesome-all-min_fa-language__1QmEH:before {\n  content: '\\F1AB';\n}\n.fontawesome-all-min_fa-laptop__19Rw2:before {\n  content: '\\F109';\n}\n.fontawesome-all-min_fa-laptop-code__3Kozm:before {\n  content: '\\F5FC';\n}\n.fontawesome-all-min_fa-laptop-medical__1RdzW:before {\n  content: '\\F812';\n}\n.fontawesome-all-min_fa-laravel__3Fw49:before {\n  content: '\\F3BD';\n}\n.fontawesome-all-min_fa-lastfm__2SDT3:before {\n  content: '\\F202';\n}\n.fontawesome-all-min_fa-lastfm-square__1BChO:before {\n  content: '\\F203';\n}\n.fontawesome-all-min_fa-laugh__3GpGX:before {\n  content: '\\F599';\n}\n.fontawesome-all-min_fa-laugh-beam__24sFv:before {\n  content: '\\F59A';\n}\n.fontawesome-all-min_fa-laugh-squint__2KYB9:before {\n  content: '\\F59B';\n}\n.fontawesome-all-min_fa-laugh-wink__30ujS:before {\n  content: '\\F59C';\n}\n.fontawesome-all-min_fa-layer-group__3_4pX:before {\n  content: '\\F5FD';\n}\n.fontawesome-all-min_fa-layer-minus__3YMHC:before {\n  content: '\\F5FE';\n}\n.fontawesome-all-min_fa-layer-plus__Ig8jw:before {\n  content: '\\F5FF';\n}\n.fontawesome-all-min_fa-leaf__SXQL1:before {\n  content: '\\F06C';\n}\n.fontawesome-all-min_fa-leaf-heart__138BR:before {\n  content: '\\F4CB';\n}\n.fontawesome-all-min_fa-leaf-maple__2QSgd:before {\n  content: '\\F6F6';\n}\n.fontawesome-all-min_fa-leaf-oak__3RGoT:before {\n  content: '\\F6F7';\n}\n.fontawesome-all-min_fa-leanpub__2Ukt7:before {\n  content: '\\F212';\n}\n.fontawesome-all-min_fa-lemon__1NXFs:before {\n  content: '\\F094';\n}\n.fontawesome-all-min_fa-less__3MLrd:before {\n  content: '\\F41D';\n}\n.fontawesome-all-min_fa-less-than__1zCNC:before {\n  content: '\\F536';\n}\n.fontawesome-all-min_fa-less-than-equal__Jsjen:before {\n  content: '\\F537';\n}\n.fontawesome-all-min_fa-level-down__3wgnP:before {\n  content: '\\F149';\n}\n.fontawesome-all-min_fa-level-down-alt__2Wv8V:before {\n  content: '\\F3BE';\n}\n.fontawesome-all-min_fa-level-up__2ZtNA:before {\n  content: '\\F148';\n}\n.fontawesome-all-min_fa-level-up-alt__fnPzX:before {\n  content: '\\F3BF';\n}\n.fontawesome-all-min_fa-life-ring__3prqL:before {\n  content: '\\F1CD';\n}\n.fontawesome-all-min_fa-lightbulb__2kask:before {\n  content: '\\F0EB';\n}\n.fontawesome-all-min_fa-lightbulb-dollar__2YKo1:before {\n  content: '\\F670';\n}\n.fontawesome-all-min_fa-lightbulb-exclamation__1ZFtv:before {\n  content: '\\F671';\n}\n.fontawesome-all-min_fa-lightbulb-on__3TYnP:before {\n  content: '\\F672';\n}\n.fontawesome-all-min_fa-lightbulb-slash__2JaZ2:before {\n  content: '\\F673';\n}\n.fontawesome-all-min_fa-lights-holiday__2XpfY:before {\n  content: '\\F7B2';\n}\n.fontawesome-all-min_fa-line__1AcVO:before {\n  content: '\\F3C0';\n}\n.fontawesome-all-min_fa-line-columns__1ZYZd:before {\n  content: '\\F870';\n}\n.fontawesome-all-min_fa-line-height__1RD3g:before {\n  content: '\\F871';\n}\n.fontawesome-all-min_fa-link__2vybr:before {\n  content: '\\F0C1';\n}\n.fontawesome-all-min_fa-linkedin__2qbzp:before {\n  content: '\\F08C';\n}\n.fontawesome-all-min_fa-linkedin-in__onrRV:before {\n  content: '\\F0E1';\n}\n.fontawesome-all-min_fa-linode__ku7nM:before {\n  content: '\\F2B8';\n}\n.fontawesome-all-min_fa-linux__1mmRq:before {\n  content: '\\F17C';\n}\n.fontawesome-all-min_fa-lips__3YWjK:before {\n  content: '\\F600';\n}\n.fontawesome-all-min_fa-lira-sign__2DfSP:before {\n  content: '\\F195';\n}\n.fontawesome-all-min_fa-list__xB6Uh:before {\n  content: '\\F03A';\n}\n.fontawesome-all-min_fa-list-alt__24H00:before {\n  content: '\\F022';\n}\n.fontawesome-all-min_fa-list-ol__3LEHF:before {\n  content: '\\F0CB';\n}\n.fontawesome-all-min_fa-list-ul__3hs73:before {\n  content: '\\F0CA';\n}\n.fontawesome-all-min_fa-location__4lVB9:before {\n  content: '\\F601';\n}\n.fontawesome-all-min_fa-location-arrow__1lXQ-:before {\n  content: '\\F124';\n}\n.fontawesome-all-min_fa-location-circle__1EPHK:before {\n  content: '\\F602';\n}\n.fontawesome-all-min_fa-location-slash__jL4Ja:before {\n  content: '\\F603';\n}\n.fontawesome-all-min_fa-lock__2o_Xl:before {\n  content: '\\F023';\n}\n.fontawesome-all-min_fa-lock-alt__1kIHZ:before {\n  content: '\\F30D';\n}\n.fontawesome-all-min_fa-lock-open__1EIHk:before {\n  content: '\\F3C1';\n}\n.fontawesome-all-min_fa-lock-open-alt__1BKdE:before {\n  content: '\\F3C2';\n}\n.fontawesome-all-min_fa-long-arrow-alt-down__1JmjQ:before {\n  content: '\\F309';\n}\n.fontawesome-all-min_fa-long-arrow-alt-left__1YgXZ:before {\n  content: '\\F30A';\n}\n.fontawesome-all-min_fa-long-arrow-alt-right__3YOHF:before {\n  content: '\\F30B';\n}\n.fontawesome-all-min_fa-long-arrow-alt-up__3vBrO:before {\n  content: '\\F30C';\n}\n.fontawesome-all-min_fa-long-arrow-down__3EwFh:before {\n  content: '\\F175';\n}\n.fontawesome-all-min_fa-long-arrow-left__1a0kI:before {\n  content: '\\F177';\n}\n.fontawesome-all-min_fa-long-arrow-right__2uQHb:before {\n  content: '\\F178';\n}\n.fontawesome-all-min_fa-long-arrow-up__1cHIn:before {\n  content: '\\F176';\n}\n.fontawesome-all-min_fa-loveseat__37oS1:before {\n  content: '\\F4CC';\n}\n.fontawesome-all-min_fa-low-vision__1Fxh_:before {\n  content: '\\F2A8';\n}\n.fontawesome-all-min_fa-luchador__271HY:before {\n  content: '\\F455';\n}\n.fontawesome-all-min_fa-luggage-cart__1yeSb:before {\n  content: '\\F59D';\n}\n.fontawesome-all-min_fa-lungs__1yd7L:before {\n  content: '\\F604';\n}\n.fontawesome-all-min_fa-lyft__3VrSo:before {\n  content: '\\F3C3';\n}\n.fontawesome-all-min_fa-mace__IQ-WH:before {\n  content: '\\F6F8';\n}\n.fontawesome-all-min_fa-magento__2TbHG:before {\n  content: '\\F3C4';\n}\n.fontawesome-all-min_fa-magic__2nSl3:before {\n  content: '\\F0D0';\n}\n.fontawesome-all-min_fa-magnet__iFuEn:before {\n  content: '\\F076';\n}\n.fontawesome-all-min_fa-mail-bulk__1xJL0:before {\n  content: '\\F674';\n}\n.fontawesome-all-min_fa-mailbox__2wnni:before {\n  content: '\\F813';\n}\n.fontawesome-all-min_fa-mailchimp__1eQn4:before {\n  content: '\\F59E';\n}\n.fontawesome-all-min_fa-male__2I8H6:before {\n  content: '\\F183';\n}\n.fontawesome-all-min_fa-mandalorian__1Ke-a:before {\n  content: '\\F50F';\n}\n.fontawesome-all-min_fa-mandolin__1niXM:before {\n  content: '\\F6F9';\n}\n.fontawesome-all-min_fa-map__2kWoU:before {\n  content: '\\F279';\n}\n.fontawesome-all-min_fa-map-marked__5Y5Oy:before {\n  content: '\\F59F';\n}\n.fontawesome-all-min_fa-map-marked-alt__ipTrq:before {\n  content: '\\F5A0';\n}\n.fontawesome-all-min_fa-map-marker__2wnus:before {\n  content: '\\F041';\n}\n.fontawesome-all-min_fa-map-marker-alt__rY25s:before {\n  content: '\\F3C5';\n}\n.fontawesome-all-min_fa-map-marker-alt-slash__soJwu:before {\n  content: '\\F605';\n}\n.fontawesome-all-min_fa-map-marker-check__13Njr:before {\n  content: '\\F606';\n}\n.fontawesome-all-min_fa-map-marker-edit__1o7ut:before {\n  content: '\\F607';\n}\n.fontawesome-all-min_fa-map-marker-exclamation__4bbAs:before {\n  content: '\\F608';\n}\n.fontawesome-all-min_fa-map-marker-minus__1NEZc:before {\n  content: '\\F609';\n}\n.fontawesome-all-min_fa-map-marker-plus__2uI0H:before {\n  content: '\\F60A';\n}\n.fontawesome-all-min_fa-map-marker-question__zh9jP:before {\n  content: '\\F60B';\n}\n.fontawesome-all-min_fa-map-marker-slash__2z8Nf:before {\n  content: '\\F60C';\n}\n.fontawesome-all-min_fa-map-marker-smile__3zHbb:before {\n  content: '\\F60D';\n}\n.fontawesome-all-min_fa-map-marker-times__azD70:before {\n  content: '\\F60E';\n}\n.fontawesome-all-min_fa-map-pin__3ZpnX:before {\n  content: '\\F276';\n}\n.fontawesome-all-min_fa-map-signs__2mc1f:before {\n  content: '\\F277';\n}\n.fontawesome-all-min_fa-markdown__1hq7g:before {\n  content: '\\F60F';\n}\n.fontawesome-all-min_fa-marker__1i3pc:before {\n  content: '\\F5A1';\n}\n.fontawesome-all-min_fa-mars__28nky:before {\n  content: '\\F222';\n}\n.fontawesome-all-min_fa-mars-double__3ea67:before {\n  content: '\\F227';\n}\n.fontawesome-all-min_fa-mars-stroke__1XHxk:before {\n  content: '\\F229';\n}\n.fontawesome-all-min_fa-mars-stroke-h__Kndbw:before {\n  content: '\\F22B';\n}\n.fontawesome-all-min_fa-mars-stroke-v__nRT-r:before {\n  content: '\\F22A';\n}\n.fontawesome-all-min_fa-mask__22ktB:before {\n  content: '\\F6FA';\n}\n.fontawesome-all-min_fa-mastodon__32flL:before {\n  content: '\\F4F6';\n}\n.fontawesome-all-min_fa-maxcdn__1sDoM:before {\n  content: '\\F136';\n}\n.fontawesome-all-min_fa-meat__16T_r:before {\n  content: '\\F814';\n}\n.fontawesome-all-min_fa-medal__3yz2r:before {\n  content: '\\F5A2';\n}\n.fontawesome-all-min_fa-medapps__1AXQ9:before {\n  content: '\\F3C6';\n}\n.fontawesome-all-min_fa-medium__3DPMn:before {\n  content: '\\F23A';\n}\n.fontawesome-all-min_fa-medium-m__2ANr6:before {\n  content: '\\F3C7';\n}\n.fontawesome-all-min_fa-medkit__1Cv7I:before {\n  content: '\\F0FA';\n}\n.fontawesome-all-min_fa-medrt__1qfQ2:before {\n  content: '\\F3C8';\n}\n.fontawesome-all-min_fa-meetup__2Ca1y:before {\n  content: '\\F2E0';\n}\n.fontawesome-all-min_fa-megaphone__34-sM:before {\n  content: '\\F675';\n}\n.fontawesome-all-min_fa-megaport__11Blc:before {\n  content: '\\F5A3';\n}\n.fontawesome-all-min_fa-meh__NBX-j:before {\n  content: '\\F11A';\n}\n.fontawesome-all-min_fa-meh-blank__oNz-w:before {\n  content: '\\F5A4';\n}\n.fontawesome-all-min_fa-meh-rolling-eyes__1v2Tf:before {\n  content: '\\F5A5';\n}\n.fontawesome-all-min_fa-memory__Uvmq4:before {\n  content: '\\F538';\n}\n.fontawesome-all-min_fa-mendeley__iOi05:before {\n  content: '\\F7B3';\n}\n.fontawesome-all-min_fa-menorah__2DyLO:before {\n  content: '\\F676';\n}\n.fontawesome-all-min_fa-mercury__3rzGg:before {\n  content: '\\F223';\n}\n.fontawesome-all-min_fa-meteor__3R8Gz:before {\n  content: '\\F753';\n}\n.fontawesome-all-min_fa-microchip__APL4i:before {\n  content: '\\F2DB';\n}\n.fontawesome-all-min_fa-microphone__D1jRx:before {\n  content: '\\F130';\n}\n.fontawesome-all-min_fa-microphone-alt__2hSBy:before {\n  content: '\\F3C9';\n}\n.fontawesome-all-min_fa-microphone-alt-slash__3fxTc:before {\n  content: '\\F539';\n}\n.fontawesome-all-min_fa-microphone-slash__fdiYG:before {\n  content: '\\F131';\n}\n.fontawesome-all-min_fa-microscope__hssc-:before {\n  content: '\\F610';\n}\n.fontawesome-all-min_fa-microsoft__3venz:before {\n  content: '\\F3CA';\n}\n.fontawesome-all-min_fa-mind-share__SjF--:before {\n  content: '\\F677';\n}\n.fontawesome-all-min_fa-minus__3BqZx:before {\n  content: '\\F068';\n}\n.fontawesome-all-min_fa-minus-circle__1hEGN:before {\n  content: '\\F056';\n}\n.fontawesome-all-min_fa-minus-hexagon__1Hm1_:before {\n  content: '\\F307';\n}\n.fontawesome-all-min_fa-minus-octagon__1mqtd:before {\n  content: '\\F308';\n}\n.fontawesome-all-min_fa-minus-square__25cjl:before {\n  content: '\\F146';\n}\n.fontawesome-all-min_fa-mistletoe__1lMEJ:before {\n  content: '\\F7B4';\n}\n.fontawesome-all-min_fa-mitten__3YdTm:before {\n  content: '\\F7B5';\n}\n.fontawesome-all-min_fa-mix__KZutY:before {\n  content: '\\F3CB';\n}\n.fontawesome-all-min_fa-mixcloud__1t0DJ:before {\n  content: '\\F289';\n}\n.fontawesome-all-min_fa-mizuni__dd1B5:before {\n  content: '\\F3CC';\n}\n.fontawesome-all-min_fa-mobile__3lbE1:before {\n  content: '\\F10B';\n}\n.fontawesome-all-min_fa-mobile-alt__2z4hM:before {\n  content: '\\F3CD';\n}\n.fontawesome-all-min_fa-mobile-android__Ik2Jq:before {\n  content: '\\F3CE';\n}\n.fontawesome-all-min_fa-mobile-android-alt__w4ibN:before {\n  content: '\\F3CF';\n}\n.fontawesome-all-min_fa-modx__291XM:before {\n  content: '\\F285';\n}\n.fontawesome-all-min_fa-monero__28Z5W:before {\n  content: '\\F3D0';\n}\n.fontawesome-all-min_fa-money-bill__13ai3:before {\n  content: '\\F0D6';\n}\n.fontawesome-all-min_fa-money-bill-alt__3UX18:before {\n  content: '\\F3D1';\n}\n.fontawesome-all-min_fa-money-bill-wave__2UmOn:before {\n  content: '\\F53A';\n}\n.fontawesome-all-min_fa-money-bill-wave-alt__23caf:before {\n  content: '\\F53B';\n}\n.fontawesome-all-min_fa-money-check__h94Ka:before {\n  content: '\\F53C';\n}\n.fontawesome-all-min_fa-money-check-alt__3e9vV:before {\n  content: '\\F53D';\n}\n.fontawesome-all-min_fa-money-check-edit__2IV4O:before {\n  content: '\\F872';\n}\n.fontawesome-all-min_fa-money-check-edit-alt__20xCt:before {\n  content: '\\F873';\n}\n.fontawesome-all-min_fa-monitor-heart-rate__BuSHj:before {\n  content: '\\F611';\n}\n.fontawesome-all-min_fa-monkey__20TAL:before {\n  content: '\\F6FB';\n}\n.fontawesome-all-min_fa-monument__3p_Sr:before {\n  content: '\\F5A6';\n}\n.fontawesome-all-min_fa-moon__39bqu:before {\n  content: '\\F186';\n}\n.fontawesome-all-min_fa-moon-cloud__Y4tOO:before {\n  content: '\\F754';\n}\n.fontawesome-all-min_fa-moon-stars__2sEvM:before {\n  content: '\\F755';\n}\n.fontawesome-all-min_fa-mortar-pestle__s0kXT:before {\n  content: '\\F5A7';\n}\n.fontawesome-all-min_fa-mosque__3yBw9:before {\n  content: '\\F678';\n}\n.fontawesome-all-min_fa-motorcycle__-xd4z:before {\n  content: '\\F21C';\n}\n.fontawesome-all-min_fa-mountain__1jTpu:before {\n  content: '\\F6FC';\n}\n.fontawesome-all-min_fa-mountains__1AZli:before {\n  content: '\\F6FD';\n}\n.fontawesome-all-min_fa-mouse-pointer__2bhUQ:before {\n  content: '\\F245';\n}\n.fontawesome-all-min_fa-mug__35bS4:before {\n  content: '\\F874';\n}\n.fontawesome-all-min_fa-mug-hot__2OibT:before {\n  content: '\\F7B6';\n}\n.fontawesome-all-min_fa-mug-marshmallows__1Qw-N:before {\n  content: '\\F7B7';\n}\n.fontawesome-all-min_fa-mug-tea__2BV1f:before {\n  content: '\\F875';\n}\n.fontawesome-all-min_fa-music__3xo3f:before {\n  content: '\\F001';\n}\n.fontawesome-all-min_fa-napster__1srg_:before {\n  content: '\\F3D2';\n}\n.fontawesome-all-min_fa-narwhal__1Lve6:before {\n  content: '\\F6FE';\n}\n.fontawesome-all-min_fa-neos__mUUrU:before {\n  content: '\\F612';\n}\n.fontawesome-all-min_fa-network-wired__1XYMR:before {\n  content: '\\F6FF';\n}\n.fontawesome-all-min_fa-neuter__3JOYX:before {\n  content: '\\F22C';\n}\n.fontawesome-all-min_fa-newspaper__1TAIc:before {\n  content: '\\F1EA';\n}\n.fontawesome-all-min_fa-nimblr__aWeHA:before {\n  content: '\\F5A8';\n}\n.fontawesome-all-min_fa-node__8NmUl:before {\n  content: '\\F419';\n}\n.fontawesome-all-min_fa-node-js__3kySf:before {\n  content: '\\F3D3';\n}\n.fontawesome-all-min_fa-not-equal__1zWEc:before {\n  content: '\\F53E';\n}\n.fontawesome-all-min_fa-notes-medical__23xao:before {\n  content: '\\F481';\n}\n.fontawesome-all-min_fa-npm__2h3Sm:before {\n  content: '\\F3D4';\n}\n.fontawesome-all-min_fa-ns8__1cHqH:before {\n  content: '\\F3D5';\n}\n.fontawesome-all-min_fa-nutritionix__16yag:before {\n  content: '\\F3D6';\n}\n.fontawesome-all-min_fa-object-group__3Heb7:before {\n  content: '\\F247';\n}\n.fontawesome-all-min_fa-object-ungroup__3JnNp:before {\n  content: '\\F248';\n}\n.fontawesome-all-min_fa-octagon__2cell:before {\n  content: '\\F306';\n}\n.fontawesome-all-min_fa-odnoklassniki__2S5uS:before {\n  content: '\\F263';\n}\n.fontawesome-all-min_fa-odnoklassniki-square__1VTyr:before {\n  content: '\\F264';\n}\n.fontawesome-all-min_fa-oil-can__2J43p:before {\n  content: '\\F613';\n}\n.fontawesome-all-min_fa-oil-temp__mv18g:before {\n  content: '\\F614';\n}\n.fontawesome-all-min_fa-old-republic__1XdBY:before {\n  content: '\\F510';\n}\n.fontawesome-all-min_fa-om__JZc4X:before {\n  content: '\\F679';\n}\n.fontawesome-all-min_fa-omega__1zfi6:before {\n  content: '\\F67A';\n}\n.fontawesome-all-min_fa-opencart__2_VZh:before {\n  content: '\\F23D';\n}\n.fontawesome-all-min_fa-openid__QesPs:before {\n  content: '\\F19B';\n}\n.fontawesome-all-min_fa-opera__2_CpW:before {\n  content: '\\F26A';\n}\n.fontawesome-all-min_fa-optin-monster__MAkE6:before {\n  content: '\\F23C';\n}\n.fontawesome-all-min_fa-ornament__3VuvQ:before {\n  content: '\\F7B8';\n}\n.fontawesome-all-min_fa-osi__1h9pg:before {\n  content: '\\F41A';\n}\n.fontawesome-all-min_fa-otter__2ACax:before {\n  content: '\\F700';\n}\n.fontawesome-all-min_fa-outdent__vpVZ2:before {\n  content: '\\F03B';\n}\n.fontawesome-all-min_fa-overline__3WOjF:before {\n  content: '\\F876';\n}\n.fontawesome-all-min_fa-page-break__28vXq:before {\n  content: '\\F877';\n}\n.fontawesome-all-min_fa-page4__3qtNC:before {\n  content: '\\F3D7';\n}\n.fontawesome-all-min_fa-pagelines__12ebJ:before {\n  content: '\\F18C';\n}\n.fontawesome-all-min_fa-pager__3CCgz:before {\n  content: '\\F815';\n}\n.fontawesome-all-min_fa-paint-brush__3qRa4:before {\n  content: '\\F1FC';\n}\n.fontawesome-all-min_fa-paint-brush-alt__3AAY6:before {\n  content: '\\F5A9';\n}\n.fontawesome-all-min_fa-paint-roller__2QoYB:before {\n  content: '\\F5AA';\n}\n.fontawesome-all-min_fa-palette__i5xC1:before {\n  content: '\\F53F';\n}\n.fontawesome-all-min_fa-palfed__1d9RY:before {\n  content: '\\F3D8';\n}\n.fontawesome-all-min_fa-pallet__3MRVO:before {\n  content: '\\F482';\n}\n.fontawesome-all-min_fa-pallet-alt__2ghm8:before {\n  content: '\\F483';\n}\n.fontawesome-all-min_fa-paper-plane__2RCR1:before {\n  content: '\\F1D8';\n}\n.fontawesome-all-min_fa-paperclip__2lY8i:before {\n  content: '\\F0C6';\n}\n.fontawesome-all-min_fa-parachute-box__2ib9K:before {\n  content: '\\F4CD';\n}\n.fontawesome-all-min_fa-paragraph__1E-1F:before {\n  content: '\\F1DD';\n}\n.fontawesome-all-min_fa-paragraph-rtl__1BraL:before {\n  content: '\\F878';\n}\n.fontawesome-all-min_fa-parking__2epBg:before {\n  content: '\\F540';\n}\n.fontawesome-all-min_fa-parking-circle__36YHo:before {\n  content: '\\F615';\n}\n.fontawesome-all-min_fa-parking-circle-slash__33P8Q:before {\n  content: '\\F616';\n}\n.fontawesome-all-min_fa-parking-slash__EnM1X:before {\n  content: '\\F617';\n}\n.fontawesome-all-min_fa-passport__3cK59:before {\n  content: '\\F5AB';\n}\n.fontawesome-all-min_fa-pastafarianism__lbect:before {\n  content: '\\F67B';\n}\n.fontawesome-all-min_fa-paste__1Tqg7:before {\n  content: '\\F0EA';\n}\n.fontawesome-all-min_fa-patreon__1hYtz:before {\n  content: '\\F3D9';\n}\n.fontawesome-all-min_fa-pause__1xsts:before {\n  content: '\\F04C';\n}\n.fontawesome-all-min_fa-pause-circle__3Xnm-:before {\n  content: '\\F28B';\n}\n.fontawesome-all-min_fa-paw__2qV7P:before {\n  content: '\\F1B0';\n}\n.fontawesome-all-min_fa-paw-alt__21b0T:before {\n  content: '\\F701';\n}\n.fontawesome-all-min_fa-paw-claws__2vwYt:before {\n  content: '\\F702';\n}\n.fontawesome-all-min_fa-paypal__1jI5m:before {\n  content: '\\F1ED';\n}\n.fontawesome-all-min_fa-peace__1NgWd:before {\n  content: '\\F67C';\n}\n.fontawesome-all-min_fa-pegasus__1XLOE:before {\n  content: '\\F703';\n}\n.fontawesome-all-min_fa-pen__bguPh:before {\n  content: '\\F304';\n}\n.fontawesome-all-min_fa-pen-alt__EliwQ:before {\n  content: '\\F305';\n}\n.fontawesome-all-min_fa-pen-fancy__6ryLG:before {\n  content: '\\F5AC';\n}\n.fontawesome-all-min_fa-pen-nib__Q8E80:before {\n  content: '\\F5AD';\n}\n.fontawesome-all-min_fa-pen-square__1q3xb:before {\n  content: '\\F14B';\n}\n.fontawesome-all-min_fa-pencil__1JVGF:before {\n  content: '\\F040';\n}\n.fontawesome-all-min_fa-pencil-alt__3GVKt:before {\n  content: '\\F303';\n}\n.fontawesome-all-min_fa-pencil-paintbrush__1o1np:before {\n  content: '\\F618';\n}\n.fontawesome-all-min_fa-pencil-ruler__2MqlH:before {\n  content: '\\F5AE';\n}\n.fontawesome-all-min_fa-pennant__1JzUs:before {\n  content: '\\F456';\n}\n.fontawesome-all-min_fa-penny-arcade__1u2-L:before {\n  content: '\\F704';\n}\n.fontawesome-all-min_fa-people-carry__2g8A-:before {\n  content: '\\F4CE';\n}\n.fontawesome-all-min_fa-pepper-hot__2Iqom:before {\n  content: '\\F816';\n}\n.fontawesome-all-min_fa-percent__MOi2z:before {\n  content: '\\F295';\n}\n.fontawesome-all-min_fa-percentage__2Xsk8:before {\n  content: '\\F541';\n}\n.fontawesome-all-min_fa-periscope__2iDT9:before {\n  content: '\\F3DA';\n}\n.fontawesome-all-min_fa-person-booth__3bKxF:before {\n  content: '\\F756';\n}\n.fontawesome-all-min_fa-person-carry__1FFtU:before {\n  content: '\\F4CF';\n}\n.fontawesome-all-min_fa-person-dolly__14WVN:before {\n  content: '\\F4D0';\n}\n.fontawesome-all-min_fa-person-dolly-empty__17_AZ:before {\n  content: '\\F4D1';\n}\n.fontawesome-all-min_fa-person-sign__3SFK6:before {\n  content: '\\F757';\n}\n.fontawesome-all-min_fa-phabricator__2bW0f:before {\n  content: '\\F3DB';\n}\n.fontawesome-all-min_fa-phoenix-framework__1opMC:before {\n  content: '\\F3DC';\n}\n.fontawesome-all-min_fa-phoenix-squadron__28TKu:before {\n  content: '\\F511';\n}\n.fontawesome-all-min_fa-phone__quAB4:before {\n  content: '\\F095';\n}\n.fontawesome-all-min_fa-phone-alt__3meXS:before {\n  content: '\\F879';\n}\n.fontawesome-all-min_fa-phone-laptop__2UAV4:before {\n  content: '\\F87A';\n}\n.fontawesome-all-min_fa-phone-office__2OTkM:before {\n  content: '\\F67D';\n}\n.fontawesome-all-min_fa-phone-plus__2sN6A:before {\n  content: '\\F4D2';\n}\n.fontawesome-all-min_fa-phone-slash__32hxz:before {\n  content: '\\F3DD';\n}\n.fontawesome-all-min_fa-phone-square__yvkp2:before {\n  content: '\\F098';\n}\n.fontawesome-all-min_fa-phone-square-alt__7rW9P:before {\n  content: '\\F87B';\n}\n.fontawesome-all-min_fa-phone-volume__2aImR:before {\n  content: '\\F2A0';\n}\n.fontawesome-all-min_fa-photo-video__lWysC:before {\n  content: '\\F87C';\n}\n.fontawesome-all-min_fa-php__3VfpF:before {\n  content: '\\F457';\n}\n.fontawesome-all-min_fa-pi__1IUHn:before {\n  content: '\\F67E';\n}\n.fontawesome-all-min_fa-pie__2z8i1:before {\n  content: '\\F705';\n}\n.fontawesome-all-min_fa-pied-piper__1goXA:before {\n  content: '\\F2AE';\n}\n.fontawesome-all-min_fa-pied-piper-alt__1hyVQ:before {\n  content: '\\F1A8';\n}\n.fontawesome-all-min_fa-pied-piper-hat__24lWu:before {\n  content: '\\F4E5';\n}\n.fontawesome-all-min_fa-pied-piper-pp__gEHp7:before {\n  content: '\\F1A7';\n}\n.fontawesome-all-min_fa-pig__3mKH6:before {\n  content: '\\F706';\n}\n.fontawesome-all-min_fa-piggy-bank__2jY0X:before {\n  content: '\\F4D3';\n}\n.fontawesome-all-min_fa-pills__N4U93:before {\n  content: '\\F484';\n}\n.fontawesome-all-min_fa-pinterest__3xVpu:before {\n  content: '\\F0D2';\n}\n.fontawesome-all-min_fa-pinterest-p__3cs6d:before {\n  content: '\\F231';\n}\n.fontawesome-all-min_fa-pinterest-square__2IDi7:before {\n  content: '\\F0D3';\n}\n.fontawesome-all-min_fa-pizza__2s0gf:before {\n  content: '\\F817';\n}\n.fontawesome-all-min_fa-pizza-slice__3YYzX:before {\n  content: '\\F818';\n}\n.fontawesome-all-min_fa-place-of-worship__1mTG7:before {\n  content: '\\F67F';\n}\n.fontawesome-all-min_fa-plane__2Q1ld:before {\n  content: '\\F072';\n}\n.fontawesome-all-min_fa-plane-alt__2Zk_m:before {\n  content: '\\F3DE';\n}\n.fontawesome-all-min_fa-plane-arrival__1GT65:before {\n  content: '\\F5AF';\n}\n.fontawesome-all-min_fa-plane-departure__2lxQL:before {\n  content: '\\F5B0';\n}\n.fontawesome-all-min_fa-play__1Kb38:before {\n  content: '\\F04B';\n}\n.fontawesome-all-min_fa-play-circle__3X3Ud:before {\n  content: '\\F144';\n}\n.fontawesome-all-min_fa-playstation__1Nlge:before {\n  content: '\\F3DF';\n}\n.fontawesome-all-min_fa-plug__3IzHV:before {\n  content: '\\F1E6';\n}\n.fontawesome-all-min_fa-plus__1mxU8:before {\n  content: '\\F067';\n}\n.fontawesome-all-min_fa-plus-circle__1OWIo:before {\n  content: '\\F055';\n}\n.fontawesome-all-min_fa-plus-hexagon__36wwN:before {\n  content: '\\F300';\n}\n.fontawesome-all-min_fa-plus-octagon__2tW6i:before {\n  content: '\\F301';\n}\n.fontawesome-all-min_fa-plus-square__OZgxJ:before {\n  content: '\\F0FE';\n}\n.fontawesome-all-min_fa-podcast__2qDeL:before {\n  content: '\\F2CE';\n}\n.fontawesome-all-min_fa-podium__1XpcR:before {\n  content: '\\F680';\n}\n.fontawesome-all-min_fa-podium-star__Xb6zr:before {\n  content: '\\F758';\n}\n.fontawesome-all-min_fa-poll__EwxIp:before {\n  content: '\\F681';\n}\n.fontawesome-all-min_fa-poll-h__3Nh_N:before {\n  content: '\\F682';\n}\n.fontawesome-all-min_fa-poll-people__2u-B0:before {\n  content: '\\F759';\n}\n.fontawesome-all-min_fa-poo__mg2_R:before {\n  content: '\\F2FE';\n}\n.fontawesome-all-min_fa-poo-storm__2eGj0:before {\n  content: '\\F75A';\n}\n.fontawesome-all-min_fa-poop__v5Zr8:before {\n  content: '\\F619';\n}\n.fontawesome-all-min_fa-popcorn__1PHVC:before {\n  content: '\\F819';\n}\n.fontawesome-all-min_fa-portrait__1vBiZ:before {\n  content: '\\F3E0';\n}\n.fontawesome-all-min_fa-pound-sign__1Uybz:before {\n  content: '\\F154';\n}\n.fontawesome-all-min_fa-power-off__2XEtV:before {\n  content: '\\F011';\n}\n.fontawesome-all-min_fa-pray__3Pcbg:before {\n  content: '\\F683';\n}\n.fontawesome-all-min_fa-praying-hands__elMSE:before {\n  content: '\\F684';\n}\n.fontawesome-all-min_fa-prescription__23U6T:before {\n  content: '\\F5B1';\n}\n.fontawesome-all-min_fa-prescription-bottle__21Rc6:before {\n  content: '\\F485';\n}\n.fontawesome-all-min_fa-prescription-bottle-alt__3COZi:before {\n  content: '\\F486';\n}\n.fontawesome-all-min_fa-presentation__2SS4u:before {\n  content: '\\F685';\n}\n.fontawesome-all-min_fa-print__8tjpZ:before {\n  content: '\\F02F';\n}\n.fontawesome-all-min_fa-print-search__23fx5:before {\n  content: '\\F81A';\n}\n.fontawesome-all-min_fa-print-slash__3iVWj:before {\n  content: '\\F686';\n}\n.fontawesome-all-min_fa-procedures__1t8cW:before {\n  content: '\\F487';\n}\n.fontawesome-all-min_fa-product-hunt__1Qa73:before {\n  content: '\\F288';\n}\n.fontawesome-all-min_fa-project-diagram___q32k:before {\n  content: '\\F542';\n}\n.fontawesome-all-min_fa-pumpkin__3zuEK:before {\n  content: '\\F707';\n}\n.fontawesome-all-min_fa-pushed__H1wWt:before {\n  content: '\\F3E1';\n}\n.fontawesome-all-min_fa-puzzle-piece__1KPdX:before {\n  content: '\\F12E';\n}\n.fontawesome-all-min_fa-python__pXH-h:before {\n  content: '\\F3E2';\n}\n.fontawesome-all-min_fa-qq__3LVBc:before {\n  content: '\\F1D6';\n}\n.fontawesome-all-min_fa-qrcode__3Q0D8:before {\n  content: '\\F029';\n}\n.fontawesome-all-min_fa-question__lXIA4:before {\n  content: '\\F128';\n}\n.fontawesome-all-min_fa-question-circle__1aKoV:before {\n  content: '\\F059';\n}\n.fontawesome-all-min_fa-question-square__db3He:before {\n  content: '\\F2FD';\n}\n.fontawesome-all-min_fa-quidditch__3XYzr:before {\n  content: '\\F458';\n}\n.fontawesome-all-min_fa-quinscape__NeUUS:before {\n  content: '\\F459';\n}\n.fontawesome-all-min_fa-quora__2YS5s:before {\n  content: '\\F2C4';\n}\n.fontawesome-all-min_fa-quote-left__1ejrD:before {\n  content: '\\F10D';\n}\n.fontawesome-all-min_fa-quote-right__1iGYT:before {\n  content: '\\F10E';\n}\n.fontawesome-all-min_fa-quran__1Hrpv:before {\n  content: '\\F687';\n}\n.fontawesome-all-min_fa-r-project__3NKtl:before {\n  content: '\\F4F7';\n}\n.fontawesome-all-min_fa-rabbit__3byGh:before {\n  content: '\\F708';\n}\n.fontawesome-all-min_fa-rabbit-fast__3CuKK:before {\n  content: '\\F709';\n}\n.fontawesome-all-min_fa-racquet__b-yhE:before {\n  content: '\\F45A';\n}\n.fontawesome-all-min_fa-radiation__3-0Hc:before {\n  content: '\\F7B9';\n}\n.fontawesome-all-min_fa-radiation-alt__3G6oe:before {\n  content: '\\F7BA';\n}\n.fontawesome-all-min_fa-rainbow__3at_X:before {\n  content: '\\F75B';\n}\n.fontawesome-all-min_fa-raindrops__2vNOU:before {\n  content: '\\F75C';\n}\n.fontawesome-all-min_fa-ram__30-vs:before {\n  content: '\\F70A';\n}\n.fontawesome-all-min_fa-ramp-loading__3jSpf:before {\n  content: '\\F4D4';\n}\n.fontawesome-all-min_fa-random__1umXk:before {\n  content: '\\F074';\n}\n.fontawesome-all-min_fa-raspberry-pi__3YvxH:before {\n  content: '\\F7BB';\n}\n.fontawesome-all-min_fa-ravelry__UrGrG:before {\n  content: '\\F2D9';\n}\n.fontawesome-all-min_fa-react__IqXDk:before {\n  content: '\\F41B';\n}\n.fontawesome-all-min_fa-reacteurope__aMXCH:before {\n  content: '\\F75D';\n}\n.fontawesome-all-min_fa-readme__1vlaY:before {\n  content: '\\F4D5';\n}\n.fontawesome-all-min_fa-rebel__1AvIx:before {\n  content: '\\F1D0';\n}\n.fontawesome-all-min_fa-receipt__2KVrd:before {\n  content: '\\F543';\n}\n.fontawesome-all-min_fa-rectangle-landscape__qRoA7:before {\n  content: '\\F2FA';\n}\n.fontawesome-all-min_fa-rectangle-portrait__1co0k:before {\n  content: '\\F2FB';\n}\n.fontawesome-all-min_fa-rectangle-wide__2nrVw:before {\n  content: '\\F2FC';\n}\n.fontawesome-all-min_fa-recycle__1IUVx:before {\n  content: '\\F1B8';\n}\n.fontawesome-all-min_fa-red-river__3WG3a:before {\n  content: '\\F3E3';\n}\n.fontawesome-all-min_fa-reddit__p6cJV:before {\n  content: '\\F1A1';\n}\n.fontawesome-all-min_fa-reddit-alien__3aODR:before {\n  content: '\\F281';\n}\n.fontawesome-all-min_fa-reddit-square__WFznP:before {\n  content: '\\F1A2';\n}\n.fontawesome-all-min_fa-redhat__3z7Iy:before {\n  content: '\\F7BC';\n}\n.fontawesome-all-min_fa-redo__3_iaa:before {\n  content: '\\F01E';\n}\n.fontawesome-all-min_fa-redo-alt__2XoUm:before {\n  content: '\\F2F9';\n}\n.fontawesome-all-min_fa-registered__1P_UC:before {\n  content: '\\F25D';\n}\n.fontawesome-all-min_fa-remove-format__24Lda:before {\n  content: '\\F87D';\n}\n.fontawesome-all-min_fa-renren__2eYQV:before {\n  content: '\\F18B';\n}\n.fontawesome-all-min_fa-repeat__3Irlm:before {\n  content: '\\F363';\n}\n.fontawesome-all-min_fa-repeat-1__3VL_R:before {\n  content: '\\F365';\n}\n.fontawesome-all-min_fa-repeat-1-alt__2Uv-v:before {\n  content: '\\F366';\n}\n.fontawesome-all-min_fa-repeat-alt__n75yQ:before {\n  content: '\\F364';\n}\n.fontawesome-all-min_fa-reply__mTf0V:before {\n  content: '\\F3E5';\n}\n.fontawesome-all-min_fa-reply-all__3sJD-:before {\n  content: '\\F122';\n}\n.fontawesome-all-min_fa-replyd__2KgxS:before {\n  content: '\\F3E6';\n}\n.fontawesome-all-min_fa-republican__3VDtW:before {\n  content: '\\F75E';\n}\n.fontawesome-all-min_fa-researchgate__1UaKb:before {\n  content: '\\F4F8';\n}\n.fontawesome-all-min_fa-resolving__EbrEa:before {\n  content: '\\F3E7';\n}\n.fontawesome-all-min_fa-restroom__1j3Dt:before {\n  content: '\\F7BD';\n}\n.fontawesome-all-min_fa-retweet__1_cpr:before {\n  content: '\\F079';\n}\n.fontawesome-all-min_fa-retweet-alt__9fVto:before {\n  content: '\\F361';\n}\n.fontawesome-all-min_fa-rev__24xTA:before {\n  content: '\\F5B2';\n}\n.fontawesome-all-min_fa-ribbon__3wbD7:before {\n  content: '\\F4D6';\n}\n.fontawesome-all-min_fa-ring__iFRQa:before {\n  content: '\\F70B';\n}\n.fontawesome-all-min_fa-rings-wedding__SVjYz:before {\n  content: '\\F81B';\n}\n.fontawesome-all-min_fa-road__goYVT:before {\n  content: '\\F018';\n}\n.fontawesome-all-min_fa-robot__1lKYL:before {\n  content: '\\F544';\n}\n.fontawesome-all-min_fa-rocket__c-HX6:before {\n  content: '\\F135';\n}\n.fontawesome-all-min_fa-rocketchat__3hXUr:before {\n  content: '\\F3E8';\n}\n.fontawesome-all-min_fa-rockrms__FK6vA:before {\n  content: '\\F3E9';\n}\n.fontawesome-all-min_fa-route__15UOM:before {\n  content: '\\F4D7';\n}\n.fontawesome-all-min_fa-route-highway__1ov2e:before {\n  content: '\\F61A';\n}\n.fontawesome-all-min_fa-route-interstate__2IVN3:before {\n  content: '\\F61B';\n}\n.fontawesome-all-min_fa-rss__1qExm:before {\n  content: '\\F09E';\n}\n.fontawesome-all-min_fa-rss-square__2mCG0:before {\n  content: '\\F143';\n}\n.fontawesome-all-min_fa-ruble-sign__15a16:before {\n  content: '\\F158';\n}\n.fontawesome-all-min_fa-ruler__2p9TS:before {\n  content: '\\F545';\n}\n.fontawesome-all-min_fa-ruler-combined__2dl7o:before {\n  content: '\\F546';\n}\n.fontawesome-all-min_fa-ruler-horizontal__3WHJ1:before {\n  content: '\\F547';\n}\n.fontawesome-all-min_fa-ruler-triangle__3DUrZ:before {\n  content: '\\F61C';\n}\n.fontawesome-all-min_fa-ruler-vertical__2m0qx:before {\n  content: '\\F548';\n}\n.fontawesome-all-min_fa-running__1LPSh:before {\n  content: '\\F70C';\n}\n.fontawesome-all-min_fa-rupee-sign__3sGt7:before {\n  content: '\\F156';\n}\n.fontawesome-all-min_fa-rv__2VmWs:before {\n  content: '\\F7BE';\n}\n.fontawesome-all-min_fa-sack__24Na7:before {\n  content: '\\F81C';\n}\n.fontawesome-all-min_fa-sack-dollar__jHCld:before {\n  content: '\\F81D';\n}\n.fontawesome-all-min_fa-sad-cry__3aHCh:before {\n  content: '\\F5B3';\n}\n.fontawesome-all-min_fa-sad-tear__2bI-Z:before {\n  content: '\\F5B4';\n}\n.fontawesome-all-min_fa-safari__9B2TK:before {\n  content: '\\F267';\n}\n.fontawesome-all-min_fa-salad__3Q5KK:before {\n  content: '\\F81E';\n}\n.fontawesome-all-min_fa-salesforce__6dqRD:before {\n  content: '\\F83B';\n}\n.fontawesome-all-min_fa-sandwich__2VzJV:before {\n  content: '\\F81F';\n}\n.fontawesome-all-min_fa-sass__1chjt:before {\n  content: '\\F41E';\n}\n.fontawesome-all-min_fa-satellite__wZrlB:before {\n  content: '\\F7BF';\n}\n.fontawesome-all-min_fa-satellite-dish__2iWF4:before {\n  content: '\\F7C0';\n}\n.fontawesome-all-min_fa-sausage__-aBqb:before {\n  content: '\\F820';\n}\n.fontawesome-all-min_fa-save__1CIHB:before {\n  content: '\\F0C7';\n}\n.fontawesome-all-min_fa-scalpel__3jyh_:before {\n  content: '\\F61D';\n}\n.fontawesome-all-min_fa-scalpel-path__1u2ts:before {\n  content: '\\F61E';\n}\n.fontawesome-all-min_fa-scanner__3FT0g:before {\n  content: '\\F488';\n}\n.fontawesome-all-min_fa-scanner-keyboard__jHU-t:before {\n  content: '\\F489';\n}\n.fontawesome-all-min_fa-scanner-touchscreen__1WTuz:before {\n  content: '\\F48A';\n}\n.fontawesome-all-min_fa-scarecrow__1yBgg:before {\n  content: '\\F70D';\n}\n.fontawesome-all-min_fa-scarf__tI6Nu:before {\n  content: '\\F7C1';\n}\n.fontawesome-all-min_fa-schlix___9jF8:before {\n  content: '\\F3EA';\n}\n.fontawesome-all-min_fa-school__3eHNy:before {\n  content: '\\F549';\n}\n.fontawesome-all-min_fa-screwdriver__k4FMR:before {\n  content: '\\F54A';\n}\n.fontawesome-all-min_fa-scribd__3T6Zt:before {\n  content: '\\F28A';\n}\n.fontawesome-all-min_fa-scroll__2DWjR:before {\n  content: '\\F70E';\n}\n.fontawesome-all-min_fa-scroll-old__zfsUK:before {\n  content: '\\F70F';\n}\n.fontawesome-all-min_fa-scrubber__3AOB1:before {\n  content: '\\F2F8';\n}\n.fontawesome-all-min_fa-scythe__E4m-d:before {\n  content: '\\F710';\n}\n.fontawesome-all-min_fa-sd-card__ZptfN:before {\n  content: '\\F7C2';\n}\n.fontawesome-all-min_fa-search__1iwTC:before {\n  content: '\\F002';\n}\n.fontawesome-all-min_fa-search-dollar__2h3v-:before {\n  content: '\\F688';\n}\n.fontawesome-all-min_fa-search-location__3JLLc:before {\n  content: '\\F689';\n}\n.fontawesome-all-min_fa-search-minus__3SQsr:before {\n  content: '\\F010';\n}\n.fontawesome-all-min_fa-search-plus__285aA:before {\n  content: '\\F00E';\n}\n.fontawesome-all-min_fa-searchengin__2io_b:before {\n  content: '\\F3EB';\n}\n.fontawesome-all-min_fa-seedling__1Edwf:before {\n  content: '\\F4D8';\n}\n.fontawesome-all-min_fa-sellcast__1Jayc:before {\n  content: '\\F2DA';\n}\n.fontawesome-all-min_fa-sellsy__3FT60:before {\n  content: '\\F213';\n}\n.fontawesome-all-min_fa-send-back__3d8qm:before {\n  content: '\\F87E';\n}\n.fontawesome-all-min_fa-send-backward__2kAD7:before {\n  content: '\\F87F';\n}\n.fontawesome-all-min_fa-server__2ypKM:before {\n  content: '\\F233';\n}\n.fontawesome-all-min_fa-servicestack__3lHTp:before {\n  content: '\\F3EC';\n}\n.fontawesome-all-min_fa-shapes__2MzRl:before {\n  content: '\\F61F';\n}\n.fontawesome-all-min_fa-share__3ZQci:before {\n  content: '\\F064';\n}\n.fontawesome-all-min_fa-share-all__3EEhS:before {\n  content: '\\F367';\n}\n.fontawesome-all-min_fa-share-alt__1GhCL:before {\n  content: '\\F1E0';\n}\n.fontawesome-all-min_fa-share-alt-square__3dZcv:before {\n  content: '\\F1E1';\n}\n.fontawesome-all-min_fa-share-square__29m2V:before {\n  content: '\\F14D';\n}\n.fontawesome-all-min_fa-sheep__1NFAL:before {\n  content: '\\F711';\n}\n.fontawesome-all-min_fa-shekel-sign__YIJ18:before {\n  content: '\\F20B';\n}\n.fontawesome-all-min_fa-shield__3RIQX:before {\n  content: '\\F132';\n}\n.fontawesome-all-min_fa-shield-alt__B0CKP:before {\n  content: '\\F3ED';\n}\n.fontawesome-all-min_fa-shield-check__1Hm37:before {\n  content: '\\F2F7';\n}\n.fontawesome-all-min_fa-shield-cross__3KVmU:before {\n  content: '\\F712';\n}\n.fontawesome-all-min_fa-ship__2NOpb:before {\n  content: '\\F21A';\n}\n.fontawesome-all-min_fa-shipping-fast__ftNJT:before {\n  content: '\\F48B';\n}\n.fontawesome-all-min_fa-shipping-timed__2TXkU:before {\n  content: '\\F48C';\n}\n.fontawesome-all-min_fa-shirtsinbulk__3dmYD:before {\n  content: '\\F214';\n}\n.fontawesome-all-min_fa-shish-kebab__2lUc_:before {\n  content: '\\F821';\n}\n.fontawesome-all-min_fa-shoe-prints__36zBX:before {\n  content: '\\F54B';\n}\n.fontawesome-all-min_fa-shopping-bag__3jmCQ:before {\n  content: '\\F290';\n}\n.fontawesome-all-min_fa-shopping-basket__1UvWJ:before {\n  content: '\\F291';\n}\n.fontawesome-all-min_fa-shopping-cart__1QrTG:before {\n  content: '\\F07A';\n}\n.fontawesome-all-min_fa-shopware__Ro2ce:before {\n  content: '\\F5B5';\n}\n.fontawesome-all-min_fa-shovel__2DAz8:before {\n  content: '\\F713';\n}\n.fontawesome-all-min_fa-shovel-snow__2dLe0:before {\n  content: '\\F7C3';\n}\n.fontawesome-all-min_fa-shower__1hQA2:before {\n  content: '\\F2CC';\n}\n.fontawesome-all-min_fa-shredder__2AKqR:before {\n  content: '\\F68A';\n}\n.fontawesome-all-min_fa-shuttle-van__1x1kF:before {\n  content: '\\F5B6';\n}\n.fontawesome-all-min_fa-shuttlecock__1_cPo:before {\n  content: '\\F45B';\n}\n.fontawesome-all-min_fa-sickle__3U0jz:before {\n  content: '\\F822';\n}\n.fontawesome-all-min_fa-sigma__3hq8O:before {\n  content: '\\F68B';\n}\n.fontawesome-all-min_fa-sign__1egLv:before {\n  content: '\\F4D9';\n}\n.fontawesome-all-min_fa-sign-in__1wjYO:before {\n  content: '\\F090';\n}\n.fontawesome-all-min_fa-sign-in-alt__1TOqw:before {\n  content: '\\F2F6';\n}\n.fontawesome-all-min_fa-sign-language__2fElB:before {\n  content: '\\F2A7';\n}\n.fontawesome-all-min_fa-sign-out__3hzcO:before {\n  content: '\\F08B';\n}\n.fontawesome-all-min_fa-sign-out-alt__1SBZA:before {\n  content: '\\F2F5';\n}\n.fontawesome-all-min_fa-signal__38fSR:before {\n  content: '\\F012';\n}\n.fontawesome-all-min_fa-signal-1__1w69i:before {\n  content: '\\F68C';\n}\n.fontawesome-all-min_fa-signal-2__2ZCkV:before {\n  content: '\\F68D';\n}\n.fontawesome-all-min_fa-signal-3__23QPT:before {\n  content: '\\F68E';\n}\n.fontawesome-all-min_fa-signal-4__MkUqs:before {\n  content: '\\F68F';\n}\n.fontawesome-all-min_fa-signal-alt__wx1do:before {\n  content: '\\F690';\n}\n.fontawesome-all-min_fa-signal-alt-1__3lA8Q:before {\n  content: '\\F691';\n}\n.fontawesome-all-min_fa-signal-alt-2__1MWlv:before {\n  content: '\\F692';\n}\n.fontawesome-all-min_fa-signal-alt-3__29Zh3:before {\n  content: '\\F693';\n}\n.fontawesome-all-min_fa-signal-alt-slash__T-_U-:before {\n  content: '\\F694';\n}\n.fontawesome-all-min_fa-signal-slash__1MZjn:before {\n  content: '\\F695';\n}\n.fontawesome-all-min_fa-signature__1gcvr:before {\n  content: '\\F5B7';\n}\n.fontawesome-all-min_fa-sim-card__23j33:before {\n  content: '\\F7C4';\n}\n.fontawesome-all-min_fa-simplybuilt__2D2Fi:before {\n  content: '\\F215';\n}\n.fontawesome-all-min_fa-sistrix__10ryj:before {\n  content: '\\F3EE';\n}\n.fontawesome-all-min_fa-sitemap__3HGrk:before {\n  content: '\\F0E8';\n}\n.fontawesome-all-min_fa-sith__3D6jW:before {\n  content: '\\F512';\n}\n.fontawesome-all-min_fa-skating__1mlkv:before {\n  content: '\\F7C5';\n}\n.fontawesome-all-min_fa-skeleton__28ojj:before {\n  content: '\\F620';\n}\n.fontawesome-all-min_fa-sketch__7rwJ7:before {\n  content: '\\F7C6';\n}\n.fontawesome-all-min_fa-ski-jump__1wz7m:before {\n  content: '\\F7C7';\n}\n.fontawesome-all-min_fa-ski-lift__34Ch4:before {\n  content: '\\F7C8';\n}\n.fontawesome-all-min_fa-skiing__2r4CJ:before {\n  content: '\\F7C9';\n}\n.fontawesome-all-min_fa-skiing-nordic__3Zj9Q:before {\n  content: '\\F7CA';\n}\n.fontawesome-all-min_fa-skull__16am9:before {\n  content: '\\F54C';\n}\n.fontawesome-all-min_fa-skull-crossbones__1gsQw:before {\n  content: '\\F714';\n}\n.fontawesome-all-min_fa-skyatlas__jDER9:before {\n  content: '\\F216';\n}\n.fontawesome-all-min_fa-skype__21HMI:before {\n  content: '\\F17E';\n}\n.fontawesome-all-min_fa-slack__11CYO:before {\n  content: '\\F198';\n}\n.fontawesome-all-min_fa-slack-hash__3HAQ0:before {\n  content: '\\F3EF';\n}\n.fontawesome-all-min_fa-slash__25u_L:before {\n  content: '\\F715';\n}\n.fontawesome-all-min_fa-sledding__1mE8y:before {\n  content: '\\F7CB';\n}\n.fontawesome-all-min_fa-sleigh__1wvsQ:before {\n  content: '\\F7CC';\n}\n.fontawesome-all-min_fa-sliders-h__1dVKq:before {\n  content: '\\F1DE';\n}\n.fontawesome-all-min_fa-sliders-h-square__1FI7w:before {\n  content: '\\F3F0';\n}\n.fontawesome-all-min_fa-sliders-v__2W2IT:before {\n  content: '\\F3F1';\n}\n.fontawesome-all-min_fa-sliders-v-square__3l7a6:before {\n  content: '\\F3F2';\n}\n.fontawesome-all-min_fa-slideshare__2xyPd:before {\n  content: '\\F1E7';\n}\n.fontawesome-all-min_fa-smile__Ej8fi:before {\n  content: '\\F118';\n}\n.fontawesome-all-min_fa-smile-beam__1PnIl:before {\n  content: '\\F5B8';\n}\n.fontawesome-all-min_fa-smile-plus__1mrXJ:before {\n  content: '\\F5B9';\n}\n.fontawesome-all-min_fa-smile-wink__26YNp:before {\n  content: '\\F4DA';\n}\n.fontawesome-all-min_fa-smog__mZZJ1:before {\n  content: '\\F75F';\n}\n.fontawesome-all-min_fa-smoke__2xuuG:before {\n  content: '\\F760';\n}\n.fontawesome-all-min_fa-smoking__1mzxa:before {\n  content: '\\F48D';\n}\n.fontawesome-all-min_fa-smoking-ban__2STxO:before {\n  content: '\\F54D';\n}\n.fontawesome-all-min_fa-sms__1hkF4:before {\n  content: '\\F7CD';\n}\n.fontawesome-all-min_fa-snake__2H-Ih:before {\n  content: '\\F716';\n}\n.fontawesome-all-min_fa-snapchat__2l4TW:before {\n  content: '\\F2AB';\n}\n.fontawesome-all-min_fa-snapchat-ghost__1h4NG:before {\n  content: '\\F2AC';\n}\n.fontawesome-all-min_fa-snapchat-square__IClYw:before {\n  content: '\\F2AD';\n}\n.fontawesome-all-min_fa-snooze__1zTyX:before {\n  content: '\\F880';\n}\n.fontawesome-all-min_fa-snow-blowing__2Z9DQ:before {\n  content: '\\F761';\n}\n.fontawesome-all-min_fa-snowboarding__2MPwA:before {\n  content: '\\F7CE';\n}\n.fontawesome-all-min_fa-snowflake__1OHkF:before {\n  content: '\\F2DC';\n}\n.fontawesome-all-min_fa-snowflakes__6UWl8:before {\n  content: '\\F7CF';\n}\n.fontawesome-all-min_fa-snowman__AJ7jo:before {\n  content: '\\F7D0';\n}\n.fontawesome-all-min_fa-snowmobile__3ggv4:before {\n  content: '\\F7D1';\n}\n.fontawesome-all-min_fa-snowplow__bumMw:before {\n  content: '\\F7D2';\n}\n.fontawesome-all-min_fa-socks__2ghED:before {\n  content: '\\F696';\n}\n.fontawesome-all-min_fa-solar-panel__2QUyt:before {\n  content: '\\F5BA';\n}\n.fontawesome-all-min_fa-sort__gVhXI:before {\n  content: '\\F0DC';\n}\n.fontawesome-all-min_fa-sort-alpha-down__3sxnJ:before {\n  content: '\\F15D';\n}\n.fontawesome-all-min_fa-sort-alpha-down-alt__2-HvA:before {\n  content: '\\F881';\n}\n.fontawesome-all-min_fa-sort-alpha-up__2e4aj:before {\n  content: '\\F15E';\n}\n.fontawesome-all-min_fa-sort-alpha-up-alt__2jYOM:before {\n  content: '\\F882';\n}\n.fontawesome-all-min_fa-sort-alt__OF2ms:before {\n  content: '\\F883';\n}\n.fontawesome-all-min_fa-sort-amount-down__7PnD9:before {\n  content: '\\F160';\n}\n.fontawesome-all-min_fa-sort-amount-down-alt__3vBvm:before {\n  content: '\\F884';\n}\n.fontawesome-all-min_fa-sort-amount-up__ScM1l:before {\n  content: '\\F161';\n}\n.fontawesome-all-min_fa-sort-amount-up-alt__1IlTz:before {\n  content: '\\F885';\n}\n.fontawesome-all-min_fa-sort-down__1SvQd:before {\n  content: '\\F0DD';\n}\n.fontawesome-all-min_fa-sort-numeric-down__3KKNj:before {\n  content: '\\F162';\n}\n.fontawesome-all-min_fa-sort-numeric-down-alt__21s4W:before {\n  content: '\\F886';\n}\n.fontawesome-all-min_fa-sort-numeric-up__3hfem:before {\n  content: '\\F163';\n}\n.fontawesome-all-min_fa-sort-numeric-up-alt__3nTbd:before {\n  content: '\\F887';\n}\n.fontawesome-all-min_fa-sort-shapes-down__20CH4:before {\n  content: '\\F888';\n}\n.fontawesome-all-min_fa-sort-shapes-down-alt__3P2nc:before {\n  content: '\\F889';\n}\n.fontawesome-all-min_fa-sort-shapes-up__2IXGM:before {\n  content: '\\F88A';\n}\n.fontawesome-all-min_fa-sort-shapes-up-alt__3S5ik:before {\n  content: '\\F88B';\n}\n.fontawesome-all-min_fa-sort-size-down__1Ok0R:before {\n  content: '\\F88C';\n}\n.fontawesome-all-min_fa-sort-size-down-alt__1qXhw:before {\n  content: '\\F88D';\n}\n.fontawesome-all-min_fa-sort-size-up__209-R:before {\n  content: '\\F88E';\n}\n.fontawesome-all-min_fa-sort-size-up-alt__376Dx:before {\n  content: '\\F88F';\n}\n.fontawesome-all-min_fa-sort-up__1dtmN:before {\n  content: '\\F0DE';\n}\n.fontawesome-all-min_fa-soundcloud__3GINC:before {\n  content: '\\F1BE';\n}\n.fontawesome-all-min_fa-soup__3SNUn:before {\n  content: '\\F823';\n}\n.fontawesome-all-min_fa-sourcetree__H7XV-:before {\n  content: '\\F7D3';\n}\n.fontawesome-all-min_fa-spa__16-yD:before {\n  content: '\\F5BB';\n}\n.fontawesome-all-min_fa-space-shuttle__1DV0z:before {\n  content: '\\F197';\n}\n.fontawesome-all-min_fa-spade__oxSfC:before {\n  content: '\\F2F4';\n}\n.fontawesome-all-min_fa-sparkles__2SHjQ:before {\n  content: '\\F890';\n}\n.fontawesome-all-min_fa-speakap__1hZYm:before {\n  content: '\\F3F3';\n}\n.fontawesome-all-min_fa-speaker-deck__136tf:before {\n  content: '\\F83C';\n}\n.fontawesome-all-min_fa-spell-check__116Gq:before {\n  content: '\\F891';\n}\n.fontawesome-all-min_fa-spider__1yyXY:before {\n  content: '\\F717';\n}\n.fontawesome-all-min_fa-spider-black-widow__2IM6Q:before {\n  content: '\\F718';\n}\n.fontawesome-all-min_fa-spider-web__3OZ33:before {\n  content: '\\F719';\n}\n.fontawesome-all-min_fa-spinner__bqKl0:before {\n  content: '\\F110';\n}\n.fontawesome-all-min_fa-spinner-third__3jkI5:before {\n  content: '\\F3F4';\n}\n.fontawesome-all-min_fa-splotch__1LaVK:before {\n  content: '\\F5BC';\n}\n.fontawesome-all-min_fa-spotify__10llD:before {\n  content: '\\F1BC';\n}\n.fontawesome-all-min_fa-spray-can__10q_z:before {\n  content: '\\F5BD';\n}\n.fontawesome-all-min_fa-square__3rXJ-:before {\n  content: '\\F0C8';\n}\n.fontawesome-all-min_fa-square-full__3CFvH:before {\n  content: '\\F45C';\n}\n.fontawesome-all-min_fa-square-root__huwtp:before {\n  content: '\\F697';\n}\n.fontawesome-all-min_fa-square-root-alt__1iVRI:before {\n  content: '\\F698';\n}\n.fontawesome-all-min_fa-squarespace__1WGFV:before {\n  content: '\\F5BE';\n}\n.fontawesome-all-min_fa-squirrel__1ADXh:before {\n  content: '\\F71A';\n}\n.fontawesome-all-min_fa-stack-exchange__1k_e5:before {\n  content: '\\F18D';\n}\n.fontawesome-all-min_fa-stack-overflow__2l3Ip:before {\n  content: '\\F16C';\n}\n.fontawesome-all-min_fa-stackpath__3vCcb:before {\n  content: '\\F842';\n}\n.fontawesome-all-min_fa-staff__1wAlU:before {\n  content: '\\F71B';\n}\n.fontawesome-all-min_fa-stamp__3Pyrd:before {\n  content: '\\F5BF';\n}\n.fontawesome-all-min_fa-star__1Czty:before {\n  content: '\\F005';\n}\n.fontawesome-all-min_fa-star-and-crescent__36JsC:before {\n  content: '\\F699';\n}\n.fontawesome-all-min_fa-star-christmas__AOyjv:before {\n  content: '\\F7D4';\n}\n.fontawesome-all-min_fa-star-exclamation__2Zdba:before {\n  content: '\\F2F3';\n}\n.fontawesome-all-min_fa-star-half__1zODU:before {\n  content: '\\F089';\n}\n.fontawesome-all-min_fa-star-half-alt__2iyPX:before {\n  content: '\\F5C0';\n}\n.fontawesome-all-min_fa-star-of-david__2VWBk:before {\n  content: '\\F69A';\n}\n.fontawesome-all-min_fa-star-of-life__HPmxy:before {\n  content: '\\F621';\n}\n.fontawesome-all-min_fa-stars__2eZAk:before {\n  content: '\\F762';\n}\n.fontawesome-all-min_fa-staylinked__14z98:before {\n  content: '\\F3F5';\n}\n.fontawesome-all-min_fa-steak__1J2Jt:before {\n  content: '\\F824';\n}\n.fontawesome-all-min_fa-steam__15tXn:before {\n  content: '\\F1B6';\n}\n.fontawesome-all-min_fa-steam-square__1CFJi:before {\n  content: '\\F1B7';\n}\n.fontawesome-all-min_fa-steam-symbol__1gRjI:before {\n  content: '\\F3F6';\n}\n.fontawesome-all-min_fa-steering-wheel__1vB9J:before {\n  content: '\\F622';\n}\n.fontawesome-all-min_fa-step-backward__PqZmX:before {\n  content: '\\F048';\n}\n.fontawesome-all-min_fa-step-forward__2c-vN:before {\n  content: '\\F051';\n}\n.fontawesome-all-min_fa-stethoscope__3S-ke:before {\n  content: '\\F0F1';\n}\n.fontawesome-all-min_fa-sticker-mule__3Lb-K:before {\n  content: '\\F3F7';\n}\n.fontawesome-all-min_fa-sticky-note__TtmuO:before {\n  content: '\\F249';\n}\n.fontawesome-all-min_fa-stocking__2H6Vx:before {\n  content: '\\F7D5';\n}\n.fontawesome-all-min_fa-stomach__1KdKc:before {\n  content: '\\F623';\n}\n.fontawesome-all-min_fa-stop__2Vf0H:before {\n  content: '\\F04D';\n}\n.fontawesome-all-min_fa-stop-circle__Kbape:before {\n  content: '\\F28D';\n}\n.fontawesome-all-min_fa-stopwatch__2lLRV:before {\n  content: '\\F2F2';\n}\n.fontawesome-all-min_fa-store__EplI_:before {\n  content: '\\F54E';\n}\n.fontawesome-all-min_fa-store-alt___jMFJ:before {\n  content: '\\F54F';\n}\n.fontawesome-all-min_fa-strava__3XmVW:before {\n  content: '\\F428';\n}\n.fontawesome-all-min_fa-stream__2O1rT:before {\n  content: '\\F550';\n}\n.fontawesome-all-min_fa-street-view__3Ixh-:before {\n  content: '\\F21D';\n}\n.fontawesome-all-min_fa-stretcher__RUwO7:before {\n  content: '\\F825';\n}\n.fontawesome-all-min_fa-strikethrough__2vLDF:before {\n  content: '\\F0CC';\n}\n.fontawesome-all-min_fa-stripe__2MC7g:before {\n  content: '\\F429';\n}\n.fontawesome-all-min_fa-stripe-s__6RqtK:before {\n  content: '\\F42A';\n}\n.fontawesome-all-min_fa-stroopwafel__2bFbS:before {\n  content: '\\F551';\n}\n.fontawesome-all-min_fa-studiovinari__23bHn:before {\n  content: '\\F3F8';\n}\n.fontawesome-all-min_fa-stumbleupon__39cU6:before {\n  content: '\\F1A4';\n}\n.fontawesome-all-min_fa-stumbleupon-circle__AhoMP:before {\n  content: '\\F1A3';\n}\n.fontawesome-all-min_fa-subscript__2s_z4:before {\n  content: '\\F12C';\n}\n.fontawesome-all-min_fa-subway__2wYp4:before {\n  content: '\\F239';\n}\n.fontawesome-all-min_fa-suitcase__10j7-:before {\n  content: '\\F0F2';\n}\n.fontawesome-all-min_fa-suitcase-rolling__2-dLa:before {\n  content: '\\F5C1';\n}\n.fontawesome-all-min_fa-sun__3fLDv:before {\n  content: '\\F185';\n}\n.fontawesome-all-min_fa-sun-cloud__3LrIy:before {\n  content: '\\F763';\n}\n.fontawesome-all-min_fa-sun-dust__1zVXV:before {\n  content: '\\F764';\n}\n.fontawesome-all-min_fa-sun-haze__nNQ-B:before {\n  content: '\\F765';\n}\n.fontawesome-all-min_fa-sunglasses__2IEZT:before {\n  content: '\\F892';\n}\n.fontawesome-all-min_fa-sunrise__1N7WC:before {\n  content: '\\F766';\n}\n.fontawesome-all-min_fa-sunset__ktNw9:before {\n  content: '\\F767';\n}\n.fontawesome-all-min_fa-superpowers__3WjtG:before {\n  content: '\\F2DD';\n}\n.fontawesome-all-min_fa-superscript__3BzpU:before {\n  content: '\\F12B';\n}\n.fontawesome-all-min_fa-supple__34OOJ:before {\n  content: '\\F3F9';\n}\n.fontawesome-all-min_fa-surprise__3pxfp:before {\n  content: '\\F5C2';\n}\n.fontawesome-all-min_fa-suse__3zins:before {\n  content: '\\F7D6';\n}\n.fontawesome-all-min_fa-swatchbook__3nqXI:before {\n  content: '\\F5C3';\n}\n.fontawesome-all-min_fa-swimmer__2z_FR:before {\n  content: '\\F5C4';\n}\n.fontawesome-all-min_fa-swimming-pool__1er_Y:before {\n  content: '\\F5C5';\n}\n.fontawesome-all-min_fa-sword__1BvBL:before {\n  content: '\\F71C';\n}\n.fontawesome-all-min_fa-swords__1C-Mh:before {\n  content: '\\F71D';\n}\n.fontawesome-all-min_fa-symfony__3RtZe:before {\n  content: '\\F83D';\n}\n.fontawesome-all-min_fa-synagogue__2W2ir:before {\n  content: '\\F69B';\n}\n.fontawesome-all-min_fa-sync__3oOdm:before {\n  content: '\\F021';\n}\n.fontawesome-all-min_fa-sync-alt__1g2FZ:before {\n  content: '\\F2F1';\n}\n.fontawesome-all-min_fa-syringe__2Bitv:before {\n  content: '\\F48E';\n}\n.fontawesome-all-min_fa-table__2B5JF:before {\n  content: '\\F0CE';\n}\n.fontawesome-all-min_fa-table-tennis__1fRyw:before {\n  content: '\\F45D';\n}\n.fontawesome-all-min_fa-tablet__12wXg:before {\n  content: '\\F10A';\n}\n.fontawesome-all-min_fa-tablet-alt__3vNc4:before {\n  content: '\\F3FA';\n}\n.fontawesome-all-min_fa-tablet-android__-gECk:before {\n  content: '\\F3FB';\n}\n.fontawesome-all-min_fa-tablet-android-alt__1yQZV:before {\n  content: '\\F3FC';\n}\n.fontawesome-all-min_fa-tablet-rugged__2o1iX:before {\n  content: '\\F48F';\n}\n.fontawesome-all-min_fa-tablets__1ZLqD:before {\n  content: '\\F490';\n}\n.fontawesome-all-min_fa-tachometer__1wcRO:before {\n  content: '\\F0E4';\n}\n.fontawesome-all-min_fa-tachometer-alt__3pxKH:before {\n  content: '\\F3FD';\n}\n.fontawesome-all-min_fa-tachometer-alt-average__3s1Rl:before {\n  content: '\\F624';\n}\n.fontawesome-all-min_fa-tachometer-alt-fast__27NAX:before {\n  content: '\\F625';\n}\n.fontawesome-all-min_fa-tachometer-alt-fastest__29zpj:before {\n  content: '\\F626';\n}\n.fontawesome-all-min_fa-tachometer-alt-slow__1wYwp:before {\n  content: '\\F627';\n}\n.fontawesome-all-min_fa-tachometer-alt-slowest__Mtj4Q:before {\n  content: '\\F628';\n}\n.fontawesome-all-min_fa-tachometer-average__1TiBI:before {\n  content: '\\F629';\n}\n.fontawesome-all-min_fa-tachometer-fast__1mtr3:before {\n  content: '\\F62A';\n}\n.fontawesome-all-min_fa-tachometer-fastest__2mCst:before {\n  content: '\\F62B';\n}\n.fontawesome-all-min_fa-tachometer-slow__1SWao:before {\n  content: '\\F62C';\n}\n.fontawesome-all-min_fa-tachometer-slowest__5whAs:before {\n  content: '\\F62D';\n}\n.fontawesome-all-min_fa-taco__2RhsX:before {\n  content: '\\F826';\n}\n.fontawesome-all-min_fa-tag__1t_sp:before {\n  content: '\\F02B';\n}\n.fontawesome-all-min_fa-tags__1Fmsc:before {\n  content: '\\F02C';\n}\n.fontawesome-all-min_fa-tally__Jx2i8:before {\n  content: '\\F69C';\n}\n.fontawesome-all-min_fa-tanakh__13WV5:before {\n  content: '\\F827';\n}\n.fontawesome-all-min_fa-tape__z9jqJ:before {\n  content: '\\F4DB';\n}\n.fontawesome-all-min_fa-tasks__1nTpe:before {\n  content: '\\F0AE';\n}\n.fontawesome-all-min_fa-tasks-alt__3uzMJ:before {\n  content: '\\F828';\n}\n.fontawesome-all-min_fa-taxi__2S8LB:before {\n  content: '\\F1BA';\n}\n.fontawesome-all-min_fa-teamspeak__1Qfht:before {\n  content: '\\F4F9';\n}\n.fontawesome-all-min_fa-teeth__20FgL:before {\n  content: '\\F62E';\n}\n.fontawesome-all-min_fa-teeth-open__3jF9n:before {\n  content: '\\F62F';\n}\n.fontawesome-all-min_fa-telegram__Y4DM0:before {\n  content: '\\F2C6';\n}\n.fontawesome-all-min_fa-telegram-plane__P_638:before {\n  content: '\\F3FE';\n}\n.fontawesome-all-min_fa-temperature-frigid__Vu3V3:before {\n  content: '\\F768';\n}\n.fontawesome-all-min_fa-temperature-high__2VVFq:before {\n  content: '\\F769';\n}\n.fontawesome-all-min_fa-temperature-hot__2OjY4:before {\n  content: '\\F76A';\n}\n.fontawesome-all-min_fa-temperature-low__3dosA:before {\n  content: '\\F76B';\n}\n.fontawesome-all-min_fa-tencent-weibo__2fL9R:before {\n  content: '\\F1D5';\n}\n.fontawesome-all-min_fa-tenge__Z9tJI:before {\n  content: '\\F7D7';\n}\n.fontawesome-all-min_fa-tennis-ball__2ZJiC:before {\n  content: '\\F45E';\n}\n.fontawesome-all-min_fa-terminal__3EP8-:before {\n  content: '\\F120';\n}\n.fontawesome-all-min_fa-text__3M72L:before {\n  content: '\\F893';\n}\n.fontawesome-all-min_fa-text-height__XoGjy:before {\n  content: '\\F034';\n}\n.fontawesome-all-min_fa-text-size__357wL:before {\n  content: '\\F894';\n}\n.fontawesome-all-min_fa-text-width__1wbdv:before {\n  content: '\\F035';\n}\n.fontawesome-all-min_fa-th__2FJGN:before {\n  content: '\\F00A';\n}\n.fontawesome-all-min_fa-th-large__3jxlo:before {\n  content: '\\F009';\n}\n.fontawesome-all-min_fa-th-list__3_5wX:before {\n  content: '\\F00B';\n}\n.fontawesome-all-min_fa-the-red-yeti__3byLG:before {\n  content: '\\F69D';\n}\n.fontawesome-all-min_fa-theater-masks__32zZs:before {\n  content: '\\F630';\n}\n.fontawesome-all-min_fa-themeco__Tq022:before {\n  content: '\\F5C6';\n}\n.fontawesome-all-min_fa-themeisle__1Y_wH:before {\n  content: '\\F2B2';\n}\n.fontawesome-all-min_fa-thermometer__hc7tr:before {\n  content: '\\F491';\n}\n.fontawesome-all-min_fa-thermometer-empty__3JUqZ:before {\n  content: '\\F2CB';\n}\n.fontawesome-all-min_fa-thermometer-full__2A9zT:before {\n  content: '\\F2C7';\n}\n.fontawesome-all-min_fa-thermometer-half__2-UPD:before {\n  content: '\\F2C9';\n}\n.fontawesome-all-min_fa-thermometer-quarter__33U6u:before {\n  content: '\\F2CA';\n}\n.fontawesome-all-min_fa-thermometer-three-quarters__DvxyJ:before {\n  content: '\\F2C8';\n}\n.fontawesome-all-min_fa-theta__10Wpw:before {\n  content: '\\F69E';\n}\n.fontawesome-all-min_fa-think-peaks__3BRGT:before {\n  content: '\\F731';\n}\n.fontawesome-all-min_fa-thumbs-down__3spUj:before {\n  content: '\\F165';\n}\n.fontawesome-all-min_fa-thumbs-up__16pAO:before {\n  content: '\\F164';\n}\n.fontawesome-all-min_fa-thumbtack__sFoXJ:before {\n  content: '\\F08D';\n}\n.fontawesome-all-min_fa-thunderstorm__3AB39:before {\n  content: '\\F76C';\n}\n.fontawesome-all-min_fa-thunderstorm-moon__2OOOG:before {\n  content: '\\F76D';\n}\n.fontawesome-all-min_fa-thunderstorm-sun__3lh5D:before {\n  content: '\\F76E';\n}\n.fontawesome-all-min_fa-ticket__2bdrt:before {\n  content: '\\F145';\n}\n.fontawesome-all-min_fa-ticket-alt__33P2m:before {\n  content: '\\F3FF';\n}\n.fontawesome-all-min_fa-tilde__3hzzf:before {\n  content: '\\F69F';\n}\n.fontawesome-all-min_fa-times__js91j:before {\n  content: '\\F00D';\n}\n.fontawesome-all-min_fa-times-circle__39ZL4:before {\n  content: '\\F057';\n}\n.fontawesome-all-min_fa-times-hexagon__3pTdd:before {\n  content: '\\F2EE';\n}\n.fontawesome-all-min_fa-times-octagon__2n3iR:before {\n  content: '\\F2F0';\n}\n.fontawesome-all-min_fa-times-square__15B73:before {\n  content: '\\F2D3';\n}\n.fontawesome-all-min_fa-tint__1Ex0K:before {\n  content: '\\F043';\n}\n.fontawesome-all-min_fa-tint-slash__3eOPN:before {\n  content: '\\F5C7';\n}\n.fontawesome-all-min_fa-tire__2jOKE:before {\n  content: '\\F631';\n}\n.fontawesome-all-min_fa-tire-flat__3XGnb:before {\n  content: '\\F632';\n}\n.fontawesome-all-min_fa-tire-pressure-warning__1mblh:before {\n  content: '\\F633';\n}\n.fontawesome-all-min_fa-tire-rugged__3BOi6:before {\n  content: '\\F634';\n}\n.fontawesome-all-min_fa-tired__7A0eh:before {\n  content: '\\F5C8';\n}\n.fontawesome-all-min_fa-toggle-off__1chVa:before {\n  content: '\\F204';\n}\n.fontawesome-all-min_fa-toggle-on__7oXA7:before {\n  content: '\\F205';\n}\n.fontawesome-all-min_fa-toilet__2mYQQ:before {\n  content: '\\F7D8';\n}\n.fontawesome-all-min_fa-toilet-paper__2Gdm6:before {\n  content: '\\F71E';\n}\n.fontawesome-all-min_fa-toilet-paper-alt__ur1Xv:before {\n  content: '\\F71F';\n}\n.fontawesome-all-min_fa-tombstone__Y2jZO:before {\n  content: '\\F720';\n}\n.fontawesome-all-min_fa-tombstone-alt__2qp_t:before {\n  content: '\\F721';\n}\n.fontawesome-all-min_fa-toolbox__2y-Px:before {\n  content: '\\F552';\n}\n.fontawesome-all-min_fa-tools__2q6OZ:before {\n  content: '\\F7D9';\n}\n.fontawesome-all-min_fa-tooth__2HXd6:before {\n  content: '\\F5C9';\n}\n.fontawesome-all-min_fa-toothbrush__1DIlZ:before {\n  content: '\\F635';\n}\n.fontawesome-all-min_fa-torah__3SYLa:before {\n  content: '\\F6A0';\n}\n.fontawesome-all-min_fa-torii-gate__34UgC:before {\n  content: '\\F6A1';\n}\n.fontawesome-all-min_fa-tornado__1JsWM:before {\n  content: '\\F76F';\n}\n.fontawesome-all-min_fa-tractor__35ENA:before {\n  content: '\\F722';\n}\n.fontawesome-all-min_fa-trade-federation__1wET7:before {\n  content: '\\F513';\n}\n.fontawesome-all-min_fa-trademark__UCXAw:before {\n  content: '\\F25C';\n}\n.fontawesome-all-min_fa-traffic-cone__3qQkO:before {\n  content: '\\F636';\n}\n.fontawesome-all-min_fa-traffic-light__2QLo3:before {\n  content: '\\F637';\n}\n.fontawesome-all-min_fa-traffic-light-go__3JPVx:before {\n  content: '\\F638';\n}\n.fontawesome-all-min_fa-traffic-light-slow__1BvlL:before {\n  content: '\\F639';\n}\n.fontawesome-all-min_fa-traffic-light-stop__KNx7P:before {\n  content: '\\F63A';\n}\n.fontawesome-all-min_fa-train__sfMAi:before {\n  content: '\\F238';\n}\n.fontawesome-all-min_fa-tram__TYcZr:before {\n  content: '\\F7DA';\n}\n.fontawesome-all-min_fa-transgender__1RPWA:before {\n  content: '\\F224';\n}\n.fontawesome-all-min_fa-transgender-alt__33-9I:before {\n  content: '\\F225';\n}\n.fontawesome-all-min_fa-trash__yzH_Y:before {\n  content: '\\F1F8';\n}\n.fontawesome-all-min_fa-trash-alt__zUvJi:before {\n  content: '\\F2ED';\n}\n.fontawesome-all-min_fa-trash-restore__3F4Ir:before {\n  content: '\\F829';\n}\n.fontawesome-all-min_fa-trash-restore-alt__27rMw:before {\n  content: '\\F82A';\n}\n.fontawesome-all-min_fa-trash-undo__1xvQY:before {\n  content: '\\F895';\n}\n.fontawesome-all-min_fa-trash-undo-alt__1MMAf:before {\n  content: '\\F896';\n}\n.fontawesome-all-min_fa-treasure-chest__3CLfN:before {\n  content: '\\F723';\n}\n.fontawesome-all-min_fa-tree__2UWAn:before {\n  content: '\\F1BB';\n}\n.fontawesome-all-min_fa-tree-alt__3jztp:before {\n  content: '\\F400';\n}\n.fontawesome-all-min_fa-tree-christmas__21QJt:before {\n  content: '\\F7DB';\n}\n.fontawesome-all-min_fa-tree-decorated__1-d5F:before {\n  content: '\\F7DC';\n}\n.fontawesome-all-min_fa-tree-large__1OFod:before {\n  content: '\\F7DD';\n}\n.fontawesome-all-min_fa-tree-palm__1aVo_:before {\n  content: '\\F82B';\n}\n.fontawesome-all-min_fa-trees__V-3HH:before {\n  content: '\\F724';\n}\n.fontawesome-all-min_fa-trello__3gALC:before {\n  content: '\\F181';\n}\n.fontawesome-all-min_fa-triangle__3hNw2:before {\n  content: '\\F2EC';\n}\n.fontawesome-all-min_fa-tripadvisor__32YrD:before {\n  content: '\\F262';\n}\n.fontawesome-all-min_fa-trophy__1jEfn:before {\n  content: '\\F091';\n}\n.fontawesome-all-min_fa-trophy-alt__3w2au:before {\n  content: '\\F2EB';\n}\n.fontawesome-all-min_fa-truck__2dHoH:before {\n  content: '\\F0D1';\n}\n.fontawesome-all-min_fa-truck-container__301hR:before {\n  content: '\\F4DC';\n}\n.fontawesome-all-min_fa-truck-couch__1Qx5q:before {\n  content: '\\F4DD';\n}\n.fontawesome-all-min_fa-truck-loading__1BajF:before {\n  content: '\\F4DE';\n}\n.fontawesome-all-min_fa-truck-monster__2tgW8:before {\n  content: '\\F63B';\n}\n.fontawesome-all-min_fa-truck-moving__31M_H:before {\n  content: '\\F4DF';\n}\n.fontawesome-all-min_fa-truck-pickup__3CFNn:before {\n  content: '\\F63C';\n}\n.fontawesome-all-min_fa-truck-plow__1udMY:before {\n  content: '\\F7DE';\n}\n.fontawesome-all-min_fa-truck-ramp__2U-l4:before {\n  content: '\\F4E0';\n}\n.fontawesome-all-min_fa-tshirt__1Yinz:before {\n  content: '\\F553';\n}\n.fontawesome-all-min_fa-tty__11RML:before {\n  content: '\\F1E4';\n}\n.fontawesome-all-min_fa-tumblr__aahBd:before {\n  content: '\\F173';\n}\n.fontawesome-all-min_fa-tumblr-square__3kppv:before {\n  content: '\\F174';\n}\n.fontawesome-all-min_fa-turkey__DzXQR:before {\n  content: '\\F725';\n}\n.fontawesome-all-min_fa-turtle__1uJrN:before {\n  content: '\\F726';\n}\n.fontawesome-all-min_fa-tv__1gAdF:before {\n  content: '\\F26C';\n}\n.fontawesome-all-min_fa-tv-retro__3dEti:before {\n  content: '\\F401';\n}\n.fontawesome-all-min_fa-twitch__2TRL1:before {\n  content: '\\F1E8';\n}\n.fontawesome-all-min_fa-twitter__2HV6e:before {\n  content: '\\F099';\n}\n.fontawesome-all-min_fa-twitter-square__2Tu1p:before {\n  content: '\\F081';\n}\n.fontawesome-all-min_fa-typo3__3FziV:before {\n  content: '\\F42B';\n}\n.fontawesome-all-min_fa-uber__DvcLn:before {\n  content: '\\F402';\n}\n.fontawesome-all-min_fa-ubuntu__3One4:before {\n  content: '\\F7DF';\n}\n.fontawesome-all-min_fa-uikit__2eDEi:before {\n  content: '\\F403';\n}\n.fontawesome-all-min_fa-umbrella__3zvlR:before {\n  content: '\\F0E9';\n}\n.fontawesome-all-min_fa-umbrella-beach__1bXda:before {\n  content: '\\F5CA';\n}\n.fontawesome-all-min_fa-underline__121Nc:before {\n  content: '\\F0CD';\n}\n.fontawesome-all-min_fa-undo__1EhnP:before {\n  content: '\\F0E2';\n}\n.fontawesome-all-min_fa-undo-alt__QzlGE:before {\n  content: '\\F2EA';\n}\n.fontawesome-all-min_fa-unicorn__3rJgz:before {\n  content: '\\F727';\n}\n.fontawesome-all-min_fa-union__1TYET:before {\n  content: '\\F6A2';\n}\n.fontawesome-all-min_fa-uniregistry__3x7ip:before {\n  content: '\\F404';\n}\n.fontawesome-all-min_fa-universal-access__3tqBD:before {\n  content: '\\F29A';\n}\n.fontawesome-all-min_fa-university__iJNr1:before {\n  content: '\\F19C';\n}\n.fontawesome-all-min_fa-unlink__Ms-5B:before {\n  content: '\\F127';\n}\n.fontawesome-all-min_fa-unlock__SwrdW:before {\n  content: '\\F09C';\n}\n.fontawesome-all-min_fa-unlock-alt__gPGoe:before {\n  content: '\\F13E';\n}\n.fontawesome-all-min_fa-untappd__3JW7A:before {\n  content: '\\F405';\n}\n.fontawesome-all-min_fa-upload__2xgm5:before {\n  content: '\\F093';\n}\n.fontawesome-all-min_fa-ups__SlMYC:before {\n  content: '\\F7E0';\n}\n.fontawesome-all-min_fa-usb__1CAfj:before {\n  content: '\\F287';\n}\n.fontawesome-all-min_fa-usd-circle__2haLn:before {\n  content: '\\F2E8';\n}\n.fontawesome-all-min_fa-usd-square__2D3Pq:before {\n  content: '\\F2E9';\n}\n.fontawesome-all-min_fa-user__Bd6al:before {\n  content: '\\F007';\n}\n.fontawesome-all-min_fa-user-alt__9jsoa:before {\n  content: '\\F406';\n}\n.fontawesome-all-min_fa-user-alt-slash__21XRh:before {\n  content: '\\F4FA';\n}\n.fontawesome-all-min_fa-user-astronaut__TpI6o:before {\n  content: '\\F4FB';\n}\n.fontawesome-all-min_fa-user-chart__1lepx:before {\n  content: '\\F6A3';\n}\n.fontawesome-all-min_fa-user-check__2aOPc:before {\n  content: '\\F4FC';\n}\n.fontawesome-all-min_fa-user-circle__x0ba-:before {\n  content: '\\F2BD';\n}\n.fontawesome-all-min_fa-user-clock__lGHgA:before {\n  content: '\\F4FD';\n}\n.fontawesome-all-min_fa-user-cog__tr5CN:before {\n  content: '\\F4FE';\n}\n.fontawesome-all-min_fa-user-crown__1N0PE:before {\n  content: '\\F6A4';\n}\n.fontawesome-all-min_fa-user-edit__3WpZ_:before {\n  content: '\\F4FF';\n}\n.fontawesome-all-min_fa-user-friends__13XHq:before {\n  content: '\\F500';\n}\n.fontawesome-all-min_fa-user-graduate__2Q6St:before {\n  content: '\\F501';\n}\n.fontawesome-all-min_fa-user-hard-hat__1Xr0P:before {\n  content: '\\F82C';\n}\n.fontawesome-all-min_fa-user-headset__2ifSK:before {\n  content: '\\F82D';\n}\n.fontawesome-all-min_fa-user-injured__1juR-:before {\n  content: '\\F728';\n}\n.fontawesome-all-min_fa-user-lock__3ri4g:before {\n  content: '\\F502';\n}\n.fontawesome-all-min_fa-user-md__2jAFa:before {\n  content: '\\F0F0';\n}\n.fontawesome-all-min_fa-user-md-chat__3ut1b:before {\n  content: '\\F82E';\n}\n.fontawesome-all-min_fa-user-minus__1gXdg:before {\n  content: '\\F503';\n}\n.fontawesome-all-min_fa-user-ninja__OyQrk:before {\n  content: '\\F504';\n}\n.fontawesome-all-min_fa-user-nurse__2HUmT:before {\n  content: '\\F82F';\n}\n.fontawesome-all-min_fa-user-plus__W3Zt0:before {\n  content: '\\F234';\n}\n.fontawesome-all-min_fa-user-secret__3tn92:before {\n  content: '\\F21B';\n}\n.fontawesome-all-min_fa-user-shield__fmVc5:before {\n  content: '\\F505';\n}\n.fontawesome-all-min_fa-user-slash__1nK8m:before {\n  content: '\\F506';\n}\n.fontawesome-all-min_fa-user-tag__1RPY5:before {\n  content: '\\F507';\n}\n.fontawesome-all-min_fa-user-tie__1G4mG:before {\n  content: '\\F508';\n}\n.fontawesome-all-min_fa-user-times__1rBsk:before {\n  content: '\\F235';\n}\n.fontawesome-all-min_fa-users__26OlC:before {\n  content: '\\F0C0';\n}\n.fontawesome-all-min_fa-users-class__lIfU5:before {\n  content: '\\F63D';\n}\n.fontawesome-all-min_fa-users-cog__3NNow:before {\n  content: '\\F509';\n}\n.fontawesome-all-min_fa-users-crown__fY_NP:before {\n  content: '\\F6A5';\n}\n.fontawesome-all-min_fa-users-medical__1Eth8:before {\n  content: '\\F830';\n}\n.fontawesome-all-min_fa-usps__1iEEI:before {\n  content: '\\F7E1';\n}\n.fontawesome-all-min_fa-ussunnah__1ZhGj:before {\n  content: '\\F407';\n}\n.fontawesome-all-min_fa-utensil-fork__1QEZi:before {\n  content: '\\F2E3';\n}\n.fontawesome-all-min_fa-utensil-knife__3fBmG:before {\n  content: '\\F2E4';\n}\n.fontawesome-all-min_fa-utensil-spoon__MvNUq:before {\n  content: '\\F2E5';\n}\n.fontawesome-all-min_fa-utensils__3hDpn:before {\n  content: '\\F2E7';\n}\n.fontawesome-all-min_fa-utensils-alt__QD0-I:before {\n  content: '\\F2E6';\n}\n.fontawesome-all-min_fa-vaadin__qp-cF:before {\n  content: '\\F408';\n}\n.fontawesome-all-min_fa-value-absolute__2PS3R:before {\n  content: '\\F6A6';\n}\n.fontawesome-all-min_fa-vector-square__Ey6kA:before {\n  content: '\\F5CB';\n}\n.fontawesome-all-min_fa-venus__2D-Ul:before {\n  content: '\\F221';\n}\n.fontawesome-all-min_fa-venus-double__3DOgc:before {\n  content: '\\F226';\n}\n.fontawesome-all-min_fa-venus-mars__3NDMa:before {\n  content: '\\F228';\n}\n.fontawesome-all-min_fa-viacoin__qkcou:before {\n  content: '\\F237';\n}\n.fontawesome-all-min_fa-viadeo__PuTcz:before {\n  content: '\\F2A9';\n}\n.fontawesome-all-min_fa-viadeo-square__3T4p2:before {\n  content: '\\F2AA';\n}\n.fontawesome-all-min_fa-vial__JKMHm:before {\n  content: '\\F492';\n}\n.fontawesome-all-min_fa-vials__2TQpz:before {\n  content: '\\F493';\n}\n.fontawesome-all-min_fa-viber__3S1__:before {\n  content: '\\F409';\n}\n.fontawesome-all-min_fa-video__1QGv3:before {\n  content: '\\F03D';\n}\n.fontawesome-all-min_fa-video-plus__2vmSj:before {\n  content: '\\F4E1';\n}\n.fontawesome-all-min_fa-video-slash__RF-Me:before {\n  content: '\\F4E2';\n}\n.fontawesome-all-min_fa-vihara__3JzOM:before {\n  content: '\\F6A7';\n}\n.fontawesome-all-min_fa-vimeo__3Eh3F:before {\n  content: '\\F40A';\n}\n.fontawesome-all-min_fa-vimeo-square__3wtBp:before {\n  content: '\\F194';\n}\n.fontawesome-all-min_fa-vimeo-v__1ptOI:before {\n  content: '\\F27D';\n}\n.fontawesome-all-min_fa-vine__2OKbk:before {\n  content: '\\F1CA';\n}\n.fontawesome-all-min_fa-vk__1J5_L:before {\n  content: '\\F189';\n}\n.fontawesome-all-min_fa-vnv__14VuA:before {\n  content: '\\F40B';\n}\n.fontawesome-all-min_fa-voicemail__3q4Hq:before {\n  content: '\\F897';\n}\n.fontawesome-all-min_fa-volcano__209XS:before {\n  content: '\\F770';\n}\n.fontawesome-all-min_fa-volleyball-ball__23oNq:before {\n  content: '\\F45F';\n}\n.fontawesome-all-min_fa-volume__12J9G:before {\n  content: '\\F6A8';\n}\n.fontawesome-all-min_fa-volume-down__3RKZ_:before {\n  content: '\\F027';\n}\n.fontawesome-all-min_fa-volume-mute__H_Y50:before {\n  content: '\\F6A9';\n}\n.fontawesome-all-min_fa-volume-off__3-nT9:before {\n  content: '\\F026';\n}\n.fontawesome-all-min_fa-volume-slash__DwuQJ:before {\n  content: '\\F2E2';\n}\n.fontawesome-all-min_fa-volume-up__1bFw2:before {\n  content: '\\F028';\n}\n.fontawesome-all-min_fa-vote-nay__rZpM2:before {\n  content: '\\F771';\n}\n.fontawesome-all-min_fa-vote-yea__1Rk9Z:before {\n  content: '\\F772';\n}\n.fontawesome-all-min_fa-vr-cardboard__3x2BG:before {\n  content: '\\F729';\n}\n.fontawesome-all-min_fa-vuejs__36jYF:before {\n  content: '\\F41F';\n}\n.fontawesome-all-min_fa-walker__2howx:before {\n  content: '\\F831';\n}\n.fontawesome-all-min_fa-walking__3NupO:before {\n  content: '\\F554';\n}\n.fontawesome-all-min_fa-wallet__1eANE:before {\n  content: '\\F555';\n}\n.fontawesome-all-min_fa-wand__3mXwZ:before {\n  content: '\\F72A';\n}\n.fontawesome-all-min_fa-wand-magic__3wzpi:before {\n  content: '\\F72B';\n}\n.fontawesome-all-min_fa-warehouse__2GgLO:before {\n  content: '\\F494';\n}\n.fontawesome-all-min_fa-warehouse-alt__1XSW2:before {\n  content: '\\F495';\n}\n.fontawesome-all-min_fa-washer__13jZN:before {\n  content: '\\F898';\n}\n.fontawesome-all-min_fa-watch__dFyVQ:before {\n  content: '\\F2E1';\n}\n.fontawesome-all-min_fa-watch-fitness__1LneL:before {\n  content: '\\F63E';\n}\n.fontawesome-all-min_fa-water__17DT0:before {\n  content: '\\F773';\n}\n.fontawesome-all-min_fa-water-lower__3qqd6:before {\n  content: '\\F774';\n}\n.fontawesome-all-min_fa-water-rise__2IFGh:before {\n  content: '\\F775';\n}\n.fontawesome-all-min_fa-wave-sine__3SCNt:before {\n  content: '\\F899';\n}\n.fontawesome-all-min_fa-wave-square__S0BIF:before {\n  content: '\\F83E';\n}\n.fontawesome-all-min_fa-wave-triangle__2om7_:before {\n  content: '\\F89A';\n}\n.fontawesome-all-min_fa-waze__1uoBq:before {\n  content: '\\F83F';\n}\n.fontawesome-all-min_fa-webcam__2-8uB:before {\n  content: '\\F832';\n}\n.fontawesome-all-min_fa-webcam-slash__1Tl4O:before {\n  content: '\\F833';\n}\n.fontawesome-all-min_fa-weebly__3p1_Q:before {\n  content: '\\F5CC';\n}\n.fontawesome-all-min_fa-weibo__38jWK:before {\n  content: '\\F18A';\n}\n.fontawesome-all-min_fa-weight__1sucL:before {\n  content: '\\F496';\n}\n.fontawesome-all-min_fa-weight-hanging__12GXr:before {\n  content: '\\F5CD';\n}\n.fontawesome-all-min_fa-weixin__2UrNX:before {\n  content: '\\F1D7';\n}\n.fontawesome-all-min_fa-whale__CC8Iy:before {\n  content: '\\F72C';\n}\n.fontawesome-all-min_fa-whatsapp__2S6DP:before {\n  content: '\\F232';\n}\n.fontawesome-all-min_fa-whatsapp-square__EyfdQ:before {\n  content: '\\F40C';\n}\n.fontawesome-all-min_fa-wheat__14Ebq:before {\n  content: '\\F72D';\n}\n.fontawesome-all-min_fa-wheelchair__1vmY2:before {\n  content: '\\F193';\n}\n.fontawesome-all-min_fa-whistle__2uPsO:before {\n  content: '\\F460';\n}\n.fontawesome-all-min_fa-whmcs__2u1gl:before {\n  content: '\\F40D';\n}\n.fontawesome-all-min_fa-wifi__ZNdqA:before {\n  content: '\\F1EB';\n}\n.fontawesome-all-min_fa-wifi-1__3jg9H:before {\n  content: '\\F6AA';\n}\n.fontawesome-all-min_fa-wifi-2__2XBnV:before {\n  content: '\\F6AB';\n}\n.fontawesome-all-min_fa-wifi-slash__2WN7X:before {\n  content: '\\F6AC';\n}\n.fontawesome-all-min_fa-wikipedia-w__Ui4Ft:before {\n  content: '\\F266';\n}\n.fontawesome-all-min_fa-wind__zgMJz:before {\n  content: '\\F72E';\n}\n.fontawesome-all-min_fa-wind-turbine__1jRhF:before {\n  content: '\\F89B';\n}\n.fontawesome-all-min_fa-wind-warning__2vcPX:before {\n  content: '\\F776';\n}\n.fontawesome-all-min_fa-window__P67Wh:before {\n  content: '\\F40E';\n}\n.fontawesome-all-min_fa-window-alt__TJWS5:before {\n  content: '\\F40F';\n}\n.fontawesome-all-min_fa-window-close__2WAn3:before {\n  content: '\\F410';\n}\n.fontawesome-all-min_fa-window-maximize__494yt:before {\n  content: '\\F2D0';\n}\n.fontawesome-all-min_fa-window-minimize__2tCzS:before {\n  content: '\\F2D1';\n}\n.fontawesome-all-min_fa-window-restore__1EsTt:before {\n  content: '\\F2D2';\n}\n.fontawesome-all-min_fa-windows__2KUsd:before {\n  content: '\\F17A';\n}\n.fontawesome-all-min_fa-windsock__13ECW:before {\n  content: '\\F777';\n}\n.fontawesome-all-min_fa-wine-bottle__2Bk8O:before {\n  content: '\\F72F';\n}\n.fontawesome-all-min_fa-wine-glass__2_HiY:before {\n  content: '\\F4E3';\n}\n.fontawesome-all-min_fa-wine-glass-alt__3Aeuo:before {\n  content: '\\F5CE';\n}\n.fontawesome-all-min_fa-wix__2fPg5:before {\n  content: '\\F5CF';\n}\n.fontawesome-all-min_fa-wizards-of-the-coast__36Lp8:before {\n  content: '\\F730';\n}\n.fontawesome-all-min_fa-wolf-pack-battalion__2UPxz:before {\n  content: '\\F514';\n}\n.fontawesome-all-min_fa-won-sign__2ENE2:before {\n  content: '\\F159';\n}\n.fontawesome-all-min_fa-wordpress__2a0rW:before {\n  content: '\\F19A';\n}\n.fontawesome-all-min_fa-wordpress-simple__2QukU:before {\n  content: '\\F411';\n}\n.fontawesome-all-min_fa-wpbeginner__3zhxx:before {\n  content: '\\F297';\n}\n.fontawesome-all-min_fa-wpexplorer__2YhoX:before {\n  content: '\\F2DE';\n}\n.fontawesome-all-min_fa-wpforms__1CjBw:before {\n  content: '\\F298';\n}\n.fontawesome-all-min_fa-wpressr__cpmvO:before {\n  content: '\\F3E4';\n}\n.fontawesome-all-min_fa-wreath__2mRn5:before {\n  content: '\\F7E2';\n}\n.fontawesome-all-min_fa-wrench__34Mh7:before {\n  content: '\\F0AD';\n}\n.fontawesome-all-min_fa-x-ray__12_rz:before {\n  content: '\\F497';\n}\n.fontawesome-all-min_fa-xbox__M6wEw:before {\n  content: '\\F412';\n}\n.fontawesome-all-min_fa-xing__2wyWf:before {\n  content: '\\F168';\n}\n.fontawesome-all-min_fa-xing-square__i1MTN:before {\n  content: '\\F169';\n}\n.fontawesome-all-min_fa-y-combinator__kTKCH:before {\n  content: '\\F23B';\n}\n.fontawesome-all-min_fa-yahoo__2XqWS:before {\n  content: '\\F19E';\n}\n.fontawesome-all-min_fa-yammer__3Pd9r:before {\n  content: '\\F840';\n}\n.fontawesome-all-min_fa-yandex__1MqWP:before {\n  content: '\\F413';\n}\n.fontawesome-all-min_fa-yandex-international__Tov4d:before {\n  content: '\\F414';\n}\n.fontawesome-all-min_fa-yarn__cncmJ:before {\n  content: '\\F7E3';\n}\n.fontawesome-all-min_fa-yelp__2uJnB:before {\n  content: '\\F1E9';\n}\n.fontawesome-all-min_fa-yen-sign__Sy7v9:before {\n  content: '\\F157';\n}\n.fontawesome-all-min_fa-yin-yang__3rSVd:before {\n  content: '\\F6AD';\n}\n.fontawesome-all-min_fa-yoast__17FAt:before {\n  content: '\\F2B1';\n}\n.fontawesome-all-min_fa-youtube__1Nqp9:before {\n  content: '\\F167';\n}\n.fontawesome-all-min_fa-youtube-square__63vAp:before {\n  content: '\\F431';\n}\n.fontawesome-all-min_fa-zhihu__1GsFC:before {\n  content: '\\F63F';\n}\n.fontawesome-all-min_sr-only__3j-Bg {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n.fontawesome-all-min_sr-only-focusable__S8jeh:active,\n.fontawesome-all-min_sr-only-focusable__S8jeh:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n@font-face {\n  font-family: 'Font Awesome 5 Brands';\n  font-style: normal;\n  font-weight: normal;\n  font-display: auto;\n  src: url(../fonts/fa/fa-brands-400.eot);\n  src: url(../fonts/fa/fa-brands-400.eot?#iefix) format('embedded-opentype'),\n    url(../fonts/fa/fa-brands-400.woff2) format('woff2'), url(../fonts/fa/fa-brands-400.woff) format('woff'),\n    url(../fonts/fa/fa-brands-400.ttf) format('truetype'), url(../fonts/fa/fa-brands-400.svg#fontawesome) format('svg');\n}\n.fontawesome-all-min_fab__2R3sl {\n  font-family: 'Font Awesome 5 Brands';\n}\n@font-face {\n  font-family: 'Font Awesome 5 Duotone';\n  font-style: normal;\n  font-weight: 900;\n  font-display: auto;\n  src: url(../fonts/fa/fa-duotone-900.eot);\n  src: url(../fonts/fa/fa-duotone-900.eot?#iefix) format('embedded-opentype'),\n    url(../fonts/fa/fa-duotone-900.woff2) format('woff2'), url(../fonts/fa/fa-duotone-900.woff) format('woff'),\n    url(../fonts/fa/fa-duotone-900.ttf) format('truetype'),\n    url(../fonts/fa/fa-duotone-900.svg#fontawesome) format('svg');\n}\n.fontawesome-all-min_fad__46Ygp {\n  position: relative;\n  font-family: 'Font Awesome 5 Duotone';\n  font-weight: 900;\n}\n.fontawesome-all-min_fad__46Ygp:before {\n  position: absolute;\n  color: var(--fa-primary-color, inherit);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n.fontawesome-all-min_fad__46Ygp:after {\n  color: var(--fa-secondary-color, inherit);\n}\n.fontawesome-all-min_fa-swap-opacity__2TNLI .fontawesome-all-min_fad__46Ygp:before,\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-swap-opacity__2TNLI:before,\n.fontawesome-all-min_fad__46Ygp:after {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n.fontawesome-all-min_fa-swap-opacity__2TNLI .fontawesome-all-min_fad__46Ygp:after,\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-swap-opacity__2TNLI:after {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-inverse__u-3vQ {\n  color: #fff;\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stack-1x__wL62i,\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stack-2x__1OqYg {\n  position: absolute;\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fw__3MaQZ:before,\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stack-1x__wL62i:before,\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stack-2x__1OqYg:before {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-abacus__13ZNc:after {\n  content: '\\10F640';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-acorn__16I_N:after {\n  content: '\\10F6AE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ad__1G7RH:after {\n  content: '\\10F641';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-address-book__2eU5r:after {\n  content: '\\10F2B9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-address-card__2zHEE:after {\n  content: '\\10F2BB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-adjust__CFqNP:after {\n  content: '\\10F042';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-air-freshener__2r-XC:after {\n  content: '\\10F5D0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-alarm-clock__UU3zO:after {\n  content: '\\10F34E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-alarm-exclamation__25oSb:after {\n  content: '\\10F843';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-alarm-plus__BovTv:after {\n  content: '\\10F844';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-alarm-snooze__1B7nA:after {\n  content: '\\10F845';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-alicorn__gMUQy:after {\n  content: '\\10F6B0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-align-center__tq6cz:after {\n  content: '\\10F037';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-align-justify__nmtR3:after {\n  content: '\\10F039';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-align-left__7vxH-:after {\n  content: '\\10F036';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-align-right__1mpdU:after {\n  content: '\\10F038';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-align-slash__AHLxV:after {\n  content: '\\10F846';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-allergies__sk3KQ:after {\n  content: '\\10F461';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ambulance__2bod8:after {\n  content: '\\10F0F9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-american-sign-language-interpreting__3cpAU:after {\n  content: '\\10F2A3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-analytics__2KmLY:after {\n  content: '\\10F643';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-anchor__2LJy-:after {\n  content: '\\10F13D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-angel__LCi1C:after {\n  content: '\\10F779';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-angle-double-down__cWP7g:after {\n  content: '\\10F103';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-angle-double-left__1nn0X:after {\n  content: '\\10F100';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-angle-double-right__16zpD:after {\n  content: '\\10F101';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-angle-double-up__23GJ2:after {\n  content: '\\10F102';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-angle-down__3_iuJ:after {\n  content: '\\10F107';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-angle-left__15m5f:after {\n  content: '\\10F104';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-angle-right__1RkR9:after {\n  content: '\\10F105';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-angle-up__Gowfu:after {\n  content: '\\10F106';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-angry__3xNgk:after {\n  content: '\\10F556';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ankh__2eCaS:after {\n  content: '\\10F644';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-apple-alt__2TIPN:after {\n  content: '\\10F5D1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-apple-crate__3xBEB:after {\n  content: '\\10F6B1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-archive__1OMUc:after {\n  content: '\\10F187';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-archway__2YB0s:after {\n  content: '\\10F557';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-circle-down__zo5JQ:after {\n  content: '\\10F358';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-circle-left__1kmyp:after {\n  content: '\\10F359';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-circle-right__MiygU:after {\n  content: '\\10F35A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-circle-up__Ky3un:after {\n  content: '\\10F35B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-down__3NV4O:after {\n  content: '\\10F354';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-from-bottom__1N0r5:after {\n  content: '\\10F346';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-from-left__2JsaK:after {\n  content: '\\10F347';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-from-right__7R7mz:after {\n  content: '\\10F348';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-from-top__27I_j:after {\n  content: '\\10F349';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-left__1aiLl:after {\n  content: '\\10F355';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-right__1L5lG:after {\n  content: '\\10F356';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-square-down__GqM5B:after {\n  content: '\\10F350';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-square-left__32Olz:after {\n  content: '\\10F351';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-square-right__5OCNV:after {\n  content: '\\10F352';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-square-up__3vGGi:after {\n  content: '\\10F353';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-to-bottom__3DOp_:after {\n  content: '\\10F34A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-to-left__2T6Kx:after {\n  content: '\\10F34B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-to-right__3W0mc:after {\n  content: '\\10F34C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-to-top__14gX7:after {\n  content: '\\10F34D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-alt-up__3hBg9:after {\n  content: '\\10F357';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-circle-down__1p-M0:after {\n  content: '\\10F0AB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-circle-left__B1c6F:after {\n  content: '\\10F0A8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-circle-right__3uw7b:after {\n  content: '\\10F0A9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-circle-up__-R6F5:after {\n  content: '\\10F0AA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-down__3nzPq:after {\n  content: '\\10F063';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-from-bottom__M2vFi:after {\n  content: '\\10F342';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-from-left__XFAQs:after {\n  content: '\\10F343';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-from-right__1MxQ6:after {\n  content: '\\10F344';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-from-top__1h1O7:after {\n  content: '\\10F345';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-left__39v15:after {\n  content: '\\10F060';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-right__Jz5uZ:after {\n  content: '\\10F061';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-square-down__rDmR7:after {\n  content: '\\10F339';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-square-left__lUlq3:after {\n  content: '\\10F33A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-square-right__2IXdP:after {\n  content: '\\10F33B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-square-up__3WtCQ:after {\n  content: '\\10F33C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-to-bottom__1px7E:after {\n  content: '\\10F33D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-to-left__Cb8_n:after {\n  content: '\\10F33E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-to-right__wS7b1:after {\n  content: '\\10F340';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-to-top__2xC_2:after {\n  content: '\\10F341';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrow-up__2ElFi:after {\n  content: '\\10F062';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrows__1Dn46:after {\n  content: '\\10F047';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrows-alt__1eJp5:after {\n  content: '\\10F0B2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrows-alt-h__2P6Ze:after {\n  content: '\\10F337';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrows-alt-v__38hYl:after {\n  content: '\\10F338';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrows-h__3e3oX:after {\n  content: '\\10F07E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-arrows-v__3Entu:after {\n  content: '\\10F07D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-assistive-listening-systems__NU1-x:after {\n  content: '\\10F2A2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-asterisk__2vtLh:after {\n  content: '\\10F069';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-at__3S0zc:after {\n  content: '\\10F1FA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-atlas__n72aV:after {\n  content: '\\10F558';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-atom__3U5wc:after {\n  content: '\\10F5D2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-atom-alt__6msHU:after {\n  content: '\\10F5D3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-audio-description__3y-gY:after {\n  content: '\\10F29E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-award__1WH7c:after {\n  content: '\\10F559';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-axe__1OjZh:after {\n  content: '\\10F6B2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-axe-battle__3q8nk:after {\n  content: '\\10F6B3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-baby__GxZ0p:after {\n  content: '\\10F77C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-baby-carriage__3d6rB:after {\n  content: '\\10F77D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-backpack__17nL9:after {\n  content: '\\10F5D4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-backspace__ceFza:after {\n  content: '\\10F55A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-backward__1-8Ir:after {\n  content: '\\10F04A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bacon__3NOUL:after {\n  content: '\\10F7E5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-badge__21oqB:after {\n  content: '\\10F335';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-badge-check__28fwG:after {\n  content: '\\10F336';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-badge-dollar__1uvHs:after {\n  content: '\\10F645';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-badge-percent__3fhyl:after {\n  content: '\\10F646';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-badger-honey__1bVKB:after {\n  content: '\\10F6B4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bags-shopping__2YeBT:after {\n  content: '\\10F847';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-balance-scale__18eED:after {\n  content: '\\10F24E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-balance-scale-left__vC94f:after {\n  content: '\\10F515';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-balance-scale-right__1b6_0:after {\n  content: '\\10F516';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ball-pile__2JrxQ:after {\n  content: '\\10F77E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ballot__1Vo65:after {\n  content: '\\10F732';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ballot-check__2o44s:after {\n  content: '\\10F733';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ban__1ddug:after {\n  content: '\\10F05E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-band-aid__2chWM:after {\n  content: '\\10F462';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-barcode__1euuG:after {\n  content: '\\10F02A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-barcode-alt__3qVhR:after {\n  content: '\\10F463';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-barcode-read__3h0v1:after {\n  content: '\\10F464';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-barcode-scan__3CCic:after {\n  content: '\\10F465';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bars__2Y8Hz:after {\n  content: '\\10F0C9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-baseball__1StXW:after {\n  content: '\\10F432';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-baseball-ball__13B-c:after {\n  content: '\\10F433';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-basketball-ball__1acwH:after {\n  content: '\\10F434';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-basketball-hoop__2O4DM:after {\n  content: '\\10F435';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bat__3mt1P:after {\n  content: '\\10F6B5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bath__2prqM:after {\n  content: '\\10F2CD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-battery-bolt__5pCUa:after {\n  content: '\\10F376';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-battery-empty__RJhJJ:after {\n  content: '\\10F244';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-battery-full__1tzwM:after {\n  content: '\\10F240';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-battery-half__JlaVa:after {\n  content: '\\10F242';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-battery-quarter__f71cV:after {\n  content: '\\10F243';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-battery-slash__1bdsd:after {\n  content: '\\10F377';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-battery-three-quarters__3x21G:after {\n  content: '\\10F241';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bed__3pzdl:after {\n  content: '\\10F236';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-beer__3-jWz:after {\n  content: '\\10F0FC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bell__2dhYb:after {\n  content: '\\10F0F3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bell-exclamation__1sQja:after {\n  content: '\\10F848';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bell-plus__1JdGk:after {\n  content: '\\10F849';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bell-school__3nbnN:after {\n  content: '\\10F5D5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bell-school-slash__3qOef:after {\n  content: '\\10F5D6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bell-slash__2h9r_:after {\n  content: '\\10F1F6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bells__3wBd8:after {\n  content: '\\10F77F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bezier-curve__34MqU:after {\n  content: '\\10F55B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bible__1uYFR:after {\n  content: '\\10F647';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bicycle__3A37_:after {\n  content: '\\10F206';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-biking__3wKAa:after {\n  content: '\\10F84A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-biking-mountain__1z42_:after {\n  content: '\\10F84B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-binoculars__Kbh-y:after {\n  content: '\\10F1E5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-biohazard__1Ms15:after {\n  content: '\\10F780';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-birthday-cake__2iEL9:after {\n  content: '\\10F1FD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-blanket__1e1LD:after {\n  content: '\\10F498';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-blender__3sVS7:after {\n  content: '\\10F517';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-blender-phone__3vFKt:after {\n  content: '\\10F6B6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-blind__1o19d:after {\n  content: '\\10F29D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-blog__2PVy4:after {\n  content: '\\10F781';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bold__1mYHv:after {\n  content: '\\10F032';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bolt__1I_Bt:after {\n  content: '\\10F0E7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bomb__1k0r5:after {\n  content: '\\10F1E2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bone__1Z9R6:after {\n  content: '\\10F5D7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bone-break__3fEb9:after {\n  content: '\\10F5D8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bong__It2fT:after {\n  content: '\\10F55C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-book__3gb6L:after {\n  content: '\\10F02D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-book-alt__25-5F:after {\n  content: '\\10F5D9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-book-dead__2vcd2:after {\n  content: '\\10F6B7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-book-heart__1NkxO:after {\n  content: '\\10F499';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-book-medical__2YmrU:after {\n  content: '\\10F7E6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-book-open__worc8:after {\n  content: '\\10F518';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-book-reader__1rENq:after {\n  content: '\\10F5DA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-book-spells__2WXjj:after {\n  content: '\\10F6B8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-book-user__3CMFU:after {\n  content: '\\10F7E7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bookmark__nGNCL:after {\n  content: '\\10F02E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-books__2UzUI:after {\n  content: '\\10F5DB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-books-medical__1jFB9:after {\n  content: '\\10F7E8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-boot__3uDSR:after {\n  content: '\\10F782';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-booth-curtain__1--4z:after {\n  content: '\\10F734';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-all__8cscS:after {\n  content: '\\10F84C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-bottom__3TTK3:after {\n  content: '\\10F84D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-center-h__2_O8D:after {\n  content: '\\10F89C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-center-v__1cxxT:after {\n  content: '\\10F89D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-inner__2kwUD:after {\n  content: '\\10F84E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-left__3vTB8:after {\n  content: '\\10F84F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-none__2teSq:after {\n  content: '\\10F850';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-outer__30juG:after {\n  content: '\\10F851';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-right__25aXI:after {\n  content: '\\10F852';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-style__3R8Dt:after {\n  content: '\\10F853';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-style-alt__1PPdo:after {\n  content: '\\10F854';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-border-top__CPnxQ:after {\n  content: '\\10F855';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bow-arrow__3Kgve:after {\n  content: '\\10F6B9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bowling-ball__2aa2R:after {\n  content: '\\10F436';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bowling-pins__1oV0w:after {\n  content: '\\10F437';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-box__2bkf-:after {\n  content: '\\10F466';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-box-alt__15h3n:after {\n  content: '\\10F49A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-box-ballot__3t1_o:after {\n  content: '\\10F735';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-box-check__2Sf6_:after {\n  content: '\\10F467';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-box-fragile__3K3M4:after {\n  content: '\\10F49B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-box-full__1yAmL:after {\n  content: '\\10F49C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-box-heart__3jxeM:after {\n  content: '\\10F49D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-box-open__3Duzz:after {\n  content: '\\10F49E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-box-up__1Q4bU:after {\n  content: '\\10F49F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-box-usd__3wGM3:after {\n  content: '\\10F4A0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-boxes__2aCrY:after {\n  content: '\\10F468';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-boxes-alt__zJWMP:after {\n  content: '\\10F4A1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-boxing-glove__3KNBg:after {\n  content: '\\10F438';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-brackets__3oF56:after {\n  content: '\\10F7E9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-brackets-curly__b7OR8:after {\n  content: '\\10F7EA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-braille__3BFv5:after {\n  content: '\\10F2A1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-brain__6ciSj:after {\n  content: '\\10F5DC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bread-loaf__3bVe5:after {\n  content: '\\10F7EB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bread-slice__2-ljO:after {\n  content: '\\10F7EC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-briefcase__1Gn43:after {\n  content: '\\10F0B1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-briefcase-medical__34pz8:after {\n  content: '\\10F469';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bring-forward__1NSwN:after {\n  content: '\\10F856';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bring-front__1RQJy:after {\n  content: '\\10F857';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-broadcast-tower__3PcVw:after {\n  content: '\\10F519';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-broom__7VfCG:after {\n  content: '\\10F51A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-browser__SXC32:after {\n  content: '\\10F37E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-brush__3Bgn9:after {\n  content: '\\10F55D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bug__3F8G5:after {\n  content: '\\10F188';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-building__18KED:after {\n  content: '\\10F1AD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bullhorn__1prfc:after {\n  content: '\\10F0A1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bullseye__32vre:after {\n  content: '\\10F140';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bullseye-arrow__2Ifhw:after {\n  content: '\\10F648';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bullseye-pointer__20Q9v:after {\n  content: '\\10F649';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-burger-soda__2vfli:after {\n  content: '\\10F858';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-burn__1Fwux:after {\n  content: '\\10F46A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-burrito__32RUA:after {\n  content: '\\10F7ED';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bus__36lOM:after {\n  content: '\\10F207';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bus-alt__142Mp:after {\n  content: '\\10F55E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-bus-school__2264p:after {\n  content: '\\10F5DD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-business-time__3ARvS:after {\n  content: '\\10F64A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cabinet-filing__2qE5X:after {\n  content: '\\10F64B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calculator__1QDsO:after {\n  content: '\\10F1EC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calculator-alt__1hWWc:after {\n  content: '\\10F64C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar__1-G3Y:after {\n  content: '\\10F133';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar-alt__1uRgF:after {\n  content: '\\10F073';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar-check__3Fc2j:after {\n  content: '\\10F274';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar-day__MdEU6:after {\n  content: '\\10F783';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar-edit__1bCm3:after {\n  content: '\\10F333';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar-exclamation__1UH78:after {\n  content: '\\10F334';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar-minus__1agIP:after {\n  content: '\\10F272';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar-plus__1frPh:after {\n  content: '\\10F271';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar-star__k9lC_:after {\n  content: '\\10F736';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar-times__U9LDD:after {\n  content: '\\10F273';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-calendar-week__2843H:after {\n  content: '\\10F784';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-camera__1L7lB:after {\n  content: '\\10F030';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-camera-alt__3KTu5:after {\n  content: '\\10F332';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-camera-retro__WM8YA:after {\n  content: '\\10F083';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-campfire__LcG4X:after {\n  content: '\\10F6BA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-campground__JlA4F:after {\n  content: '\\10F6BB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-candle-holder__1V7Zb:after {\n  content: '\\10F6BC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-candy-cane__1Fffd:after {\n  content: '\\10F786';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-candy-corn__JBaeu:after {\n  content: '\\10F6BD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cannabis__5gcq_:after {\n  content: '\\10F55F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-capsules__28MFq:after {\n  content: '\\10F46B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car__3eACn:after {\n  content: '\\10F1B9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-alt__2h2l8:after {\n  content: '\\10F5DE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-battery__2Vaww:after {\n  content: '\\10F5DF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-building__3hGCq:after {\n  content: '\\10F859';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-bump__Av3Xf:after {\n  content: '\\10F5E0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-bus__26qXH:after {\n  content: '\\10F85A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-crash__1BPgG:after {\n  content: '\\10F5E1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-garage__2fXC9:after {\n  content: '\\10F5E2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-mechanic__AvPZY:after {\n  content: '\\10F5E3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-side__1bj_R:after {\n  content: '\\10F5E4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-tilt__1633m:after {\n  content: '\\10F5E5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-car-wash__37bQ-:after {\n  content: '\\10F5E6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-circle-down__2ZYHq:after {\n  content: '\\10F32D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-circle-left__D8mSf:after {\n  content: '\\10F32E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-circle-right__ZvKCJ:after {\n  content: '\\10F330';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-circle-up__2ZNJY:after {\n  content: '\\10F331';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-down__1ipSZ:after {\n  content: '\\10F0D7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-left__38xPV:after {\n  content: '\\10F0D9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-right__rrae-:after {\n  content: '\\10F0DA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-square-down__3oI4p:after {\n  content: '\\10F150';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-square-left__Ayh-E:after {\n  content: '\\10F191';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-square-right__3xdCb:after {\n  content: '\\10F152';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-square-up__3Mahv:after {\n  content: '\\10F151';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-caret-up__1hPKc:after {\n  content: '\\10F0D8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-carrot__YIwFZ:after {\n  content: '\\10F787';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cars__12s8O:after {\n  content: '\\10F85B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cart-arrow-down__12Nx5:after {\n  content: '\\10F218';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cart-plus__1MANs:after {\n  content: '\\10F217';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cash-register__3Mk2d:after {\n  content: '\\10F788';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cat__1gCXe:after {\n  content: '\\10F6BE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cauldron__1A3nJ:after {\n  content: '\\10F6BF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-certificate__2aSAY:after {\n  content: '\\10F0A3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chair__10SwP:after {\n  content: '\\10F6C0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chair-office__3i5uw:after {\n  content: '\\10F6C1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chalkboard__Wzofs:after {\n  content: '\\10F51B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chalkboard-teacher__3btim:after {\n  content: '\\10F51C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-charging-station__FiKX5:after {\n  content: '\\10F5E7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chart-area__b5MhJ:after {\n  content: '\\10F1FE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chart-bar__yBCsb:after {\n  content: '\\10F080';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chart-line__2Wznu:after {\n  content: '\\10F201';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chart-line-down__2msDa:after {\n  content: '\\10F64D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chart-network__3DfnA:after {\n  content: '\\10F78A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chart-pie__1jxrT:after {\n  content: '\\10F200';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chart-pie-alt__1nySx:after {\n  content: '\\10F64E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chart-scatter__1nrHg:after {\n  content: '\\10F7EE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-check__3IYeD:after {\n  content: '\\10F00C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-check-circle__2XixQ:after {\n  content: '\\10F058';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-check-double__TQEjz:after {\n  content: '\\10F560';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-check-square__3upGc:after {\n  content: '\\10F14A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cheese__32U2k:after {\n  content: '\\10F7EF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cheese-swiss__1_9Gj:after {\n  content: '\\10F7F0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cheeseburger__LqNBP:after {\n  content: '\\10F7F1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess__XUs4u:after {\n  content: '\\10F439';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-bishop__1l9kE:after {\n  content: '\\10F43A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-bishop-alt__3O5JE:after {\n  content: '\\10F43B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-board__1w7-8:after {\n  content: '\\10F43C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-clock__3r4z3:after {\n  content: '\\10F43D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-clock-alt__3HjqV:after {\n  content: '\\10F43E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-king__3q1mD:after {\n  content: '\\10F43F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-king-alt__3-FTN:after {\n  content: '\\10F440';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-knight__1LpqL:after {\n  content: '\\10F441';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-knight-alt__3cLzO:after {\n  content: '\\10F442';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-pawn__27mZZ:after {\n  content: '\\10F443';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-pawn-alt__3wT5m:after {\n  content: '\\10F444';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-queen__1wLNI:after {\n  content: '\\10F445';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-queen-alt__1EJ50:after {\n  content: '\\10F446';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-rook__ArebW:after {\n  content: '\\10F447';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chess-rook-alt__1Gs4e:after {\n  content: '\\10F448';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-circle-down__3cJ7k:after {\n  content: '\\10F13A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-circle-left__1-FP-:after {\n  content: '\\10F137';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-circle-right__2pBA9:after {\n  content: '\\10F138';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-circle-up__1eD0B:after {\n  content: '\\10F139';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-double-down__2Yt53:after {\n  content: '\\10F322';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-double-left__V7UYO:after {\n  content: '\\10F323';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-double-right__2bZnc:after {\n  content: '\\10F324';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-double-up__2colD:after {\n  content: '\\10F325';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-down__1SKuX:after {\n  content: '\\10F078';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-left__Y_CF_:after {\n  content: '\\10F053';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-right__2O5pH:after {\n  content: '\\10F054';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-square-down__1T5QK:after {\n  content: '\\10F329';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-square-left__3hIRA:after {\n  content: '\\10F32A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-square-right__3KFfC:after {\n  content: '\\10F32B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-square-up__3oIWv:after {\n  content: '\\10F32C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chevron-up__3FZ54:after {\n  content: '\\10F077';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-child__zCp6M:after {\n  content: '\\10F1AE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-chimney__3XCYE:after {\n  content: '\\10F78B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-church__2NNOT:after {\n  content: '\\10F51D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-circle__3Etzd:after {\n  content: '\\10F111';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-circle-notch__XHOgN:after {\n  content: '\\10F1CE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-city__38vDr:after {\n  content: '\\10F64F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-claw-marks__3ZmBZ:after {\n  content: '\\10F6C2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clinic-medical__m7I1C:after {\n  content: '\\10F7F2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clipboard__1rbO7:after {\n  content: '\\10F328';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clipboard-check__3jXVa:after {\n  content: '\\10F46C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clipboard-list__33597:after {\n  content: '\\10F46D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clipboard-list-check__PTIg_:after {\n  content: '\\10F737';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clipboard-prescription__cpj_W:after {\n  content: '\\10F5E8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clipboard-user__ZrG_Q:after {\n  content: '\\10F7F3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clock__18Zb5:after {\n  content: '\\10F017';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clone__3DMrO:after {\n  content: '\\10F24D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-closed-captioning__1XHh0:after {\n  content: '\\10F20A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud__H3yHi:after {\n  content: '\\10F0C2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-download__3m2K3:after {\n  content: '\\10F0ED';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-download-alt__Z8Qe7:after {\n  content: '\\10F381';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-drizzle__3Mn77:after {\n  content: '\\10F738';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-hail__rX2Ig:after {\n  content: '\\10F739';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-hail-mixed__3dm-e:after {\n  content: '\\10F73A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-meatball__3BoGL:after {\n  content: '\\10F73B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-moon__3m88c:after {\n  content: '\\10F6C3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-moon-rain__iksrY:after {\n  content: '\\10F73C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-rain__DINgN:after {\n  content: '\\10F73D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-rainbow__3IirY:after {\n  content: '\\10F73E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-showers__2tz3z:after {\n  content: '\\10F73F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-showers-heavy__3-qie:after {\n  content: '\\10F740';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-sleet__1aJhJ:after {\n  content: '\\10F741';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-snow__2Pa5Z:after {\n  content: '\\10F742';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-sun__1qH_N:after {\n  content: '\\10F6C4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-sun-rain__290TK:after {\n  content: '\\10F743';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-upload__3ieQ2:after {\n  content: '\\10F0EE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cloud-upload-alt__1Jn7z:after {\n  content: '\\10F382';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clouds__3WFA4:after {\n  content: '\\10F744';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clouds-moon__2u-Sk:after {\n  content: '\\10F745';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-clouds-sun__t3cgJ:after {\n  content: '\\10F746';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-club__1y8bd:after {\n  content: '\\10F327';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cocktail__o5ey9:after {\n  content: '\\10F561';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-code__oIeNj:after {\n  content: '\\10F121';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-code-branch__3MisO:after {\n  content: '\\10F126';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-code-commit__2nE96:after {\n  content: '\\10F386';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-code-merge__2ftns:after {\n  content: '\\10F387';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-coffee__1VGNw:after {\n  content: '\\10F0F4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-coffee-togo__nwYS2:after {\n  content: '\\10F6C5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-coffin__Xv5Zo:after {\n  content: '\\10F6C6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cog__2CdJ4:after {\n  content: '\\10F013';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cogs__1qXcx:after {\n  content: '\\10F085';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-coin__2ufz0:after {\n  content: '\\10F85C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-coins__T5WFS:after {\n  content: '\\10F51E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-columns__2QZcJ:after {\n  content: '\\10F0DB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment__1BoCK:after {\n  content: '\\10F075';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt__3nKWg:after {\n  content: '\\10F27A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-check__12oZo:after {\n  content: '\\10F4A2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-dollar__1-_Ar:after {\n  content: '\\10F650';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-dots__1YPv7:after {\n  content: '\\10F4A3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-edit__2Ev7W:after {\n  content: '\\10F4A4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-exclamation__1Zjup:after {\n  content: '\\10F4A5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-lines__1-eCV:after {\n  content: '\\10F4A6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-medical__2Ozts:after {\n  content: '\\10F7F4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-minus__3Hx-1:after {\n  content: '\\10F4A7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-plus__3eeSE:after {\n  content: '\\10F4A8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-slash__13EPT:after {\n  content: '\\10F4A9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-smile__2W9F6:after {\n  content: '\\10F4AA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-alt-times__13Ams:after {\n  content: '\\10F4AB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-check__TlGaB:after {\n  content: '\\10F4AC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-dollar__1ROqz:after {\n  content: '\\10F651';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-dots__3LOvH:after {\n  content: '\\10F4AD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-edit__1Nluq:after {\n  content: '\\10F4AE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-exclamation__3Txjl:after {\n  content: '\\10F4AF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-lines__1_GvT:after {\n  content: '\\10F4B0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-medical__1nTe3:after {\n  content: '\\10F7F5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-minus__TV5vt:after {\n  content: '\\10F4B1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-plus__3q01w:after {\n  content: '\\10F4B2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-slash__1mYt2:after {\n  content: '\\10F4B3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-smile__1ImEa:after {\n  content: '\\10F4B4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comment-times__3Cpbk:after {\n  content: '\\10F4B5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comments__2iC84:after {\n  content: '\\10F086';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comments-alt__1pfuz:after {\n  content: '\\10F4B6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comments-alt-dollar__1GgWj:after {\n  content: '\\10F652';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-comments-dollar__1oUPN:after {\n  content: '\\10F653';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-compact-disc__P79QZ:after {\n  content: '\\10F51F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-compass__17aUS:after {\n  content: '\\10F14E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-compass-slash__16pps:after {\n  content: '\\10F5E9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-compress__3mlWI:after {\n  content: '\\10F066';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-compress-alt__8TylJ:after {\n  content: '\\10F422';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-compress-arrows-alt__3PlQD:after {\n  content: '\\10F78C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-compress-wide__3JKSr:after {\n  content: '\\10F326';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-concierge-bell__2qqDe:after {\n  content: '\\10F562';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-construction__UA_ex:after {\n  content: '\\10F85D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-container-storage__2OWJ4:after {\n  content: '\\10F4B7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-conveyor-belt__1TnR1:after {\n  content: '\\10F46E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-conveyor-belt-alt__1TVhi:after {\n  content: '\\10F46F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cookie__2B-Af:after {\n  content: '\\10F563';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cookie-bite__KKabJ:after {\n  content: '\\10F564';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-copy__3TNuh:after {\n  content: '\\10F0C5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-copyright__24IQj:after {\n  content: '\\10F1F9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-corn__1HMSR:after {\n  content: '\\10F6C7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-couch__2EbSV:after {\n  content: '\\10F4B8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cow__NzVmW:after {\n  content: '\\10F6C8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-credit-card__2qGC6:after {\n  content: '\\10F09D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-credit-card-blank__nIykQ:after {\n  content: '\\10F389';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-credit-card-front__3286O:after {\n  content: '\\10F38A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cricket__9SyUn:after {\n  content: '\\10F449';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-croissant__1k6h0:after {\n  content: '\\10F7F6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-crop__3D1B_:after {\n  content: '\\10F125';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-crop-alt__1wOAQ:after {\n  content: '\\10F565';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cross__2SzGJ:after {\n  content: '\\10F654';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-crosshairs__3bJAk:after {\n  content: '\\10F05B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-crow__1mGfX:after {\n  content: '\\10F520';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-crown__2tj0b:after {\n  content: '\\10F521';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-crutch__3s3Jz:after {\n  content: '\\10F7F7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-crutches__1p3CR:after {\n  content: '\\10F7F8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cube__XQMGQ:after {\n  content: '\\10F1B2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cubes__2KJXC:after {\n  content: '\\10F1B3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-curling__1-5yl:after {\n  content: '\\10F44A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-cut__1dzwA:after {\n  content: '\\10F0C4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dagger__27sX5:after {\n  content: '\\10F6CB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-database__3Umhv:after {\n  content: '\\10F1C0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-deaf__IOw58:after {\n  content: '\\10F2A4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-debug__3YRsf:after {\n  content: '\\10F7F9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-deer__1PYKU:after {\n  content: '\\10F78E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-deer-rudolph__2acU6:after {\n  content: '\\10F78F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-democrat__1ySAm:after {\n  content: '\\10F747';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-desktop__SbWlN:after {\n  content: '\\10F108';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-desktop-alt__3Smpe:after {\n  content: '\\10F390';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dewpoint__1Y9cg:after {\n  content: '\\10F748';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dharmachakra__CWglU:after {\n  content: '\\10F655';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-diagnoses__1XClF:after {\n  content: '\\10F470';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-diamond__1BxuB:after {\n  content: '\\10F219';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice__1X01d:after {\n  content: '\\10F522';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-d10__3uet4:after {\n  content: '\\10F6CD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-d12__2hQsm:after {\n  content: '\\10F6CE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-d20__2j1fS:after {\n  content: '\\10F6CF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-d4__20gZ1:after {\n  content: '\\10F6D0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-d6__2RqEL:after {\n  content: '\\10F6D1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-d8__oqzQM:after {\n  content: '\\10F6D2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-five__2ZkO4:after {\n  content: '\\10F523';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-four__pcaqw:after {\n  content: '\\10F524';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-one__69GqS:after {\n  content: '\\10F525';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-six__1KD3s:after {\n  content: '\\10F526';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-three__Jn-_S:after {\n  content: '\\10F527';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dice-two__3O6Qa:after {\n  content: '\\10F528';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-digging__2I8UH:after {\n  content: '\\10F85E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-digital-tachograph__1lSfY:after {\n  content: '\\10F566';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-diploma__GyyLH:after {\n  content: '\\10F5EA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-directions__jAd2E:after {\n  content: '\\10F5EB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-disease__3Qfb0:after {\n  content: '\\10F7FA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-divide__2Wm2C:after {\n  content: '\\10F529';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dizzy__189eC:after {\n  content: '\\10F567';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dna__R6Wq1:after {\n  content: '\\10F471';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-do-not-enter__m4Ujf:after {\n  content: '\\10F5EC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dog__2LZ-D:after {\n  content: '\\10F6D3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dog-leashed__3ralt:after {\n  content: '\\10F6D4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dollar-sign__32AJM:after {\n  content: '\\10F155';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dolly__1fk4Q:after {\n  content: '\\10F472';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dolly-empty__1BtWs:after {\n  content: '\\10F473';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dolly-flatbed__1rIV4:after {\n  content: '\\10F474';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dolly-flatbed-alt__1gl8k:after {\n  content: '\\10F475';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dolly-flatbed-empty__3xkMX:after {\n  content: '\\10F476';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-donate__3obsk:after {\n  content: '\\10F4B9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-door-closed__1P4Ei:after {\n  content: '\\10F52A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-door-open__29agg:after {\n  content: '\\10F52B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dot-circle__3WgEv:after {\n  content: '\\10F192';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dove__2L11j:after {\n  content: '\\10F4BA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-download__1-hb7:after {\n  content: '\\10F019';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-drafting-compass__1MbRV:after {\n  content: '\\10F568';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dragon__VJv8a:after {\n  content: '\\10F6D5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-draw-circle__3T4oA:after {\n  content: '\\10F5ED';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-draw-polygon__3tRTc:after {\n  content: '\\10F5EE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-draw-square__UBkoV:after {\n  content: '\\10F5EF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dreidel__235yv:after {\n  content: '\\10F792';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-drone__2VQ4I:after {\n  content: '\\10F85F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-drone-alt__38sAF:after {\n  content: '\\10F860';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-drum__3JhoW:after {\n  content: '\\10F569';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-drum-steelpan__3xms2:after {\n  content: '\\10F56A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-drumstick__2QyBA:after {\n  content: '\\10F6D6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-drumstick-bite__1wVxr:after {\n  content: '\\10F6D7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dryer__3YdrF:after {\n  content: '\\10F861';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dryer-alt__s8LaU:after {\n  content: '\\10F862';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-duck__3BfnX:after {\n  content: '\\10F6D8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dumbbell__1JTwS:after {\n  content: '\\10F44B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dumpster__83yF6:after {\n  content: '\\10F793';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dumpster-fire__3QDOW:after {\n  content: '\\10F794';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-dungeon__wZ5fu:after {\n  content: '\\10F6D9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ear__1H-0K:after {\n  content: '\\10F5F0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ear-muffs__2ibtA:after {\n  content: '\\10F795';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-eclipse__svxW0:after {\n  content: '\\10F749';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-eclipse-alt__3QyXt:after {\n  content: '\\10F74A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-edit__3XB_e:after {\n  content: '\\10F044';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-egg__1NzzN:after {\n  content: '\\10F7FB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-egg-fried__3GjlG:after {\n  content: '\\10F7FC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-eject__3e9__:after {\n  content: '\\10F052';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-elephant__29av_:after {\n  content: '\\10F6DA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ellipsis-h__11NTJ:after {\n  content: '\\10F141';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ellipsis-h-alt__3hfhS:after {\n  content: '\\10F39B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ellipsis-v__1BIgn:after {\n  content: '\\10F142';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ellipsis-v-alt__1nts8:after {\n  content: '\\10F39C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-empty-set__1BHAc:after {\n  content: '\\10F656';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-engine-warning__XBl4S:after {\n  content: '\\10F5F2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-envelope__3v5Xa:after {\n  content: '\\10F0E0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-envelope-open__1_ohI:after {\n  content: '\\10F2B6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-envelope-open-dollar__4-Txj:after {\n  content: '\\10F657';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-envelope-open-text__1KBbH:after {\n  content: '\\10F658';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-envelope-square__3GvQg:after {\n  content: '\\10F199';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-equals__BwBb-:after {\n  content: '\\10F52C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-eraser__uy_hQ:after {\n  content: '\\10F12D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ethernet__11Q7t:after {\n  content: '\\10F796';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-euro-sign__1TYU-:after {\n  content: '\\10F153';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-exchange__WHEym:after {\n  content: '\\10F0EC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-exchange-alt__38Rq2:after {\n  content: '\\10F362';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-exclamation__311pb:after {\n  content: '\\10F12A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-exclamation-circle__3Wpl0:after {\n  content: '\\10F06A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-exclamation-square__2Z_rC:after {\n  content: '\\10F321';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-exclamation-triangle__3VmXJ:after {\n  content: '\\10F071';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-expand__3k2pU:after {\n  content: '\\10F065';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-expand-alt__2EDTT:after {\n  content: '\\10F424';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-expand-arrows__2JGkT:after {\n  content: '\\10F31D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-expand-arrows-alt__3-L4H:after {\n  content: '\\10F31E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-expand-wide__e25dW:after {\n  content: '\\10F320';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-external-link__IffFC:after {\n  content: '\\10F08E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-external-link-alt__ORAtl:after {\n  content: '\\10F35D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-external-link-square__2sINh:after {\n  content: '\\10F14C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-external-link-square-alt__2Ic1m:after {\n  content: '\\10F360';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-eye__2TogO:after {\n  content: '\\10F06E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-eye-dropper__3zWNe:after {\n  content: '\\10F1FB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-eye-evil__3Eflh:after {\n  content: '\\10F6DB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-eye-slash__qwb0Q:after {\n  content: '\\10F070';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fan__2eXyx:after {\n  content: '\\10F863';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-farm__3_z5B:after {\n  content: '\\10F864';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fast-backward__3XM3Z:after {\n  content: '\\10F049';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fast-forward__2WBU5:after {\n  content: '\\10F050';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fax__1gRwm:after {\n  content: '\\10F1AC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-feather__MZWb6:after {\n  content: '\\10F52D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-feather-alt__8dqJt:after {\n  content: '\\10F56B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-female__1SGKO:after {\n  content: '\\10F182';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-field-hockey__KTEqi:after {\n  content: '\\10F44C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fighter-jet__29foC:after {\n  content: '\\10F0FB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file__2qHZZ:after {\n  content: '\\10F15B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-alt__MbqRF:after {\n  content: '\\10F15C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-archive__3YhnR:after {\n  content: '\\10F1C6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-audio__1hLm0:after {\n  content: '\\10F1C7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-certificate__24EbA:after {\n  content: '\\10F5F3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-chart-line__2fFni:after {\n  content: '\\10F659';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-chart-pie__e2TUt:after {\n  content: '\\10F65A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-check__2KaGB:after {\n  content: '\\10F316';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-code__36nbs:after {\n  content: '\\10F1C9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-contract__2mKfc:after {\n  content: '\\10F56C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-csv__LMAfN:after {\n  content: '\\10F6DD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-download__1GvmB:after {\n  content: '\\10F56D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-edit__1ch2j:after {\n  content: '\\10F31C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-excel__dH6QE:after {\n  content: '\\10F1C3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-exclamation__3QjL9:after {\n  content: '\\10F31A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-export__3Zhfo:after {\n  content: '\\10F56E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-image__1b1r2:after {\n  content: '\\10F1C5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-import__5wDcJ:after {\n  content: '\\10F56F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-invoice__3BO_F:after {\n  content: '\\10F570';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-invoice-dollar__1j-el:after {\n  content: '\\10F571';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-medical__1__Dd:after {\n  content: '\\10F477';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-medical-alt__3ERJe:after {\n  content: '\\10F478';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-minus__n5Sb2:after {\n  content: '\\10F318';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-pdf__3qgPP:after {\n  content: '\\10F1C1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-plus__3WJFj:after {\n  content: '\\10F319';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-powerpoint__4NnVa:after {\n  content: '\\10F1C4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-prescription__1bnS_:after {\n  content: '\\10F572';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-search__2wqQC:after {\n  content: '\\10F865';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-signature__veQER:after {\n  content: '\\10F573';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-spreadsheet__3DwL7:after {\n  content: '\\10F65B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-times__2I2xh:after {\n  content: '\\10F317';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-upload__1nqNG:after {\n  content: '\\10F574';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-user__3iDYa:after {\n  content: '\\10F65C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-video__2LLWe:after {\n  content: '\\10F1C8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-file-word__3dlFK:after {\n  content: '\\10F1C2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-files-medical__2NRar:after {\n  content: '\\10F7FD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fill__2wK8r:after {\n  content: '\\10F575';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fill-drip__YwrgZ:after {\n  content: '\\10F576';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-film__1-TWv:after {\n  content: '\\10F008';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-film-alt__Uwb9c:after {\n  content: '\\10F3A0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-filter__YY3DW:after {\n  content: '\\10F0B0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fingerprint__1dWIj:after {\n  content: '\\10F577';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fire__2RD4e:after {\n  content: '\\10F06D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fire-alt__1k921:after {\n  content: '\\10F7E4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fire-extinguisher__GYL6k:after {\n  content: '\\10F134';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fire-smoke__3hUHp:after {\n  content: '\\10F74B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fireplace__YR9jZ:after {\n  content: '\\10F79A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-first-aid__2JLYv:after {\n  content: '\\10F479';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fish__2-JS3:after {\n  content: '\\10F578';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fish-cooked__3elt2:after {\n  content: '\\10F7FE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fist-raised__1M1-y:after {\n  content: '\\10F6DE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flag__39JS8:after {\n  content: '\\10F024';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flag-alt__CeslX:after {\n  content: '\\10F74C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flag-checkered__1xreO:after {\n  content: '\\10F11E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flag-usa__1697B:after {\n  content: '\\10F74D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flame__1CY4v:after {\n  content: '\\10F6DF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flask___DANW:after {\n  content: '\\10F0C3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flask-poison__1wVms:after {\n  content: '\\10F6E0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flask-potion__TTbSe:after {\n  content: '\\10F6E1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flower__2QJ7H:after {\n  content: '\\10F7FF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flower-daffodil__1wOfJ:after {\n  content: '\\10F800';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flower-tulip__3nITk:after {\n  content: '\\10F801';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-flushed__1cpBb:after {\n  content: '\\10F579';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fog__2ZAUC:after {\n  content: '\\10F74E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-folder__iKK1s:after {\n  content: '\\10F07B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-folder-minus__37CQS:after {\n  content: '\\10F65D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-folder-open__24Z1M:after {\n  content: '\\10F07C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-folder-plus__1PWvb:after {\n  content: '\\10F65E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-folder-times__2k_yr:after {\n  content: '\\10F65F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-folder-tree__2DM0j:after {\n  content: '\\10F802';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-folders__J3Mvy:after {\n  content: '\\10F660';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-font__25-wG:after {\n  content: '\\10F031';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-font-awesome-logo-full__55_Qj:after {\n  content: '\\10F4E6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-font-case__zSyRM:after {\n  content: '\\10F866';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-football-ball__3DGrr:after {\n  content: '\\10F44E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-football-helmet__3-EbJ:after {\n  content: '\\10F44F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-forklift__Cz6FP:after {\n  content: '\\10F47A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-forward__3Y3_X:after {\n  content: '\\10F04E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-fragile__2S0_f:after {\n  content: '\\10F4BB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-french-fries__1gmhD:after {\n  content: '\\10F803';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-frog__12OGC:after {\n  content: '\\10F52E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-frosty-head__1eB8y:after {\n  content: '\\10F79B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-frown__3uaO4:after {\n  content: '\\10F119';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-frown-open__sCois:after {\n  content: '\\10F57A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-function__3SYHu:after {\n  content: '\\10F661';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-funnel-dollar__3q4cr:after {\n  content: '\\10F662';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-futbol__81vlX:after {\n  content: '\\10F1E3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-game-board__3q5Im:after {\n  content: '\\10F867';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-game-board-alt__3RPe6:after {\n  content: '\\10F868';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-gamepad__CCsjJ:after {\n  content: '\\10F11B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-gas-pump__1BfqV:after {\n  content: '\\10F52F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-gas-pump-slash__3P4Me:after {\n  content: '\\10F5F4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-gavel__2mU_R:after {\n  content: '\\10F0E3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-gem__1ozo4:after {\n  content: '\\10F3A5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-genderless__1x6B4:after {\n  content: '\\10F22D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ghost__3fcms:after {\n  content: '\\10F6E2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-gift__3Kr1k:after {\n  content: '\\10F06B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-gift-card__Cuzov:after {\n  content: '\\10F663';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-gifts__1EjfV:after {\n  content: '\\10F79C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-gingerbread-man__9fpUB:after {\n  content: '\\10F79D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-glass__3Qtzu:after {\n  content: '\\10F804';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-glass-champagne__1WExe:after {\n  content: '\\10F79E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-glass-cheers__1fPAw:after {\n  content: '\\10F79F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-glass-citrus__3k_VL:after {\n  content: '\\10F869';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-glass-martini__u72ET:after {\n  content: '\\10F000';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-glass-martini-alt__182_t:after {\n  content: '\\10F57B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-glass-whiskey__2xunl:after {\n  content: '\\10F7A0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-glass-whiskey-rocks__1rgyC:after {\n  content: '\\10F7A1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-glasses__2YPwK:after {\n  content: '\\10F530';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-glasses-alt__3nIhv:after {\n  content: '\\10F5F5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-globe__2ZMmh:after {\n  content: '\\10F0AC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-globe-africa__3M9A3:after {\n  content: '\\10F57C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-globe-americas__7BTyB:after {\n  content: '\\10F57D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-globe-asia__3gROa:after {\n  content: '\\10F57E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-globe-europe__kRlQt:after {\n  content: '\\10F7A2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-globe-snow__h36TL:after {\n  content: '\\10F7A3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-globe-stand__2Vgrq:after {\n  content: '\\10F5F6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-golf-ball__235QF:after {\n  content: '\\10F450';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-golf-club__3p-Dw:after {\n  content: '\\10F451';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-gopuram__3yOO3:after {\n  content: '\\10F664';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-graduation-cap__2mq9v:after {\n  content: '\\10F19D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-greater-than__k7mpH:after {\n  content: '\\10F531';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-greater-than-equal__3Sbi8:after {\n  content: '\\10F532';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grimace__3JegM:after {\n  content: '\\10F57F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin__35TtP:after {\n  content: '\\10F580';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-alt__2ZRqp:after {\n  content: '\\10F581';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-beam__dWHG7:after {\n  content: '\\10F582';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-beam-sweat__3kk5o:after {\n  content: '\\10F583';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-hearts__1HuAz:after {\n  content: '\\10F584';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-squint__27kKF:after {\n  content: '\\10F585';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-squint-tears__1BNND:after {\n  content: '\\10F586';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-stars__1bgo2:after {\n  content: '\\10F587';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-tears__QMuAc:after {\n  content: '\\10F588';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-tongue__J3nhT:after {\n  content: '\\10F589';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-tongue-squint__3KDAp:after {\n  content: '\\10F58A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-tongue-wink__31AAO:after {\n  content: '\\10F58B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grin-wink__3TV9B:after {\n  content: '\\10F58C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grip-horizontal__2aruh:after {\n  content: '\\10F58D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grip-lines__1UyUt:after {\n  content: '\\10F7A4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grip-lines-vertical__7FgcA:after {\n  content: '\\10F7A5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-grip-vertical__3uVay:after {\n  content: '\\10F58E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-guitar__1nKNp:after {\n  content: '\\10F7A6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-h-square__LGizd:after {\n  content: '\\10F0FD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-h1__2ic8D:after {\n  content: '\\10F313';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-h2__luUYf:after {\n  content: '\\10F314';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-h3__22Py-:after {\n  content: '\\10F315';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-h4__XO19z:after {\n  content: '\\10F86A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hamburger__1Aw5V:after {\n  content: '\\10F805';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hammer__qTRcQ:after {\n  content: '\\10F6E3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hammer-war__1II4C:after {\n  content: '\\10F6E4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hamsa__2vKz-:after {\n  content: '\\10F665';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-heart__2oMt7:after {\n  content: '\\10F4BC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-holding__8e3KN:after {\n  content: '\\10F4BD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-holding-box__2DqwI:after {\n  content: '\\10F47B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-holding-heart__2F-pT:after {\n  content: '\\10F4BE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-holding-magic__PZjOb:after {\n  content: '\\10F6E5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-holding-seedling__WOrKo:after {\n  content: '\\10F4BF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-holding-usd__2f5ep:after {\n  content: '\\10F4C0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-holding-water__206Jq:after {\n  content: '\\10F4C1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-lizard__3kXKR:after {\n  content: '\\10F258';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-middle-finger__11o9v:after {\n  content: '\\10F806';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-paper__2dC15:after {\n  content: '\\10F256';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-peace__z_MJQ:after {\n  content: '\\10F25B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-point-down__1Riow:after {\n  content: '\\10F0A7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-point-left__1N0k5:after {\n  content: '\\10F0A5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-point-right__1opZE:after {\n  content: '\\10F0A4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-point-up__JdCpK:after {\n  content: '\\10F0A6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-pointer__2yHIv:after {\n  content: '\\10F25A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-receiving__3vrRc:after {\n  content: '\\10F47C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-rock__QoRjU:after {\n  content: '\\10F255';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-scissors__1S4W0:after {\n  content: '\\10F257';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hand-spock__2Gc01:after {\n  content: '\\10F259';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hands__10JEJ:after {\n  content: '\\10F4C2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hands-heart__1-Rlv:after {\n  content: '\\10F4C3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hands-helping__16Qau:after {\n  content: '\\10F4C4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hands-usd__u-gfY:after {\n  content: '\\10F4C5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-handshake__WOrbZ:after {\n  content: '\\10F2B5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-handshake-alt__2Be8L:after {\n  content: '\\10F4C6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hanukiah__sOdLV:after {\n  content: '\\10F6E6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hard-hat__C9j4G:after {\n  content: '\\10F807';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hashtag__1wLSD:after {\n  content: '\\10F292';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hat-chef__2QHFL:after {\n  content: '\\10F86B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hat-santa__3G-R1:after {\n  content: '\\10F7A7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hat-winter__2XWjl:after {\n  content: '\\10F7A8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hat-witch__3UCcu:after {\n  content: '\\10F6E7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hat-wizard__vWbw7:after {\n  content: '\\10F6E8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-haykal__3zm-q:after {\n  content: '\\10F666';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hdd__2TYh8:after {\n  content: '\\10F0A0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-head-side__GNMce:after {\n  content: '\\10F6E9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-head-side-brain__2tK4Q:after {\n  content: '\\10F808';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-head-side-medical__ond5z:after {\n  content: '\\10F809';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-head-vr__3wQt8:after {\n  content: '\\10F6EA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-heading__2UR5z:after {\n  content: '\\10F1DC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-headphones__3jE0c:after {\n  content: '\\10F025';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-headphones-alt__2hxrS:after {\n  content: '\\10F58F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-headset__32xDE:after {\n  content: '\\10F590';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-heart__2zqmE:after {\n  content: '\\10F004';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-heart-broken__22rBs:after {\n  content: '\\10F7A9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-heart-circle__1OUUl:after {\n  content: '\\10F4C7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-heart-rate__3szRq:after {\n  content: '\\10F5F8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-heart-square__3rp41:after {\n  content: '\\10F4C8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-heartbeat__3oOXK:after {\n  content: '\\10F21E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-helicopter__3oHOC:after {\n  content: '\\10F533';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-helmet-battle__2RYrT:after {\n  content: '\\10F6EB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hexagon__27uRP:after {\n  content: '\\10F312';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-highlighter__3mPjQ:after {\n  content: '\\10F591';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hiking__2stNL:after {\n  content: '\\10F6EC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hippo__KqefN:after {\n  content: '\\10F6ED';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-history__7rwK2:after {\n  content: '\\10F1DA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hockey-mask__zYzOn:after {\n  content: '\\10F6EE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hockey-puck__18qqa:after {\n  content: '\\10F453';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hockey-sticks__12oq5:after {\n  content: '\\10F454';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-holly-berry__1VPWr:after {\n  content: '\\10F7AA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-home__LEmvv:after {\n  content: '\\10F015';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-home-alt__3r4de:after {\n  content: '\\10F80A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-home-heart__3Vr4h:after {\n  content: '\\10F4C9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-home-lg__1XPMv:after {\n  content: '\\10F80B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-home-lg-alt__2qIK5:after {\n  content: '\\10F80C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hood-cloak__3lrRI:after {\n  content: '\\10F6EF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-horizontal-rule__2jioc:after {\n  content: '\\10F86C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-horse__1oHQJ:after {\n  content: '\\10F6F0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-horse-head__3oax_:after {\n  content: '\\10F7AB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hospital__QwC-c:after {\n  content: '\\10F0F8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hospital-alt__3e4I3:after {\n  content: '\\10F47D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hospital-symbol__31x0p:after {\n  content: '\\10F47E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hospital-user__3-Wq1:after {\n  content: '\\10F80D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hospitals__2Ogc3:after {\n  content: '\\10F80E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hot-tub__jqVxY:after {\n  content: '\\10F593';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hotdog__3TfpP:after {\n  content: '\\10F80F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hotel__2ZZ1s:after {\n  content: '\\10F594';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hourglass__2Fx9T:after {\n  content: '\\10F254';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hourglass-end__aAC2j:after {\n  content: '\\10F253';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hourglass-half__3LUaL:after {\n  content: '\\10F252';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hourglass-start__goz5S:after {\n  content: '\\10F251';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-house-damage__2hrBE:after {\n  content: '\\10F6F1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-house-flood__3R4oN:after {\n  content: '\\10F74F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hryvnia__3cFbo:after {\n  content: '\\10F6F2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-humidity__1Y7DR:after {\n  content: '\\10F750';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-hurricane__w2q2d:after {\n  content: '\\10F751';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-i-cursor__3v4oL:after {\n  content: '\\10F246';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ice-cream__2U-Gm:after {\n  content: '\\10F810';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ice-skate__3X4MP:after {\n  content: '\\10F7AC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-icicles__392y3:after {\n  content: '\\10F7AD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-icons__2la_7:after {\n  content: '\\10F86D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-icons-alt__M5TBA:after {\n  content: '\\10F86E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-id-badge__Vxoaz:after {\n  content: '\\10F2C1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-id-card__ok8S9:after {\n  content: '\\10F2C2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-id-card-alt__dsq5j:after {\n  content: '\\10F47F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-igloo__3LNPv:after {\n  content: '\\10F7AE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-image__2CE3a:after {\n  content: '\\10F03E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-images__2dHrC:after {\n  content: '\\10F302';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-inbox__3nlvC:after {\n  content: '\\10F01C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-inbox-in__ky31L:after {\n  content: '\\10F310';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-inbox-out__3weRy:after {\n  content: '\\10F311';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-indent__122Sa:after {\n  content: '\\10F03C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-industry__1awoD:after {\n  content: '\\10F275';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-industry-alt__LrlAv:after {\n  content: '\\10F3B3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-infinity__wMUKB:after {\n  content: '\\10F534';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-info__fK8fa:after {\n  content: '\\10F129';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-info-circle__rmvul:after {\n  content: '\\10F05A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-info-square__3LaEY:after {\n  content: '\\10F30F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-inhaler__2aXph:after {\n  content: '\\10F5F9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-integral__z4RDu:after {\n  content: '\\10F667';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-intersection__1Hd09:after {\n  content: '\\10F668';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-inventory__1t2oq:after {\n  content: '\\10F480';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-island-tropical__3iSms:after {\n  content: '\\10F811';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-italic__2DCR6:after {\n  content: '\\10F033';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-jack-o-lantern__1-0_d:after {\n  content: '\\10F30E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-jedi__133wj:after {\n  content: '\\10F669';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-joint__3DtTM:after {\n  content: '\\10F595';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-journal-whills__23u-q:after {\n  content: '\\10F66A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-kaaba__1BaxJ:after {\n  content: '\\10F66B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-kerning__hwg-W:after {\n  content: '\\10F86F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-key__fKQec:after {\n  content: '\\10F084';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-key-skeleton__hWexa:after {\n  content: '\\10F6F3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-keyboard__PWGZd:after {\n  content: '\\10F11C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-keynote__dxd2N:after {\n  content: '\\10F66C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-khanda__3-csE:after {\n  content: '\\10F66D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-kidneys__1IQxn:after {\n  content: '\\10F5FB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-kiss__1uJB1:after {\n  content: '\\10F596';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-kiss-beam__2Tf4N:after {\n  content: '\\10F597';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-kiss-wink-heart__kCHFD:after {\n  content: '\\10F598';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-kite__QHGIC:after {\n  content: '\\10F6F4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-kiwi-bird__1COv6:after {\n  content: '\\10F535';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-knife-kitchen__wi3DC:after {\n  content: '\\10F6F5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lambda__3q8Yd:after {\n  content: '\\10F66E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lamp__3VLjp:after {\n  content: '\\10F4CA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-landmark__3mfHV:after {\n  content: '\\10F66F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-landmark-alt__3Hp2I:after {\n  content: '\\10F752';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-language__1QmEH:after {\n  content: '\\10F1AB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-laptop__19Rw2:after {\n  content: '\\10F109';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-laptop-code__3Kozm:after {\n  content: '\\10F5FC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-laptop-medical__1RdzW:after {\n  content: '\\10F812';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-laugh__3GpGX:after {\n  content: '\\10F599';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-laugh-beam__24sFv:after {\n  content: '\\10F59A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-laugh-squint__2KYB9:after {\n  content: '\\10F59B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-laugh-wink__30ujS:after {\n  content: '\\10F59C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-layer-group__3_4pX:after {\n  content: '\\10F5FD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-layer-minus__3YMHC:after {\n  content: '\\10F5FE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-layer-plus__Ig8jw:after {\n  content: '\\10F5FF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-leaf__SXQL1:after {\n  content: '\\10F06C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-leaf-heart__138BR:after {\n  content: '\\10F4CB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-leaf-maple__2QSgd:after {\n  content: '\\10F6F6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-leaf-oak__3RGoT:after {\n  content: '\\10F6F7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lemon__1NXFs:after {\n  content: '\\10F094';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-less-than__1zCNC:after {\n  content: '\\10F536';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-less-than-equal__Jsjen:after {\n  content: '\\10F537';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-level-down__3wgnP:after {\n  content: '\\10F149';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-level-down-alt__2Wv8V:after {\n  content: '\\10F3BE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-level-up__2ZtNA:after {\n  content: '\\10F148';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-level-up-alt__fnPzX:after {\n  content: '\\10F3BF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-life-ring__3prqL:after {\n  content: '\\10F1CD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lightbulb__2kask:after {\n  content: '\\10F0EB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lightbulb-dollar__2YKo1:after {\n  content: '\\10F670';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lightbulb-exclamation__1ZFtv:after {\n  content: '\\10F671';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lightbulb-on__3TYnP:after {\n  content: '\\10F672';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lightbulb-slash__2JaZ2:after {\n  content: '\\10F673';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lights-holiday__2XpfY:after {\n  content: '\\10F7B2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-line-columns__1ZYZd:after {\n  content: '\\10F870';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-line-height__1RD3g:after {\n  content: '\\10F871';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-link__2vybr:after {\n  content: '\\10F0C1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lips__3YWjK:after {\n  content: '\\10F600';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lira-sign__2DfSP:after {\n  content: '\\10F195';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-list__xB6Uh:after {\n  content: '\\10F03A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-list-alt__24H00:after {\n  content: '\\10F022';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-list-ol__3LEHF:after {\n  content: '\\10F0CB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-list-ul__3hs73:after {\n  content: '\\10F0CA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-location__4lVB9:after {\n  content: '\\10F601';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-location-arrow__1lXQ-:after {\n  content: '\\10F124';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-location-circle__1EPHK:after {\n  content: '\\10F602';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-location-slash__jL4Ja:after {\n  content: '\\10F603';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lock__2o_Xl:after {\n  content: '\\10F023';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lock-alt__1kIHZ:after {\n  content: '\\10F30D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lock-open__1EIHk:after {\n  content: '\\10F3C1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lock-open-alt__1BKdE:after {\n  content: '\\10F3C2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-long-arrow-alt-down__1JmjQ:after {\n  content: '\\10F309';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-long-arrow-alt-left__1YgXZ:after {\n  content: '\\10F30A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-long-arrow-alt-right__3YOHF:after {\n  content: '\\10F30B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-long-arrow-alt-up__3vBrO:after {\n  content: '\\10F30C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-long-arrow-down__3EwFh:after {\n  content: '\\10F175';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-long-arrow-left__1a0kI:after {\n  content: '\\10F177';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-long-arrow-right__2uQHb:after {\n  content: '\\10F178';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-long-arrow-up__1cHIn:after {\n  content: '\\10F176';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-loveseat__37oS1:after {\n  content: '\\10F4CC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-low-vision__1Fxh_:after {\n  content: '\\10F2A8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-luchador__271HY:after {\n  content: '\\10F455';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-luggage-cart__1yeSb:after {\n  content: '\\10F59D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-lungs__1yd7L:after {\n  content: '\\10F604';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mace__IQ-WH:after {\n  content: '\\10F6F8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-magic__2nSl3:after {\n  content: '\\10F0D0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-magnet__iFuEn:after {\n  content: '\\10F076';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mail-bulk__1xJL0:after {\n  content: '\\10F674';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mailbox__2wnni:after {\n  content: '\\10F813';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-male__2I8H6:after {\n  content: '\\10F183';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mandolin__1niXM:after {\n  content: '\\10F6F9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map__2kWoU:after {\n  content: '\\10F279';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marked__5Y5Oy:after {\n  content: '\\10F59F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marked-alt__ipTrq:after {\n  content: '\\10F5A0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker__2wnus:after {\n  content: '\\10F041';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-alt__rY25s:after {\n  content: '\\10F3C5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-alt-slash__soJwu:after {\n  content: '\\10F605';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-check__13Njr:after {\n  content: '\\10F606';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-edit__1o7ut:after {\n  content: '\\10F607';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-exclamation__4bbAs:after {\n  content: '\\10F608';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-minus__1NEZc:after {\n  content: '\\10F609';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-plus__2uI0H:after {\n  content: '\\10F60A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-question__zh9jP:after {\n  content: '\\10F60B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-slash__2z8Nf:after {\n  content: '\\10F60C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-smile__3zHbb:after {\n  content: '\\10F60D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-marker-times__azD70:after {\n  content: '\\10F60E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-pin__3ZpnX:after {\n  content: '\\10F276';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-map-signs__2mc1f:after {\n  content: '\\10F277';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-marker__1i3pc:after {\n  content: '\\10F5A1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mars__28nky:after {\n  content: '\\10F222';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mars-double__3ea67:after {\n  content: '\\10F227';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mars-stroke__1XHxk:after {\n  content: '\\10F229';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mars-stroke-h__Kndbw:after {\n  content: '\\10F22B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mars-stroke-v__nRT-r:after {\n  content: '\\10F22A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mask__22ktB:after {\n  content: '\\10F6FA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-meat__16T_r:after {\n  content: '\\10F814';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-medal__3yz2r:after {\n  content: '\\10F5A2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-medkit__1Cv7I:after {\n  content: '\\10F0FA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-megaphone__34-sM:after {\n  content: '\\10F675';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-meh__NBX-j:after {\n  content: '\\10F11A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-meh-blank__oNz-w:after {\n  content: '\\10F5A4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-meh-rolling-eyes__1v2Tf:after {\n  content: '\\10F5A5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-memory__Uvmq4:after {\n  content: '\\10F538';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-menorah__2DyLO:after {\n  content: '\\10F676';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mercury__3rzGg:after {\n  content: '\\10F223';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-meteor__3R8Gz:after {\n  content: '\\10F753';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-microchip__APL4i:after {\n  content: '\\10F2DB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-microphone__D1jRx:after {\n  content: '\\10F130';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-microphone-alt__2hSBy:after {\n  content: '\\10F3C9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-microphone-alt-slash__3fxTc:after {\n  content: '\\10F539';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-microphone-slash__fdiYG:after {\n  content: '\\10F131';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-microscope__hssc-:after {\n  content: '\\10F610';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mind-share__SjF--:after {\n  content: '\\10F677';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-minus__3BqZx:after {\n  content: '\\10F068';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-minus-circle__1hEGN:after {\n  content: '\\10F056';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-minus-hexagon__1Hm1_:after {\n  content: '\\10F307';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-minus-octagon__1mqtd:after {\n  content: '\\10F308';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-minus-square__25cjl:after {\n  content: '\\10F146';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mistletoe__1lMEJ:after {\n  content: '\\10F7B4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mitten__3YdTm:after {\n  content: '\\10F7B5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mobile__3lbE1:after {\n  content: '\\10F10B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mobile-alt__2z4hM:after {\n  content: '\\10F3CD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mobile-android__Ik2Jq:after {\n  content: '\\10F3CE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mobile-android-alt__w4ibN:after {\n  content: '\\10F3CF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-money-bill__13ai3:after {\n  content: '\\10F0D6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-money-bill-alt__3UX18:after {\n  content: '\\10F3D1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-money-bill-wave__2UmOn:after {\n  content: '\\10F53A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-money-bill-wave-alt__23caf:after {\n  content: '\\10F53B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-money-check__h94Ka:after {\n  content: '\\10F53C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-money-check-alt__3e9vV:after {\n  content: '\\10F53D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-money-check-edit__2IV4O:after {\n  content: '\\10F872';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-money-check-edit-alt__20xCt:after {\n  content: '\\10F873';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-monitor-heart-rate__BuSHj:after {\n  content: '\\10F611';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-monkey__20TAL:after {\n  content: '\\10F6FB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-monument__3p_Sr:after {\n  content: '\\10F5A6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-moon__39bqu:after {\n  content: '\\10F186';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-moon-cloud__Y4tOO:after {\n  content: '\\10F754';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-moon-stars__2sEvM:after {\n  content: '\\10F755';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mortar-pestle__s0kXT:after {\n  content: '\\10F5A7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mosque__3yBw9:after {\n  content: '\\10F678';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-motorcycle__-xd4z:after {\n  content: '\\10F21C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mountain__1jTpu:after {\n  content: '\\10F6FC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mountains__1AZli:after {\n  content: '\\10F6FD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mouse-pointer__2bhUQ:after {\n  content: '\\10F245';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mug__35bS4:after {\n  content: '\\10F874';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mug-hot__2OibT:after {\n  content: '\\10F7B6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mug-marshmallows__1Qw-N:after {\n  content: '\\10F7B7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-mug-tea__2BV1f:after {\n  content: '\\10F875';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-music__3xo3f:after {\n  content: '\\10F001';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-narwhal__1Lve6:after {\n  content: '\\10F6FE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-network-wired__1XYMR:after {\n  content: '\\10F6FF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-neuter__3JOYX:after {\n  content: '\\10F22C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-newspaper__1TAIc:after {\n  content: '\\10F1EA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-not-equal__1zWEc:after {\n  content: '\\10F53E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-notes-medical__23xao:after {\n  content: '\\10F481';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-object-group__3Heb7:after {\n  content: '\\10F247';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-object-ungroup__3JnNp:after {\n  content: '\\10F248';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-octagon__2cell:after {\n  content: '\\10F306';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-oil-can__2J43p:after {\n  content: '\\10F613';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-oil-temp__mv18g:after {\n  content: '\\10F614';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-om__JZc4X:after {\n  content: '\\10F679';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-omega__1zfi6:after {\n  content: '\\10F67A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ornament__3VuvQ:after {\n  content: '\\10F7B8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-otter__2ACax:after {\n  content: '\\10F700';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-outdent__vpVZ2:after {\n  content: '\\10F03B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-overline__3WOjF:after {\n  content: '\\10F876';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-page-break__28vXq:after {\n  content: '\\10F877';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pager__3CCgz:after {\n  content: '\\10F815';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paint-brush__3qRa4:after {\n  content: '\\10F1FC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paint-brush-alt__3AAY6:after {\n  content: '\\10F5A9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paint-roller__2QoYB:after {\n  content: '\\10F5AA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-palette__i5xC1:after {\n  content: '\\10F53F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pallet__3MRVO:after {\n  content: '\\10F482';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pallet-alt__2ghm8:after {\n  content: '\\10F483';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paper-plane__2RCR1:after {\n  content: '\\10F1D8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paperclip__2lY8i:after {\n  content: '\\10F0C6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-parachute-box__2ib9K:after {\n  content: '\\10F4CD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paragraph__1E-1F:after {\n  content: '\\10F1DD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paragraph-rtl__1BraL:after {\n  content: '\\10F878';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-parking__2epBg:after {\n  content: '\\10F540';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-parking-circle__36YHo:after {\n  content: '\\10F615';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-parking-circle-slash__33P8Q:after {\n  content: '\\10F616';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-parking-slash__EnM1X:after {\n  content: '\\10F617';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-passport__3cK59:after {\n  content: '\\10F5AB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pastafarianism__lbect:after {\n  content: '\\10F67B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paste__1Tqg7:after {\n  content: '\\10F0EA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pause__1xsts:after {\n  content: '\\10F04C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pause-circle__3Xnm-:after {\n  content: '\\10F28B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paw__2qV7P:after {\n  content: '\\10F1B0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paw-alt__21b0T:after {\n  content: '\\10F701';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-paw-claws__2vwYt:after {\n  content: '\\10F702';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-peace__1NgWd:after {\n  content: '\\10F67C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pegasus__1XLOE:after {\n  content: '\\10F703';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pen__bguPh:after {\n  content: '\\10F304';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pen-alt__EliwQ:after {\n  content: '\\10F305';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pen-fancy__6ryLG:after {\n  content: '\\10F5AC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pen-nib__Q8E80:after {\n  content: '\\10F5AD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pen-square__1q3xb:after {\n  content: '\\10F14B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pencil__1JVGF:after {\n  content: '\\10F040';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pencil-alt__3GVKt:after {\n  content: '\\10F303';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pencil-paintbrush__1o1np:after {\n  content: '\\10F618';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pencil-ruler__2MqlH:after {\n  content: '\\10F5AE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pennant__1JzUs:after {\n  content: '\\10F456';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-people-carry__2g8A-:after {\n  content: '\\10F4CE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pepper-hot__2Iqom:after {\n  content: '\\10F816';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-percent__MOi2z:after {\n  content: '\\10F295';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-percentage__2Xsk8:after {\n  content: '\\10F541';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-person-booth__3bKxF:after {\n  content: '\\10F756';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-person-carry__1FFtU:after {\n  content: '\\10F4CF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-person-dolly__14WVN:after {\n  content: '\\10F4D0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-person-dolly-empty__17_AZ:after {\n  content: '\\10F4D1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-person-sign__3SFK6:after {\n  content: '\\10F757';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-phone__quAB4:after {\n  content: '\\10F095';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-phone-alt__3meXS:after {\n  content: '\\10F879';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-phone-laptop__2UAV4:after {\n  content: '\\10F87A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-phone-office__2OTkM:after {\n  content: '\\10F67D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-phone-plus__2sN6A:after {\n  content: '\\10F4D2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-phone-slash__32hxz:after {\n  content: '\\10F3DD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-phone-square__yvkp2:after {\n  content: '\\10F098';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-phone-square-alt__7rW9P:after {\n  content: '\\10F87B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-phone-volume__2aImR:after {\n  content: '\\10F2A0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-photo-video__lWysC:after {\n  content: '\\10F87C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pi__1IUHn:after {\n  content: '\\10F67E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pie__2z8i1:after {\n  content: '\\10F705';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pig__3mKH6:after {\n  content: '\\10F706';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-piggy-bank__2jY0X:after {\n  content: '\\10F4D3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pills__N4U93:after {\n  content: '\\10F484';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pizza__2s0gf:after {\n  content: '\\10F817';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pizza-slice__3YYzX:after {\n  content: '\\10F818';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-place-of-worship__1mTG7:after {\n  content: '\\10F67F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-plane__2Q1ld:after {\n  content: '\\10F072';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-plane-alt__2Zk_m:after {\n  content: '\\10F3DE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-plane-arrival__1GT65:after {\n  content: '\\10F5AF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-plane-departure__2lxQL:after {\n  content: '\\10F5B0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-play__1Kb38:after {\n  content: '\\10F04B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-play-circle__3X3Ud:after {\n  content: '\\10F144';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-plug__3IzHV:after {\n  content: '\\10F1E6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-plus__1mxU8:after {\n  content: '\\10F067';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-plus-circle__1OWIo:after {\n  content: '\\10F055';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-plus-hexagon__36wwN:after {\n  content: '\\10F300';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-plus-octagon__2tW6i:after {\n  content: '\\10F301';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-plus-square__OZgxJ:after {\n  content: '\\10F0FE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-podcast__2qDeL:after {\n  content: '\\10F2CE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-podium__1XpcR:after {\n  content: '\\10F680';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-podium-star__Xb6zr:after {\n  content: '\\10F758';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-poll__EwxIp:after {\n  content: '\\10F681';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-poll-h__3Nh_N:after {\n  content: '\\10F682';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-poll-people__2u-B0:after {\n  content: '\\10F759';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-poo__mg2_R:after {\n  content: '\\10F2FE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-poo-storm__2eGj0:after {\n  content: '\\10F75A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-poop__v5Zr8:after {\n  content: '\\10F619';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-popcorn__1PHVC:after {\n  content: '\\10F819';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-portrait__1vBiZ:after {\n  content: '\\10F3E0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pound-sign__1Uybz:after {\n  content: '\\10F154';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-power-off__2XEtV:after {\n  content: '\\10F011';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pray__3Pcbg:after {\n  content: '\\10F683';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-praying-hands__elMSE:after {\n  content: '\\10F684';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-prescription__23U6T:after {\n  content: '\\10F5B1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-prescription-bottle__21Rc6:after {\n  content: '\\10F485';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-prescription-bottle-alt__3COZi:after {\n  content: '\\10F486';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-presentation__2SS4u:after {\n  content: '\\10F685';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-print__8tjpZ:after {\n  content: '\\10F02F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-print-search__23fx5:after {\n  content: '\\10F81A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-print-slash__3iVWj:after {\n  content: '\\10F686';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-procedures__1t8cW:after {\n  content: '\\10F487';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-project-diagram___q32k:after {\n  content: '\\10F542';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-pumpkin__3zuEK:after {\n  content: '\\10F707';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-puzzle-piece__1KPdX:after {\n  content: '\\10F12E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-qrcode__3Q0D8:after {\n  content: '\\10F029';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-question__lXIA4:after {\n  content: '\\10F128';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-question-circle__1aKoV:after {\n  content: '\\10F059';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-question-square__db3He:after {\n  content: '\\10F2FD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-quidditch__3XYzr:after {\n  content: '\\10F458';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-quote-left__1ejrD:after {\n  content: '\\10F10D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-quote-right__1iGYT:after {\n  content: '\\10F10E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-quran__1Hrpv:after {\n  content: '\\10F687';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rabbit__3byGh:after {\n  content: '\\10F708';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rabbit-fast__3CuKK:after {\n  content: '\\10F709';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-racquet__b-yhE:after {\n  content: '\\10F45A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-radiation__3-0Hc:after {\n  content: '\\10F7B9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-radiation-alt__3G6oe:after {\n  content: '\\10F7BA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rainbow__3at_X:after {\n  content: '\\10F75B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-raindrops__2vNOU:after {\n  content: '\\10F75C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ram__30-vs:after {\n  content: '\\10F70A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ramp-loading__3jSpf:after {\n  content: '\\10F4D4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-random__1umXk:after {\n  content: '\\10F074';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-receipt__2KVrd:after {\n  content: '\\10F543';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rectangle-landscape__qRoA7:after {\n  content: '\\10F2FA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rectangle-portrait__1co0k:after {\n  content: '\\10F2FB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rectangle-wide__2nrVw:after {\n  content: '\\10F2FC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-recycle__1IUVx:after {\n  content: '\\10F1B8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-redo__3_iaa:after {\n  content: '\\10F01E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-redo-alt__2XoUm:after {\n  content: '\\10F2F9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-registered__1P_UC:after {\n  content: '\\10F25D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-remove-format__24Lda:after {\n  content: '\\10F87D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-repeat__3Irlm:after {\n  content: '\\10F363';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-repeat-1__3VL_R:after {\n  content: '\\10F365';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-repeat-1-alt__2Uv-v:after {\n  content: '\\10F366';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-repeat-alt__n75yQ:after {\n  content: '\\10F364';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-reply__mTf0V:after {\n  content: '\\10F3E5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-reply-all__3sJD-:after {\n  content: '\\10F122';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-republican__3VDtW:after {\n  content: '\\10F75E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-restroom__1j3Dt:after {\n  content: '\\10F7BD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-retweet__1_cpr:after {\n  content: '\\10F079';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-retweet-alt__9fVto:after {\n  content: '\\10F361';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ribbon__3wbD7:after {\n  content: '\\10F4D6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ring__iFRQa:after {\n  content: '\\10F70B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rings-wedding__SVjYz:after {\n  content: '\\10F81B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-road__goYVT:after {\n  content: '\\10F018';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-robot__1lKYL:after {\n  content: '\\10F544';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rocket__c-HX6:after {\n  content: '\\10F135';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-route__15UOM:after {\n  content: '\\10F4D7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-route-highway__1ov2e:after {\n  content: '\\10F61A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-route-interstate__2IVN3:after {\n  content: '\\10F61B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rss__1qExm:after {\n  content: '\\10F09E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rss-square__2mCG0:after {\n  content: '\\10F143';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ruble-sign__15a16:after {\n  content: '\\10F158';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ruler__2p9TS:after {\n  content: '\\10F545';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ruler-combined__2dl7o:after {\n  content: '\\10F546';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ruler-horizontal__3WHJ1:after {\n  content: '\\10F547';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ruler-triangle__3DUrZ:after {\n  content: '\\10F61C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ruler-vertical__2m0qx:after {\n  content: '\\10F548';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-running__1LPSh:after {\n  content: '\\10F70C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rupee-sign__3sGt7:after {\n  content: '\\10F156';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-rv__2VmWs:after {\n  content: '\\10F7BE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sack__24Na7:after {\n  content: '\\10F81C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sack-dollar__jHCld:after {\n  content: '\\10F81D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sad-cry__3aHCh:after {\n  content: '\\10F5B3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sad-tear__2bI-Z:after {\n  content: '\\10F5B4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-salad__3Q5KK:after {\n  content: '\\10F81E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sandwich__2VzJV:after {\n  content: '\\10F81F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-satellite__wZrlB:after {\n  content: '\\10F7BF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-satellite-dish__2iWF4:after {\n  content: '\\10F7C0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sausage__-aBqb:after {\n  content: '\\10F820';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-save__1CIHB:after {\n  content: '\\10F0C7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scalpel__3jyh_:after {\n  content: '\\10F61D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scalpel-path__1u2ts:after {\n  content: '\\10F61E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scanner__3FT0g:after {\n  content: '\\10F488';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scanner-keyboard__jHU-t:after {\n  content: '\\10F489';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scanner-touchscreen__1WTuz:after {\n  content: '\\10F48A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scarecrow__1yBgg:after {\n  content: '\\10F70D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scarf__tI6Nu:after {\n  content: '\\10F7C1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-school__3eHNy:after {\n  content: '\\10F549';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-screwdriver__k4FMR:after {\n  content: '\\10F54A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scroll__2DWjR:after {\n  content: '\\10F70E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scroll-old__zfsUK:after {\n  content: '\\10F70F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scrubber__3AOB1:after {\n  content: '\\10F2F8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-scythe__E4m-d:after {\n  content: '\\10F710';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sd-card__ZptfN:after {\n  content: '\\10F7C2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-search__1iwTC:after {\n  content: '\\10F002';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-search-dollar__2h3v-:after {\n  content: '\\10F688';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-search-location__3JLLc:after {\n  content: '\\10F689';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-search-minus__3SQsr:after {\n  content: '\\10F010';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-search-plus__285aA:after {\n  content: '\\10F00E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-seedling__1Edwf:after {\n  content: '\\10F4D8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-send-back__3d8qm:after {\n  content: '\\10F87E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-send-backward__2kAD7:after {\n  content: '\\10F87F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-server__2ypKM:after {\n  content: '\\10F233';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shapes__2MzRl:after {\n  content: '\\10F61F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-share__3ZQci:after {\n  content: '\\10F064';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-share-all__3EEhS:after {\n  content: '\\10F367';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-share-alt__1GhCL:after {\n  content: '\\10F1E0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-share-alt-square__3dZcv:after {\n  content: '\\10F1E1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-share-square__29m2V:after {\n  content: '\\10F14D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sheep__1NFAL:after {\n  content: '\\10F711';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shekel-sign__YIJ18:after {\n  content: '\\10F20B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shield__3RIQX:after {\n  content: '\\10F132';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shield-alt__B0CKP:after {\n  content: '\\10F3ED';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shield-check__1Hm37:after {\n  content: '\\10F2F7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shield-cross__3KVmU:after {\n  content: '\\10F712';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ship__2NOpb:after {\n  content: '\\10F21A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shipping-fast__ftNJT:after {\n  content: '\\10F48B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shipping-timed__2TXkU:after {\n  content: '\\10F48C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shish-kebab__2lUc_:after {\n  content: '\\10F821';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shoe-prints__36zBX:after {\n  content: '\\10F54B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shopping-bag__3jmCQ:after {\n  content: '\\10F290';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shopping-basket__1UvWJ:after {\n  content: '\\10F291';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shopping-cart__1QrTG:after {\n  content: '\\10F07A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shovel__2DAz8:after {\n  content: '\\10F713';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shovel-snow__2dLe0:after {\n  content: '\\10F7C3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shower__1hQA2:after {\n  content: '\\10F2CC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shredder__2AKqR:after {\n  content: '\\10F68A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shuttle-van__1x1kF:after {\n  content: '\\10F5B6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-shuttlecock__1_cPo:after {\n  content: '\\10F45B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sickle__3U0jz:after {\n  content: '\\10F822';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sigma__3hq8O:after {\n  content: '\\10F68B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sign__1egLv:after {\n  content: '\\10F4D9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sign-in__1wjYO:after {\n  content: '\\10F090';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sign-in-alt__1TOqw:after {\n  content: '\\10F2F6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sign-language__2fElB:after {\n  content: '\\10F2A7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sign-out__3hzcO:after {\n  content: '\\10F08B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sign-out-alt__1SBZA:after {\n  content: '\\10F2F5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal__38fSR:after {\n  content: '\\10F012';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal-1__1w69i:after {\n  content: '\\10F68C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal-2__2ZCkV:after {\n  content: '\\10F68D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal-3__23QPT:after {\n  content: '\\10F68E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal-4__MkUqs:after {\n  content: '\\10F68F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal-alt__wx1do:after {\n  content: '\\10F690';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal-alt-1__3lA8Q:after {\n  content: '\\10F691';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal-alt-2__1MWlv:after {\n  content: '\\10F692';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal-alt-3__29Zh3:after {\n  content: '\\10F693';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal-alt-slash__T-_U-:after {\n  content: '\\10F694';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signal-slash__1MZjn:after {\n  content: '\\10F695';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-signature__1gcvr:after {\n  content: '\\10F5B7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sim-card__23j33:after {\n  content: '\\10F7C4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sitemap__3HGrk:after {\n  content: '\\10F0E8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-skating__1mlkv:after {\n  content: '\\10F7C5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-skeleton__28ojj:after {\n  content: '\\10F620';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ski-jump__1wz7m:after {\n  content: '\\10F7C7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ski-lift__34Ch4:after {\n  content: '\\10F7C8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-skiing__2r4CJ:after {\n  content: '\\10F7C9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-skiing-nordic__3Zj9Q:after {\n  content: '\\10F7CA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-skull__16am9:after {\n  content: '\\10F54C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-skull-crossbones__1gsQw:after {\n  content: '\\10F714';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-slash__25u_L:after {\n  content: '\\10F715';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sledding__1mE8y:after {\n  content: '\\10F7CB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sleigh__1wvsQ:after {\n  content: '\\10F7CC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sliders-h__1dVKq:after {\n  content: '\\10F1DE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sliders-h-square__1FI7w:after {\n  content: '\\10F3F0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sliders-v__2W2IT:after {\n  content: '\\10F3F1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sliders-v-square__3l7a6:after {\n  content: '\\10F3F2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-smile__Ej8fi:after {\n  content: '\\10F118';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-smile-beam__1PnIl:after {\n  content: '\\10F5B8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-smile-plus__1mrXJ:after {\n  content: '\\10F5B9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-smile-wink__26YNp:after {\n  content: '\\10F4DA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-smog__mZZJ1:after {\n  content: '\\10F75F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-smoke__2xuuG:after {\n  content: '\\10F760';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-smoking__1mzxa:after {\n  content: '\\10F48D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-smoking-ban__2STxO:after {\n  content: '\\10F54D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sms__1hkF4:after {\n  content: '\\10F7CD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-snake__2H-Ih:after {\n  content: '\\10F716';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-snooze__1zTyX:after {\n  content: '\\10F880';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-snow-blowing__2Z9DQ:after {\n  content: '\\10F761';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-snowboarding__2MPwA:after {\n  content: '\\10F7CE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-snowflake__1OHkF:after {\n  content: '\\10F2DC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-snowflakes__6UWl8:after {\n  content: '\\10F7CF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-snowman__AJ7jo:after {\n  content: '\\10F7D0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-snowmobile__3ggv4:after {\n  content: '\\10F7D1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-snowplow__bumMw:after {\n  content: '\\10F7D2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-socks__2ghED:after {\n  content: '\\10F696';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-solar-panel__2QUyt:after {\n  content: '\\10F5BA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort__gVhXI:after {\n  content: '\\10F0DC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-alpha-down__3sxnJ:after {\n  content: '\\10F15D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-alpha-down-alt__2-HvA:after {\n  content: '\\10F881';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-alpha-up__2e4aj:after {\n  content: '\\10F15E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-alpha-up-alt__2jYOM:after {\n  content: '\\10F882';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-alt__OF2ms:after {\n  content: '\\10F883';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-amount-down__7PnD9:after {\n  content: '\\10F160';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-amount-down-alt__3vBvm:after {\n  content: '\\10F884';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-amount-up__ScM1l:after {\n  content: '\\10F161';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-amount-up-alt__1IlTz:after {\n  content: '\\10F885';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-down__1SvQd:after {\n  content: '\\10F0DD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-numeric-down__3KKNj:after {\n  content: '\\10F162';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-numeric-down-alt__21s4W:after {\n  content: '\\10F886';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-numeric-up__3hfem:after {\n  content: '\\10F163';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-numeric-up-alt__3nTbd:after {\n  content: '\\10F887';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-shapes-down__20CH4:after {\n  content: '\\10F888';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-shapes-down-alt__3P2nc:after {\n  content: '\\10F889';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-shapes-up__2IXGM:after {\n  content: '\\10F88A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-shapes-up-alt__3S5ik:after {\n  content: '\\10F88B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-size-down__1Ok0R:after {\n  content: '\\10F88C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-size-down-alt__1qXhw:after {\n  content: '\\10F88D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-size-up__209-R:after {\n  content: '\\10F88E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-size-up-alt__376Dx:after {\n  content: '\\10F88F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sort-up__1dtmN:after {\n  content: '\\10F0DE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-soup__3SNUn:after {\n  content: '\\10F823';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-spa__16-yD:after {\n  content: '\\10F5BB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-space-shuttle__1DV0z:after {\n  content: '\\10F197';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-spade__oxSfC:after {\n  content: '\\10F2F4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sparkles__2SHjQ:after {\n  content: '\\10F890';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-spell-check__116Gq:after {\n  content: '\\10F891';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-spider__1yyXY:after {\n  content: '\\10F717';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-spider-black-widow__2IM6Q:after {\n  content: '\\10F718';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-spider-web__3OZ33:after {\n  content: '\\10F719';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-spinner__bqKl0:after {\n  content: '\\10F110';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-spinner-third__3jkI5:after {\n  content: '\\10F3F4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-splotch__1LaVK:after {\n  content: '\\10F5BC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-spray-can__10q_z:after {\n  content: '\\10F5BD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-square__3rXJ-:after {\n  content: '\\10F0C8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-square-full__3CFvH:after {\n  content: '\\10F45C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-square-root__huwtp:after {\n  content: '\\10F697';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-square-root-alt__1iVRI:after {\n  content: '\\10F698';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-squirrel__1ADXh:after {\n  content: '\\10F71A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-staff__1wAlU:after {\n  content: '\\10F71B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stamp__3Pyrd:after {\n  content: '\\10F5BF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-star__1Czty:after {\n  content: '\\10F005';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-star-and-crescent__36JsC:after {\n  content: '\\10F699';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-star-christmas__AOyjv:after {\n  content: '\\10F7D4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-star-exclamation__2Zdba:after {\n  content: '\\10F2F3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-star-half__1zODU:after {\n  content: '\\10F089';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-star-half-alt__2iyPX:after {\n  content: '\\10F5C0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-star-of-david__2VWBk:after {\n  content: '\\10F69A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-star-of-life__HPmxy:after {\n  content: '\\10F621';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stars__2eZAk:after {\n  content: '\\10F762';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-steak__1J2Jt:after {\n  content: '\\10F824';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-steering-wheel__1vB9J:after {\n  content: '\\10F622';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-step-backward__PqZmX:after {\n  content: '\\10F048';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-step-forward__2c-vN:after {\n  content: '\\10F051';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stethoscope__3S-ke:after {\n  content: '\\10F0F1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sticky-note__TtmuO:after {\n  content: '\\10F249';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stocking__2H6Vx:after {\n  content: '\\10F7D5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stomach__1KdKc:after {\n  content: '\\10F623';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stop__2Vf0H:after {\n  content: '\\10F04D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stop-circle__Kbape:after {\n  content: '\\10F28D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stopwatch__2lLRV:after {\n  content: '\\10F2F2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-store__EplI_:after {\n  content: '\\10F54E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-store-alt___jMFJ:after {\n  content: '\\10F54F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stream__2O1rT:after {\n  content: '\\10F550';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-street-view__3Ixh-:after {\n  content: '\\10F21D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stretcher__RUwO7:after {\n  content: '\\10F825';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-strikethrough__2vLDF:after {\n  content: '\\10F0CC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-stroopwafel__2bFbS:after {\n  content: '\\10F551';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-subscript__2s_z4:after {\n  content: '\\10F12C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-subway__2wYp4:after {\n  content: '\\10F239';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-suitcase__10j7-:after {\n  content: '\\10F0F2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-suitcase-rolling__2-dLa:after {\n  content: '\\10F5C1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sun__3fLDv:after {\n  content: '\\10F185';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sun-cloud__3LrIy:after {\n  content: '\\10F763';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sun-dust__1zVXV:after {\n  content: '\\10F764';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sun-haze__nNQ-B:after {\n  content: '\\10F765';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sunglasses__2IEZT:after {\n  content: '\\10F892';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sunrise__1N7WC:after {\n  content: '\\10F766';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sunset__ktNw9:after {\n  content: '\\10F767';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-superscript__3BzpU:after {\n  content: '\\10F12B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-surprise__3pxfp:after {\n  content: '\\10F5C2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-swatchbook__3nqXI:after {\n  content: '\\10F5C3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-swimmer__2z_FR:after {\n  content: '\\10F5C4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-swimming-pool__1er_Y:after {\n  content: '\\10F5C5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sword__1BvBL:after {\n  content: '\\10F71C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-swords__1C-Mh:after {\n  content: '\\10F71D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-synagogue__2W2ir:after {\n  content: '\\10F69B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sync__3oOdm:after {\n  content: '\\10F021';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-sync-alt__1g2FZ:after {\n  content: '\\10F2F1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-syringe__2Bitv:after {\n  content: '\\10F48E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-table__2B5JF:after {\n  content: '\\10F0CE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-table-tennis__1fRyw:after {\n  content: '\\10F45D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tablet__12wXg:after {\n  content: '\\10F10A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tablet-alt__3vNc4:after {\n  content: '\\10F3FA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tablet-android__-gECk:after {\n  content: '\\10F3FB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tablet-android-alt__1yQZV:after {\n  content: '\\10F3FC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tablet-rugged__2o1iX:after {\n  content: '\\10F48F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tablets__1ZLqD:after {\n  content: '\\10F490';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer__1wcRO:after {\n  content: '\\10F0E4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-alt__3pxKH:after {\n  content: '\\10F3FD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-alt-average__3s1Rl:after {\n  content: '\\10F624';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-alt-fast__27NAX:after {\n  content: '\\10F625';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-alt-fastest__29zpj:after {\n  content: '\\10F626';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-alt-slow__1wYwp:after {\n  content: '\\10F627';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-alt-slowest__Mtj4Q:after {\n  content: '\\10F628';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-average__1TiBI:after {\n  content: '\\10F629';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-fast__1mtr3:after {\n  content: '\\10F62A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-fastest__2mCst:after {\n  content: '\\10F62B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-slow__1SWao:after {\n  content: '\\10F62C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tachometer-slowest__5whAs:after {\n  content: '\\10F62D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-taco__2RhsX:after {\n  content: '\\10F826';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tag__1t_sp:after {\n  content: '\\10F02B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tags__1Fmsc:after {\n  content: '\\10F02C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tally__Jx2i8:after {\n  content: '\\10F69C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tanakh__13WV5:after {\n  content: '\\10F827';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tape__z9jqJ:after {\n  content: '\\10F4DB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tasks__1nTpe:after {\n  content: '\\10F0AE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tasks-alt__3uzMJ:after {\n  content: '\\10F828';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-taxi__2S8LB:after {\n  content: '\\10F1BA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-teeth__20FgL:after {\n  content: '\\10F62E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-teeth-open__3jF9n:after {\n  content: '\\10F62F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-temperature-frigid__Vu3V3:after {\n  content: '\\10F768';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-temperature-high__2VVFq:after {\n  content: '\\10F769';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-temperature-hot__2OjY4:after {\n  content: '\\10F76A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-temperature-low__3dosA:after {\n  content: '\\10F76B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tenge__Z9tJI:after {\n  content: '\\10F7D7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tennis-ball__2ZJiC:after {\n  content: '\\10F45E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-terminal__3EP8-:after {\n  content: '\\10F120';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-text__3M72L:after {\n  content: '\\10F893';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-text-height__XoGjy:after {\n  content: '\\10F034';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-text-size__357wL:after {\n  content: '\\10F894';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-text-width__1wbdv:after {\n  content: '\\10F035';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-th__2FJGN:after {\n  content: '\\10F00A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-th-large__3jxlo:after {\n  content: '\\10F009';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-th-list__3_5wX:after {\n  content: '\\10F00B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-theater-masks__32zZs:after {\n  content: '\\10F630';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thermometer__hc7tr:after {\n  content: '\\10F491';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thermometer-empty__3JUqZ:after {\n  content: '\\10F2CB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thermometer-full__2A9zT:after {\n  content: '\\10F2C7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thermometer-half__2-UPD:after {\n  content: '\\10F2C9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thermometer-quarter__33U6u:after {\n  content: '\\10F2CA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thermometer-three-quarters__DvxyJ:after {\n  content: '\\10F2C8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-theta__10Wpw:after {\n  content: '\\10F69E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thumbs-down__3spUj:after {\n  content: '\\10F165';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thumbs-up__16pAO:after {\n  content: '\\10F164';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thumbtack__sFoXJ:after {\n  content: '\\10F08D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thunderstorm__3AB39:after {\n  content: '\\10F76C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thunderstorm-moon__2OOOG:after {\n  content: '\\10F76D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-thunderstorm-sun__3lh5D:after {\n  content: '\\10F76E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ticket__2bdrt:after {\n  content: '\\10F145';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-ticket-alt__33P2m:after {\n  content: '\\10F3FF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tilde__3hzzf:after {\n  content: '\\10F69F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-times__js91j:after {\n  content: '\\10F00D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-times-circle__39ZL4:after {\n  content: '\\10F057';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-times-hexagon__3pTdd:after {\n  content: '\\10F2EE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-times-octagon__2n3iR:after {\n  content: '\\10F2F0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-times-square__15B73:after {\n  content: '\\10F2D3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tint__1Ex0K:after {\n  content: '\\10F043';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tint-slash__3eOPN:after {\n  content: '\\10F5C7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tire__2jOKE:after {\n  content: '\\10F631';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tire-flat__3XGnb:after {\n  content: '\\10F632';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tire-pressure-warning__1mblh:after {\n  content: '\\10F633';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tire-rugged__3BOi6:after {\n  content: '\\10F634';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tired__7A0eh:after {\n  content: '\\10F5C8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-toggle-off__1chVa:after {\n  content: '\\10F204';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-toggle-on__7oXA7:after {\n  content: '\\10F205';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-toilet__2mYQQ:after {\n  content: '\\10F7D8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-toilet-paper__2Gdm6:after {\n  content: '\\10F71E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-toilet-paper-alt__ur1Xv:after {\n  content: '\\10F71F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tombstone__Y2jZO:after {\n  content: '\\10F720';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tombstone-alt__2qp_t:after {\n  content: '\\10F721';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-toolbox__2y-Px:after {\n  content: '\\10F552';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tools__2q6OZ:after {\n  content: '\\10F7D9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tooth__2HXd6:after {\n  content: '\\10F5C9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-toothbrush__1DIlZ:after {\n  content: '\\10F635';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-torah__3SYLa:after {\n  content: '\\10F6A0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-torii-gate__34UgC:after {\n  content: '\\10F6A1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tornado__1JsWM:after {\n  content: '\\10F76F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tractor__35ENA:after {\n  content: '\\10F722';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-trademark__UCXAw:after {\n  content: '\\10F25C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-traffic-cone__3qQkO:after {\n  content: '\\10F636';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-traffic-light__2QLo3:after {\n  content: '\\10F637';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-traffic-light-go__3JPVx:after {\n  content: '\\10F638';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-traffic-light-slow__1BvlL:after {\n  content: '\\10F639';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-traffic-light-stop__KNx7P:after {\n  content: '\\10F63A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-train__sfMAi:after {\n  content: '\\10F238';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tram__TYcZr:after {\n  content: '\\10F7DA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-transgender__1RPWA:after {\n  content: '\\10F224';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-transgender-alt__33-9I:after {\n  content: '\\10F225';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-trash__yzH_Y:after {\n  content: '\\10F1F8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-trash-alt__zUvJi:after {\n  content: '\\10F2ED';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-trash-restore__3F4Ir:after {\n  content: '\\10F829';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-trash-restore-alt__27rMw:after {\n  content: '\\10F82A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-trash-undo__1xvQY:after {\n  content: '\\10F895';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-trash-undo-alt__1MMAf:after {\n  content: '\\10F896';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-treasure-chest__3CLfN:after {\n  content: '\\10F723';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tree__2UWAn:after {\n  content: '\\10F1BB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tree-alt__3jztp:after {\n  content: '\\10F400';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tree-christmas__21QJt:after {\n  content: '\\10F7DB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tree-decorated__1-d5F:after {\n  content: '\\10F7DC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tree-large__1OFod:after {\n  content: '\\10F7DD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tree-palm__1aVo_:after {\n  content: '\\10F82B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-trees__V-3HH:after {\n  content: '\\10F724';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-triangle__3hNw2:after {\n  content: '\\10F2EC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-trophy__1jEfn:after {\n  content: '\\10F091';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-trophy-alt__3w2au:after {\n  content: '\\10F2EB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-truck__2dHoH:after {\n  content: '\\10F0D1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-truck-container__301hR:after {\n  content: '\\10F4DC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-truck-couch__1Qx5q:after {\n  content: '\\10F4DD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-truck-loading__1BajF:after {\n  content: '\\10F4DE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-truck-monster__2tgW8:after {\n  content: '\\10F63B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-truck-moving__31M_H:after {\n  content: '\\10F4DF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-truck-pickup__3CFNn:after {\n  content: '\\10F63C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-truck-plow__1udMY:after {\n  content: '\\10F7DE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-truck-ramp__2U-l4:after {\n  content: '\\10F4E0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tshirt__1Yinz:after {\n  content: '\\10F553';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tty__11RML:after {\n  content: '\\10F1E4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-turkey__DzXQR:after {\n  content: '\\10F725';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-turtle__1uJrN:after {\n  content: '\\10F726';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tv__1gAdF:after {\n  content: '\\10F26C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-tv-retro__3dEti:after {\n  content: '\\10F401';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-umbrella__3zvlR:after {\n  content: '\\10F0E9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-umbrella-beach__1bXda:after {\n  content: '\\10F5CA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-underline__121Nc:after {\n  content: '\\10F0CD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-undo__1EhnP:after {\n  content: '\\10F0E2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-undo-alt__QzlGE:after {\n  content: '\\10F2EA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-unicorn__3rJgz:after {\n  content: '\\10F727';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-union__1TYET:after {\n  content: '\\10F6A2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-universal-access__3tqBD:after {\n  content: '\\10F29A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-university__iJNr1:after {\n  content: '\\10F19C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-unlink__Ms-5B:after {\n  content: '\\10F127';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-unlock__SwrdW:after {\n  content: '\\10F09C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-unlock-alt__gPGoe:after {\n  content: '\\10F13E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-upload__2xgm5:after {\n  content: '\\10F093';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-usd-circle__2haLn:after {\n  content: '\\10F2E8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-usd-square__2D3Pq:after {\n  content: '\\10F2E9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user__Bd6al:after {\n  content: '\\10F007';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-alt__9jsoa:after {\n  content: '\\10F406';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-alt-slash__21XRh:after {\n  content: '\\10F4FA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-astronaut__TpI6o:after {\n  content: '\\10F4FB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-chart__1lepx:after {\n  content: '\\10F6A3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-check__2aOPc:after {\n  content: '\\10F4FC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-circle__x0ba-:after {\n  content: '\\10F2BD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-clock__lGHgA:after {\n  content: '\\10F4FD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-cog__tr5CN:after {\n  content: '\\10F4FE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-crown__1N0PE:after {\n  content: '\\10F6A4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-edit__3WpZ_:after {\n  content: '\\10F4FF';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-friends__13XHq:after {\n  content: '\\10F500';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-graduate__2Q6St:after {\n  content: '\\10F501';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-hard-hat__1Xr0P:after {\n  content: '\\10F82C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-headset__2ifSK:after {\n  content: '\\10F82D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-injured__1juR-:after {\n  content: '\\10F728';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-lock__3ri4g:after {\n  content: '\\10F502';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-md__2jAFa:after {\n  content: '\\10F0F0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-md-chat__3ut1b:after {\n  content: '\\10F82E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-minus__1gXdg:after {\n  content: '\\10F503';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-ninja__OyQrk:after {\n  content: '\\10F504';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-nurse__2HUmT:after {\n  content: '\\10F82F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-plus__W3Zt0:after {\n  content: '\\10F234';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-secret__3tn92:after {\n  content: '\\10F21B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-shield__fmVc5:after {\n  content: '\\10F505';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-slash__1nK8m:after {\n  content: '\\10F506';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-tag__1RPY5:after {\n  content: '\\10F507';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-tie__1G4mG:after {\n  content: '\\10F508';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-user-times__1rBsk:after {\n  content: '\\10F235';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-users__26OlC:after {\n  content: '\\10F0C0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-users-class__lIfU5:after {\n  content: '\\10F63D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-users-cog__3NNow:after {\n  content: '\\10F509';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-users-crown__fY_NP:after {\n  content: '\\10F6A5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-users-medical__1Eth8:after {\n  content: '\\10F830';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-utensil-fork__1QEZi:after {\n  content: '\\10F2E3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-utensil-knife__3fBmG:after {\n  content: '\\10F2E4';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-utensil-spoon__MvNUq:after {\n  content: '\\10F2E5';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-utensils__3hDpn:after {\n  content: '\\10F2E7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-utensils-alt__QD0-I:after {\n  content: '\\10F2E6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-value-absolute__2PS3R:after {\n  content: '\\10F6A6';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-vector-square__Ey6kA:after {\n  content: '\\10F5CB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-venus__2D-Ul:after {\n  content: '\\10F221';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-venus-double__3DOgc:after {\n  content: '\\10F226';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-venus-mars__3NDMa:after {\n  content: '\\10F228';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-vial__JKMHm:after {\n  content: '\\10F492';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-vials__2TQpz:after {\n  content: '\\10F493';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-video__1QGv3:after {\n  content: '\\10F03D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-video-plus__2vmSj:after {\n  content: '\\10F4E1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-video-slash__RF-Me:after {\n  content: '\\10F4E2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-vihara__3JzOM:after {\n  content: '\\10F6A7';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-voicemail__3q4Hq:after {\n  content: '\\10F897';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-volcano__209XS:after {\n  content: '\\10F770';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-volleyball-ball__23oNq:after {\n  content: '\\10F45F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-volume__12J9G:after {\n  content: '\\10F6A8';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-volume-down__3RKZ_:after {\n  content: '\\10F027';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-volume-mute__H_Y50:after {\n  content: '\\10F6A9';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-volume-off__3-nT9:after {\n  content: '\\10F026';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-volume-slash__DwuQJ:after {\n  content: '\\10F2E2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-volume-up__1bFw2:after {\n  content: '\\10F028';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-vote-nay__rZpM2:after {\n  content: '\\10F771';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-vote-yea__1Rk9Z:after {\n  content: '\\10F772';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-vr-cardboard__3x2BG:after {\n  content: '\\10F729';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-walker__2howx:after {\n  content: '\\10F831';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-walking__3NupO:after {\n  content: '\\10F554';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wallet__1eANE:after {\n  content: '\\10F555';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wand__3mXwZ:after {\n  content: '\\10F72A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wand-magic__3wzpi:after {\n  content: '\\10F72B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-warehouse__2GgLO:after {\n  content: '\\10F494';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-warehouse-alt__1XSW2:after {\n  content: '\\10F495';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-washer__13jZN:after {\n  content: '\\10F898';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-watch__dFyVQ:after {\n  content: '\\10F2E1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-watch-fitness__1LneL:after {\n  content: '\\10F63E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-water__17DT0:after {\n  content: '\\10F773';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-water-lower__3qqd6:after {\n  content: '\\10F774';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-water-rise__2IFGh:after {\n  content: '\\10F775';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wave-sine__3SCNt:after {\n  content: '\\10F899';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wave-square__S0BIF:after {\n  content: '\\10F83E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wave-triangle__2om7_:after {\n  content: '\\10F89A';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-webcam__2-8uB:after {\n  content: '\\10F832';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-webcam-slash__1Tl4O:after {\n  content: '\\10F833';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-weight__1sucL:after {\n  content: '\\10F496';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-weight-hanging__12GXr:after {\n  content: '\\10F5CD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-whale__CC8Iy:after {\n  content: '\\10F72C';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wheat__14Ebq:after {\n  content: '\\10F72D';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wheelchair__1vmY2:after {\n  content: '\\10F193';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-whistle__2uPsO:after {\n  content: '\\10F460';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wifi__ZNdqA:after {\n  content: '\\10F1EB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wifi-1__3jg9H:after {\n  content: '\\10F6AA';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wifi-2__2XBnV:after {\n  content: '\\10F6AB';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wifi-slash__2WN7X:after {\n  content: '\\10F6AC';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wind__zgMJz:after {\n  content: '\\10F72E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wind-turbine__1jRhF:after {\n  content: '\\10F89B';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wind-warning__2vcPX:after {\n  content: '\\10F776';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-window__P67Wh:after {\n  content: '\\10F40E';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-window-alt__TJWS5:after {\n  content: '\\10F40F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-window-close__2WAn3:after {\n  content: '\\10F410';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-window-maximize__494yt:after {\n  content: '\\10F2D0';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-window-minimize__2tCzS:after {\n  content: '\\10F2D1';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-window-restore__1EsTt:after {\n  content: '\\10F2D2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-windsock__13ECW:after {\n  content: '\\10F777';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wine-bottle__2Bk8O:after {\n  content: '\\10F72F';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wine-glass__2_HiY:after {\n  content: '\\10F4E3';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wine-glass-alt__3Aeuo:after {\n  content: '\\10F5CE';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-won-sign__2ENE2:after {\n  content: '\\10F159';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wreath__2mRn5:after {\n  content: '\\10F7E2';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-wrench__34Mh7:after {\n  content: '\\10F0AD';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-x-ray__12_rz:after {\n  content: '\\10F497';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-yen-sign__Sy7v9:after {\n  content: '\\10F157';\n}\n.fontawesome-all-min_fad__46Ygp.fontawesome-all-min_fa-yin-yang__3rSVd:after {\n  content: '\\10F6AD';\n}\n@font-face {\n  font-family: 'Font Awesome 5 Pro';\n  font-style: normal;\n  font-weight: 300;\n  font-display: auto;\n  src: url(../fonts/fa/fa-light-300.eot);\n  src: url(../fonts/fa/fa-light-300.eot?#iefix) format('embedded-opentype'),\n    url(../fonts/fa/fa-light-300.woff2) format('woff2'), url(../fonts/fa/fa-light-300.woff) format('woff'),\n    url(../fonts/fa/fa-light-300.ttf) format('truetype'), url(../fonts/fa/fa-light-300.svg#fontawesome) format('svg');\n}\n.fontawesome-all-min_fal__2OKLO {\n  font-weight: 300;\n}\n@font-face {\n  font-family: 'Font Awesome 5 Pro';\n  font-style: normal;\n  font-weight: 400;\n  font-display: auto;\n  src: url(../fonts/fa/fa-regular-400.eot);\n  src: url(../fonts/fa/fa-regular-400.eot?#iefix) format('embedded-opentype'),\n    url(../fonts/fa/fa-regular-400.woff2) format('woff2'), url(../fonts/fa/fa-regular-400.woff) format('woff'),\n    url(../fonts/fa/fa-regular-400.ttf) format('truetype'),\n    url(../fonts/fa/fa-regular-400.svg#fontawesome) format('svg');\n}\n.fontawesome-all-min_fal__2OKLO,\n.fontawesome-all-min_far__1x4mk {\n  font-family: 'Font Awesome 5 Pro';\n}\n.fontawesome-all-min_far__1x4mk {\n  font-weight: 400;\n}\n@font-face {\n  font-family: 'Font Awesome 5 Pro';\n  font-style: normal;\n  font-weight: 900;\n  font-display: auto;\n  src: url(../fonts/fa/fa-solid-900.eot);\n  src: url(../fonts/fa/fa-solid-900.eot?#iefix) format('embedded-opentype'),\n    url(../fonts/fa/fa-solid-900.woff2) format('woff2'), url(../fonts/fa/fa-solid-900.woff) format('woff'),\n    url(../fonts/fa/fa-solid-900.ttf) format('truetype'), url(../fonts/fa/fa-solid-900.svg#fontawesome) format('svg');\n}\n.fontawesome-all-min_fa__3gwnS,\n.fontawesome-all-min_fas__3YAYC {\n  font-family: 'Font Awesome 5 Pro';\n  font-weight: 900;\n}\n";
styleInject(css_248z$j);

function PercentChangeFooter(props) {
  var _props$data = props.data,
      score = _props$data.score,
      change = _props$data.change,
      changePercent = _props$data.changePercent,
      _props$meta$daysInRan = props.meta.daysInRange,
      daysInRange = _props$meta$daysInRan === void 0 ? 0 : _props$meta$daysInRan;
  var t = props.t;
  var level = getScoreLevel(t, score);
  var percent = (changePercent * 100).toFixed(1);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "security-score-footer",
    style: props.style
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "level-container"
  }, score && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fad fa-shield-check",
    style: {
      color: level.color
    }
  }), /*#__PURE__*/React__default['default'].createElement("span", null, level.label))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "change-container"
  }, /*#__PURE__*/React__default['default'].createElement("span", null, change), /*#__PURE__*/React__default['default'].createElement("span", null, " (".concat(Number(percent), "%) ")), /*#__PURE__*/React__default['default'].createElement("span", null, t && t('graphs.footer.days', {
    daysInRange: daysInRange
  })), change === 0 ? null : change < 0 || percent < 0 ? /*#__PURE__*/React__default['default'].createElement("i", {
    className: "far fa-long-arrow-down"
  }) : /*#__PURE__*/React__default['default'].createElement("i", {
    className: "far fa-long-arrow-up"
  })));
}
PercentChangeFooter.defaultProps = {
  data: {},
  meta: {}
};

function getScoreLevel(t, score) {
  if (score <= 250) {
    return {
      label: t && t('graphs.footer.low'),
      color: '#3d68d3'
    };
  } else if (score > 250 && score <= 550) {
    return {
      label: t && t('graphs.footer.medium'),
      color: '#4ed4b2'
    };
  } else {
    return {
      label: t && t('graphs.footer.high'),
      color: '#4eb3d4'
    };
  }
}

function PercentLabel(props) {
  var items = props.items;
  var t = props.t;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "graph-percent-label",
    style: props.style
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "change-container"
  }, items.map(function (item, idx) {
    var percent = (item.count / item.total * 100).toFixed(0);
    return /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '30px'
      },
      key: idx
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "percent-label-color",
      style: {
        width: '8px',
        height: '8px',
        borderRadius: '10px',
        backgroundColor: item.color
      }
    }), /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        width: '52px'
      }
    }, t && item.label ? t(item.label) : item.name), /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        width: '30px',
        textAlign: 'right',
        fontWeight: 500
      }
    }, item.count), props.showPercent && /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        width: '25px',
        textAlign: 'right',
        fontWeight: 500
      }
    }, "".concat(percent, "%")));
  })));
}
PercentLabel.defaultProps = {
  items: []
};

function linear$1(t) {
  return +t;
}

function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);

var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return (+t === 1) ? 1 : 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}

// tpmt is two power minus ten times t scaled to [0,1]
function tpmt(x) {
  return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

function expIn(t) {
  return tpmt(1 - +t);
}

function expOut(t) {
  return 1 - tpmt(t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? tpmt(1 - t) : 2 - tpmt(t - 1)) / 2;
}

function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn$1(t) {
  return 1 - bounceOut$1(1 - t);
}

function bounceOut$1(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut$1(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut$1(1 - t) : bounceOut$1(t - 1) + 1) / 2;
}

var overshoot = 1.70158;

var backIn$1 = (function custom(s) {
  s = +s;

  function backIn(t) {
    return (t = +t) * t * (s * (t - 1) + t);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut$1 = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((t + 1) * s + t) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut$1 = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);

var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * tpmt(-(--t)) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * tpmt(t = +t) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * tpmt(-t) * Math.sin((s - t) / p)
        : 2 - a * tpmt(t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);

var d3Ease = /*#__PURE__*/Object.freeze({
  __proto__: null,
  easeLinear: linear$1,
  easeQuad: quadInOut,
  easeQuadIn: quadIn,
  easeQuadOut: quadOut,
  easeQuadInOut: quadInOut,
  easeCubic: cubicInOut,
  easeCubicIn: cubicIn,
  easeCubicOut: cubicOut,
  easeCubicInOut: cubicInOut,
  easePoly: polyInOut,
  easePolyIn: polyIn,
  easePolyOut: polyOut,
  easePolyInOut: polyInOut,
  easeSin: sinInOut,
  easeSinIn: sinIn,
  easeSinOut: sinOut,
  easeSinInOut: sinInOut,
  easeExp: expInOut,
  easeExpIn: expIn,
  easeExpOut: expOut,
  easeExpInOut: expInOut,
  easeCircle: circleInOut,
  easeCircleIn: circleIn,
  easeCircleOut: circleOut,
  easeCircleInOut: circleInOut,
  easeBounce: bounceOut$1,
  easeBounceIn: bounceIn$1,
  easeBounceOut: bounceOut$1,
  easeBounceInOut: bounceInOut$1,
  easeBack: backInOut$1,
  easeBackIn: backIn$1,
  easeBackOut: backOut$1,
  easeBackInOut: backInOut$1,
  easeElastic: elasticOut,
  easeElasticIn: elasticIn,
  easeElasticOut: elasticOut,
  easeElasticInOut: elasticInOut
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

var isArray_1 = isArray$1;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$2.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString$1;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$1;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$1);
}

var isSymbol_1 = isSymbol$1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$4(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$4;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$6(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$6;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$3 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$4.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = _MapCache;

var memoize_1 = memoize$1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName$2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$2 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$2, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$2, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$2;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString$1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/** Built-in value references. */
var Uint8Array$1 = _root.Uint8Array;

var _Uint8Array = Uint8Array$1;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = _mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$2:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$2 = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$2;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] =
typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag$1] =
typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$9;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys$1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$8.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/* Built-in method references that are verified to be native. */
var DataView$1 = _getNative(_root, 'DataView');

var _DataView = DataView$1;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap$1;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$2 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag$1(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (_Map && getTag$1(new _Map) != mapTag$2) ||
    (_Promise && getTag$1(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag$1(new _Set) != setTag$2) ||
    (_WeakMap && getTag$1(new _WeakMap) != weakMapTag$1)) {
  getTag$1 = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$2;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$2;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$1 : _getTag(object),
      othTag = othIsArr ? arrayTag$1 : _getTag(other);

  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;

  var objIsObj = objTag == objectTag$2,
      othIsObj = othTag == objectTag$2,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$9.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$9.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject_1(value);
}

var _isStrictComparable = isStrictComparable;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys_1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

var _getMatchData = getMatchData;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$3(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$3;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength_1(length) && _isIndex(key, length) &&
    (isArray_1(object) || isArguments_1(object));
}

var _hasPath = hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

var hasIn_1 = hasIn;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get_1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn_1(object, path)
      : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

var _baseMatchesProperty = baseMatchesProperty;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return _baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

var property_1 = property;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity_1;
  }
  if (typeof value == 'object') {
    return isArray_1(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return property_1(value);
}

var _baseIteratee = baseIteratee;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, keys_1);
}

var _baseForOwn = baseForOwn;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike_1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn);

var _baseEach = baseEach;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike_1(collection) ? Array(collection.length) : [];

  _baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap;

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

var _baseSortBy = baseSortBy;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol_1(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol_1(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

var _compareAscending = compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = _compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

var _compareMultiple = compareMultiple;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = _arrayMap(iteratees, function(iteratee) {
      if (isArray_1(iteratee)) {
        return function(value) {
          return _baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity_1];
  }

  var index = -1;
  iteratees = _arrayMap(iteratees, _baseUnary(_baseIteratee));

  var result = _baseMap(collection, function(value, key, collection) {
    var criteria = _arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return _baseSortBy(result, function(object, other) {
    return _compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy;

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray_1(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray_1(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return _baseOrderBy(collection, iteratees, orders);
}

var orderBy_1 = orderBy;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$d = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$a.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend$1(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color$1, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color$1(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba$1(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba$1((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba$1(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba$1(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla$1(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla$1(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba$1(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color$1(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb, extend$1(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex$1(this.r) + hex$1(this.g) + hex$1(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex$1(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla$1(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color$1(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend$1(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

var A$3 = -0.14861,
    B$2 = +1.78277,
    C$1 = -0.29227,
    D$2 = -0.90649,
    E$2 = +1.97294,
    ED = E$2 * D$2,
    EB = E$2 * B$2,
    BC_DA = B$2 * C$1 - D$2 * A$3;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E$2 * (g - l) - C$1 * bl) / D$2,
      s = Math.sqrt(k * k + bl * bl) / (E$2 * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Cubehelix, cubehelix, extend$1(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(
      255 * (l + a * (A$3 * cosh + B$2 * sinh)),
      255 * (l + a * (C$1 * cosh + D$2 * sinh)),
      255 * (l + a * (E$2 * cosh)),
      this.opacity
    );
  }
}));

function constant(x) {
  return function() {
    return x;
  };
}

function linear$2(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear$2(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$2(a, d) : constant(isNaN(a) ? b : a);
}

var rgb$1 = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb$1(start, end) {
    var r = color((start = rgb(start)).r, (end = rgb(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb$1.gamma = rgbGamma;

  return rgb$1;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolateValue(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function reinterpolate(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolateValue(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero$1(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

function string(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: reinterpolate(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero$1(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolateValue(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant(b)
      : (t === "number" ? reinterpolate
      : t === "string" ? ((c = color$1(b)) ? (b = c, rgb$1) : string)
      : b instanceof color$1 ? rgb$1
      : b instanceof Date ? date
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : reinterpolate)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function cubehelix$1(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix$1(start, end) {
      var h = hue((start = cubehelix(start)).h, (end = cubehelix(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix$1.gamma = cubehelixGamma;

    return cubehelix$1;
  })(1);
}

cubehelix$1(hue);
var cubehelixLong = cubehelix$1(nogamma);

var isInterpolatable = function (obj) {
  // d3 turns null into 0 and undefined into NaN, which we don't want.
  if (obj !== null) {
    switch (typeof obj) {
      case "undefined":
        return false;

      case "number":
        // The standard `isNaN` is fine in this case since we already know the
        // type is number.
        return !isNaN(obj) && obj !== Number.POSITIVE_INFINITY && obj !== Number.NEGATIVE_INFINITY;

      case "string":
        // d3 might not *actually* be able to interpolate the string, but it
        // won't cause any issues to let it try.
        return true;

      case "boolean":
        // d3 turns Booleans into integers, which we don't want. Sure, we could
        // interpolate from 0 -> 1, but we'd be sending a non-Boolean to
        // something expecting a Boolean.
        return false;

      case "object":
        // Don't try to interpolate class instances (except Date or Array).
        return obj instanceof Date || Array.isArray(obj) || isPlainObject_1(obj);

      case "function":
        // Careful! There may be extra properties on function objects that the
        // component expects to access - for instance, it may be a `d3.scale()`
        // function, which has its own methods attached. We don't know if the
        // component is only going to call the function (in which case it's
        // safely interpolatable) or if it's going to access special properties
        // (in which case our function generated from `interpolateFunction` will
        // most likely cause an error. We could check for enumerable properties
        // on the function object here to see if it's a "plain" function, but
        // let's just require that components prevent such function props from
        // being animated in the first place.
        return true;
    }
  }

  return false;
};
/**
 * Interpolate immediately to the end value at the given step `when`.
 * Some nicer default behavior might be to jump at the halfway point or return
 * `a` if `t` is 0 (instead of always returning `b`). But d3's default
 * interpolator does not do these things:
 *
 *   d3.interpolate('aaa', 'bbb')(0) === 'bbb'
 *
 * ...and things might get wonky if we don't replicate that behavior.
 *
 * @param {any} a - Start value.
 * @param {any} b - End value.
 * @param {Number} when - Step value (0 to 1) at which to jump to `b`.
 * @returns {Function} An interpolation function.
 */

var interpolateImmediate = function (a, b) {
  var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return function (t) {
    return t < when ? a : b;
  };
};
/**
 * Interpolate to or from a function. The interpolated value will be a function
 * that calls `a` (if it's a function) and `b` (if it's a function) and calls
 * `d3.interpolate` on the resulting values. Note that our function won't
 * necessarily be called (that's up to the component this eventually gets
 * passed to) - but if it does get called, it will return an appropriately
 * interpolated value.
 *
 * @param {any} a - Start value.
 * @param {any} b - End value.
 * @returns {Function} An interpolation function.
 */

var interpolateFunction = function (a, b) {
  return function (t) {
    if (t >= 1) {
      return b;
    }

    return function () {
      /* eslint-disable no-invalid-this */
      var aval = typeof a === "function" ? a.apply(this, arguments) : a;
      var bval = typeof b === "function" ? b.apply(this, arguments) : b;
      return interpolateValue(aval, bval)(t);
    };
  };
};
/**
 * Interpolate to or from an object. This method is a modification of the object interpolator in
 * d3-interpolate https://github.com/d3/d3-interpolate/blob/master/src/object.js. This interpolator
 * differs in that it uses our custom interpolators when interpolating the value of each property in
 * an object. This allows the correct interpolation of nested objects, including styles
 *
 * @param {any} a - Start value.
 * @param {any} b - End value.
 * @returns {Function} An interpolation function.
 */

var interpolateObject = function (a, b) {
  var interpolateTypes = function (x, y) {
    if (x === y || !isInterpolatable(x) || !isInterpolatable(y)) {
      return interpolateImmediate(x, y);
    }

    if (typeof x === "function" || typeof y === "function") {
      return interpolateFunction(x, y);
    }

    if (typeof x === "object" && isPlainObject_1(x) || typeof y === "object" && isPlainObject_1(y)) {
      return interpolateObject(x, y);
    }

    return interpolateValue(x, y);
  }; // When the value is an array, attempt to sort by "key" so that animating nodes may be identified
  // based on "key" instead of index


  var keyData = function (val) {
    return Array.isArray(val) ? orderBy_1(val, "key") : val;
  };

  var i = {};
  var c = {};
  var k;

  if (a === null || typeof a !== "object") {
    a = {};
  }

  if (b === null || typeof b !== "object") {
    b = {};
  }

  for (k in b) {
    if (k in a) {
      i[k] = interpolateTypes(keyData(a[k]), keyData(b[k]));
    } else {
      c[k] = b[k];
    }
  }

  return function (t) {
    for (k in i) {
      c[k] = i[k](t);
    }

    return c;
  };
};
var interpolateString = function (a, b) {
  var format = function (val) {
    return typeof val === "string" ? val.replace(/,/g, "") : val;
  };

  return interpolateValue(format(a), format(b));
};
/**
 * By default, the list of interpolators used by `d3.interpolate` has a few
 * downsides:
 *
 * - `null` values get turned into 0.
 * - `undefined`, `function`, and some other value types get turned into NaN.
 * - Boolean types get turned into numbers, which probably will be meaningless
 *   to whatever is consuming them.
 * - It tries to interpolate between identical start and end values, doing
 *   unnecessary calculations that sometimes result in floating point rounding
 *   errors.
 *
 * If only the default interpolators are used, `VictoryAnimation` will happily
 * pass down NaN (and other bad) values as props to the wrapped component.
 * The component will then either use the incorrect values or complain that it
 * was passed props of the incorrect type. This custom interpolator is added
 * using the `d3.interpolators` API, and prevents such cases from happening
 * for most values.
 *
 * @param {any} a - Start value.
 * @param {any} b - End value.
 * @returns {Function|undefined} An interpolation function, if necessary.
 */

var victoryInterpolator = function (a, b) {
  // If the values are strictly equal, or either value is not interpolatable,
  // just use either the start value `a` or end value `b` at every step, as
  // there is no reasonable in-between value.
  if (a === b || !isInterpolatable(a) || !isInterpolatable(b)) {
    return interpolateImmediate(a, b);
  }

  if (typeof a === "function" || typeof b === "function") {
    return interpolateFunction(a, b);
  }

  if (isPlainObject_1(a) || isPlainObject_1(b)) {
    return interpolateObject(a, b);
  }

  if (typeof a === "string" || typeof b === "string") {
    return interpolateString(a, b);
  }

  return interpolateValue(a, b);
};

var frame$1 = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now$1() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now$1() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now$1(); // Get the current time, if not already set.
  ++frame$1; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame$1;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame$1 = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame$1 = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame$1) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame$1 = 1, setFrame(wake);
  }
}

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

var Timer$1 =
/*#__PURE__*/
function () {
  function Timer() {
    _classCallCheck$1(this, Timer);

    this.shouldAnimate = true;
    this.subscribers = [];
    this.loop = this.loop.bind(this);
    this.timer = timer(this.loop);
  }

  _createClass$1(Timer, [{
    key: "bypassAnimation",
    value: function bypassAnimation() {
      this.shouldAnimate = false;
    }
  }, {
    key: "resumeAnimation",
    value: function resumeAnimation() {
      this.shouldAnimate = true;
    }
  }, {
    key: "loop",
    value: function loop() {
      this.subscribers.forEach(function (s) {
        s.callback(now$1() - s.startTime, s.duration);
      });
    }
  }, {
    key: "start",
    value: function start() {
      this.timer.start();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.timer.stop();
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback, duration) {
      duration = this.shouldAnimate ? duration : 0;
      return this.subscribers.push({
        startTime: now$1(),
        callback: callback,
        duration: duration
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(id) {
      if (id !== null) {
        delete this.subscribers[id - 1];
      }
    }
  }]);

  return Timer;
}();

/**
 * The React context object consumers may use to access or override the global
 * timer.
 */

var TimerContext = React__default['default'].createContext({
  transitionTimer: new Timer$1(),
  animationTimer: new Timer$1()
});
TimerContext.displayName = "TimerContext";

var isArray$2 = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray$2(a)
      , arrB = isArray$2(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

function _toConsumableArray$2(arr) { return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _nonIterableSpread$2(); }

function _nonIterableSpread$2() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$2(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$2(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$1(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$5(self); }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized$5(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var VictoryAnimation =
/*#__PURE__*/
function (_React$Component) {
  _inherits$1(VictoryAnimation, _React$Component);

  function VictoryAnimation(props, context) {
    var _this;

    _classCallCheck$2(this, VictoryAnimation);

    _this = _possibleConstructorReturn$1(this, (VictoryAnimation.__proto__ || Object.getPrototypeOf(VictoryAnimation)).call(this, props, context));
    /* defaults */

    _this.state = {
      data: Array.isArray(_this.props.data) ? _this.props.data[0] : _this.props.data,
      animationInfo: {
        progress: 0,
        animating: false
      }
    };
    _this.interpolator = null;
    _this.queue = Array.isArray(_this.props.data) ? _this.props.data.slice(1) : [];
    /* build easing function */

    _this.ease = d3Ease[_this.toNewName(_this.props.easing)];
    /*
      There is no autobinding of this in ES6 classes
      so we bind functionToBeRunEachFrame to current instance of victory animation class
    */

    _this.functionToBeRunEachFrame = _this.functionToBeRunEachFrame.bind(_assertThisInitialized$5(_this));
    _this.timer = _this.context.animationTimer;
    return _this;
  }

  _createClass$2(VictoryAnimation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Length check prevents us from triggering `onEnd` in `traverseQueue`.
      if (this.queue.length) {
        this.traverseQueue();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var equalProps = reactFastCompare(this.props, nextProps);

      if (!equalProps) {
        /* cancel existing loop if it exists */
        this.timer.unsubscribe(this.loopID);
        /* If an object was supplied */

        if (!Array.isArray(nextProps.data)) {
          // Replace the tween queue. Could set `this.queue = [nextProps.data]`,
          // but let's reuse the same array.
          this.queue.length = 0;
          this.queue.push(nextProps.data);
          /* If an array was supplied */
        } else {
          var _queue;

          /* Extend the tween queue */
          (_queue = this.queue).push.apply(_queue, _toConsumableArray$2(nextProps.data));
        }
        /* Start traversing the tween queue */


        this.traverseQueue();
      }

      return nextState.animationInfo.animating || nextState.animationInfo.terminating || !equalProps;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.loopID) {
        this.timer.unsubscribe(this.loopID);
      } else {
        this.timer.stop();
      }
    }
  }, {
    key: "toNewName",
    value: function toNewName(ease) {
      // d3-ease changed the naming scheme for ease from "linear" -> "easeLinear" etc.
      var capitalize = function (s) {
        return s && s[0].toUpperCase() + s.slice(1);
      };

      return "ease".concat(capitalize(ease));
    }
    /* Traverse the tween queue */

  }, {
    key: "traverseQueue",
    value: function traverseQueue() {
      var _this2 = this;

      if (this.queue.length) {
        /* Get the next index */
        var data = this.queue[0];
        /* compare cached version to next props */

        this.interpolator = victoryInterpolator(this.state.data, data);
        /* reset step to zero */

        if (this.props.delay) {
          setTimeout(function () {
            _this2.loopID = _this2.timer.subscribe(_this2.functionToBeRunEachFrame, _this2.props.duration);
          }, this.props.delay);
        } else {
          this.loopID = this.timer.subscribe(this.functionToBeRunEachFrame, this.props.duration);
        }
      } else if (this.props.onEnd) {
        this.props.onEnd();
      }
    }
    /* every frame we... */

  }, {
    key: "functionToBeRunEachFrame",
    value: function functionToBeRunEachFrame(elapsed, duration) {
      /*
        step can generate imprecise values, sometimes greater than 1
        if this happens set the state to 1 and return, cancelling the timer
      */
      duration = duration !== undefined ? duration : this.props.duration;
      var step = duration ? elapsed / duration : 1;

      if (step >= 1) {
        this.setState({
          data: this.interpolator(1),
          animationInfo: {
            progress: 1,
            animating: false,
            terminating: true
          }
        });

        if (this.loopID) {
          this.timer.unsubscribe(this.loopID);
        }

        this.queue.shift();
        this.traverseQueue();
        return;
      }
      /*
        if we're not at the end of the timer, set the state by passing
        current step value that's transformed by the ease function to the
        interpolator, which is cached for performance whenever props are received
      */


      this.setState({
        data: this.interpolator(this.ease(step)),
        animationInfo: {
          progress: step,
          animating: step < 1
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state.data, this.state.animationInfo);
    }
  }]);

  return VictoryAnimation;
}(React__default['default'].Component);

Object.defineProperty(VictoryAnimation, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryAnimation"
});
Object.defineProperty(VictoryAnimation, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    children: PropTypes__default['default'].func,
    data: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].array]),
    delay: PropTypes__default['default'].number,
    duration: PropTypes__default['default'].number,
    easing: PropTypes__default['default'].oneOf(["back", "backIn", "backOut", "backInOut", "bounce", "bounceIn", "bounceOut", "bounceInOut", "circle", "circleIn", "circleOut", "circleInOut", "linear", "linearIn", "linearOut", "linearInOut", "cubic", "cubicIn", "cubicOut", "cubicInOut", "elastic", "elasticIn", "elasticOut", "elasticInOut", "exp", "expIn", "expOut", "expInOut", "poly", "polyIn", "polyOut", "polyInOut", "quad", "quadIn", "quadOut", "quadInOut", "sin", "sinIn", "sinOut", "sinInOut"]),
    onEnd: PropTypes__default['default'].func
  }
});
Object.defineProperty(VictoryAnimation, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    data: {},
    delay: 0,
    duration: 1000,
    easing: "quadInOut"
  }
});
Object.defineProperty(VictoryAnimation, "contextType", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: TimerContext
});

/** Used to generate unique IDs. */
var idCounter$1 = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId$1(prefix) {
  var id = ++idCounter$1;
  return toString_1(prefix) + id;
}

var uniqueId_1 = uniqueId$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant$1(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$1;

var defineProperty$5 = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$4 = defineProperty$5;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$4 ? identity_1 : function(func, string) {
  return _defineProperty$4(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$b.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$f.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults$1 = _baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn_1(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq_1(value, objectProto$f[key]) && !hasOwnProperty$c.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

var defaults_1 = defaults$1;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$4) {
    _defineProperty$4(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$g.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$d.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$h.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = _createAssigner(function(object, source) {
  if (_isPrototype(source) || isArrayLike_1(source)) {
    _copyObject(source, keys_1(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty$e.call(source, key)) {
      _assignValue(object, key, source[key]);
    }
  }
});

var assign_1 = assign;

/** `Object#toString` result references. */
var regexpTag$2 = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == regexpTag$2;
}

var _baseIsRegExp = baseIsRegExp;

/* Node.js helper references. */
var nodeIsRegExp = _nodeUtil && _nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? _baseUnary(nodeIsRegExp) : _baseIsRegExp;

var isRegExp_1 = isRegExp;

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike_1(collection)) {
      var iteratee = _baseIteratee(predicate);
      collection = keys_1(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

var _createFind = createFind;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex;

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN$1;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var toNumber_1 = toNumber$1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0,
    MAX_INTEGER$1 = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber_1(value);
  if (value === INFINITY$3 || value === -INFINITY$3) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER$1;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite$1;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$1(value) {
  var result = toFinite_1(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger$1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex$1(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger_1(fromIndex);
  if (index < 0) {
    index = nativeMax$1(length + index, 0);
  }
  return _baseFindIndex(array, _baseIteratee(predicate), index);
}

var findIndex_1 = findIndex$1;

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find$1 = _createFind(findIndex_1);

var find_1 = find$1;

/* global console */

/* eslint-disable no-console */
// TODO: Use "warning" npm module like React is switching to.
var Log = {
  warn: function (message) {
    if (process.env.NODE_ENV !== "production") {
      if (console && console.warn) {
        console.warn(message);
      }
    }
  }
};

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Return a new validator based on `validator` but with the option to chain
 * `isRequired` onto the validation. This is nearly identical to how React
 * does it internally, but they don't expose their helper for us to use.
 * @param {Function} validator Validation function.
 * @returns {Function} Validator with `isRequired` option.
 */

var makeChainable = function (validator) {
  /* eslint-disable max-params */
  var _chainable = function (isRequired, props, propName, componentName) {
    var value = props[propName];

    if (value === undefined || value === null) {
      if (isRequired) {
        return new Error("Required `".concat(propName, "` was not specified in `").concat(componentName, "`."));
      }

      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      rest[_key - 4] = arguments[_key];
    }

    return validator.apply(void 0, [props, propName, componentName].concat(rest));
  };

  var chainable = _chainable.bind(null, false);

  chainable.isRequired = _chainable.bind(null, true);
  return chainable;
};

var nullConstructor = function () {
  return null;
};

var undefinedConstructor = function () {
  return undefined;
};
/**
 * Get the constructor of `value`. If `value` is null or undefined, return the
 * special singletons `nullConstructor` or `undefinedConstructor`, respectively.
 * @param {*} value Instance to return the constructor of.
 * @returns {Function} Constructor of `value`.
 */


var getConstructor = function (value) {
  if (value === undefined) {
    return undefinedConstructor;
  } else if (value === null) {
    return nullConstructor;
  } else {
    return value.constructor;
  }
};
/**
 * Get the name of the constructor used to create `value`, using
 * `Object.protoype.toString`. If the value is null or undefined, return
 * "null" or "undefined", respectively.
 * @param {*} value Instance to return the constructor name of.
 * @returns {String} Name of the constructor.
 */


var getConstructorName = function (value) {
  if (value === undefined) {
    return "undefined";
  } else if (value === null) {
    return "null";
  }

  return Object.prototype.toString.call(value).slice(8, -1); // eslint-disable-line no-magic-numbers
};

var CustomPropTypes = {
  /**
   * Return a new validator based on `propType` but which logs a `console.error`
   * with `explanation` if used.
   * @param {Function} propType The old, deprecated propType.
   * @param {String} explanation The message to provide the user of the deprecated propType.
   * @returns {Function} Validator which logs usage of this propType
   */
  deprecated: function (propType, explanation) {
    return function (props, propName, componentName) {
      var value = props[propName];

      if (value !== null && value !== undefined) {
        Log.warn("\"".concat(propName, "\" property of \"").concat(componentName, "\" has been deprecated ").concat(explanation));
      }

      return PropTypes__default['default'].checkPropTypes(_defineProperty$5({}, propName, propType), props, propName, componentName);
    };
  },

  /**
   * Return a new validator which returns true
   * if and only if all validators passed as arguments return true.
   * Like React.propTypes.oneOfType, except "all" instead of "any"
   * @param {Array} validators Validation functions.
   * @returns {Function} Combined validator function
   */
  allOfType: function (validators) {
    return makeChainable(function (props, propName, componentName) {
      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      return validators.reduce(function (result, validator) {
        return result || validator.apply(void 0, [props, propName, componentName].concat(rest));
      }, undefined);
    });
  },

  /**
   * Check that the value is a non-negative number.
   */
  nonNegative: makeChainable(function (props, propName, componentName) {
    var value = props[propName];

    if (typeof value !== "number" || value < 0) {
      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a non-negative number."));
    }

    return undefined;
  }),

  /**
   * Check that the value is an integer.
   */
  integer: makeChainable(function (props, propName, componentName) {
    var value = props[propName];

    if (typeof value !== "number" || value % 1 !== 0) {
      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an integer."));
    }

    return undefined;
  }),

  /**
   * Check that the value is greater than zero.
   */
  greaterThanZero: makeChainable(function (props, propName, componentName) {
    var value = props[propName];

    if (typeof value !== "number" || value <= 0) {
      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a number greater than zero."));
    }

    return undefined;
  }),

  /**
   * Check that the value is an Array of two unique values.
   */
  domain: makeChainable(function (props, propName, componentName) {
    var value = props[propName];

    if (!Array.isArray(value) || value.length !== 2 || value[1] === value[0]) {
      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an array of two unique numeric values."));
    }

    return undefined;
  }),

  /**
   * Check that the value looks like a d3 `scale` function.
   */
  scale: makeChainable(function (props, propName, componentName) {
    var supportedScaleStrings = ["linear", "time", "log", "sqrt"];

    var validScale = function (scl) {
      if (isFunction_1(scl)) {
        return isFunction_1(scl.copy) && isFunction_1(scl.domain) && isFunction_1(scl.range);
      } else if (typeof scl === "string") {
        return supportedScaleStrings.indexOf(scl) !== -1;
      }

      return false;
    };

    var value = props[propName];

    if (!validScale(value)) {
      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a d3 scale."));
    }

    return undefined;
  }),

  /**
   * Check that an array contains items of the same type.
   */
  homogeneousArray: makeChainable(function (props, propName, componentName) {
    var values = props[propName];

    if (!Array.isArray(values)) {
      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an array."));
    }

    if (values.length < 2) {
      return undefined;
    }

    var comparisonConstructor = getConstructor(values[0]);

    var typeMismatchedValue = find_1(values, function (value) {
      return comparisonConstructor !== getConstructor(value);
    });

    if (typeMismatchedValue) {
      var constructorName = getConstructorName(values[0]);
      var otherConstructorName = getConstructorName(typeMismatchedValue);
      return new Error("Expected `".concat(propName, "` in `").concat(componentName, "` to be a ") + "homogeneous array, but found types `".concat(constructorName, "` and ") + "`".concat(otherConstructorName, "`."));
    }

    return undefined;
  }),

  /**
   * Check that array prop length matches props.data.length
   */
  matchDataLength: makeChainable(function (props, propName) {
    if (props[propName] && Array.isArray(props[propName]) && props[propName].length !== props.data.length) {
      return new Error("Length of data and ".concat(propName, " arrays must match."));
    }

    return undefined;
  }),

  /**
   * Check that the value is a regular expression
   */
  regExp: makeChainable(function (props, propName, componentName) {
    if (props[propName] && !isRegExp_1(props[propName])) {
      return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a regular expression."));
    }

    return undefined;
  })
};

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$2(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$6(self); }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized$6(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Portal$2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits$2(Portal, _React$Component);

  function Portal(props) {
    var _this;

    _classCallCheck$3(this, Portal);

    _this = _possibleConstructorReturn$2(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));
    _this.map = {};
    _this.index = 1;
    _this.portalUpdate = _this.portalUpdate.bind(_assertThisInitialized$6(_this));
    _this.portalRegister = _this.portalRegister.bind(_assertThisInitialized$6(_this));
    _this.portalDeregister = _this.portalDeregister.bind(_assertThisInitialized$6(_this));
    return _this;
  }

  _createClass$3(Portal, [{
    key: "portalRegister",
    value: function portalRegister() {
      return ++this.index;
    }
  }, {
    key: "portalUpdate",
    value: function portalUpdate(key, element) {
      this.map[key] = element;
      this.forceUpdate();
    }
  }, {
    key: "portalDeregister",
    value: function portalDeregister(key) {
      delete this.map[key];
      this.forceUpdate();
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;

      return Object.keys(this.map).map(function (key) {
        var el = _this2.map[key];
        return el ? React__default['default'].cloneElement(el, {
          key: key
        }) : el;
      });
    } // Overridden in victory-core-native

  }, {
    key: "render",
    value: function render() {
      return React__default['default'].createElement("svg", this.props, this.getChildren());
    }
  }]);

  return Portal;
}(React__default['default'].Component);

Object.defineProperty(Portal$2, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "Portal"
});
Object.defineProperty(Portal$2, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    className: PropTypes__default['default'].string,
    height: CustomPropTypes.nonNegative,
    style: PropTypes__default['default'].object,
    viewBox: PropTypes__default['default'].string,
    width: CustomPropTypes.nonNegative
  }
});

/**
 * The React context object consumers may use to access the context of the
 * portal.
 */

var PortalContext = React__default['default'].createContext({});
PortalContext.displayName = "PortalContext";

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject_1(object)) {
    return object;
  }
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = _toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject_1(objValue)
          ? objValue
          : (_isIndex(path[index + 1]) ? [] : {});
      }
    }
    _assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet;

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = _baseGet(object, path);

    if (predicate(value, path)) {
      _baseSet(result, _castPath(path, object), value);
    }
  }
  return result;
}

var _basePickBy = basePickBy;

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return _basePickBy(object, paths, function(value, path) {
    return hasIn_1(object, path);
  });
}

var _basePick = basePick;

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray_1(value) || isArguments_1(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

var flatten_1 = flatten$1;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return _setToString(_overRest(func, undefined, flatten_1), func + '');
}

var _flatRest = flatRest;

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick$1 = _flatRest(function(object, paths) {
  return object == null ? {} : _basePick(object, paths);
});

var pick_1 = pick$1;

// Private Functions
function getCartesianRange(props, axis) {
  // determine how to lay the axis and what direction positive and negative are
  var vertical = axis !== "x";
  var padding = getPadding(props);

  if (vertical) {
    return [props.height - padding.bottom, padding.top];
  }

  return [padding.left, props.width - padding.right];
}

function getPolarRange(props, axis) {
  if (axis === "x") {
    var startAngle = degreesToRadians(props.startAngle || 0);
    var endAngle = degreesToRadians(props.endAngle || 360);
    return [startAngle, endAngle];
  }

  return [props.innerRadius || 0, getRadius(props)];
} // Exported Functions

/**
 * creates an object with some keys excluded
 * replacement for lodash.omit for performance. does not mimick the entire lodash.omit api
 * @param {Object} originalObject: created object will be based on this object
 * @param {Array<String>} keys: an array of keys to omit from the new object
 * @returns {Object} new object with same properties as originalObject
 */


function omit$1(originalObject) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  // code based on babel's _objectWithoutProperties
  var newObject = {};

  for (var key in originalObject) {
    if (keys.indexOf(key) >= 0) {
      continue;
    }

    if (!Object.prototype.hasOwnProperty.call(originalObject, key)) {
      continue;
    }

    newObject[key] = originalObject[key];
  }

  return newObject;
}

function getPoint(datum) {
  var exists = function (val) {
    return val !== undefined;
  };

  var _x = datum._x,
      _x1 = datum._x1,
      _x0 = datum._x0,
      _voronoiX = datum._voronoiX,
      _y = datum._y,
      _y1 = datum._y1,
      _y0 = datum._y0,
      _voronoiY = datum._voronoiY;
  var defaultX = exists(_x1) ? _x1 : _x;
  var defaultY = exists(_y1) ? _y1 : _y;
  var point = {
    x: exists(_voronoiX) ? _voronoiX : defaultX,
    x0: exists(_x0) ? _x0 : _x,
    y: exists(_voronoiY) ? _voronoiY : defaultY,
    y0: exists(_y0) ? _y0 : _y
  };
  return defaults_1({}, point, datum);
}

function scalePoint$1(props, datum) {
  var scale = props.scale,
      polar = props.polar,
      horizontal = props.horizontal;
  var d = getPoint(datum);
  var origin = props.origin || {
    x: 0,
    y: 0
  };
  var x = horizontal ? scale.y(d.y) : scale.x(d.x);
  var x0 = horizontal ? scale.y(d.y0) : scale.x(d.x0);
  var y = horizontal ? scale.x(d.x) : scale.y(d.y);
  var y0 = horizontal ? scale.x(d.x0) : scale.y(d.y0);
  return {
    x: polar ? y * Math.cos(x) + origin.x : x,
    x0: polar ? y0 * Math.cos(x0) + origin.x : x0,
    y: polar ? -y * Math.sin(x) + origin.y : y,
    y0: polar ? -y0 * Math.sin(x0) + origin.x : y0
  };
}

function getPadding(props) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "padding";
  var padding = props[name];
  var paddingVal = typeof padding === "number" ? padding : 0;
  var paddingObj = typeof padding === "object" ? padding : {};
  return {
    top: paddingObj.top || paddingVal,
    bottom: paddingObj.bottom || paddingVal,
    left: paddingObj.left || paddingVal,
    right: paddingObj.right || paddingVal
  };
}

function isTooltip(component) {
  var labelRole = component && component.type && component.type.role;
  return labelRole === "tooltip";
}

function getDefaultStyles(props, role) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? {} : _props$theme,
      labelComponent = props.labelComponent;
  var defaultStyles = theme[role] && theme[role].style || {};

  if (!isTooltip(labelComponent)) {
    return defaultStyles;
  }

  var tooltipStyle = theme.tooltip && theme.tooltip.style || {};

  var labelStyle = defaults_1({}, tooltipStyle, defaultStyles.labels);

  return defaults_1({}, {
    labels: labelStyle
  }, defaultStyles);
}

function getStyles(style, defaultStyles) {
  var width = "100%";
  var height = "100%";

  if (!style) {
    return defaults_1({
      parent: {
        height: height,
        width: width
      }
    }, defaultStyles);
  }

  var data = style.data,
      labels = style.labels,
      parent = style.parent;
  var defaultParent = defaultStyles && defaultStyles.parent || {};
  var defaultLabels = defaultStyles && defaultStyles.labels || {};
  var defaultData = defaultStyles && defaultStyles.data || {};
  return {
    parent: defaults_1({}, parent, defaultParent, {
      width: width,
      height: height
    }),
    labels: defaults_1({}, labels, defaultLabels),
    data: defaults_1({}, data, defaultData)
  };
}

function evaluateProp(prop, props) {
  return isFunction_1(prop) ? prop(props) : prop;
}

function evaluateStyle(style, props) {
  if (!style || !Object.keys(style).some(function (value) {
    return isFunction_1(style[value]);
  })) {
    return style;
  }

  return Object.keys(style).reduce(function (prev, curr) {
    prev[curr] = evaluateProp(style[curr], props);
    return prev;
  }, {});
}

function degreesToRadians(degrees) {
  return typeof degrees === "number" ? degrees * (Math.PI / 180) : degrees;
}

function radiansToDegrees(radians) {
  return typeof radians === "number" ? radians / (Math.PI / 180) : radians;
}

function getRadius(props) {
  var _getPadding = getPadding(props),
      left = _getPadding.left,
      right = _getPadding.right,
      top = _getPadding.top,
      bottom = _getPadding.bottom;

  var width = props.width,
      height = props.height;
  return Math.min(width - left - right, height - top - bottom) / 2;
}

function getPolarOrigin(props) {
  var width = props.width,
      height = props.height;

  var _getPadding2 = getPadding(props),
      top = _getPadding2.top,
      bottom = _getPadding2.bottom,
      left = _getPadding2.left,
      right = _getPadding2.right;

  var radius = Math.min(width - left - right, height - top - bottom) / 2;
  var offsetWidth = width / 2 + left - right;
  var offsetHeight = height / 2 + top - bottom;
  return {
    x: offsetWidth + radius > width ? radius + left - right : offsetWidth,
    y: offsetHeight + radius > height ? radius + top - bottom : offsetHeight
  };
}

function getRange(props, axis) {
  if (props.range && props.range[axis]) {
    return props.range[axis];
  } else if (props.range && Array.isArray(props.range)) {
    return props.range;
  }

  return props.polar ? getPolarRange(props, axis) : getCartesianRange(props, axis);
}

function createAccessor(key) {
  // creates a data accessor function
  // given a property key, path, array index, or null for identity.
  if (isFunction_1(key)) {
    return key;
  } else if (key === null || key === undefined) {
    // null/undefined means "return the data item itself"
    return function (x) {
      return x;
    };
  } // otherwise, assume it is an array index, property key or path (_.property handles all three)


  return property_1(key);
}

function modifyProps(props, fallbackProps, role) {
  var theme = props.theme && props.theme[role] ? props.theme[role] : {};
  var themeProps = omit$1(theme, ["style"]);
  var horizontal = isHorizontal(props);
  var defaultObject = horizontal === undefined ? {} : {
    horizontal: horizontal
  };
  return defaults_1(defaultObject, props, themeProps, fallbackProps);
}
/**
 * Returns the given axis or the opposite axis when horizontal
 * @param {string} axis: the given axis, either "x" pr "y"
 * @param {Boolean} horizontal: true when the chart is flipped to the horizontal orientation
 * @returns {String} the dimension appropriate for the axis given its props "x" or "y"
 */


function getCurrentAxis(axis, horizontal) {
  var otherAxis = axis === "x" ? "y" : "x";
  return horizontal ? otherAxis : axis;
}
/**
 * @param {Array} children: an array of child components
 * @param {Function} iteratee: a function with arguments "child", "childName", and "parent"
 * @param {Object} parentProps: props from the parent that are applied to children
 * @param {any}  initialMemo: The object in which the iteration results are combined.
 * @param {Function} combine: Combines the result of the iteratee with the current memo
 *   to the memo for the next iteration step
 * @returns {Array} returns an array of results from calling the iteratee on all nested children
 */

/* eslint-disable max-params */


function reduceChildren(children, iteratee) {
  var parentProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var initialMemo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var combine = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (memo, item) {
    return memo.concat(item);
  };
  var sharedProps = ["data", "domain", "categories", "polar", "startAngle", "endAngle", "minDomain", "maxDomain", "horizontal"];

  var traverseChildren = function (childArray, names, parent) {
    return childArray.reduce(function (memo, child, index) {
      var childRole = child.type && child.type.role;
      var childName = child.props.name || "".concat(childRole, "-").concat(names[index]);

      if (child.props && child.props.children) {
        var childProps = assign_1({}, child.props, pick_1(parentProps, sharedProps));

        var nestedChildren = child.type && child.type.role === "stack" && isFunction_1(child.type.getChildren) ? child.type.getChildren(childProps) : React__default['default'].Children.toArray(child.props.children).map(function (c) {
          var nestedChildProps = assign_1({}, c.props, pick_1(childProps, sharedProps));

          return React__default['default'].cloneElement(c, nestedChildProps);
        });

        var _childNames = nestedChildren.map(function (c, i) {
          return "".concat(childName, "-").concat(i);
        });

        var nestedResults = traverseChildren(nestedChildren, _childNames, child);
        memo = combine(memo, nestedResults);
      } else {
        var result = iteratee(child, childName, parent);

        if (result) {
          memo = combine(memo, result);
        }
      }

      return memo;
    }, initialMemo);
  };

  var childNames = children.map(function (c, i) {
    return i;
  });
  return traverseChildren(children, childNames);
}
/**
 * @param {Object} props: the props object
 * @returns {Boolean} returns true if the props object contains `horizontal: true` of if any
 * children or nested children are hoizontal
 */


function isHorizontal(props) {
  if (props.horizontal !== undefined || !props.children) {
    return props.horizontal;
  }

  var traverseChildren = function (childArray) {
    return childArray.reduce(function (memo, child) {
      var childProps = child.props || {};

      if (memo || childProps.horizontal || !childProps.children) {
        memo = memo || childProps.horizontal;
        return memo;
      }

      return traverseChildren(React__default['default'].Children.toArray(childProps.children));
    }, false);
  };

  return traverseChildren(React__default['default'].Children.toArray(props.children));
}

var Helpers = {
  omit: omit$1,
  getPoint: getPoint,
  scalePoint: scalePoint$1,
  getPadding: getPadding,
  getDefaultStyles: getDefaultStyles,
  getStyles: getStyles,
  evaluateProp: evaluateProp,
  evaluateStyle: evaluateStyle,
  degreesToRadians: degreesToRadians,
  radiansToDegrees: radiansToDegrees,
  getRadius: getRadius,
  getPolarOrigin: getPolarOrigin,
  getRange: getRange,
  createAccessor: createAccessor,
  modifyProps: modifyProps,
  getCurrentAxis: getCurrentAxis,
  reduceChildren: reduceChildren,
  isHorizontal: isHorizontal,
  isTooltip: isTooltip
};

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$6(target, key, source[key]); }); } return target; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$3(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$7(self); }

function _assertThisInitialized$7(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VictoryContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits$3(VictoryContainer, _React$Component);

  function VictoryContainer(props) {
    var _this;

    _classCallCheck$4(this, VictoryContainer);

    _this = _possibleConstructorReturn$3(this, (VictoryContainer.__proto__ || Object.getPrototypeOf(VictoryContainer)).call(this, props));
    _this.containerId = !isObject_1(props) || props.containerId === undefined ? uniqueId_1("victory-container-") : props.containerId;

    _this.savePortalRef = function (portal) {
      _this.portalRef = portal;
      return portal;
    };

    _this.portalUpdate = function (key, el) {
      return _this.portalRef.portalUpdate(key, el);
    };

    _this.portalRegister = function () {
      return _this.portalRef.portalRegister();
    };

    _this.portalDeregister = function (key) {
      return _this.portalRef.portalDeregister(key);
    };

    _this.saveContainerRef = props && isFunction_1(props.containerRef) ? props.containerRef : function (container) {
      _this.containerRef = container;
      return container;
    };
    _this.shouldHandleWheel = props && props.events && props.events.onWheel;

    if (_this.shouldHandleWheel) {
      _this.handleWheel = function (e) {
        return e.preventDefault();
      };
    }

    return _this;
  }

  _createClass$4(VictoryContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.shouldHandleWheel && this.containerRef) {
        this.containerRef.addEventListener("wheel", this.handleWheel);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.shouldHandleWheel && this.containerRef) {
        this.containerRef.removeEventListener("wheel", this.handleWheel);
      }
    }
  }, {
    key: "getIdForElement",
    value: function getIdForElement(elementName) {
      return "".concat(this.containerId, "-").concat(elementName);
    } // overridden in custom containers

  }, {
    key: "getChildren",
    value: function getChildren(props) {
      return props.children;
    } // Get props defined by the Open UI Automation (OUIA) 1.0-RC spec
    // See https://ouia.readthedocs.io/en/latest/README.html#ouia-component

  }, {
    key: "getOUIAProps",
    value: function getOUIAProps(props) {
      var ouiaId = props.ouiaId,
          ouiaSafe = props.ouiaSafe,
          ouiaType = props.ouiaType;
      return _objectSpread$4({}, ouiaId && {
        "data-ouia-component-id": ouiaId
      }, ouiaType && {
        "data-ouia-component-type": ouiaType
      }, ouiaSafe !== undefined && {
        "data-ouia-safe": ouiaSafe
      });
    }
  }, {
    key: "renderContainer",
    value: function renderContainer(props, svgProps, style) {
      var title = props.title,
          desc = props.desc,
          portalComponent = props.portalComponent,
          className = props.className,
          width = props.width,
          height = props.height,
          portalZIndex = props.portalZIndex,
          responsive = props.responsive;
      var children = this.getChildren(props);
      var dimensions = responsive ? {
        width: "100%",
        height: "100%"
      } : {
        width: width,
        height: height
      };

      var divStyle = assign_1({
        pointerEvents: "none",
        touchAction: "none",
        position: "relative"
      }, dimensions);

      var portalDivStyle = assign_1({
        zIndex: portalZIndex,
        position: "absolute",
        top: 0,
        left: 0
      }, dimensions);

      var svgStyle = assign_1({
        pointerEvents: "all"
      }, dimensions);

      var portalSvgStyle = assign_1({
        overflow: "visible"
      }, dimensions);

      var portalProps = {
        width: width,
        height: height,
        viewBox: svgProps.viewBox,
        preserveAspectRatio: svgProps.preserveAspectRatio,
        style: portalSvgStyle
      };
      return React__default['default'].createElement(PortalContext.Provider, {
        value: {
          portalUpdate: this.portalUpdate,
          portalRegister: this.portalRegister,
          portalDeregister: this.portalDeregister
        }
      }, React__default['default'].createElement("div", _extends$5({
        style: defaults_1({}, style, divStyle),
        className: className,
        ref: this.saveContainerRef
      }, this.getOUIAProps(props)), React__default['default'].createElement("svg", _extends$5({}, svgProps, {
        style: svgStyle
      }), title ? React__default['default'].createElement("title", {
        id: this.getIdForElement("title")
      }, title) : null, desc ? React__default['default'].createElement("desc", {
        id: this.getIdForElement("desc")
      }, desc) : null, children), React__default['default'].createElement("div", {
        style: portalDivStyle
      }, React__default['default'].cloneElement(portalComponent, _objectSpread$4({}, portalProps, {
        ref: this.savePortalRef
      })))));
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          width = _props.width,
          height = _props.height,
          responsive = _props.responsive,
          events = _props.events,
          title = _props.title,
          desc = _props.desc,
          tabIndex = _props.tabIndex,
          preserveAspectRatio = _props.preserveAspectRatio;
      var style = responsive ? this.props.style : Helpers.omit(this.props.style, ["height", "width"]);

      var svgProps = assign_1({
        width: width,
        height: height,
        tabIndex: tabIndex,
        role: "img",
        "aria-labelledby": [title && this.getIdForElement("title"), this.props["aria-labelledby"]].filter(Boolean).join(" ") || undefined,
        "aria-describedby": [desc && this.getIdForElement("desc"), this.props["aria-describedby"]].filter(Boolean).join(" ") || undefined,
        viewBox: responsive ? "0 0 ".concat(width, " ").concat(height) : undefined,
        preserveAspectRatio: responsive ? preserveAspectRatio : undefined
      }, events);

      return this.renderContainer(this.props, svgProps, style);
    }
  }]);

  return VictoryContainer;
}(React__default['default'].Component);

Object.defineProperty(VictoryContainer, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryContainer"
});
Object.defineProperty(VictoryContainer, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "container"
});
Object.defineProperty(VictoryContainer, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    "aria-describedby": PropTypes__default['default'].string,
    "aria-labelledby": PropTypes__default['default'].string,
    children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].node), PropTypes__default['default'].node]),
    className: PropTypes__default['default'].string,
    containerId: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
    containerRef: PropTypes__default['default'].func,
    desc: PropTypes__default['default'].string,
    events: PropTypes__default['default'].object,
    height: CustomPropTypes.nonNegative,
    name: PropTypes__default['default'].string,
    origin: PropTypes__default['default'].shape({
      x: CustomPropTypes.nonNegative,
      y: CustomPropTypes.nonNegative
    }),
    ouiaId: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
    ouiaSafe: PropTypes__default['default'].bool,
    ouiaType: PropTypes__default['default'].string,
    polar: PropTypes__default['default'].bool,
    portalComponent: PropTypes__default['default'].element,
    portalZIndex: CustomPropTypes.integer,
    preserveAspectRatio: PropTypes__default['default'].string,
    responsive: PropTypes__default['default'].bool,
    style: PropTypes__default['default'].object,
    tabIndex: PropTypes__default['default'].number,
    theme: PropTypes__default['default'].object,
    title: PropTypes__default['default'].string,
    width: CustomPropTypes.nonNegative
  }
});
Object.defineProperty(VictoryContainer, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    className: "VictoryContainer",
    portalComponent: React__default['default'].createElement(Portal$2, null),
    portalZIndex: 99,
    responsive: true
  }
});
Object.defineProperty(VictoryContainer, "contextType", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: TimerContext
});

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    setTag$3 = '[object Set]';

/** Used for built-in method references. */
var objectProto$i = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$i.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty$5(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike_1(value) &&
      (isArray_1(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer_1(value) || isTypedArray_1(value) || isArguments_1(value))) {
    return !value.length;
  }
  var tag = _getTag(value);
  if (tag == mapTag$3 || tag == setTag$3) {
    return !value.size;
  }
  if (_isPrototype(value)) {
    return !_baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$f.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty$5;

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$4(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$8(self); }

function _assertThisInitialized$8(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VictoryPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits$4(VictoryPortal, _React$Component);

  function VictoryPortal() {
    _classCallCheck$5(this, VictoryPortal);

    return _possibleConstructorReturn$4(this, (VictoryPortal.__proto__ || Object.getPrototypeOf(VictoryPortal)).apply(this, arguments));
  }

  _createClass$5(VictoryPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.checkedContext) {
        if (typeof this.context.portalUpdate !== "function") {
          var msg = "`renderInPortal` is not supported outside of `VictoryContainer`. " + "Component will be rendered in place";
          Log.warn(msg);
          this.renderInPlace = true;
        }

        this.checkedContext = true;
      }

      this.forceUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.renderInPlace) {
        this.portalKey = this.portalKey || this.context.portalRegister();
        this.context.portalUpdate(this.portalKey, this.element);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.context && this.context.portalDeregister) {
        this.context.portalDeregister(this.portalKey);
      }
    } // Overridden in victory-core-native

  }, {
    key: "renderPortal",
    value: function renderPortal(child) {
      if (this.renderInPlace) {
        return child;
      }

      this.element = child;
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var children = Array.isArray(this.props.children) ? this.props.children[0] : this.props.children;
      var groupComponent = this.props.groupComponent;
      var childProps = children && children.props || {};
      var standardProps = childProps.groupComponent ? {
        groupComponent: groupComponent,
        standalone: false
      } : {};

      var newProps = defaults_1(standardProps, childProps, Helpers.omit(this.props, ["children", "groupComponent"]));

      var child = children && React__default['default'].cloneElement(children, newProps);
      return this.renderPortal(child);
    }
  }]);

  return VictoryPortal;
}(React__default['default'].Component);

Object.defineProperty(VictoryPortal, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryPortal"
});
Object.defineProperty(VictoryPortal, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "portal"
});
Object.defineProperty(VictoryPortal, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    children: PropTypes__default['default'].node,
    groupComponent: PropTypes__default['default'].element
  }
});
Object.defineProperty(VictoryPortal, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    groupComponent: React__default['default'].createElement("g", null)
  }
});
Object.defineProperty(VictoryPortal, "contextType", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PortalContext
});

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var Rect = function (props) {
  // eslint-disable-next-line react/prop-types
  var desc = props.desc,
      rest = _objectWithoutProperties$2(props, ["desc"]);

  return desc ? React__default['default'].createElement("rect", _extends$6({
    vectorEffect: "non-scaling-stroke"
  }, rest), React__default['default'].createElement("desc", null, desc)) : React__default['default'].createElement("rect", _extends$6({
    vectorEffect: "non-scaling-stroke"
  }, rest));
};

// Private Functions
function getVerticalAnchor(props, datum) {
  datum = datum || {};
  var sign = datum._y >= 0 ? 1 : -1;
  var labelStyle = props.style && props.style.labels || {};

  if (datum.verticalAnchor || labelStyle.verticalAnchor) {
    return datum.verticalAnchor || labelStyle.verticalAnchor;
  } else if (!props.horizontal) {
    return sign >= 0 ? "end" : "start";
  } else {
    return "middle";
  }
}

function getTextAnchor(props, datum) {
  datum = datum || {};
  var style = props.style,
      horizontal = props.horizontal;
  var sign = datum._y >= 0 ? 1 : -1;
  var labelStyle = style && style.labels || {};

  if (datum.verticalAnchor || labelStyle.verticalAnchor) {
    return datum.verticalAnchor || labelStyle.verticalAnchor;
  } else if (!horizontal) {
    return "middle";
  } else {
    return sign >= 0 ? "start" : "end";
  }
}

function getAngle(props, datum) {
  datum = datum || {};
  var labelStyle = props.style && props.style.labels || {};
  return datum.angle === undefined ? labelStyle.angle : datum.angle;
}

function getPadding$1(props, datum) {
  datum = datum || {};
  var horizontal = props.horizontal,
      style = props.style;
  var labelStyle = style.labels || {};
  var defaultPadding = Helpers.evaluateProp(labelStyle.padding, props) || 0;
  var sign = datum._y < 0 ? -1 : 1;
  return {
    x: horizontal ? sign * defaultPadding : 0,
    y: horizontal ? 0 : -1 * sign * defaultPadding
  };
}

function getOffset(props, datum) {
  if (props.polar) {
    return {};
  }

  var padding = getPadding$1(props, datum);
  return {
    dx: padding.x,
    dy: padding.y
  };
}

function getPosition(props, datum) {
  var polar = props.polar;

  var _Helpers$scalePoint = Helpers.scalePoint(props, datum),
      x = _Helpers$scalePoint.x,
      y = _Helpers$scalePoint.y;

  if (!polar) {
    return {
      x: x,
      y: y
    };
  } else {
    var polarPadding = getPolarPadding(props, datum);
    return {
      x: x + polarPadding.x,
      y: y + polarPadding.y
    };
  }
}

function getPolarPadding(props, datum) {
  var style = props.style;
  var degrees = getDegrees(props, datum);
  var labelStyle = style.labels || {};
  var padding = Helpers.evaluateProp(labelStyle.padding, props) || 0;
  var angle = Helpers.degreesToRadians(degrees);
  return {
    x: padding * Math.cos(angle),
    y: -padding * Math.sin(angle)
  };
}

function getLabelPlacement(props) {
  var labelComponent = props.labelComponent,
      labelPlacement = props.labelPlacement,
      polar = props.polar;
  var defaultLabelPlacement = polar ? "perpendicular" : "vertical";
  return labelPlacement ? labelPlacement : labelComponent.props && labelComponent.props.labelPlacement || defaultLabelPlacement;
}

function getPolarOrientation(degrees) {
  // eslint-disable-next-line no-magic-numbers
  if (degrees < 45 || degrees > 315) {
    return "right"; // eslint-disable-next-line no-magic-numbers
  } else if (degrees >= 45 && degrees <= 135) {
    return "top"; // eslint-disable-next-line no-magic-numbers
  } else if (degrees > 135 && degrees < 225) {
    return "left";
  } else {
    return "bottom";
  }
} // Exported Functions


function getText(props, datum, index) {
  datum = datum || {};

  if (datum.label !== undefined) {
    return datum.label;
  }

  return Array.isArray(props.labels) ? props.labels[index] : props.labels;
}

function getPolarTextAnchor(props, degrees) {
  var labelPlacement = getLabelPlacement(props);

  if (labelPlacement === "perpendicular" || labelPlacement === "vertical" && (degrees === 90 || degrees === 270)) {
    return "middle";
  }

  return degrees <= 90 || degrees > 270 ? "start" : "end";
}

function getPolarVerticalAnchor(props, degrees) {
  var labelPlacement = getLabelPlacement(props);
  var orientation = getPolarOrientation(degrees);

  if (labelPlacement === "parallel" || orientation === "left" || orientation === "right") {
    return "middle";
  }

  return orientation === "top" ? "end" : "start";
}

function getPolarAngle(props, baseAngle) {
  var labelPlacement = props.labelPlacement,
      datum = props.datum;

  if (!labelPlacement || labelPlacement === "vertical") {
    return 0;
  }

  var degrees = baseAngle !== undefined ? baseAngle % 360 : getDegrees(props, datum);
  var sign = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
  var angle = 0;

  if (degrees === 0 || degrees === 180) {
    angle = 90;
  } else if (degrees > 0 && degrees < 180) {
    angle = 90 - degrees;
  } else if (degrees > 180 && degrees < 360) {
    angle = 270 - degrees;
  }

  var labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
  return angle + sign * labelRotation;
}

function getDegrees(props, datum) {
  var _Helpers$getPoint = Helpers.getPoint(datum),
      x = _Helpers$getPoint.x;

  return Helpers.radiansToDegrees(props.scale.x(x)) % 360;
}

function getProps(props, index) {
  var scale = props.scale,
      data = props.data,
      style = props.style,
      horizontal = props.horizontal,
      polar = props.polar,
      width = props.width,
      height = props.height,
      theme = props.theme,
      labelComponent = props.labelComponent;
  var datum = data[index];
  var degrees = getDegrees(props, datum);
  var textAnchor = polar ? getPolarTextAnchor(props, degrees) : getTextAnchor(props, datum);
  var verticalAnchor = polar ? getPolarVerticalAnchor(props, degrees) : getVerticalAnchor(props, datum);
  var angle = getAngle(props, datum);
  var text = getText(props, datum, index);
  var labelPlacement = getLabelPlacement(props);

  var _getPosition = getPosition(props, datum),
      x = _getPosition.x,
      y = _getPosition.y;

  var _getOffset = getOffset(props, datum),
      dx = _getOffset.dx,
      dy = _getOffset.dy;

  var labelProps = {
    angle: angle,
    data: data,
    datum: datum,
    horizontal: horizontal,
    index: index,
    polar: polar,
    scale: scale,
    labelPlacement: labelPlacement,
    text: text,
    textAnchor: textAnchor,
    verticalAnchor: verticalAnchor,
    x: x,
    y: y,
    dx: dx,
    dy: dy,
    width: width,
    height: height,
    style: style.labels
  };

  if (!Helpers.isTooltip(labelComponent)) {
    return labelProps;
  }

  var tooltipTheme = theme && theme.tooltip || {};
  return defaults_1({}, labelProps, Helpers.omit(tooltipTheme, ["style"]));
}

var LabelHelpers = {
  getText: getText,
  getPolarTextAnchor: getPolarTextAnchor,
  getPolarVerticalAnchor: getPolarVerticalAnchor,
  getPolarAngle: getPolarAngle,
  getDegrees: getDegrees,
  getProps: getProps
};

/**
 * Given an object with CSS/SVG transform definitions, return the string value
 * for use with the `transform` CSS property or SVG attribute. Note that we
 * can't always guarantee the order will match the author's intended order, so
 * authors should only use the object notation if they know that their transform
 * is commutative or that there is only one.
 * @param {Object} obj An object of transform definitions.
 * @returns {String} The generated transform string.
 */
var toTransformString = function (obj) {
  for (var _len = arguments.length, more = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }

  if (more.length > 0) {
    return more.reduce(function (memo, currentObj) {
      return [memo, toTransformString(currentObj)].join(" ");
    }, toTransformString(obj)).trim();
  } else {
    if (obj === undefined || obj === null || typeof obj === "string") {
      return obj;
    }

    var transforms = [];

    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        var value = obj[key];
        transforms.push("".concat(key, "(").concat(value, ")"));
      }
    }

    return transforms.join(" ").trim();
  }
};

var Style = {
  toTransformString: toTransformString,

  /**
   * Given the name of a color scale, getColorScale will return an array
   * of 5 hex string values in that color scale. If no 'name' parameter
   * is given, it will return the Victory default grayscale.
   * @param {String} name The name of the color scale to return (optional).
   * @returns {Array} An array of 5 hex string values composing a color scale.
   */
  getColorScale: function (name) {
    var scales = {
      grayscale: ["#cccccc", "#969696", "#636363", "#252525"],
      qualitative: ["#334D5C", "#45B29D", "#EFC94C", "#E27A3F", "#DF5A49", "#4F7DA1", "#55DBC1", "#EFDA97", "#E2A37F", "#DF948A"],
      heatmap: ["#428517", "#77D200", "#D6D305", "#EC8E19", "#C92B05"],
      warm: ["#940031", "#C43343", "#DC5429", "#FF821D", "#FFAF55"],
      cool: ["#2746B9", "#0B69D4", "#2794DB", "#31BB76", "#60E83B"],
      red: ["#FCAE91", "#FB6A4A", "#DE2D26", "#A50F15", "#750B0E"],
      blue: ["#002C61", "#004B8F", "#006BC9", "#3795E5", "#65B4F4"],
      green: ["#354722", "#466631", "#649146", "#8AB25C", "#A9C97E"]
    };
    return name ? scales[name] : scales.grayscale;
  }
};

function _toConsumableArray$3(arr) { return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _nonIterableSpread$3(); }

function _nonIterableSpread$3() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$3(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$3(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// Based on measuring specific character widths
// as in the following example https://bl.ocks.org/tophtucker/62f93a4658387bb61e4510c37e2e97cf
//prettier-ignore
var fonts = {
  "American Typewriter": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.4203125, 0.3296875, 0.6, 0.6375, 0.8015625, 0.8203125, 0.1875, 0.45625, 0.45625, 0.6375, 0.5, 0.2734375, 0.309375, 0.2734375, 0.4390625, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.2734375, 0.2734375, 0.5, 0.5, 0.5, 0.6, 0.6921875, 0.7640625, 0.6921875, 0.6375, 0.728125, 0.6734375, 0.6203125, 0.7109375, 0.784375, 0.3828125, 0.6421875, 0.7859375, 0.6375, 0.9484375, 0.7640625, 0.65625, 0.6375, 0.65625, 0.7296875, 0.6203125, 0.6375, 0.7109375, 0.740625, 0.940625, 0.784375, 0.7578125, 0.6203125, 0.4375, 0.5, 0.4375, 0.5, 0.5, 0.4921875, 0.5734375, 0.5890625, 0.5109375, 0.6, 0.528125, 0.43125, 0.5578125, 0.6375, 0.3109375, 0.40625, 0.6234375, 0.309375, 0.928125, 0.6375, 0.546875, 0.6, 0.58125, 0.4921875, 0.4921875, 0.4, 0.6203125, 0.625, 0.825, 0.6375, 0.640625, 0.528125, 0.5, 0.5, 0.5, 0.6671875],
    avg: 0.5793421052631578
  },
  Arial: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.278125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.584375, 0.584375, 0.584375, 0.55625, 1.015625, 0.6703125, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.278125, 0.278125, 0.4703125, 0.584375, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.3125, 0.55625, 0.55625, 0.2234375, 0.2703125, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.346875, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.334375, 0.2609375, 0.334375, 0.584375],
    avg: 0.528733552631579
  },
  "Arial Black": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.33125, 0.334375, 0.5, 0.6609375, 0.6671875, 1, 0.890625, 0.278125, 0.390625, 0.390625, 0.55625, 0.6609375, 0.334375, 0.334375, 0.334375, 0.28125, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.334375, 0.334375, 0.6609375, 0.6609375, 0.6609375, 0.6109375, 0.7453125, 0.78125, 0.778125, 0.778125, 0.778125, 0.7234375, 0.6671875, 0.834375, 0.834375, 0.390625, 0.6671875, 0.834375, 0.6671875, 0.9453125, 0.834375, 0.834375, 0.7234375, 0.834375, 0.78125, 0.7234375, 0.7234375, 0.834375, 0.7796875, 1.003125, 0.78125, 0.78125, 0.7234375, 0.390625, 0.28125, 0.390625, 0.6609375, 0.5125, 0.334375, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.41875, 0.6671875, 0.6671875, 0.334375, 0.384375, 0.6671875, 0.334375, 1, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.4703125, 0.6109375, 0.4453125, 0.6671875, 0.6140625, 0.946875, 0.6671875, 0.615625, 0.55625, 0.390625, 0.278125, 0.390625, 0.6609375],
    avg: 0.6213157894736842
  },
  Baskerville: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.25, 0.40625, 0.6671875, 0.490625, 0.875, 0.7015625, 0.178125, 0.2453125, 0.246875, 0.4171875, 0.6671875, 0.25, 0.3125, 0.25, 0.521875, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.25, 0.25, 0.6671875, 0.6671875, 0.6671875, 0.396875, 0.9171875, 0.684375, 0.615625, 0.71875, 0.7609375, 0.625, 0.553125, 0.771875, 0.803125, 0.3546875, 0.515625, 0.78125, 0.6046875, 0.928125, 0.75, 0.8234375, 0.5625, 0.96875, 0.7296875, 0.5421875, 0.6984375, 0.771875, 0.7296875, 0.9484375, 0.771875, 0.678125, 0.6359375, 0.3640625, 0.521875, 0.3640625, 0.46875, 0.5125, 0.334375, 0.46875, 0.521875, 0.428125, 0.521875, 0.4375, 0.3890625, 0.4765625, 0.53125, 0.25, 0.359375, 0.4640625, 0.240625, 0.803125, 0.53125, 0.5, 0.521875, 0.521875, 0.365625, 0.334375, 0.2921875, 0.521875, 0.4640625, 0.678125, 0.4796875, 0.465625, 0.428125, 0.4796875, 0.5109375, 0.4796875, 0.6671875],
    avg: 0.5323519736842108
  },
  Courier: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6078125, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.61875, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.615625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6140625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6020559210526316
  },
  "Courier New": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6015296052631579
  },
  cursive: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.1921875, 0.24375, 0.40625, 0.5671875, 0.3984375, 0.721875, 0.909375, 0.2328125, 0.434375, 0.365625, 0.4734375, 0.5578125, 0.19375, 0.3484375, 0.19375, 0.7734375, 0.503125, 0.4171875, 0.5453125, 0.45, 0.6046875, 0.4703125, 0.5984375, 0.55625, 0.503125, 0.5546875, 0.20625, 0.2, 0.5625, 0.5546875, 0.546875, 0.403125, 0.70625, 0.734375, 0.7078125, 0.64375, 0.85, 0.753125, 0.75, 0.6484375, 1.0765625, 0.44375, 0.5359375, 0.8359375, 0.653125, 1.0109375, 1.1515625, 0.6796875, 0.6984375, 1.0625, 0.8234375, 0.5125, 0.9234375, 0.8546875, 0.70625, 0.9109375, 0.7421875, 0.715625, 0.6015625, 0.4640625, 0.3359375, 0.4109375, 0.5421875, 0.5421875, 0.4328125, 0.5125, 0.5, 0.3859375, 0.7375, 0.359375, 0.75625, 0.540625, 0.5328125, 0.3203125, 0.5296875, 0.5015625, 0.484375, 0.7890625, 0.5640625, 0.4203125, 0.703125, 0.471875, 0.4734375, 0.35, 0.4125, 0.5640625, 0.471875, 0.6484375, 0.5296875, 0.575, 0.4140625, 0.415625, 0.20625, 0.3796875, 0.5421875],
    avg: 0.5604440789473684
  },
  fantasy: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.215625, 0.2625, 0.3265625, 0.6109375, 0.534375, 0.7625, 0.7828125, 0.2, 0.4359375, 0.4359375, 0.3765625, 0.5109375, 0.2796875, 0.4609375, 0.2796875, 0.5296875, 0.6640625, 0.253125, 0.521875, 0.4765625, 0.6640625, 0.490625, 0.528125, 0.5546875, 0.496875, 0.5421875, 0.2796875, 0.2796875, 0.5625, 0.4609375, 0.5625, 0.4828125, 0.609375, 0.740625, 0.7234375, 0.740625, 0.8265625, 0.7234375, 0.6171875, 0.7359375, 0.765625, 0.240625, 0.5453125, 0.715625, 0.6078125, 0.8640625, 0.653125, 0.9125, 0.6484375, 0.946875, 0.6921875, 0.653125, 0.6953125, 0.8015625, 0.58125, 0.784375, 0.671875, 0.6265625, 0.690625, 0.4359375, 0.5296875, 0.4359375, 0.53125, 0.5, 0.2875, 0.5375, 0.603125, 0.4984375, 0.60625, 0.53125, 0.434375, 0.6421875, 0.56875, 0.209375, 0.4671875, 0.5484375, 0.2203125, 0.709375, 0.55, 0.5984375, 0.6140625, 0.5765625, 0.40625, 0.4734375, 0.3734375, 0.559375, 0.4421875, 0.6421875, 0.4890625, 0.578125, 0.4484375, 0.2546875, 0.2203125, 0.2546875, 0.55],
    avg: 0.536496710526316
  },
  Geneva: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3328125, 0.3046875, 0.5, 0.6671875, 0.6671875, 0.90625, 0.728125, 0.3046875, 0.446875, 0.446875, 0.5078125, 0.6671875, 0.3046875, 0.3796875, 0.3046875, 0.5390625, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.3046875, 0.3046875, 0.6671875, 0.6671875, 0.6671875, 0.56875, 0.871875, 0.728125, 0.6375, 0.6515625, 0.7015625, 0.5765625, 0.5546875, 0.675, 0.690625, 0.2421875, 0.4921875, 0.6640625, 0.584375, 0.7890625, 0.709375, 0.7359375, 0.584375, 0.78125, 0.60625, 0.60625, 0.640625, 0.6671875, 0.728125, 0.946875, 0.6109375, 0.6109375, 0.5765625, 0.446875, 0.5390625, 0.446875, 0.6671875, 0.6671875, 0.5921875, 0.5546875, 0.6109375, 0.546875, 0.603125, 0.5765625, 0.390625, 0.6109375, 0.584375, 0.2359375, 0.334375, 0.5390625, 0.2359375, 0.8953125, 0.584375, 0.60625, 0.603125, 0.603125, 0.3875, 0.509375, 0.44375, 0.584375, 0.565625, 0.78125, 0.53125, 0.571875, 0.5546875, 0.4515625, 0.246875, 0.4515625, 0.6671875],
    avg: 0.5762664473684211
  },
  Georgia: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2421875, 0.33125, 0.4125, 0.64375, 0.6109375, 0.81875, 0.7109375, 0.215625, 0.375, 0.375, 0.4734375, 0.64375, 0.2703125, 0.375, 0.2703125, 0.46875, 0.6140625, 0.4296875, 0.559375, 0.553125, 0.565625, 0.5296875, 0.5671875, 0.503125, 0.596875, 0.5671875, 0.3125, 0.3125, 0.64375, 0.64375, 0.64375, 0.4796875, 0.9296875, 0.715625, 0.6546875, 0.6421875, 0.75, 0.6546875, 0.6, 0.7265625, 0.815625, 0.390625, 0.51875, 0.7203125, 0.6046875, 0.928125, 0.7671875, 0.7453125, 0.6109375, 0.7453125, 0.7234375, 0.5625, 0.61875, 0.7578125, 0.70625, 0.99375, 0.7125, 0.6640625, 0.6015625, 0.375, 0.46875, 0.375, 0.64375, 0.65, 0.5, 0.5046875, 0.56875, 0.4546875, 0.575, 0.484375, 0.39375, 0.509375, 0.5828125, 0.29375, 0.3671875, 0.546875, 0.2875, 0.88125, 0.5921875, 0.5390625, 0.571875, 0.5640625, 0.4109375, 0.4328125, 0.3453125, 0.5765625, 0.5203125, 0.75625, 0.50625, 0.5171875, 0.4453125, 0.43125, 0.375, 0.43125, 0.64375],
    avg: 0.5551809210526316
  },
  "Gill Sans": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2765625, 0.271875, 0.3546875, 0.584375, 0.5421875, 0.6765625, 0.625, 0.1890625, 0.3234375, 0.3234375, 0.4171875, 0.584375, 0.2203125, 0.3234375, 0.2203125, 0.28125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.2203125, 0.2296875, 0.584375, 0.584375, 0.584375, 0.334375, 1.0109375, 0.6671875, 0.5640625, 0.709375, 0.75, 0.5, 0.4703125, 0.740625, 0.7296875, 0.25, 0.3125, 0.65625, 0.490625, 0.78125, 0.78125, 0.8234375, 0.5109375, 0.8234375, 0.6046875, 0.459375, 0.6046875, 0.709375, 0.6046875, 1.0421875, 0.709375, 0.6046875, 0.646875, 0.334375, 0.28125, 0.334375, 0.4703125, 0.5828125, 0.334375, 0.428125, 0.5, 0.4390625, 0.5109375, 0.4796875, 0.296875, 0.428125, 0.5, 0.2203125, 0.2265625, 0.5, 0.2203125, 0.771875, 0.5, 0.553125, 0.5, 0.5, 0.3984375, 0.3859375, 0.334375, 0.5, 0.4390625, 0.7203125, 0.5, 0.4390625, 0.4171875, 0.334375, 0.2609375, 0.334375, 0.584375],
    avg: 0.4933717105263159
  },
  Helvetica: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2796875, 0.2765625, 0.3546875, 0.5546875, 0.5546875, 0.8890625, 0.665625, 0.190625, 0.3328125, 0.3328125, 0.3890625, 0.5828125, 0.2765625, 0.3328125, 0.2765625, 0.3015625, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.2765625, 0.2765625, 0.584375, 0.5828125, 0.584375, 0.5546875, 1.0140625, 0.665625, 0.665625, 0.721875, 0.721875, 0.665625, 0.609375, 0.7765625, 0.721875, 0.2765625, 0.5, 0.665625, 0.5546875, 0.8328125, 0.721875, 0.7765625, 0.665625, 0.7765625, 0.721875, 0.665625, 0.609375, 0.721875, 0.665625, 0.94375, 0.665625, 0.665625, 0.609375, 0.2765625, 0.3546875, 0.2765625, 0.4765625, 0.5546875, 0.3328125, 0.5546875, 0.5546875, 0.5, 0.5546875, 0.5546875, 0.2765625, 0.5546875, 0.5546875, 0.221875, 0.240625, 0.5, 0.221875, 0.8328125, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.3328125, 0.5, 0.2765625, 0.5546875, 0.5, 0.721875, 0.5, 0.5, 0.5, 0.3546875, 0.259375, 0.353125, 0.5890625],
    avg: 0.5279276315789471
  },
  "Helvetica Neue": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.259375, 0.4265625, 0.55625, 0.55625, 1, 0.6453125, 0.278125, 0.2703125, 0.26875, 0.353125, 0.6, 0.278125, 0.3890625, 0.278125, 0.36875, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.6, 0.6, 0.6, 0.55625, 0.8, 0.6625, 0.6859375, 0.7234375, 0.7046875, 0.6125, 0.575, 0.759375, 0.7234375, 0.259375, 0.5203125, 0.6703125, 0.55625, 0.871875, 0.7234375, 0.7609375, 0.6484375, 0.7609375, 0.6859375, 0.6484375, 0.575, 0.7234375, 0.6140625, 0.9265625, 0.6125, 0.6484375, 0.6125, 0.259375, 0.36875, 0.259375, 0.6, 0.5, 0.25625, 0.5375, 0.59375, 0.5375, 0.59375, 0.5375, 0.2984375, 0.575, 0.55625, 0.2234375, 0.2375, 0.5203125, 0.2234375, 0.853125, 0.55625, 0.575, 0.59375, 0.59375, 0.334375, 0.5, 0.315625, 0.55625, 0.5, 0.759375, 0.51875, 0.5, 0.48125, 0.334375, 0.2234375, 0.334375, 0.6],
    avg: 0.5279440789473684
  },
  "Hoefler Text": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2359375, 0.2234375, 0.3921875, 0.7125, 0.49375, 0.8859375, 0.771875, 0.2125, 0.3078125, 0.309375, 0.375, 0.4234375, 0.234375, 0.3125, 0.234375, 0.3, 0.5828125, 0.365625, 0.434375, 0.3921875, 0.5234375, 0.3984375, 0.5125, 0.4328125, 0.46875, 0.5125, 0.234375, 0.234375, 0.515625, 0.4234375, 0.515625, 0.340625, 0.7609375, 0.7359375, 0.6359375, 0.721875, 0.8125, 0.6375, 0.5875, 0.8078125, 0.853125, 0.4296875, 0.503125, 0.78125, 0.609375, 0.9609375, 0.8515625, 0.8140625, 0.6125, 0.8140625, 0.71875, 0.49375, 0.7125, 0.76875, 0.771875, 1.125, 0.7765625, 0.7734375, 0.65625, 0.321875, 0.3078125, 0.321875, 0.3546875, 0.5, 0.3375, 0.446875, 0.5359375, 0.45, 0.5296875, 0.4546875, 0.425, 0.4921875, 0.54375, 0.2671875, 0.240625, 0.5390625, 0.25, 0.815625, 0.5375, 0.5234375, 0.5390625, 0.5421875, 0.365625, 0.36875, 0.35625, 0.5171875, 0.5015625, 0.75, 0.5, 0.509375, 0.44375, 0.2421875, 0.14375, 0.2421875, 0.35],
    avg: 0.5116447368421051
  },
  monospace: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6078125, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.61875, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.615625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6140625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6020559210526316
  },
  Palatino: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.278125, 0.371875, 0.60625, 0.5, 0.840625, 0.778125, 0.209375, 0.334375, 0.334375, 0.390625, 0.60625, 0.2578125, 0.334375, 0.25, 0.60625, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.25, 0.25, 0.60625, 0.60625, 0.60625, 0.4453125, 0.7484375, 0.778125, 0.6109375, 0.709375, 0.775, 0.6109375, 0.55625, 0.7640625, 0.8328125, 0.3375, 0.346875, 0.7265625, 0.6109375, 0.946875, 0.83125, 0.7875, 0.6046875, 0.7875, 0.66875, 0.525, 0.6140625, 0.778125, 0.7234375, 1, 0.6671875, 0.6671875, 0.6671875, 0.334375, 0.60625, 0.334375, 0.60625, 0.5, 0.334375, 0.5, 0.565625, 0.4453125, 0.6109375, 0.4796875, 0.340625, 0.55625, 0.5828125, 0.2921875, 0.2671875, 0.5640625, 0.2921875, 0.8828125, 0.5828125, 0.546875, 0.6015625, 0.5609375, 0.3953125, 0.425, 0.3265625, 0.603125, 0.565625, 0.834375, 0.5171875, 0.55625, 0.5, 0.334375, 0.60625, 0.334375, 0.60625],
    avg: 0.5408552631578947
  },
  "sans-serif": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.303125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.5859375, 0.584375, 0.5859375, 0.55625, 1.015625, 0.6671875, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.35625, 0.278125, 0.478125, 0.55625, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.278125, 0.55625, 0.55625, 0.2234375, 0.2421875, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.334375, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.35625, 0.2609375, 0.3546875, 0.590625],
    avg: 0.5293256578947368
  },
  Seravek: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.215625, 0.296875, 0.4171875, 0.6734375, 0.4953125, 0.9125, 0.740625, 0.2421875, 0.3375, 0.3375, 0.409375, 0.60625, 0.2609375, 0.35625, 0.25625, 0.41875, 0.5921875, 0.3515625, 0.475, 0.4875, 0.5375, 0.509375, 0.5484375, 0.4546875, 0.5421875, 0.5484375, 0.25625, 0.2546875, 0.5875, 0.6171875, 0.5875, 0.4578125, 0.8140625, 0.6765625, 0.5703125, 0.6109375, 0.684375, 0.5109375, 0.4953125, 0.678125, 0.6859375, 0.2625, 0.2625, 0.5859375, 0.4734375, 0.846875, 0.709375, 0.740625, 0.509375, 0.740625, 0.584375, 0.5015625, 0.528125, 0.675, 0.5953125, 0.9453125, 0.596875, 0.540625, 0.540625, 0.359375, 0.4203125, 0.359375, 0.5109375, 0.421875, 0.4046875, 0.5015625, 0.5421875, 0.446875, 0.5453125, 0.484375, 0.38125, 0.5140625, 0.5546875, 0.240625, 0.2640625, 0.490625, 0.2765625, 0.8625, 0.5546875, 0.546875, 0.5453125, 0.5453125, 0.3625, 0.41875, 0.3890625, 0.5453125, 0.4703125, 0.7546875, 0.4921875, 0.4609375, 0.453125, 0.4015625, 0.2640625, 0.4015625, 0.58125],
    avg: 0.5044078947368421
  },
  serif: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2484375, 0.334375, 0.409375, 0.5, 0.5, 0.834375, 0.778125, 0.18125, 0.334375, 0.334375, 0.5, 0.5640625, 0.25, 0.334375, 0.25, 0.278125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.278125, 0.278125, 0.5640625, 0.5640625, 0.5640625, 0.4453125, 0.921875, 0.7234375, 0.6671875, 0.6671875, 0.7234375, 0.6109375, 0.55625, 0.7234375, 0.7234375, 0.334375, 0.390625, 0.7234375, 0.6109375, 0.890625, 0.7234375, 0.7234375, 0.55625, 0.7234375, 0.6671875, 0.55625, 0.6109375, 0.7234375, 0.7234375, 0.9453125, 0.7234375, 0.7234375, 0.6109375, 0.334375, 0.340625, 0.334375, 0.4703125, 0.5, 0.3453125, 0.4453125, 0.5, 0.4453125, 0.5, 0.4453125, 0.3828125, 0.5, 0.5, 0.278125, 0.3359375, 0.5, 0.278125, 0.778125, 0.5, 0.5, 0.5, 0.5, 0.3375, 0.390625, 0.2796875, 0.5, 0.5, 0.7234375, 0.5, 0.5, 0.4453125, 0.48125, 0.2015625, 0.48125, 0.5421875],
    avg: 0.5126315789473684
  },
  Tahoma: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3109375, 0.3328125, 0.4015625, 0.728125, 0.546875, 0.9765625, 0.70625, 0.2109375, 0.3828125, 0.3828125, 0.546875, 0.728125, 0.303125, 0.3640625, 0.303125, 0.3953125, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.3546875, 0.3546875, 0.728125, 0.728125, 0.728125, 0.475, 0.909375, 0.6109375, 0.590625, 0.6015625, 0.6796875, 0.5625, 0.521875, 0.66875, 0.6765625, 0.3734375, 0.4171875, 0.6046875, 0.4984375, 0.771875, 0.66875, 0.7078125, 0.5515625, 0.7078125, 0.6375, 0.5578125, 0.5875, 0.65625, 0.60625, 0.903125, 0.58125, 0.5890625, 0.559375, 0.3828125, 0.39375, 0.3828125, 0.728125, 0.5625, 0.546875, 0.525, 0.553125, 0.4625, 0.553125, 0.5265625, 0.3546875, 0.553125, 0.5578125, 0.2296875, 0.328125, 0.51875, 0.2296875, 0.840625, 0.5578125, 0.54375, 0.553125, 0.553125, 0.3609375, 0.446875, 0.3359375, 0.5578125, 0.4984375, 0.7421875, 0.4953125, 0.4984375, 0.4453125, 0.48125, 0.3828125, 0.48125, 0.728125],
    avg: 0.5384374999999998
  },
  "Times New Roman": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2484375, 0.334375, 0.409375, 0.5, 0.5, 0.834375, 0.778125, 0.18125, 0.334375, 0.334375, 0.5, 0.5640625, 0.25, 0.334375, 0.25, 0.28125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.278125, 0.278125, 0.5640625, 0.5640625, 0.5640625, 0.4453125, 0.921875, 0.7234375, 0.6671875, 0.6671875, 0.7234375, 0.6109375, 0.55625, 0.7234375, 0.7234375, 0.334375, 0.390625, 0.73125, 0.6109375, 0.890625, 0.7375, 0.7234375, 0.55625, 0.7234375, 0.6765625, 0.55625, 0.6109375, 0.7234375, 0.7234375, 0.9453125, 0.7234375, 0.7234375, 0.6109375, 0.334375, 0.28125, 0.334375, 0.4703125, 0.51875, 0.334375, 0.4453125, 0.503125, 0.4453125, 0.503125, 0.4453125, 0.4359375, 0.5, 0.5, 0.278125, 0.35625, 0.50625, 0.278125, 0.778125, 0.5, 0.5, 0.5046875, 0.5, 0.340625, 0.390625, 0.2796875, 0.5, 0.5, 0.7234375, 0.5, 0.5, 0.4453125, 0.48125, 0.2015625, 0.48125, 0.5421875],
    avg: 0.5134375
  },
  "Trebuchet MS": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3015625, 0.3671875, 0.325, 0.53125, 0.525, 0.6015625, 0.70625, 0.1609375, 0.3671875, 0.3671875, 0.3671875, 0.525, 0.3671875, 0.3671875, 0.3671875, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.3671875, 0.3671875, 0.525, 0.525, 0.525, 0.3671875, 0.771875, 0.590625, 0.5671875, 0.5984375, 0.6140625, 0.5359375, 0.525, 0.6765625, 0.6546875, 0.2796875, 0.4765625, 0.5765625, 0.5078125, 0.7109375, 0.6390625, 0.675, 0.5578125, 0.7421875, 0.5828125, 0.48125, 0.58125, 0.6484375, 0.5875, 0.853125, 0.5578125, 0.5703125, 0.5515625, 0.3671875, 0.3578125, 0.3671875, 0.525, 0.53125, 0.525, 0.5265625, 0.5578125, 0.4953125, 0.5578125, 0.546875, 0.375, 0.503125, 0.546875, 0.2859375, 0.3671875, 0.5046875, 0.2953125, 0.83125, 0.546875, 0.5375, 0.5578125, 0.5578125, 0.3890625, 0.40625, 0.396875, 0.546875, 0.490625, 0.7453125, 0.5015625, 0.49375, 0.475, 0.3671875, 0.525, 0.3671875, 0.525],
    avg: 0.5085197368421052
  },
  Verdana: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.35, 0.39375, 0.459375, 0.81875, 0.6359375, 1.0765625, 0.759375, 0.26875, 0.4546875, 0.4546875, 0.6359375, 0.81875, 0.3640625, 0.4546875, 0.3640625, 0.4703125, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.4546875, 0.4546875, 0.81875, 0.81875, 0.81875, 0.546875, 1, 0.684375, 0.6859375, 0.6984375, 0.771875, 0.6328125, 0.575, 0.7765625, 0.7515625, 0.421875, 0.4546875, 0.69375, 0.5578125, 0.84375, 0.7484375, 0.7875, 0.603125, 0.7875, 0.7, 0.684375, 0.6171875, 0.7328125, 0.684375, 0.9890625, 0.6859375, 0.615625, 0.6859375, 0.4546875, 0.46875, 0.4546875, 0.81875, 0.6421875, 0.6359375, 0.6015625, 0.6234375, 0.521875, 0.6234375, 0.596875, 0.384375, 0.6234375, 0.6328125, 0.275, 0.3765625, 0.5921875, 0.275, 0.9734375, 0.6328125, 0.6078125, 0.6234375, 0.6234375, 0.43125, 0.521875, 0.3953125, 0.6328125, 0.5921875, 0.81875, 0.5921875, 0.5921875, 0.5265625, 0.6359375, 0.4546875, 0.6359375, 0.81875],
    avg: 0.6171875000000003
  } //https://developer.mozilla.org/en/docs/Web/CSS/length
  // Absolute sizes in pixels for obsolete measurement units.

};
var absoluteMeasurementUnitsToPixels = {
  mm: 3.8,
  sm: 38,
  pt: 1.33,
  pc: 16,
  in: 96,
  px: 1
};
var relativeMeasurementUnitsCoef = {
  em: 1,
  ex: 0.5
};
var coefficients = {
  heightOverlapCoef: 1.05,
  // Coefficient for height value to prevent overlap.
  lineCapitalCoef: 1.15 // Coefficient for height value. Reserve space for capital chars.

};
var defaultStyle = {
  lineHeight: 1,
  letterSpacing: "0px",
  fontSize: 0,
  angle: 0,
  fontFamily: ""
};

var _degreeToRadian = function (angle) {
  return angle * Math.PI / 180;
};

var _getFontData = function (fontFamily) {
  var possibleFonts = fontFamily.split(",").map(function (f) {
    return f.replace(/'|"/g, "");
  });
  var fontMatch = possibleFonts.find(function (f) {
    return fonts[f];
  }) || "Helvetica";
  return fonts[fontMatch];
};

var _splitToLines = function (text) {
  return Array.isArray(text) ? text : text.toString().split(/\r\n|\r|\n/g);
};

var _getSizeWithRotate = function (axisSize, dependentSize, angle) {
  var angleInRadian = _degreeToRadian(angle);

  return Math.abs(Math.cos(angleInRadian) * axisSize) + Math.abs(Math.sin(angleInRadian) * dependentSize);
};
/**
 * Convert length-type parameters from specific measurement units to pixels
 * @param  {string} length Css length string value.
 * @param  {number} fontSize Current text font-size.
 * @returns {number} Approximate Css length in pixels.
 */


var convertLengthToPixels = function (length, fontSize) {
  var attribute = length.match(/[a-zA-Z%]+/) && length.match(/[a-zA-Z%]+/)[0];
  var value = length.match(/[0-9.,]+/);
  var result;

  if (!attribute) {
    result = value || 0;
  } else if (absoluteMeasurementUnitsToPixels.hasOwnProperty(attribute)) {
    result = value * absoluteMeasurementUnitsToPixels[attribute];
  } else if (relativeMeasurementUnitsCoef.hasOwnProperty(attribute)) {
    result = (fontSize ? value * fontSize : value * defaultStyle.fontSize) * relativeMeasurementUnitsCoef[attribute];
  } else {
    result = value;
  }

  return result;
};

var _prepareParams = function (inputStyle, index) {
  var lineStyle = Array.isArray(inputStyle) ? inputStyle[index] : inputStyle;

  var style = defaults_1({}, lineStyle, defaultStyle);

  return assign_1({}, style, {
    fontFamily: style.fontFamily,
    letterSpacing: typeof style.letterSpacing === "number" ? style.letterSpacing : convertLengthToPixels(String(style.letterSpacing), style.fontSize),
    fontSize: typeof style.fontSize === "number" ? style.fontSize : convertLengthToPixels(String(style.fontSize))
  });
};

var _approximateTextWidthInternal = function (text, style) {
  if (text === undefined || text === "" || text === null) {
    return 0;
  }

  var widths = _splitToLines(text).map(function (line, index) {
    var len = line.toString().length;

    var _prepareParams2 = _prepareParams(style, index),
        fontSize = _prepareParams2.fontSize,
        letterSpacing = _prepareParams2.letterSpacing,
        fontFamily = _prepareParams2.fontFamily;

    var fontData = _getFontData(fontFamily);

    var width = line.toString().split("").map(function (c) {
      return c.charCodeAt(0) < fontData.widths.length ? fontData.widths[c.charCodeAt(0)] : fontData.avg;
    }).reduce(function (cur, acc) {
      return acc + cur;
    }, 0) * fontSize;
    return width + letterSpacing * Math.max(len - 1, 0);
  });

  return Math.max.apply(Math, _toConsumableArray$3(widths));
};

var _approximateTextHeightInternal = function (text, style) {
  if (text === undefined || text === "" || text === null) {
    return 0;
  }

  return _splitToLines(text).reduce(function (total, line, index) {
    var lineStyle = _prepareParams(style, index);

    var containsCaps = line.toString().match(/[(A-Z)(0-9)]/);
    var height = containsCaps ? lineStyle.fontSize * coefficients.lineCapitalCoef : lineStyle.fontSize;
    return total + lineStyle.lineHeight * height;
  }, 0);
};
/**
 * Predict text size by font params.
 * @param {string} text Content for width calculation.
 * @param {Object} style Text styles, ,fontFamily, fontSize, etc.
 * @param {string} style.fontFamily Text fontFamily.
 * @param {(number|string)} style.fontSize Text fontSize.
 * @param {number} style.angle Text rotate angle.
 * @param {string} style.letterSpacing Text letterSpacing(space between letters).
 * @param {number} style.lineHeight Line height coefficient.
 * @returns {number} Approximate text label height.
 */


var approximateTextSize = function (text, style) {
  var angle = Array.isArray(style) ? style[0] && style[0].angle : style && style.angle;

  var height = _approximateTextHeightInternal(text, style);

  var width = _approximateTextWidthInternal(text, style);

  var widthWithRotate = angle ? _getSizeWithRotate(width, height, angle) : width;
  var heightWithRotate = angle ? _getSizeWithRotate(height, width, angle) : height;
  return {
    width: widthWithRotate,
    height: heightWithRotate * coefficients.heightOverlapCoef
  };
};

var TextSize = {
  approximateTextSize: approximateTextSize,
  convertLengthToPixels: convertLengthToPixels
};

var TSpan = function (props) {
  return React__default['default'].createElement("tspan", props);
};

function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var Text = function (props) {
  var children = props.children,
      title = props.title,
      desc = props.desc,
      rest = _objectWithoutProperties$3(props, ["children", "title", "desc"]);

  return React__default['default'].createElement("text", rest, title && React__default['default'].createElement("title", null, title), desc && React__default['default'].createElement("desc", null, desc), children);
};

Text.propTypes = {
  children: PropTypes__default['default'].node,
  desc: PropTypes__default['default'].string,
  title: PropTypes__default['default'].string
};

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$7(target, key, source[key]); }); } return target; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray$4(arr) { return _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _nonIterableSpread$4(); }

function _nonIterableSpread$4() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$4(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$4(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
var defaultStyles = {
  fill: "#252525",
  fontSize: 14,
  fontFamily: "'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif",
  stroke: "transparent"
};

var getPosition$1 = function (props, dimension) {
  if (!props.datum) {
    return 0;
  }

  var scaledPoint = Helpers.scalePoint(props, props.datum);
  return scaledPoint[dimension];
};

var getFontSize = function (style) {
  var baseSize = style && style.fontSize;

  if (typeof baseSize === "number") {
    return baseSize;
  } else if (baseSize === undefined || baseSize === null) {
    return defaultStyles.fontSize;
  } else if (typeof baseSize === "string") {
    var fontSize = +baseSize.replace("px", "");

    if (!isNaN(fontSize)) {
      return fontSize;
    } else {
      Log.warn("fontSize should be expressed as a number of pixels");
      return defaultStyles.fontSize;
    }
  }

  return defaultStyles.fontSize;
};

var getSingleValue = function (prop) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Array.isArray(prop) ? prop[index] || prop[0] : prop;
};

var useMultiLineBackgrounds = function (props) {
  var backgroundStyle = props.backgroundStyle,
      backgroundPadding = props.backgroundPadding;
  return Array.isArray(backgroundStyle) && !isEmpty_1(backgroundStyle) || Array.isArray(backgroundPadding) && !isEmpty_1(backgroundPadding);
};

var getStyles$1 = function (style, props) {
  var getSingleStyle = function (s) {
    s = s ? defaults_1({}, s, defaultStyles) : defaultStyles;
    var baseStyles = Helpers.evaluateStyle(s, props);
    return assign_1({}, baseStyles, {
      fontSize: getFontSize(baseStyles)
    });
  };

  return Array.isArray(style) && !isEmpty_1(style) ? style.map(function (s) {
    return getSingleStyle(s);
  }) : getSingleStyle(style);
};

var getBackgroundStyles = function (style, props) {
  if (!style) {
    return undefined;
  }

  return Array.isArray(style) && !isEmpty_1(style) ? style.map(function (s) {
    return Helpers.evaluateStyle(s, props);
  }) : Helpers.evaluateStyle(style, props);
};

var getBackgroundPadding = function (props) {
  if (props.backgroundPadding && Array.isArray(props.backgroundPadding)) {
    return props.backgroundPadding.map(function (backgroundPadding) {
      var padding = Helpers.evaluateProp(backgroundPadding, props);
      return Helpers.getPadding({
        padding: padding
      });
    });
  } else {
    var padding = Helpers.evaluateProp(props.backgroundPadding, props);
    return Helpers.getPadding({
      padding: padding
    });
  }
};

var getLineHeight = function (props) {
  var lineHeight = Helpers.evaluateProp(props.lineHeight, props);

  if (Array.isArray(lineHeight)) {
    return isEmpty_1(lineHeight) ? [1] : lineHeight;
  } else {
    return lineHeight;
  }
};

var getContent = function (text, props) {
  if (text === undefined || text === null) {
    return undefined;
  }

  if (Array.isArray(text)) {
    return text.map(function (line) {
      return Helpers.evaluateProp(line, props);
    });
  }

  var child = Helpers.evaluateProp(text, props);

  if (child === undefined || child === null) {
    return undefined;
  }

  return Array.isArray(child) ? child : "".concat(child).split("\n");
};

var getDy = function (props, verticalAnchor, lineHeight) {
  var dy = props.dy ? Helpers.evaluateProp(props.dy, props) : 0;
  var length = props.inline ? 1 : props.text.length;
  var capHeight = Helpers.evaluateProp(props.capHeight, props);
  var anchor = verticalAnchor ? Helpers.evaluateProp(verticalAnchor, props) : "middle";

  var fontSizes = _toConsumableArray$4(Array(length).keys()).map(function (i) {
    return getSingleValue(props.style, i).fontSize;
  });

  var lineHeights = _toConsumableArray$4(Array(length).keys()).map(function (i) {
    return getSingleValue(lineHeight, i);
  });

  if (anchor === "start") {
    return dy + (capHeight / 2 + lineHeights[0] / 2) * fontSizes[0];
  } else if (props.inline) {
    return anchor === "end" ? dy + (capHeight / 2 - lineHeights[0] / 2) * fontSizes[0] : dy + capHeight / 2 * fontSizes[0];
  } else if (length === 1) {
    return anchor === "end" ? dy + (capHeight / 2 + (0.5 - length) * lineHeights[0]) * fontSizes[0] : dy + (capHeight / 2 + (0.5 - length / 2) * lineHeights[0]) * fontSizes[0];
  } else {
    var allHeights = _toConsumableArray$4(Array(length).keys()).reduce(function (memo, i) {
      return memo + (capHeight / 2 + (0.5 - length) * lineHeights[i]) * fontSizes[i] / length;
    }, 0);

    return anchor === "end" ? dy + allHeights : dy + allHeights / 2 + capHeight / 2 * lineHeights[length - 1] * fontSizes[length - 1];
  }
};

var getTransform = function (props, x, y) {
  var polar = props.polar;
  var style = getSingleValue(props.style);
  var defaultAngle = polar ? LabelHelpers.getPolarAngle(props) : 0;
  var baseAngle = style.angle === undefined ? Helpers.evaluateProp(props.angle, props) : style.angle;
  var angle = baseAngle === undefined ? defaultAngle : baseAngle;
  var transform = props.transform || style.transform;
  var transformPart = transform && Helpers.evaluateProp(transform, props);
  var rotatePart = angle && {
    rotate: [angle, x, y]
  };
  return transformPart || angle ? Style.toTransformString(transformPart, rotatePart) : undefined;
};

var getXCoordinate = function (calculatedProps, labelSizeWidth) {
  var direction = calculatedProps.direction,
      textAnchor = calculatedProps.textAnchor,
      x = calculatedProps.x,
      dx = calculatedProps.dx;

  if (direction === "rtl") {
    return x - labelSizeWidth;
  }

  switch (textAnchor) {
    case "middle":
      return Math.round(x - labelSizeWidth / 2);

    case "end":
      return Math.round(x - labelSizeWidth);

    default:
      // start
      return x + (dx || 0);
  }
};

var getYCoordinate = function (calculatedProps, textHeight) {
  var verticalAnchor = calculatedProps.verticalAnchor,
      y = calculatedProps.y,
      _calculatedProps$orig = calculatedProps.originalDy,
      originalDy = _calculatedProps$orig === void 0 ? 0 : _calculatedProps$orig;
  var offset = y + originalDy;

  switch (verticalAnchor) {
    case "start":
      return Math.floor(offset);

    case "end":
      return Math.ceil(offset - textHeight);

    default:
      // middle
      return Math.floor(offset - textHeight / 2);
  }
};

var getFullBackground = function (calculatedProps, tspanValues) {
  var _calculatedProps$dx = calculatedProps.dx,
      dx = _calculatedProps$dx === void 0 ? 0 : _calculatedProps$dx,
      transform = calculatedProps.transform,
      backgroundComponent = calculatedProps.backgroundComponent,
      backgroundStyle = calculatedProps.backgroundStyle,
      inline = calculatedProps.inline,
      backgroundPadding = calculatedProps.backgroundPadding,
      capHeight = calculatedProps.capHeight;
  var textSizes = tspanValues.map(function (tspan) {
    return tspan.textSize;
  });
  var height = inline ? Math.max.apply(Math, _toConsumableArray$4(textSizes.map(function (size) {
    return size.height;
  }))) : textSizes.reduce(function (memo, size, i) {
    var capHeightAdjustment = i ? 0 : capHeight / 2;
    return memo + size.height * (tspanValues[i].lineHeight - capHeightAdjustment);
  }, 0);
  var width = inline ? textSizes.reduce(function (memo, size, index) {
    var offset = index ? dx : 0;
    return memo + size.width + offset;
  }, 0) : Math.max.apply(Math, _toConsumableArray$4(textSizes.map(function (size) {
    return size.width;
  })));
  var xCoordinate = getXCoordinate(calculatedProps, width);
  var yCoordinate = getYCoordinate(calculatedProps, height);
  var backgroundProps = {
    key: "background",
    height: height + backgroundPadding.top + backgroundPadding.bottom,
    style: backgroundStyle,
    transform: transform,
    width: width + backgroundPadding.left + backgroundPadding.right,
    x: inline ? xCoordinate - backgroundPadding.left : xCoordinate + dx - backgroundPadding.left,
    y: yCoordinate
  };
  return React__default['default'].cloneElement(backgroundComponent, defaults_1({}, backgroundComponent.props, backgroundProps));
};

var getInlineXOffset = function (calculatedProps, textElements, index) {
  var textAnchor = calculatedProps.textAnchor;
  var widths = textElements.map(function (t) {
    return t.widthWithPadding;
  });
  var totalWidth = widths.reduce(function (memo, width) {
    return memo + width;
  }, 0);
  var centerOffset = -totalWidth / 2;

  switch (textAnchor) {
    case "start":
      return widths.reduce(function (memo, width, i) {
        memo = i < index ? memo + width : memo;
        return memo;
      }, 0);

    case "end":
      return widths.reduce(function (memo, width, i) {
        memo = i > index ? memo - width : memo;
        return memo;
      }, 0);

    default:
      // middle
      return widths.reduce(function (memo, width, i) {
        var offsetWidth = i < index ? width : 0;
        memo = i === index ? memo + width / 2 : memo + offsetWidth;
        return memo;
      }, centerOffset);
  }
};

var getChildBackgrounds = function (calculatedProps, tspanValues) {
  var dy = calculatedProps.dy,
      dx = calculatedProps.dx,
      transform = calculatedProps.transform,
      backgroundStyle = calculatedProps.backgroundStyle,
      backgroundPadding = calculatedProps.backgroundPadding,
      backgroundComponent = calculatedProps.backgroundComponent,
      inline = calculatedProps.inline,
      y = calculatedProps.y;
  var textElements = tspanValues.map(function (current, i) {
    var previous = getSingleValue(tspanValues, i - 1);
    var labelSize = current.textSize;
    var totalLineHeight = current.fontSize * current.lineHeight;
    var textHeight = Math.ceil(totalLineHeight);
    var padding = getSingleValue(backgroundPadding, i);
    var prevPadding = getSingleValue(backgroundPadding, i - 1);
    var xOffset = inline ? dx || 0 : 0;
    var childDy = i && !inline ? previous.fontSize * previous.lineHeight + prevPadding.top + prevPadding.bottom : dy - totalLineHeight * 0.5 - (current.fontSize - current.capHeight);
    return {
      textHeight: textHeight,
      labelSize: labelSize,
      heightWithPadding: textHeight + padding.top + padding.bottom,
      widthWithPadding: labelSize.width + padding.left + padding.right + xOffset,
      y: y,
      fontSize: current.fontSize,
      dy: childDy
    };
  });
  return textElements.map(function (textElement, i) {
    var xCoordinate = getXCoordinate(calculatedProps, textElement.labelSize.width);
    var yCoordinate = textElements.slice(0, i + 1).reduce(function (prev, curr) {
      return prev + curr.dy;
    }, y);
    var padding = getSingleValue(backgroundPadding, i);
    var height = textElement.heightWithPadding;
    var xCoord = inline ? getInlineXOffset(calculatedProps, textElements, i) + xCoordinate - padding.left : xCoordinate;
    var yCoord = inline ? getYCoordinate(calculatedProps, height) - padding.top : yCoordinate;
    var backgroundProps = {
      key: "tspan-background-".concat(i),
      height: height,
      style: getSingleValue(backgroundStyle, i),
      width: textElement.widthWithPadding,
      transform: transform,
      x: xCoord - padding.left,
      y: yCoord
    };
    return React__default['default'].cloneElement(backgroundComponent, defaults_1({}, backgroundComponent.props, backgroundProps));
  });
};

var getBackgroundElement = function (calculatedProps, tspanValues) {
  return useMultiLineBackgrounds(calculatedProps) ? getChildBackgrounds(calculatedProps, tspanValues) : getFullBackground(calculatedProps, tspanValues);
};

var calculateSpanDy = function (tspanValues, i, calculatedProps) {
  var current = getSingleValue(tspanValues, i);
  var previous = getSingleValue(tspanValues, i - 1);
  var previousHeight = previous.fontSize * previous.lineHeight;
  var currentHeight = current.fontSize * current.lineHeight;
  var previousCaps = previous.fontSize - previous.capHeight;
  var currentCaps = current.fontSize - current.capHeight;
  var textHeight = previousHeight - previous.fontSize / 2 + current.fontSize / 2 - previousHeight / 2 + currentHeight / 2 - currentCaps / 2 + previousCaps / 2;
  return useMultiLineBackgrounds(calculatedProps) ? textHeight + current.backgroundPadding.top + previous.backgroundPadding.bottom : textHeight;
};

var getTSpanDy = function (tspanValues, calculatedProps, i) {
  var inline = calculatedProps.inline;
  var current = getSingleValue(tspanValues, i);

  if (i && !inline) {
    return calculateSpanDy(tspanValues, i, calculatedProps);
  } else if (inline) {
    return i === 0 ? current.backgroundPadding.top : undefined;
  } else {
    return current.backgroundPadding.top;
  }
};

var evaluateProps = function (props) {
  /* Potential evaluated props are
    1) text
    2) style
    3) everything else
  */
  var text = getContent(props.text, props);
  var style = getStyles$1(props.style, assign_1({}, props, {
    text: text
  }));
  var backgroundStyle = getBackgroundStyles(props.backgroundStyle, assign_1({}, props, {
    text: text,
    style: style
  }));
  var backgroundPadding = getBackgroundPadding(assign_1({}, props, {
    text: text,
    style: style,
    backgroundStyle: backgroundStyle
  }));
  var id = Helpers.evaluateProp(props.id, props);
  return assign_1({}, props, {
    backgroundStyle: backgroundStyle,
    backgroundPadding: backgroundPadding,
    style: style,
    text: text,
    id: id
  });
};

var getCalculatedProps = function (props) {
  var ariaLabel = Helpers.evaluateProp(props.ariaLabel, props);
  var style = getSingleValue(props.style);
  var lineHeight = getLineHeight(props);
  var direction = props.direction ? Helpers.evaluateProp(props.direction, props) : "inherit";
  var textAnchor = props.textAnchor ? Helpers.evaluateProp(props.textAnchor, props) : style.textAnchor || "start";
  var verticalAnchor = props.verticalAnchor ? Helpers.evaluateProp(props.verticalAnchor, props) : style.verticalAnchor || "middle";
  var dx = props.dx ? Helpers.evaluateProp(props.dx, props) : 0;
  var dy = getDy(props, verticalAnchor, lineHeight);
  var x = props.x !== undefined ? props.x : getPosition$1(props, "x");
  var y = props.y !== undefined ? props.y : getPosition$1(props, "y");
  var transform = getTransform(props, x, y);
  return assign_1({}, props, {
    ariaLabel: ariaLabel,
    lineHeight: lineHeight,
    direction: direction,
    textAnchor: textAnchor,
    verticalAnchor: verticalAnchor,
    dx: dx,
    dy: dy,
    originalDy: props.dy,
    transform: transform,
    x: x,
    y: y
  });
};

var renderLabel = function (calculatedProps, tspanValues) {
  var ariaLabel = calculatedProps.ariaLabel,
      inline = calculatedProps.inline,
      className = calculatedProps.className,
      title = calculatedProps.title,
      events = calculatedProps.events,
      direction = calculatedProps.direction,
      text = calculatedProps.text,
      textAnchor = calculatedProps.textAnchor,
      dx = calculatedProps.dx,
      dy = calculatedProps.dy,
      transform = calculatedProps.transform,
      x = calculatedProps.x,
      y = calculatedProps.y,
      desc = calculatedProps.desc,
      id = calculatedProps.id,
      tabIndex = calculatedProps.tabIndex,
      tspanComponent = calculatedProps.tspanComponent,
      textComponent = calculatedProps.textComponent;

  var textProps = _objectSpread$5({
    "aria-label": ariaLabel,
    key: "text"
  }, events, {
    direction: direction,
    dx: dx,
    x: x,
    y: y + dy,
    transform: transform,
    className: className,
    title: title,
    desc: Helpers.evaluateProp(desc, calculatedProps),
    tabIndex: Helpers.evaluateProp(tabIndex, calculatedProps),
    id: id
  });

  var tspans = text.map(function (line, i) {
    var currentStyle = tspanValues[i].style;
    var tspanProps = {
      key: "".concat(id, "-key-").concat(i),
      x: !inline ? x : undefined,
      dx: inline ? dx + tspanValues[i].backgroundPadding.left : dx,
      dy: getTSpanDy(tspanValues, calculatedProps, i),
      textAnchor: currentStyle.textAnchor || textAnchor,
      style: currentStyle,
      children: line
    };
    return React__default['default'].cloneElement(tspanComponent, tspanProps);
  });
  return React__default['default'].cloneElement(textComponent, textProps, tspans);
};

var VictoryLabel = function (props) {
  props = evaluateProps(props);

  if (props.text === null || props.text === undefined) {
    return null;
  }

  var calculatedProps = getCalculatedProps(props);
  var text = calculatedProps.text,
      style = calculatedProps.style,
      capHeight = calculatedProps.capHeight,
      backgroundPadding = calculatedProps.backgroundPadding,
      lineHeight = calculatedProps.lineHeight;
  var tspanValues = text.map(function (line, i) {
    var currentStyle = getSingleValue(style, i);
    var capHeightPx = TextSize.convertLengthToPixels("".concat(capHeight, "em"), currentStyle.fontSize);
    var currentLineHeight = getSingleValue(lineHeight, i);
    return {
      style: currentStyle,
      fontSize: currentStyle.fontSize || defaultStyles.fontSize,
      capHeight: capHeightPx,
      text: line,
      textSize: TextSize.approximateTextSize(line, currentStyle),
      lineHeight: currentLineHeight,
      backgroundPadding: getSingleValue(backgroundPadding, i)
    };
  });
  var label = renderLabel(calculatedProps, tspanValues);

  if (props.backgroundStyle) {
    var backgroundElement = getBackgroundElement(calculatedProps, tspanValues);
    var children = [backgroundElement, label];
    var backgroundWithLabel = React__default['default'].cloneElement(props.groupComponent, {}, children);
    return props.renderInPortal ? React__default['default'].createElement(VictoryPortal, null, backgroundWithLabel) : backgroundWithLabel;
  }

  return props.renderInPortal ? React__default['default'].createElement(VictoryPortal, null, label) : label;
};

VictoryLabel.displayName = "VictoryLabel";
VictoryLabel.role = "label";
VictoryLabel.defaultStyles = defaultStyles;
VictoryLabel.propTypes = {
  active: PropTypes__default['default'].bool,
  angle: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number, PropTypes__default['default'].func]),
  ariaLabel: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].func]),
  backgroundComponent: PropTypes__default['default'].element,
  backgroundPadding: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].object, PropTypes__default['default'].array]),
  backgroundStyle: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].array]),
  capHeight: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
  className: PropTypes__default['default'].string,
  data: PropTypes__default['default'].array,
  datum: PropTypes__default['default'].any,
  desc: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].func]),
  direction: PropTypes__default['default'].oneOf(["rtl", "ltr", "inherit"]),
  dx: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string, PropTypes__default['default'].func]),
  dy: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string, PropTypes__default['default'].func]),
  events: PropTypes__default['default'].object,
  groupComponent: PropTypes__default['default'].element,
  id: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string, PropTypes__default['default'].func]),
  index: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
  inline: PropTypes__default['default'].bool,
  labelPlacement: PropTypes__default['default'].oneOf(["parallel", "perpendicular", "vertical"]),
  lineHeight: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, CustomPropTypes.nonNegative, PropTypes__default['default'].func, PropTypes__default['default'].array]),
  origin: PropTypes__default['default'].shape({
    x: CustomPropTypes.nonNegative,
    y: CustomPropTypes.nonNegative
  }),
  polar: PropTypes__default['default'].bool,
  renderInPortal: PropTypes__default['default'].bool,
  scale: PropTypes__default['default'].shape({
    x: CustomPropTypes.scale,
    y: CustomPropTypes.scale
  }),
  style: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].array]),
  tabIndex: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
  text: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number, PropTypes__default['default'].func, PropTypes__default['default'].array]),
  textAnchor: PropTypes__default['default'].oneOfType([PropTypes__default['default'].oneOf(["start", "middle", "end", "inherit"]), PropTypes__default['default'].func]),
  textComponent: PropTypes__default['default'].element,
  title: PropTypes__default['default'].string,
  transform: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object, PropTypes__default['default'].func]),
  tspanComponent: PropTypes__default['default'].element,
  verticalAnchor: PropTypes__default['default'].oneOfType([PropTypes__default['default'].oneOf(["start", "middle", "end"]), PropTypes__default['default'].func]),
  x: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
  y: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string])
};
VictoryLabel.defaultProps = {
  backgroundComponent: React__default['default'].createElement(Rect, null),
  groupComponent: React__default['default'].createElement("g", null),
  direction: "inherit",
  textComponent: React__default['default'].createElement(Text, null),
  tspanComponent: React__default['default'].createElement(TSpan, null),
  capHeight: 0.71,
  // Magic number from d3.
  lineHeight: 1
};

function _toConsumableArray$5(arr) { return _arrayWithoutHoles$5(arr) || _iterableToArray$5(arr) || _nonIterableSpread$5(); }

function _nonIterableSpread$5() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$5(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$5(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/* eslint-disable func-style */

/* eslint-disable no-use-before-define */
function isNonEmptyArray(collection) {
  return Array.isArray(collection) && collection.length > 0;
}

function containsStrings(collection) {
  return Array.isArray(collection) && collection.some(function (value) {
    return typeof value === "string";
  });
}

function containsDates(collection) {
  return Array.isArray(collection) && collection.some(function (value) {
    return value instanceof Date;
  });
}

function containsNumbers(collection) {
  return Array.isArray(collection) && collection.some(function (value) {
    return typeof value === "number";
  });
}

function containsOnlyStrings(collection) {
  return isNonEmptyArray(collection) && collection.every(function (value) {
    return typeof value === "string";
  });
}

function isArrayOfArrays(collection) {
  return isNonEmptyArray(collection) && collection.every(Array.isArray);
}

function removeUndefined(arr) {
  return arr.filter(function (el) {
    return el !== undefined;
  });
}

function getMaxValue(arr) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var array = arr.concat(values);
  return containsDates(array) ? new Date(Math.max.apply(Math, _toConsumableArray$5(array))) : Math.max.apply(Math, _toConsumableArray$5(array));
}

function getMinValue(arr) {
  for (var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    values[_key2 - 1] = arguments[_key2];
  }

  var array = arr.concat(values);
  return containsDates(array) ? new Date(Math.min.apply(Math, _toConsumableArray$5(array))) : Math.min.apply(Math, _toConsumableArray$5(array));
}

var Collection = {
  containsDates: containsDates,
  containsNumbers: containsNumbers,
  containsOnlyStrings: containsOnlyStrings,
  containsStrings: containsStrings,
  getMaxValue: getMaxValue,
  getMinValue: getMinValue,
  isArrayOfArrays: isArrayOfArrays,
  removeUndefined: removeUndefined
};

function getDatumKey(datum, idx) {
  return (datum.key || idx).toString();
}

function getKeyedData(data) {
  return data.reduce(function (keyedData, datum, idx) {
    var key = getDatumKey(datum, idx);
    keyedData[key] = datum;
    return keyedData;
  }, {});
}

function getKeyedDataDifference(a, b) {
  var hasDifference = false;
  var difference = Object.keys(a).reduce(function (_difference, key) {
    if (!(key in b)) {
      hasDifference = true;
      _difference[key] = true;
    }

    return _difference;
  }, {});
  return hasDifference && difference;
}
/**
 * Calculate which data-points exist in oldData and not nextData -
 * these are the `exiting` data-points.  Also calculate which
 * data-points exist in nextData and not oldData - these are the
 * `entering` data-points.
 *
 * @param  {Array} oldData   this.props.data Array
 * @param  {Array} nextData  this.props.data Array
 *
 * @return {Object}          Object with `entering` and `exiting` properties.
 *                           entering[datum.key] will be true if the data is
 *                           entering, and similarly for `exiting`.
 */


function getNodeTransitions(oldData, nextData) {
  var oldDataKeyed = oldData && getKeyedData(oldData);
  var nextDataKeyed = nextData && getKeyedData(nextData);
  return {
    entering: oldDataKeyed && getKeyedDataDifference(nextDataKeyed, oldDataKeyed),
    exiting: nextDataKeyed && getKeyedDataDifference(oldDataKeyed, nextDataKeyed)
  };
}

function getChildData(child) {
  if (child.type && child.type.getData) {
    return child.type.getData(child.props);
  }

  return child.props && child.props.data || false;
}
/**
 * If a parent component has animation enabled, calculate the transitions
 * for any data of any child component that supports data transitions
 * Data transitions are defined as any two datasets where data nodes exist
 * in the first set and not the second, in the second and not the first,
 * or both.
 *
 * @param  {Children}  oldChildren   this.props.children from old props
 * @param  {Children}  nextChildren  this.props.children from next props
 *
 * @return {Object}                  Object with the following properties:
 *                                    - nodesWillExit
 *                                    - nodesWillEnter
 *                                    - childrenTransitions
 *                                    - nodesShouldEnter
 */


function getInitialTransitionState(oldChildren, nextChildren) {
  var nodesWillExit = false;
  var nodesWillEnter = false;

  var getTransition = function (oldChild, newChild) {
    if (!newChild || oldChild.type !== newChild.type) {
      return {};
    }

    var _ref = getNodeTransitions(getChildData(oldChild), getChildData(newChild)) || {},
        entering = _ref.entering,
        exiting = _ref.exiting;

    nodesWillExit = nodesWillExit || !!exiting;
    nodesWillEnter = nodesWillEnter || !!entering;
    return {
      entering: entering || false,
      exiting: exiting || false
    };
  };

  var getTransitionsFromChildren = function (old, next) {
    return old.map(function (child, idx) {
      if (child && child.props && child.props.children && next[idx]) {
        return getTransitionsFromChildren(React__default['default'].Children.toArray(old[idx].props.children), React__default['default'].Children.toArray(next[idx].props.children));
      } // get Transition entering and exiting nodes


      return getTransition(child, next[idx]);
    });
  };

  var childrenTransitions = getTransitionsFromChildren(React__default['default'].Children.toArray(oldChildren), React__default['default'].Children.toArray(nextChildren));
  return {
    nodesWillExit: nodesWillExit,
    nodesWillEnter: nodesWillEnter,
    childrenTransitions: childrenTransitions,
    // TODO: This may need to be refactored for the following situation.
    //       The component receives new props, and the data provided
    //       is a perfect match for the previous data and domain except
    //       for new nodes. In this case, we wouldn't want a delay before
    //       the new nodes appear.
    nodesShouldEnter: false
  };
}

function getInitialChildProps(animate, data) {
  var after = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : identity_1;
  return {
    data: data.map(function (datum, idx) {
      return assign_1({}, datum, after(datum, idx, data));
    })
  };
} // eslint-disable-next-line max-params


function getChildBeforeLoad(animate, child, data, cb) {
  animate = assign_1({}, animate, {
    onEnd: cb
  });

  if (animate && animate.onLoad && !animate.onLoad.duration) {
    return {
      animate: animate,
      data: data
    };
  }

  var before = animate.onLoad && animate.onLoad.before ? animate.onLoad.before : identity_1; // If nodes need to exit, transform them with the provided onLoad.before function.

  data = data.map(function (datum, idx) {
    return assign_1({}, datum, before(datum, idx, data));
  });
  return {
    animate: animate,
    data: data,
    clipWidth: 0
  };
} // eslint-disable-next-line max-params


function getChildOnLoad(animate, data, cb) {
  animate = assign_1({}, animate, {
    onEnd: cb
  });

  if (animate && animate.onLoad && !animate.onLoad.duration) {
    return {
      animate: animate,
      data: data
    };
  }

  var after = animate.onLoad && animate.onLoad.after ? animate.onLoad.after : identity_1; // If nodes need to exit, transform them with the provided onLoad.after function.

  data = data.map(function (datum, idx) {
    return assign_1({}, datum, after(datum, idx, data));
  });
  return {
    animate: animate,
    data: data
  };
} // eslint-disable-next-line max-params, max-len


function getChildPropsOnExit(animate, child, data, exitingNodes, cb) {
  // Whether or not _this_ child has exiting nodes, we want the exit-
  // transition for all children to have the same duration, delay, etc.
  var onExit = animate && animate.onExit;
  animate = assign_1({}, animate, onExit);

  if (exitingNodes) {
    // After the exit transition occurs, trigger the animations for
    // nodes that are neither exiting or entering.
    animate.onEnd = cb;
    var before = animate.onExit && animate.onExit.before ? animate.onExit.before : identity_1; // If nodes need to exit, transform them with the provided onExit.before function.

    data = data.map(function (datum, idx) {
      var key = (datum.key || idx).toString();
      return exitingNodes[key] ? assign_1({}, datum, before(datum, idx, data)) : datum;
    });
  }

  return {
    animate: animate,
    data: data
  };
} // eslint-disable-next-line max-params,max-len


function getChildPropsBeforeEnter(animate, child, data, enteringNodes, cb) {
  if (enteringNodes) {
    // Perform a normal animation here, except - when it finishes - trigger
    // the transition for entering nodes.
    animate = assign_1({}, animate, {
      onEnd: cb
    });
    var before = animate.onEnter && animate.onEnter.before ? animate.onEnter.before : identity_1; // We want the entering nodes to be included in the transition target
    // domain.  However, we may not want these nodes to be displayed initially,
    // so perform the `onEnter.before` transformation on each node.

    data = data.map(function (datum, idx) {
      var key = (datum.key || idx).toString();
      return enteringNodes[key] ? assign_1({}, datum, before(datum, idx, data)) : datum;
    });
  }

  return {
    animate: animate,
    data: data
  };
} // eslint-disable-next-line max-params, max-len


function getChildPropsOnEnter(animate, data, enteringNodes, cb) {
  // Whether or not _this_ child has entering nodes, we want the entering-
  // transition for all children to have the same duration, delay, etc.
  var onEnter = animate && animate.onEnter;
  animate = assign_1({}, animate, onEnter);

  if (enteringNodes) {
    // Old nodes have been transitioned to their new values, and the
    // domain should encompass the nodes that will now enter. So perform
    // the `onEnter.after` transformation on each node.
    animate.onEnd = cb;
    var after = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : identity_1;
    data = data.map(function (datum, idx) {
      var key = getDatumKey(datum, idx);
      return enteringNodes[key] ? assign_1({}, datum, after(datum, idx, data)) : datum;
    });
  }

  return {
    animate: animate,
    data: data
  };
}
/**
 * getTransitionPropsFactory - putting the Java in JavaScript.  This will return a
 * function that returns prop transformations for a child, given that child's props
 * and its index in the parent's children array.
 *
 * In particular, this will include an `animate` object that is set appropriately
 * so that each child will be synchoronized for each stage of a transition
 * animation.  It will also include a transformed `data` object, where each datum
 * is transformed by `animate.onExit` and `animate.onEnter` `before` and `after`
 * functions.
 *
 * @param  {Object}  props       `this.props` for the parent component.
 * @param  {Object} state        `this.state` for the parent component.
 * @param  {Function} setState    Function that, when called, will `this.setState` on
 *                                 the parent component with the provided object.
 *
 * @return {Function}              Child-prop transformation function.
 */


function getTransitionPropsFactory(props, state, setState) {
  var nodesWillExit = state && state.nodesWillExit;
  var nodesWillEnter = state && state.nodesWillEnter;
  var nodesShouldEnter = state && state.nodesShouldEnter;
  var nodesShouldLoad = state && state.nodesShouldLoad;
  var nodesDoneLoad = state && state.nodesDoneLoad;
  var childrenTransitions = state && state.childrenTransitions || [];
  var transitionDurations = {
    enter: props.animate && props.animate.onEnter && props.animate.onEnter.duration,
    exit: props.animate && props.animate.onExit && props.animate.onExit.duration,
    load: props.animate && props.animate.onLoad && props.animate.onLoad.duration,
    move: props.animate && props.animate.duration
  };

  var onLoad = function (child, data, animate) {
    if (nodesShouldLoad) {
      return getChildOnLoad(animate, data, function () {
        setState({
          nodesShouldLoad: false,
          nodesDoneLoad: true
        });
      });
    }

    return getChildBeforeLoad(animate, child, data, function () {
      setState({
        nodesDoneLoad: true
      });
    });
  }; // eslint-disable-next-line max-params


  var onExit = function (nodes, child, data, animate) {
    return getChildPropsOnExit(animate, child, data, nodes, function () {
      setState({
        nodesWillExit: false
      });
    });
  }; // eslint-disable-next-line max-params


  var onEnter = function (nodes, child, data, animate) {
    if (nodesShouldEnter) {
      return getChildPropsOnEnter(animate, data, nodes, function () {
        setState({
          nodesWillEnter: false
        });
      });
    }

    return getChildPropsBeforeEnter(animate, child, data, nodes, function () {
      setState({
        nodesShouldEnter: true
      });
    });
  };

  var getChildTransitionDuration = function (child, type) {
    var animate = child.props.animate;

    if (!child.type) {
      return {};
    }

    var defaultTransitions = child.props && child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;

    if (defaultTransitions) {
      var animationDuration = animate[type] && animate[type].duration;
      return animationDuration !== undefined ? animationDuration : defaultTransitions[type] && defaultTransitions[type].duration;
    } else {
      return {};
    }
  }; // eslint-disable-next-line max-statements, complexity, max-len


  return function getTransitionProps(child, index) {
    var data = getChildData(child) || [];

    var animate = defaults_1({}, props.animate, child.props.animate);

    var defaultTransitions = child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
    animate.onExit = defaults_1({}, animate.onExit, defaultTransitions && defaultTransitions.onExit);
    animate.onEnter = defaults_1({}, animate.onEnter, defaultTransitions && defaultTransitions.onEnter);
    animate.onLoad = defaults_1({}, animate.onLoad, defaultTransitions && defaultTransitions.onLoad);
    var childTransitions = childrenTransitions[index] || childrenTransitions[0];

    if (!nodesDoneLoad) {
      // should do onLoad animation
      var load = transitionDurations.load !== undefined ? transitionDurations.load : getChildTransitionDuration(child, "onLoad");
      var animation = {
        duration: load
      };
      return onLoad(child, data, assign_1({}, animate, animation));
    } else if (nodesWillExit) {
      var exitingNodes = childTransitions && childTransitions.exiting;
      var exit = transitionDurations.exit !== undefined ? transitionDurations.exit : getChildTransitionDuration(child, "onExit"); // if nodesWillExit, but this child has no exiting nodes, set a delay instead of a duration

      var _animation = exitingNodes ? {
        duration: exit
      } : {
        delay: exit
      };

      return onExit(exitingNodes, child, data, assign_1({}, animate, _animation));
    } else if (nodesWillEnter) {
      var enteringNodes = childTransitions && childTransitions.entering;
      var enter = transitionDurations.enter !== undefined ? transitionDurations.enter : getChildTransitionDuration(child, "onEnter");
      var move = transitionDurations.move !== undefined ? transitionDurations.move : child.props.animate && child.props.animate.duration;
      var _animation2 = {
        duration: nodesShouldEnter && enteringNodes ? enter : move
      };
      return onEnter(enteringNodes, child, data, assign_1({}, animate, _animation2));
    } else if (!state && animate && animate.onExit) {
      // This is the initial render, and nodes may enter when props change. Because
      // animation interpolation is determined by old- and next- props, data may need
      // to be augmented with certain properties.
      //
      // For example, it may be desired that exiting nodes go from `opacity: 1` to
      // `opacity: 0`. Without setting this on a per-datum basis, the interpolation
      // might go from `opacity: undefined` to `opacity: 0`, which would result in
      // interpolated `opacity: NaN` values.
      //
      return getInitialChildProps(animate, data);
    }

    return {
      animate: animate,
      data: data
    };
  };
}

var Transitions = {
  getInitialTransitionState: getInitialTransitionState,
  getTransitionPropsFactory: getTransitionPropsFactory
};

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$5(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$9(self); }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized$9(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var VictoryTransition =
/*#__PURE__*/
function (_React$Component) {
  _inherits$5(VictoryTransition, _React$Component);

  function VictoryTransition(props, context) {
    var _this;

    _classCallCheck$6(this, VictoryTransition);

    _this = _possibleConstructorReturn$5(this, (VictoryTransition.__proto__ || Object.getPrototypeOf(VictoryTransition)).call(this, props, context));
    _this.state = {
      nodesShouldLoad: false,
      nodesDoneLoad: false
    };
    var child = _this.props.children;
    var polar = child.props.polar;
    _this.continuous = !polar && child.type && child.type.continuous === true;
    _this.getTransitionState = _this.getTransitionState.bind(_assertThisInitialized$9(_this));
    _this.timer = _this.context.transitionTimer;
    return _this;
  }

  _createClass$6(VictoryTransition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        nodesShouldLoad: true
      }); //eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      if (!reactFastCompare(this.props, nextProps)) {
        this.timer.bypassAnimation();
        this.setState(this.getTransitionState(this.props, nextProps), function () {
          return _this2.timer.resumeAnimation();
        });
      }

      return true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.timer.stop();
    }
  }, {
    key: "getTransitionState",
    value: function getTransitionState(props, nextProps) {
      var animate = props.animate;

      if (!animate) {
        return {};
      } else if (animate.parentState) {
        var state = animate.parentState;
        var oldProps = state.nodesWillExit ? props : null;
        return {
          oldProps: oldProps,
          nextProps: nextProps
        };
      } else {
        var oldChildren = React__default['default'].Children.toArray(props.children);
        var nextChildren = React__default['default'].Children.toArray(nextProps.children);

        var _Transitions$getIniti = Transitions.getInitialTransitionState(oldChildren, nextChildren),
            nodesWillExit = _Transitions$getIniti.nodesWillExit,
            nodesWillEnter = _Transitions$getIniti.nodesWillEnter,
            childrenTransitions = _Transitions$getIniti.childrenTransitions,
            nodesShouldEnter = _Transitions$getIniti.nodesShouldEnter;

        return {
          nodesWillExit: nodesWillExit,
          nodesWillEnter: nodesWillEnter,
          childrenTransitions: childrenTransitions,
          nodesShouldEnter: nodesShouldEnter,
          oldProps: nodesWillExit ? props : null,
          nextProps: nextProps
        };
      }
    }
  }, {
    key: "getDomainFromChildren",
    value: function getDomainFromChildren(props, axis) {
      var getChildDomains = function (children) {
        return children.reduce(function (memo, child) {
          if (child.type && isFunction_1(child.type.getDomain)) {
            var childDomain = child.props && child.type.getDomain(child.props, axis);
            return childDomain ? memo.concat(childDomain) : memo;
          } else if (child.props && child.props.children) {
            return memo.concat(getChildDomains(React__default['default'].Children.toArray(child.props.children)));
          }

          return memo;
        }, []);
      };

      var child = React__default['default'].Children.toArray(props.children)[0];
      var childProps = child.props || {};
      var domain = Array.isArray(childProps.domain) ? childProps.domain : childProps.domain && childProps.domain[axis];

      if (!childProps.children && domain) {
        return domain;
      } else {
        var childDomains = getChildDomains([child]);
        return childDomains.length === 0 ? [0, 1] : [Collection.getMinValue(childDomains), Collection.getMaxValue(childDomains)];
      }
    }
  }, {
    key: "pickProps",
    value: function pickProps() {
      if (!this.state) {
        return this.props;
      }

      return this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
    }
  }, {
    key: "pickDomainProps",
    value: function pickDomainProps(props) {
      var parentState = isObject_1(props.animate) && props.animate.parentState;

      if (parentState && parentState.nodesWillExit) {
        return this.continous || parentState.continuous ? parentState.nextProps || this.state.nextProps || props : props;
      }

      return this.continuous && this.state.nodesWillExit ? this.state.nextProps || props : props;
    }
  }, {
    key: "getClipWidth",
    value: function getClipWidth(props, child) {
      var getDefaultClipWidth = function () {
        var range = Helpers.getRange(child.props, "x");
        return range ? Math.abs(range[1] - range[0]) : props.width;
      };

      var clipWidth = this.transitionProps ? this.transitionProps.clipWidth : undefined;
      return clipWidth !== undefined ? clipWidth : getDefaultClipWidth();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.pickProps();
      var getTransitionProps = isObject_1(this.props.animate) && this.props.animate.getTransitions ? this.props.animate.getTransitions : Transitions.getTransitionPropsFactory(props, this.state, function (newState) {
        return _this3.setState(newState);
      });
      var child = React__default['default'].Children.toArray(props.children)[0];
      var transitionProps = getTransitionProps(child);
      this.transitionProps = transitionProps;
      var domain = {
        x: this.getDomainFromChildren(this.pickDomainProps(props), "x"),
        y: this.getDomainFromChildren(props, "y")
      };
      var clipWidth = this.getClipWidth(props, child);

      var combinedProps = defaults_1({
        domain: domain,
        clipWidth: clipWidth
      }, transitionProps, child.props);

      var animationWhitelist = props.animationWhitelist || [];
      var whitelist = animationWhitelist.concat(["clipWidth"]);
      var propsToAnimate = whitelist.length ? pick_1(combinedProps, whitelist) : combinedProps;
      return React__default['default'].createElement(VictoryAnimation, _extends$7({}, combinedProps.animate, {
        data: propsToAnimate
      }), function (newProps) {
        if (child.props.groupComponent) {
          var groupComponent = _this3.continuous ? React__default['default'].cloneElement(child.props.groupComponent, {
            clipWidth: newProps.clipWidth || 0
          }) : child.props.groupComponent;
          return React__default['default'].cloneElement(child, defaults_1({
            animate: null,
            animating: true,
            groupComponent: groupComponent
          }, newProps, combinedProps));
        }

        return React__default['default'].cloneElement(child, defaults_1({
          animate: null,
          animating: true
        }, newProps, combinedProps));
      });
    }
  }]);

  return VictoryTransition;
}(React__default['default'].Component);

Object.defineProperty(VictoryTransition, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryTransition"
});
Object.defineProperty(VictoryTransition, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    animate: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].object]),
    animationWhitelist: PropTypes__default['default'].array,
    children: PropTypes__default['default'].node
  }
});
Object.defineProperty(VictoryTransition, "contextType", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: TimerContext
});

var ClipPath = function (props) {
  return React__default['default'].createElement("defs", null, React__default['default'].createElement("clipPath", {
    id: props.clipId
  }, props.children));
};

ClipPath.propTypes = {
  children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].node), PropTypes__default['default'].node]),
  clipId: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string])
};

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var Circle$3 = function (props) {
  // eslint-disable-next-line react/prop-types
  var desc = props.desc,
      rest = _objectWithoutProperties$4(props, ["desc"]);

  return desc ? React__default['default'].createElement("circle", _extends$8({
    vectorEffect: "non-scaling-stroke"
  }, rest), React__default['default'].createElement("desc", null, desc)) : React__default['default'].createElement("circle", _extends$8({
    vectorEffect: "non-scaling-stroke"
  }, rest));
};

function _toConsumableArray$6(arr) { return _arrayWithoutHoles$6(arr) || _iterableToArray$6(arr) || _nonIterableSpread$6(); }

function _nonIterableSpread$6() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$6(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$6(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$8(target, key, source[key]); }); } return target; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$6(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$a(self); }

function _assertThisInitialized$a(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VictoryClipContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits$6(VictoryClipContainer, _React$Component);

  function VictoryClipContainer(props) {
    var _this;

    _classCallCheck$7(this, VictoryClipContainer);

    _this = _possibleConstructorReturn$6(this, (VictoryClipContainer.__proto__ || Object.getPrototypeOf(VictoryClipContainer)).call(this, props));
    _this.clipId = !isObject_1(props) || props.clipId === undefined ? uniqueId_1("victory-clip-") : props.clipId;
    return _this;
  }

  _createClass$7(VictoryClipContainer, [{
    key: "calculateAttributes",
    value: function calculateAttributes(props) {
      var polar = props.polar,
          origin = props.origin,
          _props$clipWidth = props.clipWidth,
          clipWidth = _props$clipWidth === void 0 ? 0 : _props$clipWidth,
          _props$clipHeight = props.clipHeight,
          clipHeight = _props$clipHeight === void 0 ? 0 : _props$clipHeight,
          _props$translateX = props.translateX,
          translateX = _props$translateX === void 0 ? 0 : _props$translateX,
          _props$translateY = props.translateY,
          translateY = _props$translateY === void 0 ? 0 : _props$translateY;
      var clipPadding = Helpers.getPadding({
        padding: props.clipPadding
      });
      var radius = props.radius || Helpers.getRadius(props);
      return {
        x: (polar ? origin.x : translateX) - clipPadding.left,
        y: (polar ? origin.y : translateY) - clipPadding.top,
        width: Math.max((polar ? radius : clipWidth) + clipPadding.left + clipPadding.right, 0),
        height: Math.max((polar ? radius : clipHeight) + clipPadding.top + clipPadding.bottom, 0)
      };
    }
  }, {
    key: "renderClippedGroup",
    value: function renderClippedGroup(props, clipId) {
      var style = props.style,
          events = props.events,
          transform = props.transform,
          children = props.children,
          className = props.className,
          groupComponent = props.groupComponent,
          tabIndex = props.tabIndex;
      var clipComponent = this.renderClipComponent(props, clipId);

      var groupProps = assign_1({
        className: className,
        style: style,
        transform: transform,
        key: "clipped-group-".concat(clipId),
        clipPath: "url(#".concat(clipId, ")")
      }, events);

      return React__default['default'].cloneElement(groupComponent, _objectSpread$6({}, groupProps, {
        "aria-label": props["aria-label"],
        tabIndex: tabIndex
      }), [clipComponent].concat(_toConsumableArray$6(React__default['default'].Children.toArray(children))));
    }
  }, {
    key: "renderGroup",
    value: function renderGroup(props) {
      var style = props.style,
          events = props.events,
          transform = props.transform,
          children = props.children,
          className = props.className,
          groupComponent = props.groupComponent,
          tabIndex = props.tabIndex;
      return React__default['default'].cloneElement(groupComponent, assign_1({
        className: className,
        style: style,
        transform: transform,
        "aria-label": props["aria-label"],
        tabIndex: tabIndex
      }, events), children);
    }
  }, {
    key: "renderClipComponent",
    value: function renderClipComponent(props, clipId) {
      var polar = props.polar,
          origin = props.origin,
          _props$clipWidth2 = props.clipWidth,
          clipWidth = _props$clipWidth2 === void 0 ? 0 : _props$clipWidth2,
          _props$clipHeight2 = props.clipHeight,
          clipHeight = _props$clipHeight2 === void 0 ? 0 : _props$clipHeight2,
          _props$translateX2 = props.translateX,
          translateX = _props$translateX2 === void 0 ? 0 : _props$translateX2,
          _props$translateY2 = props.translateY,
          translateY = _props$translateY2 === void 0 ? 0 : _props$translateY2,
          circleComponent = props.circleComponent,
          rectComponent = props.rectComponent,
          clipPathComponent = props.clipPathComponent;

      var _Helpers$getPadding = Helpers.getPadding({
        padding: props.clipPadding
      }),
          top = _Helpers$getPadding.top,
          bottom = _Helpers$getPadding.bottom,
          left = _Helpers$getPadding.left,
          right = _Helpers$getPadding.right;

      var child;

      if (polar) {
        var radius = props.radius || Helpers.getRadius(props);
        var circleProps = {
          r: Math.max(radius + left + right, radius + top + bottom, 0),
          cx: origin.x - left,
          cy: origin.y - top
        };
        child = React__default['default'].cloneElement(circleComponent, circleProps);
      } else {
        var rectProps = {
          x: translateX - left,
          y: translateY - top,
          width: Math.max(clipWidth + left + right, 0),
          height: Math.max(clipHeight + top + bottom, 0)
        };
        child = React__default['default'].cloneElement(rectComponent, rectProps);
      }

      return React__default['default'].cloneElement(clipPathComponent, assign_1({
        key: "clip-path-".concat(clipId)
      }, props, {
        clipId: clipId
      }), child);
    }
  }, {
    key: "getClipValue",
    value: function getClipValue(props, axis) {
      var clipValues = {
        x: props.clipWidth,
        y: props.clipHeight
      };

      if (clipValues[axis] !== undefined) {
        return clipValues[axis];
      }

      var range = Helpers.getRange(props, axis);
      return range ? Math.abs(range[0] - range[1]) || undefined : undefined;
    }
  }, {
    key: "getTranslateValue",
    value: function getTranslateValue(props, axis) {
      var translateValues = {
        x: props.translateX,
        y: props.translateY
      };

      if (translateValues[axis] !== undefined) {
        return translateValues[axis];
      }

      var range = Helpers.getRange(props, axis);
      return range ? Math.min.apply(Math, _toConsumableArray$6(range)) : undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var clipHeight = this.getClipValue(this.props, "y");
      var clipWidth = this.getClipValue(this.props, "x");

      if (clipWidth === undefined || clipHeight === undefined) {
        return this.renderGroup(this.props);
      }

      var translateX = this.getTranslateValue(this.props, "x");
      var translateY = this.getTranslateValue(this.props, "y");

      var clipProps = defaults_1({}, this.props, {
        clipHeight: clipHeight,
        clipWidth: clipWidth,
        translateX: translateX,
        translateY: translateY
      });

      return this.renderClippedGroup(clipProps, this.clipId);
    }
  }]);

  return VictoryClipContainer;
}(React__default['default'].Component);

Object.defineProperty(VictoryClipContainer, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryClipContainer"
});
Object.defineProperty(VictoryClipContainer, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "container"
});
Object.defineProperty(VictoryClipContainer, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    "aria-label": PropTypes__default['default'].string,
    children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].node), PropTypes__default['default'].node]),
    circleComponent: PropTypes__default['default'].element,
    className: PropTypes__default['default'].string,
    clipHeight: CustomPropTypes.nonNegative,
    clipId: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
    clipPadding: PropTypes__default['default'].shape({
      top: PropTypes__default['default'].number,
      bottom: PropTypes__default['default'].number,
      left: PropTypes__default['default'].number,
      right: PropTypes__default['default'].number
    }),
    clipPathComponent: PropTypes__default['default'].element,
    clipWidth: CustomPropTypes.nonNegative,
    events: PropTypes__default['default'].object,
    groupComponent: PropTypes__default['default'].element,
    origin: PropTypes__default['default'].shape({
      x: CustomPropTypes.nonNegative,
      y: CustomPropTypes.nonNegative
    }),
    polar: PropTypes__default['default'].bool,
    radius: CustomPropTypes.nonNegative,
    style: PropTypes__default['default'].object,
    tabIndex: PropTypes__default['default'].number,
    transform: PropTypes__default['default'].string,
    translateX: PropTypes__default['default'].number,
    translateY: PropTypes__default['default'].number
  }
});
Object.defineProperty(VictoryClipContainer, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    circleComponent: React__default['default'].createElement(Circle$3, null),
    rectComponent: React__default['default'].createElement(Rect, null),
    clipPathComponent: React__default['default'].createElement(ClipPath, null),
    groupComponent: React__default['default'].createElement("g", null)
  }
});

// *
// * Colors
// *
var yellow200 = "#FFF59D";
var deepOrange600 = "#F4511E";
var lime300 = "#DCE775";
var lightGreen500 = "#8BC34A";
var teal700 = "#00796B";
var cyan900 = "#006064";
var colors = [deepOrange600, yellow200, lime300, lightGreen500, teal700, cyan900];
var blueGrey50 = "#ECEFF1";
var blueGrey300 = "#90A4AE";
var blueGrey700 = "#455A64";
var grey900 = "#212121"; // *
// * Typography
// *

var sansSerif = "'Helvetica Neue', 'Helvetica', sans-serif";
var letterSpacing = "normal";
var fontSize = 12; // *
// * Layout
// *

var padding = 8;
var baseProps = {
  width: 350,
  height: 350,
  padding: 50
}; // *
// * Labels
// *

var baseLabelStyles = {
  fontFamily: sansSerif,
  fontSize: fontSize,
  letterSpacing: letterSpacing,
  padding: padding,
  fill: blueGrey700,
  stroke: "transparent",
  strokeWidth: 0
};

var centeredLabelStyles = assign_1({
  textAnchor: "middle"
}, baseLabelStyles); // *
// * Strokes
// *


var strokeDasharray = "10, 5";
var strokeLinecap = "round";
var strokeLinejoin = "round";
var materialTheme = {
  area: assign_1({
    style: {
      data: {
        fill: grey900
      },
      labels: baseLabelStyles
    }
  }, baseProps),
  axis: assign_1({
    style: {
      axis: {
        fill: "transparent",
        stroke: blueGrey300,
        strokeWidth: 2,
        strokeLinecap: strokeLinecap,
        strokeLinejoin: strokeLinejoin
      },
      axisLabel: assign_1({}, centeredLabelStyles, {
        padding: padding,
        stroke: "transparent"
      }),
      grid: {
        fill: "none",
        stroke: blueGrey50,
        strokeDasharray: strokeDasharray,
        strokeLinecap: strokeLinecap,
        strokeLinejoin: strokeLinejoin,
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 5,
        stroke: blueGrey300,
        strokeWidth: 1,
        strokeLinecap: strokeLinecap,
        strokeLinejoin: strokeLinejoin
      },
      tickLabels: assign_1({}, baseLabelStyles, {
        fill: blueGrey700
      })
    }
  }, baseProps),
  polarDependentAxis: assign_1({
    style: {
      ticks: {
        fill: "transparent",
        size: 1,
        stroke: "transparent"
      }
    }
  }),
  bar: assign_1({
    style: {
      data: {
        fill: blueGrey700,
        padding: padding,
        strokeWidth: 0
      },
      labels: baseLabelStyles
    }
  }, baseProps),
  boxplot: assign_1({
    style: {
      max: {
        padding: padding,
        stroke: blueGrey700,
        strokeWidth: 1
      },
      maxLabels: assign_1({}, baseLabelStyles, {
        padding: 3
      }),
      median: {
        padding: padding,
        stroke: blueGrey700,
        strokeWidth: 1
      },
      medianLabels: assign_1({}, baseLabelStyles, {
        padding: 3
      }),
      min: {
        padding: padding,
        stroke: blueGrey700,
        strokeWidth: 1
      },
      minLabels: assign_1({}, baseLabelStyles, {
        padding: 3
      }),
      q1: {
        padding: padding,
        fill: blueGrey700
      },
      q1Labels: assign_1({}, baseLabelStyles, {
        padding: 3
      }),
      q3: {
        padding: padding,
        fill: blueGrey700
      },
      q3Labels: assign_1({}, baseLabelStyles, {
        padding: 3
      })
    },
    boxWidth: 20
  }, baseProps),
  candlestick: assign_1({
    style: {
      data: {
        stroke: blueGrey700
      },
      labels: assign_1({}, baseLabelStyles, {
        padding: 5
      })
    },
    candleColors: {
      positive: "#ffffff",
      negative: blueGrey700
    }
  }, baseProps),
  chart: baseProps,
  errorbar: assign_1({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: blueGrey700,
        strokeWidth: 2
      },
      labels: baseLabelStyles
    }
  }, baseProps),
  group: assign_1({
    colorScale: colors
  }, baseProps),
  histogram: assign_1({
    style: {
      data: {
        fill: blueGrey700,
        stroke: grey900,
        strokeWidth: 2
      },
      labels: baseLabelStyles
    }
  }, baseProps),
  legend: {
    colorScale: colors,
    gutter: 10,
    orientation: "vertical",
    titleOrientation: "top",
    style: {
      data: {
        type: "circle"
      },
      labels: baseLabelStyles,
      title: assign_1({}, baseLabelStyles, {
        padding: 5
      })
    }
  },
  line: assign_1({
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: blueGrey700,
        strokeWidth: 2
      },
      labels: baseLabelStyles
    }
  }, baseProps),
  pie: assign_1({
    colorScale: colors,
    style: {
      data: {
        padding: padding,
        stroke: blueGrey50,
        strokeWidth: 1
      },
      labels: assign_1({}, baseLabelStyles, {
        padding: 20
      })
    }
  }, baseProps),
  scatter: assign_1({
    style: {
      data: {
        fill: blueGrey700,
        opacity: 1,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: baseLabelStyles
    }
  }, baseProps),
  stack: assign_1({
    colorScale: colors
  }, baseProps),
  tooltip: {
    style: assign_1({}, baseLabelStyles, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: grey900,
      strokeWidth: 1,
      fill: "#f0f0f0",
      pointerEvents: "none"
    },
    flyoutPadding: 5,
    cornerRadius: 5,
    pointerLength: 10
  },
  voronoi: assign_1({
    style: {
      data: {
        fill: "transparent",
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: assign_1({}, baseLabelStyles, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: grey900,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      }
    }
  }, baseProps)
};

// *
// * Colors
// *
var colors$1 = ["#252525", "#525252", "#737373", "#969696", "#bdbdbd", "#d9d9d9", "#f0f0f0"];
var charcoal = "#252525";
var grey = "#969696"; // *
// * Typography
// *

var sansSerif$1 = "'Gill Sans', 'Seravek', 'Trebuchet MS', sans-serif";
var letterSpacing$1 = "normal";
var fontSize$1 = 14; // *
// * Layout
// *

var baseProps$1 = {
  width: 450,
  height: 300,
  padding: 50,
  colorScale: colors$1
}; // *
// * Labels
// *

var baseLabelStyles$1 = {
  fontFamily: sansSerif$1,
  fontSize: fontSize$1,
  letterSpacing: letterSpacing$1,
  padding: 10,
  fill: charcoal,
  stroke: "transparent"
};

var centeredLabelStyles$1 = assign_1({
  textAnchor: "middle"
}, baseLabelStyles$1); // *
// * Strokes
// *


var strokeLinecap$1 = "round";
var strokeLinejoin$1 = "round";
var grayscaleTheme = {
  area: assign_1({
    style: {
      data: {
        fill: charcoal
      },
      labels: baseLabelStyles$1
    }
  }, baseProps$1),
  axis: assign_1({
    style: {
      axis: {
        fill: "transparent",
        stroke: charcoal,
        strokeWidth: 1,
        strokeLinecap: strokeLinecap$1,
        strokeLinejoin: strokeLinejoin$1
      },
      axisLabel: assign_1({}, centeredLabelStyles$1, {
        padding: 25
      }),
      grid: {
        fill: "none",
        stroke: "none",
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 1,
        stroke: "transparent"
      },
      tickLabels: baseLabelStyles$1
    }
  }, baseProps$1),
  bar: assign_1({
    style: {
      data: {
        fill: charcoal,
        padding: 8,
        strokeWidth: 0
      },
      labels: baseLabelStyles$1
    }
  }, baseProps$1),
  boxplot: assign_1({
    style: {
      max: {
        padding: 8,
        stroke: charcoal,
        strokeWidth: 1
      },
      maxLabels: assign_1({}, baseLabelStyles$1, {
        padding: 3
      }),
      median: {
        padding: 8,
        stroke: charcoal,
        strokeWidth: 1
      },
      medianLabels: assign_1({}, baseLabelStyles$1, {
        padding: 3
      }),
      min: {
        padding: 8,
        stroke: charcoal,
        strokeWidth: 1
      },
      minLabels: assign_1({}, baseLabelStyles$1, {
        padding: 3
      }),
      q1: {
        padding: 8,
        fill: grey
      },
      q1Labels: assign_1({}, baseLabelStyles$1, {
        padding: 3
      }),
      q3: {
        padding: 8,
        fill: grey
      },
      q3Labels: assign_1({}, baseLabelStyles$1, {
        padding: 3
      })
    },
    boxWidth: 20
  }, baseProps$1),
  candlestick: assign_1({
    style: {
      data: {
        stroke: charcoal,
        strokeWidth: 1
      },
      labels: assign_1({}, baseLabelStyles$1, {
        padding: 5
      })
    },
    candleColors: {
      positive: "#ffffff",
      negative: charcoal
    }
  }, baseProps$1),
  chart: baseProps$1,
  errorbar: assign_1({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        stroke: charcoal,
        strokeWidth: 2
      },
      labels: baseLabelStyles$1
    }
  }, baseProps$1),
  group: assign_1({
    colorScale: colors$1
  }, baseProps$1),
  histogram: assign_1({
    style: {
      data: {
        fill: grey,
        stroke: charcoal,
        strokeWidth: 2
      },
      labels: baseLabelStyles$1
    }
  }, baseProps$1),
  legend: {
    colorScale: colors$1,
    gutter: 10,
    orientation: "vertical",
    titleOrientation: "top",
    style: {
      data: {
        type: "circle"
      },
      labels: baseLabelStyles$1,
      title: assign_1({}, baseLabelStyles$1, {
        padding: 5
      })
    }
  },
  line: assign_1({
    style: {
      data: {
        fill: "transparent",
        stroke: charcoal,
        strokeWidth: 2
      },
      labels: baseLabelStyles$1
    }
  }, baseProps$1),
  pie: {
    style: {
      data: {
        padding: 10,
        stroke: "transparent",
        strokeWidth: 1
      },
      labels: assign_1({}, baseLabelStyles$1, {
        padding: 20
      })
    },
    colorScale: colors$1,
    width: 400,
    height: 400,
    padding: 50
  },
  scatter: assign_1({
    style: {
      data: {
        fill: charcoal,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: baseLabelStyles$1
    }
  }, baseProps$1),
  stack: assign_1({
    colorScale: colors$1
  }, baseProps$1),
  tooltip: {
    style: assign_1({}, baseLabelStyles$1, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: charcoal,
      strokeWidth: 1,
      fill: "#f0f0f0",
      pointerEvents: "none"
    },
    flyoutPadding: 5,
    cornerRadius: 5,
    pointerLength: 10
  },
  voronoi: assign_1({
    style: {
      data: {
        fill: "transparent",
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: assign_1({}, baseLabelStyles$1, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: charcoal,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      }
    }
  }, baseProps$1)
};

var VictoryTheme = {
  material: materialTheme,
  grayscale: grayscaleTheme
};

var dataProps = {
  categories: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].shape({
    x: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    y: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)
  })]),
  data: PropTypes__default['default'].oneOfType([PropTypes__default['default'].array, PropTypes__default['default'].object]),
  dataComponent: PropTypes__default['default'].element,
  labelComponent: PropTypes__default['default'].element,
  labels: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].array]),
  samples: CustomPropTypes.nonNegative,
  sortKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),
  sortOrder: PropTypes__default['default'].oneOf(["ascending", "descending"]),
  style: PropTypes__default['default'].shape({
    parent: PropTypes__default['default'].object,
    data: PropTypes__default['default'].object,
    labels: PropTypes__default['default'].object
  }),
  x: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),
  y: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),
  y0: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)])
};
var baseProps$2 = {
  animate: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].object]),
  containerComponent: PropTypes__default['default'].element,
  domain: PropTypes__default['default'].oneOfType([CustomPropTypes.domain, PropTypes__default['default'].shape({
    x: CustomPropTypes.domain,
    y: CustomPropTypes.domain
  })]),
  maxDomain: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].instanceOf(Date), PropTypes__default['default'].shape({
    x: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].instanceOf(Date)]),
    y: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].instanceOf(Date)])
  })]),
  minDomain: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].instanceOf(Date), PropTypes__default['default'].shape({
    x: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].instanceOf(Date)]),
    y: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].instanceOf(Date)])
  })]),
  domainPadding: PropTypes__default['default'].oneOfType([PropTypes__default['default'].shape({
    x: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].arrayOf(PropTypes__default['default'].number)]),
    y: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].arrayOf(PropTypes__default['default'].number)])
  }), PropTypes__default['default'].number, PropTypes__default['default'].arrayOf(PropTypes__default['default'].number)]),
  eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
  events: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    target: PropTypes__default['default'].oneOf(["data", "labels", "parent"]),
    eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].array, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
    eventHandlers: PropTypes__default['default'].object
  })),
  externalEventMutations: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    callback: PropTypes__default['default'].function,
    childName: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].array]),
    eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].array, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
    mutation: PropTypes__default['default'].function,
    target: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].array])
  })),
  groupComponent: PropTypes__default['default'].element,
  height: CustomPropTypes.nonNegative,
  name: PropTypes__default['default'].string,
  origin: PropTypes__default['default'].shape({
    x: PropTypes__default['default'].number,
    y: PropTypes__default['default'].number
  }),
  padding: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].shape({
    top: PropTypes__default['default'].number,
    bottom: PropTypes__default['default'].number,
    left: PropTypes__default['default'].number,
    right: PropTypes__default['default'].number
  })]),
  polar: PropTypes__default['default'].bool,
  range: PropTypes__default['default'].oneOfType([CustomPropTypes.domain, PropTypes__default['default'].shape({
    x: CustomPropTypes.domain,
    y: CustomPropTypes.domain
  })]),
  scale: PropTypes__default['default'].oneOfType([CustomPropTypes.scale, PropTypes__default['default'].shape({
    x: CustomPropTypes.scale,
    y: CustomPropTypes.scale
  })]),
  sharedEvents: PropTypes__default['default'].shape({
    events: PropTypes__default['default'].array,
    getEventState: PropTypes__default['default'].func
  }),
  singleQuadrantDomainPadding: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].shape({
    x: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool]),
    y: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool])
  })]),
  standalone: PropTypes__default['default'].bool,
  theme: PropTypes__default['default'].object,
  width: CustomPropTypes.nonNegative
};
var primitiveProps = {
  active: PropTypes__default['default'].bool,
  ariaLabel: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].func]),
  className: PropTypes__default['default'].string,
  clipPath: PropTypes__default['default'].string,
  data: PropTypes__default['default'].oneOfType([PropTypes__default['default'].array, PropTypes__default['default'].object]),
  desc: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].func]),
  events: PropTypes__default['default'].object,
  id: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string, PropTypes__default['default'].func]),
  index: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
  origin: PropTypes__default['default'].shape({
    x: PropTypes__default['default'].number,
    y: PropTypes__default['default'].number
  }),
  polar: PropTypes__default['default'].bool,
  role: PropTypes__default['default'].string,
  scale: PropTypes__default['default'].oneOfType([CustomPropTypes.scale, PropTypes__default['default'].shape({
    x: CustomPropTypes.scale,
    y: CustomPropTypes.scale
  })]),
  shapeRendering: PropTypes__default['default'].string,
  style: PropTypes__default['default'].object,
  tabIndex: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
  transform: PropTypes__default['default'].string
};
var CommonProps = {
  baseProps: baseProps$2,
  dataProps: dataProps,
  primitiveProps: primitiveProps
};

function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var Path$1 = function (props) {
  // eslint-disable-next-line react/prop-types
  var desc = props.desc,
      rest = _objectWithoutProperties$5(props, ["desc"]);

  return desc ? React__default['default'].createElement("path", rest, React__default['default'].createElement("desc", null, desc)) : React__default['default'].createElement("path", rest);
};

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$9(target, key, source[key]); }); } return target; }

function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getArcPath = function (props) {
  var cx = props.cx,
      cy = props.cy,
      r = props.r,
      startAngle = props.startAngle,
      endAngle = props.endAngle,
      closedPath = props.closedPath; // Always draw the path as two arcs so that complete circles may be rendered.

  var halfAngle = Math.abs(endAngle - startAngle) / 2 + startAngle;
  var x1 = cx + r * Math.cos(Helpers.degreesToRadians(startAngle));
  var y1 = cy - r * Math.sin(Helpers.degreesToRadians(startAngle));
  var x2 = cx + r * Math.cos(Helpers.degreesToRadians(halfAngle));
  var y2 = cy - r * Math.sin(Helpers.degreesToRadians(halfAngle));
  var x3 = cx + r * Math.cos(Helpers.degreesToRadians(endAngle));
  var y3 = cy - r * Math.sin(Helpers.degreesToRadians(endAngle));
  var largerArcFlag1 = halfAngle - startAngle <= 180 ? 0 : 1;
  var largerArcFlag2 = endAngle - halfAngle <= 180 ? 0 : 1;
  var arcStart = closedPath ? " M ".concat(cx, ", ").concat(cy, " L ").concat(x1, ", ").concat(y1) : "M ".concat(x1, ", ").concat(y1);
  var arc1 = "A ".concat(r, ", ").concat(r, ", 0, ").concat(largerArcFlag1, ", 0, ").concat(x2, ", ").concat(y2);
  var arc2 = "A ".concat(r, ", ").concat(r, ", 0, ").concat(largerArcFlag2, ", 0, ").concat(x3, ", ").concat(y3);
  var arcEnd = closedPath ? "Z" : "";
  return "".concat(arcStart, " ").concat(arc1, " ").concat(arc2, " ").concat(arcEnd);
};

var evaluateProps$1 = function (props) {
  /**
   * Potential evaluated props are:
   * `ariaLabel`
   * `desc`
   * `id`
   * `style`
   * `tabIndex`
   */
  var ariaLabel = Helpers.evaluateProp(props.ariaLabel, props);
  var desc = Helpers.evaluateProp(props.desc, props);
  var id = Helpers.evaluateProp(props.id, props);
  var style = Helpers.evaluateStyle(assign_1({
    stroke: "black",
    fill: "none"
  }, props.style), props);
  var tabIndex = Helpers.evaluateProp(props.tabIndex, props);
  return assign_1({}, props, {
    ariaLabel: ariaLabel,
    desc: desc,
    id: id,
    style: style,
    tabIndex: tabIndex
  });
};

var Arc = function (props) {
  props = evaluateProps$1(props);
  return React__default['default'].cloneElement(props.pathComponent, _objectSpread$7({}, props.events, {
    "aria-label": props.ariaLabel,
    d: getArcPath(props),
    style: props.style,
    desc: props.desc,
    tabIndex: props.tabIndex,
    className: props.className,
    role: props.role,
    shapeRendering: props.shapeRendering,
    transform: props.transform,
    clipPath: props.clipPath
  }));
};

Arc.propTypes = _objectSpread$7({}, CommonProps.primitiveProps, {
  closedPath: PropTypes__default['default'].bool,
  cx: PropTypes__default['default'].number,
  cy: PropTypes__default['default'].number,
  datum: PropTypes__default['default'].any,
  endAngle: PropTypes__default['default'].number,
  pathComponent: PropTypes__default['default'].element,
  r: PropTypes__default['default'].number,
  startAngle: PropTypes__default['default'].number
});
Arc.defaultProps = {
  pathComponent: React__default['default'].createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$a(target, key, source[key]); }); } return target; }

function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var evaluateProps$2 = function (props) {
  /**
   * Potential evaluated prop is:
   * `id`
   */
  var id = Helpers.evaluateProp(props.id, props);
  return assign_1({}, props, {
    id: id
  });
};

var Background = function (props) {
  props = evaluateProps$2(props);
  return props.polar ? React__default['default'].cloneElement(props.circleComponent, _objectSpread$8({}, props.events, {
    style: props.style,
    role: props.role,
    shapeRendering: props.shapeRendering,
    cx: props.x,
    cy: props.y,
    r: props.height
  })) : React__default['default'].cloneElement(props.rectComponent, _objectSpread$8({}, props.events, {
    style: props.style,
    role: props.role,
    shapeRendering: props.shapeRendering,
    x: props.x,
    y: props.y,
    width: props.width,
    height: props.height
  }));
};

Background.propTypes = _objectSpread$8({}, CommonProps.primitiveProps, {
  circleComponent: PropTypes__default['default'].element,
  height: PropTypes__default['default'].number,
  rectComponent: PropTypes__default['default'].element,
  width: PropTypes__default['default'].number,
  x: PropTypes__default['default'].number,
  y: PropTypes__default['default'].number
});
Background.defaultProps = {
  circleComponent: React__default['default'].createElement(Circle$3, null),
  rectComponent: React__default['default'].createElement(Rect, null),
  role: "presentation",
  shapeRendering: "auto"
};

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var Line = function (props) {
  // eslint-disable-next-line react/prop-types
  var desc = props.desc,
      rest = _objectWithoutProperties$6(props, ["desc"]);

  return desc ? React__default['default'].createElement("line", _extends$9({
    vectorEffect: "non-scaling-stroke"
  }, rest), React__default['default'].createElement("desc", null, desc)) : React__default['default'].createElement("line", _extends$9({
    vectorEffect: "non-scaling-stroke"
  }, rest));
};

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$b(target, key, source[key]); }); } return target; }

function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var evaluateProps$3 = function (props) {
  /**
   * Potential evaluated props are:
   * `ariaLabel`
   * `desc`
   * `id`
   * `style`
   * `tabIndex`
   */
  var ariaLabel = Helpers.evaluateProp(props.ariaLabel, props);
  var desc = Helpers.evaluateProp(props.desc, props);
  var id = Helpers.evaluateProp(props.id, props);
  var style = Helpers.evaluateStyle(assign_1({
    stroke: "black"
  }, props.style), props);
  var tabIndex = Helpers.evaluateProp(props.tabIndex, props);
  return assign_1({}, props, {
    ariaLabel: ariaLabel,
    desc: desc,
    id: id,
    style: style,
    tabIndex: tabIndex
  });
};

var LineSegment = function (props) {
  props = evaluateProps$3(props);
  return React__default['default'].cloneElement(props.lineComponent, _objectSpread$9({}, props.events, {
    "aria-label": props.ariaLabel,
    style: props.style,
    desc: props.desc,
    tabIndex: props.tabIndex,
    className: props.className,
    role: props.role,
    shapeRendering: props.shapeRendering,
    x1: props.x1,
    x2: props.x2,
    y1: props.y1,
    y2: props.y2,
    transform: props.transform,
    clipPath: props.clipPath
  }));
};

LineSegment.propTypes = _objectSpread$9({}, CommonProps.primitiveProps, {
  datum: PropTypes__default['default'].any,
  lineComponent: PropTypes__default['default'].element,
  x1: PropTypes__default['default'].number,
  x2: PropTypes__default['default'].number,
  y1: PropTypes__default['default'].number,
  y2: PropTypes__default['default'].number
});
LineSegment.defaultProps = {
  lineComponent: React__default['default'].createElement(Line, null),
  role: "presentation",
  shapeRendering: "auto"
};

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax$2 = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax$2(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

var _baseRange = baseRange;

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && _isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite_1(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite_1(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite_1(step);
    return _baseRange(start, end, step, fromRight);
  };
}

var _createRange = createRange;

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = _createRange();

var range_1 = range;

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? _strictIndexOf(array, value, fromIndex)
    : _baseFindIndex(array, _baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && _baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = _arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = _arrayMap(values, _baseUnary(iteratee));
  }
  if (comparator) {
    includes = _arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE$1) {
    includes = _cacheHas;
    isCommon = false;
    values = new _SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

var _baseDifference = baseDifference;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = _baseRest(function(array, values) {
  return isArrayLikeObject_1(array)
    ? _baseDifference(array, values)
    : [];
});

var without_1 = without;

/** `Object#toString` result references. */
var stringTag$2 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString$1(value) {
  return typeof value == 'string' ||
    (!isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag$2);
}

var isString_1 = isString$1;

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return _arrayMap(props, function(key) {
    return object[key];
  });
}

var _baseValues = baseValues;

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : _baseValues(object, keys_1(object));
}

var values_1 = values;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike_1(collection) ? collection : values_1(collection);
  fromIndex = (fromIndex && !guard) ? toInteger_1(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax$3(length + fromIndex, 0);
  }
  return isString_1(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && _baseIndexOf(collection, value, fromIndex) > -1);
}

var includes_1 = includes;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop$4() {
  // No operation performed.
}

var noop_1 = noop$4;

/** Used as references for various `Number` constants. */
var INFINITY$4 = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(_Set && (1 / _setToArray(new _Set([,-0]))[1]) == INFINITY$4) ? noop_1 : function(values) {
  return new _Set(values);
};

var _createSet = createSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$2 = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = _arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = _arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE$2) {
    var set = iteratee ? null : _createSet(array);
    if (set) {
      return _setToArray(set);
    }
    isCommon = false;
    includes = _cacheHas;
    seen = new _SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseUniq = baseUniq;

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? _baseUniq(array) : [];
}

var uniq_1 = uniq;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy$1(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = _arrayMap(_getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = _baseIteratee(predicate);
  return _basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

var pickBy_1 = pickBy$1;

function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray$7(arr) { return _arrayWithoutHoles$7(arr) || _iterableToArray$7(arr) || _nonIterableSpread$7(); }

function _nonIterableSpread$7() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$7(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$7(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var Events = {
  /* Returns all own and shared events that should be attached to a single target element,
   * i.e. an individual bar specified by target: "data", eventKey: [index].
   * Returned events are scoped to the appropriate state. Either that of the component itself
   * (i.e. VictoryBar) in the case of own events, or that of the parent component
   * (i.e. VictoryChart) in the case of shared events
   */
  // eslint-disable-next-line max-params
  getEvents: function (props, target, eventKey, getScopedEvents) {
    var _this = this;

    // Returns all events that apply to a particular target element
    var getEventsByTarget = function (events) {
      var getSelectedEvents = function () {
        var targetEvents = events.reduce(function (memo, event) {
          if (event.target !== undefined) {
            var matchesTarget = Array.isArray(event.target) ? includes_1(event.target, target) : "".concat(event.target) === "".concat(target);
            return matchesTarget ? memo.concat(event) : memo;
          }

          return memo.concat(event);
        }, []);

        if (eventKey !== undefined && target !== "parent") {
          return targetEvents.filter(function (obj) {
            var targetKeys = obj.eventKey;

            var useKey = function (key) {
              return key ? "".concat(key) === "".concat(eventKey) : true;
            };

            return Array.isArray(targetKeys) ? targetKeys.some(function (k) {
              return useKey(k);
            }) : useKey(targetKeys);
          });
        }

        return targetEvents;
      };

      var selectedEvents = getSelectedEvents();
      return Array.isArray(selectedEvents) && selectedEvents.reduce(function (memo, event) {
        return event ? assign_1(memo, event.eventHandlers) : memo;
      }, {});
    };
    /* Returns all events from props and defaultEvents from components. Events handlers
     * specified in props will override handlers for the same event if they are also
     * specified in defaultEvents of a sub-component
     */


    var getAllEvents = function () {
      if (Array.isArray(_this.componentEvents)) {
        var _this$componentEvents;

        return Array.isArray(props.events) ? (_this$componentEvents = _this.componentEvents).concat.apply(_this$componentEvents, _toConsumableArray$7(props.events)) : _this.componentEvents;
      }

      return props.events;
    };

    var allEvents = getAllEvents();
    var ownEvents = allEvents && isFunction_1(getScopedEvents) ? getScopedEvents(getEventsByTarget(allEvents), target) : undefined;

    if (!props.sharedEvents) {
      return ownEvents;
    }

    var getSharedEvents = props.sharedEvents.getEvents;
    var sharedEvents = props.sharedEvents.events && getSharedEvents(getEventsByTarget(props.sharedEvents.events), target);
    return assign_1({}, sharedEvents, ownEvents);
  },

  /* Returns a modified events object where each event handler is replaced by a new
   * function that calls the original handler and then calls setState with the return
   * of the original event handler assigned to state property that maps to the target
   * element.
   */
  // eslint-disable-next-line max-params
  getScopedEvents: function (events, namespace, childType, baseProps) {
    var _this2 = this;

    if (isEmpty_1(events)) {
      return {};
    }

    baseProps = baseProps || this.baseProps; // returns the original base props or base state of a given target element

    var getTargetProps = function (identifier, type) {
      var childName = identifier.childName,
          target = identifier.target,
          key = identifier.key;
      var baseType = type === "props" ? baseProps : _this2.state || {};
      var base = childName === undefined || childName === null || !baseType[childName] ? baseType : baseType[childName];
      return key === "parent" ? base.parent : base[key] && base[key][target];
    }; // Returns the state object with the mutation caused by a given eventReturn
    // applied to the appropriate property on the state object


    var parseEvent = function (eventReturn, eventKey) {
      var childNames = namespace === "parent" ? eventReturn.childName : eventReturn.childName || childType;
      var target = eventReturn.target || namespace; // returns all eventKeys to modify for a targeted childName

      var getKeys = function (childName) {
        if (target === "parent") {
          return "parent";
        }

        if (eventReturn.eventKey === "all") {
          return baseProps[childName] ? without_1(Object.keys(baseProps[childName]), "parent") : without_1(Object.keys(baseProps), "parent");
        } else if (eventReturn.eventKey === undefined && eventKey === "parent") {
          return baseProps[childName] ? Object.keys(baseProps[childName]) : Object.keys(baseProps);
        }

        return eventReturn.eventKey !== undefined ? eventReturn.eventKey : eventKey;
      }; // returns the state object with mutated props applied for a single key


      var getMutationObject = function (key, childName) {
        var baseState = _this2.state || {};

        if (!isFunction_1(eventReturn.mutation)) {
          return baseState;
        }

        var mutationTargetProps = getTargetProps({
          childName: childName,
          key: key,
          target: target
        }, "props");
        var mutationTargetState = getTargetProps({
          childName: childName,
          key: key,
          target: target
        }, "state");
        var mutatedProps = eventReturn.mutation(assign_1({}, mutationTargetProps, mutationTargetState), baseProps);
        var childState = baseState[childName] || {};

        var filterState = function (state) {
          if (state[key] && state[key][target]) {
            delete state[key][target];
          }

          if (state[key] && !Object.keys(state[key]).length) {
            delete state[key];
          }

          return state;
        };

        var extendState = function (state) {
          return target === "parent" ? assign_1(state, _defineProperty$c({}, key, assign_1(state[key], mutatedProps))) : assign_1(state, _defineProperty$c({}, key, assign_1(state[key], _defineProperty$c({}, target, mutatedProps))));
        };

        var updateState = function (state) {
          return mutatedProps ? extendState(state) : filterState(state);
        };

        return childName !== undefined && childName !== null ? assign_1(baseState, _defineProperty$c({}, childName, updateState(childState))) : updateState(baseState);
      }; // returns entire mutated state for a given childName


      var getReturnByChild = function (childName) {
        var mutationKeys = getKeys(childName);
        return Array.isArray(mutationKeys) ? mutationKeys.reduce(function (memo, key) {
          return assign_1(memo, getMutationObject(key, childName));
        }, {}) : getMutationObject(mutationKeys, childName);
      }; // returns an entire mutated state for all children


      var allChildNames = childNames === "all" ? without_1(Object.keys(baseProps), "parent") : childNames;
      return Array.isArray(allChildNames) ? allChildNames.reduce(function (memo, childName) {
        return assign_1(memo, getReturnByChild(childName));
      }, {}) : getReturnByChild(allChildNames);
    }; // Parses an array of event returns into a single state mutation


    var parseEventReturn = function (eventReturn, eventKey) {
      return Array.isArray(eventReturn) ? eventReturn.reduce(function (memo, props) {
        memo = assign_1({}, memo, parseEvent(props, eventKey));
        return memo;
      }, {}) : parseEvent(eventReturn, eventKey);
    };

    var compileCallbacks = function (eventReturn) {
      var getCallback = function (obj) {
        return isFunction_1(obj.callback) && obj.callback;
      };

      var callbacks = Array.isArray(eventReturn) ? eventReturn.map(function (evtObj) {
        return getCallback(evtObj);
      }) : [getCallback(eventReturn)];
      var callbackArray = callbacks.filter(function (callback) {
        return callback !== false;
      });
      return callbackArray.length ? function () {
        return callbackArray.forEach(function (callback) {
          return callback();
        });
      } : undefined;
    }; // A function that calls a particular event handler, parses its return
    // into a state mutation, and calls setState
    // eslint-disable-next-line max-params


    var onEvent = function (evt, childProps, eventKey, eventName) {
      var eventReturn = events[eventName](evt, childProps, eventKey, _this2);

      if (!isEmpty_1(eventReturn)) {
        var callbacks = compileCallbacks(eventReturn);

        _this2.setState(parseEventReturn(eventReturn, eventKey), callbacks);
      }
    }; // returns a new events object with enhanced event handlers


    return Object.keys(events).reduce(function (memo, event) {
      memo[event] = onEvent;
      return memo;
    }, {});
  },

  /* Returns a partially applied event handler for a specific target element
   * This allows event handlers to have access to props controlling each element
   */
  getPartialEvents: function (events, eventKey, childProps) {
    return events ? Object.keys(events).reduce(function (memo, eventName) {
      var appliedEvent = function (evt) {
        return events[eventName](evt, childProps, eventKey, eventName);
      };

      memo[eventName] = appliedEvent;
      return memo;
    }, {}) : {};
  },

  /* Returns the property of the state object corresponding to event changes for
   * a particular element
   */
  getEventState: function (eventKey, namespace, childType) {
    var state = this.state || {};

    if (!childType) {
      return eventKey === "parent" ? state[eventKey] && state[eventKey][namespace] || state[eventKey] : state[eventKey] && state[eventKey][namespace];
    }

    return state[childType] && state[childType][eventKey] && state[childType][eventKey][namespace];
  },

  /**
   * Returns a set of all mutations for shared events
   *
   * @param  {Array} mutations an array of mutations objects
   * @param  {Object} baseProps an object that describes all props for children of VictorySharedEvents
   * @param  {Object} baseState an object that describes state for children of VictorySharedEvents
   * @param  {Array} childNames an array of childNames
   *
   * @return {Object} a object describing all mutations for VictorySharedEvents
   */
  // eslint-disable-next-line max-params
  getExternalMutationsWithChildren: function (mutations, baseProps, baseState, childNames) {
    var _this3 = this;

    baseProps = baseProps || {};
    baseState = baseState || {};
    return childNames.reduce(function (memo, childName) {
      var childState = baseState[childName];

      var mutation = _this3.getExternalMutations(mutations, baseProps[childName], baseState[childName], childName);

      memo[childName] = mutation ? mutation : childState;
      return pickBy_1(memo, function (v) {
        return !isEmpty_1(v);
      });
    }, {});
  },

  /**
   * Returns a set of all mutations for a component
   *
   * @param  {Array} mutations an array of mutations objects
   * @param  {Object} baseProps a props object (scoped to a childName when used by shared events)
   * @param  {Object} baseState a state object (scoped to a childName when used by shared events)
   * @param  {String} childName an optional childName
   *
   * @return {Object} a object describing mutations for a given component
   */
  // eslint-disable-next-line max-params
  getExternalMutations: function (mutations, baseProps, baseState, childName) {
    var _this4 = this;

    baseProps = baseProps || {};
    baseState = baseState || {};
    var eventKeys = Object.keys(baseProps);
    return eventKeys.reduce(function (memo, eventKey) {
      var keyState = baseState[eventKey] || {};
      var keyProps = baseProps[eventKey] || {};

      if (eventKey === "parent") {
        var identifier = {
          eventKey: eventKey,
          target: "parent"
        };

        var mutation = _this4.getExternalMutation(mutations, keyProps, keyState, identifier);

        memo[eventKey] = mutation !== undefined ? assign_1({}, keyState, mutation) : keyState;
      } else {
        // use keys from both state and props so that elements not intially included in baseProps
        // will be used. (i.e. labels)
        var targets = uniq_1(Object.keys(keyProps).concat(Object.keys(keyState)));

        memo[eventKey] = targets.reduce(function (m, target) {
          var identifier = {
            eventKey: eventKey,
            target: target,
            childName: childName
          };

          var mutation = _this4.getExternalMutation(mutations, keyProps[target], keyState[target], identifier);

          m[target] = mutation !== undefined ? assign_1({}, keyState[target], mutation) : keyState[target];
          return pickBy_1(m, function (v) {
            return !isEmpty_1(v);
          });
        }, {});
      }

      return pickBy_1(memo, function (v) {
        return !isEmpty_1(v);
      });
    }, {});
  },

  /**
   * Returns a set of mutations for a particular element given scoped baseProps and baseState
   *
   * @param  {Array} mutations an array of mutations objects
   * @param  {Object} baseProps a props object (scoped the element specified by the identifier)
   * @param  {Object} baseState a state object (scoped the element specified by the identifier)
   * @param  {Object} identifier { eventKey, target, childName }
   *
   * @return {Object | undefined} a object describing mutations for a given element, or undefined
   */
  // eslint-disable-next-line max-params
  getExternalMutation: function (mutations, baseProps, baseState, identifier) {
    var filterMutations = function (mutation, type) {
      if (typeof mutation[type] === "string") {
        return mutation[type] === "all" || mutation[type] === identifier[type];
      } else if (Array.isArray(mutation[type])) {
        // coerce arrays to strings before matching
        var stringArray = mutation[type].map(function (m) {
          return "".concat(m);
        });
        return includes_1(stringArray, identifier[type]);
      } else {
        return false;
      }
    };

    mutations = Array.isArray(mutations) ? mutations : [mutations];
    var scopedMutations = mutations;

    if (identifier.childName) {
      scopedMutations = mutations.filter(function (m) {
        return filterMutations(m, "childName");
      });
    } // find any mutation objects that match the target


    var targetMutations = scopedMutations.filter(function (m) {
      return filterMutations(m, "target");
    });

    if (isEmpty_1(targetMutations)) {
      return undefined;
    }

    var keyMutations = targetMutations.filter(function (m) {
      return filterMutations(m, "eventKey");
    });

    if (isEmpty_1(keyMutations)) {
      return undefined;
    }

    return keyMutations.reduce(function (memo, curr) {
      var mutationFunction = curr && isFunction_1(curr.mutation) ? curr.mutation : function () {
        return undefined;
      };
      var currentMutation = mutationFunction(assign_1({}, baseProps, baseState));
      return assign_1({}, memo, currentMutation);
    }, {});
  },

  /* Returns an array of defaultEvents from sub-components of a given component.
   * i.e. any static `defaultEvents` on `labelComponent` will be returned
   */
  getComponentEvents: function (props, components) {
    var events = Array.isArray(components) && components.reduce(function (memo, componentName) {
      var _memo;

      var component = props[componentName];
      var defaultEvents = component && component.type && component.type.defaultEvents;
      var componentEvents = isFunction_1(defaultEvents) ? defaultEvents(component.props) : defaultEvents;
      memo = Array.isArray(componentEvents) ? (_memo = memo).concat.apply(_memo, _toConsumableArray$7(componentEvents)) : memo;
      return memo;
    }, []);
    return events && events.length ? events : undefined;
  }
};

function _toConsumableArray$8(arr) { return _arrayWithoutHoles$8(arr) || _iterableToArray$8(arr) || _nonIterableSpread$8(); }

function _nonIterableSpread$8() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$8(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$8(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$7(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$b(self); }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized$b(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var datumHasXandY = function (datum) {
  return !isNil_1(datum._x) && !isNil_1(datum._y);
}; //  used for checking state changes. Expected components can be passed in via options


var defaultComponents = [{
  name: "parent",
  index: "parent"
}, {
  name: "data"
}, {
  name: "labels"
}];
var addEvents = (function (WrappedComponent, options) {
  return (
    /*#__PURE__*/
    function (_WrappedComponent) {
      _inherits$7(addEvents, _WrappedComponent);

      function addEvents(props) {
        var _this;

        _classCallCheck$8(this, addEvents);

        _this = _possibleConstructorReturn$7(this, (addEvents.__proto__ || Object.getPrototypeOf(addEvents)).call(this, props));
        var getScopedEvents = Events.getScopedEvents.bind(_assertThisInitialized$b(_this));
        var boundGetEvents = Events.getEvents.bind(_assertThisInitialized$b(_this));
        _this.state = {};

        _this.getEvents = function (p, target, eventKey) {
          return boundGetEvents(p, target, eventKey, getScopedEvents);
        };

        _this.getEventState = Events.getEventState.bind(_assertThisInitialized$b(_this));

        var calculatedValues = _this.getCalculatedValues(props);

        _this.cacheValues(calculatedValues);

        _this.externalMutations = _this.getExternalMutations(props);
        _this.calculatedState = _this.getStateChanges(props);
        return _this;
      }

      _createClass$8(addEvents, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
          var externalMutations = this.getExternalMutations(nextProps);
          var animating = this.props.animating || this.props.animate;
          var newMutation = !reactFastCompare(externalMutations, this.externalMutations);

          if (animating || newMutation) {
            this.cacheValues(this.getCalculatedValues(nextProps));
            this.externalMutations = externalMutations;
            this.applyExternalMutations(nextProps, externalMutations);
            return true;
          }

          var calculatedState = this.getStateChanges(nextProps);

          if (!reactFastCompare(this.calculatedState, calculatedState)) {
            this.cacheValues(this.getCalculatedValues(nextProps));
            return true;
          }

          if (!reactFastCompare(this.props, nextProps)) {
            this.cacheValues(this.getCalculatedValues(nextProps));
            return true;
          }

          return false;
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var calculatedState = this.getStateChanges(prevProps);
          this.calculatedState = calculatedState;
        } // compile all state changes from own and parent state. Order doesn't matter, as any state
        // state change should trigger a re-render

      }, {
        key: "getStateChanges",
        value: function getStateChanges(props) {
          var _this2 = this;

          if (!this.hasEvents) {
            return {};
          }

          var getState = function (key, type) {
            var result = defaults_1({}, _this2.getEventState(key, type), _this2.getSharedEventState(key, type));

            return isEmpty_1(result) ? undefined : result;
          };

          options = options || {};
          var components = options.components || defaultComponents;
          var stateChanges = components.map(function (component) {
            if (!props.standalone && component.name === "parent") {
              // don't check for changes on parent props for non-standalone components
              return undefined;
            } else {
              return component.index !== undefined ? getState(component.index, component.name) : _this2.dataKeys.map(function (key) {
                return getState(key, component.name);
              }).filter(Boolean);
            }
          }).filter(Boolean);
          return stateChanges;
        }
      }, {
        key: "applyExternalMutations",
        value: function applyExternalMutations(props, externalMutations) {
          if (!isEmpty_1(externalMutations)) {
            var callbacks = props.externalEventMutations.reduce(function (memo, mutation) {
              memo = isFunction_1(mutation.callback) ? memo.concat(mutation.callback) : memo;
              return memo;
            }, []);
            var compiledCallbacks = callbacks.length ? function () {
              callbacks.forEach(function (c) {
                return c();
              });
            } : undefined;
            this.setState(externalMutations, compiledCallbacks);
          }
        }
      }, {
        key: "getCalculatedValues",
        value: function getCalculatedValues(props) {
          var sharedEvents = props.sharedEvents;
          var components = WrappedComponent.expectedComponents;
          var componentEvents = Events.getComponentEvents(props, components);
          var getSharedEventState = sharedEvents && isFunction_1(sharedEvents.getEventState) ? sharedEvents.getEventState : function () {
            return undefined;
          };
          var baseProps = this.getBaseProps(props, getSharedEventState);

          var dataKeys = keys_1(baseProps).filter(function (key) {
            return key !== "parent";
          });

          var hasEvents = props.events || props.sharedEvents || componentEvents;
          var events = this.getAllEvents(props);
          return {
            componentEvents: componentEvents,
            getSharedEventState: getSharedEventState,
            baseProps: baseProps,
            dataKeys: dataKeys,
            hasEvents: hasEvents,
            events: events
          };
        }
      }, {
        key: "getExternalMutations",
        value: function getExternalMutations(props) {
          var sharedEvents = props.sharedEvents,
              externalEventMutations = props.externalEventMutations;
          return isEmpty_1(externalEventMutations) || sharedEvents ? undefined : Events.getExternalMutations(externalEventMutations, this.baseProps, this.state);
        }
      }, {
        key: "cacheValues",
        value: function cacheValues(obj) {
          var _this3 = this;

          keys_1(obj).forEach(function (key) {
            _this3[key] = obj[key];
          });
        }
      }, {
        key: "getBaseProps",
        value: function getBaseProps(props, getSharedEventState) {
          getSharedEventState = getSharedEventState || this.getSharedEventState;
          var sharedParentState = getSharedEventState("parent", "parent");
          var parentState = this.getEventState("parent", "parent");

          var baseParentProps = defaults_1({}, parentState, sharedParentState);

          var parentPropsList = baseParentProps.parentControlledProps;
          var parentProps = parentPropsList ? pick_1(baseParentProps, parentPropsList) : {};

          var modifiedProps = defaults_1({}, parentProps, props);

          return isFunction_1(WrappedComponent.getBaseProps) ? WrappedComponent.getBaseProps(modifiedProps) : {};
        }
      }, {
        key: "getAllEvents",
        value: function getAllEvents(props) {
          if (Array.isArray(this.componentEvents)) {
            var _componentEvents;

            return Array.isArray(props.events) ? (_componentEvents = this.componentEvents).concat.apply(_componentEvents, _toConsumableArray$8(props.events)) : this.componentEvents;
          }

          return props.events;
        }
      }, {
        key: "getComponentProps",
        value: function getComponentProps(component, type, index) {
          var name = this.props.name || WrappedComponent.role;
          var key = this.dataKeys && this.dataKeys[index] || index;
          var id = "".concat(name, "-").concat(type, "-").concat(key);
          var baseProps = this.baseProps[key] && this.baseProps[key][type] || this.baseProps[key];

          if (!baseProps && !this.hasEvents) {
            return undefined;
          }

          if (this.hasEvents) {
            var baseEvents = this.getEvents(this.props, type, key);

            var componentProps = defaults_1({
              index: index,
              key: id
            }, this.getEventState(key, type), this.getSharedEventState(key, type), component.props, baseProps, {
              id: id
            });

            var events = defaults_1({}, Events.getPartialEvents(baseEvents, key, componentProps), componentProps.events);

            return assign_1({}, componentProps, {
              events: events
            });
          }

          return defaults_1({
            index: index,
            key: id
          }, component.props, baseProps, {
            id: id
          });
        }
      }, {
        key: "renderContainer",
        value: function renderContainer(component, children) {
          var isContainer = component.type && component.type.role === "container";
          var parentProps = isContainer ? this.getComponentProps(component, "parent", "parent") : {};
          return React__default['default'].cloneElement(component, parentProps, children);
        }
      }, {
        key: "animateComponent",
        value: function animateComponent(props, defaultAnimationWhitelist) {
          var animationWhitelist = props.animate && props.animate.animationWhitelist ? props.animate.animationWhitelist : defaultAnimationWhitelist;
          return React__default['default'].createElement(VictoryTransition, {
            animate: props.animate,
            animationWhitelist: animationWhitelist
          }, React__default['default'].createElement(this.constructor, props));
        } // Used by `VictoryLine` and `VictoryArea`

      }, {
        key: "renderContinuousData",
        value: function renderContinuousData(props) {
          var _this4 = this;

          var dataComponent = props.dataComponent,
              labelComponent = props.labelComponent,
              groupComponent = props.groupComponent;

          var dataKeys = without_1(this.dataKeys, "all");

          var labelComponents = dataKeys.reduce(function (memo, key) {
            var labelProps = _this4.getComponentProps(labelComponent, "labels", key);

            if (labelProps && labelProps.text !== undefined && labelProps.text !== null) {
              memo = memo.concat(React__default['default'].cloneElement(labelComponent, labelProps));
            }

            return memo;
          }, []);
          var dataProps = this.getComponentProps(dataComponent, "data", "all");
          var children = [React__default['default'].cloneElement(dataComponent, dataProps)].concat(_toConsumableArray$8(labelComponents));
          return this.renderContainer(groupComponent, children);
        }
      }, {
        key: "renderData",
        value: function renderData(props) {
          var _this5 = this;

          var shouldRenderDatum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : datumHasXandY;
          var dataComponent = props.dataComponent,
              labelComponent = props.labelComponent,
              groupComponent = props.groupComponent;
          var dataComponents = this.dataKeys.reduce(function (validDataComponents, _dataKey, index) {
            var dataProps = _this5.getComponentProps(dataComponent, "data", index);

            if (shouldRenderDatum(dataProps.datum)) {
              validDataComponents.push(React__default['default'].cloneElement(dataComponent, dataProps));
            }

            return validDataComponents;
          }, []);
          var labelComponents = this.dataKeys.map(function (_dataKey, index) {
            var labelProps = _this5.getComponentProps(labelComponent, "labels", index);

            if (labelProps.text !== undefined && labelProps.text !== null) {
              return React__default['default'].cloneElement(labelComponent, labelProps);
            }

            return undefined;
          }).filter(Boolean);

          var children = _toConsumableArray$8(dataComponents).concat(_toConsumableArray$8(labelComponents));

          return this.renderContainer(groupComponent, children);
        }
      }]);

      return addEvents;
    }(WrappedComponent)
  );
});

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual$1(value, other) {
  return _baseIsEqual(value, other);
}

var isEqual_1 = isEqual$1;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function bisector(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
}

function ascendingComparator(f) {
  return function(d, x) {
    return ascending(f(d), x);
  };
}

var ascendingBisect = bisector(ascending);
var bisectRight = ascendingBisect.right;

function number$1(x) {
  return x === null ? NaN : +x;
}

function sequence(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function d3Quantile(values, p, valueof) {
  if (valueof == null) valueof = number$1;
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}

var prefix = "$";

function Map$2() {}

Map$2.prototype = map$2.prototype = {
  constructor: Map$2,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map$2(object, f) {
  var map = new Map$2;

  // Copy constructor.
  if (object instanceof Map$2) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

function Set$2() {}

var proto$3 = map$2.prototype;

Set$2.prototype = set$2.prototype = {
  constructor: Set$2,
  has: proto$3.has,
  add: function(value) {
    value += "";
    this[prefix + value] = value;
    return this;
  },
  remove: proto$3.remove,
  clear: proto$3.clear,
  values: proto$3.keys,
  size: proto$3.size,
  empty: proto$3.empty,
  each: proto$3.each
};

function set$2(object, f) {
  var set = new Set$2;

  // Copy constructor.
  if (object instanceof Set$2) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

var array = Array.prototype;

var map$3 = array.map;
var slice$2 = array.slice;

var implicit = {name: "implicit"};

function ordinal$1(range) {
  var index = map$2(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : slice$2.call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = map$2();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$2.call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal$1()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}

function band() {
  var scale = ordinal$1().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}

function constant$2(x) {
  return function() {
    return x;
  };
}

function number$2(x) {
  return +x;
}

var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constant$2(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisectRight(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = interpolateValue,
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = map$3.call(_, number$2), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$2.call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = slice$2.call(_), interpolate = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent$1(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re$1 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re$1.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": formatDecimal,
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return formatRounded(x * 100, p); },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
};

function identity$1(x) {
  return x;
}

var map$4 = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

function formatLocale(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$1 : formatGroup(map$4.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity$1 : formatNumerals(map$4.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "-" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale$1;
var format$1;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});

function defaultLocale(definition) {
  locale$1 = formatLocale(definition);
  format$1 = locale$1.format;
  formatPrefix = locale$1.formatPrefix;
  return locale$1;
}

function precisionFixed(step) {
  return Math.max(0, -exponent$1(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
}

function tickFormat(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = tickStep(start, stop, count == null ? 10 : count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format$1(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return tickFormat(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = tickIncrement(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = tickIncrement(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = tickIncrement(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear$3() {
  var scale = continuous(deinterpolateLinear, reinterpolate);

  scale.copy = function() {
    return copy(scale, linear$3());
  };

  return linearish(scale);
}

function identity$2() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = map$3.call(_, number$2), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity$2().domain(domain);
  };

  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : constant$2(b);
}

function reinterpolate$1(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log$1() {
  var scale = continuous(deinterpolate, reinterpolate$1).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = format$1(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return copy(scale, log$1().base(base));
  };

  return scale;
}

function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = continuous(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : constant$2(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return copy(scale, pow().exponent(exponent));
  };

  return linearish(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}

function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = d3Quantile(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[bisectRight(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$2.call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}

function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[bisectRight(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = slice$2.call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return linearish(scale);
}

function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[bisectRight(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = slice$2.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$2.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}

var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;

var second = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * durationSecond);
}, function(start, end) {
  return (end - start) / durationSecond;
}, function(date) {
  return date.getUTCSeconds();
});

var minute = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getMinutes();
});

var hour = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getHours();
});

var day = newInterval(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
}, function(date) {
  return date.getDate() - 1;
});

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getUTCMinutes();
});

var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getUTCHours();
});

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay;
}, function(date) {
  return date.getUTCDate() - 1;
});

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale$1(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day$1;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day$1 = week.getUTCDay();
          week = day$1 > 4 || day$1 === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day$1 = week.getDay();
          week = day$1 > 4 || day$1 === 0 ? monday.ceil(week) : monday(week);
          week = day.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day$1 = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$1 + 5) % 7 : d.w + d.U * 7 - (day$1 + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + day.count(year(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(year(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(thursday.count(year(d), d) + (year(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(year(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

var locale$2;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$1(definition) {
  locale$2 = formatLocale$1(definition);
  timeFormat = locale$2.format;
  timeParse = locale$2.parse;
  utcFormat = locale$2.utcFormat;
  utcParse = locale$2.utcParse;
  return locale$2;
}

var durationSecond$1 = 1000,
    durationMinute$1 = durationSecond$1 * 60,
    durationHour$1 = durationMinute$1 * 60,
    durationDay$1 = durationHour$1 * 24,
    durationWeek$1 = durationDay$1 * 7,
    durationMonth = durationDay$1 * 30,
    durationYear = durationDay$1 * 365;

function date$1(t) {
  return new Date(t);
}

function number$3(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar$2(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = continuous(deinterpolateLinear, reinterpolate),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond$1],
    [second,  5,  5 * durationSecond$1],
    [second, 15, 15 * durationSecond$1],
    [second, 30, 30 * durationSecond$1],
    [minute,  1,      durationMinute$1],
    [minute,  5,  5 * durationMinute$1],
    [minute, 15, 15 * durationMinute$1],
    [minute, 30, 30 * durationMinute$1],
    [  hour,  1,      durationHour$1  ],
    [  hour,  3,  3 * durationHour$1  ],
    [  hour,  6,  6 * durationHour$1  ],
    [  hour, 12, 12 * durationHour$1  ],
    [   day,  1,      durationDay$1   ],
    [   day,  2,  2 * durationDay$1   ],
    [  week,  1,      durationWeek$1  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = tickStep(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(tickStep(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(map$3.call(_, number$3)) : domain().map(date$1);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(nice(d, interval))
        : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar$2(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

function time() {
  return calendar$2(year, month, sunday, day, hour, minute, second, millisecond, timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
}

function utcTime() {
  return calendar$2(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
}

function colors$2(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
}

var category10 = colors$2("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

var category20b = colors$2("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");

var category20c = colors$2("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");

var category20 = colors$2("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");

var cubehelix$2 = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));

var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var rainbow = cubehelix();

function rainbow$1(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
}

function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

var viridis = ramp(colors$2("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));

var magma = ramp(colors$2("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(colors$2("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(colors$2("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return linearish(scale);
}

var d3Scale = /*#__PURE__*/Object.freeze({
  __proto__: null,
  scaleBand: band,
  scalePoint: point,
  scaleIdentity: identity$2,
  scaleLinear: linear$3,
  scaleLog: log$1,
  scaleOrdinal: ordinal$1,
  scaleImplicit: implicit,
  scalePow: pow,
  scaleSqrt: sqrt,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleThreshold: threshold,
  scaleTime: time,
  scaleUtc: utcTime,
  schemeCategory10: category10,
  schemeCategory20b: category20b,
  schemeCategory20c: category20c,
  schemeCategory20: category20,
  interpolateCubehelixDefault: cubehelix$2,
  interpolateRainbow: rainbow$1,
  interpolateWarm: warm,
  interpolateCool: cool,
  interpolateViridis: viridis,
  interpolateMagma: magma,
  interpolateInferno: inferno,
  interpolatePlasma: plasma,
  scaleSequential: sequential
});

var supportedScaleStrings = ["linear", "time", "log", "sqrt"]; // Private Functions

function toNewName(scale) {
  // d3 scale changed the naming scheme for scale from "linear" -> "scaleLinear" etc.
  var capitalize = function (s) {
    return s && s[0].toUpperCase() + s.slice(1);
  };

  return "scale".concat(capitalize(scale));
}

function validScale(scale) {
  if (typeof scale === "function") {
    return isFunction_1(scale.copy) && isFunction_1(scale.domain) && isFunction_1(scale.range);
  } else if (typeof scale === "string") {
    return includes_1(supportedScaleStrings, scale);
  }

  return false;
}

function isScaleDefined(props, axis) {
  if (!props.scale) {
    return false;
  } else if (props.scale.x || props.scale.y) {
    return props.scale[axis] ? true : false;
  }

  return true;
}

function getScaleTypeFromProps(props, axis) {
  if (!isScaleDefined(props, axis)) {
    return undefined;
  }

  var scale = props.scale[axis] || props.scale;
  return typeof scale === "string" ? scale : getType(scale);
}

function getScaleFromDomain(props, axis) {
  var domain;

  if (props.domain && props.domain[axis]) {
    domain = props.domain[axis];
  } else if (props.domain && Array.isArray(props.domain)) {
    domain = props.domain;
  }

  if (!domain) {
    return undefined;
  }

  return Collection.containsDates(domain) ? "time" : "linear";
}

function getScaleTypeFromData(props, axis) {
  if (!props.data) {
    return "linear";
  }

  var accessor = Helpers.createAccessor(props[axis]);
  var axisData = props.data.map(function (datum) {
    var processedData = isPlainObject_1(accessor(datum)) ? accessor(datum)[axis] : accessor(datum);
    return processedData !== undefined ? processedData : datum[axis];
  });
  return Collection.containsDates(axisData) ? "time" : "linear";
} // Exported Functions


function getScaleFromName(name) {
  return validScale(name) ? d3Scale[toNewName(name)]() : linear$3();
}

function getBaseScale(props, axis) {
  var scale = getScaleFromProps(props, axis);

  if (scale) {
    return typeof scale === "string" ? getScaleFromName(scale) : scale;
  }

  var defaultScale = getScaleFromDomain(props, axis) || getScaleTypeFromData(props, axis);
  return d3Scale[toNewName(defaultScale)]();
}

function getDefaultScale() {
  return linear$3();
}

function getScaleFromProps(props, axis) {
  if (!isScaleDefined(props, axis)) {
    return undefined;
  }

  var scale = props.scale[axis] || props.scale;

  if (validScale(scale)) {
    return isFunction_1(scale) ? scale : d3Scale[toNewName(scale)]();
  }

  return undefined;
}

function getScaleType(props, axis) {
  // if the scale was not given in props, it will be set to linear or time depending on data
  return getScaleTypeFromProps(props, axis) || getScaleTypeFromData(props, axis);
}

function getType(scale) {
  if (typeof scale === "string") {
    return scale;
  }

  var duckTypes = [{
    name: "log",
    method: "base"
  }, {
    name: "ordinal",
    method: "unknown"
  }, {
    name: "pow-sqrt",
    method: "exponent"
  }, {
    name: "quantile",
    method: "quantiles"
  }, {
    name: "quantize-threshold",
    method: "invertExtent"
  }];
  var scaleType = duckTypes.filter(function (type) {
    return scale[type.method] !== undefined;
  })[0];
  return scaleType ? scaleType.name : undefined;
}

var Scale = {
  getBaseScale: getBaseScale,
  getDefaultScale: getDefaultScale,
  getScaleFromProps: getScaleFromProps,
  getScaleType: getScaleType,
  getType: getType,
  getScaleFromName: getScaleFromName
};

var Immutable = {
  IMMUTABLE_ITERABLE: "@@__IMMUTABLE_ITERABLE__@@",
  IMMUTABLE_RECORD: "@@__IMMUTABLE_RECORD__@@",
  IMMUTABLE_LIST: "@@__IMMUTABLE_LIST__@@",
  IMMUTABLE_MAP: "@@__IMMUTABLE_MAP__@@",
  isImmutable: function (x) {
    return this.isIterable(x) || this.isRecord(x);
  },
  isIterable: function (x) {
    return !!(x && x[this.IMMUTABLE_ITERABLE]);
  },
  isRecord: function (x) {
    return !!(x && x[this.IMMUTABLE_RECORD]);
  },
  isList: function (x) {
    return !!(x && x[this.IMMUTABLE_LIST]);
  },
  isMap: function (x) {
    return !!(x && x[this.IMMUTABLE_MAP]);
  },
  shallowToJS: function (x, whitelist) {
    var _this = this;

    return this.isIterable(x) ? x.reduce(function (prev, curr, key) {
      if (whitelist && whitelist[key]) {
        curr = _this.shallowToJS(curr);
      }

      prev[key] = curr;
      return prev;
    }, this.isList(x) ? [] : {}) : x;
  }
};

function _toConsumableArray$9(arr) { return _arrayWithoutHoles$9(arr) || _iterableToArray$9(arr) || _nonIterableSpread$9(); }

function _nonIterableSpread$9() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$9(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$9(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function parseDatum(datum) {
  var immutableDatumWhitelist = {
    errorX: true,
    errorY: true
  };
  return Immutable.isImmutable(datum) ? Immutable.shallowToJS(datum, immutableDatumWhitelist) : datum;
}

function getLength(data) {
  return Immutable.isIterable(data) ? data.size : data.length;
} // Returns generated data for a given axis based on domain and sample from props


function generateDataArray(props, axis) {
  var propsDomain = isPlainObject_1(props.domain) ? props.domain[axis] : props.domain;
  var domain = propsDomain || Scale.getBaseScale(props, axis).domain();
  var samples = props.samples || 1;
  var domainMax = Math.max.apply(Math, _toConsumableArray$9(domain));
  var domainMin = Math.min.apply(Math, _toConsumableArray$9(domain));
  var step = (domainMax - domainMin) / samples;

  var values = range_1(domainMin, domainMax, step);

  return last_1(values) === domainMax ? values : values.concat(domainMax);
} // Returns sorted data. If no sort keys are provided, data is returned unaltered.


function sortData(dataset, sortKey) {
  var sortOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ascending";

  if (!sortKey) {
    return dataset;
  } // Ensures previous VictoryLine api for sortKey prop stays consistent


  if (sortKey === "x" || sortKey === "y") {
    sortKey = "_".concat(sortKey);
  }

  var order = sortOrder === "ascending" ? "asc" : "desc";
  return orderBy_1(dataset, sortKey, order);
} // This method will remove data points that break certain scales. (log scale only)


function cleanData(dataset, props) {
  var smallNumber = 1 / Number.MAX_SAFE_INTEGER;
  var scaleType = {
    x: Scale.getScaleType(props, "x"),
    y: Scale.getScaleType(props, "y")
  };

  if (scaleType.x !== "log" && scaleType.y !== "log") {
    return dataset;
  }

  var rules = function (datum, axis) {
    return scaleType[axis] === "log" ? datum["_".concat(axis)] !== 0 : true;
  };

  var sanitize = function (datum) {
    var _x = rules(datum, "x") ? datum._x : smallNumber;

    var _y = rules(datum, "y") ? datum._y : smallNumber;

    var _y0 = rules(datum, "y0") ? datum._y0 : smallNumber;

    return assign_1({}, datum, {
      _x: _x,
      _y: _y,
      _y0: _y0
    });
  };

  return dataset.map(function (datum) {
    if (rules(datum, "x") && rules(datum, "y") && rules(datum, "y0")) {
      return datum;
    }

    return sanitize(datum);
  });
} // Returns a data accessor given an eventKey prop


function getEventKey(key) {
  // creates a data accessor function
  // given a property key, path, array index, or null for identity.
  if (isFunction_1(key)) {
    return key;
  } else if (key === null || key === undefined) {
    return function () {
      return undefined;
    };
  } // otherwise, assume it is an array index, property key or path (_.property handles all three)


  return property_1(key);
} // Returns data with an eventKey prop added to each datum


function addEventKeys(props, data) {
  var hasEventKeyAccessor = !!props.eventKey;
  var eventKeyAccessor = getEventKey(props.eventKey);
  return data.map(function (datum, index) {
    if (datum.eventKey !== undefined) {
      return datum;
    } else if (hasEventKeyAccessor) {
      var eventKey = eventKeyAccessor(datum, index);
      return eventKey !== undefined ? assign_1({
        eventKey: eventKey
      }, datum) : datum;
    } else {
      return datum;
    }
  });
} // Exported Functions

/**
 * Returns an object mapping string data to numeric data
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Object} an object mapping string data to numeric data
 */


function createStringMap(props, axis) {
  var stringsFromAxes = getStringsFromAxes(props, axis);
  var stringsFromCategories = getStringsFromCategories(props, axis);
  var stringsFromData = getStringsFromData(props, axis);

  var allStrings = uniq_1(_toConsumableArray$9(stringsFromAxes).concat(_toConsumableArray$9(stringsFromCategories), _toConsumableArray$9(stringsFromData)));

  return allStrings.length === 0 ? null : allStrings.reduce(function (memo, string, index) {
    memo[string] = index + 1;
    return memo;
  }, {});
}
/**
 * Reduces the size of a data array, such that it is <= maxPoints.
 * @param {Array} data: an array of data; must be sorted
 * @param {Number} maxPoints: maximum number of data points to return
 * @param {Number} startingIndex: the index of the data[0] *in the entire dataset*; this function
                   assumes `data` param is a subset of larger dataset that has been zoommed
  * @returns {Array} an array of data, a subset of data param
  */


function downsample(data, maxPoints) {
  var startingIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  // ensures that the downampling of data while zooming looks good.
  var dataLength = getLength(data);

  if (dataLength > maxPoints) {
    // limit k to powers of 2, e.g. 64, 128, 256
    // so that the same points will be chosen reliably, reducing flicker on zoom
    var k = Math.pow(2, Math.ceil(Math.log2(dataLength / maxPoints)));
    return data.filter( // ensure modulo is always calculated from same reference: i + startingIndex
    function (d, i) {
      return (i + startingIndex) % k === 0;
    });
  }

  return data;
}
/**
 * Returns formatted data. Data accessors are applied, and string values are replaced.
 * @param {Array} dataset: the original domain
 * @param {Object} props: the props object
 * @param {Array} expectedKeys: an array of expected data keys
 * @returns {Array} the formatted data
 */


function formatData(dataset, props, expectedKeys) {
  var isArrayOrIterable = Array.isArray(dataset) || Immutable.isIterable(dataset);

  if (!isArrayOrIterable || getLength(dataset) < 1) {
    return [];
  }

  var defaultKeys = ["x", "y", "y0"];
  expectedKeys = Array.isArray(expectedKeys) ? expectedKeys : defaultKeys;

  var createAccessor = function (name) {
    return Helpers.createAccessor(props[name] !== undefined ? props[name] : name);
  };

  var accessor = expectedKeys.reduce(function (memo, type) {
    memo[type] = createAccessor(type);
    return memo;
  }, {});
  var preformattedData = isEqual_1(expectedKeys, defaultKeys) && props.x === "_x" && props.y === "_y" && props.y0 === "_y0";
  var stringMap;

  if (preformattedData === false) {
    // stringMap is not required if the data is preformatted
    stringMap = {
      x: expectedKeys.indexOf("x") !== -1 ? createStringMap(props, "x") : undefined,
      y: expectedKeys.indexOf("y") !== -1 ? createStringMap(props, "y") : undefined,
      y0: expectedKeys.indexOf("y0") !== -1 ? createStringMap(props, "y") : undefined
    };
  }

  var data = preformattedData ? dataset : dataset.reduce(function (dataArr, datum, index) {
    // eslint-disable-line complexity
    datum = parseDatum(datum);
    var fallbackValues = {
      x: index,
      y: datum
    };
    var processedValues = expectedKeys.reduce(function (memo, type) {
      var processedValue = accessor[type](datum);
      var value = processedValue !== undefined ? processedValue : fallbackValues[type];

      if (value !== undefined) {
        if (typeof value === "string" && stringMap[type]) {
          memo["".concat(type, "Name")] = value;
          memo["_".concat(type)] = stringMap[type][value];
        } else {
          memo["_".concat(type)] = value;
        }
      }

      return memo;
    }, {});

    var formattedDatum = assign_1({}, processedValues, datum);

    if (!isEmpty_1(formattedDatum)) {
      dataArr.push(formattedDatum);
    }

    return dataArr;
  }, []);
  var sortedData = sortData(data, props.sortKey, props.sortOrder);
  var cleanedData = cleanData(sortedData, props);
  return addEventKeys(props, cleanedData);
}
/**
 * Returns generated x and y data based on domain and sample from props
 * @param {Object} props: the props object
 * @returns {Array} an array of data
 */


function generateData(props) {
  var xValues = generateDataArray(props, "x");
  var yValues = generateDataArray(props, "y");
  var values = xValues.map(function (x, i) {
    return {
      x: x,
      y: yValues[i]
    };
  });
  return values;
}
/**
 * Returns an array of categories for a given axis
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} an array of categories
 */


function getCategories(props, axis) {
  return props.categories && !Array.isArray(props.categories) ? props.categories[axis] : props.categories;
}
/**
 * Returns an array of formatted data
 * @param {Object} props: the props object
 * @returns {Array} an array of data
 */


function getData(props) {
  return props.data ? formatData(props.data, props) : formatData(generateData(props), props);
}
/**
 * Returns an array of strings from axis tickValues for a given axis
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} an array of strings
 */


function getStringsFromAxes(props, axis) {
  var tickValues = props.tickValues,
      tickFormat = props.tickFormat;
  var tickValueArray;

  if (!tickValues || !Array.isArray(tickValues) && !tickValues[axis]) {
    tickValueArray = tickFormat && Array.isArray(tickFormat) ? tickFormat : [];
  } else {
    tickValueArray = tickValues[axis] || tickValues;
  }

  return tickValueArray.filter(function (val) {
    return typeof val === "string";
  });
}
/**
 * Returns an array of strings from categories for a given axis
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} an array of strings
 */


function getStringsFromCategories(props, axis) {
  if (!props.categories) {
    return [];
  }

  var categories = getCategories(props, axis);
  var categoryStrings = categories && categories.filter(function (val) {
    return typeof val === "string";
  });
  return categoryStrings ? Collection.removeUndefined(categoryStrings) : [];
}
/**
 * Returns an array of strings from data
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} an array of strings
 */


function getStringsFromData(props, axis) {
  var isArrayOrIterable = Array.isArray(props.data) || Immutable.isIterable(props.data);

  if (!isArrayOrIterable) {
    return [];
  }

  var key = props[axis] === undefined ? axis : props[axis];
  var accessor = Helpers.createAccessor(key); // support immutable data

  var data = props.data.reduce(function (memo, d) {
    memo.push(parseDatum(d));
    return memo;
  }, []);
  var sortedData = sortData(data, props.sortKey, props.sortOrder);
  var dataStrings = sortedData.reduce(function (dataArr, datum) {
    datum = parseDatum(datum);
    dataArr.push(accessor(datum));
    return dataArr;
  }, []).filter(function (datum) {
    return typeof datum === "string";
  }); // return a unique set of strings

  return dataStrings.reduce(function (prev, curr) {
    if (curr !== undefined && curr !== null && prev.indexOf(curr) === -1) {
      prev.push(curr);
    }

    return prev;
  }, []);
}
/**
 * Checks whether a given component can be used to calculate data
 * @param {Component} component: a React component instance
 * @returns {Boolean} Returns true if the given component has a role included in the whitelist
 */


function isDataComponent(component) {
  var getRole = function (child) {
    return child && child.type ? child.type.role : "";
  };

  var role = getRole(component);

  if (role === "portal") {
    var children = React__default['default'].Children.toArray(component.props.children);
    role = children.length ? getRole(children[0]) : "";
  }

  var whitelist = ["area", "bar", "boxplot", "candlestick", "errorbar", "group", "histogram", "line", "pie", "scatter", "stack", "voronoi"];
  return includes_1(whitelist, role);
}

var Data = {
  createStringMap: createStringMap,
  downsample: downsample,
  formatData: formatData,
  generateData: generateData,
  getCategories: getCategories,
  getData: getData,
  getStringsFromAxes: getStringsFromAxes,
  getStringsFromCategories: getStringsFromCategories,
  getStringsFromData: getStringsFromData,
  isDataComponent: isDataComponent
};

/* eslint-disable func-style */
var DefaultTransitions = {
  continuousTransitions: function () {
    return {
      onLoad: {
        duration: 2000
      },
      onExit: {
        duration: 500
      },
      onEnter: {
        duration: 500
      }
    };
  },
  continuousPolarTransitions: function () {
    return {
      onLoad: {
        duration: 2000,
        before: function () {
          return {
            _y: 0,
            _y1: 0,
            _y0: 0
          };
        },
        after: function (datum) {
          return {
            _y: datum._y,
            _y1: datum._y1,
            _y0: datum._y0
          };
        }
      },
      onExit: {
        duration: 500,
        before: function (datum, index, data) {
          var adjacent = function (attr) {
            var adj = index === 0 ? data[index + 1] : data[index - 1];
            return adj[attr];
          };

          return {
            _x: adjacent("_x"),
            _y: adjacent("_y"),
            _y0: adjacent("_y0")
          };
        }
      },
      onEnter: {
        duration: 500,
        before: function (datum, index, data) {
          var adjacent = function (attr) {
            var adj = index === 0 ? data[index + 1] : data[index - 1];
            return adj[attr];
          };

          return {
            _x: adjacent("_x"),
            _y: adjacent("_y"),
            _y0: adjacent("_y0")
          };
        },
        after: function (datum) {
          return {
            _x: datum._x,
            _y: datum._y,
            _y1: datum._y1,
            _y0: datum._y0
          };
        }
      }
    };
  },
  discreteTransitions: function () {
    return {
      onLoad: {
        duration: 2000,
        before: function () {
          return {
            opacity: 0
          };
        },
        after: function (datum) {
          return datum;
        }
      },
      onExit: {
        duration: 600,
        before: function () {
          return {
            opacity: 0
          };
        }
      },
      onEnter: {
        duration: 600,
        before: function () {
          return {
            opacity: 0
          };
        },
        after: function (datum) {
          return datum;
        }
      }
    };
  }
};

/** `Object#toString` result references. */
var dateTag$2 = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == dateTag$2;
}

var _baseIsDate = baseIsDate;

/* Node.js helper references. */
var nodeIsDate = _nodeUtil && _nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate$1 = nodeIsDate ? _baseUnary(nodeIsDate) : _baseIsDate;

var isDate_1 = isDate$1;

/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseSortedUniq(array, iteratee) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    if (!index || !eq_1(computed, seen)) {
      var seen = computed;
      result[resIndex++] = value === 0 ? 0 : value;
    }
  }
  return result;
}

var _baseSortedUniq = baseSortedUniq;

/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */
function sortedUniq(array) {
  return (array && array.length)
    ? _baseSortedUniq(array)
    : [];
}

var sortedUniq_1 = sortedUniq;

function _toConsumableArray$a(arr) { return _arrayWithoutHoles$a(arr) || _iterableToArray$a(arr) || _nonIterableSpread$a(); }

function _nonIterableSpread$a() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$a(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$a(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function cleanDomain(domain, props, axis) {
  var scaleType = Scale.getScaleType(props, axis);

  if (scaleType !== "log") {
    return domain;
  }

  var rules = function (dom) {
    var almostZero = dom[0] < 0 || dom[1] < 0 ? -1 / Number.MAX_SAFE_INTEGER : 1 / Number.MAX_SAFE_INTEGER;
    var domainOne = dom[0] === 0 ? almostZero : dom[0];
    var domainTwo = dom[1] === 0 ? almostZero : dom[1];
    return [domainOne, domainTwo];
  };

  return rules(domain);
}

function getDomainPadding(props, axis) {
  var formatPadding = function (padding) {
    return Array.isArray(padding) ? {
      left: padding[0],
      right: padding[1]
    } : {
      left: padding,
      right: padding
    };
  };

  return isPlainObject_1(props.domainPadding) ? formatPadding(props.domainPadding[axis]) : formatPadding(props.domainPadding);
}

function getFlatData(dataset, axis) {
  return flatten_1(dataset).map(function (datum) {
    return datum["_".concat(axis)] && datum["_".concat(axis)][1] !== undefined ? datum["_".concat(axis)][1] : datum["_".concat(axis)];
  });
}

function getExtremeFromData(dataset, axis) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "min";

  var getExtreme = function (arr) {
    return type === "max" ? Math.max.apply(Math, _toConsumableArray$a(arr)) : Math.min.apply(Math, _toConsumableArray$a(arr));
  };

  var initialValue = type === "max" ? -Infinity : Infinity;
  var containsDate = false;

  var result = flatten_1(dataset).reduce(function (memo, datum) {
    var current0 = datum["_".concat(axis, "0")] !== undefined ? datum["_".concat(axis, "0")] : datum["_".concat(axis)];
    var current1 = datum["_".concat(axis, "1")] !== undefined ? datum["_".concat(axis, "1")] : datum["_".concat(axis)];
    var current = getExtreme([current0, current1]);
    containsDate = containsDate || current0 instanceof Date || current1 instanceof Date;
    return getExtreme([memo, current]);
  }, initialValue);

  return containsDate ? new Date(result) : result;
} //eslint-disable-next-line max-statements


function padDomain(domain, props, axis) {
  if (!props.domainPadding) {
    return domain;
  }

  var minDomain = getMinFromProps(props, axis);
  var maxDomain = getMaxFromProps(props, axis);
  var padding = getDomainPadding(props, axis);

  if (!padding.left && !padding.right) {
    return domain;
  }

  var min = Collection.getMinValue(domain);
  var max = Collection.getMaxValue(domain);
  var currentAxis = Helpers.getCurrentAxis(axis, props.horizontal);
  var range = Helpers.getRange(props, currentAxis);
  var rangeExtent = Math.abs(range[0] - range[1]); // Naive initial padding calculation

  var initialPadding = {
    left: Math.abs(max - min) * padding.left / rangeExtent,
    right: Math.abs(max - min) * padding.right / rangeExtent
  };
  var singleQuadrantDomainPadding = isPlainObject_1(props.singleQuadrantDomainPadding) ? props.singleQuadrantDomainPadding[axis] : props.singleQuadrantDomainPadding;

  var adjust = function (val, type) {
    if (singleQuadrantDomainPadding === false) {
      return val;
    }

    var coerce = type === "min" && min >= 0 && val <= 0 || type === "max" && max <= 0 && val >= 0;
    return coerce ? 0 : val;
  }; // Adjust the domain by the initial padding


  var adjustedDomain = {
    min: adjust(min.valueOf() - initialPadding.left, "min"),
    max: adjust(max.valueOf() + initialPadding.right, "max")
  }; // re-calculate padding, taking the adjusted domain into account

  var finalPadding = {
    left: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding.left / rangeExtent,
    right: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding.right / rangeExtent
  }; // Adjust the domain by the final padding

  var paddedDomain = {
    min: adjust(min.valueOf() - finalPadding.left, "min"),
    max: adjust(max.valueOf() + finalPadding.right, "max")
  }; // default to minDomain / maxDomain if they exist

  var finalDomain = {
    min: minDomain !== undefined ? minDomain : paddedDomain.min,
    max: maxDomain !== undefined ? maxDomain : paddedDomain.max
  };
  return min instanceof Date || max instanceof Date ? getDomainFromMinMax(new Date(finalDomain.min), new Date(finalDomain.max)) : getDomainFromMinMax(finalDomain.min, finalDomain.max);
} // Public Methods

/**
 * Returns a getDomain function
 * @param {Function} getDomainFromDataFunction: a function that takes props and axis and
 * returns a domain based on data
 * @param {Function} formatDomainFunction: a function that takes domain, props, and axis and
 * returns a formatted domain
 * @returns {Function} a function that takes props and axis and returns a formatted domain
 */


function createDomainFunction(getDomainFromDataFunction, formatDomainFunction) {
  getDomainFromDataFunction = isFunction_1(getDomainFromDataFunction) ? getDomainFromDataFunction : getDomainFromData;
  formatDomainFunction = isFunction_1(formatDomainFunction) ? formatDomainFunction : formatDomain;
  return function (props, axis) {
    var propsDomain = getDomainFromProps(props, axis);

    if (propsDomain) {
      return formatDomainFunction(propsDomain, props, axis);
    }

    var categories = Data.getCategories(props, axis);
    var domain = categories ? getDomainFromCategories(props, axis, categories) : getDomainFromDataFunction(props, axis);
    return domain ? formatDomainFunction(domain, props, axis) : undefined;
  };
}
/**
 * Returns a formatted domain.
 * @param {Array} domain: a domain in the form of a two element array
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} a domain in the form of a two element array
 */


function formatDomain(domain, props, axis) {
  return cleanDomain(padDomain(domain, props, axis), props, axis);
}
/**
 * Returns a domain for a given axis based on props, category, or data
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} the domain for the given axis
 */


function getDomain(props, axis) {
  return createDomainFunction()(props, axis);
}
/**
 * Returns a domain based on categories if they exist
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @param {Array} categories: an array of categories corresponding to a given axis
 * @returns {Array|undefined} returns a domain from categories or undefined
 */


function getDomainFromCategories(props, axis, categories) {
  categories = categories || Data.getCategories(props, axis);
  var polar = props.polar,
      _props$startAngle = props.startAngle,
      startAngle = _props$startAngle === void 0 ? 0 : _props$startAngle,
      _props$endAngle = props.endAngle,
      endAngle = _props$endAngle === void 0 ? 360 : _props$endAngle;

  if (!categories) {
    return undefined;
  }

  var minDomain = getMinFromProps(props, axis);
  var maxDomain = getMaxFromProps(props, axis);
  var stringArray = Collection.containsStrings(categories) ? Data.getStringsFromCategories(props, axis) : [];
  var stringMap = stringArray.length === 0 ? null : stringArray.reduce(function (memo, string, index) {
    memo[string] = index + 1;
    return memo;
  }, {});
  var categoryValues = stringMap ? categories.map(function (value) {
    return stringMap[value];
  }) : categories;
  var min = minDomain !== undefined ? minDomain : Collection.getMinValue(categoryValues);
  var max = maxDomain !== undefined ? maxDomain : Collection.getMaxValue(categoryValues);
  var categoryDomain = getDomainFromMinMax(min, max);
  return polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? getSymmetricDomain(categoryDomain, categoryValues) : categoryDomain;
}
/**
 * Returns a domain from a dataset for a given axis
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @param {Array} dataset: an array of data
 * @returns {Array} the domain based on data
 */


function getDomainFromData(props, axis, dataset) {
  dataset = dataset || Data.getData(props);
  var polar = props.polar,
      _props$startAngle2 = props.startAngle,
      startAngle = _props$startAngle2 === void 0 ? 0 : _props$startAngle2,
      _props$endAngle2 = props.endAngle,
      endAngle = _props$endAngle2 === void 0 ? 360 : _props$endAngle2;
  var minDomain = getMinFromProps(props, axis);
  var maxDomain = getMaxFromProps(props, axis);

  if (dataset.length < 1) {
    return minDomain !== undefined && maxDomain !== undefined ? getDomainFromMinMax(minDomain, maxDomain) : undefined;
  }

  var min = minDomain !== undefined ? minDomain : getExtremeFromData(dataset, axis, "min");
  var max = maxDomain !== undefined ? maxDomain : getExtremeFromData(dataset, axis, "max");
  var domain = getDomainFromMinMax(min, max);
  return polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? getSymmetricDomain(domain, getFlatData(dataset, axis)) : domain;
}
/**
 * Returns a domain in the form of a two element array given a min and max value.
 * @param {Number|Date} min: the props object
 * @param {Number|Date} max: the current axis
 * @returns {Array} the minDomain based on props
 */


function getDomainFromMinMax(min, max) {
  var getSinglePointDomain = function (val) {
    // d3-scale does not properly resolve very small differences.
    // eslint-disable-next-line no-magic-numbers
    var verySmallNumber = val === 0 ? 2 * Math.pow(10, -10) : Math.pow(10, -10);
    var verySmallDate = 1;
    var minVal = val instanceof Date ? new Date(+val - verySmallDate) : +val - verySmallNumber;
    var maxVal = val instanceof Date ? new Date(+val + verySmallDate) : +val + verySmallNumber;
    return val === 0 ? [0, maxVal] : [minVal, maxVal];
  };

  return +min === +max ? getSinglePointDomain(max) : [min, max];
}
/**
 * Returns a the domain for a given axis if domain is given in props
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array|undefined} the domain based on props
 */


function getDomainFromProps(props, axis) {
  var minDomain = getMinFromProps(props, axis);
  var maxDomain = getMaxFromProps(props, axis);

  if (isPlainObject_1(props.domain) && props.domain[axis]) {
    return props.domain[axis];
  } else if (Array.isArray(props.domain)) {
    return props.domain;
  } else if (minDomain !== undefined && maxDomain !== undefined) {
    return getDomainFromMinMax(minDomain, maxDomain);
  }

  return undefined;
}
/**
 * Returns a domain for a given axis. This method forces the domain to include
 * zero unless the domain is explicitly specified in props.
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} the domain for the given axis
 */


function getDomainWithZero(props, axis) {
  var propsDomain = getDomainFromProps(props, axis);

  if (propsDomain) {
    return propsDomain;
  }

  var dataset = Data.getData(props);
  var y0Min = dataset.reduce(function (min, datum) {
    return datum._y0 < min ? datum._y0 : min;
  }, Infinity);

  var ensureZero = function (domain) {
    if (axis === "x") {
      return domain;
    }

    var defaultMin = y0Min !== Infinity ? y0Min : 0;
    var maxDomainProp = getMaxFromProps(props, axis);
    var minDomainProp = getMinFromProps(props, axis);
    var max = maxDomainProp !== undefined ? maxDomainProp : Collection.getMaxValue(domain, defaultMin);
    var min = minDomainProp !== undefined ? minDomainProp : Collection.getMinValue(domain, defaultMin);
    return getDomainFromMinMax(min, max);
  };

  var getDomainFunction = function () {
    return getDomainFromData(props, axis, dataset);
  };

  var formatDomainFunction = function (domain) {
    return formatDomain(ensureZero(domain), props, axis);
  };

  return createDomainFunction(getDomainFunction, formatDomainFunction)(props, axis);
}
/**
 * Returns the maxDomain from props if it exists
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Number|Date|undefined} the maxDomain based on props
 */


function getMaxFromProps(props, axis) {
  if (isPlainObject_1(props.maxDomain) && props.maxDomain[axis] !== undefined) {
    return props.maxDomain[axis];
  }

  return typeof props.maxDomain === "number" || isDate_1(props.maxDomain) ? props.maxDomain : undefined;
}
/**
 * Returns the minDomain from props if it exists
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Number|Date|undefined} the minDomain based on props
 */


function getMinFromProps(props, axis) {
  if (isPlainObject_1(props.minDomain) && props.minDomain[axis] !== undefined) {
    return props.minDomain[axis];
  }

  return typeof props.minDomain === "number" || isDate_1(props.minDomain) ? props.minDomain : undefined;
}
/**
 * Returns a symmetrically padded domain for polar charts
 * @param {Array} domain: the original domain
 * @param {Array} values: a flat array of values corresponding to either tickValues, or data values
 * for a given dimension i.e. only x values.
 * @returns {Array} the symmetric domain
 */


function getSymmetricDomain(domain, values) {
  var processedData = sortedUniq_1(values.sort(function (a, b) {
    return a - b;
  }));

  var step = processedData[1] - processedData[0];
  return [domain[0], domain[1] + step];
}
/**
 * Checks whether a given component can be used to calculate domain
 * @param {Component} component: a React component instance
 * @returns {Boolean} Returns true if the given component has a role included in the whitelist
 */


function isDomainComponent(component) {
  var getRole = function (child) {
    return child && child.type ? child.type.role : "";
  };

  var role = getRole(component);

  if (role === "portal") {
    var children = React__default['default'].Children.toArray(component.props.children);
    role = children.length ? getRole(children[0]) : "";
  }

  var whitelist = ["area", "axis", "bar", "boxplot", "candlestick", "errorbar", "group", "histogram", "line", "pie", "scatter", "stack", "voronoi"];
  return includes_1(whitelist, role);
}

var Domain = {
  createDomainFunction: createDomainFunction,
  formatDomain: formatDomain,
  getDomain: getDomain,
  getDomainFromCategories: getDomainFromCategories,
  getDomainFromData: getDomainFromData,
  getDomainFromMinMax: getDomainFromMinMax,
  getDomainFromProps: getDomainFromProps,
  getDomainWithZero: getDomainWithZero,
  getMaxFromProps: getMaxFromProps,
  getMinFromProps: getMinFromProps,
  getSymmetricDomain: getSymmetricDomain,
  isDomainComponent: isDomainComponent
};

/* eslint-disable func-style */

function transformTarget(target, matrix, dimension) {
  var a = matrix.a,
      d = matrix.d,
      e = matrix.e,
      f = matrix.f;
  return dimension === "y" ? d * target + f : a * target + e;
}

function getTransformationMatrix(svg) {
  return svg.getScreenCTM().inverse();
} // Exported Functions


function getParentSVG(evt) {
  if (evt.nativeEvent && evt.nativeEvent.identifier !== undefined) {
    return undefined;
  }

  var getParent = function (target) {
    if (target.nodeName === "svg") {
      return target;
    } else {
      return target.parentNode ? getParent(target.parentNode) : target;
    }
  };

  return getParent(evt.target);
}

function getSVGEventCoordinates(evt, svg) {
  if (evt.nativeEvent && evt.nativeEvent.identifier !== undefined) {
    // react-native override. relies on the RN.View being the _exact_ same size as its child SVG.
    // this should be fine: the svg is the only child of View and the View shirks to its children
    return {
      x: evt.nativeEvent.locationX,
      y: evt.nativeEvent.locationY
    };
  }

  evt = evt.changedTouches && evt.changedTouches.length ? evt.changedTouches[0] : evt;
  svg = svg || getParentSVG(evt);
  var matrix = getTransformationMatrix(svg);
  return {
    x: transformTarget(evt.clientX, matrix, "x"),
    y: transformTarget(evt.clientY, matrix, "y")
  };
}

function getDomainCoordinates(props, domain) {
  var scale = props.scale,
      horizontal = props.horizontal;
  domain = domain || {
    x: scale.x.domain(),
    y: scale.y.domain()
  };
  return {
    x: horizontal ? [scale.y(domain.y[0]), scale.y(domain.y[1])] : [scale.x(domain.x[0]), scale.x(domain.x[1])],
    y: horizontal ? [scale.x(domain.x[0]), scale.x(domain.x[1])] : [scale.y(domain.y[0]), scale.y(domain.y[1])]
  };
} // eslint-disable-next-line max-params


function getDataCoordinates(props, scale, x, y) {
  var polar = props.polar,
      horizontal = props.horizontal;

  if (!polar) {
    return {
      x: horizontal ? scale.x.invert(y) : scale.x.invert(x),
      y: horizontal ? scale.y.invert(x) : scale.y.invert(y)
    };
  } else {
    var origin = props.origin || {
      x: 0,
      y: 0
    };
    var baseX = x - origin.x;
    var baseY = y - origin.y;
    var radius = Math.abs(baseX * Math.sqrt(1 + Math.pow(-baseY / baseX, 2)));
    var angle = (-Math.atan2(baseY, baseX) + Math.PI * 2) % (Math.PI * 2);
    return {
      x: scale.x.invert(angle),
      y: scale.y.invert(radius)
    };
  }
}

function getBounds(props) {
  var x1 = props.x1,
      x2 = props.x2,
      y1 = props.y1,
      y2 = props.y2,
      scale = props.scale;
  var point1 = getDataCoordinates(props, scale, x1, y1);
  var point2 = getDataCoordinates(props, scale, x2, y2);

  var makeBound = function (a, b) {
    return [Collection.getMinValue([a, b]), Collection.getMaxValue([a, b])];
  };

  return {
    x: makeBound(point1.x, point2.x),
    y: makeBound(point1.y, point2.y)
  };
}

var Selection = {
  getParentSVG: getParentSVG,
  getSVGEventCoordinates: getSVGEventCoordinates,
  getDomainCoordinates: getDomainCoordinates,
  getDataCoordinates: getDataCoordinates,
  getBounds: getBounds
};

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? _baseUniq(array, _baseIteratee(iteratee)) : [];
}

var uniqBy_1 = uniqBy;

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

var _arrayAggregator = arrayAggregator;

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  _baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

var _baseAggregator = baseAggregator;

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray_1(collection) ? _arrayAggregator : _baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, _baseIteratee(iteratee), accumulator);
  };
}

var _createAggregator = createAggregator;

/** Used for built-in method references. */
var objectProto$j = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$g = objectProto$j.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = _createAggregator(function(result, value, key) {
  if (hasOwnProperty$g.call(result, key)) {
    result[key].push(value);
  } else {
    _baseAssignValue(result, key, [value]);
  }
});

var groupBy_1 = groupBy;

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  _baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

var _baseSome = baseSome;

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some$1(collection, predicate, guard) {
  var func = isArray_1(collection) ? _arraySome : _baseSome;
  if (guard && _isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, _baseIteratee(predicate));
}

var some_1 = some$1;

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  _baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

var _baseInverter = baseInverter;

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return _baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

var _createInverter = createInverter;

/** Used for built-in method references. */
var objectProto$k = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$k.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = _createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString$2.call(value);
  }

  result[value] = key;
}, constant_1(identity_1));

var invert_1 = invert;

function _toConsumableArray$b(arr) { return _arrayWithoutHoles$b(arr) || _iterableToArray$b(arr) || _nonIterableSpread$b(); }

function _nonIterableSpread$b() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$b(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$b(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
/**
 * Returns the axis (x or y) of a particular axis component
 * @param {Object} props: the props object.
 * @param {Boolean} horizontal: true for horizontal charts
 * @returns {String} the dimension appropriate for the axis given its props
 */

function getAxis(props) {
  var dependentAxis = props.dependentAxis;
  return dependentAxis ? "y" : "x";
}
/**
 * Returns all axis components that pass a given predicate
 * @param {Array} childComponents: an array of children
 * @param {Function} predicate: a predicate function that will be called with each
 * @returns {Array} all axis components that pass the given predicate or []
 */


function findAxisComponents(childComponents, predicate) {
  predicate = predicate || identity_1;

  var findAxes = function (children) {
    return children.reduce(function (memo, child) {
      if (child.type && child.type.role === "axis" && predicate(child)) {
        return memo.concat(child);
      } else if (child.props && child.props.children) {
        return memo.concat(findAxes(React__default['default'].Children.toArray(child.props.children)));
      }

      return memo;
    }, []);
  };

  return findAxes(childComponents);
}
/**
 * Returns a single axis component of the desired axis type (x or y)
 * @param {Array} childComponents: an array of children
 * @param {String} axis: desired axis either "x" or "y".
 * @returns {ReactComponent} an axis component of the desired axis or undefined
 */


function getAxisComponent(childComponents, axis) {
  var matchesAxis = function (component) {
    var type = component.type.getAxis(component.props);
    return type === axis;
  };

  return findAxisComponents(childComponents, matchesAxis)[0];
}
/**
 * Returns all axis components of the desired axis type (x or y) along with any
 * parent components excluding VictoryChart
 * @param {Array} childComponents: an optional array of children.
 * @param {String} type: desired axis either "dependent" or "independent".
 * @returns {ReactComponent} an axis component of the desired type or undefined
 */


function getAxisComponentsWithParent(childComponents, type) {
  var matchesType = function (child) {
    return type === "dependent" ? child.props.dependentAxis : !child.props.dependentAxis;
  };

  var findComponents = function (children) {
    return children.reduce(function (memo, child) {
      if (child.type && child.type.role === "axis" && matchesType(child)) {
        return memo.concat(child);
      } else if (child.props && child.props.children) {
        var childAxis = findComponents(React__default['default'].Children.toArray(child.props.children));
        return childAxis.length > 0 ? memo.concat(child) : memo;
      }

      return memo;
    }, []);
  };

  return findComponents(childComponents);
}

function getOrigin$1(domain) {
  var getSingleOrigin = function (d) {
    var domainMin = Math.min.apply(Math, _toConsumableArray$b(d));
    var domainMax = Math.max.apply(Math, _toConsumableArray$b(d));
    return domainMax < 0 ? domainMax : Math.max(0, domainMin);
  };

  return {
    x: Collection.containsDates(domain.x) ? new Date(Math.min.apply(Math, _toConsumableArray$b(domain.x))) : getSingleOrigin(domain.x),
    y: Collection.containsDates(domain.y) ? new Date(Math.min.apply(Math, _toConsumableArray$b(domain.y))) : getSingleOrigin(domain.y)
  };
}

function getOriginSign(origin, domain) {
  var getSign = function () {
    return origin <= 0 && Math.max.apply(Math, _toConsumableArray$b(domain)) <= 0 ? "negative" : "positive";
  };

  return Collection.containsDates(domain) ? "positive" : getSign();
}
/**
 * @param {Object} props: axis component props
 * @returns {Boolean} true when the axis is vertical
 */


function isVertical(props) {
  var orientation = props.orientation || (props.dependentAxis ? "left" : "bottom");
  var vertical = {
    top: false,
    bottom: false,
    left: true,
    right: true
  };
  return vertical[orientation];
}
/**
 * @param {Object} props: axis component props
 * @returns {Boolean} true when tickValues contain strings
 */


function stringTicks(props) {
  return props.tickValues !== undefined && Collection.containsStrings(props.tickValues);
}

function getDefaultTickFormat(props) {
  var tickValues = props.tickValues;
  var axis = getAxis(props);
  var stringMap = props.stringMap && props.stringMap[axis];
  var fallbackFormat = tickValues && !Collection.containsDates(tickValues) ? function (x) {
    return x;
  } : undefined;

  if (!stringMap) {
    return stringTicks(props) ? function (x, index) {
      return tickValues[index];
    } : fallbackFormat;
  } else {
    var invertedStringMap = stringMap && invert_1(stringMap);

    var tickValueArray = orderBy_1(values_1(stringMap), function (n) {
      return n;
    });

    var dataNames = tickValueArray.map(function (tick) {
      return invertedStringMap[tick];
    }); // string ticks should have one tick of padding at the beginning

    var dataTicks = [""].concat(_toConsumableArray$b(dataNames), [""]);
    return function (x) {
      return dataTicks[x];
    };
  }
}

function getTickFormat(props, scale) {
  var tickFormat = props.tickFormat;
  var axis = getAxis(props);
  var stringMap = props.stringMap && props.stringMap[axis];

  if (!tickFormat) {
    var defaultTickFormat = getDefaultTickFormat(props);
    var scaleTickFormat = scale.tickFormat && isFunction_1(scale.tickFormat) ? scale.tickFormat() : function (x) {
      return x;
    };
    return defaultTickFormat || scaleTickFormat;
  } else if (tickFormat && Array.isArray(tickFormat)) {
    return function (x, index) {
      return tickFormat[index];
    };
  } else if (tickFormat && isFunction_1(tickFormat)) {
    var applyStringTicks = function (tick, index, ticks) {
      var invertedStringMap = invert_1(stringMap);

      var stringTickArray = ticks.map(function (t) {
        return invertedStringMap[t];
      });
      return props.tickFormat(invertedStringMap[tick], index, stringTickArray);
    };

    return stringMap ? applyStringTicks : tickFormat;
  } else {
    return function (x) {
      return x;
    };
  }
}

function getStringTicks(props) {
  var axis = getAxis(props);
  var stringMap = props.stringMap && props.stringMap[axis];
  var categories = Array.isArray(props.categories) ? props.categories : props.categories && props.categories[axis];
  var ticksFromCategories = categories && Collection.containsOnlyStrings(categories) ? categories.map(function (tick) {
    return stringMap[tick];
  }) : undefined;

  var ticksFromStringMap = stringMap && values_1(stringMap);

  return ticksFromCategories && ticksFromCategories.length !== 0 ? ticksFromCategories : ticksFromStringMap;
}

function getTickArray(props) {
  var tickValues = props.tickValues,
      tickFormat = props.tickFormat;
  var axis = getAxis(props);
  var stringMap = props.stringMap && props.stringMap[axis];

  var getTicksFromFormat = function () {
    if (!tickFormat || !Array.isArray(tickFormat)) {
      return undefined;
    }

    return Collection.containsStrings(tickFormat) ? tickFormat.map(function (t, i) {
      return i;
    }) : tickFormat;
  };

  var ticks = tickValues;

  if (stringMap) {
    ticks = getStringTicks(props);
  }

  if (tickValues && Collection.containsStrings(tickValues)) {
    ticks = stringMap ? tickValues.map(function (tick) {
      return stringMap[tick];
    }) : range_1(1, tickValues.length + 1);
  }

  var tickArray = ticks ? uniq_1(ticks) : getTicksFromFormat();

  var filterArray = function (arr) {
    var domain = props.domain && props.domain[axis] || props.domain;
    return Array.isArray(domain) ? arr.filter(function (t) {
      return t >= Math.min.apply(Math, _toConsumableArray$b(domain)) && t <= Math.max.apply(Math, _toConsumableArray$b(domain));
    }) : arr;
  };

  return Array.isArray(tickArray) && tickArray.length ? filterArray(tickArray) : undefined;
}

function downsampleTicks(ticks, tickCount) {
  if (!tickCount || !Array.isArray(ticks) || ticks.length <= tickCount) {
    return ticks;
  }

  var k = Math.floor(ticks.length / tickCount);
  return ticks.filter(function (d, i) {
    return i % k === 0;
  });
}

function getTicks(props, scale, filterZero) {
  var tickCount = props.tickCount;
  var tickValues = getTickArray(props);

  if (tickValues) {
    return downsampleTicks(tickValues, tickCount);
  } else if (scale.ticks && isFunction_1(scale.ticks)) {
    // eslint-disable-next-line no-magic-numbers
    var defaultTickCount = tickCount || 5;
    var scaleTicks = scale.ticks(defaultTickCount);
    var tickArray = Array.isArray(scaleTicks) && scaleTicks.length ? scaleTicks : scale.domain();
    var ticks = downsampleTicks(tickArray, tickCount);

    if (filterZero) {
      var filteredTicks = includes_1(ticks, 0) ? without_1(ticks, 0) : ticks;
      return filteredTicks.length ? filteredTicks : ticks;
    }

    return ticks;
  }

  return scale.domain();
}
/**
 * Returns a domain based tickValues
 * @param {Object} props: the props object
 * @param {String} axis: either x or y
 * @returns {Array} returns a domain from tickValues
 */
//eslint-disable-next-line max-statements


function getDomainFromData$1(props, axis) {
  var polar = props.polar,
      _props$startAngle = props.startAngle,
      startAngle = _props$startAngle === void 0 ? 0 : _props$startAngle,
      _props$endAngle = props.endAngle,
      endAngle = _props$endAngle === void 0 ? 360 : _props$endAngle;
  var tickValues = getTickArray(props);

  if (!Array.isArray(tickValues)) {
    return undefined;
  }

  var minDomain = Domain.getMinFromProps(props, axis);
  var maxDomain = Domain.getMaxFromProps(props, axis);
  var tickStrings = stringTicks(props);
  var ticks = tickValues.map(function (value) {
    return +value;
  });
  var defaultMin = tickStrings ? 1 : Collection.getMinValue(ticks);
  var defaultMax = tickStrings ? tickValues.length : Collection.getMaxValue(ticks);
  var min = minDomain !== undefined ? minDomain : defaultMin;
  var max = maxDomain !== undefined ? maxDomain : defaultMax;
  var initialDomain = Domain.getDomainFromMinMax(min, max);
  var domain = polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? Domain.getSymmetricDomain(initialDomain, ticks) : initialDomain;

  if (isVertical(props) && !polar) {
    domain.reverse();
  }

  return domain;
} // exposed for use by VictoryChart


function getDomain$1(props, axis) {
  var inherentAxis = getAxis(props);

  if (axis && axis !== inherentAxis) {
    return undefined;
  }

  return Domain.createDomainFunction(getDomainFromData$1)(props, inherentAxis);
}

function getAxisValue(props, axis) {
  if (!props.axisValue) {
    return undefined;
  }

  var scaleAxis = axis === "x" ? "y" : "x";
  var scale = isObject_1(props.scale) && isFunction_1(props.scale[scaleAxis]) ? props.scale[scaleAxis] : undefined;

  if (!scale) {
    return undefined;
  }

  var stringMapAxis = axis === "x" ? "y" : "x";
  var stringMap = isObject_1(props.stringMap) && props.stringMap[stringMapAxis];
  var axisValue = stringMap && typeof props.axisValue === "string" ? stringMap[props.axisValue] : props.axisValue;
  return scale(axisValue);
}

function modifyProps$1(props, fallbackProps) {
  if (!isObject_1(props.theme)) {
    return Helpers.modifyProps(props, fallbackProps, "axis");
  }

  var role = "axis";

  if (props.dependentAxis && props.theme.dependentAxis) {
    role = "dependentAxis";
  } else if (!props.dependentAxis && props.theme.independentAxis) {
    role = "independentAxis";
  }

  if (role === "axis") {
    return Helpers.modifyProps(props, fallbackProps, "axis");
  }

  var axisTheme = defaults_1({}, props.theme[role], props.theme.axis);

  var theme = assign_1({}, props.theme, {
    axis: axisTheme
  });

  return Helpers.modifyProps(assign_1({}, props, {
    theme: theme
  }), fallbackProps, "axis");
}

var Axis = {
  getTicks: getTicks,
  getTickFormat: getTickFormat,
  getAxis: getAxis,
  getAxisComponent: getAxisComponent,
  getAxisComponentsWithParent: getAxisComponentsWithParent,
  getAxisValue: getAxisValue,
  findAxisComponents: findAxisComponents,
  getOrigin: getOrigin$1,
  getOriginSign: getOriginSign,
  getDomain: getDomain$1,
  isVertical: isVertical,
  modifyProps: modifyProps$1,
  stringTicks: stringTicks
};

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } return target; }

function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray$c(arr) { return _arrayWithoutHoles$c(arr) || _iterableToArray$c(arr) || _nonIterableSpread$c(); }

function _nonIterableSpread$c() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$c(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$c(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
var Wrapper$b = {
  getData: function (props, childComponents) {
    if (props.data) {
      return Data.getData(props);
    }

    childComponents = childComponents || React__default['default'].Children.toArray(props.children);
    return this.getDataFromChildren(childComponents);
  },
  getDefaultDomainPadding: function (props, axis, childComponents) {
    if (props.polar || axis !== "x") {
      return undefined;
    }

    var groupComponent = childComponents.filter(function (child) {
      return child.type && child.type.role && child.type.role === "group";
    });

    if (groupComponent.length < 1) {
      return undefined;
    }

    var _groupComponent$0$pro = groupComponent[0].props,
        offset = _groupComponent$0$pro.offset,
        children = _groupComponent$0$pro.children;
    return {
      x: offset * children.length / 2
    };
  },
  getDomain: function (props, axis, childComponents) {
    childComponents = childComponents || React__default['default'].Children.toArray(props.children);
    var propsDomain = Domain.getDomainFromProps(props, axis);
    var domainPadding = this.getDefaultDomainPadding(props, axis, childComponents);
    var domain;

    if (propsDomain) {
      domain = propsDomain;
    } else {
      var minDomain = Domain.getMinFromProps(props, axis);
      var maxDomain = Domain.getMaxFromProps(props, axis);
      var dataset = (props.data || props.y) && Data.getData(props);
      var dataDomain = dataset ? Domain.getDomainFromData(props, axis, dataset) : [];
      var childDomain = this.getDomainFromChildren(props, axis, childComponents);
      var min = minDomain || Collection.getMinValue(_toConsumableArray$c(dataDomain).concat(_toConsumableArray$c(childDomain)));
      var max = maxDomain || Collection.getMaxValue(_toConsumableArray$c(dataDomain).concat(_toConsumableArray$c(childDomain)));
      domain = Domain.getDomainFromMinMax(min, max);
    }

    return Domain.formatDomain(domain, assign_1({
      domainPadding: domainPadding
    }, props), axis);
  },
  getScale: function (props, axis, childComponents) {
    if (props.data) {
      return Scale.getBaseScale(props, axis);
    }

    var children = childComponents ? childComponents.slice(0) : React__default['default'].Children.toArray(props.children);

    var iteratee = function (child) {
      var sharedProps = assign_1({}, child.props, {
        horizontal: props.horizontal
      });

      return Scale.getScaleType(sharedProps, axis);
    };

    var childScale = uniq_1(Helpers.reduceChildren(children, iteratee, props)); // default to linear scale if more than one uniq scale type is given by children


    return childScale.length > 1 ? Scale.getScaleFromName("linear") : Scale.getScaleFromName(childScale[0]);
  },
  setAnimationState: function (props, nextProps) {
    if (!props.animate) {
      return;
    }

    if (props.animate.parentState) {
      var nodesWillExit = props.animate.parentState.nodesWillExit;
      var oldProps = nodesWillExit ? props : null;
      this.setState(defaults_1({
        oldProps: oldProps,
        nextProps: nextProps
      }, props.animate.parentState));
    } else {
      var oldChildren = React__default['default'].Children.toArray(props.children);
      var nextChildren = React__default['default'].Children.toArray(nextProps.children);

      var isContinuous = function (child) {
        var check = function (c) {
          return c.type && c.type.continuous;
        };

        return Array.isArray(child) ? some_1(child, check) : check(child);
      };

      var continuous = !props.polar && some_1(oldChildren, function (child) {
        return isContinuous(child) || child.props.children && isContinuous(child.props.children);
      });

      var _Transitions$getIniti = Transitions.getInitialTransitionState(oldChildren, nextChildren),
          _nodesWillExit = _Transitions$getIniti.nodesWillExit,
          nodesWillEnter = _Transitions$getIniti.nodesWillEnter,
          childrenTransitions = _Transitions$getIniti.childrenTransitions,
          nodesShouldEnter = _Transitions$getIniti.nodesShouldEnter;

      this.setState({
        nodesWillExit: _nodesWillExit,
        nodesWillEnter: nodesWillEnter,
        nodesShouldEnter: nodesShouldEnter,
        childrenTransitions: Collection.isArrayOfArrays(childrenTransitions) ? childrenTransitions[0] : childrenTransitions,
        oldProps: _nodesWillExit ? props : null,
        nextProps: nextProps,
        continuous: continuous
      });
    }
  },
  getAllEvents: function (props) {
    var components = ["groupComponent", "containerComponent", "labelComponent"];
    this.componentEvents = Events.getComponentEvents(props, components);
    var events = props.events;

    if (Array.isArray(this.componentEvents)) {
      var _componentEvents;

      events = Array.isArray(props.events) ? (_componentEvents = this.componentEvents).concat.apply(_componentEvents, _toConsumableArray$c(props.events)) : this.componentEvents;
    }

    return events || [];
  },
  getAnimationProps: function (props, child, index) {
    var _this = this;

    if (!props.animate) {
      return child.props.animate;
    }

    var getFilteredState = function () {
      var childrenTransitions = _this.state && _this.state.childrenTransitions;
      childrenTransitions = Collection.isArrayOfArrays(childrenTransitions) ? childrenTransitions[index] : childrenTransitions;
      return defaults_1({
        childrenTransitions: childrenTransitions
      }, _this.state);
    };

    var getTransitions = props.animate && props.animate.getTransitions;
    var state = getFilteredState();
    var parentState = props.animate && props.animate.parentState || state;

    if (!getTransitions) {
      var getTransitionProps = Transitions.getTransitionPropsFactory(props, state, function (newState) {
        return _this.setState(newState);
      });

      getTransitions = function (childComponent) {
        return getTransitionProps(childComponent, index);
      };
    }

    return defaults_1({
      getTransitions: getTransitions,
      parentState: parentState
    }, props.animate, child.props.animate);
  },
  getDomainFromChildren: function (props, axis, childComponents) {
    // eslint-disable-line max-statements, complexity, max-len
    var children = childComponents ? childComponents.slice(0) : React__default['default'].Children.toArray(props.children);
    var parentData = props.data ? Data.getData(props, axis) : undefined;
    var polar = props.polar,
        startAngle = props.startAngle,
        endAngle = props.endAngle,
        categories = props.categories,
        minDomain = props.minDomain,
        maxDomain = props.maxDomain,
        horizontal = props.horizontal;
    var baseParentProps = {
      horizontal: horizontal,
      polar: polar,
      startAngle: startAngle,
      endAngle: endAngle,
      minDomain: minDomain,
      maxDomain: maxDomain,
      categories: categories
    };
    var parentProps = parentData ? assign_1(baseParentProps, {
      data: parentData
    }) : baseParentProps;

    var iteratee = function (child) {
      var sharedProps = assign_1({}, child.props, parentProps);

      if (!Domain.isDomainComponent(child)) {
        return null;
      } else if (child.type && isFunction_1(child.type.getDomain)) {
        return child.props && child.type.getDomain(sharedProps, axis);
      } else {
        return Domain.getDomain(sharedProps, axis);
      }
    };

    var childDomains = Helpers.reduceChildren(children, iteratee, props);
    var min = childDomains.length === 0 ? 0 : Collection.getMinValue(childDomains);
    var max = childDomains.length === 0 ? 1 : Collection.getMaxValue(childDomains);
    return [min, max];
  },
  addBinsToParentPropsIfHistogram: function (_ref) {
    var children = _ref.children,
        props = _ref.props,
        childComponents = _ref.childComponents,
        parentProps = _ref.parentProps;
    var someChildrenAreHistograms = children.some(function (child) {
      return child.type && child.type.role === "histogram";
    });
    var allChildrenAreHistograms = someChildrenAreHistograms && children.length && children.every(function (child) {
      return child.type && child.type.role === "histogram";
    });

    if (someChildrenAreHistograms && !allChildrenAreHistograms) {
      Log.warn("VictoryHistogram only supports being stacked with other VictoryHistogram components. Check to make sure that you are only passing VictoryHistogram components to VictoryStack");
    } // if we are stacking histograms, we need to generate explicit bins
    // or else each histogram may end up having different bins


    if (!allChildrenAreHistograms) {
      return parentProps;
    }

    var childBins = props.bins || childComponents[0].props.bins; // if we have explicit bins then we don't need to calculate them

    if (!Array.isArray(childBins)) {
      var combinedData = children.reduce(function (memo, child) {
        var xAccessor = Helpers.createAccessor(child.props.x || "x");
        return memo.concat(child.props.data.map(function (datum) {
          return {
            x: xAccessor(datum)
          };
        }));
      }, []); // use the same function to generate bins as VictoryHistogram but with
      // the combined data from above, then get explicit bins from that

      var getFormattedHistogramData = children[0].type.getFormattedData;
      childBins = getFormattedHistogramData({
        data: combinedData,
        bins: childBins
      }).reduce(function (memo, _ref2, index) {
        var x0 = _ref2.x0,
            x1 = _ref2.x1;
        return index === 0 ? memo.concat([x0, x1]) : memo.concat(x1);
      }, []);
    }

    return _objectSpread$a({}, parentProps, {
      bins: childBins
    });
  },
  getDataFromChildren: function (props, childComponents) {
    var polar = props.polar,
        startAngle = props.startAngle,
        endAngle = props.endAngle,
        categories = props.categories,
        minDomain = props.minDomain,
        maxDomain = props.maxDomain;
    var parentProps = {
      polar: polar,
      startAngle: startAngle,
      endAngle: endAngle,
      categories: categories,
      minDomain: minDomain,
      maxDomain: maxDomain
    };
    var stack = 0;
    var children = childComponents ? childComponents.slice(0) : React__default['default'].Children.toArray(props.children);
    parentProps = this.addBinsToParentPropsIfHistogram({
      children: children,
      props: props,
      childComponents: childComponents,
      parentProps: parentProps
    });

    var iteratee = function (child, childName, parent) {
      var childProps = assign_1({}, child.props, parentProps);

      var childData;

      if (!Data.isDataComponent(child)) {
        return null;
      } else if (child.type && isFunction_1(child.type.getData)) {
        child = parent ? React__default['default'].cloneElement(child, parent.props) : child;
        childData = child.type.getData(childProps);
      } else {
        childData = Data.getData(childProps);
      }

      stack += 1;
      return childData.map(function (datum, index) {
        return assign_1({
          _stack: stack,
          _group: index
        }, datum);
      });
    };

    var stacked = children.filter(function (c) {
      return c.type && c.type.role === "stack";
    }).length;

    var combine = function (memo, val) {
      return memo.concat(uniqBy_1(val, "_group"));
    };

    var datasets = Helpers.reduceChildren(children, iteratee, props, [], combine);
    var group = stacked ? "_group" : "_stack";
    return values_1(groupBy_1(datasets, group));
  },
  getColor: function (calculatedProps, child, index) {
    // check for styles first
    var style = calculatedProps.style;
    var colorScale = calculatedProps.colorScale,
        color = calculatedProps.color;

    if (style && style.data && style.data.fill) {
      return style.data.fill;
    }

    colorScale = child.props && child.props.colorScale ? child.props.colorScale : colorScale;
    color = child.props && child.props.color ? child.props.color : color;

    if (!colorScale && !color) {
      return undefined;
    }

    var colors = Array.isArray(colorScale) ? colorScale : Style.getColorScale(colorScale);
    return color || colors[index % colors.length];
  },
  getWidth: function (props) {
    var datasets = props.datasets,
        scale = props.scale,
        horizontal = props.horizontal;
    var range = horizontal ? scale.y.range() : scale.x.range();
    var extent = Math.abs(range[1] - range[0]);
    var seriesLength = Array.isArray(datasets[0]) ? datasets[0].length : 1;
    var bars = datasets.length * seriesLength + 2;
    var barRatio = 0.5;
    return {
      width: Math.round(barRatio * extent / bars)
    };
  },
  getStyle: function (theme, style, role) {
    var defaultStyle = theme && theme[role] && theme[role].style ? theme[role].style : {};
    return Helpers.getStyles(style, defaultStyle);
  },
  getChildStyle: function (child, index, calculatedProps) {
    var style = calculatedProps.style,
        role = calculatedProps.role;
    var childStyle = child.props.style || {};

    if (Array.isArray(childStyle)) {
      return childStyle;
    }

    var childRole = child.type && child.type.role;
    var defaultFill = childRole === "stack" ? undefined : this.getColor(calculatedProps, child, index);
    var defaultColor = childRole === "line" ? {
      fill: "none",
      stroke: defaultFill
    } : {
      fill: defaultFill
    };
    var dataWidth = role === "stack" ? {} : this.getWidth(calculatedProps);

    var dataStyle = defaults_1({}, childStyle.data, assign_1({}, dataWidth, style.data, defaultColor));

    var labelsStyle = defaults_1({}, childStyle.labels, style.labels);

    return {
      parent: style.parent,
      data: dataStyle,
      labels: labelsStyle
    };
  },
  getStringsFromCategories: function (childComponents, axis) {
    var iteratee = function (child) {
      var childProps = child.props || {};

      if (!Domain.isDomainComponent(child) || !childProps.categories) {
        return null;
      } else {
        var categories = childProps.categories && !Array.isArray(childProps.categories) ? childProps.categories[axis] : childProps.props.categories;
        var categoryStrings = categories && categories.filter(function (val) {
          return typeof val === "string";
        });
        return categoryStrings ? Collection.removeUndefined(categoryStrings) : [];
      }
    };

    return Helpers.reduceChildren(childComponents.slice(0), iteratee);
  },
  getStringsFromData: function (childComponents) {
    var iteratee = function (child) {
      var childProps = child.props || {};
      var data;

      if (!Data.isDataComponent(child)) {
        return null;
      } else if (child.type && isFunction_1(child.type.getData)) {
        data = child.type.getData(childProps);
      } else {
        data = Data.getData(childProps);
      }

      return data.map(function (d) {
        return {
          x: d.xName,
          y: d.yName
        };
      });
    };

    var initialMemo = {
      x: [],
      y: []
    };

    var combine = function (memo, datum) {
      var x = Array.isArray(datum) ? datum.map(function (d) {
        return d.x;
      }).filter(Boolean) : datum.x;
      var y = Array.isArray(datum) ? datum.map(function (d) {
        return d.y;
      }).filter(Boolean) : datum.y;
      return {
        x: x !== undefined ? memo.x.concat(x) : memo.x,
        y: y !== undefined ? memo.y.concat(y) : memo.y
      };
    };

    return Helpers.reduceChildren(childComponents.slice(0), iteratee, {}, initialMemo, combine);
  },
  getCategoryAndAxisStringsFromChildren: function (props, axis, childComponents) {
    var categories = isPlainObject_1(props.categories) ? props.categories[axis] : props.categories;
    var axisComponent = Axis.getAxisComponent(childComponents, axis);
    var axisStrings = axisComponent ? Data.getStringsFromAxes(axisComponent.props, axis) : [];
    var categoryStrings = categories || this.getStringsFromCategories(childComponents, axis);
    return uniq_1(flatten_1(_toConsumableArray$c(categoryStrings).concat(_toConsumableArray$c(axisStrings))));
  },
  getStringsFromChildren: function (props, childComponents) {
    childComponents = childComponents || React__default['default'].Children.toArray(props.children);
    var xStrings = this.getCategoryAndAxisStringsFromChildren(props, "x", childComponents);
    var yStrings = this.getCategoryAndAxisStringsFromChildren(props, "y", childComponents);
    var dataStrings = this.getStringsFromData(childComponents);
    return {
      x: uniq_1(flatten_1(_toConsumableArray$c(xStrings).concat(_toConsumableArray$c(dataStrings.x)))),
      y: uniq_1(flatten_1(_toConsumableArray$c(yStrings).concat(_toConsumableArray$c(dataStrings.y))))
    };
  },
  getCategories: function (props, childComponents, allStrings) {
    var xPropCategories = props.categories && !Array.isArray(props.categories) ? props.categories.x : props.categories;
    var yPropCategories = props.categories && !Array.isArray(props.categories) ? props.categories.y : props.categories;
    var fallbackRequired = !xPropCategories || !yPropCategories;
    var fallbackProps = fallbackRequired ? allStrings || this.getStringsFromChildren(props, childComponents) : {};
    var xCategories = xPropCategories || fallbackProps.x;
    var yCategories = yPropCategories || fallbackProps.y;
    return {
      x: xCategories.length > 0 ? xCategories : undefined,
      y: yCategories.length > 0 ? yCategories : undefined
    };
  }
};

/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

var fromPairs_1 = fromPairs;

var stringify_1 = createCommonjsModule(function (module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = [];

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  };

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
    }
    else stack.push(value);

    return replacer == null ? value : replacer.call(this, key, value)
  }
}
});
var stringify_2 = stringify_1.getSerialize;

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$2(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray$d(arr) { return _arrayWithoutHoles$d(arr) || _iterableToArray$d(arr) || _nonIterableSpread$d(); }

function _nonIterableSpread$d() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$d(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$d(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$8(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$c(self); }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized$c(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var VictorySharedEvents =
/*#__PURE__*/
function (_React$Component) {
  _inherits$8(VictorySharedEvents, _React$Component);

  function VictorySharedEvents(props) {
    var _this;

    _classCallCheck$9(this, VictorySharedEvents);

    _this = _possibleConstructorReturn$8(this, (VictorySharedEvents.__proto__ || Object.getPrototypeOf(VictorySharedEvents)).call(this, props));
    _this.state = _this.state || {};
    _this.getScopedEvents = Events.getScopedEvents.bind(_assertThisInitialized$c(_this));
    _this.getEventState = Events.getEventState.bind(_assertThisInitialized$c(_this));
    _this.baseProps = _this.getBaseProps(props);
    _this.sharedEventsCache = {};
    return _this;
  }

  _createClass$9(VictorySharedEvents, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (!reactFastCompare(this.props, nextProps)) {
        this.baseProps = this.getBaseProps(nextProps);
        var externalMutations = this.getExternalMutations(nextProps, this.baseProps);
        this.applyExternalMutations(nextProps, externalMutations);
      }

      return true;
    }
  }, {
    key: "getAllEvents",
    value: function getAllEvents(props) {
      var components = ["container", "groupComponent"];
      var componentEvents = Events.getComponentEvents(props, components);

      if (Array.isArray(componentEvents)) {
        return Array.isArray(props.events) ? componentEvents.concat.apply(componentEvents, _toConsumableArray$d(props.events)) : componentEvents;
      }

      return props.events;
    }
  }, {
    key: "applyExternalMutations",
    value: function applyExternalMutations(props, externalMutations) {
      if (!isEmpty_1(externalMutations)) {
        var callbacks = props.externalEventMutations.reduce(function (memo, mutation) {
          memo = isFunction_1(mutation.callback) ? memo.concat(mutation.callback) : memo;
          return memo;
        }, []);
        var compiledCallbacks = callbacks.length ? function () {
          callbacks.forEach(function (c) {
            return c();
          });
        } : undefined;
        this.setState(externalMutations, compiledCallbacks);
      }
    }
  }, {
    key: "getExternalMutations",
    value: function getExternalMutations(props, baseProps) {
      return !isEmpty_1(props.externalEventMutations) ? Events.getExternalMutationsWithChildren(props.externalEventMutations, baseProps, this.state, Object.keys(baseProps)) : undefined;
    }
  }, {
    key: "cacheSharedEvents",
    value: function cacheSharedEvents(name, sharedEvents, cacheValues) {
      this.sharedEventsCache[name] = [sharedEvents, cacheValues];
    }
  }, {
    key: "getCachedSharedEvents",
    value: function getCachedSharedEvents(name, cacheValues) {
      var _ref = this.sharedEventsCache[name] || [],
          _ref2 = _slicedToArray$2(_ref, 2),
          sharedEvents = _ref2[0],
          prevCacheValues = _ref2[1];

      if (sharedEvents && reactFastCompare(cacheValues, prevCacheValues)) {
        return sharedEvents;
      }

      return undefined;
    }
  }, {
    key: "getBaseProps",
    value: function getBaseProps(props) {
      var container = props.container;
      var children = React__default['default'].Children.toArray(this.props.children);
      var childBaseProps = this.getBasePropsFromChildren(children);
      var parentBaseProps = container ? container.props : {};
      return assign_1({}, childBaseProps, {
        parent: parentBaseProps
      });
    }
  }, {
    key: "getBasePropsFromChildren",
    value: function getBasePropsFromChildren(childComponents) {
      var iteratee = function (child, childName) {
        if (child.type && isFunction_1(child.type.getBaseProps)) {
          var _baseProps = child.props && child.type.getBaseProps(child.props);

          return _baseProps ? [[childName, _baseProps]] : null;
        } else {
          return null;
        }
      };

      var baseProps = Helpers.reduceChildren(childComponents, iteratee);
      return fromPairs_1(baseProps);
    }
  }, {
    key: "getNewChildren",
    value: function getNewChildren(props, baseProps) {
      var _this2 = this;

      var events = props.events,
          eventKey = props.eventKey;

      var alterChildren = function (children, childNames) {
        return children.reduce(function (memo, child, index) {
          if (child.props.children) {
            var newChildren = React__default['default'].Children.toArray(child.props.children);
            var names = childNames.slice(index, index + newChildren.length);
            var results = React__default['default'].cloneElement(child, child.props, alterChildren(newChildren, names));
            return memo.concat(results);
          } else if (child.type && isFunction_1(child.type.getBaseProps)) {
            var name = child.props.name || childNames[index];
            var childEvents = Array.isArray(events) && events.filter(function (event) {
              if (event.target === "parent") {
                return false;
              }

              return Array.isArray(event.childName) ? event.childName.indexOf(name) > -1 : event.childName === name || event.childName === "all";
            });
            var sharedEventsCacheValues = [name, baseProps, childEvents, stringify_1(_this2.state[name])];
            var sharedEvents = _this2.getCachedSharedEvents(name, sharedEventsCacheValues) || {
              events: childEvents,
              // partially apply child name and baseProps,
              getEvents: function (evts, target) {
                return _this2.getScopedEvents(evts, target, name, baseProps);
              },
              // partially apply child name
              getEventState: function (key, target) {
                return _this2.getEventState(key, target, name);
              }
            };

            _this2.cacheSharedEvents(name, sharedEvents, sharedEventsCacheValues);

            return memo.concat(React__default['default'].cloneElement(child, assign_1({
              key: "events-".concat(name),
              sharedEvents: sharedEvents,
              eventKey: eventKey,
              name: name
            }, child.props)));
          } else {
            return memo.concat(child);
          }
        }, []);
      };

      var childNames = Object.keys(baseProps);
      var childComponents = React__default['default'].Children.toArray(props.children);
      return alterChildren(childComponents, childNames);
    }
  }, {
    key: "getContainer",
    value: function getContainer(props, baseProps, events) {
      var _this3 = this;

      var children = this.getNewChildren(props, baseProps);
      var parents = Array.isArray(events) && events.filter(function (event) {
        return event.target === "parent";
      });
      var sharedEvents = parents.length > 0 ? {
        events: parents,
        // partially apply childName (null) and baseProps,
        getEvents: function (evts, target) {
          return _this3.getScopedEvents(evts, target, null, baseProps);
        },
        getEventState: this.getEventState
      } : null;
      var container = props.container || props.groupComponent;
      var role = container.type && container.type.role;
      var containerProps = container.props || {};
      var boundGetEvents = Events.getEvents.bind(this);
      var parentEvents = sharedEvents && boundGetEvents({
        sharedEvents: sharedEvents
      }, "parent");

      var parentProps = defaults_1({}, this.getEventState("parent", "parent"), containerProps, baseProps.parent, {
        children: children
      });

      var containerEvents = defaults_1({}, Events.getPartialEvents(parentEvents, "parent", parentProps), containerProps.events);

      return role === "container" ? React__default['default'].cloneElement(container, assign_1({}, parentProps, {
        events: containerEvents
      })) : React__default['default'].cloneElement(container, containerEvents, children);
    }
  }, {
    key: "render",
    value: function render() {
      var events = this.getAllEvents(this.props);

      if (events) {
        return this.getContainer(this.props, this.baseProps, events);
      }

      return React__default['default'].cloneElement(this.props.container, {
        children: this.props.children
      });
    }
  }]);

  return VictorySharedEvents;
}(React__default['default'].Component);

Object.defineProperty(VictorySharedEvents, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictorySharedEvents"
});
Object.defineProperty(VictorySharedEvents, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "shared-event-wrapper"
});
Object.defineProperty(VictorySharedEvents, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].node), PropTypes__default['default'].node]),
    container: PropTypes__default['default'].node,
    eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].array, PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
    events: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      childName: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].array]),
      eventHandlers: PropTypes__default['default'].object,
      eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].array, PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
      target: PropTypes__default['default'].string
    })),
    externalEventMutations: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      callback: PropTypes__default['default'].function,
      childName: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].array]),
      eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].array, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
      mutation: PropTypes__default['default'].function,
      target: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].array])
    })),
    groupComponent: PropTypes__default['default'].node
  }
});
Object.defineProperty(VictorySharedEvents, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    groupComponent: React__default['default'].createElement("g", null)
  }
});
Object.defineProperty(VictorySharedEvents, "contextType", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: TimerContext
});

function _toConsumableArray$e(arr) { return _arrayWithoutHoles$e(arr) || _iterableToArray$e(arr) || _nonIterableSpread$e(); }

function _nonIterableSpread$e() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$e(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$e(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var orientationSign = {
  top: -1,
  left: -1,
  right: 1,
  bottom: 1
};

var getCurrentAxis$1 = function (props, axis) {
  var orientation = props.orientation,
      horizontal = props.horizontal;

  if (orientation) {
    var dimensions = {
      top: "x",
      bottom: "x",
      left: "y",
      right: "y"
    };
    return dimensions[orientation];
  }

  var otherAxis = axis === "x" ? "y" : "x";
  return horizontal ? otherAxis : axis;
};

var getScale = function (props) {
  var axis = Axis.getAxis(props);
  var currentAxis = getCurrentAxis$1(props, axis);
  var scale = Scale.getBaseScale(props, axis);
  var propsDomain = props.domain && props.domain[axis];
  var domain = propsDomain || Axis.getDomain(props) || scale.domain();
  scale.range(Helpers.getRange(props, currentAxis));
  scale.domain(domain);
  return scale;
};

var getStyleObject = function (props) {
  var theme = props.theme,
      dependentAxis = props.dependentAxis;
  var generalAxisStyle = theme && theme.axis && theme.axis.style;
  var axisType = dependentAxis ? "dependentAxis" : "independentAxis";
  var specificAxisStyle = theme && theme[axisType] && theme[axisType].style;

  var mergeStyles = function () {
    var styleNamespaces = ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"];
    return styleNamespaces.reduce(function (memo, curr) {
      memo[curr] = defaults_1({}, specificAxisStyle[curr], generalAxisStyle[curr]);
      return memo;
    }, {});
  };

  return generalAxisStyle && specificAxisStyle ? mergeStyles() : specificAxisStyle || generalAxisStyle;
};

var getStyles$2 = function (props, styleObject) {
  var style = props.style || {};
  styleObject = styleObject || {};
  var parentStyleProps = {
    height: "100%",
    width: "100%"
  };
  return {
    parent: defaults_1(style.parent, styleObject.parent, parentStyleProps),
    axis: defaults_1({}, style.axis, styleObject.axis),
    axisLabel: defaults_1({}, style.axisLabel, styleObject.axisLabel),
    grid: defaults_1({}, style.grid, styleObject.grid),
    ticks: defaults_1({}, style.ticks, styleObject.ticks),
    tickLabels: defaults_1({}, style.tickLabels, styleObject.tickLabels)
  };
};

var getTickProps = function (layout, style, datum) {
  var position = layout.position,
      transform = layout.transform;
  return {
    x1: transform.x,
    y1: transform.y,
    x2: transform.x + position.x2,
    y2: transform.y + position.y2,
    style: style,
    datum: datum
  };
}; // eslint-disable-next-line max-params


var getTickLabelProps = function (layout, style, anchors, datum, text) {
  var position = layout.position,
      transform = layout.transform;
  return {
    style: style,
    x: transform.x + position.x,
    y: transform.y + position.y,
    verticalAnchor: anchors.verticalAnchor,
    textAnchor: anchors.textAnchor,
    angle: style.angle,
    text: text,
    datum: datum
  };
};

var getGridProps = function (layout, style, datum) {
  var edge = layout.edge,
      transform = layout.transform;
  return {
    type: "grid",
    x1: transform.x,
    y1: transform.y,
    x2: edge.x + transform.x,
    y2: edge.y + transform.y,
    style: style,
    datum: datum
  };
};

var getAxisProps = function (modifiedProps, calculatedValues, globalTransform) {
  var style = calculatedValues.style,
      padding = calculatedValues.padding,
      isVertical = calculatedValues.isVertical;
  var width = modifiedProps.width,
      height = modifiedProps.height;
  return {
    type: "axis",
    style: style.axis,
    x1: isVertical ? globalTransform.x : padding.left + globalTransform.x,
    x2: isVertical ? globalTransform.x : width - padding.right + globalTransform.x,
    y1: isVertical ? padding.top + globalTransform.y : globalTransform.y,
    y2: isVertical ? height - padding.bottom + globalTransform.y : globalTransform.y
  };
};

var getEvaluatedStyles = function (style, props) {
  return {
    tickStyle: Helpers.evaluateStyle(style.ticks, props),
    labelStyle: Helpers.evaluateStyle(style.tickLabels, props),
    gridStyle: Helpers.evaluateStyle(style.grid, props)
  };
};

var getAxisLabelProps = function (props, calculatedValues, globalTransform) {
  var style = calculatedValues.style,
      orientation = calculatedValues.orientation,
      padding = calculatedValues.padding,
      labelPadding = calculatedValues.labelPadding,
      isVertical = calculatedValues.isVertical;
  var sign = orientationSign[orientation];
  var hPadding = padding.left + padding.right;
  var vPadding = padding.top + padding.bottom;
  var verticalAnchor = sign < 0 ? "end" : "start";
  var labelStyle = style.axisLabel;
  var angle = isVertical ? -90 : 0; // eslint-disable-line no-magic-numbers

  var x = isVertical ? globalTransform.x + sign * labelPadding : (props.width - hPadding) / 2 + padding.left + globalTransform.x;
  var y = isVertical ? (props.height - vPadding) / 2 + padding.top + globalTransform.y : sign * labelPadding + globalTransform.y;
  return {
    x: x,
    y: y,
    verticalAnchor: labelStyle.verticalAnchor || verticalAnchor,
    textAnchor: labelStyle.textAnchor || "middle",
    angle: labelStyle.angle === undefined ? angle : labelStyle.angle,
    style: labelStyle,
    text: props.label
  };
};

var getAnchors = function (orientation, isVertical) {
  var anchorOrientation = {
    top: "end",
    left: "end",
    right: "start",
    bottom: "start"
  };
  var anchor = anchorOrientation[orientation];
  return {
    textAnchor: isVertical ? anchor : "middle",
    verticalAnchor: isVertical ? "middle" : anchor
  };
};

var getLabelPadding = function (props, style) {
  var labelStyle = style.axisLabel || {};

  if (labelStyle.padding !== undefined && labelStyle.padding !== null) {
    return labelStyle.padding;
  }

  var isVertical = Axis.isVertical(props); // TODO: magic numbers

  /*eslint-disable no-magic-numbers*/

  var fontSize = labelStyle.fontSize || 14;
  return props.label ? fontSize * (isVertical ? 2.3 : 1.6) : 0;
  /*eslint-enable no-magic-numbers*/
};

var getOffset$1 = function (props, calculatedValues) {
  var style = calculatedValues.style,
      padding = calculatedValues.padding,
      isVertical = calculatedValues.isVertical,
      orientation = calculatedValues.orientation,
      labelPadding = calculatedValues.labelPadding,
      stringTicks = calculatedValues.stringTicks,
      ticks = calculatedValues.ticks,
      scale = calculatedValues.scale,
      axis = calculatedValues.axis;
  var polar = props.polar,
      horizontal = props.horizontal;
  var sharedProps = {
    scale: _defineProperty$e({}, axis, scale),
    polar: polar,
    horizontal: horizontal,
    ticks: ticks,
    stringTicks: stringTicks
  };
  var xPadding = orientation === "right" ? padding.right : padding.left;
  var yPadding = orientation === "top" ? padding.top : padding.bottom;
  var fontSize = style.axisLabel.fontSize || 14; // eslint-disable-line no-magic-numbers

  var offsetX = props.offsetX !== null && props.offsetX !== undefined ? props.offsetX : xPadding;
  var offsetY = props.offsetY !== null && props.offsetY !== undefined ? props.offsetY : yPadding;
  var tickSizes = ticks.map(function (data, index) {
    var tick = stringTicks ? props.tickValues[data - 1] : data;
    var tickStyle = Helpers.evaluateStyle(style.ticks, assign_1({}, sharedProps, {
      tick: tick,
      index: index
    }));
    return tickStyle.size || 0;
  });
  var totalPadding = fontSize + 2 * Math.max.apply(Math, _toConsumableArray$e(tickSizes)) + labelPadding;
  var minimumPadding = 1.2 * fontSize; // eslint-disable-line no-magic-numbers

  var x = isVertical ? totalPadding : minimumPadding;
  var y = isVertical ? minimumPadding : totalPadding;
  return {
    x: offsetX !== null && offsetX !== undefined ? offsetX : x,
    y: offsetY !== null && offsetY !== undefined ? offsetY : y
  };
};

var getTransform$1 = function (props, calculatedValues, offset) {
  //
  var orientation = calculatedValues.orientation,
      axis = calculatedValues.axis;
  var axisValue = Axis.getAxisValue(props, axis);
  return {
    top: {
      x: 0,
      y: axisValue !== undefined ? axisValue : offset.y
    },
    bottom: {
      x: 0,
      y: axisValue !== undefined ? axisValue : props.height - offset.y
    },
    left: {
      x: axisValue !== undefined ? axisValue : offset.x,
      y: 0
    },
    right: {
      x: axisValue !== undefined ? axisValue : props.width - offset.x,
      y: 0
    }
  }[orientation];
};

var getTickPosition = function (style, orientation, isVertical) {
  var tickStyle = style.tickStyle,
      labelStyle = style.labelStyle;
  var size = tickStyle.size || 0;
  var tickPadding = tickStyle.padding || 0;
  var labelPadding = labelStyle.padding || 0;
  var tickSpacing = size + tickPadding + labelPadding;
  var sign = orientationSign[orientation];
  return {
    x: isVertical ? sign * tickSpacing : 0,
    x2: isVertical ? sign * size : 0,
    y: isVertical ? 0 : sign * tickSpacing,
    y2: isVertical ? 0 : sign * size
  };
};

var getTickTransform = function (tick, globalTransform, isVertical) {
  return {
    x: isVertical ? globalTransform.x : tick + globalTransform.x,
    y: isVertical ? tick + globalTransform.y : globalTransform.y
  };
};

var getGridEdge = function (props, calculatedValues) {
  var orientation = calculatedValues.orientation,
      padding = calculatedValues.padding,
      isVertical = calculatedValues.isVertical;
  var sign = -orientationSign[orientation];
  var x = isVertical ? sign * (props.width - (padding.left + padding.right)) : 0;
  var y = isVertical ? 0 : sign * (props.height - (padding.top + padding.bottom));
  return {
    x: x,
    y: y
  };
};

var getGridOffset = function (props, calculatedValues, offset) {
  var padding = calculatedValues.padding,
      orientation = calculatedValues.orientation;
  var xPadding = orientation === "right" ? padding.right : padding.left;
  var yPadding = orientation === "top" ? padding.top : padding.bottom;
  return {
    x: props.crossAxis ? offset.x - xPadding : 0,
    y: props.crossAxis ? offset.y - yPadding : 0
  };
};

var getLayoutProps = function (modifiedProps, calculatedValues) {
  var offset = getOffset$1(modifiedProps, calculatedValues);
  return {
    globalTransform: getTransform$1(modifiedProps, calculatedValues, offset),
    gridOffset: getGridOffset(modifiedProps, calculatedValues, offset),
    gridEdge: getGridEdge(modifiedProps, calculatedValues)
  };
};

var getOrientation = function (props) {
  if (props.orientation) {
    return props.orientation;
  }

  var defaultOrientations = {
    dependent: props.horizontal ? "bottom" : "left",
    independent: props.horizontal ? "left" : "bottom"
  };
  return props.dependentAxis ? defaultOrientations.dependent : defaultOrientations.independent;
};

var getCalculatedValues = function (props) {
  var defaultStyles = getStyleObject(props);
  var style = getStyles$2(props, defaultStyles);
  var padding = Helpers.getPadding(props);
  var isVertical = Axis.isVertical(props);
  var labelPadding = getLabelPadding(props, style);
  var stringTicks = Axis.stringTicks(props) ? props.tickValues : undefined;
  var axis = Axis.getAxis(props);
  var orientation = getOrientation(props);
  var scale = getScale(props);
  var domain = Axis.getDomain(props);
  var ticks = Axis.getTicks(props, scale, props.crossAxis);
  var tickFormat = Axis.getTickFormat(props, scale);
  var anchors = getAnchors(orientation, isVertical);
  return {
    axis: axis,
    style: style,
    padding: padding,
    orientation: orientation,
    isVertical: isVertical,
    labelPadding: labelPadding,
    stringTicks: stringTicks,
    anchors: anchors,
    scale: scale,
    ticks: ticks,
    tickFormat: tickFormat,
    domain: domain
  };
};

var getBaseProps = function (props, fallbackProps) {
  props = Axis.modifyProps(props, fallbackProps);
  var calculatedValues = getCalculatedValues(props);
  var axis = calculatedValues.axis,
      style = calculatedValues.style,
      orientation = calculatedValues.orientation,
      isVertical = calculatedValues.isVertical,
      scale = calculatedValues.scale,
      ticks = calculatedValues.ticks,
      tickFormat = calculatedValues.tickFormat,
      anchors = calculatedValues.anchors,
      domain = calculatedValues.domain,
      stringTicks = calculatedValues.stringTicks,
      name = calculatedValues.name;
  var otherAxis = axis === "x" ? "y" : "x";
  var _props = props,
      width = _props.width,
      height = _props.height,
      standalone = _props.standalone,
      theme = _props.theme,
      polar = _props.polar,
      padding = _props.padding,
      horizontal = _props.horizontal;

  var _getLayoutProps = getLayoutProps(props, calculatedValues),
      globalTransform = _getLayoutProps.globalTransform,
      gridOffset = _getLayoutProps.gridOffset,
      gridEdge = _getLayoutProps.gridEdge;

  var sharedProps = {
    scale: _defineProperty$e({}, axis, scale),
    polar: polar,
    horizontal: horizontal,
    ticks: ticks,
    stringTicks: stringTicks
  };
  var axisProps = getAxisProps(props, calculatedValues, globalTransform);
  var axisLabelProps = getAxisLabelProps(props, calculatedValues, globalTransform);
  var initialChildProps = {
    parent: assign_1({
      style: style.parent,
      ticks: ticks,
      standalone: standalone,
      theme: theme,
      width: width,
      height: height,
      padding: padding,
      domain: domain,
      name: name
    }, sharedProps)
  };
  var gridProps = {
    dimension: otherAxis,
    range: _defineProperty$e({}, otherAxis, Helpers.getRange(props, otherAxis)),
    scale: props.scale && props.scale[otherAxis] ? _defineProperty$e({}, otherAxis, props.scale[otherAxis]) : undefined
  };
  return ticks.reduce(function (childProps, tickValue, index) {
    var tick = stringTicks ? stringTicks[index] : tickValue;
    var text = tickFormat(tickValue, index, ticks);
    var styles = getEvaluatedStyles(style, assign_1({}, sharedProps, {
      tick: tick,
      tickValue: tickValue,
      index: index,
      text: text
    }));
    var tickLayout = {
      position: getTickPosition(styles, orientation, isVertical),
      transform: getTickTransform(scale(tickValue), globalTransform, isVertical)
    };
    var gridLayout = {
      edge: gridEdge,
      transform: {
        x: isVertical ? -gridOffset.x + globalTransform.x : scale(tickValue) + globalTransform.x,
        y: isVertical ? scale(tickValue) + globalTransform.y : gridOffset.y + globalTransform.y
      }
    };
    childProps[index] = {
      axis: assign_1({
        dimension: axis
      }, sharedProps, axisProps),
      axisLabel: assign_1({}, sharedProps, axisLabelProps),
      ticks: assign_1({}, sharedProps, getTickProps(tickLayout, styles.tickStyle, tickValue)),
      tickLabels: assign_1({}, sharedProps, getTickLabelProps(tickLayout, styles.labelStyle, anchors, tickValue, text)),
      grid: assign_1({}, sharedProps, gridProps, getGridProps(gridLayout, styles.gridStyle, tickValue))
    };
    return childProps;
  }, initialChildProps);
};

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$f(target, key, source[key]); }); } return target; }

function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray$f(arr) { return _arrayWithoutHoles$f(arr) || _iterableToArray$f(arr) || _nonIterableSpread$f(); }

function _nonIterableSpread$f() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$f(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$f(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$9(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$d(self); }

function _assertThisInitialized$d(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var fallbackProps = {
  width: 450,
  height: 300,
  padding: 50
};
var options = {
  components: [{
    name: "axis",
    index: 0
  }, {
    name: "axisLabel",
    index: 0
  }, {
    name: "grid"
  }, {
    name: "parent",
    index: "parent"
  }, {
    name: "ticks"
  }, {
    name: "tickLabels"
  }]
};

var VictoryAxis =
/*#__PURE__*/
function (_React$Component) {
  _inherits$9(VictoryAxis, _React$Component);

  function VictoryAxis() {
    _classCallCheck$a(this, VictoryAxis);

    return _possibleConstructorReturn$9(this, (VictoryAxis.__proto__ || Object.getPrototypeOf(VictoryAxis)).apply(this, arguments));
  }

  _createClass$a(VictoryAxis, [{
    key: "renderLine",
    value: function renderLine(props) {
      var axisComponent = props.axisComponent;
      var axisProps = this.getComponentProps(axisComponent, "axis", 0);
      return React__default['default'].cloneElement(axisComponent, axisProps);
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(props) {
      var axisLabelComponent = props.axisLabelComponent,
          label = props.label;

      if (!label) {
        return null;
      }

      var axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
      return React__default['default'].cloneElement(axisLabelComponent, axisLabelProps);
    }
  }, {
    key: "renderGridAndTicks",
    value: function renderGridAndTicks(props) {
      var _this = this;

      var tickComponent = props.tickComponent,
          tickLabelComponent = props.tickLabelComponent,
          gridComponent = props.gridComponent,
          name = props.name;

      var shouldRender = function (componentProps) {
        var _componentProps$style = componentProps.style,
            style = _componentProps$style === void 0 ? {} : _componentProps$style,
            _componentProps$event = componentProps.events,
            events = _componentProps$event === void 0 ? {} : _componentProps$event;
        var visible = style.stroke !== "transparent" && style.stroke !== "none" && style.strokeWidth !== 0;
        return visible || !isEmpty_1(events);
      };

      return this.dataKeys.map(function (key, index) {
        var tickProps = _this.getComponentProps(tickComponent, "ticks", index);

        var BaseTickComponent = React__default['default'].cloneElement(tickComponent, tickProps);
        var TickComponent = shouldRender(BaseTickComponent.props) ? BaseTickComponent : undefined;

        var gridProps = _this.getComponentProps(gridComponent, "grid", index);

        var BaseGridComponent = React__default['default'].cloneElement(gridComponent, gridProps);
        var GridComponent = shouldRender(BaseGridComponent.props) ? BaseGridComponent : undefined;

        var tickLabelProps = _this.getComponentProps(tickLabelComponent, "tickLabels", index);

        var TickLabel = React__default['default'].cloneElement(tickLabelComponent, tickLabelProps);
        var children = [GridComponent, TickComponent, TickLabel].filter(Boolean);
        return React__default['default'].cloneElement(props.groupComponent, {
          key: "".concat(name, "-tick-group-").concat(key)
        }, children);
      });
    }
  }, {
    key: "fixLabelOverlap",
    value: function fixLabelOverlap(gridAndTicks, props) {
      var isVertical = Axis.isVertical(props);
      var size = isVertical ? props.height : props.width;

      var isVictoryLabel = function (child) {
        return child.type && child.type.role === "label";
      };

      var labels = gridAndTicks.map(function (gridAndTick) {
        return gridAndTick.props.children;
      }).reduce(function (accumulator, childArr) {
        return accumulator.concat(childArr);
      }, []).filter(isVictoryLabel).map(function (child) {
        return child.props;
      });

      var paddingToObject = function (padding) {
        return typeof padding === "object" ? assign_1({}, {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }, padding) : {
          top: padding,
          right: padding,
          bottom: padding,
          left: padding
        };
      };

      var labelsSumSize = labels.reduce(function (sum, label) {
        var padding = paddingToObject(label.style.padding);
        var labelSize = TextSize.approximateTextSize(label.text, {
          angle: label.angle,
          fontSize: label.style.fontSize,
          letterSpacing: label.style.letterSpacing,
          fontFamily: label.style.fontFamily
        });
        return sum + (isVertical ? labelSize.height + padding.top + padding.bottom : labelSize.width + padding.right + padding.left);
      }, 0);
      var availiableLabelCount = Math.floor(size * gridAndTicks.length / labelsSumSize);
      var divider = Math.ceil(gridAndTicks.length / availiableLabelCount) || 1;

      var getLabelCoord = function (gridAndTick) {
        return gridAndTick.props.children.filter(isVictoryLabel).reduce(function (prev, child) {
          return (isVertical ? child.props.y : child.props.x) || 0;
        }, 0);
      };

      var sorted = gridAndTicks.sort(function (a, b) {
        return isVertical ? getLabelCoord(b) - getLabelCoord(a) //ordinary axis has top-bottom orientation
        : getLabelCoord(a) - getLabelCoord(b);
      } //ordinary axis has left-right orientation
      );
      return sorted.filter(function (gridAndTick, index) {
        return index % divider === 0;
      });
    } // Overridden in native versions

  }, {
    key: "shouldAnimate",
    value: function shouldAnimate() {
      return !!this.props.animate;
    }
  }, {
    key: "render",
    value: function render() {
      var animationWhitelist = VictoryAxis.animationWhitelist;
      var props = Axis.modifyProps(this.props, fallbackProps);

      if (this.shouldAnimate()) {
        return this.animateComponent(props, animationWhitelist);
      }

      var gridAndTicks = this.renderGridAndTicks(props);
      var modifiedGridAndTicks = props.fixLabelOverlap ? this.fixLabelOverlap(gridAndTicks, props) : gridAndTicks;
      var children = [this.renderLine(props), this.renderLabel(props)].concat(_toConsumableArray$f(modifiedGridAndTicks));
      return props.standalone ? this.renderContainer(props.containerComponent, children) : React__default['default'].cloneElement(props.groupComponent, {}, children);
    }
  }]);

  return VictoryAxis;
}(React__default['default'].Component);

Object.defineProperty(VictoryAxis, "animationWhitelist", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["style", "domain", "range", "tickCount", "tickValues", "offsetX", "offsetY", "padding", "width", "height"]
});
Object.defineProperty(VictoryAxis, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryAxis"
});
Object.defineProperty(VictoryAxis, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "axis"
});
Object.defineProperty(VictoryAxis, "defaultTransitions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onExit: {
      duration: 500
    },
    onEnter: {
      duration: 500
    }
  }
});
Object.defineProperty(VictoryAxis, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: _objectSpread$b({}, CommonProps.baseProps, {
    axisComponent: PropTypes__default['default'].element,
    axisLabelComponent: PropTypes__default['default'].element,
    axisValue: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string, PropTypes__default['default'].object]),
    categories: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].shape({
      x: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
      y: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)
    })]),
    crossAxis: PropTypes__default['default'].bool,
    dependentAxis: PropTypes__default['default'].bool,
    events: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      target: PropTypes__default['default'].oneOf(["axis", "axisLabel", "grid", "ticks", "tickLabels"]),
      eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].array, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
      eventHandlers: PropTypes__default['default'].object
    })),
    fixLabelOverlap: PropTypes__default['default'].bool,
    gridComponent: PropTypes__default['default'].element,
    groupComponent: PropTypes__default['default'].element,
    invertAxis: PropTypes__default['default'].bool,
    label: PropTypes__default['default'].any,
    offsetX: PropTypes__default['default'].number,
    offsetY: PropTypes__default['default'].number,
    orientation: PropTypes__default['default'].oneOf(["top", "bottom", "left", "right"]),
    origin: PropTypes__default['default'].shape({
      x: PropTypes__default['default'].number,
      y: PropTypes__default['default'].number
    }),
    stringMap: PropTypes__default['default'].object,
    style: PropTypes__default['default'].shape({
      parent: PropTypes__default['default'].object,
      axis: PropTypes__default['default'].object,
      axisLabel: PropTypes__default['default'].object,
      grid: PropTypes__default['default'].object,
      ticks: PropTypes__default['default'].object,
      tickLabels: PropTypes__default['default'].object
    }),
    tickComponent: PropTypes__default['default'].element,
    tickCount: CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.greaterThanZero]),
    tickFormat: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.homogeneousArray]),
    tickLabelComponent: PropTypes__default['default'].element,
    tickValues: CustomPropTypes.homogeneousArray
  })
});
Object.defineProperty(VictoryAxis, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    axisComponent: React__default['default'].createElement(LineSegment, {
      type: "axis"
    }),
    axisLabelComponent: React__default['default'].createElement(VictoryLabel, null),
    tickLabelComponent: React__default['default'].createElement(VictoryLabel, null),
    tickComponent: React__default['default'].createElement(LineSegment, {
      type: "tick"
    }),
    gridComponent: React__default['default'].createElement(LineSegment, {
      type: "grid"
    }),
    standalone: true,
    theme: VictoryTheme.grayscale,
    containerComponent: React__default['default'].createElement(VictoryContainer, null),
    groupComponent: React__default['default'].createElement("g", {
      role: "presentation"
    }),
    fixLabelOverlap: false
  }
});
Object.defineProperty(VictoryAxis, "getDomain", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Axis.getDomain
});
Object.defineProperty(VictoryAxis, "getAxis", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Axis.getAxis
});
Object.defineProperty(VictoryAxis, "getStyles", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function (props) {
    return getStyles$2(props, fallbackProps.style);
  }
});
Object.defineProperty(VictoryAxis, "getBaseProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function (props) {
    return getBaseProps(props, fallbackProps);
  }
});
Object.defineProperty(VictoryAxis, "expectedComponents", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["axisComponent", "axisLabelComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent"]
});
var VictoryAxis$1 = addEvents(VictoryAxis, options);

var getPosition$2 = function (r, angle, axis) {
  return axis === "x" ? r * Math.cos(angle) : -r * Math.sin(angle);
};

var getAxisType = function (props) {
  var typicalType = props.dependentAxis ? "radial" : "angular";
  var invertedType = typicalType === "angular" ? "radial" : "angular";
  return props.horizontal ? invertedType : typicalType;
};

var filterTicks = function (ticks, scale) {
  var compareTicks = function (t) {
    return scale(t) % (2 * Math.PI);
  };

  return uniqBy_1(ticks, compareTicks);
};

var getEvaluatedStyles$1 = function (style, props) {
  return {
    tickStyle: Helpers.evaluateStyle(style.ticks, props),
    labelStyle: Helpers.evaluateStyle(style.tickLabels, props),
    gridStyle: Helpers.evaluateStyle(style.grid, props)
  };
};

var getStyleObject$1 = function (props) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? {} : _props$theme,
      dependentAxis = props.dependentAxis;
  var generalAxisStyle = theme.polarAxis && theme.polarAxis.style || theme.axis && theme.axis.style;
  var polarAxisType = dependentAxis ? "polarDependentAxis" : "polarIndependentAxis";
  var standardAxisType = dependentAxis ? "dependentAxis" : "independentAxis";
  var specificAxisStyle = theme[polarAxisType] && theme[polarAxisType].style || theme[standardAxisType] && theme[standardAxisType].style;

  var mergeStyles = function () {
    var styleNamespaces = ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"];
    return styleNamespaces.reduce(function (memo, curr) {
      memo[curr] = defaults_1({}, specificAxisStyle[curr], generalAxisStyle[curr]);
      return memo;
    }, {});
  };

  return generalAxisStyle && specificAxisStyle ? mergeStyles() : specificAxisStyle || generalAxisStyle;
};

var getRadius$1 = function (props) {
  var _Helpers$getPadding = Helpers.getPadding(props),
      left = _Helpers$getPadding.left,
      right = _Helpers$getPadding.right,
      top = _Helpers$getPadding.top,
      bottom = _Helpers$getPadding.bottom;

  var width = props.width,
      height = props.height;
  return Math.min(width - left - right, height - top - bottom) / 2;
};

var getRange$1 = function (props, axis) {
  // Return the range from props if one is given.
  if (props.range && props.range[axis]) {
    return props.range[axis];
  } else if (props.range && Array.isArray(props.range)) {
    return props.range;
  }

  var axisType = getAxisType(props);

  if (axisType === "angular") {
    var startAngle = Helpers.degreesToRadians(props.startAngle);
    var endAngle = Helpers.degreesToRadians(props.endAngle);
    return [startAngle, endAngle];
  }

  var radius = getRadius$1(props);
  return [props.innerRadius || 0, radius];
}; // exposed for use by VictoryChart (necessary?)


var getScale$1 = function (props) {
  var axis = Axis.getAxis(props);
  var scale = Scale.getBaseScale(props, axis);
  var domain = Axis.getDomain(props, axis) || scale.domain();
  var range = getRange$1(props, axis);
  scale.range(range);
  scale.domain(domain);
  return scale;
};

var getStyles$3 = function (props, styleObject) {
  var style = props.style || {};
  styleObject = styleObject || {};
  var parentStyleProps = {
    height: "auto",
    width: "100%"
  };
  return {
    parent: defaults_1(parentStyleProps, style.parent, styleObject.parent),
    axis: defaults_1({}, style.axis, styleObject.axis),
    axisLabel: defaults_1({}, style.axisLabel, styleObject.axisLabel),
    grid: defaults_1({}, style.grid, styleObject.grid),
    ticks: defaults_1({}, style.ticks, styleObject.ticks),
    tickLabels: defaults_1({}, style.tickLabels, styleObject.tickLabels)
  };
};

var getAxisAngle = function (props) {
  var axisAngle = props.axisAngle,
      startAngle = props.startAngle,
      dependentAxis = props.dependentAxis;
  var axis = Axis.getAxis(props);
  var axisValue = Axis.getAxisValue(props, axis);

  if (axisValue === undefined || !dependentAxis) {
    return axisAngle === undefined ? startAngle : axisAngle;
  }

  return Helpers.radiansToDegrees(axisValue);
}; //eslint-disable-next-line max-params


var getTickProps$1 = function (props, calculatedValues, tickValue, index) {
  var axisType = calculatedValues.axisType,
      radius = calculatedValues.radius,
      scale = calculatedValues.scale,
      style = calculatedValues.style,
      stringTicks = calculatedValues.stringTicks,
      ticks = calculatedValues.ticks,
      tickFormat = calculatedValues.tickFormat,
      origin = calculatedValues.origin;
  var text = tickFormat(tickValue, index, ticks);
  var tick = stringTicks ? stringTicks[index] : tickValue;

  var _getEvaluatedStyles = getEvaluatedStyles$1(style, {
    tick: tick,
    tickValue: tickValue,
    index: index,
    ticks: ticks,
    stringTicks: stringTicks,
    radius: radius,
    scale: scale,
    axisType: axisType,
    text: text
  }),
      tickStyle = _getEvaluatedStyles.tickStyle;

  var axisAngle = axisType === "radial" ? getAxisAngle(props) : undefined;
  var tickPadding = tickStyle.padding || tickStyle.size || 0;
  var padAngle = Helpers.degreesToRadians(90 - axisAngle);
  var tickAngle = axisType === "angular" ? scale(tickValue) : Helpers.degreesToRadians(-1 * axisAngle);
  var tickRadius = axisType === "angular" ? radius : scale(tickValue);
  return axisType === "angular" ? {
    index: index,
    datum: tick,
    style: tickStyle,
    x1: getPosition$2(tickRadius, tickAngle, "x") + origin.x,
    y1: getPosition$2(tickRadius, tickAngle, "y") + origin.y,
    x2: getPosition$2(tickRadius + tickPadding, tickAngle, "x") + origin.x,
    y2: getPosition$2(tickRadius + tickPadding, tickAngle, "y") + origin.y
  } : {
    index: index,
    datum: tick,
    style: tickStyle,
    x1: tickRadius * Math.cos(tickAngle) + Math.cos(padAngle) * tickPadding + origin.x,
    x2: tickRadius * Math.cos(tickAngle) - Math.cos(padAngle) * tickPadding + origin.x,
    y1: tickRadius * Math.sin(tickAngle) + Math.sin(padAngle) * tickPadding + origin.y,
    y2: tickRadius * Math.sin(tickAngle) - Math.sin(padAngle) * tickPadding + origin.y
  };
}; //eslint-disable-next-line max-params


var getTickLabelProps$1 = function (props, calculatedValues, tickValue, index) {
  var axisType = calculatedValues.axisType,
      radius = calculatedValues.radius,
      tickFormat = calculatedValues.tickFormat,
      style = calculatedValues.style,
      scale = calculatedValues.scale,
      ticks = calculatedValues.ticks,
      stringTicks = calculatedValues.stringTicks,
      origin = calculatedValues.origin;
  var text = tickFormat(tickValue, index, ticks);
  var tick = stringTicks ? stringTicks[index] : tickValue;

  var _getEvaluatedStyles2 = getEvaluatedStyles$1(style, {
    text: text,
    tick: tick,
    tickValue: tickValue,
    index: index,
    ticks: ticks,
    stringTicks: stringTicks,
    radius: radius,
    scale: scale,
    axisType: axisType
  }),
      labelStyle = _getEvaluatedStyles2.labelStyle;

  var tickLabelComponent = props.tickLabelComponent;
  var labelPlacement = tickLabelComponent.props && tickLabelComponent.props.labelPlacement ? tickLabelComponent.props.labelPlacement : props.labelPlacement;
  var tickPadding = labelStyle.padding || 0;
  var angularPadding = 0; // TODO: do some geometry

  var axisAngle = axisType === "radial" ? getAxisAngle(props) : undefined;
  var labelAngle = axisType === "angular" ? Helpers.radiansToDegrees(scale(tickValue)) : axisAngle + angularPadding;
  var textAngle = labelStyle.angle === undefined ? LabelHelpers.getPolarAngle(assign_1({}, props, {
    labelPlacement: labelPlacement
  }), labelAngle) : labelStyle.angle;
  var labelRadius = axisType === "angular" ? radius + tickPadding : scale(tickValue);
  var textAnchor = labelStyle.textAnchor || LabelHelpers.getPolarTextAnchor(assign_1({}, props, {
    labelPlacement: labelPlacement
  }), labelAngle);
  return {
    index: index,
    datum: tick,
    style: labelStyle,
    angle: textAngle,
    textAnchor: textAnchor,
    text: text,
    x: labelRadius * Math.cos(Helpers.degreesToRadians(labelAngle)) + origin.x,
    y: -labelRadius * Math.sin(Helpers.degreesToRadians(labelAngle)) + origin.y
  };
}; //eslint-disable-next-line max-params


var getGridProps$1 = function (props, calculatedValues, tickValue, index) {
  var axisType = calculatedValues.axisType,
      radius = calculatedValues.radius,
      style = calculatedValues.style,
      scale = calculatedValues.scale,
      stringTicks = calculatedValues.stringTicks,
      ticks = calculatedValues.ticks,
      tickFormat = calculatedValues.tickFormat,
      origin = calculatedValues.origin;
  var text = tickFormat(tickValue, index, ticks);
  var startAngle = props.startAngle,
      endAngle = props.endAngle,
      _props$innerRadius = props.innerRadius,
      innerRadius = _props$innerRadius === void 0 ? 0 : _props$innerRadius;
  var tick = stringTicks ? stringTicks[index] : tickValue;

  var _getEvaluatedStyles3 = getEvaluatedStyles$1(style, {
    tick: tick,
    tickValue: tickValue,
    index: index,
    ticks: ticks,
    stringTicks: stringTicks,
    radius: radius,
    scale: scale,
    axisType: axisType,
    text: text
  }),
      gridStyle = _getEvaluatedStyles3.gridStyle;

  var angle = scale(tickValue);
  return axisType === "angular" ? {
    index: index,
    datum: tick,
    style: gridStyle,
    x1: getPosition$2(radius, angle, "x") + origin.x,
    y1: getPosition$2(radius, angle, "y") + origin.y,
    x2: getPosition$2(innerRadius, angle, "x") + origin.x,
    y2: getPosition$2(innerRadius, angle, "y") + origin.y
  } : {
    style: gridStyle,
    index: index,
    datum: tick,
    cx: origin.x,
    cy: origin.y,
    r: scale(tickValue),
    startAngle: startAngle,
    endAngle: endAngle
  };
};

var getAxisLabelProps$1 = function (props, calculatedValues) {
  var axisType = calculatedValues.axisType,
      radius = calculatedValues.radius,
      style = calculatedValues.style,
      scale = calculatedValues.scale,
      origin = calculatedValues.origin;
  var axisLabelComponent = props.axisLabelComponent;

  if (axisType !== "radial") {
    return {};
  }

  var labelPlacement = axisLabelComponent.props && axisLabelComponent.props.labelPlacement ? axisLabelComponent.props.labelPlacement : props.labelPlacement;
  var labelStyle = style && style.axisLabel || {};
  var axisAngle = axisType === "radial" ? getAxisAngle(props) : undefined;
  var textAngle = labelStyle.angle === undefined ? LabelHelpers.getPolarAngle(assign_1({}, props, {
    labelPlacement: labelPlacement
  }), axisAngle) : labelStyle.angle;
  var labelRadius = radius + (labelStyle.padding || 0);
  var textAnchor = labelStyle.textAnchor || LabelHelpers.getTextPolarAnchor(assign_1({}, props, {
    labelPlacement: labelPlacement
  }), axisAngle);
  var verticalAnchor = labelStyle.verticalAnchor || LabelHelpers.getPolarVerticalAnchor(assign_1({}, props, {
    labelPlacement: labelPlacement
  }), axisAngle);
  return {
    style: labelStyle,
    angle: textAngle,
    textAnchor: textAnchor,
    verticalAnchor: verticalAnchor,
    text: props.label,
    x: getPosition$2(labelRadius, Helpers.degreesToRadians(axisAngle), "x") + origin.x,
    y: getPosition$2(labelRadius, Helpers.degreesToRadians(axisAngle), "y") + origin.y
  };
};

var getAxisProps$1 = function (modifiedProps, calculatedValues) {
  var style = calculatedValues.style,
      axisType = calculatedValues.axisType,
      radius = calculatedValues.radius,
      scale = calculatedValues.scale,
      origin = calculatedValues.origin;
  var startAngle = modifiedProps.startAngle,
      endAngle = modifiedProps.endAngle,
      _modifiedProps$innerR = modifiedProps.innerRadius,
      innerRadius = _modifiedProps$innerR === void 0 ? 0 : _modifiedProps$innerR;
  var axisAngle = axisType === "radial" ? Helpers.degreesToRadians(getAxisAngle(modifiedProps)) : undefined;
  return axisType === "radial" ? {
    style: style.axis,
    x1: getPosition$2(innerRadius, axisAngle, "x") + origin.x,
    x2: getPosition$2(radius, axisAngle, "x") + origin.x,
    y1: getPosition$2(innerRadius, axisAngle, "y") + origin.y,
    y2: getPosition$2(radius, axisAngle, "y") + origin.y
  } : {
    style: style.axis,
    cx: origin.x,
    cy: origin.y,
    r: radius,
    startAngle: startAngle,
    endAngle: endAngle
  };
};

var getCalculatedValues$1 = function (props) {
  props = assign_1({
    polar: true
  }, props);
  var defaultStyles = getStyleObject$1(props);
  var style = getStyles$3(props, defaultStyles);
  var padding = Helpers.getPadding(props);
  var axis = Axis.getAxis(props);
  var axisType = getAxisType(props);
  var stringTicks = Axis.stringTicks(props) ? props.tickValues : undefined;
  var domain = Axis.getDomain(props, axis);
  var range = getRange$1(props, axis);
  var scale = getScale$1(props);
  var initialTicks = Axis.getTicks(props, scale);
  var ticks = axisType === "angular" ? filterTicks(initialTicks, scale) : initialTicks;
  var tickFormat = Axis.getTickFormat(props, scale);
  var radius = getRadius$1(props);
  var origin = Helpers.getPolarOrigin(props);
  return {
    axis: axis,
    style: style,
    padding: padding,
    stringTicks: stringTicks,
    axisType: axisType,
    scale: scale,
    ticks: ticks,
    tickFormat: tickFormat,
    domain: domain,
    range: range,
    radius: radius,
    origin: origin
  };
};

var getBaseProps$1 = function (props, fallbackProps) {
  props = Axis.modifyProps(props, fallbackProps);
  var calculatedValues = getCalculatedValues$1(props);
  var style = calculatedValues.style,
      scale = calculatedValues.scale,
      ticks = calculatedValues.ticks,
      domain = calculatedValues.domain;
  var _props = props,
      width = _props.width,
      height = _props.height,
      standalone = _props.standalone,
      theme = _props.theme,
      name = _props.name;
  var axisProps = getAxisProps$1(props, calculatedValues);
  var axisLabelProps = getAxisLabelProps$1(props, calculatedValues);
  var initialChildProps = {
    parent: {
      style: style.parent,
      ticks: ticks,
      scale: scale,
      width: width,
      height: height,
      domain: domain,
      standalone: standalone,
      theme: theme,
      name: name
    }
  };
  return ticks.reduce(function (childProps, tick, index) {
    childProps[index] = {
      axis: axisProps,
      axisLabel: axisLabelProps,
      ticks: getTickProps$1(props, calculatedValues, tick, index),
      tickLabels: getTickLabelProps$1(props, calculatedValues, tick, index),
      grid: getGridProps$1(props, calculatedValues, tick, index)
    };
    return childProps;
  }, initialChildProps);
};

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } return target; }

function _defineProperty$g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray$g(arr) { return _arrayWithoutHoles$g(arr) || _iterableToArray$g(arr) || _nonIterableSpread$g(); }

function _nonIterableSpread$g() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$g(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$g(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$a(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$e(self); }

function _assertThisInitialized$e(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var fallbackProps$1 = {
  width: 450,
  height: 300,
  padding: 50
};
var options$1 = {
  components: [{
    name: "axis",
    index: 0
  }, {
    name: "axisLabel",
    index: 0
  }, {
    name: "grid"
  }, {
    name: "parent",
    index: "parent"
  }, {
    name: "ticks"
  }, {
    name: "tickLabels"
  }]
};

var VictoryPolarAxis =
/*#__PURE__*/
function (_React$Component) {
  _inherits$a(VictoryPolarAxis, _React$Component);

  function VictoryPolarAxis() {
    _classCallCheck$b(this, VictoryPolarAxis);

    return _possibleConstructorReturn$a(this, (VictoryPolarAxis.__proto__ || Object.getPrototypeOf(VictoryPolarAxis)).apply(this, arguments));
  }

  _createClass$b(VictoryPolarAxis, [{
    key: "renderAxisLine",
    value: function renderAxisLine(props) {
      var dependentAxis = props.dependentAxis;
      var axisComponent = dependentAxis ? props.axisComponent : props.circularAxisComponent;
      var axisProps = this.getComponentProps(axisComponent, "axis", 0);
      return React__default['default'].cloneElement(axisComponent, axisProps);
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(props) {
      var axisLabelComponent = props.axisLabelComponent,
          dependentAxis = props.dependentAxis,
          label = props.label;

      if (!label || !dependentAxis) {
        return null;
      }

      var axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
      return React__default['default'].cloneElement(axisLabelComponent, axisLabelProps);
    }
  }, {
    key: "renderAxis",
    value: function renderAxis(props) {
      var _this = this;

      var tickComponent = props.tickComponent,
          tickLabelComponent = props.tickLabelComponent,
          name = props.name;

      var shouldRender = function (componentProps) {
        var _componentProps$style = componentProps.style,
            style = _componentProps$style === void 0 ? {} : _componentProps$style,
            _componentProps$event = componentProps.events,
            events = _componentProps$event === void 0 ? {} : _componentProps$event;
        var visible = style.stroke !== "transparent" && style.stroke !== "none" && style.strokeWidth !== 0;
        return visible || !isEmpty_1(events);
      };

      var axisType = props.dependentAxis ? "radial" : "angular";
      var gridComponent = axisType === "radial" ? props.circularGridComponent : props.gridComponent;
      var tickComponents = this.dataKeys.map(function (key, index) {
        var tickProps = assign_1({
          key: "".concat(name, "-tick-").concat(key)
        }, _this.getComponentProps(tickComponent, "ticks", index));

        var TickComponent = React__default['default'].cloneElement(tickComponent, tickProps);
        return shouldRender(TickComponent.props) ? TickComponent : undefined;
      }).filter(Boolean);
      var gridComponents = this.dataKeys.map(function (key, index) {
        var gridProps = assign_1({
          key: "".concat(name, "-grid-").concat(key)
        }, _this.getComponentProps(gridComponent, "grid", index));

        var GridComponent = React__default['default'].cloneElement(gridComponent, gridProps);
        return shouldRender(GridComponent.props) ? GridComponent : undefined;
      }).filter(Boolean);
      var tickLabelComponents = this.dataKeys.map(function (key, index) {
        var tickLabelProps = assign_1({
          key: "".concat(name, "-tick-").concat(key)
        }, _this.getComponentProps(tickLabelComponent, "tickLabels", index));

        return React__default['default'].cloneElement(tickLabelComponent, tickLabelProps);
      });
      var axis = this.renderAxisLine(props);
      var axisLabel = this.renderLabel(props);
      var children = [axis, axisLabel].concat(_toConsumableArray$g(tickComponents), _toConsumableArray$g(gridComponents), _toConsumableArray$g(tickLabelComponents));
      return this.renderGroup(props, children);
    } // Overridden in victory-native

  }, {
    key: "renderGroup",
    value: function renderGroup(props, children) {
      var groupComponent = props.groupComponent;
      return React__default['default'].cloneElement(groupComponent, {}, children);
    }
  }, {
    key: "shouldAnimate",
    value: function shouldAnimate() {
      return !!this.props.animate;
    }
  }, {
    key: "render",
    value: function render() {
      var animationWhitelist = VictoryPolarAxis.animationWhitelist;
      var props = Axis.modifyProps(this.props, fallbackProps$1);

      if (this.shouldAnimate()) {
        return this.animateComponent(props, animationWhitelist);
      }

      var children = this.renderAxis(props);
      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
    }
  }]);

  return VictoryPolarAxis;
}(React__default['default'].Component);

Object.defineProperty(VictoryPolarAxis, "animationWhitelist", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["style", "domain", "range", "tickCount", "tickValues", "padding", "width", "height"]
});
Object.defineProperty(VictoryPolarAxis, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryAxis"
});
Object.defineProperty(VictoryPolarAxis, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "axis"
});
Object.defineProperty(VictoryPolarAxis, "defaultTransitions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onExit: {
      duration: 500
    },
    onEnter: {
      duration: 500
    }
  }
});
Object.defineProperty(VictoryPolarAxis, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: _objectSpread$c({}, CommonProps.baseProps, {
    axisAngle: PropTypes__default['default'].number,
    axisComponent: PropTypes__default['default'].element,
    axisLabelComponent: PropTypes__default['default'].element,
    axisValue: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string, PropTypes__default['default'].object]),
    categories: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].shape({
      x: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
      y: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)
    })]),
    circularAxisComponent: PropTypes__default['default'].element,
    circularGridComponent: PropTypes__default['default'].element,
    containerComponent: PropTypes__default['default'].element,
    dependentAxis: PropTypes__default['default'].bool,
    endAngle: PropTypes__default['default'].number,
    events: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      target: PropTypes__default['default'].oneOf(["axis", "axisLabel", "grid", "ticks", "tickLabels"]),
      eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].array, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
      eventHandlers: PropTypes__default['default'].object
    })),
    gridComponent: PropTypes__default['default'].element,
    innerRadius: CustomPropTypes.nonNegative,
    labelPlacement: PropTypes__default['default'].oneOf(["parallel", "perpendicular", "vertical"]),
    startAngle: PropTypes__default['default'].number,
    stringMap: PropTypes__default['default'].object,
    style: PropTypes__default['default'].shape({
      parent: PropTypes__default['default'].object,
      axis: PropTypes__default['default'].object,
      axisLabel: PropTypes__default['default'].object,
      grid: PropTypes__default['default'].object,
      ticks: PropTypes__default['default'].object,
      tickLabels: PropTypes__default['default'].object
    }),
    tickComponent: PropTypes__default['default'].element,
    tickCount: CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.greaterThanZero]),
    tickFormat: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.homogeneousArray]),
    tickLabelComponent: PropTypes__default['default'].element,
    tickValues: CustomPropTypes.homogeneousArray
  })
});
Object.defineProperty(VictoryPolarAxis, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    axisComponent: React__default['default'].createElement(LineSegment, {
      type: "axis"
    }),
    axisLabelComponent: React__default['default'].createElement(VictoryLabel, null),
    circularAxisComponent: React__default['default'].createElement(Arc, {
      type: "axis"
    }),
    circularGridComponent: React__default['default'].createElement(Arc, {
      type: "grid"
    }),
    containerComponent: React__default['default'].createElement(VictoryContainer, null),
    endAngle: 360,
    gridComponent: React__default['default'].createElement(LineSegment, {
      type: "grid"
    }),
    groupComponent: React__default['default'].createElement("g", {
      role: "presentation"
    }),
    labelPlacement: "parallel",
    startAngle: 0,
    standalone: true,
    theme: VictoryTheme.grayscale,
    tickComponent: React__default['default'].createElement(LineSegment, {
      type: "tick"
    }),
    tickLabelComponent: React__default['default'].createElement(VictoryLabel, null)
  }
});
Object.defineProperty(VictoryPolarAxis, "getDomain", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Axis.getDomain
});
Object.defineProperty(VictoryPolarAxis, "getAxis", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Axis.getAxis
});
Object.defineProperty(VictoryPolarAxis, "getScale", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: getScale$1
});
Object.defineProperty(VictoryPolarAxis, "getStyles", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function (props) {
    return getStyles$3(props, fallbackProps$1.style);
  }
});
Object.defineProperty(VictoryPolarAxis, "getBaseProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function (props) {
    return getBaseProps$1(props, fallbackProps$1);
  }
});
Object.defineProperty(VictoryPolarAxis, "expectedComponents", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["axisComponent", "circularAxisComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent", "circularGridComponent"]
});
var VictoryPolarAxis$1 = addEvents(VictoryPolarAxis, options$1);

function _toConsumableArray$h(arr) { return _arrayWithoutHoles$h(arr) || _iterableToArray$h(arr) || _nonIterableSpread$h(); }

function _nonIterableSpread$h() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$h(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$h(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
var fallbackProps$2 = {
  width: 450,
  height: 300,
  padding: 50
};

function getAxisProps$2(child, props, calculatedProps) {
  var domain = calculatedProps.domain,
      scale = calculatedProps.scale,
      stringMap = calculatedProps.stringMap,
      categories = calculatedProps.categories,
      horizontal = calculatedProps.horizontal,
      orientations = calculatedProps.orientations;
  var childProps = Axis.modifyProps(defaults_1({
    horizontal: horizontal,
    theme: props.theme
  }, child.props));
  var axis = child.type.getAxis(childProps);
  var crossAxis = childProps.crossAxis === false ? false : true;
  var orientation = childProps.orientation || orientations[axis];
  var axisOffset = horizontal ? getHorizontalAxisOffset(props, calculatedProps, orientation) : getAxisOffset(props, calculatedProps, orientation);
  return {
    stringMap: stringMap,
    horizontal: horizontal,
    categories: categories,
    startAngle: props.startAngle,
    endAngle: props.endAngle,
    innerRadius: props.innerRadius,
    domain: domain,
    scale: scale,
    offsetY: childProps.offsetY !== undefined ? childProps.offsetY : axisOffset.y,
    offsetX: childProps.offsetX !== undefined ? childProps.offsetX : axisOffset.x,
    crossAxis: crossAxis,
    orientation: orientation
  };
}

function getBackgroundWithProps(props, calculatedProps) {
  var backgroundElement = props.backgroundComponent;
  var height = props.polar ? calculatedProps.range.y[1] : calculatedProps.range.y[0] - calculatedProps.range.y[1];
  var width = calculatedProps.range.x[1] - calculatedProps.range.x[0];
  var xScale = props.horizontal ? calculatedProps.scale.y.range()[0] : calculatedProps.scale.x.range()[0];
  var yScale = props.horizontal ? calculatedProps.scale.x.range()[1] : calculatedProps.scale.y.range()[1];
  var xCoordinate = props.polar ? calculatedProps.origin.x : xScale;
  var yCoordinate = props.polar ? calculatedProps.origin.y : yScale;
  var parentName = props.name || "chart";
  var backgroundProps = {
    height: height,
    polar: props.polar,
    scale: calculatedProps.scale,
    style: props.style.background,
    x: xCoordinate,
    y: yCoordinate,
    key: "".concat(parentName, "-background"),
    width: width
  };
  return React__default['default'].cloneElement(backgroundElement, defaults_1({}, backgroundElement.props, backgroundProps));
}

function getChildProps(child, props, calculatedProps) {
  var axisChild = Axis.findAxisComponents([child]);

  if (axisChild.length > 0) {
    return getAxisProps$2(axisChild[0], props, calculatedProps);
  }

  var categories = calculatedProps.categories,
      domain = calculatedProps.domain,
      range = calculatedProps.range,
      scale = calculatedProps.scale,
      stringMap = calculatedProps.stringMap,
      horizontal = calculatedProps.horizontal;
  return {
    categories: categories,
    domain: domain,
    range: range,
    scale: scale,
    stringMap: stringMap,
    horizontal: horizontal
  };
}

function getStyles$4(props) {
  var styleProps = props.style && props.style.parent;
  return {
    parent: defaults_1({}, styleProps, {
      height: "100%",
      width: "100%",
      userSelect: "none"
    })
  };
}

function getOrientation$1(axis, originSign, horizontal) {
  var sign = originSign || "positive";
  var orientations = {
    positive: {
      x: "bottom",
      y: "left"
    },
    negative: {
      x: "top",
      y: "right"
    }
  };
  var horizontalOrientations = {
    positive: {
      x: "left",
      y: "bottom"
    },
    negative: {
      x: "right",
      y: "top"
    }
  };
  return horizontal ? horizontalOrientations[sign][axis] : orientations[sign][axis];
}

function getCalculatedProps$1(props, childComponents) {
  var style = getStyles$4(props);
  props = Helpers.modifyProps(props, fallbackProps$2, "chart");
  var _props = props,
      horizontal = _props.horizontal,
      polar = _props.polar;
  var allStrings = Wrapper$b.getStringsFromChildren(props, childComponents);
  var categories = Wrapper$b.getCategories(props, childComponents, allStrings);
  var stringMap = createStringMap$1(props, childComponents, allStrings);
  var domain = {
    x: getDomain$2(assign_1({}, props, {
      categories: categories
    }), "x", childComponents),
    y: getDomain$2(assign_1({}, props, {
      categories: categories
    }), "y", childComponents)
  };
  var range = {
    x: Helpers.getRange(props, "x"),
    y: Helpers.getRange(props, "y")
  };
  var baseScale = {
    x: Scale.getScaleFromProps(props, "x") || Wrapper$b.getScale(props, "x"),
    y: Scale.getScaleFromProps(props, "y") || Wrapper$b.getScale(props, "y")
  };
  var scale = {
    x: baseScale.x.domain(domain.x).range(horizontal ? range.y : range.x),
    y: baseScale.y.domain(domain.y).range(horizontal ? range.x : range.y)
  };
  var origin = polar ? Helpers.getPolarOrigin(props) : Axis.getOrigin(domain);
  var originSign = {
    x: Axis.getOriginSign(origin.x, domain.x),
    y: Axis.getOriginSign(origin.y, domain.y)
  };
  var orientations = {
    x: getOrientation$1("x", originSign.y, horizontal),
    y: getOrientation$1("y", originSign.x, horizontal)
  };
  var padding = Helpers.getPadding(props);
  return {
    categories: categories,
    domain: domain,
    range: range,
    horizontal: horizontal,
    scale: scale,
    stringMap: stringMap,
    style: style,
    origin: origin,
    padding: padding,
    orientations: orientations
  };
}

function getChildren(props, childComponents, calculatedProps) {
  childComponents = childComponents || getChildComponents(props);
  calculatedProps = calculatedProps || getCalculatedProps$1(props, childComponents);
  var baseStyle = calculatedProps.style.parent;
  var height = props.height,
      polar = props.polar,
      theme = props.theme,
      width = props.width;
  var _calculatedProps = calculatedProps,
      origin = _calculatedProps.origin,
      horizontal = _calculatedProps.horizontal;
  var parentName = props.name || "chart";
  return childComponents.map(function (child, index) {
    var role = child.type && child.type.role;
    var style = Array.isArray(child.props.style) ? child.props.style : defaults_1({}, child.props.style, {
      parent: baseStyle
    });
    var childProps = getChildProps(child, props, calculatedProps);
    var name = child.props.name || "".concat(parentName, "-").concat(role, "-").concat(index);

    var newProps = defaults_1({
      horizontal: horizontal,
      height: height,
      polar: polar,
      theme: theme,
      width: width,
      style: style,
      name: name,
      origin: polar ? origin : undefined,
      padding: calculatedProps.padding,
      key: "".concat(name, "-key-").concat(index),
      standalone: false
    }, childProps);

    return React__default['default'].cloneElement(child, newProps);
  });
}

var getChildComponents = function (props, defaultAxes) {
  var childComponents = React__default['default'].Children.toArray(props.children);

  var newChildComponents = _toConsumableArray$h(childComponents);

  if (childComponents.length === 0) {
    newChildComponents.push(defaultAxes.independent, defaultAxes.dependent);
  } else {
    var axisComponents = {
      dependent: Axis.getAxisComponentsWithParent(childComponents, "dependent"),
      independent: Axis.getAxisComponentsWithParent(childComponents, "independent")
    };

    if (axisComponents.dependent.length === 0 && axisComponents.independent.length === 0) {
      newChildComponents = props.prependDefaultAxes ? [defaultAxes.independent, defaultAxes.dependent].concat(newChildComponents) : newChildComponents.concat([defaultAxes.independent, defaultAxes.dependent]);
    }
  }

  return newChildComponents;
};

var getDomain$2 = function (props, axis, childComponents) {
  childComponents = childComponents || React__default['default'].Children.toArray(props.children);
  var domain = Wrapper$b.getDomain(props, axis, childComponents);
  var axisComponent = Axis.getAxisComponent(childComponents, axis);
  var invertDomain = axisComponent && axisComponent.props && axisComponent.props.invertAxis;
  return invertDomain ? domain.concat().reverse() : domain;
};

var getAxisOffset = function (props, calculatedProps, orientation) {
  var scale = calculatedProps.scale,
      origin = calculatedProps.origin,
      domain = calculatedProps.domain,
      padding = calculatedProps.padding;
  var top = padding.top,
      bottom = padding.bottom,
      left = padding.left,
      right = padding.right;
  var orientations = {
    x: orientation === "bottom" || orientation === "top" ? orientation : calculatedProps.orientations.x,
    y: orientation === "left" || orientation === "right" ? orientation : calculatedProps.orientations.y
  }; // make the axes line up, and cross when appropriate

  var orientationOffset = {
    y: orientations.x === "bottom" ? bottom : top,
    x: orientations.y === "left" ? left : right
  };
  var originOffset = {
    x: orientations.y === "left" ? 0 : props.width,
    y: orientations.x === "bottom" ? props.height : 0
  };
  var originPosition = {
    x: origin.x === domain.x[0] || origin.x === domain.x[1] ? 0 : scale.x(origin.x),
    y: origin.y === domain.y[0] || origin.y === domain.y[1] ? 0 : scale.y(origin.y)
  };
  return {
    x: originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x,
    y: originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y
  };
};

var getHorizontalAxisOffset = function (props, calculatedProps, orientation) {
  var scale = calculatedProps.scale,
      origin = calculatedProps.origin,
      domain = calculatedProps.domain,
      padding = calculatedProps.padding;
  var top = padding.top,
      bottom = padding.bottom,
      left = padding.left,
      right = padding.right;
  var orientations = {
    y: orientation === "bottom" || orientation === "top" ? orientation : calculatedProps.orientations.x,
    x: orientation === "left" || orientation === "right" ? orientation : calculatedProps.orientations.y
  }; // make the axes line up, and cross when appropriate

  var orientationOffset = {
    x: orientations.y === "bottom" ? bottom : top,
    y: orientations.x === "left" ? left : right
  };
  var originOffset = {
    y: orientations.x === "left" ? 0 : props.width,
    x: orientations.y === "bottom" ? props.height : 0
  };
  var originPosition = {
    x: origin.x === domain.x[0] || origin.x === domain.x[1] ? 0 : scale.x(origin.x),
    y: origin.y === domain.y[0] || origin.y === domain.y[1] ? 0 : scale.y(origin.y)
  };
  return {
    y: originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x,
    x: originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y
  };
};

var createStringMap$1 = function (props, childComponents, allStrings) {
  var x = !allStrings.x || allStrings.x.length === 0 ? null : allStrings.x.reduce(function (memo, string, index) {
    memo[string] = index + 1;
    return memo;
  }, {});
  var y = !allStrings.y || allStrings.y.length === 0 ? null : allStrings.y.reduce(function (memo, string, index) {
    memo[string] = index + 1;
    return memo;
  }, {});
  return {
    x: x,
    y: y
  };
};

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$h(target, key, source[key]); }); } return target; }

function _defineProperty$h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$c(Constructor.prototype, protoProps); if (staticProps) _defineProperties$c(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$b(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$f(self); }

function _inherits$b(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized$f(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
var fallbackProps$3 = {
  width: 450,
  height: 300,
  padding: 50
};

var VictoryChart =
/*#__PURE__*/
function (_React$Component) {
  _inherits$b(VictoryChart, _React$Component);

  function VictoryChart(props) {
    var _this;

    _classCallCheck$c(this, VictoryChart);

    _this = _possibleConstructorReturn$b(this, (VictoryChart.__proto__ || Object.getPrototypeOf(VictoryChart)).call(this, props));
    _this.state = {};

    if (props.animate) {
      _this.state = {
        nodesShouldLoad: false,
        nodesDoneLoad: false,
        animating: true
      };
      _this.setAnimationState = Wrapper$b.setAnimationState.bind(_assertThisInitialized$f(_this));
    }

    return _this;
  }

  _createClass$c(VictoryChart, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.animate) {
        if (!reactFastCompare(this.props, nextProps)) {
          this.setAnimationState(this.props, nextProps);
          return false;
        }
      }

      return true;
    }
  }, {
    key: "getNewChildren",
    value: function getNewChildren(props, childComponents, calculatedProps) {
      var children = getChildren(props, childComponents, calculatedProps);
      var getAnimationProps = Wrapper$b.getAnimationProps.bind(this);
      var newChildren = children.map(function (child, index) {
        var childProps = assign_1({
          animate: getAnimationProps(props, child, index)
        }, child.props);

        return React__default['default'].cloneElement(child, childProps);
      });

      if (props.style && props.style.background) {
        var backgroundComponent = getBackgroundWithProps(props, calculatedProps);
        newChildren.unshift(backgroundComponent);
      }

      return newChildren;
    }
  }, {
    key: "renderContainer",
    value: function renderContainer(containerComponent, props) {
      var containerProps = defaults_1({}, containerComponent.props, props);

      return React__default['default'].cloneElement(containerComponent, containerProps);
    }
  }, {
    key: "getContainerProps",
    value: function getContainerProps(props, calculatedProps) {
      var width = props.width,
          height = props.height,
          standalone = props.standalone,
          theme = props.theme,
          polar = props.polar,
          name = props.name;
      var domain = calculatedProps.domain,
          scale = calculatedProps.scale,
          style = calculatedProps.style,
          origin = calculatedProps.origin,
          radius = calculatedProps.radius,
          horizontal = calculatedProps.horizontal;
      return {
        domain: domain,
        scale: scale,
        width: width,
        height: height,
        standalone: standalone,
        theme: theme,
        style: style.parent,
        horizontal: horizontal,
        name: name,
        polar: polar,
        radius: radius,
        origin: polar ? origin : undefined
      };
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.state && this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
      var modifiedProps = Helpers.modifyProps(props, fallbackProps$3, "chart");
      var eventKey = modifiedProps.eventKey,
          containerComponent = modifiedProps.containerComponent,
          groupComponent = modifiedProps.groupComponent,
          standalone = modifiedProps.standalone,
          externalEventMutations = modifiedProps.externalEventMutations;
      var axes = props.polar ? modifiedProps.defaultPolarAxes : modifiedProps.defaultAxes;
      var childComponents = getChildComponents(modifiedProps, axes);
      var calculatedProps = getCalculatedProps$1(modifiedProps, childComponents);
      var newChildren = this.getNewChildren(modifiedProps, childComponents, calculatedProps);
      var containerProps = standalone ? this.getContainerProps(modifiedProps, calculatedProps) : {};
      var container = standalone ? this.renderContainer(containerComponent, containerProps) : groupComponent;
      var events = Wrapper$b.getAllEvents(props);

      if (!isEmpty_1(events)) {
        return React__default['default'].createElement(VictorySharedEvents, {
          container: container,
          eventKey: eventKey,
          events: events,
          externalEventMutations: externalEventMutations
        }, newChildren);
      }

      return React__default['default'].cloneElement(container, container.props, newChildren);
    }
  }]);

  return VictoryChart;
}(React__default['default'].Component);

Object.defineProperty(VictoryChart, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryChart"
});
Object.defineProperty(VictoryChart, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: _objectSpread$d({}, CommonProps.baseProps, {
    backgroundComponent: PropTypes__default['default'].element,
    children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].node), PropTypes__default['default'].node]),
    defaultAxes: PropTypes__default['default'].shape({
      independent: PropTypes__default['default'].element,
      dependent: PropTypes__default['default'].element
    }),
    defaultPolarAxes: PropTypes__default['default'].shape({
      independent: PropTypes__default['default'].element,
      dependent: PropTypes__default['default'].element
    }),
    endAngle: PropTypes__default['default'].number,
    innerRadius: CustomPropTypes.nonNegative,
    prependDefaultAxes: PropTypes__default['default'].bool,
    startAngle: PropTypes__default['default'].number
  })
});
Object.defineProperty(VictoryChart, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    backgroundComponent: React__default['default'].createElement(Background, null),
    containerComponent: React__default['default'].createElement(VictoryContainer, null),
    defaultAxes: {
      independent: React__default['default'].createElement(VictoryAxis$1, null),
      dependent: React__default['default'].createElement(VictoryAxis$1, {
        dependentAxis: true
      })
    },
    defaultPolarAxes: {
      independent: React__default['default'].createElement(VictoryPolarAxis$1, null),
      dependent: React__default['default'].createElement(VictoryPolarAxis$1, {
        dependentAxis: true
      })
    },
    groupComponent: React__default['default'].createElement("g", null),
    standalone: true,
    theme: VictoryTheme.grayscale
  }
});
Object.defineProperty(VictoryChart, "expectedComponents", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["groupComponent", "containerComponent"]
});

var fallbackProps$4 = {
  width: 450,
  height: 300,
  padding: 50
}; // Assumes data in `datasets` is sorted by `Data.getData`.

function fillData(props, datasets) {
  var fillInMissingData = props.fillInMissingData;
  var xMap = datasets.reduce(function (prev, dataset) {
    dataset.forEach(function (datum) {
      prev[datum._x instanceof Date ? datum._x.getTime() : datum._x] = true;
    });
    return prev;
  }, {});

  var xKeys = keys_1(xMap).map(function (k) {
    return +k;
  });

  var xArr = orderBy_1(xKeys);

  return datasets.map(function (dataset) {
    var indexOffset = 0;
    var isDate = dataset[0] && dataset[0]._x instanceof Date;
    var filledInData = xArr.map(function (x, index) {
      x = +x;
      var datum = dataset[index - indexOffset];

      if (datum) {
        var x1 = isDate ? datum._x.getTime() : datum._x;

        if (x1 === x) {
          return datum;
        } else {
          indexOffset++;
          var y = fillInMissingData ? 0 : null;
          x = isDate ? new Date(x) : x;
          return {
            x: x,
            y: y,
            _x: x,
            _y: y
          };
        }
      } else {
        var _y = fillInMissingData ? 0 : null;

        x = isDate ? new Date(x) : x;
        return {
          x: x,
          y: _y,
          _x: x,
          _y: _y
        };
      }
    });
    return filledInData;
  });
}

function getY0(datum, index, datasets) {
  if (datum.y0) {
    return datum.y0;
  }

  var y = datum._y;
  var previousDatasets = datasets.slice(0, index);
  var previousPoints = previousDatasets.reduce(function (prev, dataset) {
    return prev.concat(dataset.filter(function (previousDatum) {
      return datum._x instanceof Date ? previousDatum._x.getTime() === datum._x.getTime() : previousDatum._x === datum._x;
    }).map(function (previousDatum) {
      return previousDatum._y || 0;
    }));
  }, []);
  var y0 = previousPoints.length && previousPoints.reduce(function (memo, value) {
    var sameSign = y < 0 && value < 0 || y >= 0 && value >= 0;
    return sameSign ? +value + memo : memo;
  }, 0);
  return previousPoints.some(function (point) {
    return point instanceof Date;
  }) ? new Date(y0) : y0;
}
/* eslint-disable no-nested-ternary */


function addLayoutData(props, datasets, index) {
  var xOffset = props.xOffset || 0;
  return datasets[index].map(function (datum) {
    var yOffset = getY0(datum, index, datasets) || 0;
    return assign_1({}, datum, {
      _y0: !(datum._y instanceof Date) ? yOffset : yOffset ? new Date(yOffset) : datum._y,
      _y1: datum._y === null ? null : datum._y instanceof Date ? new Date(+datum._y + +yOffset) : datum._y + yOffset,
      _x1: datum._x === null ? null : datum._x instanceof Date ? new Date(+datum._x + +xOffset) : datum._x + xOffset
    });
  });
}
/* eslint-enable no-nested-ternary */


function stackData(props, childComponents) {
  var dataFromChildren = Wrapper$b.getDataFromChildren(props, childComponents);
  var datasets = fillData(props, dataFromChildren);
  return datasets.map(function (d, i) {
    return addLayoutData(props, datasets, i);
  });
}

function getCalculatedProps$2(props, childComponents) {
  childComponents = childComponents || React__default['default'].Children.toArray(props.children);
  var role = "stack";
  props = Helpers.modifyProps(props, fallbackProps$4, role);
  var style = Wrapper$b.getStyle(props.theme, props.style, role);
  var categories = props.categories || Wrapper$b.getCategories(props, childComponents);
  var datasets = props.datasets || stackData(props, childComponents);
  var children = childComponents.map(function (c, i) {
    return React__default['default'].cloneElement(c, {
      data: datasets[i]
    });
  });
  var domain = {
    x: Wrapper$b.getDomain(assign_1({}, props, {
      categories: categories
    }), "x", children),
    y: Wrapper$b.getDomain(assign_1({}, props, {
      categories: categories
    }), "y", children)
  };
  var range = props.range || {
    x: Helpers.getRange(props, "x"),
    y: Helpers.getRange(props, "y")
  };
  var baseScale = {
    x: Scale.getScaleFromProps(props, "x") || Wrapper$b.getScale(props, "x"),
    y: Scale.getScaleFromProps(props, "y") || Wrapper$b.getScale(props, "y")
  };
  var scale = {
    x: baseScale.x.domain(domain.x).range(props.horizontal ? range.y : range.x),
    y: baseScale.y.domain(domain.y).range(props.horizontal ? range.x : range.y)
  };
  var _props = props,
      colorScale = _props.colorScale,
      horizontal = _props.horizontal;
  return {
    datasets: datasets,
    categories: categories,
    range: range,
    domain: domain,
    horizontal: horizontal,
    scale: scale,
    style: style,
    colorScale: colorScale,
    role: role
  };
}

function getLabels(props, datasets, index) {
  if (!props.labels) {
    return undefined;
  }

  return datasets.length === index + 1 ? props.labels : undefined;
}

function getChildProps$1(props, calculatedProps) {
  var categories = calculatedProps.categories,
      domain = calculatedProps.domain,
      range = calculatedProps.range,
      scale = calculatedProps.scale,
      horizontal = calculatedProps.horizontal;
  return {
    height: props.height,
    width: props.width,
    padding: Helpers.getPadding(props),
    standalone: false,
    theme: props.theme,
    categories: categories,
    domain: domain,
    range: range,
    scale: scale,
    horizontal: horizontal
  };
}

function getColorScale(props, child) {
  var role = child.type && child.type.role;
  var colorScaleOptions = child.props.colorScale || props.colorScale;

  if (role !== "group" && role !== "stack") {
    return undefined;
  }

  return props.theme ? colorScaleOptions || props.theme.props.colorScale : colorScaleOptions;
}

function getChildren$1(props, childComponents, calculatedProps) {
  props = Helpers.modifyProps(props, fallbackProps$4, "stack");
  childComponents = childComponents || React__default['default'].Children.toArray(props.children);
  calculatedProps = calculatedProps || getCalculatedProps$2(props, childComponents);
  var _calculatedProps = calculatedProps,
      datasets = _calculatedProps.datasets;
  var childProps = getChildProps$1(props, calculatedProps);
  var parentName = props.name || "stack";
  return childComponents.map(function (child, index) {
    var role = child.type && child.type.role;
    var data = datasets[index];
    var style = Wrapper$b.getChildStyle(child, index, calculatedProps);
    var labels = props.labels ? getLabels(props, datasets, index) : child.props.labels;
    var name = child.props.name || "".concat(parentName, "-").concat(role, "-").concat(index);
    return React__default['default'].cloneElement(child, assign_1({
      key: "".concat(name, "-key-").concat(index),
      labels: labels,
      name: name,
      domainPadding: child.props.domainPadding || props.domainPadding,
      theme: props.theme,
      labelComponent: props.labelComponent || child.props.labelComponent,
      style: style,
      colorScale: getColorScale(props, child),
      data: data,
      polar: props.polar
    }, childProps));
  });
}

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$i(target, key, source[key]); }); } return target; }

function _defineProperty$i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$d(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$d(Constructor.prototype, protoProps); if (staticProps) _defineProperties$d(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$c(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$g(self); }

function _inherits$c(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized$g(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
var fallbackProps$5 = {
  width: 450,
  height: 300,
  padding: 50
};

var VictoryStack =
/*#__PURE__*/
function (_React$Component) {
  _inherits$c(VictoryStack, _React$Component);

  function VictoryStack(props) {
    var _this;

    _classCallCheck$d(this, VictoryStack);

    _this = _possibleConstructorReturn$c(this, (VictoryStack.__proto__ || Object.getPrototypeOf(VictoryStack)).call(this, props));

    if (props.animate) {
      _this.state = {
        nodesShouldLoad: false,
        nodesDoneLoad: false,
        animating: true
      };
      _this.setAnimationState = Wrapper$b.setAnimationState.bind(_assertThisInitialized$g(_this));
    }

    return _this;
  }

  _createClass$d(VictoryStack, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.animate) {
        if (!reactFastCompare(this.props, nextProps)) {
          this.setAnimationState(this.props, nextProps);
          return false;
        }
      }

      return true;
    }
  }, {
    key: "getNewChildren",
    value: function getNewChildren(props, childComponents, calculatedProps) {
      var children = getChildren$1(props, childComponents, calculatedProps);
      var getAnimationProps = Wrapper$b.getAnimationProps.bind(this);
      var newChildren = children.map(function (child, index) {
        var childProps = assign_1({
          animate: getAnimationProps(props, child, index)
        }, child.props);

        return React__default['default'].cloneElement(child, childProps);
      });
      /*
        reverse render order for children of `VictoryStack` so that higher children in the stack
        are rendered behind lower children. This looks nicer for stacked bars with cornerRadius, and
        areas with strokes
      */

      return newChildren.reverse();
    }
  }, {
    key: "renderContainer",
    value: function renderContainer(containerComponent, props) {
      var containerProps = defaults_1({}, containerComponent.props, props);

      return React__default['default'].cloneElement(containerComponent, containerProps);
    }
  }, {
    key: "getContainerProps",
    value: function getContainerProps(props, calculatedProps) {
      var width = props.width,
          height = props.height,
          standalone = props.standalone,
          theme = props.theme,
          polar = props.polar,
          horizontal = props.horizontal,
          name = props.name;
      var domain = calculatedProps.domain,
          scale = calculatedProps.scale,
          style = calculatedProps.style,
          origin = calculatedProps.origin;
      return {
        domain: domain,
        scale: scale,
        width: width,
        height: height,
        standalone: standalone,
        theme: theme,
        style: style.parent,
        horizontal: horizontal,
        polar: polar,
        origin: origin,
        name: name
      };
    }
  }, {
    key: "render",
    value: function render() {
      var role = this.constructor.role;
      var props = this.state && this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
      var modifiedProps = Helpers.modifyProps(props, fallbackProps$5, role);
      var eventKey = modifiedProps.eventKey,
          containerComponent = modifiedProps.containerComponent,
          standalone = modifiedProps.standalone,
          groupComponent = modifiedProps.groupComponent,
          externalEventMutations = modifiedProps.externalEventMutations;
      var childComponents = React__default['default'].Children.toArray(modifiedProps.children);
      var calculatedProps = getCalculatedProps$2(modifiedProps, childComponents);
      var newChildren = this.getNewChildren(modifiedProps, childComponents, calculatedProps);
      var containerProps = standalone ? this.getContainerProps(modifiedProps, calculatedProps) : {};
      var container = standalone ? this.renderContainer(containerComponent, containerProps) : groupComponent;
      var events = Wrapper$b.getAllEvents(props);

      if (!isEmpty_1(events)) {
        return React__default['default'].createElement(VictorySharedEvents, {
          container: container,
          eventKey: eventKey,
          events: events,
          externalEventMutations: externalEventMutations
        }, newChildren);
      }

      return React__default['default'].cloneElement(container, container.props, newChildren);
    }
  }]);

  return VictoryStack;
}(React__default['default'].Component);

Object.defineProperty(VictoryStack, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryStack"
});
Object.defineProperty(VictoryStack, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "stack"
});
Object.defineProperty(VictoryStack, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: _objectSpread$e({}, CommonProps.baseProps, {
    bins: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].instanceOf(Date)])), CustomPropTypes.nonNegative]),
    categories: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].shape({
      x: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
      y: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)
    })]),
    children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].node), PropTypes__default['default'].node]),
    colorScale: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
    fillInMissingData: PropTypes__default['default'].bool,
    horizontal: PropTypes__default['default'].bool,
    labelComponent: PropTypes__default['default'].element,
    labels: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].array]),
    style: PropTypes__default['default'].shape({
      parent: PropTypes__default['default'].object,
      data: PropTypes__default['default'].object,
      labels: PropTypes__default['default'].object
    }),
    xOffset: PropTypes__default['default'].number
  })
});
Object.defineProperty(VictoryStack, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    containerComponent: React__default['default'].createElement(VictoryContainer, null),
    groupComponent: React__default['default'].createElement("g", null),
    standalone: true,
    theme: VictoryTheme.grayscale,
    fillInMissingData: true
  }
});
Object.defineProperty(VictoryStack, "expectedComponents", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["groupComponent", "containerComponent", "labelComponent"]
});
Object.defineProperty(VictoryStack, "getChildren", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: getChildren$1
});

var pi$1 = Math.PI,
    tau$1 = 2 * pi$1,
    epsilon = 1e-6,
    tauEpsilon = tau$1 - epsilon;

function Path$2() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path$2;
}

Path$2.prototype = path.prototype = {
  constructor: Path$2,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$1 + tau$1;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$1)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function constant$3(x) {
  return function constant() {
    return x;
  };
}

var abs$2 = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max$1 = Math.max;
var min$1 = Math.min;
var sin = Math.sin;
var sqrt$1 = Math.sqrt;

var epsilon$1 = 1e-12;
var pi$2 = Math.PI;
var halfPi$1 = pi$2 / 2;
var tau$2 = 2 * pi$2;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi$2 : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi$1 : x <= -1 ? -halfPi$1 : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < epsilon$1) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt$1(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt$1(max$1(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

function arc() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant$3(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi$1,
        a1 = endAngle.apply(this, arguments) - halfPi$1,
        da = abs$2(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon$1)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau$2 - epsilon$1) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$1) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon$1) && (padRadius ? +padRadius.apply(this, arguments) : sqrt$1(r0 * r0 + r1 * r1)),
          rc = min$1(abs$2(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon$1) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon$1) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$1) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);

      // Apply rounded corners?
      if (rc > epsilon$1) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < pi$2 && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt$1(ax * ax + ay * ay) * sqrt$1(bx * bx + by * by))) / 2),
              lc = sqrt$1(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min$1(rc, (r0 - lc) / (kc - 1));
          rc1 = min$1(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon$1)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon$1) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon$1) || !(da0 > epsilon$1)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon$1) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$2 / 2;
    return [cos(a) * r, sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$3(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$3(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$3(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$3(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$3(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$3(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
}

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

function curveLinear(context) {
  return new Linear(context);
}

function x$3(p) {
  return p[0];
}

function y$3(p) {
  return p[1];
}

function line() {
  var x = x$3,
      y = y$3,
      defined = constant$3(true),
      context = null,
      curve = curveLinear,
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$3(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$3(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$3(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
}

function area() {
  var x0 = x$3,
      x1 = null,
      y0 = constant$3(0),
      y1 = y$3,
      defined = constant$3(true),
      context = null,
      curve = curveLinear,
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$3(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$3(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$3(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$3(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$3(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
}

function descending(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

function identity$3(d) {
  return d;
}

function pie() {
  var value = identity$3,
      sortValues = descending,
      sort = null,
      startAngle = constant$3(0),
      endAngle = constant$3(tau$2),
      padAngle = constant$3(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau$2, Math.max(-tau$2, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$3(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$3(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$3(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$3(+_), pie) : padAngle;
  };

  return pie;
}

var curveRadialLinear = curveRadial(curveLinear);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}

function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return l;
}

function lineRadial$1() {
  return lineRadial(line().curve(curveRadialLinear));
}

function areaRadial() {
  var a = area().curve(curveRadialLinear),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return a;
}

function pointRadial(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}

var slice$3 = Array.prototype.slice;

function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = x$3,
      y = y$3,
      context = null;

  function link() {
    var buffer, argv = slice$3.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = path();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$3(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$3(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial$1(context, x0, y0, x1, y1) {
  var p0 = pointRadial(x0, y0),
      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
      p2 = pointRadial(x1, y0),
      p3 = pointRadial(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial$1);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}

var circle = {
  draw: function(context, size) {
    var r = Math.sqrt(size / pi$2);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau$2);
  }
};

var cross = {
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
};

var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

var diamond = {
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
};

var ka = 0.89081309152928522810,
    kr = Math.sin(pi$2 / 10) / Math.sin(7 * pi$2 / 10),
    kx = Math.sin(tau$2 / 10) * kr,
    ky = -Math.cos(tau$2 / 10) * kr;

var star = {
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = tau$2 * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
};

var square = {
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
};

var sqrt3 = Math.sqrt(3);

var triangle = {
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
};

var c$3 = -0.5,
    s = Math.sqrt(3) / 2,
    k$3 = 1 / Math.sqrt(12),
    a$1 = (k$3 / 2 + 1) * 3;

var wye = {
  draw: function(context, size) {
    var r = Math.sqrt(size / a$1),
        x0 = r / 2,
        y0 = r * k$3,
        x1 = x0,
        y1 = r * k$3 + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c$3 * x0 - s * y0, s * x0 + c$3 * y0);
    context.lineTo(c$3 * x1 - s * y1, s * x1 + c$3 * y1);
    context.lineTo(c$3 * x2 - s * y2, s * x2 + c$3 * y2);
    context.lineTo(c$3 * x0 + s * y0, c$3 * y0 - s * x0);
    context.lineTo(c$3 * x1 + s * y1, c$3 * y1 - s * x1);
    context.lineTo(c$3 * x2 + s * y2, c$3 * y2 - s * x2);
    context.closePath();
  }
};

var symbols = [
  circle,
  cross,
  diamond,
  square,
  star,
  triangle,
  wye
];

function symbol$1() {
  var type = constant$3(circle),
      size = constant$3(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = path();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant$3(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant$3(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
}

function noop$5() {}

function point$1(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point$1(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point$1(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function basis(context) {
  return new Basis(context);
}

function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: noop$5,
  areaEnd: noop$5,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: point$1(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function basisClosed(context) {
  return new BasisClosed(context);
}

function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: point$1(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function basisOpen(context) {
  return new BasisOpen(context);
}

function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

var bundle$1 = (function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85);

function point$2(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point$2(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinal = (function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: noop$5,
  areaEnd: noop$5,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalClosed = (function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalOpen = (function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function point$3(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > epsilon$1) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > epsilon$1) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point$3(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRom = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: noop$5,
  areaEnd: noop$5,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$3(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomClosed = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$3(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomOpen = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: noop$5,
  areaEnd: noop$5,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

function linearClosed(context) {
  return new LinearClosed(context);
}

function sign$1(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign$1(s0) + sign$1(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point$4(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point$4(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point$4(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point$4(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

function natural(context) {
  return new Natural(context);
}

function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

function step(context) {
  return new Step(context, 0.5);
}

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

function none(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

function none$1(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}

function stackValue(d, key) {
  return d[key];
}

function stack() {
  var keys = constant$3([]),
      order = none$1,
      offset = none,
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$3(slice$3.call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$3(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant$3(slice$3.call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
  };

  return stack;
}

function expand$1(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  none(series, order);
}

function diverging(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = 0, d[1] = dy;
      }
    }
  }
}

function silhouette(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  none(series, order);
}

function wiggle(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  none(series, order);
}

function appearance(series) {
  var peaks = series.map(peak);
  return none$1(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
}

function peak(series) {
  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  return j;
}

function ascending$1(series) {
  var sums = series.map(sum);
  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
}

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

function descending$1(series) {
  return ascending$1(series).reverse();
}

function insideOut(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(sum),
      order = appearance(series),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
}

function reverse(series) {
  return none$1(series).reverse();
}

var d3Shape = /*#__PURE__*/Object.freeze({
  __proto__: null,
  arc: arc,
  area: area,
  line: line,
  pie: pie,
  areaRadial: areaRadial,
  radialArea: areaRadial,
  lineRadial: lineRadial$1,
  radialLine: lineRadial$1,
  pointRadial: pointRadial,
  linkHorizontal: linkHorizontal,
  linkVertical: linkVertical,
  linkRadial: linkRadial,
  symbol: symbol$1,
  symbols: symbols,
  symbolCircle: circle,
  symbolCross: cross,
  symbolDiamond: diamond,
  symbolSquare: square,
  symbolStar: star,
  symbolTriangle: triangle,
  symbolWye: wye,
  curveBasisClosed: basisClosed,
  curveBasisOpen: basisOpen,
  curveBasis: basis,
  curveBundle: bundle$1,
  curveCardinalClosed: cardinalClosed,
  curveCardinalOpen: cardinalOpen,
  curveCardinal: cardinal,
  curveCatmullRomClosed: catmullRomClosed,
  curveCatmullRomOpen: catmullRomOpen,
  curveCatmullRom: catmullRom,
  curveLinearClosed: linearClosed,
  curveLinear: curveLinear,
  curveMonotoneX: monotoneX,
  curveMonotoneY: monotoneY,
  curveNatural: natural,
  curveStep: step,
  curveStepAfter: stepAfter,
  curveStepBefore: stepBefore,
  stack: stack,
  stackOffsetExpand: expand$1,
  stackOffsetDiverging: diverging,
  stackOffsetNone: none,
  stackOffsetSilhouette: silhouette,
  stackOffsetWiggle: wiggle,
  stackOrderAppearance: appearance,
  stackOrderAscending: ascending$1,
  stackOrderDescending: descending$1,
  stackOrderInsideOut: insideOut,
  stackOrderNone: none$1,
  stackOrderReverse: reverse
});

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } return target; }

function _defineProperty$j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getPath = function (props) {
  var slice = props.slice,
      radius = props.radius,
      innerRadius = props.innerRadius,
      cornerRadius = props.cornerRadius;

  if (isFunction_1(props.pathFunction)) {
    return props.pathFunction(slice);
  }

  var padAngle = Helpers.degreesToRadians(props.padAngle);
  var startAngle = Helpers.degreesToRadians(props.sliceStartAngle);
  var endAngle = Helpers.degreesToRadians(props.sliceEndAngle);
  var pathFunction = arc().cornerRadius(cornerRadius).outerRadius(radius).innerRadius(innerRadius || 0);
  return pathFunction(defaults_1({
    startAngle: startAngle,
    endAngle: endAngle,
    padAngle: padAngle
  }, slice));
};

var evaluateProps$4 = function (props) {
  /**
   * * Potential evaluated props of following must be evaluated in this order:
   * 1) `style`
   * 2) `radius`
   * 3) `innerRadius`
   *
   * Everything else does not have to be evaluated in a particular order:
   * `ariaLabel`
   * `id`
   * `cornerRadius`
   * `padAngle`
   * `sliceStartAngle`
   * `sliceEndAngle`
   * `tabIndex`
   */
  var style = Helpers.evaluateStyle(props.style, props);
  var radius = Helpers.evaluateProp(props.radius, assign_1({}, props, {
    style: style
  }));
  var innerRadius = Helpers.evaluateProp(props.innerRadius, assign_1({}, props, {
    style: style,
    radius: radius
  }));
  var ariaLabel = Helpers.evaluateProp(props.ariaLabel, props);
  var id = Helpers.evaluateProp(props.id, props);
  var cornerRadius = Helpers.evaluateProp(props.cornerRadius, props);
  var padAngle = Helpers.evaluateProp(props.padAngle, props);
  var sliceStartAngle = Helpers.evaluateProp(props.sliceStartAngle, props);
  var sliceEndAngle = Helpers.evaluateProp(props.sliceEndAngle, props);
  var tabIndex = Helpers.evaluateProp(props.tabIndex, props);
  return assign_1({}, props, {
    ariaLabel: ariaLabel,
    style: style,
    radius: radius,
    innerRadius: innerRadius,
    id: id,
    cornerRadius: cornerRadius,
    padAngle: padAngle,
    sliceStartAngle: sliceStartAngle,
    sliceEndAngle: sliceEndAngle,
    tabIndex: tabIndex
  });
};

var Slice = function (props) {
  props = evaluateProps$4(props);
  var defaultTransform = props.origin ? "translate(".concat(props.origin.x, ", ").concat(props.origin.y, ")") : undefined;
  return React__default['default'].cloneElement(props.pathComponent, _objectSpread$f({}, props.events, {
    "aria-label": props.ariaLabel,
    d: getPath(props),
    style: props.style,
    transform: props.transform || defaultTransform,
    className: props.className,
    role: props.role,
    shapeRendering: props.shapeRendering,
    clipPath: props.clipPath,
    tabIndex: props.tabIndex
  }));
};

Slice.propTypes = _objectSpread$f({}, CommonProps.primitiveProps, {
  cornerRadius: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
  datum: PropTypes__default['default'].object,
  innerRadius: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
  padAngle: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
  pathComponent: PropTypes__default['default'].element,
  pathFunction: PropTypes__default['default'].func,
  radius: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
  slice: PropTypes__default['default'].object,
  sliceEndAngle: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
  sliceStartAngle: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func])
});
Slice.defaultProps = {
  pathComponent: React__default['default'].createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};

var checkForValidText = function (text) {
  if (text === undefined || text === null || isFunction_1(text)) {
    return text;
  } else {
    return "".concat(text);
  }
};

var getColor = function (style, colors, index) {
  if (style && style.data && style.data.fill) {
    return style.data.fill;
  }

  return colors && colors[index % colors.length];
};

var getRadius$2 = function (props, padding) {
  if (typeof props.radius === "number") {
    return props.radius;
  }

  return Math.min(props.width - padding.left - padding.right, props.height - padding.top - padding.bottom) / 2;
};

var getOrigin$2 = function (props, padding) {
  var width = props.width,
      height = props.height;
  var origin = isPlainObject_1(props.origin) ? props.origin : {};
  return {
    x: origin.x !== undefined ? origin.x : (padding.left - padding.right + width) / 2,
    y: origin.y !== undefined ? origin.y : (padding.top - padding.bottom + height) / 2
  };
};

var getSlices = function (props, data) {
  var padAngle = isFunction_1(props.padAngle) ? 0 : props.padAngle;
  var layoutFunction = pie().sort(null).startAngle(Helpers.degreesToRadians(props.startAngle)).endAngle(Helpers.degreesToRadians(props.endAngle)).padAngle(Helpers.degreesToRadians(padAngle)).value(function (datum) {
    return datum._y;
  });
  return layoutFunction(data);
};

var getCalculatedValues$2 = function (props) {
  var colorScale = props.colorScale;
  var styleObject = Helpers.getDefaultStyles(props, "pie");
  var style = Helpers.getStyles(props.style, styleObject, "auto", "100%");
  var colors = Array.isArray(colorScale) ? colorScale : Style.getColorScale(colorScale);
  var padding = Helpers.getPadding(props);
  var defaultRadius = getRadius$2(props, padding);
  var origin = getOrigin$2(props, padding);
  var data = Data.getData(props);
  var slices = getSlices(props, data);
  return assign_1({}, props, {
    style: style,
    colors: colors,
    padding: padding,
    defaultRadius: defaultRadius,
    data: data,
    slices: slices,
    origin: origin
  });
};

var getSliceStyle = function (index, calculatedValues) {
  var style = calculatedValues.style,
      colors = calculatedValues.colors;
  var fill = getColor(style, colors, index);
  return assign_1({
    fill: fill
  }, style.data);
};

var getLabelText = function (props, datum, index) {
  var text;

  if (datum.label) {
    text = datum.label;
  } else if (Array.isArray(props.labels)) {
    text = props.labels[index];
  } else {
    text = isFunction_1(props.labels) ? props.labels : datum.xName || datum._x;
  }

  return checkForValidText(text);
};

var getLabelArc = function (radius, labelRadius, style) {
  var padding = style && style.padding || 0;
  var arcRadius = labelRadius || radius + padding;
  return arc().outerRadius(arcRadius).innerRadius(arcRadius);
};

var getLabelPosition = function (arc, slice, position) {
  var construct = {
    startAngle: position === "startAngle" ? slice.startAngle : slice.endAngle,
    endAngle: position === "endAngle" ? slice.endAngle : slice.startAngle
  };

  var clonedArc = assign_1({}, slice, construct);

  return arc.centroid(clonedArc);
};

var getLabelOrientation = function (degree, labelPlacement) {
  if (labelPlacement === "perpendicular") {
    return degree > 90 && degree < 270 ? "bottom" : "top";
  } else if (labelPlacement === "parallel") {
    return degree >= 0 && degree <= 180 ? "right" : "left";
  }

  if (degree < 45 || degree > 315) {
    return "top";
  } else if (degree >= 45 && degree < 135) {
    return "right";
  } else if (degree >= 135 && degree < 225) {
    return "bottom";
  } else {
    return "left";
  }
};

var getTextAnchor$1 = function (orientation) {
  if (orientation === "top" || orientation === "bottom") {
    return "middle";
  }

  return orientation === "right" ? "start" : "end";
};

var getVerticalAnchor$1 = function (orientation) {
  if (orientation === "left" || orientation === "right") {
    return "middle";
  }

  return orientation === "bottom" ? "start" : "end";
};

var getBaseLabelAngle = function (slice, labelPosition, labelStyle) {
  var baseAngle = 0;

  if (labelPosition.angle !== undefined) {
    baseAngle = labelStyle.angle;
  } else if (labelPosition === "centroid") {
    baseAngle = Helpers.radiansToDegrees((slice.startAngle + slice.endAngle) / 2);
  } else {
    baseAngle = labelPosition === "startAngle" ? Helpers.radiansToDegrees(slice.startAngle) : Helpers.radiansToDegrees(slice.endAngle);
  }

  var positiveAngle = baseAngle < 0 ? 360 - baseAngle : baseAngle;
  return positiveAngle % 360;
};

var getLabelAngle = function (baseAngle, labelPlacement) {
  if (labelPlacement === "vertical") {
    return 0;
  }

  if (labelPlacement === "parallel") {
    return baseAngle > 180 && baseAngle < 360 ? baseAngle + 90 : baseAngle - 90;
  }

  return baseAngle > 90 && baseAngle < 270 ? baseAngle - 180 : baseAngle;
};

var getLabelProps = function (text, dataProps, calculatedValues) {
  var index = dataProps.index,
      datum = dataProps.datum,
      data = dataProps.data,
      slice = dataProps.slice,
      labelComponent = dataProps.labelComponent,
      theme = dataProps.theme;
  var style = calculatedValues.style,
      defaultRadius = calculatedValues.defaultRadius,
      origin = calculatedValues.origin,
      width = calculatedValues.width,
      height = calculatedValues.height;
  var labelRadius = Helpers.evaluateProp(calculatedValues.labelRadius, assign_1({
    text: text
  }, dataProps));
  var labelPosition = Helpers.evaluateProp(calculatedValues.labelPosition, assign_1({
    text: text
  }, dataProps)) || "centroid";
  var labelPlacement = Helpers.evaluateProp(calculatedValues.labelPlacement, assign_1({
    text: text
  }, dataProps)) || "vertical";

  var labelStyle = assign_1({
    padding: 0
  }, style.labels);

  var evaluatedStyle = Helpers.evaluateStyle(labelStyle, assign_1({
    labelRadius: labelRadius,
    text: text
  }, dataProps));
  var labelArc = getLabelArc(defaultRadius, labelRadius, evaluatedStyle);
  var position = getLabelPosition(labelArc, slice, labelPosition);
  var baseAngle = getBaseLabelAngle(slice, labelPosition, labelStyle);
  var labelAngle = getLabelAngle(baseAngle, labelPlacement);
  var orientation = getLabelOrientation(baseAngle, labelPlacement);
  var textAnchor = labelStyle.textAnchor || getTextAnchor$1(orientation);
  var verticalAnchor = labelStyle.verticalAnchor || getVerticalAnchor$1(orientation);
  var labelProps = {
    width: width,
    height: height,
    index: index,
    datum: datum,
    data: data,
    slice: slice,
    orientation: orientation,
    text: text,
    style: labelStyle,
    x: Math.round(position[0]) + origin.x,
    y: Math.round(position[1]) + origin.y,
    textAnchor: textAnchor,
    verticalAnchor: verticalAnchor,
    angle: labelAngle
  };

  if (!Helpers.isTooltip(labelComponent)) {
    return labelProps;
  }

  var tooltipTheme = theme && theme.tooltip || {};
  return defaults_1({}, labelProps, Helpers.omit(tooltipTheme, ["style"]));
};

var getBaseProps$2 = function (props, fallbackProps) {
  props = Helpers.modifyProps(props, fallbackProps, "pie");
  var calculatedValues = getCalculatedValues$2(props);
  var slices = calculatedValues.slices,
      style = calculatedValues.style,
      data = calculatedValues.data,
      origin = calculatedValues.origin,
      defaultRadius = calculatedValues.defaultRadius,
      labels = calculatedValues.labels,
      events = calculatedValues.events,
      sharedEvents = calculatedValues.sharedEvents,
      height = calculatedValues.height,
      width = calculatedValues.width,
      standalone = calculatedValues.standalone,
      name = calculatedValues.name,
      innerRadius = calculatedValues.innerRadius,
      cornerRadius = calculatedValues.cornerRadius,
      padAngle = calculatedValues.padAngle;
  var radius = props.radius || defaultRadius;
  var initialChildProps = {
    parent: {
      standalone: standalone,
      height: height,
      width: width,
      slices: slices,
      name: name,
      style: style.parent
    }
  };
  return slices.reduce(function (childProps, slice, index) {
    var datum = defaults_1({}, data[index], {
      startAngle: Helpers.radiansToDegrees(slice.startAngle),
      endAngle: Helpers.radiansToDegrees(slice.endAngle),
      padAngle: Helpers.radiansToDegrees(slice.padAngle)
    });

    var eventKey = !isNil_1(datum.eventKey) ? datum.eventKey : index;
    var dataProps = {
      index: index,
      slice: slice,
      datum: datum,
      data: data,
      origin: origin,
      innerRadius: innerRadius,
      radius: radius,
      cornerRadius: cornerRadius,
      padAngle: padAngle,
      style: getSliceStyle(index, calculatedValues)
    };
    childProps[eventKey] = {
      data: dataProps
    };
    var text = getLabelText(props, datum, index);

    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
      var evaluatedText = Helpers.evaluateProp(text, dataProps);
      childProps[eventKey].labels = getLabelProps(evaluatedText, assign_1({}, props, dataProps), calculatedValues);
    }

    return childProps;
  }, initialChildProps);
};

function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$e(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$e(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$e(Constructor.prototype, protoProps); if (staticProps) _defineProperties$e(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$d(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$h(self); }

function _assertThisInitialized$h(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$d(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var fallbackProps$6 = {
  endAngle: 360,
  height: 400,
  innerRadius: 0,
  cornerRadius: 0,
  padAngle: 0,
  padding: 30,
  width: 400,
  startAngle: 0,
  colorScale: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
  labelPosition: "centroid"
};

var VictoryPie =
/*#__PURE__*/
function (_React$Component) {
  _inherits$d(VictoryPie, _React$Component);

  function VictoryPie() {
    _classCallCheck$e(this, VictoryPie);

    return _possibleConstructorReturn$d(this, (VictoryPie.__proto__ || Object.getPrototypeOf(VictoryPie)).apply(this, arguments));
  }

  _createClass$e(VictoryPie, [{
    key: "shouldAnimate",
    // Overridden in victory-native
    value: function shouldAnimate() {
      return Boolean(this.props.animate);
    }
  }, {
    key: "render",
    value: function render() {
      var animationWhitelist = VictoryPie.animationWhitelist,
          role = VictoryPie.role;
      var props = Helpers.modifyProps(this.props, fallbackProps$6, role);

      if (this.shouldAnimate()) {
        return this.animateComponent(props, animationWhitelist);
      }

      var children = this.renderData(props);
      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
    }
  }]);

  return VictoryPie;
}(React__default['default'].Component);

Object.defineProperty(VictoryPie, "animationWhitelist", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["data", "endAngle", "height", "innerRadius", "cornerRadius", "padAngle", "padding", "colorScale", "startAngle", "style", "width"]
});
Object.defineProperty(VictoryPie, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryPie"
});
Object.defineProperty(VictoryPie, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "pie"
});
Object.defineProperty(VictoryPie, "defaultTransitions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onExit: {
      duration: 500,
      before: function () {
        return {
          _y: 0,
          label: " "
        };
      }
    },
    onEnter: {
      duration: 500,
      before: function () {
        return {
          _y: 0,
          label: " "
        };
      },
      after: function (datum) {
        return {
          y_: datum._y,
          label: datum.label
        };
      }
    }
  }
});
Object.defineProperty(VictoryPie, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    animate: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].object]),
    colorScale: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].string), PropTypes__default['default'].oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
    containerComponent: PropTypes__default['default'].element,
    cornerRadius: PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
    data: PropTypes__default['default'].array,
    dataComponent: PropTypes__default['default'].element,
    endAngle: PropTypes__default['default'].number,
    eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
    events: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      target: PropTypes__default['default'].oneOf(["data", "labels", "parent"]),
      eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
      eventHandlers: PropTypes__default['default'].object
    })),
    externalEventMutations: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      callback: PropTypes__default['default'].function,
      childName: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].array]),
      eventKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].array, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string]),
      mutation: PropTypes__default['default'].function,
      target: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].array])
    })),
    groupComponent: PropTypes__default['default'].element,
    height: CustomPropTypes.nonNegative,
    innerRadius: PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
    labelComponent: PropTypes__default['default'].element,
    labelPlacement: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].oneOf(["parallel", "perpendicular", "vertical"])]),
    labelPosition: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].oneOf(["startAngle", "centroid", "endAngle"])]),
    labelRadius: PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
    labels: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].array]),
    name: PropTypes__default['default'].string,
    origin: PropTypes__default['default'].shape({
      x: CustomPropTypes.nonNegative,
      y: CustomPropTypes.nonNegative
    }),
    padAngle: PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
    padding: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].shape({
      top: PropTypes__default['default'].number,
      bottom: PropTypes__default['default'].number,
      left: PropTypes__default['default'].number,
      right: PropTypes__default['default'].number
    })]),
    radius: PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
    sharedEvents: PropTypes__default['default'].shape({
      events: PropTypes__default['default'].array,
      getEventState: PropTypes__default['default'].func
    }),
    sortKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),
    sortOrder: PropTypes__default['default'].oneOf(["ascending", "descending"]),
    standalone: PropTypes__default['default'].bool,
    startAngle: PropTypes__default['default'].number,
    style: PropTypes__default['default'].shape({
      parent: PropTypes__default['default'].object,
      data: PropTypes__default['default'].object,
      labels: PropTypes__default['default'].object
    }),
    theme: PropTypes__default['default'].object,
    width: CustomPropTypes.nonNegative,
    x: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),
    y: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, CustomPropTypes.allOfType([CustomPropTypes.integer, CustomPropTypes.nonNegative]), PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)])
  }
});
Object.defineProperty(VictoryPie, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    data: [{
      x: "A",
      y: 1
    }, {
      x: "B",
      y: 2
    }, {
      x: "C",
      y: 3
    }, {
      x: "D",
      y: 1
    }, {
      x: "E",
      y: 2
    }],
    standalone: true,
    dataComponent: React__default['default'].createElement(Slice, null),
    labelComponent: React__default['default'].createElement(VictoryLabel, null),
    containerComponent: React__default['default'].createElement(VictoryContainer, null),
    groupComponent: React__default['default'].createElement("g", null),
    sortOrder: "ascending",
    theme: VictoryTheme.grayscale
  }
});
Object.defineProperty(VictoryPie, "getBaseProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function (props) {
    return getBaseProps$2(props, fallbackProps$6);
  }
});
Object.defineProperty(VictoryPie, "getData", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Data.getData
});
Object.defineProperty(VictoryPie, "expectedComponents", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
});
var VictoryPie$1 = addEvents(VictoryPie);

var getDataWithBaseline = function (props, scale) {
  var data = Data.getData(props);

  if (data.length < 2) {
    data = [];
  }

  var getDefaultMin = function (axis) {
    var defaultZero = Scale.getType(scale[axis]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
    var domain = scale[axis].domain();
    var minY = Collection.getMinValue(domain);
    var maxY = Collection.getMaxValue(domain);
    var defaultMin = defaultZero;

    if (minY < 0 && maxY <= 0) {
      defaultMin = maxY;
    } else if (minY >= 0 && maxY > 0) {
      defaultMin = minY;
    }

    return Collection.containsDates(domain) ? new Date(defaultMin) : defaultMin;
  };

  return data.map(function (datum) {
    var _y1 = datum._y1 !== undefined ? datum._y1 : datum._y;

    var _y0 = datum._y0 !== undefined ? datum._y0 : getDefaultMin("y");

    var _x1 = datum._x1 !== undefined ? datum._x1 : datum._x;

    var _x0 = datum._x0 !== undefined ? datum._x0 : getDefaultMin("x");

    return assign_1({}, datum, {
      _y0: _y0,
      _y1: _y1,
      _x0: _x0,
      _x1: _x1
    });
  });
};

var getCalculatedValues$3 = function (props) {
  var polar = props.polar;
  var defaultStyles = Helpers.getDefaultStyles(props, "area");
  var style = Helpers.getStyles(props.style, defaultStyles);
  var range = {
    x: Helpers.getRange(props, "x"),
    y: Helpers.getRange(props, "y")
  };
  var domain = {
    x: Domain.getDomainWithZero(props, "x"),
    y: Domain.getDomainWithZero(props, "y")
  };
  var scale = {
    x: Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
    y: Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
  };
  var origin = polar ? props.origin || Helpers.getPolarOrigin(props) : undefined;
  var data = getDataWithBaseline(props, scale);
  return {
    style: style,
    data: data,
    scale: scale,
    domain: domain,
    origin: origin
  };
};

var getBaseProps$3 = function (props, fallbackProps) {
  var modifiedProps = Helpers.modifyProps(props, fallbackProps, "area");
  props = assign_1({}, modifiedProps, getCalculatedValues$3(modifiedProps));
  var _props = props,
      data = _props.data,
      domain = _props.domain,
      events = _props.events,
      groupComponent = _props.groupComponent,
      height = _props.height,
      horizontal = _props.horizontal,
      interpolation = _props.interpolation,
      origin = _props.origin,
      padding = _props.padding,
      polar = _props.polar,
      scale = _props.scale,
      sharedEvents = _props.sharedEvents,
      standalone = _props.standalone,
      style = _props.style,
      theme = _props.theme,
      width = _props.width,
      labels = _props.labels,
      name = _props.name;
  var initialChildProps = {
    parent: {
      style: style.parent,
      width: width,
      height: height,
      scale: scale,
      data: data,
      domain: domain,
      standalone: standalone,
      theme: theme,
      polar: polar,
      origin: origin,
      padding: padding,
      name: name,
      horizontal: horizontal
    },
    all: {
      data: {
        horizontal: horizontal,
        polar: polar,
        origin: origin,
        scale: scale,
        data: data,
        interpolation: interpolation,
        groupComponent: groupComponent,
        style: style.data
      }
    }
  };
  return data.reduce(function (childProps, datum, index) {
    var text = LabelHelpers.getText(props, datum, index);

    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
      var eventKey = !isNil_1(datum.eventKey) ? datum.eventKey : index;
      childProps[eventKey] = {
        labels: LabelHelpers.getProps(props, index)
      };
    }

    return childProps;
  }, initialChildProps);
};

function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$k(target, key, source[key]); }); } return target; }

function _defineProperty$k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defined = function (d) {
  var y = d._y1 !== undefined ? d._y1 : d._y;
  return y !== null && y !== undefined && d._y0 !== null;
};

var getXAccessor = function (scale) {
  return function (d) {
    return scale.x(d._x1 !== undefined ? d._x1 : d._x);
  };
};

var getYAccessor = function (scale) {
  return function (d) {
    return scale.y(d._y1 !== undefined ? d._y1 : d._y);
  };
};

var getY0Accessor = function (scale) {
  return function (d) {
    return scale.y(d._y0);
  };
};

var getAngleAccessor = function (scale) {
  return function (d) {
    var x = scale.x(d._x1 !== undefined ? d._x1 : d._x);
    return -1 * x + Math.PI / 2;
  };
};

var toNewName$1 = function (interpolation) {
  // d3 shape changed the naming scheme for interpolators from "basis" -> "curveBasis" etc.
  var capitalize = function (s) {
    return s && s[0].toUpperCase() + s.slice(1);
  };

  return "curve".concat(capitalize(interpolation));
};

var getLineFunction = function (props) {
  var polar = props.polar,
      scale = props.scale,
      horizontal = props.horizontal;
  var interpolationFunction = typeof props.interpolation === "function" && props.interpolation;
  var interpolationName = typeof props.interpolation === "string" && toNewName$1(props.interpolation);
  return polar ? lineRadial$1().defined(defined).curve(interpolationFunction || d3Shape["".concat(interpolationName, "Closed")]).angle(getAngleAccessor(scale)).radius(getYAccessor(scale)) : line().defined(defined).curve(interpolationFunction || d3Shape[interpolationName]).x(horizontal ? getYAccessor(scale) : getXAccessor(scale)).y(horizontal ? getXAccessor(scale) : getYAccessor(scale));
};

var getCartesianArea = function (props, interpolation) {
  var horizontal = props.horizontal,
      scale = props.scale;
  var interpolationFunction = typeof interpolation === "function" && interpolation;
  var interpolationName = typeof interpolation === "string" && interpolation;
  return horizontal ? area().defined(defined).curve(interpolationFunction || d3Shape[interpolationName]).x0(getY0Accessor(scale)).x1(getYAccessor(scale)).y(getXAccessor(scale)) : area().defined(defined).curve(interpolationFunction || d3Shape[interpolationName]).x(getXAccessor(scale)).y1(getYAccessor(scale)).y0(getY0Accessor(scale));
};

var getAreaFunction = function (props) {
  var polar = props.polar,
      scale = props.scale;
  var interpolationFunction = typeof props.interpolation === "function" && props.interpolation;
  var interpolationName = typeof props.interpolation === "string" && toNewName$1(props.interpolation);
  var interpolation = interpolationFunction || interpolationName;
  return polar ? areaRadial().defined(defined).curve(interpolationFunction || d3Shape["".concat(interpolationName, "Closed")]).angle(getAngleAccessor(scale)).outerRadius(getYAccessor(scale)).innerRadius(getY0Accessor(scale)) : getCartesianArea(props, interpolation);
};

var evaluateProps$5 = function (props) {
  /**
   * Potential evaluated props are:
   * `ariaLabel`
   * `desc`
   * `id`
   * `style`
   * `tabIndex`
   */
  var ariaLabel = Helpers.evaluateProp(props.ariaLabel, props);
  var desc = Helpers.evaluateProp(props.desc, props);
  var id = Helpers.evaluateProp(props.id, props);
  var style = Helpers.evaluateStyle(assign_1({
    fill: "black"
  }, props.style), props);
  var tabIndex = Helpers.evaluateProp(props.tabIndex, props);
  return assign_1({}, props, {
    ariaLabel: ariaLabel,
    desc: desc,
    id: id,
    style: style,
    tabIndex: tabIndex
  });
};

var Area = function (props) {
  props = evaluateProps$5(props);
  var _props = props,
      ariaLabel = _props.ariaLabel,
      role = _props.role,
      shapeRendering = _props.shapeRendering,
      className = _props.className,
      polar = _props.polar,
      origin = _props.origin,
      data = _props.data,
      pathComponent = _props.pathComponent,
      events = _props.events,
      groupComponent = _props.groupComponent,
      clipPath = _props.clipPath,
      id = _props.id,
      style = _props.style,
      desc = _props.desc,
      tabIndex = _props.tabIndex;
  var defaultTransform = polar && origin ? "translate(".concat(origin.x, ", ").concat(origin.y, ")") : undefined;
  var transform = props.transform || defaultTransform;
  var renderLine = style.stroke && style.stroke !== "none" && style.stroke !== "transparent";
  var areaFunction = getAreaFunction(props);
  var lineFunction = renderLine && getLineFunction(props);
  var areaStroke = style.stroke ? "none" : style.fill;

  var sharedProps = _objectSpread$g({
    "aria-label": ariaLabel,
    className: className,
    role: role,
    shapeRendering: shapeRendering,
    transform: transform
  }, events, {
    clipPath: clipPath,
    tabIndex: tabIndex
  });

  var area = React__default['default'].cloneElement(pathComponent, assign_1({
    key: "".concat(id, "-area"),
    style: assign_1({}, style, {
      stroke: areaStroke
    }),
    d: areaFunction(data),
    desc: desc,
    tabIndex: tabIndex
  }, sharedProps));
  var line = renderLine ? React__default['default'].cloneElement(pathComponent, assign_1({
    key: "".concat(id, "-area-stroke"),
    style: assign_1({}, style, {
      fill: "none"
    }),
    d: lineFunction(data)
  }, sharedProps)) : null;
  return renderLine ? React__default['default'].cloneElement(groupComponent, {}, [area, line]) : area;
};

Area.propTypes = _objectSpread$g({}, CommonProps.primitiveProps, {
  groupComponent: PropTypes__default['default'].element,
  interpolation: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].func]),
  pathComponent: PropTypes__default['default'].element
});
Area.defaultProps = {
  groupComponent: React__default['default'].createElement("g", null),
  pathComponent: React__default['default'].createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};

function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$l(target, key, source[key]); }); } return target; }

function _defineProperty$l(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$f(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$f(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$f(Constructor.prototype, protoProps); if (staticProps) _defineProperties$f(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$e(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$i(self); }

function _assertThisInitialized$i(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$e(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var fallbackProps$7 = {
  width: 450,
  height: 300,
  padding: 50,
  interpolation: "linear"
};
var options$2 = {
  components: [{
    name: "parent",
    index: "parent"
  }, {
    name: "data",
    index: "all"
  }, {
    name: "labels"
  }]
};

var VictoryArea =
/*#__PURE__*/
function (_React$Component) {
  _inherits$e(VictoryArea, _React$Component);

  function VictoryArea() {
    _classCallCheck$f(this, VictoryArea);

    return _possibleConstructorReturn$e(this, (VictoryArea.__proto__ || Object.getPrototypeOf(VictoryArea)).apply(this, arguments));
  }

  _createClass$f(VictoryArea, [{
    key: "shouldAnimate",
    // Overridden in native versions
    value: function shouldAnimate() {
      return !!this.props.animate;
    }
  }, {
    key: "render",
    value: function render() {
      var animationWhitelist = VictoryArea.animationWhitelist,
          role = VictoryArea.role;
      var props = Helpers.modifyProps(this.props, fallbackProps$7, role);

      if (this.shouldAnimate()) {
        return this.animateComponent(props, animationWhitelist);
      }

      var children = this.renderContinuousData(props);
      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
    }
  }]);

  return VictoryArea;
}(React__default['default'].Component);

Object.defineProperty(VictoryArea, "animationWhitelist", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["data", "domain", "height", "padding", "style", "width"]
});
Object.defineProperty(VictoryArea, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: _objectSpread$h({}, CommonProps.baseProps, CommonProps.dataProps, {
    interpolation: PropTypes__default['default'].oneOfType([PropTypes__default['default'].oneOf(["basis", "cardinal", "catmullRom", "linear", "monotoneX", "monotoneY", "natural", "step", "stepAfter", "stepBefore"]), PropTypes__default['default'].func]),
    label: CustomPropTypes.deprecated(PropTypes__default['default'].string, "Use `labels` instead for individual data labels")
  })
});
Object.defineProperty(VictoryArea, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    containerComponent: React__default['default'].createElement(VictoryContainer, null),
    dataComponent: React__default['default'].createElement(Area, null),
    groupComponent: React__default['default'].createElement(VictoryClipContainer, null),
    labelComponent: React__default['default'].createElement(VictoryLabel, {
      renderInPortal: true
    }),
    samples: 50,
    sortKey: "x",
    sortOrder: "ascending",
    standalone: true,
    theme: VictoryTheme.grayscale
  }
});
Object.defineProperty(VictoryArea, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryArea"
});
Object.defineProperty(VictoryArea, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "area"
});
Object.defineProperty(VictoryArea, "continuous", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: true
});
Object.defineProperty(VictoryArea, "defaultTransitions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DefaultTransitions.continuousTransitions()
});
Object.defineProperty(VictoryArea, "defaultPolarTransitions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DefaultTransitions.continuousPolarTransitions()
});
Object.defineProperty(VictoryArea, "getDomain", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Domain.getDomainWithZero
});
Object.defineProperty(VictoryArea, "getData", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Data.getData
});
Object.defineProperty(VictoryArea, "getBaseProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function (props) {
    return getBaseProps$3(props, fallbackProps$7);
  }
});
Object.defineProperty(VictoryArea, "expectedComponents", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
});
var VictoryArea$1 = addEvents(VictoryArea, options$2);

var getBarPosition = function (props, datum) {
  var getDefaultMin = function (axis) {
    var defaultZero = Scale.getType(props.scale[axis]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
    var defaultMin = defaultZero;
    var minY = Collection.getMinValue(props.domain[axis]);
    var maxY = Collection.getMaxValue(props.domain[axis]);

    if (minY < 0 && maxY <= 0) {
      defaultMin = maxY;
    } else if (minY >= 0 && maxY > 0) {
      defaultMin = minY;
    }

    return datum["_".concat(axis)] instanceof Date ? new Date(defaultMin) : defaultMin;
  };

  var _y0 = datum._y0 !== undefined ? datum._y0 : getDefaultMin("y");

  var _x0 = datum._x0 !== undefined ? datum._x0 : getDefaultMin("x");

  return Helpers.scalePoint(props, assign_1({}, datum, {
    _y0: _y0,
    _x0: _x0
  }));
};

var getCalculatedValues$4 = function (props) {
  var polar = props.polar;
  var defaultStyles = Helpers.getDefaultStyles(props, "bar");
  var style = Helpers.getStyles(props.style, defaultStyles);
  var data = Data.getData(props); // Data.getData needs to be called to format the data (we may be able to do this in a wrapper component)

  var range = props.range || {
    x: Helpers.getRange(props, "x"),
    y: Helpers.getRange(props, "y")
  };
  var domain = {
    x: Domain.getDomainWithZero(props, "x"),
    y: Domain.getDomainWithZero(props, "y")
  };
  var scale = {
    x: Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
    y: Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
  };
  var origin = polar ? props.origin || Helpers.getPolarOrigin(props) : undefined;
  return {
    style: style,
    data: data,
    scale: scale,
    domain: domain,
    origin: origin
  };
};

var getBaseProps$4 = function (props, fallbackProps) {
  var modifiedProps = Helpers.modifyProps(props, fallbackProps, "bar");
  props = assign_1({}, modifiedProps, getCalculatedValues$4(modifiedProps));
  var _props = props,
      alignment = _props.alignment,
      barRatio = _props.barRatio,
      cornerRadius = _props.cornerRadius,
      data = _props.data,
      domain = _props.domain,
      events = _props.events,
      height = _props.height,
      horizontal = _props.horizontal,
      origin = _props.origin,
      padding = _props.padding,
      polar = _props.polar,
      scale = _props.scale,
      sharedEvents = _props.sharedEvents,
      standalone = _props.standalone,
      style = _props.style,
      theme = _props.theme,
      width = _props.width,
      labels = _props.labels,
      name = _props.name,
      barWidth = _props.barWidth,
      getPath = _props.getPath;
  var initialChildProps = {
    parent: {
      horizontal: horizontal,
      domain: domain,
      scale: scale,
      width: width,
      height: height,
      data: data,
      standalone: standalone,
      name: name,
      theme: theme,
      polar: polar,
      origin: origin,
      padding: padding,
      style: style.parent
    }
  };
  return data.reduce(function (childProps, datum, index) {
    var eventKey = !isNil_1(datum.eventKey) ? datum.eventKey : index;

    var _getBarPosition = getBarPosition(props, datum),
        x = _getBarPosition.x,
        y = _getBarPosition.y,
        y0 = _getBarPosition.y0,
        x0 = _getBarPosition.x0;

    var dataProps = {
      alignment: alignment,
      barRatio: barRatio,
      barWidth: barWidth,
      cornerRadius: cornerRadius,
      data: data,
      datum: datum,
      getPath: getPath,
      horizontal: horizontal,
      index: index,
      polar: polar,
      origin: origin,
      scale: scale,
      style: style.data,
      width: width,
      height: height,
      x: x,
      y: y,
      y0: y0,
      x0: x0
    };
    childProps[eventKey] = {
      data: dataProps
    };
    var text = LabelHelpers.getText(props, datum, index);

    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
      childProps[eventKey].labels = LabelHelpers.getProps(props, index);
    }

    return childProps;
  }, initialChildProps);
};

/**
 * A point in the 2d plane
 * @param {number} x - x coordinate
 * @param {number} y - y coordinate
 * @returns {object} - point object
 */
var point$5 = function (x, y) {
  return {
    x: x,
    y: y,
    distance: function (p1) {
      return Math.sqrt(Math.pow(this.x - p1.x, 2) + Math.pow(this.y - p1.y, 2));
    },
    // vector addition in 2d plane
    add: function (p1) {
      return point$5(this.x + p1.x, this.y + p1.y);
    },
    // vector subtraction in 2d
    // returns p0 - p1
    subtract: function (p1) {
      return point$5(this.x - p1.x, this.y - p1.y);
    },
    // multiply a 2d point by a scalar
    scalarMult: function (n) {
      return point$5(this.x * n, this.y * n);
    },
    scalarDivide: function (n) {
      if (n === 0) {
        throw new Error("Division by 0 error");
      }

      return point$5(this.x / n, this.y / n);
    },
    equals: function (p1) {
      return this.x === p1.x && this.y === p1.y;
    }
  };
};
/**
 * A circle in the 2d plane
 * @param {point} center - center of circle
 * @param {number} radius - radius of circle
 * @returns {object} - point object
 */


var circle$1 = function (center, radius) {
  return {
    center: center,
    radius: radius,
    hasIntersection: function (circle1) {
      var P0 = this.center;
      var P1 = circle1.center;
      var r0 = this.radius;
      var r1 = circle1.radius;
      var d = P0.distance(P1);

      if (d > r0 + r1) {
        return false; // separate circles
      }

      if (d < Math.abs(r0 - r1)) {
        return false; // one circle contains another
      }

      return true;
    },
    equals: function (circle1) {
      var P0 = this.center;
      var P1 = circle1.center;
      var r0 = this.radius;
      var r1 = circle1.radius;
      return r0 === r1 && P0.equals(P1);
    },
    // Source: http://paulbourke.net/geometry/circlesphere/
    // "Intersection of two circles" by Paul Bourke
    // Left-most point is returned as 0th element of array
    // Right-most point is returned as 1st elemennt of array
    intersection: function (circle1) {
      // eslint-disable-line max-statements
      var P0 = this.center;
      var P1 = circle1.center;
      var r0 = this.radius;
      var r1 = circle1.radius;
      var d = P0.distance(P1);

      if (!this.hasIntersection(circle1) || this.equals(circle1)) {
        return [];
      }

      var a = (Math.pow(r0, 2) - Math.pow(r1, 2) + Math.pow(d, 2)) / (2 * d);
      var h = Math.sqrt(Math.pow(r0, 2) - Math.pow(a, 2));
      var P2 = P0.add(P1.subtract(P0).scalarMult(a).scalarDivide(d));
      var x0 = P0.x,
          y0 = P0.y;
      var x1 = P1.x,
          y1 = P1.y;
      var x2 = P2.x,
          y2 = P2.y;
      var P3s = [point$5(x2 - h * (y1 - y0) / d, y2 + h * (x1 - x0) / d), point$5(x2 + h * (y1 - y0) / d, y2 - h * (x1 - x0) / d)];
      P3s.sort(function (Point1, Point2) {
        return Point1.x - Point2.x;
      });
      return P3s;
    },
    solveX: function (y) {
      var sqrt = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(y - this.center.y, 2));
      return [this.center.x - sqrt, this.center.x + sqrt];
    },
    solveY: function (x) {
      var sqrt = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(x - this.center.x, 2));
      return [this.center.y - sqrt, this.center.y + sqrt];
    }
  };
};

function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$m(target, key, source[key]); }); } return target; }

function _defineProperty$m(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray$i(arr) { return _arrayWithoutHoles$i(arr) || _iterableToArray$i(arr) || _nonIterableSpread$i(); }

function _nonIterableSpread$i() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$i(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$i(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var getPosition$3 = function (props, width) {
  var x = props.x,
      x0 = props.x0,
      y = props.y,
      y0 = props.y0,
      horizontal = props.horizontal;
  var alignment = props.alignment || "middle";
  var size = alignment === "middle" ? width / 2 : width;
  var sign = horizontal ? -1 : 1;

  if (horizontal) {
    return {
      x0: x0,
      x1: x,
      y0: alignment === "start" ? y : y - sign * size,
      y1: alignment === "end" ? y : y + sign * size
    };
  }

  return {
    x0: alignment === "start" ? x : x - sign * size,
    x1: alignment === "end" ? x : x + sign * size,
    y0: y0,
    y1: y
  };
};

var getAngle$1 = function (props, index) {
  var data = props.data,
      scale = props.scale;
  var x = data[index]._x1 === undefined ? "_x" : "_x1";
  return scale.x(data[index][x]);
};

var getAngularWidth = function (props, width) {
  var scale = props.scale;
  var range = scale.y.range();
  var r = Math.max.apply(Math, _toConsumableArray$i(range));
  var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
  return width / (2 * Math.PI * r) * angularRange;
};

var transformAngle = function (angle) {
  return -1 * angle + Math.PI / 2;
};

var getCustomBarPath = function (props, width) {
  var getPath = props.getPath;

  var propsWithCalculatedValues = _objectSpread$i({}, props, getPosition$3(props, width));

  return getPath(propsWithCalculatedValues);
};

var getStartAngle = function (props, index) {
  var data = props.data,
      scale = props.scale,
      alignment = props.alignment;
  var currentAngle = getAngle$1(props, index);
  var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
  var previousAngle = index === 0 ? getAngle$1(props, data.length - 1) - Math.PI * 2 : getAngle$1(props, index - 1);

  if (index === 0 && angularRange < 2 * Math.PI) {
    return scale.x.range()[0];
  } else if (alignment === "start" || alignment === "end") {
    return alignment === "start" ? previousAngle : currentAngle;
  } else {
    return (currentAngle + previousAngle) / 2;
  }
};

var getEndAngle = function (props, index) {
  var data = props.data,
      scale = props.scale,
      alignment = props.alignment;
  var currentAngle = getAngle$1(props, index);
  var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
  var lastAngle = scale.x.range()[1] === 2 * Math.PI ? getAngle$1(props, 0) + Math.PI * 2 : scale.x.range()[1];
  var nextAngle = index === data.length - 1 ? getAngle$1(props, 0) + Math.PI * 2 : getAngle$1(props, index + 1);

  if (index === data.length - 1 && angularRange < 2 * Math.PI) {
    return lastAngle;
  } else if (alignment === "start" || alignment === "end") {
    return alignment === "start" ? currentAngle : nextAngle;
  } else {
    return (currentAngle + nextAngle) / 2;
  }
};

var mapPointsToPath = function (coords, cornerRadius, direction) {
  var topLeftPath = "".concat(cornerRadius.topLeft, " ").concat(cornerRadius.topLeft, " ").concat(direction);
  var topRightPath = "".concat(cornerRadius.topRight, " ").concat(cornerRadius.topRight, " ").concat(direction);
  var bottomLeftPath = "".concat(cornerRadius.bottomLeft, " ").concat(cornerRadius.bottomLeft, " ").concat(direction);
  var bottomRightPath = "".concat(cornerRadius.bottomRight, " ").concat(cornerRadius.bottomRight, " ").concat(direction);
  var commands = ["M", "A ".concat(bottomLeftPath, ","), "L", "A ".concat(topLeftPath, ","), "L", "A ".concat(topRightPath, ","), "L", "A ".concat(bottomRightPath, ",")];
  var path = commands.reduce(function (acc, command, i) {
    acc += "".concat(command, " ").concat(coords[i].x, ", ").concat(coords[i].y, " \n");
    return acc;
  }, "");
  return "".concat(path, " z");
};

var getVerticalBarPoints = function (position, sign, cr) {
  var x0 = position.x0,
      x1 = position.x1,
      y0 = position.y0,
      y1 = position.y1; // eslint-disable-next-line max-statements, max-len

  var getHalfPoints = function (side) {
    var isLeft = side === "Left";
    var signL = isLeft ? 1 : -1;
    var x = isLeft ? x0 : x1;
    var bottomPoint = {
      x: x + signL * cr["bottom".concat(side)],
      y: y0
    };
    var bottomMiddlePoint = {
      x: x,
      y: y0 - sign * cr["bottom".concat(side)]
    };
    var topMiddlePoint = {
      x: x,
      y: y1 + sign * cr["top".concat(side)]
    };
    var topPoint = {
      x: x + signL * cr["top".concat(side)],
      y: y1
    };
    var hasIntersection = sign === 1 ? y0 - cr["bottom".concat(side)] < y1 + cr["top".concat(side)] : y0 + cr["bottom".concat(side)] > y1 - cr["top".concat(side)];

    if (hasIntersection) {
      var topCenter = point$5(x + signL * cr["top".concat(side)], y1 + sign * cr["top".concat(side)]);
      var topCircle = circle$1(topCenter, cr["top".concat(side)]);
      var bottomCenter = point$5(x + signL * cr["bottom".concat(side)], y0 - sign * cr["bottom".concat(side)]);
      var bottomCircle = circle$1(bottomCenter, cr["bottom".concat(side)]);
      var circleIntersection = topCircle.intersection(bottomCircle);
      var hasArcIntersection = circleIntersection.length > 0;

      if (hasArcIntersection) {
        var arcIntersection = circleIntersection[isLeft ? 0 : 1];
        bottomMiddlePoint = {
          x: arcIntersection.x,
          y: arcIntersection.y
        };
        topMiddlePoint = {
          x: arcIntersection.x,
          y: arcIntersection.y
        };
      } else {
        var hasBottomLineTopArcIntersection = cr["top".concat(side)] > cr["bottom".concat(side)];

        if (hasBottomLineTopArcIntersection) {
          var newX = topCircle.solveX(y0)[isLeft ? 0 : 1];
          bottomPoint = {
            x: newX,
            y: y0
          };
          bottomMiddlePoint = {
            x: newX,
            y: y0
          };
          topMiddlePoint = {
            x: newX,
            y: y0
          };
        } else {
          var _newX = bottomCircle.solveX(y1)[isLeft ? 0 : 1];
          bottomMiddlePoint = {
            x: _newX,
            y: y1
          };
          topMiddlePoint = {
            x: _newX,
            y: y1
          };
          topPoint = {
            x: _newX,
            y: y1
          };
        }
      }
    }

    var points = [bottomPoint, bottomMiddlePoint, topMiddlePoint, topPoint];
    return isLeft ? points : points.reverse();
  };

  return getHalfPoints("Left").concat(getHalfPoints("Right"));
};

var getHorizontalBarPoints = function (position, sign, cr) {
  var y0 = position.y0,
      y1 = position.y1;
  var x0 = position.x0 < position.x1 ? position.x0 : position.x1;
  var x1 = position.x0 < position.x1 ? position.x1 : position.x0; // eslint-disable-next-line max-statements, max-len

  var getHalfPoints = function (side) {
    var isTop = side === "top";
    var signL = isTop ? -1 : 1;
    var y = isTop ? y1 : y0;
    var leftPoint = {
      x: x0,
      y: y - signL * cr["".concat(side, "Left")]
    };
    var leftMiddlePoint = {
      x: x0 + cr["".concat(side, "Left")],
      y: y
    };
    var rightMiddlePoint = {
      x: x1 - cr["".concat(side, "Right")],
      y: y
    };
    var rightPoint = {
      x: x1,
      y: y - signL * cr["".concat(side, "Right")]
    };
    var hasIntersection = leftMiddlePoint.x > rightMiddlePoint.x;

    if (hasIntersection) {
      var leftCenter = point$5(x0 + cr["".concat(side, "Left")], y - signL * cr["".concat(side, "Left")]);
      var leftCircle = circle$1(leftCenter, cr["".concat(side, "Left")]);
      var rightCenter = point$5(x1 - cr["".concat(side, "Right")], y - signL * cr["".concat(side, "Right")]);
      var rightCircle = circle$1(rightCenter, cr["".concat(side, "Right")]);
      var circleIntersection = leftCircle.intersection(rightCircle);
      var hasArcIntersection = circleIntersection.length > 0;

      if (hasArcIntersection) {
        var arcIntersection = circleIntersection[sign > 0 ? 1 : 0];
        leftMiddlePoint = {
          x: arcIntersection.x,
          y: arcIntersection.y
        };
        rightMiddlePoint = {
          x: arcIntersection.x,
          y: arcIntersection.y
        };
      } else {
        var hasLeftLineRightArcIntersection = cr["".concat(side, "Right")] > cr["".concat(side, "Left")];

        if (hasLeftLineRightArcIntersection) {
          var newY = rightCircle.solveY(x0)[isTop ? 0 : 1];
          leftPoint = {
            x: x0,
            y: newY
          };
          leftMiddlePoint = {
            x: x0,
            y: newY
          };
          rightMiddlePoint = {
            x: x0,
            y: newY
          };
        } else {
          var _newY = leftCircle.solveY(x1)[isTop ? 0 : 1];
          rightPoint = {
            x: x1,
            y: _newY
          };
          rightMiddlePoint = {
            x: x1,
            y: _newY
          };
          leftMiddlePoint = {
            x: x1,
            y: _newY
          };
        }
      }
    }

    return [leftPoint, leftMiddlePoint, rightMiddlePoint, rightPoint];
  };

  var topPoints = getHalfPoints("top");
  var bottomPoints = getHalfPoints("bottom"); // eslint-disable-next-line no-magic-numbers

  return [bottomPoints[1], bottomPoints[0]].concat(_toConsumableArray$i(topPoints), [bottomPoints[3], bottomPoints[2]]);
}; // eslint-disable-next-line max-params


var getVerticalBarPath = function (props, width, cornerRadius) {
  var position = getPosition$3(props, width);
  var sign = position.y0 > position.y1 ? 1 : -1;
  var direction = sign > 0 ? "0 0 1" : "0 0 0";
  var points = getVerticalBarPoints(position, sign, cornerRadius);
  return mapPointsToPath(points, cornerRadius, direction);
}; // eslint-disable-next-line max-params

var getHorizontalBarPath = function (props, width, cornerRadius) {
  var position = getPosition$3(props, width);
  var sign = position.x0 < position.x1 ? 1 : -1;
  var direction = "0 0 1";
  var cr = {
    topRight: sign > 0 ? cornerRadius.topLeft : cornerRadius.bottomLeft,
    bottomRight: sign > 0 ? cornerRadius.topRight : cornerRadius.bottomRight,
    bottomLeft: sign > 0 ? cornerRadius.bottomRight : cornerRadius.topRight,
    topLeft: sign > 0 ? cornerRadius.bottomLeft : cornerRadius.topLeft
  };
  var points = getHorizontalBarPoints(position, sign, cr);
  return mapPointsToPath(points, cr, direction);
};
var getVerticalPolarBarPath = function (props, cornerRadius) {
  var datum = props.datum,
      scale = props.scale,
      index = props.index,
      alignment = props.alignment,
      style = props.style;
  var r1 = scale.y(datum._y0 || 0);
  var r2 = scale.y(datum._y1 !== undefined ? datum._y1 : datum._y);
  var currentAngle = scale.x(datum._x1 !== undefined ? datum._x1 : datum._x);
  var start;
  var end;

  if (style.width) {
    var width = getAngularWidth(props, style.width);
    var size = alignment === "middle" ? width / 2 : width;
    start = alignment === "start" ? currentAngle : currentAngle - size;
    end = alignment === "end" ? currentAngle : currentAngle + size;
  } else {
    start = getStartAngle(props, index);
    end = getEndAngle(props, index);
  }

  var getPath = function (edge) {
    var pathFunction = arc().innerRadius(r1).outerRadius(r2).startAngle(transformAngle(start)).endAngle(transformAngle(end)).cornerRadius(cornerRadius[edge]);
    return pathFunction();
  };

  var getPathData = function (edge) {
    var rightPath = getPath("".concat(edge, "Right"));
    var rightMoves = rightPath.match(/[A-Z]/g);
    var rightCoords = rightPath.split(/[A-Z]/).slice(1);
    var rightMiddle = rightMoves.indexOf("L");
    var leftPath = getPath("".concat(edge, "Left"));
    var leftMoves = leftPath.match(/[A-Z]/g);
    var leftCoords = leftPath.split(/[A-Z]/).slice(1);
    var leftMiddle = leftMoves.indexOf("L");
    return {
      rightMoves: rightMoves,
      rightCoords: rightCoords,
      rightMiddle: rightMiddle,
      leftMoves: leftMoves,
      leftCoords: leftCoords,
      leftMiddle: leftMiddle
    };
  }; // eslint-disable-next-line max-statements


  var getTopPath = function () {
    var topRight = cornerRadius.topRight,
        topLeft = cornerRadius.topLeft;
    var arcLength = r2 * Math.abs(end - start);

    var _getPathData = getPathData("top"),
        rightMoves = _getPathData.rightMoves,
        rightCoords = _getPathData.rightCoords,
        rightMiddle = _getPathData.rightMiddle,
        leftMoves = _getPathData.leftMoves,
        leftCoords = _getPathData.leftCoords,
        leftMiddle = _getPathData.leftMiddle;

    var moves;
    var coords;

    if (topRight === topLeft || arcLength < 2 * topRight + 2 * topLeft) {
      moves = topRight > topLeft ? rightMoves : leftMoves;
      coords = topRight > topLeft ? rightCoords : leftCoords;
    } else {
      // eslint-disable-next-line no-magic-numbers
      var isShort = function (middle) {
        return middle < 3;
      };

      var rightOffset = topLeft > topRight && isShort(rightMiddle) ? 1 : 2;
      var leftOffset;

      if (topRight > topLeft) {
        var defaultOffset = isShort(rightMiddle) ? leftMiddle : leftMiddle - 2;
        leftOffset = isShort(leftMiddle) ? leftMiddle - 1 : defaultOffset;
      } else {
        var _defaultOffset = isShort(leftMiddle) ? 1 : 2;

        leftOffset = isShort(rightMiddle) ? _defaultOffset : leftMiddle - 2;
      }

      moves = _toConsumableArray$i(rightMoves.slice(0, rightOffset)).concat(_toConsumableArray$i(leftMoves.slice(leftOffset)));
      coords = _toConsumableArray$i(rightCoords.slice(0, rightOffset)).concat(_toConsumableArray$i(leftCoords.slice(leftOffset)));
    }

    var middle = moves.indexOf("L");
    var subMoves = moves.slice(0, middle);
    var subCoords = coords.slice(0, middle);
    return subMoves.map(function (m, i) {
      return {
        command: m,
        coords: subCoords[i].split(",")
      };
    });
  }; // eslint-disable-next-line max-statements


  var getBottomPath = function () {
    var bottomRight = cornerRadius.bottomRight,
        bottomLeft = cornerRadius.bottomLeft;
    var arcLength = r1 * Math.abs(end - start);

    var _getPathData2 = getPathData("bottom"),
        rightMoves = _getPathData2.rightMoves,
        rightCoords = _getPathData2.rightCoords,
        rightMiddle = _getPathData2.rightMiddle,
        leftMoves = _getPathData2.leftMoves,
        leftCoords = _getPathData2.leftCoords,
        leftMiddle = _getPathData2.leftMiddle;

    var moves;
    var coords;

    if (bottomRight === bottomLeft || arcLength < 2 * bottomRight + 2 * bottomLeft) {
      moves = bottomRight > bottomLeft ? rightMoves : leftMoves;
      coords = bottomRight > bottomLeft ? rightCoords : leftCoords;
    } else {
      // eslint-disable-next-line no-magic-numbers
      var isShort = function (m, middle) {
        return m.length - middle < 4;
      };

      var shortPath = bottomRight > bottomLeft ? isShort(rightMoves, rightMiddle) : isShort(leftMoves, leftMiddle); // eslint-disable-next-line no-magic-numbers

      var rightOffset = shortPath ? -1 : -3;
      moves = _toConsumableArray$i(leftMoves.slice(0, leftMiddle + 2)).concat(_toConsumableArray$i(rightMoves.slice(rightOffset)));
      coords = _toConsumableArray$i(leftCoords.slice(0, leftMiddle + 2)).concat(_toConsumableArray$i(rightCoords.slice(rightOffset)));
    }

    var middle = moves.indexOf("L");
    var subMoves = moves.slice(middle, -1);
    var subCoords = coords.slice(middle, -1);
    return subMoves.map(function (m, i) {
      return {
        command: m,
        coords: subCoords[i].split(",")
      };
    });
  };

  var topPath = getTopPath();
  var bottomPath = getBottomPath();

  var moves = _toConsumableArray$i(topPath).concat(_toConsumableArray$i(bottomPath));

  var path = moves.reduce(function (memo, move) {
    memo += "".concat(move.command, " ").concat(move.coords.join());
    return memo;
  }, "");
  return "".concat(path, " z");
};

function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$n(target, key, source[key]); }); } return target; }

function _defineProperty$n(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getBarPath = function (props, width, cornerRadius) {
  if (props.getPath) {
    return getCustomBarPath(props, width);
  }

  return props.horizontal ? getHorizontalBarPath(props, width, cornerRadius) : getVerticalBarPath(props, width, cornerRadius);
};

var getPolarBarPath = function (props, cornerRadius) {
  // TODO Radial bars
  return getVerticalPolarBarPath(props, cornerRadius);
};

var getBarWidth = function (barWidth, props) {
  var scale = props.scale,
      data = props.data,
      defaultBarWidth = props.defaultBarWidth,
      style = props.style;

  if (barWidth) {
    return Helpers.evaluateProp(barWidth, props);
  } else if (style.width) {
    return style.width;
  }

  var range = scale.x.range();
  var extent = Math.abs(range[1] - range[0]);
  var bars = data.length + 2;
  var barRatio = props.barRatio || 0.5;
  var defaultWidth = barRatio * (data.length < 2 ? defaultBarWidth : extent / bars);
  return Math.max(1, defaultWidth);
};

var getCornerRadiusFromObject = function (cornerRadius, props) {
  var realCornerRadius = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  };

  var updateCornerRadius = function (corner, fallback) {
    if (!isNil_1(cornerRadius[corner])) {
      realCornerRadius[corner] = Helpers.evaluateProp(cornerRadius[corner], props);
    } else if (!isNil_1(cornerRadius[fallback])) {
      realCornerRadius[corner] = Helpers.evaluateProp(cornerRadius[fallback], props);
    }
  };

  updateCornerRadius("topLeft", "top");
  updateCornerRadius("topRight", "top");
  updateCornerRadius("bottomLeft", "bottom");
  updateCornerRadius("bottomRight", "bottom");
  return realCornerRadius;
};

var getCornerRadius = function (cornerRadius, props) {
  var realCornerRadius = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  };

  if (!cornerRadius) {
    return realCornerRadius;
  }

  if (isPlainObject_1(cornerRadius)) {
    return getCornerRadiusFromObject(cornerRadius, props);
  } else {
    realCornerRadius.topLeft = Helpers.evaluateProp(cornerRadius, props);
    realCornerRadius.topRight = Helpers.evaluateProp(cornerRadius, props);
    return realCornerRadius;
  }
};

var getStyle = function () {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 ? arguments[1] : undefined;
  var stroke = style.fill || "black";
  var baseStyle = {
    fill: "black",
    stroke: stroke
  };
  return Helpers.evaluateStyle(assign_1(baseStyle, style), props);
};

var evaluateProps$6 = function (props) {
  /**
   * Potential evaluated props of following must be evaluated in this order:
   * 1) `style`
   * 2) `barWidth`
   * 3) `cornerRadius`
   *
   * Everything else does not have to be evaluated in a particular order:
   * `ariaLabel`
   * `desc`
   * `id`
   * `tabIndex`
   */
  var style = getStyle(props.style, props);
  var barWidth = getBarWidth(props.barWidth, assign_1({}, props, {
    style: style
  }));
  var cornerRadius = getCornerRadius(props.cornerRadius, assign_1({}, props, {
    style: style,
    barWidth: barWidth
  }));
  var ariaLabel = Helpers.evaluateProp(props.ariaLabel, props);
  var desc = Helpers.evaluateProp(props.desc, props);
  var id = Helpers.evaluateProp(props.id, props);
  var tabIndex = Helpers.evaluateProp(props.tabIndex, props);
  return assign_1({}, props, {
    ariaLabel: ariaLabel,
    style: style,
    barWidth: barWidth,
    cornerRadius: cornerRadius,
    desc: desc,
    id: id,
    tabIndex: tabIndex
  });
};

var Bar = function (props) {
  props = evaluateProps$6(props);
  var _props = props,
      polar = _props.polar,
      origin = _props.origin,
      style = _props.style,
      barWidth = _props.barWidth,
      cornerRadius = _props.cornerRadius;
  var path = polar ? getPolarBarPath(props, cornerRadius) : getBarPath(props, barWidth, cornerRadius);
  var defaultTransform = polar && origin ? "translate(".concat(origin.x, ", ").concat(origin.y, ")") : undefined;
  return React__default['default'].cloneElement(props.pathComponent, _objectSpread$j({}, props.events, {
    "aria-label": props.ariaLabel,
    style: style,
    d: path,
    className: props.className,
    clipPath: props.clipPath,
    desc: props.desc,
    index: props.index,
    role: props.role,
    shapeRendering: props.shapeRendering,
    transform: props.transform || defaultTransform,
    tabIndex: props.tabIndex
  }));
};

Bar.propTypes = _objectSpread$j({}, CommonProps.primitiveProps, {
  alignment: PropTypes__default['default'].oneOf(["start", "middle", "end"]),
  barRatio: PropTypes__default['default'].number,
  barWidth: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
  cornerRadius: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func, PropTypes__default['default'].shape({
    top: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
    topLeft: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
    topRight: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
    bottom: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
    bottomLeft: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
    bottomRight: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func])
  })]),
  datum: PropTypes__default['default'].object,
  getPath: PropTypes__default['default'].func,
  horizontal: PropTypes__default['default'].bool,
  pathComponent: PropTypes__default['default'].element,
  width: PropTypes__default['default'].number,
  x: PropTypes__default['default'].number,
  y: PropTypes__default['default'].number,
  y0: PropTypes__default['default'].number
});
Bar.defaultProps = {
  defaultBarWidth: 8,
  pathComponent: React__default['default'].createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};

function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$o(target, key, source[key]); }); } return target; }

function _defineProperty$o(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$g(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$g(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$g(Constructor.prototype, protoProps); if (staticProps) _defineProperties$g(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$f(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$j(self); }

function _assertThisInitialized$j(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$f(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var fallbackProps$8 = {
  width: 450,
  height: 300,
  padding: 50
};
var defaultData = [{
  x: 1,
  y: 1
}, {
  x: 2,
  y: 2
}, {
  x: 3,
  y: 3
}, {
  x: 4,
  y: 4
}];

var VictoryBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits$f(VictoryBar, _React$Component);

  function VictoryBar() {
    _classCallCheck$g(this, VictoryBar);

    return _possibleConstructorReturn$f(this, (VictoryBar.__proto__ || Object.getPrototypeOf(VictoryBar)).apply(this, arguments));
  }

  _createClass$g(VictoryBar, [{
    key: "shouldAnimate",
    // Overridden in native versions
    value: function shouldAnimate() {
      return !!this.props.animate;
    }
  }, {
    key: "render",
    value: function render() {
      var animationWhitelist = VictoryBar.animationWhitelist,
          role = VictoryBar.role;
      var props = Helpers.modifyProps(this.props, fallbackProps$8, role);

      if (this.shouldAnimate()) {
        return this.animateComponent(props, animationWhitelist);
      }

      var children = this.renderData(props);
      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
    }
  }]);

  return VictoryBar;
}(React__default['default'].Component);

Object.defineProperty(VictoryBar, "animationWhitelist", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["data", "domain", "height", "padding", "style", "width"]
});
Object.defineProperty(VictoryBar, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryBar"
});
Object.defineProperty(VictoryBar, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "bar"
});
Object.defineProperty(VictoryBar, "defaultTransitions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onLoad: {
      duration: 2000,
      before: function () {
        return {
          _y: 0,
          _y1: 0,
          _y0: 0
        };
      },
      after: function (datum) {
        return {
          _y: datum._y,
          _y1: datum._y1,
          _y0: datum._y0
        };
      }
    },
    onExit: {
      duration: 500,
      before: function () {
        return {
          _y: 0,
          yOffset: 0
        };
      }
    },
    onEnter: {
      duration: 500,
      before: function () {
        return {
          _y: 0,
          _y1: 0,
          _y0: 0
        };
      },
      after: function (datum) {
        return {
          _y: datum._y,
          _y1: datum._y1,
          _y0: datum._y0
        };
      }
    }
  }
});
Object.defineProperty(VictoryBar, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: _objectSpread$k({}, CommonProps.baseProps, CommonProps.dataProps, {
    alignment: PropTypes__default['default'].oneOf(["start", "middle", "end"]),
    barRatio: PropTypes__default['default'].number,
    barWidth: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
    cornerRadius: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func, PropTypes__default['default'].shape({
      top: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
      topLeft: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
      topRight: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
      bottom: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
      bottomLeft: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
      bottomRight: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func])
    })]),
    getPath: PropTypes__default['default'].func,
    horizontal: PropTypes__default['default'].bool
  })
});
Object.defineProperty(VictoryBar, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    containerComponent: React__default['default'].createElement(VictoryContainer, null),
    data: defaultData,
    dataComponent: React__default['default'].createElement(Bar, null),
    groupComponent: React__default['default'].createElement("g", {
      role: "presentation"
    }),
    labelComponent: React__default['default'].createElement(VictoryLabel, null),
    samples: 50,
    sortOrder: "ascending",
    standalone: true,
    theme: VictoryTheme.grayscale
  }
});
Object.defineProperty(VictoryBar, "getDomain", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Domain.getDomainWithZero
});
Object.defineProperty(VictoryBar, "getData", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Data.getData
});
Object.defineProperty(VictoryBar, "getBaseProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function (props) {
    return getBaseProps$4(props, fallbackProps$8);
  }
});
Object.defineProperty(VictoryBar, "expectedComponents", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
});
var VictoryBar$1 = addEvents(VictoryBar);

var getCalculatedValues$5 = function (props) {
  var data = Data.getData(props);

  if (data.length < 2) {
    data = [];
  }

  var range = {
    x: Helpers.getRange(props, "x"),
    y: Helpers.getRange(props, "y")
  };
  var domain = {
    x: Domain.getDomain(props, "x"),
    y: Domain.getDomain(props, "y")
  };
  var scale = {
    x: Scale.getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
    y: Scale.getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
  };
  var origin = props.polar ? props.origin || Helpers.getPolarOrigin(props) : undefined;
  var defaultStyles = Helpers.getDefaultStyles(props, "line");
  var style = Helpers.getStyles(props.style, defaultStyles);
  return {
    domain: domain,
    data: data,
    scale: scale,
    style: style,
    origin: origin
  };
};

var getBaseProps$5 = function (props, fallbackProps) {
  var modifiedProps = Helpers.modifyProps(props, fallbackProps, "line");
  props = assign_1({}, modifiedProps, getCalculatedValues$5(modifiedProps));
  var _props = props,
      data = _props.data,
      domain = _props.domain,
      events = _props.events,
      groupComponent = _props.groupComponent,
      height = _props.height,
      horizontal = _props.horizontal,
      interpolation = _props.interpolation,
      origin = _props.origin,
      padding = _props.padding,
      polar = _props.polar,
      scale = _props.scale,
      sharedEvents = _props.sharedEvents,
      standalone = _props.standalone,
      style = _props.style,
      theme = _props.theme,
      width = _props.width,
      labels = _props.labels,
      name = _props.name;
  var initialChildProps = {
    parent: {
      style: style.parent,
      scale: scale,
      data: data,
      height: height,
      width: width,
      name: name,
      domain: domain,
      standalone: standalone,
      polar: polar,
      origin: origin,
      padding: padding,
      horizontal: horizontal
    },
    all: {
      data: {
        horizontal: horizontal,
        polar: polar,
        origin: origin,
        scale: scale,
        data: data,
        interpolation: interpolation,
        groupComponent: groupComponent,
        style: style.data,
        theme: theme
      }
    }
  };
  return data.reduce(function (childProps, datum, index) {
    var text = LabelHelpers.getText(props, datum, index);

    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
      var eventKey = !isNil_1(datum.eventKey) ? datum.eventKey : index;
      childProps[eventKey] = {
        labels: LabelHelpers.getProps(props, index)
      };
    }

    return childProps;
  }, initialChildProps);
};

function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$p(target, key, source[key]); }); } return target; }

function _defineProperty$p(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defined$1 = function (d) {
  var y = d._y1 !== undefined ? d._y1 : d._y;
  return y !== null && y !== undefined && d._y0 !== null;
};

var getXAccessor$1 = function (scale) {
  return function (d) {
    return scale.x(d._x1 !== undefined ? d._x1 : d._x);
  };
};

var getYAccessor$1 = function (scale) {
  return function (d) {
    return scale.y(d._y1 !== undefined ? d._y1 : d._y);
  };
};

var getAngleAccessor$1 = function (scale) {
  return function (d) {
    var x = scale.x(d._x1 !== undefined ? d._x1 : d._x);
    return -1 * x + Math.PI / 2;
  };
};

var toNewName$2 = function (interpolation) {
  // d3 shape changed the naming scheme for interpolators from "basis" -> "curveBasis" etc.
  var capitalize = function (s) {
    return s && s[0].toUpperCase() + s.slice(1);
  };

  return "curve".concat(capitalize(interpolation));
};

var getLineFunction$1 = function (props) {
  var polar = props.polar,
      scale = props.scale,
      horizontal = props.horizontal;
  var defaultOpenCurve = polar ? false : true;
  var openCurve = props.openCurve === undefined ? defaultOpenCurve : props.openCurve;
  var interpolationFunction = typeof props.interpolation === "function" && props.interpolation;
  var interpolationName = typeof props.interpolation === "string" && (!openCurve ? "".concat(toNewName$2(props.interpolation), "Closed") : toNewName$2(props.interpolation));
  return polar ? lineRadial$1().defined(defined$1).curve(interpolationFunction || d3Shape[interpolationName]).angle(getAngleAccessor$1(scale)).radius(getYAccessor$1(scale)) : line().defined(defined$1).curve(interpolationFunction || d3Shape[interpolationName]).x(horizontal ? getYAccessor$1(scale) : getXAccessor$1(scale)).y(horizontal ? getXAccessor$1(scale) : getYAccessor$1(scale));
};

var evaluateProps$7 = function (props) {
  /**
   * Potential evaluated props are:
   * `ariaLabel`
   * `id`
   * `style`
   * `tabIndex`
   */
  var ariaLabel = Helpers.evaluateProp(props.ariaLabel, props);
  var id = Helpers.evaluateProp(props.id, props);
  var style = Helpers.evaluateStyle(assign_1({
    fill: "none",
    stroke: "black"
  }, props.style), props);
  var tabIndex = Helpers.evaluateProp(props.tabIndex, props);
  return assign_1({}, props, {
    ariaLabel: ariaLabel,
    id: id,
    style: style,
    tabIndex: tabIndex
  });
};

var Curve = function (props) {
  props = evaluateProps$7(props);
  var _props = props,
      polar = _props.polar,
      origin = _props.origin;
  var lineFunction = getLineFunction$1(props);
  var defaultTransform = polar && origin ? "translate(".concat(origin.x, ", ").concat(origin.y, ")") : undefined;
  return React__default['default'].cloneElement(props.pathComponent, _objectSpread$l({}, props.events, {
    "aria-label": props.ariaLabel,
    d: lineFunction(props.data),
    style: props.style,
    transform: props.transform || defaultTransform,
    className: props.className,
    role: props.role,
    shapeRendering: props.shapeRendering,
    clipPath: props.clipPath,
    tabIndex: props.tabIndex
  }));
};

Curve.propTypes = _objectSpread$l({}, CommonProps.primitiveProps, {
  interpolation: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].func]),
  openCurve: PropTypes__default['default'].bool,
  origin: PropTypes__default['default'].object,
  pathComponent: PropTypes__default['default'].element,
  polar: PropTypes__default['default'].bool
});
Curve.defaultProps = {
  pathComponent: React__default['default'].createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};

function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$q(target, key, source[key]); }); } return target; }

function _defineProperty$q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$h(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$h(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$h(Constructor.prototype, protoProps); if (staticProps) _defineProperties$h(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$g(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$k(self); }

function _assertThisInitialized$k(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$g(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var fallbackProps$9 = {
  width: 450,
  height: 300,
  padding: 50,
  interpolation: "linear"
};
var options$3 = {
  components: [{
    name: "parent",
    index: "parent"
  }, {
    name: "data",
    index: "all"
  }, {
    name: "labels"
  }]
};

var VictoryLine =
/*#__PURE__*/
function (_React$Component) {
  _inherits$g(VictoryLine, _React$Component);

  function VictoryLine() {
    _classCallCheck$h(this, VictoryLine);

    return _possibleConstructorReturn$g(this, (VictoryLine.__proto__ || Object.getPrototypeOf(VictoryLine)).apply(this, arguments));
  }

  _createClass$h(VictoryLine, [{
    key: "shouldAnimate",
    // Overridden in native versions
    value: function shouldAnimate() {
      return !!this.props.animate;
    }
  }, {
    key: "render",
    value: function render() {
      var animationWhitelist = VictoryLine.animationWhitelist,
          role = VictoryLine.role;
      var props = Helpers.modifyProps(this.props, fallbackProps$9, role);

      if (this.shouldAnimate()) {
        return this.animateComponent(props, animationWhitelist);
      }

      var children = this.renderContinuousData(props);
      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
    }
  }]);

  return VictoryLine;
}(React__default['default'].Component);

Object.defineProperty(VictoryLine, "animationWhitelist", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["data", "domain", "height", "padding", "samples", "style", "width"]
});
Object.defineProperty(VictoryLine, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryLine"
});
Object.defineProperty(VictoryLine, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "line"
});
Object.defineProperty(VictoryLine, "defaultTransitions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DefaultTransitions.continuousTransitions()
});
Object.defineProperty(VictoryLine, "defaultPolarTransitions", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DefaultTransitions.continuousPolarTransitions()
});
Object.defineProperty(VictoryLine, "continuous", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: true
});
Object.defineProperty(VictoryLine, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: _objectSpread$m({}, CommonProps.baseProps, CommonProps.dataProps, {
    interpolation: PropTypes__default['default'].oneOfType([PropTypes__default['default'].oneOf(["basis", "bundle", "cardinal", "catmullRom", "linear", "monotoneX", "monotoneY", "natural", "step", "stepAfter", "stepBefore"]), PropTypes__default['default'].func]),
    label: CustomPropTypes.deprecated(PropTypes__default['default'].string, "Use `labels` instead for individual data labels")
  })
});
Object.defineProperty(VictoryLine, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    containerComponent: React__default['default'].createElement(VictoryContainer, null),
    dataComponent: React__default['default'].createElement(Curve, null),
    labelComponent: React__default['default'].createElement(VictoryLabel, {
      renderInPortal: true
    }),
    groupComponent: React__default['default'].createElement(VictoryClipContainer, null),
    samples: 50,
    sortKey: "x",
    sortOrder: "ascending",
    standalone: true,
    theme: VictoryTheme.grayscale
  }
});
Object.defineProperty(VictoryLine, "getDomain", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Domain.getDomain
});
Object.defineProperty(VictoryLine, "getData", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: Data.getData
});
Object.defineProperty(VictoryLine, "getBaseProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function (props) {
    return getBaseProps$5(props, fallbackProps$9);
  }
});
Object.defineProperty(VictoryLine, "expectedComponents", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]
});
var VictoryLine$1 = addEvents(VictoryLine, options$3);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$2 = function() {
  return _root.Date.now();
};

var now_1 = now$2;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$4 = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$4(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce$1;

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  if (isObject_1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce_1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle$1;

function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$r(target, key, source[key]); }); } return target; }

function _defineProperty$r(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getVerticalPath = function (props) {
  var pointerWidth = props.pointerWidth,
      cornerRadius = props.cornerRadius,
      orientation = props.orientation,
      width = props.width,
      height = props.height,
      center = props.center;
  var sign = orientation === "bottom" ? 1 : -1;
  var x = props.x + (props.dx || 0);
  var y = props.y + (props.dy || 0);
  var centerX = isPlainObject_1(center) && center.x;
  var centerY = isPlainObject_1(center) && center.y;
  var pointerEdge = centerY + sign * (height / 2);
  var oppositeEdge = centerY - sign * (height / 2);
  var rightEdge = centerX + width / 2;
  var leftEdge = centerX - width / 2;
  var pointerLength = sign * (y - pointerEdge) < 0 ? 0 : props.pointerLength;
  var direction = orientation === "bottom" ? "0 0 0" : "0 0 1";
  var arc = "".concat(cornerRadius, " ").concat(cornerRadius, " ").concat(direction);
  return "M ".concat(centerX - pointerWidth / 2, ", ").concat(pointerEdge, "\n    L ").concat(pointerLength ? x : centerX + pointerWidth / 2, ", ").concat(pointerLength ? y : pointerEdge, "\n    L ").concat(centerX + pointerWidth / 2, ", ").concat(pointerEdge, "\n    L ").concat(rightEdge - cornerRadius, ", ").concat(pointerEdge, "\n    A ").concat(arc, " ").concat(rightEdge, ", ").concat(pointerEdge - sign * cornerRadius, "\n    L ").concat(rightEdge, ", ").concat(oppositeEdge + sign * cornerRadius, "\n    A ").concat(arc, " ").concat(rightEdge - cornerRadius, ", ").concat(oppositeEdge, "\n    L ").concat(leftEdge + cornerRadius, ", ").concat(oppositeEdge, "\n    A ").concat(arc, " ").concat(leftEdge, ", ").concat(oppositeEdge + sign * cornerRadius, "\n    L ").concat(leftEdge, ", ").concat(pointerEdge - sign * cornerRadius, "\n    A ").concat(arc, " ").concat(leftEdge + cornerRadius, ", ").concat(pointerEdge, "\n    z");
};

var getHorizontalPath = function (props) {
  var pointerWidth = props.pointerWidth,
      cornerRadius = props.cornerRadius,
      orientation = props.orientation,
      width = props.width,
      height = props.height,
      center = props.center;
  var sign = orientation === "left" ? 1 : -1;
  var x = props.x + (props.dx || 0);
  var y = props.y + (props.dy || 0);
  var centerX = isPlainObject_1(center) && center.x;
  var centerY = isPlainObject_1(center) && center.y;
  var pointerEdge = centerX - sign * (width / 2);
  var oppositeEdge = centerX + sign * (width / 2);
  var bottomEdge = centerY + height / 2;
  var topEdge = centerY - height / 2;
  var pointerLength = sign * (x - pointerEdge) > 0 ? 0 : props.pointerLength;
  var direction = orientation === "left" ? "0 0 0" : "0 0 1";
  var arc = "".concat(cornerRadius, " ").concat(cornerRadius, " ").concat(direction);
  return "M ".concat(pointerEdge, ", ").concat(centerY - pointerWidth / 2, "\n    L ").concat(pointerLength ? x : pointerEdge, ", ").concat(pointerLength ? y : centerY + pointerWidth / 2, "\n    L ").concat(pointerEdge, ", ").concat(centerY + pointerWidth / 2, "\n    L ").concat(pointerEdge, ", ").concat(bottomEdge - cornerRadius, "\n    A ").concat(arc, " ").concat(pointerEdge + sign * cornerRadius, ", ").concat(bottomEdge, "\n    L ").concat(oppositeEdge - sign * cornerRadius, ", ").concat(bottomEdge, "\n    A ").concat(arc, " ").concat(oppositeEdge, ", ").concat(bottomEdge - cornerRadius, "\n    L ").concat(oppositeEdge, ", ").concat(topEdge + cornerRadius, "\n    A ").concat(arc, " ").concat(oppositeEdge - sign * cornerRadius, ", ").concat(topEdge, "\n    L ").concat(pointerEdge + sign * cornerRadius, ", ").concat(topEdge, "\n    A ").concat(arc, " ").concat(pointerEdge, ", ").concat(topEdge + cornerRadius, "\n    z");
};

var getFlyoutPath = function (props) {
  var orientation = props.orientation || "top";
  return orientation === "left" || orientation === "right" ? getHorizontalPath(props) : getVerticalPath(props);
};

var evaluateProps$8 = function (props) {
  /**
   * Potential evaluated props are:
   * `id`
   * `style`
   */
  var id = Helpers.evaluateProp(props.id, props);
  var style = Helpers.evaluateStyle(props.style, props);
  return assign_1({}, props, {
    id: id,
    style: style
  });
};

var Flyout = function (props) {
  props = evaluateProps$8(props);
  return React__default['default'].cloneElement(props.pathComponent, _objectSpread$n({}, props.events, {
    style: props.style,
    d: getFlyoutPath(props),
    className: props.className,
    shapeRendering: props.shapeRendering,
    role: props.role,
    transform: props.transform,
    clipPath: props.clipPath
  }));
};

Flyout.propTypes = _objectSpread$n({}, CommonProps.primitiveProps, {
  center: PropTypes__default['default'].shape({
    x: PropTypes__default['default'].number,
    y: PropTypes__default['default'].number
  }),
  cornerRadius: PropTypes__default['default'].number,
  datum: PropTypes__default['default'].object,
  dx: PropTypes__default['default'].number,
  dy: PropTypes__default['default'].number,
  height: PropTypes__default['default'].number,
  orientation: PropTypes__default['default'].oneOf(["top", "bottom", "left", "right"]),
  pathComponent: PropTypes__default['default'].element,
  pointerLength: PropTypes__default['default'].number,
  pointerWidth: PropTypes__default['default'].number,
  width: PropTypes__default['default'].number,
  x: PropTypes__default['default'].number,
  y: PropTypes__default['default'].number
});
Flyout.defaultProps = {
  pathComponent: React__default['default'].createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};

function _toConsumableArray$j(arr) { return _arrayWithoutHoles$j(arr) || _iterableToArray$j(arr) || _nonIterableSpread$j(); }

function _nonIterableSpread$j() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$j(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$j(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck$i(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$i(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$i(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$i(Constructor.prototype, protoProps); if (staticProps) _defineProperties$i(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$h(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$l(self); }

function _assertThisInitialized$l(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$h(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var fallbackProps$a = {
  cornerRadius: 5,
  pointerLength: 10,
  pointerWidth: 10
};

var VictoryTooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits$h(VictoryTooltip, _React$Component);

  function VictoryTooltip(props) {
    var _this;

    _classCallCheck$i(this, VictoryTooltip);

    _this = _possibleConstructorReturn$h(this, (VictoryTooltip.__proto__ || Object.getPrototypeOf(VictoryTooltip)).call(this, props));
    _this.id = props.id === undefined ? uniqueId_1("tooltip-") : props.id;
    return _this;
  }

  _createClass$i(VictoryTooltip, [{
    key: "getDefaultOrientation",
    value: function getDefaultOrientation(props) {
      var datum = props.datum,
          horizontal = props.horizontal,
          polar = props.polar;

      if (!polar) {
        var positive = horizontal ? "right" : "top";
        var negative = horizontal ? "left" : "bottom";
        return datum && datum.y < 0 ? negative : positive;
      } else {
        return this.getPolarOrientation(props, datum);
      }
    }
  }, {
    key: "getPolarOrientation",
    value: function getPolarOrientation(props, datum) {
      var degrees = LabelHelpers.getDegrees(props, datum);
      var placement = props.labelPlacement || "vertical";

      if (placement === " vertical") {
        return this.getVerticalOrientations(degrees);
      } else if (placement === "parallel") {
        return degrees < 90 || degrees > 270 ? "right" : "left";
      } else {
        return degrees > 180 ? "bottom" : "top";
      }
    }
  }, {
    key: "getVerticalOrientations",
    value: function getVerticalOrientations(degrees) {
      // eslint-disable-next-line no-magic-numbers
      if (degrees < 45 || degrees > 315) {
        return "right"; // eslint-disable-next-line no-magic-numbers
      } else if (degrees >= 45 && degrees <= 135) {
        return "top"; // eslint-disable-next-line no-magic-numbers
      } else if (degrees > 135 && degrees < 225) {
        return "left";
      } else {
        return "bottom";
      }
    }
  }, {
    key: "getStyles",
    value: function getStyles(props) {
      var theme = props.theme || VictoryTheme.grayscale;
      var defaultLabelStyles = theme && theme.tooltip && theme.tooltip.style ? theme.tooltip.style : {};
      var baseLabelStyle = Array.isArray(props.style) ? props.style.map(function (s) {
        return defaults_1({}, s, defaultLabelStyles);
      }) : defaults_1({}, props.style, defaultLabelStyles);
      var defaultFlyoutStyles = theme && theme.tooltip && theme.tooltip.flyoutStyle ? theme.tooltip.flyoutStyle : {};
      var baseFlyoutStyle = props.flyoutStyle ? defaults_1({}, props.flyoutStyle, defaultFlyoutStyles) : defaultFlyoutStyles;
      var style = Array.isArray(baseLabelStyle) ? baseLabelStyle.map(function (s) {
        return Helpers.evaluateStyle(s, props);
      }) : Helpers.evaluateStyle(baseLabelStyle, props);
      var flyoutStyle = Helpers.evaluateStyle(baseFlyoutStyle, assign_1({}, props, {
        style: style
      }));
      return {
        style: style,
        flyoutStyle: flyoutStyle
      };
    }
  }, {
    key: "getEvaluatedProps",
    value: function getEvaluatedProps(props) {
      var cornerRadius = props.cornerRadius,
          centerOffset = props.centerOffset,
          dx = props.dx,
          dy = props.dy;
      var active = Helpers.evaluateProp(props.active, props);
      var text = Helpers.evaluateProp(props.text, assign_1({}, props, {
        active: active
      }));

      var _getStyles = this.getStyles(assign_1({}, props, {
        active: active,
        text: text
      })),
          style = _getStyles.style,
          flyoutStyle = _getStyles.flyoutStyle;

      var orientation = Helpers.evaluateProp(props.orientation, assign_1({}, props, {
        active: active,
        text: text,
        style: style,
        flyoutStyle: flyoutStyle
      })) || this.getDefaultOrientation(props);
      var padding = Helpers.evaluateProp(props.flyoutPadding, assign_1({}, props, {
        active: active,
        text: text,
        style: style,
        flyoutStyle: flyoutStyle,
        orientation: orientation
      })) || this.getLabelPadding(style);
      var flyoutPadding = Helpers.getPadding({
        padding: padding
      });
      var pointerWidth = Helpers.evaluateProp(props.pointerWidth, assign_1({}, props, {
        active: active,
        text: text,
        style: style,
        flyoutStyle: flyoutStyle,
        orientation: orientation
      }));
      var pointerLength = Helpers.evaluateProp(props.pointerLength, assign_1({}, props, {
        active: active,
        text: text,
        style: style,
        flyoutStyle: flyoutStyle,
        orientation: orientation
      }));
      var labelSize = TextSize.approximateTextSize(text, style);

      var _getDimensions = this.getDimensions(assign_1({}, props, {
        style: style,
        flyoutStyle: flyoutStyle,
        active: active,
        text: text,
        orientation: orientation,
        flyoutPadding: flyoutPadding,
        pointerWidth: pointerWidth,
        pointerLength: pointerLength
      }), labelSize),
          flyoutHeight = _getDimensions.flyoutHeight,
          flyoutWidth = _getDimensions.flyoutWidth;

      var evaluatedProps = assign_1({}, props, {
        active: active,
        text: text,
        style: style,
        flyoutStyle: flyoutStyle,
        orientation: orientation,
        flyoutHeight: flyoutHeight,
        flyoutWidth: flyoutWidth,
        flyoutPadding: flyoutPadding,
        pointerWidth: pointerWidth,
        pointerLength: pointerLength
      });

      var offsetX = isPlainObject_1(centerOffset) && centerOffset.x !== undefined ? Helpers.evaluateProp(centerOffset.x, evaluatedProps) : 0;
      var offsetY = isPlainObject_1(centerOffset) && centerOffset.y !== undefined ? Helpers.evaluateProp(centerOffset.y, evaluatedProps) : 0;
      return assign_1({}, evaluatedProps, {
        centerOffset: {
          x: offsetX,
          y: offsetY
        },
        dx: dx !== undefined ? Helpers.evaluateProp(dx, evaluatedProps) : 0,
        dy: dy !== undefined ? Helpers.evaluateProp(dy, evaluatedProps) : 0,
        cornerRadius: Helpers.evaluateProp(cornerRadius, evaluatedProps)
      });
    }
  }, {
    key: "getCalculatedValues",
    value: function getCalculatedValues(props) {
      var style = props.style,
          text = props.text,
          flyoutStyle = props.flyoutStyle,
          flyoutHeight = props.flyoutHeight,
          flyoutWidth = props.flyoutWidth;
      var labelSize = TextSize.approximateTextSize(text, style);
      var flyoutDimensions = {
        height: flyoutHeight,
        width: flyoutWidth
      };
      var flyoutCenter = this.getFlyoutCenter(props, flyoutDimensions);
      var transform = this.getTransform(props);
      return {
        style: style,
        flyoutStyle: flyoutStyle,
        labelSize: labelSize,
        flyoutDimensions: flyoutDimensions,
        flyoutCenter: flyoutCenter,
        transform: transform
      };
    }
  }, {
    key: "getTransform",
    value: function getTransform(props) {
      var x = props.x,
          y = props.y,
          style = props.style;
      var labelStyle = style || {};
      var angle = labelStyle.angle || props.angle || this.getDefaultAngle(props);
      return angle ? "rotate(".concat(angle, " ").concat(x, " ").concat(y, ")") : undefined;
    } // eslint-disable-next-line complexity

  }, {
    key: "getDefaultAngle",
    value: function getDefaultAngle(props) {
      var polar = props.polar,
          labelPlacement = props.labelPlacement,
          orientation = props.orientation,
          datum = props.datum;

      if (!polar || !labelPlacement || labelPlacement === "vertical") {
        return 0;
      }

      var degrees = LabelHelpers.getDegrees(props, datum);
      var sign = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
      var labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
      var angle;

      if (degrees === 0 || degrees === 180) {
        angle = orientation === "top" && degrees === 180 ? 270 : 90;
      } else if (degrees > 0 && degrees < 180) {
        angle = 90 - degrees;
      } else if (degrees > 180 && degrees < 360) {
        angle = 270 - degrees;
      }

      return angle + sign * labelRotation;
    }
  }, {
    key: "constrainTooltip",
    value: function constrainTooltip(center, props, dimensions) {
      var x = center.x,
          y = center.y;
      var width = dimensions.width,
          height = dimensions.height;
      var extent = {
        x: [0, props.width],
        y: [0, props.height]
      };
      var flyoutExtent = {
        x: [x - width / 2, x + width / 2],
        y: [y - height / 2, y + height / 2]
      };
      var adjustments = {
        x: [flyoutExtent.x[0] < extent.x[0] ? extent.x[0] - flyoutExtent.x[0] : 0, flyoutExtent.x[1] > extent.x[1] ? flyoutExtent.x[1] - extent.x[1] : 0],
        y: [flyoutExtent.y[0] < extent.y[0] ? extent.y[0] - flyoutExtent.y[0] : 0, flyoutExtent.y[1] > extent.y[1] ? flyoutExtent.y[1] - extent.y[1] : 0]
      };
      return {
        x: Math.round(x + adjustments.x[0] - adjustments.x[1]),
        y: Math.round(y + adjustments.y[0] - adjustments.y[1])
      };
    } // eslint-disable-next-line complexity

  }, {
    key: "getFlyoutCenter",
    value: function getFlyoutCenter(props, dimensions) {
      var x = props.x,
          y = props.y,
          dx = props.dx,
          dy = props.dy,
          pointerLength = props.pointerLength,
          orientation = props.orientation,
          constrainToVisibleArea = props.constrainToVisibleArea,
          centerOffset = props.centerOffset;
      var height = dimensions.height,
          width = dimensions.width;
      var xSign = orientation === "left" ? -1 : 1;
      var ySign = orientation === "bottom" ? -1 : 1;
      var flyoutCenter = {
        x: orientation === "left" || orientation === "right" ? x + xSign * (pointerLength + width / 2 + xSign * dx) : x + dx,
        y: orientation === "top" || orientation === "bottom" ? y - ySign * (pointerLength + height / 2 - ySign * dy) : y + dy
      };
      var center = {
        x: isPlainObject_1(props.center) && props.center.x !== undefined ? props.center.x : flyoutCenter.x,
        y: isPlainObject_1(props.center) && props.center.y !== undefined ? props.center.y : flyoutCenter.y
      };
      var centerWithOffset = {
        x: center.x + centerOffset.x,
        y: center.y + centerOffset.y
      };
      return constrainToVisibleArea ? this.constrainTooltip(centerWithOffset, props, dimensions) : centerWithOffset;
    }
  }, {
    key: "getLabelPadding",
    value: function getLabelPadding(style) {
      if (!style) {
        return 0;
      }

      var paddings = Array.isArray(style) ? style.map(function (s) {
        return s.padding;
      }) : [style.padding];
      return Math.max.apply(Math, _toConsumableArray$j(paddings).concat([0]));
    }
  }, {
    key: "getDimensions",
    value: function getDimensions(props, labelSize) {
      var orientation = props.orientation,
          pointerLength = props.pointerLength,
          pointerWidth = props.pointerWidth,
          flyoutHeight = props.flyoutHeight,
          flyoutWidth = props.flyoutWidth,
          flyoutPadding = props.flyoutPadding;
      var cornerRadius = Helpers.evaluateProp(props.cornerRadius, props);

      var getHeight = function () {
        var calculatedHeight = labelSize.height + flyoutPadding.top + flyoutPadding.bottom;
        var minHeight = orientation === "top" || orientation === "bottom" ? 2 * cornerRadius : 2 * cornerRadius + pointerWidth;
        return Math.max(minHeight, calculatedHeight);
      };

      var getWidth = function () {
        var calculatedWidth = labelSize.width + flyoutPadding.left + flyoutPadding.right;
        var minWidth = orientation === "left" || orientation === "right" ? 2 * cornerRadius + pointerLength : 2 * cornerRadius;
        return Math.max(minWidth, calculatedWidth);
      };

      return {
        flyoutHeight: flyoutHeight ? Helpers.evaluateProp(flyoutHeight, props) : getHeight(),
        flyoutWidth: flyoutWidth ? Helpers.evaluateProp(flyoutWidth, props) : getWidth()
      };
    }
  }, {
    key: "getLabelProps",
    value: function getLabelProps(props, calculatedValues) {
      var flyoutCenter = calculatedValues.flyoutCenter,
          style = calculatedValues.style,
          labelSize = calculatedValues.labelSize,
          _calculatedValues$dy = calculatedValues.dy,
          dy = _calculatedValues$dy === void 0 ? 0 : _calculatedValues$dy,
          _calculatedValues$dx = calculatedValues.dx,
          dx = _calculatedValues$dx === void 0 ? 0 : _calculatedValues$dx;
      var text = props.text,
          datum = props.datum,
          activePoints = props.activePoints,
          labelComponent = props.labelComponent,
          index = props.index,
          flyoutPadding = props.flyoutPadding;
      var textAnchor = (Array.isArray(style) && style.length ? style[0].textAnchor : style.textAnchor) || "middle";

      var getLabelX = function () {
        if (!textAnchor || textAnchor === "middle") {
          return flyoutCenter.x;
        }

        var sign = textAnchor === "end" ? -1 : 1;
        return flyoutCenter.x - sign * (labelSize.width / 2);
      };

      return defaults_1({}, labelComponent.props, {
        key: "".concat(this.id, "-label-").concat(index),
        text: text,
        datum: datum,
        activePoints: activePoints,
        textAnchor: textAnchor,
        dy: dy,
        dx: dx,
        style: style,
        x: getLabelX() + (flyoutPadding.left - flyoutPadding.right) / 2,
        y: flyoutCenter.y + (flyoutPadding.top - flyoutPadding.bottom) / 2,
        verticalAnchor: "middle",
        angle: style.angle
      });
    }
  }, {
    key: "getPointerOrientation",
    value: function getPointerOrientation(point, center, flyoutDimensions) {
      var edges = {
        bottom: center.y + flyoutDimensions.height / 2,
        top: center.y - flyoutDimensions.height / 2,
        left: center.x - flyoutDimensions.width / 2,
        right: center.x + flyoutDimensions.width / 2
      };
      var gaps = [{
        side: "top",
        val: edges.top > point.y ? edges.top - point.y : -1
      }, {
        side: "bottom",
        val: edges.bottom < point.y ? point.y - edges.bottom : -1
      }, {
        side: "right",
        val: edges.right < point.x ? point.x - edges.right : -1
      }, {
        side: "left",
        val: edges.left > point.x ? edges.left - point.x : -1
      }];
      return orderBy_1(gaps, "val", "desc")[0].side;
    }
  }, {
    key: "getFlyoutProps",
    value: function getFlyoutProps(props, calculatedValues) {
      var flyoutDimensions = calculatedValues.flyoutDimensions,
          flyoutStyle = calculatedValues.flyoutStyle,
          flyoutCenter = calculatedValues.flyoutCenter;
      var x = props.x,
          y = props.y,
          dx = props.dx,
          dy = props.dy,
          datum = props.datum,
          activePoints = props.activePoints,
          index = props.index,
          pointerLength = props.pointerLength,
          pointerWidth = props.pointerWidth,
          cornerRadius = props.cornerRadius,
          events = props.events,
          flyoutComponent = props.flyoutComponent;
      var pointerOrientation = Helpers.evaluateProp(props.pointerOrientation, props);
      return defaults_1({}, flyoutComponent.props, {
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        datum: datum,
        activePoints: activePoints,
        index: index,
        pointerLength: pointerLength,
        pointerWidth: pointerWidth,
        cornerRadius: cornerRadius,
        events: events,
        orientation: pointerOrientation || this.getPointerOrientation({
          x: x,
          y: y
        }, flyoutCenter, flyoutDimensions),
        key: "".concat(this.id, "-tooltip-").concat(index),
        width: flyoutDimensions.width,
        height: flyoutDimensions.height,
        style: flyoutStyle,
        center: flyoutCenter
      });
    } // Overridden in victory-core-native

  }, {
    key: "renderTooltip",
    value: function renderTooltip(props) {
      var evaluatedProps = this.getEvaluatedProps(props);
      var flyoutComponent = evaluatedProps.flyoutComponent,
          labelComponent = evaluatedProps.labelComponent,
          groupComponent = evaluatedProps.groupComponent,
          active = evaluatedProps.active,
          renderInPortal = evaluatedProps.renderInPortal;

      if (!active) {
        return renderInPortal ? React__default['default'].createElement(VictoryPortal, null, null) : null;
      }

      var calculatedValues = this.getCalculatedValues(evaluatedProps);
      var children = [React__default['default'].cloneElement(flyoutComponent, this.getFlyoutProps(evaluatedProps, calculatedValues)), React__default['default'].cloneElement(labelComponent, this.getLabelProps(evaluatedProps, calculatedValues))];
      var tooltip = React__default['default'].cloneElement(groupComponent, {
        role: "presentation",
        transform: calculatedValues.transform
      }, children);
      return renderInPortal ? React__default['default'].createElement(VictoryPortal, null, tooltip) : tooltip;
    }
  }, {
    key: "render",
    value: function render() {
      var props = Helpers.modifyProps(this.props, fallbackProps$a, "tooltip");
      return this.renderTooltip(props);
    }
  }]);

  return VictoryTooltip;
}(React__default['default'].Component);

Object.defineProperty(VictoryTooltip, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "VictoryTooltip"
});
Object.defineProperty(VictoryTooltip, "role", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: "tooltip"
});
Object.defineProperty(VictoryTooltip, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    activateData: PropTypes__default['default'].bool,
    active: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].func]),
    activePoints: PropTypes__default['default'].array,
    angle: PropTypes__default['default'].number,
    center: PropTypes__default['default'].shape({
      x: CustomPropTypes.nonNegative,
      y: CustomPropTypes.nonNegative
    }),
    centerOffset: PropTypes__default['default'].shape({
      x: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
      y: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func])
    }),
    constrainToVisibleArea: PropTypes__default['default'].bool,
    cornerRadius: PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
    data: PropTypes__default['default'].array,
    datum: PropTypes__default['default'].object,
    dx: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
    dy: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].func]),
    events: PropTypes__default['default'].object,
    flyoutComponent: PropTypes__default['default'].element,
    flyoutHeight: PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
    flyoutPadding: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].number, PropTypes__default['default'].shape({
      top: PropTypes__default['default'].number,
      bottom: PropTypes__default['default'].number,
      left: PropTypes__default['default'].number,
      right: PropTypes__default['default'].number
    })]),
    flyoutStyle: PropTypes__default['default'].object,
    flyoutWidth: PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
    groupComponent: PropTypes__default['default'].element,
    height: PropTypes__default['default'].number,
    horizontal: PropTypes__default['default'].bool,
    id: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
    index: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
    labelComponent: PropTypes__default['default'].element,
    orientation: PropTypes__default['default'].oneOfType([PropTypes__default['default'].oneOf(["top", "bottom", "left", "right"]), PropTypes__default['default'].func]),
    pointerLength: PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
    pointerOrientation: PropTypes__default['default'].oneOfType([PropTypes__default['default'].oneOf(["top", "bottom", "left", "right"]), PropTypes__default['default'].func]),
    pointerWidth: PropTypes__default['default'].oneOfType([CustomPropTypes.nonNegative, PropTypes__default['default'].func]),
    polar: PropTypes__default['default'].bool,
    renderInPortal: PropTypes__default['default'].bool,
    scale: PropTypes__default['default'].shape({
      x: CustomPropTypes.scale,
      y: CustomPropTypes.scale
    }),
    style: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].array]),
    text: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number, PropTypes__default['default'].func, PropTypes__default['default'].array]),
    theme: PropTypes__default['default'].object,
    width: PropTypes__default['default'].number,
    x: PropTypes__default['default'].number,
    y: PropTypes__default['default'].number
  }
});
Object.defineProperty(VictoryTooltip, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    active: false,
    renderInPortal: true,
    labelComponent: React__default['default'].createElement(VictoryLabel, null),
    flyoutComponent: React__default['default'].createElement(Flyout, null),
    groupComponent: React__default['default'].createElement("g", null)
  }
});
Object.defineProperty(VictoryTooltip, "defaultEvents", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: function (props) {
    var activate = props.activateData ? [{
      target: "labels",
      mutation: function () {
        return {
          active: true
        };
      }
    }, {
      target: "data",
      mutation: function () {
        return {
          active: true
        };
      }
    }] : [{
      target: "labels",
      mutation: function () {
        return {
          active: true
        };
      }
    }];
    var deactivate = props.activateData ? [{
      target: "labels",
      mutation: function () {
        return {
          active: undefined
        };
      }
    }, {
      target: "data",
      mutation: function () {
        return {
          active: undefined
        };
      }
    }] : [{
      target: "labels",
      mutation: function () {
        return {
          active: undefined
        };
      }
    }];
    return [{
      target: "data",
      eventHandlers: {
        onMouseOver: function () {
          return activate;
        },
        onFocus: function () {
          return activate;
        },
        onTouchStart: function () {
          return activate;
        },
        onMouseOut: function () {
          return deactivate;
        },
        onBlur: function () {
          return deactivate;
        },
        onTouchEnd: function () {
          return deactivate;
        }
      }
    }];
  }
});

var delaunator = createCommonjsModule(function (module, exports) {
(function (global, factory) {
     module.exports = factory() ;
}(commonjsGlobal, function () {
    var EPSILON = Math.pow(2, -52);
    var EDGE_STACK = new Uint32Array(512);

    var Delaunator = function Delaunator(coords) {
        var n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== 'number') { throw new Error('Expected coords to contain numbers.'); }

        this.coords = coords;

        // arrays that will store the triangulation graph
        var maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);

        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash

        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);

        this.update();
    };

    Delaunator.from = function from (points, getX, getY) {
            if ( getX === void 0 ) getX = defaultGetX;
            if ( getY === void 0 ) getY = defaultGetY;

        var n = points.length;
        var coords = new Float64Array(n * 2);

        for (var i = 0; i < n; i++) {
            var p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }

        return new Delaunator(coords);
    };

    Delaunator.prototype.update = function update () {
        var ref =  this;
            var coords = ref.coords;
            var hullPrev = ref._hullPrev;
            var hullNext = ref._hullNext;
            var hullTri = ref._hullTri;
            var hullHash = ref._hullHash;
        var n = coords.length >> 1;

        // populate an array of point indices; calculate input data bbox
        var minX = Infinity;
        var minY = Infinity;
        var maxX = -Infinity;
        var maxY = -Infinity;

        for (var i = 0; i < n; i++) {
            var x = coords[2 * i];
            var y = coords[2 * i + 1];
            if (x < minX) { minX = x; }
            if (y < minY) { minY = y; }
            if (x > maxX) { maxX = x; }
            if (y > maxY) { maxY = y; }
            this._ids[i] = i;
        }
        var cx = (minX + maxX) / 2;
        var cy = (minY + maxY) / 2;

        var minDist = Infinity;
        var i0, i1, i2;

        // pick a seed point close to the center
        for (var i$1 = 0; i$1 < n; i$1++) {
            var d = dist(cx, cy, coords[2 * i$1], coords[2 * i$1 + 1]);
            if (d < minDist) {
                i0 = i$1;
                minDist = d;
            }
        }
        var i0x = coords[2 * i0];
        var i0y = coords[2 * i0 + 1];

        minDist = Infinity;

        // find the point closest to the seed
        for (var i$2 = 0; i$2 < n; i$2++) {
            if (i$2 === i0) { continue; }
            var d$1 = dist(i0x, i0y, coords[2 * i$2], coords[2 * i$2 + 1]);
            if (d$1 < minDist && d$1 > 0) {
                i1 = i$2;
                minDist = d$1;
            }
        }
        var i1x = coords[2 * i1];
        var i1y = coords[2 * i1 + 1];

        var minRadius = Infinity;

        // find the third point which forms the smallest circumcircle with the first two
        for (var i$3 = 0; i$3 < n; i$3++) {
            if (i$3 === i0 || i$3 === i1) { continue; }
            var r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i$3], coords[2 * i$3 + 1]);
            if (r < minRadius) {
                i2 = i$3;
                minRadius = r;
            }
        }
        var i2x = coords[2 * i2];
        var i2y = coords[2 * i2 + 1];

        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for (var i$4 = 0; i$4 < n; i$4++) {
                this._dists[i$4] = (coords[2 * i$4] - coords[0]) || (coords[2 * i$4 + 1] - coords[1]);
            }
            quicksort(this._ids, this._dists, 0, n - 1);
            var hull = new Uint32Array(n);
            var j = 0;
            for (var i$5 = 0, d0 = -Infinity; i$5 < n; i$5++) {
                var id = this._ids[i$5];
                if (this._dists[id] > d0) {
                    hull[j++] = id;
                    d0 = this._dists[id];
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }

        // swap the order of the seed points for counter-clockwise orientation
        if (orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
            var i$6 = i1;
            var x$1 = i1x;
            var y$1 = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i$6;
            i2x = x$1;
            i2y = y$1;
        }

        var center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;

        for (var i$7 = 0; i$7 < n; i$7++) {
            this._dists[i$7] = dist(coords[2 * i$7], coords[2 * i$7 + 1], center.x, center.y);
        }

        // sort the points by distance from the seed triangle circumcenter
        quicksort(this._ids, this._dists, 0, n - 1);

        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        var hullSize = 3;

        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;

        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;

        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;

        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);

        for (var k = 0, xp = (void 0), yp = (void 0); k < this._ids.length; k++) {
            var i$8 = this._ids[k];
            var x$2 = coords[2 * i$8];
            var y$2 = coords[2 * i$8 + 1];

            // skip near-duplicate points
            if (k > 0 && Math.abs(x$2 - xp) <= EPSILON && Math.abs(y$2 - yp) <= EPSILON) { continue; }
            xp = x$2;
            yp = y$2;

            // skip seed triangle points
            if (i$8 === i0 || i$8 === i1 || i$8 === i2) { continue; }

            // find a visible edge on the convex hull using edge hash
            var start = 0;
            for (var j$1 = 0, key = this._hashKey(x$2, y$2); j$1 < this._hashSize; j$1++) {
                start = hullHash[(key + j$1) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) { break; }
            }

            start = hullPrev[start];
            var e = start, q = (void 0);
            while (q = hullNext[e], !orient(x$2, y$2, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1])) {
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) { continue; } // likely a near-duplicate point; skip it

            // add the first triangle from the point
            var t = this._addTriangle(e, i$8, hullNext[e], -1, -1, hullTri[e]);

            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i$8] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;

            // walk forward through the hull, adding more triangles and flipping recursively
            var n$1 = hullNext[e];
            while (q = hullNext[n$1], orient(x$2, y$2, coords[2 * n$1], coords[2 * n$1 + 1], coords[2 * q], coords[2 * q + 1])) {
                t = this._addTriangle(n$1, i$8, q, hullTri[i$8], -1, hullTri[n$1]);
                hullTri[i$8] = this._legalize(t + 2);
                hullNext[n$1] = n$1; // mark as removed
                hullSize--;
                n$1 = q;
            }

            // walk backward from the other side, adding more triangles and flipping
            if (e === start) {
                while (q = hullPrev[e], orient(x$2, y$2, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1])) {
                    t = this._addTriangle(q, i$8, e, -1, hullTri[e], hullTri[q]);
                    this._legalize(t + 2);
                    hullTri[q] = t;
                    hullNext[e] = e; // mark as removed
                    hullSize--;
                    e = q;
                }
            }

            // update the hull indices
            this._hullStart = hullPrev[i$8] = e;
            hullNext[e] = hullPrev[n$1] = i$8;
            hullNext[i$8] = n$1;

            // save the two new edges in the hash table
            hullHash[this._hashKey(x$2, y$2)] = i$8;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }

        this.hull = new Uint32Array(hullSize);
        for (var i$9 = 0, e$1 = this._hullStart; i$9 < hullSize; i$9++) {
            this.hull[i$9] = e$1;
            e$1 = hullNext[e$1];
        }

        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    };

    Delaunator.prototype._hashKey = function _hashKey (x, y) {
        return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    };

    Delaunator.prototype._legalize = function _legalize (a) {
        var ref = this;
            var triangles = ref._triangles;
            var halfedges = ref._halfedges;
            var coords = ref.coords;

        var i = 0;
        var ar = 0;

        // recursion eliminated with a fixed-size stack
        while (true) {
            var b = halfedges[a];

            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *       pl                pl
             *      /||\              /  \
             *   al/ || \bl        al/\a
             *    /  ||  \          /  \
             *   /  a||b  \flip/___ar___\
             * p0\   ||   /p1   =>   p0\---bl---/p1
             *    \  ||  /          \  /
             *   ar\ || /br         b\/br
             *      \||/              \  /
             *       pr                pr
             */
            var a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;

            if (b === -1) { // convex hull edge
                if (i === 0) { break; }
                a = EDGE_STACK[--i];
                continue;
            }

            var b0 = b - b % 3;
            var al = a0 + (a + 1) % 3;
            var bl = b0 + (b + 2) % 3;

            var p0 = triangles[ar];
            var pr = triangles[a];
            var pl = triangles[al];
            var p1 = triangles[bl];

            var illegal = inCircle(
                coords[2 * p0], coords[2 * p0 + 1],
                coords[2 * pr], coords[2 * pr + 1],
                coords[2 * pl], coords[2 * pl + 1],
                coords[2 * p1], coords[2 * p1 + 1]);

            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;

                var hbl = halfedges[bl];

                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    var e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    } while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);

                var br = b0 + (b + 1) % 3;

                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < EDGE_STACK.length) {
                    EDGE_STACK[i++] = br;
                }
            } else {
                if (i === 0) { break; }
                a = EDGE_STACK[--i];
            }
        }

        return ar;
    };

    Delaunator.prototype._link = function _link (a, b) {
        this._halfedges[a] = b;
        if (b !== -1) { this._halfedges[b] = a; }
    };

    // add a new triangle given vertex indices and adjacent half-edge ids
    Delaunator.prototype._addTriangle = function _addTriangle (i0, i1, i2, a, b, c) {
        var t = this.trianglesLen;

        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;

        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);

        this.trianglesLen += 3;

        return t;
    };

    // monotonically increases with real angle, but doesn't need expensive trigonometry
    function pseudoAngle(dx, dy) {
        var p = dx / (Math.abs(dx) + Math.abs(dy));
        return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
    }

    function dist(ax, ay, bx, by) {
        var dx = ax - bx;
        var dy = ay - by;
        return dx * dx + dy * dy;
    }

    // return 2d orientation sign if we're confident in it through J. Shewchuk's error bound check
    function orientIfSure(px, py, rx, ry, qx, qy) {
        var l = (ry - py) * (qx - px);
        var r = (rx - px) * (qy - py);
        return Math.abs(l - r) >= 3.3306690738754716e-16 * Math.abs(l + r) ? l - r : 0;
    }

    // a more robust orientation test that's stable in a given triangle (to fix robustness issues)
    function orient(rx, ry, qx, qy, px, py) {
        var sign = orientIfSure(px, py, rx, ry, qx, qy) ||
        orientIfSure(rx, ry, qx, qy, px, py) ||
        orientIfSure(qx, qy, px, py, rx, ry);
        return sign < 0;
    }

    function inCircle(ax, ay, bx, by, cx, cy, px, py) {
        var dx = ax - px;
        var dy = ay - py;
        var ex = bx - px;
        var ey = by - py;
        var fx = cx - px;
        var fy = cy - py;

        var ap = dx * dx + dy * dy;
        var bp = ex * ex + ey * ey;
        var cp = fx * fx + fy * fy;

        return dx * (ey * cp - bp * fy) -
               dy * (ex * cp - bp * fx) +
               ap * (ex * fy - ey * fx) < 0;
    }

    function circumradius(ax, ay, bx, by, cx, cy) {
        var dx = bx - ax;
        var dy = by - ay;
        var ex = cx - ax;
        var ey = cy - ay;

        var bl = dx * dx + dy * dy;
        var cl = ex * ex + ey * ey;
        var d = 0.5 / (dx * ey - dy * ex);

        var x = (ey * bl - dy * cl) * d;
        var y = (dx * cl - ex * bl) * d;

        return x * x + y * y;
    }

    function circumcenter(ax, ay, bx, by, cx, cy) {
        var dx = bx - ax;
        var dy = by - ay;
        var ex = cx - ax;
        var ey = cy - ay;

        var bl = dx * dx + dy * dy;
        var cl = ex * ex + ey * ey;
        var d = 0.5 / (dx * ey - dy * ex);

        var x = ax + (ey * bl - dy * cl) * d;
        var y = ay + (dx * cl - ex * bl) * d;

        return {x: x, y: y};
    }

    function quicksort(ids, dists, left, right) {
        if (right - left <= 20) {
            for (var i = left + 1; i <= right; i++) {
                var temp = ids[i];
                var tempDist = dists[temp];
                var j = i - 1;
                while (j >= left && dists[ids[j]] > tempDist) { ids[j + 1] = ids[j--]; }
                ids[j + 1] = temp;
            }
        } else {
            var median = (left + right) >> 1;
            var i$1 = left + 1;
            var j$1 = right;
            swap(ids, median, i$1);
            if (dists[ids[left]] > dists[ids[right]]) { swap(ids, left, right); }
            if (dists[ids[i$1]] > dists[ids[right]]) { swap(ids, i$1, right); }
            if (dists[ids[left]] > dists[ids[i$1]]) { swap(ids, left, i$1); }

            var temp$1 = ids[i$1];
            var tempDist$1 = dists[temp$1];
            while (true) {
                do { i$1++; } while (dists[ids[i$1]] < tempDist$1);
                do { j$1--; } while (dists[ids[j$1]] > tempDist$1);
                if (j$1 < i$1) { break; }
                swap(ids, i$1, j$1);
            }
            ids[left + 1] = ids[j$1];
            ids[j$1] = temp$1;

            if (right - i$1 + 1 >= j$1 - left) {
                quicksort(ids, dists, i$1, right);
                quicksort(ids, dists, left, j$1 - 1);
            } else {
                quicksort(ids, dists, left, j$1 - 1);
                quicksort(ids, dists, i$1, right);
            }
        }
    }

    function swap(arr, i, j) {
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }

    function defaultGetX(p) {
        return p[0];
    }
    function defaultGetY(p) {
        return p[1];
    }

    return Delaunator;

}));
});

var lib$3 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;

var _delaunator = _interopRequireDefault(delaunator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// From https://github.com/d3/d3-delaunay/blob/master/src/delaunay.js
function pointX(p) {
  return p[0];
}

function pointY(p) {
  return p[1];
} // A triangulation is collinear if all its triangles have a non-null area


function collinear(d) {
  var triangles = d.triangles,
      coords = d.coords;

  for (var i = 0; i < triangles.length; i += 3) {
    var a = 2 * triangles[i];
    var b = 2 * triangles[i + 1];
    var c = 2 * triangles[i + 2];
    var cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]); // eslint-disable-next-line no-magic-numbers

    if (cross > 1e-10) {
      return false;
    }
  }

  return true;
}

function jitter(x, y, r) {
  return [x + Math.sin(x + y) * r, y + Math.cos(x - y) * r];
} // eslint-disable-next-line max-params


function flatArray(points, fx, fy, that) {
  var n = points.length;
  var array = new Float64Array(n * 2);

  for (var i = 0; i < n; ++i) {
    var p = points[i];
    array[i * 2] = fx.call(that, p, i, points);
    array[i * 2 + 1] = fy.call(that, p, i, points);
  }

  return array;
}

var Delaunay =
/*#__PURE__*/
function () {
  function Delaunay(points) {
    var delaunator = new _delaunator["default"](points);
    this.inedges = new Int32Array(points.length / 2);
    this._hullIndex = new Int32Array(points.length / 2);
    this.points = delaunator.coords;

    this._init(delaunator);
  } // eslint-disable-next-line max-statements, complexity


  var _proto = Delaunay.prototype;

  _proto._init = function _init(delaunator) {
    var d = delaunator;
    var points = this.points; // check for collinear
    // eslint-disable-next-line no-magic-numbers

    if (d.hull && d.hull.length > 2 && collinear(d)) {
      this.collinear = Int32Array.from({
        length: points.length / 2
      }, function (_, i) {
        return i;
      }).sort(function (i, j) {
        return points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1];
      }); // for exact neighbors

      var e = this.collinear[0];
      var f = this.collinear[this.collinear.length - 1];
      var bounds = [points[2 * e], points[2 * e + 1], points[2 * f], points[2 * f + 1]];
      var r = 1e-8 * // eslint-disable-line no-magic-numbers
      Math.sqrt(Math.pow(bounds[3] - bounds[1], 2) + Math.pow(bounds[2] - bounds[0], 2));

      for (var i = 0, n = points.length / 2; i < n; ++i) {
        var p = jitter(points[2 * i], points[2 * i + 1], r);
        points[2 * i] = p[0];
        points[2 * i + 1] = p[1];
      }

      delaunator = new _delaunator["default"](points);
    }

    var halfedges = this.halfedges = delaunator.halfedges;
    var hull = this.hull = delaunator.hull;
    var triangles = this.triangles = delaunator.triangles;
    var inedges = this.inedges.fill(-1);

    var hullIndex = this._hullIndex.fill(-1); // Compute an index from each point to an (arbitrary) incoming halfedge
    // Used to give the first neighbor of each point; for this reason,
    // on the hull we give priority to exterior halfedges


    for (var _e = 0, _n = halfedges.length; _e < _n; ++_e) {
      var _p = triangles[_e % 3 === 2 ? _e - 2 : _e + 1];
      if (halfedges[_e] === -1 || inedges[_p] === -1) inedges[_p] = _e;
    }

    for (var _i = 0, _n2 = hull.length; _i < _n2; ++_i) {
      hullIndex[hull[_i]] = _i;
    } // degenerate case: 1 or 2 (distinct) points


    if (hull.length <= 2 && hull.length > 0) {
      this.triangles = new Int32Array(3).fill(-1);
      this.halfedges = new Int32Array(3).fill(-1);
      this.triangles[0] = hull[0];
      this.triangles[1] = hull[1];
      this.triangles[2] = hull[1];
      inedges[hull[0]] = 1;
      if (hull.length === 2) inedges[hull[1]] = 0;
    }
  } // eslint-disable-next-line max-statements
  ;

  _proto.neighbors = function neighbors(i) {
    var results = [];
    var inedges = this.inedges,
        hull = this.hull,
        _hullIndex = this._hullIndex,
        halfedges = this.halfedges,
        triangles = this.triangles;
    var e0 = inedges[i];
    if (e0 === -1) return results; // coincident point

    var e = e0;
    var p0 = -1;

    do {
      p0 = triangles[e];
      results.push(p0);
      e = e % 3 === 2 ? e - 2 : e + 1;
      if (triangles[e] !== i) break; // bad triangulation

      e = halfedges[e];

      if (e === -1) {
        var p = hull[(_hullIndex[i] + 1) % hull.length];
        if (p !== p0) results.push(p);
        break;
      }
    } while (e !== e0);

    return results;
  };

  _proto.find = function find(x, y, i) {
    if (i === void 0) {
      i = 0;
    }

    // eslint-disable-next-line no-self-compare
    if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
    var i0 = i;
    var c;

    while ((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0) {
      i = c;
    }

    return c;
  };

  _proto._step = function _step(i, x, y) {
    var inedges = this.inedges,
        points = this.points;
    if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
    var c = i;
    var dc = Math.pow(x - points[i * 2], 2) + Math.pow(y - points[i * 2 + 1], 2);

    for (var _iterator = this.neighbors(i), _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i2 >= _iterator.length) break;
        _ref = _iterator[_i2++];
      } else {
        _i2 = _iterator.next();
        if (_i2.done) break;
        _ref = _i2.value;
      }

      var t = _ref;
      var dt = Math.pow(x - points[t * 2], 2) + Math.pow(y - points[t * 2 + 1], 2);

      if (dt < dc) {
        dc = dt;
        c = t;
      }
    }

    return c;
  };

  return Delaunay;
}(); // eslint-disable-next-line max-params


exports["default"] = Delaunay;

Delaunay.from = function (points, fx, fy, that) {
  if (fx === void 0) {
    fx = pointX;
  }

  if (fy === void 0) {
    fy = pointY;
  }

  return new Delaunay(flatArray(points, fx, fy, that));
}; // only public methods will be .from and .find
});

var Delaunay = unwrapExports(lib$3);

function _toConsumableArray$k(arr) { return _arrayWithoutHoles$k(arr) || _iterableToArray$k(arr) || _nonIterableSpread$k(); }

function _nonIterableSpread$k() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$k(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$k(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
var VoronoiHelpers = {
  withinBounds: function (props, point) {
    var width = props.width,
        height = props.height,
        polar = props.polar,
        origin = props.origin,
        scale = props.scale;
    var padding = Helpers.getPadding(props, "voronoiPadding");
    var x = point.x,
        y = point.y;

    if (polar) {
      var distanceSquared = Math.pow(x - origin.x, 2) + Math.pow(y - origin.y, 2);
      var radius = Math.max.apply(Math, _toConsumableArray$k(scale.y.range()));
      return distanceSquared < Math.pow(radius, 2);
    } else {
      return x >= padding.left && x <= width - padding.right && y >= padding.top && y <= height - padding.bottom;
    }
  },
  getDatasets: function (props) {
    var children = React__default['default'].Children.toArray(props.children);

    var addMeta = function (data, name, child) {
      var continuous = child && child.type && child.type.continuous;
      var style = child ? child.props && child.props.style : props.style;
      return data.map(function (datum, index) {
        var _Helpers$getPoint = Helpers.getPoint(datum),
            x = _Helpers$getPoint.x,
            y = _Helpers$getPoint.y,
            y0 = _Helpers$getPoint.y0,
            x0 = _Helpers$getPoint.x0;

        var voronoiX = (+x + +x0) / 2;
        var voronoiY = (+y + +y0) / 2;
        return assign_1({
          _voronoiX: props.voronoiDimension === "y" ? 0 : voronoiX,
          _voronoiY: props.voronoiDimension === "x" ? 0 : voronoiY,
          eventKey: index,
          childName: name,
          continuous: continuous,
          style: style
        }, datum);
      });
    };

    if (props.data) {
      return addMeta(props.data);
    }

    var getData = function (childProps) {
      var data = Data.getData(childProps);
      return Array.isArray(data) && data.length > 0 ? data : undefined;
    };

    var iteratee = function (child, childName) {
      var childProps = child.props || {};
      var name = childProps.name || childName;
      var blacklist = props.voronoiBlacklist || [];
      var blacklistStr = blacklist.filter(isString_1);
      var blacklistRegExp = blacklist.filter(isRegExp_1);
      var isRegExpMatch = blacklistRegExp.some(function (regExp) {
        return regExp.test(name);
      });

      if (!Data.isDataComponent(child) || includes_1(blacklistStr, name) || isRegExpMatch) {
        return null;
      }

      var getChildData = child.type && isFunction_1(child.type.getData) ? child.type.getData : getData;
      var childData = getChildData(child.props);
      return childData ? addMeta(childData, name, child) : null;
    };

    return Helpers.reduceChildren(children, iteratee, props);
  },
  findPoints: function (datasets, point) {
    return datasets.filter(function (d) {
      return point._voronoiX === d._voronoiX && point._voronoiY === d._voronoiY;
    });
  },
  withinRadius: function (point, mousePosition, radius) {
    if (!point) {
      return false;
    }

    if (!radius) {
      return true;
    }

    var x = mousePosition.x,
        y = mousePosition.y;
    var distanceSquared = Math.pow(x - point[0], 2) + Math.pow(y - point[1], 2);
    return distanceSquared < Math.pow(radius, 2);
  },
  getVoronoiPoints: function (props, mousePosition) {
    var datasets = this.getDatasets(props);
    var scaledData = datasets.map(function (d) {
      var _Helpers$scalePoint = Helpers.scalePoint(props, d),
          x = _Helpers$scalePoint.x,
          y = _Helpers$scalePoint.y;

      return [x, y];
    });
    var delaunay = Delaunay.from(scaledData);
    var index = delaunay.find(mousePosition.x, mousePosition.y);
    var withinRadius = this.withinRadius(scaledData[index], mousePosition, props.radius);
    var points = withinRadius ? this.findPoints(datasets, datasets[index]) : [];
    return {
      points: points,
      index: index
    };
  },
  getActiveMutations: function (props, point) {
    var childName = point.childName,
        continuous = point.continuous;
    var activateData = props.activateData,
        activateLabels = props.activateLabels,
        labels = props.labels;

    if (!activateData && !activateLabels) {
      return [];
    }

    var defaultTarget = activateData ? ["data"] : [];
    var targets = labels && !activateLabels ? defaultTarget : defaultTarget.concat("labels");

    if (isEmpty_1(targets)) {
      return [];
    }

    return targets.map(function (target) {
      var eventKey = continuous === true && target === "data" ? "all" : point.eventKey;
      return {
        childName: childName,
        eventKey: eventKey,
        target: target,
        mutation: function () {
          return {
            active: true
          };
        }
      };
    });
  },
  getInactiveMutations: function (props, point) {
    var childName = point.childName,
        continuous = point.continuous;
    var activateData = props.activateData,
        activateLabels = props.activateLabels,
        labels = props.labels;

    if (!activateData && !activateLabels) {
      return [];
    }

    var defaultTarget = activateData ? ["data"] : [];
    var targets = labels && !activateLabels ? defaultTarget : defaultTarget.concat("labels");

    if (isEmpty_1(targets)) {
      return [];
    }

    return targets.map(function (target) {
      var eventKey = continuous && target === "data" ? "all" : point.eventKey;
      return {
        childName: childName,
        eventKey: eventKey,
        target: target,
        mutation: function () {
          return null;
        }
      };
    });
  },
  // eslint-disable-next-line max-params
  getParentMutation: function (activePoints, mousePosition, parentSVG, vIndex) {
    return [{
      target: "parent",
      eventKey: "parent",
      mutation: function () {
        return {
          activePoints: activePoints,
          mousePosition: mousePosition,
          parentSVG: parentSVG,
          vIndex: vIndex
        };
      }
    }];
  },
  onActivated: function (props, points) {
    if (isFunction_1(props.onActivated)) {
      props.onActivated(points, props);
    }
  },
  onDeactivated: function (props, points) {
    if (isFunction_1(props.onDeactivated)) {
      props.onDeactivated(points, props);
    }
  },
  onMouseLeave: function (evt, targetProps) {
    var _this = this,
        _getParentMutation;

    var activePoints = targetProps.activePoints || [];
    this.onDeactivated(targetProps, activePoints);
    var inactiveMutations = activePoints.length ? activePoints.map(function (point) {
      return _this.getInactiveMutations(targetProps, point);
    }) : [];
    return (_getParentMutation = this.getParentMutation([])).concat.apply(_getParentMutation, _toConsumableArray$k(inactiveMutations));
  },
  onMouseMove: function (evt, targetProps) {
    var _this2 = this;

    // eslint-disable-line max-statements
    var activePoints = targetProps.activePoints || [];
    var parentSVG = targetProps.parentSVG || Selection.getParentSVG(evt);
    var mousePosition = Selection.getSVGEventCoordinates(evt, parentSVG);

    if (!this.withinBounds(targetProps, mousePosition)) {
      var _getParentMutation2;

      this.onDeactivated(targetProps, activePoints);
      var inactiveMutations = activePoints.length ? activePoints.map(function (point) {
        return _this2.getInactiveMutations(targetProps, point);
      }) : [];
      return (_getParentMutation2 = this.getParentMutation([], mousePosition, parentSVG)).concat.apply(_getParentMutation2, _toConsumableArray$k(inactiveMutations));
    }

    var _getVoronoiPoints = this.getVoronoiPoints(targetProps, mousePosition),
        _getVoronoiPoints$poi = _getVoronoiPoints.points,
        points = _getVoronoiPoints$poi === void 0 ? [] : _getVoronoiPoints$poi,
        index = _getVoronoiPoints.index;

    var parentMutations = this.getParentMutation(points, mousePosition, parentSVG, index);

    if (activePoints.length && reactFastCompare(points, activePoints)) {
      return parentMutations;
    } else {
      this.onActivated(targetProps, points);
      this.onDeactivated(targetProps, activePoints);
      var activeMutations = points.length ? points.map(function (point) {
        return _this2.getActiveMutations(targetProps, point);
      }) : [];

      var _inactiveMutations = activePoints.length ? activePoints.map(function (point) {
        return _this2.getInactiveMutations(targetProps, point);
      }) : [];

      return parentMutations.concat.apply(parentMutations, _toConsumableArray$k(_inactiveMutations).concat(_toConsumableArray$k(activeMutations)));
    }
  }
};
var VoronoiHelpers$1 = {
  onMouseLeave: VoronoiHelpers.onMouseLeave.bind(VoronoiHelpers),
  onMouseMove: throttle_1(VoronoiHelpers.onMouseMove.bind(VoronoiHelpers), 32, // eslint-disable-line no-magic-numbers
  {
    leading: true,
    trailing: false
  })
};

function _toConsumableArray$l(arr) { return _arrayWithoutHoles$l(arr) || _iterableToArray$l(arr) || _nonIterableSpread$l(); }

function _nonIterableSpread$l() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$l(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$l(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$s(target, key, source[key]); }); } return target; }

function _defineProperty$s(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$j(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$j(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$j(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$j(Constructor.prototype, protoProps); if (staticProps) _defineProperties$j(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$i(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$m(self); }

function _assertThisInitialized$m(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$i(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var voronoiContainerMixin = function (base) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_base) {
    _inherits$i(VictoryVoronoiContainer, _base);

    function VictoryVoronoiContainer() {
      _classCallCheck$j(this, VictoryVoronoiContainer);

      return _possibleConstructorReturn$i(this, (VictoryVoronoiContainer.__proto__ || Object.getPrototypeOf(VictoryVoronoiContainer)).apply(this, arguments));
    }

    _createClass$j(VictoryVoronoiContainer, [{
      key: "getDimension",
      value: function getDimension(props) {
        var horizontal = props.horizontal,
            voronoiDimension = props.voronoiDimension;

        if (!horizontal || !voronoiDimension) {
          return voronoiDimension;
        }

        return voronoiDimension === "x" ? "y" : "x";
      }
    }, {
      key: "getPoint",
      value: function getPoint(point) {
        var whitelist = ["_x", "_x1", "_x0", "_y", "_y1", "_y0"];
        return pick_1(point, whitelist);
      }
    }, {
      key: "getLabelPosition",
      value: function getLabelPosition(props, labelProps, points) {
        var mousePosition = props.mousePosition,
            mouseFollowTooltips = props.mouseFollowTooltips;
        var voronoiDimension = this.getDimension(props);
        var point = this.getPoint(points[0]);
        var basePosition = Helpers.scalePoint(props, point);
        var center = mouseFollowTooltips ? mousePosition : undefined;

        if (!voronoiDimension || points.length < 2) {
          return _objectSpread$o({}, basePosition, {
            center: defaults_1({}, labelProps.center, center)
          });
        }

        var x = voronoiDimension === "y" ? mousePosition.x : basePosition.x;
        var y = voronoiDimension === "x" ? mousePosition.y : basePosition.y;
        center = mouseFollowTooltips ? mousePosition : {
          x: x,
          y: y
        };
        return {
          x: x,
          y: y,
          center: defaults_1({}, labelProps.center, center)
        };
      }
    }, {
      key: "getStyle",
      value: function getStyle(props, points, type) {
        var labels = props.labels,
            labelComponent = props.labelComponent,
            theme = props.theme;
        var componentProps = labelComponent.props || {};
        var themeStyles = theme && theme.voronoi && theme.voronoi.style ? theme.voronoi.style : {};
        var componentStyleArray = type === "flyout" ? componentProps.flyoutStyle : componentProps.style;
        return points.reduce(function (memo, datum, index) {
          var labelProps = defaults_1({}, componentProps, {
            datum: datum,
            active: true
          });

          var text = isFunction_1(labels) ? labels(labelProps) : undefined;
          var textArray = text !== undefined ? "".concat(text).split("\n") : [];
          var baseStyle = datum.style && datum.style[type] || {};
          var componentStyle = Array.isArray(componentStyleArray) ? componentStyleArray[index] : componentStyleArray;
          var style = Helpers.evaluateStyle(defaults_1({}, componentStyle, baseStyle, themeStyles[type]), labelProps);
          var styleArray = textArray.length ? textArray.map(function () {
            return style;
          }) : [style];
          memo = memo.concat(styleArray);
          return memo;
        }, []);
      }
    }, {
      key: "getDefaultLabelProps",
      value: function getDefaultLabelProps(props, points) {
        var voronoiDimension = props.voronoiDimension,
            horizontal = props.horizontal,
            mouseFollowTooltips = props.mouseFollowTooltips;
        var point = this.getPoint(points[0]);
        var multiPoint = voronoiDimension && points.length > 1;
        var y = point._y1 !== undefined ? point._y1 : point._y;
        var defaultHorizontalOrientation = y < 0 ? "left" : "right";
        var defaultOrientation = y < 0 ? "bottom" : "top";
        var labelOrientation = horizontal ? defaultHorizontalOrientation : defaultOrientation;
        var orientation = mouseFollowTooltips ? undefined : labelOrientation;
        return {
          orientation: orientation,
          pointerLength: multiPoint ? 0 : undefined,
          constrainToVisibleArea: multiPoint || mouseFollowTooltips ? true : undefined
        };
      }
    }, {
      key: "getLabelProps",
      value: function getLabelProps(props, points) {
        var labels = props.labels,
            scale = props.scale,
            labelComponent = props.labelComponent,
            theme = props.theme,
            width = props.width,
            height = props.height;
        var componentProps = labelComponent.props || {};
        var text = points.reduce(function (memo, datum) {
          var labelProps = defaults_1({}, componentProps, {
            datum: datum,
            active: true
          });

          var t = isFunction_1(labels) ? labels(labelProps) : null;

          if (t === null || t === undefined) {
            return memo;
          }

          memo = memo.concat("".concat(t).split("\n"));
          return memo;
        }, []); // remove properties from first point to make datum
        // eslint-disable-next-line no-unused-vars

        var _points$ = points[0],
            childName = _points$.childName,
            eventKey = _points$.eventKey,
            style = _points$.style,
            continuous = _points$.continuous,
            datum = _objectWithoutProperties$7(_points$, ["childName", "eventKey", "style", "continuous"]);

        var name = props.name === childName ? childName : "".concat(props.name, "-").concat(childName);

        var labelProps = defaults_1({
          key: "".concat(name, "-").concat(eventKey, "-voronoi-tooltip"),
          id: "".concat(name, "-").concat(eventKey, "-voronoi-tooltip"),
          active: true,
          renderInPortal: false,
          activePoints: points,
          datum: datum,
          scale: scale,
          theme: theme
        }, componentProps, {
          text: text,
          width: width,
          height: height,
          style: this.getStyle(props, points, "labels"),
          flyoutStyle: this.getStyle(props, points, "flyout")[0]
        }, this.getDefaultLabelProps(props, points));

        var labelPosition = this.getLabelPosition(props, labelProps, points);
        return defaults_1({}, labelPosition, labelProps);
      }
    }, {
      key: "getTooltip",
      value: function getTooltip(props) {
        var labels = props.labels,
            activePoints = props.activePoints,
            labelComponent = props.labelComponent;

        if (!labels) {
          return null;
        }

        if (Array.isArray(activePoints) && activePoints.length) {
          var labelProps = this.getLabelProps(props, activePoints);
          var text = labelProps.text;
          var showLabel = Array.isArray(text) ? text.filter(Boolean).length : text;
          return showLabel ? React__default['default'].cloneElement(labelComponent, labelProps) : null;
        } else {
          return null;
        }
      } // Overrides method in VictoryContainer

    }, {
      key: "getChildren",
      value: function getChildren(props) {
        return _toConsumableArray$l(React__default['default'].Children.toArray(props.children)).concat([this.getTooltip(props)]);
      }
    }]);

    return VictoryVoronoiContainer;
  }(base), Object.defineProperty(_class, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictoryVoronoiContainer"
  }), Object.defineProperty(_class, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: _objectSpread$o({}, VictoryContainer.propTypes, {
      activateData: PropTypes__default['default'].bool,
      activateLabels: PropTypes__default['default'].bool,
      disable: PropTypes__default['default'].bool,
      labelComponent: PropTypes__default['default'].element,
      labels: PropTypes__default['default'].func,
      mouseFollowTooltips: PropTypes__default['default'].bool,
      onActivated: PropTypes__default['default'].func,
      onDeactivated: PropTypes__default['default'].func,
      radius: PropTypes__default['default'].number,
      voronoiBlacklist: PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, CustomPropTypes.regExp])),
      voronoiDimension: PropTypes__default['default'].oneOf(["x", "y"]),
      voronoiPadding: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].shape({
        top: PropTypes__default['default'].number,
        bottom: PropTypes__default['default'].number,
        left: PropTypes__default['default'].number,
        right: PropTypes__default['default'].number
      })])
    })
  }), Object.defineProperty(_class, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: _objectSpread$o({}, VictoryContainer.defaultProps, {
      activateData: true,
      activateLabels: true,
      labelComponent: React__default['default'].createElement(VictoryTooltip, null),
      voronoiPadding: 5
    })
  }), Object.defineProperty(_class, "defaultEvents", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function (props) {
      return [{
        target: "parent",
        eventHandlers: {
          onMouseLeave: function (evt, targetProps) {
            return props.disable ? {} : VoronoiHelpers$1.onMouseLeave(evt, targetProps);
          },
          onTouchCancel: function (evt, targetProps) {
            return props.disable ? {} : VoronoiHelpers$1.onMouseLeave(evt, targetProps);
          },
          onMouseMove: function (evt, targetProps) {
            return props.disable ? {} : VoronoiHelpers$1.onMouseMove(evt, targetProps);
          },
          onTouchMove: function (evt, targetProps) {
            return props.disable ? {} : VoronoiHelpers$1.onMouseMove(evt, targetProps);
          }
        }
      }, {
        target: "data",
        eventHandlers: props.disable ? {} : {
          onMouseOver: function () {
            return null;
          },
          onMouseOut: function () {
            return null;
          },
          onMouseMove: function () {
            return null;
          }
        }
      }];
    }
  }), _temp;
};
var VictoryVoronoiContainer = voronoiContainerMixin(VictoryContainer);

function SecurityScoreGraph(props) {
  var score = props.data.score,
      name = props.name;
  var percentage = score / 800 * 100;
  var gradients = getGradients(percentage);
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("svg", {
    style: {
      height: 0
    }
  }, /*#__PURE__*/React__default['default'].createElement("defs", null, /*#__PURE__*/React__default['default'].createElement("linearGradient", {
    id: "".concat(name)
  }, gradients))), /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default['default'].createElement("svg", {
    viewBox: "0 0 600 370"
  }, /*#__PURE__*/React__default['default'].createElement(VictoryPie$1, {
    animate: {
      duration: 2000,
      onLoad: {
        duration: 1000
      }
    },
    colorScale: ["url(#".concat(name, ")"), '#f4f7f9'],
    standalone: false,
    width: 600,
    height: 600,
    startAngle: -90,
    endAngle: 90,
    innerRadius: 185,
    labels: function labels() {
      return null;
    },
    cornerRadius: function cornerRadius() {
      return 5;
    },
    data: [{
      x: '',
      y: percentage
    }, {
      x: '',
      y: 100 - percentage
    }],
    labelRadius: 100
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "20",
    cy: "290",
    r: "7",
    fill: "#373636",
    key: 1
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "30",
    cy: "235",
    r: "2",
    fill: "#999999",
    key: 2
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "48",
    cy: "185",
    r: "2",
    fill: "#999999",
    key: 3
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "75",
    cy: "140",
    r: "2",
    fill: "#999999",
    key: 4
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "118",
    cy: "95",
    r: "7",
    fill: "#3d68d3",
    key: 5
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "170",
    cy: "60",
    r: "2",
    fill: "#999999",
    key: 6
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "235",
    cy: "35",
    r: "2",
    fill: "#999999",
    key: 7
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "300",
    cy: "25",
    r: "2",
    fill: "#999999",
    key: 8
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "365",
    cy: "35",
    r: "2",
    fill: "#999999",
    key: 9
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "430",
    cy: "60",
    r: "2",
    fill: "#999999",
    key: 10
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "482",
    cy: "95",
    r: "7",
    fill: "#4ed4b2",
    key: 11
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "525",
    cy: "140",
    r: "2",
    fill: "#999999",
    key: 12
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "552",
    cy: "185",
    r: "2",
    fill: "#999999",
    key: 13
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "570",
    cy: "235",
    r: "2",
    fill: "#999999",
    key: 14
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "580",
    cy: "290",
    r: "7",
    fill: "#4eb3d4",
    key: 15
  })), /*#__PURE__*/React__default['default'].createElement(VictoryLabel, {
    textAnchor: "middle",
    verticalAnchor: "middle",
    x: 300,
    y: 300,
    dy: -50,
    style: {
      fontSize: 100,
      fontFamily: 'Avenir',
      fontWeight: 900
    },
    text: score
  }))));
}

function getGradients(percentage) {
  var gradients = [/*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "0%",
    stopColor: "#3d68d3",
    key: 1
  })];

  if (percentage <= 15) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#418ec7",
      key: 2
    }));
  } else if (percentage <= 25) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "50%",
      stopColor: "#418ec7",
      key: 2
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#4393c6",
      key: 3
    }));
  } else if (percentage <= 40) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "33%",
      stopColor: "#418ec7",
      key: 2
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "66%",
      stopColor: "#4393c6",
      key: 3
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#49b4bc",
      key: 4
    }));
  } else if (percentage <= 50) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "25%",
      stopColor: "#418ec7",
      key: 2
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "50%",
      stopColor: "#4393c6",
      key: 3
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "75%",
      stopColor: "#49b4bc",
      key: 4
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#4ed4b2",
      key: 5
    }));
  } else if (percentage <= 60) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "20%",
      stopColor: "#418ec7",
      key: 2
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "40%",
      stopColor: "#4393c6",
      key: 3
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "60%",
      stopColor: "#49b4bc",
      key: 4
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "80%",
      stopColor: "#4ed4b2",
      key: 5
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#4ec8bd",
      key: 6
    }));
  } else if (percentage <= 75) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "18%",
      stopColor: "#418ec7",
      key: 2
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "36%",
      stopColor: "#4393c6",
      key: 3
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "52%",
      stopColor: "#49b4bc",
      key: 4
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "68%",
      stopColor: "#4ed4b2",
      key: 5
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "84%",
      stopColor: "#4ec8bd",
      key: 6
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#4dc0c6",
      key: 7
    }));
  } else if (percentage <= 85) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "12%",
      stopColor: "#418ec7",
      key: 2
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "27%",
      stopColor: "#4393c6",
      key: 3
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "42%",
      stopColor: "#49b4bc",
      key: 4
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "56%",
      stopColor: "#4ed4b2",
      key: 5
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "71%",
      stopColor: "#4ec8bd",
      key: 6
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "86%",
      stopColor: "#4dc0c6",
      key: 7
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#4cbacd",
      key: 8
    }));
  } else if (percentage <= 100) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "15%",
      stopColor: "#418ec7",
      key: 2
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "25%",
      stopColor: "#4393c6",
      key: 3
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "40%",
      stopColor: "#49b4bc",
      key: 4
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "50%",
      stopColor: "#4ed4b2",
      key: 5
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "60%",
      stopColor: "#4ec8bd",
      key: 6
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "75%",
      stopColor: "#4dc0c6",
      key: 7
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "85%",
      stopColor: "#4cbacd",
      key: 8
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#4eb3d4",
      key: 9
    }));
  }

  return gradients;
}

var lodash = createCommonjsModule(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as the semantic version number. */
  var VERSION = '4.17.20';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined$1) {
        result = result === undefined$1 ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined$1 : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined$1;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined$1;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined$1 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined$1 : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined$1;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined$1 : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined$1) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined$1) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined$1) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined$1 : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined$1
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined$1 || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined$1;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined$1 ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined$1;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined$1 : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined$1 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined$1
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined$1 && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined$1;

      var isCommon = newValue === undefined$1;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined$1;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
          if (newValue === undefined$1) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined$1;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined$1 ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined$1;

        if (newValue === undefined$1) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined$1 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined$1;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
            args, holders, undefined$1, undefined$1, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined$1 && other === undefined$1) {
          return defaultValue;
        }
        if (value !== undefined$1) {
          result = value;
        }
        if (other !== undefined$1) {
          if (result === undefined$1) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined$1 ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined$1;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined$1, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined$1;
      }
      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined$1 ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined$1;
      }
      var data = isBindKey ? undefined$1 : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined$1
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined$1, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined$1 : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined$1) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined$1
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined$1, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined$1;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined$1;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined$1 || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined$1, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined$1 ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined$1;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined$1;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined$1, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined$1;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined$1, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined$1 ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined$1, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined$1
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined$1);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined$1) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined$1;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined$1
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined$1 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined$1 : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined$1;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined$1;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined$1;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined$1;
        return result;
      }

      function cancel() {
        if (timerId !== undefined$1) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
      }

      function flush() {
        return timerId === undefined$1 ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined$1) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined$1) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined$1 ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      var result = customizer ? customizer(value, other) : undefined$1;
      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined$1;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined$1;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined$1, customDefaultsMerge);
      return apply(mergeWith, undefined$1, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined$1 : baseGet(object, path);
      return result === undefined$1 ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined$1;
      }
      while (++index < length) {
        var value = object == null ? undefined$1 : object[toKey(path[index])];
        if (value === undefined$1) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined$1) {
        upper = lower;
        lower = undefined$1;
      }
      if (upper !== undefined$1) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined$1) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined$1) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined$1;
      }
      if (floating === undefined$1) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined$1;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined$1;
        }
      }
      if (lower === undefined$1 && upper === undefined$1) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined$1) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined$1
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined$1;
      }
      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined$1;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined$1, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined$1) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined$1 : pattern;

      if (pattern === undefined$1) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined$1, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined$1 : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined$1;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined$1;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined$1;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined$1;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined$1) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined$1
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal));
});

var css_248z$k = ".index_security-score-by-category-labels__1EC9s {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 202px;\n  width: 300px;\n  line-height: 21px;\n  padding: 26px 0;\n  text-align: right; }\n\n#index_root__2dqQ6 > div > div > div > div > svg > g:nth-child(2) > line {\n  display: none; }\n\n#index_root__2dqQ6 > div > div > div > div > svg > g:nth-child(3) > line {\n  display: none; }\n";
styleInject(css_248z$k);

function SecurityScoreByCategoryGraph(props) {
  var data = props.data,
      name = props.name;
  var gradients = [];
  var categories = [];
  data = lodash.orderBy(data, 'score', 'asc');

  var _data = data.map(function (item, idx) {
    var gradient = getGradients$1(parseInt(item.score), idx);
    gradients.push( /*#__PURE__*/React__default['default'].createElement("linearGradient", {
      id: "gradient".concat(idx),
      key: "gradient-".concat(idx)
    }, gradient));
    categories.push(item.name);
    return {
      x: item.name,
      y: item.score,
      name: item.name,
      score: parseInt(item.score),
      fill: "url(#gradient".concat(idx, ")")
    };
  });

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("svg", {
    style: {
      height: 0
    }
  }, /*#__PURE__*/React__default['default'].createElement("defs", null, gradients)), /*#__PURE__*/React__default['default'].createElement(VictoryChart, {
    height: props.height || 250,
    width: props.width || 600,
    padding: {
      top: 5,
      bottom: 60,
      left: 170,
      right: 20
    },
    style: {
      height: 'max-content',
      maxWidth: ''
    },
    domain: {
      y: [0, 800]
    },
    domainPadding: {
      x: 5
    },
    containerComponent: /*#__PURE__*/React__default['default'].createElement(VictoryContainer, {
      responsive: true
    })
  }, /*#__PURE__*/React__default['default'].createElement(VictoryBar$1, {
    animate: {
      duration: 2000,
      onLoad: {
        duration: 1000
      }
    },
    horizontal: true,
    colorScale: ["url(#".concat(name, ")"), '#f4f7f9'],
    style: {
      data: {
        fill: function fill(_ref) {
          var datum = _ref.datum;
          return datum.fill;
        },
        width: props.width < 500 ? 10 : 15,
        fontSize: 10
      }
    },
    labels: function labels(_ref2) {
      var datum = _ref2.datum;
      return Math.round(datum.y);
    },
    cornerRadius: function cornerRadius() {
      return 5;
    },
    categories: {
      x: categories
    },
    data: _data,
    labelComponent: /*#__PURE__*/React__default['default'].createElement(VictoryLabel, {
      dx: function dx(_ref3) {
        var datum = _ref3.datum;
        return datum.score < 100 ? 15 : -35;
      },
      style: {
        fontSize: 10,
        fontFamily: 'Avenir',
        fontWeight: 500
      }
    })
  })));
}

function getGradients$1(score, idx) {
  var gradients = [];

  if (score <= 250) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "0%",
      stopColor: "#3d68d3",
      key: "start-".concat(idx)
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#f4e0fb",
      key: "end-".concat(idx)
    }));
  } else if (score > 250 && score <= 550) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "0%",
      stopColor: "#4ed4b2",
      key: "start-".concat(idx)
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#6affd9",
      key: "end-".concat(idx)
    }));
  } else if (score > 550) {
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "0%",
      stopColor: "#4eb3d4",
      key: "start-".concat(idx)
    }));
    gradients.push( /*#__PURE__*/React__default['default'].createElement("stop", {
      offset: "100%",
      stopColor: "#79deff",
      key: "end-".concat(idx)
    }));
  }

  return gradients;
}

function SecurityScoreOverTime(props) {
  var data = props.data,
      t = props.t;
  data = lodash.orderBy(data, 'dateInt', 'asc');
  var startDate = hooks(data[0].dateInt);
  var endDate = hooks(data[data.length - 1].dateInt);
  var diff = endDate.diff(startDate, 'M', true);
  var range = startDate.format('MMMM YYYY');
  var categories = [];
  var xFormat = 'D';

  if (diff > 1) {
    xFormat = 'M/D';
    range = "".concat(startDate.format('MMMM YYYY'), " - ").concat(endDate.format('MMMM YYYY'));
  }

  var _data = data.map(function (item) {
    return {
      x: hooks(item.dateInt).format(xFormat),
      y: item.score,
      date: hooks(item.dateInt).format('M/DD/YYYY')
    };
  });

  for (var i = 0; i < data.length; i++) {
    categories.push(hooks(data[i].dateInt).format(xFormat));
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default['default'].createElement(VictoryChart, {
    height: props.height || 250,
    width: props.width || 600,
    padding: {
      top: 10,
      bottom: 55,
      left: 60,
      right: 10
    },
    style: {
      height: 'max-content',
      maxWidth: ''
    },
    domain: {
      y: [0, 800]
    },
    domainPadding: {
      x: 5
    },
    maxDomain: {
      y: 800
    },
    minDomain: {
      y: 0
    },
    containerComponent: /*#__PURE__*/React__default['default'].createElement(VictoryVoronoiContainer, null)
  }, /*#__PURE__*/React__default['default'].createElement(VictoryAxis$1, {
    dependentAxis: true
  }), /*#__PURE__*/React__default['default'].createElement(VictoryAxis$1, {
    fixLabelOverlap: true
  }), /*#__PURE__*/React__default['default'].createElement(Background, {
    x: 60,
    y: 9,
    style: {
      fill: '#e4f4fa',
      height: '62px',
      width: props.width - 70
    }
  }), /*#__PURE__*/React__default['default'].createElement(Background, {
    x: 60,
    y: 70,
    style: {
      fill: '#edfbf7',
      height: '65px',
      width: props.width - 70
    }
  }), /*#__PURE__*/React__default['default'].createElement(Background, {
    x: 60,
    y: 135,
    style: {
      fill: '#ecf0fb',
      height: '60px',
      width: props.width - 70
    }
  }), /*#__PURE__*/React__default['default'].createElement(VictoryLine$1, {
    animate: {
      duration: 2000,
      onLoad: {
        duration: 1000
      }
    },
    style: {
      data: {
        width: props.width < 500 ? 10 : 15,
        fontSize: 10
      }
    },
    cornerRadius: function cornerRadius() {
      return 5;
    },
    categories: {
      x: categories
    },
    data: _data,
    labels: function labels(_ref) {
      var datum = _ref.datum;
      return ["".concat(datum.date), "".concat(t ? t('graphs.security-score-over-time.score') : 'Score', ": ").concat(Math.round(datum.y))];
    },
    labelComponent: /*#__PURE__*/React__default['default'].createElement(VictoryTooltip, {
      dy: 0,
      pointerLength: 6,
      flyoutWidth: 70,
      cornerRadius: 0,
      style: {
        fill: 'white',
        fontSize: '13px',
        fontWeight: '300'
      },
      flyoutStyle: {
        fill: '#333333',
        strokeWidth: 0
      }
    })
  }), /*#__PURE__*/React__default['default'].createElement(VictoryLabel, {
    textAnchor: "middle",
    verticalAnchor: "middle",
    dx: -100,
    dy: 5,
    style: {
      fontSize: 11,
      fontFamily: 'Avenir',
      fontWeight: 600
    },
    transform: "rotate(270)",
    text: "SECURITY SCORE"
  }), /*#__PURE__*/React__default['default'].createElement(VictoryLabel, {
    textAnchor: "middle",
    verticalAnchor: "middle",
    dx: props.width / 2,
    dy: props.height - 7,
    style: {
      fontSize: 11,
      fontFamily: 'Avenir',
      fontWeight: 600
    },
    text: range
  })));
}

function getRandomInt$1(min, max) {
  var minCeil = Math.ceil(min);
  var maxCeil = Math.floor(max);
  return Math.floor(Math.random() * (maxCeil - minCeil + 1)) + minCeil;
}
/*
    numAbbr.abbreviate(12, 1)
    // => 12
    numAbbr.abbreviate(0, 2)
    // => 0
    numAbbr.abbreviate(1234, 0)
    // => 1k
    numAbbr.abbreviate(34567, 2)
    // => 34.57k
    numAbbr.abbreviate(918395, 1)
    // => 918.4k
    numAbbr.abbreviate(2134124, 2)
    // => 2.13m
    numAbbr.abbreviate(-47475782130, 2)
    // => -47.48b
 */

function NumAbbr() {
  var units;

  if (!(this instanceof NumAbbr)) {
    // function usage: abbrev(n, decPlaces, units)
    var n = arguments[0];
    var decPlaces = arguments[1];
    units = arguments[2];
    var ab = new NumAbbr(units);
    return ab.abbreviate(n, decPlaces);
  } // class usage: new NumberAbbreviate(units)


  units = arguments[0];
  this.units = units == null ? ['k', 'm', 'b', 't'] : units;
}

NumAbbr.prototype._abbreviate = function (number, decPlaces) {
  decPlaces = Math.pow(10, decPlaces);

  for (var i = this.units.length - 1; i >= 0; i--) {
    var size = Math.pow(10, (i + 1) * 3);

    if (size <= number) {
      number = Math.round(number * decPlaces / size) / decPlaces;

      if (number === 1000 && i < this.units.length - 1) {
        number = 1;
        i++;
      }

      number += this.units[i];
      break;
    }
  }

  return number;
};

NumAbbr.prototype.abbreviate = function (number, decPlaces) {
  var isNegative = number < 0;

  var abbreviatedNumber = this._abbreviate(Math.abs(number), decPlaces || 0);

  return isNegative ? '-' + abbreviatedNumber : abbreviatedNumber;
};

var startingPoint = 90;
function HighRiskParticipants(props) {
  var highRiskParticipantCountAsPercent = props.data.highRiskParticipantCountAsPercent,
      name = props.name;
  var percentage = highRiskParticipantCountAsPercent * 100;
  var startAngle = percentage ? startingPoint - 180 * highRiskParticipantCountAsPercent : 0;
  var numAbbr = new NumAbbr();
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("svg", {
    style: {
      height: 0
    }
  }, /*#__PURE__*/React__default['default'].createElement("defs", null, /*#__PURE__*/React__default['default'].createElement("linearGradient", {
    id: "".concat(name)
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "0%",
    stopColor: "#1595bf"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "100%",
    stopColor: "#4eb3d4"
  })))), /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default['default'].createElement("svg", {
    viewBox: "0 0 ".concat(props.width, " ").concat(props.height)
  }, /*#__PURE__*/React__default['default'].createElement(VictoryPie$1, {
    animate: {
      duration: 2000,
      onLoad: {
        duration: 1000
      }
    },
    colorScale: ["url(#".concat(name, ")"), '#f4f7f9'],
    standalone: false,
    height: props.height,
    width: props.width,
    labels: function labels() {
      return null;
    },
    cornerRadius: function cornerRadius() {
      return 5;
    },
    startAngle: startAngle,
    endAngle: 360 + startAngle,
    origin: {
      y: 120
    },
    radius: function radius(_ref) {
      var datum = _ref.datum;

      if (datum.x === 'high-risk') {
        return 120;
      } else {
        return 100;
      }
    },
    innerRadius: 70,
    data: [{
      x: 'high-risk',
      y: percentage
    }, {
      x: '',
      y: 100 - percentage
    }],
    padding: {
      right: 150
    },
    labelRadius: 100
  }), /*#__PURE__*/React__default['default'].createElement(VictoryLabel, {
    textAnchor: "middle",
    verticalAnchor: "middle",
    x: 130,
    y: 300,
    dy: -180,
    style: {
      fontSize: 44,
      fontFamily: 'Avenir',
      fontWeight: 900
    },
    text: "".concat(parseInt(percentage), "%")
  }), /*#__PURE__*/React__default['default'].createElement(VictoryLabel, {
    textAnchor: "middle",
    verticalAnchor: "middle",
    x: 330,
    y: 300,
    dy: -180,
    style: {
      fontSize: 50,
      fontFamily: 'Avenir',
      fontWeight: 400,
      fill: '#4eb3d4'
    },
    text: "".concat(numAbbr.abbreviate(props.data.highRiskParticipantCount, 1))
  }), /*#__PURE__*/React__default['default'].createElement(VictoryLabel, {
    textAnchor: "middle",
    verticalAnchor: "middle",
    x: 330,
    y: 346,
    dy: -180,
    style: {
      fontSize: 20,
      fontFamily: 'Avenir',
      fontWeight: 300,
      fill: '#828282'
    },
    text: "Participants"
  }))));
}

function SecurityScoreLegend(props) {
  var ranges = props.ranges;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "security-score-legend",
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center'
    }
  }, ranges.map(function (item, idx) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        marginTop: '12px'
      },
      key: idx
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "legend-top",
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        background: "".concat(item.color),
        width: 10,
        height: 10,
        borderRadius: 2,
        marginRight: '10px'
      }
    }), /*#__PURE__*/React__default['default'].createElement("div", null, item.label)), /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        margin: '3px 20px'
      }
    }, item.range));
  }));
}

function BottomRank(props) {
  var _this = this;

  var data = props.data,
      activeItem = props.activeItem,
      setActiveItem = props.setActiveItem,
      t = props.t;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "bottom-rank-graph"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "bottom-rank-graph-left-nav"
  }, data && Object.entries(data).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    var name = key.split(/(?=[A-Z])/);
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "bottom-rank-graph-left-nav-item ".concat(activeItem === key ? 'active' : ''),
      onClick: setActiveItem.bind(_this, key),
      key: key
    }, t ? t("graphs.bottom-rank.".concat(key)) : "".concat(name[0], " ").concat(name[1] ? name[1] : ''), /*#__PURE__*/React__default['default'].createElement("i", {
      className: "fal fa-chevron-right"
    }));
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "bottom-rank-graph-body"
  }, data && data[activeItem] && data[activeItem].length < 1 ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "no-data"
  }, /*#__PURE__*/React__default['default'].createElement("p", null, "No data available.")) : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "headers"
  }, /*#__PURE__*/React__default['default'].createElement("div", null, t ? t('graphs.bottom-rank.name') : 'Name'), /*#__PURE__*/React__default['default'].createElement("div", null, t ? t('graphs.bottom-rank.securityScore') : 'Security Score')), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "body"
  }, data && data[activeItem] && data[activeItem].map(function (item, index) {
    var change = item.change,
        changePercent = item.changePercent;
    var percent = (changePercent * 100).toFixed(1);
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "bottom-rank-body-row",
      key: index
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        display: 'flex',
        flexGrow: '1'
      }
    }, item.name), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "rank-score",
      style: {
        display: 'flex',
        minWidth: '40px',
        textAlign: 'center'
      }
    }, item.score), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "change-container",
      style: {
        display: 'flex',
        minWidth: '20px',
        textAlign: 'center'
      }
    }, change === 0 ? null : change < 0 || percent < 0 ? /*#__PURE__*/React__default['default'].createElement("i", {
      className: "far fa-long-arrow-down"
    }) : /*#__PURE__*/React__default['default'].createElement("i", {
      className: "far fa-long-arrow-up"
    })));
  })))));
}

function LicenseDistribution(props) {
  var data = props.data;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default['default'].createElement("svg", {
    viewBox: "0 0 ".concat(props.width, " ").concat(props.height - 20)
  }, /*#__PURE__*/React__default['default'].createElement(VictoryLabel, {
    textAnchor: "middle",
    verticalAnchor: "start",
    x: 90,
    y: 268,
    dy: -180,
    style: {
      fontSize: 25,
      fontFamily: 'Avenir',
      fontWeight: 900
    },
    text: data.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }), /*#__PURE__*/React__default['default'].createElement(VictoryPie$1, {
    animate: {
      duration: 2000,
      onLoad: {
        duration: 1000
      }
    },
    origin: {
      x: 90
    },
    labels: function labels() {
      return null;
    },
    startAngle: -180,
    colorScale: ['#4eb3d4', '#4ed4b2', '#e1db5f'],
    standalone: false,
    height: props.height,
    width: props.width,
    innerRadius: 70,
    data: [{
      x: '',
      y: data && data.active || 0
    }, {
      x: '',
      y: data && data.available || 0
    }, {
      x: '',
      y: data && data.pending || 0
    }]
  })));
}

var css_248z$l = ".index_assigned-completion-rate-graph__Iz3jq {\n  font-size: 80px;\n  font-weight: 500;\n  text-align: center;\n  height: 80%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n";
styleInject(css_248z$l);

function AssignedCompletionRate(props) {
  var _props$data$completio = props.data.completion,
      completion = _props$data$completio === void 0 ? 0 : _props$data$completio;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "assigned-completion-rate-graph"
  }, "".concat(Number((completion * 100).toFixed(1))), "%");
}

function ParticipantProgress(props) {
  var data = props.data;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default['default'].createElement("svg", {
    viewBox: "0 0 ".concat(props.width, " ").concat(props.height - 20)
  }, /*#__PURE__*/React__default['default'].createElement(VictoryLabel, {
    textAnchor: "middle",
    verticalAnchor: "start",
    x: 90,
    y: 268,
    dy: -180,
    style: {
      fontSize: 25,
      fontFamily: 'Avenir',
      fontWeight: 900
    },
    text: data.totalParticipants && data.totalParticipants.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }), /*#__PURE__*/React__default['default'].createElement(VictoryPie$1, {
    animate: {
      duration: 2000,
      onLoad: {
        duration: 1000
      }
    },
    origin: {
      x: 90
    },
    labels: function labels() {
      return null;
    },
    startAngle: 0,
    colorScale: ['#4eb3d4', '#e1db5f', '#3d68d3'],
    radius: 70,
    standalone: false,
    height: props.height,
    width: props.width,
    innerRadius: function innerRadius(_ref) {
      var datum = _ref.datum;

      if (datum.x === 'complete') {
        return 45;
      } else if (datum.x === 'underway') {
        return 50;
      } else {
        return 55;
      }
    },
    data: [{
      x: 'complete',
      y: data.complete.participantCount || 0
    }, {
      x: 'underway',
      y: data.underway.participantCount || 0
    }, {
      x: 'overdue',
      y: data.overdue.participantCount || 0
    }]
  })));
}

function ParticipantProgressOverTime(props) {
  var data = props.data,
      t = props.t;
  data = lodash.orderBy(data, 'dateInt', 'asc');
  var startDate = hooks(data[0].dateInt);
  var endDate = hooks(data[data.length - 1].dateInt);
  var diff = endDate.diff(startDate, 'M', true);
  var range = startDate.format('MMMM YYYY');
  var highParticipantCount = 10;
  var overdueData = [];
  var completeData = [];
  var underwayData = [];
  var xFormat = 'D';

  if (diff > 1) {
    xFormat = 'M/D';
    range = "".concat(startDate.format('MMMM YYYY'), " - ").concat(endDate.format('MMMM YYYY'));
  }

  data.forEach(function (item, index) {
    var currentParticipants = 0;

    if (item.overdue) {
      currentParticipants = currentParticipants + item.overdue.participantCount;
      overdueData.push({
        x: hooks(item.dateInt).format(xFormat),
        date: hooks(item.dateInt).format('M/DD/YYYY'),
        y: item.overdue.participantCount,
        type: t ? t('graphs.participant-progress-over-time.overdue-participants') : 'Overdue participants'
      });
    }

    if (item.complete) {
      currentParticipants = currentParticipants + item.complete.participantCount;
      completeData.push({
        x: hooks(item.dateInt).format(xFormat),
        date: hooks(item.dateInt).format('M/DD/YYYY'),
        y: item.complete.participantCount,
        type: t ? t('graphs.participant-progress-over-time.complete-participants') : 'Complete participants'
      });
    }

    if (item.underway) {
      currentParticipants = currentParticipants + item.underway.participantCount;
      underwayData.push({
        x: hooks(item.dateInt).format(xFormat),
        date: hooks(item.dateInt).format('M/DD/YYYY'),
        y: item.underway.participantCount,
        type: t ? t('graphs.participant-progress-over-time.underway-participants') : 'Underway participants'
      });
    }

    if (currentParticipants > highParticipantCount) {
      highParticipantCount = currentParticipants;
    }
  });
  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default['default'].createElement(VictoryChart, {
    height: props.height || 230,
    width: props.width || 600,
    padding: {
      top: 10,
      bottom: 45,
      left: 40,
      right: 10
    },
    style: {
      tickLabels: {
        fontSize: 10
      },
      height: 'max-content',
      maxWidth: ''
    },
    domain: {
      y: [0, highParticipantCount + 1]
    },
    minDomain: {
      y: 0
    },
    containerComponent: /*#__PURE__*/React__default['default'].createElement(VictoryVoronoiContainer, {
      labels: function labels(d) {
        return d.y;
      }
    })
  }, /*#__PURE__*/React__default['default'].createElement(VictoryStack, null, /*#__PURE__*/React__default['default'].createElement(VictoryArea$1, {
    style: {
      data: {
        fill: '#c5d2f2',
        stroke: '#3d68d3',
        strokeWidth: '2px'
      }
    },
    data: overdueData,
    labels: function labels(_ref) {
      var datum = _ref.datum;
      return ["".concat(datum.date), "".concat(datum.type, ": ").concat(datum.y)];
    },
    labelComponent: /*#__PURE__*/React__default['default'].createElement(VictoryTooltip, {
      dy: 0,
      pointerLength: 6,
      flyoutWidth: 130,
      cornerRadius: 0,
      style: {
        fill: 'white',
        fontSize: '11px',
        fontWeight: '300'
      },
      flyoutStyle: {
        fill: '#333333',
        strokeWidth: 0
      }
    })
  }), /*#__PURE__*/React__default['default'].createElement(VictoryArea$1, {
    style: {
      data: {
        fill: '#cae8f2',
        stroke: '#4eb3d4',
        strokeWidth: '2px'
      }
    },
    data: completeData,
    labels: function labels(_ref2) {
      var datum = _ref2.datum;
      return ["".concat(datum.date), "".concat(datum.type, ": ").concat(datum.y)];
    },
    labelComponent: /*#__PURE__*/React__default['default'].createElement(VictoryTooltip, {
      dy: 0,
      pointerLength: 6,
      flyoutWidth: 130,
      cornerRadius: 0,
      style: {
        fill: 'white',
        fontSize: '11px',
        fontWeight: '300'
      },
      flyoutStyle: {
        fill: '#333333',
        strokeWidth: 0
      }
    })
  }), /*#__PURE__*/React__default['default'].createElement(VictoryArea$1, {
    style: {
      data: {
        fill: '#f6f4cf',
        stroke: '#e1db5f',
        strokeWidth: '2px'
      }
    },
    data: underwayData,
    labels: function labels(_ref3) {
      var datum = _ref3.datum;
      return ["".concat(datum.date), "".concat(datum.type, ": ").concat(datum.y)];
    },
    labelComponent: /*#__PURE__*/React__default['default'].createElement(VictoryTooltip, {
      dy: 0,
      pointerLength: 6,
      flyoutWidth: 130,
      cornerRadius: 0,
      style: {
        fill: 'white',
        fontSize: '11px',
        fontWeight: '300'
      },
      flyoutStyle: {
        fill: '#333333',
        strokeWidth: 0
      }
    })
  })), /*#__PURE__*/React__default['default'].createElement(VictoryAxis$1, {
    dependentAxis: true,
    label: t ? t('graphs.participant-progress-over-time.participants') : 'PARTICIPANTS',
    style: {
      axis: {
        stroke: '#756f6a'
      },
      axisLabel: {
        fontSize: 12,
        padding: 30
      },
      tickLabels: {
        fontSize: 11,
        padding: 5
      }
    }
  }), /*#__PURE__*/React__default['default'].createElement(VictoryAxis$1, {
    fixLabelOverlap: true,
    label: range,
    style: {
      axis: {
        stroke: '#756f6a'
      },
      axisLabel: {
        fontSize: 12,
        padding: 30
      },
      tickLabels: {
        fontSize: 11,
        padding: 5
      }
    }
  })));
}

function rng() {
  return crypto__default['default'].randomBytes(16);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }

  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

function _classCallCheck$k(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$k(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$k(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$k(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$k(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$t(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        _defineProperty$t(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits$j(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _assertThisInitialized$n(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$j(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$n(self);
}

var CONSTANT = {
  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};

/**
 * Static methods for react-tooltip
 */

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatible with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
  var event;

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, {
      detail: opts
    });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, false, true, opts);
  }

  window.dispatchEvent(event);
};

function staticMethods (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
      target: target
    });
  };
  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */


  target.rebuild = function () {
    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
  };
  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */


  target.show = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
      target: target
    });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false; // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY

      this.showTooltip({
        currentTarget: hasTarget && event.detail.target
      }, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({
        currentTarget: hasTarget && event.detail.target
      }, hasTarget);
    }
  };
}

/**
 * Events that should be bound to the window
 */
function windowListener (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild

    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show

    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize

    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize);
      window.addEventListener('resize', this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener('resize', this.onWindowResize);
  };
  /**
   * invoked by resize event of window
   */


  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
}

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */
var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;
  var isCapture = this.isCapture(e.currentTarget);
  var currentItem = e.currentTarget.getAttribute('currentItem');
  if (!isCapture) e.stopPropagation();

  if (show && currentItem === 'true') {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute('currentItem', 'true');
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute('currentItem', 'false');
    } else {
      targetArray[i].setAttribute('currentItem', 'true');
    }
  }
};

var customListeners = {
  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
  set: function set(target, event, listener) {
    if (this.id in target) {
      var map = target[this.id];
      map[event] = listener;
    } else {
      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
      Object.defineProperty(target, this.id, {
        configurable: true,
        value: _defineProperty$t({}, event, listener)
      });
    }
  },
  get: function get(target, event) {
    var map = target[this.id];

    if (map !== undefined) {
      return map[event];
    }
  }
};
function customEvent (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;
    return event || !!ele.getAttribute('data-event');
  };
  /* Bind listener for custom event */


  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff;
    var dataEvent = ele.getAttribute('data-event') || event;
    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
    dataEvent.split(' ').forEach(function (event) {
      ele.removeEventListener(event, customListeners.get(ele, event));
      var customListener = checkStatus.bind(_this, dataEventOff);
      customListeners.set(ele, event, customListener);
      ele.addEventListener(event, customListener, false);
    });

    if (dataEventOff) {
      dataEventOff.split(' ').forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };
  /* Unbind listener for custom event */


  target.prototype.customUnbindListener = function (ele) {
    var _this$state2 = this.state,
        event = _this$state2.event,
        eventOff = _this$state2.eventOff;
    var dataEvent = event || ele.getAttribute('data-event');
    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
}

/**
 * Util method to judge if it should follow capture model
 */
function isCapture (target) {
  target.prototype.isCapture = function (currentTarget) {
    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
  };
}

/**
 * Util method to get effect
 */
function getEffect (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
}

/**
 * Util method to get effect
 */

var makeProxy = function makeProxy(e) {
  var proxy = {};

  for (var key in e) {
    if (typeof e[key] === 'function') {
      proxy[key] = e[key].bind(e);
    } else {
      proxy[key] = e[key];
    }
  }

  return proxy;
};

var bodyListener = function bodyListener(callback, options, e) {
  var _options$respectEffec = options.respectEffect,
      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
      _options$customEvent = options.customEvent,
      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
  var id = this.props.id;
  var tip = e.target.getAttribute('data-tip') || null;
  var forId = e.target.getAttribute('data-for') || null;
  var target = e.target;

  if (this.isCustomEvent(target) && !customEvent) {
    return;
  }

  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;

  if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
    var proxy = makeProxy(e);
    proxy.currentTarget = target;
    callback(proxy);
  }
};

var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
  var events = {};
  targetArray.forEach(function (target) {
    var event = target.getAttribute(dataAttribute);
    if (event) event.split(' ').forEach(function (event) {
      return events[event] = true;
    });
  });
  return events;
};

var getBody = function getBody() {
  return document.getElementsByTagName('body')[0];
};

function bodyMode (target) {
  target.prototype.isBodyMode = function () {
    return !!this.props.bodyMode;
  };

  target.prototype.bindBodyListener = function (targetArray) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff,
        possibleCustomEvents = _this$state.possibleCustomEvents,
        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
    var body = getBody();
    var customEvents = findCustomEvents(targetArray, 'data-event');
    var customEventsOff = findCustomEvents(targetArray, 'data-event-off');
    if (event != null) customEvents[event] = true;
    if (eventOff != null) customEventsOff[eventOff] = true;
    possibleCustomEvents.split(' ').forEach(function (event) {
      return customEvents[event] = true;
    });
    possibleCustomEventsOff.split(' ').forEach(function (event) {
      return customEventsOff[event] = true;
    });
    this.unbindBodyListener(body);
    var listeners = this.bodyModeListeners = {};

    if (event == null) {
      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
        respectEffect: true
      });
      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
    }

    for (var _event in customEvents) {
      listeners[_event] = bodyListener.bind(this, function (e) {
        var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
        checkStatus.call(_this, targetEventOff, e);
      }, {
        customEvent: true
      });
    }

    for (var _event2 in customEventsOff) {
      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
        customEvent: true
      });
    }

    for (var _event3 in listeners) {
      body.addEventListener(_event3, listeners[_event3]);
    }
  };

  target.prototype.unbindBodyListener = function (body) {
    body = body || getBody();
    var listeners = this.bodyModeListeners;

    for (var event in listeners) {
      body.removeEventListener(event, listeners[event]);
    }
  };
}

/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */
// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

function trackRemoval (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;
    var observer = new MutationObserver(function (mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];

        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];

          if (element === _this.state.currentTarget) {
            _this.hideTooltip();

            return;
          }
        }
      }
    });
    observer.observe(window.document, {
      childList: true,
      subtree: true
    });
    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
}

/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */
function getPosition$4 (e, target, node, place, desiredPlace, effect, offset) {
  var _getDimensions = getDimensions(node),
      tipWidth = _getDimensions.width,
      tipHeight = _getDimensions.height;

  var _getDimensions2 = getDimensions(target),
      targetWidth = _getDimensions2.width,
      targetHeight = _getDimensions2.height;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset$1(offset),
      extraOffsetX = _calculateOffset.extraOffsetX,
      extraOffsetY = _calculateOffset.extraOffsetY;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offsetX = defaultOffset[place].l;
    return mouseX + offsetX + extraOffsetX;
  };

  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offsetX = defaultOffset[place].r;
    return mouseX + offsetX + extraOffsetX;
  };

  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offsetY = defaultOffset[place].t;
    return mouseY + offsetY + extraOffsetY;
  };

  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offsetY = defaultOffset[place].b;
    return mouseY + offsetY + extraOffsetY;
  }; //
  // Functions to test whether the tooltip's sides are inside
  // the client window for a given orientation p
  //
  //  _____________
  // |             | <-- Right side
  // | p = 'left'  |\
  // |             |/  |\
  // |_____________|   |_\  <-- Mouse
  //      / \           |
  //       |
  //       |
  //  Bottom side
  //


  var outsideLeft = function outsideLeft(p) {
    return getTipOffsetLeft(p) < 0;
  };

  var outsideRight = function outsideRight(p) {
    return getTipOffsetRight(p) > windowWidth;
  };

  var outsideTop = function outsideTop(p) {
    return getTipOffsetTop(p) < 0;
  };

  var outsideBottom = function outsideBottom(p) {
    return getTipOffsetBottom(p) > windowHeight;
  }; // Check whether the tooltip with orientation p is completely inside the client window


  var outside = function outside(p) {
    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
  };

  var inside = function inside(p) {
    return !outside(p);
  };

  var placesList = ['top', 'bottom', 'left', 'right'];
  var insideList = [];

  for (var i = 0; i < 4; i++) {
    var p = placesList[i];

    if (inside(p)) {
      insideList.push(p);
    }
  }

  var isNewState = false;
  var newPlace;
  var shouldUpdatePlace = desiredPlace !== place;

  if (inside(desiredPlace) && shouldUpdatePlace) {
    isNewState = true;
    newPlace = desiredPlace;
  } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
    isNewState = true;
    newPlace = insideList[0];
  }

  if (isNewState) {
    return {
      isNewState: true,
      newState: {
        place: newPlace
      }
    };
  }

  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
}

var getDimensions = function getDimensions(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      height = _node$getBoundingClie.height,
      width = _node$getBoundingClie.width;

  return {
    height: parseInt(height, 10),
    width: parseInt(width, 10)
  };
}; // Get current mouse offset


var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;

  var _getDimensions3 = getDimensions(currentTarget),
      targetWidth = _getDimensions3.width,
      targetHeight = _getDimensions3.height;

  if (effect === 'float') {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }

  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window


var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top;
  var right;
  var bottom;
  var left;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === 'float') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === 'solid') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return {
    top: top,
    bottom: bottom,
    left: left,
    right: right
  };
}; // Consider additional offset into position calculation


var calculateOffset$1 = function calculateOffset(offset) {
  var extraOffsetX = 0;
  var extraOffsetY = 0;

  if (Object.prototype.toString.apply(offset) === '[object String]') {
    offset = JSON.parse(offset.toString().replace(/'/g, '"'));
  }

  for (var key in offset) {
    if (key === 'top') {
      extraOffsetY -= parseInt(offset[key], 10);
    } else if (key === 'bottom') {
      extraOffsetY += parseInt(offset[key], 10);
    } else if (key === 'left') {
      extraOffsetX -= parseInt(offset[key], 10);
    } else if (key === 'right') {
      extraOffsetX += parseInt(offset[key], 10);
    }
  }

  return {
    extraOffsetX: extraOffsetX,
    extraOffsetY: extraOffsetY
  };
}; // Get the offset of the parent elements


var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;

  while (currentParent) {
    var computedStyle = window.getComputedStyle(currentParent); // transform and will-change: transform change the containing block
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block

    if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
  return {
    parentTop: parentTop,
    parentLeft: parentLeft
  };
};

/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */
function getTipContent (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.

  if (getContent === null) return null; // Tip not exist and children is null or undefined

  var regexp = /<br\s*\/?>/;

  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  } // Multiline tooltip content


  return tip.split(regexp).map(function (d, i) {
    return React__default['default'].createElement("span", {
      key: i,
      className: "multi-line"
    }, d);
  });
}

/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return /(^aria-\w+$|^role$)/.test(prop);
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });
  return ariaObj;
}

/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */
function nodeListToArray (nodeList) {
  var length = nodeList.length;

  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }

  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
}

function generateUUID() {
  return 't' + v4();
}

___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}");

/**
 * Default pop-up style values (text color, background color).
 */
var defaultColors = {
  dark: {
    text: '#fff',
    background: '#222',
    border: 'transparent',
    arrow: '#222'
  },
  success: {
    text: '#fff',
    background: '#8DC572',
    border: 'transparent',
    arrow: '#8DC572'
  },
  warning: {
    text: '#fff',
    background: '#F0AD4E',
    border: 'transparent',
    arrow: '#F0AD4E'
  },
  error: {
    text: '#fff',
    background: '#BE6464',
    border: 'transparent',
    arrow: '#BE6464'
  },
  info: {
    text: '#fff',
    background: '#337AB7',
    border: 'transparent',
    arrow: '#337AB7'
  },
  light: {
    text: '#222',
    background: '#fff',
    border: 'transparent',
    arrow: '#fff'
  }
};
function getDefaultPopupColors(type) {
  return defaultColors[type] ? _objectSpread2$1({}, defaultColors[type]) : undefined;
}

/**
 * Generates the specific tooltip style for use on render.
 */

function generateTooltipStyle(uuid, customColors, type, hasBorder) {
  return generateStyle(uuid, getPopupColors(customColors, type, hasBorder));
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */

function generateStyle(uuid, colors) {
  var textColor = colors.text;
  var backgroundColor = colors.background;
  var borderColor = colors.border;
  var arrowColor = colors.arrow;
  return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        border-top: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ").concat(arrowColor, ";\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        border-bottom: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ").concat(arrowColor, ";\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        border-left: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ").concat(arrowColor, ";\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        border-right: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ").concat(arrowColor, ";\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ");
}

function getPopupColors(customColors, type, hasBorder) {
  var textColor = customColors.text;
  var backgroundColor = customColors.background;
  var borderColor = customColors.border;
  var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
  var colors = getDefaultPopupColors(type);

  if (textColor) {
    colors.text = textColor;
  }

  if (backgroundColor) {
    colors.background = backgroundColor;
  }

  if (hasBorder) {
    if (borderColor) {
      colors.border = borderColor;
    } else {
      colors.border = type === 'light' ? 'black' : 'white';
    }
  }

  if (arrowColor) {
    colors.arrow = arrowColor;
  }

  return colors;
}

var _class, _class2, _temp;

var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits$j(ReactTooltip, _React$Component);

  _createClass$k(ReactTooltip, null, [{
    key: "propTypes",
    get: function get() {
      return {
        uuid: PropTypes__default['default'].string,
        children: PropTypes__default['default'].any,
        place: PropTypes__default['default'].string,
        type: PropTypes__default['default'].string,
        effect: PropTypes__default['default'].string,
        offset: PropTypes__default['default'].object,
        multiline: PropTypes__default['default'].bool,
        border: PropTypes__default['default'].bool,
        textColor: PropTypes__default['default'].string,
        backgroundColor: PropTypes__default['default'].string,
        borderColor: PropTypes__default['default'].string,
        arrowColor: PropTypes__default['default'].string,
        insecure: PropTypes__default['default'].bool,
        "class": PropTypes__default['default'].string,
        className: PropTypes__default['default'].string,
        id: PropTypes__default['default'].string,
        html: PropTypes__default['default'].bool,
        delayHide: PropTypes__default['default'].number,
        delayUpdate: PropTypes__default['default'].number,
        delayShow: PropTypes__default['default'].number,
        event: PropTypes__default['default'].string,
        eventOff: PropTypes__default['default'].string,
        isCapture: PropTypes__default['default'].bool,
        globalEventOff: PropTypes__default['default'].string,
        getContent: PropTypes__default['default'].any,
        afterShow: PropTypes__default['default'].func,
        afterHide: PropTypes__default['default'].func,
        overridePosition: PropTypes__default['default'].func,
        disable: PropTypes__default['default'].bool,
        scrollHide: PropTypes__default['default'].bool,
        resizeHide: PropTypes__default['default'].bool,
        wrapper: PropTypes__default['default'].string,
        bodyMode: PropTypes__default['default'].bool,
        possibleCustomEvents: PropTypes__default['default'].string,
        possibleCustomEventsOff: PropTypes__default['default'].string,
        clickable: PropTypes__default['default'].bool
      };
    }
  }]);

  function ReactTooltip(props) {
    var _this;

    _classCallCheck$k(this, ReactTooltip);

    _this = _possibleConstructorReturn$j(this, _getPrototypeOf$1(ReactTooltip).call(this, props));
    _this.state = {
      uuid: props.uuid || generateUUID(),
      place: props.place || 'top',
      // Direction of tooltip
      desiredPlace: props.place || 'top',
      type: 'dark',
      // Color theme of tooltip
      effect: 'float',
      // float or fixed
      show: false,
      border: false,
      customColors: {},
      offset: {},
      extraClass: '',
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null,
      // Current mouse event
      currentTarget: null,
      // Current target of mouse event
      ariaProps: parseAria(props),
      // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      possibleCustomEvents: props.possibleCustomEvents || '',
      possibleCustomEventsOff: props.possibleCustomEventsOff || '',
      originTooltip: null,
      isMultiline: false
    };

    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'hideTooltipOnScroll', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.delayReshow = null;
    _this.intervalUpdateContent = null;
    return _this;
  }
  /**
   * For unify the bind and unbind listener
   */


  _createClass$k(ReactTooltip, [{
    key: "bind",
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          insecure = _this$props.insecure,
          resizeHide = _this$props.resizeHide;
      this.bindListener(); // Bind listener for tooltip

      this.bindWindowEvents(resizeHide); // Bind global event for static method
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mount = false;
      this.clearTimer();
      this.unbindListener();
      this.removeScrollListener(this.state.currentTarget);
      this.unbindWindowEvents();
    }
    /**
     * Return if the mouse is on the tooltip.
     * @returns {boolean} true - mouse is on the tooltip
     */

  }, {
    key: "mouseOnToolTip",
    value: function mouseOnToolTip() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        /* old IE or Firefox work around */
        if (!this.tooltipRef.matches) {
          /* old IE work around */
          if (this.tooltipRef.msMatchesSelector) {
            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
          } else {
            /* old Firefox work around */
            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
          }
        }

        return this.tooltipRef.matches(':hover');
      }

      return false;
    }
    /**
     * Pick out corresponded target elements
     */

  }, {
    key: "getTargetArray",
    value: function getTargetArray(id) {
      var targetArray = [];
      var selector;

      if (!id) {
        selector = '[data-tip]:not([data-for])';
      } else {
        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
      } // Scan document for shadow DOM elements


      nodeListToArray(document.getElementsByTagName('*')).filter(function (element) {
        return element.shadowRoot;
      }).forEach(function (element) {
        targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
      });
      return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
    }
    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: "bindListener",
    value: function bindListener() {
      var _this3 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          globalEventOff = _this$props2.globalEventOff,
          isCapture = _this$props2.isCapture;
      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        if (target.getAttribute('currentItem') === null) {
          target.setAttribute('currentItem', 'false');
        }

        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customUnbindListener(target);
        }
      });

      if (this.isBodyMode()) {
        this.bindBodyListener(targetArray);
      } else {
        targetArray.forEach(function (target) {
          var isCaptureMode = _this3.isCapture(target);

          var effect = _this3.getEffect(target);

          if (_this3.isCustomEvent(target)) {
            _this3.customBindListener(target);

            return;
          }

          target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);

          if (effect === 'float') {
            target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
          }

          target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
        });
      } // Global event to hide tooltip


      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
      } // Track removal of targetArray elements from DOM


      this.bindRemovalTracker();
    }
    /**
     * Unbind listeners on target elements
     */

  }, {
    key: "unbindListener",
    value: function unbindListener() {
      var _this4 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          globalEventOff = _this$props3.globalEventOff;

      if (this.isBodyMode()) {
        this.unbindBodyListener();
      } else {
        var targetArray = this.getTargetArray(id);
        targetArray.forEach(function (target) {
          _this4.unbindBasicListener(target);

          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
        });
      }

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }
    /**
     * Invoke this before bind listener and unmount the component
     * it is necessary to invoke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: "unbindBasicListener",
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: "getTooltipContent",
    value: function getTooltipContent() {
      var _this$props4 = this.props,
          getContent = _this$props4.getContent,
          children = _this$props4.children; // Generate tooltip content

      var content;

      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0](this.state.originTooltip);
        } else {
          content = getContent(this.state.originTooltip);
        }
      }

      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
    }
  }, {
    key: "isEmptyTip",
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
    }
    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: "showTooltip",
    value: function showTooltip(e, isGlobalCall) {
      if (!this.tooltipRef) {
        return;
      }

      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement) return;
      } // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected


      var _this$props5 = this.props,
          multiline = _this$props5.multiline,
          getContent = _this$props5.getContent;
      var originTooltip = e.currentTarget.getAttribute('data-tip');
      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect

      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll

      var scrollHide = true;

      if (e.currentTarget.getAttribute('data-scroll-hide')) {
        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      } // Make sure the correct place is set


      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
      var result = getPosition$4(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      }

      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering

      this.clearTimer();
      var target = e.currentTarget;
      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
      var self = this;

      var updateState = function updateState() {
        self.setState({
          originTooltip: originTooltip,
          isMultiline: isMultiline,
          desiredPlace: desiredPlace,
          place: place,
          type: target.getAttribute('data-type') || self.props.type || 'dark',
          customColors: {
            text: target.getAttribute('data-text-color') || self.props.textColor || null,
            background: target.getAttribute('data-background-color') || self.props.backgroundColor || null,
            border: target.getAttribute('data-border-color') || self.props.borderColor || null,
            arrow: target.getAttribute('data-arrow-color') || self.props.arrowColor || null
          },
          effect: effect,
          offset: offset,
          html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html) || false,
          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
          border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border) || false,
          extraClass: target.getAttribute('data-class') || self.props["class"] || self.props.className || '',
          disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable) || false,
          currentTarget: target
        }, function () {
          if (scrollHide) {
            self.addScrollListener(self.state.currentTarget);
          }

          self.updateTooltip(e);

          if (getContent && Array.isArray(getContent)) {
            self.intervalUpdateContent = setInterval(function () {
              if (self.mount) {
                var _getContent = self.props.getContent;
                var placeholder = getTipContent(originTooltip, '', _getContent[0](), isMultiline);
                var isEmptyTip = self.isEmptyTip(placeholder);
                self.setState({
                  isEmptyTip: isEmptyTip
                });
                self.updatePosition();
              }
            }, getContent[1]);
          }
        });
      }; // If there is no delay call immediately, don't allow events to get in first.


      if (reshowDelay) {
        this.delayReshow = setTimeout(updateState, reshowDelay);
      } else {
        updateState();
      }
    }
    /**
     * When mouse hover, update tool tip
     */

  }, {
    key: "updateTooltip",
    value: function updateTooltip(e) {
      var _this5 = this;

      var _this$state = this.state,
          delayShow = _this$state.delayShow,
          disable = _this$state.disable;
      var afterShow = this.props.afterShow;
      var placeholder = this.getTooltipContent();
      var delayTime = parseInt(delayShow, 10);
      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

      if (this.mouseOnToolTip()) {
        return;
      } // if the tooltip is empty, disable the tooltip


      if (this.isEmptyTip(placeholder) || disable) {
        return;
      }

      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this5.state.show;

          _this5.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this5.updatePosition();

            if (isInvisible && afterShow) {
              afterShow(e);
            }
          });
        }
      };

      clearTimeout(this.delayShowLoop);

      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }
    /*
     * If we're mousing over the tooltip remove it when we leave.
     */

  }, {
    key: "listenForTooltipExit",
    value: function listenForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
      }
    }
  }, {
    key: "removeListenerForTooltipExit",
    value: function removeListenerForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
      }
    }
    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: "hideTooltip",
    value: function hideTooltip(e, hasTarget) {
      var _this6 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        isScroll: false
      };
      var disable = this.state.disable;
      var isScroll = options.isScroll;
      var delayHide = isScroll ? 0 : this.state.delayHide;
      var afterHide = this.props.afterHide;
      var placeholder = this.getTooltipContent();
      if (!this.mount) return;
      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip

      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }

      var resetState = function resetState() {
        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

        if (_this6.mouseOnToolTip()) {
          _this6.listenForTooltipExit();

          return;
        }

        _this6.removeListenerForTooltipExit();

        _this6.setState({
          show: false
        }, function () {
          _this6.removeScrollListener(_this6.state.currentTarget);

          if (isVisible && afterHide) {
            afterHide(e);
          }
        });
      };

      this.clearTimer();

      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }
    /**
     * When scroll, hide tooltip
     */

  }, {
    key: "hideTooltipOnScroll",
    value: function hideTooltipOnScroll(event, hasTarget) {
      this.hideTooltip(event, hasTarget, {
        isScroll: true
      });
    }
    /**
     * Add scroll event listener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: "addScrollListener",
    value: function addScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
    } // Calculation the position

  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var _this7 = this;

      var _this$state2 = this.state,
          currentEvent = _this$state2.currentEvent,
          currentTarget = _this$state2.currentTarget,
          place = _this$state2.place,
          desiredPlace = _this$state2.desiredPlace,
          effect = _this$state2.effect,
          offset = _this$state2.offset;
      var node = this.tooltipRef;
      var result = getPosition$4(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      }

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this7.updatePosition();
        });
      } // Set tooltip position


      node.style.left = result.position.left + 'px';
      node.style.top = result.position.top + 'px';
    }
    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearTimeout(this.delayReshow);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: "hasCustomColors",
    value: function hasCustomColors() {
      var _this8 = this;

      return Boolean(Object.keys(this.state.customColors).find(function (color) {
        return color !== 'border' && _this8.state.customColors[color];
      }) || this.state.border && this.state.customColors['border']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      var _this$state3 = this.state,
          extraClass = _this$state3.extraClass,
          html = _this$state3.html,
          ariaProps = _this$state3.ariaProps,
          disable = _this$state3.disable;
      var content = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(content);
      var style = generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border);
      var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' border' : '') + " place-".concat(this.state.place) + // top, bottom, left, right
      " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + ( // dark, success, warning, error, info, light, custom
      this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
      var Wrapper = this.props.wrapper;

      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(' ');

      if (html) {
        var htmlContent = "".concat(content, "\n<style>").concat(style, "</style>");
        return React__default['default'].createElement(Wrapper, _extends$a({
          className: "".concat(wrapperClassName),
          id: this.props.id,
          ref: function ref(_ref) {
            return _this9.tooltipRef = _ref;
          }
        }, ariaProps, {
          "data-id": "tooltip",
          dangerouslySetInnerHTML: {
            __html: htmlContent
          }
        }));
      } else {
        return React__default['default'].createElement(Wrapper, _extends$a({
          className: "".concat(wrapperClassName),
          id: this.props.id
        }, ariaProps, {
          ref: function ref(_ref2) {
            return _this9.tooltipRef = _ref2;
          },
          "data-id": "tooltip"
        }), React__default['default'].createElement("style", {
          dangerouslySetInnerHTML: {
            __html: style
          }
        }), content);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var ariaProps = prevState.ariaProps;
      var newAriaProps = parseAria(nextProps);
      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });

      if (!isChanged) {
        return null;
      }

      return _objectSpread2$1({}, prevState, {
        ariaProps: newAriaProps
      });
    }
  }]);

  return ReactTooltip;
}(React__default['default'].Component), _defineProperty$t(_class2, "defaultProps", {
  insecure: true,
  resizeHide: true,
  wrapper: 'div',
  clickable: false
}), _defineProperty$t(_class2, "supportedWrappers", ['div', 'span']), _defineProperty$t(_class2, "displayName", 'ReactTooltip'), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;

var css_248z$m = ".index_low-progress-assigned__39NRp {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100%;\n  width: 100%; }\n  .index_low-progress-assigned__39NRp .index_top-toggle__1t1ci {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    background: #e8eaec;\n    padding: 6px 0;\n    margin: 10px 0 15px;\n    line-height: 25px;\n    width: 350px;\n    border-radius: 10px; }\n    .index_low-progress-assigned__39NRp .index_top-toggle__1t1ci div {\n      padding: 3px 30px;\n      cursor: pointer; }\n    .index_low-progress-assigned__39NRp .index_top-toggle__1t1ci .index_active__2EKrf {\n      background: #ffffff;\n      border-radius: 5px;\n      font-weight: 500; }\n  .index_low-progress-assigned__39NRp .index_graph-headers__15Cp3 {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    width: 100%;\n    font-size: 11px;\n    margin-bottom: 20px; }\n    .index_low-progress-assigned__39NRp .index_graph-headers__15Cp3 .index_left-header__1Mdj6 {\n      font-weight: 500;\n      width: 20%;\n      text-align: right; }\n    .index_low-progress-assigned__39NRp .index_graph-headers__15Cp3 .index_center-header__N-VEy {\n      display: flex;\n      justify-content: center;\n      width: 60%;\n      min-width: 500px;\n      padding: 0 10px; }\n      .index_low-progress-assigned__39NRp .index_graph-headers__15Cp3 .index_center-header__N-VEy .index_legend-item__2Jt8U {\n        display: flex;\n        flex-direction: row;\n        padding: 0 10px; }\n        .index_low-progress-assigned__39NRp .index_graph-headers__15Cp3 .index_center-header__N-VEy .index_legend-item__2Jt8U .index_color-swatch__3ejeb {\n          width: 8px;\n          height: 8px;\n          border-radius: 2px;\n          margin: 3px 8px; }\n    .index_low-progress-assigned__39NRp .index_graph-headers__15Cp3 .index_right-header__1zs95 {\n      font-weight: 500;\n      width: 20%;\n      padding-right: 15px; }\n  .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    overflow-x: hidden;\n    margin-right: -15px;\n    width: 100%;\n    height: calc(100% - 200px);\n    font-size: 12px; }\n    .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-graph-row__1ulBY {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      width: 100%; }\n    .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_item-name__2O8B7 {\n      width: 20%;\n      text-align: right; }\n    .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_horizontal-bar-graph__Xo1TI {\n      display: flex;\n      flex-direction: row;\n      flex-grow: 1;\n      margin: 6px 40px 6px 30px;\n      border-radius: 10px;\n      cursor: pointer; }\n      .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_horizontal-bar-graph__Xo1TI .index_complete-bar__2lXqS {\n        background: #4eb3d4;\n        width: 50%;\n        height: 24px;\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 5px; }\n      .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_horizontal-bar-graph__Xo1TI .index_incomplete-bar__1LPQd {\n        background: #3d68d3;\n        width: 50%;\n        height: 24px;\n        border-top-right-radius: 5px;\n        border-bottom-right-radius: 5px; }\n    .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_item-score__1uK8J {\n      width: 18%; }\n    .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 {\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 60px; }\n      .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline-title__J-vS2 {\n        width: 20%;\n        text-align: right;\n        text-transform: uppercase;\n        font-size: 10px;\n        font-weight: 500; }\n      .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF {\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n        width: 0;\n        margin: 0 40px 0 30px;\n        padding: 2px;\n        justify-content: center;\n        align-items: flex-start;\n        overflow-y: hidden; }\n        .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF ::-webkit-scrollbar {\n          width: 1px; }\n        .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF .index_line-top__3fo4J {\n          height: 5px;\n          width: 100%;\n          border-left: 1px solid;\n          border-right: 1px solid; }\n        .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF .index_line-bottom__dsxBu {\n          border-top: 1px solid;\n          height: 5px;\n          width: 100%;\n          border-left: 1px solid;\n          border-right: 1px solid; }\n        .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF .index_dates__3NoFu {\n          display: flex;\n          flex-direction: row;\n          justify-content: space-around;\n          font-size: 10px;\n          width: 100%; }\n          .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF .index_dates__3NoFu .index_timeline-item__17WGc {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            align-items: center;\n            width: 35px; }\n          .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF .index_dates__3NoFu .index_dot__3C2ao {\n            height: 10px;\n            width: 10px;\n            border-radius: 30px;\n            background: #4eb3d4;\n            margin: -10px 0 5px; }\n        .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF.index_wide__Gc5Sv {\n          width: calc(100% - 440px);\n          align-items: flex-start; }\n          .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF.index_wide__Gc5Sv .index_line-top__3fo4J {\n            width: 100vw;\n            margin: 0 10px; }\n          .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF.index_wide__Gc5Sv .index_line-bottom__dsxBu {\n            width: 100vw;\n            margin: 0 10px; }\n          .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_timeline__1ERcF.index_wide__Gc5Sv .index_dates__3NoFu {\n            width: 100vw;\n            margin: 0 10px; }\n      .index_low-progress-assigned__39NRp .index_low-progress-graph__1j6rm .index_low-progress-timeline-row__2Jd21 .index_end-filler__2SJZB {\n        width: 18%; }\n  .index_low-progress-assigned__39NRp .index_graph-footers__VLIxC {\n    display: flex;\n    flex-direction: column;\n    width: 65%;\n    font-size: 11px;\n    font-weight: 500; }\n    .index_low-progress-assigned__39NRp .index_graph-footers__VLIxC .index_graph-ticks__xa91d {\n      display: flex;\n      flex-direction: row;\n      margin: 20px -10px 8px 35px;\n      padding-right: 15px; }\n      .index_low-progress-assigned__39NRp .index_graph-footers__VLIxC .index_graph-ticks__xa91d .index_graph-tick__2HNQp {\n        width: 10%;\n        min-width: 30px;\n        text-align: center; }\n    .index_low-progress-assigned__39NRp .index_graph-footers__VLIxC .index_axis-label__zxPKi {\n      display: flex;\n      justify-content: center; }\n";
styleInject(css_248z$m);

function LowProgressAssigned(props) {
  var _this = this;

  var data = props.data,
      t = props.t,
      activeItem = props.activeItem,
      setActiveItem = props.setActiveItem;

  var _useState = React$2.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      activeRow = _useState2[0],
      setActiveRow = _useState2[1];

  var ticks = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "low-progress-assigned"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "top-toggle"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(activeItem === 'series' ? 'active' : ''),
    onClick: setActiveItem.bind(null, 'series')
  }, t ? t('graphs.low-progress-assigned.series') : 'Series'), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(activeItem === 'modules' ? 'active' : ''),
    onClick: setActiveItem.bind(null, 'modules')
  }, t ? t('graphs.low-progress-assigned.modules') : 'Independent Modules')), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "graph-headers"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "left-header"
  }, t ? t('graphs.low-progress-assigned.name') : 'Name'), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "center-header"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "legend-item"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "color-swatch",
    style: {
      background: '#4eb3d4'
    }
  }), /*#__PURE__*/React__default['default'].createElement("div", null, t ? t('graphs.low-progress-assigned.complete') : 'Complete')), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "legend-item"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "color-swatch",
    style: {
      background: '#3d68d3'
    }
  }), /*#__PURE__*/React__default['default'].createElement("div", null, t ? t('graphs.low-progress-assigned.incomplete') : 'Incomplete'))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "right-header"
  }, t ? t('graphs.low-progress-assigned.total-participants') : 'Total Participants')), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "low-progress-graph"
  }, /*#__PURE__*/React__default['default'].createElement(ReactTooltip, {
    effect: "solid",
    delayShow: 300
  }), data[activeItem].map(function (item, idx) {
    var nextItem = activeRow.name === item.name ? {} : item;
    var wide = activeRow.assignmentTimeline && activeRow.assignmentTimeline.length > 10;
    return /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        width: '100%'
      },
      key: idx
    }, /*#__PURE__*/React__default['default'].createElement(ReactTooltip, {
      effect: "solid",
      delayShow: 300,
      id: "tooltip-complete",
      className: "card-tooltip"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        width: '140px'
      }
    }, /*#__PURE__*/React__default['default'].createElement("div", null, "Complete: ".concat(item.completePercent * 100, "%")), /*#__PURE__*/React__default['default'].createElement("div", null, "Participants: ".concat(item.completeCount)))), /*#__PURE__*/React__default['default'].createElement(ReactTooltip, {
      effect: "solid",
      delayShow: 300,
      id: "tooltip-incomplete",
      className: "card-tooltip"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        width: '140px'
      }
    }, /*#__PURE__*/React__default['default'].createElement("div", null, "Incomplete: ".concat(item.incompletePercent * 100, "%")), /*#__PURE__*/React__default['default'].createElement("div", null, "Complete: ".concat(item.incompleteCount)))), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "low-progress-graph-row",
      onClick: setActiveRow.bind(_this, nextItem)
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "item-name"
    }, item.name), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "horizontal-bar-graph",
      key: "bar-graph-".concat(idx)
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "complete-bar",
      style: {
        width: "".concat(item.completePercent * 100, "%")
      },
      "data-count": item.completeCount,
      "data-tip": "".concat(item.completePercent * 100, "%"),
      "data-for": "tooltip-complete"
    }), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "incomplete-bar",
      style: {
        width: "".concat(item.incompletePercent === 0 ? 100 : item.incompletePercent * 100, "%")
      },
      "data-count": item.incompleteCount,
      "data-tip": "".concat(item.incompletePercent === 0 ? 100 : item.incompletePercent * 100, "%"),
      "data-for": "tooltip-incomplete"
    })), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "item-score"
    }, item.participantCount)), activeRow.name === item.name && /*#__PURE__*/React__default['default'].createElement("div", {
      className: "low-progress-timeline-row"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "timeline-title"
    }, t ? t('') : 'Assigned Date Timeline'), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "timeline ".concat(wide ? 'wide' : '')
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "line-top"
    }), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "line-bottom"
    }), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "dates"
    }, /*#__PURE__*/React__default['default'].createElement(ReactTooltip, {
      effect: "solid",
      delayShow: 300
    }), activeRow.assignmentTimeline.map(function (time, index) {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "timeline-item",
        "data-tip": "Participants: ".concat(time.participantCount),
        key: index
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "dot"
      }), hooks(time.dateInt).format('M/DD'));
    }))), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "end-filler"
    })));
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "graph-footers"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "graph-ticks"
  }, ticks.map(function (tick, idx) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "graph-tick",
      key: idx
    }, "".concat(tick, "%"));
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "axis-label"
  }, t ? t('graphs.low-progress-assigned.percent-complete') : 'Percentage Completed')));
}

var css_248z$n = ".index_security-score-footer__1nWNl {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; }\n  .index_security-score-footer__1nWNl .index_level-container__1bcxX {\n    font-weight: 500; }\n    .index_security-score-footer__1nWNl .index_level-container__1bcxX .index_fad__11wHR {\n      margin-right: 5px; }\n  .index_security-score-footer__1nWNl .index_change-container__1Pn0i {\n    font-size: 13px;\n    line-height: 22px; }\n    .index_security-score-footer__1nWNl .index_change-container__1Pn0i .index_far__dwOcc {\n      margin-left: 5px; }\n\n.index_security-score-by-category-labels__1SBe7 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 202px;\n  width: 300px;\n  line-height: 21px;\n  padding: 26px 0;\n  text-align: right; }\n\n#index_root__2OLMH > div > div > div > div > svg > g:nth-child(2) > line {\n  display: none; }\n\n#index_root__2OLMH > div > div > div > div > svg > g:nth-child(3) > line {\n  display: none; }\n\n.index_bottom-rank-graph__3XwoF {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 10px; }\n  .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-left-nav__11-dx {\n    display: flex;\n    flex-direction: column;\n    width: 25%;\n    min-width: 80px;\n    height: 100%;\n    text-align: right;\n    text-transform: capitalize;\n    padding: 35px 20px;\n    background: #edf7fb;\n    border-right: 2px solid #4eb3d4;\n    align-items: flex-end;\n    border-bottom-left-radius: 10px;\n    border-top-left-radius: 10px; }\n    .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-left-nav__11-dx .index_bottom-rank-graph-left-nav-item__1VPGd {\n      margin: 0 -40px 5px 0;\n      padding: 10px 30px 10px 7px;\n      border-radius: 13px;\n      width: 180px; }\n      .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-left-nav__11-dx .index_bottom-rank-graph-left-nav-item__1VPGd .index_fal__WWRQh {\n        display: none;\n        float: right;\n        font-size: 10px;\n        margin-right: -20px;\n        line-height: 14px;\n        font-weight: 600; }\n      .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-left-nav__11-dx .index_bottom-rank-graph-left-nav-item__1VPGd.index_active__33XN1, .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-left-nav__11-dx .index_bottom-rank-graph-left-nav-item__1VPGd:hover {\n        background: white;\n        box-shadow: 3px 0 10px 0 #eaeaea;\n        font-weight: 500;\n        cursor: pointer; }\n        .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-left-nav__11-dx .index_bottom-rank-graph-left-nav-item__1VPGd.index_active__33XN1 .index_fal__WWRQh, .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-left-nav__11-dx .index_bottom-rank-graph-left-nav-item__1VPGd:hover .index_fal__WWRQh {\n          display: block; }\n  .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-body__S-0v1 {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    width: 80%;\n    height: 280px;\n    min-width: 224px;\n    padding: 20px 60px 20px 50px; }\n    .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-body__S-0v1 .index_no-data__1dQLn {\n      margin: 100px auto; }\n    .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-body__S-0v1 .index_headers__8xjv9 {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      padding-bottom: 20px;\n      font-weight: 500; }\n    .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-body__S-0v1 .index_body__2Pqia {\n      overflow-x: hidden; }\n    .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-body__S-0v1 .index_bottom-rank-body-row__30sfW {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      padding: 9px 20px;\n      border-radius: 10px;\n      margin: 3px -20px; }\n      .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-body__S-0v1 .index_bottom-rank-body-row__30sfW:nth-child(even) {\n        background: #f4f7f9; }\n      .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-body__S-0v1 .index_bottom-rank-body-row__30sfW .index_rank-score__1IEH5 {\n        display: inline-flex;\n        min-width: 30px;\n        text-align: center;\n        justify-content: center; }\n      .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-body__S-0v1 .index_bottom-rank-body-row__30sfW .index_fa-long-arrow-up__3oU2w {\n        color: #4ed4b2; }\n      .index_bottom-rank-graph__3XwoF .index_bottom-rank-graph-body__S-0v1 .index_bottom-rank-body-row__30sfW .index_fa-long-arrow-down__QN-s4 {\n        color: #3d68d3; }\n\n.index_graph-placeholder__2JYc8 {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(6px); }\n  .index_graph-placeholder__2JYc8.index_loaded__mp5ag {\n    transition: all 0.2s;\n    backdrop-filter: none;\n    background-color: rgba(255, 255, 255, 0); }\n";
styleInject(css_248z$n);

function GraphPlaceholder(props) {
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "graph-placeholder ".concat(props.loading ? 'loading' : 'loaded')
  }));
}

function EmptyPlaceholder(props) {
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("iframe", {
    src: "https://cdn.cyberescape.livingsecurity.com/files/radial-circular-placeholder.html",
    height: props.height || 300,
    width: props.width || 300,
    style: {
      border: 'none'
    }
  }));
}

var Button$2 = function Button(_ref) {
  var children = _ref.children,
      setFilterMenuIsOpen = _ref.setFilterMenuIsOpen;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    onClick: function onClick() {
      return setFilterMenuIsOpen(function (prevState) {
        return !prevState;
      });
    },
    className: "ReportsFilter__AddFilterButton"
  }, /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#173042",
    d: "M13.36 1.814H2.64c-.117 0-.233.023-.342.068-.108.045-.207.111-.29.194-.082.084-.148.182-.193.291-.045.109-.068.225-.067.343v1.56c0 .211.075.416.213.577l3.885 4.587c.137.162.212.366.213.578v2.428c0 .16.043.317.124.455.08.138.197.252.337.33l2.095 1.16c.131.074.28.113.43.113.238 0 .465-.095.632-.263.168-.168.262-.396.262-.634v-3.589c0-.212.076-.416.213-.578l3.886-4.583c.137-.161.212-.366.213-.578V2.71c0-.118-.023-.234-.068-.343-.045-.109-.11-.207-.193-.29-.083-.084-.182-.15-.29-.195-.108-.045-.225-.068-.342-.068z"
  })), /*#__PURE__*/React__default['default'].createElement("div", null, children));
};

var Menu = function Menu(_ref) {
  var allFiltersItemText = _ref.allFiltersItemText,
      participant = _ref.participant,
      setFilterMenuIsOpen = _ref.setFilterMenuIsOpen,
      setActiveFilterFields = _ref.setActiveFilterFields;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    onClick: function onClick() {
      return setFilterMenuIsOpen(function (prevState) {
        return !prevState;
      });
    },
    className: "ReportsFilter__FilterDropdown__background"
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ReportsFilter__AddFilterDropdown"
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    onClick: function onClick() {
      setActiveFilterFields(function () {
        var nextFilter = [];
        Object.keys(participant).forEach(function (filterField) {
          return nextFilter.push(filterField);
        });
        return nextFilter;
      });
      setFilterMenuIsOpen(function (prevState) {
        return !prevState;
      });
    },
    className: "ReportsFilter__FilterDropdownItem"
  }, allFiltersItemText), participant && Object.keys(participant).map(function (filterField, idx) {
    return /*#__PURE__*/React__default['default'].createElement(AddFilterDropdownItem, {
      participant: participant,
      key: idx,
      setActiveFilterFields: setActiveFilterFields,
      filterField: filterField,
      setFilterMenuIsOpen: setFilterMenuIsOpen
    });
  })));
};

var AddFilterDropdownItem = function AddFilterDropdownItem(_ref2) {
  var participant = _ref2.participant,
      filterField = _ref2.filterField,
      setActiveFilterFields = _ref2.setActiveFilterFields,
      setFilterMenuIsOpen = _ref2.setFilterMenuIsOpen;
  return /*#__PURE__*/React__default['default'].createElement("li", {
    onClick: function onClick() {
      setActiveFilterFields(function (prevState) {
        var nextState = lodash.cloneDeep(prevState);

        if (nextState.length === Object.keys(participant).length) {
          nextState = nextState.filter(function (prevFilterField) {
            return prevFilterField === filterField;
          });
        }

        if (nextState.includes(filterField)) ; else {
          nextState.push(filterField);
        }

        return nextState;
      });
      setFilterMenuIsOpen(function (prevState) {
        return !prevState;
      });
    },
    className: "ReportsFilter__FilterDropdownItem"
  }, filterField.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  }));
};

var AddFilterContainer = function AddFilterContainer(props) {
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Button$2, {
    setFilterMenuIsOpen: props.setFilterMenuIsOpen
  }, props.addFiltersButtonText), props.filterMenuIsOpen && /*#__PURE__*/React__default['default'].createElement(Menu, {
    setFilterMenuIsOpen: props.setFilterMenuIsOpen,
    setActiveFilterFields: props.setActiveFilterFields,
    participant: props.participant,
    allFiltersItemText: props.allFiltersItemText
  }));
};

var Button$3 = function Button(_ref) {
  var handleClick = _ref.handleClick,
      setActiveFilterFields = _ref.setActiveFilterFields,
      children = _ref.children,
      removeFilterButtonText = _ref.removeFilterButtonText;

  var _useState = React$2.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showRemoveButton = _useState2[0],
      setShowRemoveButton = _useState2[1];

  var _useState3 = React$2.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      buttonOpen = _useState4[0],
      setButtonOpen = _useState4[1];

  var buttonOpenRef = React$2.useRef(buttonOpen);
  buttonOpenRef.current = !buttonOpen;
  var timer;

  var handleRemoveButtonMouseEnter = function handleRemoveButtonMouseEnter() {
    setShowRemoveButton(true);
    timer = setTimeout(function () {
      setButtonOpen(buttonOpenRef.current);
    }, 300);
  };

  var handleRemoveButtonMouseLeave = function handleRemoveButtonMouseLeave() {
    setButtonOpen(false);
    setShowRemoveButton(false);
    clearTimeout(timer);
  };

  var removeFilterField = function removeFilterField(filterField) {
    setActiveFilterFields(function (prevState) {
      var nextState = [];
      nextState = prevState.filter(function (prevFilterField) {
        return prevFilterField !== filterField;
      });
      return nextState;
    });
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ReportsFilter__FilterButton_container"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    onMouseEnter: handleRemoveButtonMouseEnter,
    onMouseLeave: handleRemoveButtonMouseLeave,
    className: "ReportsFilter__RemoveFilterButton",
    onClick: function onClick() {
      return removeFilterField(children);
    }
  }, buttonOpen && showRemoveButton ? /*#__PURE__*/React__default['default'].createElement("p", null, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fas fa-times"
  }), removeFilterButtonText) : /*#__PURE__*/React__default['default'].createElement("p", null, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fas fa-times"
  }))), /*#__PURE__*/React__default['default'].createElement("div", {
    onClick: function onClick() {
      handleClick(children);
    },
    className: "ReportsFilter__FilterButton"
  }, /*#__PURE__*/React__default['default'].createElement("p", null, children.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  })), "\xA0", /*#__PURE__*/React__default['default'].createElement("span", null), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fa fa-chevron-right"
  }))));
};

/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Alignment along the horizontal axis. */
var Alignment = {
    CENTER: "center",
    LEFT: "left",
    RIGHT: "right",
};

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// tslint:disable:object-literal-sort-keys
/**
 * The four basic intents.
 */
var Intent = {
    NONE: "none",
    PRIMARY: "primary",
    SUCCESS: "success",
    WARNING: "warning",
    DANGER: "danger",
};

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NS = process.env.BLUEPRINT_NAMESPACE || process.env.REACT_APP_BLUEPRINT_NAMESPACE || "bp3";
var ALIGN_LEFT = NS + "-align-left";
var ALIGN_RIGHT = NS + "-align-right";
var DISABLED = NS + "-disabled";
var INLINE = NS + "-inline";
var LARGE = NS + "-large";
var INTENT_PRIMARY = intentClass(Intent.PRIMARY);
var INTENT_SUCCESS = intentClass(Intent.SUCCESS);
var INTENT_WARNING = intentClass(Intent.WARNING);
var INTENT_DANGER = intentClass(Intent.DANGER);
var CONTROL = NS + "-control";
var CONTROL_INDICATOR = CONTROL + "-indicator";
var CONTROL_INDICATOR_CHILD = CONTROL_INDICATOR + "-child";
var CHECKBOX = NS + "-checkbox";
var RADIO = NS + "-radio";
var SWITCH = NS + "-switch";
var SWITCH_INNER_TEXT = SWITCH + "-inner-text";
/** Return CSS class for alignment. */
function alignmentClass(alignment) {
    switch (alignment) {
        case Alignment.LEFT:
            return ALIGN_LEFT;
        case Alignment.RIGHT:
            return ALIGN_RIGHT;
        default:
            return undefined;
    }
}
function intentClass(intent) {
    if (intent == null || intent === Intent.NONE) {
        return undefined;
    }
    return NS + "-intent-" + intent.toLowerCase();
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$1(d, b) {
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns whether `process.env.NODE_ENV` exists and equals `env`. */
function isNodeEnv(env) {
    return typeof process !== "undefined" && process.env && process.env.NODE_ENV === env;
}

/*
 * Copyright 2019 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An abstract component that Blueprint components can extend
 * in order to add some common functionality like runtime props validation.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
var AbstractPureComponent2 = /** @class */ (function (_super) {
    __extends$1(AbstractPureComponent2, _super);
    function AbstractPureComponent2(props, context) {
        var _this = _super.call(this, props, context) || this;
        // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
        _this.timeoutIds = [];
        _this.requestIds = [];
        /**
         * Clear all known timeouts.
         */
        _this.clearTimeouts = function () {
            if (_this.timeoutIds.length > 0) {
                for (var _i = 0, _a = _this.timeoutIds; _i < _a.length; _i++) {
                    var timeoutId = _a[_i];
                    window.clearTimeout(timeoutId);
                }
                _this.timeoutIds = [];
            }
        };
        /**
         * Clear all known animation frame requests.
         */
        _this.cancelAnimationFrames = function () {
            if (_this.requestIds.length > 0) {
                for (var _i = 0, _a = _this.requestIds; _i < _a.length; _i++) {
                    var requestId = _a[_i];
                    window.cancelAnimationFrame(requestId);
                }
                _this.requestIds = [];
            }
        };
        if (!isNodeEnv("production")) {
            _this.validateProps(_this.props);
        }
        return _this;
    }
    AbstractPureComponent2.prototype.componentDidUpdate = function (_prevProps, _prevState, _snapshot) {
        if (!isNodeEnv("production")) {
            this.validateProps(this.props);
        }
    };
    AbstractPureComponent2.prototype.componentWillUnmount = function () {
        this.clearTimeouts();
        this.cancelAnimationFrames();
    };
    /**
     * Request an animation frame and remember its ID.
     * All pending requests will be canceled when component unmounts.
     * @returns a "cancel" function that will cancel the request when invoked.
     */
    AbstractPureComponent2.prototype.requestAnimationFrame = function (callback) {
        var handle = window.requestAnimationFrame(callback);
        this.requestIds.push(handle);
        return function () { return window.cancelAnimationFrame(handle); };
    };
    /**
     * Set a timeout and remember its ID.
     * All pending timeouts will be cleared when component unmounts.
     * @returns a "cancel" function that will clear timeout when invoked.
     */
    AbstractPureComponent2.prototype.setTimeout = function (callback, timeout) {
        var handle = window.setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return function () { return window.clearTimeout(handle); };
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * Like propTypes, these runtime checks run only in development mode.
     */
    AbstractPureComponent2.prototype.validateProps = function (_props) {
        // implement in subclass
    };
    return AbstractPureComponent2;
}(React$2.PureComponent));

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DISPLAYNAME_PREFIX = "Blueprint3";

/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Renders common control elements, with additional props to customize appearance.
 * This component is not exported and is only used in this file for `Checkbox`, `Radio`, and `Switch` below.
 */
var Control = function (_a) {
    var _b;
    var alignIndicator = _a.alignIndicator, children = _a.children, className = _a.className, indicatorChildren = _a.indicatorChildren, inline = _a.inline, inputRef = _a.inputRef, label = _a.label, labelElement = _a.labelElement, large = _a.large, style = _a.style, type = _a.type, typeClassName = _a.typeClassName, _c = _a.tagName, tagName = _c === void 0 ? "label" : _c, htmlProps = __rest$1(_a, ["alignIndicator", "children", "className", "indicatorChildren", "inline", "inputRef", "label", "labelElement", "large", "style", "type", "typeClassName", "tagName"]);
    var classes = classnames(CONTROL, typeClassName, (_b = {},
        _b[DISABLED] = htmlProps.disabled,
        _b[INLINE] = inline,
        _b[LARGE] = large,
        _b), alignmentClass(alignIndicator), className);
    return React$2.createElement(tagName, { className: classes, style: style }, React$2.createElement("input", __assign$2({}, htmlProps, { ref: inputRef, type: type })), React$2.createElement("span", { className: CONTROL_INDICATOR }, indicatorChildren), label, labelElement, children);
};
var Switch = /** @class */ (function (_super) {
    __extends$1(Switch, _super);
    function Switch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Switch.prototype.render = function () {
        var _a = this.props, innerLabelChecked = _a.innerLabelChecked, innerLabel = _a.innerLabel, controlProps = __rest$1(_a, ["innerLabelChecked", "innerLabel"]);
        var switchLabels = innerLabel || innerLabelChecked
            ? [
                React$2.createElement("div", { key: "checked", className: CONTROL_INDICATOR_CHILD },
                    React$2.createElement("div", { className: SWITCH_INNER_TEXT }, innerLabelChecked ? innerLabelChecked : innerLabel)),
                React$2.createElement("div", { key: "unchecked", className: CONTROL_INDICATOR_CHILD },
                    React$2.createElement("div", { className: SWITCH_INNER_TEXT }, innerLabel)),
            ]
            : null;
        return (React$2.createElement(Control, __assign$2({}, controlProps, { type: "checkbox", typeClassName: SWITCH, indicatorChildren: switchLabels })));
    };
    Switch.displayName = DISPLAYNAME_PREFIX + ".Switch";
    Switch = __decorate([
        polyfill
    ], Switch);
    return Switch;
}(AbstractPureComponent2));
var Radio = /** @class */ (function (_super) {
    __extends$1(Radio, _super);
    function Radio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Radio.prototype.render = function () {
        return React$2.createElement(Control, __assign$2({}, this.props, { type: "radio", typeClassName: RADIO }));
    };
    Radio.displayName = DISPLAYNAME_PREFIX + ".Radio";
    Radio = __decorate([
        polyfill
    ], Radio);
    return Radio;
}(AbstractPureComponent2));
var Checkbox = /** @class */ (function (_super) {
    __extends$1(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            indeterminate: _this.props.indeterminate || _this.props.defaultIndeterminate || false,
        };
        // must maintain internal reference for `indeterminate` support
        _this.input = null;
        _this.handleChange = function (evt) {
            var _a, _b;
            var indeterminate = evt.target.indeterminate;
            // update state immediately only if uncontrolled
            if (_this.props.indeterminate == null) {
                _this.setState({ indeterminate: indeterminate });
            }
            // otherwise wait for props change. always invoke handler.
            (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
        };
        _this.handleInputRef = function (ref) {
            var _a, _b;
            _this.input = ref;
            (_b = (_a = _this.props).inputRef) === null || _b === void 0 ? void 0 : _b.call(_a, ref);
        };
        return _this;
    }
    Checkbox.getDerivedStateFromProps = function (_a) {
        var indeterminate = _a.indeterminate;
        // put props into state if controlled by props
        if (indeterminate != null) {
            return { indeterminate: indeterminate };
        }
        return null;
    };
    Checkbox.prototype.render = function () {
        var _a = this.props, defaultIndeterminate = _a.defaultIndeterminate, indeterminate = _a.indeterminate, controlProps = __rest$1(_a, ["defaultIndeterminate", "indeterminate"]);
        return (React$2.createElement(Control, __assign$2({}, controlProps, { inputRef: this.handleInputRef, onChange: this.handleChange, type: "checkbox", typeClassName: CHECKBOX })));
    };
    Checkbox.prototype.componentDidMount = function () {
        this.updateIndeterminate();
    };
    Checkbox.prototype.componentDidUpdate = function () {
        this.updateIndeterminate();
    };
    Checkbox.prototype.updateIndeterminate = function () {
        if (this.input != null) {
            this.input.indeterminate = this.state.indeterminate;
        }
    };
    Checkbox.displayName = DISPLAYNAME_PREFIX + ".Checkbox";
    Checkbox = __decorate([
        polyfill
    ], Checkbox);
    return Checkbox;
}(AbstractPureComponent2));

var Menu$1 = function Menu(_ref) {
  var filterItems = _ref.filterItems,
      filterField = _ref.filterField,
      handleCheckboxChange = _ref.handleCheckboxChange,
      isChecked = _ref.isChecked;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ReportsFilter__FilterDropdown"
  }, filterItems.map(function (filterItem, idx) {
    return /*#__PURE__*/React__default['default'].createElement("li", {
      key: idx,
      className: "ReportsFilter__FilterDropdownItem"
    }, /*#__PURE__*/React__default['default'].createElement(Checkbox, {
      name: filterItem.name,
      checked: isChecked[filterItem.name] === undefined ? false : isChecked[filterItem.name],
      onChange: function onChange(e) {
        return handleCheckboxChange(e, idx, filterField, filterItem);
      }
    }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, filterItem.name, " \xA0 ", "(".concat(filterItem.count, ")"))));
  })));
};

var FilterFieldDropdown = function FilterFieldDropdown(_ref) {
  var activeFilter = _ref.activeFilter,
      setActiveFilter = _ref.setActiveFilter,
      activeFilterFields = _ref.activeFilterFields,
      setActiveFilterFields = _ref.setActiveFilterFields,
      setActiveDropdown = _ref.setActiveDropdown,
      filterField = _ref.filterField,
      pastReport = _ref.pastReport,
      filteredReport = _ref.filteredReport,
      numberOfFilterFields = _ref.numberOfFilterFields,
      toggleFilterFieldMenus = _ref.toggleFilterFieldMenus,
      closeAllDropdowns = _ref.closeAllDropdowns,
      jobTitleMenuOpen = _ref.jobTitleMenuOpen,
      rolesMenuOpen = _ref.rolesMenuOpen,
      departmentsMenuOpen = _ref.departmentsMenuOpen,
      divisionsMenuOpen = _ref.divisionsMenuOpen,
      locationsMenuOpen = _ref.locationsMenuOpen,
      citiesMenuOpen = _ref.citiesMenuOpen,
      statesMenuOpen = _ref.statesMenuOpen,
      removeFilterButtonText = _ref.removeFilterButtonText;

  var _useState = React$2.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var handleCheckboxChange = function handleCheckboxChange(e, index, filterField, filterToAddOrRemove) {
    if (!isChecked[filterToAddOrRemove.name]) {
      // set the currentTarget as its own isChecked key value
      setIsChecked(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), {}, _defineProperty({}, filterToAddOrRemove.name, true));
      });
      setActiveFilter(true, index, filterField, filterToAddOrRemove);
      setActiveDropdown(filterField);
    } else if (isChecked[filterToAddOrRemove.name]) {
      setIsChecked(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), {}, _defineProperty({}, filterToAddOrRemove.name, false));
      });
      setActiveFilter(false, index, filterField, filterToAddOrRemove);
      setActiveDropdown(filterField);
    }
  };

  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ReportsFilter__FilterButton_inner show \n          ".concat(activeFilterFields && activeFilterFields.length === numberOfFilterFields || filteredReport && filteredReport.participant[filterField].length >= 0 ? 'show' : '')
  }, /*#__PURE__*/React__default['default'].createElement(Button$3, {
    removeFilterButtonText: removeFilterButtonText,
    handleClick: toggleFilterFieldMenus,
    setActiveFilterFields: setActiveFilterFields,
    setActiveDropdown: setActiveDropdown
  }, filterField), /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, filteredReport.participant[filterField].length && (filterField === 'jobTitles' && !!jobTitleMenuOpen || filterField === 'roles' && !!rolesMenuOpen || filterField === 'departments' && !!departmentsMenuOpen || filterField === 'divisions' && !!divisionsMenuOpen || filterField === 'states' && !!statesMenuOpen || filterField === 'cities' && !!citiesMenuOpen || filterField === 'locations' && !!locationsMenuOpen) ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    onClick: function onClick() {
      return closeAllDropdowns(filterField);
    },
    className: "ReportsFilter__FilterDropdown__background"
  }), /*#__PURE__*/React__default['default'].createElement(Menu$1, {
    isChecked: isChecked,
    setIsChecked: setIsChecked,
    handleCheckboxChange: handleCheckboxChange,
    filterItems: pastReport.participant[filterField],
    filterField: filterField
  })) : null)));
};

var FieldItemsContainer = function FieldItemsContainer(_ref) {
  var tenantId = _ref.tenantId,
      activeFilter = _ref.activeFilter,
      setActiveFilter = _ref.setActiveFilter,
      activeFilterFields = _ref.activeFilterFields,
      setActiveFilterFields = _ref.setActiveFilterFields,
      activeDropdown = _ref.activeDropdown,
      setActiveDropdown = _ref.setActiveDropdown,
      baseFilters = _ref.baseFilters,
      pastReport = _ref.pastReport,
      filteredReport = _ref.filteredReport,
      toggleFilterFieldMenus = _ref.toggleFilterFieldMenus,
      closeAllDropdowns = _ref.closeAllDropdowns,
      jobTitleMenuOpen = _ref.jobTitleMenuOpen,
      rolesMenuOpen = _ref.rolesMenuOpen,
      departmentsMenuOpen = _ref.departmentsMenuOpen,
      divisionsMenuOpen = _ref.divisionsMenuOpen,
      locationsMenuOpen = _ref.locationsMenuOpen,
      citiesMenuOpen = _ref.citiesMenuOpen,
      statesMenuOpen = _ref.statesMenuOpen,
      removeFilterButtonText = _ref.removeFilterButtonText;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ReportsFilter__FilterButtons_container"
  }, activeFilterFields && activeFilterFields.map(function (filterField, idx) {
    return /*#__PURE__*/React__default['default'].createElement(FilterFieldDropdown, {
      removeFilterButtonText: removeFilterButtonText,
      activeFilter: activeFilter,
      numberOfFilterFields: Object.keys(baseFilters.participant).length,
      key: idx,
      tenantId: tenantId,
      pastReport: pastReport,
      activeDropdown: activeDropdown,
      setActiveDropdown: setActiveDropdown,
      activeFilterFields: activeFilterFields,
      setActiveFilterFields: setActiveFilterFields,
      filterField: filterField,
      setActiveFilter: setActiveFilter,
      filteredReport: filteredReport,
      baseFilters: baseFilters,
      toggleFilterFieldMenus: toggleFilterFieldMenus,
      closeAllDropdowns: closeAllDropdowns,
      jobTitleMenuOpen: jobTitleMenuOpen,
      rolesMenuOpen: rolesMenuOpen,
      departmentsMenuOpen: departmentsMenuOpen,
      divisionsMenuOpen: divisionsMenuOpen,
      locationsMenuOpen: locationsMenuOpen,
      citiesMenuOpen: citiesMenuOpen,
      statesMenuOpen: statesMenuOpen
    });
  }));
};

var css_248z$o = "@charset \"UTF-8\";\n/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n/* Document\n   ========================================================================== */\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\nhtml {\n  line-height: 1.15;\n  /* 1 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */ }\n\n/* Sections\n   ========================================================================== */\n/**\n * Remove the margin in all browsers.\n */\nbody {\n  margin: 0; }\n\n/**\n * Render the `main` element consistently in IE.\n */\nmain {\n  display: block; }\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\n\n/* Grouping content\n   ========================================================================== */\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\nhr {\n  box-sizing: content-box;\n  /* 1 */\n  height: 0;\n  /* 1 */\n  overflow: visible;\n  /* 2 */ }\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\npre {\n  font-family: monospace, monospace;\n  /* 1 */\n  font-size: 1em;\n  /* 2 */ }\n\n/* Text-level semantics\n   ========================================================================== */\n/**\n * Remove the gray background on active links in IE 10.\n */\na {\n  background-color: transparent; }\n\n/**\n * 1. Remove the bottom border in Chrome 57-\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\nabbr[title] {\n  border-bottom: none;\n  /* 1 */\n  text-decoration: underline;\n  /* 2 */\n  text-decoration: underline dotted;\n  /* 2 */ }\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\nb,\nstrong {\n  font-weight: bolder; }\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace;\n  /* 1 */\n  font-size: 1em;\n  /* 2 */ }\n\n/**\n * Add the correct font size in all browsers.\n */\nsmall {\n  font-size: 80%; }\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\n\nsub {\n  bottom: -0.25em; }\n\nsup {\n  top: -0.5em; }\n\n/* Embedded content\n   ========================================================================== */\n/**\n * Remove the border on images inside links in IE 10.\n */\nimg {\n  border-style: none; }\n\n/* Forms\n   ========================================================================== */\n/**\n * 1. Change the font styles in all browsers.\n * 2. Remove the margin in Firefox and Safari.\n */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  /* 1 */\n  font-size: 100%;\n  /* 1 */\n  line-height: 1.15;\n  /* 1 */\n  margin: 0;\n  /* 2 */ }\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\nbutton,\ninput {\n  /* 1 */\n  overflow: visible; }\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\nbutton,\nselect {\n  /* 1 */\n  text-transform: none; }\n\n/**\n * Correct the inability to style clickable types in iOS and Safari.\n */\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; }\n\n/**\n * Remove the inner border and padding in Firefox.\n */\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0; }\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText; }\n\n/**\n * Correct the padding in Firefox.\n */\nfieldset {\n  padding: 0.35em 0.75em 0.625em; }\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\nlegend {\n  box-sizing: border-box;\n  /* 1 */\n  color: inherit;\n  /* 2 */\n  display: table;\n  /* 1 */\n  max-width: 100%;\n  /* 1 */\n  padding: 0;\n  /* 3 */\n  white-space: normal;\n  /* 1 */ }\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\nprogress {\n  vertical-align: baseline; }\n\n/**\n * Remove the default vertical scrollbar in IE 10+.\n */\ntextarea {\n  overflow: auto; }\n\n/**\n * 1. Add the correct box sizing in IE 10.\n * 2. Remove the padding in IE 10.\n */\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box;\n  /* 1 */\n  padding: 0;\n  /* 2 */ }\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */ }\n\n/**\n * Remove the inner padding in Chrome and Safari on macOS.\n */\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */ }\n\n/* Interactive\n   ========================================================================== */\n/*\n * Add the correct display in Edge, IE 10+, and Firefox.\n */\ndetails {\n  display: block; }\n\n/*\n * Add the correct display in all browsers.\n */\nsummary {\n  display: list-item; }\n\n/* Misc\n   ========================================================================== */\n/**\n * Add the correct display in IE 10+.\n */\ntemplate {\n  display: none; }\n\n/**\n * Add the correct display in IE 10.\n */\n[hidden] {\n  display: none; }\n\n@font-face {\n  font-family: \"Icons16\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"../../resources/icons/icons-16.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../resources/icons/icons-16.woff\") format(\"woff\"), url(\"../../resources/icons/icons-16.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: \"Icons20\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"../../resources/icons/icons-20.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../resources/icons/icons-20.woff\") format(\"woff\"), url(\"../../resources/icons/icons-20.ttf\") format(\"truetype\"); }\nhtml {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box; }\n\n*,\n*::before,\n*::after {\n  -webkit-box-sizing: inherit;\n  box-sizing: inherit; }\n\nbody {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.28581;\n  text-transform: none;\n  color: #182026;\n  font-family: -apple-system, \"BlinkMacSystemFont\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Open Sans\", \"Helvetica Neue\", \"Icons16\", sans-serif; }\n\np {\n  margin-bottom: 10px;\n  margin-top: 0; }\n\nsmall {\n  font-size: 12px; }\n\nstrong {\n  font-weight: 600; }\n\n::-moz-selection {\n  background: rgba(125, 188, 255, 0.6); }\n\n::selection {\n  background: rgba(125, 188, 255, 0.6); }\n\n.ReportsFilter_bp3-heading__H7aWJ {\n  color: #182026;\n  font-weight: 600;\n  margin: 0 0 10px;\n  padding: 0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-heading__H7aWJ {\n  color: #f5f8fa; }\n\nh1.ReportsFilter_bp3-heading__H7aWJ, .ReportsFilter_bp3-running-text__1-CIx h1 {\n  font-size: 36px;\n  line-height: 40px; }\n\nh2.ReportsFilter_bp3-heading__H7aWJ, .ReportsFilter_bp3-running-text__1-CIx h2 {\n  font-size: 28px;\n  line-height: 32px; }\n\nh3.ReportsFilter_bp3-heading__H7aWJ, .ReportsFilter_bp3-running-text__1-CIx h3 {\n  font-size: 22px;\n  line-height: 25px; }\n\nh4.ReportsFilter_bp3-heading__H7aWJ, .ReportsFilter_bp3-running-text__1-CIx h4 {\n  font-size: 18px;\n  line-height: 21px; }\n\nh5.ReportsFilter_bp3-heading__H7aWJ, .ReportsFilter_bp3-running-text__1-CIx h5 {\n  font-size: 16px;\n  line-height: 19px; }\n\nh6.ReportsFilter_bp3-heading__H7aWJ, .ReportsFilter_bp3-running-text__1-CIx h6 {\n  font-size: 14px;\n  line-height: 16px; }\n\n.ReportsFilter_bp3-ui-text__32RUC {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.28581;\n  text-transform: none; }\n\n.ReportsFilter_bp3-monospace-text__1ko77 {\n  font-family: monospace;\n  text-transform: none; }\n\n.ReportsFilter_bp3-text-muted__1cP1z {\n  color: #5c7080; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-text-muted__1cP1z {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-text-disabled__3mRij {\n  color: rgba(92, 112, 128, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-text-disabled__3mRij {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-text-overflow-ellipsis__39CfD {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal; }\n\n.ReportsFilter_bp3-running-text__1-CIx {\n  font-size: 14px;\n  line-height: 1.5; }\n\n.ReportsFilter_bp3-running-text__1-CIx h1 {\n  color: #182026;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx h1 {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-running-text__1-CIx h2 {\n  color: #182026;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx h2 {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-running-text__1-CIx h3 {\n  color: #182026;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx h3 {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-running-text__1-CIx h4 {\n  color: #182026;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx h4 {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-running-text__1-CIx h5 {\n  color: #182026;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx h5 {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-running-text__1-CIx h6 {\n  color: #182026;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx h6 {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-running-text__1-CIx hr {\n  border: none;\n  border-bottom: 1px solid rgba(16, 22, 26, 0.15);\n  margin: 20px 0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx hr {\n  border-color: rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-running-text__1-CIx p {\n  margin: 0 0 10px;\n  padding: 0; }\n\n.ReportsFilter_bp3-text-large__120D9 {\n  font-size: 16px; }\n\n.ReportsFilter_bp3-text-small__1q-id {\n  font-size: 12px; }\n\na {\n  color: #106ba3;\n  text-decoration: none; }\n\na:hover {\n  color: #106ba3;\n  cursor: pointer;\n  text-decoration: underline; }\n\na .ReportsFilter_bp3-icon__15ATj, a .ReportsFilter_bp3-icon-standard__1vHca, a .ReportsFilter_bp3-icon-large__oZ-F2 {\n  color: inherit; }\n\na code,\n.ReportsFilter_bp3-dark__3R7GO a code {\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO a,\n.ReportsFilter_bp3-dark__3R7GO a:hover {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO a .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-dark__3R7GO a .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-dark__3R7GO a .ReportsFilter_bp3-icon-large__oZ-F2,\n.ReportsFilter_bp3-dark__3R7GO a:hover .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-dark__3R7GO a:hover .ReportsFilter_bp3-icon-standard__1vHca,\n.ReportsFilter_bp3-dark__3R7GO a:hover .ReportsFilter_bp3-icon-large__oZ-F2 {\n  color: inherit; }\n\n.ReportsFilter_bp3-running-text__1-CIx code, .ReportsFilter_bp3-code__3j229 {\n  font-family: monospace;\n  text-transform: none;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 3px;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2);\n  color: #5c7080;\n  font-size: smaller;\n  padding: 2px 5px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx code, .ReportsFilter_bp3-running-text__1-CIx .ReportsFilter_bp3-dark__3R7GO code, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-code__3j229 {\n  background: rgba(16, 22, 26, 0.3);\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4);\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-running-text__1-CIx a > code, a > .ReportsFilter_bp3-code__3j229 {\n  color: #137cbd; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx a > code, .ReportsFilter_bp3-running-text__1-CIx .ReportsFilter_bp3-dark__3R7GO a > code, .ReportsFilter_bp3-dark__3R7GO a > .ReportsFilter_bp3-code__3j229 {\n  color: inherit; }\n\n.ReportsFilter_bp3-running-text__1-CIx pre, .ReportsFilter_bp3-code-block__1xr-M {\n  font-family: monospace;\n  text-transform: none;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 3px;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.15);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.15);\n  color: #182026;\n  display: block;\n  font-size: 13px;\n  line-height: 1.4;\n  margin: 10px 0;\n  padding: 13px 15px 12px;\n  word-break: break-all;\n  word-wrap: break-word; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx pre, .ReportsFilter_bp3-running-text__1-CIx .ReportsFilter_bp3-dark__3R7GO pre, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-code-block__1xr-M {\n  background: rgba(16, 22, 26, 0.3);\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-running-text__1-CIx pre > code, .ReportsFilter_bp3-code-block__1xr-M > code {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: inherit;\n  font-size: inherit;\n  padding: 0; }\n\n.ReportsFilter_bp3-running-text__1-CIx kbd, .ReportsFilter_bp3-key__2owm4 {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background: #ffffff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);\n  color: #5c7080;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-family: inherit;\n  font-size: 12px;\n  height: 24px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  line-height: 24px;\n  min-width: 24px;\n  padding: 3px 6px;\n  vertical-align: middle; }\n\n.ReportsFilter_bp3-running-text__1-CIx kbd .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-key__2owm4 .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-running-text__1-CIx kbd .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-key__2owm4 .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-running-text__1-CIx kbd .ReportsFilter_bp3-icon-large__oZ-F2, .ReportsFilter_bp3-key__2owm4 .ReportsFilter_bp3-icon-large__oZ-F2 {\n  margin-right: 5px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx kbd, .ReportsFilter_bp3-running-text__1-CIx .ReportsFilter_bp3-dark__3R7GO kbd, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-key__2owm4 {\n  background: #394b59;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4);\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-running-text__1-CIx blockquote, .ReportsFilter_bp3-blockquote__2omtB {\n  border-left: solid 4px rgba(167, 182, 194, 0.5);\n  margin: 0 0 10px;\n  padding: 0 20px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx blockquote, .ReportsFilter_bp3-running-text__1-CIx .ReportsFilter_bp3-dark__3R7GO blockquote, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-blockquote__2omtB {\n  border-color: rgba(115, 134, 148, 0.5); }\n\n.ReportsFilter_bp3-running-text__1-CIx ul,\n.ReportsFilter_bp3-running-text__1-CIx ol, .ReportsFilter_bp3-list__L8riJ {\n  margin: 10px 0;\n  padding-left: 30px; }\n\n.ReportsFilter_bp3-running-text__1-CIx ul li:not(:last-child), .ReportsFilter_bp3-running-text__1-CIx ol li:not(:last-child), .ReportsFilter_bp3-list__L8riJ li:not(:last-child) {\n  margin-bottom: 5px; }\n\n.ReportsFilter_bp3-running-text__1-CIx ul ol, .ReportsFilter_bp3-running-text__1-CIx ol ol, .ReportsFilter_bp3-list__L8riJ ol,\n.ReportsFilter_bp3-running-text__1-CIx ul ul,\n.ReportsFilter_bp3-running-text__1-CIx ol ul,\n.ReportsFilter_bp3-list__L8riJ ul {\n  margin-top: 5px; }\n\n.ReportsFilter_bp3-list-unstyled__3fGDs {\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\n.ReportsFilter_bp3-list-unstyled__3fGDs li {\n  padding: 0; }\n\n.ReportsFilter_bp3-rtl__2FUMx {\n  text-align: right; }\n\n.ReportsFilter_bp3-dark__3R7GO {\n  color: #f5f8fa; }\n\n:focus {\n  outline: rgba(19, 124, 189, 0.6) auto 2px;\n  outline-offset: 2px;\n  -moz-outline-radius: 6px; }\n\n.ReportsFilter_bp3-focus-disabled__2QOzm :focus {\n  outline: none !important; }\n\n.ReportsFilter_bp3-focus-disabled__2QOzm :focus ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  outline: none !important; }\n\n.ReportsFilter_bp3-alert__3u6eO {\n  max-width: 400px;\n  padding: 20px; }\n\n.ReportsFilter_bp3-alert-body__3Lg5L {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.ReportsFilter_bp3-alert-body__3Lg5L .ReportsFilter_bp3-icon__15ATj {\n  font-size: 40px;\n  margin-right: 20px;\n  margin-top: 0; }\n\n.ReportsFilter_bp3-alert-contents__3QC_B {\n  word-break: break-word; }\n\n.ReportsFilter_bp3-alert-footer__1Z8pp {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n  margin-top: 10px; }\n\n.ReportsFilter_bp3-alert-footer__1Z8pp .ReportsFilter_bp3-button__15ViT {\n  margin-left: 10px; }\n\n.ReportsFilter_bp3-breadcrumbs__U7mE3 {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  cursor: default;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  height: 30px;\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\n.ReportsFilter_bp3-breadcrumbs__U7mE3 > li {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.ReportsFilter_bp3-breadcrumbs__U7mE3 > li::after {\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.71 7.29l-4-4a1.003 1.003 0 00-1.42 1.42L8.59 8 5.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z' fill='%235C7080'/%3e%3c/svg%3e\");\n  content: \"\";\n  display: block;\n  height: 16px;\n  margin: 0 5px;\n  width: 16px; }\n\n.ReportsFilter_bp3-breadcrumbs__U7mE3 > li:last-of-type::after {\n  display: none; }\n\n.ReportsFilter_bp3-breadcrumb__39MM3,\n.ReportsFilter_bp3-breadcrumb-current__NHvpn,\n.ReportsFilter_bp3-breadcrumbs-collapsed__flj6T {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-size: 16px; }\n\n.ReportsFilter_bp3-breadcrumb__39MM3,\n.ReportsFilter_bp3-breadcrumbs-collapsed__flj6T {\n  color: #5c7080; }\n\n.ReportsFilter_bp3-breadcrumb__39MM3:hover {\n  text-decoration: none; }\n\n.ReportsFilter_bp3-breadcrumb__39MM3.ReportsFilter_bp3-disabled__1YzwV {\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-breadcrumb__39MM3 .ReportsFilter_bp3-icon__15ATj {\n  margin-right: 5px; }\n\n.ReportsFilter_bp3-breadcrumb-current__NHvpn {\n  color: inherit;\n  font-weight: 600; }\n\n.ReportsFilter_bp3-breadcrumb-current__NHvpn .ReportsFilter_bp3-input__2T1HJ {\n  font-size: inherit;\n  font-weight: inherit;\n  vertical-align: baseline; }\n\n.ReportsFilter_bp3-breadcrumbs-collapsed__flj6T {\n  background: #ced9e0;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  margin-right: 2px;\n  padding: 1px 5px;\n  vertical-align: text-bottom; }\n\n.ReportsFilter_bp3-breadcrumbs-collapsed__flj6T::before {\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cg fill='%235C7080'%3e%3ccircle cx='2' cy='8.03' r='2'/%3e%3ccircle cx='14' cy='8.03' r='2'/%3e%3ccircle cx='8' cy='8.03' r='2'/%3e%3c/g%3e%3c/svg%3e\") center no-repeat;\n  content: \"\";\n  display: block;\n  height: 16px;\n  width: 16px; }\n\n.ReportsFilter_bp3-breadcrumbs-collapsed__flj6T:hover {\n  background: #bfccd6;\n  color: #182026;\n  text-decoration: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-breadcrumb__39MM3,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-breadcrumbs-collapsed__flj6T {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-breadcrumbs__U7mE3 > li::after {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-breadcrumb__39MM3.ReportsFilter_bp3-disabled__1YzwV {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-breadcrumb-current__NHvpn {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-breadcrumbs-collapsed__flj6T {\n  background: rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-breadcrumbs-collapsed__flj6T:hover {\n  background: rgba(16, 22, 26, 0.6);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-button__15ViT {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 14px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: 5px 10px;\n  text-align: left;\n  vertical-align: middle;\n  min-height: 30px;\n  min-width: 30px; }\n\n.ReportsFilter_bp3-button__15ViT > * {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0; }\n\n.ReportsFilter_bp3-button__15ViT > .ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1; }\n\n.ReportsFilter_bp3-button__15ViT::before,\n.ReportsFilter_bp3-button__15ViT > * {\n  margin-right: 7px; }\n\n.ReportsFilter_bp3-button__15ViT:empty::before,\n.ReportsFilter_bp3-button__15ViT > :last-child {\n  margin-right: 0; }\n\n.ReportsFilter_bp3-button__15ViT:empty {\n  padding: 0 !important; }\n\n.ReportsFilter_bp3-button__15ViT:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV {\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-fill__3iORs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-align-right__1vvtP,\n.ReportsFilter_bp3-align-right__1vvtP .ReportsFilter_bp3-button__15ViT {\n  text-align: right; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-align-left__3an4r,\n.ReportsFilter_bp3-align-left__3an4r .ReportsFilter_bp3-button__15ViT {\n  text-align: left; }\n\n.ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]) {\n  background-color: #f5f8fa;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.8)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  color: #182026; }\n\n.ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):hover {\n  background-clip: padding-box;\n  background-color: #ebf1f5;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1); }\n\n.ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):active, .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-active__1Mw-V {\n  background-color: #d8e1e8;\n  background-image: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):disabled, .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(206, 217, 224, 0.5);\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed;\n  outline: none; }\n\n.ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):disabled.ReportsFilter_bp3-active__1Mw-V:hover, .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V:hover {\n  background: rgba(206, 217, 224, 0.7); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0 {\n  background-color: #137cbd;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.1)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  color: #ffffff; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:hover {\n  background-color: #106ba3;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #0e5a8a;\n  background-image: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(19, 124, 189, 0.5);\n  background-image: none;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z {\n  background-color: #0f9960;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.1)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  color: #ffffff; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:hover {\n  background-color: #0d8050;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #0a6640;\n  background-image: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(15, 153, 96, 0.5);\n  background-image: none;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs {\n  background-color: #d9822b;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.1)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  color: #ffffff; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:hover {\n  background-color: #bf7326;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #a66321;\n  background-image: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(217, 130, 43, 0.5);\n  background-image: none;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj {\n  background-color: #db3737;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.1)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  color: #ffffff; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:hover {\n  background-color: #c23030;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #a82a2a;\n  background-image: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(219, 55, 55, 0.5);\n  background-image: none;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6); }\n\n.ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"] .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #ffffff; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-large__17hsQ,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-button__15ViT {\n  min-height: 40px;\n  min-width: 40px;\n  font-size: 16px;\n  padding: 5px 15px; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-large__17hsQ::before,\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-large__17hsQ > *,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-button__15ViT::before,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-button__15ViT > * {\n  margin-right: 10px; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-large__17hsQ:empty::before,\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-large__17hsQ > :last-child,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-button__15ViT:empty::before,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-button__15ViT > :last-child {\n  margin-right: 0; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-small__2yDvz,\n.ReportsFilter_bp3-small__2yDvz .ReportsFilter_bp3-button__15ViT {\n  min-height: 24px;\n  min-width: 24px;\n  padding: 0 7px; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-loading__3XI1m {\n  position: relative; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-loading__3XI1m[class*=\"bp3-icon-\"]::before {\n  visibility: hidden; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-loading__3XI1m .ReportsFilter_bp3-button-spinner__2ZL-c {\n  margin: 0;\n  position: absolute; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-loading__3XI1m > :not(.ReportsFilter_bp3-button-spinner__2ZL-c) {\n  visibility: hidden; }\n\n.ReportsFilter_bp3-button__15ViT[class*=\"bp3-icon-\"]::before {\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  color: #5c7080; }\n\n.ReportsFilter_bp3-button__15ViT .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-button__15ViT .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-button__15ViT .ReportsFilter_bp3-icon-large__oZ-F2 {\n  color: #5c7080; }\n\n.ReportsFilter_bp3-button__15ViT .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-align-right__1vvtP, .ReportsFilter_bp3-button__15ViT .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-align-right__1vvtP, .ReportsFilter_bp3-button__15ViT .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-align-right__1vvtP {\n  margin-left: 7px; }\n\n.ReportsFilter_bp3-button__15ViT .ReportsFilter_bp3-icon__15ATj:first-child:last-child,\n.ReportsFilter_bp3-button__15ViT .ReportsFilter_bp3-spinner__1DHED + .ReportsFilter_bp3-icon__15ATj:last-child {\n  margin: 0 -7px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]) {\n  background-color: #394b59;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.05)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-active__1Mw-V {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):hover {\n  background-color: #30404d;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-active__1Mw-V {\n  background-color: #202b33;\n  background-image: none;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(57, 75, 89, 0.5);\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]):disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(57, 75, 89, 0.7); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]) .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  background: rgba(16, 22, 26, 0.5);\n  stroke: #8a9ba8; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"])[class*=\"bp3-icon-\"]::before {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]) .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]) .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT:not([class*=\"bp3-intent-\"]) .ReportsFilter_bp3-icon-large__oZ-F2 {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"] {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"]:hover {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"]:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"].ReportsFilter_bp3-active__1Mw-V {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"]:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"].ReportsFilter_bp3-disabled__1YzwV {\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.3); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"] .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #8a9ba8; }\n\n.ReportsFilter_bp3-button__15ViT:disabled::before,\n.ReportsFilter_bp3-button__15ViT:disabled .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-button__15ViT:disabled .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-button__15ViT:disabled .ReportsFilter_bp3-icon-large__oZ-F2, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV::before,\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-icon-large__oZ-F2, .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"]::before,\n.ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"] .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"] .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"] .ReportsFilter_bp3-icon-large__oZ-F2 {\n  color: inherit !important; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9 {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:hover {\n  background: rgba(167, 182, 194, 0.3);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #182026;\n  text-decoration: none; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(115, 134, 148, 0.3);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #182026; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-disabled__1YzwV:hover {\n  background: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(115, 134, 148, 0.3); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9 {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:hover {\n  background: rgba(138, 155, 168, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(138, 155, 168, 0.3);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-disabled__1YzwV:hover {\n  background: none;\n  color: rgba(167, 182, 194, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(138, 155, 168, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0:hover {\n  background: rgba(19, 124, 189, 0.15);\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3);\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(16, 107, 163, 0.5); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #106ba3; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0:hover {\n  background: rgba(19, 124, 189, 0.2);\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3);\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(72, 175, 240, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z:hover {\n  background: rgba(15, 153, 96, 0.15);\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3);\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(13, 128, 80, 0.5); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #0d8050; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z:hover {\n  background: rgba(15, 153, 96, 0.2);\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3);\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(61, 204, 145, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs {\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs:hover {\n  background: rgba(217, 130, 43, 0.15);\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3);\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(191, 115, 38, 0.5); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #bf7326; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs:hover {\n  background: rgba(217, 130, 43, 0.2);\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3);\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(255, 179, 102, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #c23030; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #c23030; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj:hover {\n  background: rgba(219, 55, 55, 0.15);\n  color: #c23030; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3);\n  color: #c23030; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(194, 48, 48, 0.5); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #c23030; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj:hover {\n  background: rgba(219, 55, 55, 0.2);\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3);\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(255, 115, 115, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8 {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border: 1px solid rgba(24, 32, 38, 0.2);\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:hover {\n  background: rgba(167, 182, 194, 0.3);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #182026;\n  text-decoration: none; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(115, 134, 148, 0.3);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #182026; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV:hover {\n  background: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(115, 134, 148, 0.3); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8 {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:hover {\n  background: rgba(138, 155, 168, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(138, 155, 168, 0.3);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV:hover {\n  background: none;\n  color: rgba(167, 182, 194, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(138, 155, 168, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:hover {\n  background: rgba(19, 124, 189, 0.15);\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3);\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(16, 107, 163, 0.5); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #106ba3; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:hover {\n  background: rgba(19, 124, 189, 0.2);\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3);\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(72, 175, 240, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:hover {\n  background: rgba(15, 153, 96, 0.15);\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3);\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(13, 128, 80, 0.5); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #0d8050; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:hover {\n  background: rgba(15, 153, 96, 0.2);\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3);\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(61, 204, 145, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs {\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:hover {\n  background: rgba(217, 130, 43, 0.15);\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3);\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(191, 115, 38, 0.5); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #bf7326; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:hover {\n  background: rgba(217, 130, 43, 0.2);\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3);\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(255, 179, 102, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #c23030; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #c23030; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:hover {\n  background: rgba(219, 55, 55, 0.15);\n  color: #c23030; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3);\n  color: #c23030; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(194, 48, 48, 0.5); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #c23030; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:hover {\n  background: rgba(219, 55, 55, 0.2);\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3);\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(255, 115, 115, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled:hover, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV:hover {\n  border-color: rgba(92, 112, 128, 0.1); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8 {\n  border-color: rgba(255, 255, 255, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8:disabled:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-disabled__1YzwV:hover {\n  border-color: rgba(255, 255, 255, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0 {\n  border-color: rgba(16, 107, 163, 0.6); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  border-color: rgba(16, 107, 163, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0 {\n  border-color: rgba(72, 175, 240, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  border-color: rgba(72, 175, 240, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z {\n  border-color: rgba(13, 128, 80, 0.6); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  border-color: rgba(13, 128, 80, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z {\n  border-color: rgba(61, 204, 145, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  border-color: rgba(61, 204, 145, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs {\n  border-color: rgba(191, 115, 38, 0.6); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  border-color: rgba(191, 115, 38, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs {\n  border-color: rgba(255, 179, 102, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  border-color: rgba(255, 179, 102, 0.2); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj {\n  border-color: rgba(194, 48, 48, 0.6); }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  border-color: rgba(194, 48, 48, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj {\n  border-color: rgba(255, 115, 115, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-outlined__19MR8.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  border-color: rgba(255, 115, 115, 0.2); }\n\na.ReportsFilter_bp3-button__15ViT {\n  text-align: center;\n  text-decoration: none;\n  -webkit-transition: none;\n  transition: none; }\n\na.ReportsFilter_bp3-button__15ViT, a.ReportsFilter_bp3-button__15ViT:hover, a.ReportsFilter_bp3-button__15ViT:active {\n  color: #182026; }\n\na.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV {\n  color: rgba(92, 112, 128, 0.6); }\n\n.ReportsFilter_bp3-button-text__2RWg2 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-align-left__3an4r .ReportsFilter_bp3-button-text__2RWg2, .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-align-right__1vvtP .ReportsFilter_bp3-button-text__2RWg2,\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-align-left__3an4r .ReportsFilter_bp3-button-text__2RWg2,\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-align-right__1vvtP .ReportsFilter_bp3-button-text__2RWg2 {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto; }\n\n.ReportsFilter_bp3-button-group__OVeCS {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  position: relative;\n  z-index: 4; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT:focus {\n  z-index: 5; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT:hover {\n  z-index: 6; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT:active, .ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-active__1Mw-V {\n  z-index: 7; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT:disabled, .ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV {\n  z-index: 3; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"] {\n  z-index: 9; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"]:focus {\n  z-index: 10; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"]:hover {\n  z-index: 11; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"]:active, .ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"].ReportsFilter_bp3-active__1Mw-V {\n  z-index: 12; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"]:disabled, .ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent-\"].ReportsFilter_bp3-disabled__1YzwV {\n  z-index: 8; }\n\n.ReportsFilter_bp3-button-group__OVeCS:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-popover-wrapper__1aeCY:not(:first-child) .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-button-group__OVeCS:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-button__15ViT:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0; }\n\n.ReportsFilter_bp3-button-group__OVeCS:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-popover-wrapper__1aeCY:not(:last-child) .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-button-group__OVeCS:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-button__15ViT:not(:last-child) {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  margin-right: -1px; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:hover {\n  background: rgba(167, 182, 194, 0.3);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #182026;\n  text-decoration: none; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:active, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(115, 134, 148, 0.3);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #182026; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:disabled, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:disabled:hover, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV:hover {\n  background: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:disabled:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(115, 134, 148, 0.3); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:hover {\n  background: rgba(138, 155, 168, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(138, 155, 168, 0.3);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:disabled:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV:hover {\n  background: none;\n  color: rgba(167, 182, 194, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT:disabled:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(138, 155, 168, 0.3); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:hover {\n  background: rgba(19, 124, 189, 0.15);\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3);\n  color: #106ba3; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(16, 107, 163, 0.5); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #106ba3; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:hover {\n  background: rgba(19, 124, 189, 0.2);\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3);\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(72, 175, 240, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:hover {\n  background: rgba(15, 153, 96, 0.15);\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3);\n  color: #0d8050; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(13, 128, 80, 0.5); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #0d8050; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:hover {\n  background: rgba(15, 153, 96, 0.2);\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3);\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(61, 204, 145, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs {\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:hover {\n  background: rgba(217, 130, 43, 0.15);\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3);\n  color: #bf7326; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(191, 115, 38, 0.5); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #bf7326; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:hover {\n  background: rgba(217, 130, 43, 0.2);\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3);\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(255, 179, 102, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #c23030; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #c23030; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:hover {\n  background: rgba(219, 55, 55, 0.15);\n  color: #c23030; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3);\n  color: #c23030; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(194, 48, 48, 0.5); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3); }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #c23030; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:hover {\n  background: rgba(219, 55, 55, 0.2);\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3);\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(255, 115, 115, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3); }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-popover-wrapper__1aeCY,\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-popover-target__2jiug {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-fill__3iORs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%; }\n\n.ReportsFilter_bp3-button-group__OVeCS .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-fill__3iORs,\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-fill__3iORs .ReportsFilter_bp3-button__15ViT:not(.ReportsFilter_bp3-fixed__2PPz2) {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2 {\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  vertical-align: top; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2.ReportsFilter_bp3-fill__3iORs {\n  height: 100%;\n  width: unset; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-button__15ViT {\n  margin-right: 0 !important;\n  width: 100%; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-popover-wrapper__1aeCY:first-child .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-button__15ViT:first-child {\n  border-radius: 3px 3px 0 0; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-popover-wrapper__1aeCY:last-child .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-button__15ViT:last-child {\n  border-radius: 0 0 3px 3px; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-popover-wrapper__1aeCY:not(:last-child) .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-button__15ViT:not(:last-child) {\n  margin-bottom: -1px; }\n\n.ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-align-left__3an4r .ReportsFilter_bp3-button__15ViT {\n  text-align: left; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-popover-wrapper__1aeCY:not(:last-child) .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS:not(.ReportsFilter_bp3-minimal__V1Rn9) > .ReportsFilter_bp3-button__15ViT:not(:last-child) {\n  margin-right: 1px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-popover-wrapper__1aeCY:not(:last-child) .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-button__15ViT:not(:last-child) {\n  margin-bottom: 1px; }\n\n.ReportsFilter_bp3-callout__19fx9 {\n  font-size: 14px;\n  line-height: 1.5;\n  background-color: rgba(138, 155, 168, 0.15);\n  border-radius: 3px;\n  padding: 10px 12px 9px;\n  position: relative;\n  width: 100%; }\n\n.ReportsFilter_bp3-callout__19fx9[class*=\"bp3-icon-\"] {\n  padding-left: 40px; }\n\n.ReportsFilter_bp3-callout__19fx9[class*=\"bp3-icon-\"]::before {\n  font-family: \"Icons20\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  color: #5c7080;\n  left: 10px;\n  position: absolute;\n  top: 10px; }\n\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-callout-icon__34lcl {\n  padding-left: 40px; }\n\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-callout-icon__34lcl > .ReportsFilter_bp3-icon__15ATj:first-child {\n  color: #5c7080;\n  left: 10px;\n  position: absolute;\n  top: 10px; }\n\n.ReportsFilter_bp3-callout__19fx9 .ReportsFilter_bp3-heading__H7aWJ {\n  line-height: 20px;\n  margin-bottom: 5px;\n  margin-top: 0; }\n\n.ReportsFilter_bp3-callout__19fx9 .ReportsFilter_bp3-heading__H7aWJ:last-child {\n  margin-bottom: 0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9 {\n  background-color: rgba(138, 155, 168, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9[class*=\"bp3-icon-\"]::before {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-primary__OlAS0 {\n  background-color: rgba(19, 124, 189, 0.15); }\n\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-primary__OlAS0[class*=\"bp3-icon-\"]::before,\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-primary__OlAS0 > .ReportsFilter_bp3-icon__15ATj:first-child,\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-heading__H7aWJ {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-primary__OlAS0 {\n  background-color: rgba(19, 124, 189, 0.25); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-primary__OlAS0[class*=\"bp3-icon-\"]::before,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-primary__OlAS0 > .ReportsFilter_bp3-icon__15ATj:first-child,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-heading__H7aWJ {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-success__3_w9z {\n  background-color: rgba(15, 153, 96, 0.15); }\n\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-success__3_w9z[class*=\"bp3-icon-\"]::before,\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-success__3_w9z > .ReportsFilter_bp3-icon__15ATj:first-child,\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-heading__H7aWJ {\n  color: #0d8050; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-success__3_w9z {\n  background-color: rgba(15, 153, 96, 0.25); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-success__3_w9z[class*=\"bp3-icon-\"]::before,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-success__3_w9z > .ReportsFilter_bp3-icon__15ATj:first-child,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-heading__H7aWJ {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-warning__372vs {\n  background-color: rgba(217, 130, 43, 0.15); }\n\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-warning__372vs[class*=\"bp3-icon-\"]::before,\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-warning__372vs > .ReportsFilter_bp3-icon__15ATj:first-child,\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-heading__H7aWJ {\n  color: #bf7326; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-warning__372vs {\n  background-color: rgba(217, 130, 43, 0.25); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-warning__372vs[class*=\"bp3-icon-\"]::before,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-warning__372vs > .ReportsFilter_bp3-icon__15ATj:first-child,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-heading__H7aWJ {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-danger__GyPAj {\n  background-color: rgba(219, 55, 55, 0.15); }\n\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-danger__GyPAj[class*=\"bp3-icon-\"]::before,\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-danger__GyPAj > .ReportsFilter_bp3-icon__15ATj:first-child,\n.ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-heading__H7aWJ {\n  color: #c23030; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-danger__GyPAj {\n  background-color: rgba(219, 55, 55, 0.25); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-danger__GyPAj[class*=\"bp3-icon-\"]::before,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-danger__GyPAj > .ReportsFilter_bp3-icon__15ATj:first-child,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-callout__19fx9.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-heading__H7aWJ {\n  color: #ff7373; }\n\n.ReportsFilter_bp3-running-text__1-CIx .ReportsFilter_bp3-callout__19fx9 {\n  margin: 20px 0; }\n\n.ReportsFilter_bp3-card__3xfII {\n  background-color: #ffffff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.15), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.15), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0);\n  padding: 20px;\n  -webkit-transition: -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-card__3xfII.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-card__3xfII {\n  background-color: #30404d;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0); }\n\n.ReportsFilter_bp3-elevation-0__1uUZ4 {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.15), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.15), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0); }\n\n.ReportsFilter_bp3-elevation-0__1uUZ4.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-elevation-0__1uUZ4 {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0); }\n\n.ReportsFilter_bp3-elevation-1__2y-6R {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-elevation-1__2y-6R.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-elevation-1__2y-6R {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-elevation-2__3G5fl {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 1px 1px rgba(16, 22, 26, 0.2), 0 2px 6px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 1px 1px rgba(16, 22, 26, 0.2), 0 2px 6px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-elevation-2__3G5fl.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-elevation-2__3G5fl {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.4), 0 2px 6px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.4), 0 2px 6px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-elevation-3__2wYZy {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-elevation-3__2wYZy.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-elevation-3__2wYZy {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-elevation-4__2Jma9 {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 4px 8px rgba(16, 22, 26, 0.2), 0 18px 46px 6px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 4px 8px rgba(16, 22, 26, 0.2), 0 18px 46px 6px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-elevation-4__2Jma9.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-elevation-4__2Jma9 {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 4px 8px rgba(16, 22, 26, 0.4), 0 18px 46px 6px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 4px 8px rgba(16, 22, 26, 0.4), 0 18px 46px 6px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-card__3xfII.ReportsFilter_bp3-interactive__3MyBv:hover {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  cursor: pointer; }\n\n.ReportsFilter_bp3-card__3xfII.ReportsFilter_bp3-interactive__3MyBv:hover.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-card__3xfII.ReportsFilter_bp3-interactive__3MyBv:hover {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-card__3xfII.ReportsFilter_bp3-interactive__3MyBv:active {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);\n  opacity: 0.9;\n  -webkit-transition-duration: 0;\n  transition-duration: 0; }\n\n.ReportsFilter_bp3-card__3xfII.ReportsFilter_bp3-interactive__3MyBv:active.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-card__3xfII.ReportsFilter_bp3-interactive__3MyBv:active {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-collapse__3-2-X {\n  height: 0;\n  overflow-y: hidden;\n  -webkit-transition: height 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: height 200ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-collapse__3-2-X .ReportsFilter_bp3-collapse-body__jBmyk {\n  -webkit-transition: -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-collapse__3-2-X .ReportsFilter_bp3-collapse-body__jBmyk[aria-hidden=\"true\"] {\n  display: none; }\n\n.ReportsFilter_bp3-context-menu__XjVqC .ReportsFilter_bp3-popover-target__2jiug {\n  display: block; }\n\n.ReportsFilter_bp3-context-menu-popover-target__2Qn6W {\n  position: fixed; }\n\n.ReportsFilter_bp3-divider__Uugww {\n  border-bottom: 1px solid rgba(16, 22, 26, 0.15);\n  border-right: 1px solid rgba(16, 22, 26, 0.15);\n  margin: 5px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-divider__Uugww {\n  border-color: rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dialog-container__1p7la {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  min-height: 100%;\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 100%; }\n\n.ReportsFilter_bp3-dialog-container__1p7la.ReportsFilter_bp3-overlay-enter__1l8Ue > .ReportsFilter_bp3-dialog__2dk7M, .ReportsFilter_bp3-dialog-container__1p7la.ReportsFilter_bp3-overlay-appear__Kp1wI > .ReportsFilter_bp3-dialog__2dk7M {\n  opacity: 0;\n  -webkit-transform: scale(0.5);\n  transform: scale(0.5); }\n\n.ReportsFilter_bp3-dialog-container__1p7la.ReportsFilter_bp3-overlay-enter-active__3x69Z > .ReportsFilter_bp3-dialog__2dk7M, .ReportsFilter_bp3-dialog-container__1p7la.ReportsFilter_bp3-overlay-appear-active__3364s > .ReportsFilter_bp3-dialog__2dk7M {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 300ms;\n  transition-duration: 300ms;\n  -webkit-transition-property: opacity, -webkit-transform;\n  transition-property: opacity, -webkit-transform;\n  transition-property: opacity, transform;\n  transition-property: opacity, transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11); }\n\n.ReportsFilter_bp3-dialog-container__1p7la.ReportsFilter_bp3-overlay-exit__17aZI > .ReportsFilter_bp3-dialog__2dk7M {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1); }\n\n.ReportsFilter_bp3-dialog-container__1p7la.ReportsFilter_bp3-overlay-exit-active__1pKHO > .ReportsFilter_bp3-dialog__2dk7M {\n  opacity: 0;\n  -webkit-transform: scale(0.5);\n  transform: scale(0.5);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 300ms;\n  transition-duration: 300ms;\n  -webkit-transition-property: opacity, -webkit-transform;\n  transition-property: opacity, -webkit-transform;\n  transition-property: opacity, transform;\n  transition-property: opacity, transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11); }\n\n.ReportsFilter_bp3-dialog__2dk7M {\n  background: #ebf1f5;\n  border-radius: 6px;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 4px 8px rgba(16, 22, 26, 0.2), 0 18px 46px 6px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 4px 8px rgba(16, 22, 26, 0.2), 0 18px 46px 6px rgba(16, 22, 26, 0.2);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin: 30px 0;\n  padding-bottom: 20px;\n  pointer-events: all;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n  width: 500px; }\n\n.ReportsFilter_bp3-dialog__2dk7M:focus {\n  outline: 0; }\n\n.ReportsFilter_bp3-dialog__2dk7M.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-dialog__2dk7M {\n  background: #293742;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 4px 8px rgba(16, 22, 26, 0.4), 0 18px 46px 6px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 4px 8px rgba(16, 22, 26, 0.4), 0 18px 46px 6px rgba(16, 22, 26, 0.4);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dialog-header__4_XWg {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background: #ffffff;\n  border-radius: 6px 6px 0 0;\n  -webkit-box-shadow: 0 1px 0 rgba(16, 22, 26, 0.15);\n  box-shadow: 0 1px 0 rgba(16, 22, 26, 0.15);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  min-height: 40px;\n  padding-left: 20px;\n  padding-right: 5px; }\n\n.ReportsFilter_bp3-dialog-header__4_XWg .ReportsFilter_bp3-icon-large__oZ-F2,\n.ReportsFilter_bp3-dialog-header__4_XWg .ReportsFilter_bp3-icon__15ATj {\n  color: #5c7080;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  margin-right: 10px; }\n\n.ReportsFilter_bp3-dialog-header__4_XWg .ReportsFilter_bp3-heading__H7aWJ {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  line-height: inherit;\n  margin: 0; }\n\n.ReportsFilter_bp3-dialog-header__4_XWg .ReportsFilter_bp3-heading__H7aWJ:last-child {\n  margin-right: 20px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-dialog-header__4_XWg {\n  background: #30404d;\n  -webkit-box-shadow: 0 1px 0 rgba(16, 22, 26, 0.4);\n  box-shadow: 0 1px 0 rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-dialog-header__4_XWg .ReportsFilter_bp3-icon-large__oZ-F2,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-dialog-header__4_XWg .ReportsFilter_bp3-icon__15ATj {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dialog-body__1i105 {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  line-height: 18px;\n  margin: 20px; }\n\n.ReportsFilter_bp3-dialog-footer__18h3w {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  margin: 0 20px; }\n\n.ReportsFilter_bp3-dialog-footer-actions__2_t2t {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end; }\n\n.ReportsFilter_bp3-dialog-footer-actions__2_t2t .ReportsFilter_bp3-button__15ViT {\n  margin-left: 10px; }\n\n.ReportsFilter_bp3-drawer__1fSuQ {\n  background: #ffffff;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 4px 8px rgba(16, 22, 26, 0.2), 0 18px 46px 6px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 4px 8px rgba(16, 22, 26, 0.2), 0 18px 46px 6px rgba(16, 22, 26, 0.2);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin: 0;\n  padding: 0; }\n\n.ReportsFilter_bp3-drawer__1fSuQ:focus {\n  outline: 0; }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-top__XEO9P {\n  height: 50%;\n  left: 0;\n  right: 0;\n  top: 0; }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-top__XEO9P.ReportsFilter_bp3-overlay-enter__1l8Ue, .ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-top__XEO9P.ReportsFilter_bp3-overlay-appear__Kp1wI {\n  -webkit-transform: translateY(-100%);\n  transform: translateY(-100%); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-top__XEO9P.ReportsFilter_bp3-overlay-enter-active__3x69Z, .ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-top__XEO9P.ReportsFilter_bp3-overlay-appear-active__3364s {\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 200ms;\n  transition-duration: 200ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-top__XEO9P.ReportsFilter_bp3-overlay-exit__17aZI {\n  -webkit-transform: translateY(0);\n  transform: translateY(0); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-top__XEO9P.ReportsFilter_bp3-overlay-exit-active__1pKHO {\n  -webkit-transform: translateY(-100%);\n  transform: translateY(-100%);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-bottom__1L_KQ {\n  bottom: 0;\n  height: 50%;\n  left: 0;\n  right: 0; }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-bottom__1L_KQ.ReportsFilter_bp3-overlay-enter__1l8Ue, .ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-bottom__1L_KQ.ReportsFilter_bp3-overlay-appear__Kp1wI {\n  -webkit-transform: translateY(100%);\n  transform: translateY(100%); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-bottom__1L_KQ.ReportsFilter_bp3-overlay-enter-active__3x69Z, .ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-bottom__1L_KQ.ReportsFilter_bp3-overlay-appear-active__3364s {\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 200ms;\n  transition-duration: 200ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-bottom__1L_KQ.ReportsFilter_bp3-overlay-exit__17aZI {\n  -webkit-transform: translateY(0);\n  transform: translateY(0); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-bottom__1L_KQ.ReportsFilter_bp3-overlay-exit-active__1pKHO {\n  -webkit-transform: translateY(100%);\n  transform: translateY(100%);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-left__fhVPt {\n  bottom: 0;\n  left: 0;\n  top: 0;\n  width: 50%; }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-left__fhVPt.ReportsFilter_bp3-overlay-enter__1l8Ue, .ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-left__fhVPt.ReportsFilter_bp3-overlay-appear__Kp1wI {\n  -webkit-transform: translateX(-100%);\n  transform: translateX(-100%); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-left__fhVPt.ReportsFilter_bp3-overlay-enter-active__3x69Z, .ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-left__fhVPt.ReportsFilter_bp3-overlay-appear-active__3364s {\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 200ms;\n  transition-duration: 200ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-left__fhVPt.ReportsFilter_bp3-overlay-exit__17aZI {\n  -webkit-transform: translateX(0);\n  transform: translateX(0); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-left__fhVPt.ReportsFilter_bp3-overlay-exit-active__1pKHO {\n  -webkit-transform: translateX(-100%);\n  transform: translateX(-100%);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-right__ZcZWO {\n  bottom: 0;\n  right: 0;\n  top: 0;\n  width: 50%; }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-right__ZcZWO.ReportsFilter_bp3-overlay-enter__1l8Ue, .ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-right__ZcZWO.ReportsFilter_bp3-overlay-appear__Kp1wI {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-right__ZcZWO.ReportsFilter_bp3-overlay-enter-active__3x69Z, .ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-right__ZcZWO.ReportsFilter_bp3-overlay-appear-active__3364s {\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 200ms;\n  transition-duration: 200ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-right__ZcZWO.ReportsFilter_bp3-overlay-exit__17aZI {\n  -webkit-transform: translateX(0);\n  transform: translateX(0); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-position-right__ZcZWO.ReportsFilter_bp3-overlay-exit-active__1pKHO {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO):not(.ReportsFilter_bp3-vertical__22D_2) {\n  bottom: 0;\n  right: 0;\n  top: 0;\n  width: 50%; }\n\n.ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO):not(.ReportsFilter_bp3-vertical__22D_2).ReportsFilter_bp3-overlay-enter__1l8Ue, .ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO):not(.ReportsFilter_bp3-vertical__22D_2).ReportsFilter_bp3-overlay-appear__Kp1wI {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%); }\n\n.ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO):not(.ReportsFilter_bp3-vertical__22D_2).ReportsFilter_bp3-overlay-enter-active__3x69Z, .ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO):not(.ReportsFilter_bp3-vertical__22D_2).ReportsFilter_bp3-overlay-appear-active__3364s {\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 200ms;\n  transition-duration: 200ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO):not(.ReportsFilter_bp3-vertical__22D_2).ReportsFilter_bp3-overlay-exit__17aZI {\n  -webkit-transform: translateX(0);\n  transform: translateX(0); }\n\n.ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO):not(.ReportsFilter_bp3-vertical__22D_2).ReportsFilter_bp3-overlay-exit-active__1pKHO {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO).ReportsFilter_bp3-vertical__22D_2 {\n  bottom: 0;\n  height: 50%;\n  left: 0;\n  right: 0; }\n\n.ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO).ReportsFilter_bp3-vertical__22D_2.ReportsFilter_bp3-overlay-enter__1l8Ue, .ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO).ReportsFilter_bp3-vertical__22D_2.ReportsFilter_bp3-overlay-appear__Kp1wI {\n  -webkit-transform: translateY(100%);\n  transform: translateY(100%); }\n\n.ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO).ReportsFilter_bp3-vertical__22D_2.ReportsFilter_bp3-overlay-enter-active__3x69Z, .ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO).ReportsFilter_bp3-vertical__22D_2.ReportsFilter_bp3-overlay-appear-active__3364s {\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 200ms;\n  transition-duration: 200ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO).ReportsFilter_bp3-vertical__22D_2.ReportsFilter_bp3-overlay-exit__17aZI {\n  -webkit-transform: translateY(0);\n  transform: translateY(0); }\n\n.ReportsFilter_bp3-drawer__1fSuQ:not(.ReportsFilter_bp3-position-top__XEO9P):not(.ReportsFilter_bp3-position-bottom__1L_KQ):not(.ReportsFilter_bp3-position-left__fhVPt):not(\n.ReportsFilter_bp3-position-right__ZcZWO).ReportsFilter_bp3-vertical__22D_2.ReportsFilter_bp3-overlay-exit-active__1pKHO {\n  -webkit-transform: translateY(100%);\n  transform: translateY(100%);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-drawer__1fSuQ.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-drawer__1fSuQ {\n  background: #30404d;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 4px 8px rgba(16, 22, 26, 0.4), 0 18px 46px 6px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 4px 8px rgba(16, 22, 26, 0.4), 0 18px 46px 6px rgba(16, 22, 26, 0.4);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-drawer-header__3bGRk {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 0;\n  -webkit-box-shadow: 0 1px 0 rgba(16, 22, 26, 0.15);\n  box-shadow: 0 1px 0 rgba(16, 22, 26, 0.15);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  min-height: 40px;\n  padding: 5px;\n  padding-left: 20px;\n  position: relative; }\n\n.ReportsFilter_bp3-drawer-header__3bGRk .ReportsFilter_bp3-icon-large__oZ-F2,\n.ReportsFilter_bp3-drawer-header__3bGRk .ReportsFilter_bp3-icon__15ATj {\n  color: #5c7080;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  margin-right: 10px; }\n\n.ReportsFilter_bp3-drawer-header__3bGRk .ReportsFilter_bp3-heading__H7aWJ {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  line-height: inherit;\n  margin: 0; }\n\n.ReportsFilter_bp3-drawer-header__3bGRk .ReportsFilter_bp3-heading__H7aWJ:last-child {\n  margin-right: 20px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-drawer-header__3bGRk {\n  -webkit-box-shadow: 0 1px 0 rgba(16, 22, 26, 0.4);\n  box-shadow: 0 1px 0 rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-drawer-header__3bGRk .ReportsFilter_bp3-icon-large__oZ-F2,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-drawer-header__3bGRk .ReportsFilter_bp3-icon__15ATj {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-drawer-body__1oTdL {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  line-height: 18px;\n  overflow: auto; }\n\n.ReportsFilter_bp3-drawer-footer__2gdI5 {\n  -webkit-box-shadow: inset 0 1px 0 rgba(16, 22, 26, 0.15);\n  box-shadow: inset 0 1px 0 rgba(16, 22, 26, 0.15);\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  padding: 10px 20px;\n  position: relative; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-drawer-footer__2gdI5 {\n  -webkit-box-shadow: inset 0 1px 0 rgba(16, 22, 26, 0.4);\n  box-shadow: inset 0 1px 0 rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-editable-text__3dp97 {\n  cursor: text;\n  display: inline-block;\n  max-width: 100%;\n  position: relative;\n  vertical-align: top;\n  white-space: nowrap; }\n\n.ReportsFilter_bp3-editable-text__3dp97::before {\n  bottom: -3px;\n  left: -3px;\n  position: absolute;\n  right: -3px;\n  top: -3px;\n  border-radius: 3px;\n  content: \"\";\n  -webkit-transition: background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-editable-text__3dp97:hover::before {\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15); }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-editable-text-editing__1aj52::before {\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-disabled__1YzwV::before {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-editable-text-input__nIvEQ,\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: #137cbd; }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-primary__OlAS0:hover::before {\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(19, 124, 189, 0.4);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(19, 124, 189, 0.4); }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-editable-text-editing__1aj52::before {\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-editable-text-input__nIvEQ,\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: #0f9960; }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-success__3_w9z:hover::before {\n  -webkit-box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px rgba(15, 153, 96, 0.4);\n  box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px rgba(15, 153, 96, 0.4); }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-editable-text-editing__1aj52::before {\n  -webkit-box-shadow: 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-editable-text-input__nIvEQ,\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: #d9822b; }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-warning__372vs:hover::before {\n  -webkit-box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px rgba(217, 130, 43, 0.4);\n  box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px rgba(217, 130, 43, 0.4); }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-editable-text-editing__1aj52::before {\n  -webkit-box-shadow: 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-editable-text-input__nIvEQ,\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: #db3737; }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-danger__GyPAj:hover::before {\n  -webkit-box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px rgba(219, 55, 55, 0.4);\n  box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px rgba(219, 55, 55, 0.4); }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-editable-text-editing__1aj52::before {\n  -webkit-box-shadow: 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97:hover::before {\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(255, 255, 255, 0.15);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-editable-text-editing__1aj52::before {\n  background-color: rgba(16, 22, 26, 0.3);\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-disabled__1YzwV::before {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-primary__OlAS0:hover::before {\n  -webkit-box-shadow: 0 0 0 0 rgba(72, 175, 240, 0), 0 0 0 0 rgba(72, 175, 240, 0), inset 0 0 0 1px rgba(72, 175, 240, 0.4);\n  box-shadow: 0 0 0 0 rgba(72, 175, 240, 0), 0 0 0 0 rgba(72, 175, 240, 0), inset 0 0 0 1px rgba(72, 175, 240, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-editable-text-editing__1aj52::before {\n  -webkit-box-shadow: 0 0 0 1px #48aff0, 0 0 0 3px rgba(72, 175, 240, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #48aff0, 0 0 0 3px rgba(72, 175, 240, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-success__3_w9z:hover::before {\n  -webkit-box-shadow: 0 0 0 0 rgba(61, 204, 145, 0), 0 0 0 0 rgba(61, 204, 145, 0), inset 0 0 0 1px rgba(61, 204, 145, 0.4);\n  box-shadow: 0 0 0 0 rgba(61, 204, 145, 0), 0 0 0 0 rgba(61, 204, 145, 0), inset 0 0 0 1px rgba(61, 204, 145, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-editable-text-editing__1aj52::before {\n  -webkit-box-shadow: 0 0 0 1px #3dcc91, 0 0 0 3px rgba(61, 204, 145, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #3dcc91, 0 0 0 3px rgba(61, 204, 145, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-warning__372vs:hover::before {\n  -webkit-box-shadow: 0 0 0 0 rgba(255, 179, 102, 0), 0 0 0 0 rgba(255, 179, 102, 0), inset 0 0 0 1px rgba(255, 179, 102, 0.4);\n  box-shadow: 0 0 0 0 rgba(255, 179, 102, 0), 0 0 0 0 rgba(255, 179, 102, 0), inset 0 0 0 1px rgba(255, 179, 102, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-editable-text-editing__1aj52::before {\n  -webkit-box-shadow: 0 0 0 1px #ffb366, 0 0 0 3px rgba(255, 179, 102, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #ffb366, 0 0 0 3px rgba(255, 179, 102, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-danger__GyPAj:hover::before {\n  -webkit-box-shadow: 0 0 0 0 rgba(255, 115, 115, 0), 0 0 0 0 rgba(255, 115, 115, 0), inset 0 0 0 1px rgba(255, 115, 115, 0.4);\n  box-shadow: 0 0 0 0 rgba(255, 115, 115, 0), 0 0 0 0 rgba(255, 115, 115, 0), inset 0 0 0 1px rgba(255, 115, 115, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-editable-text-editing__1aj52::before {\n  -webkit-box-shadow: 0 0 0 1px #ff7373, 0 0 0 3px rgba(255, 115, 115, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #ff7373, 0 0 0 3px rgba(255, 115, 115, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-editable-text-input__nIvEQ,\n.ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: inherit;\n  display: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  max-width: inherit;\n  min-width: inherit;\n  position: relative;\n  resize: none;\n  text-transform: inherit;\n  vertical-align: top; }\n\n.ReportsFilter_bp3-editable-text-input__nIvEQ {\n  background: none;\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 0;\n  white-space: pre-wrap;\n  width: 100%; }\n\n.ReportsFilter_bp3-editable-text-input__nIvEQ::-webkit-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-editable-text-input__nIvEQ::-moz-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-editable-text-input__nIvEQ:-ms-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-editable-text-input__nIvEQ::-ms-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-editable-text-input__nIvEQ::placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-editable-text-input__nIvEQ:focus {\n  outline: none; }\n\n.ReportsFilter_bp3-editable-text-input__nIvEQ::-ms-clear {\n  display: none; }\n\n.ReportsFilter_bp3-editable-text-content__1ux18 {\n  overflow: hidden;\n  padding-right: 2px;\n  text-overflow: ellipsis;\n  white-space: pre; }\n\n.ReportsFilter_bp3-editable-text-editing__1aj52 > .ReportsFilter_bp3-editable-text-content__1ux18 {\n  left: 0;\n  position: absolute;\n  visibility: hidden; }\n\n.ReportsFilter_bp3-editable-text-placeholder__2ySbm > .ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: rgba(92, 112, 128, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-editable-text-placeholder__2ySbm > .ReportsFilter_bp3-editable-text-content__1ux18 {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-multiline__O6Fqf {\n  display: block; }\n\n.ReportsFilter_bp3-editable-text__3dp97.ReportsFilter_bp3-multiline__O6Fqf .ReportsFilter_bp3-editable-text-content__1ux18 {\n  overflow: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word; }\n\n.ReportsFilter_bp3-divider__Uugww {\n  border-bottom: 1px solid rgba(16, 22, 26, 0.15);\n  border-right: 1px solid rgba(16, 22, 26, 0.15);\n  margin: 5px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-divider__Uugww {\n  border-color: rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-control-group__3aCAC {\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch; }\n\n.ReportsFilter_bp3-control-group__3aCAC > * {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0; }\n\n.ReportsFilter_bp3-control-group__3aCAC > .ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input__2T1HJ,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy {\n  position: relative; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input__2T1HJ {\n  border-radius: inherit;\n  z-index: 2; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input__2T1HJ:focus {\n  border-radius: 3px;\n  z-index: 14; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input__2T1HJ[class*=\"bp3-intent\"] {\n  z-index: 13; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input__2T1HJ[class*=\"bp3-intent\"]:focus {\n  z-index: 15; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input__2T1HJ[readonly], .ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input__2T1HJ:disabled, .ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-disabled__1YzwV {\n  z-index: 1; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input-group__1Xj6J[class*=\"bp3-intent\"] .ReportsFilter_bp3-input__2T1HJ {\n  z-index: 13; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input-group__1Xj6J[class*=\"bp3-intent\"] .ReportsFilter_bp3-input__2T1HJ:focus {\n  z-index: 15; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select {\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  border-radius: inherit;\n  z-index: 4; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT:focus,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select:focus,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select:focus {\n  z-index: 5; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT:hover,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select:hover,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select:hover {\n  z-index: 6; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT:active,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select:active,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select:active {\n  z-index: 7; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT[readonly], .ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT:disabled, .ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select[readonly],\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select:disabled,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select[readonly],\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select:disabled,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select.ReportsFilter_bp3-disabled__1YzwV {\n  z-index: 3; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent\"],\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select[class*=\"bp3-intent\"],\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select[class*=\"bp3-intent\"] {\n  z-index: 9; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent\"]:focus,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select[class*=\"bp3-intent\"]:focus,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select[class*=\"bp3-intent\"]:focus {\n  z-index: 10; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent\"]:hover,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select[class*=\"bp3-intent\"]:hover,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select[class*=\"bp3-intent\"]:hover {\n  z-index: 11; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent\"]:active,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select[class*=\"bp3-intent\"]:active,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select[class*=\"bp3-intent\"]:active {\n  z-index: 12; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent\"][readonly], .ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent\"]:disabled, .ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-button__15ViT[class*=\"bp3-intent\"].ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select[class*=\"bp3-intent\"][readonly],\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select[class*=\"bp3-intent\"]:disabled,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh select[class*=\"bp3-intent\"].ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select[class*=\"bp3-intent\"][readonly],\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select[class*=\"bp3-intent\"]:disabled,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy select[class*=\"bp3-intent\"].ReportsFilter_bp3-disabled__1YzwV {\n  z-index: 8; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-input-action__3C2wG {\n  z-index: 16; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy::after,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh::after,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-html-select__2bWXh > .ReportsFilter_bp3-icon__15ATj {\n  z-index: 17; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-select__1n6gy:focus-within {\n  z-index: 5; }\n\n.ReportsFilter_bp3-control-group__3aCAC:not(.ReportsFilter_bp3-vertical__22D_2) > *:not(.ReportsFilter_bp3-divider__Uugww) {\n  margin-right: -1px; }\n\n.ReportsFilter_bp3-control-group__3aCAC:not(.ReportsFilter_bp3-vertical__22D_2) > .ReportsFilter_bp3-divider__Uugww:not(:first-child) {\n  margin-left: 6px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control-group__3aCAC:not(.ReportsFilter_bp3-vertical__22D_2) > *:not(.ReportsFilter_bp3-divider__Uugww) {\n  margin-right: 0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control-group__3aCAC:not(.ReportsFilter_bp3-vertical__22D_2) > .ReportsFilter_bp3-button__15ViT + .ReportsFilter_bp3-button__15ViT {\n  margin-left: 1px; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-popover-wrapper__1aeCY,\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-popover-target__2jiug {\n  border-radius: inherit; }\n\n.ReportsFilter_bp3-control-group__3aCAC > :first-child {\n  border-radius: 3px 0 0 3px; }\n\n.ReportsFilter_bp3-control-group__3aCAC > :last-child {\n  border-radius: 0 3px 3px 0;\n  margin-right: 0; }\n\n.ReportsFilter_bp3-control-group__3aCAC > :only-child {\n  border-radius: 3px;\n  margin-right: 0; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-button__15ViT {\n  border-radius: 3px; }\n\n.ReportsFilter_bp3-control-group__3aCAC .ReportsFilter_bp3-numeric-input__3EMCo:not(:first-child) .ReportsFilter_bp3-input-group__1Xj6J {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0; }\n\n.ReportsFilter_bp3-control-group__3aCAC.ReportsFilter_bp3-fill__3iORs {\n  width: 100%; }\n\n.ReportsFilter_bp3-control-group__3aCAC > .ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto; }\n\n.ReportsFilter_bp3-control-group__3aCAC.ReportsFilter_bp3-fill__3iORs > *:not(.ReportsFilter_bp3-fixed__2PPz2) {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto; }\n\n.ReportsFilter_bp3-control-group__3aCAC.ReportsFilter_bp3-vertical__22D_2 {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column; }\n\n.ReportsFilter_bp3-control-group__3aCAC.ReportsFilter_bp3-vertical__22D_2 > * {\n  margin-top: -1px; }\n\n.ReportsFilter_bp3-control-group__3aCAC.ReportsFilter_bp3-vertical__22D_2 > :first-child {\n  border-radius: 3px 3px 0 0;\n  margin-top: 0; }\n\n.ReportsFilter_bp3-control-group__3aCAC.ReportsFilter_bp3-vertical__22D_2 > :last-child {\n  border-radius: 0 0 3px 3px; }\n\n.ReportsFilter_bp3-control__uzs-q {\n  cursor: pointer;\n  display: block;\n  margin-bottom: 10px;\n  position: relative;\n  text-transform: none; }\n\n.ReportsFilter_bp3-control__uzs-q input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #137cbd;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.1)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  color: #ffffff; }\n\n.ReportsFilter_bp3-control__uzs-q:hover input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #106ba3;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-control__uzs-q input:not(:disabled):active:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: #0e5a8a;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-control__uzs-q input:disabled:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(19, 124, 189, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q:hover input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #106ba3;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q input:not(:disabled):active:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #0e5a8a;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q input:disabled:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(14, 90, 138, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-control__uzs-q:not(.ReportsFilter_bp3-align-right__1vvtP) {\n  padding-left: 26px; }\n\n.ReportsFilter_bp3-control__uzs-q:not(.ReportsFilter_bp3-align-right__1vvtP) .ReportsFilter_bp3-control-indicator__3WfzA {\n  margin-left: -26px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-align-right__1vvtP {\n  padding-right: 26px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-align-right__1vvtP .ReportsFilter_bp3-control-indicator__3WfzA {\n  margin-right: -26px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-disabled__1YzwV {\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-inline__kQDLs {\n  display: inline-block;\n  margin-right: 20px; }\n\n.ReportsFilter_bp3-control__uzs-q input {\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  z-index: -1; }\n\n.ReportsFilter_bp3-control__uzs-q .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-clip: padding-box;\n  background-color: #f5f8fa;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.8)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  border: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  cursor: pointer;\n  display: inline-block;\n  font-size: 16px;\n  height: 1em;\n  margin-right: 10px;\n  margin-top: -3px;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  width: 1em; }\n\n.ReportsFilter_bp3-control__uzs-q .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  content: \"\";\n  display: block;\n  height: 1em;\n  width: 1em; }\n\n.ReportsFilter_bp3-control__uzs-q:hover .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #ebf1f5; }\n\n.ReportsFilter_bp3-control__uzs-q input:not(:disabled):active ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: #d8e1e8;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-control__uzs-q input:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(206, 217, 224, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-control__uzs-q input:focus ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  outline: rgba(19, 124, 189, 0.6) auto 2px;\n  outline-offset: 2px;\n  -moz-outline-radius: 6px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-align-right__1vvtP .ReportsFilter_bp3-control-indicator__3WfzA {\n  float: right;\n  margin-left: 10px;\n  margin-top: 1px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-large__17hsQ {\n  font-size: 16px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-large__17hsQ:not(.ReportsFilter_bp3-align-right__1vvtP) {\n  padding-left: 30px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-large__17hsQ:not(.ReportsFilter_bp3-align-right__1vvtP) .ReportsFilter_bp3-control-indicator__3WfzA {\n  margin-left: -30px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-large__17hsQ.ReportsFilter_bp3-align-right__1vvtP {\n  padding-right: 30px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-large__17hsQ.ReportsFilter_bp3-align-right__1vvtP .ReportsFilter_bp3-control-indicator__3WfzA {\n  margin-right: -30px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-control-indicator__3WfzA {\n  font-size: 20px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-large__17hsQ.ReportsFilter_bp3-align-right__1vvtP .ReportsFilter_bp3-control-indicator__3WfzA {\n  margin-top: 0; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX input:indeterminate ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #137cbd;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.1)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  color: #ffffff; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX:hover input:indeterminate ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #106ba3;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX input:not(:disabled):active:indeterminate ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: #0e5a8a;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX input:disabled:indeterminate ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(19, 124, 189, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX input:indeterminate ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX:hover input:indeterminate ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #106ba3;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX input:not(:disabled):active:indeterminate ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #0e5a8a;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX input:disabled:indeterminate ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(14, 90, 138, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX .ReportsFilter_bp3-control-indicator__3WfzA {\n  border-radius: 3px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='white'/%3e%3c/svg%3e\"); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX input:indeterminate ~ .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z' fill='white'/%3e%3c/svg%3e\"); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-radio__3Uku2 .ReportsFilter_bp3-control-indicator__3WfzA {\n  border-radius: 50%; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-radio__3Uku2 input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  background-image: radial-gradient(#ffffff, #ffffff 28%, transparent 32%); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-radio__3Uku2 input:checked:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  opacity: 0.5; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-radio__3Uku2 input:focus ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  -moz-outline-radius: 16px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(167, 182, 194, 0.5); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY:hover input ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(115, 134, 148, 0.5); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:not(:disabled):active ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(92, 112, 128, 0.5); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(206, 217, 224, 0.5); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  background: rgba(255, 255, 255, 0.8); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: #137cbd; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY:hover input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: #106ba3; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked:not(:disabled):active ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: #0e5a8a; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(19, 124, 189, 0.5); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  background: rgba(255, 255, 255, 0.8); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY:not(.ReportsFilter_bp3-align-right__1vvtP) {\n  padding-left: 38px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY:not(.ReportsFilter_bp3-align-right__1vvtP) .ReportsFilter_bp3-control-indicator__3WfzA {\n  margin-left: -38px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY.ReportsFilter_bp3-align-right__1vvtP {\n  padding-right: 38px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY.ReportsFilter_bp3-align-right__1vvtP .ReportsFilter_bp3-control-indicator__3WfzA {\n  margin-right: -38px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY .ReportsFilter_bp3-control-indicator__3WfzA {\n  border: none;\n  border-radius: 1.75em;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  min-width: 1.75em;\n  -webkit-transition: background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  width: auto; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  background: #ffffff;\n  border-radius: 50%;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2);\n  height: calc(1em - 4px);\n  left: 0;\n  margin: 2px;\n  position: absolute;\n  -webkit-transition: left 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: left 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  width: calc(1em - 4px); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  left: calc(100% - 1em); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY.ReportsFilter_bp3-large__17hsQ:not(.ReportsFilter_bp3-align-right__1vvtP) {\n  padding-left: 45px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY.ReportsFilter_bp3-large__17hsQ:not(.ReportsFilter_bp3-align-right__1vvtP) .ReportsFilter_bp3-control-indicator__3WfzA {\n  margin-left: -45px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY.ReportsFilter_bp3-large__17hsQ.ReportsFilter_bp3-align-right__1vvtP {\n  padding-right: 45px; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY.ReportsFilter_bp3-large__17hsQ.ReportsFilter_bp3-align-right__1vvtP .ReportsFilter_bp3-control-indicator__3WfzA {\n  margin-right: -45px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(16, 22, 26, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY:hover input ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(16, 22, 26, 0.7); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:not(:disabled):active ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(16, 22, 26, 0.9); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(57, 75, 89, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  background: rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: #137cbd; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY:hover input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: #106ba3; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked:not(:disabled):active ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: #0e5a8a; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(14, 90, 138, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  background: rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  background: #394b59;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA::before {\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY .ReportsFilter_bp3-switch-inner-text__2nFuc {\n  font-size: 0.7em;\n  text-align: center; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY .ReportsFilter_bp3-control-indicator-child__3WsZk:first-child {\n  line-height: 0;\n  margin-left: 0.5em;\n  margin-right: 1.2em;\n  visibility: hidden; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY .ReportsFilter_bp3-control-indicator-child__3WsZk:last-child {\n  line-height: 1em;\n  margin-left: 1.2em;\n  margin-right: 0.5em;\n  visibility: visible; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA .ReportsFilter_bp3-control-indicator-child__3WsZk:first-child {\n  line-height: 1em;\n  visibility: visible; }\n\n.ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-switch__2BxdY input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA .ReportsFilter_bp3-control-indicator-child__3WsZk:last-child {\n  line-height: 0;\n  visibility: hidden; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-disabled__1YzwV {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #394b59;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.05)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q:hover .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #30404d; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q input:not(:disabled):active ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: #202b33;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q input:disabled ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background: rgba(57, 75, 89, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX input:disabled:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-control__uzs-q.ReportsFilter_bp3-checkbox__1dUfX input:disabled:indeterminate ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-file-input__1TAaK {\n  cursor: pointer;\n  display: inline-block;\n  height: 30px;\n  position: relative; }\n\n.ReportsFilter_bp3-file-input__1TAaK input {\n  margin: 0;\n  min-width: 200px;\n  opacity: 0; }\n\n.ReportsFilter_bp3-file-input__1TAaK input:disabled + .ReportsFilter_bp3-file-upload-input__Otd-V,\n.ReportsFilter_bp3-file-input__1TAaK input.ReportsFilter_bp3-disabled__1YzwV + .ReportsFilter_bp3-file-upload-input__Otd-V {\n  background: rgba(206, 217, 224, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed;\n  resize: none; }\n\n.ReportsFilter_bp3-file-input__1TAaK input:disabled + .ReportsFilter_bp3-file-upload-input__Otd-V::after,\n.ReportsFilter_bp3-file-input__1TAaK input.ReportsFilter_bp3-disabled__1YzwV + .ReportsFilter_bp3-file-upload-input__Otd-V::after {\n  background-color: rgba(206, 217, 224, 0.5);\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed;\n  outline: none; }\n\n.ReportsFilter_bp3-file-input__1TAaK input:disabled + .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-file-input__1TAaK input:disabled + .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-active__1Mw-V:hover,\n.ReportsFilter_bp3-file-input__1TAaK input.ReportsFilter_bp3-disabled__1YzwV + .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-file-input__1TAaK input.ReportsFilter_bp3-disabled__1YzwV + .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-active__1Mw-V:hover {\n  background: rgba(206, 217, 224, 0.7); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-input__1TAaK input:disabled + .ReportsFilter_bp3-file-upload-input__Otd-V, .ReportsFilter_bp3-dark__3R7GO\n.ReportsFilter_bp3-file-input__1TAaK input.ReportsFilter_bp3-disabled__1YzwV + .ReportsFilter_bp3-file-upload-input__Otd-V {\n  background: rgba(57, 75, 89, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-input__1TAaK input:disabled + .ReportsFilter_bp3-file-upload-input__Otd-V::after, .ReportsFilter_bp3-dark__3R7GO\n.ReportsFilter_bp3-file-input__1TAaK input.ReportsFilter_bp3-disabled__1YzwV + .ReportsFilter_bp3-file-upload-input__Otd-V::after {\n  background-color: rgba(57, 75, 89, 0.5);\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-input__1TAaK input:disabled + .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO\n.ReportsFilter_bp3-file-input__1TAaK input.ReportsFilter_bp3-disabled__1YzwV + .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(57, 75, 89, 0.7); }\n\n.ReportsFilter_bp3-file-input__1TAaK.ReportsFilter_bp3-file-input-has-selection__Lb9EM .ReportsFilter_bp3-file-upload-input__Otd-V {\n  color: #182026; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-input__1TAaK.ReportsFilter_bp3-file-input-has-selection__Lb9EM .ReportsFilter_bp3-file-upload-input__Otd-V {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-file-input__1TAaK.ReportsFilter_bp3-fill__3iORs {\n  width: 100%; }\n\n.ReportsFilter_bp3-file-input__1TAaK.ReportsFilter_bp3-large__17hsQ,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-file-input__1TAaK {\n  height: 40px; }\n\n.ReportsFilter_bp3-file-input__1TAaK .ReportsFilter_bp3-file-upload-input-custom-text__3Q0G1::after {\n  content: attr(bp3-button-text); }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: #ffffff;\n  border: none;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  color: #182026;\n  font-size: 14px;\n  font-weight: 400;\n  height: 30px;\n  line-height: 30px;\n  outline: none;\n  padding: 0 10px;\n  -webkit-transition: -webkit-box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: -webkit-box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  vertical-align: middle;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  color: rgba(92, 112, 128, 0.6);\n  left: 0;\n  padding-right: 80px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V::-webkit-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V::-moz-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V:-ms-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V::-ms-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V::placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V:focus, .ReportsFilter_bp3-file-upload-input__Otd-V.ReportsFilter_bp3-active__1Mw-V {\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V[type=\"search\"], .ReportsFilter_bp3-file-upload-input__Otd-V.ReportsFilter_bp3-round__12jLZ {\n  border-radius: 30px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  padding-left: 10px; }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.15);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.15); }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V:disabled, .ReportsFilter_bp3-file-upload-input__Otd-V.ReportsFilter_bp3-disabled__1YzwV {\n  background: rgba(206, 217, 224, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed;\n  resize: none; }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V::after {\n  background-color: #f5f8fa;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.8)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  color: #182026;\n  min-height: 24px;\n  min-width: 24px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  border-radius: 3px;\n  content: \"Browse\";\n  line-height: 24px;\n  margin: 3px;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 0;\n  width: 70px; }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V::after:hover {\n  background-clip: padding-box;\n  background-color: #ebf1f5;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1); }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V::after:active, .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #d8e1e8;\n  background-image: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V::after:disabled, .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(206, 217, 224, 0.5);\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed;\n  outline: none; }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V::after:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-file-upload-input__Otd-V::after:disabled.ReportsFilter_bp3-active__1Mw-V:hover, .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V:hover {\n  background: rgba(206, 217, 224, 0.7); }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V:hover::after {\n  background-clip: padding-box;\n  background-color: #ebf1f5;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1); }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V:active::after {\n  background-color: #d8e1e8;\n  background-image: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-file-upload-input__Otd-V {\n  font-size: 16px;\n  height: 40px;\n  line-height: 40px;\n  padding-right: 95px; }\n\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-file-upload-input__Otd-V[type=\"search\"], .ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-file-upload-input__Otd-V.ReportsFilter_bp3-round__12jLZ {\n  padding: 0 15px; }\n\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-file-upload-input__Otd-V::after {\n  min-height: 30px;\n  min-width: 30px;\n  line-height: 30px;\n  margin: 5px;\n  width: 85px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V {\n  background: rgba(16, 22, 26, 0.3);\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  color: #f5f8fa;\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::-webkit-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::-moz-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V:-ms-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::-ms-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V:focus {\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V.ReportsFilter_bp3-disabled__1YzwV {\n  background: rgba(57, 75, 89, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after {\n  background-color: #394b59;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.05)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-active__1Mw-V {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after:hover {\n  background-color: #30404d;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #202b33;\n  background-image: none;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(57, 75, 89, 0.5);\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(57, 75, 89, 0.7); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V::after .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  background: rgba(16, 22, 26, 0.5);\n  stroke: #8a9ba8; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V:hover::after {\n  background-color: #30404d;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-file-upload-input__Otd-V:active::after {\n  background-color: #202b33;\n  background-image: none;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-file-upload-input__Otd-V::after {\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1); }\n\n.ReportsFilter_bp3-form-group__1DJxs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin: 0 0 15px; }\n\n.ReportsFilter_bp3-form-group__1DJxs label.ReportsFilter_bp3-label__1Z8C0 {\n  margin-bottom: 5px; }\n\n.ReportsFilter_bp3-form-group__1DJxs .ReportsFilter_bp3-control__uzs-q {\n  margin-top: 7px; }\n\n.ReportsFilter_bp3-form-group__1DJxs .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: #5c7080;\n  font-size: 12px;\n  margin-top: 5px; }\n\n.ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: #0d8050; }\n\n.ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: #bf7326; }\n\n.ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: #c23030; }\n\n.ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-inline__kQDLs {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row; }\n\n.ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-inline__kQDLs.ReportsFilter_bp3-large__17hsQ label.ReportsFilter_bp3-label__1Z8C0 {\n  line-height: 40px;\n  margin: 0 10px 0 0; }\n\n.ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-inline__kQDLs label.ReportsFilter_bp3-label__1Z8C0 {\n  line-height: 30px;\n  margin: 0 10px 0 0; }\n\n.ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-label__1Z8C0,\n.ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-text-muted__1cP1z,\n.ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: rgba(92, 112, 128, 0.6) !important; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-form-group__1DJxs .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-label__1Z8C0,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-text-muted__1cP1z,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-form-group__1DJxs.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-form-helper-text__1MPsW {\n  color: rgba(167, 182, 194, 0.6) !important; }\n\n.ReportsFilter_bp3-input-group__1Xj6J {\n  display: block;\n  position: relative; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ {\n  position: relative;\n  width: 100%; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:first-child) {\n  padding-left: 30px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:last-child) {\n  padding-right: 30px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input-action__3C2wG,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-input-left-container__w3AWe,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-icon__15ATj {\n  position: absolute;\n  top: 0; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input-action__3C2wG:first-child,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-input-left-container__w3AWe:first-child,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-button__15ViT:first-child,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-icon__15ATj:first-child {\n  left: 0; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input-action__3C2wG:last-child,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-input-left-container__w3AWe:last-child,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-button__15ViT:last-child,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-icon__15ATj:last-child {\n  right: 0; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-button__15ViT {\n  min-height: 24px;\n  min-width: 24px;\n  margin: 3px;\n  padding: 0 7px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-button__15ViT:empty {\n  padding: 0; }\n\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-input-left-container__w3AWe,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-icon__15ATj {\n  z-index: 1; }\n\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-input-left-container__w3AWe > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-icon__15ATj {\n  color: #5c7080; }\n\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-input-left-container__w3AWe > .ReportsFilter_bp3-icon__15ATj:empty,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-icon__15ATj:empty {\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased; }\n\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-input-left-container__w3AWe > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-input-group__1Xj6J > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input-action__3C2wG > .ReportsFilter_bp3-spinner__1DHED {\n  margin: 7px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-tag__t-27S {\n  margin: 5px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:not(:hover):not(:focus),\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-input-action__3C2wG .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:not(:hover):not(:focus) {\n  color: #5c7080; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:not(:hover):not(:focus), .ReportsFilter_bp3-dark__3R7GO\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-input-action__3C2wG .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:not(:hover):not(:focus) {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:not(:hover):not(:focus) .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:not(:hover):not(:focus) .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:not(:hover):not(:focus) .ReportsFilter_bp3-icon-large__oZ-F2,\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-input-action__3C2wG .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:not(:hover):not(:focus) .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-input-action__3C2wG .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:not(:hover):not(:focus) .ReportsFilter_bp3-icon-standard__1vHca,\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-input-action__3C2wG .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:not(:hover):not(:focus) .ReportsFilter_bp3-icon-large__oZ-F2 {\n  color: #5c7080; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled,\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-input-action__3C2wG .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled {\n  color: rgba(92, 112, 128, 0.6) !important; }\n\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled .ReportsFilter_bp3-icon-large__oZ-F2,\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-input-action__3C2wG .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-input-action__3C2wG .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled .ReportsFilter_bp3-icon-standard__1vHca,\n.ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ:not(:focus) + .ReportsFilter_bp3-input-action__3C2wG .ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-minimal__V1Rn9:disabled .ReportsFilter_bp3-icon-large__oZ-F2 {\n  color: rgba(92, 112, 128, 0.6) !important; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-disabled__1YzwV {\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-icon__15ATj {\n  color: rgba(92, 112, 128, 0.6); }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-button__15ViT {\n  min-height: 30px;\n  min-width: 30px;\n  margin: 5px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-large__17hsQ > .ReportsFilter_bp3-input-left-container__w3AWe > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-large__17hsQ > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-input-action__3C2wG > .ReportsFilter_bp3-spinner__1DHED {\n  margin: 12px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-input__2T1HJ {\n  font-size: 16px;\n  height: 40px;\n  line-height: 40px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-input__2T1HJ[type=\"search\"], .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-round__12jLZ {\n  padding: 0 15px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-input__2T1HJ:not(:first-child) {\n  padding-left: 40px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-input__2T1HJ:not(:last-child) {\n  padding-right: 40px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-small__2yDvz .ReportsFilter_bp3-button__15ViT {\n  min-height: 20px;\n  min-width: 20px;\n  margin: 2px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-small__2yDvz .ReportsFilter_bp3-tag__t-27S {\n  min-height: 20px;\n  min-width: 20px;\n  margin: 2px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-small__2yDvz > .ReportsFilter_bp3-input-left-container__w3AWe > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-small__2yDvz > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-small__2yDvz .ReportsFilter_bp3-input-action__3C2wG > .ReportsFilter_bp3-spinner__1DHED {\n  margin: 4px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-small__2yDvz .ReportsFilter_bp3-input__2T1HJ {\n  font-size: 12px;\n  height: 24px;\n  line-height: 24px;\n  padding-left: 8px;\n  padding-right: 8px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-small__2yDvz .ReportsFilter_bp3-input__2T1HJ[type=\"search\"], .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-small__2yDvz .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-round__12jLZ {\n  padding: 0 12px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-small__2yDvz .ReportsFilter_bp3-input__2T1HJ:not(:first-child) {\n  padding-left: 24px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-small__2yDvz .ReportsFilter_bp3-input__2T1HJ:not(:last-child) {\n  padding-right: 24px; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  width: 100%; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-round__12jLZ .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-round__12jLZ .ReportsFilter_bp3-input__2T1HJ,\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-round__12jLZ .ReportsFilter_bp3-tag__t-27S {\n  border-radius: 30px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-icon__15ATj {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-icon__15ATj {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-input__2T1HJ {\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px #137cbd, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px #137cbd, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-input__2T1HJ:focus {\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-input__2T1HJ[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #137cbd;\n  box-shadow: inset 0 0 0 1px #137cbd; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-input__2T1HJ:disabled, .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-primary__OlAS0 > .ReportsFilter_bp3-icon__15ATj {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-primary__OlAS0 > .ReportsFilter_bp3-icon__15ATj {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-input__2T1HJ {\n  -webkit-box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px #0f9960, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px #0f9960, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-input__2T1HJ:focus {\n  -webkit-box-shadow: 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-input__2T1HJ[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #0f9960;\n  box-shadow: inset 0 0 0 1px #0f9960; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-input__2T1HJ:disabled, .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-success__3_w9z > .ReportsFilter_bp3-icon__15ATj {\n  color: #0d8050; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-success__3_w9z > .ReportsFilter_bp3-icon__15ATj {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-input__2T1HJ {\n  -webkit-box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px #d9822b, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px #d9822b, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-input__2T1HJ:focus {\n  -webkit-box-shadow: 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-input__2T1HJ[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #d9822b;\n  box-shadow: inset 0 0 0 1px #d9822b; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-input__2T1HJ:disabled, .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-warning__372vs > .ReportsFilter_bp3-icon__15ATj {\n  color: #bf7326; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-warning__372vs > .ReportsFilter_bp3-icon__15ATj {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-input__2T1HJ {\n  -webkit-box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px #db3737, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px #db3737, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-input__2T1HJ:focus {\n  -webkit-box-shadow: 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-input__2T1HJ[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #db3737;\n  box-shadow: inset 0 0 0 1px #db3737; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-input__2T1HJ:disabled, .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-danger__GyPAj > .ReportsFilter_bp3-icon__15ATj {\n  color: #c23030; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-group__1Xj6J.ReportsFilter_bp3-intent-danger__GyPAj > .ReportsFilter_bp3-icon__15ATj {\n  color: #ff7373; }\n\n.ReportsFilter_bp3-input__2T1HJ {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: #ffffff;\n  border: none;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  color: #182026;\n  font-size: 14px;\n  font-weight: 400;\n  height: 30px;\n  line-height: 30px;\n  outline: none;\n  padding: 0 10px;\n  -webkit-transition: -webkit-box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: -webkit-box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  vertical-align: middle; }\n\n.ReportsFilter_bp3-input__2T1HJ::-webkit-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-input__2T1HJ::-moz-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-input__2T1HJ:-ms-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-input__2T1HJ::-ms-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-input__2T1HJ::placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-input__2T1HJ:focus, .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-active__1Mw-V {\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input__2T1HJ[type=\"search\"], .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-round__12jLZ {\n  border-radius: 30px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  padding-left: 10px; }\n\n.ReportsFilter_bp3-input__2T1HJ[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.15);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.15); }\n\n.ReportsFilter_bp3-input__2T1HJ:disabled, .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-disabled__1YzwV {\n  background: rgba(206, 217, 224, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed;\n  resize: none; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-large__17hsQ {\n  font-size: 16px;\n  height: 40px;\n  line-height: 40px; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-large__17hsQ[type=\"search\"], .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-large__17hsQ.ReportsFilter_bp3-round__12jLZ {\n  padding: 0 15px; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-small__2yDvz {\n  font-size: 12px;\n  height: 24px;\n  line-height: 24px;\n  padding-left: 8px;\n  padding-right: 8px; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-small__2yDvz[type=\"search\"], .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-small__2yDvz.ReportsFilter_bp3-round__12jLZ {\n  padding: 0 12px; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  width: 100%; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ {\n  background: rgba(16, 22, 26, 0.3);\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ::-webkit-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ::-moz-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ:-ms-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ::-ms-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ::placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ:focus {\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-disabled__1YzwV {\n  background: rgba(57, 75, 89, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-primary__OlAS0 {\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px #137cbd, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px #137cbd, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-primary__OlAS0:focus {\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-primary__OlAS0[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #137cbd;\n  box-shadow: inset 0 0 0 1px #137cbd; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-primary__OlAS0 {\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px #137cbd, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px #137cbd, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-primary__OlAS0:focus {\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-primary__OlAS0[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #137cbd;\n  box-shadow: inset 0 0 0 1px #137cbd; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-success__3_w9z {\n  -webkit-box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px #0f9960, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px #0f9960, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-success__3_w9z:focus {\n  -webkit-box-shadow: 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-success__3_w9z[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #0f9960;\n  box-shadow: inset 0 0 0 1px #0f9960; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-success__3_w9z {\n  -webkit-box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px #0f9960, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px #0f9960, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-success__3_w9z:focus {\n  -webkit-box-shadow: 0 0 0 1px #0f9960, 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #0f9960, 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-success__3_w9z[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #0f9960;\n  box-shadow: inset 0 0 0 1px #0f9960; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-warning__372vs {\n  -webkit-box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px #d9822b, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px #d9822b, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-warning__372vs:focus {\n  -webkit-box-shadow: 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-warning__372vs[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #d9822b;\n  box-shadow: inset 0 0 0 1px #d9822b; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-warning__372vs {\n  -webkit-box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px #d9822b, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px #d9822b, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-warning__372vs:focus {\n  -webkit-box-shadow: 0 0 0 1px #d9822b, 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #d9822b, 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-warning__372vs[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #d9822b;\n  box-shadow: inset 0 0 0 1px #d9822b; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-danger__GyPAj {\n  -webkit-box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px #db3737, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px #db3737, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-danger__GyPAj:focus {\n  -webkit-box-shadow: 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-danger__GyPAj[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #db3737;\n  box-shadow: inset 0 0 0 1px #db3737; }\n\n.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-danger__GyPAj {\n  -webkit-box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px #db3737, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px #db3737, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-danger__GyPAj:focus {\n  -webkit-box-shadow: 0 0 0 1px #db3737, 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #db3737, 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-danger__GyPAj[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px #db3737;\n  box-shadow: inset 0 0 0 1px #db3737; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-input__2T1HJ::-ms-clear {\n  display: none; }\n\ntextarea.ReportsFilter_bp3-input__2T1HJ {\n  max-width: 100%;\n  padding: 10px; }\n\ntextarea.ReportsFilter_bp3-input__2T1HJ, textarea.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-large__17hsQ, textarea.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-small__2yDvz {\n  height: auto;\n  line-height: inherit; }\n\ntextarea.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-small__2yDvz {\n  padding: 8px; }\n\n.ReportsFilter_bp3-dark__3R7GO textarea.ReportsFilter_bp3-input__2T1HJ {\n  background: rgba(16, 22, 26, 0.3);\n  -webkit-box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO textarea.ReportsFilter_bp3-input__2T1HJ::-webkit-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO textarea.ReportsFilter_bp3-input__2T1HJ::-moz-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO textarea.ReportsFilter_bp3-input__2T1HJ:-ms-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO textarea.ReportsFilter_bp3-input__2T1HJ::-ms-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO textarea.ReportsFilter_bp3-input__2T1HJ::placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO textarea.ReportsFilter_bp3-input__2T1HJ:focus {\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO textarea.ReportsFilter_bp3-input__2T1HJ[readonly] {\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO textarea.ReportsFilter_bp3-input__2T1HJ:disabled, .ReportsFilter_bp3-dark__3R7GO textarea.ReportsFilter_bp3-input__2T1HJ.ReportsFilter_bp3-disabled__1YzwV {\n  background: rgba(57, 75, 89, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(167, 182, 194, 0.6); }\n\nlabel.ReportsFilter_bp3-label__1Z8C0 {\n  display: block;\n  margin-bottom: 15px;\n  margin-top: 0; }\n\nlabel.ReportsFilter_bp3-label__1Z8C0 .ReportsFilter_bp3-html-select__2bWXh,\nlabel.ReportsFilter_bp3-label__1Z8C0 .ReportsFilter_bp3-input__2T1HJ,\nlabel.ReportsFilter_bp3-label__1Z8C0 .ReportsFilter_bp3-select__1n6gy,\nlabel.ReportsFilter_bp3-label__1Z8C0 .ReportsFilter_bp3-slider__1otHV,\nlabel.ReportsFilter_bp3-label__1Z8C0 .ReportsFilter_bp3-popover-wrapper__1aeCY {\n  display: block;\n  margin-top: 5px;\n  text-transform: none; }\n\nlabel.ReportsFilter_bp3-label__1Z8C0 .ReportsFilter_bp3-button-group__OVeCS {\n  margin-top: 5px; }\n\nlabel.ReportsFilter_bp3-label__1Z8C0 .ReportsFilter_bp3-select__1n6gy select,\nlabel.ReportsFilter_bp3-label__1Z8C0 .ReportsFilter_bp3-html-select__2bWXh select {\n  font-weight: 400;\n  vertical-align: top;\n  width: 100%; }\n\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-disabled__1YzwV,\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-text-muted__1cP1z {\n  color: rgba(92, 112, 128, 0.6); }\n\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-inline__kQDLs {\n  line-height: 30px; }\n\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-inline__kQDLs .ReportsFilter_bp3-html-select__2bWXh,\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-inline__kQDLs .ReportsFilter_bp3-input__2T1HJ,\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-inline__kQDLs .ReportsFilter_bp3-input-group__1Xj6J,\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-inline__kQDLs .ReportsFilter_bp3-select__1n6gy,\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-inline__kQDLs .ReportsFilter_bp3-popover-wrapper__1aeCY {\n  display: inline-block;\n  margin: 0 0 0 5px;\n  vertical-align: top; }\n\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-inline__kQDLs .ReportsFilter_bp3-button-group__OVeCS {\n  margin: 0 0 0 5px; }\n\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-inline__kQDLs .ReportsFilter_bp3-input-group__1Xj6J .ReportsFilter_bp3-input__2T1HJ {\n  margin-left: 0; }\n\nlabel.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-inline__kQDLs.ReportsFilter_bp3-large__17hsQ {\n  line-height: 40px; }\n\nlabel.ReportsFilter_bp3-label__1Z8C0:not(.ReportsFilter_bp3-inline__kQDLs) .ReportsFilter_bp3-popover-target__2jiug {\n  display: block; }\n\n.ReportsFilter_bp3-dark__3R7GO label.ReportsFilter_bp3-label__1Z8C0 {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO label.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-dark__3R7GO label.ReportsFilter_bp3-label__1Z8C0.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-text-muted__1cP1z {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-numeric-input__3EMCo .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-button__15ViT {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 14px;\n  flex: 1 1 14px;\n  min-height: 0;\n  padding: 0;\n  width: 30px; }\n\n.ReportsFilter_bp3-numeric-input__3EMCo .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-button__15ViT:first-child {\n  border-radius: 0 3px 0 0; }\n\n.ReportsFilter_bp3-numeric-input__3EMCo .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-button__15ViT:last-child {\n  border-radius: 0 0 3px 0; }\n\n.ReportsFilter_bp3-numeric-input__3EMCo .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2:first-child > .ReportsFilter_bp3-button__15ViT:first-child {\n  border-radius: 3px 0 0 0; }\n\n.ReportsFilter_bp3-numeric-input__3EMCo .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2:first-child > .ReportsFilter_bp3-button__15ViT:last-child {\n  border-radius: 0 0 0 3px; }\n\n.ReportsFilter_bp3-numeric-input__3EMCo.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-button-group__OVeCS.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-button__15ViT {\n  width: 40px; }\n\nform {\n  display: block; }\n\n.ReportsFilter_bp3-html-select__2bWXh select,\n.ReportsFilter_bp3-select__1n6gy select {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 14px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: 5px 10px;\n  text-align: left;\n  vertical-align: middle;\n  background-color: #f5f8fa;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.8)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  color: #182026;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  border-radius: 3px;\n  height: 30px;\n  padding: 0 25px 0 10px;\n  width: 100%; }\n\n.ReportsFilter_bp3-html-select__2bWXh select > *, .ReportsFilter_bp3-select__1n6gy select > * {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0; }\n\n.ReportsFilter_bp3-html-select__2bWXh select > .ReportsFilter_bp3-fill__3iORs, .ReportsFilter_bp3-select__1n6gy select > .ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1; }\n\n.ReportsFilter_bp3-html-select__2bWXh select::before,\n.ReportsFilter_bp3-select__1n6gy select::before, .ReportsFilter_bp3-html-select__2bWXh select > *, .ReportsFilter_bp3-select__1n6gy select > * {\n  margin-right: 7px; }\n\n.ReportsFilter_bp3-html-select__2bWXh select:empty::before,\n.ReportsFilter_bp3-select__1n6gy select:empty::before,\n.ReportsFilter_bp3-html-select__2bWXh select > :last-child,\n.ReportsFilter_bp3-select__1n6gy select > :last-child {\n  margin-right: 0; }\n\n.ReportsFilter_bp3-html-select__2bWXh select:hover,\n.ReportsFilter_bp3-select__1n6gy select:hover {\n  background-clip: padding-box;\n  background-color: #ebf1f5;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1); }\n\n.ReportsFilter_bp3-html-select__2bWXh select:active,\n.ReportsFilter_bp3-select__1n6gy select:active, .ReportsFilter_bp3-html-select__2bWXh select.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy select.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #d8e1e8;\n  background-image: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-html-select__2bWXh select:disabled,\n.ReportsFilter_bp3-select__1n6gy select:disabled, .ReportsFilter_bp3-html-select__2bWXh select.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-select__1n6gy select.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(206, 217, 224, 0.5);\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed;\n  outline: none; }\n\n.ReportsFilter_bp3-html-select__2bWXh select:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy select:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh select:disabled.ReportsFilter_bp3-active__1Mw-V:hover,\n.ReportsFilter_bp3-select__1n6gy select:disabled.ReportsFilter_bp3-active__1Mw-V:hover, .ReportsFilter_bp3-html-select__2bWXh select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V:hover,\n.ReportsFilter_bp3-select__1n6gy select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V:hover {\n  background: rgba(206, 217, 224, 0.7); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:hover {\n  background: rgba(167, 182, 194, 0.3);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #182026;\n  text-decoration: none; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:active,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(115, 134, 148, 0.3);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #182026; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:disabled,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:disabled, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:disabled:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:disabled:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV:hover {\n  background: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:disabled:hover.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:disabled:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(115, 134, 148, 0.3); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:hover,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:hover, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:active,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:active, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:hover,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:hover, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:hover {\n  background: rgba(138, 155, 168, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:active,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:active, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(138, 155, 168, 0.3);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:disabled, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:disabled,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:disabled, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:disabled:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:disabled:hover,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:disabled:hover, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:disabled:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-disabled__1YzwV:hover,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV:hover, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-disabled__1YzwV:hover {\n  background: none;\n  color: rgba(167, 182, 194, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select:disabled:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:disabled:hover.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select:disabled:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select:disabled:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-disabled__1YzwV:hover.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(138, 155, 168, 0.3); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:active,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #106ba3; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:hover {\n  background: rgba(19, 124, 189, 0.15);\n  color: #106ba3; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:active,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3);\n  color: #106ba3; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:disabled,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(16, 107, 163, 0.5); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ-, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #106ba3; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0:hover,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0:hover {\n  background: rgba(19, 124, 189, 0.2);\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0:active,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3);\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0:disabled,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(72, 175, 240, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(19, 124, 189, 0.3); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #0d8050; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:active,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #0d8050; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:hover {\n  background: rgba(15, 153, 96, 0.15);\n  color: #0d8050; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:active,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3);\n  color: #0d8050; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:disabled,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(13, 128, 80, 0.5); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ-, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #0d8050; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z:hover,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z:hover {\n  background: rgba(15, 153, 96, 0.2);\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z:active,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3);\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z:disabled,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(61, 204, 145, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(15, 153, 96, 0.3); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs {\n  color: #bf7326; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:active,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #bf7326; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:hover {\n  background: rgba(217, 130, 43, 0.15);\n  color: #bf7326; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:active,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3);\n  color: #bf7326; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:disabled,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(191, 115, 38, 0.5); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ-, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #bf7326; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs:hover,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs:hover {\n  background: rgba(217, 130, 43, 0.2);\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs:active,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3);\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs:disabled,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(255, 179, 102, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(217, 130, 43, 0.3); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #c23030; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:active,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #c23030; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:hover,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:hover {\n  background: rgba(219, 55, 55, 0.15);\n  color: #c23030; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:active,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3);\n  color: #c23030; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:disabled,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(194, 48, 48, 0.5); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ-, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #c23030; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj:hover,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj:hover {\n  background: rgba(219, 55, 55, 0.2);\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj:active,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3);\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj:disabled,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV {\n  background: none;\n  color: rgba(255, 115, 115, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-dark__3R7GO select.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(219, 55, 55, 0.3); }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-large__17hsQ select,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-large__17hsQ select {\n  font-size: 16px;\n  height: 40px;\n  padding-right: 35px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select {\n  background-color: #394b59;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.05)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select.ReportsFilter_bp3-active__1Mw-V {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select:hover {\n  background-color: #30404d;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #202b33;\n  background-image: none;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select.ReportsFilter_bp3-disabled__1YzwV, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(57, 75, 89, 0.5);\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(57, 75, 89, 0.7); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh select .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ-, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-select__1n6gy select .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  background: rgba(16, 22, 26, 0.5);\n  stroke: #8a9ba8; }\n\n.ReportsFilter_bp3-html-select__2bWXh select:disabled,\n.ReportsFilter_bp3-select__1n6gy select:disabled {\n  background-color: rgba(206, 217, 224, 0.5);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-html-select__2bWXh .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-select__1n6gy .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-select__1n6gy::after {\n  color: #5c7080;\n  pointer-events: none;\n  position: absolute;\n  right: 7px;\n  top: 7px; }\n\n.ReportsFilter_bp3-html-select__2bWXh .ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-select__1n6gy .ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-select__1n6gy::after {\n  color: rgba(92, 112, 128, 0.6); }\n\n.ReportsFilter_bp3-html-select__2bWXh,\n.ReportsFilter_bp3-select__1n6gy {\n  display: inline-block;\n  letter-spacing: normal;\n  position: relative;\n  vertical-align: middle; }\n\n.ReportsFilter_bp3-html-select__2bWXh select::-ms-expand,\n.ReportsFilter_bp3-select__1n6gy select::-ms-expand {\n  display: none; }\n\n.ReportsFilter_bp3-html-select__2bWXh .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-select__1n6gy .ReportsFilter_bp3-icon__15ATj {\n  color: #5c7080; }\n\n.ReportsFilter_bp3-html-select__2bWXh .ReportsFilter_bp3-icon__15ATj:hover,\n.ReportsFilter_bp3-select__1n6gy .ReportsFilter_bp3-icon__15ATj:hover {\n  color: #182026; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-dark__3R7GO\n.ReportsFilter_bp3-select__1n6gy .ReportsFilter_bp3-icon__15ATj {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh .ReportsFilter_bp3-icon__15ATj:hover, .ReportsFilter_bp3-dark__3R7GO\n.ReportsFilter_bp3-select__1n6gy .ReportsFilter_bp3-icon__15ATj:hover {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-large__17hsQ::after,\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-large__17hsQ::after,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-icon__15ATj {\n  right: 12px;\n  top: 12px; }\n\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-fill__3iORs,\n.ReportsFilter_bp3-html-select__2bWXh.ReportsFilter_bp3-fill__3iORs select,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-fill__3iORs,\n.ReportsFilter_bp3-select__1n6gy.ReportsFilter_bp3-fill__3iORs select {\n  width: 100%; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh option, .ReportsFilter_bp3-dark__3R7GO\n.ReportsFilter_bp3-select__1n6gy option {\n  background-color: #30404d;\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh option:disabled, .ReportsFilter_bp3-dark__3R7GO\n.ReportsFilter_bp3-select__1n6gy option:disabled {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-html-select__2bWXh::after, .ReportsFilter_bp3-dark__3R7GO\n.ReportsFilter_bp3-select__1n6gy::after {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-select__1n6gy::after {\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\E6C6\"; }\n\n.ReportsFilter_bp3-running-text__1-CIx table, table.ReportsFilter_bp3-html-table__2D18y {\n  border-spacing: 0;\n  font-size: 14px; }\n\n.ReportsFilter_bp3-running-text__1-CIx table th, table.ReportsFilter_bp3-html-table__2D18y th,\n.ReportsFilter_bp3-running-text__1-CIx table td,\ntable.ReportsFilter_bp3-html-table__2D18y td {\n  padding: 11px;\n  text-align: left;\n  vertical-align: top; }\n\n.ReportsFilter_bp3-running-text__1-CIx table th, table.ReportsFilter_bp3-html-table__2D18y th {\n  color: #182026;\n  font-weight: 600; }\n\n.ReportsFilter_bp3-running-text__1-CIx table td,\ntable.ReportsFilter_bp3-html-table__2D18y td {\n  color: #182026; }\n\n.ReportsFilter_bp3-running-text__1-CIx table tbody tr:first-child th, table.ReportsFilter_bp3-html-table__2D18y tbody tr:first-child th,\n.ReportsFilter_bp3-running-text__1-CIx table tbody tr:first-child td,\ntable.ReportsFilter_bp3-html-table__2D18y tbody tr:first-child td {\n  -webkit-box-shadow: inset 0 1px 0 0 rgba(16, 22, 26, 0.15);\n  box-shadow: inset 0 1px 0 0 rgba(16, 22, 26, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx table th, .ReportsFilter_bp3-running-text__1-CIx .ReportsFilter_bp3-dark__3R7GO table th, .ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y th {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx table td, .ReportsFilter_bp3-running-text__1-CIx .ReportsFilter_bp3-dark__3R7GO table td, .ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y td {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx table tbody tr:first-child th, .ReportsFilter_bp3-running-text__1-CIx .ReportsFilter_bp3-dark__3R7GO table tbody tr:first-child th, .ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y tbody tr:first-child th,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-running-text__1-CIx table tbody tr:first-child td,\n.ReportsFilter_bp3-running-text__1-CIx .ReportsFilter_bp3-dark__3R7GO table tbody tr:first-child td,\n.ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y tbody tr:first-child td {\n  -webkit-box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.15);\n  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.15); }\n\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-condensed__pmTFp th,\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-condensed__pmTFp td, table.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-small__2yDvz th,\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-small__2yDvz td {\n  padding-bottom: 6px;\n  padding-top: 6px; }\n\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-striped__3pQR3 tbody tr:nth-child(odd) td {\n  background: rgba(191, 204, 214, 0.15); }\n\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-bordered__2XAnt th:not(:first-child) {\n  -webkit-box-shadow: inset 1px 0 0 0 rgba(16, 22, 26, 0.15);\n  box-shadow: inset 1px 0 0 0 rgba(16, 22, 26, 0.15); }\n\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-bordered__2XAnt tbody tr td {\n  -webkit-box-shadow: inset 0 1px 0 0 rgba(16, 22, 26, 0.15);\n  box-shadow: inset 0 1px 0 0 rgba(16, 22, 26, 0.15); }\n\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-bordered__2XAnt tbody tr td:not(:first-child) {\n  -webkit-box-shadow: inset 1px 1px 0 0 rgba(16, 22, 26, 0.15);\n  box-shadow: inset 1px 1px 0 0 rgba(16, 22, 26, 0.15); }\n\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-bordered__2XAnt.ReportsFilter_bp3-html-table-striped__3pQR3 tbody tr:not(:first-child) td {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-bordered__2XAnt.ReportsFilter_bp3-html-table-striped__3pQR3 tbody tr:not(:first-child) td:not(:first-child) {\n  -webkit-box-shadow: inset 1px 0 0 0 rgba(16, 22, 26, 0.15);\n  box-shadow: inset 1px 0 0 0 rgba(16, 22, 26, 0.15); }\n\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-interactive__3MyBv tbody tr:hover td {\n  background-color: rgba(191, 204, 214, 0.3);\n  cursor: pointer; }\n\ntable.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-interactive__3MyBv tbody tr:active td {\n  background-color: rgba(191, 204, 214, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-striped__3pQR3 tbody tr:nth-child(odd) td {\n  background: rgba(92, 112, 128, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-bordered__2XAnt th:not(:first-child) {\n  -webkit-box-shadow: inset 1px 0 0 0 rgba(255, 255, 255, 0.15);\n  box-shadow: inset 1px 0 0 0 rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-bordered__2XAnt tbody tr td {\n  -webkit-box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.15);\n  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-bordered__2XAnt tbody tr td:not(:first-child) {\n  -webkit-box-shadow: inset 1px 1px 0 0 rgba(255, 255, 255, 0.15);\n  box-shadow: inset 1px 1px 0 0 rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-bordered__2XAnt.ReportsFilter_bp3-html-table-striped__3pQR3 tbody tr:not(:first-child) td {\n  -webkit-box-shadow: inset 1px 0 0 0 rgba(255, 255, 255, 0.15);\n  box-shadow: inset 1px 0 0 0 rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-html-table-bordered__2XAnt.ReportsFilter_bp3-html-table-striped__3pQR3 tbody tr:not(:first-child) td:first-child {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-interactive__3MyBv tbody tr:hover td {\n  background-color: rgba(92, 112, 128, 0.3);\n  cursor: pointer; }\n\n.ReportsFilter_bp3-dark__3R7GO table.ReportsFilter_bp3-html-table__2D18y.ReportsFilter_bp3-interactive__3MyBv tbody tr:active td {\n  background-color: rgba(92, 112, 128, 0.4); }\n\n.ReportsFilter_bp3-key-combo__aTGvP {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center; }\n\n.ReportsFilter_bp3-key-combo__aTGvP > * {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0; }\n\n.ReportsFilter_bp3-key-combo__aTGvP > .ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1; }\n\n.ReportsFilter_bp3-key-combo__aTGvP::before,\n.ReportsFilter_bp3-key-combo__aTGvP > * {\n  margin-right: 5px; }\n\n.ReportsFilter_bp3-key-combo__aTGvP:empty::before,\n.ReportsFilter_bp3-key-combo__aTGvP > :last-child {\n  margin-right: 0; }\n\n.ReportsFilter_bp3-hotkey-dialog__1jBRE {\n  padding-bottom: 0;\n  top: 40px; }\n\n.ReportsFilter_bp3-hotkey-dialog__1jBRE .ReportsFilter_bp3-dialog-body__1i105 {\n  margin: 0;\n  padding: 0; }\n\n.ReportsFilter_bp3-hotkey-dialog__1jBRE .ReportsFilter_bp3-hotkey-label__2nHmy {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1; }\n\n.ReportsFilter_bp3-hotkey-column__1rUiN {\n  margin: auto;\n  max-height: 80vh;\n  overflow-y: auto;\n  padding: 30px; }\n\n.ReportsFilter_bp3-hotkey-column__1rUiN .ReportsFilter_bp3-heading__H7aWJ {\n  margin-bottom: 20px; }\n\n.ReportsFilter_bp3-hotkey-column__1rUiN .ReportsFilter_bp3-heading__H7aWJ:not(:first-child) {\n  margin-top: 40px; }\n\n.ReportsFilter_bp3-hotkey__2VDAn {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  margin-left: 0;\n  margin-right: 0; }\n\n.ReportsFilter_bp3-hotkey__2VDAn:not(:last-child) {\n  margin-bottom: 10px; }\n\n.ReportsFilter_bp3-icon__15ATj {\n  display: inline-block;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  vertical-align: text-bottom; }\n\n.ReportsFilter_bp3-icon__15ATj:not(:empty)::before {\n  content: \"\" !important;\n  content: unset !important; }\n\n.ReportsFilter_bp3-icon__15ATj > svg {\n  display: block; }\n\n.ReportsFilter_bp3-icon__15ATj > svg:not([fill]) {\n  fill: currentColor; }\n\n.ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #0d8050; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-warning__372vs {\n  color: #bf7326; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-warning__372vs {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #c23030; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #ff7373; }\n\nspan.ReportsFilter_bp3-icon-standard__1vHca {\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block; }\n\nspan.ReportsFilter_bp3-icon-large__oZ-F2 {\n  font-family: \"Icons20\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block; }\n\nspan.ReportsFilter_bp3-icon__15ATj:empty {\n  font-family: \"Icons20\";\n  font-size: inherit;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1; }\n\nspan.ReportsFilter_bp3-icon__15ATj:empty::before {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased; }\n\n.ReportsFilter_bp3-icon-add__Df27M::before {\n  content: \"\\E63E\"; }\n\n.ReportsFilter_bp3-icon-add-column-left__3wyOm::before {\n  content: \"\\E6F9\"; }\n\n.ReportsFilter_bp3-icon-add-column-right__23YMl::before {\n  content: \"\\E6FA\"; }\n\n.ReportsFilter_bp3-icon-add-row-bottom__2xpmY::before {\n  content: \"\\E6F8\"; }\n\n.ReportsFilter_bp3-icon-add-row-top__CogHl::before {\n  content: \"\\E6F7\"; }\n\n.ReportsFilter_bp3-icon-add-to-artifact__2uwAC::before {\n  content: \"\\E67C\"; }\n\n.ReportsFilter_bp3-icon-add-to-folder__3Gk27::before {\n  content: \"\\E6D2\"; }\n\n.ReportsFilter_bp3-icon-airplane__ZWzg1::before {\n  content: \"\\E74B\"; }\n\n.ReportsFilter_bp3-icon-align-center__3OC-1::before {\n  content: \"\\E603\"; }\n\n.ReportsFilter_bp3-icon-align-justify__1mJmg::before {\n  content: \"\\E605\"; }\n\n.ReportsFilter_bp3-icon-align-left__3-tF3::before {\n  content: \"\\E602\"; }\n\n.ReportsFilter_bp3-icon-align-right__3Sngj::before {\n  content: \"\\E604\"; }\n\n.ReportsFilter_bp3-icon-alignment-bottom__2QD5M::before {\n  content: \"\\E727\"; }\n\n.ReportsFilter_bp3-icon-alignment-horizontal-center__3T0k3::before {\n  content: \"\\E726\"; }\n\n.ReportsFilter_bp3-icon-alignment-left__B-Xai::before {\n  content: \"\\E722\"; }\n\n.ReportsFilter_bp3-icon-alignment-right__ZcHEx::before {\n  content: \"\\E724\"; }\n\n.ReportsFilter_bp3-icon-alignment-top__39_VC::before {\n  content: \"\\E725\"; }\n\n.ReportsFilter_bp3-icon-alignment-vertical-center__2GIMP::before {\n  content: \"\\E723\"; }\n\n.ReportsFilter_bp3-icon-annotation__19kDF::before {\n  content: \"\\E6F0\"; }\n\n.ReportsFilter_bp3-icon-application__2T9p2::before {\n  content: \"\\E735\"; }\n\n.ReportsFilter_bp3-icon-applications__3CsEa::before {\n  content: \"\\E621\"; }\n\n.ReportsFilter_bp3-icon-archive__39cEW::before {\n  content: \"\\E907\"; }\n\n.ReportsFilter_bp3-icon-arrow-bottom-left__2sqf1::before {\n  content: \"\\2199\"; }\n\n.ReportsFilter_bp3-icon-arrow-bottom-right__2I86t::before {\n  content: \"\\2198\"; }\n\n.ReportsFilter_bp3-icon-arrow-down__2j-XQ::before {\n  content: \"\\2193\"; }\n\n.ReportsFilter_bp3-icon-arrow-left__22_Li::before {\n  content: \"\\2190\"; }\n\n.ReportsFilter_bp3-icon-arrow-right__kB9HC::before {\n  content: \"\\2192\"; }\n\n.ReportsFilter_bp3-icon-arrow-top-left__NW8C9::before {\n  content: \"\\2196\"; }\n\n.ReportsFilter_bp3-icon-arrow-top-right__GPVQ2::before {\n  content: \"\\2197\"; }\n\n.ReportsFilter_bp3-icon-arrow-up__znzv_::before {\n  content: \"\\2191\"; }\n\n.ReportsFilter_bp3-icon-arrows-horizontal__2jMu2::before {\n  content: \"\\2194\"; }\n\n.ReportsFilter_bp3-icon-arrows-vertical__3notf::before {\n  content: \"\\2195\"; }\n\n.ReportsFilter_bp3-icon-asterisk__npXaV::before {\n  content: \"*\"; }\n\n.ReportsFilter_bp3-icon-automatic-updates__20l9j::before {\n  content: \"\\E65F\"; }\n\n.ReportsFilter_bp3-icon-badge__6thHC::before {\n  content: \"\\E6E3\"; }\n\n.ReportsFilter_bp3-icon-ban-circle__2eDKt::before {\n  content: \"\\E69D\"; }\n\n.ReportsFilter_bp3-icon-bank-account__tybUV::before {\n  content: \"\\E76F\"; }\n\n.ReportsFilter_bp3-icon-barcode__27MMJ::before {\n  content: \"\\E676\"; }\n\n.ReportsFilter_bp3-icon-blank__3G8B7::before {\n  content: \"\\E900\"; }\n\n.ReportsFilter_bp3-icon-blocked-person__2kn5i::before {\n  content: \"\\E768\"; }\n\n.ReportsFilter_bp3-icon-bold__332xe::before {\n  content: \"\\E606\"; }\n\n.ReportsFilter_bp3-icon-book__1mQ17::before {\n  content: \"\\E6B8\"; }\n\n.ReportsFilter_bp3-icon-bookmark__3Z5a1::before {\n  content: \"\\E61A\"; }\n\n.ReportsFilter_bp3-icon-box__rFuHx::before {\n  content: \"\\E6BF\"; }\n\n.ReportsFilter_bp3-icon-briefcase__24iVG::before {\n  content: \"\\E674\"; }\n\n.ReportsFilter_bp3-icon-bring-data__2b5iR::before {\n  content: \"\\E90A\"; }\n\n.ReportsFilter_bp3-icon-build__2uohy::before {\n  content: \"\\E72D\"; }\n\n.ReportsFilter_bp3-icon-calculator__pOmZ0::before {\n  content: \"\\E70B\"; }\n\n.ReportsFilter_bp3-icon-calendar__1OFGx::before {\n  content: \"\\E62B\"; }\n\n.ReportsFilter_bp3-icon-camera__1hFIv::before {\n  content: \"\\E69E\"; }\n\n.ReportsFilter_bp3-icon-caret-down__Axxpv::before {\n  content: \"\\2304\"; }\n\n.ReportsFilter_bp3-icon-caret-left__30qps::before {\n  content: \"\\2329\"; }\n\n.ReportsFilter_bp3-icon-caret-right__2zeSN::before {\n  content: \"\\232A\"; }\n\n.ReportsFilter_bp3-icon-caret-up__1c_9C::before {\n  content: \"\\2303\"; }\n\n.ReportsFilter_bp3-icon-cell-tower__2QzCU::before {\n  content: \"\\E770\"; }\n\n.ReportsFilter_bp3-icon-changes__35ZL4::before {\n  content: \"\\E623\"; }\n\n.ReportsFilter_bp3-icon-chart__UyUH1::before {\n  content: \"\\E67E\"; }\n\n.ReportsFilter_bp3-icon-chat__3ZKBY::before {\n  content: \"\\E689\"; }\n\n.ReportsFilter_bp3-icon-chevron-backward__27be8::before {\n  content: \"\\E6DF\"; }\n\n.ReportsFilter_bp3-icon-chevron-down__P4g0r::before {\n  content: \"\\E697\"; }\n\n.ReportsFilter_bp3-icon-chevron-forward__WnjSl::before {\n  content: \"\\E6E0\"; }\n\n.ReportsFilter_bp3-icon-chevron-left__H8_Sz::before {\n  content: \"\\E694\"; }\n\n.ReportsFilter_bp3-icon-chevron-right__e_qxV::before {\n  content: \"\\E695\"; }\n\n.ReportsFilter_bp3-icon-chevron-up__1AmGH::before {\n  content: \"\\E696\"; }\n\n.ReportsFilter_bp3-icon-circle__QT4-v::before {\n  content: \"\\E66A\"; }\n\n.ReportsFilter_bp3-icon-circle-arrow-down__29VJA::before {\n  content: \"\\E68E\"; }\n\n.ReportsFilter_bp3-icon-circle-arrow-left__1VOqv::before {\n  content: \"\\E68C\"; }\n\n.ReportsFilter_bp3-icon-circle-arrow-right__2iO5C::before {\n  content: \"\\E68B\"; }\n\n.ReportsFilter_bp3-icon-circle-arrow-up__5qRkU::before {\n  content: \"\\E68D\"; }\n\n.ReportsFilter_bp3-icon-citation__2riuO::before {\n  content: \"\\E61B\"; }\n\n.ReportsFilter_bp3-icon-clean__1BrpI::before {\n  content: \"\\E7C5\"; }\n\n.ReportsFilter_bp3-icon-clipboard__ROQgZ::before {\n  content: \"\\E61D\"; }\n\n.ReportsFilter_bp3-icon-cloud__1595W::before {\n  content: \"\\2601\"; }\n\n.ReportsFilter_bp3-icon-cloud-download__2T17v::before {\n  content: \"\\E690\"; }\n\n.ReportsFilter_bp3-icon-cloud-upload__1Kevk::before {\n  content: \"\\E691\"; }\n\n.ReportsFilter_bp3-icon-code__3imOG::before {\n  content: \"\\E661\"; }\n\n.ReportsFilter_bp3-icon-code-block__36P67::before {\n  content: \"\\E6C5\"; }\n\n.ReportsFilter_bp3-icon-cog__3wyal::before {\n  content: \"\\E645\"; }\n\n.ReportsFilter_bp3-icon-collapse-all__2itkn::before {\n  content: \"\\E763\"; }\n\n.ReportsFilter_bp3-icon-column-layout__3iZcq::before {\n  content: \"\\E6DA\"; }\n\n.ReportsFilter_bp3-icon-comment__2uVyn::before {\n  content: \"\\E68A\"; }\n\n.ReportsFilter_bp3-icon-comparison__138Hz::before {\n  content: \"\\E637\"; }\n\n.ReportsFilter_bp3-icon-compass__E0jmR::before {\n  content: \"\\E79C\"; }\n\n.ReportsFilter_bp3-icon-compressed__GeBQ5::before {\n  content: \"\\E6C0\"; }\n\n.ReportsFilter_bp3-icon-confirm__3H0wm::before {\n  content: \"\\E639\"; }\n\n.ReportsFilter_bp3-icon-console__2DXTA::before {\n  content: \"\\E79B\"; }\n\n.ReportsFilter_bp3-icon-contrast__2YE48::before {\n  content: \"\\E6CB\"; }\n\n.ReportsFilter_bp3-icon-control__2YSYp::before {\n  content: \"\\E67F\"; }\n\n.ReportsFilter_bp3-icon-credit-card__TnV_i::before {\n  content: \"\\E649\"; }\n\n.ReportsFilter_bp3-icon-cross__3pYix::before {\n  content: \"\\2717\"; }\n\n.ReportsFilter_bp3-icon-crown__3DS5Y::before {\n  content: \"\\E7B4\"; }\n\n.ReportsFilter_bp3-icon-cube__3qE-a::before {\n  content: \"\\E7C8\"; }\n\n.ReportsFilter_bp3-icon-cube-add__E1Ln3::before {\n  content: \"\\E7C9\"; }\n\n.ReportsFilter_bp3-icon-cube-remove__9RxGL::before {\n  content: \"\\E7D0\"; }\n\n.ReportsFilter_bp3-icon-curved-range-chart__2sN9I::before {\n  content: \"\\E71B\"; }\n\n.ReportsFilter_bp3-icon-cut__2DiLi::before {\n  content: \"\\E6EF\"; }\n\n.ReportsFilter_bp3-icon-dashboard__3EVJc::before {\n  content: \"\\E751\"; }\n\n.ReportsFilter_bp3-icon-data-lineage__3Lpcp::before {\n  content: \"\\E908\"; }\n\n.ReportsFilter_bp3-icon-database__A3w73::before {\n  content: \"\\E683\"; }\n\n.ReportsFilter_bp3-icon-delete__3g-iN::before {\n  content: \"\\E644\"; }\n\n.ReportsFilter_bp3-icon-delta__3Qz56::before {\n  content: \"\\394\"; }\n\n.ReportsFilter_bp3-icon-derive-column__NRxlI::before {\n  content: \"\\E739\"; }\n\n.ReportsFilter_bp3-icon-desktop__2Y_oV::before {\n  content: \"\\E6AF\"; }\n\n.ReportsFilter_bp3-icon-diagnosis__XaQhw::before {\n  content: \"\\E90D\"; }\n\n.ReportsFilter_bp3-icon-diagram-tree__plUv3::before {\n  content: \"\\E7B3\"; }\n\n.ReportsFilter_bp3-icon-direction-left__8qvnm::before {\n  content: \"\\E681\"; }\n\n.ReportsFilter_bp3-icon-direction-right__SOSkT::before {\n  content: \"\\E682\"; }\n\n.ReportsFilter_bp3-icon-disable__HPdtO::before {\n  content: \"\\E600\"; }\n\n.ReportsFilter_bp3-icon-document__hc3_-::before {\n  content: \"\\E630\"; }\n\n.ReportsFilter_bp3-icon-document-open__2a1yq::before {\n  content: \"\\E71E\"; }\n\n.ReportsFilter_bp3-icon-document-share__3Zj2Q::before {\n  content: \"\\E71F\"; }\n\n.ReportsFilter_bp3-icon-dollar__11lo5::before {\n  content: \"$\"; }\n\n.ReportsFilter_bp3-icon-dot__29e7j::before {\n  content: \"\\2022\"; }\n\n.ReportsFilter_bp3-icon-double-caret-horizontal___lLsB::before {\n  content: \"\\E6C7\"; }\n\n.ReportsFilter_bp3-icon-double-caret-vertical__2my9t::before {\n  content: \"\\E6C6\"; }\n\n.ReportsFilter_bp3-icon-double-chevron-down__1NMJe::before {\n  content: \"\\E703\"; }\n\n.ReportsFilter_bp3-icon-double-chevron-left__2uhae::before {\n  content: \"\\E6FF\"; }\n\n.ReportsFilter_bp3-icon-double-chevron-right__guAUk::before {\n  content: \"\\E701\"; }\n\n.ReportsFilter_bp3-icon-double-chevron-up__2Vd55::before {\n  content: \"\\E702\"; }\n\n.ReportsFilter_bp3-icon-doughnut-chart__2xjRH::before {\n  content: \"\\E6CE\"; }\n\n.ReportsFilter_bp3-icon-download__3lV72::before {\n  content: \"\\E62F\"; }\n\n.ReportsFilter_bp3-icon-drag-handle-horizontal__W9f4H::before {\n  content: \"\\E716\"; }\n\n.ReportsFilter_bp3-icon-drag-handle-vertical__OD3yz::before {\n  content: \"\\E715\"; }\n\n.ReportsFilter_bp3-icon-draw__2nr4v::before {\n  content: \"\\E66B\"; }\n\n.ReportsFilter_bp3-icon-drive-time__2xgmb::before {\n  content: \"\\E615\"; }\n\n.ReportsFilter_bp3-icon-duplicate__3YGcF::before {\n  content: \"\\E69C\"; }\n\n.ReportsFilter_bp3-icon-edit__3EbpT::before {\n  content: \"\\270E\"; }\n\n.ReportsFilter_bp3-icon-eject__1x18S::before {\n  content: \"\\23CF\"; }\n\n.ReportsFilter_bp3-icon-endorsed__SsEts::before {\n  content: \"\\E75F\"; }\n\n.ReportsFilter_bp3-icon-envelope__2e94x::before {\n  content: \"\\2709\"; }\n\n.ReportsFilter_bp3-icon-equals__2faj7::before {\n  content: \"\\E7D9\"; }\n\n.ReportsFilter_bp3-icon-eraser__3l1MR::before {\n  content: \"\\E773\"; }\n\n.ReportsFilter_bp3-icon-error__30dyX::before {\n  content: \"\\E648\"; }\n\n.ReportsFilter_bp3-icon-euro___tTFe::before {\n  content: \"\\20AC\"; }\n\n.ReportsFilter_bp3-icon-exchange__2t4IN::before {\n  content: \"\\E636\"; }\n\n.ReportsFilter_bp3-icon-exclude-row__38r8l::before {\n  content: \"\\E6EA\"; }\n\n.ReportsFilter_bp3-icon-expand-all__10N5P::before {\n  content: \"\\E764\"; }\n\n.ReportsFilter_bp3-icon-export__JitBo::before {\n  content: \"\\E633\"; }\n\n.ReportsFilter_bp3-icon-eye-off__1pUqp::before {\n  content: \"\\E6CC\"; }\n\n.ReportsFilter_bp3-icon-eye-on__Yksw0::before {\n  content: \"\\E75A\"; }\n\n.ReportsFilter_bp3-icon-eye-open__3sQS8::before {\n  content: \"\\E66F\"; }\n\n.ReportsFilter_bp3-icon-fast-backward__IxKSE::before {\n  content: \"\\E6A8\"; }\n\n.ReportsFilter_bp3-icon-fast-forward__25_7b::before {\n  content: \"\\E6AC\"; }\n\n.ReportsFilter_bp3-icon-feed__yWTP4::before {\n  content: \"\\E656\"; }\n\n.ReportsFilter_bp3-icon-feed-subscribed__4Fn8w::before {\n  content: \"\\E78F\"; }\n\n.ReportsFilter_bp3-icon-film__2Gr9X::before {\n  content: \"\\E6A1\"; }\n\n.ReportsFilter_bp3-icon-filter__1kjTP::before {\n  content: \"\\E638\"; }\n\n.ReportsFilter_bp3-icon-filter-keep__5iQh7::before {\n  content: \"\\E78C\"; }\n\n.ReportsFilter_bp3-icon-filter-list__2mRnu::before {\n  content: \"\\E6EE\"; }\n\n.ReportsFilter_bp3-icon-filter-open__2ZMcw::before {\n  content: \"\\E7D7\"; }\n\n.ReportsFilter_bp3-icon-filter-remove__3V_Q9::before {\n  content: \"\\E78D\"; }\n\n.ReportsFilter_bp3-icon-flag__SF-M-::before {\n  content: \"\\2691\"; }\n\n.ReportsFilter_bp3-icon-flame__3SK31::before {\n  content: \"\\E7A9\"; }\n\n.ReportsFilter_bp3-icon-flash__cb8ir::before {\n  content: \"\\E6B3\"; }\n\n.ReportsFilter_bp3-icon-floppy-disk__2Q9Kz::before {\n  content: \"\\E6B7\"; }\n\n.ReportsFilter_bp3-icon-flow-branch__Fbmet::before {\n  content: \"\\E7C1\"; }\n\n.ReportsFilter_bp3-icon-flow-end__2qqbz::before {\n  content: \"\\E7C4\"; }\n\n.ReportsFilter_bp3-icon-flow-linear__3JPBQ::before {\n  content: \"\\E7C0\"; }\n\n.ReportsFilter_bp3-icon-flow-review__3lWaw::before {\n  content: \"\\E7C2\"; }\n\n.ReportsFilter_bp3-icon-flow-review-branch__7R82O::before {\n  content: \"\\E7C3\"; }\n\n.ReportsFilter_bp3-icon-flows__3CMTR::before {\n  content: \"\\E659\"; }\n\n.ReportsFilter_bp3-icon-folder-close__p52r5::before {\n  content: \"\\E652\"; }\n\n.ReportsFilter_bp3-icon-folder-new__2gcYm::before {\n  content: \"\\E7B0\"; }\n\n.ReportsFilter_bp3-icon-folder-open__3wBoQ::before {\n  content: \"\\E651\"; }\n\n.ReportsFilter_bp3-icon-folder-shared__1jOO4::before {\n  content: \"\\E653\"; }\n\n.ReportsFilter_bp3-icon-folder-shared-open__3h9ll::before {\n  content: \"\\E670\"; }\n\n.ReportsFilter_bp3-icon-follower__24Bcq::before {\n  content: \"\\E760\"; }\n\n.ReportsFilter_bp3-icon-following__3YnjU::before {\n  content: \"\\E761\"; }\n\n.ReportsFilter_bp3-icon-font__36w5g::before {\n  content: \"\\E6B4\"; }\n\n.ReportsFilter_bp3-icon-fork__3DVu7::before {\n  content: \"\\E63A\"; }\n\n.ReportsFilter_bp3-icon-form__14gRr::before {\n  content: \"\\E795\"; }\n\n.ReportsFilter_bp3-icon-full-circle__cwrwk::before {\n  content: \"\\E685\"; }\n\n.ReportsFilter_bp3-icon-full-stacked-chart__3ENLe::before {\n  content: \"\\E75E\"; }\n\n.ReportsFilter_bp3-icon-fullscreen__3MQ8l::before {\n  content: \"\\E699\"; }\n\n.ReportsFilter_bp3-icon-function__1UieG::before {\n  content: \"\\E6E5\"; }\n\n.ReportsFilter_bp3-icon-gantt-chart__2oKOO::before {\n  content: \"\\E6F4\"; }\n\n.ReportsFilter_bp3-icon-geolocation__N8_xd::before {\n  content: \"\\E640\"; }\n\n.ReportsFilter_bp3-icon-geosearch__TsiMd::before {\n  content: \"\\E613\"; }\n\n.ReportsFilter_bp3-icon-git-branch__34PH0::before {\n  content: \"\\E72A\"; }\n\n.ReportsFilter_bp3-icon-git-commit__7TBCU::before {\n  content: \"\\E72B\"; }\n\n.ReportsFilter_bp3-icon-git-merge__M5kbM::before {\n  content: \"\\E729\"; }\n\n.ReportsFilter_bp3-icon-git-new-branch__FVdKt::before {\n  content: \"\\E749\"; }\n\n.ReportsFilter_bp3-icon-git-pull__YNgLD::before {\n  content: \"\\E728\"; }\n\n.ReportsFilter_bp3-icon-git-push__4FgDL::before {\n  content: \"\\E72C\"; }\n\n.ReportsFilter_bp3-icon-git-repo__W0x70::before {\n  content: \"\\E748\"; }\n\n.ReportsFilter_bp3-icon-glass__1oL6P::before {\n  content: \"\\E6B1\"; }\n\n.ReportsFilter_bp3-icon-globe__1cV_j::before {\n  content: \"\\E666\"; }\n\n.ReportsFilter_bp3-icon-globe-network__VNDiC::before {\n  content: \"\\E7B5\"; }\n\n.ReportsFilter_bp3-icon-graph__1KL0w::before {\n  content: \"\\E673\"; }\n\n.ReportsFilter_bp3-icon-graph-remove__2NjZf::before {\n  content: \"\\E609\"; }\n\n.ReportsFilter_bp3-icon-greater-than__27AqE::before {\n  content: \"\\E7E1\"; }\n\n.ReportsFilter_bp3-icon-greater-than-or-equal-to__55jLD::before {\n  content: \"\\E7E2\"; }\n\n.ReportsFilter_bp3-icon-grid__3Va2T::before {\n  content: \"\\E6D0\"; }\n\n.ReportsFilter_bp3-icon-grid-view__2lW7u::before {\n  content: \"\\E6E4\"; }\n\n.ReportsFilter_bp3-icon-group-objects__1DNvl::before {\n  content: \"\\E60A\"; }\n\n.ReportsFilter_bp3-icon-grouped-bar-chart__2-igC::before {\n  content: \"\\E75D\"; }\n\n.ReportsFilter_bp3-icon-hand__25WMF::before {\n  content: \"\\E6DE\"; }\n\n.ReportsFilter_bp3-icon-hand-down__38o25::before {\n  content: \"\\E6BB\"; }\n\n.ReportsFilter_bp3-icon-hand-left__15MMl::before {\n  content: \"\\E6BC\"; }\n\n.ReportsFilter_bp3-icon-hand-right__3Bd02::before {\n  content: \"\\E6B9\"; }\n\n.ReportsFilter_bp3-icon-hand-up__1x65o::before {\n  content: \"\\E6BA\"; }\n\n.ReportsFilter_bp3-icon-header__tY-SM::before {\n  content: \"\\E6B5\"; }\n\n.ReportsFilter_bp3-icon-header-one__3jmy5::before {\n  content: \"\\E793\"; }\n\n.ReportsFilter_bp3-icon-header-two__11qF5::before {\n  content: \"\\E794\"; }\n\n.ReportsFilter_bp3-icon-headset__iaS6U::before {\n  content: \"\\E6DC\"; }\n\n.ReportsFilter_bp3-icon-heart__1G-O1::before {\n  content: \"\\2665\"; }\n\n.ReportsFilter_bp3-icon-heart-broken__1Jqv-::before {\n  content: \"\\E7A2\"; }\n\n.ReportsFilter_bp3-icon-heat-grid__1uFNZ::before {\n  content: \"\\E6F3\"; }\n\n.ReportsFilter_bp3-icon-heatmap__X44Wv::before {\n  content: \"\\E614\"; }\n\n.ReportsFilter_bp3-icon-help__2o-h3::before {\n  content: \"?\"; }\n\n.ReportsFilter_bp3-icon-helper-management__2qUhQ::before {\n  content: \"\\E66D\"; }\n\n.ReportsFilter_bp3-icon-highlight__m5y-i::before {\n  content: \"\\E6ED\"; }\n\n.ReportsFilter_bp3-icon-history__3qncE::before {\n  content: \"\\E64A\"; }\n\n.ReportsFilter_bp3-icon-home__1EDec::before {\n  content: \"\\2302\"; }\n\n.ReportsFilter_bp3-icon-horizontal-bar-chart__1De6s::before {\n  content: \"\\E70C\"; }\n\n.ReportsFilter_bp3-icon-horizontal-bar-chart-asc__2osMi::before {\n  content: \"\\E75C\"; }\n\n.ReportsFilter_bp3-icon-horizontal-bar-chart-desc__2KhhM::before {\n  content: \"\\E71D\"; }\n\n.ReportsFilter_bp3-icon-horizontal-distribution__2yQfX::before {\n  content: \"\\E720\"; }\n\n.ReportsFilter_bp3-icon-id-number__2IGcY::before {\n  content: \"\\E771\"; }\n\n.ReportsFilter_bp3-icon-image-rotate-left__2ugeT::before {\n  content: \"\\E73A\"; }\n\n.ReportsFilter_bp3-icon-image-rotate-right__1Hl1X::before {\n  content: \"\\E73B\"; }\n\n.ReportsFilter_bp3-icon-import__2wx6K::before {\n  content: \"\\E632\"; }\n\n.ReportsFilter_bp3-icon-inbox__2Ku1x::before {\n  content: \"\\E629\"; }\n\n.ReportsFilter_bp3-icon-inbox-filtered__2Shz1::before {\n  content: \"\\E7D1\"; }\n\n.ReportsFilter_bp3-icon-inbox-geo__iGP81::before {\n  content: \"\\E7D2\"; }\n\n.ReportsFilter_bp3-icon-inbox-search__25Ozb::before {\n  content: \"\\E7D3\"; }\n\n.ReportsFilter_bp3-icon-inbox-update__1ZqLZ::before {\n  content: \"\\E7D4\"; }\n\n.ReportsFilter_bp3-icon-info-sign__1vUUZ::before {\n  content: \"\\2139\"; }\n\n.ReportsFilter_bp3-icon-inheritance__3AAnE::before {\n  content: \"\\E7D5\"; }\n\n.ReportsFilter_bp3-icon-inner-join__3xSsC::before {\n  content: \"\\E7A3\"; }\n\n.ReportsFilter_bp3-icon-insert__lSlqT::before {\n  content: \"\\E66C\"; }\n\n.ReportsFilter_bp3-icon-intersection__2Sszu::before {\n  content: \"\\E765\"; }\n\n.ReportsFilter_bp3-icon-ip-address__2HNIE::before {\n  content: \"\\E772\"; }\n\n.ReportsFilter_bp3-icon-issue__1CwAQ::before {\n  content: \"\\E774\"; }\n\n.ReportsFilter_bp3-icon-issue-closed__1MK9D::before {\n  content: \"\\E776\"; }\n\n.ReportsFilter_bp3-icon-issue-new__1Pow7::before {\n  content: \"\\E775\"; }\n\n.ReportsFilter_bp3-icon-italic__3Vz7E::before {\n  content: \"\\E607\"; }\n\n.ReportsFilter_bp3-icon-join-table__k6avZ::before {\n  content: \"\\E738\"; }\n\n.ReportsFilter_bp3-icon-key__3l20h::before {\n  content: \"\\E78E\"; }\n\n.ReportsFilter_bp3-icon-key-backspace__1ybq9::before {\n  content: \"\\E707\"; }\n\n.ReportsFilter_bp3-icon-key-command__1m-Wu::before {\n  content: \"\\E705\"; }\n\n.ReportsFilter_bp3-icon-key-control__1B86_::before {\n  content: \"\\E704\"; }\n\n.ReportsFilter_bp3-icon-key-delete__3adad::before {\n  content: \"\\E708\"; }\n\n.ReportsFilter_bp3-icon-key-enter__IG8yW::before {\n  content: \"\\E70A\"; }\n\n.ReportsFilter_bp3-icon-key-escape__fCWl5::before {\n  content: \"\\E709\"; }\n\n.ReportsFilter_bp3-icon-key-option__1di0w::before {\n  content: \"\\E742\"; }\n\n.ReportsFilter_bp3-icon-key-shift__35-2A::before {\n  content: \"\\E706\"; }\n\n.ReportsFilter_bp3-icon-key-tab__2wlS2::before {\n  content: \"\\E757\"; }\n\n.ReportsFilter_bp3-icon-known-vehicle__3mjGX::before {\n  content: \"\\E73C\"; }\n\n.ReportsFilter_bp3-icon-lab-test__2BEsy::before {\n  content: \"\\E90E\"; }\n\n.ReportsFilter_bp3-icon-label__3Yl0Z::before {\n  content: \"\\E665\"; }\n\n.ReportsFilter_bp3-icon-layer__x19_g::before {\n  content: \"\\E6CF\"; }\n\n.ReportsFilter_bp3-icon-layers__1EGCA::before {\n  content: \"\\E618\"; }\n\n.ReportsFilter_bp3-icon-layout__I18_A::before {\n  content: \"\\E60C\"; }\n\n.ReportsFilter_bp3-icon-layout-auto__2z6D3::before {\n  content: \"\\E60D\"; }\n\n.ReportsFilter_bp3-icon-layout-balloon__14nUC::before {\n  content: \"\\E6D3\"; }\n\n.ReportsFilter_bp3-icon-layout-circle__2G37D::before {\n  content: \"\\E60E\"; }\n\n.ReportsFilter_bp3-icon-layout-grid__2qxI8::before {\n  content: \"\\E610\"; }\n\n.ReportsFilter_bp3-icon-layout-group-by__2ivac::before {\n  content: \"\\E611\"; }\n\n.ReportsFilter_bp3-icon-layout-hierarchy__2o3ks::before {\n  content: \"\\E60F\"; }\n\n.ReportsFilter_bp3-icon-layout-linear__2cy_6::before {\n  content: \"\\E6C3\"; }\n\n.ReportsFilter_bp3-icon-layout-skew-grid__3G8eh::before {\n  content: \"\\E612\"; }\n\n.ReportsFilter_bp3-icon-layout-sorted-clusters__r5pWR::before {\n  content: \"\\E6D4\"; }\n\n.ReportsFilter_bp3-icon-learning__e4W4X::before {\n  content: \"\\E904\"; }\n\n.ReportsFilter_bp3-icon-left-join__pHS_y::before {\n  content: \"\\E7A4\"; }\n\n.ReportsFilter_bp3-icon-less-than__CohqG::before {\n  content: \"\\E7E3\"; }\n\n.ReportsFilter_bp3-icon-less-than-or-equal-to__3Q5MX::before {\n  content: \"\\E7E4\"; }\n\n.ReportsFilter_bp3-icon-lifesaver__21xVZ::before {\n  content: \"\\E7C7\"; }\n\n.ReportsFilter_bp3-icon-lightbulb__3-vCO::before {\n  content: \"\\E6B0\"; }\n\n.ReportsFilter_bp3-icon-link__36AbM::before {\n  content: \"\\E62D\"; }\n\n.ReportsFilter_bp3-icon-list__3WLvG::before {\n  content: \"\\2630\"; }\n\n.ReportsFilter_bp3-icon-list-columns__13K6H::before {\n  content: \"\\E7B9\"; }\n\n.ReportsFilter_bp3-icon-list-detail-view__3g3qs::before {\n  content: \"\\E743\"; }\n\n.ReportsFilter_bp3-icon-locate__2piB5::before {\n  content: \"\\E619\"; }\n\n.ReportsFilter_bp3-icon-lock__1yrjv::before {\n  content: \"\\E625\"; }\n\n.ReportsFilter_bp3-icon-log-in__2XkYv::before {\n  content: \"\\E69A\"; }\n\n.ReportsFilter_bp3-icon-log-out__10wvK::before {\n  content: \"\\E64C\"; }\n\n.ReportsFilter_bp3-icon-manual__wUxqs::before {\n  content: \"\\E6F6\"; }\n\n.ReportsFilter_bp3-icon-manually-entered-data__1mQD0::before {\n  content: \"\\E74A\"; }\n\n.ReportsFilter_bp3-icon-map__355AN::before {\n  content: \"\\E662\"; }\n\n.ReportsFilter_bp3-icon-map-create__3xdoT::before {\n  content: \"\\E741\"; }\n\n.ReportsFilter_bp3-icon-map-marker__S0GT8::before {\n  content: \"\\E67D\"; }\n\n.ReportsFilter_bp3-icon-maximize__16h43::before {\n  content: \"\\E635\"; }\n\n.ReportsFilter_bp3-icon-media__1Ezlb::before {\n  content: \"\\E62C\"; }\n\n.ReportsFilter_bp3-icon-menu__20rgd::before {\n  content: \"\\E762\"; }\n\n.ReportsFilter_bp3-icon-menu-closed__2lKI9::before {\n  content: \"\\E655\"; }\n\n.ReportsFilter_bp3-icon-menu-open__30kDy::before {\n  content: \"\\E654\"; }\n\n.ReportsFilter_bp3-icon-merge-columns__21Dnd::before {\n  content: \"\\E74F\"; }\n\n.ReportsFilter_bp3-icon-merge-links__kC8aY::before {\n  content: \"\\E60B\"; }\n\n.ReportsFilter_bp3-icon-minimize__3o76J::before {\n  content: \"\\E634\"; }\n\n.ReportsFilter_bp3-icon-minus__3xPRw::before {\n  content: \"\\2212\"; }\n\n.ReportsFilter_bp3-icon-mobile-phone__2M0iY::before {\n  content: \"\\E717\"; }\n\n.ReportsFilter_bp3-icon-mobile-video__19X-z::before {\n  content: \"\\E69F\"; }\n\n.ReportsFilter_bp3-icon-moon__1CrK-::before {\n  content: \"\\E754\"; }\n\n.ReportsFilter_bp3-icon-more__7pyjT::before {\n  content: \"\\E62A\"; }\n\n.ReportsFilter_bp3-icon-mountain__D3Ddu::before {\n  content: \"\\E7B1\"; }\n\n.ReportsFilter_bp3-icon-move__f_aHx::before {\n  content: \"\\E693\"; }\n\n.ReportsFilter_bp3-icon-mugshot__jQUyr::before {\n  content: \"\\E6DB\"; }\n\n.ReportsFilter_bp3-icon-multi-select__31Uxz::before {\n  content: \"\\E680\"; }\n\n.ReportsFilter_bp3-icon-music__rfqZI::before {\n  content: \"\\E6A6\"; }\n\n.ReportsFilter_bp3-icon-new-drawing__1JNY5::before {\n  content: \"\\E905\"; }\n\n.ReportsFilter_bp3-icon-new-grid-item__3NRNf::before {\n  content: \"\\E747\"; }\n\n.ReportsFilter_bp3-icon-new-layer__YkW40::before {\n  content: \"\\E902\"; }\n\n.ReportsFilter_bp3-icon-new-layers__11QC1::before {\n  content: \"\\E903\"; }\n\n.ReportsFilter_bp3-icon-new-link__1Clzo::before {\n  content: \"\\E65C\"; }\n\n.ReportsFilter_bp3-icon-new-object__1Tnvw::before {\n  content: \"\\E65D\"; }\n\n.ReportsFilter_bp3-icon-new-person__E2T6G::before {\n  content: \"\\E6E9\"; }\n\n.ReportsFilter_bp3-icon-new-prescription__2HeNV::before {\n  content: \"\\E78B\"; }\n\n.ReportsFilter_bp3-icon-new-text-box__2jRSf::before {\n  content: \"\\E65B\"; }\n\n.ReportsFilter_bp3-icon-ninja__1mSHs::before {\n  content: \"\\E675\"; }\n\n.ReportsFilter_bp3-icon-not-equal-to__J9D3U::before {\n  content: \"\\E7E0\"; }\n\n.ReportsFilter_bp3-icon-notifications__1Q-Y3::before {\n  content: \"\\E624\"; }\n\n.ReportsFilter_bp3-icon-notifications-updated__x-EZn::before {\n  content: \"\\E7B8\"; }\n\n.ReportsFilter_bp3-icon-numbered-list__253Fl::before {\n  content: \"\\E746\"; }\n\n.ReportsFilter_bp3-icon-numerical__1y9Ir::before {\n  content: \"\\E756\"; }\n\n.ReportsFilter_bp3-icon-office__2U_e1::before {\n  content: \"\\E69B\"; }\n\n.ReportsFilter_bp3-icon-offline__2_N4G::before {\n  content: \"\\E67A\"; }\n\n.ReportsFilter_bp3-icon-oil-field__31xpg::before {\n  content: \"\\E73F\"; }\n\n.ReportsFilter_bp3-icon-one-column__29R-1::before {\n  content: \"\\E658\"; }\n\n.ReportsFilter_bp3-icon-outdated__2wkeQ::before {\n  content: \"\\E7A8\"; }\n\n.ReportsFilter_bp3-icon-page-layout__TLhP7::before {\n  content: \"\\E660\"; }\n\n.ReportsFilter_bp3-icon-panel-stats__3pQYK::before {\n  content: \"\\E777\"; }\n\n.ReportsFilter_bp3-icon-panel-table__Zv10J::before {\n  content: \"\\E778\"; }\n\n.ReportsFilter_bp3-icon-paperclip__1Ow6s::before {\n  content: \"\\E664\"; }\n\n.ReportsFilter_bp3-icon-paragraph__30r6x::before {\n  content: \"\\E76C\"; }\n\n.ReportsFilter_bp3-icon-path__2vAig::before {\n  content: \"\\E753\"; }\n\n.ReportsFilter_bp3-icon-path-search__30KLz::before {\n  content: \"\\E65E\"; }\n\n.ReportsFilter_bp3-icon-pause__1hAyF::before {\n  content: \"\\E6A9\"; }\n\n.ReportsFilter_bp3-icon-people__2BCDL::before {\n  content: \"\\E63D\"; }\n\n.ReportsFilter_bp3-icon-percentage__2IOZn::before {\n  content: \"\\E76A\"; }\n\n.ReportsFilter_bp3-icon-person__32Jbj::before {\n  content: \"\\E63C\"; }\n\n.ReportsFilter_bp3-icon-phone__3prbt::before {\n  content: \"\\260E\"; }\n\n.ReportsFilter_bp3-icon-pie-chart__3RUc0::before {\n  content: \"\\E684\"; }\n\n.ReportsFilter_bp3-icon-pin__3T0i6::before {\n  content: \"\\E646\"; }\n\n.ReportsFilter_bp3-icon-pivot__3AIjN::before {\n  content: \"\\E6F1\"; }\n\n.ReportsFilter_bp3-icon-pivot-table__4oT47::before {\n  content: \"\\E6EB\"; }\n\n.ReportsFilter_bp3-icon-play__2tEPO::before {\n  content: \"\\E6AB\"; }\n\n.ReportsFilter_bp3-icon-plus__290EQ::before {\n  content: \"+\"; }\n\n.ReportsFilter_bp3-icon-polygon-filter__TgOnW::before {\n  content: \"\\E6D1\"; }\n\n.ReportsFilter_bp3-icon-power__2fn4_::before {\n  content: \"\\E6D9\"; }\n\n.ReportsFilter_bp3-icon-predictive-analysis__1Zkfj::before {\n  content: \"\\E617\"; }\n\n.ReportsFilter_bp3-icon-prescription__1-0Rq::before {\n  content: \"\\E78A\"; }\n\n.ReportsFilter_bp3-icon-presentation__3LNaJ::before {\n  content: \"\\E687\"; }\n\n.ReportsFilter_bp3-icon-print__JwSZN::before {\n  content: \"\\2399\"; }\n\n.ReportsFilter_bp3-icon-projects__2hhp4::before {\n  content: \"\\E622\"; }\n\n.ReportsFilter_bp3-icon-properties__2vPkt::before {\n  content: \"\\E631\"; }\n\n.ReportsFilter_bp3-icon-property__1iVTC::before {\n  content: \"\\E65A\"; }\n\n.ReportsFilter_bp3-icon-publish-function__1NkML::before {\n  content: \"\\E752\"; }\n\n.ReportsFilter_bp3-icon-pulse__1_Yun::before {\n  content: \"\\E6E8\"; }\n\n.ReportsFilter_bp3-icon-random__2RHyy::before {\n  content: \"\\E698\"; }\n\n.ReportsFilter_bp3-icon-record__2QSYI::before {\n  content: \"\\E6AE\"; }\n\n.ReportsFilter_bp3-icon-redo__1BQFZ::before {\n  content: \"\\E6C4\"; }\n\n.ReportsFilter_bp3-icon-refresh__3nJw1::before {\n  content: \"\\E643\"; }\n\n.ReportsFilter_bp3-icon-regression-chart__2mj7B::before {\n  content: \"\\E758\"; }\n\n.ReportsFilter_bp3-icon-remove__rSV4D::before {\n  content: \"\\E63F\"; }\n\n.ReportsFilter_bp3-icon-remove-column__2VjVq::before {\n  content: \"\\E755\"; }\n\n.ReportsFilter_bp3-icon-remove-column-left__9EITN::before {\n  content: \"\\E6FD\"; }\n\n.ReportsFilter_bp3-icon-remove-column-right__oAfYw::before {\n  content: \"\\E6FE\"; }\n\n.ReportsFilter_bp3-icon-remove-row-bottom__2rswH::before {\n  content: \"\\E6FC\"; }\n\n.ReportsFilter_bp3-icon-remove-row-top__3Cq-p::before {\n  content: \"\\E6FB\"; }\n\n.ReportsFilter_bp3-icon-repeat__2Gccl::before {\n  content: \"\\E692\"; }\n\n.ReportsFilter_bp3-icon-reset__2g3MO::before {\n  content: \"\\E7D6\"; }\n\n.ReportsFilter_bp3-icon-resolve__2kO5P::before {\n  content: \"\\E672\"; }\n\n.ReportsFilter_bp3-icon-rig__XS2G7::before {\n  content: \"\\E740\"; }\n\n.ReportsFilter_bp3-icon-right-join__2vlLe::before {\n  content: \"\\E7A5\"; }\n\n.ReportsFilter_bp3-icon-ring__1eayB::before {\n  content: \"\\E6F2\"; }\n\n.ReportsFilter_bp3-icon-rotate-document__2Cowo::before {\n  content: \"\\E6E1\"; }\n\n.ReportsFilter_bp3-icon-rotate-page__30S2Z::before {\n  content: \"\\E6E2\"; }\n\n.ReportsFilter_bp3-icon-satellite__xGV_1::before {\n  content: \"\\E76B\"; }\n\n.ReportsFilter_bp3-icon-saved__n2I45::before {\n  content: \"\\E6B6\"; }\n\n.ReportsFilter_bp3-icon-scatter-plot__193CP::before {\n  content: \"\\E73E\"; }\n\n.ReportsFilter_bp3-icon-search__2VoIy::before {\n  content: \"\\E64B\"; }\n\n.ReportsFilter_bp3-icon-search-around__AuDgC::before {\n  content: \"\\E608\"; }\n\n.ReportsFilter_bp3-icon-search-template__GweRX::before {\n  content: \"\\E628\"; }\n\n.ReportsFilter_bp3-icon-search-text__2qBBp::before {\n  content: \"\\E663\"; }\n\n.ReportsFilter_bp3-icon-segmented-control__3nSjO::before {\n  content: \"\\E6EC\"; }\n\n.ReportsFilter_bp3-icon-select__vPmUj::before {\n  content: \"\\E616\"; }\n\n.ReportsFilter_bp3-icon-selection__eussS::before {\n  content: \"\\29BF\"; }\n\n.ReportsFilter_bp3-icon-send-to__10ZTS::before {\n  content: \"\\E66E\"; }\n\n.ReportsFilter_bp3-icon-send-to-graph__2Ksiu::before {\n  content: \"\\E736\"; }\n\n.ReportsFilter_bp3-icon-send-to-map__1I_-7::before {\n  content: \"\\E737\"; }\n\n.ReportsFilter_bp3-icon-series-add__mWXoQ::before {\n  content: \"\\E796\"; }\n\n.ReportsFilter_bp3-icon-series-configuration__3-1gm::before {\n  content: \"\\E79A\"; }\n\n.ReportsFilter_bp3-icon-series-derived__3Ch1C::before {\n  content: \"\\E799\"; }\n\n.ReportsFilter_bp3-icon-series-filtered__LOhTv::before {\n  content: \"\\E798\"; }\n\n.ReportsFilter_bp3-icon-series-search__2An3z::before {\n  content: \"\\E797\"; }\n\n.ReportsFilter_bp3-icon-settings__1QBH7::before {\n  content: \"\\E6A2\"; }\n\n.ReportsFilter_bp3-icon-share__3vLY9::before {\n  content: \"\\E62E\"; }\n\n.ReportsFilter_bp3-icon-shield__1MXts::before {\n  content: \"\\E7B2\"; }\n\n.ReportsFilter_bp3-icon-shop__5itMd::before {\n  content: \"\\E6C2\"; }\n\n.ReportsFilter_bp3-icon-shopping-cart__2zamQ::before {\n  content: \"\\E6C1\"; }\n\n.ReportsFilter_bp3-icon-signal-search__1dKzS::before {\n  content: \"\\E909\"; }\n\n.ReportsFilter_bp3-icon-sim-card__fobti::before {\n  content: \"\\E718\"; }\n\n.ReportsFilter_bp3-icon-slash__3pGKH::before {\n  content: \"\\E769\"; }\n\n.ReportsFilter_bp3-icon-small-cross__1flc2::before {\n  content: \"\\E6D7\"; }\n\n.ReportsFilter_bp3-icon-small-minus__2bVsl::before {\n  content: \"\\E70E\"; }\n\n.ReportsFilter_bp3-icon-small-plus__62sgb::before {\n  content: \"\\E70D\"; }\n\n.ReportsFilter_bp3-icon-small-tick__3cNRv::before {\n  content: \"\\E6D8\"; }\n\n.ReportsFilter_bp3-icon-snowflake__cEgtj::before {\n  content: \"\\E7B6\"; }\n\n.ReportsFilter_bp3-icon-social-media__2kBh_::before {\n  content: \"\\E671\"; }\n\n.ReportsFilter_bp3-icon-sort__2F7sD::before {\n  content: \"\\E64F\"; }\n\n.ReportsFilter_bp3-icon-sort-alphabetical__2dHh9::before {\n  content: \"\\E64D\"; }\n\n.ReportsFilter_bp3-icon-sort-alphabetical-desc__3uihW::before {\n  content: \"\\E6C8\"; }\n\n.ReportsFilter_bp3-icon-sort-asc__2KD20::before {\n  content: \"\\E6D5\"; }\n\n.ReportsFilter_bp3-icon-sort-desc__23mb0::before {\n  content: \"\\E6D6\"; }\n\n.ReportsFilter_bp3-icon-sort-numerical__2s967::before {\n  content: \"\\E64E\"; }\n\n.ReportsFilter_bp3-icon-sort-numerical-desc__2RFPc::before {\n  content: \"\\E6C9\"; }\n\n.ReportsFilter_bp3-icon-split-columns__2iTcg::before {\n  content: \"\\E750\"; }\n\n.ReportsFilter_bp3-icon-square__23CEj::before {\n  content: \"\\E686\"; }\n\n.ReportsFilter_bp3-icon-stacked-chart__3dzib::before {\n  content: \"\\E6E7\"; }\n\n.ReportsFilter_bp3-icon-star__3EzGp::before {\n  content: \"\\2605\"; }\n\n.ReportsFilter_bp3-icon-star-empty__1DBUt::before {\n  content: \"\\2606\"; }\n\n.ReportsFilter_bp3-icon-step-backward__1tdao::before {\n  content: \"\\E6A7\"; }\n\n.ReportsFilter_bp3-icon-step-chart__pY-ea::before {\n  content: \"\\E70F\"; }\n\n.ReportsFilter_bp3-icon-step-forward__2oDdf::before {\n  content: \"\\E6AD\"; }\n\n.ReportsFilter_bp3-icon-stop__2kAUz::before {\n  content: \"\\E6AA\"; }\n\n.ReportsFilter_bp3-icon-stopwatch__1YhsX::before {\n  content: \"\\E901\"; }\n\n.ReportsFilter_bp3-icon-strikethrough__1YUJp::before {\n  content: \"\\E7A6\"; }\n\n.ReportsFilter_bp3-icon-style__31f-N::before {\n  content: \"\\E601\"; }\n\n.ReportsFilter_bp3-icon-swap-horizontal__1rD8B::before {\n  content: \"\\E745\"; }\n\n.ReportsFilter_bp3-icon-swap-vertical__33dmi::before {\n  content: \"\\E744\"; }\n\n.ReportsFilter_bp3-icon-symbol-circle__5BiGy::before {\n  content: \"\\E72E\"; }\n\n.ReportsFilter_bp3-icon-symbol-cross__2Gv02::before {\n  content: \"\\E731\"; }\n\n.ReportsFilter_bp3-icon-symbol-diamond__hnItR::before {\n  content: \"\\E730\"; }\n\n.ReportsFilter_bp3-icon-symbol-square__2rLqV::before {\n  content: \"\\E72F\"; }\n\n.ReportsFilter_bp3-icon-symbol-triangle-down__13RRq::before {\n  content: \"\\E733\"; }\n\n.ReportsFilter_bp3-icon-symbol-triangle-up__DjC0u::before {\n  content: \"\\E732\"; }\n\n.ReportsFilter_bp3-icon-tag__3yoS8::before {\n  content: \"\\E61C\"; }\n\n.ReportsFilter_bp3-icon-take-action__3Bkco::before {\n  content: \"\\E6CA\"; }\n\n.ReportsFilter_bp3-icon-taxi__2EMSK::before {\n  content: \"\\E79E\"; }\n\n.ReportsFilter_bp3-icon-text-highlight__8uD1u::before {\n  content: \"\\E6DD\"; }\n\n.ReportsFilter_bp3-icon-th__2jyhL::before {\n  content: \"\\E667\"; }\n\n.ReportsFilter_bp3-icon-th-derived__3Wxsx::before {\n  content: \"\\E669\"; }\n\n.ReportsFilter_bp3-icon-th-disconnect__2eGct::before {\n  content: \"\\E7D8\"; }\n\n.ReportsFilter_bp3-icon-th-filtered__1SMSj::before {\n  content: \"\\E7C6\"; }\n\n.ReportsFilter_bp3-icon-th-list__24hBe::before {\n  content: \"\\E668\"; }\n\n.ReportsFilter_bp3-icon-thumbs-down__2GZIp::before {\n  content: \"\\E6BE\"; }\n\n.ReportsFilter_bp3-icon-thumbs-up__2yGOb::before {\n  content: \"\\E6BD\"; }\n\n.ReportsFilter_bp3-icon-tick__1GWUV::before {\n  content: \"\\2713\"; }\n\n.ReportsFilter_bp3-icon-tick-circle__jrBRj::before {\n  content: \"\\E779\"; }\n\n.ReportsFilter_bp3-icon-time__3zv7m::before {\n  content: \"\\23F2\"; }\n\n.ReportsFilter_bp3-icon-timeline-area-chart__2KNFA::before {\n  content: \"\\E6CD\"; }\n\n.ReportsFilter_bp3-icon-timeline-bar-chart__Ln7EC::before {\n  content: \"\\E620\"; }\n\n.ReportsFilter_bp3-icon-timeline-events__3H54U::before {\n  content: \"\\E61E\"; }\n\n.ReportsFilter_bp3-icon-timeline-line-chart__2u-xc::before {\n  content: \"\\E61F\"; }\n\n.ReportsFilter_bp3-icon-tint__3jI1l::before {\n  content: \"\\E6B2\"; }\n\n.ReportsFilter_bp3-icon-torch__328Cb::before {\n  content: \"\\E677\"; }\n\n.ReportsFilter_bp3-icon-tractor__1zpzw::before {\n  content: \"\\E90C\"; }\n\n.ReportsFilter_bp3-icon-train__2ZIcw::before {\n  content: \"\\E79F\"; }\n\n.ReportsFilter_bp3-icon-translate__4-bJk::before {\n  content: \"\\E759\"; }\n\n.ReportsFilter_bp3-icon-trash__3EKFS::before {\n  content: \"\\E63B\"; }\n\n.ReportsFilter_bp3-icon-tree__3iMkn::before {\n  content: \"\\E7B7\"; }\n\n.ReportsFilter_bp3-icon-trending-down__31zbw::before {\n  content: \"\\E71A\"; }\n\n.ReportsFilter_bp3-icon-trending-up__sBrLH::before {\n  content: \"\\E719\"; }\n\n.ReportsFilter_bp3-icon-truck__1jZpJ::before {\n  content: \"\\E90B\"; }\n\n.ReportsFilter_bp3-icon-two-columns__3RWjj::before {\n  content: \"\\E657\"; }\n\n.ReportsFilter_bp3-icon-unarchive__vV1v4::before {\n  content: \"\\E906\"; }\n\n.ReportsFilter_bp3-icon-underline__2yWBX::before {\n  content: \"\\2381\"; }\n\n.ReportsFilter_bp3-icon-undo__3p2IO::before {\n  content: \"\\238C\"; }\n\n.ReportsFilter_bp3-icon-ungroup-objects__uRGUg::before {\n  content: \"\\E688\"; }\n\n.ReportsFilter_bp3-icon-unknown-vehicle__2n6tC::before {\n  content: \"\\E73D\"; }\n\n.ReportsFilter_bp3-icon-unlock__37L5U::before {\n  content: \"\\E626\"; }\n\n.ReportsFilter_bp3-icon-unpin__3TMVa::before {\n  content: \"\\E650\"; }\n\n.ReportsFilter_bp3-icon-unresolve__1n5I5::before {\n  content: \"\\E679\"; }\n\n.ReportsFilter_bp3-icon-updated__35-ts::before {\n  content: \"\\E7A7\"; }\n\n.ReportsFilter_bp3-icon-upload__1zwyl::before {\n  content: \"\\E68F\"; }\n\n.ReportsFilter_bp3-icon-user__349tI::before {\n  content: \"\\E627\"; }\n\n.ReportsFilter_bp3-icon-variable__Q-BMy::before {\n  content: \"\\E6F5\"; }\n\n.ReportsFilter_bp3-icon-vertical-bar-chart-asc__3fRoZ::before {\n  content: \"\\E75B\"; }\n\n.ReportsFilter_bp3-icon-vertical-bar-chart-desc__ssjxh::before {\n  content: \"\\E71C\"; }\n\n.ReportsFilter_bp3-icon-vertical-distribution__aX2xz::before {\n  content: \"\\E721\"; }\n\n.ReportsFilter_bp3-icon-video__38DfP::before {\n  content: \"\\E6A0\"; }\n\n.ReportsFilter_bp3-icon-volume-down__2LMxF::before {\n  content: \"\\E6A4\"; }\n\n.ReportsFilter_bp3-icon-volume-off__2Wxos::before {\n  content: \"\\E6A3\"; }\n\n.ReportsFilter_bp3-icon-volume-up__1ZKPd::before {\n  content: \"\\E6A5\"; }\n\n.ReportsFilter_bp3-icon-walk__1TR9T::before {\n  content: \"\\E79D\"; }\n\n.ReportsFilter_bp3-icon-warning-sign__1MpOq::before {\n  content: \"\\E647\"; }\n\n.ReportsFilter_bp3-icon-waterfall-chart__2DfB1::before {\n  content: \"\\E6E6\"; }\n\n.ReportsFilter_bp3-icon-widget__l_8ur::before {\n  content: \"\\E678\"; }\n\n.ReportsFilter_bp3-icon-widget-button__KOOHR::before {\n  content: \"\\E790\"; }\n\n.ReportsFilter_bp3-icon-widget-footer__1iDdY::before {\n  content: \"\\E792\"; }\n\n.ReportsFilter_bp3-icon-widget-header__253Td::before {\n  content: \"\\E791\"; }\n\n.ReportsFilter_bp3-icon-wrench__2frN-::before {\n  content: \"\\E734\"; }\n\n.ReportsFilter_bp3-icon-zoom-in__2W8Yk::before {\n  content: \"\\E641\"; }\n\n.ReportsFilter_bp3-icon-zoom-out__3Dqh2::before {\n  content: \"\\E642\"; }\n\n.ReportsFilter_bp3-icon-zoom-to-fit__nVWOp::before {\n  content: \"\\E67B\"; }\n\n.ReportsFilter_bp3-submenu__rF1qt > .ReportsFilter_bp3-popover-wrapper__1aeCY {\n  display: block; }\n\n.ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug {\n  display: block; }\n\n.ReportsFilter_bp3-submenu__rF1qt.ReportsFilter_bp3-popover__14V67 {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 0 5px; }\n\n.ReportsFilter_bp3-submenu__rF1qt.ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-content__2X1nV {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt.ReportsFilter_bp3-popover__14V67, .ReportsFilter_bp3-submenu__rF1qt.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-dark__3R7GO {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt.ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-content__2X1nV, .ReportsFilter_bp3-submenu__rF1qt.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-dark__3R7GO > .ReportsFilter_bp3-popover-content__2X1nV {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-menu__32OvI {\n  background: #ffffff;\n  border-radius: 3px;\n  color: #182026;\n  list-style: none;\n  margin: 0;\n  min-width: 180px;\n  padding: 5px;\n  text-align: left; }\n\n.ReportsFilter_bp3-menu-divider__2hVYx {\n  border-top: 1px solid rgba(16, 22, 26, 0.15);\n  display: block;\n  margin: 5px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-divider__2hVYx {\n  border-top-color: rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-menu-item__1kvGq {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  border-radius: 2px;\n  color: inherit;\n  line-height: 20px;\n  padding: 5px 7px;\n  text-decoration: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.ReportsFilter_bp3-menu-item__1kvGq > * {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0; }\n\n.ReportsFilter_bp3-menu-item__1kvGq > .ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1; }\n\n.ReportsFilter_bp3-menu-item__1kvGq::before,\n.ReportsFilter_bp3-menu-item__1kvGq > * {\n  margin-right: 7px; }\n\n.ReportsFilter_bp3-menu-item__1kvGq:empty::before,\n.ReportsFilter_bp3-menu-item__1kvGq > :last-child {\n  margin-right: 0; }\n\n.ReportsFilter_bp3-menu-item__1kvGq > .ReportsFilter_bp3-fill__3iORs {\n  word-break: break-word; }\n\n.ReportsFilter_bp3-menu-item__1kvGq:hover, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-menu-item__1kvGq {\n  background-color: rgba(167, 182, 194, 0.3);\n  cursor: pointer;\n  text-decoration: none; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: inherit;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq {\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-menu-item__1kvGq {\n  background-color: rgba(138, 155, 168, 0.15);\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: inherit;\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-icon__15ATj {\n  color: inherit; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #137cbd; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:active {\n  background-color: #106ba3; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:hover::before, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:hover::after, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:hover .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:active::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:active::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:active .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #0d8050; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-icon__15ATj {\n  color: inherit; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #0d8050; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #0f9960; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:active {\n  background-color: #0d8050; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:hover::before, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:hover::after, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:hover .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:active::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:active::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:active .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs {\n  color: #bf7326; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-icon__15ATj {\n  color: inherit; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #bf7326; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #d9822b; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:active {\n  background-color: #bf7326; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:hover::before, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:hover::after, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:hover .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:active::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:active::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:active .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #c23030; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-icon__15ATj {\n  color: inherit; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #c23030; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #db3737; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:active {\n  background-color: #c23030; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:hover::before, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:hover::after, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:hover .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:active::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:active::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:active .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V::before, .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V::after,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-menu-item__1kvGq::before {\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  margin-right: 7px; }\n\n.ReportsFilter_bp3-menu-item__1kvGq::before,\n.ReportsFilter_bp3-menu-item__1kvGq > .ReportsFilter_bp3-icon__15ATj {\n  color: #5c7080;\n  margin-top: 2px; }\n\n.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #5c7080; }\n\n.ReportsFilter_bp3-menu-item__1kvGq:hover, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-menu-item__1kvGq {\n  color: inherit; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-menu-item__1kvGq:active {\n  background-color: rgba(115, 134, 148, 0.3); }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: inherit !important;\n  color: rgba(92, 112, 128, 0.6) !important;\n  cursor: not-allowed !important;\n  outline: none !important; }\n\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-disabled__1YzwV::before,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-disabled__1YzwV > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: rgba(92, 112, 128, 0.6) !important; }\n\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-menu-item__1kvGq {\n  font-size: 16px;\n  line-height: 22px;\n  padding: 9px 7px; }\n\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-icon__15ATj {\n  margin-top: 3px; }\n\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-menu-item__1kvGq::before {\n  font-family: \"Icons20\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  margin-right: 10px;\n  margin-top: 1px; }\n\nbutton.ReportsFilter_bp3-menu-item__1kvGq {\n  background: none;\n  border: none;\n  text-align: left;\n  width: 100%; }\n\n.ReportsFilter_bp3-menu-header__2Eemh {\n  border-top: 1px solid rgba(16, 22, 26, 0.15);\n  display: block;\n  margin: 5px;\n  cursor: default;\n  padding-left: 2px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-header__2Eemh {\n  border-top-color: rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-menu-header__2Eemh:first-of-type {\n  border-top: none; }\n\n.ReportsFilter_bp3-menu-header__2Eemh > h6 {\n  color: #182026;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  line-height: 17px;\n  margin: 0;\n  padding: 10px 7px 0 1px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-header__2Eemh > h6 {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-menu-header__2Eemh:first-of-type > h6 {\n  padding-top: 0; }\n\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-menu-header__2Eemh > h6 {\n  font-size: 18px;\n  padding-bottom: 5px;\n  padding-top: 15px; }\n\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-menu-header__2Eemh:first-of-type > h6 {\n  padding-top: 0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu__32OvI {\n  background: #30404d;\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-icon__15ATj {\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #137cbd; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:active {\n  background-color: #106ba3; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:hover::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:hover::after, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq::after, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:hover .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:active::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:active::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0:active .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-active__1Mw-V .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-icon__15ATj {\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #0f9960; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:active {\n  background-color: #0d8050; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:hover::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:hover::after, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq::after, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:hover .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:active::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:active::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z:active .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-active__1Mw-V .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-icon__15ATj {\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #d9822b; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:active {\n  background-color: #bf7326; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:hover::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:hover::after, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq::after, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:hover .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:active::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:active::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs:active .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-active__1Mw-V .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-icon__15ATj {\n  color: inherit; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #db3737; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:active {\n  background-color: #c23030; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:hover::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:hover::after, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq::after, .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:hover .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0,\n.ReportsFilter_bp3-submenu__rF1qt .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-target__2jiug.ReportsFilter_bp3-popover-open__3CAoS > .ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:active::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:active::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj:active .ReportsFilter_bp3-menu-item-label__BhgT0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V::before, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V::after,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-active__1Mw-V .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq::before,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq > .ReportsFilter_bp3-icon__15ATj {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq:active {\n  background-color: rgba(138, 155, 168, 0.3); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-disabled__1YzwV {\n  color: rgba(167, 182, 194, 0.6) !important; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-disabled__1YzwV::before,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-disabled__1YzwV > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-item__1kvGq.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-menu-item-label__BhgT0 {\n  color: rgba(167, 182, 194, 0.6) !important; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-divider__2hVYx,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-header__2Eemh {\n  border-color: rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-menu-header__2Eemh > h6 {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-label__1Z8C0 .ReportsFilter_bp3-menu__32OvI {\n  margin-top: 5px; }\n\n.ReportsFilter_bp3-navbar__1WiRj {\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);\n  height: 50px;\n  padding: 0 15px;\n  position: relative;\n  width: 100%;\n  z-index: 10; }\n\n.ReportsFilter_bp3-navbar__1WiRj.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-navbar__1WiRj {\n  background-color: #394b59; }\n\n.ReportsFilter_bp3-navbar__1WiRj.ReportsFilter_bp3-dark__3R7GO {\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-navbar__1WiRj {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-navbar__1WiRj.ReportsFilter_bp3-fixed-top__pUViP {\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0; }\n\n.ReportsFilter_bp3-navbar-heading__2Tl0G {\n  font-size: 16px;\n  margin-right: 15px; }\n\n.ReportsFilter_bp3-navbar-group__3XlYu {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 50px; }\n\n.ReportsFilter_bp3-navbar-group__3XlYu.ReportsFilter_bp3-align-left__3an4r {\n  float: left; }\n\n.ReportsFilter_bp3-navbar-group__3XlYu.ReportsFilter_bp3-align-right__1vvtP {\n  float: right; }\n\n.ReportsFilter_bp3-navbar-divider__1A2TS {\n  border-left: 1px solid rgba(16, 22, 26, 0.15);\n  height: 20px;\n  margin: 0 10px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-navbar-divider__1A2TS {\n  border-left-color: rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-non-ideal-state__35g1e {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 100%;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%; }\n\n.ReportsFilter_bp3-non-ideal-state__35g1e > * {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0; }\n\n.ReportsFilter_bp3-non-ideal-state__35g1e > .ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1; }\n\n.ReportsFilter_bp3-non-ideal-state__35g1e::before,\n.ReportsFilter_bp3-non-ideal-state__35g1e > * {\n  margin-bottom: 20px; }\n\n.ReportsFilter_bp3-non-ideal-state__35g1e:empty::before,\n.ReportsFilter_bp3-non-ideal-state__35g1e > :last-child {\n  margin-bottom: 0; }\n\n.ReportsFilter_bp3-non-ideal-state__35g1e > * {\n  max-width: 400px; }\n\n.ReportsFilter_bp3-non-ideal-state-visual__1OsPp {\n  color: rgba(92, 112, 128, 0.6);\n  font-size: 60px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-non-ideal-state-visual__1OsPp {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-overflow-list__1iZVj {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  min-width: 0; }\n\n.ReportsFilter_bp3-overflow-list-spacer__2dA_L {\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n  width: 1px; }\n\nbody.ReportsFilter_bp3-overlay-open__1DHQa {\n  overflow: hidden; }\n\n.ReportsFilter_bp3-overlay__1AXB_ {\n  bottom: 0;\n  left: 0;\n  position: static;\n  right: 0;\n  top: 0;\n  z-index: 20; }\n\n.ReportsFilter_bp3-overlay__1AXB_:not(.ReportsFilter_bp3-overlay-open__1DHQa) {\n  pointer-events: none; }\n\n.ReportsFilter_bp3-overlay__1AXB_.ReportsFilter_bp3-overlay-container__1kIC7 {\n  overflow: hidden;\n  position: fixed; }\n\n.ReportsFilter_bp3-overlay__1AXB_.ReportsFilter_bp3-overlay-container__1kIC7.ReportsFilter_bp3-overlay-inline__2c3E8 {\n  position: absolute; }\n\n.ReportsFilter_bp3-overlay__1AXB_.ReportsFilter_bp3-overlay-scroll-container__A-pd- {\n  overflow: auto;\n  position: fixed; }\n\n.ReportsFilter_bp3-overlay__1AXB_.ReportsFilter_bp3-overlay-scroll-container__A-pd-.ReportsFilter_bp3-overlay-inline__2c3E8 {\n  position: absolute; }\n\n.ReportsFilter_bp3-overlay__1AXB_.ReportsFilter_bp3-overlay-inline__2c3E8 {\n  display: inline;\n  overflow: visible; }\n\n.ReportsFilter_bp3-overlay-content__mV8_d {\n  position: fixed;\n  z-index: 20; }\n\n.ReportsFilter_bp3-overlay-inline__2c3E8 .ReportsFilter_bp3-overlay-content__mV8_d,\n.ReportsFilter_bp3-overlay-scroll-container__A-pd- .ReportsFilter_bp3-overlay-content__mV8_d {\n  position: absolute; }\n\n.ReportsFilter_bp3-overlay-backdrop__1iyVa {\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  opacity: 1;\n  background-color: rgba(16, 22, 26, 0.7);\n  overflow: auto;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  z-index: 20; }\n\n.ReportsFilter_bp3-overlay-backdrop__1iyVa.ReportsFilter_bp3-overlay-enter__1l8Ue, .ReportsFilter_bp3-overlay-backdrop__1iyVa.ReportsFilter_bp3-overlay-appear__Kp1wI {\n  opacity: 0; }\n\n.ReportsFilter_bp3-overlay-backdrop__1iyVa.ReportsFilter_bp3-overlay-enter-active__3x69Z, .ReportsFilter_bp3-overlay-backdrop__1iyVa.ReportsFilter_bp3-overlay-appear-active__3364s {\n  opacity: 1;\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 200ms;\n  transition-duration: 200ms;\n  -webkit-transition-property: opacity;\n  transition-property: opacity;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-overlay-backdrop__1iyVa.ReportsFilter_bp3-overlay-exit__17aZI {\n  opacity: 1; }\n\n.ReportsFilter_bp3-overlay-backdrop__1iyVa.ReportsFilter_bp3-overlay-exit-active__1pKHO {\n  opacity: 0;\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 200ms;\n  transition-duration: 200ms;\n  -webkit-transition-property: opacity;\n  transition-property: opacity;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-overlay-backdrop__1iyVa:focus {\n  outline: none; }\n\n.ReportsFilter_bp3-overlay-inline__2c3E8 .ReportsFilter_bp3-overlay-backdrop__1iyVa {\n  position: absolute; }\n\n.ReportsFilter_bp3-panel-stack__2W1ox {\n  overflow: hidden;\n  position: relative; }\n\n.ReportsFilter_bp3-panel-stack-header__zB629 {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-shadow: 0 1px rgba(16, 22, 26, 0.15);\n  box-shadow: 0 1px rgba(16, 22, 26, 0.15);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  height: 30px;\n  z-index: 1; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-panel-stack-header__zB629 {\n  -webkit-box-shadow: 0 1px rgba(255, 255, 255, 0.15);\n  box-shadow: 0 1px rgba(255, 255, 255, 0.15); }\n\n.ReportsFilter_bp3-panel-stack-header__zB629 > span {\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.ReportsFilter_bp3-panel-stack-header__zB629 .ReportsFilter_bp3-heading__H7aWJ {\n  margin: 0 5px; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-panel-stack-header-back__3nrl3 {\n  margin-left: 5px;\n  padding-left: 0;\n  white-space: nowrap; }\n\n.ReportsFilter_bp3-button__15ViT.ReportsFilter_bp3-panel-stack-header-back__3nrl3 .ReportsFilter_bp3-icon__15ATj {\n  margin: 0 2px; }\n\n.ReportsFilter_bp3-panel-stack-view__2oC_x {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  background-color: #ffffff;\n  border-right: 1px solid rgba(16, 22, 26, 0.15);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin-right: -1px;\n  overflow-y: auto;\n  z-index: 1; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-panel-stack-view__2oC_x {\n  background-color: #30404d; }\n\n.ReportsFilter_bp3-panel-stack-view__2oC_x:nth-last-child(n + 4) {\n  display: none; }\n\n.ReportsFilter_bp3-panel-stack-push__3Zgmi .ReportsFilter_bp3-panel-stack-enter__4_SYO, .ReportsFilter_bp3-panel-stack-push__3Zgmi .ReportsFilter_bp3-panel-stack-appear__1-Pz3 {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n  opacity: 0; }\n\n.ReportsFilter_bp3-panel-stack-push__3Zgmi .ReportsFilter_bp3-panel-stack-enter-active__2k4L8, .ReportsFilter_bp3-panel-stack-push__3Zgmi .ReportsFilter_bp3-panel-stack-appear-active__3IUz6 {\n  -webkit-transform: translate(0%);\n  transform: translate(0%);\n  opacity: 1;\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 400ms;\n  transition-duration: 400ms;\n  -webkit-transition-property: opacity, -webkit-transform;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  -webkit-transition-timing-function: ease;\n  transition-timing-function: ease; }\n\n.ReportsFilter_bp3-panel-stack-push__3Zgmi .ReportsFilter_bp3-panel-stack-exit__35Qei {\n  -webkit-transform: translate(0%);\n  transform: translate(0%);\n  opacity: 1; }\n\n.ReportsFilter_bp3-panel-stack-push__3Zgmi .ReportsFilter_bp3-panel-stack-exit-active__105L3 {\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  opacity: 0;\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 400ms;\n  transition-duration: 400ms;\n  -webkit-transition-property: opacity, -webkit-transform;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  -webkit-transition-timing-function: ease;\n  transition-timing-function: ease; }\n\n.ReportsFilter_bp3-panel-stack-pop__2mxtM .ReportsFilter_bp3-panel-stack-enter__4_SYO, .ReportsFilter_bp3-panel-stack-pop__2mxtM .ReportsFilter_bp3-panel-stack-appear__1-Pz3 {\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  opacity: 0; }\n\n.ReportsFilter_bp3-panel-stack-pop__2mxtM .ReportsFilter_bp3-panel-stack-enter-active__2k4L8, .ReportsFilter_bp3-panel-stack-pop__2mxtM .ReportsFilter_bp3-panel-stack-appear-active__3IUz6 {\n  -webkit-transform: translate(0%);\n  transform: translate(0%);\n  opacity: 1;\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 400ms;\n  transition-duration: 400ms;\n  -webkit-transition-property: opacity, -webkit-transform;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  -webkit-transition-timing-function: ease;\n  transition-timing-function: ease; }\n\n.ReportsFilter_bp3-panel-stack-pop__2mxtM .ReportsFilter_bp3-panel-stack-exit__35Qei {\n  -webkit-transform: translate(0%);\n  transform: translate(0%);\n  opacity: 1; }\n\n.ReportsFilter_bp3-panel-stack-pop__2mxtM .ReportsFilter_bp3-panel-stack-exit-active__105L3 {\n  -webkit-transform: translateX(100%);\n  transform: translateX(100%);\n  opacity: 0;\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 400ms;\n  transition-duration: 400ms;\n  -webkit-transition-property: opacity, -webkit-transform;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  -webkit-transition-timing-function: ease;\n  transition-timing-function: ease; }\n\n.ReportsFilter_bp3-popover__14V67 {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  border-radius: 3px;\n  display: inline-block;\n  z-index: 20; }\n\n.ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-arrow__35dvK {\n  height: 30px;\n  position: absolute;\n  width: 30px; }\n\n.ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-arrow__35dvK::before {\n  height: 20px;\n  margin: 5px;\n  width: 20px; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-target-attached-top__324h6 > .ReportsFilter_bp3-popover__14V67 {\n  margin-bottom: 17px;\n  margin-top: -17px; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-target-attached-top__324h6 > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK {\n  bottom: -11px; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-target-attached-top__324h6 > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK svg {\n  -webkit-transform: rotate(-90deg);\n  transform: rotate(-90deg); }\n\n.ReportsFilter_bp3-tether-element-attached-left__p1Z0k.ReportsFilter_bp3-tether-target-attached-right__2rvqh > .ReportsFilter_bp3-popover__14V67 {\n  margin-left: 17px; }\n\n.ReportsFilter_bp3-tether-element-attached-left__p1Z0k.ReportsFilter_bp3-tether-target-attached-right__2rvqh > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK {\n  left: -11px; }\n\n.ReportsFilter_bp3-tether-element-attached-left__p1Z0k.ReportsFilter_bp3-tether-target-attached-right__2rvqh > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK svg {\n  -webkit-transform: rotate(0);\n  transform: rotate(0); }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-target-attached-bottom__r4QYp > .ReportsFilter_bp3-popover__14V67 {\n  margin-top: 17px; }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-target-attached-bottom__r4QYp > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK {\n  top: -11px; }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-target-attached-bottom__r4QYp > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK svg {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg); }\n\n.ReportsFilter_bp3-tether-element-attached-right__2enGx.ReportsFilter_bp3-tether-target-attached-left__dPLP_ > .ReportsFilter_bp3-popover__14V67 {\n  margin-left: -17px;\n  margin-right: 17px; }\n\n.ReportsFilter_bp3-tether-element-attached-right__2enGx.ReportsFilter_bp3-tether-target-attached-left__dPLP_ > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK {\n  right: -11px; }\n\n.ReportsFilter_bp3-tether-element-attached-right__2enGx.ReportsFilter_bp3-tether-target-attached-left__dPLP_ > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK svg {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg); }\n\n.ReportsFilter_bp3-tether-element-attached-middle__hFPd4 > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%); }\n\n.ReportsFilter_bp3-tether-element-attached-center__RGCg2 > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK {\n  right: 50%;\n  -webkit-transform: translateX(50%);\n  transform: translateX(50%); }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-target-attached-top__324h6 > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK {\n  top: -0.3934px; }\n\n.ReportsFilter_bp3-tether-element-attached-right__2enGx.ReportsFilter_bp3-tether-target-attached-right__2rvqh > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK {\n  right: -0.3934px; }\n\n.ReportsFilter_bp3-tether-element-attached-left__p1Z0k.ReportsFilter_bp3-tether-target-attached-left__dPLP_ > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK {\n  left: -0.3934px; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-target-attached-bottom__r4QYp > .ReportsFilter_bp3-popover__14V67 > .ReportsFilter_bp3-popover-arrow__35dvK {\n  bottom: -0.3934px; }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-element-attached-left__p1Z0k > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform-origin: top left;\n  transform-origin: top left; }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-element-attached-center__RGCg2 > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform-origin: top center;\n  transform-origin: top center; }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-element-attached-right__2enGx > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform-origin: top right;\n  transform-origin: top right; }\n\n.ReportsFilter_bp3-tether-element-attached-middle__hFPd4.ReportsFilter_bp3-tether-element-attached-left__p1Z0k > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform-origin: center left;\n  transform-origin: center left; }\n\n.ReportsFilter_bp3-tether-element-attached-middle__hFPd4.ReportsFilter_bp3-tether-element-attached-center__RGCg2 > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform-origin: center center;\n  transform-origin: center center; }\n\n.ReportsFilter_bp3-tether-element-attached-middle__hFPd4.ReportsFilter_bp3-tether-element-attached-right__2enGx > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform-origin: center right;\n  transform-origin: center right; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-element-attached-left__p1Z0k > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform-origin: bottom left;\n  transform-origin: bottom left; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-element-attached-center__RGCg2 > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform-origin: bottom center;\n  transform-origin: bottom center; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-element-attached-right__2enGx > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform-origin: bottom right;\n  transform-origin: bottom right; }\n\n.ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-content__2X1nV {\n  background: #ffffff;\n  color: inherit; }\n\n.ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-arrow__35dvK::before {\n  -webkit-box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.2);\n  box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-arrow-border__2wZtp {\n  fill: #10161a;\n  fill-opacity: 0.1; }\n\n.ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-arrow-fill__3ZcIs {\n  fill: #ffffff; }\n\n.ReportsFilter_bp3-popover-enter__1H7E0 > .ReportsFilter_bp3-popover__14V67, .ReportsFilter_bp3-popover-appear__3iRJU > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform: scale(0.3);\n  transform: scale(0.3); }\n\n.ReportsFilter_bp3-popover-enter-active__2Rs6c > .ReportsFilter_bp3-popover__14V67, .ReportsFilter_bp3-popover-appear-active__2dwM2 > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 300ms;\n  transition-duration: 300ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11); }\n\n.ReportsFilter_bp3-popover-exit__FnKlU > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform: scale(1);\n  transform: scale(1); }\n\n.ReportsFilter_bp3-popover-exit-active__xoMhf > .ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform: scale(0.3);\n  transform: scale(0.3);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 300ms;\n  transition-duration: 300ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11); }\n\n.ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-content__2X1nV {\n  border-radius: 3px;\n  position: relative; }\n\n.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-popover-content-sizing__1Htqs .ReportsFilter_bp3-popover-content__2X1nV {\n  max-width: 350px;\n  padding: 20px; }\n\n.ReportsFilter_bp3-popover-target__2jiug + .ReportsFilter_bp3-overlay__1AXB_ .ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-popover-content-sizing__1Htqs {\n  width: 350px; }\n\n.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-minimal__V1Rn9 {\n  margin: 0 !important; }\n\n.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-popover-arrow__35dvK {\n  display: none; }\n\n.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform: scale(1);\n  transform: scale(1); }\n\n.ReportsFilter_bp3-popover-enter__1H7E0 > .ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-popover__14V67, .ReportsFilter_bp3-popover-appear__3iRJU > .ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform: scale(1);\n  transform: scale(1); }\n\n.ReportsFilter_bp3-popover-enter-active__2Rs6c > .ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-popover__14V67, .ReportsFilter_bp3-popover-appear-active__2dwM2 > .ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-popover-exit__FnKlU > .ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform: scale(1);\n  transform: scale(1); }\n\n.ReportsFilter_bp3-popover-exit-active__xoMhf > .ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-popover__14V67 {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover__14V67 {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-content__2X1nV,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-content__2X1nV {\n  background: #30404d;\n  color: inherit; }\n\n.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-arrow__35dvK::before,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-arrow__35dvK::before {\n  -webkit-box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.4);\n  box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-arrow-border__2wZtp,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-arrow-border__2wZtp {\n  fill: #10161a;\n  fill-opacity: 0.2; }\n\n.ReportsFilter_bp3-popover__14V67.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-arrow-fill__3ZcIs,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover__14V67 .ReportsFilter_bp3-popover-arrow-fill__3ZcIs {\n  fill: #30404d; }\n\n.ReportsFilter_bp3-popover-arrow__35dvK::before {\n  border-radius: 2px;\n  content: \"\";\n  display: block;\n  position: absolute;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg); }\n\n.ReportsFilter_bp3-tether-pinned__3f5H9 .ReportsFilter_bp3-popover-arrow__35dvK {\n  display: none; }\n\n.ReportsFilter_bp3-popover-backdrop__2bOlk {\n  background: rgba(255, 255, 255, 0); }\n\n.ReportsFilter_bp3-transition-container__PmQS3 {\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  z-index: 20; }\n\n.ReportsFilter_bp3-transition-container__PmQS3.ReportsFilter_bp3-popover-enter__1H7E0, .ReportsFilter_bp3-transition-container__PmQS3.ReportsFilter_bp3-popover-appear__3iRJU {\n  opacity: 0; }\n\n.ReportsFilter_bp3-transition-container__PmQS3.ReportsFilter_bp3-popover-enter-active__2Rs6c, .ReportsFilter_bp3-transition-container__PmQS3.ReportsFilter_bp3-popover-appear-active__2dwM2 {\n  opacity: 1;\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: opacity;\n  transition-property: opacity;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-transition-container__PmQS3.ReportsFilter_bp3-popover-exit__FnKlU {\n  opacity: 1; }\n\n.ReportsFilter_bp3-transition-container__PmQS3.ReportsFilter_bp3-popover-exit-active__xoMhf {\n  opacity: 0;\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: opacity;\n  transition-property: opacity;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-transition-container__PmQS3:focus {\n  outline: none; }\n\n.ReportsFilter_bp3-transition-container__PmQS3.ReportsFilter_bp3-popover-leave__3egfd .ReportsFilter_bp3-popover-content__2X1nV {\n  pointer-events: none; }\n\n.ReportsFilter_bp3-transition-container__PmQS3[data-x-out-of-boundaries] {\n  display: none; }\n\nspan.ReportsFilter_bp3-popover-target__2jiug {\n  display: inline-block; }\n\n.ReportsFilter_bp3-popover-wrapper__1aeCY.ReportsFilter_bp3-fill__3iORs {\n  width: 100%; }\n\n.ReportsFilter_bp3-portal__1JB6c {\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n@-webkit-keyframes ReportsFilter_linear-progress-bar-stripes__2HW9U {\n  from {\n    background-position: 0 0; }\n  to {\n    background-position: 30px 0; } }\n\n@keyframes ReportsFilter_linear-progress-bar-stripes__2HW9U {\n  from {\n    background-position: 0 0; }\n  to {\n    background-position: 30px 0; } }\n\n.ReportsFilter_bp3-progress-bar__1I87E {\n  background: rgba(92, 112, 128, 0.2);\n  border-radius: 40px;\n  display: block;\n  height: 8px;\n  overflow: hidden;\n  position: relative;\n  width: 100%; }\n\n.ReportsFilter_bp3-progress-bar__1I87E .ReportsFilter_bp3-progress-meter__3Rvlm {\n  background: linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%);\n  background-color: rgba(92, 112, 128, 0.8);\n  background-size: 30px 30px;\n  border-radius: 40px;\n  height: 100%;\n  position: absolute;\n  -webkit-transition: width 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: width 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  width: 100%; }\n\n.ReportsFilter_bp3-progress-bar__1I87E:not(.ReportsFilter_bp3-no-animation__Sc11G):not(.ReportsFilter_bp3-no-stripes__2hfrk) .ReportsFilter_bp3-progress-meter__3Rvlm {\n  animation: ReportsFilter_linear-progress-bar-stripes__2HW9U 300ms linear infinite reverse; }\n\n.ReportsFilter_bp3-progress-bar__1I87E.ReportsFilter_bp3-no-stripes__2hfrk .ReportsFilter_bp3-progress-meter__3Rvlm {\n  background-image: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-progress-bar__1I87E {\n  background: rgba(16, 22, 26, 0.5); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-progress-bar__1I87E .ReportsFilter_bp3-progress-meter__3Rvlm {\n  background-color: #8a9ba8; }\n\n.ReportsFilter_bp3-progress-bar__1I87E.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-progress-meter__3Rvlm {\n  background-color: #137cbd; }\n\n.ReportsFilter_bp3-progress-bar__1I87E.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-progress-meter__3Rvlm {\n  background-color: #0f9960; }\n\n.ReportsFilter_bp3-progress-bar__1I87E.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-progress-meter__3Rvlm {\n  background-color: #d9822b; }\n\n.ReportsFilter_bp3-progress-bar__1I87E.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-progress-meter__3Rvlm {\n  background-color: #db3737; }\n\n@-webkit-keyframes ReportsFilter_skeleton-glow__ALOgN {\n  from {\n    background: rgba(206, 217, 224, 0.2);\n    border-color: rgba(206, 217, 224, 0.2); }\n  to {\n    background: rgba(92, 112, 128, 0.2);\n    border-color: rgba(92, 112, 128, 0.2); } }\n\n@keyframes ReportsFilter_skeleton-glow__ALOgN {\n  from {\n    background: rgba(206, 217, 224, 0.2);\n    border-color: rgba(206, 217, 224, 0.2); }\n  to {\n    background: rgba(92, 112, 128, 0.2);\n    border-color: rgba(92, 112, 128, 0.2); } }\n\n.ReportsFilter_bp3-skeleton__iuigi {\n  -webkit-animation: 1000ms linear infinite alternate :local(skeleton-glow);\n  animation: 1000ms linear infinite alternate :local(skeleton-glow);\n  background: rgba(206, 217, 224, 0.2);\n  background-clip: padding-box !important;\n  border-color: rgba(206, 217, 224, 0.2) !important;\n  border-radius: 2px;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  color: transparent !important;\n  cursor: default;\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.ReportsFilter_bp3-skeleton__iuigi::before, .ReportsFilter_bp3-skeleton__iuigi::after,\n.ReportsFilter_bp3-skeleton__iuigi * {\n  visibility: hidden !important; }\n\n.ReportsFilter_bp3-slider__1otHV {\n  height: 40px;\n  min-width: 150px;\n  width: 100%;\n  cursor: default;\n  outline: none;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.ReportsFilter_bp3-slider__1otHV:hover {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-slider__1otHV:active {\n  cursor: -webkit-grabbing;\n  cursor: grabbing; }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-disabled__1YzwV {\n  cursor: not-allowed;\n  opacity: 0.5; }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-slider-unlabeled__db6Sv {\n  height: 16px; }\n\n.ReportsFilter_bp3-slider-track__wlYLv,\n.ReportsFilter_bp3-slider-progress__1anNH {\n  height: 6px;\n  left: 0;\n  right: 0;\n  top: 5px;\n  position: absolute; }\n\n.ReportsFilter_bp3-slider-track__wlYLv {\n  border-radius: 3px;\n  overflow: hidden; }\n\n.ReportsFilter_bp3-slider-progress__1anNH {\n  background: rgba(92, 112, 128, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-progress__1anNH {\n  background: rgba(16, 22, 26, 0.5); }\n\n.ReportsFilter_bp3-slider-progress__1anNH.ReportsFilter_bp3-intent-primary__OlAS0 {\n  background-color: #137cbd; }\n\n.ReportsFilter_bp3-slider-progress__1anNH.ReportsFilter_bp3-intent-success__3_w9z {\n  background-color: #0f9960; }\n\n.ReportsFilter_bp3-slider-progress__1anNH.ReportsFilter_bp3-intent-warning__372vs {\n  background-color: #d9822b; }\n\n.ReportsFilter_bp3-slider-progress__1anNH.ReportsFilter_bp3-intent-danger__GyPAj {\n  background-color: #db3737; }\n\n.ReportsFilter_bp3-slider-handle__3bPJf {\n  background-color: #f5f8fa;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.8)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  color: #182026;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2);\n  cursor: pointer;\n  height: 16px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 16px; }\n\n.ReportsFilter_bp3-slider-handle__3bPJf:hover {\n  background-clip: padding-box;\n  background-color: #ebf1f5;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1); }\n\n.ReportsFilter_bp3-slider-handle__3bPJf:active, .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #d8e1e8;\n  background-image: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-slider-handle__3bPJf:disabled, .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(206, 217, 224, 0.5);\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed;\n  outline: none; }\n\n.ReportsFilter_bp3-slider-handle__3bPJf:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-slider-handle__3bPJf:disabled.ReportsFilter_bp3-active__1Mw-V:hover, .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V:hover {\n  background: rgba(206, 217, 224, 0.7); }\n\n.ReportsFilter_bp3-slider-handle__3bPJf:focus {\n  z-index: 1; }\n\n.ReportsFilter_bp3-slider-handle__3bPJf:hover {\n  background-clip: padding-box;\n  background-color: #ebf1f5;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2);\n  cursor: -webkit-grab;\n  cursor: grab;\n  z-index: 2; }\n\n.ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #d8e1e8;\n  background-image: none;\n  -webkit-box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 1px rgba(16, 22, 26, 0.1);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 1px rgba(16, 22, 26, 0.1);\n  cursor: -webkit-grabbing;\n  cursor: grabbing; }\n\n.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-slider-handle__3bPJf {\n  background: #bfccd6;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  pointer-events: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf {\n  background-color: #394b59;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.05)), to(rgba(255, 255, 255, 0)));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf:hover, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-active__1Mw-V {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf:hover {\n  background-color: #30404d;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf:active, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #202b33;\n  background-image: none;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf:disabled, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-disabled__1YzwV {\n  background-color: rgba(57, 75, 89, 0.5);\n  background-image: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf:disabled.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-disabled__1YzwV.ReportsFilter_bp3-active__1Mw-V {\n  background: rgba(57, 75, 89, 0.7); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf .ReportsFilter_bp3-button-spinner__2ZL-c .ReportsFilter_bp3-spinner-head__BgtQ- {\n  background: rgba(16, 22, 26, 0.5);\n  stroke: #8a9ba8; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf:hover {\n  background-color: #394b59; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #293742; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-slider-handle__3bPJf {\n  background: #5c7080;\n  border-color: #5c7080;\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-slider-handle__3bPJf .ReportsFilter_bp3-slider-label__2L_St {\n  background: #394b59;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  color: #f5f8fa;\n  margin-left: 8px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-slider-handle__3bPJf .ReportsFilter_bp3-slider-label__2L_St {\n  background: #e1e8ed;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4);\n  color: #394b59; }\n\n.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-slider-handle__3bPJf .ReportsFilter_bp3-slider-label__2L_St {\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-start__3jknS, .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-end__2OzyK {\n  width: 8px; }\n\n.ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-start__3jknS {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0; }\n\n.ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-end__2OzyK {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  margin-left: 8px; }\n\n.ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-end__2OzyK .ReportsFilter_bp3-slider-label__2L_St {\n  margin-left: 0; }\n\n.ReportsFilter_bp3-slider-label__2L_St {\n  -webkit-transform: translate(-50%, 20px);\n  transform: translate(-50%, 20px);\n  display: inline-block;\n  font-size: 12px;\n  line-height: 1;\n  padding: 2px 5px;\n  position: absolute;\n  vertical-align: top; }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 {\n  height: 150px;\n  min-width: 40px;\n  width: 40px; }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-track__wlYLv,\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-progress__1anNH {\n  bottom: 0;\n  height: auto;\n  left: 5px;\n  top: 0;\n  width: 6px; }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-progress__1anNH {\n  top: auto; }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-label__2L_St {\n  -webkit-transform: translate(20px, 50%);\n  transform: translate(20px, 50%); }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-handle__3bPJf {\n  top: auto; }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-handle__3bPJf .ReportsFilter_bp3-slider-label__2L_St {\n  margin-left: 0;\n  margin-top: -8px; }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-end__2OzyK, .ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-start__3jknS {\n  height: 8px;\n  margin-left: 0;\n  width: 16px; }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-start__3jknS {\n  border-bottom-right-radius: 3px;\n  border-top-left-radius: 0; }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-start__3jknS .ReportsFilter_bp3-slider-label__2L_St {\n  -webkit-transform: translate(20px);\n  transform: translate(20px); }\n\n.ReportsFilter_bp3-slider__1otHV.ReportsFilter_bp3-vertical__22D_2 .ReportsFilter_bp3-slider-handle__3bPJf.ReportsFilter_bp3-end__2OzyK {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 3px;\n  margin-bottom: 8px; }\n\n@-webkit-keyframes ReportsFilter_pt-spinner-animation__3qlN_ {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes ReportsFilter_pt-spinner-animation__3qlN_ {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n.ReportsFilter_bp3-spinner__1DHED {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  overflow: visible;\n  vertical-align: middle; }\n\n.ReportsFilter_bp3-spinner__1DHED svg {\n  display: block; }\n\n.ReportsFilter_bp3-spinner__1DHED path {\n  fill-opacity: 0; }\n\n.ReportsFilter_bp3-spinner__1DHED .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: rgba(92, 112, 128, 0.8);\n  stroke-linecap: round;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n  -webkit-transition: stroke-dashoffset 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: stroke-dashoffset 200ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-spinner__1DHED .ReportsFilter_bp3-spinner-track__1btXz {\n  stroke: rgba(92, 112, 128, 0.2); }\n\n.ReportsFilter_bp3-spinner-animation__8Pxj0 {\n  -webkit-animation: ReportsFilter_pt-spinner-animation__3qlN_ 500ms linear infinite;\n  animation: ReportsFilter_pt-spinner-animation__3qlN_ 500ms linear infinite; }\n\n.ReportsFilter_bp3-no-spin__Yn0US > .ReportsFilter_bp3-spinner-animation__8Pxj0 {\n  -webkit-animation: none;\n  animation: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-spinner__1DHED .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #8a9ba8; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-spinner__1DHED .ReportsFilter_bp3-spinner-track__1btXz {\n  stroke: rgba(16, 22, 26, 0.5); }\n\n.ReportsFilter_bp3-spinner__1DHED.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #137cbd; }\n\n.ReportsFilter_bp3-spinner__1DHED.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #0f9960; }\n\n.ReportsFilter_bp3-spinner__1DHED.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #d9822b; }\n\n.ReportsFilter_bp3-spinner__1DHED.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-spinner-head__BgtQ- {\n  stroke: #db3737; }\n\n.ReportsFilter_bp3-tabs__16o5V.ReportsFilter_bp3-vertical__22D_2 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.ReportsFilter_bp3-tabs__16o5V.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-tab-list__1NhKb {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column; }\n\n.ReportsFilter_bp3-tabs__16o5V.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-tab-list__1NhKb .ReportsFilter_bp3-tab__1JV3_ {\n  border-radius: 3px;\n  padding: 0 10px;\n  width: 100%; }\n\n.ReportsFilter_bp3-tabs__16o5V.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-tab-list__1NhKb .ReportsFilter_bp3-tab__1JV3_[aria-selected=\"true\"] {\n  background-color: rgba(19, 124, 189, 0.2);\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.ReportsFilter_bp3-tabs__16o5V.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-tab-list__1NhKb .ReportsFilter_bp3-tab-indicator-wrapper__1spjd .ReportsFilter_bp3-tab-indicator__lkSlV {\n  background-color: rgba(19, 124, 189, 0.2);\n  border-radius: 3px;\n  bottom: 0;\n  height: auto;\n  left: 0;\n  right: 0;\n  top: 0; }\n\n.ReportsFilter_bp3-tabs__16o5V.ReportsFilter_bp3-vertical__22D_2 > .ReportsFilter_bp3-tab-panel__12uVF {\n  margin-top: 0;\n  padding-left: 20px; }\n\n.ReportsFilter_bp3-tab-list__1NhKb {\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  border: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative; }\n\n.ReportsFilter_bp3-tab-list__1NhKb > *:not(:last-child) {\n  margin-right: 20px; }\n\n.ReportsFilter_bp3-tab__1JV3_ {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  color: #182026;\n  cursor: pointer;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  font-size: 14px;\n  line-height: 30px;\n  max-width: 100%;\n  position: relative;\n  vertical-align: top; }\n\n.ReportsFilter_bp3-tab__1JV3_ a {\n  color: inherit;\n  display: block;\n  text-decoration: none; }\n\n.ReportsFilter_bp3-tab-indicator-wrapper__1spjd ~ .ReportsFilter_bp3-tab__1JV3_ {\n  background-color: transparent !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important; }\n\n.ReportsFilter_bp3-tab__1JV3_[aria-disabled=\"true\"] {\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-tab__1JV3_[aria-selected=\"true\"] {\n  border-radius: 0;\n  -webkit-box-shadow: inset 0 -3px 0 #106ba3;\n  box-shadow: inset 0 -3px 0 #106ba3; }\n\n.ReportsFilter_bp3-tab__1JV3_[aria-selected=\"true\"], .ReportsFilter_bp3-tab__1JV3_:not([aria-disabled=\"true\"]):hover {\n  color: #106ba3; }\n\n.ReportsFilter_bp3-tab__1JV3_:focus {\n  -moz-outline-radius: 0; }\n\n.ReportsFilter_bp3-large__17hsQ > .ReportsFilter_bp3-tab__1JV3_ {\n  font-size: 16px;\n  line-height: 40px; }\n\n.ReportsFilter_bp3-tab-panel__12uVF {\n  margin-top: 20px; }\n\n.ReportsFilter_bp3-tab-panel__12uVF[aria-hidden=\"true\"] {\n  display: none; }\n\n.ReportsFilter_bp3-tab-indicator-wrapper__1spjd {\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  -webkit-transform: translateX(0), translateY(0);\n  transform: translateX(0), translateY(0);\n  -webkit-transition: height, width, -webkit-transform;\n  transition: height, width, -webkit-transform;\n  transition: height, transform, width;\n  transition: height, transform, width, -webkit-transform;\n  -webkit-transition-duration: 200ms;\n  transition-duration: 200ms;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-tab-indicator-wrapper__1spjd .ReportsFilter_bp3-tab-indicator__lkSlV {\n  background-color: #106ba3;\n  bottom: 0;\n  height: 3px;\n  left: 0;\n  position: absolute;\n  right: 0; }\n\n.ReportsFilter_bp3-tab-indicator-wrapper__1spjd.ReportsFilter_bp3-no-animation__Sc11G {\n  -webkit-transition: none;\n  transition: none; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tab__1JV3_ {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tab__1JV3_[aria-disabled=\"true\"] {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tab__1JV3_[aria-selected=\"true\"] {\n  -webkit-box-shadow: inset 0 -3px 0 #48aff0;\n  box-shadow: inset 0 -3px 0 #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tab__1JV3_[aria-selected=\"true\"], .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tab__1JV3_:not([aria-disabled=\"true\"]):hover {\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tab-indicator__lkSlV {\n  background-color: #48aff0; }\n\n.ReportsFilter_bp3-flex-expander__2fXRZ {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1;\n  flex: 1 1; }\n\n.ReportsFilter_bp3-tag__t-27S {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #5c7080;\n  border: none;\n  border-radius: 3px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #f5f8fa;\n  font-size: 12px;\n  line-height: 16px;\n  max-width: 100%;\n  min-height: 20px;\n  min-width: 20px;\n  padding: 2px 6px;\n  position: relative; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(92, 112, 128, 0.85); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(92, 112, 128, 0.7); }\n\n.ReportsFilter_bp3-tag__t-27S > * {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0; }\n\n.ReportsFilter_bp3-tag__t-27S > .ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1; }\n\n.ReportsFilter_bp3-tag__t-27S::before,\n.ReportsFilter_bp3-tag__t-27S > * {\n  margin-right: 4px; }\n\n.ReportsFilter_bp3-tag__t-27S:empty::before,\n.ReportsFilter_bp3-tag__t-27S > :last-child {\n  margin-right: 0; }\n\n.ReportsFilter_bp3-tag__t-27S:focus {\n  outline: rgba(19, 124, 189, 0.6) auto 2px;\n  outline-offset: 0;\n  -moz-outline-radius: 6px; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-round__12jLZ {\n  border-radius: 30px;\n  padding-left: 8px;\n  padding-right: 8px; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S {\n  background-color: #bfccd6;\n  color: #182026; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(191, 204, 214, 0.85); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(191, 204, 214, 0.7); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S > .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S .ReportsFilter_bp3-icon-large__oZ-F2 {\n  fill: currentColor; }\n\n.ReportsFilter_bp3-tag__t-27S > .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-tag__t-27S .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-tag__t-27S .ReportsFilter_bp3-icon-large__oZ-F2 {\n  fill: #ffffff; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-large__17hsQ,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-tag__t-27S {\n  font-size: 14px;\n  line-height: 20px;\n  min-height: 30px;\n  min-width: 30px;\n  padding: 5px 10px; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-large__17hsQ::before,\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-large__17hsQ > *,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-tag__t-27S::before,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-tag__t-27S > * {\n  margin-right: 7px; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-large__17hsQ:empty::before,\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-large__17hsQ > :last-child,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-tag__t-27S:empty::before,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-tag__t-27S > :last-child {\n  margin-right: 0; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-large__17hsQ.ReportsFilter_bp3-round__12jLZ,\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-round__12jLZ {\n  padding-left: 12px;\n  padding-right: 12px; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-primary__OlAS0 {\n  background: #137cbd;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(19, 124, 189, 0.85); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(19, 124, 189, 0.7); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-success__3_w9z {\n  background: #0f9960;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(15, 153, 96, 0.85); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(15, 153, 96, 0.7); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-warning__372vs {\n  background: #d9822b;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(217, 130, 43, 0.85); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(217, 130, 43, 0.7); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-danger__GyPAj {\n  background: #db3737;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(219, 55, 55, 0.85); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(219, 55, 55, 0.7); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-fill__3iORs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9 > .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9 .ReportsFilter_bp3-icon-large__oZ-F2 {\n  fill: #5c7080; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]) {\n  background-color: rgba(138, 155, 168, 0.2);\n  color: #182026; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(92, 112, 128, 0.3); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(92, 112, 128, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]) {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(191, 204, 214, 0.3); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]).ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(191, 204, 214, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]) > .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]) .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9:not([class*=\"bp3-intent-\"]) .ReportsFilter_bp3-icon-large__oZ-F2 {\n  fill: #a7b6c2; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0 {\n  background-color: rgba(19, 124, 189, 0.15);\n  color: #106ba3; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(19, 124, 189, 0.25); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(19, 124, 189, 0.35); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0 > .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-icon-large__oZ-F2 {\n  fill: #137cbd; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0 {\n  background-color: rgba(19, 124, 189, 0.25);\n  color: #48aff0; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(19, 124, 189, 0.35); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-primary__OlAS0.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(19, 124, 189, 0.45); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z {\n  background-color: rgba(15, 153, 96, 0.15);\n  color: #0d8050; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(15, 153, 96, 0.25); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(15, 153, 96, 0.35); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z > .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-icon-large__oZ-F2 {\n  fill: #0f9960; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z {\n  background-color: rgba(15, 153, 96, 0.25);\n  color: #3dcc91; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(15, 153, 96, 0.35); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-success__3_w9z.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(15, 153, 96, 0.45); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs {\n  background-color: rgba(217, 130, 43, 0.15);\n  color: #bf7326; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(217, 130, 43, 0.25); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(217, 130, 43, 0.35); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs > .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-icon-large__oZ-F2 {\n  fill: #d9822b; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs {\n  background-color: rgba(217, 130, 43, 0.25);\n  color: #ffb366; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(217, 130, 43, 0.35); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-warning__372vs.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(217, 130, 43, 0.45); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj {\n  background-color: rgba(219, 55, 55, 0.15);\n  color: #c23030; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(219, 55, 55, 0.25); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(219, 55, 55, 0.35); }\n\n.ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj > .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-icon-large__oZ-F2 {\n  fill: #db3737; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj {\n  background-color: rgba(219, 55, 55, 0.25);\n  color: #ff7373; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv {\n  cursor: pointer; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv:hover {\n  background-color: rgba(219, 55, 55, 0.35); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-minimal__V1Rn9.ReportsFilter_bp3-intent-danger__GyPAj.ReportsFilter_bp3-interactive__3MyBv:active {\n  background-color: rgba(219, 55, 55, 0.45); }\n\n.ReportsFilter_bp3-tag-remove__3sM0T {\n  background: none;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: -2px;\n  margin-right: -6px !important;\n  margin-top: -2px;\n  opacity: 0.5;\n  padding: 2px;\n  padding-left: 0; }\n\n.ReportsFilter_bp3-tag-remove__3sM0T:hover {\n  background: none;\n  opacity: 0.8;\n  text-decoration: none; }\n\n.ReportsFilter_bp3-tag-remove__3sM0T:active {\n  opacity: 1; }\n\n.ReportsFilter_bp3-tag-remove__3sM0T:empty::before {\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\E6D7\"; }\n\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-tag-remove__3sM0T {\n  margin-right: -10px !important;\n  padding: 5px;\n  padding-left: 0; }\n\n.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-tag-remove__3sM0T:empty::before {\n  font-family: \"Icons20\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1; }\n\n.ReportsFilter_bp3-tag-input__24o9m {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  cursor: text;\n  height: auto;\n  line-height: inherit;\n  min-height: 30px;\n  padding-left: 5px;\n  padding-right: 0; }\n\n.ReportsFilter_bp3-tag-input__24o9m > * {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0; }\n\n.ReportsFilter_bp3-tag-input__24o9m > .ReportsFilter_bp3-tag-input-values__vSOc7 {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-icon__3_IX0 {\n  color: #5c7080;\n  margin-left: 2px;\n  margin-right: 7px;\n  margin-top: 7px; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-values__vSOc7 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: stretch;\n  align-self: stretch;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: 7px;\n  margin-top: 5px;\n  min-width: 0; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-values__vSOc7 > * {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-values__vSOc7 > .ReportsFilter_bp3-fill__3iORs {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-values__vSOc7::before,\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-values__vSOc7 > * {\n  margin-right: 5px; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-values__vSOc7:empty::before,\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-values__vSOc7 > :last-child {\n  margin-right: 0; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-values__vSOc7:first-child .ReportsFilter_bp3-input-ghost__1zjbe:first-child {\n  padding-left: 5px; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-values__vSOc7 > * {\n  margin-bottom: 5px; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag__t-27S {\n  overflow-wrap: break-word; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag__t-27S.ReportsFilter_bp3-active__1Mw-V {\n  outline: rgba(19, 124, 189, 0.6) auto 2px;\n  outline-offset: 0;\n  -moz-outline-radius: 6px; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-input-ghost__1zjbe {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  line-height: 20px;\n  width: 80px; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-input-ghost__1zjbe:disabled, .ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-input-ghost__1zjbe.ReportsFilter_bp3-disabled__1YzwV {\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-button__15ViT,\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-spinner__1DHED {\n  margin: 3px;\n  margin-left: 0; }\n\n.ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-button__15ViT {\n  min-height: 24px;\n  min-width: 24px;\n  padding: 0 7px; }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-large__17hsQ {\n  height: auto;\n  min-height: 40px; }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-large__17hsQ::before,\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-large__17hsQ > * {\n  margin-right: 10px; }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-large__17hsQ:empty::before,\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-large__17hsQ > :last-child {\n  margin-right: 0; }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-tag-input-icon__3_IX0 {\n  margin-left: 5px;\n  margin-top: 10px; }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-input-ghost__1zjbe {\n  line-height: 30px; }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-button__15ViT {\n  min-height: 30px;\n  min-width: 30px;\n  padding: 5px 10px;\n  margin: 5px;\n  margin-left: 0; }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-large__17hsQ .ReportsFilter_bp3-spinner__1DHED {\n  margin: 8px;\n  margin-left: 0; }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-active__1Mw-V {\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-primary__OlAS0 {\n  -webkit-box-shadow: 0 0 0 1px #106ba3, 0 0 0 3px rgba(16, 107, 163, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #106ba3, 0 0 0 3px rgba(16, 107, 163, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-success__3_w9z {\n  -webkit-box-shadow: 0 0 0 1px #0d8050, 0 0 0 3px rgba(13, 128, 80, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #0d8050, 0 0 0 3px rgba(13, 128, 80, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-warning__372vs {\n  -webkit-box-shadow: 0 0 0 1px #bf7326, 0 0 0 3px rgba(191, 115, 38, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #bf7326, 0 0 0 3px rgba(191, 115, 38, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-danger__GyPAj {\n  -webkit-box-shadow: 0 0 0 1px #c23030, 0 0 0 3px rgba(194, 48, 48, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px #c23030, 0 0 0 3px rgba(194, 48, 48, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-tag-input-icon__3_IX0, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input-icon__3_IX0 {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-input-ghost__1zjbe, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-ghost__1zjbe {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-input-ghost__1zjbe::-webkit-input-placeholder, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-ghost__1zjbe::-webkit-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-input-ghost__1zjbe::-moz-placeholder, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-ghost__1zjbe::-moz-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-input-ghost__1zjbe:-ms-input-placeholder, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-ghost__1zjbe:-ms-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-input-ghost__1zjbe::-ms-input-placeholder, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-ghost__1zjbe::-ms-input-placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m .ReportsFilter_bp3-input-ghost__1zjbe::placeholder, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-input-ghost__1zjbe::placeholder {\n  color: rgba(167, 182, 194, 0.6); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-active__1Mw-V, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO.ReportsFilter_bp3-active__1Mw-V {\n  background-color: rgba(16, 22, 26, 0.3);\n  -webkit-box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-primary__OlAS0 {\n  -webkit-box-shadow: 0 0 0 1px #106ba3, 0 0 0 3px rgba(16, 107, 163, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #106ba3, 0 0 0 3px rgba(16, 107, 163, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-success__3_w9z {\n  -webkit-box-shadow: 0 0 0 1px #0d8050, 0 0 0 3px rgba(13, 128, 80, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #0d8050, 0 0 0 3px rgba(13, 128, 80, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-warning__372vs {\n  -webkit-box-shadow: 0 0 0 1px #bf7326, 0 0 0 3px rgba(191, 115, 38, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #bf7326, 0 0 0 3px rgba(191, 115, 38, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-tag-input__24o9m.ReportsFilter_bp3-dark__3R7GO.ReportsFilter_bp3-active__1Mw-V.ReportsFilter_bp3-intent-danger__GyPAj {\n  -webkit-box-shadow: 0 0 0 1px #c23030, 0 0 0 3px rgba(194, 48, 48, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px #c23030, 0 0 0 3px rgba(194, 48, 48, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-input-ghost__1zjbe {\n  background: none;\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 0; }\n\n.ReportsFilter_bp3-input-ghost__1zjbe::-webkit-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-input-ghost__1zjbe::-moz-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-input-ghost__1zjbe:-ms-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-input-ghost__1zjbe::-ms-input-placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-input-ghost__1zjbe::placeholder {\n  color: rgba(92, 112, 128, 0.6);\n  opacity: 1; }\n\n.ReportsFilter_bp3-input-ghost__1zjbe:focus {\n  outline: none !important; }\n\n.ReportsFilter_bp3-toast__DSImg {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  background-color: #ffffff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 20px 0 0;\n  max-width: 500px;\n  min-width: 300px;\n  pointer-events: all;\n  position: relative !important; }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-enter__1zqR_, .ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-appear__3hha6 {\n  -webkit-transform: translateY(-40px);\n  transform: translateY(-40px); }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-enter-active__2O5kf, .ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-appear-active__3NTHR {\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 300ms;\n  transition-duration: 300ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11); }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-enter__1zqR_ ~ .ReportsFilter_bp3-toast__DSImg, .ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-appear__3hha6 ~ .ReportsFilter_bp3-toast__DSImg {\n  -webkit-transform: translateY(-40px);\n  transform: translateY(-40px); }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-enter-active__2O5kf ~ .ReportsFilter_bp3-toast__DSImg, .ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-appear-active__3NTHR ~ .ReportsFilter_bp3-toast__DSImg {\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 300ms;\n  transition-duration: 300ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11); }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-exit__12UyT {\n  opacity: 1;\n  -webkit-filter: blur(0);\n  filter: blur(0); }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-exit-active__24fXc {\n  opacity: 0;\n  -webkit-filter: blur(10px);\n  filter: blur(10px);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 300ms;\n  transition-duration: 300ms;\n  -webkit-transition-property: opacity, -webkit-filter;\n  transition-property: opacity, -webkit-filter;\n  transition-property: opacity, filter;\n  transition-property: opacity, filter, -webkit-filter;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-exit__12UyT ~ .ReportsFilter_bp3-toast__DSImg {\n  -webkit-transform: translateY(0);\n  transform: translateY(0); }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-exit-active__24fXc ~ .ReportsFilter_bp3-toast__DSImg {\n  -webkit-transform: translateY(-40px);\n  transform: translateY(-40px);\n  -webkit-transition-delay: 50ms;\n  transition-delay: 50ms;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-toast__DSImg .ReportsFilter_bp3-button-group__OVeCS {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  padding: 5px;\n  padding-left: 0; }\n\n.ReportsFilter_bp3-toast__DSImg > .ReportsFilter_bp3-icon__15ATj {\n  color: #5c7080;\n  margin: 12px;\n  margin-right: 0; }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-toast__DSImg {\n  background-color: #394b59;\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-dark__3R7GO > .ReportsFilter_bp3-icon__15ATj,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-toast__DSImg > .ReportsFilter_bp3-icon__15ATj {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] a {\n  color: rgba(255, 255, 255, 0.7); }\n\n.ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] a:hover {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] > .ReportsFilter_bp3-icon__15ATj {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] .ReportsFilter_bp3-button__15ViT, .ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] .ReportsFilter_bp3-button__15ViT::before,\n.ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] .ReportsFilter_bp3-button__15ViT .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] .ReportsFilter_bp3-button__15ViT:active {\n  color: rgba(255, 255, 255, 0.7) !important; }\n\n.ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] .ReportsFilter_bp3-button__15ViT:focus {\n  outline-color: rgba(255, 255, 255, 0.5); }\n\n.ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] .ReportsFilter_bp3-button__15ViT:hover {\n  background-color: rgba(255, 255, 255, 0.15) !important;\n  color: #ffffff !important; }\n\n.ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] .ReportsFilter_bp3-button__15ViT:active {\n  background-color: rgba(255, 255, 255, 0.3) !important;\n  color: #ffffff !important; }\n\n.ReportsFilter_bp3-toast__DSImg[class*=\"bp3-intent-\"] .ReportsFilter_bp3-button__15ViT::after {\n  background: rgba(255, 255, 255, 0.3) !important; }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-intent-primary__OlAS0 {\n  background-color: #137cbd;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-intent-success__3_w9z {\n  background-color: #0f9960;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-intent-warning__372vs {\n  background-color: #d9822b;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-intent-danger__GyPAj {\n  background-color: #db3737;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-toast-message__2Fqla {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  padding: 11px;\n  word-break: break-word; }\n\n.ReportsFilter_bp3-toast-container__2QYE2 {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  left: 0;\n  overflow: hidden;\n  padding: 0 20px 20px;\n  pointer-events: none;\n  position: fixed;\n  right: 0;\n  z-index: 40; }\n\n.ReportsFilter_bp3-toast-container__2QYE2.ReportsFilter_bp3-toast-container-top__16fsA {\n  top: 0; }\n\n.ReportsFilter_bp3-toast-container__2QYE2.ReportsFilter_bp3-toast-container-bottom__11H0x {\n  bottom: 0;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: column-reverse;\n  flex-direction: column-reverse;\n  top: auto; }\n\n.ReportsFilter_bp3-toast-container__2QYE2.ReportsFilter_bp3-toast-container-left__XP6xc {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start; }\n\n.ReportsFilter_bp3-toast-container__2QYE2.ReportsFilter_bp3-toast-container-right__SYbk_ {\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end; }\n\n.ReportsFilter_bp3-toast-container-bottom__11H0x .ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-enter__1zqR_:not(.ReportsFilter_bp3-toast-enter-active__2O5kf),\n.ReportsFilter_bp3-toast-container-bottom__11H0x .ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-enter__1zqR_:not(.ReportsFilter_bp3-toast-enter-active__2O5kf) ~ .ReportsFilter_bp3-toast__DSImg, .ReportsFilter_bp3-toast-container-bottom__11H0x .ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-appear__3hha6:not(.ReportsFilter_bp3-toast-appear-active__3NTHR),\n.ReportsFilter_bp3-toast-container-bottom__11H0x .ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-appear__3hha6:not(.ReportsFilter_bp3-toast-appear-active__3NTHR) ~ .ReportsFilter_bp3-toast__DSImg,\n.ReportsFilter_bp3-toast-container-bottom__11H0x .ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-exit-active__24fXc ~ .ReportsFilter_bp3-toast__DSImg,\n.ReportsFilter_bp3-toast-container-bottom__11H0x .ReportsFilter_bp3-toast__DSImg.ReportsFilter_bp3-toast-leave-active__16ofn ~ .ReportsFilter_bp3-toast__DSImg {\n  -webkit-transform: translateY(60px);\n  transform: translateY(60px); }\n\n.ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  -webkit-transform: scale(1);\n  transform: scale(1); }\n\n.ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-arrow__35dvK {\n  height: 22px;\n  position: absolute;\n  width: 22px; }\n\n.ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-arrow__35dvK::before {\n  height: 14px;\n  margin: 4px;\n  width: 14px; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-target-attached-top__324h6 > .ReportsFilter_bp3-tooltip__1NXdl {\n  margin-bottom: 11px;\n  margin-top: -11px; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-target-attached-top__324h6 > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK {\n  bottom: -8px; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-target-attached-top__324h6 > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK svg {\n  -webkit-transform: rotate(-90deg);\n  transform: rotate(-90deg); }\n\n.ReportsFilter_bp3-tether-element-attached-left__p1Z0k.ReportsFilter_bp3-tether-target-attached-right__2rvqh > .ReportsFilter_bp3-tooltip__1NXdl {\n  margin-left: 11px; }\n\n.ReportsFilter_bp3-tether-element-attached-left__p1Z0k.ReportsFilter_bp3-tether-target-attached-right__2rvqh > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK {\n  left: -8px; }\n\n.ReportsFilter_bp3-tether-element-attached-left__p1Z0k.ReportsFilter_bp3-tether-target-attached-right__2rvqh > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK svg {\n  -webkit-transform: rotate(0);\n  transform: rotate(0); }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-target-attached-bottom__r4QYp > .ReportsFilter_bp3-tooltip__1NXdl {\n  margin-top: 11px; }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-target-attached-bottom__r4QYp > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK {\n  top: -8px; }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-target-attached-bottom__r4QYp > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK svg {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg); }\n\n.ReportsFilter_bp3-tether-element-attached-right__2enGx.ReportsFilter_bp3-tether-target-attached-left__dPLP_ > .ReportsFilter_bp3-tooltip__1NXdl {\n  margin-left: -11px;\n  margin-right: 11px; }\n\n.ReportsFilter_bp3-tether-element-attached-right__2enGx.ReportsFilter_bp3-tether-target-attached-left__dPLP_ > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK {\n  right: -8px; }\n\n.ReportsFilter_bp3-tether-element-attached-right__2enGx.ReportsFilter_bp3-tether-target-attached-left__dPLP_ > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK svg {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg); }\n\n.ReportsFilter_bp3-tether-element-attached-middle__hFPd4 > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%); }\n\n.ReportsFilter_bp3-tether-element-attached-center__RGCg2 > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK {\n  right: 50%;\n  -webkit-transform: translateX(50%);\n  transform: translateX(50%); }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-target-attached-top__324h6 > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK {\n  top: -0.22183px; }\n\n.ReportsFilter_bp3-tether-element-attached-right__2enGx.ReportsFilter_bp3-tether-target-attached-right__2rvqh > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK {\n  right: -0.22183px; }\n\n.ReportsFilter_bp3-tether-element-attached-left__p1Z0k.ReportsFilter_bp3-tether-target-attached-left__dPLP_ > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK {\n  left: -0.22183px; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-target-attached-bottom__r4QYp > .ReportsFilter_bp3-tooltip__1NXdl > .ReportsFilter_bp3-popover-arrow__35dvK {\n  bottom: -0.22183px; }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-element-attached-left__p1Z0k > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform-origin: top left;\n  transform-origin: top left; }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-element-attached-center__RGCg2 > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform-origin: top center;\n  transform-origin: top center; }\n\n.ReportsFilter_bp3-tether-element-attached-top__3p4hA.ReportsFilter_bp3-tether-element-attached-right__2enGx > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform-origin: top right;\n  transform-origin: top right; }\n\n.ReportsFilter_bp3-tether-element-attached-middle__hFPd4.ReportsFilter_bp3-tether-element-attached-left__p1Z0k > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform-origin: center left;\n  transform-origin: center left; }\n\n.ReportsFilter_bp3-tether-element-attached-middle__hFPd4.ReportsFilter_bp3-tether-element-attached-center__RGCg2 > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform-origin: center center;\n  transform-origin: center center; }\n\n.ReportsFilter_bp3-tether-element-attached-middle__hFPd4.ReportsFilter_bp3-tether-element-attached-right__2enGx > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform-origin: center right;\n  transform-origin: center right; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-element-attached-left__p1Z0k > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform-origin: bottom left;\n  transform-origin: bottom left; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-element-attached-center__RGCg2 > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform-origin: bottom center;\n  transform-origin: bottom center; }\n\n.ReportsFilter_bp3-tether-element-attached-bottom__icaq4.ReportsFilter_bp3-tether-element-attached-right__2enGx > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform-origin: bottom right;\n  transform-origin: bottom right; }\n\n.ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-content__2X1nV {\n  background: #394b59;\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-arrow__35dvK::before {\n  -webkit-box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.2);\n  box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.2); }\n\n.ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-arrow-border__2wZtp {\n  fill: #10161a;\n  fill-opacity: 0.1; }\n\n.ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-arrow-fill__3ZcIs {\n  fill: #394b59; }\n\n.ReportsFilter_bp3-popover-enter__1H7E0 > .ReportsFilter_bp3-tooltip__1NXdl, .ReportsFilter_bp3-popover-appear__3iRJU > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform: scale(0.8);\n  transform: scale(0.8); }\n\n.ReportsFilter_bp3-popover-enter-active__2Rs6c > .ReportsFilter_bp3-tooltip__1NXdl, .ReportsFilter_bp3-popover-appear-active__2dwM2 > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-popover-exit__FnKlU > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform: scale(1);\n  transform: scale(1); }\n\n.ReportsFilter_bp3-popover-exit-active__xoMhf > .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-transform: scale(0.8);\n  transform: scale(0.8);\n  -webkit-transition-delay: 0;\n  transition-delay: 0;\n  -webkit-transition-duration: 100ms;\n  transition-duration: 100ms;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-content__2X1nV {\n  padding: 10px 12px; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-dark__3R7GO,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tooltip__1NXdl {\n  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4);\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-content__2X1nV,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-content__2X1nV {\n  background: #e1e8ed;\n  color: #394b59; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-arrow__35dvK::before,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-arrow__35dvK::before {\n  -webkit-box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.4);\n  box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.4); }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-arrow-border__2wZtp,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-arrow-border__2wZtp {\n  fill: #10161a;\n  fill-opacity: 0.2; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-popover-arrow-fill__3ZcIs,\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tooltip__1NXdl .ReportsFilter_bp3-popover-arrow-fill__3ZcIs {\n  fill: #e1e8ed; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-popover-content__2X1nV {\n  background: #137cbd;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-intent-primary__OlAS0 .ReportsFilter_bp3-popover-arrow-fill__3ZcIs {\n  fill: #137cbd; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-popover-content__2X1nV {\n  background: #0f9960;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-intent-success__3_w9z .ReportsFilter_bp3-popover-arrow-fill__3ZcIs {\n  fill: #0f9960; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-popover-content__2X1nV {\n  background: #d9822b;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-intent-warning__372vs .ReportsFilter_bp3-popover-arrow-fill__3ZcIs {\n  fill: #d9822b; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-popover-content__2X1nV {\n  background: #db3737;\n  color: #ffffff; }\n\n.ReportsFilter_bp3-tooltip__1NXdl.ReportsFilter_bp3-intent-danger__GyPAj .ReportsFilter_bp3-popover-arrow-fill__3ZcIs {\n  fill: #db3737; }\n\n.ReportsFilter_bp3-tooltip-indicator__2XINR {\n  border-bottom: dotted 1px;\n  cursor: help; }\n\n.ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-large__oZ-F2 {\n  color: #5c7080; }\n\n.ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #137cbd; }\n\n.ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #0f9960; }\n\n.ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-warning__372vs {\n  color: #d9822b; }\n\n.ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #db3737; }\n\n.ReportsFilter_bp3-tree-node-list__1-ZhO {\n  list-style: none;\n  margin: 0;\n  padding-left: 0; }\n\n.ReportsFilter_bp3-tree-root__3Pdp9 {\n  background-color: transparent;\n  cursor: default;\n  padding-left: 0;\n  position: relative; }\n\n.ReportsFilter_bp3-tree-node-content-0__3d6XK {\n  padding-left: 0px; }\n\n.ReportsFilter_bp3-tree-node-content-1__3rgdV {\n  padding-left: 23px; }\n\n.ReportsFilter_bp3-tree-node-content-2__16yHZ {\n  padding-left: 46px; }\n\n.ReportsFilter_bp3-tree-node-content-3__5NxUO {\n  padding-left: 69px; }\n\n.ReportsFilter_bp3-tree-node-content-4__1YSLF {\n  padding-left: 92px; }\n\n.ReportsFilter_bp3-tree-node-content-5__28zlN {\n  padding-left: 115px; }\n\n.ReportsFilter_bp3-tree-node-content-6__1hZxg {\n  padding-left: 138px; }\n\n.ReportsFilter_bp3-tree-node-content-7__38Ixx {\n  padding-left: 161px; }\n\n.ReportsFilter_bp3-tree-node-content-8__1gewt {\n  padding-left: 184px; }\n\n.ReportsFilter_bp3-tree-node-content-9__10Cfy {\n  padding-left: 207px; }\n\n.ReportsFilter_bp3-tree-node-content-10__VxwfY {\n  padding-left: 230px; }\n\n.ReportsFilter_bp3-tree-node-content-11__1fY5I {\n  padding-left: 253px; }\n\n.ReportsFilter_bp3-tree-node-content-12__2EnRJ {\n  padding-left: 276px; }\n\n.ReportsFilter_bp3-tree-node-content-13__2qMX- {\n  padding-left: 299px; }\n\n.ReportsFilter_bp3-tree-node-content-14__2PqNF {\n  padding-left: 322px; }\n\n.ReportsFilter_bp3-tree-node-content-15__1bhgu {\n  padding-left: 345px; }\n\n.ReportsFilter_bp3-tree-node-content-16__2CeZk {\n  padding-left: 368px; }\n\n.ReportsFilter_bp3-tree-node-content-17__285-q {\n  padding-left: 391px; }\n\n.ReportsFilter_bp3-tree-node-content-18__3w7hd {\n  padding-left: 414px; }\n\n.ReportsFilter_bp3-tree-node-content-19__1JCZ9 {\n  padding-left: 437px; }\n\n.ReportsFilter_bp3-tree-node-content-20__2XXtI {\n  padding-left: 460px; }\n\n.ReportsFilter_bp3-tree-node-content__3r7DA {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 30px;\n  padding-right: 5px;\n  width: 100%; }\n\n.ReportsFilter_bp3-tree-node-content__3r7DA:hover {\n  background-color: rgba(191, 204, 214, 0.4); }\n\n.ReportsFilter_bp3-tree-node-caret__2RRE1,\n.ReportsFilter_bp3-tree-node-caret-none__H8bIO {\n  min-width: 30px; }\n\n.ReportsFilter_bp3-tree-node-caret__2RRE1 {\n  color: #5c7080;\n  cursor: pointer;\n  padding: 7px;\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.ReportsFilter_bp3-tree-node-caret__2RRE1:hover {\n  color: #182026; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree-node-caret__2RRE1 {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree-node-caret__2RRE1:hover {\n  color: #f5f8fa; }\n\n.ReportsFilter_bp3-tree-node-caret__2RRE1.ReportsFilter_bp3-tree-node-caret-open__1PmrQ {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg); }\n\n.ReportsFilter_bp3-tree-node-caret__2RRE1.ReportsFilter_bp3-icon-standard__1vHca::before {\n  content: \"\\E695\"; }\n\n.ReportsFilter_bp3-tree-node-icon__2VHlD {\n  margin-right: 7px;\n  position: relative; }\n\n.ReportsFilter_bp3-tree-node-label__3LSyM {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.ReportsFilter_bp3-tree-node-label__3LSyM span {\n  display: inline; }\n\n.ReportsFilter_bp3-tree-node-secondary-label__237uk {\n  padding: 0 5px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.ReportsFilter_bp3-tree-node-secondary-label__237uk .ReportsFilter_bp3-popover-wrapper__1aeCY,\n.ReportsFilter_bp3-tree-node-secondary-label__237uk .ReportsFilter_bp3-popover-target__2jiug {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-tree-node-content__3r7DA {\n  background-color: inherit;\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-tree-node-caret__2RRE1,\n.ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-disabled__1YzwV .ReportsFilter_bp3-tree-node-icon__2VHlD {\n  color: rgba(92, 112, 128, 0.6);\n  cursor: not-allowed; }\n\n.ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-tree-node-selected__3Zgs5 > .ReportsFilter_bp3-tree-node-content__3r7DA {\n  background-color: #137cbd; }\n\n.ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-tree-node-selected__3Zgs5 > .ReportsFilter_bp3-tree-node-content__3r7DA,\n.ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-tree-node-selected__3Zgs5 > .ReportsFilter_bp3-tree-node-content__3r7DA .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-tree-node-selected__3Zgs5 > .ReportsFilter_bp3-tree-node-content__3r7DA .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-tree-node-selected__3Zgs5 > .ReportsFilter_bp3-tree-node-content__3r7DA .ReportsFilter_bp3-icon-large__oZ-F2 {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-tree-node-selected__3Zgs5 > .ReportsFilter_bp3-tree-node-content__3r7DA .ReportsFilter_bp3-tree-node-caret__2RRE1::before {\n  color: rgba(255, 255, 255, 0.7); }\n\n.ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-tree-node-selected__3Zgs5 > .ReportsFilter_bp3-tree-node-content__3r7DA .ReportsFilter_bp3-tree-node-caret__2RRE1:hover::before {\n  color: #ffffff; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree-node-content__3r7DA:hover {\n  background-color: rgba(92, 112, 128, 0.3); }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon__15ATj, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-standard__1vHca, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-large__oZ-F2 {\n  color: #a7b6c2; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-primary__OlAS0, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-primary__OlAS0 {\n  color: #137cbd; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-success__3_w9z, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-success__3_w9z {\n  color: #0f9960; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-warning__372vs, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-warning__372vs {\n  color: #d9822b; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon__15ATj.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-standard__1vHca.ReportsFilter_bp3-intent-danger__GyPAj, .ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree__1PxFT .ReportsFilter_bp3-icon-large__oZ-F2.ReportsFilter_bp3-intent-danger__GyPAj {\n  color: #db3737; }\n\n.ReportsFilter_bp3-dark__3R7GO .ReportsFilter_bp3-tree-node__3Y85w.ReportsFilter_bp3-tree-node-selected__3Zgs5 > .ReportsFilter_bp3-tree-node-content__3r7DA {\n  background-color: #137cbd; }\nli {\n  list-style-type: none; }\n\n.ReportsFilter_ReportsFilter__container__gszEK {\n  min-height: 90px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px 0 #e8eaec;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 3; }\n\n.ReportsFilter_ReportsFilter__inner__dQaro {\n  width: 100%;\n  padding: 20px 24px 12px;\n  display: flex;\n  justify-content: space-between; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__timeframe__1U_en {\n    width: 226px; }\n  .ReportsFilter_ReportsFilter__inner__dQaro label {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 18px;\n    color: #000000; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__AddFilterButton_container__3EBiv {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__AddFilterButton__kbh_W {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    min-width: 70px;\n    height: 32px;\n    border-radius: 5px;\n    background-color: #dfeef2;\n    font-size: 12px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 2.29;\n    letter-spacing: normal;\n    color: #173042;\n    cursor: pointer;\n    margin: 0 12px 12px 0;\n    z-index: 2; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButtons_container__ea_0i {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    padding-top: 12px;\n    flex: 1;\n    z-index: 2; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButton_inner__ZOm6x {\n    display: none;\n    margin: 0 12px 0 0; }\n  @media screen and (max-width: 1560px) {\n    .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButton_inner__ZOm6x {\n      margin: 12px 12px 0 0; } }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButton_inner__ZOm6x.ReportsFilter_show__3vXpF {\n    display: block; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButton_container__2WLPv {\n    display: flex;\n    justify-content: center;\n    position: relative; }\n    .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButton_container__2WLPv:hover > .ReportsFilter_ReportsFilter__RemoveFilterButton__7PFmD {\n      display: flex; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__RemoveFilterButton__7PFmD {\n    position: absolute;\n    display: none;\n    justify-content: center;\n    align-items: center;\n    height: 20px;\n    width: 20px;\n    top: -15px;\n    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.33);\n    border: solid 0 #173042;\n    border-radius: 100%;\n    background-color: #fff;\n    transition: all 0.5s;\n    cursor: pointer;\n    text-align: center;\n    font-size: 9px; }\n    .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__RemoveFilterButton__7PFmD p {\n      margin-top: 0;\n      margin-bottom: 0;\n      padding: 0 5px;\n      min-width: 100px;\n      display: flex;\n      justify-content: space-evenly;\n      align-items: center; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__RemoveFilterButton__7PFmD:hover {\n    width: 100px;\n    border-radius: 25px; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButton__1j_mF {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    height: 32px;\n    border-radius: 5px;\n    background-color: #edf0f2;\n    cursor: pointer;\n    padding: 0 8px; }\n    .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButton__1j_mF.ReportsFilter_focus__2NDe7 {\n      border-radius: 7px;\n      box-shadow: 0 0 4px 0 rgba(38, 38, 38, 0.25);\n      border: solid 1px #a2acb3; }\n    .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButton__1j_mF .ReportsFilter_fa-chevron-right__3FtFc {\n      font-size: 11px;\n      line-height: 10px; }\n    .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButton__1j_mF p {\n      font-size: 12px;\n      font-weight: 700;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: 2.29;\n      letter-spacing: normal;\n      color: #173042;\n      margin: 0; }\n    .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterButton__1j_mF span {\n      font-size: 12px;\n      font-weight: normal;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: 2.29;\n      letter-spacing: normal;\n      color: #173042;\n      margin-right: 15px; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__AddFilterDropdown__7l-M2 {\n    position: absolute;\n    top: 235px;\n    width: 130px; }\n    .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__AddFilterDropdown__7l-M2 .ReportsFilter_ReportsFilter__FilterDropdownItem__91AmU:hover {\n      cursor: pointer;\n      background-color: #dfeef2;\n      border-radius: 4px; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterDropdown__6rIT_ {\n    position: absolute;\n    width: 100%;\n    max-width: 200px; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterDropdown__6rIT_::-webkit-scrollbar {\n    width: 8px; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterDropdown__6rIT_::-webkit-scrollbar-thumb {\n    height: 54px;\n    border-radius: 10px;\n    box-shadow: 0 0 6px 0 #acacac;\n    background-color: #ffffff; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterDropdown__6rIT_,\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__AddFilterDropdown__7l-M2 {\n    height: 230px;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px 0 #d1dadc;\n    background-color: #ffffff;\n    overflow-y: auto;\n    overflow-x: hidden;\n    z-index: 9999;\n    padding: 5px; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterDropdown__background__2aaq9 {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    color: red;\n    height: 100%;\n    width: 100%; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__FilterDropdownItem__91AmU {\n    font-size: 12px;\n    color: #000000;\n    padding: 5px; }\n  .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__Timeframe__3H_uP {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 226px;\n    height: 32px;\n    min-height: 32px;\n    border-radius: 5px;\n    background-color: #dfeef2;\n    color: #000000;\n    font-size: 12px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 2.67;\n    letter-spacing: normal; }\n    .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__Timeframe__3H_uP .ReportsFilter_ReportsFilter__date__28i6Y {\n      display: flex;\n      justify-content: space-around;\n      margin: 0 0.5rem; }\n      .ReportsFilter_ReportsFilter__inner__dQaro .ReportsFilter_ReportsFilter__Timeframe__3H_uP .ReportsFilter_ReportsFilter__date__28i6Y .ReportsFilter_ReportsFilter__StartDate__xnVxo {\n        margin-right: 0.5rem; }\n\n.ReportsFilter_bp3-control__uzs-q .ReportsFilter_bp3-control-indicator__3WfzA {\n  height: unset;\n  width: unset;\n  border: 2px solid #000; }\n\n.ReportsFilter_bp3-control__uzs-q input:checked ~ .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #4eb3d4 !important; }\n\n.ReportsFilter_bp3-control__uzs-q input:checked .ReportsFilter_bp3-control-indicator__3WfzA {\n  background-color: #4eb3d4 !important;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n  color: #ffffff; }\n";
styleInject(css_248z$o);

var ReportsFilter = function ReportsFilter(_ref) {
  var tenantId = _ref.tenantId,
      activeFilter = _ref.activeFilter,
      setActiveFilter = _ref.setActiveFilter,
      setActiveFilterDates = _ref.setActiveFilterDates,
      pastReport = _ref.pastReport,
      updatePastReport = _ref.updatePastReport,
      baseFilters = _ref.baseFilters,
      filteredReport = _ref.filteredReport,
      DatePicker = _ref.DatePicker,
      datePickerLabel = _ref.datePickerLabel,
      addFiltersLabel = _ref.addFiltersLabel,
      allFiltersItemText = _ref.allFiltersItemText,
      addFiltersButtonText = _ref.addFiltersButtonText,
      removeFilterButtonText = _ref.removeFilterButtonText;

  // Add Filter Field Dropdown State
  var _useState = React$2.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      filterMenuIsOpen = _useState2[0],
      setFilterMenuIsOpen = _useState2[1]; // Filter Field Dropdown States


  var _useState3 = React$2.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      jobTitleMenuOpen = _useState4[0],
      setJobTitleMenuOpen = _useState4[1];

  var _useState5 = React$2.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      rolesMenuOpen = _useState6[0],
      setRolesMenuOpen = _useState6[1];

  var _useState7 = React$2.useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      departmentsMenuOpen = _useState8[0],
      setDepartmentsMenuOpen = _useState8[1];

  var _useState9 = React$2.useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      divisionsMenuOpen = _useState10[0],
      setDivisionsMenuOpen = _useState10[1];

  var _useState11 = React$2.useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      locationsMenuOpen = _useState12[0],
      setLocationsMenuOpen = _useState12[1];

  var _useState13 = React$2.useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      citiesMenuOpen = _useState14[0],
      setCitiesMenuOpen = _useState14[1];

  var _useState15 = React$2.useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      statesMenuOpen = _useState16[0],
      setStatesMenuOpen = _useState16[1]; // Active Filter Field Dropdown State


  var _useState17 = React$2.useState(''),
      _useState18 = _slicedToArray(_useState17, 2),
      activeDropdown = _useState18[0],
      setActiveDropdown = _useState18[1];

  var closeAllDropdowns = function closeAllDropdowns() {
    updatePastReport();
    setFilterMenuIsOpen(false);
    setJobTitleMenuOpen(false);
    setRolesMenuOpen(false);
    setDepartmentsMenuOpen(false);
    setDivisionsMenuOpen(false);
    setLocationsMenuOpen(false);
    setCitiesMenuOpen(false);
    setStatesMenuOpen(false);
  };

  var toggleFilterFieldMenus = function toggleFilterFieldMenus(filterField) {
    switch (filterField) {
      case 'jobTitles':
        closeAllDropdowns();
        setJobTitleMenuOpen(function (prevState) {
          return !prevState;
        });
        break;

      case 'roles':
        closeAllDropdowns();
        setRolesMenuOpen(function (prevState) {
          return !prevState;
        });
        break;

      case 'departments':
        closeAllDropdowns();
        setDepartmentsMenuOpen(function (prevState) {
          return !prevState;
        });
        break;

      case 'divisions':
        closeAllDropdowns();
        setDivisionsMenuOpen(function (prevState) {
          return !prevState;
        });
        break;

      case 'states':
        closeAllDropdowns();
        setStatesMenuOpen(function (prevState) {
          return !prevState;
        });
        break;

      case 'cities':
        closeAllDropdowns();
        setCitiesMenuOpen(function (prevState) {
          return !prevState;
        });
        break;

      case 'locations':
        closeAllDropdowns();
        setLocationsMenuOpen(function (prevState) {
          return !prevState;
        });
        break;
    }
  }; // Active Filter Fields State


  var _useState19 = React$2.useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      activeFilterFields = _useState20[0],
      setActiveFilterFields = _useState20[1];

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ReportsFilter__container"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ReportsFilter__inner"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ReportsFilter__AddFilterButton_container"
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    htmlFor: "filters"
  }, addFiltersLabel), /*#__PURE__*/React__default['default'].createElement(AddFilterContainer, {
    addFiltersButtonText: addFiltersButtonText,
    allFiltersItemText: allFiltersItemText,
    filterMenuIsOpen: filterMenuIsOpen,
    setFilterMenuIsOpen: setFilterMenuIsOpen,
    participant: baseFilters.participant,
    setActiveFilterFields: setActiveFilterFields,
    tenantId: tenantId
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default['default'].createElement(FieldItemsContainer, {
    removeFilterButtonText: removeFilterButtonText,
    pastReport: pastReport,
    activeDropdown: activeDropdown,
    setActiveDropdown: setActiveDropdown,
    baseFilters: baseFilters,
    activeFilter: activeFilter,
    setActiveFilter: setActiveFilter,
    filteredReport: filteredReport,
    activeFilterFields: activeFilterFields,
    setActiveFilterFields: setActiveFilterFields,
    closeAllDropdowns: closeAllDropdowns,
    toggleFilterFieldMenus: toggleFilterFieldMenus,
    jobTitleMenuOpen: jobTitleMenuOpen,
    rolesMenuOpen: rolesMenuOpen,
    departmentsMenuOpen: departmentsMenuOpen,
    divisionsMenuOpen: divisionsMenuOpen,
    locationsMenuOpen: locationsMenuOpen,
    citiesMenuOpen: citiesMenuOpen,
    statesMenuOpen: statesMenuOpen
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ReportsFilter__timeframe"
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    htmlFor: "Date Picker"
  }, datePickerLabel), /*#__PURE__*/React__default['default'].createElement(DatePicker, {
    setActiveFilterDates: setActiveFilterDates,
    isOutsideRange: true,
    initialVisibleMonth: true,
    availableDates: baseFilters.availableDates && baseFilters.availableDates,
    firstAvailableDate: baseFilters.availableDates && hooks(baseFilters.availableDates[0].dateInt, 'x'),
    lastAvailableDate: baseFilters.availableDates && hooks(baseFilters.availableDates[baseFilters.availableDates.length - 1].dateInt, 'x')
  }))));
};

var build = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = shallowEqual;

var _objectIs = _interopRequireDefault(objectIs);

var _has = _interopRequireDefault(src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// adapted from https://github.com/facebook/react/blob/144328fe81719e916b946e22660479e31561bb0b/packages/shared/shallowEqual.js#L36-L68
function shallowEqual(objA, objB) {
  if ((0, _objectIs["default"])(objA, objB)) {
    return true;
  }

  if (!objA || !objB || _typeof(objA) !== 'object' || _typeof(objB) !== 'object') {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  keysA.sort();
  keysB.sort(); // Test for A's keys different from B.

  for (var i = 0; i < keysA.length; i += 1) {
    if (!(0, _has["default"])(objB, keysA[i]) || !(0, _objectIs["default"])(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}


});

unwrapExports(build);

function isValidMoment(testMoment) {
  if (typeof hooks.isMoment === 'function' && !hooks.isMoment(testMoment)) {
    return false;
  }

  /* istanbul ignore else  */
  if (typeof testMoment.isValid === 'function') {
    // moment 1.7.0+
    return testMoment.isValid();
  }

  /* istanbul ignore next */
  return !isNaN(testMoment);
}

var momentValidationWrapper = {
  isValidMoment : isValidMoment,
};

var messages = {
  invalidPredicate: '`predicate` must be a function',
  invalidPropValidator: '`propValidator` must be a function',
  requiredCore: 'is marked as required',
  invalidTypeCore: 'Invalid input type',
  predicateFailureCore: 'Failed to succeed with predicate',
  anonymousMessage: '<<anonymous>>',
  baseInvalidMessage: 'Invalid ',
};

function constructPropValidatorVariations(propValidator) {
  if (typeof propValidator !== 'function') {
    throw new Error(messages.invalidPropValidator);
  }

  var requiredPropValidator = propValidator.bind(null, false, null);
  requiredPropValidator.isRequired = propValidator.bind(null, true, null);

  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
    if (typeof predicate !== 'function') {
      throw new Error(messages.invalidPredicate);
    }
    var basePropValidator = propValidator.bind(null, false, predicate);
    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
    return basePropValidator;
  };

  return requiredPropValidator;
}

function createInvalidRequiredErrorMessage(propName, componentName, value) {
  return new Error(
    'The prop `' + propName + '` ' + messages.requiredCore +
    ' in `' + componentName + '`, but its value is `' + value + '`.'
  );
}

var independentGuardianValue = -1;

function preValidationRequireCheck(isRequired, componentName, propFullName, propValue) {
  var isPropValueUndefined = typeof propValue === 'undefined';
  var isPropValueNull = propValue === null;

  if (isRequired) {
    if (isPropValueUndefined) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
    } else if (isPropValueNull) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
    }
  }

  if (isPropValueUndefined || isPropValueNull) {
    return null;
  }

  return independentGuardianValue;
}

function createMomentChecker(type, typeValidator, validator, momentType) {

  function propValidator(
    isRequired, // Bound parameter to indicate with the propType is required
    predicate, // Bound parameter to allow user to add dynamic validation
    props,
    propName,
    componentName,
    location,
    propFullName
  ) {
    var propValue = props[ propName ];
    var propType = typeof propValue;

    componentName = componentName || messages.anonymousMessage;
    propFullName = propFullName || propName;

    var preValidationRequireCheckValue = preValidationRequireCheck(
      isRequired, componentName, propFullName, propValue
    );

    if (preValidationRequireCheckValue !== independentGuardianValue) {
      return preValidationRequireCheckValue;
    }

    if (typeValidator && !typeValidator(propValue)) {
      return new Error(
        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + type + '`.'
      );
    }

    if (!validator(propValue)) {
      return new Error(
        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
      );
    }

    if (predicate && !predicate(propValue)) {
      var predicateName = predicate.name || messages.anonymousMessage;
      return new Error(
        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
        predicateName + '`.'
      );
    }

    return null;

  }

  return constructPropValidatorVariations(propValidator);

}

var core = {
  constructPropValidatorVariations: constructPropValidatorVariations,
  createMomentChecker: createMomentChecker,
  messages: messages,
};

var src$1 = {

  momentObj : core.createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(value);
    },
    'Moment'
  ),

  momentString : core.createMomentChecker(
    'string',
    function(str) {
      return typeof str === 'string';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(hooks(value));
    },
    'Moment'
  ),

  momentDurationObj : core.createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return hooks.isDuration(value);
    },
    'Duration'
  ),

};

function noop$6() {
  return null;
}

noop$6.isRequired = noop$6;

function noopThunk() {
  return noop$6;
}

var mocks = {
  and: noopThunk,
  between: noopThunk,
  booleanSome: noopThunk,
  childrenHavePropXorChildren: noopThunk,
  childrenOf: noopThunk,
  childrenOfType: noopThunk,
  childrenSequenceOf: noopThunk,
  componentWithName: noopThunk,
  disallowedIf: noopThunk,
  elementType: noopThunk,
  empty: noopThunk,
  explicitNull: noopThunk,
  forbidExtraProps: Object,
  integer: noopThunk,
  keysOf: noopThunk,
  mutuallyExclusiveProps: noopThunk,
  mutuallyExclusiveTrueProps: noopThunk,
  nChildren: noopThunk,
  nonNegativeInteger: noop$6,
  nonNegativeNumber: noopThunk,
  numericString: noopThunk,
  object: noopThunk,
  or: noopThunk,
  predicate: noopThunk,
  range: noopThunk,
  ref: noopThunk,
  requiredBy: noopThunk,
  restrictedProp: noopThunk,
  sequenceOf: noopThunk,
  shape: noopThunk,
  stringEndsWith: noopThunk,
  stringStartsWith: noopThunk,
  uniqueArray: noopThunk,
  uniqueArrayOf: noopThunk,
  valuesOf: noopThunk,
  withShape: noopThunk
};

/* globals
	AggregateError,
	Atomics,
	FinalizationRegistry,
	SharedArrayBuffer,
	WeakRef,
*/

var undefined$3;

var $SyntaxError$1 = SyntaxError;
var $Function$1 = Function;
var $TypeError$4 = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor$1 = function (expressionSyntax) {
	try {
		// eslint-disable-next-line no-new-func
		return Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD$3 = Object.getOwnPropertyDescriptor;
if ($gOPD$3) {
	try {
		$gOPD$3({}, '');
	} catch (e) {
		$gOPD$3 = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError$2 = function () { throw new $TypeError$4(); };
var ThrowTypeError$2 = $gOPD$3
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError$2;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD$3(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError$2;
			}
		}
	}())
	: throwTypeError$2;

var hasSymbols$5 = hasSymbols$1();

var getProto$3 = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var asyncGenFunction$2 = getEvalledConstructor$1('async function* () {}');
var asyncGenFunctionPrototype$1 = asyncGenFunction$2 ? asyncGenFunction$2.prototype : undefined$3;
var asyncGenPrototype$1 = asyncGenFunctionPrototype$1 ? asyncGenFunctionPrototype$1.prototype : undefined$3;

var TypedArray$2 = typeof Uint8Array === 'undefined' ? undefined$3 : getProto$3(Uint8Array);

var INTRINSICS$2 = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$3 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$3 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$5 ? getProto$3([][Symbol.iterator]()) : undefined$3,
	'%AsyncFromSyncIteratorPrototype%': undefined$3,
	'%AsyncFunction%': getEvalledConstructor$1('async function () {}'),
	'%AsyncGenerator%': asyncGenFunctionPrototype$1,
	'%AsyncGeneratorFunction%': asyncGenFunction$2,
	'%AsyncIteratorPrototype%': asyncGenPrototype$1 ? getProto$3(asyncGenPrototype$1) : undefined$3,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$3 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$3 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$3 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$3 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$3 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$3 : FinalizationRegistry,
	'%Function%': $Function$1,
	'%GeneratorFunction%': getEvalledConstructor$1('function* () {}'),
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$3 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$3 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$3 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$5 ? getProto$3(getProto$3([][Symbol.iterator]())) : undefined$3,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$3,
	'%Map%': typeof Map === 'undefined' ? undefined$3 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$5 ? undefined$3 : getProto$3(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$3 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$3 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$3 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$3 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$5 ? undefined$3 : getProto$3(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$3 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$5 ? getProto$3(''[Symbol.iterator]()) : undefined$3,
	'%Symbol%': hasSymbols$5 ? Symbol : undefined$3,
	'%SyntaxError%': $SyntaxError$1,
	'%ThrowTypeError%': ThrowTypeError$2,
	'%TypedArray%': TypedArray$2,
	'%TypeError%': $TypeError$4,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$3 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$3 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$3 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$3 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$3 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$3 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$3 : WeakSet
};

var LEGACY_ALIASES$1 = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat$1 = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply$1 = functionBind.call(Function.apply, Array.prototype.splice);
var $replace$2 = functionBind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName$3 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$3 = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath$3 = function stringToPath(string) {
	var result = [];
	$replace$2(string, rePropName$3, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$2(subString, reEscapeChar$3, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic$2 = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES$1, intrinsicName)) {
		alias = LEGACY_ALIASES$1[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS$2, intrinsicName)) {
		var value = INTRINSICS$2[intrinsicName];
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$4('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError$1('intrinsic ' + name + ' does not exist!');
};

var GetIntrinsic$2 = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$4('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$4('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath$3(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic$2('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply$1(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS$2, intrinsicRealName)) {
			value = INTRINSICS$2[intrinsicRealName];
		} else if (value != null) {
			if ($gOPD$3 && (i + 1) >= parts.length) {
				var desc = $gOPD$3(value, part);
				isOwn = !!desc;

				if (!allowMissing && !(part in value)) {
					throw new $TypeError$4('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS$2[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind$2 = createCommonjsModule(function (module) {





var $apply = GetIntrinsic$2('%Function.prototype.apply%');
var $call = GetIntrinsic$2('%Function.prototype.call%');
var $reflectApply = GetIntrinsic$2('%Reflect.apply%', true) || functionBind.call($call, $apply);

var $defineProperty = GetIntrinsic$2('%Object.defineProperty%', true);

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind() {
	return $reflectApply(functionBind, $call, arguments);
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});
var callBind_1$2 = callBind$2.apply;

var $indexOf = callBind$2(GetIntrinsic$2('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic$2(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.')) {
		return callBind$2(intrinsic);
	}
	return intrinsic;
};

// modified from https://github.com/es-shims/es6-shim

var canBeObject = function (obj) {
	return typeof obj !== 'undefined' && obj !== null;
};
var hasSymbols$6 = shams();

var toObject$1 = Object;
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols$6 ? Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
var implementation$5 = function assign(target, source1) {
	if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
	var objTarget = toObject$1(target);
	var s, source, i, props, syms, value, key;
	for (s = 1; s < arguments.length; ++s) {
		source = toObject$1(arguments[s]);
		props = objectKeys(source);
		var getSymbols = hasSymbols$6 && (Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			syms = getSymbols(source);
			for (i = 0; i < syms.length; ++i) {
				key = syms[i];
				if ($propIsEnumerable(source, key)) {
					$push(props, key);
				}
			}
		}
		for (i = 0; i < props.length; ++i) {
			key = props[i];
			value = source[key];
			if ($propIsEnumerable(source, key)) {
				objTarget[key] = value;
			}
		}
	}
	return objTarget;
};

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

var polyfill$4 = function getPolyfill() {
	if (!Object.assign) {
		return implementation$5;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation$5;
	}
	if (assignHasPendingExceptions()) {
		return implementation$5;
	}
	return Object.assign;
};

var shim$2 = function shimAssign() {
	var polyfill = polyfill$4();
	defineProperties_1(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};

var polyfill$5 = callBind$2.apply(polyfill$4());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
	return polyfill$5(Object, arguments);
};

defineProperties_1(bound, {
	getPolyfill: polyfill$4,
	implementation: implementation$5,
	shim: shim$2
});

var object_assign = bound;

var isPlainObject_1$1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = isPlainObject;
function isPlainObject(x) {
  return x && (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && !Array.isArray(x);
}
module.exports = exports['default'];

});

unwrapExports(isPlainObject_1$1);

var build$1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = forbidExtraProps;



var _object2 = _interopRequireDefault(object_assign);



var _has2 = _interopRequireDefault(src);



var _isPlainObject2 = _interopRequireDefault(isPlainObject_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var zeroWidthSpace = '\u200B';
var specialProperty = 'prop-types-exact: ' + zeroWidthSpace;
var semaphore = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' ? Symbol['for'](specialProperty) : /* istanbul ignore next */specialProperty;

function brand(fn) {
  return (0, _object2['default'])(fn, _defineProperty({}, specialProperty, semaphore));
}

function isBranded(value) {
  return value && value[specialProperty] === semaphore;
}

function forbidExtraProps(propTypes) {
  if (!(0, _isPlainObject2['default'])(propTypes)) {
    throw new TypeError('given propTypes must be an object');
  }
  if ((0, _has2['default'])(propTypes, specialProperty) && !isBranded(propTypes[specialProperty])) {
    throw new TypeError('Against all odds, you created a propType for a prop that uses both the zero-width space and our custom string - which, sadly, conflicts with `prop-types-exact`');
  }

  return (0, _object2['default'])({}, propTypes, _defineProperty({}, specialProperty, brand(function () {
    function forbidUnknownProps(props, _, componentName) {
      var unknownProps = Object.keys(props).filter(function (prop) {
        return !(0, _has2['default'])(propTypes, prop);
      });
      if (unknownProps.length > 0) {
        return new TypeError(String(componentName) + ': unknown props found: ' + String(unknownProps.join(', ')));
      }
      return null;
    }

    return forbidUnknownProps;
  }())));
}
module.exports = exports['default'];

});

unwrapExports(build$1);

var wrapValidator_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapValidator;

var _object = _interopRequireDefault(object_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function wrapValidator(validator, typeName) {
  var typeChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, _object["default"])(validator.bind(), {
    typeName: typeName,
    typeChecker: typeChecker,
    isRequired: (0, _object["default"])(validator.isRequired.bind(), {
      typeName: typeName,
      typeChecker: typeChecker,
      typeRequired: true
    })
  });
}

});

unwrapExports(wrapValidator_1);

var and = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = andValidator;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function andValidator(validators) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';

  if (!Array.isArray(validators)) {
    throw new TypeError('and: 2 or more validators are required');
  }

  if (validators.length <= 1) {
    throw new RangeError('and: 2 or more validators are required');
  }

  var validator = function and() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var firstError = null;
    validators.some(function (validatorFn) {
      firstError = validatorFn.apply(void 0, args);
      return firstError != null;
    });
    return firstError == null ? null : firstError;
  };

  validator.isRequired = function andIsRequired() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var firstError = null;
    validators.some(function (validatorFn) {
      firstError = validatorFn.isRequired.apply(validatorFn, args);
      return firstError != null;
    });
    return firstError == null ? null : firstError;
  };

  return (0, _wrapValidator["default"])(validator, name, validators);
}

});

unwrapExports(and);

var $TypeError$5 = GetIntrinsic$1('%TypeError%');

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.10

var CheckObjectCoercible = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError$5(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};

var RequireObjectCoercible = CheckObjectCoercible;

var $indexOf$1 = callBind$1(GetIntrinsic$1('String.prototype.indexOf'));

var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic$1(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf$1(name, '.prototype.')) {
		return callBind$1(intrinsic);
	}
	return intrinsic;
};

var $isEnumerable = callBound$1('Object.prototype.propertyIsEnumerable');

var implementation$6 = function entries(O) {
	var obj = RequireObjectCoercible(O);
	var entrys = [];
	for (var key in obj) {
		if (src(obj, key) && $isEnumerable(obj, key)) {
			entrys.push([key, obj[key]]);
		}
	}
	return entrys;
};

var polyfill$6 = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation$6;
};

var shim$3 = function shimEntries() {
	var polyfill = polyfill$6();
	defineProperties_1(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};

var polyfill$7 = callBind$1(polyfill$6(), Object);

defineProperties_1(polyfill$7, {
	getPolyfill: polyfill$6,
	implementation: implementation$6,
	shim: shim$3
});

var object_entries = polyfill$7;

var isPlainObject$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isPlainObject = _interopRequireDefault(isPlainObject_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _isPlainObject["default"];
exports["default"] = _default;

});

unwrapExports(isPlainObject$1);

var shape = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = shapeValidator;

var _isPlainObject = _interopRequireDefault(isPlainObject$1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function shapeValidator(shapeTypes) {
  if (!(0, _isPlainObject["default"])(shapeTypes)) {
    throw new TypeError('shape must be a normal object');
  }

  function shape(props, propName, componentName, location) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    } // code adapted from PropTypes.shape: https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L381
    // eslint-disable-next-line guard-for-in, no-restricted-syntax


    for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      rest[_key - 4] = arguments[_key];
    }

    for (var key in shapeTypes) {
      var checker = shapeTypes[key];

      if (checker) {
        var error = checker.apply(void 0, [propValue, key, componentName, location].concat(rest));

        if (error) {
          return error;
        }
      }
    }

    return null;
  }

  shape.isRequired = function shapeRequired(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return shape.apply(void 0, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(shape, 'shape', shapeTypes);
}

});

unwrapExports(shape);

var isPrimitive_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPrimitive;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isPrimitive(x) {
  return !x || _typeof(x) !== 'object' && typeof x !== 'function';
}

});

unwrapExports(isPrimitive_1);

var valuesOf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = valuesOfValidator;

var _isPrimitive = _interopRequireDefault(isPrimitive_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// code adapted from https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L307-L340
function valuesOfValidator(propType) {
  if (typeof propType !== 'function') {
    throw new TypeError('objectOf: propType must be a function');
  }

  var validator = function valuesOf(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];

    if (propValue == null || (0, _isPrimitive["default"])(propValue)) {
      return null;
    }

    var firstError;
    Object.keys(propValue).some(function (key) {
      firstError = propType.apply(void 0, [propValue, key, componentName, location, "".concat(propFullName, ".").concat(key)].concat(rest));
      return firstError;
    });
    return firstError || null;
  };

  validator.isRequired = function valuesOfRequired(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return validator.apply(void 0, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, 'valuesOf', propType);
}

});

unwrapExports(valuesOf);

var between = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = betweenValidator;

var _object = _interopRequireDefault(object_entries);

var _shape = _interopRequireDefault(shape);

var _valuesOf = _interopRequireDefault(valuesOf);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function number(props, propName, componentName) {
  var value = props[propName];

  if (typeof value === 'number' && !isNaN(value)) {
    return null;
  }

  return new TypeError("".concat(componentName, ": ").concat(propName, " must be a non-NaN number."));
}

function numberOrPropsFunc(props, propName) {
  var value = props[propName];

  if (typeof value === 'function') {
    return null;
  }

  if (typeof value === 'number' && !isNaN(value)) {
    return null;
  }

  return new TypeError("".concat(propName, ": a function, or a non-NaN number is required"));
}

function lowerCompare(value, _ref) {
  var gt = _ref.gt,
      gte = _ref.gte;

  if (typeof gt === 'number') {
    return value > gt;
  }

  if (typeof gte === 'number') {
    return value >= gte;
  }

  return true;
}

function upperCompare(value, _ref2) {
  var lt = _ref2.lt,
      lte = _ref2.lte;

  if (typeof lt === 'number') {
    return value < lt;
  }

  if (typeof lte === 'number') {
    return value <= lte;
  }

  return true;
}

function greaterThanError(_ref3) {
  var gt = _ref3.gt,
      gte = _ref3.gte;

  if (typeof gt === 'number') {
    return "greater than ".concat(gt);
  }

  if (typeof gte === 'number') {
    return "greater than or equal to ".concat(gte);
  }

  return '';
}

function lessThanError(_ref4) {
  var lt = _ref4.lt,
      lte = _ref4.lte;

  if (typeof lt === 'number') {
    return "less than ".concat(lt);
  }

  if (typeof lte === 'number') {
    return "less than or equal to ".concat(lte);
  }

  return '';
}

function errorMessage(componentName, propName, opts) {
  var errors = [greaterThanError(opts), lessThanError(opts)].filter(Boolean).join(' and ');
  return "".concat(componentName, ": ").concat(propName, " must be ").concat(errors);
}

function propsThunkify(opts) {
  return (0, _object["default"])(opts).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    var numberThunk = typeof value === 'number' ? function () {
      return value;
    } : value;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, numberThunk));
  }, {});
}

function invokeWithProps(optsThunks, props) {
  return (0, _object["default"])(optsThunks).reduce(function (acc, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        thunk = _ref8[1];

    var value = thunk(props);
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
  }, {});
}

var argValidators = [(0, _shape["default"])({
  lt: numberOrPropsFunc,
  gt: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  lte: numberOrPropsFunc,
  gt: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  lt: numberOrPropsFunc,
  gte: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  lte: numberOrPropsFunc,
  gte: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  lt: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  lte: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  gt: numberOrPropsFunc
}).isRequired, (0, _shape["default"])({
  gte: numberOrPropsFunc
}).isRequired];

function argValidator(props, propName) {
  return argValidators.every(function (validator) {
    return !!validator(props, propName);
  });
}

var thunkValueValidator = (0, _valuesOf["default"])(number).isRequired;

function betweenValidator(options) {
  var argError = argValidator({
    options: options
  }, 'options');

  if (argError) {
    throw new TypeError('between: only one of the pairs of `lt`/`lte`, and `gt`/`gte`, may be supplied, and at least one pair must be provided.');
  }

  var optsThunks = propsThunkify(options);

  var validator = function between(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    if (typeof propValue !== 'number') {
      return new RangeError("".concat(componentName, ": ").concat(propName, " must be a number, got \"").concat(_typeof(propValue), "\""));
    }

    var opts = invokeWithProps(optsThunks, props);

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var thunkValuesError = thunkValueValidator.apply(void 0, [_defineProperty({}, propName, opts), propName, componentName].concat(rest));

    if (thunkValuesError) {
      return thunkValuesError;
    }

    if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) {
      return new RangeError(errorMessage(componentName, propName, opts));
    }

    return null;
  };

  validator.isRequired = function betweenRequired(props, propName, componentName) {
    var propValue = props[propName];

    if (typeof propValue !== 'number') {
      return new RangeError("".concat(componentName, ": ").concat(propName, " must be a number, got \"").concat(_typeof(propValue), "\""));
    }

    var opts = invokeWithProps(optsThunks, props);

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    var thunkValuesError = thunkValueValidator.apply(void 0, [_defineProperty({}, propName, opts), propName, componentName].concat(rest));

    if (thunkValuesError) {
      return thunkValuesError;
    }

    if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) {
      return new RangeError(errorMessage(componentName, propName, opts));
    }

    return null;
  };

  return (0, _wrapValidator["default"])(validator, 'between', options);
}

});

unwrapExports(between);

var booleanSome = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = booleanSomeValidator;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function booleanSomeValidator() {
  for (var _len = arguments.length, notAllPropsFalse = new Array(_len), _key = 0; _key < _len; _key++) {
    notAllPropsFalse[_key] = arguments[_key];
  }

  if (notAllPropsFalse.length < 1) {
    throw new TypeError('at least one prop (one of which must be `true`) is required');
  }

  if (!notAllPropsFalse.every(function (x) {
    return typeof x === 'string';
  })) {
    throw new TypeError('all booleanSome props must be strings');
  }

  var propsList = notAllPropsFalse.join(', or ');

  var validator = function booleanSome(props, propName, componentName) {
    var countFalse = function countFalse(count, prop) {
      return count + (props[prop] === false ? 1 : 0);
    };

    var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);

    if (falsePropCount === notAllPropsFalse.length) {
      return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return PropTypes__default['default'].bool.apply(void 0, [props, propName, componentName].concat(rest));
  };

  validator.isRequired = function booleanSomeRequired(props, propName, componentName) {
    var countFalse = function countFalse(count, prop) {
      return count + (props[prop] === false ? 1 : 0);
    };

    var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);

    if (falsePropCount === notAllPropsFalse.length) {
      return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return PropTypes__default['default'].bool.isRequired.apply(PropTypes__default['default'].bool, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, "booleanSome: ".concat(propsList), notAllPropsFalse);
}

});

unwrapExports(booleanSome);

var childrenHavePropXorChildren_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = childrenHavePropXorChildren;

var _react = _interopRequireDefault(React__default['default']);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function childrenHavePropXorChildren(prop) {
  if (typeof prop !== 'string' && _typeof(prop) !== 'symbol') {
    throw new TypeError('invalid prop: must be string or symbol');
  }

  var validator = function childrenHavePropXorChildrenWithProp(_ref, _, componentName) {
    var children = _ref.children;
    var truthyChildrenCount = 0;
    var propCount = 0;
    var grandchildrenCount = 0;

    _react["default"].Children.forEach(children, function (child) {
      if (!child) {
        return;
      }

      truthyChildrenCount += 1;

      if (child.props[prop]) {
        propCount += 1;
      }

      if (_react["default"].Children.count(child.props.children)) {
        grandchildrenCount += 1;
      }
    });

    if (propCount === truthyChildrenCount && grandchildrenCount === 0 || propCount === 0 && grandchildrenCount === truthyChildrenCount || propCount === 0 && grandchildrenCount === 0) {
      return null;
    }

    return new TypeError("`".concat(componentName, "` requires children to all have prop \u201C").concat(prop, "\u201D, all have children, or all have neither."));
  };

  validator.isRequired = validator;
  return (0, _wrapValidator["default"])(validator, "childrenHavePropXorChildrenWithProp:".concat(prop), prop);
}

});

unwrapExports(childrenHavePropXorChildren_1);

var renderableChildren_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = renderableChildren;

var _react = _interopRequireDefault(React__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function renderableChildren(childrenProp) {
  return _react["default"].Children.toArray(childrenProp).filter(function (child) {
    return child === 0 || child;
  });
}

});

unwrapExports(renderableChildren_1);

var childrenOf_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = childrenOf;

var _renderableChildren = _interopRequireDefault(renderableChildren_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function validateChildren(propType, children, props) {
  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  var error;
  children.some(function (child) {
    error = propType.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, {
      children: child
    }), 'children'].concat(rest));
    return error;
  });
  return error || null;
}

function childrenOf(propType) {
  function childrenOfPropType(props, propName, componentName) {
    if (propName !== 'children') {
      return new TypeError("".concat(componentName, " is using the childrenOf validator on non-children prop \"").concat(propName, "\""));
    }

    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    var children = (0, _renderableChildren["default"])(propValue);

    if (children.length === 0) {
      return null;
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return validateChildren.apply(void 0, [propType, children, props, componentName].concat(rest));
  }

  childrenOfPropType.isRequired = function (props, propName, componentName) {
    if (propName !== 'children') {
      return new TypeError("".concat(componentName, " is using the childrenOf validator on non-children prop \"").concat(propName, "\""));
    }

    var children = (0, _renderableChildren["default"])(props[propName]);

    if (children.length === 0) {
      return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(propType.typeName || propType.name));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return validateChildren.apply(void 0, [propType, children, props, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(childrenOfPropType, 'childrenOf', propType);
}

});

unwrapExports(childrenOf_1);

var $Object$1 = GetIntrinsic$1('%Object%');



// https://www.ecma-international.org/ecma-262/6.0/#sec-toobject

var ToObject = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object$1(value);
};

var $Math = GetIntrinsic$1('%Math%');
var $Number = GetIntrinsic$1('%Number%');

var maxSafeInteger = $Number.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.3

var ToNumber = function ToNumber(value) {
	return +value; // eslint-disable-line no-implicit-coercion
};

var _isNaN = Number.isNaN || function isNaN(a) {
	return a !== a;
};

var $isNaN = Number.isNaN || function (a) { return a !== a; };

var _isFinite = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };

var sign$2 = function sign(number) {
	return number >= 0 ? 1 : -1;
};

var $Math$1 = GetIntrinsic$1('%Math%');






var $floor = $Math$1.floor;
var $abs = $Math$1.abs;

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.4

var ToInteger = function ToInteger(value) {
	var number = ToNumber(value);
	if (_isNaN(number)) { return 0; }
	if (number === 0 || !_isFinite(number)) { return number; }
	return sign$2(number) * $floor($abs(number));
};

var $test = GetIntrinsic$1('RegExp.prototype.test');



var regexTester = function regexTester(regex) {
	return callBind$1($test, regex);
};

var isPrimitive = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var isPrimitive$1 = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$7 = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag$3 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var isCallable = reflectApply
	? function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag$3) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr$7.call(value);
		return strClass === fnClass || strClass === genClass;
	};

var isSymbol$2 = createCommonjsModule(function (module) {

var toStr = Object.prototype.toString;
var hasSymbols = hasSymbols$1();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false ;
	};
}
});

var hasSymbols$7 = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';






var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive$1(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
var es2015 = function ToPrimitive(input) {
	if (isPrimitive$1(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols$7) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol$2(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive$1(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDateObject(input) || isSymbol$2(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive

var ToPrimitive = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return es2015(input, arguments[1]);
	}
	return es2015(input);
};

var $TypeError$6 = GetIntrinsic$1('%TypeError%');
var $Number$1 = GetIntrinsic$1('%Number%');
var $RegExp = GetIntrinsic$1('%RegExp%');
var $parseInteger = GetIntrinsic$1('%parseInt%');





var $strSlice = callBound$1('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace$3 = callBound$1('String.prototype.replace');
var $trim = function (value) {
	return $replace$3(value, trimRegex, '');
};



// https://www.ecma-international.org/ecma-262/6.0/#sec-tonumber

var ToNumber$1 = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number$1);
	if (typeof value === 'symbol') {
		throw new $TypeError$6('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		} else {
			var trimmed = $trim(value);
			if (trimmed !== value) {
				return ToNumber(trimmed);
			}
		}
	}
	return $Number$1(value);
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-tointeger

var ToInteger$1 = function ToInteger$1(value) {
	var number = ToNumber$1(value);
	return ToInteger(number);
};

var ToLength = function ToLength(argument) {
	var len = ToInteger$1(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > maxSafeInteger) { return maxSafeInteger; }
	return len;
};

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.11

var IsCallable = isCallable;

var implementation$7 = function find(predicate) {
	var list = ToObject(this);
	var length = ToLength(list.length);
	if (!IsCallable(predicate)) {
		throw new TypeError('Array#find: predicate must be a function');
	}
	if (length === 0) {
		return void 0;
	}
	var thisArg;
	if (arguments.length > 0) {
		thisArg = arguments[1];
	}

	for (var i = 0, value; i < length; i++) {
		value = list[i];
		// inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
		if (predicate.apply(thisArg, [value, i, list])) {
			return value;
		}
	}
	return void 0;
};

var polyfill$8 = function getPolyfill() {
	// Detect if an implementation exists
	// Detect early implementations which skipped holes in sparse arrays
	// eslint-disable-next-line no-sparse-arrays
	var implemented = Array.prototype.find && [, 1].find(function () {
		return true;
	}) !== 1;

	// eslint-disable-next-line global-require
	return implemented ? Array.prototype.find : implementation$7;
};

var shim$4 = function shimArrayPrototypeFind() {
	var polyfill = polyfill$8();

	defineProperties_1(Array.prototype, { find: polyfill }, {
		find: function () {
			return Array.prototype.find !== polyfill;
		}
	});

	return polyfill;
};

var slice$4 = Array.prototype.slice;

var polyfill$9 = polyfill$8();

var boundFindShim = function find(array, predicate) { // eslint-disable-line no-unused-vars
	RequireObjectCoercible(array);
	var args = slice$4.call(arguments, 1);
	return polyfill$9.apply(array, args);
};

defineProperties_1(boundFindShim, {
	getPolyfill: polyfill$8,
	implementation: implementation$7,
	shim: shim$4
});

var array_prototype_find = boundFindShim;

var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD$2 = Object.getOwnPropertyDescriptor;
if (gOPD$2) {
	try {
		gOPD$2([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD$2 = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	return functionsHaveNames() && gOPD$2 && !!gOPD$2(function () {}, 'name').configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

var functionsHaveNames_1 = functionsHaveNames;

var functionsHaveNames$1 = functionsHaveNames_1();

var $functionToString = callBound$1('Function.prototype.toString');
var $stringMatch = callBound$1('String.prototype.match');

var classRegex = /^class /;

var isClass = function isClassConstructor(fn) {
	if (IsCallable(fn)) {
		return false;
	}
	if (typeof fn !== 'function') {
		return false;
	}
	try {
		var match = $stringMatch($functionToString(fn), classRegex);
		return !!match;
	} catch (e) {}
	return false;
};

var regex$1 = /\s*function\s+([^(\s]*)\s*/;

var functionProto = Function.prototype;

var implementation$8 = function getName() {
	if (!isClass(this) && !IsCallable(this)) {
		throw new TypeError('Function.prototype.name sham getter called on non-function');
	}
	if (functionsHaveNames$1) {
		return this.name;
	}
	if (this === functionProto) {
		return '';
	}
	var str = $functionToString(this);
	var match = $stringMatch(str, regex$1);
	var name = match && match[1];
	return name;
};

var polyfill$a = function getPolyfill() {
	return implementation$8;
};

var supportsDescriptors$3 = defineProperties_1.supportsDescriptors;
var functionsHaveNames$2 = functionsHaveNames_1();

var defineProperty$6 = Object.defineProperty;
var TypeErr$1 = TypeError;

var shim$5 = function shimName() {
	var polyfill = polyfill$a();
	if (functionsHaveNames$2) {
		return polyfill;
	}
	if (!supportsDescriptors$3) {
		throw new TypeErr$1('Shimming Function.prototype.name support requires ES5 property descriptor support.');
	}
	var functionProto = Function.prototype;
	defineProperty$6(functionProto, 'name', {
		configurable: true,
		enumerable: false,
		get: function () {
			var name = polyfill.call(this);
			if (this !== functionProto) {
				defineProperty$6(this, 'name', {
					configurable: true,
					enumerable: false,
					value: name,
					writable: false
				});
			}
			return name;
		}
	});
	return polyfill;
};

var bound$1 = callBind$1(implementation$8);

defineProperties_1(bound$1, {
	getPolyfill: polyfill$a,
	implementation: implementation$8,
	shim: shim$5
});

var function_prototype_name = bound$1;

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$4="function"===typeof Symbol&&Symbol.for,c$4=b$4?Symbol.for("react.element"):60103,d$2=b$4?Symbol.for("react.portal"):60106,e$2=b$4?Symbol.for("react.fragment"):60107,f$2=b$4?Symbol.for("react.strict_mode"):60108,g$3=b$4?Symbol.for("react.profiler"):60114,h$2=b$4?Symbol.for("react.provider"):60109,k$4=b$4?Symbol.for("react.context"):60110,l$2=b$4?Symbol.for("react.async_mode"):60111,m$2=b$4?Symbol.for("react.concurrent_mode"):60111,n$2=b$4?Symbol.for("react.forward_ref"):60112,p$2=b$4?Symbol.for("react.suspense"):60113,q$3=b$4?
Symbol.for("react.suspense_list"):60120,r$2=b$4?Symbol.for("react.memo"):60115,t$1=b$4?Symbol.for("react.lazy"):60116,v$3=b$4?Symbol.for("react.block"):60121,w$3=b$4?Symbol.for("react.fundamental"):60117,x$4=b$4?Symbol.for("react.responder"):60118,y$4=b$4?Symbol.for("react.scope"):60119;
function z$3(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$4:switch(a=a.type,a){case l$2:case m$2:case e$2:case g$3:case f$2:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$4:case n$2:case t$1:case r$2:case h$2:return a;default:return u}}case d$2:return u}}}function A$4(a){return z$3(a)===m$2}var AsyncMode$1=l$2;var ConcurrentMode$1=m$2;var ContextConsumer$2=k$4;var ContextProvider$2=h$2;var Element$4=c$4;var ForwardRef$2=n$2;var Fragment$2=e$2;var Lazy$2=t$1;var Memo$2=r$2;var Portal$3=d$2;
var Profiler$2=g$3;var StrictMode$2=f$2;var Suspense$2=p$2;var isAsyncMode$2=function(a){return A$4(a)||z$3(a)===l$2};var isConcurrentMode$2=A$4;var isContextConsumer$2=function(a){return z$3(a)===k$4};var isContextProvider$2=function(a){return z$3(a)===h$2};var isElement$2=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$4};var isForwardRef$2=function(a){return z$3(a)===n$2};var isFragment$2=function(a){return z$3(a)===e$2};var isLazy$2=function(a){return z$3(a)===t$1};
var isMemo$2=function(a){return z$3(a)===r$2};var isPortal$2=function(a){return z$3(a)===d$2};var isProfiler$2=function(a){return z$3(a)===g$3};var isStrictMode$2=function(a){return z$3(a)===f$2};var isSuspense$2=function(a){return z$3(a)===p$2};
var isValidElementType$2=function(a){return "string"===typeof a||"function"===typeof a||a===e$2||a===m$2||a===g$3||a===f$2||a===p$2||a===q$3||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$2||a.$$typeof===h$2||a.$$typeof===k$4||a.$$typeof===n$2||a.$$typeof===w$3||a.$$typeof===x$4||a.$$typeof===y$4||a.$$typeof===v$3)};var typeOf$2=z$3;

var reactIs_production_min$2 = {
	AsyncMode: AsyncMode$1,
	ConcurrentMode: ConcurrentMode$1,
	ContextConsumer: ContextConsumer$2,
	ContextProvider: ContextProvider$2,
	Element: Element$4,
	ForwardRef: ForwardRef$2,
	Fragment: Fragment$2,
	Lazy: Lazy$2,
	Memo: Memo$2,
	Portal: Portal$3,
	Profiler: Profiler$2,
	StrictMode: StrictMode$2,
	Suspense: Suspense$2,
	isAsyncMode: isAsyncMode$2,
	isConcurrentMode: isConcurrentMode$2,
	isContextConsumer: isContextConsumer$2,
	isContextProvider: isContextProvider$2,
	isElement: isElement$2,
	isForwardRef: isForwardRef$2,
	isFragment: isFragment$2,
	isLazy: isLazy$2,
	isMemo: isMemo$2,
	isPortal: isPortal$2,
	isProfiler: isProfiler$2,
	isStrictMode: isStrictMode$2,
	isSuspense: isSuspense$2,
	isValidElementType: isValidElementType$2,
	typeOf: typeOf$2
};

var reactIs_development$2 = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
var reactIs_development_1$2 = reactIs_development$2.AsyncMode;
var reactIs_development_2$2 = reactIs_development$2.ConcurrentMode;
var reactIs_development_3$2 = reactIs_development$2.ContextConsumer;
var reactIs_development_4$2 = reactIs_development$2.ContextProvider;
var reactIs_development_5$2 = reactIs_development$2.Element;
var reactIs_development_6$2 = reactIs_development$2.ForwardRef;
var reactIs_development_7$2 = reactIs_development$2.Fragment;
var reactIs_development_8$2 = reactIs_development$2.Lazy;
var reactIs_development_9$2 = reactIs_development$2.Memo;
var reactIs_development_10$2 = reactIs_development$2.Portal;
var reactIs_development_11$2 = reactIs_development$2.Profiler;
var reactIs_development_12$2 = reactIs_development$2.StrictMode;
var reactIs_development_13$2 = reactIs_development$2.Suspense;
var reactIs_development_14$2 = reactIs_development$2.isAsyncMode;
var reactIs_development_15$2 = reactIs_development$2.isConcurrentMode;
var reactIs_development_16$2 = reactIs_development$2.isContextConsumer;
var reactIs_development_17$2 = reactIs_development$2.isContextProvider;
var reactIs_development_18$2 = reactIs_development$2.isElement;
var reactIs_development_19$2 = reactIs_development$2.isForwardRef;
var reactIs_development_20$2 = reactIs_development$2.isFragment;
var reactIs_development_21$2 = reactIs_development$2.isLazy;
var reactIs_development_22$2 = reactIs_development$2.isMemo;
var reactIs_development_23$2 = reactIs_development$2.isPortal;
var reactIs_development_24$2 = reactIs_development$2.isProfiler;
var reactIs_development_25$2 = reactIs_development$2.isStrictMode;
var reactIs_development_26$2 = reactIs_development$2.isSuspense;
var reactIs_development_27$1 = reactIs_development$2.isValidElementType;
var reactIs_development_28$1 = reactIs_development$2.typeOf;

var reactIs$2 = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min$2;
} else {
  module.exports = reactIs_development$2;
}
});

var getComponentName_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getComponentName;

var _functionPrototype = _interopRequireDefault(function_prototype_name);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getComponentName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return Component.displayName || (0, _functionPrototype["default"])(Component);
  }

  if ((0, reactIs$2.isForwardRef)({
    type: Component,
    $$typeof: reactIs$2.Element
  })) {
    return Component.displayName;
  }

  if ((0, reactIs$2.isMemo)(Component)) {
    return getComponentName(Component.type);
  }

  return null;
}

});

unwrapExports(getComponentName_1);

var childrenOfType_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _arrayPrototype = _interopRequireDefault(array_prototype_find);

var _getComponentName = _interopRequireDefault(getComponentName_1);

var _renderableChildren = _interopRequireDefault(renderableChildren_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function onlyTypes(types, children, componentName) {
  if (!children.every(function (child) {
    return child && (0, _arrayPrototype["default"])(types, function (Type) {
      return Type === '*' || child.type === Type;
    });
  })) {
    var typeNames = types.map(_getComponentName["default"]).join(', or ');
    return new TypeError("`".concat(componentName, "` only accepts children of type ").concat(typeNames));
  }

  return null;
}

function isRequired(types, children, componentName) {
  if (children.length === 0) {
    var typeNames = types.map(_getComponentName["default"]).join(', or ');
    return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(typeNames));
  }

  return null;
}

function childrenOfType() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  if (types.length < 1) {
    throw new TypeError('childrenOfType: at least 1 type is required');
  }

  function validator(props, propName, componentName) {
    return onlyTypes(types, (0, _renderableChildren["default"])(props[propName]), componentName);
  }

  validator.isRequired = function (props, propName, componentName) {
    var children = (0, _renderableChildren["default"])(props[propName]);
    return isRequired(types, children, componentName) || onlyTypes(types, children, componentName);
  };

  return (0, _wrapValidator["default"])(validator, 'childrenOfType', types);
}

var _default = childrenOfType;
exports["default"] = _default;

});

unwrapExports(childrenOfType_1);

var isInteger = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var floor = Math.floor;
var finite = isFinite;

var _default = Number.isInteger ||
/* istanbul ignore next */
function (x) {
  return typeof x === 'number' && finite(x) && floor(x) === x;
};

exports["default"] = _default;

});

unwrapExports(isInteger);

var integer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isInteger = _interopRequireDefault(isInteger);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function requiredInteger(props, propName, componentName) {
  var propValue = props[propName];

  if (propValue == null || !(0, _isInteger["default"])(propValue)) {
    return new RangeError("".concat(propName, " in ").concat(componentName, " must be an integer"));
  }

  return null;
}

var validator = function integer(props, propName) {
  var propValue = props[propName];

  if (propValue == null) {
    return null;
  }

  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  return requiredInteger.apply(void 0, [props, propName].concat(rest));
};

validator.isRequired = requiredInteger;

var _default = function _default() {
  return (0, _wrapValidator["default"])(validator, 'integer');
};

exports["default"] = _default;

});

unwrapExports(integer);

var nonNegativeNumber_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectIs = _interopRequireDefault(objectIs);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function isNonNegative(x) {
  return typeof x === 'number' && isFinite(x) && x >= 0 && !(0, _objectIs["default"])(x, -0);
}

function nonNegativeNumber(props, propName, componentName) {
  var value = props[propName];

  if (value == null || isNonNegative(value)) {
    return null;
  }

  return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
}

function requiredNonNegativeNumber(props, propName, componentName) {
  var value = props[propName];

  if (isNonNegative(value)) {
    return null;
  }

  return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
}

nonNegativeNumber.isRequired = requiredNonNegativeNumber;

var _default = function _default() {
  return (0, _wrapValidator["default"])(nonNegativeNumber, 'nonNegativeNumber');
};

exports["default"] = _default;

});

unwrapExports(nonNegativeNumber_1);

var nonNegativeInteger = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _and = _interopRequireDefault(and);

var _integer = _interopRequireDefault(integer);

var _nonNegativeNumber = _interopRequireDefault(nonNegativeNumber_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _and["default"])([(0, _integer["default"])(), (0, _nonNegativeNumber["default"])()], 'nonNegativeInteger');

exports["default"] = _default;

});

unwrapExports(nonNegativeInteger);

var typeOf_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = typeOf;

var _react = _interopRequireDefault(React__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function typeOf(child) {
  if (child === null) {
    return 'null';
  }

  if (Array.isArray(child)) {
    return 'array';
  }

  if (_typeof(child) !== 'object') {
    return _typeof(child);
  }

  if ( /*#__PURE__*/_react["default"].isValidElement(child)) {
    return child.type;
  }

  return child;
}

});

unwrapExports(typeOf_1);

var object_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isPlainObject = _interopRequireDefault(isPlainObject$1);

var _typeOf = _interopRequireDefault(typeOf_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
  code adapted from https://github.com/facebook/react/blob/14156e56b9cf18ac86963185c5af4abddf3ff811/src/isomorphic/classic/types/ReactPropTypes.js#L202-L206
  so that it can be called outside of React's normal PropType flow
*/
var ReactPropTypeLocationNames = {
  prop: 'prop',
  context: 'context',
  childContext: 'child context'
};

function object(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (propValue == null) {
    return null;
  }

  if ((0, _isPlainObject["default"])(propValue)) {
    return null;
  }

  var locationName = ReactPropTypeLocationNames[location] || location;
  return new TypeError("Invalid ".concat(locationName, " `").concat(propFullName, "` of type `").concat((0, _typeOf["default"])(propValue), "` supplied to `").concat(componentName, "`, expected `object`."));
}

object.isRequired = function objectRequired(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (propValue == null) {
    var locationName = ReactPropTypeLocationNames[location] || location;
    return new TypeError("The ".concat(locationName, " `").concat(propFullName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(propValue, "`."));
  }

  for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
    rest[_key - 5] = arguments[_key];
  }

  return object.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
};

var _default = function _default() {
  return (0, _wrapValidator["default"])(object, 'object');
};

exports["default"] = _default;

});

unwrapExports(object_1);

var withShape_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withShape;

var _and = _interopRequireDefault(and);

var _shape = _interopRequireDefault(shape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function withShape(type, shapeTypes) {
  if (typeof type !== 'function') {
    throw new TypeError('type must be a valid PropType');
  }

  var shapeValidator = (0, _shape["default"])(shapeTypes);
  return (0, _and["default"])([type, shapeValidator], 'withShape');
}

});

unwrapExports(withShape_1);

var sequenceOf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sequenceOfValidator;



var _and = _interopRequireDefault(and);

var _between = _interopRequireDefault(between);

var _nonNegativeInteger = _interopRequireDefault(nonNegativeInteger);

var _object = _interopRequireDefault(object_1);

var _withShape = _interopRequireDefault(withShape_1);

var _typeOf = _interopRequireDefault(typeOf_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var minValidator = _nonNegativeInteger["default"];
var maxValidator = (0, _and["default"])([_nonNegativeInteger["default"], (0, _between["default"])({
  gte: 1
})]);

function validateRange(min, max) {
  if (typeof max !== 'number' || typeof min !== 'number') {
    return null; // no additional checking needed unless both are present
  }

  if (min <= max) {
    return null;
  }

  return new RangeError('min must be less than or equal to max');
}

var specifierShape = {
  validator: function validator(props, propName) {
    var propValue = props[propName];

    if (typeof propValue !== 'function') {
      return new TypeError('"validator" must be a propType validator function');
    }

    return null;
  },
  min: function min(props, propName) {
    return minValidator(props, propName) || validateRange(props.min, props.max);
  },
  max: function max(props, propName) {
    return maxValidator(props, propName) || validateRange(props.min, props.max);
  }
};

function getMinMax(_ref) {
  var min = _ref.min,
      max = _ref.max;
  var minimum;
  var maximum;

  if (typeof min !== 'number' && typeof max !== 'number') {
    // neither provided, default to "1"
    minimum = 1;
    maximum = 1;
  } else {
    minimum = typeof min === 'number' ? min : 1;
    maximum = typeof max === 'number' ? max : Infinity;
  }

  return {
    minimum: minimum,
    maximum: maximum
  };
}

function chunkByType(items) {
  var chunk = [];
  var lastType;
  return items.reduce(function (chunks, item) {
    var itemType = (0, _typeOf["default"])(item);

    if (!lastType || itemType === lastType) {
      chunk.push(item);
    } else {
      chunks.push(chunk);
      chunk = [item];
    }

    lastType = itemType;
    return chunks;
  }, []).concat(chunk.length > 0 ? [chunk] : []);
}

function validateChunks(specifiers, props, propName, componentName) {
  var items = props[propName];
  var chunks = chunkByType(items);

  for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
    rest[_key - 4] = arguments[_key];
  }

  for (var i = 0; i < specifiers.length; i += 1) {
    var _specifiers$i = specifiers[i],
        validator = _specifiers$i.validator,
        min = _specifiers$i.min,
        max = _specifiers$i.max;

    var _getMinMax = getMinMax({
      min: min,
      max: max
    }),
        minimum = _getMinMax.minimum,
        maximum = _getMinMax.maximum;

    if (chunks.length === 0 && minimum === 0) {
      // no chunks left, but this specifier does not require any items
      continue; // eslint-disable-line no-continue
    }

    var arrayOfValidator = (0, PropTypes__default['default'].arrayOf)(validator).isRequired;
    var chunk = chunks.shift(); // extract the next chunk to test

    var chunkError = arrayOfValidator.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, _defineProperty({}, propName, chunk)), propName, componentName].concat(rest));

    if (chunkError) {
      // this chunk is invalid
      if (minimum === 0) {
        // but, specifier has a min of 0 and can be skipped
        chunks.unshift(chunk); // put the chunk back, for the next iteration

        continue; // eslint-disable-line no-continue
      }

      return chunkError;
    } // chunk is valid!


    if (chunk.length < minimum) {
      return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a minimum of ").concat(min, " items, but only has ").concat(chunk.length, "."));
    }

    if (chunk.length > maximum) {
      return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a maximum of ").concat(max, " items, but has ").concat(chunk.length, "."));
    }
  }

  if (chunks.length > 0) {
    return new TypeError("".concat(componentName, ": after all ").concat(specifiers.length, " specifiers matched, ").concat(chunks.length, " types of items were remaining."));
  }

  return null;
}

var specifierValidator = (0, _withShape["default"])((0, _object["default"])(), specifierShape).isRequired;

function sequenceOfValidator() {
  for (var _len2 = arguments.length, specifiers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    specifiers[_key2] = arguments[_key2];
  }

  if (specifiers.length === 0) {
    throw new RangeError('sequenceOf: at least one specifier is required');
  }

  var errors = specifiers.map(function (specifier, i) {
    return specifierValidator({
      specifier: specifier
    }, 'specifier', 'sequenceOf specifier', "suequenceOf specifier, index ".concat(i), "specifier, index ".concat(i));
  });

  if (errors.some(Boolean)) {
    throw new TypeError("\n      sequenceOf: all specifiers must match the appropriate shape.\n\n      Errors:\n        ".concat(errors.map(function (e, i) {
      return " - Argument index ".concat(i, ": ").concat(e.message);
    }).join(',\n        '), "\n    "));
  }

  var validator = function sequenceOf(props, propName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      rest[_key3 - 2] = arguments[_key3];
    }

    var error = PropTypes__default['default'].array.apply(void 0, [props, propName].concat(rest));

    if (error) {
      return error;
    }

    return validateChunks.apply(void 0, [specifiers, props, propName].concat(rest));
  };

  validator.isRequired = function sequenceOfRequired(props, propName, componentName) {
    for (var _len4 = arguments.length, rest = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
      rest[_key4 - 3] = arguments[_key4];
    }

    var error = PropTypes__default['default'].array.isRequired.apply(PropTypes__default['default'].array, [props, propName, componentName].concat(rest));

    if (error) {
      return error;
    }

    return validateChunks.apply(void 0, [specifiers, props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, 'sequenceOf', specifiers);
}

});

unwrapExports(sequenceOf);

var childrenSequenceOf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = childrenSequenceOfValidator;

var _sequenceOf = _interopRequireDefault(sequenceOf);

var _renderableChildren = _interopRequireDefault(renderableChildren_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function childrenSequenceOfValidator() {
  for (var _len = arguments.length, specifiers = new Array(_len), _key = 0; _key < _len; _key++) {
    specifiers[_key] = arguments[_key];
  }

  var seq = _sequenceOf["default"].apply(void 0, specifiers);

  var validator = function childrenSequenceOf(props, propName, componentName) {
    if (propName !== 'children') {
      return new TypeError("".concat(componentName, " is using the childrenSequenceOf validator on non-children prop \"").concat(propName, "\""));
    }

    var propValue = props[propName];
    var children = (0, _renderableChildren["default"])(propValue);

    if (children.length === 0) {
      return null;
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return seq.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, {
      children: children
    }), propName, componentName].concat(rest));
  };

  validator.isRequired = function childrenSequenceOfRequired(props, propName, componentName) {
    if (propName !== 'children') {
      return new TypeError("".concat(componentName, " is using the childrenSequenceOf validator on non-children prop \"").concat(propName, "\""));
    }

    var propValue = props[propName];
    var children = (0, _renderableChildren["default"])(propValue);

    if (children.length === 0) {
      return new TypeError("".concat(componentName, ": renderable children are required."));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return seq.isRequired.apply(seq, [_objectSpread(_objectSpread({}, props), {}, {
      children: children
    }), propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, 'childrenSequenceOf', specifiers);
}

});

unwrapExports(childrenSequenceOf);

var componentWithName_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = componentWithName;

var _react = _interopRequireDefault(React__default['default']);

var _isRegex = _interopRequireDefault(isRegex);

var _arrayPrototype = _interopRequireDefault(array_prototype_find);

var _getComponentName = _interopRequireDefault(getComponentName_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function stripHOCs(fullName, namesOfHOCsToStrip) {
  var innerName = fullName;

  while (/\([^()]*\)/g.test(innerName)) {
    var HOC = innerName;
    var previousHOC = void 0;

    do {
      previousHOC = HOC;
      HOC = previousHOC.replace(/\([^()]*\)/g, '');
    } while (previousHOC !== HOC);

    if (namesOfHOCsToStrip.indexOf(HOC) === -1) {
      return innerName;
    }

    innerName = innerName.replace(RegExp("^".concat(HOC, "\\(|\\)$"), 'g'), '');
  }

  return innerName;
}

function hasName(name, namesOfHOCsToStrip, propValue, propName, componentName) {
  for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
    rest[_key - 5] = arguments[_key];
  }

  if (Array.isArray(propValue)) {
    return (0, _arrayPrototype["default"])(propValue.map(function (item) {
      return hasName.apply(void 0, [name, namesOfHOCsToStrip, item, propName, componentName].concat(rest));
    }), Boolean) || null;
  }

  if (! /*#__PURE__*/_react["default"].isValidElement(propValue)) {
    return new TypeError("".concat(componentName, ".").concat(propName, " is not a valid React element"));
  }

  var type = propValue.type;
  var componentNameFromType = (0, _getComponentName["default"])(type);
  var innerComponentName = namesOfHOCsToStrip.length > 0 ? stripHOCs(componentNameFromType, namesOfHOCsToStrip) : componentNameFromType;

  if ((0, _isRegex["default"])(name) && !name.test(innerComponentName)) {
    return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components matching the regular expression ").concat(name));
  }

  if (!(0, _isRegex["default"])(name) && innerComponentName !== name) {
    return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components named ").concat(name, ", got ").concat(innerComponentName));
  }

  return null;
}

function componentWithName(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof name !== 'string' && !(0, _isRegex["default"])(name)) {
    throw new TypeError('name must be a string or a regex');
  }

  var passedOptions = Object.keys(options);

  if (passedOptions.length > 1 || passedOptions.length === 1 && passedOptions[0] !== 'stripHOCs') {
    throw new TypeError("The only options supported are: \u201CstripHOCs\u201D, got: \u201C".concat(passedOptions.join('”, “'), "\u201D"));
  }

  var _options$stripHOCs = options.stripHOCs,
      namesOfHOCsToStrip = _options$stripHOCs === void 0 ? [] : _options$stripHOCs;
  var allHOCNamesAreValid = namesOfHOCsToStrip.every(function (x) {
    if (typeof x !== 'string' || /[()]/g.test(x)) {
      return false;
    }

    return /^(?:[a-z][a-zA-Z0-9]+|[A-Z][a-z][a-zA-Z0-9]+)$/.test(x);
  });

  if (!allHOCNamesAreValid) {
    throw new TypeError('every provided HOC name must be a string with no parens, and in camelCase');
  }

  function componentWithNameValidator(props, propName, componentName) {
    var propValue = props[propName];

    if (props[propName] == null) {
      return null;
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return hasName.apply(void 0, [name, namesOfHOCsToStrip, propValue, propName, componentName].concat(rest));
  }

  componentWithNameValidator.isRequired = function componentWithNameRequired(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return new TypeError("`".concat(componentName, ".").concat(propName, "` requires at least one component named ").concat(name));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return hasName.apply(void 0, [name, namesOfHOCsToStrip, propValue, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(componentWithNameValidator, "componentWithName:".concat(name), name);
}

});

unwrapExports(componentWithName_1);

var disallowedIf_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = disallowedIf;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function disallowedIf(propType, otherPropName, otherPropType) {
  if (typeof propType !== 'function' || typeof propType.isRequired !== 'function') {
    throw new TypeError('a propType validator is required; propType validators must also provide `.isRequired`');
  }

  if (typeof otherPropName !== 'string') {
    throw new TypeError('other prop name must be a string');
  }

  if (typeof otherPropType !== 'function') {
    throw new TypeError('other prop type validator is required');
  }

  function disallowedIfRequired(props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var error = propType.isRequired.apply(propType, [props, propName, componentName].concat(rest));

    if (error) {
      return error;
    }

    if (props[otherPropName] == null) {
      return null;
    }

    var otherError = otherPropType.apply(void 0, [props, otherPropName, componentName].concat(rest));

    if (otherError) {
      return null;
    }

    return new Error("prop \u201C".concat(propName, "\u201D is disallowed when \u201C").concat(otherPropName, "\u201D matches the provided validator"));
  }

  var validator = function disallowedIfPropType(props, propName) {
    if (props[propName] == null) {
      return null;
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      rest[_key2 - 2] = arguments[_key2];
    }

    return disallowedIfRequired.apply(void 0, [props, propName].concat(rest));
  };

  validator.isRequired = disallowedIfRequired;
  return (0, _wrapValidator["default"])(validator, 'disallowedIf', {
    propType: propType,
    otherPropName: otherPropName,
    otherPropType: otherPropType
  });
}

});

unwrapExports(disallowedIf_1);

var elementType = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = elementTypeValidator;





var _and = _interopRequireDefault(and);

var _getComponentName = _interopRequireDefault(getComponentName_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function getTypeName(Type) {
  if (typeof Type === 'string') {
    return Type;
  }

  var type = (0, _getComponentName["default"])(Type);
  /* istanbul ignore next */
  // in environments where functions do not have names

  return type || 'Anonymous Component';
}

function validateElementType(Type, props, propName, componentName) {
  var type = props[propName].type;

  if (type === Type) {
    return null;
  }

  return new TypeError("".concat(componentName, ".").concat(propName, " must be a React element of type ").concat(getTypeName(Type)));
}

function elementTypeValidator(Type) {
  if (Type === '*') {
    return (0, _wrapValidator["default"])(PropTypes__default['default'].element, 'elementType(*)', Type);
  }

  if (!(0, reactIs$2.isValidElementType)(Type)) {
    throw new TypeError("Type must be a React Component, an HTML element tag name, or \"*\". Got an ".concat(_typeof(Type)));
  }

  function elementType(props, propName, componentName) {
    if (props[propName] == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return validateElementType.apply(void 0, [Type, props, propName, componentName].concat(rest));
  }

  elementType.isRequired = elementType; // covered by and + element

  var typeName = getTypeName(Type);
  var validatorName = "elementType(".concat(typeName, ")");
  return (0, _wrapValidator["default"])((0, _and["default"])([PropTypes__default['default'].element, elementType], validatorName), validatorName, Type);
}

});

unwrapExports(elementType);

var or_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = or;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function oneOfTypeValidator(validators) {
  var validator = function oneOfType(props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var propValue = props[propName];

    if (typeof propValue === 'undefined') {
      return null;
    }

    var errors = validators.map(function (v) {
      return v.apply(void 0, [props, propName, componentName].concat(rest));
    }).filter(Boolean);

    if (errors.length < validators.length) {
      return null;
    }

    return new TypeError("".concat(componentName, ": invalid value supplied to ").concat(propName, "."));
  };

  validator.isRequired = function oneOfTypeRequired(props, propName, componentName) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    var propValue = props[propName];

    if (typeof propValue === 'undefined') {
      return new TypeError("".concat(componentName, ": missing value for required ").concat(propName, "."));
    }

    var errors = validators.map(function (v) {
      return v.apply(void 0, [props, propName, componentName].concat(rest));
    }).filter(Boolean);

    if (errors.length === validators.length) {
      return new TypeError("".concat(componentName, ": invalid value ").concat(errors, " supplied to required ").concat(propName, "."));
    }

    return null;
  };

  return (0, _wrapValidator["default"])(validator, 'oneOfType', validators);
}

function or(validators) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';

  if (!Array.isArray(validators)) {
    throw new TypeError('or: 2 or more validators are required');
  }

  if (validators.length <= 1) {
    throw new RangeError('or: 2 or more validators are required');
  }

  var validator = oneOfTypeValidator([(0, PropTypes__default['default'].arrayOf)(oneOfTypeValidator(validators))].concat(_toConsumableArray(validators)));
  return (0, _wrapValidator["default"])(validator, name, validators);
}

});

unwrapExports(or_1);

var explicitNull_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function explicitNull(props, propName, componentName) {
  if (props[propName] == null) {
    return null;
  }

  return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be null or undefined; received ").concat(_typeof(props[propName])));
}

explicitNull.isRequired = function explicitNullRequired(props, propName, componentName) {
  if (props[propName] === null) {
    return null;
  }

  return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be null; received ").concat(_typeof(props[propName])));
};

var _default = function _default() {
  return (0, _wrapValidator["default"])(explicitNull, 'explicitNull');
};

exports["default"] = _default;

});

unwrapExports(explicitNull_1);

var empty$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;



var _or = _interopRequireDefault(or_1);

var _explicitNull = _interopRequireDefault(explicitNull_1);

var _withShape = _interopRequireDefault(withShape_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var arrayOfValidator;
var validator = (0, _or["default"])([_explicitNull["default"], // null/undefined
(0, PropTypes__default['default'].oneOf)([false, '', NaN]), (0, _withShape["default"])(PropTypes__default['default'].array, {
  length: (0, PropTypes__default['default'].oneOf)([0]).isRequired
}).isRequired, function () {
  return arrayOfValidator.apply(void 0, arguments);
}]);
arrayOfValidator = (0, PropTypes__default['default'].arrayOf)(validator).isRequired;

var _default = function _default() {
  return (0, _wrapValidator["default"])(validator, 'empty');
};

exports["default"] = _default;

});

unwrapExports(empty$1);

var keysOf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = keysOfValidator;

var _isPrimitive = _interopRequireDefault(isPrimitive_1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function keysOfValidator(propType) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'keysOf';

  if (typeof propType !== 'function') {
    throw new TypeError('argument to keysOf must be a valid PropType function');
  }

  var validator = function keysOf(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];

    if (propValue == null || (0, _isPrimitive["default"])(propValue)) {
      return null;
    }

    var firstError = null;
    Object.keys(propValue).some(function (key) {
      firstError = propType.apply(void 0, [_defineProperty({}, key, key), key, componentName, location, "(".concat(propFullName, ").").concat(key)].concat(rest));
      return firstError != null;
    });
    return firstError || null;
  };

  validator.isRequired = function keyedByRequired(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " is required, but value is ").concat(propValue));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return validator.apply(void 0, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, name, propType);
}

});

unwrapExports(keysOf);

var mutuallyExclusiveProps = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mutuallyExclusiveOfType;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function mutuallyExclusiveOfType(propType) {
  if (typeof propType !== 'function') {
    throw new TypeError('a propType is required');
  }

  for (var _len = arguments.length, exclusiveProps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    exclusiveProps[_key - 1] = arguments[_key];
  }

  if (exclusiveProps.length < 1) {
    throw new TypeError('at least one prop that is mutually exclusive with this propType is required');
  }

  var propList = exclusiveProps.join(', or ');
  var map = exclusiveProps.reduce(function (acc, prop) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, prop, true));
  }, {});

  var countProps = function countProps(count, prop) {
    return count + (map[prop] ? 1 : 0);
  };

  var validator = function mutuallyExclusiveProps(props, propName, componentName) {
    var exclusivePropCount = Object.keys(props).filter(function (prop) {
      return props[prop] != null;
    }).reduce(countProps, 0);

    if (exclusivePropCount > 1) {
      return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };

  validator.isRequired = function mutuallyExclusivePropsRequired(props, propName, componentName) {
    var exclusivePropCount = Object.keys(props).filter(function (prop) {
      return prop === propName || props[prop] != null;
    }).reduce(countProps, 0);

    if (exclusivePropCount > 1) {
      return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, "mutuallyExclusiveProps:".concat(propList), exclusiveProps);
}

});

unwrapExports(mutuallyExclusiveProps);

var mutuallyExclusiveTrueProps = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mutuallyExclusiveTrue;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function mutuallyExclusiveTrue() {
  for (var _len = arguments.length, exclusiveProps = new Array(_len), _key = 0; _key < _len; _key++) {
    exclusiveProps[_key] = arguments[_key];
  }

  if (exclusiveProps.length < 1) {
    throw new TypeError('at least one prop that is mutually exclusive is required');
  }

  if (!exclusiveProps.every(function (x) {
    return typeof x === 'string';
  })) {
    throw new TypeError('all exclusive true props must be strings');
  }

  var propsList = exclusiveProps.join(', or ');

  var validator = function mutuallyExclusiveTrueProps(props, propName, componentName) {
    var countProps = function countProps(count, prop) {
      return count + (props[prop] ? 1 : 0);
    };

    var exclusivePropCount = exclusiveProps.reduce(countProps, 0);

    if (exclusivePropCount > 1) {
      return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return PropTypes__default['default'].bool.apply(void 0, [props, propName, componentName].concat(rest));
  };

  validator.isRequired = function mutuallyExclusiveTruePropsRequired(props, propName, componentName) {
    var countProps = function countProps(count, prop) {
      return count + (props[prop] ? 1 : 0);
    };

    var exclusivePropCount = exclusiveProps.reduce(countProps, 0);

    if (exclusivePropCount > 1) {
      return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
    }

    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    return PropTypes__default['default'].bool.isRequired.apply(PropTypes__default['default'].bool, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(validator, "mutuallyExclusiveTrueProps: ".concat(propsList), exclusiveProps);
}

});

unwrapExports(mutuallyExclusiveTrueProps);

var nChildren_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = nChildren;

var _react = _interopRequireDefault(React__default['default']);



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function nChildren(n) {
  var propType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PropTypes__default['default'].node;

  if (typeof n !== 'number' || isNaN(n) || n < 0) {
    throw new TypeError('a non-negative number is required');
  }

  var validator = function nChildrenValidator(props, propName, componentName) {
    if (propName !== 'children') {
      return new TypeError("".concat(componentName, " is using the nChildren validator on a non-children prop"));
    }

    var children = props.children;

    var childrenCount = _react["default"].Children.count(children);

    if (childrenCount !== n) {
      return new RangeError("".concat(componentName, " expects to receive ").concat(n, " children, but received ").concat(childrenCount, " children."));
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };

  validator.isRequired = validator;
  return (0, _wrapValidator["default"])(validator, "nChildren:".concat(n), n);
}

});

unwrapExports(nChildren_1);

var numericString = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var validNumericChars = /^[-+]?(?:[1-9][0-9]*(?:\.[0-9]+)?|0|0\.[0-9]+)$/;

var validator = function numericString(props, propName, componentName) {
  if (props[propName] == null) {
    return null;
  }

  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  var stringError = PropTypes__default['default'].string.apply(void 0, [props, propName, componentName].concat(rest));

  if (stringError) {
    return stringError;
  }

  var value = props[propName];
  var passesRegex = validNumericChars.test(value);

  if (passesRegex) {
    return null;
  }

  return new TypeError("".concat(componentName, ": prop \"").concat(propName, "\" (value \"").concat(value, "\") must be a numeric string:\n    - starting with an optional + or -\n    - that does not have a leading zero\n    - with an optional decimal part (that contains only one decimal point, if present)\n    - that otherwise only contains digits (0-9)\n    - not +-NaN, or +-Infinity\n  "));
};

validator.isRequired = function numericStringRequired(props, propName, componentName) {
  if (props[propName] == null) {
    return new TypeError("".concat(componentName, ": ").concat(propName, " is required"));
  }

  for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    rest[_key2 - 3] = arguments[_key2];
  }

  return validator.apply(void 0, [props, propName, componentName].concat(rest));
};

var _default = function _default() {
  return (0, _wrapValidator["default"])(validator, 'numericString');
};

exports["default"] = _default;

});

unwrapExports(numericString);

var predicate_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = predicate;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function predicate(fn) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (typeof fn !== 'function') {
    throw new TypeError('`fn` must be a function');
  }

  if (typeof message !== 'string') {
    throw new TypeError('`message`, if provided, must be a string');
  }

  function requiredValidator(props, propName, componentName) {
    var result = fn(props[propName]);

    if (result) {
      return null;
    }

    return new TypeError("`".concat(componentName, "` requires that `").concat(propName, "` pass a predicate function").concat(message ? ": ".concat(message) : '', "."));
  }

  function validator(props, propName) {
    if (props[propName] == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    return requiredValidator.apply(void 0, [props, propName].concat(rest));
  }

  validator.isRequired = requiredValidator;
  return (0, _wrapValidator["default"])(validator, 'predicate', fn);
}

});

unwrapExports(predicate_1);

var range_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = range;

var _and = _interopRequireDefault(and);

var _between = _interopRequireDefault(between);

var _integer = _interopRequireDefault(integer);

var _isInteger = _interopRequireDefault(isInteger);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
/* istanbul ignore next */
Math.pow(2, 53) - 1;

function isValidLength(x) {
  return (0, _isInteger["default"])(x) && Math.abs(x) < MAX_SAFE_INTEGER;
}

function range(min, max) {
  if (!isValidLength(min) || !isValidLength(max)) {
    throw new RangeError("\"range\" requires two integers: ".concat(min, " and ").concat(max, " given"));
  }

  if (min === max) {
    throw new RangeError('min and max must not be the same');
  }

  return (0, _wrapValidator["default"])((0, _and["default"])([(0, _integer["default"])(), (0, _between["default"])({
    gte: min,
    lt: max
  })], 'range'), 'range', {
    min: min,
    max: max
  });
}

});

unwrapExports(range_1$1);

var ref_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;



var _isPlainObject = _interopRequireDefault(isPlainObject$1);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isPrototypeOf = Object.prototype.isPrototypeOf;

function isNewRef(prop) {
  if (!(0, _isPlainObject["default"])(prop)) {
    return false;
  }

  var ownProperties = Object.keys(prop);
  return ownProperties.length === 1 && ownProperties[0] === 'current';
}

function isCallbackRef(prop) {
  return typeof prop === 'function' && !isPrototypeOf.call(React__default['default'].Component, prop) && (!React__default['default'].PureComponent || !isPrototypeOf.call(React__default['default'].PureComponent, prop));
}

function requiredRef(props, propName, componentName) {
  var propValue = props[propName];

  if (isCallbackRef(propValue) || isNewRef(propValue)) {
    return null;
  }

  return new TypeError("".concat(propName, " in ").concat(componentName, " must be a ref"));
}

function ref(props, propName, componentName) {
  var propValue = props[propName];

  if (propValue == null) {
    return null;
  }

  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  return requiredRef.apply(void 0, [props, propName, componentName].concat(rest));
}

ref.isRequired = requiredRef;

var _default = function _default() {
  return (0, _wrapValidator["default"])(ref, 'ref');
};

exports["default"] = _default;

});

unwrapExports(ref_1);

var requiredBy = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getRequiredBy;

var _objectIs = _interopRequireDefault(objectIs);

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getRequiredBy(requiredByPropName, propType) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  function requiredBy(props, propName, componentName) {
    if (props[requiredByPropName]) {
      var propValue = props[propName];

      if ((0, _objectIs["default"])(propValue, defaultValue) || typeof propValue === 'undefined') {
        return new TypeError("".concat(componentName, ": when ").concat(requiredByPropName, " is true, prop \u201C").concat(propName, "\u201D must be present."));
      }
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  }

  requiredBy.isRequired = function requiredByRequired(props, propName, componentName) {
    var propValue = props[propName];

    if ((0, _objectIs["default"])(propValue, defaultValue)) {
      return new TypeError("".concat(componentName, ": prop \u201C").concat(propName, "\u201D must be present."));
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    return propType.isRequired.apply(propType, [props, propName, componentName].concat(rest));
  };

  return (0, _wrapValidator["default"])(requiredBy, "requiredBy \u201C".concat(requiredByPropName, "\u201D"), [requiredByPropName, defaultValue]);
}

});

unwrapExports(requiredBy);

var restrictedProp = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function customMessageWrapper(messsageFunction) {
  function restrictedProp(props, propName, componentName, location) {
    if (props[propName] == null) {
      return null;
    }

    if (messsageFunction && typeof messsageFunction === 'function') {
      for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        rest[_key - 4] = arguments[_key];
      }

      return new TypeError(messsageFunction.apply(void 0, [props, propName, componentName, location].concat(rest)));
    }

    return new TypeError("The ".concat(propName, " ").concat(location, " on ").concat(componentName, " is not allowed."));
  }

  restrictedProp.isRequired = restrictedProp;
  return restrictedProp;
}

var _default = function _default() {
  var messsageFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapValidator["default"])(customMessageWrapper(messsageFunction), 'restrictedProp');
};

exports["default"] = _default;

});

unwrapExports(restrictedProp);

var stringEndsWith = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stringEndsWithValidator;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function stringEndsWithValidator(end) {
  if (typeof end !== 'string' || end.length === 0) {
    throw new TypeError('a non-empty string is required');
  }

  var validator = function stringEndsWith(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var stringError = PropTypes__default['default'].string.apply(void 0, [props, propName, componentName].concat(rest));

    if (stringError) {
      return stringError;
    }

    if (!propValue.endsWith(end) || propValue.length <= end.length) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " does not end with \"").concat(end, "\""));
    }

    return null;
  };

  validator.isRequired = function requiredStringEndsWith() {
    var stringError = PropTypes__default['default'].string.isRequired.apply(PropTypes__default['default'].string, arguments);

    if (stringError) {
      return stringError;
    }

    return validator.apply(void 0, arguments);
  };

  return (0, _wrapValidator["default"])(validator, "stringEndsWith: ".concat(end));
}

});

unwrapExports(stringEndsWith);

var stringStartsWith = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stringStartsWithValidator;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function stringStartsWithValidator(start) {
  if (typeof start !== 'string' || start.length === 0) {
    throw new TypeError('a non-empty string is required');
  }

  var validator = function stringStartsWith(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var stringError = PropTypes__default['default'].string.apply(void 0, [props, propName, componentName].concat(rest));

    if (stringError) {
      return stringError;
    }

    if (!propValue.startsWith(start) || propValue.length <= start.length) {
      return new TypeError("".concat(componentName, ": ").concat(propName, " does not start with \"").concat(start, "\""));
    }

    return null;
  };

  validator.isRequired = function requiredStringStartsWith() {
    var stringError = PropTypes__default['default'].string.isRequired.apply(PropTypes__default['default'].string, arguments);

    if (stringError) {
      return stringError;
    }

    return validator.apply(void 0, arguments);
  };

  return (0, _wrapValidator["default"])(validator, "stringStartsWith: ".concat(start));
}

});

unwrapExports(stringStartsWith);

var uniqueArray_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;



var _wrapValidator = _interopRequireDefault(wrapValidator_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function uniqueCountWithSet(arr) {
  return new Set(arr).size;
}
/* istanbul ignore next */


function uniqueCountLegacy(arr) {
  var seen = [];
  arr.forEach(function (item) {
    if (seen.indexOf(item) === -1) {
      seen.push(item);
    }
  });
  return seen.length;
}

var getUniqueCount = typeof Set === 'function' ? uniqueCountWithSet :
/* istanbul ignore next */
uniqueCountLegacy;

function requiredUniqueArray(props, propName, componentName) {
  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  var result = PropTypes__default['default'].array.isRequired.apply(PropTypes__default['default'].array, [props, propName, componentName].concat(rest));

  if (result != null) {
    return result;
  }

  var propValue = props[propName];
  var uniqueCount = getUniqueCount(propValue);

  if (uniqueCount !== propValue.length) {
    return new RangeError("".concat(componentName, ": values must be unique. ").concat(propValue.length - uniqueCount, " duplicate values found."));
  }

  return null;
}

function uniqueArray(props, propName) {
  var propValue = props[propName];

  if (propValue == null) {
    return null;
  }

  for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    rest[_key2 - 2] = arguments[_key2];
  }

  return requiredUniqueArray.apply(void 0, [props, propName].concat(rest));
}

uniqueArray.isRequired = requiredUniqueArray;

var _default = function _default() {
  return (0, _wrapValidator["default"])(uniqueArray, 'uniqueArray');
};

exports["default"] = _default;

});

unwrapExports(uniqueArray_1);

var uniqueArrayOf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = uniqueArrayOfTypeValidator;



var _and = _interopRequireDefault(and);

var _uniqueArray = _interopRequireDefault(uniqueArray_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var unique = (0, _uniqueArray["default"])();

function uniqueArrayOfTypeValidator(type) {
  if (typeof type !== 'function') {
    throw new TypeError('type must be a validator function');
  }

  var mapper = null;
  var name = 'uniqueArrayOfType';

  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  if (rest.length === 1) {
    if (typeof rest[0] === 'function') {
      mapper = rest[0];
    } else if (typeof rest[0] === 'string') {
      name = rest[0];
    } else {
      throw new TypeError('single input must either be string or function');
    }
  } else if (rest.length === 2) {
    if (typeof rest[0] === 'function' && typeof rest[1] === 'string') {
      mapper = rest[0];
      name = rest[1];
    } else {
      throw new TypeError('multiple inputs must be in [function, string] order');
    }
  } else if (rest.length > 2) {
    throw new TypeError('only [], [name], [mapper], and [mapper, name] are valid inputs');
  }

  function uniqueArrayOfMapped(props, propName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }

    var values = propValue.map(mapper);

    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    return unique.apply(void 0, [_objectSpread(_objectSpread({}, props), {}, _defineProperty({}, propName, values)), propName].concat(args));
  }

  uniqueArrayOfMapped.isRequired = function isRequired(props, propName) {
    var propValue = props[propName];

    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    if (propValue == null) {
      return PropTypes__default['default'].array.isRequired.apply(PropTypes__default['default'].array, [props, propName].concat(args));
    }

    return uniqueArrayOfMapped.apply(void 0, [props, propName].concat(args));
  };

  var arrayValidator = (0, PropTypes__default['default'].arrayOf)(type);
  var uniqueValidator = mapper ? uniqueArrayOfMapped : unique;
  var validator = (0, _and["default"])([arrayValidator, uniqueValidator], name);
  validator.isRequired = (0, _and["default"])([uniqueValidator.isRequired, arrayValidator.isRequired], "".concat(name, ".isRequired"));
  return validator;
}

});

unwrapExports(uniqueArrayOf);

var build$2 = createCommonjsModule(function (module) {

var _propTypesExact = _interopRequireDefault(build$1);

var _and = _interopRequireDefault(and);

var _between = _interopRequireDefault(between);

var _booleanSome = _interopRequireDefault(booleanSome);

var _childrenHavePropXorChildren = _interopRequireDefault(childrenHavePropXorChildren_1);

var _childrenOf = _interopRequireDefault(childrenOf_1);

var _childrenOfType = _interopRequireDefault(childrenOfType_1);

var _childrenSequenceOf = _interopRequireDefault(childrenSequenceOf);

var _componentWithName = _interopRequireDefault(componentWithName_1);

var _disallowedIf = _interopRequireDefault(disallowedIf_1);

var _elementType = _interopRequireDefault(elementType);

var _empty = _interopRequireDefault(empty$1);

var _explicitNull = _interopRequireDefault(explicitNull_1);

var _integer = _interopRequireDefault(integer);

var _keysOf = _interopRequireDefault(keysOf);

var _mutuallyExclusiveProps = _interopRequireDefault(mutuallyExclusiveProps);

var _mutuallyExclusiveTrueProps = _interopRequireDefault(mutuallyExclusiveTrueProps);

var _nChildren = _interopRequireDefault(nChildren_1);

var _nonNegativeInteger = _interopRequireDefault(nonNegativeInteger);

var _nonNegativeNumber = _interopRequireDefault(nonNegativeNumber_1);

var _numericString = _interopRequireDefault(numericString);

var _object = _interopRequireDefault(object_1);

var _or = _interopRequireDefault(or_1);

var _predicate = _interopRequireDefault(predicate_1);

var _range = _interopRequireDefault(range_1$1);

var _ref = _interopRequireDefault(ref_1);

var _requiredBy = _interopRequireDefault(requiredBy);

var _restrictedProp = _interopRequireDefault(restrictedProp);

var _sequenceOf = _interopRequireDefault(sequenceOf);

var _shape = _interopRequireDefault(shape);

var _stringEndsWith = _interopRequireDefault(stringEndsWith);

var _stringStartsWith = _interopRequireDefault(stringStartsWith);

var _uniqueArray = _interopRequireDefault(uniqueArray_1);

var _uniqueArrayOf = _interopRequireDefault(uniqueArrayOf);

var _valuesOf = _interopRequireDefault(valuesOf);

var _withShape = _interopRequireDefault(withShape_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = {
  and: _and["default"],
  between: _between["default"],
  booleanSome: _booleanSome["default"],
  childrenHavePropXorChildren: _childrenHavePropXorChildren["default"],
  childrenOf: _childrenOf["default"],
  childrenOfType: _childrenOfType["default"],
  childrenSequenceOf: _childrenSequenceOf["default"],
  componentWithName: _componentWithName["default"],
  disallowedIf: _disallowedIf["default"],
  elementType: _elementType["default"],
  empty: _empty["default"],
  explicitNull: _explicitNull["default"],
  forbidExtraProps: _propTypesExact["default"],
  integer: _integer["default"],
  keysOf: _keysOf["default"],
  mutuallyExclusiveProps: _mutuallyExclusiveProps["default"],
  mutuallyExclusiveTrueProps: _mutuallyExclusiveTrueProps["default"],
  nChildren: _nChildren["default"],
  nonNegativeInteger: _nonNegativeInteger["default"],
  nonNegativeNumber: _nonNegativeNumber["default"],
  numericString: _numericString["default"],
  object: _object["default"],
  or: _or["default"],
  predicate: _predicate["default"],
  range: _range["default"],
  ref: _ref["default"],
  requiredBy: _requiredBy["default"],
  restrictedProp: _restrictedProp["default"],
  sequenceOf: _sequenceOf["default"],
  shape: _shape["default"],
  stringEndsWith: _stringEndsWith["default"],
  stringStartsWith: _stringStartsWith["default"],
  uniqueArray: _uniqueArray["default"],
  uniqueArrayOf: _uniqueArrayOf["default"],
  valuesOf: _valuesOf["default"],
  withShape: _withShape["default"]
};

});

unwrapExports(build$2);
var build_1 = build$2.and;
var build_2 = build$2.between;
var build_3 = build$2.booleanSome;
var build_4 = build$2.childrenHavePropXorChildren;
var build_5 = build$2.childrenOf;
var build_6 = build$2.childrenOfType;
var build_7 = build$2.childrenSequenceOf;
var build_8 = build$2.componentWithName;
var build_9 = build$2.disallowedIf;
var build_10 = build$2.elementType;
var build_11 = build$2.empty;
var build_12 = build$2.explicitNull;
var build_13 = build$2.forbidExtraProps;
var build_14 = build$2.integer;
var build_15 = build$2.keysOf;
var build_16 = build$2.mutuallyExclusiveProps;
var build_17 = build$2.mutuallyExclusiveTrueProps;
var build_18 = build$2.nChildren;
var build_19 = build$2.nonNegativeInteger;
var build_20 = build$2.nonNegativeNumber;
var build_21 = build$2.numericString;
var build_22 = build$2.object;
var build_23 = build$2.or;
var build_24 = build$2.predicate;
var build_25 = build$2.range;
var build_26 = build$2.ref;
var build_27 = build$2.requiredBy;
var build_28 = build$2.restrictedProp;
var build_29 = build$2.sequenceOf;
var build_30 = build$2.shape;
var build_31 = build$2.stringEndsWith;
var build_32 = build$2.stringStartsWith;
var build_33 = build$2.uniqueArray;
var build_34 = build$2.uniqueArrayOf;
var build_35 = build$2.valuesOf;
var build_36 = build$2.withShape;

var airbnbPropTypes = process.env.NODE_ENV === 'production' ? mocks : build$2;

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

var interopRequireWildcard = createCommonjsModule(function (module) {
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof_1(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;
});

unwrapExports(interopRequireWildcard);

var emptyStylesFn = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var EMPTY_STYLES = {};

var EMPTY_STYLES_FN = function EMPTY_STYLES_FN() {
  return EMPTY_STYLES;
};

var _default = EMPTY_STYLES_FN;
exports["default"] = _default;
});

unwrapExports(emptyStylesFn);

var perf = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.perfStart = perfStart;
exports.perfEnd = perfEnd;
exports["default"] = withPerf;

function perfStart(startMark) {
  if (typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function' && startMark) {
    performance.clearMarks(startMark);
    performance.mark(startMark);
  }
}

function perfEnd(startMark, endMark, measureName) {
  if (typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
    performance.clearMarks(endMark);
    performance.mark(endMark);
    performance.measure(measureName, startMark, endMark);
    performance.clearMarks(measureName);
  }
}

function withPerf(methodName) {
  var startMark = "react-with-styles.".concat(methodName, ".start");
  var endMark = "react-with-styles.".concat(methodName, ".end");
  var measureName = "\uD83D\uDC69\u200D\uD83C\uDFA8 [".concat(methodName, "]");
  return function (fn) {
    return function () {
      if (process.env.NODE_ENV !== 'production') {
        perfStart(startMark);
      }

      var result = fn.apply(void 0, arguments);

      if (process.env.NODE_ENV !== 'production') {
        perfEnd(startMark, endMark, measureName);
      }

      return result;
    };
  };
}
});

unwrapExports(perf);
var perf_1 = perf.perfStart;
var perf_2 = perf.perfEnd;

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function(key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function(key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument)
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

var deepmerge_1 = deepmerge;

var constants = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHANNEL = exports.CHANNEL = '__direction__';

var DIRECTIONS = exports.DIRECTIONS = {
  LTR: 'ltr',
  RTL: 'rtl'
};
});

unwrapExports(constants);
var constants_1 = constants.CHANNEL;
var constants_2 = constants.DIRECTIONS;

var brcast = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].shape({
  getState: _propTypes2['default'].func,
  setState: _propTypes2['default'].func,
  subscribe: _propTypes2['default'].func
});
});

unwrapExports(brcast);

var $isEnumerable$1 = callBound$1('Object.prototype.propertyIsEnumerable');

var implementation$9 = function values(O) {
	var obj = RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if (src(obj, key) && $isEnumerable$1(obj, key)) {
			vals.push(obj[key]);
		}
	}
	return vals;
};

var polyfill$b = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation$9;
};

var shim$6 = function shimValues() {
	var polyfill = polyfill$b();
	defineProperties_1(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};

var polyfill$c = polyfill$b();

defineProperties_1(polyfill$c, {
	getPolyfill: polyfill$b,
	implementation: implementation$9,
	shim: shim$6
});

var object_values = polyfill$c;

var direction = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _object2 = _interopRequireDefault(object_values);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf((0, _object2['default'])(constants.DIRECTIONS));
});

unwrapExports(direction);

var withDirection_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDirectionPropTypes = exports.DIRECTIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = withDirection;



var _react2 = _interopRequireDefault(React__default['default']);



var _hoistNonReactStatics2 = _interopRequireDefault(hoistNonReactStatics_cjs);



var _deepmerge2 = _interopRequireDefault(deepmerge_1);



var _getComponentName2 = _interopRequireDefault(getComponentName_1);





var _brcast2 = _interopRequireDefault(brcast);



var _direction2 = _interopRequireDefault(direction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/forbid-foreign-prop-types */
// This higher-order component consumes a string from React context that is
// provided by the DirectionProvider component.
// We can use this to conditionally switch layout/direction for right-to-left layouts.

var contextTypes = _defineProperty({}, constants.CHANNEL, _brcast2['default']);

exports.DIRECTIONS = constants.DIRECTIONS;

// set a default direction so that a component wrapped with this HOC can be
// used even without a DirectionProvider ancestor in its react tree.

var defaultDirection = constants.DIRECTIONS.LTR;

// export for convenience, in order for components to spread these onto their propTypes
var withDirectionPropTypes = exports.withDirectionPropTypes = {
  direction: _direction2['default'].isRequired
};

function withDirection(WrappedComponent) {
  var WithDirection = function (_React$Component) {
    _inherits(WithDirection, _React$Component);

    function WithDirection(props, context) {
      _classCallCheck(this, WithDirection);

      var _this = _possibleConstructorReturn(this, (WithDirection.__proto__ || Object.getPrototypeOf(WithDirection)).call(this, props, context));

      _this.state = {
        direction: context[constants.CHANNEL] ? context[constants.CHANNEL].getState() : defaultDirection
      };
      return _this;
    }

    _createClass(WithDirection, [{
      key: 'componentDidMount',
      value: function () {
        function componentDidMount() {
          var _this2 = this;

          if (this.context[constants.CHANNEL]) {
            // subscribe to future direction changes
            this.channelUnsubscribe = this.context[constants.CHANNEL].subscribe(function (direction) {
              _this2.setState({ direction: direction });
            });
          }
        }

        return componentDidMount;
      }()
    }, {
      key: 'componentWillUnmount',
      value: function () {
        function componentWillUnmount() {
          if (this.channelUnsubscribe) {
            this.channelUnsubscribe();
          }
        }

        return componentWillUnmount;
      }()
    }, {
      key: 'render',
      value: function () {
        function render() {
          var direction = this.state.direction;


          return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, {
            direction: direction
          }));
        }

        return render;
      }()
    }]);

    return WithDirection;
  }(_react2['default'].Component);

  var wrappedComponentName = (0, _getComponentName2['default'])(WrappedComponent) || 'Component';

  WithDirection.WrappedComponent = WrappedComponent;
  WithDirection.contextTypes = contextTypes;
  WithDirection.displayName = 'withDirection(' + String(wrappedComponentName) + ')';
  if (WrappedComponent.propTypes) {
    WithDirection.propTypes = (0, _deepmerge2['default'])({}, WrappedComponent.propTypes);
    delete WithDirection.propTypes.direction;
  }
  if (WrappedComponent.defaultProps) {
    WithDirection.defaultProps = (0, _deepmerge2['default'])({}, WrappedComponent.defaultProps);
  }

  return (0, _hoistNonReactStatics2['default'])(WithDirection, WrappedComponent);
}
});

unwrapExports(withDirection_1);
var withDirection_2 = withDirection_1.withDirectionPropTypes;
var withDirection_3 = withDirection_1.DIRECTIONS;

var WithStylesContext_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DIRECTIONS", {
  enumerable: true,
  get: function get() {
    return withDirection_1.DIRECTIONS;
  }
});
exports["default"] = void 0;



var _propTypes = interopRequireDefault(PropTypes__default['default']);



function detectAndCreateContext(defaultValue) {
  if (React__default['default'].createContext) {
    return (0, React__default['default'].createContext)(defaultValue);
  }

  return {
    Provider: function Provider() {
      throw new ReferenceError('WithStylesContext requires React 16.3 or later');
    },
    Consumer: function Consumer() {
      throw new ReferenceError('WithStylesContext requires React 16.3 or later');
    }
  };
}

var WithStylesContext = detectAndCreateContext({
  stylesInterface: null,
  stylesTheme: null,
  direction: null
});
WithStylesContext.Provider.propTypes = {
  stylesInterface: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  stylesTheme: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  direction: _propTypes["default"].oneOf([withDirection_1.DIRECTIONS.LTR, withDirection_1.DIRECTIONS.RTL])
};
var _default = WithStylesContext;
exports["default"] = _default;
});

unwrapExports(WithStylesContext_1);

var ThemedStyleSheet = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._getInterface = _getInterface;
exports._getTheme = get;
exports["default"] = void 0;
var styleInterface;
var styleTheme;
var START_MARK = 'react-with-styles.resolve.start';
var END_MARK = 'react-with-styles.resolve.end';
var MEASURE_MARK = "\uD83D\uDC69\u200D\uD83C\uDFA8 [resolve]";

function registerTheme(theme) {
  styleTheme = theme;
}

function registerInterface(interfaceToRegister) {
  styleInterface = interfaceToRegister;
}

function create(makeFromTheme, createWithDirection) {
  var styles = createWithDirection(makeFromTheme(styleTheme));
  return function () {
    return styles;
  };
}

function createLTR(makeFromTheme) {
  return create(makeFromTheme, styleInterface.createLTR || styleInterface.create);
}

function createRTL(makeFromTheme) {
  return create(makeFromTheme, styleInterface.createRTL || styleInterface.create);
}

function get() {
  return styleTheme;
}

function resolve() {
  if (process.env.NODE_ENV !== 'production' && typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
    performance.clearMarks(START_MARK);
    performance.mark(START_MARK);
  }

  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var result = styleInterface.resolve(styles);

  if (process.env.NODE_ENV !== 'production' && typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
    performance.clearMarks(END_MARK);
    performance.mark(END_MARK);
    performance.measure(MEASURE_MARK, START_MARK, END_MARK);
    performance.clearMarks(MEASURE_MARK);
  }

  return result;
}

function resolveLTR() {
  for (var _len2 = arguments.length, styles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    styles[_key2] = arguments[_key2];
  }

  if (styleInterface.resolveLTR) {
    return styleInterface.resolveLTR(styles);
  }

  return resolve(styles);
}

function resolveRTL() {
  for (var _len3 = arguments.length, styles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    styles[_key3] = arguments[_key3];
  }

  if (styleInterface.resolveRTL) {
    return styleInterface.resolveRTL(styles);
  }

  return resolve(styles);
}

function flush() {
  if (styleInterface.flush) {
    styleInterface.flush();
  }
} // Exported until we deprecate this API completely
// eslint-disable-next-line no-underscore-dangle


function _getInterface() {
  return styleInterface;
} // Exported until we deprecate this API completely


var _default = {
  registerTheme: registerTheme,
  registerInterface: registerInterface,
  create: createLTR,
  createLTR: createLTR,
  createRTL: createRTL,
  get: get,
  resolve: resolveLTR,
  resolveLTR: resolveLTR,
  resolveRTL: resolveRTL,
  flush: flush
};
exports["default"] = _default;
});

unwrapExports(ThemedStyleSheet);
var ThemedStyleSheet_1 = ThemedStyleSheet._getInterface;
var ThemedStyleSheet_2 = ThemedStyleSheet._getTheme;

var withStylesPropTypes_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withStylesPropTypes = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);

var withStylesPropTypes = {
  styles: _propTypes["default"].object.isRequired,
  theme: _propTypes["default"].object.isRequired,
  css: _propTypes["default"].func.isRequired
};
exports.withStylesPropTypes = withStylesPropTypes;
var _default = withStylesPropTypes;
exports["default"] = _default;
});

unwrapExports(withStylesPropTypes_1);
var withStylesPropTypes_2 = withStylesPropTypes_1.withStylesPropTypes;

var withStyles_1 = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStyles = withStyles;
Object.defineProperty(exports, "withStylesPropTypes", {
  enumerable: true,
  get: function get() {
    return withStylesPropTypes_1.withStylesPropTypes;
  }
});
exports.css = exports["default"] = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _react = interopRequireDefault(React__default['default']);

var _hoistNonReactStatics = interopRequireDefault(hoistNonReactStatics_cjs);

var _getComponentName = interopRequireDefault(getComponentName_1);

var _emptyStylesFn = interopRequireDefault(emptyStylesFn);

var _perf = interopRequireDefault(perf);

var _WithStylesContext = interopRequireWildcard(WithStylesContext_1);

var _ThemedStyleSheet = interopRequireWildcard(ThemedStyleSheet);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * A higher order function that returns a higher order class component that injects
 * CSS-in-JS props derived from the react-with-styles theme, interface, and
 * direction provided through the WithStylesContext provider.
 *
 * The function should be used as follows:
 * `withStyles((theme) => styles, options)(Component)`
 *
 * Options can be used to rename the injected props, memoize the component, and flush
 * the styles to the styles tag (or whatever the interface implements as flush) before
 * rendering.
 *
 * @export
 * @param {Function|null|undefined} [stylesFn=EMPTY_STYLES_FN]
 * @param {Object} [{
 *     stylesPropName = 'styles',
 *     themePropName = 'theme',
 *     cssPropName = 'css',
 *     flushBefore = false,
 *     pureComponent = false,
 *   }={}]
 * @returns a higher order component that wraps the provided component and injects
 * the react-with-styles css, styles, and theme props.
 */
function withStyles() {
  var stylesFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emptyStylesFn["default"];

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stylesPropName = _ref.stylesPropName,
      stylesPropName = _ref$stylesPropName === void 0 ? 'styles' : _ref$stylesPropName,
      _ref$themePropName = _ref.themePropName,
      themePropName = _ref$themePropName === void 0 ? 'theme' : _ref$themePropName,
      _ref$cssPropName = _ref.cssPropName,
      cssPropName = _ref$cssPropName === void 0 ? 'css' : _ref$cssPropName,
      _ref$flushBefore = _ref.flushBefore,
      flushBefore = _ref$flushBefore === void 0 ? false : _ref$flushBefore,
      _ref$pureComponent = _ref.pureComponent,
      pureComponent = _ref$pureComponent === void 0 ? false : _ref$pureComponent;

  stylesFn = stylesFn || _emptyStylesFn["default"];
  var BaseClass = pureComponent ? _react["default"].PureComponent : _react["default"].Component;
  /** Cache for storing the result of stylesFn(theme) for all themes. */

  var stylesFnResultCacheMap = typeof WeakMap === 'undefined' ? new Map() : new WeakMap();

  function getOrCreateStylesFnResultCache(theme) {
    // Get and store the result in the stylesFnResultsCache for the component
    // -- not the instance -- so we only apply the theme to the stylesFn
    // once per theme for this component.
    var cachedResultForTheme = stylesFnResultCacheMap.get(theme);
    var stylesFnResult = cachedResultForTheme || stylesFn(theme) || {};
    stylesFnResultCacheMap.set(theme, stylesFnResult); // cache the result of stylesFn(theme)

    return stylesFnResult;
  }
  /**
   * Cache for storing the results of computations:
   * `WeakMap<Theme, WeakMap<typeof WithStyles, { ltr: {}, rtl: {} }>>`
   * Falling back to `Map` whenever `WeakMap` is not supported
   */


  var withStylesCache = typeof WeakMap === 'undefined' ? new Map() : new WeakMap();

  function getComponentCache(theme, component, direction) {
    var themeCache = withStylesCache.get(theme);

    if (!themeCache) {
      return null;
    }

    var componentCache = themeCache.get(component);

    if (!componentCache) {
      return null;
    }

    return componentCache[direction];
  }

  function updateComponentCache(theme, component, direction, results) {
    var themeCache = withStylesCache.get(theme);

    if (!themeCache) {
      themeCache = typeof WeakMap === 'undefined' ? new Map() : new WeakMap();
      withStylesCache.set(theme, themeCache);
    }

    var componentCache = themeCache.get(component);

    if (!componentCache) {
      componentCache = {
        ltr: {},
        rtl: {}
      };
      themeCache.set(component, componentCache);
    }

    componentCache[direction] = results;
  }
  /** Derive the create function from the interface and direction */


  function makeCreateFn(direction, stylesInterface) {
    var directionSelector = direction === _WithStylesContext.DIRECTIONS.RTL ? 'RTL' : 'LTR';
    var create = stylesInterface["create".concat(directionSelector)] || stylesInterface.create;

    if (process.env.NODE_ENV !== 'production') {
      create = (0, _perf["default"])('create')(create);
    }

    return create;
  }
  /** Derive the resolve function from the interface and direction */


  function makeResolveFn(direction, stylesInterface) {
    var directionSelector = direction === _WithStylesContext.DIRECTIONS.RTL ? 'RTL' : 'LTR';
    var resolve = stylesInterface["resolve".concat(directionSelector)] || stylesInterface.resolve;

    if (process.env.NODE_ENV !== 'production') {
      resolve = (0, _perf["default"])('resolve')(resolve);
    }

    return resolve;
  } // The function that wraps the provided component in a wrapper
  // component that injects the withStyles props


  return function withStylesHOC(WrappedComponent) {
    var wrappedComponentName = (0, _getComponentName["default"])(WrappedComponent); // The wrapper component that injects the withStyles props

    var WithStyles =
    /*#__PURE__*/
    function (_BaseClass) {
      (0, _inheritsLoose2["default"])(WithStyles, _BaseClass);

      function WithStyles() {
        return _BaseClass.apply(this, arguments) || this;
      }

      var _proto = WithStyles.prototype;

      _proto.getCurrentInterface = function getCurrentInterface() {
        // Fallback to the singleton implementation
        return this.context && this.context.stylesInterface || (0, _ThemedStyleSheet._getInterface)();
      };

      _proto.getCurrentTheme = function getCurrentTheme() {
        // Fallback to the singleton implementation
        return this.context && this.context.stylesTheme || (0, _ThemedStyleSheet._getTheme)();
      };

      _proto.getCurrentDirection = function getCurrentDirection() {
        return this.context && this.context.direction || _WithStylesContext.DIRECTIONS.LTR;
      };

      _proto.getProps = function getProps() {
        // Get the styles interface, theme, and direction from context
        var stylesInterface = this.getCurrentInterface();
        var theme = this.getCurrentTheme();
        var direction = this.getCurrentDirection(); // Use a cache to store the interface methods and created styles by direction.
        // This way, if the theme and the interface don't change, we do not recalculate
        // styles or any other interface derivations. They are effectively only calculated
        // once per direction, until the theme or interface change.
        // Assume: always an object.

        var componentCache = getComponentCache(theme, WithStyles, direction); // Determine what's changed

        var interfaceChanged = !componentCache || !componentCache.stylesInterface || stylesInterface && componentCache.stylesInterface !== stylesInterface;
        var themeChanged = !componentCache || componentCache.theme !== theme; // If the interface and theme haven't changed for this direction,
        // we return the cached props immediately.

        if (!interfaceChanged && !themeChanged) {
          return componentCache.props;
        } // If the theme or the interface changed, then there are some values
        // we need to recalculate. We avoid recalculating the ones we already
        // calculated in the past if the objects they're derived from have not
        // changed.


        var create = interfaceChanged && makeCreateFn(direction, stylesInterface) || componentCache.create;
        var resolve = interfaceChanged && makeResolveFn(direction, stylesInterface) || componentCache.resolve; // Derive the css function prop

        var css = interfaceChanged && function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return resolve(args);
        } || componentCache.props.css; // Get or calculate the themed styles from the stylesFn:
        // Uses a separate cache at the component level, not at the instance level,
        // to only apply the theme to the stylesFn once per component class per theme.


        var stylesFnResult = getOrCreateStylesFnResultCache(theme); // Derive the styles prop: recalculate it if create changed, or stylesFnResult changed

        var styles = (interfaceChanged || stylesFnResult !== componentCache.stylesFnResult) && create(stylesFnResult) || componentCache.props.styles; // Put the new props together

        var props = {
          css: css,
          styles: styles,
          theme: theme
        }; // Update the cache with all the new values

        updateComponentCache(theme, WithStyles, direction, {
          stylesInterface: stylesInterface,
          theme: theme,
          create: create,
          resolve: resolve,
          stylesFnResult: stylesFnResult,
          props: props
        });
        return props;
      };

      _proto.flush = function flush() {
        var stylesInterface = this.getCurrentInterface();

        if (stylesInterface && stylesInterface.flush) {
          stylesInterface.flush();
        }
      };

      _proto.render = function render() {
        var _ref2;

        // We only want to re-render if the theme, stylesInterface, or direction change.
        // These values are in context so we're listening for their updates.
        // this.getProps() derives the props from the theme, stylesInterface, and direction in
        // context, and memoizes them on the instance per direction.
        var _this$getProps = this.getProps(),
            theme = _this$getProps.theme,
            styles = _this$getProps.styles,
            css = _this$getProps.css; // Flush if specified


        if (flushBefore) {
          this.flush();
        }

        return _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, this.props, (_ref2 = {}, (0, _defineProperty2["default"])(_ref2, themePropName, theme), (0, _defineProperty2["default"])(_ref2, stylesPropName, styles), (0, _defineProperty2["default"])(_ref2, cssPropName, css), _ref2)));
      };

      return WithStyles;
    }(BaseClass); // Copy the wrapped component's prop types and default props on WithStyles


    if (WrappedComponent.propTypes) {
      WithStyles.propTypes = _objectSpread({}, WrappedComponent.propTypes);
      delete WithStyles.propTypes[stylesPropName];
      delete WithStyles.propTypes[themePropName];
      delete WithStyles.propTypes[cssPropName];
    }

    if (WrappedComponent.defaultProps) {
      WithStyles.defaultProps = _objectSpread({}, WrappedComponent.defaultProps);
    }

    WithStyles.contextType = _WithStylesContext["default"];
    WithStyles.WrappedComponent = WrappedComponent;
    WithStyles.displayName = "withStyles(".concat(wrappedComponentName, ")");
    return (0, _hoistNonReactStatics["default"])(WithStyles, WrappedComponent);
  };
}

var _default = withStyles;
/**
 * Deprecated: Do not use directly. Please wrap your component in `withStyles` and use the `css`
 * prop injected via props instead.
 */

exports["default"] = _default;
var css = _ThemedStyleSheet["default"].resolveLTR;
exports.css = css;
});

unwrapExports(withStyles_1);
var withStyles_2 = withStyles_1.withStyles;
var withStyles_3 = withStyles_1.css;

var performanceNow = createCommonjsModule(function (module) {
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(commonjsGlobal);


});

var root$1 = typeof window === 'undefined' ? commonjsGlobal : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root$1['request' + suffix]
  , caf = root$1['cancel' + suffix] || root$1['cancelRequest' + suffix];

for(var i$1 = 0; !raf && i$1 < vendors.length; i$1++) {
  raf = root$1[vendors[i$1] + 'Request' + suffix];
  caf = root$1[vendors[i$1] + 'Cancel' + suffix]
      || root$1[vendors[i$1] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last$1 = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60;

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = performanceNow()
        , next = Math.max(0, frameDuration - (_now - last$1));
      last$1 = next + _now;
      setTimeout(function() {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last$1);
            } catch(e) {
              setTimeout(function() { throw e }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id
  };

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

var raf_1 = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root$1, fn)
};
var cancel = function() {
  caf.apply(root$1, arguments);
};
var polyfill$d = function(object) {
  if (!object) {
    object = root$1;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
raf_1.cancel = cancel;
raf_1.polyfill = polyfill$d;

var defaultPhrases = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarDayPhrases = exports.DayPickerNavigationPhrases = exports.DayPickerKeyboardShortcutsPhrases = exports.DayPickerPhrases = exports.SingleDatePickerInputPhrases = exports.SingleDatePickerPhrases = exports.DateRangePickerInputPhrases = exports.DateRangePickerPhrases = exports["default"] = void 0;
var calendarLabel = 'Calendar';
var roleDescription = 'datepicker';
var closeDatePicker = 'Close';
var focusStartDate = 'Interact with the calendar and add the check-in date for your trip.';
var clearDate = 'Clear Date';
var clearDates = 'Clear Dates';
var jumpToPrevMonth = 'Move backward to switch to the previous month.';
var jumpToNextMonth = 'Move forward to switch to the next month.';
var keyboardShortcuts = 'Keyboard Shortcuts';
var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel.';
var hideKeyboardShortcutsPanel = 'Close the shortcuts panel.';
var openThisPanel = 'Open this panel.';
var enterKey = 'Enter key';
var leftArrowRightArrow = 'Right and left arrow keys';
var upArrowDownArrow = 'up and down arrow keys';
var pageUpPageDown = 'page up and page down keys';
var homeEnd = 'Home and end keys';
var escape = 'Escape key';
var questionMark = 'Question mark';
var selectFocusedDate = 'Select the date in focus.';
var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day.';
var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week.';
var moveFocusByOneMonth = 'Switch months.';
var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week.';
var returnFocusToInput = 'Return to the date input field.';
var keyboardForwardNavigationInstructions = 'Navigate forward to interact with the calendar and select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';
var keyboardBackwardNavigationInstructions = 'Navigate backward to interact with the calendar and select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';

var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
  var date = _ref.date;
  return "Choose ".concat(date, " as your check-in date. It\u2019s available.");
};

var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
  var date = _ref2.date;
  return "Choose ".concat(date, " as your check-out date. It\u2019s available.");
};

var chooseAvailableDate = function chooseAvailableDate(_ref3) {
  var date = _ref3.date;
  return date;
};

var dateIsUnavailable = function dateIsUnavailable(_ref4) {
  var date = _ref4.date;
  return "Not available. ".concat(date);
};

var dateIsSelected = function dateIsSelected(_ref5) {
  var date = _ref5.date;
  return "Selected. ".concat(date);
};

var dateIsSelectedAsStartDate = function dateIsSelectedAsStartDate(_ref6) {
  var date = _ref6.date;
  return "Selected as start date. ".concat(date);
};

var dateIsSelectedAsEndDate = function dateIsSelectedAsEndDate(_ref7) {
  var date = _ref7.date;
  return "Selected as end date. ".concat(date);
};

var _default = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  closeDatePicker: closeDatePicker,
  focusStartDate: focusStartDate,
  clearDate: clearDate,
  clearDates: clearDates,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports["default"] = _default;
var DateRangePickerPhrases = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  closeDatePicker: closeDatePicker,
  clearDates: clearDates,
  focusStartDate: focusStartDate,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports.DateRangePickerPhrases = DateRangePickerPhrases;
var DateRangePickerInputPhrases = {
  focusStartDate: focusStartDate,
  clearDates: clearDates,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions
};
exports.DateRangePickerInputPhrases = DateRangePickerInputPhrases;
var SingleDatePickerPhrases = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  closeDatePicker: closeDatePicker,
  clearDate: clearDate,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions,
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected
};
exports.SingleDatePickerPhrases = SingleDatePickerPhrases;
var SingleDatePickerInputPhrases = {
  clearDate: clearDate,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions
};
exports.SingleDatePickerInputPhrases = SingleDatePickerInputPhrases;
var DayPickerPhrases = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports.DayPickerPhrases = DayPickerPhrases;
var DayPickerKeyboardShortcutsPhrases = {
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput
};
exports.DayPickerKeyboardShortcutsPhrases = DayPickerKeyboardShortcutsPhrases;
var DayPickerNavigationPhrases = {
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth
};
exports.DayPickerNavigationPhrases = DayPickerNavigationPhrases;
var CalendarDayPhrases = {
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports.CalendarDayPhrases = CalendarDayPhrases;
});

unwrapExports(defaultPhrases);
var defaultPhrases_1 = defaultPhrases.CalendarDayPhrases;
var defaultPhrases_2 = defaultPhrases.DayPickerNavigationPhrases;
var defaultPhrases_3 = defaultPhrases.DayPickerKeyboardShortcutsPhrases;
var defaultPhrases_4 = defaultPhrases.DayPickerPhrases;
var defaultPhrases_5 = defaultPhrases.SingleDatePickerInputPhrases;
var defaultPhrases_6 = defaultPhrases.SingleDatePickerPhrases;
var defaultPhrases_7 = defaultPhrases.DateRangePickerInputPhrases;
var defaultPhrases_8 = defaultPhrases.DateRangePickerPhrases;

var getPhrasePropTypes_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPhrasePropTypes;

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _propTypes = interopRequireDefault(PropTypes__default['default']);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getPhrasePropTypes(defaultPhrases) {
  return Object.keys(defaultPhrases).reduce(function (phrases, key) {
    return _objectSpread({}, phrases, (0, _defineProperty2["default"])({}, key, _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node])));
  }, {});
}
});

unwrapExports(getPhrasePropTypes_1);

var getPhrase_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPhrase;

function getPhrase(phrase, args) {
  if (typeof phrase === 'string') return phrase;

  if (typeof phrase === 'function') {
    return phrase(args);
  }

  return '';
}
});

unwrapExports(getPhrase_1);

var constants$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODIFIER_KEY_NAMES = exports.DEFAULT_VERTICAL_SPACING = exports.FANG_HEIGHT_PX = exports.FANG_WIDTH_PX = exports.WEEKDAYS = exports.BLOCKED_MODIFIER = exports.DAY_SIZE = exports.OPEN_UP = exports.OPEN_DOWN = exports.ANCHOR_RIGHT = exports.ANCHOR_LEFT = exports.INFO_POSITION_AFTER = exports.INFO_POSITION_BEFORE = exports.INFO_POSITION_BOTTOM = exports.INFO_POSITION_TOP = exports.ICON_AFTER_POSITION = exports.ICON_BEFORE_POSITION = exports.NAV_POSITION_TOP = exports.NAV_POSITION_BOTTOM = exports.VERTICAL_SCROLLABLE = exports.VERTICAL_ORIENTATION = exports.HORIZONTAL_ORIENTATION = exports.END_DATE = exports.START_DATE = exports.ISO_MONTH_FORMAT = exports.ISO_FORMAT = exports.DISPLAY_FORMAT = void 0;
var DISPLAY_FORMAT = 'L';
exports.DISPLAY_FORMAT = DISPLAY_FORMAT;
var ISO_FORMAT = 'YYYY-MM-DD';
exports.ISO_FORMAT = ISO_FORMAT;
var ISO_MONTH_FORMAT = 'YYYY-MM'; // TODO delete this line of dead code on next breaking change

exports.ISO_MONTH_FORMAT = ISO_MONTH_FORMAT;
var START_DATE = 'startDate';
exports.START_DATE = START_DATE;
var END_DATE = 'endDate';
exports.END_DATE = END_DATE;
var HORIZONTAL_ORIENTATION = 'horizontal';
exports.HORIZONTAL_ORIENTATION = HORIZONTAL_ORIENTATION;
var VERTICAL_ORIENTATION = 'vertical';
exports.VERTICAL_ORIENTATION = VERTICAL_ORIENTATION;
var VERTICAL_SCROLLABLE = 'verticalScrollable';
exports.VERTICAL_SCROLLABLE = VERTICAL_SCROLLABLE;
var NAV_POSITION_BOTTOM = 'navPositionBottom';
exports.NAV_POSITION_BOTTOM = NAV_POSITION_BOTTOM;
var NAV_POSITION_TOP = 'navPositionTop';
exports.NAV_POSITION_TOP = NAV_POSITION_TOP;
var ICON_BEFORE_POSITION = 'before';
exports.ICON_BEFORE_POSITION = ICON_BEFORE_POSITION;
var ICON_AFTER_POSITION = 'after';
exports.ICON_AFTER_POSITION = ICON_AFTER_POSITION;
var INFO_POSITION_TOP = 'top';
exports.INFO_POSITION_TOP = INFO_POSITION_TOP;
var INFO_POSITION_BOTTOM = 'bottom';
exports.INFO_POSITION_BOTTOM = INFO_POSITION_BOTTOM;
var INFO_POSITION_BEFORE = 'before';
exports.INFO_POSITION_BEFORE = INFO_POSITION_BEFORE;
var INFO_POSITION_AFTER = 'after';
exports.INFO_POSITION_AFTER = INFO_POSITION_AFTER;
var ANCHOR_LEFT = 'left';
exports.ANCHOR_LEFT = ANCHOR_LEFT;
var ANCHOR_RIGHT = 'right';
exports.ANCHOR_RIGHT = ANCHOR_RIGHT;
var OPEN_DOWN = 'down';
exports.OPEN_DOWN = OPEN_DOWN;
var OPEN_UP = 'up';
exports.OPEN_UP = OPEN_UP;
var DAY_SIZE = 39;
exports.DAY_SIZE = DAY_SIZE;
var BLOCKED_MODIFIER = 'blocked';
exports.BLOCKED_MODIFIER = BLOCKED_MODIFIER;
var WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
exports.WEEKDAYS = WEEKDAYS;
var FANG_WIDTH_PX = 20;
exports.FANG_WIDTH_PX = FANG_WIDTH_PX;
var FANG_HEIGHT_PX = 10;
exports.FANG_HEIGHT_PX = FANG_HEIGHT_PX;
var DEFAULT_VERTICAL_SPACING = 22;
exports.DEFAULT_VERTICAL_SPACING = DEFAULT_VERTICAL_SPACING;
var MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);
exports.MODIFIER_KEY_NAMES = MODIFIER_KEY_NAMES;
});

unwrapExports(constants$1);
var constants_1$1 = constants$1.MODIFIER_KEY_NAMES;
var constants_2$1 = constants$1.DEFAULT_VERTICAL_SPACING;
var constants_3 = constants$1.FANG_HEIGHT_PX;
var constants_4 = constants$1.FANG_WIDTH_PX;
var constants_5 = constants$1.WEEKDAYS;
var constants_6 = constants$1.BLOCKED_MODIFIER;
var constants_7 = constants$1.DAY_SIZE;
var constants_8 = constants$1.OPEN_UP;
var constants_9 = constants$1.OPEN_DOWN;
var constants_10 = constants$1.ANCHOR_RIGHT;
var constants_11 = constants$1.ANCHOR_LEFT;
var constants_12 = constants$1.INFO_POSITION_AFTER;
var constants_13 = constants$1.INFO_POSITION_BEFORE;
var constants_14 = constants$1.INFO_POSITION_BOTTOM;
var constants_15 = constants$1.INFO_POSITION_TOP;
var constants_16 = constants$1.ICON_AFTER_POSITION;
var constants_17 = constants$1.ICON_BEFORE_POSITION;
var constants_18 = constants$1.NAV_POSITION_TOP;
var constants_19 = constants$1.NAV_POSITION_BOTTOM;
var constants_20 = constants$1.VERTICAL_SCROLLABLE;
var constants_21 = constants$1.VERTICAL_ORIENTATION;
var constants_22 = constants$1.HORIZONTAL_ORIENTATION;
var constants_23 = constants$1.END_DATE;
var constants_24 = constants$1.START_DATE;
var constants_25 = constants$1.ISO_MONTH_FORMAT;
var constants_26 = constants$1.ISO_FORMAT;
var constants_27 = constants$1.DISPLAY_FORMAT;

var getCalendarDaySettings_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarDaySettings;

var _getPhrase = interopRequireDefault(getPhrase_1);



function isSelected(modifiers) {
  return modifiers.has('selected') || modifiers.has('selected-span') || modifiers.has('selected-start') || modifiers.has('selected-end');
}

function shouldUseDefaultCursor(modifiers) {
  return modifiers.has('blocked-minimum-nights') || modifiers.has('blocked-calendar') || modifiers.has('blocked-out-of-range');
}

function isHoveredSpan(modifiers) {
  if (isSelected(modifiers)) return false;
  return modifiers.has('hovered-span') || modifiers.has('after-hovered-start') || modifiers.has('before-hovered-end');
}

function getAriaLabel(phrases, modifiers, day, ariaLabelFormat) {
  var chooseAvailableDate = phrases.chooseAvailableDate,
      dateIsUnavailable = phrases.dateIsUnavailable,
      dateIsSelected = phrases.dateIsSelected,
      dateIsSelectedAsStartDate = phrases.dateIsSelectedAsStartDate,
      dateIsSelectedAsEndDate = phrases.dateIsSelectedAsEndDate;
  var formattedDate = {
    date: day.format(ariaLabelFormat)
  };

  if (modifiers.has('selected-start') && dateIsSelectedAsStartDate) {
    return (0, _getPhrase["default"])(dateIsSelectedAsStartDate, formattedDate);
  }

  if (modifiers.has('selected-end') && dateIsSelectedAsEndDate) {
    return (0, _getPhrase["default"])(dateIsSelectedAsEndDate, formattedDate);
  }

  if (isSelected(modifiers) && dateIsSelected) {
    return (0, _getPhrase["default"])(dateIsSelected, formattedDate);
  }

  if (modifiers.has(constants$1.BLOCKED_MODIFIER)) {
    return (0, _getPhrase["default"])(dateIsUnavailable, formattedDate);
  }

  return (0, _getPhrase["default"])(chooseAvailableDate, formattedDate);
}

function getCalendarDaySettings(day, ariaLabelFormat, daySize, modifiers, phrases) {
  return {
    ariaLabel: getAriaLabel(phrases, modifiers, day, ariaLabelFormat),
    hoveredSpan: isHoveredSpan(modifiers),
    isOutsideRange: modifiers.has('blocked-out-of-range'),
    selected: isSelected(modifiers),
    useDefaultCursor: shouldUseDefaultCursor(modifiers),
    daySizeStyles: {
      width: daySize,
      height: daySize - 1
    }
  };
}
});

unwrapExports(getCalendarDaySettings_1);

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var arrayLikeToArray = _arrayLikeToArray$1;

function _arrayWithoutHoles$m(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

var arrayWithoutHoles = _arrayWithoutHoles$m;

function _iterableToArray$m(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

var iterableToArray = _iterableToArray$m;

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

var unsupportedIterableToArray = _unsupportedIterableToArray$1;

function _nonIterableSpread$m() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableSpread = _nonIterableSpread$m;

function _toConsumableArray$m(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray$m;

var ModifiersShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _toConsumableArray2 = interopRequireDefault(toConsumableArray);

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = (0, airbnbPropTypes.and)([_propTypes["default"].instanceOf(Set), function modifiers(props, propName) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  var propValue = props[propName];
  var firstError;
  (0, _toConsumableArray2["default"])(propValue).some(function (v, i) {
    var _PropTypes$string;

    var fakePropName = "".concat(propName, ": index ").concat(i);
    firstError = (_PropTypes$string = _propTypes["default"].string).isRequired.apply(_PropTypes$string, [(0, _defineProperty2["default"])({}, fakePropName, v), fakePropName].concat(rest));
    return firstError != null;
  });
  return firstError == null ? null : firstError;
}], 'Modifiers (Set of Strings)');

exports["default"] = _default;
});

unwrapExports(ModifiersShape);

var CalendarDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureCalendarDay = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);

var _reactMomentProptypes = interopRequireDefault(src$1);





var _moment = interopRequireDefault(hooks);

var _raf = interopRequireDefault(raf_1);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _getCalendarDaySettings = interopRequireDefault(getCalendarDaySettings_1);

var _ModifiersShape = interopRequireDefault(ModifiersShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  day: _reactMomentProptypes["default"].momentObj,
  daySize: airbnbPropTypes.nonNegativeInteger,
  isOutsideDay: _propTypes["default"].bool,
  modifiers: _ModifiersShape["default"],
  isFocused: _propTypes["default"].bool,
  tabIndex: _propTypes["default"].oneOf([0, -1]),
  onDayClick: _propTypes["default"].func,
  onDayMouseEnter: _propTypes["default"].func,
  onDayMouseLeave: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  ariaLabelFormat: _propTypes["default"].string,
  // internationalization
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.CalendarDayPhrases))
})) : {};
var defaultProps = {
  day: (0, _moment["default"])(),
  daySize: constants$1.DAY_SIZE,
  isOutsideDay: false,
  modifiers: new Set(),
  isFocused: false,
  tabIndex: -1,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  renderDayContents: null,
  ariaLabelFormat: 'dddd, LL',
  // internationalization
  phrases: defaultPhrases.CalendarDayPhrases
};

var CalendarDay =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(CalendarDay, _ref);
  var _proto = CalendarDay.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function CalendarDay() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _ref.call.apply(_ref, [this].concat(args)) || this;
    _this.setButtonRef = _this.setButtonRef.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var _this$props = this.props,
        isFocused = _this$props.isFocused,
        tabIndex = _this$props.tabIndex;

    if (tabIndex === 0) {
      if (isFocused || tabIndex !== prevProps.tabIndex) {
        (0, _raf["default"])(function () {
          if (_this2.buttonRef) {
            _this2.buttonRef.focus();
          }
        });
      }
    }
  };

  _proto.onDayClick = function onDayClick(day, e) {
    var onDayClick = this.props.onDayClick;
    onDayClick(day, e);
  };

  _proto.onDayMouseEnter = function onDayMouseEnter(day, e) {
    var onDayMouseEnter = this.props.onDayMouseEnter;
    onDayMouseEnter(day, e);
  };

  _proto.onDayMouseLeave = function onDayMouseLeave(day, e) {
    var onDayMouseLeave = this.props.onDayMouseLeave;
    onDayMouseLeave(day, e);
  };

  _proto.onKeyDown = function onKeyDown(day, e) {
    var onDayClick = this.props.onDayClick;
    var key = e.key;

    if (key === 'Enter' || key === ' ') {
      onDayClick(day, e);
    }
  };

  _proto.setButtonRef = function setButtonRef(ref) {
    this.buttonRef = ref;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props2 = this.props,
        day = _this$props2.day,
        ariaLabelFormat = _this$props2.ariaLabelFormat,
        daySize = _this$props2.daySize,
        isOutsideDay = _this$props2.isOutsideDay,
        modifiers = _this$props2.modifiers,
        renderDayContents = _this$props2.renderDayContents,
        tabIndex = _this$props2.tabIndex,
        styles = _this$props2.styles,
        phrases = _this$props2.phrases;
    if (!day) return _react["default"].createElement("td", null);

    var _getCalendarDaySettin = (0, _getCalendarDaySettings["default"])(day, ariaLabelFormat, daySize, modifiers, phrases),
        daySizeStyles = _getCalendarDaySettin.daySizeStyles,
        useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
        selected = _getCalendarDaySettin.selected,
        hoveredSpan = _getCalendarDaySettin.hoveredSpan,
        isOutsideRange = _getCalendarDaySettin.isOutsideRange,
        ariaLabel = _getCalendarDaySettin.ariaLabel;

    return _react["default"].createElement("td", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, styles.CalendarDay__default, isOutsideDay && styles.CalendarDay__outside, modifiers.has('today') && styles.CalendarDay__today, modifiers.has('first-day-of-week') && styles.CalendarDay__firstDayOfWeek, modifiers.has('last-day-of-week') && styles.CalendarDay__lastDayOfWeek, modifiers.has('hovered-offset') && styles.CalendarDay__hovered_offset, modifiers.has('hovered-start-first-possible-end') && styles.CalendarDay__hovered_start_first_possible_end, modifiers.has('hovered-start-blocked-minimum-nights') && styles.CalendarDay__hovered_start_blocked_min_nights, modifiers.has('highlighted-calendar') && styles.CalendarDay__highlighted_calendar, modifiers.has('blocked-minimum-nights') && styles.CalendarDay__blocked_minimum_nights, modifiers.has('blocked-calendar') && styles.CalendarDay__blocked_calendar, hoveredSpan && styles.CalendarDay__hovered_span, modifiers.has('after-hovered-start') && styles.CalendarDay__after_hovered_start, modifiers.has('selected-span') && styles.CalendarDay__selected_span, modifiers.has('selected-start') && styles.CalendarDay__selected_start, modifiers.has('selected-end') && styles.CalendarDay__selected_end, selected && !modifiers.has('selected-span') && styles.CalendarDay__selected, modifiers.has('before-hovered-end') && styles.CalendarDay__before_hovered_end, modifiers.has('no-selected-start-before-selected-end') && styles.CalendarDay__no_selected_start_before_selected_end, modifiers.has('selected-start-in-hovered-span') && styles.CalendarDay__selected_start_in_hovered_span, modifiers.has('selected-end-in-hovered-span') && styles.CalendarDay__selected_end_in_hovered_span, modifiers.has('selected-start-no-selected-end') && styles.CalendarDay__selected_start_no_selected_end, modifiers.has('selected-end-no-selected-start') && styles.CalendarDay__selected_end_no_selected_start, isOutsideRange && styles.CalendarDay__blocked_out_of_range, daySizeStyles), {
      role: "button" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
      ,
      ref: this.setButtonRef,
      "aria-disabled": modifiers.has('blocked'),
      "aria-label": ariaLabel,
      onMouseEnter: function onMouseEnter(e) {
        _this3.onDayMouseEnter(day, e);
      },
      onMouseLeave: function onMouseLeave(e) {
        _this3.onDayMouseLeave(day, e);
      },
      onMouseUp: function onMouseUp(e) {
        e.currentTarget.blur();
      },
      onClick: function onClick(e) {
        _this3.onDayClick(day, e);
      },
      onKeyDown: function onKeyDown(e) {
        _this3.onKeyDown(day, e);
      },
      tabIndex: tabIndex
    }), renderDayContents ? renderDayContents(day, modifiers) : day.format('D'));
  };

  return CalendarDay;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureCalendarDay = CalendarDay;
CalendarDay.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
CalendarDay.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      font = _ref2$reactDates.font;
  return {
    CalendarDay: {
      boxSizing: 'border-box',
      cursor: 'pointer',
      fontSize: font.size,
      textAlign: 'center',
      ':active': {
        outline: 0
      }
    },
    CalendarDay__defaultCursor: {
      cursor: 'default'
    },
    CalendarDay__default: {
      border: "1px solid ".concat(color.core.borderLight),
      color: color.text,
      background: color.background,
      ':hover': {
        background: color.core.borderLight,
        border: "1px solid ".concat(color.core.borderLight),
        color: 'inherit'
      }
    },
    CalendarDay__hovered_offset: {
      background: color.core.borderBright,
      border: "1px double ".concat(color.core.borderLight),
      color: 'inherit'
    },
    CalendarDay__outside: {
      border: 0,
      background: color.outside.backgroundColor,
      color: color.outside.color,
      ':hover': {
        border: 0
      }
    },
    CalendarDay__blocked_minimum_nights: {
      background: color.minimumNights.backgroundColor,
      border: "1px solid ".concat(color.minimumNights.borderColor),
      color: color.minimumNights.color,
      ':hover': {
        background: color.minimumNights.backgroundColor_hover,
        color: color.minimumNights.color_active
      },
      ':active': {
        background: color.minimumNights.backgroundColor_active,
        color: color.minimumNights.color_active
      }
    },
    CalendarDay__highlighted_calendar: {
      background: color.highlighted.backgroundColor,
      color: color.highlighted.color,
      ':hover': {
        background: color.highlighted.backgroundColor_hover,
        color: color.highlighted.color_active
      },
      ':active': {
        background: color.highlighted.backgroundColor_active,
        color: color.highlighted.color_active
      }
    },
    CalendarDay__selected_span: {
      background: color.selectedSpan.backgroundColor,
      border: "1px double ".concat(color.selectedSpan.borderColor),
      color: color.selectedSpan.color,
      ':hover': {
        background: color.selectedSpan.backgroundColor_hover,
        border: "1px double ".concat(color.selectedSpan.borderColor),
        color: color.selectedSpan.color_active
      },
      ':active': {
        background: color.selectedSpan.backgroundColor_active,
        border: "1px double ".concat(color.selectedSpan.borderColor),
        color: color.selectedSpan.color_active
      }
    },
    CalendarDay__selected: {
      background: color.selected.backgroundColor,
      border: "1px double ".concat(color.selected.borderColor),
      color: color.selected.color,
      ':hover': {
        background: color.selected.backgroundColor_hover,
        border: "1px double ".concat(color.selected.borderColor),
        color: color.selected.color_active
      },
      ':active': {
        background: color.selected.backgroundColor_active,
        border: "1px double ".concat(color.selected.borderColor),
        color: color.selected.color_active
      }
    },
    CalendarDay__hovered_span: {
      background: color.hoveredSpan.backgroundColor,
      border: "1px double ".concat(color.hoveredSpan.borderColor),
      color: color.hoveredSpan.color,
      ':hover': {
        background: color.hoveredSpan.backgroundColor_hover,
        border: "1px double ".concat(color.hoveredSpan.borderColor),
        color: color.hoveredSpan.color_active
      },
      ':active': {
        background: color.hoveredSpan.backgroundColor_active,
        border: "1px double ".concat(color.hoveredSpan.borderColor),
        color: color.hoveredSpan.color_active
      }
    },
    CalendarDay__blocked_calendar: {
      background: color.blocked_calendar.backgroundColor,
      border: "1px solid ".concat(color.blocked_calendar.borderColor),
      color: color.blocked_calendar.color,
      ':hover': {
        background: color.blocked_calendar.backgroundColor_hover,
        border: "1px solid ".concat(color.blocked_calendar.borderColor),
        color: color.blocked_calendar.color_active
      },
      ':active': {
        background: color.blocked_calendar.backgroundColor_active,
        border: "1px solid ".concat(color.blocked_calendar.borderColor),
        color: color.blocked_calendar.color_active
      }
    },
    CalendarDay__blocked_out_of_range: {
      background: color.blocked_out_of_range.backgroundColor,
      border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
      color: color.blocked_out_of_range.color,
      ':hover': {
        background: color.blocked_out_of_range.backgroundColor_hover,
        border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
        color: color.blocked_out_of_range.color_active
      },
      ':active': {
        background: color.blocked_out_of_range.backgroundColor_active,
        border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
        color: color.blocked_out_of_range.color_active
      }
    },
    CalendarDay__hovered_start_first_possible_end: {
      background: color.core.borderLighter,
      border: "1px double ".concat(color.core.borderLighter)
    },
    CalendarDay__hovered_start_blocked_min_nights: {
      background: color.core.borderLighter,
      border: "1px double ".concat(color.core.borderLight)
    },
    CalendarDay__selected_start: {},
    CalendarDay__selected_end: {},
    CalendarDay__today: {},
    CalendarDay__firstDayOfWeek: {},
    CalendarDay__lastDayOfWeek: {},
    CalendarDay__after_hovered_start: {},
    CalendarDay__before_hovered_end: {},
    CalendarDay__no_selected_start_before_selected_end: {},
    CalendarDay__selected_start_in_hovered_span: {},
    CalendarDay__selected_end_in_hovered_span: {},
    CalendarDay__selected_start_no_selected_end: {},
    CalendarDay__selected_end_no_selected_start: {}
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(CalendarDay);

exports["default"] = _default;
});

unwrapExports(CalendarDay_1);
var CalendarDay_2 = CalendarDay_1.PureCalendarDay;

var CalendarWeek_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CalendarWeek;

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
  children: _propTypes["default"].node.isRequired
}) : {};

function CalendarWeek(_ref) {
  var children = _ref.children;
  return _react["default"].createElement("tr", null, children);
}

CalendarWeek.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
});

unwrapExports(CalendarWeek_1);

var calculateDimension_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateDimension;

function calculateDimension(el, axis) {
  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!el) {
    return 0;
  }

  var axisStart = axis === 'width' ? 'Left' : 'Top';
  var axisEnd = axis === 'width' ? 'Right' : 'Bottom'; // Only read styles if we need to

  var style = !borderBox || withMargin ? window.getComputedStyle(el) : null; // Offset includes border and padding

  var offsetWidth = el.offsetWidth,
      offsetHeight = el.offsetHeight;
  var size = axis === 'width' ? offsetWidth : offsetHeight; // Get the inner size

  if (!borderBox) {
    size -= parseFloat(style["padding".concat(axisStart)]) + parseFloat(style["padding".concat(axisEnd)]) + parseFloat(style["border".concat(axisStart, "Width")]) + parseFloat(style["border".concat(axisEnd, "Width")]);
  } // Apply margin


  if (withMargin) {
    size += parseFloat(style["margin".concat(axisStart)]) + parseFloat(style["margin".concat(axisEnd)]);
  }

  return size;
}
});

unwrapExports(calculateDimension_1);

var getCalendarMonthWeeks_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarMonthWeeks;

var _moment = interopRequireDefault(hooks);



function getCalendarMonthWeeks(month, enableOutsideDays) {
  var firstDayOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _moment["default"].localeData().firstDayOfWeek();

  if (!_moment["default"].isMoment(month) || !month.isValid()) {
    throw new TypeError('`month` must be a valid moment object');
  }

  if (constants$1.WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
    throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
  } // set utc offset to get correct dates in future (when timezone changes)


  var firstOfMonth = month.clone().startOf('month').hour(12);
  var lastOfMonth = month.clone().endOf('month').hour(12); // calculate the exact first and last days to fill the entire matrix
  // (considering days outside month)

  var prevDays = (firstOfMonth.day() + 7 - firstDayOfWeek) % 7;
  var nextDays = (firstDayOfWeek + 6 - lastOfMonth.day()) % 7;
  var firstDay = firstOfMonth.clone().subtract(prevDays, 'day');
  var lastDay = lastOfMonth.clone().add(nextDays, 'day');
  var totalDays = lastDay.diff(firstDay, 'days') + 1;
  var currentDay = firstDay.clone();
  var weeksInMonth = [];

  for (var i = 0; i < totalDays; i += 1) {
    if (i % 7 === 0) {
      weeksInMonth.push([]);
    }

    var day = null;

    if (i >= prevDays && i < totalDays - nextDays || enableOutsideDays) {
      day = currentDay.clone();
    }

    weeksInMonth[weeksInMonth.length - 1].push(day);
    currentDay.add(1, 'day');
  }

  return weeksInMonth;
}
});

unwrapExports(getCalendarMonthWeeks_1);

var isSameDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isSameDay;

var _moment = interopRequireDefault(hooks);

function isSameDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false; // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow

  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
}
});

unwrapExports(isSameDay_1);

var toMomentObject_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toMomentObject;

var _moment = interopRequireDefault(hooks);



function toMomentObject(dateString, customFormat) {
  var dateFormats = customFormat ? [customFormat, constants$1.DISPLAY_FORMAT, constants$1.ISO_FORMAT] : [constants$1.DISPLAY_FORMAT, constants$1.ISO_FORMAT];
  var date = (0, _moment["default"])(dateString, dateFormats, true);
  return date.isValid() ? date.hour(12) : null;
}
});

unwrapExports(toMomentObject_1);

var toISODateString_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toISODateString;

var _moment = interopRequireDefault(hooks);

var _toMomentObject = interopRequireDefault(toMomentObject_1);

function toISODateString(date, currentFormat) {
  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
  if (!dateObj) return null; // Template strings compiled in strict mode uses concat, which is slow. Since
  // this code is in a hot path and we want it to be as fast as possible, we
  // want to use old-fashioned +.
  // eslint-disable-next-line prefer-template

  return dateObj.year() + '-' + String(dateObj.month() + 1).padStart(2, '0') + '-' + String(dateObj.date()).padStart(2, '0');
}
});

unwrapExports(toISODateString_1);

var ScrollableOrientationShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = _propTypes["default"].oneOf([constants$1.HORIZONTAL_ORIENTATION, constants$1.VERTICAL_ORIENTATION, constants$1.VERTICAL_SCROLLABLE]);

exports["default"] = _default;
});

unwrapExports(ScrollableOrientationShape);

var DayOfWeekShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = _propTypes["default"].oneOf(constants$1.WEEKDAYS);

exports["default"] = _default;
});

unwrapExports(DayOfWeekShape);

var CalendarMonth_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);

var _reactMomentProptypes = interopRequireDefault(src$1);





var _moment = interopRequireDefault(hooks);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _CalendarWeek = interopRequireDefault(CalendarWeek_1);

var _CalendarDay = interopRequireDefault(CalendarDay_1);

var _calculateDimension = interopRequireDefault(calculateDimension_1);

var _getCalendarMonthWeeks = interopRequireDefault(getCalendarMonthWeeks_1);

var _isSameDay = interopRequireDefault(isSameDay_1);

var _toISODateString = interopRequireDefault(toISODateString_1);

var _ModifiersShape = interopRequireDefault(ModifiersShape);

var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  month: _reactMomentProptypes["default"].momentObj,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  isVisible: _propTypes["default"].bool,
  enableOutsideDays: _propTypes["default"].bool,
  modifiers: _propTypes["default"].objectOf(_ModifiersShape["default"]),
  orientation: _ScrollableOrientationShape["default"],
  daySize: airbnbPropTypes.nonNegativeInteger,
  onDayClick: _propTypes["default"].func,
  onDayMouseEnter: _propTypes["default"].func,
  onDayMouseLeave: _propTypes["default"].func,
  onMonthSelect: _propTypes["default"].func,
  onYearSelect: _propTypes["default"].func,
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  firstDayOfWeek: _DayOfWeekShape["default"],
  setMonthTitleHeight: _propTypes["default"].func,
  verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
  focusedDate: _reactMomentProptypes["default"].momentObj,
  // indicates focusable day
  isFocused: _propTypes["default"].bool,
  // indicates whether or not to move focus to focusable day
  // i18n
  monthFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.CalendarDayPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string
})) : {};
var defaultProps = {
  month: (0, _moment["default"])(),
  horizontalMonthPadding: 13,
  isVisible: true,
  enableOutsideDays: false,
  modifiers: {},
  orientation: constants$1.HORIZONTAL_ORIENTATION,
  daySize: constants$1.DAY_SIZE,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  onMonthSelect: function onMonthSelect() {},
  onYearSelect: function onYearSelect() {},
  renderMonthText: null,
  renderCalendarDay: function renderCalendarDay(props) {
    return _react["default"].createElement(_CalendarDay["default"], props);
  },
  renderDayContents: null,
  renderMonthElement: null,
  firstDayOfWeek: null,
  setMonthTitleHeight: null,
  focusedDate: null,
  isFocused: false,
  // i18n
  monthFormat: 'MMMM YYYY',
  // english locale
  phrases: defaultPhrases.CalendarDayPhrases,
  dayAriaLabelFormat: undefined,
  verticalBorderSpacing: undefined
};

var CalendarMonth =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(CalendarMonth, _ref);
  var _proto = CalendarMonth.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function CalendarMonth(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.state = {
      weeks: (0, _getCalendarMonthWeeks["default"])(props.month, props.enableOutsideDays, props.firstDayOfWeek == null ? _moment["default"].localeData().firstDayOfWeek() : props.firstDayOfWeek)
    };
    _this.setCaptionRef = _this.setCaptionRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setMonthTitleHeight = _this.setMonthTitleHeight.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.setMonthTitleHeightTimeout = setTimeout(this.setMonthTitleHeight, 0);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var month = nextProps.month,
        enableOutsideDays = nextProps.enableOutsideDays,
        firstDayOfWeek = nextProps.firstDayOfWeek;
    var _this$props = this.props,
        prevMonth = _this$props.month,
        prevEnableOutsideDays = _this$props.enableOutsideDays,
        prevFirstDayOfWeek = _this$props.firstDayOfWeek;

    if (!month.isSame(prevMonth) || enableOutsideDays !== prevEnableOutsideDays || firstDayOfWeek !== prevFirstDayOfWeek) {
      this.setState({
        weeks: (0, _getCalendarMonthWeeks["default"])(month, enableOutsideDays, firstDayOfWeek == null ? _moment["default"].localeData().firstDayOfWeek() : firstDayOfWeek)
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.setMonthTitleHeightTimeout) {
      clearTimeout(this.setMonthTitleHeightTimeout);
    }
  };

  _proto.setMonthTitleHeight = function setMonthTitleHeight() {
    var setMonthTitleHeight = this.props.setMonthTitleHeight;

    if (setMonthTitleHeight) {
      var captionHeight = (0, _calculateDimension["default"])(this.captionRef, 'height', true, true);
      setMonthTitleHeight(captionHeight);
    }
  };

  _proto.setCaptionRef = function setCaptionRef(ref) {
    this.captionRef = ref;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        dayAriaLabelFormat = _this$props2.dayAriaLabelFormat,
        daySize = _this$props2.daySize,
        focusedDate = _this$props2.focusedDate,
        horizontalMonthPadding = _this$props2.horizontalMonthPadding,
        isFocused = _this$props2.isFocused,
        isVisible = _this$props2.isVisible,
        modifiers = _this$props2.modifiers,
        month = _this$props2.month,
        monthFormat = _this$props2.monthFormat,
        onDayClick = _this$props2.onDayClick,
        onDayMouseEnter = _this$props2.onDayMouseEnter,
        onDayMouseLeave = _this$props2.onDayMouseLeave,
        onMonthSelect = _this$props2.onMonthSelect,
        onYearSelect = _this$props2.onYearSelect,
        orientation = _this$props2.orientation,
        phrases = _this$props2.phrases,
        renderCalendarDay = _this$props2.renderCalendarDay,
        renderDayContents = _this$props2.renderDayContents,
        renderMonthElement = _this$props2.renderMonthElement,
        renderMonthText = _this$props2.renderMonthText,
        styles = _this$props2.styles,
        verticalBorderSpacing = _this$props2.verticalBorderSpacing;
    var weeks = this.state.weeks;
    var monthTitle = renderMonthText ? renderMonthText(month) : month.format(monthFormat);
    var verticalScrollable = orientation === constants$1.VERTICAL_SCROLLABLE;
    return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.CalendarMonth, {
      padding: "0 ".concat(horizontalMonthPadding, "px")
    }), {
      "data-visible": isVisible
    }), _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setCaptionRef
    }, (0, withStyles_1.css)(styles.CalendarMonth_caption, verticalScrollable && styles.CalendarMonth_caption__verticalScrollable)), renderMonthElement ? renderMonthElement({
      month: month,
      onMonthSelect: onMonthSelect,
      onYearSelect: onYearSelect,
      isVisible: isVisible
    }) : _react["default"].createElement("strong", null, monthTitle)), _react["default"].createElement("table", (0, _extends2["default"])({}, (0, withStyles_1.css)(!verticalBorderSpacing && styles.CalendarMonth_table, verticalBorderSpacing && styles.CalendarMonth_verticalSpacing, verticalBorderSpacing && {
      borderSpacing: "0px ".concat(verticalBorderSpacing, "px")
    }), {
      role: "presentation"
    }), _react["default"].createElement("tbody", null, weeks.map(function (week, i) {
      return _react["default"].createElement(_CalendarWeek["default"], {
        key: i
      }, week.map(function (day, dayOfWeek) {
        return renderCalendarDay({
          key: dayOfWeek,
          day: day,
          daySize: daySize,
          isOutsideDay: !day || day.month() !== month.month(),
          tabIndex: isVisible && (0, _isSameDay["default"])(day, focusedDate) ? 0 : -1,
          isFocused: isFocused,
          onDayMouseEnter: onDayMouseEnter,
          onDayMouseLeave: onDayMouseLeave,
          onDayClick: onDayClick,
          renderDayContents: renderDayContents,
          phrases: phrases,
          modifiers: modifiers[(0, _toISODateString["default"])(day)],
          ariaLabelFormat: dayAriaLabelFormat
        });
      }));
    }))));
  };

  return CalendarMonth;
}(_react["default"].PureComponent || _react["default"].Component);

CalendarMonth.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
CalendarMonth.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      font = _ref2$reactDates.font,
      spacing = _ref2$reactDates.spacing;
  return {
    CalendarMonth: {
      background: color.background,
      textAlign: 'center',
      verticalAlign: 'top',
      userSelect: 'none'
    },
    CalendarMonth_table: {
      borderCollapse: 'collapse',
      borderSpacing: 0
    },
    CalendarMonth_verticalSpacing: {
      borderCollapse: 'separate'
    },
    CalendarMonth_caption: {
      color: color.text,
      fontSize: font.captionSize,
      textAlign: 'center',
      paddingTop: spacing.captionPaddingTop,
      paddingBottom: spacing.captionPaddingBottom,
      captionSide: 'initial'
    },
    CalendarMonth_caption__verticalScrollable: {
      paddingTop: 12,
      paddingBottom: 7
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(CalendarMonth);

exports["default"] = _default;
});

unwrapExports(CalendarMonth_1);

var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this;

    // options has already been normalized at this point.
    var eventHandlers = this.getEventHandlers(eventName, options);

    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);

    var isSubscribed = true;
    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.

          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();
    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

// eslint-disable-next-line import/prefer-default-export
function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

var index_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addEventListener: addEventListener
});

var noflip_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = noflip;
var NOFLIP = '/* @noflip */'; // Appends a noflip comment to a style rule in order to prevent it from being automatically
// flipped in RTL contexts. This should be used only in situations where the style must remain
// unflipped regardless of direction context. See: https://github.com/kentcdodds/rtl-css-js#usage

function noflip(value) {
  if (typeof value === 'number') return "".concat(value, "px ").concat(NOFLIP);
  if (typeof value === 'string') return "".concat(value, " ").concat(NOFLIP);
  throw new TypeError('noflip expects a string or a number');
}
});

unwrapExports(noflip_1);

var isTransitionEndSupported_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isTransitionEndSupported;

function isTransitionEndSupported() {
  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
}
});

unwrapExports(isTransitionEndSupported_1);

var getTransformStyles_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getTransformStyles;

function getTransformStyles(transformValue) {
  return {
    transform: transformValue,
    msTransform: transformValue,
    MozTransform: transformValue,
    WebkitTransform: transformValue
  };
}
});

unwrapExports(getTransformStyles_1);

var getCalendarMonthWidth_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarMonthWidth;

function getCalendarMonthWidth(daySize) {
  var calendarMonthPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return 7 * daySize + 2 * calendarMonthPadding + 1;
}
});

unwrapExports(getCalendarMonthWidth_1);

var toISOMonthString_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toISOMonthString;

var _moment = interopRequireDefault(hooks);

var _toMomentObject = interopRequireDefault(toMomentObject_1);

function toISOMonthString(date, currentFormat) {
  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
  if (!dateObj) return null; // Template strings compiled in strict mode uses concat, which is slow. Since
  // this code is in a hot path and we want it to be as fast as possible, we
  // want to use old-fashioned +.
  // eslint-disable-next-line prefer-template

  return dateObj.year() + '-' + String(dateObj.month() + 1).padStart(2, '0');
}
});

unwrapExports(toISOMonthString_1);

var isSameMonth_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isSameMonth;

var _moment = interopRequireDefault(hooks);

function isSameMonth(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false; // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow

  return a.month() === b.month() && a.year() === b.year();
}
});

unwrapExports(isSameMonth_1);

var isPrevMonth_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPrevMonth;

var _moment = interopRequireDefault(hooks);

var _isSameMonth = interopRequireDefault(isSameMonth_1);

function isPrevMonth(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return (0, _isSameMonth["default"])(a.clone().subtract(1, 'month'), b);
}
});

unwrapExports(isPrevMonth_1);

var isNextMonth_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isNextMonth;

var _moment = interopRequireDefault(hooks);

var _isSameMonth = interopRequireDefault(isSameMonth_1);

function isNextMonth(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return (0, _isSameMonth["default"])(a.clone().add(1, 'month'), b);
}
});

unwrapExports(isNextMonth_1);

var CalendarMonthGrid_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);

var _reactMomentProptypes = interopRequireDefault(src$1);





var _moment = interopRequireDefault(hooks);





var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _noflip = interopRequireDefault(noflip_1);

var _CalendarMonth = interopRequireDefault(CalendarMonth_1);

var _isTransitionEndSupported = interopRequireDefault(isTransitionEndSupported_1);

var _getTransformStyles = interopRequireDefault(getTransformStyles_1);

var _getCalendarMonthWidth = interopRequireDefault(getCalendarMonthWidth_1);

var _toISOMonthString = interopRequireDefault(toISOMonthString_1);

var _isPrevMonth = interopRequireDefault(isPrevMonth_1);

var _isNextMonth = interopRequireDefault(isNextMonth_1);

var _ModifiersShape = interopRequireDefault(ModifiersShape);

var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  enableOutsideDays: _propTypes["default"].bool,
  firstVisibleMonthIndex: _propTypes["default"].number,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  initialMonth: _reactMomentProptypes["default"].momentObj,
  isAnimating: _propTypes["default"].bool,
  numberOfMonths: _propTypes["default"].number,
  modifiers: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_ModifiersShape["default"])),
  orientation: _ScrollableOrientationShape["default"],
  onDayClick: _propTypes["default"].func,
  onDayMouseEnter: _propTypes["default"].func,
  onDayMouseLeave: _propTypes["default"].func,
  onMonthTransitionEnd: _propTypes["default"].func,
  onMonthChange: _propTypes["default"].func,
  onYearChange: _propTypes["default"].func,
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  translationValue: _propTypes["default"].number,
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  daySize: airbnbPropTypes.nonNegativeInteger,
  focusedDate: _reactMomentProptypes["default"].momentObj,
  // indicates focusable day
  isFocused: _propTypes["default"].bool,
  // indicates whether or not to move focus to focusable day
  firstDayOfWeek: _DayOfWeekShape["default"],
  setMonthTitleHeight: _propTypes["default"].func,
  isRTL: _propTypes["default"].bool,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
  // i18n
  monthFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.CalendarDayPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string
})) : {};
var defaultProps = {
  enableOutsideDays: false,
  firstVisibleMonthIndex: 0,
  horizontalMonthPadding: 13,
  initialMonth: (0, _moment["default"])(),
  isAnimating: false,
  numberOfMonths: 1,
  modifiers: {},
  orientation: constants$1.HORIZONTAL_ORIENTATION,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  onMonthChange: function onMonthChange() {},
  onYearChange: function onYearChange() {},
  onMonthTransitionEnd: function onMonthTransitionEnd() {},
  renderMonthText: null,
  renderCalendarDay: undefined,
  renderDayContents: null,
  translationValue: null,
  renderMonthElement: null,
  daySize: constants$1.DAY_SIZE,
  focusedDate: null,
  isFocused: false,
  firstDayOfWeek: null,
  setMonthTitleHeight: null,
  isRTL: false,
  transitionDuration: 200,
  verticalBorderSpacing: undefined,
  // i18n
  monthFormat: 'MMMM YYYY',
  // english locale
  phrases: defaultPhrases.CalendarDayPhrases,
  dayAriaLabelFormat: undefined
};

function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
  var month = initialMonth.clone();
  if (!withoutTransitionMonths) month = month.subtract(1, 'month');
  var months = [];

  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    months.push(month);
    month = month.clone().add(1, 'month');
  }

  return months;
}

var CalendarMonthGrid =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(CalendarMonthGrid, _ref);
  var _proto = CalendarMonthGrid.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function CalendarMonthGrid(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    var withoutTransitionMonths = props.orientation === constants$1.VERTICAL_SCROLLABLE;
    _this.state = {
      months: getMonths(props.initialMonth, props.numberOfMonths, withoutTransitionMonths)
    };
    _this.isTransitionEndSupported = (0, _isTransitionEndSupported["default"])();
    _this.onTransitionEnd = _this.onTransitionEnd.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.locale = _moment["default"].locale();
    _this.onMonthSelect = _this.onMonthSelect.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearSelect = _this.onYearSelect.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.removeEventListener = (0, index_esm.addEventListener)(this.container, 'transitionend', this.onTransitionEnd);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var initialMonth = nextProps.initialMonth,
        numberOfMonths = nextProps.numberOfMonths,
        orientation = nextProps.orientation;
    var months = this.state.months;
    var _this$props = this.props,
        prevInitialMonth = _this$props.initialMonth,
        prevNumberOfMonths = _this$props.numberOfMonths;
    var hasMonthChanged = !prevInitialMonth.isSame(initialMonth, 'month');
    var hasNumberOfMonthsChanged = prevNumberOfMonths !== numberOfMonths;
    var newMonths = months;

    if (hasMonthChanged && !hasNumberOfMonthsChanged) {
      if ((0, _isNextMonth["default"])(prevInitialMonth, initialMonth)) {
        newMonths = months.slice(1);
        newMonths.push(months[months.length - 1].clone().add(1, 'month'));
      } else if ((0, _isPrevMonth["default"])(prevInitialMonth, initialMonth)) {
        newMonths = months.slice(0, months.length - 1);
        newMonths.unshift(months[0].clone().subtract(1, 'month'));
      } else {
        var withoutTransitionMonths = orientation === constants$1.VERTICAL_SCROLLABLE;
        newMonths = getMonths(initialMonth, numberOfMonths, withoutTransitionMonths);
      }
    }

    if (hasNumberOfMonthsChanged) {
      var _withoutTransitionMonths = orientation === constants$1.VERTICAL_SCROLLABLE;

      newMonths = getMonths(initialMonth, numberOfMonths, _withoutTransitionMonths);
    }

    var momentLocale = _moment["default"].locale();

    if (this.locale !== momentLocale) {
      this.locale = momentLocale;
      newMonths = newMonths.map(function (m) {
        return m.locale(_this2.locale);
      });
    }

    this.setState({
      months: newMonths
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props2 = this.props,
        isAnimating = _this$props2.isAnimating,
        transitionDuration = _this$props2.transitionDuration,
        onMonthTransitionEnd = _this$props2.onMonthTransitionEnd; // For IE9, immediately call onMonthTransitionEnd instead of
    // waiting for the animation to complete. Similarly, if transitionDuration
    // is set to 0, also immediately invoke the onMonthTransitionEnd callback

    if ((!this.isTransitionEndSupported || !transitionDuration) && isAnimating) {
      onMonthTransitionEnd();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.removeEventListener) this.removeEventListener();
  };

  _proto.onTransitionEnd = function onTransitionEnd() {
    var onMonthTransitionEnd = this.props.onMonthTransitionEnd;
    onMonthTransitionEnd();
  };

  _proto.onMonthSelect = function onMonthSelect(currentMonth, newMonthVal) {
    var newMonth = currentMonth.clone();
    var _this$props3 = this.props,
        onMonthChange = _this$props3.onMonthChange,
        orientation = _this$props3.orientation;
    var months = this.state.months;
    var withoutTransitionMonths = orientation === constants$1.VERTICAL_SCROLLABLE;
    var initialMonthSubtraction = months.indexOf(currentMonth);

    if (!withoutTransitionMonths) {
      initialMonthSubtraction -= 1;
    }

    newMonth.set('month', newMonthVal).subtract(initialMonthSubtraction, 'months');
    onMonthChange(newMonth);
  };

  _proto.onYearSelect = function onYearSelect(currentMonth, newYearVal) {
    var newMonth = currentMonth.clone();
    var _this$props4 = this.props,
        onYearChange = _this$props4.onYearChange,
        orientation = _this$props4.orientation;
    var months = this.state.months;
    var withoutTransitionMonths = orientation === constants$1.VERTICAL_SCROLLABLE;
    var initialMonthSubtraction = months.indexOf(currentMonth);

    if (!withoutTransitionMonths) {
      initialMonthSubtraction -= 1;
    }

    newMonth.set('year', newYearVal).subtract(initialMonthSubtraction, 'months');
    onYearChange(newMonth);
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props5 = this.props,
        enableOutsideDays = _this$props5.enableOutsideDays,
        firstVisibleMonthIndex = _this$props5.firstVisibleMonthIndex,
        horizontalMonthPadding = _this$props5.horizontalMonthPadding,
        isAnimating = _this$props5.isAnimating,
        modifiers = _this$props5.modifiers,
        numberOfMonths = _this$props5.numberOfMonths,
        monthFormat = _this$props5.monthFormat,
        orientation = _this$props5.orientation,
        translationValue = _this$props5.translationValue,
        daySize = _this$props5.daySize,
        onDayMouseEnter = _this$props5.onDayMouseEnter,
        onDayMouseLeave = _this$props5.onDayMouseLeave,
        onDayClick = _this$props5.onDayClick,
        renderMonthText = _this$props5.renderMonthText,
        renderCalendarDay = _this$props5.renderCalendarDay,
        renderDayContents = _this$props5.renderDayContents,
        renderMonthElement = _this$props5.renderMonthElement,
        onMonthTransitionEnd = _this$props5.onMonthTransitionEnd,
        firstDayOfWeek = _this$props5.firstDayOfWeek,
        focusedDate = _this$props5.focusedDate,
        isFocused = _this$props5.isFocused,
        isRTL = _this$props5.isRTL,
        styles = _this$props5.styles,
        phrases = _this$props5.phrases,
        dayAriaLabelFormat = _this$props5.dayAriaLabelFormat,
        transitionDuration = _this$props5.transitionDuration,
        verticalBorderSpacing = _this$props5.verticalBorderSpacing,
        setMonthTitleHeight = _this$props5.setMonthTitleHeight;
    var months = this.state.months;
    var isVertical = orientation === constants$1.VERTICAL_ORIENTATION;
    var isVerticalScrollable = orientation === constants$1.VERTICAL_SCROLLABLE;
    var isHorizontal = orientation === constants$1.HORIZONTAL_ORIENTATION;
    var calendarMonthWidth = (0, _getCalendarMonthWidth["default"])(daySize, horizontalMonthPadding);
    var width = isVertical || isVerticalScrollable ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;
    var transformType = isVertical || isVerticalScrollable ? 'translateY' : 'translateX';
    var transformValue = "".concat(transformType, "(").concat(translationValue, "px)");
    return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.CalendarMonthGrid, isHorizontal && styles.CalendarMonthGrid__horizontal, isVertical && styles.CalendarMonthGrid__vertical, isVerticalScrollable && styles.CalendarMonthGrid__vertical_scrollable, isAnimating && styles.CalendarMonthGrid__animating, isAnimating && transitionDuration && {
      transition: "transform ".concat(transitionDuration, "ms ease-in-out")
    }, _objectSpread({}, (0, _getTransformStyles["default"])(transformValue), {
      width: width
    })), {
      ref: this.setContainerRef,
      onTransitionEnd: onMonthTransitionEnd
    }), months.map(function (month, i) {
      var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
      var hideForAnimation = i === 0 && !isVisible;
      var showForAnimation = i === 0 && isAnimating && isVisible;
      var monthString = (0, _toISOMonthString["default"])(month);
      return _react["default"].createElement("div", (0, _extends2["default"])({
        key: monthString
      }, (0, withStyles_1.css)(isHorizontal && styles.CalendarMonthGrid_month__horizontal, hideForAnimation && styles.CalendarMonthGrid_month__hideForAnimation, showForAnimation && !isVertical && !isRTL && {
        position: 'absolute',
        left: -calendarMonthWidth
      }, showForAnimation && !isVertical && isRTL && {
        position: 'absolute',
        right: 0
      }, showForAnimation && isVertical && {
        position: 'absolute',
        top: -translationValue
      }, !isVisible && !isAnimating && styles.CalendarMonthGrid_month__hidden)), _react["default"].createElement(_CalendarMonth["default"], {
        month: month,
        isVisible: isVisible,
        enableOutsideDays: enableOutsideDays,
        modifiers: modifiers[monthString],
        monthFormat: monthFormat,
        orientation: orientation,
        onDayMouseEnter: onDayMouseEnter,
        onDayMouseLeave: onDayMouseLeave,
        onDayClick: onDayClick,
        onMonthSelect: _this3.onMonthSelect,
        onYearSelect: _this3.onYearSelect,
        renderMonthText: renderMonthText,
        renderCalendarDay: renderCalendarDay,
        renderDayContents: renderDayContents,
        renderMonthElement: renderMonthElement,
        firstDayOfWeek: firstDayOfWeek,
        daySize: daySize,
        focusedDate: isVisible ? focusedDate : null,
        isFocused: isFocused,
        phrases: phrases,
        setMonthTitleHeight: setMonthTitleHeight,
        dayAriaLabelFormat: dayAriaLabelFormat,
        verticalBorderSpacing: verticalBorderSpacing,
        horizontalMonthPadding: horizontalMonthPadding
      }));
    }));
  };

  return CalendarMonthGrid;
}(_react["default"].PureComponent || _react["default"].Component);

CalendarMonthGrid.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
CalendarMonthGrid.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      spacing = _ref2$reactDates.spacing,
      zIndex = _ref2$reactDates.zIndex;
  return {
    CalendarMonthGrid: {
      background: color.background,
      textAlign: (0, _noflip["default"])('left'),
      zIndex: zIndex
    },
    CalendarMonthGrid__animating: {
      zIndex: zIndex + 1
    },
    CalendarMonthGrid__horizontal: {
      position: 'absolute',
      left: (0, _noflip["default"])(spacing.dayPickerHorizontalPadding)
    },
    CalendarMonthGrid__vertical: {
      margin: '0 auto'
    },
    CalendarMonthGrid__vertical_scrollable: {
      margin: '0 auto'
    },
    CalendarMonthGrid_month__horizontal: {
      display: 'inline-block',
      verticalAlign: 'top',
      minHeight: '100%'
    },
    CalendarMonthGrid_month__hideForAnimation: {
      position: 'absolute',
      zIndex: zIndex - 1,
      opacity: 0,
      pointerEvents: 'none'
    },
    CalendarMonthGrid_month__hidden: {
      visibility: 'hidden'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(CalendarMonthGrid);

exports["default"] = _default;
});

unwrapExports(CalendarMonthGrid_1);

var canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var _createClass$l = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$l(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$k(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$k(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal$4 = function (_React$Component) {
  _inherits$k(Portal, _React$Component);

  function Portal() {
    _classCallCheck$l(this, Portal);

    return _possibleConstructorReturn$k(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$l(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM$1) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return ReactDOM__default['default'].createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(React__default['default'].Component);

Portal$4.propTypes = {
  children: PropTypes__default['default'].node.isRequired,
  node: PropTypes__default['default'].any
};

var _createClass$m = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$m(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$l(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$l(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal$5 = function (_React$Component) {
  _inherits$l(Portal, _React$Component);

  function Portal() {
    _classCallCheck$m(this, Portal);

    return _possibleConstructorReturn$l(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$m(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      ReactDOM__default['default'].unmountComponentAtNode(this.defaultNode || this.props.node);
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof this.props.children.type === 'function') {
        children = React__default['default'].cloneElement(this.props.children);
      }

      this.portal = ReactDOM__default['default'].unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(React__default['default'].Component);


Portal$5.propTypes = {
  children: PropTypes__default['default'].node.isRequired,
  node: PropTypes__default['default'].any
};

var Portal$6 = void 0;

if (ReactDOM__default['default'].createPortal) {
  Portal$6 = Portal$4;
} else {
  Portal$6 = Portal$5;
}

var Portal$7 = Portal$6;

var _createClass$n = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$n(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$m(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$m(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27
};

var PortalWithState = function (_React$Component) {
  _inherits$m(PortalWithState, _React$Component);

  function PortalWithState(props) {
    _classCallCheck$n(this, PortalWithState);

    var _this = _possibleConstructorReturn$m(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));

    _this.portalNode = null;
    _this.state = { active: !!props.defaultOpen };
    _this.openPortal = _this.openPortal.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    return _this;
  }

  _createClass$n(PortalWithState, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.addEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'openPortal',
    value: function openPortal(e) {
      if (this.state.active) {
        return;
      }
      if (e && e.nativeEvent) {
        e.nativeEvent.stopImmediatePropagation();
      }
      this.setState({ active: true }, this.props.onOpen);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      if (!this.state.active) {
        return;
      }
      this.setState({ active: false }, this.props.onClose);
    }
  }, {
    key: 'wrapWithPortal',
    value: function wrapWithPortal(children) {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }
      return React__default['default'].createElement(
        Portal$7,
        {
          node: this.props.node,
          key: 'react-portal',
          ref: function ref(portalNode) {
            return _this2.portalNode = portalNode;
          }
        },
        children
      );
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }
      var root = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        openPortal: this.openPortal,
        closePortal: this.closePortal,
        portal: this.wrapWithPortal,
        isOpen: this.state.active
      });
    }
  }]);

  return PortalWithState;
}(React__default['default'].Component);

PortalWithState.propTypes = {
  children: PropTypes__default['default'].func.isRequired,
  defaultOpen: PropTypes__default['default'].bool,
  node: PropTypes__default['default'].any,
  closeOnEsc: PropTypes__default['default'].bool,
  closeOnOutsideClick: PropTypes__default['default'].bool,
  onOpen: PropTypes__default['default'].func,
  onClose: PropTypes__default['default'].func
};

PortalWithState.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};

var es$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Portal: Portal$7,
  PortalWithState: PortalWithState
});

var build$3 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isTouchDevice;
function isTouchDevice() {
  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
}
module.exports = exports['default'];
});

unwrapExports(build$3);

var implementation$a = function contains(other) {
	if (arguments.length < 1) {
		throw new TypeError('1 argument is required');
	}
	if (typeof other !== 'object') {
		throw new TypeError('Argument 1 (”other“) to Node.contains must be an instance of Node');
	}

	var node = other;
	do {
		if (this === node) {
			return true;
		}
		if (node) {
			node = node.parentNode;
		}
	} while (node);

	return false;
};

var polyfill$e = function getPolyfill() {
	if (typeof document !== 'undefined') {
		if (document.contains) {
			return document.contains;
		}
		if (document.body && document.body.contains) {
			try {
				if (typeof document.body.contains.call(document, '') === 'boolean') {
					return document.body.contains;
				}
			} catch (e) { /**/ }
		}
	}
	return implementation$a;
};

var shim$7 = function shimContains() {
	var polyfill = polyfill$e();
	if (typeof document !== 'undefined') {
		defineProperties_1(
			document,
			{ contains: polyfill },
			{ contains: function () { return document.contains !== polyfill; } }
		);
		if (typeof Element !== 'undefined') {
			defineProperties_1(
				Element.prototype,
				{ contains: polyfill },
				{ contains: function () { return Element.prototype.contains !== polyfill; } }
			);
		}
	}
	return polyfill;
};

var polyfill$f = polyfill$e();


var boundContains = function contains(node, other) {
	return polyfill$f.apply(node, [other]);
};

defineProperties_1(boundContains, {
	getPolyfill: polyfill$e,
	implementation: implementation$a,
	shim: shim$7
});

var document_contains = boundContains;

var OutsideClickHandler_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default['default']);



var _propTypes2 = _interopRequireDefault(PropTypes__default['default']);







var _object2 = _interopRequireDefault(object_values);



var _document2 = _interopRequireDefault(document_contains);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DISPLAY = {
  BLOCK: 'block',
  FLEX: 'flex',
  INLINE: 'inline',
  INLINE_BLOCK: 'inline-block',
  CONTENTS: 'contents'
};

var propTypes = (0, airbnbPropTypes.forbidExtraProps)({
  children: _propTypes2['default'].node.isRequired,
  onOutsideClick: _propTypes2['default'].func.isRequired,
  disabled: _propTypes2['default'].bool,
  useCapture: _propTypes2['default'].bool,
  display: _propTypes2['default'].oneOf((0, _object2['default'])(DISPLAY))
});

var defaultProps = {
  disabled: false,

  // `useCapture` is set to true by default so that a `stopPropagation` in the
  // children will not prevent all outside click handlers from firing - maja
  useCapture: true,
  display: DISPLAY.BLOCK
};

var OutsideClickHandler = function (_React$Component) {
  _inherits(OutsideClickHandler, _React$Component);

  function OutsideClickHandler() {
    var _ref;

    _classCallCheck(this, OutsideClickHandler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));

    _this.onMouseDown = _this.onMouseDown.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);
    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
    return _this;
  }

  _createClass(OutsideClickHandler, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _props = this.props,
            disabled = _props.disabled,
            useCapture = _props.useCapture;


        if (!disabled) this.addMouseDownEventListener(useCapture);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(_ref2) {
        var prevDisabled = _ref2.disabled;
        var _props2 = this.props,
            disabled = _props2.disabled,
            useCapture = _props2.useCapture;

        if (prevDisabled !== disabled) {
          if (disabled) {
            this.removeEventListeners();
          } else {
            this.addMouseDownEventListener(useCapture);
          }
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        this.removeEventListeners();
      }

      return componentWillUnmount;
    }()

    // Use mousedown/mouseup to enforce that clicks remain outside the root's
    // descendant tree, even when dragged. This should also get triggered on
    // touch devices.

  }, {
    key: 'onMouseDown',
    value: function () {
      function onMouseDown(e) {
        var useCapture = this.props.useCapture;


        var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);
        if (!isDescendantOfRoot) {
          if (this.removeMouseUp) {
            this.removeMouseUp();
            this.removeMouseUp = null;
          }
          this.removeMouseUp = (0, index_esm.addEventListener)(document, 'mouseup', this.onMouseUp, { capture: useCapture });
        }
      }

      return onMouseDown;
    }()

    // Use mousedown/mouseup to enforce that clicks remain outside the root's
    // descendant tree, even when dragged. This should also get triggered on
    // touch devices.

  }, {
    key: 'onMouseUp',
    value: function () {
      function onMouseUp(e) {
        var onOutsideClick = this.props.onOutsideClick;


        var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);
        if (this.removeMouseUp) {
          this.removeMouseUp();
          this.removeMouseUp = null;
        }

        if (!isDescendantOfRoot) {
          onOutsideClick(e);
        }
      }

      return onMouseUp;
    }()
  }, {
    key: 'setChildNodeRef',
    value: function () {
      function setChildNodeRef(ref) {
        this.childNode = ref;
      }

      return setChildNodeRef;
    }()
  }, {
    key: 'addMouseDownEventListener',
    value: function () {
      function addMouseDownEventListener(useCapture) {
        this.removeMouseDown = (0, index_esm.addEventListener)(document, 'mousedown', this.onMouseDown, { capture: useCapture });
      }

      return addMouseDownEventListener;
    }()
  }, {
    key: 'removeEventListeners',
    value: function () {
      function removeEventListeners() {
        if (this.removeMouseDown) this.removeMouseDown();
        if (this.removeMouseUp) this.removeMouseUp();
      }

      return removeEventListeners;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props3 = this.props,
            children = _props3.children,
            display = _props3.display;


        return _react2['default'].createElement(
          'div',
          {
            ref: this.setChildNodeRef,
            style: display !== DISPLAY.BLOCK && (0, _object2['default'])(DISPLAY).includes(display) ? { display: display } : undefined
          },
          children
        );
      }

      return render;
    }()
  }]);

  return OutsideClickHandler;
}(_react2['default'].Component);

exports['default'] = OutsideClickHandler;


OutsideClickHandler.propTypes = propTypes;
OutsideClickHandler.defaultProps = defaultProps;
});

unwrapExports(OutsideClickHandler_1);

// eslint-disable-next-line import/no-unresolved
var reactOutsideClickHandler = OutsideClickHandler_1;

var FocusedInputShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = _propTypes["default"].oneOf([constants$1.START_DATE, constants$1.END_DATE]);

exports["default"] = _default;
});

unwrapExports(FocusedInputShape);

var IconPositionShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = _propTypes["default"].oneOf([constants$1.ICON_BEFORE_POSITION, constants$1.ICON_AFTER_POSITION]);

exports["default"] = _default;
});

unwrapExports(IconPositionShape);

var OrientationShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = _propTypes["default"].oneOf([constants$1.HORIZONTAL_ORIENTATION, constants$1.VERTICAL_ORIENTATION]);

exports["default"] = _default;
});

unwrapExports(OrientationShape);

var DisabledShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf([constants$1.START_DATE, constants$1.END_DATE])]);

exports["default"] = _default;
});

unwrapExports(DisabledShape);

var AnchorDirectionShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = _propTypes["default"].oneOf([constants$1.ANCHOR_LEFT, constants$1.ANCHOR_RIGHT]);

exports["default"] = _default;
});

unwrapExports(AnchorDirectionShape);

var OpenDirectionShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = _propTypes["default"].oneOf([constants$1.OPEN_DOWN, constants$1.OPEN_UP]);

exports["default"] = _default;
});

unwrapExports(OpenDirectionShape);

var CalendarInfoPositionShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = _propTypes["default"].oneOf([constants$1.INFO_POSITION_TOP, constants$1.INFO_POSITION_BOTTOM, constants$1.INFO_POSITION_BEFORE, constants$1.INFO_POSITION_AFTER]);

exports["default"] = _default;
});

unwrapExports(CalendarInfoPositionShape);

var NavPositionShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);



var _default = _propTypes["default"].oneOf([constants$1.NAV_POSITION_BOTTOM, constants$1.NAV_POSITION_TOP]);

exports["default"] = _default;
});

unwrapExports(NavPositionShape);

var DateRangePickerShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);

var _reactMomentProptypes = interopRequireDefault(src$1);





var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _FocusedInputShape = interopRequireDefault(FocusedInputShape);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _OrientationShape = interopRequireDefault(OrientationShape);

var _DisabledShape = interopRequireDefault(DisabledShape);

var _AnchorDirectionShape = interopRequireDefault(AnchorDirectionShape);

var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);

var _CalendarInfoPositionShape = interopRequireDefault(CalendarInfoPositionShape);

var _NavPositionShape = interopRequireDefault(NavPositionShape);

var _default = {
  // required props for a functional interactive DateRangePicker
  startDate: _reactMomentProptypes["default"].momentObj,
  endDate: _reactMomentProptypes["default"].momentObj,
  onDatesChange: _propTypes["default"].func.isRequired,
  focusedInput: _FocusedInputShape["default"],
  onFocusChange: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func,
  // input related props
  startDateId: _propTypes["default"].string.isRequired,
  startDatePlaceholderText: _propTypes["default"].string,
  startDateOffset: _propTypes["default"].func,
  endDateOffset: _propTypes["default"].func,
  endDateId: _propTypes["default"].string.isRequired,
  endDatePlaceholderText: _propTypes["default"].string,
  startDateAriaLabel: _propTypes["default"].string,
  endDateAriaLabel: _propTypes["default"].string,
  disabled: _DisabledShape["default"],
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  screenReaderInputMessage: _propTypes["default"].string,
  showClearDates: _propTypes["default"].bool,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes["default"].node,
  customArrowIcon: _propTypes["default"].node,
  customCloseIcon: _propTypes["default"].node,
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  keepFocusOnInput: _propTypes["default"].bool,
  // calendar presentation and interaction related props
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes["default"].func,
  orientation: _OrientationShape["default"],
  anchorDirection: _AnchorDirectionShape["default"],
  openDirection: _OpenDirectionShape["default"],
  horizontalMargin: _propTypes["default"].number,
  withPortal: _propTypes["default"].bool,
  withFullScreenPortal: _propTypes["default"].bool,
  appendToBody: _propTypes["default"].bool,
  disableScroll: _propTypes["default"].bool,
  daySize: airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes["default"].bool,
  firstDayOfWeek: _DayOfWeekShape["default"],
  initialVisibleMonth: _propTypes["default"].func,
  numberOfMonths: _propTypes["default"].number,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  reopenPickerOnClearDates: _propTypes["default"].bool,
  renderCalendarInfo: _propTypes["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  verticalHeight: airbnbPropTypes.nonNegativeInteger,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  // navigation related props
  dayPickerNavigationInlineStyles: _propTypes["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  // day presentation and interaction related props
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  minimumNights: _propTypes["default"].number,
  minDate: _reactMomentProptypes["default"].momentObj,
  maxDate: _reactMomentProptypes["default"].momentObj,
  enableOutsideDays: _propTypes["default"].bool,
  isDayBlocked: _propTypes["default"].func,
  isOutsideRange: _propTypes["default"].func,
  isDayHighlighted: _propTypes["default"].func,
  // internationalization props
  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  monthFormat: _propTypes["default"].string,
  weekDayFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DateRangePickerPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string
};
exports["default"] = _default;
});

unwrapExports(DateRangePickerShape);

var getResponsiveContainerStyles_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getResponsiveContainerStyles;

var _defineProperty2 = interopRequireDefault(defineProperty$1);



function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
  var windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
  var calculatedOffset = anchorDirection === constants$1.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
  var calculatedMargin = margin || 0;
  return (0, _defineProperty2["default"])({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
}
});

unwrapExports(getResponsiveContainerStyles_1);

var getDetachedContainerStyles_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDetachedContainerStyles;



/**
 * Calculate and return a CSS transform style to position a detached element
 * next to a reference element. The open and anchor direction indicate wether
 * it should be positioned above/below and/or to the left/right of the
 * reference element.
 *
 * Assuming r(0,0), r(1,1), d(0,0), d(1,1) for the bottom-left and top-right
 * corners of the reference and detached elements, respectively:
 *  - openDirection = DOWN, anchorDirection = LEFT => d(0,1) == r(0,1)
 *  - openDirection = UP, anchorDirection = LEFT => d(0,0) == r(0,0)
 *  - openDirection = DOWN, anchorDirection = RIGHT => d(1,1) == r(1,1)
 *  - openDirection = UP, anchorDirection = RIGHT => d(1,0) == r(1,0)
 *
 * By using a CSS transform, we allow to further position it using
 * top/bottom CSS properties for the anchor gutter.
 *
 * @param {string} openDirection The vertical positioning of the popup
 * @param {string} anchorDirection The horizontal position of the popup
 * @param {HTMLElement} referenceEl The reference element
 */
function getDetachedContainerStyles(openDirection, anchorDirection, referenceEl) {
  var referenceRect = referenceEl.getBoundingClientRect();
  var offsetX = referenceRect.left;
  var offsetY = referenceRect.top;

  if (openDirection === constants$1.OPEN_UP) {
    offsetY = -(window.innerHeight - referenceRect.bottom);
  }

  if (anchorDirection === constants$1.ANCHOR_RIGHT) {
    offsetX = -(window.innerWidth - referenceRect.right);
  }

  return {
    transform: "translate3d(".concat(Math.round(offsetX), "px, ").concat(Math.round(offsetY), "px, 0)")
  };
}
});

unwrapExports(getDetachedContainerStyles_1);

var getInputHeight_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getInputHeight;

/* eslint-disable camelcase */
function getPadding(vertical, top, bottom) {
  var isTopDefined = typeof top === 'number';
  var isBottomDefined = typeof bottom === 'number';
  var isVerticalDefined = typeof vertical === 'number';

  if (isTopDefined && isBottomDefined) {
    return top + bottom;
  }

  if (isTopDefined && isVerticalDefined) {
    return top + vertical;
  }

  if (isTopDefined) {
    return top;
  }

  if (isBottomDefined && isVerticalDefined) {
    return bottom + vertical;
  }

  if (isBottomDefined) {
    return bottom;
  }

  if (isVerticalDefined) {
    return 2 * vertical;
  }

  return 0;
}

function getInputHeight(_ref, small) {
  var _ref$font$input = _ref.font.input,
      lineHeight = _ref$font$input.lineHeight,
      lineHeight_small = _ref$font$input.lineHeight_small,
      _ref$spacing = _ref.spacing,
      inputPadding = _ref$spacing.inputPadding,
      displayTextPaddingVertical = _ref$spacing.displayTextPaddingVertical,
      displayTextPaddingTop = _ref$spacing.displayTextPaddingTop,
      displayTextPaddingBottom = _ref$spacing.displayTextPaddingBottom,
      displayTextPaddingVertical_small = _ref$spacing.displayTextPaddingVertical_small,
      displayTextPaddingTop_small = _ref$spacing.displayTextPaddingTop_small,
      displayTextPaddingBottom_small = _ref$spacing.displayTextPaddingBottom_small;
  var calcLineHeight = small ? lineHeight_small : lineHeight;
  var padding = small ? getPadding(displayTextPaddingVertical_small, displayTextPaddingTop_small, displayTextPaddingBottom_small) : getPadding(displayTextPaddingVertical, displayTextPaddingTop, displayTextPaddingBottom);
  return parseInt(calcLineHeight, 10) + 2 * inputPadding + padding;
}
});

unwrapExports(getInputHeight_1);

var isBeforeDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isBeforeDay;

var _moment = interopRequireDefault(hooks);

function isBeforeDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  var aYear = a.year();
  var aMonth = a.month();
  var bYear = b.year();
  var bMonth = b.month();
  var isSameYear = aYear === bYear;
  var isSameMonth = aMonth === bMonth;
  if (isSameYear && isSameMonth) return a.date() < b.date();
  if (isSameYear) return aMonth < bMonth;
  return aYear < bYear;
}
});

unwrapExports(isBeforeDay_1);

var isInclusivelyAfterDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isInclusivelyAfterDay;

var _moment = interopRequireDefault(hooks);

var _isBeforeDay = interopRequireDefault(isBeforeDay_1);

function isInclusivelyAfterDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return !(0, _isBeforeDay["default"])(a, b);
}
});

unwrapExports(isInclusivelyAfterDay_1);

var disableScroll_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollParent = getScrollParent;
exports.getScrollAncestorsOverflowY = getScrollAncestorsOverflowY;
exports["default"] = disableScroll;

var getScrollingRoot = function getScrollingRoot() {
  return document.scrollingElement || document.documentElement;
};
/**
 * Recursively finds the scroll parent of a node. The scroll parrent of a node
 * is the closest node that is scrollable. A node is scrollable if:
 *  - it is allowed to scroll via CSS ('overflow-y' not visible or hidden);
 *  - and its children/content are "bigger" than the node's box height.
 *
 * The root of the document always scrolls by default.
 *
 * @param {HTMLElement} node Any DOM element.
 * @return {HTMLElement} The scroll parent element.
 */


function getScrollParent(node) {
  var parent = node.parentElement;
  if (parent == null) return getScrollingRoot();

  var _window$getComputedSt = window.getComputedStyle(parent),
      overflowY = _window$getComputedSt.overflowY;

  var canScroll = overflowY !== 'visible' && overflowY !== 'hidden';

  if (canScroll && parent.scrollHeight > parent.clientHeight) {
    return parent;
  }

  return getScrollParent(parent);
}
/**
 * Recursively traverses the tree upwards from the given node, capturing all
 * ancestor nodes that scroll along with their current 'overflow-y' CSS
 * property.
 *
 * @param {HTMLElement} node Any DOM element.
 * @param {Map<HTMLElement,string>} [acc] Accumulator map.
 * @return {Map<HTMLElement,string>} Map of ancestors with their 'overflow-y' value.
 */


function getScrollAncestorsOverflowY(node) {
  var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
  var scrollingRoot = getScrollingRoot();
  var scrollParent = getScrollParent(node);
  acc.set(scrollParent, scrollParent.style.overflowY);
  if (scrollParent === scrollingRoot) return acc;
  return getScrollAncestorsOverflowY(scrollParent, acc);
}
/**
 * Disabling the scroll on a node involves finding all the scrollable ancestors
 * and set their 'overflow-y' CSS property to 'hidden'. When all ancestors have
 * 'overflow-y: hidden' (up to the document element) there is no scroll
 * container, thus all the scroll outside of the node is disabled. In order to
 * enable scroll again, we store the previous value of the 'overflow-y' for
 * every ancestor in a closure and reset it back.
 *
 * @param {HTMLElement} node Any DOM element.
 */


function disableScroll(node) {
  var scrollAncestorsOverflowY = getScrollAncestorsOverflowY(node);

  var toggle = function toggle(on) {
    return scrollAncestorsOverflowY.forEach(function (overflowY, ancestor) {
      ancestor.style.setProperty('overflow-y', on ? 'hidden' : overflowY);
    });
  };

  toggle(true);
  return function () {
    return toggle(false);
  };
}
});

unwrapExports(disableScroll_1);
var disableScroll_2 = disableScroll_1.getScrollParent;
var disableScroll_3 = disableScroll_1.getScrollAncestorsOverflowY;

var DateInput_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);





var _throttle = interopRequireDefault(throttle_1);

var _isTouchDevice = interopRequireDefault(build$3);

var _noflip = interopRequireDefault(noflip_1);

var _getInputHeight = interopRequireDefault(getInputHeight_1);

var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FANG_PATH_TOP = "M0,".concat(constants$1.FANG_HEIGHT_PX, " ").concat(constants$1.FANG_WIDTH_PX, ",").concat(constants$1.FANG_HEIGHT_PX, " ").concat(constants$1.FANG_WIDTH_PX / 2, ",0z");
var FANG_STROKE_TOP = "M0,".concat(constants$1.FANG_HEIGHT_PX, " ").concat(constants$1.FANG_WIDTH_PX / 2, ",0 ").concat(constants$1.FANG_WIDTH_PX, ",").concat(constants$1.FANG_HEIGHT_PX);
var FANG_PATH_BOTTOM = "M0,0 ".concat(constants$1.FANG_WIDTH_PX, ",0 ").concat(constants$1.FANG_WIDTH_PX / 2, ",").concat(constants$1.FANG_HEIGHT_PX, "z");
var FANG_STROKE_BOTTOM = "M0,0 ".concat(constants$1.FANG_WIDTH_PX / 2, ",").concat(constants$1.FANG_HEIGHT_PX, " ").concat(constants$1.FANG_WIDTH_PX, ",0");
var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  id: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  displayValue: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  screenReaderMessage: _propTypes["default"].string,
  focused: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  showCaret: _propTypes["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  small: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDownShiftTab: _propTypes["default"].func,
  onKeyDownTab: _propTypes["default"].func,
  onKeyDownArrowDown: _propTypes["default"].func,
  onKeyDownQuestionMark: _propTypes["default"].func,
  // accessibility
  isFocused: _propTypes["default"].bool // describes actual DOM focus

})) : {};
var defaultProps = {
  placeholder: 'Select Date',
  displayValue: '',
  ariaLabel: undefined,
  screenReaderMessage: '',
  focused: false,
  disabled: false,
  required: false,
  readOnly: null,
  openDirection: constants$1.OPEN_DOWN,
  showCaret: false,
  verticalSpacing: constants$1.DEFAULT_VERTICAL_SPACING,
  small: false,
  block: false,
  regular: false,
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onKeyDownShiftTab: function onKeyDownShiftTab() {},
  onKeyDownTab: function onKeyDownTab() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  // accessibility
  isFocused: false
};

var DateInput =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DateInput, _ref);
  var _proto = DateInput.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DateInput(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.state = {
      dateString: '',
      isTouchDevice: false
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setInputRef = _this.setInputRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.throttledKeyDown = (0, _throttle["default"])(_this.onFinalKeyDown, 300, {
      trailing: false
    });
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      isTouchDevice: (0, _isTouchDevice["default"])()
    });
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var dateString = this.state.dateString;

    if (dateString && nextProps.displayValue) {
      this.setState({
        dateString: ''
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props = this.props,
        focused = _this$props.focused,
        isFocused = _this$props.isFocused;
    if (prevProps.focused === focused && prevProps.isFocused === isFocused) return;

    if (focused && isFocused) {
      this.inputRef.focus();
    }
  };

  _proto.onChange = function onChange(e) {
    var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        onKeyDownQuestionMark = _this$props2.onKeyDownQuestionMark;
    var dateString = e.target.value; // In Safari, onKeyDown does not consistently fire ahead of onChange. As a result, we need to
    // special case the `?` key so that it always triggers the appropriate callback, instead of
    // modifying the input value

    if (dateString[dateString.length - 1] === '?') {
      onKeyDownQuestionMark(e);
    } else {
      this.setState({
        dateString: dateString
      }, function () {
        return onChange(dateString);
      });
    }
  };

  _proto.onKeyDown = function onKeyDown(e) {
    e.stopPropagation();

    if (!constants$1.MODIFIER_KEY_NAMES.has(e.key)) {
      this.throttledKeyDown(e);
    }
  };

  _proto.onFinalKeyDown = function onFinalKeyDown(e) {
    var _this$props3 = this.props,
        onKeyDownShiftTab = _this$props3.onKeyDownShiftTab,
        onKeyDownTab = _this$props3.onKeyDownTab,
        onKeyDownArrowDown = _this$props3.onKeyDownArrowDown,
        onKeyDownQuestionMark = _this$props3.onKeyDownQuestionMark;
    var key = e.key;

    if (key === 'Tab') {
      if (e.shiftKey) {
        onKeyDownShiftTab(e);
      } else {
        onKeyDownTab(e);
      }
    } else if (key === 'ArrowDown') {
      onKeyDownArrowDown(e);
    } else if (key === '?') {
      e.preventDefault();
      onKeyDownQuestionMark(e);
    }
  };

  _proto.setInputRef = function setInputRef(ref) {
    this.inputRef = ref;
  };

  _proto.render = function render() {
    var _this$state = this.state,
        dateString = _this$state.dateString,
        isTouch = _this$state.isTouchDevice;
    var _this$props4 = this.props,
        id = _this$props4.id,
        placeholder = _this$props4.placeholder,
        ariaLabel = _this$props4.ariaLabel,
        displayValue = _this$props4.displayValue,
        screenReaderMessage = _this$props4.screenReaderMessage,
        focused = _this$props4.focused,
        showCaret = _this$props4.showCaret,
        onFocus = _this$props4.onFocus,
        disabled = _this$props4.disabled,
        required = _this$props4.required,
        readOnly = _this$props4.readOnly,
        openDirection = _this$props4.openDirection,
        verticalSpacing = _this$props4.verticalSpacing,
        small = _this$props4.small,
        regular = _this$props4.regular,
        block = _this$props4.block,
        styles = _this$props4.styles,
        reactDates = _this$props4.theme.reactDates;
    var value = dateString || displayValue || '';
    var screenReaderMessageId = "DateInput__screen-reader-message-".concat(id);
    var withFang = showCaret && focused;
    var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
    return _react["default"].createElement("div", (0, withStyles_1.css)(styles.DateInput, small && styles.DateInput__small, block && styles.DateInput__block, withFang && styles.DateInput__withFang, disabled && styles.DateInput__disabled, withFang && openDirection === constants$1.OPEN_DOWN && styles.DateInput__openDown, withFang && openDirection === constants$1.OPEN_UP && styles.DateInput__openUp), _react["default"].createElement("input", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateInput_input, small && styles.DateInput_input__small, regular && styles.DateInput_input__regular, readOnly && styles.DateInput_input__readOnly, focused && styles.DateInput_input__focused, disabled && styles.DateInput_input__disabled), {
      "aria-label": ariaLabel === undefined ? placeholder : ariaLabel,
      type: "text",
      id: id,
      name: id,
      ref: this.setInputRef,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onFocus: onFocus,
      placeholder: placeholder,
      autoComplete: "off",
      disabled: disabled,
      readOnly: typeof readOnly === 'boolean' ? readOnly : isTouch,
      required: required,
      "aria-describedby": screenReaderMessage && screenReaderMessageId
    })), withFang && _react["default"].createElement("svg", (0, _extends2["default"])({
      role: "presentation",
      focusable: "false"
    }, (0, withStyles_1.css)(styles.DateInput_fang, openDirection === constants$1.OPEN_DOWN && {
      top: inputHeight + verticalSpacing - constants$1.FANG_HEIGHT_PX - 1
    }, openDirection === constants$1.OPEN_UP && {
      bottom: inputHeight + verticalSpacing - constants$1.FANG_HEIGHT_PX - 1
    })), _react["default"].createElement("path", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateInput_fangShape), {
      d: openDirection === constants$1.OPEN_DOWN ? FANG_PATH_TOP : FANG_PATH_BOTTOM
    })), _react["default"].createElement("path", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateInput_fangStroke), {
      d: openDirection === constants$1.OPEN_DOWN ? FANG_STROKE_TOP : FANG_STROKE_BOTTOM
    }))), screenReaderMessage && _react["default"].createElement("p", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateInput_screenReaderMessage), {
      id: screenReaderMessageId
    }), screenReaderMessage));
  };

  return DateInput;
}(_react["default"].PureComponent || _react["default"].Component);

DateInput.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DateInput.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      border = _ref2$reactDates.border,
      color = _ref2$reactDates.color,
      sizing = _ref2$reactDates.sizing,
      spacing = _ref2$reactDates.spacing,
      font = _ref2$reactDates.font,
      zIndex = _ref2$reactDates.zIndex;
  return {
    DateInput: {
      margin: 0,
      padding: spacing.inputPadding,
      background: color.background,
      position: 'relative',
      display: 'inline-block',
      width: sizing.inputWidth,
      verticalAlign: 'middle'
    },
    DateInput__small: {
      width: sizing.inputWidth_small
    },
    DateInput__block: {
      width: '100%'
    },
    DateInput__disabled: {
      background: color.disabled,
      color: color.textDisabled
    },
    DateInput_input: {
      fontWeight: font.input.weight,
      fontSize: font.input.size,
      lineHeight: font.input.lineHeight,
      color: color.text,
      backgroundColor: color.background,
      width: '100%',
      padding: "".concat(spacing.displayTextPaddingVertical, "px ").concat(spacing.displayTextPaddingHorizontal, "px"),
      paddingTop: spacing.displayTextPaddingTop,
      paddingBottom: spacing.displayTextPaddingBottom,
      paddingLeft: (0, _noflip["default"])(spacing.displayTextPaddingLeft),
      paddingRight: (0, _noflip["default"])(spacing.displayTextPaddingRight),
      border: border.input.border,
      borderTop: border.input.borderTop,
      borderRight: (0, _noflip["default"])(border.input.borderRight),
      borderBottom: border.input.borderBottom,
      borderLeft: (0, _noflip["default"])(border.input.borderLeft),
      borderRadius: border.input.borderRadius
    },
    DateInput_input__small: {
      fontSize: font.input.size_small,
      lineHeight: font.input.lineHeight_small,
      letterSpacing: font.input.letterSpacing_small,
      padding: "".concat(spacing.displayTextPaddingVertical_small, "px ").concat(spacing.displayTextPaddingHorizontal_small, "px"),
      paddingTop: spacing.displayTextPaddingTop_small,
      paddingBottom: spacing.displayTextPaddingBottom_small,
      paddingLeft: (0, _noflip["default"])(spacing.displayTextPaddingLeft_small),
      paddingRight: (0, _noflip["default"])(spacing.displayTextPaddingRight_small)
    },
    DateInput_input__regular: {
      fontWeight: 'auto'
    },
    DateInput_input__readOnly: {
      userSelect: 'none'
    },
    DateInput_input__focused: {
      outline: border.input.outlineFocused,
      background: color.backgroundFocused,
      border: border.input.borderFocused,
      borderTop: border.input.borderTopFocused,
      borderRight: (0, _noflip["default"])(border.input.borderRightFocused),
      borderBottom: border.input.borderBottomFocused,
      borderLeft: (0, _noflip["default"])(border.input.borderLeftFocused)
    },
    DateInput_input__disabled: {
      background: color.disabled,
      fontStyle: font.input.styleDisabled
    },
    DateInput_screenReaderMessage: {
      border: 0,
      clip: 'rect(0, 0, 0, 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: 1
    },
    DateInput_fang: {
      position: 'absolute',
      width: constants$1.FANG_WIDTH_PX,
      height: constants$1.FANG_HEIGHT_PX,
      left: 22,
      // TODO: should be noflip wrapped and handled by an isRTL prop
      zIndex: zIndex + 2
    },
    DateInput_fangShape: {
      fill: color.background
    },
    DateInput_fangStroke: {
      stroke: color.core.border,
      fill: 'transparent'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DateInput);

exports["default"] = _default;
});

unwrapExports(DateInput_1);

var RightArrow_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React__default['default']);

var RightArrow = function RightArrow(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z"
  }));
};

RightArrow.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = RightArrow;
exports["default"] = _default;
});

unwrapExports(RightArrow_1);

var LeftArrow_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React__default['default']);

var LeftArrow = function LeftArrow(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M336 275L126 485h806c13 0 23 10 23 23s-10 23-23 23H126l210 210c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7L55 524c-11-11-11-21 0-32l249-249c21-22 53 10 32 32z"
  }));
};

LeftArrow.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = LeftArrow;
exports["default"] = _default;
});

unwrapExports(LeftArrow_1);

var CloseButton_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React__default['default']);

var CloseButton = function CloseButton(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z"
  }));
};

CloseButton.defaultProps = {
  focusable: "false",
  viewBox: "0 0 12 12"
};
var _default = CloseButton;
exports["default"] = _default;
});

unwrapExports(CloseButton_1);

var CalendarIcon_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React__default['default']);

var CalendarIcon = function CalendarIcon(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "m107 1393h241v-241h-241zm295 0h268v-241h-268zm-295-295h241v-268h-241zm295 0h268v-268h-268zm-295-321h241v-241h-241zm616 616h268v-241h-268zm-321-616h268v-241h-268zm643 616h241v-241h-241zm-322-295h268v-268h-268zm-294-723v-241c0-7-3-14-8-19-6-5-12-8-19-8h-54c-7 0-13 3-19 8-5 5-8 12-8 19v241c0 7 3 14 8 19 6 5 12 8 19 8h54c7 0 13-3 19-8 5-5 8-12 8-19zm616 723h241v-268h-241zm-322-321h268v-241h-268zm322 0h241v-241h-241zm27-402v-241c0-7-3-14-8-19-6-5-12-8-19-8h-54c-7 0-13 3-19 8-5 5-8 12-8 19v241c0 7 3 14 8 19 6 5 12 8 19 8h54c7 0 13-3 19-8 5-5 8-12 8-19zm321-54v1072c0 29-11 54-32 75s-46 32-75 32h-1179c-29 0-54-11-75-32s-32-46-32-75v-1072c0-29 11-54 32-75s46-32 75-32h107v-80c0-37 13-68 40-95s57-39 94-39h54c37 0 68 13 95 39 26 26 39 58 39 95v80h321v-80c0-37 13-69 40-95 26-26 57-39 94-39h54c37 0 68 13 94 39s40 58 40 95v80h107c29 0 54 11 75 32s32 46 32 75z"
  }));
};

CalendarIcon.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1393.1 1500"
};
var _default = CalendarIcon;
exports["default"] = _default;
});

unwrapExports(CalendarIcon_1);

var DateRangePickerInput_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);







var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _noflip = interopRequireDefault(noflip_1);

var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);

var _DateInput = interopRequireDefault(DateInput_1);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _DisabledShape = interopRequireDefault(DisabledShape);

var _RightArrow = interopRequireDefault(RightArrow_1);

var _LeftArrow = interopRequireDefault(LeftArrow_1);

var _CloseButton = interopRequireDefault(CloseButton_1);

var _CalendarIcon = interopRequireDefault(CalendarIcon_1);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  children: _propTypes["default"].node,
  startDateId: _propTypes["default"].string,
  startDatePlaceholderText: _propTypes["default"].string,
  startDateAriaLabel: _propTypes["default"].string,
  screenReaderMessage: _propTypes["default"].string,
  endDateId: _propTypes["default"].string,
  endDatePlaceholderText: _propTypes["default"].string,
  endDateAriaLabel: _propTypes["default"].string,
  onStartDateFocus: _propTypes["default"].func,
  onEndDateFocus: _propTypes["default"].func,
  onStartDateChange: _propTypes["default"].func,
  onEndDateChange: _propTypes["default"].func,
  onStartDateShiftTab: _propTypes["default"].func,
  onEndDateTab: _propTypes["default"].func,
  onClearDates: _propTypes["default"].func,
  onKeyDownArrowDown: _propTypes["default"].func,
  onKeyDownQuestionMark: _propTypes["default"].func,
  startDate: _propTypes["default"].string,
  endDate: _propTypes["default"].string,
  isStartDateFocused: _propTypes["default"].bool,
  isEndDateFocused: _propTypes["default"].bool,
  showClearDates: _propTypes["default"].bool,
  disabled: _DisabledShape["default"],
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  showCaret: _propTypes["default"].bool,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes["default"].node,
  customArrowIcon: _propTypes["default"].node,
  customCloseIcon: _propTypes["default"].node,
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  // accessibility
  isFocused: _propTypes["default"].bool,
  // describes actual DOM focus
  // i18n
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DateRangePickerInputPhrases)),
  isRTL: _propTypes["default"].bool
})) : {};
var defaultProps = {
  children: null,
  startDateId: constants$1.START_DATE,
  endDateId: constants$1.END_DATE,
  startDatePlaceholderText: 'Start Date',
  endDatePlaceholderText: 'End Date',
  startDateAriaLabel: undefined,
  endDateAriaLabel: undefined,
  screenReaderMessage: '',
  onStartDateFocus: function onStartDateFocus() {},
  onEndDateFocus: function onEndDateFocus() {},
  onStartDateChange: function onStartDateChange() {},
  onEndDateChange: function onEndDateChange() {},
  onStartDateShiftTab: function onStartDateShiftTab() {},
  onEndDateTab: function onEndDateTab() {},
  onClearDates: function onClearDates() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  startDate: '',
  endDate: '',
  isStartDateFocused: false,
  isEndDateFocused: false,
  showClearDates: false,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: constants$1.OPEN_DOWN,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$1.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  // accessibility
  isFocused: false,
  // i18n
  phrases: defaultPhrases.DateRangePickerInputPhrases,
  isRTL: false
};

function DateRangePickerInput(_ref) {
  var children = _ref.children,
      startDate = _ref.startDate,
      startDateId = _ref.startDateId,
      startDatePlaceholderText = _ref.startDatePlaceholderText,
      screenReaderMessage = _ref.screenReaderMessage,
      isStartDateFocused = _ref.isStartDateFocused,
      onStartDateChange = _ref.onStartDateChange,
      onStartDateFocus = _ref.onStartDateFocus,
      onStartDateShiftTab = _ref.onStartDateShiftTab,
      startDateAriaLabel = _ref.startDateAriaLabel,
      endDate = _ref.endDate,
      endDateId = _ref.endDateId,
      endDatePlaceholderText = _ref.endDatePlaceholderText,
      isEndDateFocused = _ref.isEndDateFocused,
      onEndDateChange = _ref.onEndDateChange,
      onEndDateFocus = _ref.onEndDateFocus,
      onEndDateTab = _ref.onEndDateTab,
      endDateAriaLabel = _ref.endDateAriaLabel,
      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
      onClearDates = _ref.onClearDates,
      showClearDates = _ref.showClearDates,
      disabled = _ref.disabled,
      required = _ref.required,
      readOnly = _ref.readOnly,
      showCaret = _ref.showCaret,
      openDirection = _ref.openDirection,
      showDefaultInputIcon = _ref.showDefaultInputIcon,
      inputIconPosition = _ref.inputIconPosition,
      customInputIcon = _ref.customInputIcon,
      customArrowIcon = _ref.customArrowIcon,
      customCloseIcon = _ref.customCloseIcon,
      isFocused = _ref.isFocused,
      phrases = _ref.phrases,
      isRTL = _ref.isRTL,
      noBorder = _ref.noBorder,
      block = _ref.block,
      verticalSpacing = _ref.verticalSpacing,
      small = _ref.small,
      regular = _ref.regular,
      styles = _ref.styles;

  var calendarIcon = customInputIcon || _react["default"].createElement(_CalendarIcon["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_calendarIcon_svg));

  var arrowIcon = customArrowIcon || _react["default"].createElement(_RightArrow["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_arrow_svg));

  if (isRTL) arrowIcon = _react["default"].createElement(_LeftArrow["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_arrow_svg));
  if (small) arrowIcon = '-';

  var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.DateRangePickerInput_clearDates_svg, small && styles.DateRangePickerInput_clearDates_svg__small));

  var screenReaderStartDateText = screenReaderMessage || phrases.keyboardForwardNavigationInstructions;
  var screenReaderEndDateText = screenReaderMessage || phrases.keyboardBackwardNavigationInstructions;

  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateRangePickerInput_calendarIcon), {
    type: "button",
    disabled: disabled,
    "aria-label": phrases.focusStartDate,
    onClick: onKeyDownArrowDown
  }), calendarIcon);

  var startDateDisabled = disabled === constants$1.START_DATE || disabled === true;
  var endDateDisabled = disabled === constants$1.END_DATE || disabled === true;
  return _react["default"].createElement("div", (0, withStyles_1.css)(styles.DateRangePickerInput, disabled && styles.DateRangePickerInput__disabled, isRTL && styles.DateRangePickerInput__rtl, !noBorder && styles.DateRangePickerInput__withBorder, block && styles.DateRangePickerInput__block, showClearDates && styles.DateRangePickerInput__showClearDates), inputIconPosition === constants$1.ICON_BEFORE_POSITION && inputIcon, _react["default"].createElement(_DateInput["default"], {
    id: startDateId,
    placeholder: startDatePlaceholderText,
    ariaLabel: startDateAriaLabel,
    displayValue: startDate,
    screenReaderMessage: screenReaderStartDateText,
    focused: isStartDateFocused,
    isFocused: isFocused,
    disabled: startDateDisabled,
    required: required,
    readOnly: readOnly,
    showCaret: showCaret,
    openDirection: openDirection,
    onChange: onStartDateChange,
    onFocus: onStartDateFocus,
    onKeyDownShiftTab: onStartDateShiftTab,
    onKeyDownArrowDown: onKeyDownArrowDown,
    onKeyDownQuestionMark: onKeyDownQuestionMark,
    verticalSpacing: verticalSpacing,
    small: small,
    regular: regular
  }), children, _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateRangePickerInput_arrow), {
    "aria-hidden": "true",
    role: "presentation"
  }), arrowIcon), _react["default"].createElement(_DateInput["default"], {
    id: endDateId,
    placeholder: endDatePlaceholderText,
    ariaLabel: endDateAriaLabel,
    displayValue: endDate,
    screenReaderMessage: screenReaderEndDateText,
    focused: isEndDateFocused,
    isFocused: isFocused,
    disabled: endDateDisabled,
    required: required,
    readOnly: readOnly,
    showCaret: showCaret,
    openDirection: openDirection,
    onChange: onEndDateChange,
    onFocus: onEndDateFocus,
    onKeyDownArrowDown: onKeyDownArrowDown,
    onKeyDownQuestionMark: onKeyDownQuestionMark,
    onKeyDownTab: onEndDateTab,
    verticalSpacing: verticalSpacing,
    small: small,
    regular: regular
  }), showClearDates && _react["default"].createElement("button", (0, _extends2["default"])({
    type: "button",
    "aria-label": phrases.clearDates
  }, (0, withStyles_1.css)(styles.DateRangePickerInput_clearDates, small && styles.DateRangePickerInput_clearDates__small, !customCloseIcon && styles.DateRangePickerInput_clearDates_default, !(startDate || endDate) && styles.DateRangePickerInput_clearDates__hide), {
    onClick: onClearDates,
    disabled: disabled
  }), closeIcon), inputIconPosition === constants$1.ICON_AFTER_POSITION && inputIcon);
}

DateRangePickerInput.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DateRangePickerInput.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      border = _ref2$reactDates.border,
      color = _ref2$reactDates.color,
      sizing = _ref2$reactDates.sizing;
  return {
    DateRangePickerInput: {
      backgroundColor: color.background,
      display: 'inline-block'
    },
    DateRangePickerInput__disabled: {
      background: color.disabled
    },
    DateRangePickerInput__withBorder: {
      borderColor: color.border,
      borderWidth: border.pickerInput.borderWidth,
      borderStyle: border.pickerInput.borderStyle,
      borderRadius: border.pickerInput.borderRadius
    },
    DateRangePickerInput__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    DateRangePickerInput__block: {
      display: 'block'
    },
    DateRangePickerInput__showClearDates: {
      paddingRight: 30 // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    DateRangePickerInput_arrow: {
      display: 'inline-block',
      verticalAlign: 'middle',
      color: color.text
    },
    DateRangePickerInput_arrow_svg: {
      verticalAlign: 'middle',
      fill: color.text,
      height: sizing.arrowWidth,
      width: sizing.arrowWidth
    },
    DateRangePickerInput_clearDates: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      padding: 10,
      margin: '0 10px 0 5px',
      // TODO: should be noflip wrapped and handled by an isRTL prop
      position: 'absolute',
      right: 0,
      // TODO: should be noflip wrapped and handled by an isRTL prop
      top: '50%',
      transform: 'translateY(-50%)'
    },
    DateRangePickerInput_clearDates__small: {
      padding: 6
    },
    DateRangePickerInput_clearDates_default: {
      ':focus': {
        background: color.core.border,
        borderRadius: '50%'
      },
      ':hover': {
        background: color.core.border,
        borderRadius: '50%'
      }
    },
    DateRangePickerInput_clearDates__hide: {
      visibility: 'hidden'
    },
    DateRangePickerInput_clearDates_svg: {
      fill: color.core.grayLight,
      height: 12,
      width: 15,
      verticalAlign: 'middle'
    },
    DateRangePickerInput_clearDates_svg__small: {
      height: 9
    },
    DateRangePickerInput_calendarIcon: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: 10,
      margin: '0 5px 0 10px' // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    DateRangePickerInput_calendarIcon_svg: {
      fill: color.core.grayLight,
      height: 15,
      width: 14,
      verticalAlign: 'middle'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DateRangePickerInput);

exports["default"] = _default;
});

unwrapExports(DateRangePickerInput_1);

var toLocalizedDateString_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toLocalizedDateString;

var _moment = interopRequireDefault(hooks);

var _toMomentObject = interopRequireDefault(toMomentObject_1);



function toLocalizedDateString(date, currentFormat) {
  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
  if (!dateObj) return null;
  return dateObj.format(constants$1.DISPLAY_FORMAT);
}
});

unwrapExports(toLocalizedDateString_1);

var DateRangePickerInputController_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);

var _moment = interopRequireDefault(hooks);

var _reactMomentProptypes = interopRequireDefault(src$1);



var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _DateRangePickerInput = interopRequireDefault(DateRangePickerInput_1);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _DisabledShape = interopRequireDefault(DisabledShape);

var _toMomentObject = interopRequireDefault(toMomentObject_1);

var _toLocalizedDateString = interopRequireDefault(toLocalizedDateString_1);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);

var _isBeforeDay = interopRequireDefault(isBeforeDay_1);



var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
  children: _propTypes["default"].node,
  startDate: _reactMomentProptypes["default"].momentObj,
  startDateId: _propTypes["default"].string,
  startDatePlaceholderText: _propTypes["default"].string,
  isStartDateFocused: _propTypes["default"].bool,
  startDateAriaLabel: _propTypes["default"].string,
  endDate: _reactMomentProptypes["default"].momentObj,
  endDateId: _propTypes["default"].string,
  endDatePlaceholderText: _propTypes["default"].string,
  isEndDateFocused: _propTypes["default"].bool,
  endDateAriaLabel: _propTypes["default"].string,
  screenReaderMessage: _propTypes["default"].string,
  showClearDates: _propTypes["default"].bool,
  showCaret: _propTypes["default"].bool,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  disabled: _DisabledShape["default"],
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  reopenPickerOnClearDates: _propTypes["default"].bool,
  withFullScreenPortal: _propTypes["default"].bool,
  minimumNights: airbnbPropTypes.nonNegativeInteger,
  isOutsideRange: _propTypes["default"].func,
  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  onFocusChange: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onDatesChange: _propTypes["default"].func,
  onKeyDownArrowDown: _propTypes["default"].func,
  onKeyDownQuestionMark: _propTypes["default"].func,
  customInputIcon: _propTypes["default"].node,
  customArrowIcon: _propTypes["default"].node,
  customCloseIcon: _propTypes["default"].node,
  // accessibility
  isFocused: _propTypes["default"].bool,
  // i18n
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DateRangePickerInputPhrases)),
  isRTL: _propTypes["default"].bool
}) : {};
var defaultProps = {
  children: null,
  startDate: null,
  startDateId: constants$1.START_DATE,
  startDatePlaceholderText: 'Start Date',
  isStartDateFocused: false,
  startDateAriaLabel: undefined,
  endDate: null,
  endDateId: constants$1.END_DATE,
  endDatePlaceholderText: 'End Date',
  isEndDateFocused: false,
  endDateAriaLabel: undefined,
  screenReaderMessage: '',
  showClearDates: false,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$1.ICON_BEFORE_POSITION,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: constants$1.OPEN_DOWN,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  withFullScreenPortal: false,
  minimumNights: 1,
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  onFocusChange: function onFocusChange() {},
  onClose: function onClose() {},
  onDatesChange: function onDatesChange() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,
  // accessibility
  isFocused: false,
  // i18n
  phrases: defaultPhrases.DateRangePickerInputPhrases,
  isRTL: false
};

var DateRangePickerInputController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DateRangePickerInputController, _ref);
  var _proto = DateRangePickerInputController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DateRangePickerInputController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.onClearFocus = _this.onClearFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onStartDateChange = _this.onStartDateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onStartDateFocus = _this.onStartDateFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onEndDateChange = _this.onEndDateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onEndDateFocus = _this.onEndDateFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearDates = _this.clearDates.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.onClearFocus = function onClearFocus() {
    var _this$props = this.props,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate;
    onFocusChange(null);
    onClose({
      startDate: startDate,
      endDate: endDate
    });
  };

  _proto.onEndDateChange = function onEndDateChange(endDateString) {
    var _this$props2 = this.props,
        startDate = _this$props2.startDate,
        isOutsideRange = _this$props2.isOutsideRange,
        minimumNights = _this$props2.minimumNights,
        keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
        onDatesChange = _this$props2.onDatesChange;
    var endDate = (0, _toMomentObject["default"])(endDateString, this.getDisplayFormat());
    var isEndDateValid = endDate && !isOutsideRange(endDate) && !(startDate && (0, _isBeforeDay["default"])(endDate, startDate.clone().add(minimumNights, 'days')));

    if (isEndDateValid) {
      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
      if (!keepOpenOnDateSelect) this.onClearFocus();
    } else {
      onDatesChange({
        startDate: startDate,
        endDate: null
      });
    }
  };

  _proto.onEndDateFocus = function onEndDateFocus() {
    var _this$props3 = this.props,
        startDate = _this$props3.startDate,
        onFocusChange = _this$props3.onFocusChange,
        withFullScreenPortal = _this$props3.withFullScreenPortal,
        disabled = _this$props3.disabled;

    if (!startDate && withFullScreenPortal && (!disabled || disabled === constants$1.END_DATE)) {
      // When the datepicker is full screen, we never want to focus the end date first
      // because there's no indication that that is the case once the datepicker is open and it
      // might confuse the user
      onFocusChange(constants$1.START_DATE);
    } else if (!disabled || disabled === constants$1.START_DATE) {
      onFocusChange(constants$1.END_DATE);
    }
  };

  _proto.onStartDateChange = function onStartDateChange(startDateString) {
    var endDate = this.props.endDate;
    var _this$props4 = this.props,
        isOutsideRange = _this$props4.isOutsideRange,
        minimumNights = _this$props4.minimumNights,
        onDatesChange = _this$props4.onDatesChange,
        onFocusChange = _this$props4.onFocusChange,
        disabled = _this$props4.disabled;
    var startDate = (0, _toMomentObject["default"])(startDateString, this.getDisplayFormat());
    var isEndDateBeforeStartDate = startDate && (0, _isBeforeDay["default"])(endDate, startDate.clone().add(minimumNights, 'days'));
    var isStartDateValid = startDate && !isOutsideRange(startDate) && !(disabled === constants$1.END_DATE && isEndDateBeforeStartDate);

    if (isStartDateValid) {
      if (isEndDateBeforeStartDate) {
        endDate = null;
      }

      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
      onFocusChange(constants$1.END_DATE);
    } else {
      onDatesChange({
        startDate: null,
        endDate: endDate
      });
    }
  };

  _proto.onStartDateFocus = function onStartDateFocus() {
    var _this$props5 = this.props,
        disabled = _this$props5.disabled,
        onFocusChange = _this$props5.onFocusChange;

    if (!disabled || disabled === constants$1.END_DATE) {
      onFocusChange(constants$1.START_DATE);
    }
  };

  _proto.getDisplayFormat = function getDisplayFormat() {
    var displayFormat = this.props.displayFormat;
    return typeof displayFormat === 'string' ? displayFormat : displayFormat();
  };

  _proto.getDateString = function getDateString(date) {
    var displayFormat = this.getDisplayFormat();

    if (date && displayFormat) {
      return date && date.format(displayFormat);
    }

    return (0, _toLocalizedDateString["default"])(date);
  };

  _proto.clearDates = function clearDates() {
    var _this$props6 = this.props,
        onDatesChange = _this$props6.onDatesChange,
        reopenPickerOnClearDates = _this$props6.reopenPickerOnClearDates,
        onFocusChange = _this$props6.onFocusChange;
    onDatesChange({
      startDate: null,
      endDate: null
    });

    if (reopenPickerOnClearDates) {
      onFocusChange(constants$1.START_DATE);
    }
  };

  _proto.render = function render() {
    var _this$props7 = this.props,
        children = _this$props7.children,
        startDate = _this$props7.startDate,
        startDateId = _this$props7.startDateId,
        startDatePlaceholderText = _this$props7.startDatePlaceholderText,
        isStartDateFocused = _this$props7.isStartDateFocused,
        startDateAriaLabel = _this$props7.startDateAriaLabel,
        endDate = _this$props7.endDate,
        endDateId = _this$props7.endDateId,
        endDatePlaceholderText = _this$props7.endDatePlaceholderText,
        endDateAriaLabel = _this$props7.endDateAriaLabel,
        isEndDateFocused = _this$props7.isEndDateFocused,
        screenReaderMessage = _this$props7.screenReaderMessage,
        showClearDates = _this$props7.showClearDates,
        showCaret = _this$props7.showCaret,
        showDefaultInputIcon = _this$props7.showDefaultInputIcon,
        inputIconPosition = _this$props7.inputIconPosition,
        customInputIcon = _this$props7.customInputIcon,
        customArrowIcon = _this$props7.customArrowIcon,
        customCloseIcon = _this$props7.customCloseIcon,
        disabled = _this$props7.disabled,
        required = _this$props7.required,
        readOnly = _this$props7.readOnly,
        openDirection = _this$props7.openDirection,
        isFocused = _this$props7.isFocused,
        phrases = _this$props7.phrases,
        onKeyDownArrowDown = _this$props7.onKeyDownArrowDown,
        onKeyDownQuestionMark = _this$props7.onKeyDownQuestionMark,
        isRTL = _this$props7.isRTL,
        noBorder = _this$props7.noBorder,
        block = _this$props7.block,
        small = _this$props7.small,
        regular = _this$props7.regular,
        verticalSpacing = _this$props7.verticalSpacing;
    var startDateString = this.getDateString(startDate);
    var endDateString = this.getDateString(endDate);
    return _react["default"].createElement(_DateRangePickerInput["default"], {
      startDate: startDateString,
      startDateId: startDateId,
      startDatePlaceholderText: startDatePlaceholderText,
      isStartDateFocused: isStartDateFocused,
      startDateAriaLabel: startDateAriaLabel,
      endDate: endDateString,
      endDateId: endDateId,
      endDatePlaceholderText: endDatePlaceholderText,
      isEndDateFocused: isEndDateFocused,
      endDateAriaLabel: endDateAriaLabel,
      isFocused: isFocused,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      showCaret: showCaret,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      customInputIcon: customInputIcon,
      customArrowIcon: customArrowIcon,
      customCloseIcon: customCloseIcon,
      phrases: phrases,
      onStartDateChange: this.onStartDateChange,
      onStartDateFocus: this.onStartDateFocus,
      onStartDateShiftTab: this.onClearFocus,
      onEndDateChange: this.onEndDateChange,
      onEndDateFocus: this.onEndDateFocus,
      showClearDates: showClearDates,
      onClearDates: this.clearDates,
      screenReaderMessage: screenReaderMessage,
      onKeyDownArrowDown: onKeyDownArrowDown,
      onKeyDownQuestionMark: onKeyDownQuestionMark,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing
    }, children);
  };

  return DateRangePickerInputController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = DateRangePickerInputController;
DateRangePickerInputController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DateRangePickerInputController.defaultProps = defaultProps;
});

unwrapExports(DateRangePickerInputController_1);

function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles$3;

function _iterableToArrayLimit$3(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit$3;

function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableRest = _nonIterableRest$3;

function _slicedToArray$3(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray$3;

var isNextDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isNextDay;

var _moment = interopRequireDefault(hooks);

var _isSameDay = interopRequireDefault(isSameDay_1);

function isNextDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  var nextDay = (0, _moment["default"])(a).add(1, 'day');
  return (0, _isSameDay["default"])(nextDay, b);
}
});

unwrapExports(isNextDay_1);

var isAfterDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAfterDay;

var _moment = interopRequireDefault(hooks);

var _isBeforeDay = interopRequireDefault(isBeforeDay_1);

var _isSameDay = interopRequireDefault(isSameDay_1);

function isAfterDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return !(0, _isBeforeDay["default"])(a, b) && !(0, _isSameDay["default"])(a, b);
}
});

unwrapExports(isAfterDay_1);

var isPreviousDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPreviousDay;

var _moment = interopRequireDefault(hooks);

var _isSameDay = interopRequireDefault(isSameDay_1);

function isPreviousDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  var dayBefore = (0, _moment["default"])(a).subtract(1, 'day');
  return (0, _isSameDay["default"])(dayBefore, b);
}
});

unwrapExports(isPreviousDay_1);

var getVisibleDays_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getVisibleDays;

var _moment = interopRequireDefault(hooks);

var _toISOMonthString = interopRequireDefault(toISOMonthString_1);

function getVisibleDays(month, numberOfMonths, enableOutsideDays, withoutTransitionMonths) {
  if (!_moment["default"].isMoment(month)) return {};
  var visibleDaysByMonth = {};
  var currentMonth = withoutTransitionMonths ? month.clone() : month.clone().subtract(1, 'month');

  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    var visibleDays = []; // set utc offset to get correct dates in future (when timezone changes)

    var baseDate = currentMonth.clone();
    var firstOfMonth = baseDate.clone().startOf('month').hour(12);
    var lastOfMonth = baseDate.clone().endOf('month').hour(12);
    var currentDay = firstOfMonth.clone(); // days belonging to the previous month

    if (enableOutsideDays) {
      for (var j = 0; j < currentDay.weekday(); j += 1) {
        var prevDay = currentDay.clone().subtract(j + 1, 'day');
        visibleDays.unshift(prevDay);
      }
    }

    while (currentDay < lastOfMonth) {
      visibleDays.push(currentDay.clone());
      currentDay.add(1, 'day');
    }

    if (enableOutsideDays) {
      // weekday() returns the index of the day of the week according to the locale
      // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
      if (currentDay.weekday() !== 0) {
        // days belonging to the next month
        for (var k = currentDay.weekday(), count = 0; k < 7; k += 1, count += 1) {
          var nextDay = currentDay.clone().add(count, 'day');
          visibleDays.push(nextDay);
        }
      }
    }

    visibleDaysByMonth[(0, _toISOMonthString["default"])(currentMonth)] = visibleDays;
    currentMonth = currentMonth.clone().add(1, 'month');
  }

  return visibleDaysByMonth;
}
});

unwrapExports(getVisibleDays_1);

var isDayVisible_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isDayVisible;

var _moment = interopRequireDefault(hooks);

var _isBeforeDay = interopRequireDefault(isBeforeDay_1);

var _isAfterDay = interopRequireDefault(isAfterDay_1);

var _toISOMonthString = interopRequireDefault(toISOMonthString_1);

var startCacheOutsideDays = new Map();
var endCacheOutsideDays = new Map();
var startCacheInsideDays = new Map();
var endCacheInsideDays = new Map();

function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
  if (!_moment["default"].isMoment(day)) return false; // Cloning is a little expensive, so we want to do it as little as possible.

  var startKey = (0, _toISOMonthString["default"])(month); // eslint-disable-next-line prefer-template

  var endKey = startKey + '+' + numberOfMonths;

  if (enableOutsideDays) {
    if (!startCacheOutsideDays.has(startKey)) {
      startCacheOutsideDays.set(startKey, month.clone().startOf('month').startOf('week'));
    }

    if ((0, _isBeforeDay["default"])(day, startCacheOutsideDays.get(startKey))) return false;

    if (!endCacheOutsideDays.has(endKey)) {
      endCacheOutsideDays.set(endKey, month.clone().endOf('week').add(numberOfMonths - 1, 'months').endOf('month').endOf('week'));
    }

    return !(0, _isAfterDay["default"])(day, endCacheOutsideDays.get(endKey));
  } // !enableOutsideDays


  if (!startCacheInsideDays.has(startKey)) {
    startCacheInsideDays.set(startKey, month.clone().startOf('month'));
  }

  if ((0, _isBeforeDay["default"])(day, startCacheInsideDays.get(startKey))) return false;

  if (!endCacheInsideDays.has(endKey)) {
    endCacheInsideDays.set(endKey, month.clone().add(numberOfMonths - 1, 'months').endOf('month'));
  }

  return !(0, _isAfterDay["default"])(day, endCacheInsideDays.get(endKey));
}
});

unwrapExports(isDayVisible_1);

var getSelectedDateOffset_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSelectedDateOffset;

var defaultModifier = function defaultModifier(day) {
  return day;
};

function getSelectedDateOffset(fn, day) {
  var modifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModifier;
  if (!fn) return day;
  return modifier(fn(day.clone()));
}
});

unwrapExports(getSelectedDateOffset_1);

var getPreviousMonthMemoLast_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPreviousMonthMemoLast;
var getPreviousMonthMemoKey;
var getPreviousMonthMemoValue;

function getPreviousMonthMemoLast(month) {
  if (month !== getPreviousMonthMemoKey) {
    getPreviousMonthMemoKey = month;
    getPreviousMonthMemoValue = month.clone().subtract(1, 'month');
  }

  return getPreviousMonthMemoValue;
}
});

unwrapExports(getPreviousMonthMemoLast_1);

var modifiers$1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addModifier = addModifier;
exports.deleteModifier = deleteModifier;

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _isDayVisible = interopRequireDefault(isDayVisible_1);

var _toISODateString = interopRequireDefault(toISODateString_1);

var _toISOMonthString = interopRequireDefault(toISOMonthString_1);

var _getPreviousMonthMemoLast = interopRequireDefault(getPreviousMonthMemoLast_1);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function addModifier(updatedDays, day, modifier, props, state) {
  var numberOfVisibleMonths = props.numberOfMonths,
      enableOutsideDays = props.enableOutsideDays,
      orientation = props.orientation;
  var firstVisibleMonth = state.currentMonth,
      visibleDays = state.visibleDays;
  var currentMonth = firstVisibleMonth;
  var numberOfMonths = numberOfVisibleMonths;

  if (orientation === constants$1.VERTICAL_SCROLLABLE) {
    numberOfMonths = Object.keys(visibleDays).length;
  } else {
    currentMonth = (0, _getPreviousMonthMemoLast["default"])(currentMonth);
    numberOfMonths += 2;
  }

  if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
    return updatedDays;
  }

  var iso = (0, _toISODateString["default"])(day);

  var updatedDaysAfterAddition = _objectSpread({}, updatedDays);

  if (enableOutsideDays) {
    var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
      return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
    });
    updatedDaysAfterAddition = monthsToUpdate.reduce(function (acc, monthIso) {
      var month = updatedDays[monthIso] || visibleDays[monthIso];

      if (!month[iso] || !month[iso].has(modifier)) {
        var modifiers = new Set(month[iso]);
        modifiers.add(modifier);
        acc[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
      }

      return acc;
    }, updatedDaysAfterAddition);
  } else {
    var monthIso = (0, _toISOMonthString["default"])(day);
    var month = updatedDays[monthIso] || visibleDays[monthIso] || {};

    if (!month[iso] || !month[iso].has(modifier)) {
      var modifiers = new Set(month[iso]);
      modifiers.add(modifier);
      updatedDaysAfterAddition[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
    }
  }

  return updatedDaysAfterAddition;
}

function deleteModifier(updatedDays, day, modifier, props, state) {
  var numberOfVisibleMonths = props.numberOfMonths,
      enableOutsideDays = props.enableOutsideDays,
      orientation = props.orientation;
  var firstVisibleMonth = state.currentMonth,
      visibleDays = state.visibleDays;
  var currentMonth = firstVisibleMonth;
  var numberOfMonths = numberOfVisibleMonths;

  if (orientation === constants$1.VERTICAL_SCROLLABLE) {
    numberOfMonths = Object.keys(visibleDays).length;
  } else {
    currentMonth = (0, _getPreviousMonthMemoLast["default"])(currentMonth);
    numberOfMonths += 2;
  }

  if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
    return updatedDays;
  }

  var iso = (0, _toISODateString["default"])(day);

  var updatedDaysAfterDeletion = _objectSpread({}, updatedDays);

  if (enableOutsideDays) {
    var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
      return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
    });
    updatedDaysAfterDeletion = monthsToUpdate.reduce(function (acc, monthIso) {
      var month = updatedDays[monthIso] || visibleDays[monthIso];

      if (month[iso] && month[iso].has(modifier)) {
        var modifiers = new Set(month[iso]);
        modifiers["delete"](modifier);
        acc[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
      }

      return acc;
    }, updatedDaysAfterDeletion);
  } else {
    var monthIso = (0, _toISOMonthString["default"])(day);
    var month = updatedDays[monthIso] || visibleDays[monthIso] || {};

    if (month[iso] && month[iso].has(modifier)) {
      var modifiers = new Set(month[iso]);
      modifiers["delete"](modifier);
      updatedDaysAfterDeletion[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
    }
  }

  return updatedDaysAfterDeletion;
}
});

unwrapExports(modifiers$1);
var modifiers_1 = modifiers$1.addModifier;
var modifiers_2 = modifiers$1.deleteModifier;

var ChevronUp_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React__default['default']);

var ChevronUp = function ChevronUp(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M32 713l453-453c11-11 21-11 32 0l453 453c5 5 7 10 7 16 0 13-10 23-22 23-7 0-12-2-16-7L501 309 64 745c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32z"
  }));
};

ChevronUp.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = ChevronUp;
exports["default"] = _default;
});

unwrapExports(ChevronUp_1);

var ChevronDown_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = interopRequireDefault(React__default['default']);

var ChevronDown = function ChevronDown(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M968 289L514 741c-11 11-21 11-32 0L29 289c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437 436 438-436c4-5 9-7 16-7 6 0 11 2 16 7 9 10 9 21 0 32z"
  }));
};

ChevronDown.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = ChevronDown;
exports["default"] = _default;
});

unwrapExports(ChevronDown_1);

var DayPickerNavigation_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _toConsumableArray2 = interopRequireDefault(toConsumableArray);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);







var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _noflip = interopRequireDefault(noflip_1);

var _LeftArrow = interopRequireDefault(LeftArrow_1);

var _RightArrow = interopRequireDefault(RightArrow_1);

var _ChevronUp = interopRequireDefault(ChevronUp_1);

var _ChevronDown = interopRequireDefault(ChevronDown_1);

var _NavPositionShape = interopRequireDefault(NavPositionShape);

var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  disablePrev: _propTypes["default"].bool,
  disableNext: _propTypes["default"].bool,
  inlineStyles: _propTypes["default"].object,
  isRTL: _propTypes["default"].bool,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  orientation: _ScrollableOrientationShape["default"],
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  // internationalization
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerNavigationPhrases)),
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  showNavPrevButton: _propTypes["default"].bool,
  showNavNextButton: _propTypes["default"].bool
})) : {};
var defaultProps = {
  disablePrev: false,
  disableNext: false,
  inlineStyles: null,
  isRTL: false,
  navPosition: constants$1.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  orientation: constants$1.HORIZONTAL_ORIENTATION,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  // internationalization
  phrases: defaultPhrases.DayPickerNavigationPhrases,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  showNavPrevButton: true,
  showNavNextButton: true
};

var DayPickerNavigation =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerNavigation, _ref);

  function DayPickerNavigation() {
    return _ref.apply(this, arguments) || this;
  }

  var _proto = DayPickerNavigation.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        inlineStyles = _this$props.inlineStyles,
        isRTL = _this$props.isRTL,
        disablePrev = _this$props.disablePrev,
        disableNext = _this$props.disableNext,
        navPosition = _this$props.navPosition,
        navPrev = _this$props.navPrev,
        navNext = _this$props.navNext,
        onPrevMonthClick = _this$props.onPrevMonthClick,
        onNextMonthClick = _this$props.onNextMonthClick,
        orientation = _this$props.orientation,
        phrases = _this$props.phrases,
        renderNavPrevButton = _this$props.renderNavPrevButton,
        renderNavNextButton = _this$props.renderNavNextButton,
        showNavPrevButton = _this$props.showNavPrevButton,
        showNavNextButton = _this$props.showNavNextButton,
        styles = _this$props.styles;

    if (!showNavNextButton && !showNavPrevButton) {
      return null;
    }

    var isHorizontal = orientation === constants$1.HORIZONTAL_ORIENTATION;
    var isVertical = orientation !== constants$1.HORIZONTAL_ORIENTATION;
    var isVerticalScrollable = orientation === constants$1.VERTICAL_SCROLLABLE;
    var isBottomNavPosition = navPosition === constants$1.NAV_POSITION_BOTTOM;
    var hasInlineStyles = !!inlineStyles;
    var navPrevIcon = navPrev;
    var navNextIcon = navNext;
    var isDefaultNavPrev = false;
    var isDefaultNavNext = false;
    var navPrevTabIndex = {};
    var navNextTabIndex = {};

    if (!navPrevIcon && !renderNavPrevButton && showNavPrevButton) {
      navPrevTabIndex = {
        tabIndex: '0'
      };
      isDefaultNavPrev = true;
      var Icon = isVertical ? _ChevronUp["default"] : _LeftArrow["default"];

      if (isRTL && !isVertical) {
        Icon = _RightArrow["default"];
      }

      navPrevIcon = _react["default"].createElement(Icon, (0, withStyles_1.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical, disablePrev && styles.DayPickerNavigation_svg__disabled));
    }

    if (!navNextIcon && !renderNavNextButton && showNavNextButton) {
      navNextTabIndex = {
        tabIndex: '0'
      };
      isDefaultNavNext = true;

      var _Icon = isVertical ? _ChevronDown["default"] : _RightArrow["default"];

      if (isRTL && !isVertical) {
        _Icon = _LeftArrow["default"];
      }

      navNextIcon = _react["default"].createElement(_Icon, (0, withStyles_1.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical, disableNext && styles.DayPickerNavigation_svg__disabled));
    }

    var isDefaultNav = isDefaultNavNext || isDefaultNavPrev;
    return _react["default"].createElement("div", withStyles_1.css.apply(void 0, [styles.DayPickerNavigation, isHorizontal && styles.DayPickerNavigation__horizontal].concat((0, _toConsumableArray2["default"])(isVertical ? [styles.DayPickerNavigation__vertical, isDefaultNav && styles.DayPickerNavigation__verticalDefault] : []), (0, _toConsumableArray2["default"])(isVerticalScrollable ? [styles.DayPickerNavigation__verticalScrollable, isDefaultNav && styles.DayPickerNavigation__verticalScrollableDefault, showNavPrevButton && styles.DayPickerNavigation__verticalScrollable_prevNav] : []), (0, _toConsumableArray2["default"])(isBottomNavPosition ? [styles.DayPickerNavigation__bottom, isDefaultNav && styles.DayPickerNavigation__bottomDefault] : []), [hasInlineStyles && inlineStyles])), showNavPrevButton && (renderNavPrevButton ? renderNavPrevButton({
      ariaLabel: phrases.jumpToPrevMonth,
      disabled: disablePrev,
      onClick: disablePrev ? undefined : onPrevMonthClick,
      onKeyUp: disablePrev ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onPrevMonthClick(e);
        }
      },
      onMouseUp: disablePrev ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }) : _react["default"].createElement("div", (0, _extends2["default"])({
      // eslint-disable-line jsx-a11y/interactive-supports-focus
      role: "button"
    }, navPrevTabIndex, withStyles_1.css.apply(void 0, [styles.DayPickerNavigation_button, isDefaultNavPrev && styles.DayPickerNavigation_button__default, disablePrev && styles.DayPickerNavigation_button__disabled].concat((0, _toConsumableArray2["default"])(isHorizontal ? [styles.DayPickerNavigation_button__horizontal].concat((0, _toConsumableArray2["default"])(isDefaultNavPrev ? [styles.DayPickerNavigation_button__horizontalDefault, isBottomNavPosition && styles.DayPickerNavigation_bottomButton__horizontalDefault, !isRTL && styles.DayPickerNavigation_leftButton__horizontalDefault, isRTL && styles.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), (0, _toConsumableArray2["default"])(isVertical ? [styles.DayPickerNavigation_button__vertical].concat((0, _toConsumableArray2["default"])(isDefaultNavPrev ? [styles.DayPickerNavigation_button__verticalDefault, styles.DayPickerNavigation_prevButton__verticalDefault, isVerticalScrollable && styles.DayPickerNavigation_prevButton__verticalScrollableDefault] : [])) : []))), {
      "aria-disabled": disablePrev ? true : undefined,
      "aria-label": phrases.jumpToPrevMonth,
      onClick: disablePrev ? undefined : onPrevMonthClick,
      onKeyUp: disablePrev ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onPrevMonthClick(e);
        }
      },
      onMouseUp: disablePrev ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }), navPrevIcon)), showNavNextButton && (renderNavNextButton ? renderNavNextButton({
      ariaLabel: phrases.jumpToNextMonth,
      disabled: disableNext,
      onClick: disableNext ? undefined : onNextMonthClick,
      onKeyUp: disableNext ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onNextMonthClick(e);
        }
      },
      onMouseUp: disableNext ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }) : _react["default"].createElement("div", (0, _extends2["default"])({
      // eslint-disable-line jsx-a11y/interactive-supports-focus
      role: "button"
    }, navNextTabIndex, withStyles_1.css.apply(void 0, [styles.DayPickerNavigation_button, isDefaultNavNext && styles.DayPickerNavigation_button__default, disableNext && styles.DayPickerNavigation_button__disabled].concat((0, _toConsumableArray2["default"])(isHorizontal ? [styles.DayPickerNavigation_button__horizontal].concat((0, _toConsumableArray2["default"])(isDefaultNavNext ? [styles.DayPickerNavigation_button__horizontalDefault, isBottomNavPosition && styles.DayPickerNavigation_bottomButton__horizontalDefault, isRTL && styles.DayPickerNavigation_leftButton__horizontalDefault, !isRTL && styles.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), (0, _toConsumableArray2["default"])(isVertical ? [styles.DayPickerNavigation_button__vertical].concat((0, _toConsumableArray2["default"])(isDefaultNavNext ? [styles.DayPickerNavigation_button__verticalDefault, styles.DayPickerNavigation_nextButton__verticalDefault, isVerticalScrollable && styles.DayPickerNavigation_nextButton__verticalScrollableDefault] : [])) : []))), {
      "aria-disabled": disableNext ? true : undefined,
      "aria-label": phrases.jumpToNextMonth,
      onClick: disableNext ? undefined : onNextMonthClick,
      onKeyUp: disableNext ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onNextMonthClick(e);
        }
      },
      onMouseUp: disableNext ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }), navNextIcon)));
  };

  return DayPickerNavigation;
}(_react["default"].PureComponent || _react["default"].Component);

DayPickerNavigation.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPickerNavigation.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      zIndex = _ref2$reactDates.zIndex;
  return {
    DayPickerNavigation: {
      position: 'relative',
      zIndex: zIndex + 2
    },
    DayPickerNavigation__horizontal: {
      height: 0
    },
    DayPickerNavigation__vertical: {},
    DayPickerNavigation__verticalScrollable: {},
    DayPickerNavigation__verticalScrollable_prevNav: {
      zIndex: zIndex + 1 // zIndex + 2 causes the button to show on top of the day of week headers

    },
    DayPickerNavigation__verticalDefault: {
      position: 'absolute',
      width: '100%',
      height: 52,
      bottom: 0,
      left: (0, _noflip["default"])(0)
    },
    DayPickerNavigation__verticalScrollableDefault: {
      position: 'relative'
    },
    DayPickerNavigation__bottom: {
      height: 'auto'
    },
    DayPickerNavigation__bottomDefault: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    DayPickerNavigation_button: {
      cursor: 'pointer',
      userSelect: 'none',
      border: 0,
      padding: 0,
      margin: 0
    },
    DayPickerNavigation_button__default: {
      border: "1px solid ".concat(color.core.borderLight),
      backgroundColor: color.background,
      color: color.placeholderText,
      ':focus': {
        border: "1px solid ".concat(color.core.borderMedium)
      },
      ':hover': {
        border: "1px solid ".concat(color.core.borderMedium)
      },
      ':active': {
        background: color.backgroundDark
      }
    },
    DayPickerNavigation_button__disabled: {
      cursor: 'default',
      border: "1px solid ".concat(color.disabled),
      ':focus': {
        border: "1px solid ".concat(color.disabled)
      },
      ':hover': {
        border: "1px solid ".concat(color.disabled)
      },
      ':active': {
        background: 'none'
      }
    },
    DayPickerNavigation_button__horizontal: {},
    DayPickerNavigation_button__horizontalDefault: {
      position: 'absolute',
      top: 18,
      lineHeight: 0.78,
      borderRadius: 3,
      padding: '6px 9px'
    },
    DayPickerNavigation_bottomButton__horizontalDefault: {
      position: 'static',
      marginLeft: 22,
      marginRight: 22,
      marginBottom: 30,
      marginTop: -10
    },
    DayPickerNavigation_leftButton__horizontalDefault: {
      left: (0, _noflip["default"])(22)
    },
    DayPickerNavigation_rightButton__horizontalDefault: {
      right: (0, _noflip["default"])(22)
    },
    DayPickerNavigation_button__vertical: {},
    DayPickerNavigation_button__verticalDefault: {
      padding: 5,
      background: color.background,
      boxShadow: (0, _noflip["default"])('0 0 5px 2px rgba(0, 0, 0, 0.1)'),
      position: 'relative',
      display: 'inline-block',
      textAlign: 'center',
      height: '100%',
      width: '50%'
    },
    DayPickerNavigation_prevButton__verticalDefault: {},
    DayPickerNavigation_nextButton__verticalDefault: {
      borderLeft: (0, _noflip["default"])(0)
    },
    DayPickerNavigation_nextButton__verticalScrollableDefault: {
      width: '100%'
    },
    DayPickerNavigation_prevButton__verticalScrollableDefault: {
      width: '100%'
    },
    DayPickerNavigation_svg__horizontal: {
      height: 19,
      width: 19,
      fill: color.core.grayLight,
      display: 'block'
    },
    DayPickerNavigation_svg__vertical: {
      height: 42,
      width: 42,
      fill: color.text
    },
    DayPickerNavigation_svg__disabled: {
      fill: color.disabled
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DayPickerNavigation);

exports["default"] = _default;
});

unwrapExports(DayPickerNavigation_1);

var KeyboardShortcutRow_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  unicode: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  action: _propTypes["default"].string.isRequired,
  block: _propTypes["default"].bool
})) : {};
var defaultProps = {
  block: false
};

function KeyboardShortcutRow(_ref) {
  var unicode = _ref.unicode,
      label = _ref.label,
      action = _ref.action,
      block = _ref.block,
      styles = _ref.styles;
  return _react["default"].createElement("li", (0, withStyles_1.css)(styles.KeyboardShortcutRow, block && styles.KeyboardShortcutRow__block), _react["default"].createElement("div", (0, withStyles_1.css)(styles.KeyboardShortcutRow_keyContainer, block && styles.KeyboardShortcutRow_keyContainer__block), _react["default"].createElement("span", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.KeyboardShortcutRow_key), {
    role: "img",
    "aria-label": "".concat(label, ",") // add comma so screen readers will pause before reading action

  }), unicode)), _react["default"].createElement("div", (0, withStyles_1.css)(styles.KeyboardShortcutRow_action), action));
}

KeyboardShortcutRow.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
KeyboardShortcutRow.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var color = _ref2.reactDates.color;
  return {
    KeyboardShortcutRow: {
      listStyle: 'none',
      margin: '6px 0'
    },
    KeyboardShortcutRow__block: {
      marginBottom: 16
    },
    KeyboardShortcutRow_keyContainer: {
      display: 'inline-block',
      whiteSpace: 'nowrap',
      textAlign: 'right',
      // is not handled by isRTL
      marginRight: 6 // is not handled by isRTL

    },
    KeyboardShortcutRow_keyContainer__block: {
      textAlign: 'left',
      // is not handled by isRTL
      display: 'inline'
    },
    KeyboardShortcutRow_key: {
      fontFamily: 'monospace',
      fontSize: 12,
      textTransform: 'uppercase',
      background: color.core.grayLightest,
      padding: '2px 6px'
    },
    KeyboardShortcutRow_action: {
      display: 'inline',
      wordBreak: 'break-word',
      marginLeft: 8 // is not handled by isRTL

    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(KeyboardShortcutRow);

exports["default"] = _default;
});

unwrapExports(KeyboardShortcutRow_1);

var DayPickerKeyboardShortcuts_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BOTTOM_RIGHT = exports.TOP_RIGHT = exports.TOP_LEFT = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);







var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _KeyboardShortcutRow = interopRequireDefault(KeyboardShortcutRow_1);

var _CloseButton = interopRequireDefault(CloseButton_1);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TOP_LEFT = 'top-left';
exports.TOP_LEFT = TOP_LEFT;
var TOP_RIGHT = 'top-right';
exports.TOP_RIGHT = TOP_RIGHT;
var BOTTOM_RIGHT = 'bottom-right';
exports.BOTTOM_RIGHT = BOTTOM_RIGHT;
var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  block: _propTypes["default"].bool,
  // TODO: rename button location to be direction-agnostic
  buttonLocation: _propTypes["default"].oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
  showKeyboardShortcutsPanel: _propTypes["default"].bool,
  openKeyboardShortcutsPanel: _propTypes["default"].func,
  closeKeyboardShortcutsPanel: _propTypes["default"].func,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerKeyboardShortcutsPhrases)),
  renderKeyboardShortcutsButton: _propTypes["default"].func,
  renderKeyboardShortcutsPanel: _propTypes["default"].func
})) : {};
var defaultProps = {
  block: false,
  buttonLocation: BOTTOM_RIGHT,
  showKeyboardShortcutsPanel: false,
  openKeyboardShortcutsPanel: function openKeyboardShortcutsPanel() {},
  closeKeyboardShortcutsPanel: function closeKeyboardShortcutsPanel() {},
  phrases: defaultPhrases.DayPickerKeyboardShortcutsPhrases,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined
};

function getKeyboardShortcuts(phrases) {
  return [{
    unicode: '↵',
    label: phrases.enterKey,
    action: phrases.selectFocusedDate
  }, {
    unicode: '←/→',
    label: phrases.leftArrowRightArrow,
    action: phrases.moveFocusByOneDay
  }, {
    unicode: '↑/↓',
    label: phrases.upArrowDownArrow,
    action: phrases.moveFocusByOneWeek
  }, {
    unicode: 'PgUp/PgDn',
    label: phrases.pageUpPageDown,
    action: phrases.moveFocusByOneMonth
  }, {
    unicode: 'Home/End',
    label: phrases.homeEnd,
    action: phrases.moveFocustoStartAndEndOfWeek
  }, {
    unicode: 'Esc',
    label: phrases.escape,
    action: phrases.returnFocusToInput
  }, {
    unicode: '?',
    label: phrases.questionMark,
    action: phrases.openThisPanel
  }];
}

var DayPickerKeyboardShortcuts =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerKeyboardShortcuts, _ref);
  var _proto = DayPickerKeyboardShortcuts.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPickerKeyboardShortcuts() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _ref.call.apply(_ref, [this].concat(args)) || this;
    var phrases = _this.props.phrases;
    _this.keyboardShortcuts = getKeyboardShortcuts(phrases);
    _this.onShowKeyboardShortcutsButtonClick = _this.onShowKeyboardShortcutsButtonClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setShowKeyboardShortcutsButtonRef = _this.setShowKeyboardShortcutsButtonRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setHideKeyboardShortcutsButtonRef = _this.setHideKeyboardShortcutsButtonRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var phrases = this.props.phrases;

    if (nextProps.phrases !== phrases) {
      this.keyboardShortcuts = getKeyboardShortcuts(nextProps.phrases);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.handleFocus();
  };

  _proto.onKeyDown = function onKeyDown(e) {
    e.stopPropagation();
    var closeKeyboardShortcutsPanel = this.props.closeKeyboardShortcutsPanel; // Because the close button is the only focusable element inside of the panel, this
    // amounts to a very basic focus trap. The user can exit the panel by "pressing" the
    // close button or hitting escape

    switch (e.key) {
      case 'Escape':
        closeKeyboardShortcutsPanel();
        break;
      // do nothing - this allows the up and down arrows continue their
      // default behavior of scrolling the content of the Keyboard Shortcuts Panel
      // which is needed when only a single month is shown for instance.

      case 'ArrowUp':
      case 'ArrowDown':
        break;
      // completely block the rest of the keys that have functionality outside of this panel

      case 'Tab':
      case 'Home':
      case 'End':
      case 'PageUp':
      case 'PageDown':
      case 'ArrowLeft':
      case 'ArrowRight':
        e.preventDefault();
        break;
    }
  };

  _proto.onShowKeyboardShortcutsButtonClick = function onShowKeyboardShortcutsButtonClick() {
    var _this2 = this;

    var openKeyboardShortcutsPanel = this.props.openKeyboardShortcutsPanel; // we want to return focus to this button after closing the keyboard shortcuts panel

    openKeyboardShortcutsPanel(function () {
      _this2.showKeyboardShortcutsButton.focus();
    });
  };

  _proto.setShowKeyboardShortcutsButtonRef = function setShowKeyboardShortcutsButtonRef(ref) {
    this.showKeyboardShortcutsButton = ref;
  };

  _proto.setHideKeyboardShortcutsButtonRef = function setHideKeyboardShortcutsButtonRef(ref) {
    this.hideKeyboardShortcutsButton = ref;
  };

  _proto.handleFocus = function handleFocus() {
    if (this.hideKeyboardShortcutsButton) {
      // automatically move focus into the dialog by moving
      // to the only interactive element, the hide button
      this.hideKeyboardShortcutsButton.focus();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        buttonLocation = _this$props.buttonLocation,
        showKeyboardShortcutsPanel = _this$props.showKeyboardShortcutsPanel,
        closeKeyboardShortcutsPanel = _this$props.closeKeyboardShortcutsPanel,
        styles = _this$props.styles,
        phrases = _this$props.phrases,
        renderKeyboardShortcutsButton = _this$props.renderKeyboardShortcutsButton,
        renderKeyboardShortcutsPanel = _this$props.renderKeyboardShortcutsPanel;
    var toggleButtonText = showKeyboardShortcutsPanel ? phrases.hideKeyboardShortcutsPanel : phrases.showKeyboardShortcutsPanel;
    var bottomRight = buttonLocation === BOTTOM_RIGHT;
    var topRight = buttonLocation === TOP_RIGHT;
    var topLeft = buttonLocation === TOP_LEFT;
    return _react["default"].createElement("div", null, renderKeyboardShortcutsButton && renderKeyboardShortcutsButton({
      // passing in context-specific props
      ref: this.setShowKeyboardShortcutsButtonRef,
      onClick: this.onShowKeyboardShortcutsButtonClick,
      ariaLabel: toggleButtonText
    }), !renderKeyboardShortcutsButton && _react["default"].createElement("button", (0, _extends2["default"])({
      ref: this.setShowKeyboardShortcutsButtonRef
    }, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_show, bottomRight && styles.DayPickerKeyboardShortcuts_show__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_show__topRight, topLeft && styles.DayPickerKeyboardShortcuts_show__topLeft), {
      type: "button",
      "aria-label": toggleButtonText,
      onClick: this.onShowKeyboardShortcutsButtonClick,
      onMouseUp: function onMouseUp(e) {
        e.currentTarget.blur();
      }
    }), _react["default"].createElement("span", (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_showSpan, bottomRight && styles.DayPickerKeyboardShortcuts_showSpan__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_showSpan__topRight, topLeft && styles.DayPickerKeyboardShortcuts_showSpan__topLeft), "?")), showKeyboardShortcutsPanel && (renderKeyboardShortcutsPanel ? renderKeyboardShortcutsPanel({
      closeButtonAriaLabel: phrases.hideKeyboardShortcutsPanel,
      keyboardShortcuts: this.keyboardShortcuts,
      onCloseButtonClick: closeKeyboardShortcutsPanel,
      onKeyDown: this.onKeyDown,
      title: phrases.keyboardShortcuts
    }) : _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_panel), {
      role: "dialog",
      "aria-labelledby": "DayPickerKeyboardShortcuts_title",
      "aria-describedby": "DayPickerKeyboardShortcuts_description"
    }), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_title), {
      id: "DayPickerKeyboardShortcuts_title"
    }), phrases.keyboardShortcuts), _react["default"].createElement("button", (0, _extends2["default"])({
      ref: this.setHideKeyboardShortcutsButtonRef
    }, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_close), {
      type: "button",
      tabIndex: "0",
      "aria-label": phrases.hideKeyboardShortcutsPanel,
      onClick: closeKeyboardShortcutsPanel,
      onKeyDown: this.onKeyDown
    }), _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_closeSvg))), _react["default"].createElement("ul", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPickerKeyboardShortcuts_list), {
      id: "DayPickerKeyboardShortcuts_description"
    }), this.keyboardShortcuts.map(function (_ref2) {
      var unicode = _ref2.unicode,
          label = _ref2.label,
          action = _ref2.action;
      return _react["default"].createElement(_KeyboardShortcutRow["default"], {
        key: label,
        unicode: unicode,
        label: label,
        action: action,
        block: block
      });
    })))));
  };

  return DayPickerKeyboardShortcuts;
}(_react["default"].PureComponent || _react["default"].Component);

DayPickerKeyboardShortcuts.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPickerKeyboardShortcuts.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref3) {
  var _ref3$reactDates = _ref3.reactDates,
      color = _ref3$reactDates.color,
      font = _ref3$reactDates.font,
      zIndex = _ref3$reactDates.zIndex;
  return {
    DayPickerKeyboardShortcuts_buttonReset: {
      background: 'none',
      border: 0,
      borderRadius: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      padding: 0,
      cursor: 'pointer',
      fontSize: font.size,
      ':active': {
        outline: 'none'
      }
    },
    DayPickerKeyboardShortcuts_show: {
      width: 33,
      height: 26,
      position: 'absolute',
      zIndex: zIndex + 2,
      '::before': {
        content: '""',
        display: 'block',
        position: 'absolute'
      }
    },
    DayPickerKeyboardShortcuts_show__bottomRight: {
      bottom: 0,
      right: 0,
      '::before': {
        borderTop: '26px solid transparent',
        borderRight: "33px solid ".concat(color.core.primary),
        bottom: 0,
        right: 0
      },
      ':hover::before': {
        borderRight: "33px solid ".concat(color.core.primary_dark)
      }
    },
    DayPickerKeyboardShortcuts_show__topRight: {
      top: 0,
      right: 0,
      '::before': {
        borderBottom: '26px solid transparent',
        borderRight: "33px solid ".concat(color.core.primary),
        top: 0,
        right: 0
      },
      ':hover::before': {
        borderRight: "33px solid ".concat(color.core.primary_dark)
      }
    },
    DayPickerKeyboardShortcuts_show__topLeft: {
      top: 0,
      left: 0,
      '::before': {
        borderBottom: '26px solid transparent',
        borderLeft: "33px solid ".concat(color.core.primary),
        top: 0,
        left: 0
      },
      ':hover::before': {
        borderLeft: "33px solid ".concat(color.core.primary_dark)
      }
    },
    DayPickerKeyboardShortcuts_showSpan: {
      color: color.core.white,
      position: 'absolute'
    },
    DayPickerKeyboardShortcuts_showSpan__bottomRight: {
      bottom: 0,
      right: 5
    },
    DayPickerKeyboardShortcuts_showSpan__topRight: {
      top: 1,
      right: 5
    },
    DayPickerKeyboardShortcuts_showSpan__topLeft: {
      top: 1,
      left: 5
    },
    DayPickerKeyboardShortcuts_panel: {
      overflow: 'auto',
      background: color.background,
      border: "1px solid ".concat(color.core.border),
      borderRadius: 2,
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      zIndex: zIndex + 2,
      padding: 22,
      margin: 33,
      textAlign: 'left' // TODO: investigate use of text-align throughout the library

    },
    DayPickerKeyboardShortcuts_title: {
      fontSize: 16,
      fontWeight: 'bold',
      margin: 0
    },
    DayPickerKeyboardShortcuts_list: {
      listStyle: 'none',
      padding: 0,
      fontSize: font.size
    },
    DayPickerKeyboardShortcuts_close: {
      position: 'absolute',
      right: 22,
      top: 22,
      zIndex: zIndex + 2,
      ':active': {
        outline: 'none'
      }
    },
    DayPickerKeyboardShortcuts_closeSvg: {
      height: 15,
      width: 15,
      fill: color.core.grayLighter,
      ':hover': {
        fill: color.core.grayLight
      },
      ':focus': {
        fill: color.core.grayLight
      }
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DayPickerKeyboardShortcuts);

exports["default"] = _default;
});

unwrapExports(DayPickerKeyboardShortcuts_1);
var DayPickerKeyboardShortcuts_2 = DayPickerKeyboardShortcuts_1.BOTTOM_RIGHT;
var DayPickerKeyboardShortcuts_3 = DayPickerKeyboardShortcuts_1.TOP_RIGHT;
var DayPickerKeyboardShortcuts_4 = DayPickerKeyboardShortcuts_1.TOP_LEFT;

var getNumberOfCalendarMonthWeeks_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getNumberOfCalendarMonthWeeks;

var _moment = interopRequireDefault(hooks);

function getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek) {
  var weekDayDiff = firstDayOfMonth.day() - firstDayOfWeek;
  return (weekDayDiff + 7) % 7;
}

function getNumberOfCalendarMonthWeeks(month) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _moment["default"].localeData().firstDayOfWeek();
  var firstDayOfMonth = month.clone().startOf('month');
  var numBlankDays = getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek);
  return Math.ceil((numBlankDays + month.daysInMonth()) / 7);
}
});

unwrapExports(getNumberOfCalendarMonthWeeks_1);

var getActiveElement_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getActiveElement;

function getActiveElement() {
  return typeof document !== 'undefined' && document.activeElement;
}
});

unwrapExports(getActiveElement_1);

var DayPicker_1 = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureDayPicker = exports.defaultProps = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _toConsumableArray2 = interopRequireDefault(toConsumableArray);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);





var _moment = interopRequireDefault(hooks);

var _throttle = interopRequireDefault(throttle_1);

var _isTouchDevice = interopRequireDefault(build$3);

var _reactOutsideClickHandler = interopRequireDefault(reactOutsideClickHandler);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _noflip = interopRequireDefault(noflip_1);

var _CalendarMonthGrid = interopRequireDefault(CalendarMonthGrid_1);

var _DayPickerNavigation = interopRequireDefault(DayPickerNavigation_1);

var _DayPickerKeyboardShortcuts = interopRequireWildcard(DayPickerKeyboardShortcuts_1);

var _getNumberOfCalendarMonthWeeks = interopRequireDefault(getNumberOfCalendarMonthWeeks_1);

var _getCalendarMonthWidth = interopRequireDefault(getCalendarMonthWidth_1);

var _calculateDimension = interopRequireDefault(calculateDimension_1);

var _getActiveElement = interopRequireDefault(getActiveElement_1);

var _isDayVisible = interopRequireDefault(isDayVisible_1);

var _isSameMonth = interopRequireDefault(isSameMonth_1);

var _ModifiersShape = interopRequireDefault(ModifiersShape);

var _NavPositionShape = interopRequireDefault(NavPositionShape);

var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);

var _CalendarInfoPositionShape = interopRequireDefault(CalendarInfoPositionShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MONTH_PADDING = 23;
var PREV_TRANSITION = 'prev';
var NEXT_TRANSITION = 'next';
var MONTH_SELECTION_TRANSITION = 'month_selection';
var YEAR_SELECTION_TRANSITION = 'year_selection';
var PREV_NAV = 'prev_nav';
var NEXT_NAV = 'next_nav';
var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  // calendar presentation props
  enableOutsideDays: _propTypes["default"].bool,
  numberOfMonths: _propTypes["default"].number,
  orientation: _ScrollableOrientationShape["default"],
  withPortal: _propTypes["default"].bool,
  onOutsideClick: _propTypes["default"].func,
  hidden: _propTypes["default"].bool,
  initialVisibleMonth: _propTypes["default"].func,
  firstDayOfWeek: _DayOfWeekShape["default"],
  renderCalendarInfo: _propTypes["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  daySize: airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes["default"].bool,
  verticalHeight: airbnbPropTypes.nonNegativeInteger,
  noBorder: _propTypes["default"].bool,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  renderKeyboardShortcutsButton: _propTypes["default"].func,
  renderKeyboardShortcutsPanel: _propTypes["default"].func,
  // navigation props
  dayPickerNavigationInlineStyles: _propTypes["default"].object,
  disablePrev: _propTypes["default"].bool,
  disableNext: _propTypes["default"].bool,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  noNavButtons: _propTypes["default"].bool,
  noNavNextButton: _propTypes["default"].bool,
  noNavPrevButton: _propTypes["default"].bool,
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  onMonthChange: _propTypes["default"].func,
  onYearChange: _propTypes["default"].func,
  onGetNextScrollableMonths: _propTypes["default"].func,
  // VERTICAL_SCROLLABLE daypickers only
  onGetPrevScrollableMonths: _propTypes["default"].func,
  // VERTICAL_SCROLLABLE daypickers only
  // month props
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes["default"].func,
  // day props
  modifiers: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_ModifiersShape["default"])),
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  onDayClick: _propTypes["default"].func,
  onDayMouseEnter: _propTypes["default"].func,
  onDayMouseLeave: _propTypes["default"].func,
  // accessibility props
  isFocused: _propTypes["default"].bool,
  getFirstFocusableDay: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  showKeyboardShortcuts: _propTypes["default"].bool,
  onTab: _propTypes["default"].func,
  onShiftTab: _propTypes["default"].func,
  // internationalization
  monthFormat: _propTypes["default"].string,
  weekDayFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string
})) : {};
var defaultProps = {
  // calendar presentation props
  enableOutsideDays: false,
  numberOfMonths: 2,
  orientation: constants$1.HORIZONTAL_ORIENTATION,
  withPortal: false,
  onOutsideClick: function onOutsideClick() {},
  hidden: false,
  initialVisibleMonth: function initialVisibleMonth() {
    return (0, _moment["default"])();
  },
  firstDayOfWeek: null,
  renderCalendarInfo: null,
  calendarInfoPosition: constants$1.INFO_POSITION_BOTTOM,
  hideKeyboardShortcutsPanel: false,
  daySize: constants$1.DAY_SIZE,
  isRTL: false,
  verticalHeight: null,
  noBorder: false,
  transitionDuration: undefined,
  verticalBorderSpacing: undefined,
  horizontalMonthPadding: 13,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined,
  // navigation props
  dayPickerNavigationInlineStyles: null,
  disablePrev: false,
  disableNext: false,
  navPosition: constants$1.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  noNavButtons: false,
  noNavNextButton: false,
  noNavPrevButton: false,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onMonthChange: function onMonthChange() {},
  onYearChange: function onYearChange() {},
  onGetNextScrollableMonths: function onGetNextScrollableMonths() {},
  onGetPrevScrollableMonths: function onGetPrevScrollableMonths() {},
  // month props
  renderMonthText: null,
  renderMonthElement: null,
  renderWeekHeaderElement: null,
  // day props
  modifiers: {},
  renderCalendarDay: undefined,
  renderDayContents: null,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  // accessibility props
  isFocused: false,
  getFirstFocusableDay: null,
  onBlur: function onBlur() {},
  showKeyboardShortcuts: false,
  onTab: function onTab() {},
  onShiftTab: function onShiftTab() {},
  // internationalization
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: defaultPhrases.DayPickerPhrases,
  dayAriaLabelFormat: undefined
};
exports.defaultProps = defaultProps;

var DayPicker =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPicker, _ref);
  var _proto = DayPicker.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPicker(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    var currentMonth = props.hidden ? (0, _moment["default"])() : props.initialVisibleMonth();
    var focusedDate = currentMonth.clone().startOf('month');

    if (props.getFirstFocusableDay) {
      focusedDate = props.getFirstFocusableDay(currentMonth);
    }

    var horizontalMonthPadding = props.horizontalMonthPadding;
    var translationValue = props.isRTL && _this.isHorizontal() ? -(0, _getCalendarMonthWidth["default"])(props.daySize, horizontalMonthPadding) : 0;
    _this.hasSetInitialVisibleMonth = !props.hidden;
    _this.state = {
      currentMonthScrollTop: null,
      currentMonth: currentMonth,
      monthTransition: null,
      translationValue: translationValue,
      scrollableMonthMultiple: 1,
      calendarMonthWidth: (0, _getCalendarMonthWidth["default"])(props.daySize, horizontalMonthPadding),
      focusedDate: !props.hidden || props.isFocused ? focusedDate : null,
      nextFocusedDate: null,
      showKeyboardShortcuts: props.showKeyboardShortcuts,
      onKeyboardShortcutsPanelClose: function onKeyboardShortcutsPanelClose() {},
      isTouchDevice: (0, _isTouchDevice["default"])(),
      withMouseInteractions: true,
      calendarInfoWidth: 0,
      monthTitleHeight: null,
      hasSetHeight: false
    };

    _this.setCalendarMonthWeeks(currentMonth);

    _this.calendarMonthGridHeight = 0;
    _this.setCalendarInfoWidthTimeout = null;
    _this.setCalendarMonthGridHeightTimeout = null;
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.throttledKeyDown = (0, _throttle["default"])(_this.onFinalKeyDown, 200, {
      trailing: false
    });
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPrevMonthTransition = _this.onPrevMonthTransition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthClick = _this.onNextMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthTransition = _this.onNextMonthTransition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMonthChange = _this.onMonthChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearChange = _this.onYearChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getNextScrollableMonths = _this.getNextScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getPrevScrollableMonths = _this.getPrevScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.openKeyboardShortcutsPanel = _this.openKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.closeKeyboardShortcutsPanel = _this.closeKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setCalendarInfoRef = _this.setCalendarInfoRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setTransitionContainerRef = _this.setTransitionContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setMonthTitleHeight = _this.setMonthTitleHeight.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    var orientation = this.props.orientation;
    var currentMonth = this.state.currentMonth;
    var calendarInfoWidth = this.calendarInfo ? (0, _calculateDimension["default"])(this.calendarInfo, 'width', true, true) : 0;
    var currentMonthScrollTop = this.transitionContainer && orientation === constants$1.VERTICAL_SCROLLABLE ? this.transitionContainer.scrollHeight - this.transitionContainer.scrollTop : null;
    this.setState({
      isTouchDevice: (0, _isTouchDevice["default"])(),
      calendarInfoWidth: calendarInfoWidth,
      currentMonthScrollTop: currentMonthScrollTop
    });
    this.setCalendarMonthWeeks(currentMonth);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {
    var hidden = nextProps.hidden,
        isFocused = nextProps.isFocused,
        showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
        onBlur = nextProps.onBlur,
        orientation = nextProps.orientation,
        renderMonthText = nextProps.renderMonthText,
        horizontalMonthPadding = nextProps.horizontalMonthPadding;
    var currentMonth = this.state.currentMonth;
    var nextCurrentMonth = nextState.currentMonth;

    if (!hidden) {
      if (!this.hasSetInitialVisibleMonth) {
        this.hasSetInitialVisibleMonth = true;
        this.setState({
          currentMonth: nextProps.initialVisibleMonth()
        });
      }
    }

    var _this$props = this.props,
        daySize = _this$props.daySize,
        prevIsFocused = _this$props.isFocused,
        prevRenderMonthText = _this$props.renderMonthText;

    if (nextProps.daySize !== daySize) {
      this.setState({
        calendarMonthWidth: (0, _getCalendarMonthWidth["default"])(nextProps.daySize, horizontalMonthPadding)
      });
    }

    if (isFocused !== prevIsFocused) {
      if (isFocused) {
        var focusedDate = this.getFocusedDay(currentMonth);
        var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

        if (nextProps.showKeyboardShortcuts) {
          // the ? shortcut came from the input and we should return input there once it is close
          onKeyboardShortcutsPanelClose = onBlur;
        }

        this.setState({
          showKeyboardShortcuts: showKeyboardShortcuts,
          onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
          focusedDate: focusedDate,
          withMouseInteractions: false
        });
      } else {
        this.setState({
          focusedDate: null
        });
      }
    }

    if (renderMonthText !== prevRenderMonthText) {
      this.setState({
        monthTitleHeight: null
      });
    } // Capture the scroll position so when previous months are rendered above the current month
    // we can adjust scroll after the component has updated and the previous current month
    // stays in view.


    if (orientation === constants$1.VERTICAL_SCROLLABLE && this.transitionContainer && !(0, _isSameMonth["default"])(currentMonth, nextCurrentMonth)) {
      this.setState({
        currentMonthScrollTop: this.transitionContainer.scrollHeight - this.transitionContainer.scrollTop
      });
    }
  };

  _proto.componentWillUpdate = function componentWillUpdate() {
    var _this2 = this;

    var transitionDuration = this.props.transitionDuration; // Calculating the dimensions trigger a DOM repaint which
    // breaks the CSS transition.
    // The setTimeout will wait until the transition ends.

    if (this.calendarInfo) {
      this.setCalendarInfoWidthTimeout = setTimeout(function () {
        var calendarInfoWidth = _this2.state.calendarInfoWidth;
        var calendarInfoPanelWidth = (0, _calculateDimension["default"])(_this2.calendarInfo, 'width', true, true);

        if (calendarInfoWidth !== calendarInfoPanelWidth) {
          _this2.setState({
            calendarInfoWidth: calendarInfoPanelWidth
          });
        }
      }, transitionDuration);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props2 = this.props,
        orientation = _this$props2.orientation,
        daySize = _this$props2.daySize,
        isFocused = _this$props2.isFocused,
        numberOfMonths = _this$props2.numberOfMonths;
    var _this$state = this.state,
        currentMonth = _this$state.currentMonth,
        currentMonthScrollTop = _this$state.currentMonthScrollTop,
        focusedDate = _this$state.focusedDate,
        monthTitleHeight = _this$state.monthTitleHeight;

    if (this.isHorizontal() && (orientation !== prevProps.orientation || daySize !== prevProps.daySize)) {
      var visibleCalendarWeeks = this.calendarMonthWeeks.slice(1, numberOfMonths + 1);
      var calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);
      var newMonthHeight = monthTitleHeight + calendarMonthWeeksHeight + 1;
      this.adjustDayPickerHeight(newMonthHeight);
    }

    if (!prevProps.isFocused && isFocused && !focusedDate) {
      this.container.focus();
    } // If orientation is VERTICAL_SCROLLABLE and currentMonth has changed adjust scrollTop so the
    // new months rendered above the current month don't push the current month out of view.


    if (orientation === constants$1.VERTICAL_SCROLLABLE && !(0, _isSameMonth["default"])(prevState.currentMonth, currentMonth) && currentMonthScrollTop && this.transitionContainer) {
      this.transitionContainer.scrollTop = this.transitionContainer.scrollHeight - currentMonthScrollTop;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.setCalendarInfoWidthTimeout);
    clearTimeout(this.setCalendarMonthGridHeightTimeout);
  };

  _proto.onKeyDown = function onKeyDown(e) {
    e.stopPropagation();

    if (!constants$1.MODIFIER_KEY_NAMES.has(e.key)) {
      this.throttledKeyDown(e);
    }
  };

  _proto.onFinalKeyDown = function onFinalKeyDown(e) {
    this.setState({
      withMouseInteractions: false
    });
    var _this$props3 = this.props,
        onBlur = _this$props3.onBlur,
        onTab = _this$props3.onTab,
        onShiftTab = _this$props3.onShiftTab,
        isRTL = _this$props3.isRTL;
    var _this$state2 = this.state,
        focusedDate = _this$state2.focusedDate,
        showKeyboardShortcuts = _this$state2.showKeyboardShortcuts;
    if (!focusedDate) return;
    var newFocusedDate = focusedDate.clone();
    var didTransitionMonth = false; // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
    // return it to wherever it was before when the panel was opened

    var activeElement = (0, _getActiveElement["default"])();

    var onKeyboardShortcutsPanelClose = function onKeyboardShortcutsPanelClose() {
      if (activeElement) activeElement.focus();
    };

    switch (e.key) {
      case 'ArrowUp':
        e.preventDefault();
        newFocusedDate.subtract(1, 'week');
        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'ArrowLeft':
        e.preventDefault();

        if (isRTL) {
          newFocusedDate.add(1, 'day');
        } else {
          newFocusedDate.subtract(1, 'day');
        }

        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'Home':
        e.preventDefault();
        newFocusedDate.startOf('week');
        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'PageUp':
        e.preventDefault();
        newFocusedDate.subtract(1, 'month');
        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'ArrowDown':
        e.preventDefault();
        newFocusedDate.add(1, 'week');
        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case 'ArrowRight':
        e.preventDefault();

        if (isRTL) {
          newFocusedDate.subtract(1, 'day');
        } else {
          newFocusedDate.add(1, 'day');
        }

        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case 'End':
        e.preventDefault();
        newFocusedDate.endOf('week');
        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case 'PageDown':
        e.preventDefault();
        newFocusedDate.add(1, 'month');
        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case '?':
        this.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
        break;

      case 'Escape':
        if (showKeyboardShortcuts) {
          this.closeKeyboardShortcutsPanel();
        } else {
          onBlur(e);
        }

        break;

      case 'Tab':
        if (e.shiftKey) {
          onShiftTab();
        } else {
          onTab(e);
        }

        break;
    } // If there was a month transition, do not update the focused date until the transition has
    // completed. Otherwise, attempting to focus on a DOM node may interrupt the CSS animation. If
    // didTransitionMonth is true, the focusedDate gets updated in #updateStateAfterMonthTransition


    if (!didTransitionMonth) {
      this.setState({
        focusedDate: newFocusedDate
      });
    }
  };

  _proto.onPrevMonthClick = function onPrevMonthClick(e) {
    if (e) e.preventDefault();
    this.onPrevMonthTransition();
  };

  _proto.onPrevMonthTransition = function onPrevMonthTransition(nextFocusedDate) {
    var _this$props4 = this.props,
        daySize = _this$props4.daySize,
        isRTL = _this$props4.isRTL,
        numberOfMonths = _this$props4.numberOfMonths;
    var _this$state3 = this.state,
        calendarMonthWidth = _this$state3.calendarMonthWidth,
        monthTitleHeight = _this$state3.monthTitleHeight;
    var translationValue;

    if (this.isVertical()) {
      var calendarMonthWeeksHeight = this.calendarMonthWeeks[0] * (daySize - 1);
      translationValue = monthTitleHeight + calendarMonthWeeksHeight + 1;
    } else if (this.isHorizontal()) {
      translationValue = calendarMonthWidth;

      if (isRTL) {
        translationValue = -2 * calendarMonthWidth;
      }

      var visibleCalendarWeeks = this.calendarMonthWeeks.slice(0, numberOfMonths);

      var _calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);

      var newMonthHeight = monthTitleHeight + _calendarMonthWeeksHeight + 1;
      this.adjustDayPickerHeight(newMonthHeight);
    }

    this.setState({
      monthTransition: PREV_TRANSITION,
      translationValue: translationValue,
      focusedDate: null,
      nextFocusedDate: nextFocusedDate
    });
  };

  _proto.onMonthChange = function onMonthChange(currentMonth) {
    this.setCalendarMonthWeeks(currentMonth);
    this.calculateAndSetDayPickerHeight(); // Translation value is a hack to force an invisible transition that
    // properly rerenders the CalendarMonthGrid

    this.setState({
      monthTransition: MONTH_SELECTION_TRANSITION,
      translationValue: 0.00001,
      focusedDate: null,
      nextFocusedDate: currentMonth,
      currentMonth: currentMonth
    });
  };

  _proto.onYearChange = function onYearChange(currentMonth) {
    this.setCalendarMonthWeeks(currentMonth);
    this.calculateAndSetDayPickerHeight(); // Translation value is a hack to force an invisible transition that
    // properly rerenders the CalendarMonthGrid

    this.setState({
      monthTransition: YEAR_SELECTION_TRANSITION,
      translationValue: 0.0001,
      focusedDate: null,
      nextFocusedDate: currentMonth,
      currentMonth: currentMonth
    });
  };

  _proto.onNextMonthClick = function onNextMonthClick(e) {
    if (e) e.preventDefault();
    this.onNextMonthTransition();
  };

  _proto.onNextMonthTransition = function onNextMonthTransition(nextFocusedDate) {
    var _this$props5 = this.props,
        isRTL = _this$props5.isRTL,
        numberOfMonths = _this$props5.numberOfMonths,
        daySize = _this$props5.daySize;
    var _this$state4 = this.state,
        calendarMonthWidth = _this$state4.calendarMonthWidth,
        monthTitleHeight = _this$state4.monthTitleHeight;
    var translationValue;

    if (this.isVertical()) {
      var firstVisibleMonthWeeks = this.calendarMonthWeeks[1];
      var calendarMonthWeeksHeight = firstVisibleMonthWeeks * (daySize - 1);
      translationValue = -(monthTitleHeight + calendarMonthWeeksHeight + 1);
    }

    if (this.isHorizontal()) {
      translationValue = -calendarMonthWidth;

      if (isRTL) {
        translationValue = 0;
      }

      var visibleCalendarWeeks = this.calendarMonthWeeks.slice(2, numberOfMonths + 2);

      var _calendarMonthWeeksHeight2 = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);

      var newMonthHeight = monthTitleHeight + _calendarMonthWeeksHeight2 + 1;
      this.adjustDayPickerHeight(newMonthHeight);
    }

    this.setState({
      monthTransition: NEXT_TRANSITION,
      translationValue: translationValue,
      focusedDate: null,
      nextFocusedDate: nextFocusedDate
    });
  };

  _proto.getFirstDayOfWeek = function getFirstDayOfWeek() {
    var firstDayOfWeek = this.props.firstDayOfWeek;

    if (firstDayOfWeek == null) {
      return _moment["default"].localeData().firstDayOfWeek();
    }

    return firstDayOfWeek;
  };

  _proto.getWeekHeaders = function getWeekHeaders() {
    var weekDayFormat = this.props.weekDayFormat;
    var currentMonth = this.state.currentMonth;
    var firstDayOfWeek = this.getFirstDayOfWeek();
    var weekHeaders = [];

    for (var i = 0; i < 7; i += 1) {
      weekHeaders.push(currentMonth.clone().day((i + firstDayOfWeek) % 7).format(weekDayFormat));
    }

    return weekHeaders;
  };

  _proto.getFirstVisibleIndex = function getFirstVisibleIndex() {
    var orientation = this.props.orientation;
    var monthTransition = this.state.monthTransition;
    if (orientation === constants$1.VERTICAL_SCROLLABLE) return 0;
    var firstVisibleMonthIndex = 1;

    if (monthTransition === PREV_TRANSITION) {
      firstVisibleMonthIndex -= 1;
    } else if (monthTransition === NEXT_TRANSITION) {
      firstVisibleMonthIndex += 1;
    }

    return firstVisibleMonthIndex;
  };

  _proto.getFocusedDay = function getFocusedDay(newMonth) {
    var _this$props6 = this.props,
        getFirstFocusableDay = _this$props6.getFirstFocusableDay,
        numberOfMonths = _this$props6.numberOfMonths;
    var focusedDate;

    if (getFirstFocusableDay) {
      focusedDate = getFirstFocusableDay(newMonth);
    }

    if (newMonth && (!focusedDate || !(0, _isDayVisible["default"])(focusedDate, newMonth, numberOfMonths))) {
      focusedDate = newMonth.clone().startOf('month');
    }

    return focusedDate;
  };

  _proto.setMonthTitleHeight = function setMonthTitleHeight(monthTitleHeight) {
    var _this3 = this;

    this.setState({
      monthTitleHeight: monthTitleHeight
    }, function () {
      _this3.calculateAndSetDayPickerHeight();
    });
  };

  _proto.setCalendarMonthWeeks = function setCalendarMonthWeeks(currentMonth) {
    var numberOfMonths = this.props.numberOfMonths;
    this.calendarMonthWeeks = [];
    var month = currentMonth.clone().subtract(1, 'months');
    var firstDayOfWeek = this.getFirstDayOfWeek();

    for (var i = 0; i < numberOfMonths + 2; i += 1) {
      var numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(month, firstDayOfWeek);
      this.calendarMonthWeeks.push(numberOfWeeks);
      month = month.add(1, 'months');
    }
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.setCalendarInfoRef = function setCalendarInfoRef(ref) {
    this.calendarInfo = ref;
  };

  _proto.setTransitionContainerRef = function setTransitionContainerRef(ref) {
    this.transitionContainer = ref;
  };

  _proto.getNextScrollableMonths = function getNextScrollableMonths(e) {
    var onGetNextScrollableMonths = this.props.onGetNextScrollableMonths;
    if (e) e.preventDefault();
    if (onGetNextScrollableMonths) onGetNextScrollableMonths(e);
    this.setState(function (_ref2) {
      var scrollableMonthMultiple = _ref2.scrollableMonthMultiple;
      return {
        scrollableMonthMultiple: scrollableMonthMultiple + 1
      };
    });
  };

  _proto.getPrevScrollableMonths = function getPrevScrollableMonths(e) {
    var _this$props7 = this.props,
        numberOfMonths = _this$props7.numberOfMonths,
        onGetPrevScrollableMonths = _this$props7.onGetPrevScrollableMonths;
    if (e) e.preventDefault();
    if (onGetPrevScrollableMonths) onGetPrevScrollableMonths(e);
    this.setState(function (_ref3) {
      var currentMonth = _ref3.currentMonth,
          scrollableMonthMultiple = _ref3.scrollableMonthMultiple;
      return {
        currentMonth: currentMonth.clone().subtract(numberOfMonths, 'month'),
        scrollableMonthMultiple: scrollableMonthMultiple + 1
      };
    });
  };

  _proto.maybeTransitionNextMonth = function maybeTransitionNextMonth(newFocusedDate) {
    var numberOfMonths = this.props.numberOfMonths;
    var _this$state5 = this.state,
        currentMonth = _this$state5.currentMonth,
        focusedDate = _this$state5.focusedDate;
    var newFocusedDateMonth = newFocusedDate.month();
    var focusedDateMonth = focusedDate.month();
    var isNewFocusedDateVisible = (0, _isDayVisible["default"])(newFocusedDate, currentMonth, numberOfMonths);

    if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
      this.onNextMonthTransition(newFocusedDate);
      return true;
    }

    return false;
  };

  _proto.maybeTransitionPrevMonth = function maybeTransitionPrevMonth(newFocusedDate) {
    var numberOfMonths = this.props.numberOfMonths;
    var _this$state6 = this.state,
        currentMonth = _this$state6.currentMonth,
        focusedDate = _this$state6.focusedDate;
    var newFocusedDateMonth = newFocusedDate.month();
    var focusedDateMonth = focusedDate.month();
    var isNewFocusedDateVisible = (0, _isDayVisible["default"])(newFocusedDate, currentMonth, numberOfMonths);

    if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
      this.onPrevMonthTransition(newFocusedDate);
      return true;
    }

    return false;
  };

  _proto.isHorizontal = function isHorizontal() {
    var orientation = this.props.orientation;
    return orientation === constants$1.HORIZONTAL_ORIENTATION;
  };

  _proto.isVertical = function isVertical() {
    var orientation = this.props.orientation;
    return orientation === constants$1.VERTICAL_ORIENTATION || orientation === constants$1.VERTICAL_SCROLLABLE;
  };

  _proto.updateStateAfterMonthTransition = function updateStateAfterMonthTransition() {
    var _this4 = this;

    var _this$props8 = this.props,
        onPrevMonthClick = _this$props8.onPrevMonthClick,
        onNextMonthClick = _this$props8.onNextMonthClick,
        numberOfMonths = _this$props8.numberOfMonths,
        onMonthChange = _this$props8.onMonthChange,
        onYearChange = _this$props8.onYearChange,
        isRTL = _this$props8.isRTL;
    var _this$state7 = this.state,
        currentMonth = _this$state7.currentMonth,
        monthTransition = _this$state7.monthTransition,
        focusedDate = _this$state7.focusedDate,
        nextFocusedDate = _this$state7.nextFocusedDate,
        withMouseInteractions = _this$state7.withMouseInteractions,
        calendarMonthWidth = _this$state7.calendarMonthWidth;
    if (!monthTransition) return;
    var newMonth = currentMonth.clone();
    var firstDayOfWeek = this.getFirstDayOfWeek();

    if (monthTransition === PREV_TRANSITION) {
      newMonth.subtract(1, 'month');
      if (onPrevMonthClick) onPrevMonthClick(newMonth);
      var newInvisibleMonth = newMonth.clone().subtract(1, 'month');
      var numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(newInvisibleMonth, firstDayOfWeek);
      this.calendarMonthWeeks = [numberOfWeeks].concat((0, _toConsumableArray2["default"])(this.calendarMonthWeeks.slice(0, -1)));
    } else if (monthTransition === NEXT_TRANSITION) {
      newMonth.add(1, 'month');
      if (onNextMonthClick) onNextMonthClick(newMonth);

      var _newInvisibleMonth = newMonth.clone().add(numberOfMonths, 'month');

      var _numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(_newInvisibleMonth, firstDayOfWeek);

      this.calendarMonthWeeks = [].concat((0, _toConsumableArray2["default"])(this.calendarMonthWeeks.slice(1)), [_numberOfWeeks]);
    } else if (monthTransition === MONTH_SELECTION_TRANSITION) {
      if (onMonthChange) onMonthChange(newMonth);
    } else if (monthTransition === YEAR_SELECTION_TRANSITION) {
      if (onYearChange) onYearChange(newMonth);
    }

    var newFocusedDate = null;

    if (nextFocusedDate) {
      newFocusedDate = nextFocusedDate;
    } else if (!focusedDate && !withMouseInteractions) {
      newFocusedDate = this.getFocusedDay(newMonth);
    }

    this.setState({
      currentMonth: newMonth,
      monthTransition: null,
      translationValue: isRTL && this.isHorizontal() ? -calendarMonthWidth : 0,
      nextFocusedDate: null,
      focusedDate: newFocusedDate
    }, function () {
      // we don't want to focus on the relevant calendar day after a month transition
      // if the user is navigating around using a mouse
      if (withMouseInteractions) {
        var activeElement = (0, _getActiveElement["default"])();

        if (activeElement && activeElement !== document.body && _this4.container.contains(activeElement) && activeElement.blur) {
          activeElement.blur();
        }
      }
    });
  };

  _proto.adjustDayPickerHeight = function adjustDayPickerHeight(newMonthHeight) {
    var _this5 = this;

    var monthHeight = newMonthHeight + MONTH_PADDING;

    if (monthHeight !== this.calendarMonthGridHeight) {
      this.transitionContainer.style.height = "".concat(monthHeight, "px");

      if (!this.calendarMonthGridHeight) {
        this.setCalendarMonthGridHeightTimeout = setTimeout(function () {
          _this5.setState({
            hasSetHeight: true
          });
        }, 0);
      }

      this.calendarMonthGridHeight = monthHeight;
    }
  };

  _proto.calculateAndSetDayPickerHeight = function calculateAndSetDayPickerHeight() {
    var _this$props9 = this.props,
        daySize = _this$props9.daySize,
        numberOfMonths = _this$props9.numberOfMonths;
    var monthTitleHeight = this.state.monthTitleHeight;
    var visibleCalendarWeeks = this.calendarMonthWeeks.slice(1, numberOfMonths + 1);
    var calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);
    var newMonthHeight = monthTitleHeight + calendarMonthWeeksHeight + 1;

    if (this.isHorizontal()) {
      this.adjustDayPickerHeight(newMonthHeight);
    }
  };

  _proto.openKeyboardShortcutsPanel = function openKeyboardShortcutsPanel(onCloseCallBack) {
    this.setState({
      showKeyboardShortcuts: true,
      onKeyboardShortcutsPanelClose: onCloseCallBack
    });
  };

  _proto.closeKeyboardShortcutsPanel = function closeKeyboardShortcutsPanel() {
    var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

    if (onKeyboardShortcutsPanelClose) {
      onKeyboardShortcutsPanelClose();
    }

    this.setState({
      onKeyboardShortcutsPanelClose: null,
      showKeyboardShortcuts: false
    });
  };

  _proto.renderNavigation = function renderNavigation(navDirection) {
    var _this$props10 = this.props,
        dayPickerNavigationInlineStyles = _this$props10.dayPickerNavigationInlineStyles,
        disablePrev = _this$props10.disablePrev,
        disableNext = _this$props10.disableNext,
        navPosition = _this$props10.navPosition,
        navPrev = _this$props10.navPrev,
        navNext = _this$props10.navNext,
        noNavButtons = _this$props10.noNavButtons,
        noNavNextButton = _this$props10.noNavNextButton,
        noNavPrevButton = _this$props10.noNavPrevButton,
        orientation = _this$props10.orientation,
        phrases = _this$props10.phrases,
        renderNavPrevButton = _this$props10.renderNavPrevButton,
        renderNavNextButton = _this$props10.renderNavNextButton,
        isRTL = _this$props10.isRTL;

    if (noNavButtons) {
      return null;
    }

    var onPrevMonthClick = orientation === constants$1.VERTICAL_SCROLLABLE ? this.getPrevScrollableMonths : this.onPrevMonthClick;
    var onNextMonthClick = orientation === constants$1.VERTICAL_SCROLLABLE ? this.getNextScrollableMonths : this.onNextMonthClick;
    return _react["default"].createElement(_DayPickerNavigation["default"], {
      disablePrev: disablePrev,
      disableNext: disableNext,
      inlineStyles: dayPickerNavigationInlineStyles,
      onPrevMonthClick: onPrevMonthClick,
      onNextMonthClick: onNextMonthClick,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      orientation: orientation,
      phrases: phrases,
      isRTL: isRTL,
      showNavNextButton: !(noNavNextButton || orientation === constants$1.VERTICAL_SCROLLABLE && navDirection === PREV_NAV),
      showNavPrevButton: !(noNavPrevButton || orientation === constants$1.VERTICAL_SCROLLABLE && navDirection === NEXT_NAV)
    });
  };

  _proto.renderWeekHeader = function renderWeekHeader(index) {
    var _this$props11 = this.props,
        daySize = _this$props11.daySize,
        horizontalMonthPadding = _this$props11.horizontalMonthPadding,
        orientation = _this$props11.orientation,
        renderWeekHeaderElement = _this$props11.renderWeekHeaderElement,
        styles = _this$props11.styles;
    var calendarMonthWidth = this.state.calendarMonthWidth;
    var verticalScrollable = orientation === constants$1.VERTICAL_SCROLLABLE;
    var horizontalStyle = {
      left: index * calendarMonthWidth
    };
    var verticalStyle = {
      marginLeft: -calendarMonthWidth / 2
    };
    var weekHeaderStyle = {}; // no styles applied to the vertical-scrollable orientation

    if (this.isHorizontal()) {
      weekHeaderStyle = horizontalStyle;
    } else if (this.isVertical() && !verticalScrollable) {
      weekHeaderStyle = verticalStyle;
    }

    var weekHeaders = this.getWeekHeaders();
    var header = weekHeaders.map(function (day) {
      return _react["default"].createElement("li", (0, _extends2["default"])({
        key: day
      }, (0, withStyles_1.css)(styles.DayPicker_weekHeader_li, {
        width: daySize
      })), renderWeekHeaderElement ? renderWeekHeaderElement(day) : _react["default"].createElement("small", null, day));
    });
    return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPicker_weekHeader, this.isVertical() && styles.DayPicker_weekHeader__vertical, verticalScrollable && styles.DayPicker_weekHeader__verticalScrollable, weekHeaderStyle, {
      padding: "0 ".concat(horizontalMonthPadding, "px")
    }), {
      key: "week-".concat(index)
    }), _react["default"].createElement("ul", (0, withStyles_1.css)(styles.DayPicker_weekHeader_ul), header));
  };

  _proto.render = function render() {
    var _this6 = this;

    var _this$state8 = this.state,
        calendarMonthWidth = _this$state8.calendarMonthWidth,
        currentMonth = _this$state8.currentMonth,
        monthTransition = _this$state8.monthTransition,
        translationValue = _this$state8.translationValue,
        scrollableMonthMultiple = _this$state8.scrollableMonthMultiple,
        focusedDate = _this$state8.focusedDate,
        showKeyboardShortcuts = _this$state8.showKeyboardShortcuts,
        isTouch = _this$state8.isTouchDevice,
        hasSetHeight = _this$state8.hasSetHeight,
        calendarInfoWidth = _this$state8.calendarInfoWidth,
        monthTitleHeight = _this$state8.monthTitleHeight;
    var _this$props12 = this.props,
        enableOutsideDays = _this$props12.enableOutsideDays,
        numberOfMonths = _this$props12.numberOfMonths,
        orientation = _this$props12.orientation,
        modifiers = _this$props12.modifiers,
        withPortal = _this$props12.withPortal,
        onDayClick = _this$props12.onDayClick,
        onDayMouseEnter = _this$props12.onDayMouseEnter,
        onDayMouseLeave = _this$props12.onDayMouseLeave,
        firstDayOfWeek = _this$props12.firstDayOfWeek,
        renderMonthText = _this$props12.renderMonthText,
        renderCalendarDay = _this$props12.renderCalendarDay,
        renderDayContents = _this$props12.renderDayContents,
        renderCalendarInfo = _this$props12.renderCalendarInfo,
        renderMonthElement = _this$props12.renderMonthElement,
        renderKeyboardShortcutsButton = _this$props12.renderKeyboardShortcutsButton,
        renderKeyboardShortcutsPanel = _this$props12.renderKeyboardShortcutsPanel,
        calendarInfoPosition = _this$props12.calendarInfoPosition,
        hideKeyboardShortcutsPanel = _this$props12.hideKeyboardShortcutsPanel,
        onOutsideClick = _this$props12.onOutsideClick,
        monthFormat = _this$props12.monthFormat,
        daySize = _this$props12.daySize,
        isFocused = _this$props12.isFocused,
        isRTL = _this$props12.isRTL,
        styles = _this$props12.styles,
        theme = _this$props12.theme,
        phrases = _this$props12.phrases,
        verticalHeight = _this$props12.verticalHeight,
        dayAriaLabelFormat = _this$props12.dayAriaLabelFormat,
        noBorder = _this$props12.noBorder,
        transitionDuration = _this$props12.transitionDuration,
        verticalBorderSpacing = _this$props12.verticalBorderSpacing,
        horizontalMonthPadding = _this$props12.horizontalMonthPadding,
        navPosition = _this$props12.navPosition;
    var dayPickerHorizontalPadding = theme.reactDates.spacing.dayPickerHorizontalPadding;
    var isHorizontal = this.isHorizontal();
    var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
    var weekHeaders = [];

    for (var i = 0; i < numOfWeekHeaders; i += 1) {
      weekHeaders.push(this.renderWeekHeader(i));
    }

    var verticalScrollable = orientation === constants$1.VERTICAL_SCROLLABLE;
    var height;

    if (isHorizontal) {
      height = this.calendarMonthGridHeight;
    } else if (this.isVertical() && !verticalScrollable && !withPortal) {
      // If the user doesn't set a desired height,
      // we default back to this kind of made-up value that generally looks good
      height = verticalHeight || 1.75 * calendarMonthWidth;
    }

    var isCalendarMonthGridAnimating = monthTransition !== null;
    var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;
    var keyboardShortcutButtonLocation = _DayPickerKeyboardShortcuts.BOTTOM_RIGHT;

    if (this.isVertical()) {
      keyboardShortcutButtonLocation = withPortal ? _DayPickerKeyboardShortcuts.TOP_LEFT : _DayPickerKeyboardShortcuts.TOP_RIGHT;
    }

    var shouldAnimateHeight = isHorizontal && hasSetHeight;
    var calendarInfoPositionTop = calendarInfoPosition === constants$1.INFO_POSITION_TOP;
    var calendarInfoPositionBottom = calendarInfoPosition === constants$1.INFO_POSITION_BOTTOM;
    var calendarInfoPositionBefore = calendarInfoPosition === constants$1.INFO_POSITION_BEFORE;
    var calendarInfoPositionAfter = calendarInfoPosition === constants$1.INFO_POSITION_AFTER;
    var calendarInfoIsInline = calendarInfoPositionBefore || calendarInfoPositionAfter;

    var calendarInfo = renderCalendarInfo && _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setCalendarInfoRef
    }, (0, withStyles_1.css)(calendarInfoIsInline && styles.DayPicker_calendarInfo__horizontal)), renderCalendarInfo());

    var calendarInfoPanelWidth = renderCalendarInfo && calendarInfoIsInline ? calendarInfoWidth : 0;
    var firstVisibleMonthIndex = this.getFirstVisibleIndex();
    var wrapperHorizontalWidth = calendarMonthWidth * numberOfMonths + 2 * dayPickerHorizontalPadding; // Adding `1px` because of whitespace between 2 inline-block

    var fullHorizontalWidth = wrapperHorizontalWidth + calendarInfoPanelWidth + 1;
    var transitionContainerStyle = {
      width: isHorizontal && wrapperHorizontalWidth,
      height: height
    };
    var dayPickerWrapperStyle = {
      width: isHorizontal && wrapperHorizontalWidth
    };
    var dayPickerStyle = {
      width: isHorizontal && fullHorizontalWidth,
      // These values are to center the datepicker (approximately) on the page
      marginLeft: isHorizontal && withPortal ? -fullHorizontalWidth / 2 : null,
      marginTop: isHorizontal && withPortal ? -calendarMonthWidth / 2 : null
    };
    return _react["default"].createElement("div", (0, withStyles_1.css)(styles.DayPicker, isHorizontal && styles.DayPicker__horizontal, verticalScrollable && styles.DayPicker__verticalScrollable, isHorizontal && withPortal && styles.DayPicker_portal__horizontal, this.isVertical() && withPortal && styles.DayPicker_portal__vertical, dayPickerStyle, !monthTitleHeight && styles.DayPicker__hidden, !noBorder && styles.DayPicker__withBorder), _react["default"].createElement(_reactOutsideClickHandler["default"], {
      onOutsideClick: onOutsideClick
    }, (calendarInfoPositionTop || calendarInfoPositionBefore) && calendarInfo, _react["default"].createElement("div", (0, withStyles_1.css)(dayPickerWrapperStyle, calendarInfoIsInline && isHorizontal && styles.DayPicker_wrapper__horizontal), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPicker_weekHeaders, isHorizontal && styles.DayPicker_weekHeaders__horizontal), {
      "aria-hidden": "true",
      role: "presentation"
    }), weekHeaders), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPicker_focusRegion), {
      ref: this.setContainerRef,
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      onKeyDown: this.onKeyDown,
      onMouseUp: function onMouseUp() {
        _this6.setState({
          withMouseInteractions: true
        });
      },
      tabIndex: -1,
      role: "application",
      "aria-roledescription": phrases.roleDescription,
      "aria-label": phrases.calendarLabel
    }), !verticalScrollable && navPosition === constants$1.NAV_POSITION_TOP && this.renderNavigation(), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DayPicker_transitionContainer, shouldAnimateHeight && styles.DayPicker_transitionContainer__horizontal, this.isVertical() && styles.DayPicker_transitionContainer__vertical, verticalScrollable && styles.DayPicker_transitionContainer__verticalScrollable, transitionContainerStyle), {
      ref: this.setTransitionContainerRef
    }), verticalScrollable && this.renderNavigation(PREV_NAV), _react["default"].createElement(_CalendarMonthGrid["default"], {
      setMonthTitleHeight: !monthTitleHeight ? this.setMonthTitleHeight : undefined,
      translationValue: translationValue,
      enableOutsideDays: enableOutsideDays,
      firstVisibleMonthIndex: firstVisibleMonthIndex,
      initialMonth: currentMonth,
      isAnimating: isCalendarMonthGridAnimating,
      modifiers: modifiers,
      orientation: orientation,
      numberOfMonths: numberOfMonths * scrollableMonthMultiple,
      onDayClick: onDayClick,
      onDayMouseEnter: onDayMouseEnter,
      onDayMouseLeave: onDayMouseLeave,
      onMonthChange: this.onMonthChange,
      onYearChange: this.onYearChange,
      renderMonthText: renderMonthText,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderMonthElement: renderMonthElement,
      onMonthTransitionEnd: this.updateStateAfterMonthTransition,
      monthFormat: monthFormat,
      daySize: daySize,
      firstDayOfWeek: firstDayOfWeek,
      isFocused: shouldFocusDate,
      focusedDate: focusedDate,
      phrases: phrases,
      isRTL: isRTL,
      dayAriaLabelFormat: dayAriaLabelFormat,
      transitionDuration: transitionDuration,
      verticalBorderSpacing: verticalBorderSpacing,
      horizontalMonthPadding: horizontalMonthPadding
    }), verticalScrollable && this.renderNavigation(NEXT_NAV)), !verticalScrollable && navPosition === constants$1.NAV_POSITION_BOTTOM && this.renderNavigation(), !isTouch && !hideKeyboardShortcutsPanel && _react["default"].createElement(_DayPickerKeyboardShortcuts["default"], {
      block: this.isVertical() && !withPortal,
      buttonLocation: keyboardShortcutButtonLocation,
      showKeyboardShortcutsPanel: showKeyboardShortcuts,
      openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
      closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
      phrases: phrases,
      renderKeyboardShortcutsButton: renderKeyboardShortcutsButton,
      renderKeyboardShortcutsPanel: renderKeyboardShortcutsPanel
    }))), (calendarInfoPositionBottom || calendarInfoPositionAfter) && calendarInfo));
  };

  return DayPicker;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureDayPicker = DayPicker;
DayPicker.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPicker.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref4) {
  var _ref4$reactDates = _ref4.reactDates,
      color = _ref4$reactDates.color,
      font = _ref4$reactDates.font,
      noScrollBarOnVerticalScrollable = _ref4$reactDates.noScrollBarOnVerticalScrollable,
      spacing = _ref4$reactDates.spacing,
      zIndex = _ref4$reactDates.zIndex;
  return {
    DayPicker: {
      background: color.background,
      position: 'relative',
      textAlign: (0, _noflip["default"])('left')
    },
    DayPicker__horizontal: {
      background: color.background
    },
    DayPicker__verticalScrollable: {
      height: '100%'
    },
    DayPicker__hidden: {
      visibility: 'hidden'
    },
    DayPicker__withBorder: {
      boxShadow: (0, _noflip["default"])('0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07)'),
      borderRadius: 3
    },
    DayPicker_portal__horizontal: {
      boxShadow: 'none',
      position: 'absolute',
      left: (0, _noflip["default"])('50%'),
      top: '50%'
    },
    DayPicker_portal__vertical: {
      position: 'initial'
    },
    DayPicker_focusRegion: {
      outline: 'none'
    },
    DayPicker_calendarInfo__horizontal: {
      display: 'inline-block',
      verticalAlign: 'top'
    },
    DayPicker_wrapper__horizontal: {
      display: 'inline-block',
      verticalAlign: 'top'
    },
    DayPicker_weekHeaders: {
      position: 'relative'
    },
    DayPicker_weekHeaders__horizontal: {
      marginLeft: (0, _noflip["default"])(spacing.dayPickerHorizontalPadding)
    },
    DayPicker_weekHeader: {
      color: color.placeholderText,
      position: 'absolute',
      top: 62,
      zIndex: zIndex + 2,
      textAlign: (0, _noflip["default"])('left')
    },
    DayPicker_weekHeader__vertical: {
      left: (0, _noflip["default"])('50%')
    },
    DayPicker_weekHeader__verticalScrollable: {
      top: 0,
      display: 'table-row',
      borderBottom: "1px solid ".concat(color.core.border),
      background: color.background,
      marginLeft: (0, _noflip["default"])(0),
      left: (0, _noflip["default"])(0),
      width: '100%',
      textAlign: 'center'
    },
    DayPicker_weekHeader_ul: {
      listStyle: 'none',
      margin: '1px 0',
      paddingLeft: (0, _noflip["default"])(0),
      paddingRight: (0, _noflip["default"])(0),
      fontSize: font.size
    },
    DayPicker_weekHeader_li: {
      display: 'inline-block',
      textAlign: 'center'
    },
    DayPicker_transitionContainer: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 3
    },
    DayPicker_transitionContainer__horizontal: {
      transition: 'height 0.2s ease-in-out'
    },
    DayPicker_transitionContainer__vertical: {
      width: '100%'
    },
    DayPicker_transitionContainer__verticalScrollable: _objectSpread({
      paddingTop: 20,
      height: '100%',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: (0, _noflip["default"])(0),
      left: (0, _noflip["default"])(0),
      overflowY: 'scroll'
    }, noScrollBarOnVerticalScrollable && {
      '-webkitOverflowScrolling': 'touch',
      '::-webkit-scrollbar': {
        '-webkit-appearance': 'none',
        display: 'none'
      }
    })
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DayPicker);

exports["default"] = _default;
});

unwrapExports(DayPicker_1);
var DayPicker_2 = DayPicker_1.PureDayPicker;
var DayPicker_3 = DayPicker_1.defaultProps;

var getPooledMoment_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPooledMoment;

var _moment = interopRequireDefault(hooks);

var momentPool = new Map();

function getPooledMoment(dayString) {
  if (!momentPool.has(dayString)) {
    momentPool.set(dayString, (0, _moment["default"])(dayString));
  }

  return momentPool.get(dayString);
}
});

unwrapExports(getPooledMoment_1);

var DayPickerRangeController_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _slicedToArray2 = interopRequireDefault(slicedToArray);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);

var _reactMomentProptypes = interopRequireDefault(src$1);



var _moment = interopRequireDefault(hooks);

var _object = interopRequireDefault(object_values);

var _isTouchDevice = interopRequireDefault(build$3);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);

var _isNextDay = interopRequireDefault(isNextDay_1);

var _isSameDay = interopRequireDefault(isSameDay_1);

var _isAfterDay = interopRequireDefault(isAfterDay_1);

var _isBeforeDay = interopRequireDefault(isBeforeDay_1);

var _isPreviousDay = interopRequireDefault(isPreviousDay_1);

var _getVisibleDays = interopRequireDefault(getVisibleDays_1);

var _isDayVisible = interopRequireDefault(isDayVisible_1);

var _getSelectedDateOffset = interopRequireDefault(getSelectedDateOffset_1);

var _toISODateString = interopRequireDefault(toISODateString_1);



var _DisabledShape = interopRequireDefault(DisabledShape);

var _FocusedInputShape = interopRequireDefault(FocusedInputShape);

var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);

var _CalendarInfoPositionShape = interopRequireDefault(CalendarInfoPositionShape);

var _NavPositionShape = interopRequireDefault(NavPositionShape);



var _DayPicker = interopRequireDefault(DayPicker_1);

var _getPooledMoment = interopRequireDefault(getPooledMoment_1);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
  startDate: _reactMomentProptypes["default"].momentObj,
  endDate: _reactMomentProptypes["default"].momentObj,
  onDatesChange: _propTypes["default"].func,
  startDateOffset: _propTypes["default"].func,
  endDateOffset: _propTypes["default"].func,
  minDate: _reactMomentProptypes["default"].momentObj,
  maxDate: _reactMomentProptypes["default"].momentObj,
  focusedInput: _FocusedInputShape["default"],
  onFocusChange: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  minimumNights: _propTypes["default"].number,
  disabled: _DisabledShape["default"],
  isOutsideRange: _propTypes["default"].func,
  isDayBlocked: _propTypes["default"].func,
  isDayHighlighted: _propTypes["default"].func,
  getMinNightsForHoverDate: _propTypes["default"].func,
  daysViolatingMinNightsCanBeClicked: _propTypes["default"].bool,
  // DayPicker props
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes["default"].func,
  enableOutsideDays: _propTypes["default"].bool,
  numberOfMonths: _propTypes["default"].number,
  orientation: _ScrollableOrientationShape["default"],
  withPortal: _propTypes["default"].bool,
  initialVisibleMonth: _propTypes["default"].func,
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  daySize: airbnbPropTypes.nonNegativeInteger,
  noBorder: _propTypes["default"].bool,
  verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  dayPickerNavigationInlineStyles: _propTypes["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  noNavButtons: _propTypes["default"].bool,
  noNavNextButton: _propTypes["default"].bool,
  noNavPrevButton: _propTypes["default"].bool,
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  onOutsideClick: _propTypes["default"].func,
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  renderCalendarInfo: _propTypes["default"].func,
  renderKeyboardShortcutsButton: _propTypes["default"].func,
  renderKeyboardShortcutsPanel: _propTypes["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  firstDayOfWeek: _DayOfWeekShape["default"],
  verticalHeight: airbnbPropTypes.nonNegativeInteger,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  // accessibility
  onBlur: _propTypes["default"].func,
  isFocused: _propTypes["default"].bool,
  showKeyboardShortcuts: _propTypes["default"].bool,
  onTab: _propTypes["default"].func,
  onShiftTab: _propTypes["default"].func,
  // i18n
  monthFormat: _propTypes["default"].string,
  weekDayFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string,
  isRTL: _propTypes["default"].bool
}) : {};
var defaultProps = {
  startDate: undefined,
  // TODO: use null
  endDate: undefined,
  // TODO: use null
  minDate: null,
  maxDate: null,
  onDatesChange: function onDatesChange() {},
  startDateOffset: undefined,
  endDateOffset: undefined,
  focusedInput: null,
  onFocusChange: function onFocusChange() {},
  onClose: function onClose() {},
  keepOpenOnDateSelect: false,
  minimumNights: 1,
  disabled: false,
  isOutsideRange: function isOutsideRange() {},
  isDayBlocked: function isDayBlocked() {},
  isDayHighlighted: function isDayHighlighted() {},
  getMinNightsForHoverDate: function getMinNightsForHoverDate() {},
  daysViolatingMinNightsCanBeClicked: false,
  // DayPicker props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: constants$1.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  daySize: constants$1.DAY_SIZE,
  dayPickerNavigationInlineStyles: null,
  navPosition: constants$1.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  noNavButtons: false,
  noNavNextButton: false,
  noNavPrevButton: false,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onOutsideClick: function onOutsideClick() {},
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderCalendarInfo: null,
  renderMonthElement: null,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined,
  calendarInfoPosition: constants$1.INFO_POSITION_BOTTOM,
  firstDayOfWeek: null,
  verticalHeight: null,
  noBorder: false,
  transitionDuration: undefined,
  verticalBorderSpacing: undefined,
  horizontalMonthPadding: 13,
  // accessibility
  onBlur: function onBlur() {},
  isFocused: false,
  showKeyboardShortcuts: false,
  onTab: function onTab() {},
  onShiftTab: function onShiftTab() {},
  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: defaultPhrases.DayPickerPhrases,
  dayAriaLabelFormat: undefined,
  isRTL: false
};

var getChooseAvailableDatePhrase = function getChooseAvailableDatePhrase(phrases, focusedInput) {
  if (focusedInput === constants$1.START_DATE) {
    return phrases.chooseAvailableStartDate;
  }

  if (focusedInput === constants$1.END_DATE) {
    return phrases.chooseAvailableEndDate;
  }

  return phrases.chooseAvailableDate;
};

var DayPickerRangeController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerRangeController, _ref);
  var _proto = DayPickerRangeController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPickerRangeController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.isTouchDevice = (0, _isTouchDevice["default"])();
    _this.today = (0, _moment["default"])();
    _this.modifiers = {
      today: function today(day) {
        return _this.isToday(day);
      },
      blocked: function blocked(day) {
        return _this.isBlocked(day);
      },
      'blocked-calendar': function blockedCalendar(day) {
        return props.isDayBlocked(day);
      },
      'blocked-out-of-range': function blockedOutOfRange(day) {
        return props.isOutsideRange(day);
      },
      'highlighted-calendar': function highlightedCalendar(day) {
        return props.isDayHighlighted(day);
      },
      valid: function valid(day) {
        return !_this.isBlocked(day);
      },
      'selected-start': function selectedStart(day) {
        return _this.isStartDate(day);
      },
      'selected-end': function selectedEnd(day) {
        return _this.isEndDate(day);
      },
      'blocked-minimum-nights': function blockedMinimumNights(day) {
        return _this.doesNotMeetMinimumNights(day);
      },
      'selected-span': function selectedSpan(day) {
        return _this.isInSelectedSpan(day);
      },
      'last-in-range': function lastInRange(day) {
        return _this.isLastInRange(day);
      },
      hovered: function hovered(day) {
        return _this.isHovered(day);
      },
      'hovered-span': function hoveredSpan(day) {
        return _this.isInHoveredSpan(day);
      },
      'hovered-offset': function hoveredOffset(day) {
        return _this.isInHoveredSpan(day);
      },
      'after-hovered-start': function afterHoveredStart(day) {
        return _this.isDayAfterHoveredStartDate(day);
      },
      'first-day-of-week': function firstDayOfWeek(day) {
        return _this.isFirstDayOfWeek(day);
      },
      'last-day-of-week': function lastDayOfWeek(day) {
        return _this.isLastDayOfWeek(day);
      },
      'hovered-start-first-possible-end': function hoveredStartFirstPossibleEnd(day, hoverDate) {
        return _this.isFirstPossibleEndDateForHoveredStartDate(day, hoverDate);
      },
      'hovered-start-blocked-minimum-nights': function hoveredStartBlockedMinimumNights(day, hoverDate) {
        return _this.doesNotMeetMinNightsForHoveredStartDate(day, hoverDate);
      },
      'before-hovered-end': function beforeHoveredEnd(day) {
        return _this.isDayBeforeHoveredEndDate(day);
      },
      'no-selected-start-before-selected-end': function noSelectedStartBeforeSelectedEnd(day) {
        return _this.beforeSelectedEnd(day) && !props.startDate;
      },
      'selected-start-in-hovered-span': function selectedStartInHoveredSpan(day, hoverDate) {
        return _this.isStartDate(day) && (0, _isAfterDay["default"])(hoverDate, day);
      },
      'selected-start-no-selected-end': function selectedStartNoSelectedEnd(day) {
        return _this.isStartDate(day) && !props.endDate;
      },
      'selected-end-no-selected-start': function selectedEndNoSelectedStart(day) {
        return _this.isEndDate(day) && !props.startDate;
      }
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays; // initialize phrases
    // set the appropriate CalendarDay phrase based on focusedInput


    var chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);
    _this.state = {
      hoverDate: null,
      currentMonth: currentMonth,
      phrases: _objectSpread({}, props.phrases, {
        chooseAvailableDate: chooseAvailableDate
      }),
      visibleDays: visibleDays,
      disablePrev: _this.shouldDisableMonthNavigation(props.minDate, currentMonth),
      disableNext: _this.shouldDisableMonthNavigation(props.maxDate, currentMonth)
    };
    _this.onDayClick = _this.onDayClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayMouseEnter = _this.onDayMouseEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthClick = _this.onNextMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMonthChange = _this.onMonthChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearChange = _this.onYearChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetNextScrollableMonths = _this.onGetNextScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetPrevScrollableMonths = _this.onGetPrevScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var startDate = nextProps.startDate,
        endDate = nextProps.endDate,
        focusedInput = nextProps.focusedInput,
        getMinNightsForHoverDate = nextProps.getMinNightsForHoverDate,
        minimumNights = nextProps.minimumNights,
        isOutsideRange = nextProps.isOutsideRange,
        isDayBlocked = nextProps.isDayBlocked,
        isDayHighlighted = nextProps.isDayHighlighted,
        phrases = nextProps.phrases,
        initialVisibleMonth = nextProps.initialVisibleMonth,
        numberOfMonths = nextProps.numberOfMonths,
        enableOutsideDays = nextProps.enableOutsideDays;
    var _this$props = this.props,
        prevStartDate = _this$props.startDate,
        prevEndDate = _this$props.endDate,
        prevFocusedInput = _this$props.focusedInput,
        prevMinimumNights = _this$props.minimumNights,
        prevIsOutsideRange = _this$props.isOutsideRange,
        prevIsDayBlocked = _this$props.isDayBlocked,
        prevIsDayHighlighted = _this$props.isDayHighlighted,
        prevPhrases = _this$props.phrases,
        prevInitialVisibleMonth = _this$props.initialVisibleMonth,
        prevNumberOfMonths = _this$props.numberOfMonths,
        prevEnableOutsideDays = _this$props.enableOutsideDays;
    var hoverDate = this.state.hoverDate;
    var visibleDays = this.state.visibleDays;
    var recomputeOutsideRange = false;
    var recomputeDayBlocked = false;
    var recomputeDayHighlighted = false;

    if (isOutsideRange !== prevIsOutsideRange) {
      this.modifiers['blocked-out-of-range'] = function (day) {
        return isOutsideRange(day);
      };

      recomputeOutsideRange = true;
    }

    if (isDayBlocked !== prevIsDayBlocked) {
      this.modifiers['blocked-calendar'] = function (day) {
        return isDayBlocked(day);
      };

      recomputeDayBlocked = true;
    }

    if (isDayHighlighted !== prevIsDayHighlighted) {
      this.modifiers['highlighted-calendar'] = function (day) {
        return isDayHighlighted(day);
      };

      recomputeDayHighlighted = true;
    }

    var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
    var didStartDateChange = startDate !== prevStartDate;
    var didEndDateChange = endDate !== prevEndDate;
    var didFocusChange = focusedInput !== prevFocusedInput;

    if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocusedInput && didFocusChange) {
      var newMonthState = this.getStateForNewMonth(nextProps);
      var currentMonth = newMonthState.currentMonth;
      visibleDays = newMonthState.visibleDays;
      this.setState({
        currentMonth: currentMonth,
        visibleDays: visibleDays
      });
    }

    var modifiers = {};

    if (didStartDateChange) {
      modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start');
      modifiers = this.addModifier(modifiers, startDate, 'selected-start');

      if (prevStartDate) {
        var startSpan = prevStartDate.clone().add(1, 'day');
        var endSpan = prevStartDate.clone().add(prevMinimumNights + 1, 'days');
        modifiers = this.deleteModifierFromRange(modifiers, startSpan, endSpan, 'after-hovered-start');

        if (!endDate || !prevEndDate) {
          modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start-no-selected-end');
        }
      }

      if (!prevStartDate && endDate && startDate) {
        modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-no-selected-start');
        modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-in-hovered-span');
        (0, _object["default"])(visibleDays).forEach(function (days) {
          Object.keys(days).forEach(function (day) {
            var momentObj = (0, _moment["default"])(day);
            modifiers = _this2.deleteModifier(modifiers, momentObj, 'no-selected-start-before-selected-end');
          });
        });
      }
    }

    if (didEndDateChange) {
      modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end');
      modifiers = this.addModifier(modifiers, endDate, 'selected-end');

      if (prevEndDate && (!startDate || !prevStartDate)) {
        modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end-no-selected-start');
      }
    }

    if (didStartDateChange || didEndDateChange) {
      if (prevStartDate && prevEndDate) {
        modifiers = this.deleteModifierFromRange(modifiers, prevStartDate, prevEndDate.clone().add(1, 'day'), 'selected-span');
      }

      if (startDate && endDate) {
        modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');
        modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
      }

      if (startDate && !endDate) {
        modifiers = this.addModifier(modifiers, startDate, 'selected-start-no-selected-end');
      }

      if (endDate && !startDate) {
        modifiers = this.addModifier(modifiers, endDate, 'selected-end-no-selected-start');
      }

      if (!startDate && endDate) {
        (0, _object["default"])(visibleDays).forEach(function (days) {
          Object.keys(days).forEach(function (day) {
            var momentObj = (0, _moment["default"])(day);

            if ((0, _isBeforeDay["default"])(momentObj, endDate)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'no-selected-start-before-selected-end');
            }
          });
        });
      }
    }

    if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
      var _startSpan = startDate.clone().add(1, 'day');

      var _endSpan = startDate.clone().add(minimumNights + 1, 'days');

      modifiers = this.addModifierToRange(modifiers, _startSpan, _endSpan, 'after-hovered-start');
    }

    if (!this.isTouchDevice && didEndDateChange && !startDate && endDate) {
      var _startSpan2 = endDate.clone().subtract(minimumNights, 'days');

      var _endSpan2 = endDate.clone();

      modifiers = this.addModifierToRange(modifiers, _startSpan2, _endSpan2, 'before-hovered-end');
    }

    if (prevMinimumNights > 0) {
      if (didFocusChange || didStartDateChange || minimumNights !== prevMinimumNights) {
        var _startSpan3 = prevStartDate || this.today;

        modifiers = this.deleteModifierFromRange(modifiers, _startSpan3, _startSpan3.clone().add(prevMinimumNights, 'days'), 'blocked-minimum-nights');
        modifiers = this.deleteModifierFromRange(modifiers, _startSpan3, _startSpan3.clone().add(prevMinimumNights, 'days'), 'blocked');
      }
    }

    if (didFocusChange || recomputePropModifiers) {
      (0, _object["default"])(visibleDays).forEach(function (days) {
        Object.keys(days).forEach(function (day) {
          var momentObj = (0, _getPooledMoment["default"])(day);
          var isBlocked = false;

          if (didFocusChange || recomputeOutsideRange) {
            if (isOutsideRange(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
              isBlocked = true;
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
            }
          }

          if (didFocusChange || recomputeDayBlocked) {
            if (isDayBlocked(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
              isBlocked = true;
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
            }
          }

          if (isBlocked) {
            modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
          } else {
            modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
          }

          if (didFocusChange || recomputeDayHighlighted) {
            if (isDayHighlighted(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
            }
          }
        });
      });
    }

    if (!this.isTouchDevice && didFocusChange && hoverDate && !this.isBlocked(hoverDate)) {
      var minNightsForHoverDate = getMinNightsForHoverDate(hoverDate);

      if (minNightsForHoverDate > 0 && focusedInput === constants$1.END_DATE) {
        modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
        modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
      }

      if (minNightsForHoverDate > 0 && focusedInput === constants$1.START_DATE) {
        modifiers = this.addModifierToRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
        modifiers = this.addModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
      }
    }

    if (minimumNights > 0 && startDate && focusedInput === constants$1.END_DATE) {
      modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
      modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked');
    }

    var today = (0, _moment["default"])();

    if (!(0, _isSameDay["default"])(this.today, today)) {
      modifiers = this.deleteModifier(modifiers, this.today, 'today');
      modifiers = this.addModifier(modifiers, today, 'today');
      this.today = today;
    }

    if (Object.keys(modifiers).length > 0) {
      this.setState({
        visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
      });
    }

    if (didFocusChange || phrases !== prevPhrases) {
      // set the appropriate CalendarDay phrase based on focusedInput
      var chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);
      this.setState({
        phrases: _objectSpread({}, phrases, {
          chooseAvailableDate: chooseAvailableDate
        })
      });
    }
  };

  _proto.onDayClick = function onDayClick(day, e) {
    var _this$props2 = this.props,
        keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
        minimumNights = _this$props2.minimumNights,
        onBlur = _this$props2.onBlur,
        focusedInput = _this$props2.focusedInput,
        onFocusChange = _this$props2.onFocusChange,
        onClose = _this$props2.onClose,
        onDatesChange = _this$props2.onDatesChange,
        startDateOffset = _this$props2.startDateOffset,
        endDateOffset = _this$props2.endDateOffset,
        disabled = _this$props2.disabled,
        daysViolatingMinNightsCanBeClicked = _this$props2.daysViolatingMinNightsCanBeClicked;
    if (e) e.preventDefault();
    if (this.isBlocked(day, !daysViolatingMinNightsCanBeClicked)) return;
    var _this$props3 = this.props,
        startDate = _this$props3.startDate,
        endDate = _this$props3.endDate;

    if (startDateOffset || endDateOffset) {
      startDate = (0, _getSelectedDateOffset["default"])(startDateOffset, day);
      endDate = (0, _getSelectedDateOffset["default"])(endDateOffset, day);

      if (this.isBlocked(startDate) || this.isBlocked(endDate)) {
        return;
      }

      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });

      if (!keepOpenOnDateSelect) {
        onFocusChange(null);
        onClose({
          startDate: startDate,
          endDate: endDate
        });
      }
    } else if (focusedInput === constants$1.START_DATE) {
      var lastAllowedStartDate = endDate && endDate.clone().subtract(minimumNights, 'days');
      var isStartDateAfterEndDate = (0, _isBeforeDay["default"])(lastAllowedStartDate, day) || (0, _isAfterDay["default"])(startDate, endDate);
      var isEndDateDisabled = disabled === constants$1.END_DATE;

      if (!isEndDateDisabled || !isStartDateAfterEndDate) {
        startDate = day;

        if (isStartDateAfterEndDate) {
          endDate = null;
        }
      }

      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });

      if (isEndDateDisabled && !isStartDateAfterEndDate) {
        onFocusChange(null);
        onClose({
          startDate: startDate,
          endDate: endDate
        });
      } else if (!isEndDateDisabled) {
        onFocusChange(constants$1.END_DATE);
      }
    } else if (focusedInput === constants$1.END_DATE) {
      var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');

      if (!startDate) {
        endDate = day;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
        onFocusChange(constants$1.START_DATE);
      } else if ((0, _isInclusivelyAfterDay["default"])(day, firstAllowedEndDate)) {
        endDate = day;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });

        if (!keepOpenOnDateSelect) {
          onFocusChange(null);
          onClose({
            startDate: startDate,
            endDate: endDate
          });
        }
      } else if (daysViolatingMinNightsCanBeClicked && this.doesNotMeetMinimumNights(day)) {
        endDate = day;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
      } else if (disabled !== constants$1.START_DATE) {
        startDate = day;
        endDate = null;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
      } else {
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
      }
    } else {
      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
    }

    onBlur();
  };

  _proto.onDayMouseEnter = function onDayMouseEnter(day) {
    /* eslint react/destructuring-assignment: 1 */
    if (this.isTouchDevice) return;
    var _this$props4 = this.props,
        startDate = _this$props4.startDate,
        endDate = _this$props4.endDate,
        focusedInput = _this$props4.focusedInput,
        getMinNightsForHoverDate = _this$props4.getMinNightsForHoverDate,
        minimumNights = _this$props4.minimumNights,
        startDateOffset = _this$props4.startDateOffset,
        endDateOffset = _this$props4.endDateOffset;
    var _this$state = this.state,
        hoverDate = _this$state.hoverDate,
        visibleDays = _this$state.visibleDays,
        dateOffset = _this$state.dateOffset;
    var nextDateOffset = null;

    if (focusedInput) {
      var hasOffset = startDateOffset || endDateOffset;
      var modifiers = {};

      if (hasOffset) {
        var start = (0, _getSelectedDateOffset["default"])(startDateOffset, day);
        var end = (0, _getSelectedDateOffset["default"])(endDateOffset, day, function (rangeDay) {
          return rangeDay.add(1, 'day');
        });
        nextDateOffset = {
          start: start,
          end: end
        }; // eslint-disable-next-line react/destructuring-assignment

        if (dateOffset && dateOffset.start && dateOffset.end) {
          modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
        }

        modifiers = this.addModifierToRange(modifiers, start, end, 'hovered-offset');
      }

      if (!hasOffset) {
        modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
        modifiers = this.addModifier(modifiers, day, 'hovered');

        if (startDate && !endDate && focusedInput === constants$1.END_DATE) {
          if ((0, _isAfterDay["default"])(hoverDate, startDate)) {
            var endSpan = hoverDate.clone().add(1, 'day');
            modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
          }

          if ((0, _isBeforeDay["default"])(day, startDate) || (0, _isSameDay["default"])(day, startDate)) {
            modifiers = this.deleteModifier(modifiers, startDate, 'selected-start-in-hovered-span');
          }

          if (!this.isBlocked(day) && (0, _isAfterDay["default"])(day, startDate)) {
            var _endSpan3 = day.clone().add(1, 'day');

            modifiers = this.addModifierToRange(modifiers, startDate, _endSpan3, 'hovered-span');
            modifiers = this.addModifier(modifiers, startDate, 'selected-start-in-hovered-span');
          }
        }

        if (!startDate && endDate && focusedInput === constants$1.START_DATE) {
          if ((0, _isBeforeDay["default"])(hoverDate, endDate)) {
            modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
          }

          if ((0, _isAfterDay["default"])(day, endDate) || (0, _isSameDay["default"])(day, endDate)) {
            modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-in-hovered-span');
          }

          if (!this.isBlocked(day) && (0, _isBeforeDay["default"])(day, endDate)) {
            modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
            modifiers = this.addModifier(modifiers, endDate, 'selected-end-in-hovered-span');
          }
        }

        if (startDate) {
          var startSpan = startDate.clone().add(1, 'day');

          var _endSpan4 = startDate.clone().add(minimumNights + 1, 'days');

          modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan4, 'after-hovered-start');

          if ((0, _isSameDay["default"])(day, startDate)) {
            var newStartSpan = startDate.clone().add(1, 'day');
            var newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
            modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
          }
        }

        if (endDate) {
          var _startSpan4 = endDate.clone().subtract(minimumNights, 'days');

          modifiers = this.deleteModifierFromRange(modifiers, _startSpan4, endDate, 'before-hovered-end');

          if ((0, _isSameDay["default"])(day, endDate)) {
            var _newStartSpan = endDate.clone().subtract(minimumNights, 'days');

            modifiers = this.addModifierToRange(modifiers, _newStartSpan, endDate, 'before-hovered-end');
          }
        }

        if (hoverDate && !this.isBlocked(hoverDate)) {
          var minNightsForPrevHoverDate = getMinNightsForHoverDate(hoverDate);

          if (minNightsForPrevHoverDate > 0 && focusedInput === constants$1.START_DATE) {
            modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForPrevHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
            modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForPrevHoverDate, 'days'), 'hovered-start-first-possible-end');
          }
        }

        if (!this.isBlocked(day)) {
          var minNightsForHoverDate = getMinNightsForHoverDate(day);

          if (minNightsForHoverDate > 0 && focusedInput === constants$1.START_DATE) {
            modifiers = this.addModifierToRange(modifiers, day.clone().add(1, 'days'), day.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
            modifiers = this.addModifier(modifiers, day.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
          }
        }
      }

      this.setState({
        hoverDate: day,
        dateOffset: nextDateOffset,
        visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
      });
    }
  };

  _proto.onDayMouseLeave = function onDayMouseLeave(day) {
    var _this$props5 = this.props,
        startDate = _this$props5.startDate,
        endDate = _this$props5.endDate,
        focusedInput = _this$props5.focusedInput,
        getMinNightsForHoverDate = _this$props5.getMinNightsForHoverDate,
        minimumNights = _this$props5.minimumNights;
    var _this$state2 = this.state,
        hoverDate = _this$state2.hoverDate,
        visibleDays = _this$state2.visibleDays,
        dateOffset = _this$state2.dateOffset;
    if (this.isTouchDevice || !hoverDate) return;
    var modifiers = {};
    modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');

    if (dateOffset) {
      modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
    }

    if (startDate && !endDate) {
      if ((0, _isAfterDay["default"])(hoverDate, startDate)) {
        var endSpan = hoverDate.clone().add(1, 'day');
        modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
      }

      if ((0, _isAfterDay["default"])(day, startDate)) {
        modifiers = this.deleteModifier(modifiers, startDate, 'selected-start-in-hovered-span');
      }
    }

    if (!startDate && endDate) {
      if ((0, _isAfterDay["default"])(endDate, hoverDate)) {
        modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
      }

      if ((0, _isBeforeDay["default"])(day, endDate)) {
        modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-in-hovered-span');
      }
    }

    if (startDate && (0, _isSameDay["default"])(day, startDate)) {
      var startSpan = startDate.clone().add(1, 'day');

      var _endSpan5 = startDate.clone().add(minimumNights + 1, 'days');

      modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan5, 'after-hovered-start');
    }

    if (endDate && (0, _isSameDay["default"])(day, endDate)) {
      var _startSpan5 = endDate.clone().subtract(minimumNights, 'days');

      modifiers = this.deleteModifierFromRange(modifiers, _startSpan5, endDate, 'before-hovered-end');
    }

    if (!this.isBlocked(hoverDate)) {
      var minNightsForHoverDate = getMinNightsForHoverDate(hoverDate);

      if (minNightsForHoverDate > 0 && focusedInput === constants$1.START_DATE) {
        modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
        modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
      }
    }

    this.setState({
      hoverDate: null,
      visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
    });
  };

  _proto.onPrevMonthClick = function onPrevMonthClick() {
    var _this$props6 = this.props,
        enableOutsideDays = _this$props6.enableOutsideDays,
        maxDate = _this$props6.maxDate,
        minDate = _this$props6.minDate,
        numberOfMonths = _this$props6.numberOfMonths,
        onPrevMonthClick = _this$props6.onPrevMonthClick;
    var _this$state3 = this.state,
        currentMonth = _this$state3.currentMonth,
        visibleDays = _this$state3.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var prevMonth = currentMonth.clone().subtract(2, 'months');
    var prevMonthVisibleDays = (0, _getVisibleDays["default"])(prevMonth, 1, enableOutsideDays, true);
    var newCurrentMonth = currentMonth.clone().subtract(1, 'month');
    this.setState({
      currentMonth: newCurrentMonth,
      disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
      disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(prevMonthVisibleDays))
    }, function () {
      onPrevMonthClick(newCurrentMonth.clone());
    });
  };

  _proto.onNextMonthClick = function onNextMonthClick() {
    var _this$props7 = this.props,
        enableOutsideDays = _this$props7.enableOutsideDays,
        maxDate = _this$props7.maxDate,
        minDate = _this$props7.minDate,
        numberOfMonths = _this$props7.numberOfMonths,
        onNextMonthClick = _this$props7.onNextMonthClick;
    var _this$state4 = this.state,
        currentMonth = _this$state4.currentMonth,
        visibleDays = _this$state4.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
    var nextMonthVisibleDays = (0, _getVisibleDays["default"])(nextMonth, 1, enableOutsideDays, true);
    var newCurrentMonth = currentMonth.clone().add(1, 'month');
    this.setState({
      currentMonth: newCurrentMonth,
      disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
      disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(nextMonthVisibleDays))
    }, function () {
      onNextMonthClick(newCurrentMonth.clone());
    });
  };

  _proto.onMonthChange = function onMonthChange(newMonth) {
    var _this$props8 = this.props,
        numberOfMonths = _this$props8.numberOfMonths,
        enableOutsideDays = _this$props8.enableOutsideDays,
        orientation = _this$props8.orientation;
    var withoutTransitionMonths = orientation === constants$1.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onYearChange = function onYearChange(newMonth) {
    var _this$props9 = this.props,
        numberOfMonths = _this$props9.numberOfMonths,
        enableOutsideDays = _this$props9.enableOutsideDays,
        orientation = _this$props9.orientation;
    var withoutTransitionMonths = orientation === constants$1.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onGetNextScrollableMonths = function onGetNextScrollableMonths() {
    var _this$props10 = this.props,
        numberOfMonths = _this$props10.numberOfMonths,
        enableOutsideDays = _this$props10.enableOutsideDays;
    var _this$state5 = this.state,
        currentMonth = _this$state5.currentMonth,
        visibleDays = _this$state5.visibleDays;
    var numberOfVisibleMonths = Object.keys(visibleDays).length;
    var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(nextMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.onGetPrevScrollableMonths = function onGetPrevScrollableMonths() {
    var _this$props11 = this.props,
        numberOfMonths = _this$props11.numberOfMonths,
        enableOutsideDays = _this$props11.enableOutsideDays;
    var _this$state6 = this.state,
        currentMonth = _this$state6.currentMonth,
        visibleDays = _this$state6.visibleDays;
    var firstPreviousMonth = currentMonth.clone().subtract(numberOfMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(firstPreviousMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      currentMonth: firstPreviousMonth.clone(),
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.getFirstFocusableDay = function getFirstFocusableDay(newMonth) {
    var _this3 = this;

    var _this$props12 = this.props,
        startDate = _this$props12.startDate,
        endDate = _this$props12.endDate,
        focusedInput = _this$props12.focusedInput,
        minimumNights = _this$props12.minimumNights,
        numberOfMonths = _this$props12.numberOfMonths;
    var focusedDate = newMonth.clone().startOf('month');

    if (focusedInput === constants$1.START_DATE && startDate) {
      focusedDate = startDate.clone();
    } else if (focusedInput === constants$1.END_DATE && !endDate && startDate) {
      focusedDate = startDate.clone().add(minimumNights, 'days');
    } else if (focusedInput === constants$1.END_DATE && endDate) {
      focusedDate = endDate.clone();
    }

    if (this.isBlocked(focusedDate)) {
      var days = [];
      var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
      var currentDay = focusedDate.clone();

      while (!(0, _isAfterDay["default"])(currentDay, lastVisibleDay)) {
        currentDay = currentDay.clone().add(1, 'day');
        days.push(currentDay);
      }

      var viableDays = days.filter(function (day) {
        return !_this3.isBlocked(day);
      });

      if (viableDays.length > 0) {
        var _viableDays = (0, _slicedToArray2["default"])(viableDays, 1);

        focusedDate = _viableDays[0];
      }
    }

    return focusedDate;
  };

  _proto.getModifiers = function getModifiers(visibleDays) {
    var _this4 = this;

    var modifiers = {};
    Object.keys(visibleDays).forEach(function (month) {
      modifiers[month] = {};
      visibleDays[month].forEach(function (day) {
        modifiers[month][(0, _toISODateString["default"])(day)] = _this4.getModifiersForDay(day);
      });
    });
    return modifiers;
  };

  _proto.getModifiersForDay = function getModifiersForDay(day) {
    var _this5 = this;

    return new Set(Object.keys(this.modifiers).filter(function (modifier) {
      return _this5.modifiers[modifier](day);
    }));
  };

  _proto.getStateForNewMonth = function getStateForNewMonth(nextProps) {
    var _this6 = this;

    var initialVisibleMonth = nextProps.initialVisibleMonth,
        numberOfMonths = nextProps.numberOfMonths,
        enableOutsideDays = nextProps.enableOutsideDays,
        orientation = nextProps.orientation,
        startDate = nextProps.startDate;
    var initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
      return startDate;
    } : function () {
      return _this6.today;
    });
    var currentMonth = initialVisibleMonthThunk();
    var withoutTransitionMonths = orientation === constants$1.VERTICAL_SCROLLABLE;
    var visibleDays = this.getModifiers((0, _getVisibleDays["default"])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
    return {
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };
  };

  _proto.shouldDisableMonthNavigation = function shouldDisableMonthNavigation(date, visibleMonth) {
    if (!date) return false;
    var _this$props13 = this.props,
        numberOfMonths = _this$props13.numberOfMonths,
        enableOutsideDays = _this$props13.enableOutsideDays;
    return (0, _isDayVisible["default"])(date, visibleMonth, numberOfMonths, enableOutsideDays);
  };

  _proto.addModifier = function addModifier(updatedDays, day, modifier) {
    return (0, modifiers$1.addModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.addModifierToRange = function addModifierToRange(updatedDays, start, end, modifier) {
    var days = updatedDays;
    var spanStart = start.clone();

    while ((0, _isBeforeDay["default"])(spanStart, end)) {
      days = this.addModifier(days, spanStart, modifier);
      spanStart = spanStart.clone().add(1, 'day');
    }

    return days;
  };

  _proto.deleteModifier = function deleteModifier(updatedDays, day, modifier) {
    return (0, modifiers$1.deleteModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.deleteModifierFromRange = function deleteModifierFromRange(updatedDays, start, end, modifier) {
    var days = updatedDays;
    var spanStart = start.clone();

    while ((0, _isBeforeDay["default"])(spanStart, end)) {
      days = this.deleteModifier(days, spanStart, modifier);
      spanStart = spanStart.clone().add(1, 'day');
    }

    return days;
  };

  _proto.doesNotMeetMinimumNights = function doesNotMeetMinimumNights(day) {
    var _this$props14 = this.props,
        startDate = _this$props14.startDate,
        isOutsideRange = _this$props14.isOutsideRange,
        focusedInput = _this$props14.focusedInput,
        minimumNights = _this$props14.minimumNights;
    if (focusedInput !== constants$1.END_DATE) return false;

    if (startDate) {
      var dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
      return dayDiff < minimumNights && dayDiff >= 0;
    }

    return isOutsideRange((0, _moment["default"])(day).subtract(minimumNights, 'days'));
  };

  _proto.doesNotMeetMinNightsForHoveredStartDate = function doesNotMeetMinNightsForHoveredStartDate(day, hoverDate) {
    var _this$props15 = this.props,
        focusedInput = _this$props15.focusedInput,
        getMinNightsForHoverDate = _this$props15.getMinNightsForHoverDate;
    if (focusedInput !== constants$1.END_DATE) return false;

    if (hoverDate && !this.isBlocked(hoverDate)) {
      var minNights = getMinNightsForHoverDate(hoverDate);
      var dayDiff = day.diff(hoverDate.clone().startOf('day').hour(12), 'days');
      return dayDiff < minNights && dayDiff >= 0;
    }

    return false;
  };

  _proto.isDayAfterHoveredStartDate = function isDayAfterHoveredStartDate(day) {
    var _this$props16 = this.props,
        startDate = _this$props16.startDate,
        endDate = _this$props16.endDate,
        minimumNights = _this$props16.minimumNights;

    var _ref2 = this.state || {},
        hoverDate = _ref2.hoverDate;

    return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay["default"])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay["default"])(hoverDate, startDate);
  };

  _proto.isEndDate = function isEndDate(day) {
    var endDate = this.props.endDate;
    return (0, _isSameDay["default"])(day, endDate);
  };

  _proto.isHovered = function isHovered(day) {
    var _ref3 = this.state || {},
        hoverDate = _ref3.hoverDate;

    var focusedInput = this.props.focusedInput;
    return !!focusedInput && (0, _isSameDay["default"])(day, hoverDate);
  };

  _proto.isInHoveredSpan = function isInHoveredSpan(day) {
    var _this$props17 = this.props,
        startDate = _this$props17.startDate,
        endDate = _this$props17.endDate;

    var _ref4 = this.state || {},
        hoverDate = _ref4.hoverDate;

    var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay["default"])(hoverDate, day));
    var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay["default"])(hoverDate, day));
    var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);
    return (isForwardRange || isBackwardRange) && isValidDayHovered;
  };

  _proto.isInSelectedSpan = function isInSelectedSpan(day) {
    var _this$props18 = this.props,
        startDate = _this$props18.startDate,
        endDate = _this$props18.endDate;
    return day.isBetween(startDate, endDate, 'days');
  };

  _proto.isLastInRange = function isLastInRange(day) {
    var endDate = this.props.endDate;
    return this.isInSelectedSpan(day) && (0, _isNextDay["default"])(day, endDate);
  };

  _proto.isStartDate = function isStartDate(day) {
    var startDate = this.props.startDate;
    return (0, _isSameDay["default"])(day, startDate);
  };

  _proto.isBlocked = function isBlocked(day) {
    var blockDaysViolatingMinNights = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _this$props19 = this.props,
        isDayBlocked = _this$props19.isDayBlocked,
        isOutsideRange = _this$props19.isOutsideRange;
    return isDayBlocked(day) || isOutsideRange(day) || blockDaysViolatingMinNights && this.doesNotMeetMinimumNights(day);
  };

  _proto.isToday = function isToday(day) {
    return (0, _isSameDay["default"])(day, this.today);
  };

  _proto.isFirstDayOfWeek = function isFirstDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === (firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek());
  };

  _proto.isLastDayOfWeek = function isLastDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === ((firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek()) + 6) % 7;
  };

  _proto.isFirstPossibleEndDateForHoveredStartDate = function isFirstPossibleEndDateForHoveredStartDate(day, hoverDate) {
    var _this$props20 = this.props,
        focusedInput = _this$props20.focusedInput,
        getMinNightsForHoverDate = _this$props20.getMinNightsForHoverDate;
    if (focusedInput !== constants$1.END_DATE || !hoverDate || this.isBlocked(hoverDate)) return false;
    var minNights = getMinNightsForHoverDate(hoverDate);
    var firstAvailableEndDate = hoverDate.clone().add(minNights, 'days');
    return (0, _isSameDay["default"])(day, firstAvailableEndDate);
  };

  _proto.beforeSelectedEnd = function beforeSelectedEnd(day) {
    var endDate = this.props.endDate;
    return (0, _isBeforeDay["default"])(day, endDate);
  };

  _proto.isDayBeforeHoveredEndDate = function isDayBeforeHoveredEndDate(day) {
    var _this$props21 = this.props,
        startDate = _this$props21.startDate,
        endDate = _this$props21.endDate,
        minimumNights = _this$props21.minimumNights;

    var _ref5 = this.state || {},
        hoverDate = _ref5.hoverDate;

    return !!endDate && !startDate && !this.isBlocked(day) && (0, _isPreviousDay["default"])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay["default"])(hoverDate, endDate);
  };

  _proto.render = function render() {
    var _this$props22 = this.props,
        numberOfMonths = _this$props22.numberOfMonths,
        orientation = _this$props22.orientation,
        monthFormat = _this$props22.monthFormat,
        renderMonthText = _this$props22.renderMonthText,
        renderWeekHeaderElement = _this$props22.renderWeekHeaderElement,
        dayPickerNavigationInlineStyles = _this$props22.dayPickerNavigationInlineStyles,
        navPosition = _this$props22.navPosition,
        navPrev = _this$props22.navPrev,
        navNext = _this$props22.navNext,
        renderNavPrevButton = _this$props22.renderNavPrevButton,
        renderNavNextButton = _this$props22.renderNavNextButton,
        noNavButtons = _this$props22.noNavButtons,
        noNavNextButton = _this$props22.noNavNextButton,
        noNavPrevButton = _this$props22.noNavPrevButton,
        onOutsideClick = _this$props22.onOutsideClick,
        withPortal = _this$props22.withPortal,
        enableOutsideDays = _this$props22.enableOutsideDays,
        firstDayOfWeek = _this$props22.firstDayOfWeek,
        renderKeyboardShortcutsButton = _this$props22.renderKeyboardShortcutsButton,
        renderKeyboardShortcutsPanel = _this$props22.renderKeyboardShortcutsPanel,
        hideKeyboardShortcutsPanel = _this$props22.hideKeyboardShortcutsPanel,
        daySize = _this$props22.daySize,
        focusedInput = _this$props22.focusedInput,
        renderCalendarDay = _this$props22.renderCalendarDay,
        renderDayContents = _this$props22.renderDayContents,
        renderCalendarInfo = _this$props22.renderCalendarInfo,
        renderMonthElement = _this$props22.renderMonthElement,
        calendarInfoPosition = _this$props22.calendarInfoPosition,
        onBlur = _this$props22.onBlur,
        onShiftTab = _this$props22.onShiftTab,
        onTab = _this$props22.onTab,
        isFocused = _this$props22.isFocused,
        showKeyboardShortcuts = _this$props22.showKeyboardShortcuts,
        isRTL = _this$props22.isRTL,
        weekDayFormat = _this$props22.weekDayFormat,
        dayAriaLabelFormat = _this$props22.dayAriaLabelFormat,
        verticalHeight = _this$props22.verticalHeight,
        noBorder = _this$props22.noBorder,
        transitionDuration = _this$props22.transitionDuration,
        verticalBorderSpacing = _this$props22.verticalBorderSpacing,
        horizontalMonthPadding = _this$props22.horizontalMonthPadding;
    var _this$state7 = this.state,
        currentMonth = _this$state7.currentMonth,
        phrases = _this$state7.phrases,
        visibleDays = _this$state7.visibleDays,
        disablePrev = _this$state7.disablePrev,
        disableNext = _this$state7.disableNext;
    return _react["default"].createElement(_DayPicker["default"], {
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      modifiers: visibleDays,
      numberOfMonths: numberOfMonths,
      onDayClick: this.onDayClick,
      onDayMouseEnter: this.onDayMouseEnter,
      onDayMouseLeave: this.onDayMouseLeave,
      onPrevMonthClick: this.onPrevMonthClick,
      onNextMonthClick: this.onNextMonthClick,
      onMonthChange: this.onMonthChange,
      onTab: onTab,
      onShiftTab: onShiftTab,
      onYearChange: this.onYearChange,
      onGetNextScrollableMonths: this.onGetNextScrollableMonths,
      onGetPrevScrollableMonths: this.onGetPrevScrollableMonths,
      monthFormat: monthFormat,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      withPortal: withPortal,
      hidden: !focusedInput,
      initialVisibleMonth: function initialVisibleMonth() {
        return currentMonth;
      },
      daySize: daySize,
      onOutsideClick: onOutsideClick,
      disablePrev: disablePrev,
      disableNext: disableNext,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      noNavButtons: noNavButtons,
      noNavPrevButton: noNavPrevButton,
      noNavNextButton: noNavNextButton,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      renderKeyboardShortcutsButton: renderKeyboardShortcutsButton,
      renderKeyboardShortcutsPanel: renderKeyboardShortcutsPanel,
      calendarInfoPosition: calendarInfoPosition,
      firstDayOfWeek: firstDayOfWeek,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      isFocused: isFocused,
      getFirstFocusableDay: this.getFirstFocusableDay,
      onBlur: onBlur,
      showKeyboardShortcuts: showKeyboardShortcuts,
      phrases: phrases,
      isRTL: isRTL,
      weekDayFormat: weekDayFormat,
      dayAriaLabelFormat: dayAriaLabelFormat,
      verticalHeight: verticalHeight,
      verticalBorderSpacing: verticalBorderSpacing,
      noBorder: noBorder,
      transitionDuration: transitionDuration,
      horizontalMonthPadding: horizontalMonthPadding
    });
  };

  return DayPickerRangeController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = DayPickerRangeController;
DayPickerRangeController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPickerRangeController.defaultProps = defaultProps;
});

unwrapExports(DayPickerRangeController_1);

var DateRangePicker_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureDateRangePicker = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _moment = interopRequireDefault(hooks);









var _isTouchDevice = interopRequireDefault(build$3);

var _reactOutsideClickHandler = interopRequireDefault(reactOutsideClickHandler);

var _DateRangePickerShape = interopRequireDefault(DateRangePickerShape);



var _getResponsiveContainerStyles = interopRequireDefault(getResponsiveContainerStyles_1);

var _getDetachedContainerStyles = interopRequireDefault(getDetachedContainerStyles_1);

var _getInputHeight = interopRequireDefault(getInputHeight_1);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);

var _disableScroll2 = interopRequireDefault(disableScroll_1);

var _noflip = interopRequireDefault(noflip_1);

var _DateRangePickerInputController = interopRequireDefault(DateRangePickerInputController_1);

var _DayPickerRangeController = interopRequireDefault(DayPickerRangeController_1);

var _CloseButton = interopRequireDefault(CloseButton_1);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {}, _DateRangePickerShape["default"])) : {};
var defaultProps = {
  // required props for a functional interactive DateRangePicker
  startDate: null,
  endDate: null,
  focusedInput: null,
  // input related props
  startDatePlaceholderText: 'Start Date',
  endDatePlaceholderText: 'End Date',
  startDateAriaLabel: undefined,
  endDateAriaLabel: undefined,
  startDateOffset: undefined,
  endDateOffset: undefined,
  disabled: false,
  required: false,
  readOnly: false,
  screenReaderInputMessage: '',
  showClearDates: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$1.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  keepFocusOnInput: false,
  // calendar presentation and interaction related props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  orientation: constants$1.HORIZONTAL_ORIENTATION,
  anchorDirection: constants$1.ANCHOR_LEFT,
  openDirection: constants$1.OPEN_DOWN,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  appendToBody: false,
  disableScroll: false,
  initialVisibleMonth: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  renderCalendarInfo: null,
  calendarInfoPosition: constants$1.INFO_POSITION_BOTTOM,
  hideKeyboardShortcutsPanel: false,
  daySize: constants$1.DAY_SIZE,
  isRTL: false,
  firstDayOfWeek: null,
  verticalHeight: null,
  transitionDuration: undefined,
  verticalSpacing: constants$1.DEFAULT_VERTICAL_SPACING,
  horizontalMonthPadding: undefined,
  // navigation related props
  dayPickerNavigationInlineStyles: null,
  navPosition: constants$1.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onClose: function onClose() {},
  // day presentation and interaction related props
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderMonthElement: null,
  minimumNights: 1,
  enableOutsideDays: false,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  isDayHighlighted: function isDayHighlighted() {
    return false;
  },
  minDate: undefined,
  maxDate: undefined,
  // internationalization
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: defaultPhrases.DateRangePickerPhrases,
  dayAriaLabelFormat: undefined
};

var DateRangePicker =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DateRangePicker, _ref);
  var _proto = DateRangePicker.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DateRangePicker(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.state = {
      dayPickerContainerStyles: {},
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    };
    _this.isTouchDevice = false;
    _this.onOutsideClick = _this.onOutsideClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDateRangePickerInputFocus = _this.onDateRangePickerInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerFocus = _this.onDayPickerFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerFocusOut = _this.onDayPickerFocusOut.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerBlur = _this.onDayPickerBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.disableScroll = _this.disableScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.removeEventListener = (0, index_esm.addEventListener)(window, 'resize', this.responsivizePickerPosition, {
      passive: true
    });
    this.responsivizePickerPosition();
    this.disableScroll();
    var focusedInput = this.props.focusedInput;

    if (focusedInput) {
      this.setState({
        isDateRangePickerInputFocused: true
      });
    }

    this.isTouchDevice = (0, _isTouchDevice["default"])();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var focusedInput = this.props.focusedInput;

    if (!prevProps.focusedInput && focusedInput && this.isOpened()) {
      // The date picker just changed from being closed to being open.
      this.responsivizePickerPosition();
      this.disableScroll();
    } else if (prevProps.focusedInput && !focusedInput && !this.isOpened()) {
      // The date picker just changed from being open to being closed.
      if (this.enableScroll) this.enableScroll();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeDayPickerEventListeners();
    if (this.removeEventListener) this.removeEventListener();
    if (this.enableScroll) this.enableScroll();
  };

  _proto.onOutsideClick = function onOutsideClick(event) {
    var _this$props = this.props,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate,
        appendToBody = _this$props.appendToBody;
    if (!this.isOpened()) return;
    if (appendToBody && this.dayPickerContainer.contains(event.target)) return;
    this.setState({
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
    onFocusChange(null);
    onClose({
      startDate: startDate,
      endDate: endDate
    });
  };

  _proto.onDateRangePickerInputFocus = function onDateRangePickerInputFocus(focusedInput) {
    var _this$props2 = this.props,
        onFocusChange = _this$props2.onFocusChange,
        readOnly = _this$props2.readOnly,
        withPortal = _this$props2.withPortal,
        withFullScreenPortal = _this$props2.withFullScreenPortal,
        keepFocusOnInput = _this$props2.keepFocusOnInput;

    if (focusedInput) {
      var withAnyPortal = withPortal || withFullScreenPortal;
      var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;

      if (moveFocusToDayPicker) {
        this.onDayPickerFocus();
      } else {
        this.onDayPickerBlur();
      }
    }

    onFocusChange(focusedInput);
  };

  _proto.onDayPickerFocus = function onDayPickerFocus() {
    var _this$props3 = this.props,
        focusedInput = _this$props3.focusedInput,
        onFocusChange = _this$props3.onFocusChange;
    if (!focusedInput) onFocusChange(constants$1.START_DATE);
    this.setState({
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: false
    });
  };

  _proto.onDayPickerFocusOut = function onDayPickerFocusOut(event) {
    // In cases where **relatedTarget** is not null, it points to the right
    // element here. However, in cases where it is null (such as clicking on a
    // specific day) or it is **document.body** (IE11), the appropriate value is **event.target**.
    //
    // We handle both situations here by using the ` || ` operator to fallback
    // to *event.target** when **relatedTarget** is not provided.
    var relatedTarget = event.relatedTarget === document.body ? event.target : event.relatedTarget || event.target;
    if (this.dayPickerContainer.contains(relatedTarget)) return;
    this.onOutsideClick(event);
  };

  _proto.onDayPickerBlur = function onDayPickerBlur() {
    this.setState({
      isDateRangePickerInputFocused: true,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
  };

  _proto.setDayPickerContainerRef = function setDayPickerContainerRef(ref) {
    if (ref === this.dayPickerContainer) return;
    if (this.dayPickerContainer) this.removeDayPickerEventListeners();
    this.dayPickerContainer = ref;
    if (!ref) return;
    this.addDayPickerEventListeners();
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.addDayPickerEventListeners = function addDayPickerEventListeners() {
    // NOTE: We are using a manual event listener here, because React doesn't
    // provide FocusOut, while blur and keydown don't provide the information
    // needed in order to know whether we have left focus or not.
    //
    // For reference, this issue is further described here:
    // - https://github.com/facebook/react/issues/6410
    this.removeDayPickerFocusOut = (0, index_esm.addEventListener)(this.dayPickerContainer, 'focusout', this.onDayPickerFocusOut);
  };

  _proto.removeDayPickerEventListeners = function removeDayPickerEventListeners() {
    if (this.removeDayPickerFocusOut) this.removeDayPickerFocusOut();
  };

  _proto.isOpened = function isOpened() {
    var focusedInput = this.props.focusedInput;
    return focusedInput === constants$1.START_DATE || focusedInput === constants$1.END_DATE;
  };

  _proto.disableScroll = function disableScroll() {
    var _this$props4 = this.props,
        appendToBody = _this$props4.appendToBody,
        propDisableScroll = _this$props4.disableScroll;
    if (!appendToBody && !propDisableScroll) return;
    if (!this.isOpened()) return; // Disable scroll for every ancestor of this DateRangePicker up to the
    // document level. This ensures the input and the picker never move. Other
    // sibling elements or the picker itself can scroll.

    this.enableScroll = (0, _disableScroll2["default"])(this.container);
  };

  _proto.responsivizePickerPosition = function responsivizePickerPosition() {
    // It's possible the portal props have been changed in response to window resizes
    // So let's ensure we reset this back to the base state each time
    var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

    if (Object.keys(dayPickerContainerStyles).length > 0) {
      this.setState({
        dayPickerContainerStyles: {}
      });
    }

    if (!this.isOpened()) {
      return;
    }

    var _this$props5 = this.props,
        openDirection = _this$props5.openDirection,
        anchorDirection = _this$props5.anchorDirection,
        horizontalMargin = _this$props5.horizontalMargin,
        withPortal = _this$props5.withPortal,
        withFullScreenPortal = _this$props5.withFullScreenPortal,
        appendToBody = _this$props5.appendToBody;
    var isAnchoredLeft = anchorDirection === constants$1.ANCHOR_LEFT;

    if (!withPortal && !withFullScreenPortal) {
      var containerRect = this.dayPickerContainer.getBoundingClientRect();
      var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
      var containerEdge = isAnchoredLeft ? containerRect[constants$1.ANCHOR_RIGHT] : containerRect[constants$1.ANCHOR_LEFT];
      this.setState({
        dayPickerContainerStyles: _objectSpread({}, (0, _getResponsiveContainerStyles["default"])(anchorDirection, currentOffset, containerEdge, horizontalMargin), {}, appendToBody && (0, _getDetachedContainerStyles["default"])(openDirection, anchorDirection, this.container))
      });
    }
  };

  _proto.showKeyboardShortcutsPanel = function showKeyboardShortcutsPanel() {
    this.setState({
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: true
    });
  };

  _proto.maybeRenderDayPickerWithPortal = function maybeRenderDayPickerWithPortal() {
    var _this$props6 = this.props,
        withPortal = _this$props6.withPortal,
        withFullScreenPortal = _this$props6.withFullScreenPortal,
        appendToBody = _this$props6.appendToBody;

    if (!this.isOpened()) {
      return null;
    }

    if (withPortal || withFullScreenPortal || appendToBody) {
      return _react["default"].createElement(es$1.Portal, null, this.renderDayPicker());
    }

    return this.renderDayPicker();
  };

  _proto.renderDayPicker = function renderDayPicker() {
    var _this$props7 = this.props,
        anchorDirection = _this$props7.anchorDirection,
        openDirection = _this$props7.openDirection,
        isDayBlocked = _this$props7.isDayBlocked,
        isDayHighlighted = _this$props7.isDayHighlighted,
        isOutsideRange = _this$props7.isOutsideRange,
        numberOfMonths = _this$props7.numberOfMonths,
        orientation = _this$props7.orientation,
        monthFormat = _this$props7.monthFormat,
        renderMonthText = _this$props7.renderMonthText,
        renderWeekHeaderElement = _this$props7.renderWeekHeaderElement,
        dayPickerNavigationInlineStyles = _this$props7.dayPickerNavigationInlineStyles,
        navPosition = _this$props7.navPosition,
        navPrev = _this$props7.navPrev,
        navNext = _this$props7.navNext,
        renderNavPrevButton = _this$props7.renderNavPrevButton,
        renderNavNextButton = _this$props7.renderNavNextButton,
        onPrevMonthClick = _this$props7.onPrevMonthClick,
        onNextMonthClick = _this$props7.onNextMonthClick,
        onDatesChange = _this$props7.onDatesChange,
        onFocusChange = _this$props7.onFocusChange,
        withPortal = _this$props7.withPortal,
        withFullScreenPortal = _this$props7.withFullScreenPortal,
        daySize = _this$props7.daySize,
        enableOutsideDays = _this$props7.enableOutsideDays,
        focusedInput = _this$props7.focusedInput,
        startDate = _this$props7.startDate,
        startDateOffset = _this$props7.startDateOffset,
        endDate = _this$props7.endDate,
        endDateOffset = _this$props7.endDateOffset,
        minDate = _this$props7.minDate,
        maxDate = _this$props7.maxDate,
        minimumNights = _this$props7.minimumNights,
        keepOpenOnDateSelect = _this$props7.keepOpenOnDateSelect,
        renderCalendarDay = _this$props7.renderCalendarDay,
        renderDayContents = _this$props7.renderDayContents,
        renderCalendarInfo = _this$props7.renderCalendarInfo,
        renderMonthElement = _this$props7.renderMonthElement,
        calendarInfoPosition = _this$props7.calendarInfoPosition,
        firstDayOfWeek = _this$props7.firstDayOfWeek,
        initialVisibleMonth = _this$props7.initialVisibleMonth,
        hideKeyboardShortcutsPanel = _this$props7.hideKeyboardShortcutsPanel,
        customCloseIcon = _this$props7.customCloseIcon,
        onClose = _this$props7.onClose,
        phrases = _this$props7.phrases,
        dayAriaLabelFormat = _this$props7.dayAriaLabelFormat,
        isRTL = _this$props7.isRTL,
        weekDayFormat = _this$props7.weekDayFormat,
        styles = _this$props7.styles,
        verticalHeight = _this$props7.verticalHeight,
        transitionDuration = _this$props7.transitionDuration,
        verticalSpacing = _this$props7.verticalSpacing,
        horizontalMonthPadding = _this$props7.horizontalMonthPadding,
        small = _this$props7.small,
        disabled = _this$props7.disabled,
        reactDates = _this$props7.theme.reactDates;
    var _this$state = this.state,
        dayPickerContainerStyles = _this$state.dayPickerContainerStyles,
        isDayPickerFocused = _this$state.isDayPickerFocused,
        showKeyboardShortcuts = _this$state.showKeyboardShortcuts;
    var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;

    var initialVisibleMonthThunk = initialVisibleMonth || function () {
      return startDate || endDate || (0, _moment["default"])();
    };

    var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.DateRangePicker_closeButton_svg));

    var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
    var withAnyPortal = withPortal || withFullScreenPortal;
    /* eslint-disable jsx-a11y/no-static-element-interactions */

    /* eslint-disable jsx-a11y/click-events-have-key-events */

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setDayPickerContainerRef
    }, (0, withStyles_1.css)(styles.DateRangePicker_picker, anchorDirection === constants$1.ANCHOR_LEFT && styles.DateRangePicker_picker__directionLeft, anchorDirection === constants$1.ANCHOR_RIGHT && styles.DateRangePicker_picker__directionRight, orientation === constants$1.HORIZONTAL_ORIENTATION && styles.DateRangePicker_picker__horizontal, orientation === constants$1.VERTICAL_ORIENTATION && styles.DateRangePicker_picker__vertical, !withAnyPortal && openDirection === constants$1.OPEN_DOWN && {
      top: inputHeight + verticalSpacing
    }, !withAnyPortal && openDirection === constants$1.OPEN_UP && {
      bottom: inputHeight + verticalSpacing
    }, withAnyPortal && styles.DateRangePicker_picker__portal, withFullScreenPortal && styles.DateRangePicker_picker__fullScreenPortal, isRTL && styles.DateRangePicker_picker__rtl, dayPickerContainerStyles), {
      onClick: onOutsideClick
    }), _react["default"].createElement(_DayPickerRangeController["default"], {
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      numberOfMonths: numberOfMonths,
      onPrevMonthClick: onPrevMonthClick,
      onNextMonthClick: onNextMonthClick,
      onDatesChange: onDatesChange,
      onFocusChange: onFocusChange,
      onClose: onClose,
      focusedInput: focusedInput,
      startDate: startDate,
      startDateOffset: startDateOffset,
      endDate: endDate,
      endDateOffset: endDateOffset,
      minDate: minDate,
      maxDate: maxDate,
      monthFormat: monthFormat,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      withPortal: withAnyPortal,
      daySize: daySize,
      initialVisibleMonth: initialVisibleMonthThunk,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      minimumNights: minimumNights,
      isOutsideRange: isOutsideRange,
      isDayHighlighted: isDayHighlighted,
      isDayBlocked: isDayBlocked,
      keepOpenOnDateSelect: keepOpenOnDateSelect,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      calendarInfoPosition: calendarInfoPosition,
      isFocused: isDayPickerFocused,
      showKeyboardShortcuts: showKeyboardShortcuts,
      onBlur: this.onDayPickerBlur,
      phrases: phrases,
      dayAriaLabelFormat: dayAriaLabelFormat,
      isRTL: isRTL,
      firstDayOfWeek: firstDayOfWeek,
      weekDayFormat: weekDayFormat,
      verticalHeight: verticalHeight,
      transitionDuration: transitionDuration,
      disabled: disabled,
      horizontalMonthPadding: horizontalMonthPadding
    }), withFullScreenPortal && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.DateRangePicker_closeButton), {
      type: "button",
      onClick: this.onOutsideClick,
      "aria-label": phrases.closeDatePicker
    }), closeIcon));
    /* eslint-enable jsx-a11y/no-static-element-interactions */

    /* eslint-enable jsx-a11y/click-events-have-key-events */
  };

  _proto.render = function render() {
    var _this$props8 = this.props,
        startDate = _this$props8.startDate,
        startDateId = _this$props8.startDateId,
        startDatePlaceholderText = _this$props8.startDatePlaceholderText,
        startDateAriaLabel = _this$props8.startDateAriaLabel,
        endDate = _this$props8.endDate,
        endDateId = _this$props8.endDateId,
        endDatePlaceholderText = _this$props8.endDatePlaceholderText,
        endDateAriaLabel = _this$props8.endDateAriaLabel,
        focusedInput = _this$props8.focusedInput,
        screenReaderInputMessage = _this$props8.screenReaderInputMessage,
        showClearDates = _this$props8.showClearDates,
        showDefaultInputIcon = _this$props8.showDefaultInputIcon,
        inputIconPosition = _this$props8.inputIconPosition,
        customInputIcon = _this$props8.customInputIcon,
        customArrowIcon = _this$props8.customArrowIcon,
        customCloseIcon = _this$props8.customCloseIcon,
        disabled = _this$props8.disabled,
        required = _this$props8.required,
        readOnly = _this$props8.readOnly,
        openDirection = _this$props8.openDirection,
        phrases = _this$props8.phrases,
        isOutsideRange = _this$props8.isOutsideRange,
        minimumNights = _this$props8.minimumNights,
        withPortal = _this$props8.withPortal,
        withFullScreenPortal = _this$props8.withFullScreenPortal,
        displayFormat = _this$props8.displayFormat,
        reopenPickerOnClearDates = _this$props8.reopenPickerOnClearDates,
        keepOpenOnDateSelect = _this$props8.keepOpenOnDateSelect,
        onDatesChange = _this$props8.onDatesChange,
        onClose = _this$props8.onClose,
        isRTL = _this$props8.isRTL,
        noBorder = _this$props8.noBorder,
        block = _this$props8.block,
        verticalSpacing = _this$props8.verticalSpacing,
        small = _this$props8.small,
        regular = _this$props8.regular,
        styles = _this$props8.styles;
    var isDateRangePickerInputFocused = this.state.isDateRangePickerInputFocused;
    var enableOutsideClick = !withPortal && !withFullScreenPortal;
    var hideFang = verticalSpacing < constants$1.FANG_HEIGHT_PX;

    var input = _react["default"].createElement(_DateRangePickerInputController["default"], {
      startDate: startDate,
      startDateId: startDateId,
      startDatePlaceholderText: startDatePlaceholderText,
      isStartDateFocused: focusedInput === constants$1.START_DATE,
      startDateAriaLabel: startDateAriaLabel,
      endDate: endDate,
      endDateId: endDateId,
      endDatePlaceholderText: endDatePlaceholderText,
      isEndDateFocused: focusedInput === constants$1.END_DATE,
      endDateAriaLabel: endDateAriaLabel,
      displayFormat: displayFormat,
      showClearDates: showClearDates,
      showCaret: !withPortal && !withFullScreenPortal && !hideFang,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      customInputIcon: customInputIcon,
      customArrowIcon: customArrowIcon,
      customCloseIcon: customCloseIcon,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      reopenPickerOnClearDates: reopenPickerOnClearDates,
      keepOpenOnDateSelect: keepOpenOnDateSelect,
      isOutsideRange: isOutsideRange,
      minimumNights: minimumNights,
      withFullScreenPortal: withFullScreenPortal,
      onDatesChange: onDatesChange,
      onFocusChange: this.onDateRangePickerInputFocus,
      onKeyDownArrowDown: this.onDayPickerFocus,
      onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
      onClose: onClose,
      phrases: phrases,
      screenReaderMessage: screenReaderInputMessage,
      isFocused: isDateRangePickerInputFocused,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing
    }, this.maybeRenderDayPickerWithPortal());

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setContainerRef
    }, (0, withStyles_1.css)(styles.DateRangePicker, block && styles.DateRangePicker__block)), enableOutsideClick && _react["default"].createElement(_reactOutsideClickHandler["default"], {
      onOutsideClick: this.onOutsideClick
    }, input), enableOutsideClick || input);
  };

  return DateRangePicker;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureDateRangePicker = DateRangePicker;
DateRangePicker.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DateRangePicker.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      zIndex = _ref2$reactDates.zIndex;
  return {
    DateRangePicker: {
      position: 'relative',
      display: 'inline-block'
    },
    DateRangePicker__block: {
      display: 'block'
    },
    DateRangePicker_picker: {
      zIndex: zIndex + 1,
      backgroundColor: color.background,
      position: 'absolute'
    },
    DateRangePicker_picker__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    DateRangePicker_picker__directionLeft: {
      left: (0, _noflip["default"])(0)
    },
    DateRangePicker_picker__directionRight: {
      right: (0, _noflip["default"])(0)
    },
    DateRangePicker_picker__portal: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      position: 'fixed',
      top: 0,
      left: (0, _noflip["default"])(0),
      height: '100%',
      width: '100%'
    },
    DateRangePicker_picker__fullScreenPortal: {
      backgroundColor: color.background
    },
    DateRangePicker_closeButton: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      right: (0, _noflip["default"])(0),
      padding: 15,
      zIndex: zIndex + 2,
      ':hover': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      },
      ':focus': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      }
    },
    DateRangePicker_closeButton_svg: {
      height: 15,
      width: 15,
      fill: color.core.grayLighter
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DateRangePicker);

exports["default"] = _default;
});

unwrapExports(DateRangePicker_1);
var DateRangePicker_2 = DateRangePicker_1.PureDateRangePicker;

var DayPickerSingleDateController_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _slicedToArray2 = interopRequireDefault(slicedToArray);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);

var _reactMomentProptypes = interopRequireDefault(src$1);



var _moment = interopRequireDefault(hooks);

var _object = interopRequireDefault(object_values);

var _isTouchDevice = interopRequireDefault(build$3);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _isSameDay = interopRequireDefault(isSameDay_1);

var _isAfterDay = interopRequireDefault(isAfterDay_1);

var _getVisibleDays = interopRequireDefault(getVisibleDays_1);

var _toISODateString = interopRequireDefault(toISODateString_1);



var _ScrollableOrientationShape = interopRequireDefault(ScrollableOrientationShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);

var _CalendarInfoPositionShape = interopRequireDefault(CalendarInfoPositionShape);

var _NavPositionShape = interopRequireDefault(NavPositionShape);



var _DayPicker = interopRequireDefault(DayPicker_1);

var _getPooledMoment = interopRequireDefault(getPooledMoment_1);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
  date: _reactMomentProptypes["default"].momentObj,
  onDateChange: _propTypes["default"].func,
  focused: _propTypes["default"].bool,
  onFocusChange: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  isOutsideRange: _propTypes["default"].func,
  isDayBlocked: _propTypes["default"].func,
  isDayHighlighted: _propTypes["default"].func,
  // DayPicker props
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes["default"].func,
  enableOutsideDays: _propTypes["default"].bool,
  numberOfMonths: _propTypes["default"].number,
  orientation: _ScrollableOrientationShape["default"],
  withPortal: _propTypes["default"].bool,
  initialVisibleMonth: _propTypes["default"].func,
  firstDayOfWeek: _DayOfWeekShape["default"],
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  daySize: airbnbPropTypes.nonNegativeInteger,
  verticalHeight: airbnbPropTypes.nonNegativeInteger,
  noBorder: _propTypes["default"].bool,
  verticalBorderSpacing: airbnbPropTypes.nonNegativeInteger,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  dayPickerNavigationInlineStyles: _propTypes["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  noNavButtons: _propTypes["default"].bool,
  noNavNextButton: _propTypes["default"].bool,
  noNavPrevButton: _propTypes["default"].bool,
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  onOutsideClick: _propTypes["default"].func,
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  renderCalendarInfo: _propTypes["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  // accessibility
  onBlur: _propTypes["default"].func,
  isFocused: _propTypes["default"].bool,
  showKeyboardShortcuts: _propTypes["default"].bool,
  onTab: _propTypes["default"].func,
  onShiftTab: _propTypes["default"].func,
  // i18n
  monthFormat: _propTypes["default"].string,
  weekDayFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.DayPickerPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string,
  isRTL: _propTypes["default"].bool
}) : {};
var defaultProps = {
  date: undefined,
  // TODO: use null
  onDateChange: function onDateChange() {},
  focused: false,
  onFocusChange: function onFocusChange() {},
  onClose: function onClose() {},
  keepOpenOnDateSelect: false,
  isOutsideRange: function isOutsideRange() {},
  isDayBlocked: function isDayBlocked() {},
  isDayHighlighted: function isDayHighlighted() {},
  // DayPicker props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: constants$1.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  firstDayOfWeek: null,
  daySize: constants$1.DAY_SIZE,
  verticalHeight: null,
  noBorder: false,
  verticalBorderSpacing: undefined,
  transitionDuration: undefined,
  horizontalMonthPadding: 13,
  dayPickerNavigationInlineStyles: null,
  navPosition: constants$1.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  noNavButtons: false,
  noNavNextButton: false,
  noNavPrevButton: false,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onOutsideClick: function onOutsideClick() {},
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderCalendarInfo: null,
  renderMonthElement: null,
  calendarInfoPosition: constants$1.INFO_POSITION_BOTTOM,
  // accessibility
  onBlur: function onBlur() {},
  isFocused: false,
  showKeyboardShortcuts: false,
  onTab: function onTab() {},
  onShiftTab: function onShiftTab() {},
  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: defaultPhrases.DayPickerPhrases,
  dayAriaLabelFormat: undefined,
  isRTL: false
};

var DayPickerSingleDateController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerSingleDateController, _ref);
  var _proto = DayPickerSingleDateController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPickerSingleDateController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.isTouchDevice = false;
    _this.today = (0, _moment["default"])();
    _this.modifiers = {
      today: function today(day) {
        return _this.isToday(day);
      },
      blocked: function blocked(day) {
        return _this.isBlocked(day);
      },
      'blocked-calendar': function blockedCalendar(day) {
        return props.isDayBlocked(day);
      },
      'blocked-out-of-range': function blockedOutOfRange(day) {
        return props.isOutsideRange(day);
      },
      'highlighted-calendar': function highlightedCalendar(day) {
        return props.isDayHighlighted(day);
      },
      valid: function valid(day) {
        return !_this.isBlocked(day);
      },
      hovered: function hovered(day) {
        return _this.isHovered(day);
      },
      selected: function selected(day) {
        return _this.isSelected(day);
      },
      'first-day-of-week': function firstDayOfWeek(day) {
        return _this.isFirstDayOfWeek(day);
      },
      'last-day-of-week': function lastDayOfWeek(day) {
        return _this.isLastDayOfWeek(day);
      }
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays;

    _this.state = {
      hoverDate: null,
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };
    _this.onDayMouseEnter = _this.onDayMouseEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayClick = _this.onDayClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthClick = _this.onNextMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMonthChange = _this.onMonthChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearChange = _this.onYearChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetNextScrollableMonths = _this.onGetNextScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetPrevScrollableMonths = _this.onGetPrevScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.isTouchDevice = (0, _isTouchDevice["default"])();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var date = nextProps.date,
        focused = nextProps.focused,
        isOutsideRange = nextProps.isOutsideRange,
        isDayBlocked = nextProps.isDayBlocked,
        isDayHighlighted = nextProps.isDayHighlighted,
        initialVisibleMonth = nextProps.initialVisibleMonth,
        numberOfMonths = nextProps.numberOfMonths,
        enableOutsideDays = nextProps.enableOutsideDays;
    var _this$props = this.props,
        prevIsOutsideRange = _this$props.isOutsideRange,
        prevIsDayBlocked = _this$props.isDayBlocked,
        prevIsDayHighlighted = _this$props.isDayHighlighted,
        prevNumberOfMonths = _this$props.numberOfMonths,
        prevEnableOutsideDays = _this$props.enableOutsideDays,
        prevInitialVisibleMonth = _this$props.initialVisibleMonth,
        prevFocused = _this$props.focused,
        prevDate = _this$props.date;
    var visibleDays = this.state.visibleDays;
    var recomputeOutsideRange = false;
    var recomputeDayBlocked = false;
    var recomputeDayHighlighted = false;

    if (isOutsideRange !== prevIsOutsideRange) {
      this.modifiers['blocked-out-of-range'] = function (day) {
        return isOutsideRange(day);
      };

      recomputeOutsideRange = true;
    }

    if (isDayBlocked !== prevIsDayBlocked) {
      this.modifiers['blocked-calendar'] = function (day) {
        return isDayBlocked(day);
      };

      recomputeDayBlocked = true;
    }

    if (isDayHighlighted !== prevIsDayHighlighted) {
      this.modifiers['highlighted-calendar'] = function (day) {
        return isDayHighlighted(day);
      };

      recomputeDayHighlighted = true;
    }

    var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;

    if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocused && focused) {
      var newMonthState = this.getStateForNewMonth(nextProps);
      var currentMonth = newMonthState.currentMonth;
      visibleDays = newMonthState.visibleDays;
      this.setState({
        currentMonth: currentMonth,
        visibleDays: visibleDays
      });
    }

    var didDateChange = date !== prevDate;
    var didFocusChange = focused !== prevFocused;
    var modifiers = {};

    if (didDateChange) {
      modifiers = this.deleteModifier(modifiers, prevDate, 'selected');
      modifiers = this.addModifier(modifiers, date, 'selected');
    }

    if (didFocusChange || recomputePropModifiers) {
      (0, _object["default"])(visibleDays).forEach(function (days) {
        Object.keys(days).forEach(function (day) {
          var momentObj = (0, _getPooledMoment["default"])(day);

          if (_this2.isBlocked(momentObj)) {
            modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
          } else {
            modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
          }

          if (didFocusChange || recomputeOutsideRange) {
            if (isOutsideRange(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
            }
          }

          if (didFocusChange || recomputeDayBlocked) {
            if (isDayBlocked(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
            }
          }

          if (didFocusChange || recomputeDayHighlighted) {
            if (isDayHighlighted(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
            }
          }
        });
      });
    }

    var today = (0, _moment["default"])();

    if (!(0, _isSameDay["default"])(this.today, today)) {
      modifiers = this.deleteModifier(modifiers, this.today, 'today');
      modifiers = this.addModifier(modifiers, today, 'today');
      this.today = today;
    }

    if (Object.keys(modifiers).length > 0) {
      this.setState({
        visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
      });
    }
  };

  _proto.componentWillUpdate = function componentWillUpdate() {
    this.today = (0, _moment["default"])();
  };

  _proto.onDayClick = function onDayClick(day, e) {
    if (e) e.preventDefault();
    if (this.isBlocked(day)) return;
    var _this$props2 = this.props,
        onDateChange = _this$props2.onDateChange,
        keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
        onFocusChange = _this$props2.onFocusChange,
        onClose = _this$props2.onClose;
    onDateChange(day);

    if (!keepOpenOnDateSelect) {
      onFocusChange({
        focused: false
      });
      onClose({
        date: day
      });
    }
  };

  _proto.onDayMouseEnter = function onDayMouseEnter(day) {
    if (this.isTouchDevice) return;
    var _this$state = this.state,
        hoverDate = _this$state.hoverDate,
        visibleDays = _this$state.visibleDays;
    var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
    modifiers = this.addModifier(modifiers, day, 'hovered');
    this.setState({
      hoverDate: day,
      visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
    });
  };

  _proto.onDayMouseLeave = function onDayMouseLeave() {
    var _this$state2 = this.state,
        hoverDate = _this$state2.hoverDate,
        visibleDays = _this$state2.visibleDays;
    if (this.isTouchDevice || !hoverDate) return;
    var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
    this.setState({
      hoverDate: null,
      visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
    });
  };

  _proto.onPrevMonthClick = function onPrevMonthClick() {
    var _this$props3 = this.props,
        onPrevMonthClick = _this$props3.onPrevMonthClick,
        numberOfMonths = _this$props3.numberOfMonths,
        enableOutsideDays = _this$props3.enableOutsideDays;
    var _this$state3 = this.state,
        currentMonth = _this$state3.currentMonth,
        visibleDays = _this$state3.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var prevMonth = currentMonth.clone().subtract(1, 'month');
    var prevMonthVisibleDays = (0, _getVisibleDays["default"])(prevMonth, 1, enableOutsideDays);
    this.setState({
      currentMonth: prevMonth,
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(prevMonthVisibleDays))
    }, function () {
      onPrevMonthClick(prevMonth.clone());
    });
  };

  _proto.onNextMonthClick = function onNextMonthClick() {
    var _this$props4 = this.props,
        onNextMonthClick = _this$props4.onNextMonthClick,
        numberOfMonths = _this$props4.numberOfMonths,
        enableOutsideDays = _this$props4.enableOutsideDays;
    var _this$state4 = this.state,
        currentMonth = _this$state4.currentMonth,
        visibleDays = _this$state4.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
    var nextMonthVisibleDays = (0, _getVisibleDays["default"])(nextMonth, 1, enableOutsideDays);
    var newCurrentMonth = currentMonth.clone().add(1, 'month');
    this.setState({
      currentMonth: newCurrentMonth,
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(nextMonthVisibleDays))
    }, function () {
      onNextMonthClick(newCurrentMonth.clone());
    });
  };

  _proto.onMonthChange = function onMonthChange(newMonth) {
    var _this$props5 = this.props,
        numberOfMonths = _this$props5.numberOfMonths,
        enableOutsideDays = _this$props5.enableOutsideDays,
        orientation = _this$props5.orientation;
    var withoutTransitionMonths = orientation === constants$1.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onYearChange = function onYearChange(newMonth) {
    var _this$props6 = this.props,
        numberOfMonths = _this$props6.numberOfMonths,
        enableOutsideDays = _this$props6.enableOutsideDays,
        orientation = _this$props6.orientation;
    var withoutTransitionMonths = orientation === constants$1.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onGetNextScrollableMonths = function onGetNextScrollableMonths() {
    var _this$props7 = this.props,
        numberOfMonths = _this$props7.numberOfMonths,
        enableOutsideDays = _this$props7.enableOutsideDays;
    var _this$state5 = this.state,
        currentMonth = _this$state5.currentMonth,
        visibleDays = _this$state5.visibleDays;
    var numberOfVisibleMonths = Object.keys(visibleDays).length;
    var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(nextMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.onGetPrevScrollableMonths = function onGetPrevScrollableMonths() {
    var _this$props8 = this.props,
        numberOfMonths = _this$props8.numberOfMonths,
        enableOutsideDays = _this$props8.enableOutsideDays;
    var _this$state6 = this.state,
        currentMonth = _this$state6.currentMonth,
        visibleDays = _this$state6.visibleDays;
    var firstPreviousMonth = currentMonth.clone().subtract(numberOfMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(firstPreviousMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      currentMonth: firstPreviousMonth.clone(),
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.getFirstFocusableDay = function getFirstFocusableDay(newMonth) {
    var _this3 = this;

    var _this$props9 = this.props,
        date = _this$props9.date,
        numberOfMonths = _this$props9.numberOfMonths;
    var focusedDate = newMonth.clone().startOf('month');

    if (date) {
      focusedDate = date.clone();
    }

    if (this.isBlocked(focusedDate)) {
      var days = [];
      var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
      var currentDay = focusedDate.clone();

      while (!(0, _isAfterDay["default"])(currentDay, lastVisibleDay)) {
        currentDay = currentDay.clone().add(1, 'day');
        days.push(currentDay);
      }

      var viableDays = days.filter(function (day) {
        return !_this3.isBlocked(day) && (0, _isAfterDay["default"])(day, focusedDate);
      });

      if (viableDays.length > 0) {
        var _viableDays = (0, _slicedToArray2["default"])(viableDays, 1);

        focusedDate = _viableDays[0];
      }
    }

    return focusedDate;
  };

  _proto.getModifiers = function getModifiers(visibleDays) {
    var _this4 = this;

    var modifiers = {};
    Object.keys(visibleDays).forEach(function (month) {
      modifiers[month] = {};
      visibleDays[month].forEach(function (day) {
        modifiers[month][(0, _toISODateString["default"])(day)] = _this4.getModifiersForDay(day);
      });
    });
    return modifiers;
  };

  _proto.getModifiersForDay = function getModifiersForDay(day) {
    var _this5 = this;

    return new Set(Object.keys(this.modifiers).filter(function (modifier) {
      return _this5.modifiers[modifier](day);
    }));
  };

  _proto.getStateForNewMonth = function getStateForNewMonth(nextProps) {
    var _this6 = this;

    var initialVisibleMonth = nextProps.initialVisibleMonth,
        date = nextProps.date,
        numberOfMonths = nextProps.numberOfMonths,
        orientation = nextProps.orientation,
        enableOutsideDays = nextProps.enableOutsideDays;
    var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
      return date;
    } : function () {
      return _this6.today;
    });
    var currentMonth = initialVisibleMonthThunk();
    var withoutTransitionMonths = orientation === constants$1.VERTICAL_SCROLLABLE;
    var visibleDays = this.getModifiers((0, _getVisibleDays["default"])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
    return {
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };
  };

  _proto.addModifier = function addModifier(updatedDays, day, modifier) {
    return (0, modifiers$1.addModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.deleteModifier = function deleteModifier(updatedDays, day, modifier) {
    return (0, modifiers$1.deleteModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.isBlocked = function isBlocked(day) {
    var _this$props10 = this.props,
        isDayBlocked = _this$props10.isDayBlocked,
        isOutsideRange = _this$props10.isOutsideRange;
    return isDayBlocked(day) || isOutsideRange(day);
  };

  _proto.isHovered = function isHovered(day) {
    var _ref2 = this.state || {},
        hoverDate = _ref2.hoverDate;

    return (0, _isSameDay["default"])(day, hoverDate);
  };

  _proto.isSelected = function isSelected(day) {
    var date = this.props.date;
    return (0, _isSameDay["default"])(day, date);
  };

  _proto.isToday = function isToday(day) {
    return (0, _isSameDay["default"])(day, this.today);
  };

  _proto.isFirstDayOfWeek = function isFirstDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === (firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek());
  };

  _proto.isLastDayOfWeek = function isLastDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === ((firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek()) + 6) % 7;
  };

  _proto.render = function render() {
    var _this$props11 = this.props,
        numberOfMonths = _this$props11.numberOfMonths,
        orientation = _this$props11.orientation,
        monthFormat = _this$props11.monthFormat,
        renderMonthText = _this$props11.renderMonthText,
        renderWeekHeaderElement = _this$props11.renderWeekHeaderElement,
        dayPickerNavigationInlineStyles = _this$props11.dayPickerNavigationInlineStyles,
        navPosition = _this$props11.navPosition,
        navPrev = _this$props11.navPrev,
        navNext = _this$props11.navNext,
        renderNavPrevButton = _this$props11.renderNavPrevButton,
        renderNavNextButton = _this$props11.renderNavNextButton,
        noNavButtons = _this$props11.noNavButtons,
        noNavPrevButton = _this$props11.noNavPrevButton,
        noNavNextButton = _this$props11.noNavNextButton,
        onOutsideClick = _this$props11.onOutsideClick,
        onShiftTab = _this$props11.onShiftTab,
        onTab = _this$props11.onTab,
        withPortal = _this$props11.withPortal,
        focused = _this$props11.focused,
        enableOutsideDays = _this$props11.enableOutsideDays,
        hideKeyboardShortcutsPanel = _this$props11.hideKeyboardShortcutsPanel,
        daySize = _this$props11.daySize,
        firstDayOfWeek = _this$props11.firstDayOfWeek,
        renderCalendarDay = _this$props11.renderCalendarDay,
        renderDayContents = _this$props11.renderDayContents,
        renderCalendarInfo = _this$props11.renderCalendarInfo,
        renderMonthElement = _this$props11.renderMonthElement,
        calendarInfoPosition = _this$props11.calendarInfoPosition,
        isFocused = _this$props11.isFocused,
        isRTL = _this$props11.isRTL,
        phrases = _this$props11.phrases,
        dayAriaLabelFormat = _this$props11.dayAriaLabelFormat,
        onBlur = _this$props11.onBlur,
        showKeyboardShortcuts = _this$props11.showKeyboardShortcuts,
        weekDayFormat = _this$props11.weekDayFormat,
        verticalHeight = _this$props11.verticalHeight,
        noBorder = _this$props11.noBorder,
        transitionDuration = _this$props11.transitionDuration,
        verticalBorderSpacing = _this$props11.verticalBorderSpacing,
        horizontalMonthPadding = _this$props11.horizontalMonthPadding;
    var _this$state7 = this.state,
        currentMonth = _this$state7.currentMonth,
        visibleDays = _this$state7.visibleDays;
    return _react["default"].createElement(_DayPicker["default"], {
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      modifiers: visibleDays,
      numberOfMonths: numberOfMonths,
      onDayClick: this.onDayClick,
      onDayMouseEnter: this.onDayMouseEnter,
      onDayMouseLeave: this.onDayMouseLeave,
      onPrevMonthClick: this.onPrevMonthClick,
      onNextMonthClick: this.onNextMonthClick,
      onMonthChange: this.onMonthChange,
      onYearChange: this.onYearChange,
      onGetNextScrollableMonths: this.onGetNextScrollableMonths,
      onGetPrevScrollableMonths: this.onGetPrevScrollableMonths,
      monthFormat: monthFormat,
      withPortal: withPortal,
      hidden: !focused,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      initialVisibleMonth: function initialVisibleMonth() {
        return currentMonth;
      },
      firstDayOfWeek: firstDayOfWeek,
      onOutsideClick: onOutsideClick,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      noNavButtons: noNavButtons,
      noNavNextButton: noNavNextButton,
      noNavPrevButton: noNavPrevButton,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      calendarInfoPosition: calendarInfoPosition,
      isFocused: isFocused,
      getFirstFocusableDay: this.getFirstFocusableDay,
      onBlur: onBlur,
      onTab: onTab,
      onShiftTab: onShiftTab,
      phrases: phrases,
      daySize: daySize,
      isRTL: isRTL,
      showKeyboardShortcuts: showKeyboardShortcuts,
      weekDayFormat: weekDayFormat,
      dayAriaLabelFormat: dayAriaLabelFormat,
      verticalHeight: verticalHeight,
      noBorder: noBorder,
      transitionDuration: transitionDuration,
      verticalBorderSpacing: verticalBorderSpacing,
      horizontalMonthPadding: horizontalMonthPadding
    });
  };

  return DayPickerSingleDateController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = DayPickerSingleDateController;
DayPickerSingleDateController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPickerSingleDateController.defaultProps = defaultProps;
});

unwrapExports(DayPickerSingleDateController_1);

var SingleDatePickerShape = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = interopRequireDefault(PropTypes__default['default']);

var _reactMomentProptypes = interopRequireDefault(src$1);





var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _OrientationShape = interopRequireDefault(OrientationShape);

var _AnchorDirectionShape = interopRequireDefault(AnchorDirectionShape);

var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);

var _DayOfWeekShape = interopRequireDefault(DayOfWeekShape);

var _CalendarInfoPositionShape = interopRequireDefault(CalendarInfoPositionShape);

var _NavPositionShape = interopRequireDefault(NavPositionShape);

var _default = {
  // required props for a functional interactive SingleDatePicker
  date: _reactMomentProptypes["default"].momentObj,
  onDateChange: _propTypes["default"].func.isRequired,
  focused: _propTypes["default"].bool,
  onFocusChange: _propTypes["default"].func.isRequired,
  // input related props
  id: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  screenReaderInputMessage: _propTypes["default"].string,
  showClearDate: _propTypes["default"].bool,
  customCloseIcon: _propTypes["default"].node,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes["default"].node,
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  keepFocusOnInput: _propTypes["default"].bool,
  // calendar presentation and interaction related props
  renderMonthText: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes["default"].func,
  orientation: _OrientationShape["default"],
  anchorDirection: _AnchorDirectionShape["default"],
  openDirection: _OpenDirectionShape["default"],
  horizontalMargin: _propTypes["default"].number,
  withPortal: _propTypes["default"].bool,
  withFullScreenPortal: _propTypes["default"].bool,
  appendToBody: _propTypes["default"].bool,
  disableScroll: _propTypes["default"].bool,
  initialVisibleMonth: _propTypes["default"].func,
  firstDayOfWeek: _DayOfWeekShape["default"],
  numberOfMonths: _propTypes["default"].number,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  reopenPickerOnClearDate: _propTypes["default"].bool,
  renderCalendarInfo: _propTypes["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  daySize: airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes["default"].bool,
  verticalHeight: airbnbPropTypes.nonNegativeInteger,
  transitionDuration: airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: airbnbPropTypes.nonNegativeInteger,
  // navigation related props
  dayPickerNavigationInlineStyles: _propTypes["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  // day presentation and interaction related props
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  enableOutsideDays: _propTypes["default"].bool,
  isDayBlocked: _propTypes["default"].func,
  isOutsideRange: _propTypes["default"].func,
  isDayHighlighted: _propTypes["default"].func,
  // internationalization props
  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  monthFormat: _propTypes["default"].string,
  weekDayFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.SingleDatePickerPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string
};
exports["default"] = _default;
});

unwrapExports(SingleDatePickerShape);

var SingleDatePickerInput_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);







var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _noflip = interopRequireDefault(noflip_1);

var _DateInput = interopRequireDefault(DateInput_1);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _CloseButton = interopRequireDefault(CloseButton_1);

var _CalendarIcon = interopRequireDefault(CalendarIcon_1);

var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {
  id: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node,
  placeholder: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  displayValue: _propTypes["default"].string,
  screenReaderMessage: _propTypes["default"].string,
  focused: _propTypes["default"].bool,
  isFocused: _propTypes["default"].bool,
  // describes actual DOM focus
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  showCaret: _propTypes["default"].bool,
  showClearDate: _propTypes["default"].bool,
  customCloseIcon: _propTypes["default"].node,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes["default"].node,
  isRTL: _propTypes["default"].bool,
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  onChange: _propTypes["default"].func,
  onClearDate: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDownShiftTab: _propTypes["default"].func,
  onKeyDownTab: _propTypes["default"].func,
  onKeyDownArrowDown: _propTypes["default"].func,
  onKeyDownQuestionMark: _propTypes["default"].func,
  // i18n
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.SingleDatePickerInputPhrases))
})) : {};
var defaultProps = {
  children: null,
  placeholder: 'Select Date',
  ariaLabel: undefined,
  displayValue: '',
  screenReaderMessage: '',
  focused: false,
  isFocused: false,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: constants$1.OPEN_DOWN,
  showCaret: false,
  showClearDate: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$1.ICON_BEFORE_POSITION,
  customCloseIcon: null,
  customInputIcon: null,
  isRTL: false,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  onChange: function onChange() {},
  onClearDate: function onClearDate() {},
  onFocus: function onFocus() {},
  onKeyDownShiftTab: function onKeyDownShiftTab() {},
  onKeyDownTab: function onKeyDownTab() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  // i18n
  phrases: defaultPhrases.SingleDatePickerInputPhrases
};

function SingleDatePickerInput(_ref) {
  var id = _ref.id,
      children = _ref.children,
      placeholder = _ref.placeholder,
      ariaLabel = _ref.ariaLabel,
      displayValue = _ref.displayValue,
      focused = _ref.focused,
      isFocused = _ref.isFocused,
      disabled = _ref.disabled,
      required = _ref.required,
      readOnly = _ref.readOnly,
      showCaret = _ref.showCaret,
      showClearDate = _ref.showClearDate,
      showDefaultInputIcon = _ref.showDefaultInputIcon,
      inputIconPosition = _ref.inputIconPosition,
      phrases = _ref.phrases,
      onClearDate = _ref.onClearDate,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onKeyDownShiftTab = _ref.onKeyDownShiftTab,
      onKeyDownTab = _ref.onKeyDownTab,
      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
      screenReaderMessage = _ref.screenReaderMessage,
      customCloseIcon = _ref.customCloseIcon,
      customInputIcon = _ref.customInputIcon,
      openDirection = _ref.openDirection,
      isRTL = _ref.isRTL,
      noBorder = _ref.noBorder,
      block = _ref.block,
      small = _ref.small,
      regular = _ref.regular,
      verticalSpacing = _ref.verticalSpacing,
      styles = _ref.styles;

  var calendarIcon = customInputIcon || _react["default"].createElement(_CalendarIcon["default"], (0, withStyles_1.css)(styles.SingleDatePickerInput_calendarIcon_svg));

  var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, withStyles_1.css)(styles.SingleDatePickerInput_clearDate_svg, small && styles.SingleDatePickerInput_clearDate_svg__small));

  var screenReaderText = screenReaderMessage || phrases.keyboardForwardNavigationInstructions;

  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.SingleDatePickerInput_calendarIcon), {
    type: "button",
    disabled: disabled,
    "aria-label": phrases.focusStartDate,
    onClick: onFocus
  }), calendarIcon);

  return _react["default"].createElement("div", (0, withStyles_1.css)(styles.SingleDatePickerInput, disabled && styles.SingleDatePickerInput__disabled, isRTL && styles.SingleDatePickerInput__rtl, !noBorder && styles.SingleDatePickerInput__withBorder, block && styles.SingleDatePickerInput__block, showClearDate && styles.SingleDatePickerInput__showClearDate), inputIconPosition === constants$1.ICON_BEFORE_POSITION && inputIcon, _react["default"].createElement(_DateInput["default"], {
    id: id,
    placeholder: placeholder,
    ariaLabel: ariaLabel,
    displayValue: displayValue,
    screenReaderMessage: screenReaderText,
    focused: focused,
    isFocused: isFocused,
    disabled: disabled,
    required: required,
    readOnly: readOnly,
    showCaret: showCaret,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDownShiftTab: onKeyDownShiftTab,
    onKeyDownTab: onKeyDownTab,
    onKeyDownArrowDown: onKeyDownArrowDown,
    onKeyDownQuestionMark: onKeyDownQuestionMark,
    openDirection: openDirection,
    verticalSpacing: verticalSpacing,
    small: small,
    regular: regular,
    block: block
  }), children, showClearDate && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.SingleDatePickerInput_clearDate, small && styles.SingleDatePickerInput_clearDate__small, !customCloseIcon && styles.SingleDatePickerInput_clearDate__default, !displayValue && styles.SingleDatePickerInput_clearDate__hide), {
    type: "button",
    "aria-label": phrases.clearDate,
    disabled: disabled,
    onClick: onClearDate
  }), closeIcon), inputIconPosition === constants$1.ICON_AFTER_POSITION && inputIcon);
}

SingleDatePickerInput.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
SingleDatePickerInput.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      border = _ref2$reactDates.border,
      color = _ref2$reactDates.color;
  return {
    SingleDatePickerInput: {
      display: 'inline-block',
      backgroundColor: color.background
    },
    SingleDatePickerInput__withBorder: {
      borderColor: color.border,
      borderWidth: border.pickerInput.borderWidth,
      borderStyle: border.pickerInput.borderStyle,
      borderRadius: border.pickerInput.borderRadius
    },
    SingleDatePickerInput__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    SingleDatePickerInput__disabled: {
      backgroundColor: color.disabled
    },
    SingleDatePickerInput__block: {
      display: 'block'
    },
    SingleDatePickerInput__showClearDate: {
      paddingRight: 30 // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    SingleDatePickerInput_clearDate: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      padding: 10,
      margin: '0 10px 0 5px',
      // TODO: should be noflip wrapped and handled by an isRTL prop
      position: 'absolute',
      right: 0,
      // TODO: should be noflip wrapped and handled by an isRTL prop
      top: '50%',
      transform: 'translateY(-50%)'
    },
    SingleDatePickerInput_clearDate__default: {
      ':focus': {
        background: color.core.border,
        borderRadius: '50%'
      },
      ':hover': {
        background: color.core.border,
        borderRadius: '50%'
      }
    },
    SingleDatePickerInput_clearDate__small: {
      padding: 6
    },
    SingleDatePickerInput_clearDate__hide: {
      visibility: 'hidden'
    },
    SingleDatePickerInput_clearDate_svg: {
      fill: color.core.grayLight,
      height: 12,
      width: 15,
      verticalAlign: 'middle'
    },
    SingleDatePickerInput_clearDate_svg__small: {
      height: 9
    },
    SingleDatePickerInput_calendarIcon: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: 10,
      margin: '0 5px 0 10px' // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    SingleDatePickerInput_calendarIcon_svg: {
      fill: color.core.grayLight,
      height: 15,
      width: 14,
      verticalAlign: 'middle'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(SingleDatePickerInput);

exports["default"] = _default;
});

unwrapExports(SingleDatePickerInput_1);

var SingleDatePickerInputController_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _react = interopRequireDefault(React__default['default']);

var _propTypes = interopRequireDefault(PropTypes__default['default']);

var _moment = interopRequireDefault(hooks);

var _reactMomentProptypes = interopRequireDefault(src$1);



var _OpenDirectionShape = interopRequireDefault(OpenDirectionShape);



var _getPhrasePropTypes = interopRequireDefault(getPhrasePropTypes_1);

var _SingleDatePickerInput = interopRequireDefault(SingleDatePickerInput_1);

var _IconPositionShape = interopRequireDefault(IconPositionShape);

var _DisabledShape = interopRequireDefault(DisabledShape);

var _toMomentObject = interopRequireDefault(toMomentObject_1);

var _toLocalizedDateString = interopRequireDefault(toLocalizedDateString_1);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);



var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)({
  children: _propTypes["default"].node,
  date: _reactMomentProptypes["default"].momentObj,
  onDateChange: _propTypes["default"].func.isRequired,
  focused: _propTypes["default"].bool,
  onFocusChange: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  screenReaderMessage: _propTypes["default"].string,
  showClearDate: _propTypes["default"].bool,
  showCaret: _propTypes["default"].bool,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  disabled: _DisabledShape["default"],
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  verticalSpacing: airbnbPropTypes.nonNegativeInteger,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  reopenPickerOnClearDate: _propTypes["default"].bool,
  isOutsideRange: _propTypes["default"].func,
  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  onClose: _propTypes["default"].func,
  onKeyDownArrowDown: _propTypes["default"].func,
  onKeyDownQuestionMark: _propTypes["default"].func,
  customInputIcon: _propTypes["default"].node,
  customCloseIcon: _propTypes["default"].node,
  // accessibility
  isFocused: _propTypes["default"].bool,
  // i18n
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(defaultPhrases.SingleDatePickerInputPhrases)),
  isRTL: _propTypes["default"].bool
}) : {};
var defaultProps = {
  children: null,
  date: null,
  focused: false,
  placeholder: '',
  ariaLabel: undefined,
  screenReaderMessage: 'Date',
  showClearDate: false,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$1.ICON_BEFORE_POSITION,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: constants$1.OPEN_DOWN,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  onClose: function onClose() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  customInputIcon: null,
  customCloseIcon: null,
  // accessibility
  isFocused: false,
  // i18n
  phrases: defaultPhrases.SingleDatePickerInputPhrases,
  isRTL: false
};

var SingleDatePickerInputController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(SingleDatePickerInputController, _ref);
  var _proto = SingleDatePickerInputController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function SingleDatePickerInputController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onClearFocus = _this.onClearFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearDate = _this.clearDate.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.onChange = function onChange(dateString) {
    var _this$props = this.props,
        isOutsideRange = _this$props.isOutsideRange,
        keepOpenOnDateSelect = _this$props.keepOpenOnDateSelect,
        onDateChange = _this$props.onDateChange,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose;
    var newDate = (0, _toMomentObject["default"])(dateString, this.getDisplayFormat());
    var isValid = newDate && !isOutsideRange(newDate);

    if (isValid) {
      onDateChange(newDate);

      if (!keepOpenOnDateSelect) {
        onFocusChange({
          focused: false
        });
        onClose({
          date: newDate
        });
      }
    } else {
      onDateChange(null);
    }
  };

  _proto.onFocus = function onFocus() {
    var _this$props2 = this.props,
        onFocusChange = _this$props2.onFocusChange,
        disabled = _this$props2.disabled;

    if (!disabled) {
      onFocusChange({
        focused: true
      });
    }
  };

  _proto.onClearFocus = function onClearFocus() {
    var _this$props3 = this.props,
        focused = _this$props3.focused,
        onFocusChange = _this$props3.onFocusChange,
        onClose = _this$props3.onClose,
        date = _this$props3.date;
    if (!focused) return;
    onFocusChange({
      focused: false
    });
    onClose({
      date: date
    });
  };

  _proto.getDisplayFormat = function getDisplayFormat() {
    var displayFormat = this.props.displayFormat;
    return typeof displayFormat === 'string' ? displayFormat : displayFormat();
  };

  _proto.getDateString = function getDateString(date) {
    var displayFormat = this.getDisplayFormat();

    if (date && displayFormat) {
      return date && date.format(displayFormat);
    }

    return (0, _toLocalizedDateString["default"])(date);
  };

  _proto.clearDate = function clearDate() {
    var _this$props4 = this.props,
        onDateChange = _this$props4.onDateChange,
        reopenPickerOnClearDate = _this$props4.reopenPickerOnClearDate,
        onFocusChange = _this$props4.onFocusChange;
    onDateChange(null);

    if (reopenPickerOnClearDate) {
      onFocusChange({
        focused: true
      });
    }
  };

  _proto.render = function render() {
    var _this$props5 = this.props,
        children = _this$props5.children,
        id = _this$props5.id,
        placeholder = _this$props5.placeholder,
        ariaLabel = _this$props5.ariaLabel,
        disabled = _this$props5.disabled,
        focused = _this$props5.focused,
        isFocused = _this$props5.isFocused,
        required = _this$props5.required,
        readOnly = _this$props5.readOnly,
        openDirection = _this$props5.openDirection,
        showClearDate = _this$props5.showClearDate,
        showCaret = _this$props5.showCaret,
        showDefaultInputIcon = _this$props5.showDefaultInputIcon,
        inputIconPosition = _this$props5.inputIconPosition,
        customCloseIcon = _this$props5.customCloseIcon,
        customInputIcon = _this$props5.customInputIcon,
        date = _this$props5.date,
        phrases = _this$props5.phrases,
        onKeyDownArrowDown = _this$props5.onKeyDownArrowDown,
        onKeyDownQuestionMark = _this$props5.onKeyDownQuestionMark,
        screenReaderMessage = _this$props5.screenReaderMessage,
        isRTL = _this$props5.isRTL,
        noBorder = _this$props5.noBorder,
        block = _this$props5.block,
        small = _this$props5.small,
        regular = _this$props5.regular,
        verticalSpacing = _this$props5.verticalSpacing;
    var displayValue = this.getDateString(date);
    return _react["default"].createElement(_SingleDatePickerInput["default"], {
      id: id,
      placeholder: placeholder,
      ariaLabel: ariaLabel,
      focused: focused,
      isFocused: isFocused,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      showCaret: showCaret,
      onClearDate: this.clearDate,
      showClearDate: showClearDate,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      customCloseIcon: customCloseIcon,
      customInputIcon: customInputIcon,
      displayValue: displayValue,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onKeyDownShiftTab: this.onClearFocus,
      onKeyDownArrowDown: onKeyDownArrowDown,
      onKeyDownQuestionMark: onKeyDownQuestionMark,
      screenReaderMessage: screenReaderMessage,
      phrases: phrases,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing
    }, children);
  };

  return SingleDatePickerInputController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = SingleDatePickerInputController;
SingleDatePickerInputController.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
SingleDatePickerInputController.defaultProps = defaultProps;
});

unwrapExports(SingleDatePickerInputController_1);

var SingleDatePicker_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureSingleDatePicker = void 0;

var _enzymeShallowEqual = interopRequireDefault(build);

var _extends2 = interopRequireDefault(_extends_1);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _defineProperty2 = interopRequireDefault(defineProperty$1);

var _react = interopRequireDefault(React__default['default']);

var _moment = interopRequireDefault(hooks);









var _isTouchDevice = interopRequireDefault(build$3);

var _reactOutsideClickHandler = interopRequireDefault(reactOutsideClickHandler);

var _SingleDatePickerShape = interopRequireDefault(SingleDatePickerShape);



var _getResponsiveContainerStyles = interopRequireDefault(getResponsiveContainerStyles_1);

var _getDetachedContainerStyles = interopRequireDefault(getDetachedContainerStyles_1);

var _getInputHeight = interopRequireDefault(getInputHeight_1);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);

var _disableScroll2 = interopRequireDefault(disableScroll_1);

var _noflip = interopRequireDefault(noflip_1);

var _SingleDatePickerInputController = interopRequireDefault(SingleDatePickerInputController_1);

var _DayPickerSingleDateController = interopRequireDefault(DayPickerSingleDateController_1);

var _CloseButton = interopRequireDefault(CloseButton_1);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes = process.env.NODE_ENV !== "production" ? (0, airbnbPropTypes.forbidExtraProps)(_objectSpread({}, withStyles_1.withStylesPropTypes, {}, _SingleDatePickerShape["default"])) : {};
var defaultProps = {
  // required props for a functional interactive SingleDatePicker
  date: null,
  focused: false,
  // input related props
  id: 'date',
  placeholder: 'Date',
  ariaLabel: undefined,
  disabled: false,
  required: false,
  readOnly: false,
  screenReaderInputMessage: '',
  showClearDate: false,
  showDefaultInputIcon: false,
  inputIconPosition: constants$1.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customCloseIcon: null,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: constants$1.DEFAULT_VERTICAL_SPACING,
  keepFocusOnInput: false,
  // calendar presentation and interaction related props
  orientation: constants$1.HORIZONTAL_ORIENTATION,
  anchorDirection: constants$1.ANCHOR_LEFT,
  openDirection: constants$1.OPEN_DOWN,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  appendToBody: false,
  disableScroll: false,
  initialVisibleMonth: null,
  firstDayOfWeek: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  renderCalendarInfo: null,
  calendarInfoPosition: constants$1.INFO_POSITION_BOTTOM,
  hideKeyboardShortcutsPanel: false,
  daySize: constants$1.DAY_SIZE,
  isRTL: false,
  verticalHeight: null,
  transitionDuration: undefined,
  horizontalMonthPadding: 13,
  // navigation related props
  dayPickerNavigationInlineStyles: null,
  navPosition: constants$1.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onClose: function onClose() {},
  // month presentation and interaction related props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  // day presentation and interaction related props
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderMonthElement: null,
  enableOutsideDays: false,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  isDayHighlighted: function isDayHighlighted() {},
  // internationalization props
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: defaultPhrases.SingleDatePickerPhrases,
  dayAriaLabelFormat: undefined
};

var SingleDatePicker =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(SingleDatePicker, _ref);
  var _proto = SingleDatePicker.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function SingleDatePicker(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.isTouchDevice = false;
    _this.state = {
      dayPickerContainerStyles: {},
      isDayPickerFocused: false,
      isInputFocused: false,
      showKeyboardShortcuts: false
    };
    _this.onFocusOut = _this.onFocusOut.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onOutsideClick = _this.onOutsideClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onInputFocus = _this.onInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerFocus = _this.onDayPickerFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerBlur = _this.onDayPickerBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.disableScroll = _this.disableScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  /* istanbul ignore next */


  _proto.componentDidMount = function componentDidMount() {
    this.removeResizeEventListener = (0, index_esm.addEventListener)(window, 'resize', this.responsivizePickerPosition, {
      passive: true
    });
    this.responsivizePickerPosition();
    this.disableScroll();
    var focused = this.props.focused;

    if (focused) {
      this.setState({
        isInputFocused: true
      });
    }

    this.isTouchDevice = (0, _isTouchDevice["default"])();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var focused = this.props.focused;

    if (!prevProps.focused && focused) {
      this.responsivizePickerPosition();
      this.disableScroll();
    } else if (prevProps.focused && !focused) {
      if (this.enableScroll) this.enableScroll();
    }
  }
  /* istanbul ignore next */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.removeResizeEventListener) this.removeResizeEventListener();
    if (this.removeFocusOutEventListener) this.removeFocusOutEventListener();
    if (this.enableScroll) this.enableScroll();
  };

  _proto.onOutsideClick = function onOutsideClick(event) {
    var _this$props = this.props,
        focused = _this$props.focused,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose,
        date = _this$props.date,
        appendToBody = _this$props.appendToBody;
    if (!focused) return;
    if (appendToBody && this.dayPickerContainer.contains(event.target)) return;
    this.setState({
      isInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
    onFocusChange({
      focused: false
    });
    onClose({
      date: date
    });
  };

  _proto.onInputFocus = function onInputFocus(_ref2) {
    var focused = _ref2.focused;
    var _this$props2 = this.props,
        onFocusChange = _this$props2.onFocusChange,
        readOnly = _this$props2.readOnly,
        withPortal = _this$props2.withPortal,
        withFullScreenPortal = _this$props2.withFullScreenPortal,
        keepFocusOnInput = _this$props2.keepFocusOnInput;

    if (focused) {
      var withAnyPortal = withPortal || withFullScreenPortal;
      var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;

      if (moveFocusToDayPicker) {
        this.onDayPickerFocus();
      } else {
        this.onDayPickerBlur();
      }
    }

    onFocusChange({
      focused: focused
    });
  };

  _proto.onDayPickerFocus = function onDayPickerFocus() {
    this.setState({
      isInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: false
    });
  };

  _proto.onDayPickerBlur = function onDayPickerBlur() {
    this.setState({
      isInputFocused: true,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
  };

  _proto.onFocusOut = function onFocusOut(e) {
    var onFocusChange = this.props.onFocusChange; // In cases where **relatedTarget** is not null, it points to the right
    // element here. However, in cases where it is null (such as clicking on a
    // specific day) or it is **document.body** (IE11), the appropriate value is **event.target**.
    //
    // We handle both situations here by using the ` || ` operator to fallback
    // to *event.target** when **relatedTarget** is not provided.

    var relatedTarget = e.relatedTarget === document.body ? e.target : e.relatedTarget || e.target;
    if (this.dayPickerContainer.contains(relatedTarget)) return;
    onFocusChange({
      focused: false
    });
  };

  _proto.setDayPickerContainerRef = function setDayPickerContainerRef(ref) {
    if (ref === this.dayPickerContainer) return;
    this.removeEventListeners();
    this.dayPickerContainer = ref;
    if (!ref) return;
    this.addEventListeners();
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.addEventListeners = function addEventListeners() {
    // We manually set event because React has not implemented onFocusIn/onFocusOut.
    // Keep an eye on https://github.com/facebook/react/issues/6410 for updates
    // We use "blur w/ useCapture param" vs "onfocusout" for FF browser support
    this.removeFocusOutEventListener = (0, index_esm.addEventListener)(this.dayPickerContainer, 'focusout', this.onFocusOut);
  };

  _proto.removeEventListeners = function removeEventListeners() {
    if (this.removeFocusOutEventListener) this.removeFocusOutEventListener();
  };

  _proto.disableScroll = function disableScroll() {
    var _this$props3 = this.props,
        appendToBody = _this$props3.appendToBody,
        propDisableScroll = _this$props3.disableScroll,
        focused = _this$props3.focused;
    if (!appendToBody && !propDisableScroll) return;
    if (!focused) return; // Disable scroll for every ancestor of this <SingleDatePicker> up to the
    // document level. This ensures the input and the picker never move. Other
    // sibling elements or the picker itself can scroll.

    this.enableScroll = (0, _disableScroll2["default"])(this.container);
  }
  /* istanbul ignore next */
  ;

  _proto.responsivizePickerPosition = function responsivizePickerPosition() {
    // It's possible the portal props have been changed in response to window resizes
    // So let's ensure we reset this back to the base state each time
    this.setState({
      dayPickerContainerStyles: {}
    });
    var _this$props4 = this.props,
        openDirection = _this$props4.openDirection,
        anchorDirection = _this$props4.anchorDirection,
        horizontalMargin = _this$props4.horizontalMargin,
        withPortal = _this$props4.withPortal,
        withFullScreenPortal = _this$props4.withFullScreenPortal,
        appendToBody = _this$props4.appendToBody,
        focused = _this$props4.focused;
    var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

    if (!focused) {
      return;
    }

    var isAnchoredLeft = anchorDirection === constants$1.ANCHOR_LEFT;

    if (!withPortal && !withFullScreenPortal) {
      var containerRect = this.dayPickerContainer.getBoundingClientRect();
      var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
      var containerEdge = isAnchoredLeft ? containerRect[constants$1.ANCHOR_RIGHT] : containerRect[constants$1.ANCHOR_LEFT];
      this.setState({
        dayPickerContainerStyles: _objectSpread({}, (0, _getResponsiveContainerStyles["default"])(anchorDirection, currentOffset, containerEdge, horizontalMargin), {}, appendToBody && (0, _getDetachedContainerStyles["default"])(openDirection, anchorDirection, this.container))
      });
    }
  };

  _proto.showKeyboardShortcutsPanel = function showKeyboardShortcutsPanel() {
    this.setState({
      isInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: true
    });
  };

  _proto.maybeRenderDayPickerWithPortal = function maybeRenderDayPickerWithPortal() {
    var _this$props5 = this.props,
        focused = _this$props5.focused,
        withPortal = _this$props5.withPortal,
        withFullScreenPortal = _this$props5.withFullScreenPortal,
        appendToBody = _this$props5.appendToBody;

    if (!focused) {
      return null;
    }

    if (withPortal || withFullScreenPortal || appendToBody) {
      return _react["default"].createElement(es$1.Portal, null, this.renderDayPicker());
    }

    return this.renderDayPicker();
  };

  _proto.renderDayPicker = function renderDayPicker() {
    var _this$props6 = this.props,
        anchorDirection = _this$props6.anchorDirection,
        openDirection = _this$props6.openDirection,
        onDateChange = _this$props6.onDateChange,
        date = _this$props6.date,
        onFocusChange = _this$props6.onFocusChange,
        focused = _this$props6.focused,
        enableOutsideDays = _this$props6.enableOutsideDays,
        numberOfMonths = _this$props6.numberOfMonths,
        orientation = _this$props6.orientation,
        monthFormat = _this$props6.monthFormat,
        dayPickerNavigationInlineStyles = _this$props6.dayPickerNavigationInlineStyles,
        navPosition = _this$props6.navPosition,
        navPrev = _this$props6.navPrev,
        navNext = _this$props6.navNext,
        renderNavPrevButton = _this$props6.renderNavPrevButton,
        renderNavNextButton = _this$props6.renderNavNextButton,
        onPrevMonthClick = _this$props6.onPrevMonthClick,
        onNextMonthClick = _this$props6.onNextMonthClick,
        onClose = _this$props6.onClose,
        withPortal = _this$props6.withPortal,
        withFullScreenPortal = _this$props6.withFullScreenPortal,
        keepOpenOnDateSelect = _this$props6.keepOpenOnDateSelect,
        initialVisibleMonth = _this$props6.initialVisibleMonth,
        renderMonthText = _this$props6.renderMonthText,
        renderWeekHeaderElement = _this$props6.renderWeekHeaderElement,
        renderCalendarDay = _this$props6.renderCalendarDay,
        renderDayContents = _this$props6.renderDayContents,
        renderCalendarInfo = _this$props6.renderCalendarInfo,
        renderMonthElement = _this$props6.renderMonthElement,
        calendarInfoPosition = _this$props6.calendarInfoPosition,
        hideKeyboardShortcutsPanel = _this$props6.hideKeyboardShortcutsPanel,
        firstDayOfWeek = _this$props6.firstDayOfWeek,
        customCloseIcon = _this$props6.customCloseIcon,
        phrases = _this$props6.phrases,
        dayAriaLabelFormat = _this$props6.dayAriaLabelFormat,
        daySize = _this$props6.daySize,
        isRTL = _this$props6.isRTL,
        isOutsideRange = _this$props6.isOutsideRange,
        isDayBlocked = _this$props6.isDayBlocked,
        isDayHighlighted = _this$props6.isDayHighlighted,
        weekDayFormat = _this$props6.weekDayFormat,
        styles = _this$props6.styles,
        verticalHeight = _this$props6.verticalHeight,
        transitionDuration = _this$props6.transitionDuration,
        verticalSpacing = _this$props6.verticalSpacing,
        horizontalMonthPadding = _this$props6.horizontalMonthPadding,
        small = _this$props6.small,
        reactDates = _this$props6.theme.reactDates;
    var _this$state = this.state,
        dayPickerContainerStyles = _this$state.dayPickerContainerStyles,
        isDayPickerFocused = _this$state.isDayPickerFocused,
        showKeyboardShortcuts = _this$state.showKeyboardShortcuts;
    var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;

    var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], null);

    var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
    var withAnyPortal = withPortal || withFullScreenPortal;
    /* eslint-disable jsx-a11y/no-static-element-interactions */

    /* eslint-disable jsx-a11y/click-events-have-key-events */

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setDayPickerContainerRef
    }, (0, withStyles_1.css)(styles.SingleDatePicker_picker, anchorDirection === constants$1.ANCHOR_LEFT && styles.SingleDatePicker_picker__directionLeft, anchorDirection === constants$1.ANCHOR_RIGHT && styles.SingleDatePicker_picker__directionRight, openDirection === constants$1.OPEN_DOWN && styles.SingleDatePicker_picker__openDown, openDirection === constants$1.OPEN_UP && styles.SingleDatePicker_picker__openUp, !withAnyPortal && openDirection === constants$1.OPEN_DOWN && {
      top: inputHeight + verticalSpacing
    }, !withAnyPortal && openDirection === constants$1.OPEN_UP && {
      bottom: inputHeight + verticalSpacing
    }, orientation === constants$1.HORIZONTAL_ORIENTATION && styles.SingleDatePicker_picker__horizontal, orientation === constants$1.VERTICAL_ORIENTATION && styles.SingleDatePicker_picker__vertical, withAnyPortal && styles.SingleDatePicker_picker__portal, withFullScreenPortal && styles.SingleDatePicker_picker__fullScreenPortal, isRTL && styles.SingleDatePicker_picker__rtl, dayPickerContainerStyles), {
      onClick: onOutsideClick
    }), _react["default"].createElement(_DayPickerSingleDateController["default"], {
      date: date,
      onDateChange: onDateChange,
      onFocusChange: onFocusChange,
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      numberOfMonths: numberOfMonths,
      monthFormat: monthFormat,
      withPortal: withAnyPortal,
      focused: focused,
      keepOpenOnDateSelect: keepOpenOnDateSelect,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      initialVisibleMonth: initialVisibleMonth,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      onPrevMonthClick: onPrevMonthClick,
      onNextMonthClick: onNextMonthClick,
      onClose: onClose,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      calendarInfoPosition: calendarInfoPosition,
      isFocused: isDayPickerFocused,
      showKeyboardShortcuts: showKeyboardShortcuts,
      onBlur: this.onDayPickerBlur,
      phrases: phrases,
      dayAriaLabelFormat: dayAriaLabelFormat,
      daySize: daySize,
      isRTL: isRTL,
      isOutsideRange: isOutsideRange,
      isDayBlocked: isDayBlocked,
      isDayHighlighted: isDayHighlighted,
      firstDayOfWeek: firstDayOfWeek,
      weekDayFormat: weekDayFormat,
      verticalHeight: verticalHeight,
      transitionDuration: transitionDuration,
      horizontalMonthPadding: horizontalMonthPadding
    }), withFullScreenPortal && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, withStyles_1.css)(styles.SingleDatePicker_closeButton), {
      "aria-label": phrases.closeDatePicker,
      type: "button",
      onClick: this.onOutsideClick
    }), _react["default"].createElement("div", (0, withStyles_1.css)(styles.SingleDatePicker_closeButton_svg), closeIcon)));
    /* eslint-enable jsx-a11y/no-static-element-interactions */

    /* eslint-enable jsx-a11y/click-events-have-key-events */
  };

  _proto.render = function render() {
    var _this$props7 = this.props,
        id = _this$props7.id,
        placeholder = _this$props7.placeholder,
        ariaLabel = _this$props7.ariaLabel,
        disabled = _this$props7.disabled,
        focused = _this$props7.focused,
        required = _this$props7.required,
        readOnly = _this$props7.readOnly,
        openDirection = _this$props7.openDirection,
        showClearDate = _this$props7.showClearDate,
        showDefaultInputIcon = _this$props7.showDefaultInputIcon,
        inputIconPosition = _this$props7.inputIconPosition,
        customCloseIcon = _this$props7.customCloseIcon,
        customInputIcon = _this$props7.customInputIcon,
        date = _this$props7.date,
        onDateChange = _this$props7.onDateChange,
        displayFormat = _this$props7.displayFormat,
        phrases = _this$props7.phrases,
        withPortal = _this$props7.withPortal,
        withFullScreenPortal = _this$props7.withFullScreenPortal,
        screenReaderInputMessage = _this$props7.screenReaderInputMessage,
        isRTL = _this$props7.isRTL,
        noBorder = _this$props7.noBorder,
        block = _this$props7.block,
        small = _this$props7.small,
        regular = _this$props7.regular,
        verticalSpacing = _this$props7.verticalSpacing,
        reopenPickerOnClearDate = _this$props7.reopenPickerOnClearDate,
        keepOpenOnDateSelect = _this$props7.keepOpenOnDateSelect,
        styles = _this$props7.styles,
        isOutsideRange = _this$props7.isOutsideRange;
    var isInputFocused = this.state.isInputFocused;
    var enableOutsideClick = !withPortal && !withFullScreenPortal;
    var hideFang = verticalSpacing < constants$1.FANG_HEIGHT_PX;

    var input = _react["default"].createElement(_SingleDatePickerInputController["default"], {
      id: id,
      placeholder: placeholder,
      ariaLabel: ariaLabel,
      focused: focused,
      isFocused: isInputFocused,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      showCaret: !withPortal && !withFullScreenPortal && !hideFang,
      showClearDate: showClearDate,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      isOutsideRange: isOutsideRange,
      customCloseIcon: customCloseIcon,
      customInputIcon: customInputIcon,
      date: date,
      onDateChange: onDateChange,
      displayFormat: displayFormat,
      onFocusChange: this.onInputFocus,
      onKeyDownArrowDown: this.onDayPickerFocus,
      onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
      screenReaderMessage: screenReaderInputMessage,
      phrases: phrases,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing,
      reopenPickerOnClearDate: reopenPickerOnClearDate,
      keepOpenOnDateSelect: keepOpenOnDateSelect
    }, this.maybeRenderDayPickerWithPortal());

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setContainerRef
    }, (0, withStyles_1.css)(styles.SingleDatePicker, block && styles.SingleDatePicker__block)), enableOutsideClick && _react["default"].createElement(_reactOutsideClickHandler["default"], {
      onOutsideClick: this.onOutsideClick
    }, input), enableOutsideClick || input);
  };

  return SingleDatePicker;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureSingleDatePicker = SingleDatePicker;
SingleDatePicker.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
SingleDatePicker.defaultProps = defaultProps;

var _default = (0, withStyles_1.withStyles)(function (_ref3) {
  var _ref3$reactDates = _ref3.reactDates,
      color = _ref3$reactDates.color,
      zIndex = _ref3$reactDates.zIndex;
  return {
    SingleDatePicker: {
      position: 'relative',
      display: 'inline-block'
    },
    SingleDatePicker__block: {
      display: 'block'
    },
    SingleDatePicker_picker: {
      zIndex: zIndex + 1,
      backgroundColor: color.background,
      position: 'absolute'
    },
    SingleDatePicker_picker__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    SingleDatePicker_picker__directionLeft: {
      left: (0, _noflip["default"])(0)
    },
    SingleDatePicker_picker__directionRight: {
      right: (0, _noflip["default"])(0)
    },
    SingleDatePicker_picker__portal: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      position: 'fixed',
      top: 0,
      left: (0, _noflip["default"])(0),
      height: '100%',
      width: '100%'
    },
    SingleDatePicker_picker__fullScreenPortal: {
      backgroundColor: color.background
    },
    SingleDatePicker_closeButton: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      right: (0, _noflip["default"])(0),
      padding: 15,
      zIndex: zIndex + 2,
      ':hover': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      },
      ':focus': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      }
    },
    SingleDatePicker_closeButton_svg: {
      height: 15,
      width: 15,
      fill: color.core.grayLighter
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(SingleDatePicker);

exports["default"] = _default;
});

unwrapExports(SingleDatePicker_1);
var SingleDatePicker_2 = SingleDatePicker_1.PureSingleDatePicker;

var isInclusivelyBeforeDay_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isInclusivelyBeforeDay;

var _moment = interopRequireDefault(hooks);

var _isAfterDay = interopRequireDefault(isAfterDay_1);

function isInclusivelyBeforeDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return !(0, _isAfterDay["default"])(a, b);
}
});

unwrapExports(isInclusivelyBeforeDay_1);

var lib$4 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CalendarDay", {
  enumerable: true,
  get: function get() {
    return _CalendarDay["default"];
  }
});
Object.defineProperty(exports, "CalendarMonth", {
  enumerable: true,
  get: function get() {
    return _CalendarMonth["default"];
  }
});
Object.defineProperty(exports, "CalendarMonthGrid", {
  enumerable: true,
  get: function get() {
    return _CalendarMonthGrid["default"];
  }
});
Object.defineProperty(exports, "DateRangePicker", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker["default"];
  }
});
Object.defineProperty(exports, "DateRangePickerInput", {
  enumerable: true,
  get: function get() {
    return _DateRangePickerInput["default"];
  }
});
Object.defineProperty(exports, "DateRangePickerInputController", {
  enumerable: true,
  get: function get() {
    return _DateRangePickerInputController["default"];
  }
});
Object.defineProperty(exports, "DateRangePickerShape", {
  enumerable: true,
  get: function get() {
    return _DateRangePickerShape["default"];
  }
});
Object.defineProperty(exports, "DayPicker", {
  enumerable: true,
  get: function get() {
    return _DayPicker["default"];
  }
});
Object.defineProperty(exports, "DayPickerRangeController", {
  enumerable: true,
  get: function get() {
    return _DayPickerRangeController["default"];
  }
});
Object.defineProperty(exports, "DayPickerSingleDateController", {
  enumerable: true,
  get: function get() {
    return _DayPickerSingleDateController["default"];
  }
});
Object.defineProperty(exports, "SingleDatePicker", {
  enumerable: true,
  get: function get() {
    return _SingleDatePicker["default"];
  }
});
Object.defineProperty(exports, "SingleDatePickerInput", {
  enumerable: true,
  get: function get() {
    return _SingleDatePickerInput["default"];
  }
});
Object.defineProperty(exports, "SingleDatePickerShape", {
  enumerable: true,
  get: function get() {
    return _SingleDatePickerShape["default"];
  }
});
Object.defineProperty(exports, "isInclusivelyAfterDay", {
  enumerable: true,
  get: function get() {
    return _isInclusivelyAfterDay["default"];
  }
});
Object.defineProperty(exports, "isInclusivelyBeforeDay", {
  enumerable: true,
  get: function get() {
    return _isInclusivelyBeforeDay["default"];
  }
});
Object.defineProperty(exports, "isNextDay", {
  enumerable: true,
  get: function get() {
    return _isNextDay["default"];
  }
});
Object.defineProperty(exports, "isSameDay", {
  enumerable: true,
  get: function get() {
    return _isSameDay["default"];
  }
});
Object.defineProperty(exports, "toISODateString", {
  enumerable: true,
  get: function get() {
    return _toISODateString["default"];
  }
});
Object.defineProperty(exports, "toLocalizedDateString", {
  enumerable: true,
  get: function get() {
    return _toLocalizedDateString["default"];
  }
});
Object.defineProperty(exports, "toMomentObject", {
  enumerable: true,
  get: function get() {
    return _toMomentObject["default"];
  }
});

var _CalendarDay = interopRequireDefault(CalendarDay_1);

var _CalendarMonth = interopRequireDefault(CalendarMonth_1);

var _CalendarMonthGrid = interopRequireDefault(CalendarMonthGrid_1);

var _DateRangePicker = interopRequireDefault(DateRangePicker_1);

var _DateRangePickerInput = interopRequireDefault(DateRangePickerInput_1);

var _DateRangePickerInputController = interopRequireDefault(DateRangePickerInputController_1);

var _DateRangePickerShape = interopRequireDefault(DateRangePickerShape);

var _DayPicker = interopRequireDefault(DayPicker_1);

var _DayPickerRangeController = interopRequireDefault(DayPickerRangeController_1);

var _DayPickerSingleDateController = interopRequireDefault(DayPickerSingleDateController_1);

var _SingleDatePicker = interopRequireDefault(SingleDatePicker_1);

var _SingleDatePickerInput = interopRequireDefault(SingleDatePickerInput_1);

var _SingleDatePickerShape = interopRequireDefault(SingleDatePickerShape);

var _isInclusivelyAfterDay = interopRequireDefault(isInclusivelyAfterDay_1);

var _isInclusivelyBeforeDay = interopRequireDefault(isInclusivelyBeforeDay_1);

var _isNextDay = interopRequireDefault(isNextDay_1);

var _isSameDay = interopRequireDefault(isSameDay_1);

var _toISODateString = interopRequireDefault(toISODateString_1);

var _toLocalizedDateString = interopRequireDefault(toLocalizedDateString_1);

var _toMomentObject = interopRequireDefault(toMomentObject_1);
});

unwrapExports(lib$4);

// eslint-disable-next-line import/no-unresolved
var reactDates = lib$4;
var reactDates_1 = reactDates.DateRangePicker;

var util_inspect = util__default['default'].inspect;

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString$2 = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;

var inspectCustom = util_inspect.custom;
var inspectSymbol = inspectCustom && isSymbol$3(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$1(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$1(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$1(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean') {
        throw new TypeError('option "customInspect", if provided, must be `true` or `false`');
    }

    if (
        has$1(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') { // eslint-disable-line valid-typeof
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$3(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf$1(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$1(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']';
    }
    if (isSymbol$3(obj)) {
        var symString = Symbol.prototype.toString.call(obj);
        return typeof obj === 'object' ? markBoxed(symString) : symString;
    }
    if (isElement$3(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray$3(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + xs.join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isNumber$1(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString$2(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate$2(obj) && !isRegExp$1(obj)) {
        var ys = arrObjKeys(obj, inspect);
        if (ys.length === 0) { return '{}'; }
        if (indent) {
            return '{' + indentedJoin(ys, indent) + '}';
        }
        return '{ ' + ys.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray$3(obj) { return toStr$8(obj) === '[object Array]'; }
function isDate$2(obj) { return toStr$8(obj) === '[object Date]'; }
function isRegExp$1(obj) { return toStr$8(obj) === '[object RegExp]'; }
function isError(obj) { return toStr$8(obj) === '[object Error]'; }
function isSymbol$3(obj) { return toStr$8(obj) === '[object Symbol]'; }
function isString$2(obj) { return toStr$8(obj) === '[object String]'; }
function isNumber$1(obj) { return toStr$8(obj) === '[object Number]'; }
function isBigInt(obj) { return toStr$8(obj) === '[object BigInt]'; }
function isBoolean(obj) { return toStr$8(obj) === '[object Boolean]'; }

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$1(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr$8(obj) {
    return objectToString$2.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf$1(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement$3(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b', 9: 't', 10: 'n', 12: 'f', 13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16);
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf$1(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = Array(opts.indent + 1).join(' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$3(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$1(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$1(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if ((/[^\w$]/).test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    return xs;
}

// https://www.ecma-international.org/ecma-262/6.0/#sec-ispropertykey

var IsPropertyKey = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};

// https://www.ecma-international.org/ecma-262/5.1/#sec-8

var Type = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};

// https://ecma-international.org/ecma-262/6.0/#sec-ecmascript-data-types-and-values

var Type$1 = function Type$1(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	return Type(x);
};

var $TypeError$7 = GetIntrinsic$1('%TypeError%');






/**
 * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
 * 1. Assert: Type(O) is Object.
 * 2. Assert: IsPropertyKey(P) is true.
 * 3. Return O.[[Get]](P, O).
 */

var Get = function Get(O, P) {
	// 7.3.1.1
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$7('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError$7('Assertion failed: IsPropertyKey(P) is not true, got ' + objectInspect(P));
	}
	// 7.3.1.3
	return O[P];
};

var $Array = GetIntrinsic$1('%Array%');

// eslint-disable-next-line global-require
var toStr$9 = !$Array.isArray && callBound$1('Object.prototype.toString');

// https://www.ecma-international.org/ecma-262/6.0/#sec-isarray

var IsArray = $Array.isArray || function IsArray(argument) {
	return toStr$9(argument) === '[object Array]';
};

var $TypeError$8 = GetIntrinsic$1('%TypeError%');

var isPropertyDescriptor = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

	for (var key in Desc) { // eslint-disable-line no-restricted-syntax
		if (src(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError$8('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};

var $defineProperty = GetIntrinsic$1('%Object.defineProperty%', true);

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}



var $isEnumerable$2 = callBound$1('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
var DefineOwnProperty = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable$2(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};

var $TypeError$9 = GetIntrinsic$1('%TypeError%');
var $SyntaxError$2 = GetIntrinsic$1('%SyntaxError%');



var predicates = {
	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Type, Desc) {
		if (Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (src(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = src(Desc, '[[Value]]');
		var IsAccessor = src(Desc, '[[Get]]') || src(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError$9('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	}
};

var assertRecord = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError$2('unknown record type: ' + recordType);
	}
	if (!predicate(Type, value)) {
		throw new $TypeError$9(argumentName + ' must be a ' + recordType);
	}
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

var FromPropertyDescriptor = function FromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}

	assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);

	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = Desc['[[Configurable]]'];
	}
	return obj;
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-isaccessordescriptor

var IsAccessorDescriptor = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Get]]') && !src(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};

// https://www.ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

var IsDataDescriptor = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Value]]') && !src(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.12

var SameValue = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return _isNaN(x) && _isNaN(y);
};

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.2

var ToBoolean = function ToBoolean(value) { return !!value; };

var $TypeError$a = GetIntrinsic$1('%TypeError%');





// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5

var ToPropertyDescriptor = function ToPropertyDescriptor(Obj) {
	if (Type$1(Obj) !== 'Object') {
		throw new $TypeError$a('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (src(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (src(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (src(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (src(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (src(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new $TypeError$a('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (src(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError$a('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((src(desc, '[[Get]]') || src(desc, '[[Set]]')) && (src(desc, '[[Value]]') || src(desc, '[[Writable]]'))) {
		throw new $TypeError$a('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};

var $TypeError$b = GetIntrinsic$1('%TypeError%');












// https://www.ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow

var DefinePropertyOrThrow = function DefinePropertyOrThrow(O, P, desc) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$b('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError$b('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor({
		Type: Type$1,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor({
		Type: Type$1,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError$b('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};

var IsConstructor = createCommonjsModule(function (module) {



var $construct = GetIntrinsic$1('%Reflect.construct%', true);

var DefinePropertyOrThrow$1 = DefinePropertyOrThrow;
try {
	DefinePropertyOrThrow$1({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow$1 = null;
}

// https://www.ecma-international.org/ecma-262/6.0/#sec-isconstructor

if (DefinePropertyOrThrow$1 && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow$1(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}
});

var $Math$2 = GetIntrinsic$1('%Math%');

var $floor$1 = $Math$2.floor;
var $abs$1 = $Math$2.abs;




// https://www.ecma-international.org/ecma-262/6.0/#sec-isinteger

var IsInteger = function IsInteger(argument) {
	if (typeof argument !== 'number' || _isNaN(argument) || !_isFinite(argument)) {
		return false;
	}
	var abs = $abs$1(argument);
	return $floor$1(abs) === abs;
};

var $Array$1 = GetIntrinsic$1('%Array%');
var $species = GetIntrinsic$1('%Symbol.species%', true);
var $TypeError$c = GetIntrinsic$1('%TypeError%');







// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate

var ArraySpeciesCreate = function ArraySpeciesCreate(originalArray, length) {
	if (!IsInteger(length) || length < 0) {
		throw new $TypeError$c('Assertion failed: length must be an integer >= 0');
	}
	var len = length === 0 ? 0 : length;
	var C;
	var isArray = IsArray(originalArray);
	if (isArray) {
		C = Get(originalArray, 'constructor');
		// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
		// if (IsConstructor(C)) {
		// 	if C is another realm's Array, C = undefined
		// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
		// }
		if ($species && Type$1(C) === 'Object') {
			C = Get(C, $species);
			if (C === null) {
				C = void 0;
			}
		}
	}
	if (typeof C === 'undefined') {
		return $Array$1(len);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError$c('C must be a constructor');
	}
	return new C(len); // Construct(C, len);
};

var $apply = GetIntrinsic$1('%Reflect.apply%', true) || callBound$1('%Function.prototype.apply%');

// https://www.ecma-international.org/ecma-262/6.0/#sec-call

var Call = function Call(F, V) {
	var args = arguments.length > 2 ? arguments[2] : [];
	return $apply(F, V, args);
};

var $gOPD$4 = GetIntrinsic$1('%Object.getOwnPropertyDescriptor%');
if ($gOPD$4) {
	try {
		$gOPD$4([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD$4 = null;
	}
}

var getOwnPropertyDescriptor$1 = $gOPD$4;

var $match = GetIntrinsic$1('%Symbol.match%', true);





// https://ecma-international.org/ecma-262/6.0/#sec-isregexp

var IsRegExp = function IsRegExp(argument) {
	if (!argument || typeof argument !== 'object') {
		return false;
	}
	if ($match) {
		var isRegExp = argument[$match];
		if (typeof isRegExp !== 'undefined') {
			return ToBoolean(isRegExp);
		}
	}
	return isRegex(argument);
};

var $TypeError$d = GetIntrinsic$1('%TypeError%');



var $isEnumerable$3 = callBound$1('Object.prototype.propertyIsEnumerable');









// https://www.ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty

var OrdinaryGetOwnProperty = function OrdinaryGetOwnProperty(O, P) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$d('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$d('Assertion failed: P must be a Property Key');
	}
	if (!src(O, P)) {
		return void 0;
	}
	if (!getOwnPropertyDescriptor$1) {
		// ES3 / IE 8 fallback
		var arrayLength = IsArray(O) && P === 'length';
		var regexLastIndex = IsRegExp(O) && P === 'lastIndex';
		return {
			'[[Configurable]]': !(arrayLength || regexLastIndex),
			'[[Enumerable]]': $isEnumerable$3(O, P),
			'[[Value]]': O[P],
			'[[Writable]]': true
		};
	}
	return ToPropertyDescriptor(getOwnPropertyDescriptor$1(O, P));
};

var $Object$2 = GetIntrinsic$1('%Object%');



var $preventExtensions = $Object$2.preventExtensions;
var $isExtensible = $Object$2.isExtensible;

// https://www.ecma-international.org/ecma-262/6.0/#sec-isextensible-o

var IsExtensible = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive(obj);
	};

var $TypeError$e = GetIntrinsic$1('%TypeError%');











// https://www.ecma-international.org/ecma-262/6.0/#sec-createdataproperty

var CreateDataProperty = function CreateDataProperty(O, P, V) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$e('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$e('Assertion failed: IsPropertyKey(P) is not true');
	}
	var oldDesc = OrdinaryGetOwnProperty(O, P);
	var extensible = !oldDesc || IsExtensible(O);
	var immutable = oldDesc && (!oldDesc['[[Writable]]'] || !oldDesc['[[Configurable]]']);
	if (immutable || !extensible) {
		return false;
	}
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		{
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		}
	);
};

var $TypeError$f = GetIntrinsic$1('%TypeError%');





// // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow

var CreateDataPropertyOrThrow = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$f('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$f('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError$f('unable to create data property');
	}
	return success;
};

var $TypeError$g = GetIntrinsic$1('%TypeError%');




// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

var HasProperty = function HasProperty(O, P) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$g('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$g('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};

var $String = GetIntrinsic$1('%String%');
var $TypeError$h = GetIntrinsic$1('%TypeError%');

// https://www.ecma-international.org/ecma-262/6.0/#sec-tostring

var ToString = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError$h('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};

var $TypeError$i = GetIntrinsic$1('%TypeError%');











// https://ecma-international.org/ecma-262/10.0/#sec-flattenintoarray

// eslint-disable-next-line max-params, max-statements
var FlattenIntoArray = function FlattenIntoArray(target, source, sourceLen, start, depth) {
	var mapperFunction;
	if (arguments.length > 5) {
		mapperFunction = arguments[5];
	}

	var targetIndex = start;
	var sourceIndex = 0;
	while (sourceIndex < sourceLen) {
		var P = ToString(sourceIndex);
		var exists = HasProperty(source, P);
		if (exists === true) {
			var element = Get(source, P);
			if (typeof mapperFunction !== 'undefined') {
				if (arguments.length <= 6) {
					throw new $TypeError$i('Assertion failed: thisArg is required when mapperFunction is provided');
				}
				element = Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
			}
			var shouldFlatten = false;
			if (depth > 0) {
				shouldFlatten = IsArray(element);
			}
			if (shouldFlatten) {
				var elementLen = ToLength(Get(element, 'length'));
				targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
			} else {
				if (targetIndex >= maxSafeInteger) {
					throw new $TypeError$i('index too large');
				}
				CreateDataPropertyOrThrow(target, ToString(targetIndex), element);
				targetIndex += 1;
			}
		}
		sourceIndex += 1;
	}

	return targetIndex;
};

var implementation$b = function flat() {
	var O = ToObject(this);
	var sourceLen = ToLength(Get(O, 'length'));

	var depthNum = 1;
	if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
		depthNum = ToInteger$1(arguments[0]);
	}

	var A = ArraySpeciesCreate(O, 0);
	FlattenIntoArray(A, O, sourceLen, 0, depthNum);
	return A;
};

var polyfill$g = function getPolyfill() {
	return Array.prototype.flat || implementation$b;
};

var shim$8 = function shimFlat() {
	var polyfill = polyfill$g();
	defineProperties_1(
		Array.prototype,
		{ flat: polyfill },
		{ flat: function () { return Array.prototype.flat !== polyfill; } }
	);
	return polyfill;
};

var polyfill$h = polyfill$g();


var boundFlat = callBind$1(polyfill$h);

defineProperties_1(boundFlat, {
	getPolyfill: polyfill$g,
	implementation: implementation$b,
	shim: shim$8
});

var array_prototype_flat = boundFlat;

var globalKey = '__ global cache key __';
/* istanbul ignore else */
// eslint-disable-next-line no-restricted-properties
if (typeof Symbol === 'function' && isSymbol$2(Symbol('foo')) && typeof Symbol['for'] === 'function') {
	// eslint-disable-next-line no-restricted-properties
	globalKey = Symbol['for'](globalKey);
}

var trueThunk = function () {
	return true;
};

var ensureCache = function ensureCache() {
	if (!commonjsGlobal[globalKey]) {
		var properties = {};
		properties[globalKey] = {};
		var predicates = {};
		predicates[globalKey] = trueThunk;
		defineProperties_1(commonjsGlobal, properties, predicates);
	}
	return commonjsGlobal[globalKey];
};

var cache = ensureCache();

var isPrimitive$2 = function isPrimitive(val) {
	return val === null || (typeof val !== 'object' && typeof val !== 'function');
};

var getPrimitiveKey = function getPrimitiveKey(val) {
	if (isSymbol$2(val)) {
		return Symbol.prototype.valueOf.call(val);
	}
	return typeof val + ' | ' + String(val);
};

var requirePrimitiveKey = function requirePrimitiveKey(val) {
	if (!isPrimitive$2(val)) {
		throw new TypeError('key must not be an object');
	}
};

var globalCache = {
	clear: function clear() {
		delete commonjsGlobal[globalKey];
		cache = ensureCache();
	},

	'delete': function deleteKey(key) {
		requirePrimitiveKey(key);
		delete cache[getPrimitiveKey(key)];
		return !globalCache.has(key);
	},

	get: function get(key) {
		requirePrimitiveKey(key);
		return cache[getPrimitiveKey(key)];
	},

	has: function has(key) {
		requirePrimitiveKey(key);
		return getPrimitiveKey(key) in cache;
	},

	set: function set(key, value) {
		requirePrimitiveKey(key);
		var primitiveKey = getPrimitiveKey(key);
		var props = {};
		props[primitiveKey] = value;
		var predicates = {};
		predicates[primitiveKey] = trueThunk;
		defineProperties_1(cache, props, predicates);
		return globalCache.has(key);
	},

	setIfMissingThenGet: function setIfMissingThenGet(key, valueThunk) {
		if (globalCache.has(key)) {
			return globalCache.get(key);
		}
		var item = valueThunk();
		globalCache.set(key, item);
		return item;
	}
};

var globalCache_1 = globalCache;

var constants$2 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_SPECIFICITY = exports.GLOBAL_CACHE_KEY = void 0;
var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
var MAX_SPECIFICITY = 20;
exports.MAX_SPECIFICITY = MAX_SPECIFICITY;
});

unwrapExports(constants$2);
var constants_1$2 = constants$2.MAX_SPECIFICITY;
var constants_2$2 = constants$2.GLOBAL_CACHE_KEY;

var getClassName_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getClassName;

/**
 * Construct a class name.
 *
 * namespace {String} Used to construct unique class names.
 * styleName {String} Name identifying the specific style.
 *
 * Return the class name.
 */
function getClassName(namespace, styleName) {
  var namespaceSegment = namespace.length > 0 ? "".concat(namespace, "__") : '';
  return "".concat(namespaceSegment).concat(styleName);
}
});

unwrapExports(getClassName_1);

var separateStyles_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// This function takes an array of styles and separates them into styles that
// are handled by Aphrodite and inline styles.
function separateStyles(stylesArray) {
  var classNames = []; // Since determining if an Object is empty requires collecting all of its
  // keys, and we want the best performance in this code because we are in the
  // render path, we are going to do a little bookkeeping ourselves.

  var hasInlineStyles = false;
  var inlineStyles = {}; // This is run on potentially every node in the tree when rendering, where
  // performance is critical. Normally we would prefer using `forEach`, but
  // old-fashioned for loops are faster so that's what we have chosen here.

  for (var i = 0; i < stylesArray.length; i++) {
    // eslint-disable-line no-plusplus
    var style = stylesArray[i]; // If this  style is falsy, we just want to disregard it. This allows for
    // syntax like:
    //
    //   css(isFoo && styles.foo)

    if (style) {
      if (typeof style === 'string') {
        classNames.push(style);
      } else {
        Object.assign(inlineStyles, style);
        hasInlineStyles = true;
      }
    }
  }

  return {
    classNames: classNames,
    hasInlineStyles: hasInlineStyles,
    inlineStyles: inlineStyles
  };
}

var _default = separateStyles;
exports["default"] = _default;
});

unwrapExports(separateStyles_1);

var dist = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _arrayPrototype = interopRequireDefault(array_prototype_flat);

var _globalCache = interopRequireDefault(globalCache_1);



var _getClassName = interopRequireDefault(getClassName_1);

var _separateStyles2 = interopRequireDefault(separateStyles_1);

/**
 * Function required as part of the react-with-styles interface. Parses the styles provided by
 * react-with-styles to produce class names based on the style name and optionally the namespace if
 * available.
 *
 * stylesObject {Object} The styles object passed to withStyles.
 *
 * Return an object mapping style names to class names.
 */
function create(stylesObject) {
  var stylesToClasses = {};
  var styleNames = Object.keys(stylesObject);
  var sharedState = _globalCache["default"].get(constants$2.GLOBAL_CACHE_KEY) || {};
  var _sharedState$namespac = sharedState.namespace,
      namespace = _sharedState$namespac === void 0 ? '' : _sharedState$namespac;
  styleNames.forEach(function (styleName) {
    var className = (0, _getClassName["default"])(namespace, styleName);
    stylesToClasses[styleName] = className;
  });
  return stylesToClasses;
}
/**
 * Process styles to be consumed by a component.
 *
 * stylesArray {Array} Array of the following: values returned by create, plain JavaScript objects
 * representing inline styles, or arrays thereof.
 *
 * Return an object with optional className and style properties to be spread on a component.
 */


function resolve(stylesArray) {
  var flattenedStyles = (0, _arrayPrototype["default"])(stylesArray, Infinity);

  var _separateStyles = (0, _separateStyles2["default"])(flattenedStyles),
      classNames = _separateStyles.classNames,
      hasInlineStyles = _separateStyles.hasInlineStyles,
      inlineStyles = _separateStyles.inlineStyles;

  var specificClassNames = classNames.map(function (name, index) {
    return "".concat(name, " ").concat(name, "_").concat(index + 1);
  });
  var className = specificClassNames.join(' ');
  var result = {
    className: className
  };
  if (hasInlineStyles) result.style = inlineStyles;
  return result;
}

var _default = {
  create: create,
  resolve: resolve
};
exports["default"] = _default;
});

unwrapExports(dist);

// eslint-disable-next-line import/no-unresolved
var reactWithStylesInterfaceCss = dist.default;

var DefaultTheme = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var core = {
  white: '#fff',
  gray: '#484848',
  grayLight: '#82888a',
  grayLighter: '#cacccd',
  grayLightest: '#f2f2f2',
  borderMedium: '#c4c4c4',
  border: '#dbdbdb',
  borderLight: '#e4e7e7',
  borderLighter: '#eceeee',
  borderBright: '#f4f5f5',
  primary: '#00a699',
  primaryShade_1: '#33dacd',
  primaryShade_2: '#66e2da',
  primaryShade_3: '#80e8e0',
  primaryShade_4: '#b2f1ec',
  primary_dark: '#008489',
  secondary: '#007a87',
  yellow: '#ffe8bc',
  yellow_dark: '#ffce71'
};
var _default = {
  reactDates: {
    zIndex: 0,
    border: {
      input: {
        border: 0,
        borderTop: 0,
        borderRight: 0,
        borderBottom: '2px solid transparent',
        borderLeft: 0,
        outlineFocused: 0,
        borderFocused: 0,
        borderTopFocused: 0,
        borderLeftFocused: 0,
        borderBottomFocused: "2px solid ".concat(core.primary_dark),
        borderRightFocused: 0,
        borderRadius: 0
      },
      pickerInput: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 2
      }
    },
    color: {
      core: core,
      disabled: core.grayLightest,
      background: core.white,
      backgroundDark: '#f2f2f2',
      backgroundFocused: core.white,
      border: 'rgb(219, 219, 219)',
      text: core.gray,
      textDisabled: core.border,
      textFocused: '#007a87',
      placeholderText: '#757575',
      outside: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        color: core.gray,
        color_active: core.gray,
        color_hover: core.gray
      },
      highlighted: {
        backgroundColor: core.yellow,
        backgroundColor_active: core.yellow_dark,
        backgroundColor_hover: core.yellow_dark,
        color: core.gray,
        color_active: core.gray,
        color_hover: core.gray
      },
      minimumNights: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        borderColor: core.borderLighter,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      },
      hoveredSpan: {
        backgroundColor: core.primaryShade_4,
        backgroundColor_active: core.primaryShade_3,
        backgroundColor_hover: core.primaryShade_4,
        borderColor: core.primaryShade_3,
        borderColor_active: core.primaryShade_3,
        borderColor_hover: core.primaryShade_3,
        color: core.secondary,
        color_active: core.secondary,
        color_hover: core.secondary
      },
      selectedSpan: {
        backgroundColor: core.primaryShade_2,
        backgroundColor_active: core.primaryShade_1,
        backgroundColor_hover: core.primaryShade_1,
        borderColor: core.primaryShade_1,
        borderColor_active: core.primary,
        borderColor_hover: core.primary,
        color: core.white,
        color_active: core.white,
        color_hover: core.white
      },
      selected: {
        backgroundColor: core.primary,
        backgroundColor_active: core.primary,
        backgroundColor_hover: core.primary,
        borderColor: core.primary,
        borderColor_active: core.primary,
        borderColor_hover: core.primary,
        color: core.white,
        color_active: core.white,
        color_hover: core.white
      },
      blocked_calendar: {
        backgroundColor: core.grayLighter,
        backgroundColor_active: core.grayLighter,
        backgroundColor_hover: core.grayLighter,
        borderColor: core.grayLighter,
        borderColor_active: core.grayLighter,
        borderColor_hover: core.grayLighter,
        color: core.grayLight,
        color_active: core.grayLight,
        color_hover: core.grayLight
      },
      blocked_out_of_range: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        borderColor: core.borderLight,
        borderColor_active: core.borderLight,
        borderColor_hover: core.borderLight,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      }
    },
    spacing: {
      dayPickerHorizontalPadding: 9,
      captionPaddingTop: 22,
      captionPaddingBottom: 37,
      inputPadding: 0,
      displayTextPaddingVertical: undefined,
      displayTextPaddingTop: 11,
      displayTextPaddingBottom: 9,
      displayTextPaddingHorizontal: undefined,
      displayTextPaddingLeft: 11,
      displayTextPaddingRight: 11,
      displayTextPaddingVertical_small: undefined,
      displayTextPaddingTop_small: 7,
      displayTextPaddingBottom_small: 5,
      displayTextPaddingHorizontal_small: undefined,
      displayTextPaddingLeft_small: 7,
      displayTextPaddingRight_small: 7
    },
    sizing: {
      inputWidth: 130,
      inputWidth_small: 97,
      arrowWidth: 24
    },
    noScrollBarOnVerticalScrollable: false,
    font: {
      size: 14,
      captionSize: 18,
      input: {
        size: 19,
        weight: 200,
        lineHeight: '24px',
        size_small: 15,
        lineHeight_small: '18px',
        letterSpacing_small: '0.2px',
        styleDisabled: 'italic'
      }
    }
  }
};
exports["default"] = _default;
});

unwrapExports(DefaultTheme);

var registerInterfaceWithDefaultTheme_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = registerInterfaceWithDefaultTheme;

var _ThemedStyleSheet = interopRequireDefault(ThemedStyleSheet);

var _DefaultTheme = interopRequireDefault(DefaultTheme);

function registerInterfaceWithDefaultTheme(reactWithStylesInterface) {
  _ThemedStyleSheet["default"].registerInterface(reactWithStylesInterface);

  _ThemedStyleSheet["default"].registerTheme(_DefaultTheme["default"]);
}
});

unwrapExports(registerInterfaceWithDefaultTheme_1);

var registerCSSInterfaceWithDefaultTheme_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = registerCSSInterfaceWithDefaultTheme;

var _reactWithStylesInterfaceCss = interopRequireDefault(reactWithStylesInterfaceCss);

var _registerInterfaceWithDefaultTheme = interopRequireDefault(registerInterfaceWithDefaultTheme_1);

function registerCSSInterfaceWithDefaultTheme() {
  (0, _registerInterfaceWithDefaultTheme["default"])(_reactWithStylesInterfaceCss["default"]);
}
});

unwrapExports(registerCSSInterfaceWithDefaultTheme_1);

var _registerCSSInterfaceWithDefaultTheme = interopRequireDefault(registerCSSInterfaceWithDefaultTheme_1);

(0, _registerCSSInterfaceWithDefaultTheme["default"])();

var css_248z$p = "._datepicker_PresetDateRangePicker_panel__2m46e {\n  padding: 0 22px 11px\n}\n._datepicker_PresetDateRangePicker_button__2y0fU {\n  position: relative;\n  height: 100%;\n  text-align: center;\n  background: 0 0;\n  border: 2px solid #00a699;\n  color: #00a699;\n  padding: 4px 12px;\n  margin-right: 8px;\n  font: inherit;\n  font-weight: 700;\n  line-height: normal;\n  overflow: visible;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer\n}\n._datepicker_PresetDateRangePicker_button__2y0fU:active {\n  outline: 0\n}\n._datepicker_PresetDateRangePicker_button__selected__2c_vf {\n  color: #fff;\n  background: #00a699\n}\n._datepicker_SingleDatePickerInput__BQiHV {\n  display: inline-block;\n  background-color: #fff\n}\n._datepicker_SingleDatePickerInput__withBorder__23T21 {\n  border-radius: 2px;\n  border: 1px solid #dbdbdb\n}\n._datepicker_SingleDatePickerInput__rtl__3F3La {\n  direction: rtl\n}\n._datepicker_SingleDatePickerInput__disabled__2VkML {\n  background-color: #f2f2f2\n}\n._datepicker_SingleDatePickerInput__block__1LWPC {\n  display: block\n}\n._datepicker_SingleDatePickerInput__showClearDate__3cZJp {\n  padding-right: 30px\n}\n._datepicker_SingleDatePickerInput_clearDate__3MqjI {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%)\n}\n._datepicker_SingleDatePickerInput_clearDate__default__3I48Z:focus,\n._datepicker_SingleDatePickerInput_clearDate__default__3I48Z:hover {\n  background: #dbdbdb;\n  border-radius: 50%\n}\n._datepicker_SingleDatePickerInput_clearDate__small__sJoQF {\n  padding: 6px\n}\n._datepicker_SingleDatePickerInput_clearDate__hide__2lVgU {\n  visibility: hidden\n}\n._datepicker_SingleDatePickerInput_clearDate_svg__3Oty9 {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle\n}\n._datepicker_SingleDatePickerInput_clearDate_svg__small__1UV0F {\n  height: 9px\n}\n._datepicker_SingleDatePickerInput_calendarIcon__2MdBC {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px\n}\n._datepicker_SingleDatePickerInput_calendarIcon_svg__2frx4 {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle\n}\n._datepicker_SingleDatePicker__21YdR {\n  position: relative;\n  display: inline-block\n}\n._datepicker_SingleDatePicker__block__1v08N {\n  display: block\n}\n._datepicker_SingleDatePicker_picker__1522m {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute\n}\n._datepicker_SingleDatePicker_picker__rtl__2BDJ- {\n  direction: rtl\n}\n._datepicker_SingleDatePicker_picker__directionLeft__1f35R {\n  left: 0\n}\n._datepicker_SingleDatePicker_picker__directionRight__1AUD9 {\n  right: 0\n}\n._datepicker_SingleDatePicker_picker__portal__RF5Tw {\n  background-color: rgba(0,0,0,.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%\n}\n._datepicker_SingleDatePicker_picker__fullScreenPortal___juEV {\n  background-color: #fff\n}\n._datepicker_SingleDatePicker_closeButton__3ACUM {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2\n}\n._datepicker_SingleDatePicker_closeButton__3ACUM:focus,\n._datepicker_SingleDatePicker_closeButton__3ACUM:hover {\n  color: darken(#cacccd,10%);\n  text-decoration: none\n}\n._datepicker_SingleDatePicker_closeButton_svg__31yRO {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}\n._datepicker_DayPickerKeyboardShortcuts_buttonReset__224RN {\n  background: 0 0;\n  border: 0;\n  border-radius: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer;\n  font-size: 14px\n}\n._datepicker_DayPickerKeyboardShortcuts_buttonReset__224RN:active {\n  outline: 0\n}\n._datepicker_DayPickerKeyboardShortcuts_show__1bb2S {\n  width: 33px;\n  height: 26px;\n  position: absolute;\n  z-index: 2\n}\n._datepicker_DayPickerKeyboardShortcuts_show__1bb2S::before {\n  content: \"\";\n  display: block;\n  position: absolute\n}\n._datepicker_DayPickerKeyboardShortcuts_show__bottomRight__3mBgA {\n  bottom: 0;\n  right: 0\n}\n._datepicker_DayPickerKeyboardShortcuts_show__bottomRight__3mBgA::before {\n  border-top: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  bottom: 0;\n  right: 0\n}\n._datepicker_DayPickerKeyboardShortcuts_show__bottomRight__3mBgA:hover::before {\n  border-right: 33px solid #008489\n}\n._datepicker_DayPickerKeyboardShortcuts_show__topRight__mUViw {\n  top: 0;\n  right: 0\n}\n._datepicker_DayPickerKeyboardShortcuts_show__topRight__mUViw::before {\n  border-bottom: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  top: 0;\n  right: 0\n}\n._datepicker_DayPickerKeyboardShortcuts_show__topRight__mUViw:hover::before {\n  border-right: 33px solid #008489\n}\n._datepicker_DayPickerKeyboardShortcuts_show__topLeft__SwsCr {\n  top: 0;\n  left: 0\n}\n._datepicker_DayPickerKeyboardShortcuts_show__topLeft__SwsCr::before {\n  border-bottom: 26px solid transparent;\n  border-left: 33px solid #00a699;\n  top: 0;\n  left: 0\n}\n._datepicker_DayPickerKeyboardShortcuts_show__topLeft__SwsCr:hover::before {\n  border-left: 33px solid #008489\n}\n._datepicker_DayPickerKeyboardShortcuts_showSpan__3ljsy {\n  color: #fff;\n  position: absolute\n}\n._datepicker_DayPickerKeyboardShortcuts_showSpan__bottomRight__3WYbW {\n  bottom: 0;\n  right: 5px\n}\n._datepicker_DayPickerKeyboardShortcuts_showSpan__topRight__1s97v {\n  top: 1px;\n  right: 5px\n}\n._datepicker_DayPickerKeyboardShortcuts_showSpan__topLeft__3UUIm {\n  top: 1px;\n  left: 5px\n}\n._datepicker_DayPickerKeyboardShortcuts_panel__250s8 {\n  overflow: auto;\n  background: #fff;\n  border: 1px solid #dbdbdb;\n  border-radius: 2px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 2;\n  padding: 22px;\n  margin: 33px;\n  text-align: left\n}\n._datepicker_DayPickerKeyboardShortcuts_title__1XaLc {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0\n}\n._datepicker_DayPickerKeyboardShortcuts_list__2hKx6 {\n  list-style: none;\n  padding: 0;\n  font-size: 14px\n}\n._datepicker_DayPickerKeyboardShortcuts_close__2N4c2 {\n  position: absolute;\n  right: 22px;\n  top: 22px;\n  z-index: 2\n}\n._datepicker_DayPickerKeyboardShortcuts_close__2N4c2:active {\n  outline: 0\n}\n._datepicker_DayPickerKeyboardShortcuts_closeSvg__2pcAs {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}\n._datepicker_DayPickerKeyboardShortcuts_closeSvg__2pcAs:focus,\n._datepicker_DayPickerKeyboardShortcuts_closeSvg__2pcAs:hover {\n  fill: #82888a\n}\n._datepicker_CalendarDay__2FmMO {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center\n}\n._datepicker_CalendarDay__2FmMO:active {\n  outline: 0\n}\n._datepicker_CalendarDay__defaultCursor__2BP-B {\n  cursor: default\n}\n._datepicker_CalendarDay__default__11oPP {\n  border: 1px solid #e4e7e7;\n  color: #484848;\n  background: #fff\n}\n._datepicker_CalendarDay__default__11oPP:hover {\n  background: #e4e7e7;\n  border: 1px solid #e4e7e7;\n  color: inherit\n}\n._datepicker_CalendarDay__hovered_offset__2SDWc {\n  background: #f4f5f5;\n  border: 1px double #e4e7e7;\n  color: inherit\n}\n._datepicker_CalendarDay__outside__2Em-5 {\n  border: 0;\n  background: #fff;\n  color: #484848\n}\n._datepicker_CalendarDay__outside__2Em-5:hover {\n  border: 0\n}\n._datepicker_CalendarDay__blocked_minimum_nights__ScB0l {\n  background: #fff;\n  border: 1px solid #eceeee;\n  color: #cacccd\n}\n._datepicker_CalendarDay__blocked_minimum_nights__ScB0l:active,\n._datepicker_CalendarDay__blocked_minimum_nights__ScB0l:hover {\n  background: #fff;\n  color: #cacccd\n}\n._datepicker_CalendarDay__highlighted_calendar__1sLbd {\n  background: #ffe8bc;\n  color: #484848\n}\n._datepicker_CalendarDay__highlighted_calendar__1sLbd:active,\n._datepicker_CalendarDay__highlighted_calendar__1sLbd:hover {\n  background: #ffce71;\n  color: #484848\n}\n._datepicker_CalendarDay__selected_span__1OuG0 {\n  background: #66e2da;\n  border: 1px double #33dacd;\n  color: #fff\n}\n._datepicker_CalendarDay__selected_span__1OuG0:active,\n._datepicker_CalendarDay__selected_span__1OuG0:hover {\n  background: #33dacd;\n  border: 1px double #33dacd;\n  color: #fff\n}\n._datepicker_CalendarDay__selected__3s6gr,\n._datepicker_CalendarDay__selected__3s6gr:active,\n._datepicker_CalendarDay__selected__3s6gr:hover {\n  background: #00a699;\n  border: 1px double #00a699;\n  color: #fff\n}\n._datepicker_CalendarDay__hovered_span__2Fk4M,\n._datepicker_CalendarDay__hovered_span__2Fk4M:hover {\n  background: #b2f1ec;\n  border: 1px double #80e8e0;\n  color: #007a87\n}\n._datepicker_CalendarDay__hovered_span__2Fk4M:active {\n  background: #80e8e0;\n  border: 1px double #80e8e0;\n  color: #007a87\n}\n._datepicker_CalendarDay__blocked_calendar__GwRAs,\n._datepicker_CalendarDay__blocked_calendar__GwRAs:active,\n._datepicker_CalendarDay__blocked_calendar__GwRAs:hover {\n  background: #cacccd;\n  border: 1px solid #cacccd;\n  color: #82888a\n}\n._datepicker_CalendarDay__blocked_out_of_range__1-dUe,\n._datepicker_CalendarDay__blocked_out_of_range__1-dUe:active,\n._datepicker_CalendarDay__blocked_out_of_range__1-dUe:hover {\n  background: #fff;\n  border: 1px solid #e4e7e7;\n  color: #cacccd\n}\n._datepicker_CalendarDay__hovered_start_first_possible_end__FpRnQ {\n  background: #eceeee;\n  border: 1px double #eceeee\n}\n._datepicker_CalendarDay__hovered_start_blocked_min_nights__qUecZ {\n  background: #eceeee;\n  border: 1px double #e4e7e7\n}\n._datepicker_CalendarMonth__3n7I7 {\n  background: #fff;\n  text-align: center;\n  vertical-align: top;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n._datepicker_CalendarMonth_table__3hAKe {\n  border-collapse: collapse;\n  border-spacing: 0\n}\n._datepicker_CalendarMonth_verticalSpacing__3k_pL {\n  border-collapse: separate\n}\n._datepicker_CalendarMonth_caption__2RD4F {\n  color: #484848;\n  font-size: 18px;\n  text-align: center;\n  padding-top: 22px;\n  padding-bottom: 37px;\n  caption-side: initial\n}\n._datepicker_CalendarMonth_caption__verticalScrollable__1drQp {\n  padding-top: 12px;\n  padding-bottom: 7px\n}\n._datepicker_CalendarMonthGrid__1vclb {\n  background: #fff;\n  text-align: left;\n  z-index: 0\n}\n._datepicker_CalendarMonthGrid__animating__Lu1pL {\n  z-index: 1\n}\n._datepicker_CalendarMonthGrid__horizontal__1KHes {\n  position: absolute;\n  left: 9px\n}\n._datepicker_CalendarMonthGrid__vertical__2t8p_,\n._datepicker_CalendarMonthGrid__vertical_scrollable__1CgOp {\n  margin: 0 auto\n}\n._datepicker_CalendarMonthGrid_month__horizontal__3oilR {\n  display: inline-block;\n  vertical-align: top;\n  min-height: 100%\n}\n._datepicker_CalendarMonthGrid_month__hideForAnimation__3E1pN {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none\n}\n._datepicker_CalendarMonthGrid_month__hidden__nUZMt {\n  visibility: hidden\n}\n._datepicker_DayPickerNavigation__2Vjh5 {\n  position: relative;\n  z-index: 2\n}\n._datepicker_DayPickerNavigation__horizontal__2Numu {\n  height: 0\n}\n._datepicker_DayPickerNavigation__verticalScrollable_prevNav__919np {\n  z-index: 1\n}\n._datepicker_DayPickerNavigation__verticalDefault__1Quz8 {\n  position: absolute;\n  width: 100%;\n  height: 52px;\n  bottom: 0;\n  left: 0\n}\n._datepicker_DayPickerNavigation__verticalScrollableDefault__3xQqJ {\n  position: relative\n}\n._datepicker_DayPickerNavigation__bottom__2Meps {\n  height: auto\n}\n._datepicker_DayPickerNavigation__bottomDefault__3HlzE {\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: space-between;\n  justify-content: space-between\n}\n._datepicker_DayPickerNavigation_button__39bti {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border: 0;\n  padding: 0;\n  margin: 0\n}\n._datepicker_DayPickerNavigation_button__default__3Xah9 {\n  border: 1px solid #e4e7e7;\n  background-color: #fff;\n  color: #757575\n}\n._datepicker_DayPickerNavigation_button__default__3Xah9:focus,\n._datepicker_DayPickerNavigation_button__default__3Xah9:hover {\n  border: 1px solid #c4c4c4\n}\n._datepicker_DayPickerNavigation_button__default__3Xah9:active {\n  background: #f2f2f2\n}\n._datepicker_DayPickerNavigation_button__disabled__2iyzC {\n  cursor: default;\n  border: 1px solid #f2f2f2\n}\n._datepicker_DayPickerNavigation_button__disabled__2iyzC:focus,\n._datepicker_DayPickerNavigation_button__disabled__2iyzC:hover {\n  border: 1px solid #f2f2f2\n}\n._datepicker_DayPickerNavigation_button__disabled__2iyzC:active {\n  background: 0 0\n}\n._datepicker_DayPickerNavigation_button__horizontalDefault__Ql7zx {\n  position: absolute;\n  top: 18px;\n  line-height: .78;\n  border-radius: 3px;\n  padding: 6px 9px\n}\n._datepicker_DayPickerNavigation_bottomButton__horizontalDefault__3BefC {\n  position: static;\n  margin: -10px 22px 30px\n}\n._datepicker_DayPickerNavigation_leftButton__horizontalDefault__wwI00 {\n  left: 22px\n}\n._datepicker_DayPickerNavigation_rightButton__horizontalDefault__3DdXp {\n  right: 22px\n}\n._datepicker_DayPickerNavigation_button__verticalDefault__12y_- {\n  padding: 5px;\n  background: #fff;\n  box-shadow: 0 0 5px 2px rgba(0,0,0,.1);\n  position: relative;\n  display: inline-block;\n  text-align: center;\n  height: 100%;\n  width: 50%\n}\n._datepicker_DayPickerNavigation_nextButton__verticalDefault__zokSy {\n  border-left: 0\n}\n._datepicker_DayPickerNavigation_nextButton__verticalScrollableDefault__ZfL-9,\n._datepicker_DayPickerNavigation_prevButton__verticalScrollableDefault__BG-8_ {\n  width: 100%\n}\n._datepicker_DayPickerNavigation_svg__horizontal__2wOjr {\n  height: 19px;\n  width: 19px;\n  fill: #82888a;\n  display: block\n}\n._datepicker_DayPickerNavigation_svg__vertical__3MIae {\n  height: 42px;\n  width: 42px;\n  fill: #484848\n}\n._datepicker_DayPickerNavigation_svg__disabled__Yqn4M {\n  fill: #f2f2f2\n}\n._datepicker_DayPicker__20izm {\n  background: #fff;\n  position: relative;\n  text-align: left\n}\n._datepicker_DayPicker__horizontal__3WLMr {\n  background: #fff\n}\n._datepicker_DayPicker__verticalScrollable__1XUxP {\n  height: 100%\n}\n._datepicker_DayPicker__hidden__3QeWz {\n  visibility: hidden\n}\n._datepicker_DayPicker__withBorder__309sq {\n  box-shadow: 0 2px 6px rgba(0,0,0,.05),0 0 0 1px rgba(0,0,0,.07);\n  border-radius: 3px\n}\n._datepicker_DayPicker_portal__horizontal__2Z1Df {\n  box-shadow: none;\n  position: absolute;\n  left: 50%;\n  top: 50%\n}\n._datepicker_DayPicker_portal__vertical__esK6u {\n  position: initial\n}\n._datepicker_DayPicker_focusRegion__-goBN {\n  outline: 0\n}\n._datepicker_DayPicker_calendarInfo__horizontal__1MVav,\n._datepicker_DayPicker_wrapper__horizontal__3Lu1c {\n  display: inline-block;\n  vertical-align: top\n}\n._datepicker_DayPicker_weekHeaders__o2POo {\n  position: relative\n}\n._datepicker_DayPicker_weekHeaders__horizontal__3s67n {\n  margin-left: 9px\n}\n._datepicker_DayPicker_weekHeader__2D2vw {\n  color: #757575;\n  position: absolute;\n  top: 62px;\n  z-index: 2;\n  text-align: left\n}\n._datepicker_DayPicker_weekHeader__vertical__2TeD7 {\n  left: 50%\n}\n._datepicker_DayPicker_weekHeader__verticalScrollable__1sjqy {\n  top: 0;\n  display: table-row;\n  border-bottom: 1px solid #dbdbdb;\n  background: #fff;\n  margin-left: 0;\n  left: 0;\n  width: 100%;\n  text-align: center\n}\n._datepicker_DayPicker_weekHeader_ul__1ftXe {\n  list-style: none;\n  margin: 1px 0;\n  padding-left: 0;\n  padding-right: 0;\n  font-size: 14px\n}\n._datepicker_DayPicker_weekHeader_li__2HB_8 {\n  display: inline-block;\n  text-align: center\n}\n._datepicker_DayPicker_transitionContainer__1DUKx {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px\n}\n._datepicker_DayPicker_transitionContainer__horizontal__Qmrzw {\n  -webkit-transition: height .2s ease-in-out;\n  -moz-transition: height .2s ease-in-out;\n  transition: height .2s ease-in-out\n}\n._datepicker_DayPicker_transitionContainer__vertical__vt3wp {\n  width: 100%\n}\n._datepicker_DayPicker_transitionContainer__verticalScrollable__1c9QF {\n  padding-top: 20px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  overflow-y: scroll\n}\n._datepicker_DateInput__2CJOz {\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  position: relative;\n  display: inline-block;\n  width: 130px;\n  vertical-align: middle\n}\n._datepicker_DateInput__small__3-FNP {\n  width: 97px\n}\n._datepicker_DateInput__block__GpVeI {\n  width: 100%\n}\n._datepicker_DateInput__disabled__vuPuL {\n  background: #f2f2f2;\n  color: #dbdbdb\n}\n._datepicker_DateInput_input__1O9oE {\n  font-weight: 200;\n  font-size: 19px;\n  line-height: 24px;\n  color: #484848;\n  background-color: #fff;\n  width: 100%;\n  padding: 11px 11px 9px;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid transparent;\n  border-left: 0;\n  border-radius: 0\n}\n._datepicker_DateInput_input__small__3R8zo {\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: .2px;\n  padding: 7px 7px 5px\n}\n._datepicker_DateInput_input__regular__2JnXL {\n  font-weight: auto\n}\n._datepicker_DateInput_input__readOnly__3_g9K {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none\n}\n._datepicker_DateInput_input__focused__BpGw9 {\n  outline: 0;\n  background: #fff;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid #008489;\n  border-left: 0\n}\n._datepicker_DateInput_input__disabled__16LO9 {\n  background: #f2f2f2;\n  font-style: italic\n}\n._datepicker_DateInput_screenReaderMessage__2RoG_ {\n  border: 0;\n  clip: rect(0,0,0,0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px\n}\n._datepicker_DateInput_fang__3_0be {\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  left: 22px;\n  z-index: 2\n}\n._datepicker_DateInput_fangShape__1I9RF {\n  fill: #fff\n}\n._datepicker_DateInput_fangStroke__Rovs8 {\n  stroke: #dbdbdb;\n  fill: transparent\n}\n._datepicker_DateRangePickerInput__2OhAM {\n  background-color: #fff;\n  display: inline-block\n}\n._datepicker_DateRangePickerInput__disabled__3J4FS {\n  background: #f2f2f2\n}\n._datepicker_DateRangePickerInput__withBorder__24F8w {\n  border-radius: 2px;\n  border: 1px solid #dbdbdb\n}\n._datepicker_DateRangePickerInput__rtl__10YPa {\n  direction: rtl\n}\n._datepicker_DateRangePickerInput__block__15-zS {\n  display: block\n}\n._datepicker_DateRangePickerInput__showClearDates__iDeCk {\n  padding-right: 30px\n}\n._datepicker_DateRangePickerInput_arrow__2kPIj {\n  display: inline-block;\n  vertical-align: middle;\n  color: #484848\n}\n._datepicker_DateRangePickerInput_arrow_svg__1Zu-x {\n  vertical-align: middle;\n  fill: #484848;\n  height: 24px;\n  width: 24px\n}\n._datepicker_DateRangePickerInput_clearDates__23MlZ {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%)\n}\n._datepicker_DateRangePickerInput_clearDates__small__3Cywg {\n  padding: 6px\n}\n._datepicker_DateRangePickerInput_clearDates_default__jqk0S:focus,\n._datepicker_DateRangePickerInput_clearDates_default__jqk0S:hover {\n  background: #dbdbdb;\n  border-radius: 50%\n}\n._datepicker_DateRangePickerInput_clearDates__hide__WL8LZ {\n  visibility: hidden\n}\n._datepicker_DateRangePickerInput_clearDates_svg__3cAev {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle\n}\n._datepicker_DateRangePickerInput_clearDates_svg__small__2_hEh {\n  height: 9px\n}\n._datepicker_DateRangePickerInput_calendarIcon__1JM2M {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px\n}\n._datepicker_DateRangePickerInput_calendarIcon_svg__2EJhg {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle\n}\n._datepicker_DateRangePicker__1C_DO {\n  position: relative;\n  display: inline-block\n}\n._datepicker_DateRangePicker__block__1TY7f {\n  display: block\n}\n._datepicker_DateRangePicker_picker__2vZVt {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute\n}\n._datepicker_DateRangePicker_picker__rtl__1RqUY {\n  direction: rtl\n}\n._datepicker_DateRangePicker_picker__directionLeft__2o4xK {\n  left: 0\n}\n._datepicker_DateRangePicker_picker__directionRight__57NlY {\n  right: 0\n}\n._datepicker_DateRangePicker_picker__portal__2QQqQ {\n  background-color: rgba(0,0,0,.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%\n}\n._datepicker_DateRangePicker_picker__fullScreenPortal__2i5RR {\n  background-color: #fff\n}\n._datepicker_DateRangePicker_closeButton__2Il_3 {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2\n}\n._datepicker_DateRangePicker_closeButton__2Il_3:focus,\n._datepicker_DateRangePicker_closeButton__2Il_3:hover {\n  color: darken(#cacccd,10%);\n  text-decoration: none\n}\n._datepicker_DateRangePicker_closeButton_svg__3N-zY {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}";
styleInject(css_248z$p);

var css_248z$q = ".DatePicker_PresetDateRangePicker_panel__jG1Rp {\n  padding: 0 22px 11px; }\n\n.DatePicker_PresetDateRangePicker_button__31vR0 {\n  position: relative;\n  height: 100%;\n  text-align: center;\n  background: 0 0;\n  border: 2px solid #00a699;\n  color: #00a699;\n  padding: 4px 12px;\n  margin-right: 8px;\n  font: inherit;\n  font-weight: 700;\n  line-height: normal;\n  overflow: visible;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer; }\n\n.DatePicker_PresetDateRangePicker_button__31vR0:active {\n  outline: 0; }\n\n.DatePicker_PresetDateRangePicker_button__selected__3pRKS {\n  color: #fff;\n  background: #00a699; }\n\n.DatePicker_DayPickerKeyboardShortcuts_buttonReset__3vz-F {\n  background: 0 0;\n  border: 0;\n  border-radius: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer;\n  font-size: 14px; }\n\n.DatePicker_DayPickerKeyboardShortcuts_buttonReset__3vz-F:active {\n  outline: 0; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__7JDhV {\n  width: 33px;\n  height: 26px;\n  position: absolute;\n  z-index: 2; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__7JDhV::before {\n  content: '';\n  display: block;\n  position: absolute; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__bottomRight__2-KpN {\n  bottom: 0;\n  right: 0; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__bottomRight__2-KpN::before {\n  border-top: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  bottom: 0;\n  right: 0; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__bottomRight__2-KpN:hover::before {\n  border-right: 33px solid #008489; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__topRight__Qoldo {\n  top: 0;\n  right: 0; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__topRight__Qoldo::before {\n  border-bottom: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  top: 0;\n  right: 0; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__topRight__Qoldo:hover::before {\n  border-right: 33px solid #008489; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__topLeft__5pHXD {\n  top: 0;\n  left: 0; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__topLeft__5pHXD::before {\n  border-bottom: 26px solid transparent;\n  border-left: 33px solid #00a699;\n  top: 0;\n  left: 0; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__topLeft__5pHXD:hover::before {\n  border-left: 33px solid #008489; }\n\n.DatePicker_DayPickerKeyboardShortcuts_showSpan__32A7H {\n  color: #fff;\n  position: absolute; }\n\n.DatePicker_DayPickerKeyboardShortcuts_showSpan__bottomRight__2MMwg {\n  bottom: 0;\n  right: 5px; }\n\n.DatePicker_DayPickerKeyboardShortcuts_showSpan__topRight__3toHa {\n  top: 1px;\n  right: 5px; }\n\n.DatePicker_DayPickerKeyboardShortcuts_showSpan__topLeft__3UdwM {\n  top: 1px;\n  left: 5px; }\n\n.DatePicker_DayPickerKeyboardShortcuts_panel__2EB6p {\n  overflow: auto;\n  background: #fff;\n  border: 1px solid #dbdbdb;\n  border-radius: 2px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 2;\n  padding: 22px;\n  margin: 33px;\n  text-align: left; }\n\n.DatePicker_DayPickerKeyboardShortcuts_title__iSU1O {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0; }\n\n.DatePicker_DayPickerKeyboardShortcuts_list__1KPgU {\n  list-style: none;\n  padding: 0;\n  font-size: 14px; }\n\n.DatePicker_DayPickerKeyboardShortcuts_close__22pc- {\n  position: absolute;\n  right: 22px;\n  top: 22px;\n  z-index: 2; }\n\n.DatePicker_DayPickerKeyboardShortcuts_close__22pc-:active {\n  outline: 0; }\n\n.DatePicker_DayPickerKeyboardShortcuts_closeSvg__31EGh {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd; }\n\n.DatePicker_DayPickerKeyboardShortcuts_closeSvg__31EGh:focus,\n.DatePicker_DayPickerKeyboardShortcuts_closeSvg__31EGh:hover {\n  fill: #82888a; }\n\n.DatePicker_CalendarDay__1Xuna {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center; }\n\n.DatePicker_CalendarDay__1Xuna:active {\n  outline: 0; }\n\n.DatePicker_CalendarDay__defaultCursor__XwjQr {\n  cursor: default; }\n\n.DatePicker_CalendarDay__default__oD4kp {\n  border: 1px solid #e4e7e7;\n  color: #484848;\n  background: #fff; }\n\n.DatePicker_CalendarDay__default__oD4kp:hover {\n  background: #e4e7e7;\n  border: 1px solid #e4e7e7;\n  color: inherit; }\n\n.DatePicker_CalendarDay__hovered_offset__31MyJ {\n  background: #f4f5f5;\n  border: 1px double #e4e7e7;\n  color: inherit; }\n\n.DatePicker_CalendarDay__outside__3g_4d {\n  border: 0;\n  background: #fff;\n  color: #484848; }\n\n.DatePicker_CalendarDay__outside__3g_4d:hover {\n  border: 0; }\n\n.DatePicker_CalendarDay__blocked_minimum_nights__3ei7g {\n  background: #fff;\n  border: 1px solid #eceeee;\n  color: #cacccd; }\n\n.DatePicker_CalendarDay__blocked_minimum_nights__3ei7g:active,\n.DatePicker_CalendarDay__blocked_minimum_nights__3ei7g:hover {\n  background: #fff;\n  color: #cacccd; }\n\n.DatePicker_CalendarDay__highlighted_calendar__10nPC {\n  background: #ffe8bc;\n  color: #484848; }\n\n.DatePicker_CalendarDay__highlighted_calendar__10nPC:active,\n.DatePicker_CalendarDay__highlighted_calendar__10nPC:hover {\n  background: #ffce71;\n  color: #484848; }\n\n.DatePicker_CalendarDay__selected_span__KBStv {\n  background: #66e2da;\n  border: 1px double #33dacd;\n  color: #fff; }\n\n.DatePicker_CalendarDay__selected_span__KBStv:active,\n.DatePicker_CalendarDay__selected_span__KBStv:hover {\n  background: #33dacd;\n  outline: 1px double #33dacd;\n  color: #fff; }\n\n.DatePicker_CalendarDay__selected__3A0zs,\n.DatePicker_CalendarDay__selected__3A0zs:active,\n.DatePicker_CalendarDay__selected__3A0zs:hover {\n  background: #00a699;\n  border: 1px double #00a699;\n  color: #fff; }\n\n.DatePicker_CalendarDay__hovered_span__2vYYr,\n.DatePicker_CalendarDay__hovered_span__2vYYr:hover {\n  background: #b2f1ec;\n  border: 1px double #80e8e0;\n  color: #007a87; }\n\n.DatePicker_CalendarDay__hovered_span__2vYYr:active {\n  background: #80e8e0;\n  border: 1px double #80e8e0;\n  color: #007a87; }\n\n.DatePicker_CalendarDay__blocked_calendar__Ri2Cq,\n.DatePicker_CalendarDay__blocked_calendar__Ri2Cq:active,\n.DatePicker_CalendarDay__blocked_calendar__Ri2Cq:hover {\n  background: #cacccd;\n  border: 1px solid #cacccd;\n  color: #82888a; }\n\n.DatePicker_CalendarDay__blocked_out_of_range__3lx4I,\n.DatePicker_CalendarDay__blocked_out_of_range__3lx4I:active,\n.DatePicker_CalendarDay__blocked_out_of_range__3lx4I:hover {\n  background: #fff;\n  border: 1px solid #e4e7e7;\n  color: #cacccd; }\n\n.DatePicker_CalendarDay__hovered_start_first_possible_end__3ZOUU {\n  background: #eceeee;\n  border: 1px double #eceeee; }\n\n.DatePicker_CalendarDay__hovered_start_blocked_min_nights__2bpeV {\n  background: #eceeee;\n  border: 1px double #e4e7e7; }\n\n.DatePicker_CalendarMonth__gj2VG {\n  background: #fff;\n  text-align: center;\n  vertical-align: top;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.DatePicker_CalendarMonth_table__1b_5N {\n  border-collapse: collapse;\n  border-spacing: 0; }\n\n.DatePicker_CalendarMonth_verticalSpacing__2C6nI {\n  border-collapse: separate; }\n\n.DatePicker_CalendarMonth_caption__31ZVI {\n  color: #484848;\n  font-size: 18px;\n  text-align: center;\n  padding-top: 22px;\n  padding-bottom: 37px;\n  caption-side: initial; }\n\n.DatePicker_CalendarMonth_caption__verticalScrollable__3bvHM {\n  padding-top: 12px;\n  padding-bottom: 7px; }\n\n.DatePicker_CalendarMonthGrid__1Svif {\n  background: #fff;\n  text-align: left;\n  z-index: 0; }\n\n.DatePicker_CalendarMonthGrid__animating__37x31 {\n  z-index: 1; }\n\n.DatePicker_CalendarMonthGrid__horizontal__4PFdd {\n  position: absolute;\n  left: 9px; }\n\n.DatePicker_CalendarMonthGrid__vertical__2iIpa,\n.DatePicker_CalendarMonthGrid__vertical_scrollable__2xHd4 {\n  margin: 0 auto; }\n\n.DatePicker_CalendarMonthGrid_month__horizontal__1ui73 {\n  display: inline-block;\n  vertical-align: top;\n  min-height: 100%; }\n\n.DatePicker_CalendarMonthGrid_month__hideForAnimation__8ab31 {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none; }\n\n.DatePicker_CalendarMonthGrid_month__hidden__1MbTz {\n  visibility: hidden; }\n\n.DatePicker_DayPickerNavigation__2itIZ {\n  position: relative;\n  z-index: 2; }\n\n.DatePicker_DayPickerNavigation__horizontal__vOu1j {\n  height: 0; }\n\n.DatePicker_DayPickerNavigation__verticalScrollable_prevNav__a_s-v {\n  z-index: 1; }\n\n.DatePicker_DayPickerNavigation__verticalDefault__2m6aZ {\n  position: absolute;\n  width: 100%;\n  height: 52px;\n  bottom: 0;\n  left: 0; }\n\n.DatePicker_DayPickerNavigation__verticalScrollableDefault__DZ2Nm {\n  position: relative; }\n\n.DatePicker_DayPickerNavigation__bottom__t7RP_ {\n  height: auto; }\n\n.DatePicker_DayPickerNavigation__bottomDefault__2kk3n {\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: space-between;\n  justify-content: space-between; }\n\n.DatePicker_DayPickerNavigation_button__1kvJk {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border: 0;\n  padding: 0;\n  margin: 0; }\n\n.DatePicker_DayPickerNavigation_button__default__25l8J {\n  border: 1px solid #e4e7e7;\n  background-color: #fff;\n  color: #757575; }\n\n.DatePicker_DayPickerNavigation_button__default__25l8J:focus,\n.DatePicker_DayPickerNavigation_button__default__25l8J:hover {\n  border: 1px solid #c4c4c4; }\n\n.DatePicker_DayPickerNavigation_button__default__25l8J:active {\n  background: #f2f2f2; }\n\n.DatePicker_DayPickerNavigation_button__disabled__30uWt {\n  cursor: default;\n  border: 1px solid #f2f2f2; }\n\n.DatePicker_DayPickerNavigation_button__disabled__30uWt:focus,\n.DatePicker_DayPickerNavigation_button__disabled__30uWt:hover {\n  border: 1px solid #f2f2f2; }\n\n.DatePicker_DayPickerNavigation_button__disabled__30uWt:active {\n  background: 0 0; }\n\n.DatePicker_DayPickerNavigation_button__horizontalDefault__8G08Q {\n  position: absolute;\n  top: 18px;\n  line-height: 0.78;\n  border-radius: 3px;\n  padding: 6px 9px; }\n\n.DatePicker_DayPickerNavigation_bottomButton__horizontalDefault__3qfQg {\n  position: static;\n  margin: -10px 22px 30px; }\n\n.DatePicker_DayPickerNavigation_leftButton__horizontalDefault__dqVuA {\n  left: 22px; }\n\n.DatePicker_DayPickerNavigation_rightButton__horizontalDefault__20CDR {\n  right: 22px; }\n\n.DatePicker_DayPickerNavigation_button__verticalDefault__3ioWC {\n  padding: 5px;\n  background: #fff;\n  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);\n  position: relative;\n  display: inline-block;\n  text-align: center;\n  height: 100%;\n  width: 50%; }\n\n.DatePicker_DayPickerNavigation_nextButton__verticalDefault__1ET6M {\n  border-left: 0; }\n\n.DatePicker_DayPickerNavigation_nextButton__verticalScrollableDefault__s3x_d,\n.DatePicker_DayPickerNavigation_prevButton__verticalScrollableDefault__3lMcs {\n  width: 100%; }\n\n.DatePicker_DayPickerNavigation_svg__horizontal__2RuRH {\n  height: 19px;\n  width: 19px;\n  fill: #82888a;\n  display: block; }\n\n.DatePicker_DayPickerNavigation_svg__vertical__jD7FE {\n  height: 42px;\n  width: 42px;\n  fill: #484848; }\n\n.DatePicker_DayPickerNavigation_svg__disabled__zOrEH {\n  fill: #f2f2f2; }\n\n.DatePicker_DayPicker__1giMK {\n  background: #fff;\n  position: relative;\n  text-align: left; }\n\n.DatePicker_DayPicker__horizontal__1IGgR {\n  background: #fff; }\n\n.DatePicker_DayPicker__verticalScrollable__y585l {\n  height: 100%; }\n\n.DatePicker_DayPicker__hidden__153fE {\n  visibility: hidden; }\n\n.DatePicker_DayPicker_portal__horizontal__wme8X {\n  box-shadow: none;\n  position: absolute;\n  left: 50%;\n  top: 50%; }\n\n.DatePicker_DayPicker_portal__vertical__1wVul {\n  position: initial; }\n\n.DatePicker_DayPicker_focusRegion__1ZePJ {\n  outline: 0; }\n\n.DatePicker_DayPicker_calendarInfo__horizontal__1oIx3,\n.DatePicker_DayPicker_wrapper__horizontal__1pWxo {\n  display: inline-block;\n  vertical-align: top; }\n\n.DatePicker_DayPicker_weekHeaders__z4HyX {\n  position: relative; }\n\n.DatePicker_DayPicker_weekHeaders__horizontal__1Weto {\n  margin-left: 9px; }\n\n.DatePicker_DayPicker_weekHeader__t4DcS {\n  color: #757575;\n  position: absolute;\n  top: 62px;\n  z-index: 2;\n  text-align: left; }\n\n.DatePicker_DayPicker_weekHeader__vertical__3x5WY {\n  left: 50%; }\n\n.DatePicker_DayPicker_weekHeader__verticalScrollable__3ultl {\n  top: 0;\n  display: table-row;\n  border-bottom: 1px solid #dbdbdb;\n  background: #fff;\n  margin-left: 0;\n  left: 0;\n  width: 100%;\n  text-align: center; }\n\n.DatePicker_DayPicker_weekHeader_ul__3FB0o {\n  list-style: none;\n  margin: 1px 0;\n  padding-left: 0;\n  padding-right: 0;\n  font-size: 14px; }\n\n.DatePicker_DayPicker_weekHeader_li__ATw6x {\n  display: inline-block;\n  text-align: center; }\n\n.DatePicker_DayPicker_transitionContainer__1J_Yh {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px; }\n\n.DatePicker_DayPicker_transitionContainer__horizontal__13bX_ {\n  -webkit-transition: height 0.2s ease-in-out;\n  -moz-transition: height 0.2s ease-in-out;\n  transition: height 0.2s ease-in-out; }\n\n.DatePicker_DayPicker_transitionContainer__vertical__7L826 {\n  width: 100%; }\n\n.DatePicker_DayPicker_transitionContainer__verticalScrollable__2XdjD {\n  padding-top: 20px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  overflow-y: scroll; }\n\n.DatePicker_DateInput__239nu {\n  margin: 0;\n  padding: 0;\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  background: #dfeef2;\n  width: 79px; }\n\n.DatePicker_DateInput__small__3Zy6B {\n  width: 97px; }\n\n.DatePicker_DateInput__block__3l5_9 {\n  width: 100%; }\n\n.DatePicker_DateInput__disabled__5k1Q9 {\n  background: #f2f2f2;\n  color: #dbdbdb; }\n\n.DatePicker_DateInput_input__DqNA9 {\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 20px;\n  color: #000;\n  text-align: center;\n  padding: 0;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 0;\n  border-left: 0;\n  border-radius: 0;\n  background-color: #dfeef2;\n  width: 70px; }\n\n.DatePicker_DateInput_input__small__1hCJU {\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: 0.2px;\n  padding: 7px 7px 5px; }\n\n.DatePicker_DateInput_input__regular__1DOBp {\n  font-weight: 400; }\n\n.DatePicker_DateInput_input__readOnly__sMcEq {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.DatePicker_DateInput_input__focused__1PGJw {\n  outline: 0;\n  background: #fff; }\n\n.DatePicker_DateInput_input__disabled__2gTLW {\n  background: #f2f2f2;\n  font-style: italic; }\n\n.DatePicker_DateInput_screenReaderMessage__1Avkk {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.DatePicker_DateInput_fang__2jmAE {\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  left: 22px;\n  z-index: 2; }\n\n.DatePicker_DateInput_fangShape__1Qff- {\n  fill: #fff; }\n\n.DatePicker_DateInput_fangStroke__3D3z_ {\n  stroke: #dbdbdb;\n  fill: transparent; }\n\n.DatePicker_DateRangePickerInput__disabled__pYkUc {\n  background: #f2f2f2; }\n\n.DatePicker_DateRangePickerInput__rtl__MBPPj {\n  direction: rtl; }\n\n.DatePicker_DateRangePickerInput__block__1Amdv {\n  display: block; }\n\n.DatePicker_DateRangePickerInput__showClearDates__uTGNV {\n  padding-right: 30px; }\n\n.DatePicker_DateRangePickerInput_arrow__1pXDq {\n  display: inline-block;\n  vertical-align: middle;\n  color: #484848; }\n\n.DatePicker_DateRangePickerInput_arrow_svg__wZ6mo {\n  vertical-align: middle;\n  fill: #484848;\n  height: 24px;\n  width: 24px; }\n\n.DatePicker_DateRangePickerInput_clearDates__1OVjD {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%); }\n\n.DatePicker_DateRangePickerInput_clearDates__small__ePJxv {\n  padding: 6px; }\n\n.DatePicker_DateRangePickerInput_clearDates_default__3_J-i:focus,\n.DatePicker_DateRangePickerInput_clearDates_default__3_J-i:hover {\n  background: #dbdbdb;\n  border-radius: 50%; }\n\n.DatePicker_DateRangePickerInput_clearDates__hide__2N6V8 {\n  visibility: hidden; }\n\n.DatePicker_DateRangePickerInput_clearDates_svg__T9nhB {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle; }\n\n.DatePicker_DateRangePickerInput_clearDates_svg__small__1YMZ1 {\n  height: 9px; }\n\n.DatePicker_DateRangePickerInput_calendarIcon__2sFB5 {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 0 0 0.25rem;\n  padding: 0; }\n\n.DatePicker_DateRangePickerInput_calendarIcon_svg__2VeBi {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle; }\n\n.DatePicker_DateRangePicker__2TzsY {\n  position: relative;\n  display: inline-block; }\n\n.DatePicker_DateRangePicker__block__s721n {\n  display: block; }\n\n.DatePicker_DateRangePicker_picker__1m01Z {\n  z-index: 1; }\n\n.DatePicker_DateRangePicker_picker__rtl__ZCsVe {\n  direction: rtl; }\n\n.DatePicker_DateRangePicker_picker__directionLeft__13ueN {\n  left: 0; }\n\n.DatePicker_DateRangePicker_picker__directionRight__mWRFc {\n  right: 0; }\n\n.DatePicker_DateRangePicker_picker__portal__1BVvP {\n  background-color: rgba(0, 0, 0, 0.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%; }\n\n.DatePicker_DateRangePicker_picker__fullScreenPortal__1SQas {\n  background-color: #fff; }\n\n.DatePicker_DateRangePicker_closeButton__2scIb {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2; }\n\n.DatePicker_DateRangePicker_closeButton__2scIb:focus,\n.DatePicker_DateRangePicker_closeButton__2scIb:hover {\n  color: #b0b3b4;\n  text-decoration: none; }\n\n.DatePicker_DateRangePicker_closeButton_svg__CVo0G {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd; }\n\n.DatePicker_DateRangePicker__2TzsY,\n.DatePicker_DateRangePicker_1__1JPPj {\n  margin-bottom: 12px; }\n\n.DatePicker_DateRangePickerInput__1Omvr {\n  min-width: 226px;\n  height: 32px;\n  min-height: 32px;\n  border-radius: 6px;\n  background-color: #dfeef2;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  color: #000000;\n  display: flex;\n  justify-content: space-around;\n  align-items: center; }\n\n.DatePicker_DateRangePickerInput__withBorder__2g7le {\n  border: 1px solid #4eb3d4; }\n\n.DatePicker_DateRangePickerInput_arrow__1pXDq > svg {\n  display: none; }\n\n.DatePicker_DateRangePickerInput_arrow__1pXDq:after {\n  color: white;\n  margin: 0;\n  font-weight: 700;\n  content: '|'; }\n\n.DatePicker_DateRangePickerInput_calendarIcon__2sFB5 > svg {\n  display: none; }\n\n.DatePicker_DateRangePickerInput_calendarIcon__2sFB5:after {\n  content: url(\"https://puzzle-media.s3.amazonaws.com/calendarIcon.svg\"); }\n\n.DatePicker_CalendarMonth_table__1b_5N {\n  border-spacing: 0 5px;\n  border-collapse: separate; }\n  .DatePicker_CalendarMonth_table__1b_5N tbody {\n    margin: 1rem; }\n\n.DatePicker_DateInput_fang__2jmAE,\n.DatePicker_DateInput_fang__2jmAE {\n  display: none; }\n\n.DatePicker_DateRangePicker_picker__1m01Z,\n.DatePicker_DateRangePicker_picker_1__2imhp {\n  top: 35px !important;\n  max-width: 665px;\n  max-height: 400px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px 0 #d1dadc;\n  background-color: #ffffff;\n  position: absolute;\n  padding: 28px 10px 36px; }\n\n.DatePicker_DayPickerNavigation_leftButton__horizontalDefault__dqVuA {\n  top: 150px;\n  left: -10px; }\n\n.DatePicker_DayPickerNavigation_rightButton__horizontalDefault__20CDR {\n  top: 150px;\n  right: -10px; }\n\n.DatePicker_DayPickerNavigation_button__default__25l8J:hover,\n.DatePicker_DayPickerNavigation_button__default__25l8J:focus {\n  border: 0;\n  outline: 0;\n  background-color: transparent;\n  color: black; }\n\n.DatePicker_DayPickerNavigation_button__default__25l8J {\n  border: 0;\n  background-color: transparent;\n  color: black; }\n\n.DatePicker_DayPickerNavigation_button__default__25l8J > svg {\n  display: none; }\n\n.DatePicker_DayPickerNavigation_button__default__25l8J.DatePicker_DayPickerNavigation_leftButton__horizontalDefault__dqVuA:after {\n  content: url(\"https://puzzle-media.s3.amazonaws.com/chevron-left.svg\"); }\n\n.DatePicker_DayPickerNavigation_button__default__25l8J.DatePicker_DayPickerNavigation_rightButton__horizontalDefault__20CDR:after {\n  content: url(\"https://puzzle-media.s3.amazonaws.com/chevron-right.svg\"); }\n\n.DatePicker_DayPicker__withBorder__15Ff8 {\n  box-shadow: none; }\n\n.DatePicker_CalendarDay__1Xuna.DatePicker_CalendarDay__default__oD4kp {\n  border: 0;\n  font-size: 11px;\n  padding: 0; }\n\n.DatePicker_CalendarDay__1Xuna.DatePicker_CalendarDay__default__oD4kp:hover,\n.DatePicker_CalendarDay__hovered_span__2vYYr {\n  background: #dfeef2;\n  color: black; }\n\n.DatePicker_CalendarDay__1Xuna.DatePicker_CalendarDay__default__oD4kp.DatePicker_CalendarDay__selected__3A0zs:hover {\n  border: 0;\n  font-size: 11px;\n  padding: 0;\n  background: #4eb3d4;\n  color: white; }\n\n.DatePicker_CalendarMonth_caption__31ZVI {\n  text-align: left;\n  padding-right: 10px;\n  padding-left: 10px;\n  font-size: 24px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #173042; }\n\n.DatePicker_DayPickerKeyboardShortcuts_show__bottomRight__2-KpN {\n  display: none; }\n\n.DatePicker_CalendarDay__selected__3A0zs,\n.DatePicker_CalendarDay__selected__3A0zs:active {\n  background-color: #4eb3d4;\n  border: 0;\n  color: #fff;\n  border-radius: 100% 0 0 100%; }\n\n.DatePicker_CalendarDay__selected__3A0zs:hover {\n  background-color: #4eb3d4;\n  border: 0;\n  color: #fff; }\n\n.DatePicker_CalendarDay__selected__3A0zs:focus {\n  outline: none; }\n\n.DatePicker_CalendarDay__selected_end__5W86j {\n  border-radius: 0 100% 100% 0; }\n\n.DatePicker_CalendarDay__selected_span__KBStv {\n  background: #dfeef2;\n  color: black; }\n\n.DatePicker_CalendarDay__selected_span__KBStv:hover {\n  background: #dfeef2;\n  outline: 1px solid #4eb3d4;\n  color: black; }\n";
styleInject(css_248z$q);

var DatePicker$1 = /*#__PURE__*/function (_Component) {
  _inherits(DatePicker, _Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);
    _this.state = {
      availableDates: _this.props.availableDates ? _this.props.availableDates.map(function (date) {
        return date.dateInt;
      }) : [],
      startDate: _this.props.firstAvailableDate,
      endDate: _this.props.lastAvailableDate
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default['default'].createElement(reactDates_1, {
        isDayBlocked: function isDayBlocked(day) {
          return _this2.state.availableDates.indexOf(parseInt(hooks(day).startOf('d').format('x'))) === -1;
        },
        isOutsideRange: this.props.isOutsideRange ? function (day) {
          return !day.isSameOrAfter(_this2.props.firstAvailableDate) || !day.isSameOrBefore(_this2.props.lastAvailableDate);
        } : null,
        initialVisibleMonth: this.props.initialVisibleMonth ? function () {
          var lastDate = lodash.cloneDeep(_this2.props.lastAvailableDate);

          return lastDate.subtract(1, 'month');
        } : null,
        anchorDirection: "right",
        showDefaultInputIcon: true,
        startDate: this.state.startDate // momentPropTypes.momentObj or null,
        ,
        startDateId: "your_unique_start_date_id" // PropTypes.string.isRequired,
        ,
        endDate: this.state.endDate // momentPropTypes.momentObj or null,
        ,
        endDateId: "your_unique_end_date_id" // PropTypes.string.isRequired,
        ,
        onDatesChange: function onDatesChange(_ref) {
          var startDate = _ref.startDate,
              endDate = _ref.endDate;

          _this2.setState({
            startDate: startDate,
            endDate: endDate
          });
        },
        onClose: function onClose(_ref2) {
          var startDate = _ref2.startDate,
              endDate = _ref2.endDate;

          _this2.props.setActiveFilterDates({
            startDate: startDate && startDate.format(),
            endDate: endDate && endDate.format()
          });
        },
        focusedInput: this.state.focusedInput // PropTypes.oneOf([START_DATE, END_DATE]) or null,
        ,
        onFocusChange: function onFocusChange(focusedInput) {
          return _this2.setState({
            focusedInput: focusedInput
          });
        } // PropTypes.func.isRequired,

      });
    }
  }]);

  return DatePicker;
}(React$2.Component);

function useInterval(callback, delay) {
  var savedCallback = React$2.useRef(); // Remember the latest function.

  React$2.useEffect(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  React$2.useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
}

var useTimer = function useTimer(timeIsUp, gameMinutes, isTiming, setIsTiming, gameState, restartGame) {
  var _useState = React$2.useState(+gameMinutes * 60 * 1000),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  React$2.useEffect(function () {
    if (gameState === PuzzleStates.RESTART) {
      console.log(gameState);
      setCount(+gameMinutes * 60 * 1000);
      restartGame();
    }
  }, [gameState]);

  var Timer = function Timer(_ref) {
    var color = _ref.color;
    useInterval(function () {
      if (count === 0) {
        setIsTiming(false);
        timeIsUp('count is zero');
      } else {
        setCount(count - 1000);
      }
    }, isTiming ? 1000 : null);
    return /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        color: color
      }
    }, formatTime(count));
  };

  return {
    Timer: Timer
  };
};

function isMobile(minWidth) {
  return detectMobile() || window.innerWidth < (minWidth || 500);
}
function detectMobile() {
  return !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

var raygun_umd = createCommonjsModule(function (module) {
/*! Raygun4js - v2.20.3 - 2020-09-24
* https://github.com/MindscapeHQ/raygun4js
* Copyright (c) 2020 MindscapeHQ; Licensed MIT */
// https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js

(function (root, factory) {
    if ( module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals
        root.Raygun = factory();
    }
}(commonjsGlobal, function () {

  var windw = this || window || commonjsGlobal;
  var originalOnError = windw.onerror;
  windw.onerror = function (msg, url, line, col, err) {
    if (originalOnError) {
      originalOnError(msg, url, line, col, err);
    }

    if (!err) {
      err = new Error(msg);
    }

    windw['rg4js'].q = windw['rg4js'].q || [];
    windw['rg4js'].q.push({e: err});
  };

  // Similar approach as the snippet, creates the rg4js proxy function, which is exported in umd.outro.js once the
  // script is executed, and later overwritten by the loader once it's finished
  (function(wind) { wind['RaygunObject'] = 'rg4js';
  wind[wind['RaygunObject']] = wind[wind['RaygunObject']] || function() {
      if (wind && typeof wind['Raygun'] === 'undefined' ||
        (typeof document === 'undefined' || document.readyState !== 'complete')) {
        // onload hasn't been called, cache the commands just like the snippet
        (wind[wind['RaygunObject']].o = wind[wind['RaygunObject']].o || []).push(arguments);
      } else {
        // onload has been called and provider has executed, call the executor proxy function
        wind[wind['RaygunObject']](arguments[0], arguments[1]);
      }
      
  };})(windw);

(function(window, undefined$1) {


var TraceKit = {};
var _oldTraceKit = window.TraceKit;

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';
var Raygun;


/**
 * _has, a better form of hasOwnProperty
 * Example: _has(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function _has(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
}

function _isUndefined(what) {
    return typeof what === 'undefined';
}

/**
 * TraceKit gets loaded before Raygun
 * Raygun uses this callback to give TraceKit an instance of Raygun
 * This is required to use the Utilities module
 */
TraceKit.setRaygun = function setRaygun(rg) {
    if (!Raygun) {
        Raygun = rg;
    }
};

/**
 * TraceKit.noConflict: Export TraceKit out to another variable
 * Example: var TK = TraceKit.noConflict()
 */
TraceKit.noConflict = function noConflict() {
    window.TraceKit = _oldTraceKit;
    return TraceKit;
};

/**
 * TraceKit.wrap: Wrap any function in a TraceKit reporter
 * Example: func = TraceKit.wrap(func);
 *
 * @param {Function} func Function to be wrapped
 * @return {Function} The wrapped func
 */
TraceKit.wrap = function traceKitWrapper(func) {
    function wrapped() {
        try {
            return func.apply(this, arguments);
        } catch (e) {
            TraceKit.report(e);
            throw e;
        }
    }
    return wrapped;
};

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
    var handlers = [],
        lastException = null,
        lastExceptionStack = null;

    /**
     * Add a crash handler.
     * @param {Function} handler
     */
    function subscribe(handler) {
        installGlobalHandler();
        handlers.push(handler);
    }

    /**
     * Remove a crash handler.
     * @param {Function} handler
     */
    function unsubscribe(handler) {
        for (var i = handlers.length - 1; i >= 0; --i) {
            if (handlers[i] === handler) {
                handlers.splice(i, 1);
            }
        }
    }

    /**
     * Dispatch stack information to all handlers.
     * @param {Object.<string, *>} stack
     */
    function notifyHandlers(stack, windowError) {
        var exception = null;
        if (windowError && !TraceKit.collectWindowErrors) {
          return;
        }
        for (var i in handlers) {
            if (_has(handlers, i)) {
                try {
                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
                } catch (inner) {
                    exception = inner;
                }
            }
        }

        if (exception) {
            throw exception;
        }
    }

    var _oldOnerrorHandler, _onErrorHandlerInstalled;

    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} message Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error
     * occurred.
     */
    function traceKitWindowOnError(message, url, lineNo, columnNo, errorObj) {
        var stack = null;

        if (errorObj) {
          stack = TraceKit.computeStackTrace(errorObj);
        }
        else
        {
            if (lastExceptionStack) {
                TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
                stack = lastExceptionStack;
                lastExceptionStack = null;
                lastException = null;
            } else {
                var location = {
                    'url': url,
                    'line': lineNo,
                    'column': columnNo
                };
                location.func = TraceKit.computeStackTrace.guessFunctionName(location.url, location.line);
                location.context = TraceKit.computeStackTrace.gatherContext(location.url, location.line);
                stack = {
                    'mode': 'onerror',
                    'message': message,
                    'url': document.location.href,
                    'stack': [location],
                    'useragent': navigator.userAgent
                };
            }
        }

        notifyHandlers(stack, 'from window.onerror');

        if (_oldOnerrorHandler) {
            return _oldOnerrorHandler.apply(this, arguments);
        }

        return false;
    }

    function installGlobalHandler ()
    {
        if (_onErrorHandlerInstalled === true) {
           return;
        }
        _oldOnerrorHandler = window.onerror;
        window.onerror = traceKitWindowOnError;
        _onErrorHandlerInstalled = true;
    }

    /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     */
    function report(ex) {
        var args;
        if (typeof document !== 'undefined') {
            args = _slice.call(arguments, 1);
        }

        if (lastExceptionStack) {
            if (lastException === ex) {
                return; // already caught by an inner catch block, ignore
            } else {
                var s = lastExceptionStack;
                lastExceptionStack = null;
                lastException = null;
                notifyHandlers.apply(null, [s, null].concat(args));
            }
        }

        var stack = TraceKit.computeStackTrace(ex);
        lastExceptionStack = stack;
        lastException = ex;

        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        window.setTimeout(function () {
            if (lastException === ex) {
                lastExceptionStack = null;
                lastException = null;
                notifyHandlers.apply(null, [stack, null].concat(args));
            }
        }, (stack.incomplete ? 2000 : 0));

        if (!Raygun.Utilities.isReactNative()) {
            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
        }
        // Else case for this is handled in attach
    }

    report.subscribe = subscribe;
    report.unsubscribe = unsubscribe;
    return report;
}());

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace.ofCaller([depth])
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *   s.stack[i].context  - an array of source code lines; the middle element corresponds to the correct line#
 *   s.mode              - 'stack', 'stacktrace', 'multiline', 'callers', 'onerror', or 'failed' -- method used to collect the stack trace
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 * Tracing example:
 *     function trace(message) {
 *         var stackInfo = TraceKit.computeStackTrace.ofCaller();
 *         var data = message + "\n";
 *         for(var i in stackInfo.stack) {
 *             var item = stackInfo.stack[i];
 *             data += (item.func || '[anonymous]') + "() in " + item.url + ":" + (item.line || '0') + "\n";
 *         }
 *         if (window.console)
 *             console.info(data);
 *         else
 *             alert(data);
 *     }
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
    var sourceCache = {};

    /**
     * Attempts to retrieve source code via XMLHttpRequest, which is used
     * to look up anonymous function names.
     * @param {string} url URL of source code.
     * @return {string} Source contents.
     */
    function loadSource(url) {
        if (typeof url !== 'string') {
          return [];
        }

        return ''; // Remote fetching disabled due to deprecated synchronous XHR support in browsers
    }

    /**
     * Retrieves source code from the source code cache.
     * @param {string} url URL of source code.
     * @return {Array.<string>} Source contents.
     */
    function getSource(url) {
        if (!_has(sourceCache, url)) {
            // URL needs to be able to fetched within the acceptable domain.  Otherwise,
            // cross-domain errors will be triggered.
            var source = '';

            url = url || "";

            var domain;
            if (typeof document !== 'undefined') {
                domain = document.domain;
            } else {
                domain = window.location.hostname;
            }

            if (url.indexOf && url.indexOf(domain) !== -1) {
                source = loadSource(url);
            }

            sourceCache[url] = source ? source.split('\n') : [];
        }

        return sourceCache[url];
    }

    /**
     * Tries to use an externally loaded copy of source code to determine
     * the name of a function by looking at the name of the variable it was
     * assigned to, if any.
     * @param {string} url URL of source code.
     * @param {(string|number)} lineNo Line number in source code.
     * @return {string} The function name, if discoverable.
     */
    function guessFunctionName(url, lineNo) {
        var reFunctionArgNames = /function ([^(]*)\(([^)]*)\)/,
            reGuessFunction = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,
            line = '',
            maxLines = 10,
            source = getSource(url),
            m;

        if (!source.length) {
            return UNKNOWN_FUNCTION;
        }

        // Walk backwards from the first line in the function until we find the line which
        // matches the pattern above, which is the function definition
        for (var i = 0; i < maxLines; ++i) {
            line = source[lineNo - i] + line;

            if (!_isUndefined(line)) {
                if ((m = reGuessFunction.exec(line))) {
                    return m[1];
                } else if ((m = reFunctionArgNames.exec(line))) {
                    return m[1];
                }
            }
        }

        return UNKNOWN_FUNCTION;
    }

    /**
     * Retrieves the surrounding lines from where an exception occurred.
     * @param {string} url URL of source code.
     * @param {(string|number)} line Line number in source code to centre
     * around for context.
     * @return {?Array.<string>} Lines of source code.
     */
    function gatherContext(url, line) {
        var source = getSource(url);

        if (!source.length) {
            return null;
        }

        var context = [],
            // linesBefore & linesAfter are inclusive with the offending line.
            // if linesOfContext is even, there will be one extra line
            //   *before* the offending line.
            linesBefore = Math.floor(TraceKit.linesOfContext / 2),
            // Add one extra line if linesOfContext is odd
            linesAfter = linesBefore + (TraceKit.linesOfContext % 2),
            start = Math.max(0, line - linesBefore - 1),
            end = Math.min(source.length, line + linesAfter - 1);

        line -= 1; // convert to 0-based index

        for (var i = start; i < end; ++i) {
            if (!_isUndefined(source[i])) {
                context.push(source[i]);
            }
        }

        return context.length > 0 ? context : null;
    }

    /**
     * Escapes special characters, except for whitespace, in a string to be
     * used inside a regular expression as a string literal.
     * @param {string} text The string.
     * @return {string} The escaped string literal.
     */
    function escapeRegExp(text) {
        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
    }

    /**
     * Escapes special characters in a string to be used inside a regular
     * expression as a string literal. Also ensures that HTML entities will
     * be matched the same as their literal friends.
     * @param {string} body The string.
     * @return {string} The escaped string.
     */
    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
    }

    /**
     * Determines where a code fragment occurs in the source code.
     * @param {RegExp} re The function definition.
     * @param {Array.<string>} urls A list of URLs to search.
     * @return {?Object.<string, (string|number)>} An object containing
     * the url, line, and column number of the defined function.
     */
    function findSourceInUrls(re, urls) {
        var source, m;
        for (var i = 0, j = urls.length; i < j; ++i) {
            // console.log('searching', urls[i]);
            if ((source = getSource(urls[i])).length) {
                source = source.join('\n');
                if ((m = re.exec(source))) {
                    // console.log('Found function in ' + urls[i]);

                    return {
                        'url': urls[i],
                        'line': source.substring(0, m.index).split('\n').length,
                        'column': m.index - source.lastIndexOf('\n', m.index) - 1
                    };
                }
            }
        }

        // console.log('no match');

        return null;
    }

    /**
     * Determines at which column a code fragment occurs on a line of the
     * source code.
     * @param {string} fragment The code fragment.
     * @param {string} url The URL to search.
     * @param {(string|number)} line The line number to examine.
     * @return {?number} The column number.
     */
    function findSourceInLine(fragment, url, line) {
        var source = getSource(url),
            re = new RegExp('\\b' + escapeRegExp(fragment) + '\\b'),
            m;

        line -= 1;

        if (source && source.length > line && (m = re.exec(source[line]))) {
            return m.index;
        }

        return null;
    }

    /**
     * Determines where a function was defined within the source code.
     * @param {(Function|string)} func A function reference or serialized
     * function definition.
     * @return {?Object.<string, (string|number)>} An object containing
     * the url, line, and column number of the defined function.
     */
    function findSourceByFunctionBody(func) {
        var urls = [window.location.href],
            scripts = document.getElementsByTagName('script'),
            body,
            code = '' + func,
            codeRE = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
            eventRE = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
            re,
            parts,
            result;

        for (var i = 0; i < scripts.length; ++i) {
            var script = scripts[i];
            if (script.src) {
                urls.push(script.src);
            }
        }

        if (!(parts = codeRE.exec(code))) {
            re = new RegExp(escapeRegExp(code).replace(/\s+/g, '\\s+'));
        }

        // not sure if this is really necessary, but I don’t have a test
        // corpus large enough to confirm that and it was in the original.
        else {
            var name = parts[1] ? '\\s+' + parts[1] : '',
                args = parts[2].split(',').join('\\s*,\\s*');

            body = escapeRegExp(parts[3]).replace(/;$/, ';?'); // semicolon is inserted if the function ends with a comment.replace(/\s+/g, '\\s+');
            re = new RegExp('function' + name + '\\s*\\(\\s*' + args + '\\s*\\)\\s*{\\s*' + body + '\\s*}');
        }

        // look for a normal function definition
        if ((result = findSourceInUrls(re, urls))) {
            return result;
        }

        // look for an old-school event handler function
        if ((parts = eventRE.exec(code))) {
            var event = parts[1];
            body = escapeCodeAsRegExpForMatchingInsideHTML(parts[2]);

            // look for a function defined in HTML as an onXXX handler
            re = new RegExp('on' + event + '=[\\\'"]\\s*' + body + '\\s*[\\\'"]', 'i');

            if ((result = findSourceInUrls(re, urls[0]))) {
                return result;
            }

            // look for ???
            re = new RegExp(body);

            if ((result = findSourceInUrls(re, urls))) {
                return result;
            }
        }

        return null;
    }

    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * Added WinJS regex for Raygun4JS's offline caching support
     * Added stack string sanitization for React Native in release mode, for JavaScriptCore, which uses the Gecko regex
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceFromStackProp(ex) {

        if (!ex.stack) {
            return null;
        }

        var chrome = /^\s*at (.*?) ?\(((?:file|https?|\s*|blob|chrome-extension|native|webpack|ionic|eval|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|ionic|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i,
            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
            lines = ex.stack.split('\n'),
            stack = [],
            parts,
            element,
            reference = /^(.*) is undefined$/.exec(ex.message);

        if (Raygun.Utilities.isReactNative()) {
            var reactNativeDevicePathStripRegex = /^(.*@)?.*\/[^\.]+(\.app|CodePush)\/?(.*)/;
            var sourcemapPrefix = 'file://reactnative.local/';

            for (var i = 0; i < lines.length; i++) {
                parts = reactNativeDevicePathStripRegex.exec(lines[i]);

                if (parts !== null) {
                    var functionName = parts[1] ? parts[1] : 'anonymous@';
                    var filenameLineNumAndColumnNum = parts[3];
                    lines[i] = functionName + sourcemapPrefix + filenameLineNumAndColumnNum;
                }
            }
        }

        for (var i = 0, j = lines.length; i < j; ++i) {
            if ((parts = gecko.exec(lines[i]))) {
                element = {
                    'url': parts[3],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': parts[2] ? parts[2].split(',') : '',
                    'line': +parts[4],
                    'column': parts[5] ? +parts[5] : null
                };
            } else if ((parts = chrome.exec(lines[i]))) {
                element = {
                    'url': parts[2],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'line': +parts[3],
                    'column': parts[4] ? +parts[4] : null
                };
            } else if ((parts = winjs.exec(lines[i]))) {
                element = {
                    'url': parts[2],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'line': +parts[3],
                    'column': parts[4] ? +parts[4] : null
                };
            } else {
                continue;
            }

            if (!element.func && element.line) {
                element.func = guessFunctionName(element.url, element.line);
            }

            if (typeof document !== 'undefined' && element.line) {
                element.context = gatherContext(element.url, element.line);
            }

            stack.push(element);
        }

        if (stack[0] && stack[0].line && !stack[0].column && reference) {
            stack[0].column = findSourceInLine(reference[1], stack[0].url, stack[0].line);
        } else if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
            // Firefox column number
            stack[0].column = ex.columnNumber + 1;
        }

        if (!stack.length) {
            return null;
        }

        var res = {
            'mode': 'stack',
            'name': ex ? ex.name : '',
            'message': ex ? ex.message : '',
            'url': typeof document !== 'undefined' ? document.location.href : '',
            'stack': stack,
            'useragent': navigator ? navigator.userAgent : '',
            'stackstring': ex && ex.stack ? ex.stack.toString() : ''
        };

        return res;
    }

    /**
     * Computes stack trace information from the stacktrace property.
     * Opera 10 uses this property.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceFromStacktraceProp(ex) {
        // Access and store the stacktrace property before doing ANYTHING
        // else to it because Opera is not very good at providing it
        // reliably in other circumstances.
        var stacktrace = ex.stacktrace;

        var testRE = / line (\d+), column (\d+) in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\) in (.*):\s*$/i,
            lines = stacktrace ? stacktrace.split('\n') : [],
            stack = [],
            parts;

        for (var i = 0, j = lines.length; i < j; i += 2) {
            if ((parts = testRE.exec(lines[i]))) {
                var element = {
                    'line': +parts[1],
                    'column': +parts[2],
                    'func': parts[3] || parts[4],
                    'args': parts[5] ? parts[5].split(',') : [],
                    'url': parts[6]
                };

                if (!element.func && element.line) {
                    element.func = guessFunctionName(element.url, element.line);
                }
                if (element.line) {
                    try {
                        element.context = gatherContext(element.url, element.line);
                    } catch (exc) {}
                }

                if (!element.context) {
                    element.context = [lines[i + 1]];
                }

                stack.push(element);
            }
        }

        if (!stack.length) {
            return null;
        }

        return {
            'mode': 'stacktrace',
            'name': ex.name,
            'message': ex.message,
            'url': document.location.href,
            'stack': stack,
            'useragent': navigator.userAgent,
            'stackstring': stacktrace
        };
    }

    /**
     * NOT TESTED.
     * Computes stack trace information from an error message that includes
     * the stack trace.
     * Opera 9 and earlier use this method if the option to show stack
     * traces is turned on in opera:config.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack information.
     */
    function computeStackTraceFromOperaMultiLineMessage(ex) {
        // Opera includes a stack trace into the exception message. An example is:
        //
        // Statement on line 3: Undefined variable: undefinedFunc
        // Backtrace:
        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
        //         undefinedFunc(a);
        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
        //           zzz(x, y, z);
        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
        //           yyy(a, a, a);
        //   Line 1 of function script
        //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
        //   ...

        var lines = ex.message.split('\n');
        if (lines.length < 4) {
            return null;
        }

        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,
            lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,
            lineRE3 = /^\s*Line (\d+) of function script\s*$/i,
            stack = [],
            scripts = document.getElementsByTagName('script'),
            inlineScriptBlocks = [],
            parts,
            i,
            len,
            source;

        for (i in scripts) {
            if (_has(scripts, i) && !scripts[i].src) {
                inlineScriptBlocks.push(scripts[i]);
            }
        }

        for (i = 2, len = lines.length; i < len; i += 2) {
            var item = null;
            if ((parts = lineRE1.exec(lines[i]))) {
                item = {
                    'url': parts[2],
                    'func': parts[3],
                    'line': +parts[1]
                };
            } else if ((parts = lineRE2.exec(lines[i]))) {
                item = {
                    'url': parts[3],
                    'func': parts[4]
                };
                var relativeLine = (+parts[1]); // relative to the start of the <SCRIPT> block
                var script = inlineScriptBlocks[parts[2] - 1];
                if (script) {
                    source = getSource(item.url);
                    if (source) {
                        source = source.join('\n');
                        var pos = source.indexOf(script.innerText);
                        if (pos >= 0) {
                            item.line = relativeLine + source.substring(0, pos).split('\n').length;
                        }
                    }
                }
            } else if ((parts = lineRE3.exec(lines[i]))) {
                var url = window.location.href.replace(/#.*$/, ''),
                    line = parts[1];
                var re = new RegExp(escapeCodeAsRegExpForMatchingInsideHTML(lines[i + 1]));
                source = findSourceInUrls(re, [url]);
                item = {
                    'url': url,
                    'line': source ? source.line : line,
                    'func': ''
                };
            }

            if (item) {
                if (!item.func) {
                    item.func = guessFunctionName(item.url, item.line);
                }
                var context = gatherContext(item.url, item.line);
                var midline = (context ? context[Math.floor(context.length / 2)] : null);
                if (context && midline.replace(/^\s*/, '') === lines[i + 1].replace(/^\s*/, '')) {
                    item.context = context;
                } else {
                    // if (context) alert("Context mismatch. Correct midline:\n" + lines[i+1] + "\n\nMidline:\n" + midline + "\n\nContext:\n" + context.join("\n") + "\n\nURL:\n" + item.url);
                    item.context = [lines[i + 1]];
                }
                stack.push(item);
            }
        }
        if (!stack.length) {
            return null; // could not parse multiline exception message as Opera stack trace
        }

        return {
            'mode': 'multiline',
            'name': ex.name,
            'message': lines[0],
            'url': document.location.href,
            'stack': stack,
            'useragent': navigator.userAgent
        };
    }

    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {Object.<string, *>} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     */
    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            'url': url,
            'line': lineNo
        };

        if (initial.url && initial.line) {
            stackInfo.incomplete = false;

            if (!initial.func) {
                initial.func = guessFunctionName(initial.url, initial.line);
            }

            if (!initial.context) {
                initial.context = gatherContext(initial.url, initial.line);
            }

            var reference = / '([^']+)' /.exec(message);
            if (reference) {
                initial.column = findSourceInLine(reference[1], initial.url, initial.line);
            }

            if (stackInfo.stack.length > 0) {
                if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                        return false; // already in stack trace
                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                        stackInfo.stack[0].line = initial.line;
                        stackInfo.stack[0].context = initial.context;
                        return false;
                    }
                }
            }

            stackInfo.stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        } else {
            stackInfo.incomplete = true;
        }

        return false;
    }

    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
            stack = [],
            funcs = {},
            recursion = false,
            parts,
            item,
            source;

        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
            if (curr === computeStackTrace || curr === TraceKit.report) {
                // console.log('skipping internal function');
                continue;
            }

            item = {
                'url': null,
                'func': UNKNOWN_FUNCTION,
                'line': null,
                'column': null
            };

            if (curr.name) {
                item.func = curr.name;
            } else if ((parts = functionName.exec(curr.toString()))) {
                item.func = parts[1];
            }

            if (typeof item.func === 'undefined') {
              try {
                item.func = parts.input.substring(0, parts.input.indexOf('{'));
              } catch (e) { }
            }

            if ((source = findSourceByFunctionBody(curr))) {
                item.url = source.url;
                item.line = source.line;

                if (item.func === UNKNOWN_FUNCTION) {
                    item.func = guessFunctionName(item.url, item.line);
                }

                var reference = / '([^']+)' /.exec(ex.message || ex.description);
                if (reference) {
                    item.column = findSourceInLine(reference[1], source.url, source.line);
                }
            }

            if (funcs['' + curr]) {
                recursion = true;
            }else {
                funcs['' + curr] = true;
            }

            stack.push(item);
        }

        if (depth) {
            // console.log('depth is ' + depth);
            // console.log('stack is ' + stack.length);
            stack.splice(0, depth);
        }

        var result = {
            'mode': 'callers',
            'name': ex.name,
            'message': ex.message,
            'url': document.location.href,
            'stack': stack,
            'useragent': navigator.userAgent
        };
        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }

    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     */
    function computeStackTrace(ex, depth) {
        var stack = null;
        depth = (depth == null ? 0 : +depth);

        try {
            // This must be tried first because Opera 10 *destroys*
            // its stacktrace property if you try to access the stack
            // property first!!
            stack = computeStackTraceFromStacktraceProp(ex);
            if (stack) {
                return stack;
            }
        } catch (e) {
        }

        try {
            stack = computeStackTraceFromStackProp(ex);
            if (stack) {
                return stack;
            }
        } catch (e) {
        }

        try {
            stack = computeStackTraceFromOperaMultiLineMessage(ex);
            if (stack) {
                return stack;
            }
        } catch (e) {
        }

        try {
            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
            if (stack) {
                return stack;
            }
        } catch (e) {
        }

        return {
            'tracekitResult': 'failedToComputeAnyStackTrace'
        };
    }

    /**
     * Logs a stacktrace starting from the previous call and working down.
     * @param {(number|string)=} depth How many frames deep to trace.
     * @return {Object.<string, *>} Stack trace information.
     */
    function computeStackTraceOfCaller(depth) {
        depth = (depth == null ? 0 : +depth) + 1; // "+ 1" because "ofCaller" should drop one frame
        try {
            throw new Error();
        } catch (ex) {
            return computeStackTrace(ex, depth + 1);
        }
    }

    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
    computeStackTrace.guessFunctionName = guessFunctionName;
    computeStackTrace.gatherContext = gatherContext;
    computeStackTrace.ofCaller = computeStackTraceOfCaller;

    return computeStackTrace;
}());

/**
 * Extends support for global error handling for asynchronous browser
 * functions. Adopted from Closure Library's errorhandler.js
 */
TraceKit.extendToAsynchronousCallbacks = function () {
    var _helper = function _helper(fnName) {
        var originalFn = window[fnName];
        window[fnName] = function traceKitAsyncExtension() {
            // Make a copy of the arguments
            var args = _slice.call(arguments);
            var originalCallback = args[0];
            if (typeof (originalCallback) === 'function') {
                args[0] = TraceKit.wrap(originalCallback);
            }
            // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
            // also only supports 2 argument and doesn't care what "this" is, so we
            // can just call the original function directly.
            if (originalFn.apply) {
                return originalFn.apply(this, args);
            } else {
                return originalFn(args[0], args[1]);
            }
        };
    };

    _helper('setTimeout');
    _helper('setInterval');
};

//Default options:
if (!TraceKit.remoteFetching) {
  TraceKit.remoteFetching = true;
}
if (!TraceKit.collectWindowErrors) {
  TraceKit.collectWindowErrors = true;
}
if (!TraceKit.linesOfContext || TraceKit.linesOfContext < 1) {
  // 5 lines before, the offending line, 5 lines after
  TraceKit.linesOfContext = 11;
}



// Export to global object
window.TraceKit = TraceKit;

}(window));

// Mozilla's toISOString() shim for IE8
if (!Date.prototype.toISOString) {
    (function () {
        function pad(number) {
            var r = String(number);
            if (r.length === 1) {
                r = '0' + r;
            }
            return r;
        }

        Date.prototype.toISOString = function () {
            return this.getUTCFullYear() + '-' + pad(this.getUTCMonth() + 1) + '-' + pad(this.getUTCDate()) + 'T' + pad(this.getUTCHours()) + ':' + pad(this.getUTCMinutes()) + ':' + pad(this.getUTCSeconds()) + '.' + String((this.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5) + 'Z';
        };
    }());
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(searchElement, fromIndex) {
        var k;
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);
        var len = o.length >>> 0;

        if (len === 0) {
            return -1;
        }
        var n = fromIndex | 0;

        if (n >= len) {
            return -1;
        }
        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        while (k < len) {
            if (k in o && o[k] === searchElement) {
                return k;
            }
            k++;
        }
        return -1;
    };
}

// Production steps of ECMA-262, Edition 5, 15.4.4.19
// Reference: http://es5.github.io/#x15.4.4.19
if (!Array.prototype.map) {
    Array.prototype.map = function(callback/*, thisArg*/) {
        var T, A, k;

        if (this == null) {
            throw new TypeError('this is null or not defined');
        }

        var O = Object(this);
        var len = O.length >>> 0;

        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }

        if (arguments.length > 1) {
            T = arguments[1];
        }

        A = new Array(len);
        k = 0;

        while (k < len) {
            var kValue, mappedValue;

            if (k in O) {
                kValue = O[k];

                mappedValue = callback.call(T, kValue, k, O);
                A[k] = mappedValue;
            }
            k++;
        }

        return A;
    };
}

// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(callback/*, thisArg*/) {
        var T, k;

        if (this == null) {
            throw new TypeError('this is null or not defined');
        }

        var O = Object(this);
        var len = O.length >>> 0;

        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }

        if (arguments.length > 1) {
            T = arguments[1];
        }

        k = 0;
        while (k < len) {
            var kValue;

            if (k in O) {
                kValue = O[k];

                callback.call(T, kValue, k, O);
            }
            k++;
        }
    };
}

// Mozilla's bind() shim for IE8
if (!Function.prototype.bind) {
    Function.prototype.bind = function (oThis) {
        if (typeof this !== 'function') {
            throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
        }

        var aArgs = Array.prototype.slice.call(arguments, 1),
            fToBind = this,
            FNOP = function () {
            },
            fBound = function () {
                return fToBind.apply(this instanceof FNOP && oThis ? this : oThis,
                    aArgs.concat(Array.prototype.slice.call(arguments)));
            };

        FNOP.prototype = this.prototype;
        fBound.prototype = new FNOP();

        return fBound;
    };
}

(function traceKitAsyncForjQuery($, TraceKit) {
  // quit if jQuery isn't on the page
  if (!$ || !$.event || !$.event.add) {
    return;
  }

  var _oldEventAdd = $.event.add;
  $.event.add = function traceKitEventAdd(elem, types, handler, data, selector) {
    if (typeof handler !== 'function' && typeof handler.handler !== 'function') {
      return _oldEventAdd.call(this, elem, types, handler, data, selector);
    }

    var _handler;

    if (handler.handler) {
      _handler = handler.handler;
      handler.handler = TraceKit.wrap(handler.handler);
    } else {
      _handler = handler;
      handler = TraceKit.wrap(handler);
    }

    // If the handler we are attaching doesn’t have the same guid as
    // the original, it will never be removed when someone tries to
    // unbind the original function later. Technically as a result of
    // this our guids are no longer globally unique, but whatever, that
    // never hurt anybody RIGHT?!
    if (_handler.guid) {
      handler.guid = _handler.guid;
    } else {
      handler.guid = _handler.guid = $.guid++;
    }

    return _oldEventAdd.call(this, elem, types, handler, data, selector);
  };

  var _oldReady = $.fn.ready;
  $.fn.ready = function traceKitjQueryReadyWrapper(fn) {
    return _oldReady.call(this, TraceKit.wrap(fn));
  };

  var _oldAjax = $.ajax;
  $.ajax = function traceKitAjaxWrapper(url, options) {
    if (typeof url === "object") {
      options = url;
      url = undefined;
    }

    options = options || {};

    var keys = ['complete', 'error', 'success'], key;
    while(key = keys.pop()) {
      if ($.isFunction(options[key])) {
        options[key] = TraceKit.wrap(options[key]);
      }
    }

    try {
      return (url) ? _oldAjax.call(this, url, options) : _oldAjax.call(this, options);
    } catch (e) {
      TraceKit.report(e);
      throw e;
    }
  };

}(window.jQuery, window.TraceKit));

/*globals __DEV__ */

// js-url - see LICENSE file

window.raygunUtilityFactory = function(window, Raygun) {
  var rg = {
    getUuid: function() {
      function _p8(s) {
        var p = (Math.random().toString(16) + '000000000').substr(2, 8);
        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
      }

      return _p8() + _p8(true) + _p8(true) + _p8();
    },

    createCookie: function(name, value, hours, setAsSecure) {
      if (this.isReactNative()) {
        return;
      }

      var expires;
      if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + hours * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
      } else {
        expires = '';
      }

      var secure = setAsSecure ? '; secure' : '';

      document.cookie = name + '=' + value + expires + '; path=/' + secure;
    },

    readCookie: function(name) {
      if (this.isReactNative()) {
        return 'none';
      }

      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }

      return null;
    },

    clearCookie: function(key) {
      if (this.isReactNative()) {
        return;
      }

      this.createCookie(key, '', -1);
    },

    log: function(message, data) {
      if (Raygun.Options._debugMode && window.console && window.console.log) {
        window.console.log(message);

        if (data) {
          window.console.log(data);
        }
      }
    },

    isApiKeyConfigured: function() {
      if (Raygun.Options._raygunApiKey && Raygun.Options._raygunApiKey !== '') {
        return true;
      }
      Raygun.Utilities.log(
        'Raygun API key has not been configured.'
      );
      return false;
    },

    isReactNative: function() {
      return typeof document === 'undefined' && typeof __DEV__ !== 'undefined';
    },

    defaultReactNativeGlobalHandler: function(error, fatal) {
      if (typeof _defaultReactNativeGlobalHandler === 'function') {
        _defaultReactNativeGlobalHandler(error, fatal);
      }
    },

    localStorageAvailable: function() {
      try {
        return 'localStorage' in window && window['localStorage'] !== null;
      } catch (e) {
        return false;
      }
    },

    sessionStorageAvailable: function() {
      try {
        return 'sessionStorage' in window && window['sessionStorage'] !== null;
      } catch(e) {
        return false;
      }
    },

    truncateURL: function(url) {
      // truncate after fourth /, or 24 characters, whichever is shorter
      // /api/1/diagrams/xyz/server becomes
      // /api/1/diagrams/...
      var truncated = url;
      var path = url.split('//')[1];

      if (path) {
        var queryStart = path.indexOf('?');
        var sanitizedPath = path.toString().substring(0, queryStart);
        var truncated_parts = sanitizedPath
          .split('/')
          .slice(0, 4)
          .join('/');
        var truncated_length = sanitizedPath.substring(0, 48);
        truncated =
          truncated_parts.length < truncated_length.length ? truncated_parts : truncated_length;
        if (truncated !== sanitizedPath) {
          truncated += '..';
        }
      }

      return truncated;
    },

    merge: function(o1, o2) {
      var a,
        o3 = {};
      for (a in o1) {
        o3[a] = o1[a];
      }
      for (a in o2) {
        o3[a] = o2[a];
      }
      return o3;
    },

    mergeMutate: function(o1, o2) {
      var a;

      for (a in o2) {
        o1[a] = o2[a];
      }

      return o1;
    },

    mergeArray: function(t0, t1) {
      if (t1 != null) {
        return t0.concat(t1);
      }
      return t0.slice(0);
    },

    forEach: function(set, func) {
      for (var i = 0; i < set.length; i++) {
        func.call(null, i, set[i]);
      }
    },

    isEmpty: function(o) {
      for (var p in o) {
        if (o.hasOwnProperty(p)) {
          return false;
        }
      }
      return true;
    },

    contains: function(array, obj) {
      var i = array.length;
      while (i--) {
        if (array[i] === obj) {
          return true;
        }
      }
      return false;
    },

    getRandomInt: function() {
      return Math.floor(Math.random() * 9007199254740993);
    },

    getViewPort: function() {
      if (this.isReactNative()) {
        return { width: 'Not available', height: 'Not available' };
      }

      var e = document.documentElement,
        g = document.getElementsByTagName('body')[0],
        x = window.innerWidth || e.clientWidth || g.clientWidth,
        y = window.innerHeight || e.clientHeight || g.clientHeight;
      return { width: x, height: y };
    },

    parseUrl: function(arg, url) {
      function isNumeric(arg) {
        return !isNaN(parseFloat(arg)) && isFinite(arg);
      }

      return (function(arg, url) {
        if (typeof document === 'undefined') {
          return '';
        }

        var _ls = url || window.location.toString();

        if (!arg) {
          return _ls;
        } else {
          arg = arg.toString();
        }

        if (_ls.substring(0, 2) === '//') {
          _ls = 'http:' + _ls;
        } else if (_ls.split('://').length === 1) {
          _ls = 'http://' + _ls;
        }

        url = _ls.split('/');
        var _l = { auth: '' },
          host = url[2].split('@');

        if (host.length === 1) {
          host = host[0].split(':');
        } else {
          _l.auth = host[0];
          host = host[1].split(':');
        }

        _l.protocol = url[0];
        _l.hostname = host[0];
        _l.port = host[1] || (_l.protocol.split(':')[0].toLowerCase() === 'https' ? '443' : '80');
        _l.pathname =
          (url.length > 3 ? '/' : '') +
          url
            .slice(3, url.length)
            .join('/')
            .split('?')[0]
            .split('#')[0];
        var _p = _l.pathname;

        if (_p.charAt(_p.length - 1) === '/') {
          _p = _p.substring(0, _p.length - 1);
        }
        var _h = _l.hostname,
          _hs = _h.split('.'),
          _ps = _p.split('/');

        if (arg === 'hostname') {
          return _h;
        } else if (arg === 'domain') {
          if (
            /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(
              _h
            )
          ) {
            return _h;
          }
          return _hs.slice(-2).join('.');
        }
        //else if (arg === 'tld') { return _hs.slice(-1).join('.'); }
        else if (arg === 'sub') {
          return _hs.slice(0, _hs.length - 2).join('.');
        } else if (arg === 'port') {
          return _l.port;
        } else if (arg === 'protocol') {
          return _l.protocol.split(':')[0];
        } else if (arg === 'auth') {
          return _l.auth;
        } else if (arg === 'user') {
          return _l.auth.split(':')[0];
        } else if (arg === 'pass') {
          return _l.auth.split(':')[1] || '';
        } else if (arg === 'path') {
          return _l.pathname;
        } else if (arg.charAt(0) === '.') {
          arg = arg.substring(1);
          if (isNumeric(arg)) {
            arg = parseInt(arg, 10);
            return _hs[arg < 0 ? _hs.length + arg : arg - 1] || '';
          }
        } else if (isNumeric(arg)) {
          arg = parseInt(arg, 10);
          return _ps[arg < 0 ? _ps.length + arg : arg] || '';
        } else if (arg === 'file') {
          return _ps.slice(-1)[0];
        } else if (arg === 'filename') {
          return _ps.slice(-1)[0].split('.')[0];
        } else if (arg === 'fileext') {
          return _ps.slice(-1)[0].split('.')[1] || '';
        } else if (arg.charAt(0) === '?' || arg.charAt(0) === '#') {
          var params = _ls,
            param = null;

          if (arg.charAt(0) === '?') {
            params = (params.split('?')[1] || '').split('#')[0];
          } else if (arg.charAt(0) === '#') {
            params = params.split('#')[1] || '';
          }

          if (!arg.charAt(1)) {
            return params;
          }

          arg = arg.substring(1);
          params = params.split('&');

          for (var i = 0, ii = params.length; i < ii; i++) {
            param = params[i].split('=');
            if (param[0] === arg) {
              return param[1] || '';
            }
          }

          return null;
        }

        return '';
      })(arg, url);
    },
    // Replace existing function on object with new, but call old one afterwards still
    // Returns function that when called will un-enhance object
    enhance: function(object, property, newFunction) {
      var existingFunction = object[property];

      object[property] = function enhanced() {
        newFunction.apply(this, arguments);

        if (typeof existingFunction === 'function') {
          existingFunction.apply(this, arguments);
        }
      };

      return function unenhance() {
        object[property] = existingFunction;
      };
    },
    // Theoretically cross browser event listening
    // Returns function that when called will remove handler
    addEventHandler: function(element, event, handler, useCapture) {
      var capture = useCapture || false;

      if (element.addEventListener) {
        element.addEventListener(event, handler, capture);
      } else if (element.attachEvent) {
        element.attachEvent('on' + event, handler);
      } else {
        element['on' + event] = handler;
      }

      return function() {
        if (element.removeEventListener) {
          element.removeEventListener(event, handler, capture);
        } else if (element.detachEvent) {
          element.detachEvent('on' + event, handler);
        } else {
          element['on' + event] = function() {};
        }
      };
    },
    nodeText: function(node) {
      var text = node.textContent || node.innerText || '';

      if (['submit', 'button'].indexOf(node.type) !== -1) {
        text = node.value || text;
      }

      text = text.replace(/^\s+|\s+$/g, '');

      return text;
    },
    // Returns simple CSS selector to target node
    nodeSelector: function(node) {
      var parts = [node.tagName];

      if (node.id) {
        parts.push('#' + node.id);
      }

      if (node.className && node.className.length) {
        parts.push('.' + node.className.split(' ').join('.'));
      }

      return parts.join('');
    },
    truncate: function(text, length) {
      var omission = '(...)';

      if (text.length > length) {
        return text.slice(0, length - omission.length) + omission;
      } else {
        return text;
      }
    },
    getOrigin: function() {
      if (!window.location.origin) {
        return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
      }

      return window.location.origin;
    },
    resolveFullUrl: function(url) {
      if(url && url.indexOf('//') === 0) {
        url = window.location.protocol + url;
      }

      if (url && window.location.pathname && url.indexOf('://') === -1) {
        var origin = this.getOrigin();

        if (url.indexOf('/') !== 0) {
          var pathname = window.location.pathname;
          var pathComponents = pathname.split('/');
          pathComponents.pop();

          return origin + pathComponents.join('/') + '/' + url;
        } else {
          return origin + url;
        }
      }

      return url;
    },
    removeFromArray: function(array, item) {
      var newArray = [];

      for (var i = 0; i < array.length; i++) {
        if (array[i] !== item) {
          newArray.push(array[i]);
        }
      }

      return newArray;
    },
    isIE: function() {
      return window.navigator.userAgent.indexOf('Trident') > -1 || window.navigator.userAgent.indexOf('MSIE') > -1;
    }
  };

  var _defaultReactNativeGlobalHandler;
  if (
    rg.isReactNative() &&
    __DEV__ !== true &&
    window.ErrorUtils &&
    window.ErrorUtils.getGlobalHandler
  ) {
    _defaultReactNativeGlobalHandler = window.ErrorUtils.getGlobalHandler();
  }

  return rg;
};

/*
 * raygun4js
 * https://github.com/MindscapeHQ/raygun4js
 *
 * Copyright (c) 2017 MindscapeHQ
 * Licensed under the MIT license.
 */

window.raygunNetworkTrackingFactory = function(window, Raygun) {
  var NetworkTracking = function() {
    this.requestHandlers = [];
    this.responseHandlers = [];
    this.errorHandlers = [];

    this.wrapWithHandler = function(method) {
      return function() {
        try {
          return method.apply(this, arguments);
        } catch (ex) {
          Raygun.Utilities.log(ex);
        }
      };
    };

    this.executeHandlers = this.wrapWithHandler(function(handlers, data) {
      for (var i = 0; i < handlers.length; i++) {
        handlers[i](JSON.parse(JSON.stringify(data)));
      }
    });

    this.wrapPrototypeWithHandlers();

    this.attach();
  };

  NetworkTracking.prototype.on = function(type, handler) {
    switch (type) {
      case 'request':
        this.requestHandlers.push(handler);
        break;
      case 'response':
        this.responseHandlers.push(handler);
        break;
      case 'error':
        this.errorHandlers.push(handler);
        break;
    }
  };

  NetworkTracking.prototype.off = function(type, handler) {
    switch (type) {
      case 'request':
        this.requestHandlers = Raygun.Utilities.removeFromArray(this.requestHandlers, handler);
        break;
      case 'response':
        this.responseHandlers = Raygun.Utilities.removeFromArray(this.responseHandlers, handler);
        break;
      case 'error':
        this.errorHandlers = Raygun.Utilities.removeFromArray(this.errorHandlers, handler);
        break;
    }
  };

  NetworkTracking.prototype.attach = function() {
    var self = this;

    if (window.XMLHttpRequest.prototype.addEventListener) {
      Raygun.Utilities.enhance(
        window.XMLHttpRequest.prototype,
        'open',
        self.wrapWithHandler(function() {
          var initTime = new Date().getTime();
          var url = Raygun.Utilities.resolveFullUrl(arguments[1]) || 'Unknown';
          var baseUrl = url.split('?')[0];
          var method = arguments[0];

          Raygun.Utilities.enhance(
            this,
            'send',
            self.wrapWithHandler(function() {
              var metadata = {
                method: method,
                requestURL: url,
                baseUrl: baseUrl,
              };

              if (arguments[0] && typeof arguments[0] === 'string') {
                metadata.body = arguments[0];
              }

              self.executeHandlers(self.requestHandlers, metadata);
            })
          );

          this.addEventListener(
            'load',
            self.wrapWithHandler(function() {
              var body = 'N/A for non text responses';

              if (this.responseType === '' || this.responseType === 'text') {
                body = this.responseText;
              }

              Raygun.Utilities.log('Tracking XHR response for', url);
              self.executeHandlers(self.responseHandlers, {
                status: this.status,
                requestURL: url,
                responseURL: this.responseURL,
                baseUrl: baseUrl,
                body: body,
                duration: new Date().getTime() - initTime,
              });
            })
          );

          this.addEventListener(
            'error',
            self.wrapWithHandler(function() {
              self.executeHandlers(self.errorHandlers, {
                requestURL: url,
                responseURL: this.responseURL,
                duration: new Date().getTime() - initTime,
              });
            })
          );
        })
      );
    }
    
    /**
     * Two window objects can be defined inside the installation code snippets that users inject into their page when using Raygun4JS.
     * These are used to intercept the original fetch method before a reference to it can be made.
     * Because if a stored reference to the fetch method is made, we cannot get the status code from that point onwards. 
     * 
     * window.__raygunOriginalFetch - the window.fetch method as of when the code snippet was executed
     * window.__raygunFetchCallback - a callback which is executed when the code snippet fetch method is called 
     */
    var originalFetch = window.__raygunOriginalFetch || window.fetch;

    // If fetch has been polyfilled we don't want to hook into it as it then uses XMLHttpRequest
    // This results in doubled up breadcrumbs
    // Can't reliably detect when it has been polyfilled but no IE version supports fetch
    // So if this is IE, don't hook into fetch
    if (typeof originalFetch === 'function' && typeof originalFetch.polyfill === 'undefined' && !Raygun.Utilities.isIE()) {

      
      var processFetch = function() {
        var fetchInput = arguments[0];
        var url, baseUrl;
        var options = arguments[1];
        var method = (options && options.method) || 'GET';
        var initTime = new Date().getTime();

        if (typeof fetchInput === 'string') {
          url = fetchInput;
        } else if (typeof window.Request !== 'undefined' && fetchInput instanceof window.Request) {
          url = fetchInput.url;

          if (fetchInput.method) {
            method = fetchInput.method;
          }
        } else {
          url = String(fetchInput);
        }
        url = Raygun.Utilities.resolveFullUrl(url);
        baseUrl = url.split('?')[0];

        var promise = originalFetch.apply(null, arguments);

        try {
          var metadata = {
            method: method,
            requestURL: url,
            baseUrl: baseUrl,
          };

          if (options && options.body) {
            metadata.body = options.body;
          }

          self.executeHandlers(self.requestHandlers, metadata);

          promise.then(
            self.wrapWithHandler(function(response) {
              var body = 'N/A when the fetch response does not support clone()';
              var ourResponse = typeof response.clone === 'function' ? response.clone() : undefined;

              function executeHandlers() {
                Raygun.Utilities.log('tracking fetch response for', url);
                self.executeHandlers(self.responseHandlers, {
                  status: response.status,
                  requestURL: url,
                  responseURL: response.url,
                  body: body,
                  baseUrl: baseUrl,
                  duration: new Date().getTime() - initTime,
                });
              }

              if (ourResponse) {
                try {
                  ourResponse.text().then(function(text) {
                    body = Raygun.Utilities.truncate(text, 500);

                    executeHandlers();
                  }).catch(function() { executeHandlers(); });
                } catch(_e) {
                  executeHandlers();
                }
              } else {
                executeHandlers();
              }
            })
          );

          promise.catch(
            self.wrapWithHandler(function(error) {
              self.executeHandlers(self.errorHandlers, {
                metadata: {
                  requestUrl: url,
                  error: error.toString(),
                  duration: new Date().getTime() - initTime,
                },
              });
            })
          );
        } catch (e) {
          Raygun.Utilities.log(e);
        }

        return promise;
      };

      if(!!window.__raygunOriginalFetch) {
        window.__raygunFetchCallback = processFetch;
      } else {
        window.fetch = processFetch;
      }
    }
  };

  NetworkTracking.prototype.wrapPrototypeWithHandlers = function() {
    var name, method;
    for (name in NetworkTracking.prototype) {
      method = NetworkTracking.prototype[name];
      if (typeof method === 'function') {
        NetworkTracking.prototype[name] = this.wrapWithHandler(method);
      }
    }
  };

  return new NetworkTracking();
};

/*
 * raygun4js
 * https://github.com/MindscapeHQ/raygun4js
 *
 * Copyright (c) 2017 MindscapeHQ
 * Licensed under the MIT license.
 */
/* globals console */

window.raygunBreadcrumbsFactory = function(window, Raygun) {
  function urlMatchesIgnoredHosts(url, ignoredHosts) {
    for (var i = 0; i < ignoredHosts.length; i++) {
      var host = ignoredHosts[i];

      if (typeof host === 'string' && url && url.indexOf(host) > -1) {
        return true;
      } else if (typeof host === 'object' && host.exec(url)) {
        return true;
      }
    }

    return false;
  }

  var Breadcrumbs = function() {
    this.MAX_BREADCRUMBS = 32;
    this.MAX_MESSAGE_SIZE = 1024;
    this.BREADCRUMB_LEVELS = ['debug', 'info', 'warning', 'error'];
    this.DEFAULT_BREADCRUMB_LEVEL = 'info';
    this.DEFAULT_XHR_IGNORED_HOSTS = ['raygun'];

    this.breadcrumbLevel = 'info';
    this.logXhrContents = false;
    this.xhrIgnoredHosts = [].concat(this.DEFAULT_XHR_IGNORED_HOSTS);
    this.breadcrumbs = [];
    this.wrapWithHandler = function(method) {
      return function() {
        try {
          return method.apply(this, arguments);
        } catch (ex) {
          Raygun.Utilities.log(ex);
        }
      };
    };

    this.disableConsoleFunctions = [];
    this.disableNavigationFunctions = [];
    this.disableXHRLogging = function() {};
    this.disableClicksTracking = function() {};

    this.enableAutoBreadcrumbs();
    this.wrapPrototypeWithHandlers();
  };

  Breadcrumbs.prototype.recordBreadcrumb = function(value, metadata) {
    var crumb = {
      level: this.DEFAULT_BREADCRUMB_LEVEL,
      timestamp: new Date().getTime(),
      type: 'manual',
    };

    switch (typeof value) {
      case 'object':
        crumb = Raygun.Utilities.merge(crumb, value);
        break;
      case 'string':
        crumb = Raygun.Utilities.merge(
          Raygun.Utilities.merge(crumb, {
            message: value,
            metadata: metadata,
          })
        );
        break;
      default:
        Raygun.Utilities.log(
          "expected first argument to recordBreadcrumb to be a 'string' or 'object', got " +
            typeof value
        );
        return;
    }

    if (this.BREADCRUMB_LEVELS.indexOf(crumb.level) === -1) {
      Raygun.Utilities.log(
        'unknown breadcrumb level ' +
          crumb.level +
          " setting to default of '" +
          this.DEFAULT_BREADCRUMB_LEVEL +
          "'"
      );
      crumb.level = this.DEFAULT_BREADCRUMB_LEVEL;
    }

    if (this.shouldRecord(crumb)) {
      crumb.message = Raygun.Utilities.truncate(crumb.message, this.MAX_MESSAGE_SIZE);

      this.breadcrumbs.push(crumb);
      this.breadcrumbs = this.breadcrumbs.slice(-this.MAX_BREADCRUMBS);
    }
  };

  Breadcrumbs.prototype.shouldRecord = function(crumb) {
    var crumbLevel = this.BREADCRUMB_LEVELS.indexOf(crumb.level);
    var activeLevel = this.BREADCRUMB_LEVELS.indexOf(this.breadcrumbLevel);

    return crumbLevel >= activeLevel;
  };

  Breadcrumbs.prototype.setBreadcrumbLevel = function(level) {
    if (this.BREADCRUMB_LEVELS.indexOf(level) === -1) {
      Raygun.Utilities.log(
        "Breadcrumb level of '" +
          level +
          "' is invalid, setting to default of '" +
          this.DEFAULT_BREADCRUMB_LEVEL +
          "'"
      );

      return;
    }

    this.breadcrumbLevel = level;
  };

  Breadcrumbs.prototype.setOption = function(option, value) {
    if (option === 'breadcrumbsLevel') {
      this.setBreadcrumbLevel(value);
    } else if (option === 'xhrIgnoredHosts') {
      this.xhrIgnoredHosts = value.concat(this.DEFAULT_XHR_IGNORED_HOSTS);

      var self = this;
      this.removeBreadcrumbsWithPredicate(function(crumb) {
        if (crumb.type !== 'request') {
          return false;
        }

        return urlMatchesIgnoredHosts(
          crumb.metadata.requestURL || crumb.metadata.responseURL,
          self.xhrIgnoredHosts
        );
      });
    } else if (option === 'logXhrContents') {
      this.logXhrContents = value;
    }
  };

  Breadcrumbs.prototype.any = function() {
    return this.breadcrumbs.length > 0;
  };

  Breadcrumbs.prototype.all = function() {
    var sanitizedBreadcrumbs = [];

    for (var i = 0; i < this.breadcrumbs.length; i++) {
      var crumb = this.breadcrumbs[i];

      if (crumb && crumb.type === 'request' && !this.logXhrContents) {
        if (crumb.metadata && crumb.metadata.body) {
          crumb.metadata.body = 'Disabled because logContentsOfXhrCalls has not been enabled';
        }
      }

      sanitizedBreadcrumbs.push(crumb);
    }

    return sanitizedBreadcrumbs;
  };

  Breadcrumbs.prototype.enableAutoBreadcrumbs = function() {
    this.enableAutoBreadcrumbsXHR();
    this.enableAutoBreadcrumbsClicks();
    this.enableAutoBreadcrumbsConsole();
    this.enableAutoBreadcrumbsNavigation();
  };

  Breadcrumbs.prototype.disableAutoBreadcrumbs = function() {
    this.disableAutoBreadcrumbsXHR();
    this.disableAutoBreadcrumbsClicks();
    this.disableAutoBreadcrumbsConsole();
    this.disableAutoBreadcrumbsNavigation();
  };

  Breadcrumbs.prototype.removeBreadcrumbsWithPredicate = function(predicate) {
    var crumbs = this.breadcrumbs;
    var filteredCrumbs = [];

    for (var i = 0; i < crumbs.length; i++) {
      var crumb = crumbs[i];

      if (!predicate(crumb)) {
        filteredCrumbs.push(crumb);
      }
    }

    this.breadcrumbs = filteredCrumbs;
  };

  Breadcrumbs.prototype.removeCrumbsOfType = function(type) {
    this.removeBreadcrumbsWithPredicate(function(crumb) {
      return crumb.type === type;
    });
  };

  Breadcrumbs.prototype.enableAutoBreadcrumbsConsole = function() {
    if (typeof window.console === 'undefined') {
      return;
    }

    var logConsoleCall = function logConsoleCall(severity, args) {
      var stringifiedArgs = [];

      for (var i = 0; i < args.length; i++) {
        var arg = args[i];
        if (arg === null || arg === undefined) {
          continue;
        }

        stringifiedArgs.push(arg.toString());
      }

      this.recordBreadcrumb({
        type: 'console',
        level: severity,
        message: Array.prototype.slice.call(stringifiedArgs).join(', '),
      });
    }.bind(this);

    var consoleProperties = ['log', 'warn', 'error'];
    var self = this;
    this.disableConsoleFunctions = consoleProperties.map(function(property) {
      return Raygun.Utilities.enhance(
        console,
        property,
        self.wrapWithHandler(function() {
          var severity = property === 'log' ? 'info' : property === 'warn' ? 'warning' : 'error';

          logConsoleCall(severity, arguments);
        })
      );
    });
  };

  Breadcrumbs.prototype.disableAutoBreadcrumbsConsole = function() {
    this.disableConsoleFunctions.forEach(function(unenhance) {
      unenhance();
    });
    this.removeCrumbsOfType('console');
  };

  Breadcrumbs.prototype.enableAutoBreadcrumbsNavigation = function() {
    if (!window.addEventListener || !window.history || !window.history.pushState) {
      return;
    }

    var buildStateChange = function(name, state, title, url) {
      var currentPath = location.pathname + location.search + location.hash;
      var prevState = null;

      if (window.history.state) {
        prevState = history.state;
      }

      return {
        message: 'History ' + name,
        type: 'navigation',
        level: 'info',
        metadata: {
          from: currentPath,
          to: url || currentPath,
          prevState: JSON.stringify(prevState) || 'unsupported',
          nextState: JSON.stringify(state),
        },
      };
    }.bind(this);

    var parseHash = function(url) {
      return url.split('#')[1] || '';
    };

    var historyFunctionsToEnhance = ['pushState', 'replaceState'];
    this.disableNavigationFunctions = this.disableNavigationFunctions.concat(
      historyFunctionsToEnhance.map(
        function(stateChange) {
          return Raygun.Utilities.enhance(
            history,
            stateChange,
            this.wrapWithHandler(
              function(state, title, url) {
                this.recordBreadcrumb(buildStateChange(stateChange, state, title, url));
              }.bind(this)
            )
          );
        }.bind(this)
      )
    );

    var buildHashChange = function(e) {
      var oldURL = e.oldURL;
      var newURL = e.newURL;
      var metadata;

      if (oldURL && newURL) {
        metadata = {
          from: parseHash(oldURL),
          to: parseHash(newURL),
        };
      } else {
        metadata = {
          to: location.hash,
        };
      }

      return {
        type: 'navigation',
        message: 'Hash change',
        metadata: metadata,
      };
    };

    var logBreadcrumbWrapper = function(handler) {
      return this.wrapWithHandler(
        function() {
          this.recordBreadcrumb(handler.apply(null, arguments));
        }.bind(this)
      );
    }.bind(this);
    var eventsWithHandlers = [
      { element: window, event: 'hashchange', handler: buildHashChange },
      {
        element: window,
        event: 'load',
        handler: function() {
          return { type: 'navigation', message: 'Page loaded' };
        },
      },
      {
        element: window,
        event: 'popstate',
        handler: function() {
          return { type: 'navigation', message: 'Navigated back' };
        },
      },
      {
        element: window,
        event: 'pagehide',
        handler: function() {
          return { type: 'navigation', message: 'Page hidden' };
        },
      },
      {
        element: window,
        event: 'pageshow',
        handler: function() {
          return { type: 'navigation', message: 'Page shown' };
        },
      },
      {
        element: document,
        event: 'DOMContentLoaded',
        handler: function() {
          return { type: 'navigation', message: 'DOMContentLoaded' };
        },
      },
    ];

    this.disableNavigationFunctions = this.disableNavigationFunctions.concat(
      eventsWithHandlers.map(
        function(mapping) {
          return Raygun.Utilities.addEventHandler(
            mapping.element,
            mapping.event,
            logBreadcrumbWrapper(mapping.handler)
          );
        }.bind(this)
      )
    );
  };

  Breadcrumbs.prototype.disableAutoBreadcrumbsNavigation = function() {
    this.disableNavigationFunctions.forEach(function(unenhance) {
      unenhance();
    });
    this.disableNavigationFunctions = [];

    this.removeCrumbsOfType('navigation');
  };

  Breadcrumbs.prototype.enableAutoBreadcrumbsClicks = function() {
    this.disableClicksTracking = Raygun.Utilities.addEventHandler(
      window,
      'click',
      this.wrapWithHandler(
        function(e) {
          var text, selector;

          try {
            text = Raygun.Utilities.truncate(Raygun.Utilities.nodeText(e.target), 150);
            selector = Raygun.Utilities.nodeSelector(e.target);
          } catch (exception) {
            text = '[unknown]';
            selector = '[unknown]';

            Raygun.Utilities.log(
              'Error retrieving node text/selector. Most likely due to a cross domain error'
            );
          }

          this.recordBreadcrumb({
            type: 'click-event',
            message: 'UI Click',
            level: 'info',
            metadata: {
              text: text,
              selector: selector,
            },
          });
        }.bind(this),
        true
      )
    );
  };

  Breadcrumbs.prototype.disableAutoBreadcrumbsClicks = function() {
    this.disableClicksTracking();
    this.removeCrumbsOfType('click-event');
  };

  Breadcrumbs.prototype.enableAutoBreadcrumbsXHR = function() {
    var self = this;

    var requestHandler = self.wrapWithHandler(function(request) {
      if (urlMatchesIgnoredHosts(request.requestURL, self.xhrIgnoredHosts)) {
        return;
      }

      if (request.body) {
        request.body = Raygun.Utilities.truncate(request.body, 500);
      }

      self.recordBreadcrumb({
        type: 'request',
        message: 'Opening request to ' + request.requestURL,
        level: 'info',
        metadata: request,
      });
    });
    var responseHandler = self.wrapWithHandler(function(response) {
      if (
        urlMatchesIgnoredHosts(response.requestURL, self.xhrIgnoredHosts) ||
        urlMatchesIgnoredHosts(response.responseURL, self.xhrIgnoredHosts)
      ) {
        return;
      }

      if (response.body) {
        response.body = Raygun.Utilities.truncate(response.body, 500);
      }

      response.duration = response.duration + 'ms';
      self.recordBreadcrumb({
        type: 'request',
        message: 'Finished request to ' + response.requestURL,
        level: 'info',
        metadata: response,
      });
    });
    var errorHandler = self.wrapWithHandler(function(error) {
      if (urlMatchesIgnoredHosts(error.requestURL, self.xhrIgnoredHosts)) {
        return;
      }

      error.duration = error.duration + 'ms';
      self.recordBreadcrumb({
        type: 'request',
        message: 'Failed request to ' + error.requestUrl,
        level: 'info',
        metadata: error,
      });
    });

    Raygun.NetworkTracking.on('request', requestHandler);
    Raygun.NetworkTracking.on('response', responseHandler);
    Raygun.NetworkTracking.on('error', errorHandler);

    this.disableXHRLogging = function() {
      Raygun.NetworkTracking.off('request', requestHandler);
      Raygun.NetworkTracking.off('response', responseHandler);
      Raygun.NetworkTracking.off('error', errorHandler);
    };
  };

  Breadcrumbs.prototype.disableAutoBreadcrumbsXHR = function() {
    this.disableXHRLogging();
    this.removeCrumbsOfType('request');
  };

  Breadcrumbs.prototype.wrapPrototypeWithHandlers = function() {
    var name, method;
    for (name in Breadcrumbs.prototype) {
      method = Breadcrumbs.prototype[name];
      if (typeof method === 'function') {
        Breadcrumbs.prototype[name] = this.wrapWithHandler(method);
      }
    }
  };

  return Breadcrumbs;
};

/*
 * raygun4js
 * https://github.com/MindscapeHQ/raygun4js
 *
 * Copyright (c) 2013-2018 Raygun Limited
 * Licensed under the MIT license.
 */

/*globals __DEV__, raygunUtilityFactory, raygunBreadcrumbsFactory, raygunNetworkTrackingFactory */

var raygunFactory = function(window, $, undefined$1) {
  var Raygun = {};
  Raygun.Utilities = raygunUtilityFactory(window, Raygun);
  Raygun.NetworkTracking = raygunNetworkTrackingFactory(window, Raygun);
  Raygun.Breadcrumbs = raygunBreadcrumbsFactory(window, Raygun);

  // Constants
  var ProviderStates = {
    LOADING: 0,
    READY: 1,
  };

  var _userKey = 'raygun4js-userid';

  // State variables
  var _traceKit = TraceKit,
    _raygun = window.Raygun,
    _debugMode = false,
    _allowInsecureSubmissions = false,
    _ignoreAjaxAbort = false,
    _ignoreAjaxError = false,
    _enableOfflineSave = false,
    _ignore3rdPartyErrors = false,
    _disableAnonymousUserTracking = false,
    _disableErrorTracking = false,
    _disablePulse = true,
    _wrapAsynchronousCallbacks = false,
    _automaticPerformanceCustomTimings = false,
    _customData = {},
    _tags = [],
    _user,
    _version,
    _filteredKeys,
    _whitelistedScriptDomains = [],
    _beforeSendCallback,
    _beforeSendRumCallback,
    _groupingKeyCallback,
    _beforeXHRCallback,
    _afterSendCallback,
    _raygunApiUrl = 'https://api.raygun.io',
    _excludedHostnames = null,
    _excludedUserAgents = null,
    _filterScope = 'customData',
    _rum = null,
    _breadcrumbs = new Raygun.Breadcrumbs(),
    _pulseMaxVirtualPageDuration = null,
    _pulseIgnoreUrlCasing = true,
    _providerState = ProviderStates.LOADING,
    _loadedFrom,
    _processExceptionQueue = [],
    _trackEventQueue = [],
    _pulseCustomLoadTimeEnabled = null,
    $document,
    _captureUnhandledRejections = true,
    _setCookieAsSecure = false,
    _clientIp,
    _captureMissingRequests = false,
    detachPromiseRejectionFunction;

  var rand = Math.random();
  var _publicRaygunFunctions = {
    Rand: rand,
    Options: {},

    noConflict: function() {
      // Because _raygun potentially gets set before other code sets window.Raygun
      // this will potentially overwrite the new Raygun object with undefined
      // Not really much point in restoring undefined so just don't do that
      if (_raygun) {
        window.Raygun = _raygun;
      }
      return Raygun;
    },

    constructNewRaygun: function() {
      var rgInstance = raygunFactory(window, window.jQuery);

      return rgInstance;
    },

    init: function(key, options, customdata) {
      _traceKit.remoteFetching = false;

      this.Options._raygunApiKey = key;

      if (customdata) {
        _customData = customdata;
      }

      if ($) {
        $document = $(document);
      }

      if (options) {
        _allowInsecureSubmissions = options.allowInsecureSubmissions || false;
        _ignoreAjaxAbort = options.ignoreAjaxAbort || false;
        _ignoreAjaxError = options.ignoreAjaxError || false;
        _disableAnonymousUserTracking = options.disableAnonymousUserTracking || false;
        _disableErrorTracking = options.disableErrorTracking || false;
        _disablePulse = options.disablePulse === undefined$1 ? true : options.disablePulse;
        _excludedHostnames = options.excludedHostnames || false;
        _excludedUserAgents = options.excludedUserAgents || false;
        _pulseMaxVirtualPageDuration = options.pulseMaxVirtualPageDuration || null;
        _pulseIgnoreUrlCasing = options.pulseIgnoreUrlCasing || false;
        _pulseCustomLoadTimeEnabled = options.pulseCustomLoadTimeEnabled || false;
        _setCookieAsSecure = options.setCookieAsSecure || false;
        _captureMissingRequests = options.captureMissingRequests || false;
        _automaticPerformanceCustomTimings = options.automaticPerformanceCustomTimings || false;

        if (options.apiUrl) {
          _raygunApiUrl = options.apiUrl;
        }

        if (typeof options.wrapAsynchronousCallbacks !== 'undefined') {
          _wrapAsynchronousCallbacks = options.wrapAsynchronousCallbacks;
        }

        if (typeof options.captureUnhandledRejections !== 'undefined') {
          _captureUnhandledRejections = options.captureUnhandledRejections;
        }

        if (options.debugMode) {
          _debugMode = options.debugMode;
        }
        this.Options._debugMode = _debugMode;

        if (options.ignore3rdPartyErrors) {
          _ignore3rdPartyErrors = true;
        }

        if (options.apiEndpoint) {
          _raygunApiUrl = options.apiEndpoint;
        }

        if (options.from) {
          _loadedFrom = options.from;
        }

        if(options.clientIp) {
          _clientIp = options.clientIp;
        }        
      }

      ensureUser();

      return Raygun;
    },

    withCustomData: function(customdata) {
      _customData = customdata;
      return Raygun;
    },

    withTags: function(tags) {
      _tags = tags;

      if (_rum !== undefined$1 && _rum !== null) {
        _rum.withTags(tags);
      }

      return Raygun;
    },

    attach: function() {
      if (!Raygun.Utilities.isApiKeyConfigured() || _disableErrorTracking) {
        return Raygun;
      }

      if (window.RaygunObject && window[window.RaygunObject] && window[window.RaygunObject].q) {
        window.onerror = null;
      }

      if (_captureUnhandledRejections) {
        attachPromiseRejectionHandler();
      }

      // Attach React Native's handler in Release mode
      if (Raygun.Utilities.isReactNative()) {
        if (__DEV__ !== true && window.ErrorUtils && window.ErrorUtils.setGlobalHandler) {
          window.ErrorUtils.setGlobalHandler(function(error, fatal) {
            // Calling the defaultReactNativeGlobalHandler in release mode instantly closes the application
            // If an exception is currently being sent it will be lost, this sets our own afterSendCallback
            // to notify us when the error is done sending so we can call the default handler
            var originalAfterSendCallback = _afterSendCallback;
            _afterSendCallback = function() {
              if (typeof originalAfterSendCallback === 'function') {
                originalAfterSendCallback();
              }

              Raygun.Utilities.defaultReactNativeGlobalHandler(error, fatal);
              _afterSendCallback = originalAfterSendCallback;
            };

            TraceKit.report(error);
          });
        }
      }

      _traceKit.report.subscribe(processException);

      if (_wrapAsynchronousCallbacks) {
        _traceKit.extendToAsynchronousCallbacks();
      }

      if ($document && $document.ajaxError && !_ignoreAjaxError) {
        $document.ajaxError(processJQueryAjaxError);
      }
      return Raygun;
    },

    detach: function() {
      _traceKit.report.unsubscribe(processException);
      if ($document) {
        $document.unbind('ajaxError', processJQueryAjaxError);
      }
      if (_captureUnhandledRejections) {
        detachPromiseRejectionHandler();
      }
      return Raygun;
    },

    send: function(ex, customData, tags) {
      if (_disableErrorTracking) {
        Raygun.Utilities.log('Error not sent due to disabled error tracking');
        return Raygun;
      }

      try {
        processException(
          _traceKit.computeStackTrace(ex),
          {
            customData:
              typeof _customData === 'function'
                ? Raygun.Utilities.merge(_customData(), customData)
                : Raygun.Utilities.merge(_customData, customData),
            tags:
              typeof _tags === 'function'
                ? Raygun.Utilities.mergeArray(_tags(), tags)
                : Raygun.Utilities.mergeArray(_tags, tags),
          },
          true,
          ex
        );
      } catch (traceKitException) {
        if (ex !== traceKitException) {
          throw traceKitException;
        }
      }
      return Raygun;
    },

    setUser: function(user, isAnonymous, email, fullName, firstName, uuid) {
      _user = {
        Identifier: user,
      };
      if (typeof isAnonymous === 'boolean') {
        _user['IsAnonymous'] = isAnonymous;
      }
      if (email) {
        _user['Email'] = email;
      }
      if (fullName) {
        _user['FullName'] = fullName;
      }
      if (firstName) {
        _user['FirstName'] = firstName;
      }
      if (uuid) {
        _user['UUID'] = uuid;
      }

      if (_rum !== undefined$1 && _rum !== null) {
        _rum.setUser(_user);
      }

      return Raygun;
    },

    resetAnonymousUser: function() {
      clearStorage();
    },

    setVersion: function(version) {
      _version = version;
      return Raygun;
    },

    saveIfOffline: function(enableOffline) {
      if (typeof enableOffline !== 'undefined' && typeof enableOffline === 'boolean') {
        _enableOfflineSave = enableOffline;
      }

      return Raygun;
    },

    filterSensitiveData: function(filteredKeys) {
      _filteredKeys = filteredKeys;
      return Raygun;
    },

    setFilterScope: function(scope) {
      if (scope === 'customData' || scope === 'all') {
        _filterScope = scope;
      }
      return Raygun;
    },

    whitelistCrossOriginDomains: function(whitelist) {
      _whitelistedScriptDomains = whitelist;
      return Raygun;
    },

    onBeforeSend: function(callback) {
      _beforeSendCallback = callback;
      return Raygun;
    },

    onBeforeSendRum: function(callback) {
      _beforeSendRumCallback = callback;
      return Raygun;
    },

    groupingKey: function(callback) {
      _groupingKeyCallback = callback;
      return Raygun;
    },

    onBeforeXHR: function(callback) {
      _beforeXHRCallback = callback;
      return Raygun;
    },

    onAfterSend: function(callback) {
      _afterSendCallback = callback;
      return Raygun;
    },

    // Public Pulse functions

    endSession: function() {
      if (Raygun.RealUserMonitoring !== undefined$1 && _rum) {
        _rum.endSession();
      }
    },

    trackEvent: function(type, options) {
      if (_providerState !== ProviderStates.READY) {
        _trackEventQueue.push({ type: type, options: options });
        return;
      }

      if (Raygun.RealUserMonitoring !== undefined$1 && _rum) {
        if (type === 'pageView' && options.path) {
          _rum.virtualPageLoaded(options.path);
        } else if (type === 'customTiming') {
          _rum.trackCustomTiming(options.name, options.duration, options.offset);
        } else if (type === 'customTimings' && options.timings) {
          _rum.sendCustomTimings(options.timings);
        } 
      }
    },

    setClientIp: function(ip) {
      _clientIp = ip;
    },
    captureMissingRequests: function(val) {
      if (Raygun.RealUserMonitoring !== undefined$1 && _rum) {
        _rum.captureMissingRequests(val);
      }
    },
    recordBreadcrumb: function() {
      _breadcrumbs.recordBreadcrumb.apply(_breadcrumbs, arguments);
    },
    enableAutoBreadcrumbs: function(type) {
      if (type) {
        _breadcrumbs['enableAutoBreadcrumbs' + type]();
      } else {
        _breadcrumbs.enableAutoBreadcrumbs();
      }
    },
    disableAutoBreadcrumbs: function(type) {
      if (type) {
        _breadcrumbs['disableAutoBreadcrumbs' + type]();
      } else {
        _breadcrumbs.disableAutoBreadcrumbs();
      }
    },
    setBreadcrumbOption: function(option, value) {
      _breadcrumbs.setOption(option, value);
    },
    setBreadcrumbs: function(breadcrumbs) {
      _breadcrumbs = breadcrumbs;
    },
    getBreadcrumbs: function() {
      return _breadcrumbs.all();
    },
  };

  Raygun = Raygun.Utilities.mergeMutate(Raygun, _publicRaygunFunctions);

  function callAfterSend(response) {
    if (typeof _afterSendCallback === 'function') {
      _afterSendCallback(response);
    }
  }

  function ensureUser() {
    if (!_user && !_disableAnonymousUserTracking) {
      getFromStorage(setUserComplete);
    } else {
      bootRaygun();
    }
  }

  function setUserComplete(userId) {
    var userIdentifier = "Unknown";

    if (!userId) {
      userIdentifier = Raygun.Utilities.getUuid();
      saveToStorage(userIdentifier);
    } else {
      userIdentifier = userId;
    }

    Raygun.setUser(userIdentifier, true, null, null, null, userIdentifier);

    bootRaygun();
  }

  // Callback for `unhandledrejection` event.
  function promiseRejectionHandler(event) {
    var error = event.reason;
    if (!error && event.detail && event.detail.reason) {
      error = event.detail.reason;
    }
    if (!(error instanceof Error) && event.reason && event.reason.error) {
      error = event.reason.error;
    }
    if (!error) {
      error = event;
    }
    _publicRaygunFunctions.send(error, null, ['UnhandledPromiseRejection']);
  }

  // Install global promise rejection handler.
  function attachPromiseRejectionHandler() {
    detachPromiseRejectionFunction = Raygun.Utilities.addEventHandler(
      window,
      'unhandledrejection',
      promiseRejectionHandler
    );
  }

  // Uninstall global promise rejection handler.
  function detachPromiseRejectionHandler() {
    if (detachPromiseRejectionFunction) {
      detachPromiseRejectionFunction();
    }
  }

  // The final initializing logic is provided as a callback due to async storage methods for user data in React Native
  // The common case executes it immediately due to that data being provided by the cookie synchronously
  // The case when Affected User Tracking is enabled calls this function when the code sets the user data
  function bootRaygun() {
    if (_providerState === ProviderStates.READY) {
      return;
    }

    _providerState = ProviderStates.READY;

    if (Raygun.RealUserMonitoring !== undefined$1 && !_disablePulse) {
      var startRum = function() {
        _rum = new Raygun.RealUserMonitoring(
          Raygun.Options._raygunApiKey,
          _raygunApiUrl,
          makePostCorsRequest,
          _user,
          _version,
          _tags,
          _excludedHostnames,
          _excludedUserAgents,
          _debugMode,
          _pulseMaxVirtualPageDuration,
          _pulseIgnoreUrlCasing,
          _pulseCustomLoadTimeEnabled,
          _beforeSendRumCallback,
          _setCookieAsSecure,
          _captureMissingRequests,
          _automaticPerformanceCustomTimings
        );
        _rum.attach();
      };

      if (!Raygun.Utilities.isReactNative()) {
        if (_loadedFrom === 'onLoad') {
          startRum();
        } else {
          if (window.addEventListener) {
            window.addEventListener('load', startRum);
          } else {
            window.attachEvent('onload', startRum);
          }
        }
      } else {
        Raygun.Utilities.log('Not enabling RUM because Raygun4JS has detected a React Native environment, see #310 on Github');
      }
    }

    retriggerDelayedCommands();

    sendSavedErrors();
  }

  // We need to delay handled/unhandled send() and trackEvent() calls until the user data callback has returned
  function retriggerDelayedCommands() {
    var i;
    for (i = 0; i < _processExceptionQueue.length; i++) {
      processException(
        _processExceptionQueue[i].stackTrace,
        _processExceptionQueue[i].options,
        _processExceptionQueue[i].userTriggered,
        _processExceptionQueue[i].error
      );
    }

    _processExceptionQueue = [];

    for (i = 0; i < _trackEventQueue.length; i++) {
      _publicRaygunFunctions.trackEvent(_trackEventQueue[i].type, _trackEventQueue[i].options);
    }

    _trackEventQueue = [];
  }

  function offlineSave(url, data) {
    var dateTime = new Date().toJSON();

    try {
      var key =
        'raygunjs+' +
        Raygun.Options._raygunApiKey +
        '=' +
        dateTime +
        '=' +
        Raygun.Utilities.getRandomInt();

      if (typeof localStorage[key] === 'undefined') {
        localStorage[key] = JSON.stringify({ url: url, data: data });
      }
    } catch (e) {
      Raygun.Utilities.log('Raygun4JS: LocalStorage full, cannot save exception');
    }
  }

  function sendSavedErrors() {
    if (Raygun.Utilities.localStorageAvailable()) {
      for (var key in localStorage) {
        if (key.indexOf('raygunjs+' + Raygun.Options._raygunApiKey) > -1) {
          try {
            var payload = JSON.parse(localStorage[key]);
            makePostCorsRequest(payload.url, payload.data);
          } catch (e) {
            Raygun.Utilities.log('Raygun4JS: Invalid JSON object in LocalStorage');
          }

          try {
            localStorage.removeItem(key);
          } catch (e) {
            Raygun.Utilities.log('Raygun4JS: Unable to remove error');
          }
        }
      }
    }
  }

  function filterValue(key, value) {
    if (_filteredKeys) {
      for (var i = 0; i < _filteredKeys.length; i++) {
        if (typeof _filteredKeys[i] === 'object' && typeof _filteredKeys[i].exec === 'function') {
          var executedFilter = _filteredKeys[i].exec(key);

          if (executedFilter !== null && executedFilter !== undefined$1) {
            return '[removed by filter]';
          }
        } else if (_filteredKeys[i] === key) {
          return '[removed by filter]';
        }
      }
    }

    return value;
  }

  function filterObject(reference, parentKey) {
    if (reference == null) {
      return reference;
    }

    if (Object.prototype.toString.call(reference) !== '[object Object]') {
      return reference;
    }

    var filteredObject = {};

    for (var propertyName in reference) {
      var propertyValue = reference[propertyName];

      if (Object.prototype.toString.call(propertyValue) === '[object Object]') {
        if (parentKey !== 'Details' || propertyName !== 'Client') {
          filteredObject[propertyName] = filterObject(
            filterValue(propertyName, propertyValue),
            propertyName
          );
        } else {
          filteredObject[propertyName] = propertyValue;
        }
      } else if (Object.prototype.toString.call(propertyValue) !== '[object Function]') {
        if (typeof parentKey !== 'undefined') {
          filteredObject[propertyName] = filterValue(propertyName, propertyValue);
        } else if (propertyName === 'OccurredOn') {
          filteredObject[propertyName] = propertyValue;
        }
      }
    }

    return filteredObject;
  }

  function processJQueryAjaxError(event, jqXHR, ajaxSettings, thrownError) {
    var message =
      'AJAX Error: ' +
      (jqXHR.statusText || 'unknown') +
      ' ' +
      (ajaxSettings.type || 'unknown') +
      ' ' +
      (Raygun.Utilities.truncateURL(ajaxSettings.url) || 'unknown');

    // ignore ajax abort if set in the options
    if (_ignoreAjaxAbort) {
      if (jqXHR.status === 0 || !jqXHR.getAllResponseHeaders()) {
        return;
      }
    }

    Raygun.send(thrownError || event.type, {
      status: jqXHR.status,
      statusText: jqXHR.statusText,
      type: ajaxSettings.type,
      url: ajaxSettings.url,
      ajaxErrorMessage: message,
      contentType: ajaxSettings.contentType,
      requestData:
        ajaxSettings.data && ajaxSettings.data.slice
          ? ajaxSettings.data.slice(0, 10240)
          : undefined$1,
      responseData:
        jqXHR.responseText && jqXHR.responseText.slice
          ? jqXHR.responseText.slice(0, 10240)
          : undefined$1,
      activeTarget:
        event.target &&
        event.target.activeElement &&
        event.target.activeElement.outerHTML &&
        event.target.activeElement.outerHTML.slice
          ? event.target.activeElement.outerHTML.slice(0, 10240)
          : undefined$1,
    });
  }

  function processException(stackTrace, options, userTriggered, error) {
    if (_providerState !== ProviderStates.READY) {
      _processExceptionQueue.push({
        stackTrace: stackTrace,
        options: options,
        userTriggered: userTriggered,
        error: error,
      });
      return;
    }

    var scriptError = 'Script error';

    var stack = [],
      qs = {};

    if (_ignore3rdPartyErrors) {
      if (!stackTrace.stack || !stackTrace.stack.length) {
        Raygun.Utilities.log('Raygun4JS: Cancelling send due to null stacktrace');
        return;
      }

      var domain = Raygun.Utilities.parseUrl('domain');

      var msg = scriptError;
      if (stackTrace.message) {
        msg = stackTrace.message;
      } else if (options && options.status) {
        msg = options.status;
      }

      if (typeof msg === 'undefined') {
        msg = scriptError;
      }

      if (
        !Raygun.Utilities.isReactNative() &&
        typeof msg.substring === 'function' &&
        msg.substring(0, scriptError.length) === scriptError &&
        stackTrace.stack[0].url !== null &&
        stackTrace.stack[0].url !== undefined$1 &&
        stackTrace.stack[0].url.indexOf(domain) === -1 &&
        (stackTrace.stack[0].line === 0 || stackTrace.stack[0].func === '?')
      ) {
        Raygun.Utilities.log(
          'Raygun4JS: cancelling send due to third-party script error with no stacktrace and message'
        );
        return;
      }

      var foundValidDomain = false;
      for (var i = 0; !foundValidDomain && stackTrace.stack && i < stackTrace.stack.length; i++) {
        if (
          stackTrace.stack[i] !== null &&
          stackTrace.stack[i] !== undefined$1 &&
          stackTrace.stack[i].url !== null &&
          stackTrace.stack[i].url !== undefined$1
        ) {
          for (var j in _whitelistedScriptDomains) {
            if (stackTrace.stack[i].url.indexOf(_whitelistedScriptDomains[j]) > -1) {
              foundValidDomain = true;
            }
          }

          if (stackTrace.stack[i].url.indexOf(domain) > -1) {
            foundValidDomain = true;
          }
        }
      }

      if (!foundValidDomain) {
        Raygun.Utilities.log(
          'Raygun4JS: cancelling send due to error on non-origin, non-whitelisted domain'
        );

        return;
      }
    }

    if (_excludedHostnames instanceof Array) {
      for (var hostIndex in _excludedHostnames) {
        if (_excludedHostnames.hasOwnProperty(hostIndex)) {
          if (
            window.location.hostname &&
            window.location.hostname.match(_excludedHostnames[hostIndex])
          ) {
            Raygun.Utilities.log(
              'Raygun4JS: cancelling send as error originates from an excluded hostname'
            );

            return;
          }
        }
      }
    }

    if (_excludedUserAgents instanceof Array && !Raygun.Utilities.isReactNative()) {
      for (var userAgentIndex in _excludedUserAgents) {
        if (_excludedUserAgents.hasOwnProperty(userAgentIndex)) {
          if (navigator.userAgent.match(_excludedUserAgents[userAgentIndex])) {
            Raygun.Utilities.log(
              'Raygun4JS: cancelling send as error originates from an excluded user agent'
            );

            return;
          }
        }
      }
    }

    if (
      !Raygun.Utilities.isReactNative() &&
      navigator.userAgent.match('RaygunPulseInsightsCrawler')
    ) {
      return;
    }

    if (stackTrace.stack && stackTrace.stack.length) {
      Raygun.Utilities.forEach(stackTrace.stack, function(i, frame) {
        stack.push({
          LineNumber: frame.line,
          ColumnNumber: frame.column,
          ClassName: 'line ' + frame.line + ', column ' + frame.column,
          FileName: frame.url,
          MethodName: frame.func || '[anonymous]',
        });
      });
    }

    var queryString = Raygun.Utilities.parseUrl('?');

    if (queryString.length > 0) {
      Raygun.Utilities.forEach(queryString.split('&'), function(i, segment) {
        var parts = segment.split('=');
        if (parts && parts.length === 2) {
          var key = decodeURIComponent(parts[0]);
          var value = filterValue(key, parts[1]);

          qs[key] = value;
        }
      });
    }

    if (options === undefined$1) {
      options = {};
    }

    if (Raygun.Utilities.isEmpty(options.customData)) {
      if (typeof _customData === 'function') {
        options.customData = _customData();
      } else {
        options.customData = _customData;
      }
    }

    if (Raygun.Utilities.isEmpty(options.tags)) {
      if (typeof _tags === 'function') {
        options.tags = _tags();
      } else if (typeof _tags === 'string') {
        options.tags = [_tags];
      } else {
        options.tags = _tags;
      }
    }

    if (!userTriggered) {
      if (!options.tags) {
        options.tags = [];
      }

      if (!Raygun.Utilities.contains(options.tags, 'UnhandledException')) {
        options.tags.push('UnhandledException');
      }
    }

    if (
      Raygun.Utilities.isReactNative() &&
      !Raygun.Utilities.contains(options.tags, 'React Native')
    ) {
      options.tags.push('React Native');
    }

    var screenData = window.screen || {
      width: Raygun.Utilities.getViewPort().width,
      height: Raygun.Utilities.getViewPort().height,
      colorDepth: 8,
    };

    var custom_message = options.customData && options.customData.ajaxErrorMessage;

    var finalCustomData;
    if (_filterScope === 'customData') {
      finalCustomData = filterObject(options.customData, 'UserCustomData');
    } else {
      finalCustomData = options.customData;
    }

    try {
      JSON.stringify(finalCustomData);
    } catch (e) {
      var m = 'Cannot add custom data; may contain circular reference';
      finalCustomData = { error: m };
      Raygun.Utilities.log('Raygun4JS: ' + m);
    }

    var finalMessage = scriptError;
    if (custom_message) {
      finalMessage = custom_message;
    } else if (stackTrace.message) {
      finalMessage = stackTrace.message;
    } else if (options && options.status) {
      finalMessage = options.status;
    } else if (typeof error === 'string') {
      finalMessage = error;
    }

    if (typeof finalMessage === 'undefined') {
      finalMessage = scriptError;
    }

    if (finalMessage && typeof finalMessage === 'string') {
      finalMessage = finalMessage.substring(0, 512);
    }

    var pageLocation;
    if (!Raygun.Utilities.isReactNative()) {
      pageLocation = [
        location.protocol,
        '//',
        location.host,
        location.pathname,
        location.hash,
      ].join('');
    } else {
      pageLocation = '/';
    }

    var payload = {
      OccurredOn: new Date(),
      Details: {
        Error: {
          ClassName: stackTrace.name,
          Message: finalMessage,
          StackTrace: stack,
          StackString: stackTrace.stackstring,
        },
        Environment: {
          UtcOffset: new Date().getTimezoneOffset() / -60.0,
          'User-Language': navigator.userLanguage,
          'Document-Mode': !Raygun.Utilities.isReactNative()
            ? document.documentMode
            : 'Not available',
          'Browser-Width': Raygun.Utilities.getViewPort().width,
          'Browser-Height': Raygun.Utilities.getViewPort().height,
          'Screen-Width': screenData.width,
          'Screen-Height': screenData.height,
          'Color-Depth': screenData.colorDepth,
          Browser: navigator.appCodeName,
          'Browser-Name': navigator.appName,
          'Browser-Version': navigator.appVersion,
          Platform: navigator.platform,
        },
        Client: {
          Name: 'raygun-js',
          Version: '2.20.3',
        },
        UserCustomData: finalCustomData,
        Tags: options.tags,
        Request: {
          Url: pageLocation,
          QueryString: qs,
          Headers: {
            'User-Agent': navigator.userAgent,
            Referer: !Raygun.Utilities.isReactNative() ? document.referrer : 'Not available',
            Host: !Raygun.Utilities.isReactNative() ? document.domain : 'Not available',
          },
        },
        Version: _version || 'Not supplied',
      },
    };

    payload.Details.User = _user;

    if (_breadcrumbs.any()) {
      payload.Details.Breadcrumbs = [];
      var crumbs = _breadcrumbs.all() || [];

      crumbs.forEach(function(crumb) {
        if (crumb.metadata) {
          crumb.CustomData = crumb.metadata;
          delete crumb.metadata;
        }

        payload.Details.Breadcrumbs.push(crumb);
      });
    }

    if (_filterScope === 'all') {
      payload = filterObject(payload);
    }

    if (typeof _groupingKeyCallback === 'function') {
      Raygun.Utilities.log('Raygun4JS: calling custom grouping key');
      payload.Details.GroupingKey = _groupingKeyCallback(payload, stackTrace, options);
    }

    if (typeof _beforeSendCallback === 'function') {
      var mutatedPayload = _beforeSendCallback(payload);

      if (mutatedPayload) {
        sendToRaygun(mutatedPayload);
      }
    } else {
      sendToRaygun(payload);
    }
  }

  function sendToRaygun(data) {
    if (!Raygun.Utilities.isApiKeyConfigured()) {
      return;
    }

    Raygun.Utilities.log('Sending exception data to Raygun:', data);
    var url = _raygunApiUrl + '/entries?apikey=' + encodeURIComponent(Raygun.Options._raygunApiKey);
    makePostCorsRequest(url, JSON.stringify(data));
  }

  // Create the XHR object.
  function createCORSRequest(method, url) {
    var xhr;

    xhr = new window.XMLHttpRequest();

    if ('withCredentials' in xhr || Raygun.Utilities.isReactNative()) {
      // XHR for Chrome/Firefox/Opera/Safari
      // as well as React Native's custom XHR implementation
      xhr.open(method, url, true);
    } else if (window.XDomainRequest) {
      // XDomainRequest for IE.
      if (_allowInsecureSubmissions) {
        // remove 'https:' and use relative protocol
        // this allows IE8 to post messages when running
        // on http
        url = url.slice(6);
      }

      xhr = new window.XDomainRequest();
      xhr.open(method, url);
    }

    xhr.timeout = 10000;

    return xhr;
  }

  // Make the actual CORS request.
  function makePostCorsRequest(url, data, _successCallback, _errorCallback) {
    var xhr = createCORSRequest('POST', url);
    if (typeof xhr.setRequestHeader === 'function') {
      xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');

      if(typeof _clientIp !== "undefined") {
        xhr.setRequestHeader('X-Remote-Address', _clientIp);
      }
    }

    if (typeof _beforeXHRCallback === 'function') {
      _beforeXHRCallback(xhr);
    }

    Raygun.Utilities.log('Is offline enabled? ' + _enableOfflineSave);

    // For some reason this check is false in React Native but these handlers still need to be attached
    if ('withCredentials' in xhr || Raygun.Utilities.isReactNative()) {
      xhr.onreadystatechange = function() {
        if (xhr.readyState !== 4) {
          return;
        }

        if (xhr.status === 202) {
          sendSavedErrors();
        } else if (
          _enableOfflineSave &&
          xhr.status !== 403 &&
          xhr.status !== 400 &&
          xhr.status !== 429
        ) {
          offlineSave(url, data);
        }
      };

      xhr.onload = function() {
        Raygun.Utilities.log('posted to Raygun');

        callAfterSend(this);

        if (_successCallback && typeof _successCallback === 'function') {
          _successCallback(xhr, url, data);
        }
      };
    } else if (window.XDomainRequest) {
      xhr.ontimeout = function() {
        if (_enableOfflineSave) {
          Raygun.Utilities.log('Raygun: saved locally');
          offlineSave(url, data);
        }
      };

      xhr.onload = function() {
        Raygun.Utilities.log('posted to Raygun');

        sendSavedErrors();
        callAfterSend(this);

        if (_successCallback && typeof _successCallback === 'function') {
          _successCallback(xhr, url, data);
        }
      };
    }

    xhr.onerror = function() {
      Raygun.Utilities.log('failed to post to Raygun');

      callAfterSend(this);

      if (_errorCallback && typeof _errorCallback === 'function') {
        _errorCallback(xhr, url, data);
      }
    };

    if (!xhr) {
      Raygun.Utilities.log('CORS not supported');
      return;
    }

    // Old versions of RN fail to send errors without this
    if (Raygun.Utilities.isReactNative()) {
      xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
    }

    xhr.send(data);
  }

  // Storage 
  function saveToStorage(value) {
    if(Raygun.Utilities.localStorageAvailable()) {
      localStorage.setItem(_userKey, value);
    } else {
      Raygun.Utilities.createCookie(_userKey, value, 24 * 31, _setCookieAsSecure);
    }
  }

  function clearStorage() {
    if(Raygun.Utilities.localStorageAvailable()) {
      localStorage.removeItem(_userKey);
    } else {
      Raygun.Utilities.clearCookie(_userKey);
    }
  }

  function getFromStorage(callback) {
    /**
     * Attempt to get the value from local storage, 
     * If that doesn't contain a value then try from a cookie as previous versions saved it here
     */
    var value;
    if(Raygun.Utilities.localStorageAvailable()) {
      value = localStorage.getItem(_userKey);

      if(value !== null) {
        callback(value);
        return;
      }
    }

    value = Raygun.Utilities.readCookie(_userKey);

    /**
     * If there was a cookie and localStorage is avaliable then  
     * clear the cookie as localStorage will be the storage mechanism going forward
     */  
    if(value !== null && Raygun.Utilities.localStorageAvailable()) {
      Raygun.Utilities.clearCookie(_userKey);
      localStorage.setItem(_userKey, value);
    }
    
    callback(value);
  }

  if (!window.__raygunNoConflict) {
    window.Raygun = Raygun;
  }
  TraceKit.setRaygun(Raygun);

  return Raygun;
};

window.__instantiatedRaygun = raygunFactory(window, window.jQuery);

/*
 * raygun4js
 * https://github.com/MindscapeHQ/raygun4js
 *
 * Copyright (c) 2018 MindscapeHQ
 * Licensed under the MIT license.
 */

var raygunRumFactory = function(window, $, Raygun) {
  Raygun.RealUserMonitoring = function(
    apiKey,
    apiUrl,
    makePostCorsRequest,
    user,
    version,
    tags,
    excludedHostNames,
    excludedUserAgents,
    debugMode,
    maxVirtualPageDuration,
    ignoreUrlCasing,
    customTimingsEnabled,
    beforeSendCb,
    setCookieAsSecure,
    captureMissingRequests,
    automaticPerformanceCustomTimings
  ) {
    var self = this;
    var _private = {};

    this.cookieName = 'raygun4js-sid';
    this.apiKey = apiKey;
    this.apiUrl = apiUrl;
    this.debugMode = debugMode;
    this.excludedHostNames = excludedHostNames;
    this.excludedUserAgents = excludedUserAgents;
    this.maxVirtualPageDuration = maxVirtualPageDuration || 1800000; // 30 minutes
    this.ignoreUrlCasing = ignoreUrlCasing;
    /**
     * Note: the `customTimingsEnabled` flag is for tracking legacy custom timings
     * because that api prevents page timings from being sent until the main request is completed
     */
    this.customTimingsEnabled = customTimingsEnabled; 
    this.automaticPerformanceCustomTimings = automaticPerformanceCustomTimings;
    this.beforeSend =
      beforeSendCb ||
      function(payload) {
        return payload;
      };

    this.pendingPayloadData = customTimingsEnabled || false;
    this.queuedPerformanceTimings = [];
    this.pendingVirtualPage = null;

    this.sessionId = null;
    this.virtualPage = null;
    this.user = user;
    this.version = version;
    this.tags = tags;
    this.heartBeatInterval = null;
    this.heartBeatIntervalTime = 30000;
    this.offset = 0;
    this._captureMissingRequests = captureMissingRequests || false;
    this.sendUsingNavigatorBeacon = false;
    
    /**
     * `stopCollectingMetrics` is a flag to stop collecting/sending metrics from this point onwards. 
     * This is used to prevent resources triggered from the 'pageshow' event from being tracked
     */
    this.stopCollectingMetrics = false;

    this.queuedItems = [];
    this.maxQueueItemsSent = 50;
    this.setCookieAsSecure = setCookieAsSecure;

    this.xhrRequestMap = {};
    this.xhrStatusMap = {};

    var Timings = {
      Page: 'p',
      VirtualPage: 'v',
      XHR: 'x',
      CachedChildAsset: 'e',
      ChildAsset: 'c',
      CustomTiming: 't'
    };

    this.Utilities = {};

    // ================================================================================
    // =                                                                              =
    // =                                 Public Api                                   =
    // =                                                                              =
    // ================================================================================

    this.attach = function() {
      getSessionId(function(isNewSession) {
        self.pageLoaded(isNewSession);
      });

      var clickHandler = function() {
        this.updateStorageTimestamp();
      }.bind(_private);

      var unloadHandler = function() {
        self.sendUsingNavigatorBeacon = true;
        sendChildAssets(true);
        sendQueuedItems();
      }.bind(_private);

      var visibilityChangeHandler = function() {
        if (document.visibilityState === 'visible') {
          this.updateStorageTimestamp();
        }
      }.bind(_private);

      var pageHideHandler = function() {
        self.sendUsingNavigatorBeacon = true;
        sendChildAssets(true);
        sendQueuedItems();
        self.stopCollectingMetrics = true;
      }.bind(_private);

      if (window.addEventListener) {
        window.addEventListener('click', clickHandler);
        document.addEventListener('visibilitychange', visibilityChangeHandler);
        window.addEventListener('beforeunload', unloadHandler);
        window.addEventListener('pagehide', pageHideHandler);
      } else if (window.attachEvent) {
        document.attachEvent('onclick', clickHandler);
      }

      Raygun.NetworkTracking.on('request', xhrRequestHandler.bind(this));
      Raygun.NetworkTracking.on('error', xhrErrorHandler.bind(this));
      Raygun.NetworkTracking.on('response', xhrResponseHandler.bind(this));
    };

    this.pageLoaded = function(isNewSession) {
      // Only create a session if we don't have one.
      if (isNewSession) {
        sendNewSessionStart();
      }

      sendPerformance(true);

      heartBeat();

      self.initalStaticPageLoadTimestamp = getPerformanceNow(0);
    };

    this.virtualPageLoaded = function(path) {
      if (typeof path === 'string') {
        if (path.length > 0 && path[0] !== '/') {
          path = path + '/';
        }

        if (path.length > 800) {
          path = path.substring(0, 800);
        }

        this.virtualPage = path;
      }

      resumeCollectingMetrics();
      processVirtualPageTimingsInQueue();
      sendPerformance(false);
    };

    this.setUser = function(user) {
      self.user = user;
    };

    this.withTags = function(tags) {
      self.tags = tags;
    };

    this.endSession = function() {
      self.pendingPayloadData = false;
      sendQueuedPerformancePayloads();
      
      sendItemImmediately({
        sessionId: self.sessionId,
        requestId: self.requestId,
        timestamp: new Date().toISOString(),	
        type: 'session_end',	
      });

      generateNewSessionId();

      sendNewSessionStart();
    };

    this.sendCustomTimings = function(customTimings) {
      if (
        typeof customTimings === 'object' &&
        (typeof customTimings.custom1 === 'number' ||
          typeof customTimings.custom2 === 'number' ||
          typeof customTimings.custom3 === 'number' ||
          typeof customTimings.custom4 === 'number' ||
          typeof customTimings.custom5 === 'number' ||
          typeof customTimings.custom6 === 'number' ||
          typeof customTimings.custom7 === 'number' ||
          typeof customTimings.custom8 === 'number' ||
          typeof customTimings.custom9 === 'number' ||
          typeof customTimings.custom10 === 'number')
      ) {
        if (self.pendingPayloadData && self.queuedPerformanceTimings.length > 0) {
          // Append custom timings to first queued item, which should be a page view
          self.pendingPayloadData = false;
          self.queuedPerformanceTimings[0].customTiming = customTimings;
          sendQueuedPerformancePayloads();
        }
      }
    };

    this.trackCustomTiming = function(name, duration, offset) {
      if(typeof duration === "number") {
        var newTimings = [];
        newTimings.push(createCustomTimingMeasurement(name, duration, offset));
        addPerformanceTimingsToQueue(newTimings, false);
      } else {
        log('Raygun4JS: Custom timing "' + name + '" duration value is not a number');
      }
    };

    this.captureMissingRequests = function(val) {
      this._captureMissingRequests = val;
    };

    // ================================================================================
    // =                                                                              =
    // =                              Session Management                              =
    // =                                                                              =
    // ================================================================================

    function heartBeat() {
      if (self.heartBeatInterval !== null) {
        log('Raygun4JS: Heartbeat already exists. Skipping heartbeat creation.');
        return;
      }

      self.heartBeatInterval = setInterval(function() {
        sendChildAssets();
        sendQueuedItems();
      }, self.heartBeatIntervalTime); // 30 seconds between heartbeats
    }

    function sendNewSessionStart() {
      sendItemImmediately({
        sessionId: self.sessionId,
        timestamp: new Date().toISOString(),
        type: 'session_start',
        user: self.user,
        version: self.version || 'Not supplied',
        tags: self.tags,
        device: navigator.userAgent,
      });
    }

    function hasSessionExpired(storageItem) {
      var existingTimestamp = new Date(readStorageElement(storageItem, 'timestamp'));
      var halfHrAgo = new Date(new Date() - 30 * 60000);
      return existingTimestamp < halfHrAgo;
    }

    function getSessionId(callback) {
      var storageItem = getFromStorage();
      var nullValue = storageItem === null;
      var expired = false;

      if(!nullValue) {
        expired = hasSessionExpired(storageItem);
      }
      
      if(nullValue || expired) {
        generateNewSessionId();
        callback(true);
      } else {
        var id = readStorageElement(storageItem, 'id');   
        saveToStorage(id); // Update the timestamp     
        self.sessionId = id;
        callback(false);
      }
    }

    function updateStorageTimestamp() {
      var storageItem = getFromStorage();
      var expired = false;

      if(storageItem) {
        expired = hasSessionExpired(storageItem);
      }
      
      if(expired || !storageItem){
        self.sessionId = randomKey(32);
      }

      saveToStorage(self.sessionId);

      if (expired) {
        sendNewSessionStart();
      }
    }

    function generateNewSessionId(){
      self.sessionId = randomKey(32);
      saveToStorage(self.sessionId);
    }

    // ================================================================================
    // =                                                                              =
    // =                                  Queueing                                    =
    // =                                                                              =
    // ================================================================================

    function sendPerformance(firstLoad) {
      var performanceData = getPerformanceData(self.virtualPage, firstLoad);

      if (performanceData === null || performanceData.length < 0) {
        return;
      }

      addPerformanceTimingsToQueue(performanceData, false);
    }

    function sendChildAssets(forceSend) {
      if (forceSend) {
        processVirtualPageTimingsInQueue();
      }

      var data = [];
      extractChildData(data, undefined, forceSend);
      addPerformanceTimingsToQueue(data, forceSend);
    }

    function sendQueuedItems() {
      if (self.queuedItems.length > 0) {
        // Dequeue:
        self.queuedItems = sortCollectionByProperty(self.queuedItems, 'timestamp');
        var itemsToSend = self.queuedItems.splice(0, self.maxQueueItemsSent);

        sendItemsImmediately(itemsToSend);
      }
    }

    function processVirtualPageTimingsInQueue() {
      var i = 0,
        data;
      for (i; i < self.queuedPerformanceTimings.length; i++) {
        data = self.queuedPerformanceTimings[i];
        if (data.timing.t === Timings.VirtualPage && data.timing.pending) {
          data.timing = generateVirtualEncodedTimingData(data.timing);
        }
      }
    }

    function sendItemImmediately(item) {
      var itemsToSend = [item];

      sendItemsImmediately(itemsToSend);
    }

    function sendItemsImmediately(itemsToSend) {
      var payload = {
        eventData: itemsToSend,
      };

      var successCallback = function() {
        log('Raygun4JS: Items sent successfully. Queue length: ' + self.queuedItems.length);
      };

      var errorCallback = function(response) {

        // Requeue:
        requeueItemsToFront(itemsToSend);

        log(
          'Raygun4JS: Items failed to send. Queue length: ' +
            self.queuedItems.length +
            ' Response status code: ' +
            response.status
        );
      };

      postPayload(payload, successCallback, errorCallback);
    }

    function sendQueuedPerformancePayloads(forceSend) {
      if (self.pendingPayloadData && !forceSend) {
        return;
      }

      var currentPayloadTimingData = [];
      var payloadTimings = [];
      var payloadIncludesPageTiming = false;
      var data, i;

      var addCurrentPayloadEvents = function() {
        payloadTimings.push(createTimingPayload(currentPayloadTimingData));
        currentPayloadTimingData = [];
        payloadIncludesPageTiming = false;
      };

      var sendTimingData = function() {
        if (currentPayloadTimingData.length > 0) {
          addCurrentPayloadEvents();
        }

        if (payloadTimings.length > 0) {
          sendItemsImmediately(payloadTimings);
          currentPayloadTimingData = [];
          payloadIncludesPageTiming = false;
        }
      };

      for (i = 0; i < self.queuedPerformanceTimings.length; i++) {
        data = self.queuedPerformanceTimings[i];
        var isPageOrVirtualPage =
          data.timing.t === Timings.Page || data.timing.t === Timings.VirtualPage;

        if (payloadIncludesPageTiming && isPageOrVirtualPage) {
          // Ensure that pages/virtual pages are both not included in the same 'web_request_timing'
          addCurrentPayloadEvents();
        }

        if (currentPayloadTimingData.length > 0 && isPageOrVirtualPage) {
          // Resources already exist before the page view so associate them with previous "page" by having them as a seperate web_request_timing
          addCurrentPayloadEvents();
        }

        if (isPageOrVirtualPage) {
          // If the next timing data is a page or virtual page, generate a new request ID
          createRequestId();
        }

        if (data.timing.t === Timings.VirtualPage && data.timing.pending) {
          // Pending virtual page, wait until the virtual page timings have been calculated
          sendTimingData();
          self.queuedPerformanceTimings.splice(0, i);
          return;
        }

        currentPayloadTimingData.push(data);
        payloadIncludesPageTiming =
          payloadIncludesPageTiming ||
          (data.timing.t === Timings.Page || data.timing.t === Timings.VirtualPage);
      }

      sendTimingData();
      self.queuedPerformanceTimings = [];
    }

    function requeueItemsToFront(itemsToSend) {
      self.queuedItems = itemsToSend.concat(self.queuedItems);
    }

    function addPerformanceTimingsToQueue(performanceData, forceSend) {
      if(self.stopCollectingMetrics === false) {
        self.queuedPerformanceTimings = self.queuedPerformanceTimings.concat(performanceData);
        sendQueuedPerformancePayloads(forceSend);
      }
    }

    // ================================================================================
    // =                                                                              =
    // =                                Timing Data                                   =
    // =                                                                              =
    // ================================================================================

    function getPerformanceData(virtualPage, firstLoad) {
      if (
        !performanceEntryExists('timing', 'object') ||
        window.performance.timing.fetchStart === undefined ||
        isNaN(window.performance.timing.fetchStart)
      ) {
        return null;
      }

      var data = [];

      if (firstLoad) {
        // Called by the static onLoad event being fired, persist itself
        data.push(getPrimaryTimingData());
      }

      // Called during both the static load event and the virtual load calls
      // Associates all data loaded up to this point with the previous page
      // Eg: Page load if it is this is a new load, or the last view if a virtual page was freshly triggered
      extractChildData(data);

      if (virtualPage) {
        data.push(getVirtualPrimaryTimingData(virtualPage, getPerformanceNow(0)));

        extractChildData(data, true);
      }

      return data;
    }

    function extractChildData(collection, fromVirtualPage, forceSend) {
      if (!performanceEntryExists('getEntries', 'function')) {
        return;
      }

      try {
        var offset = fromVirtualPage ? 0 : window.performance.timing.navigationStart;
        var resources = window.performance.getEntries();
        var i;

        for (i = self.offset; i < resources.length; i++) {
          var resource = resources[i];
          if(!forceSend && waitingForResourceToFinishLoading(resource)) {
            break;
          } else if (isCustomTimingMeasurement(resource)) {
            if(self.automaticPerformanceCustomTimings) {
              collection.push(getCustomTimingMeasurement(resource));
            }
          } else if (!shouldIgnoreResource(resource)) {
            collection.push(getSecondaryTimingData(resource, offset));
          } 
        }

        self.offset = i;

        if(this._captureMissingRequests) {
          addMissingWrtData(collection, offset);
        }
      } catch (e) {
        log(e);
      }
    }

    /**
     * This adds in the missing WRT data from non 2xx status code responses in Chrome/Safari
     * This is to ensure we have full status code tracking support.
     * It creates a fake WRT payload containing only the duration & XHR type as those are the minimum
     * required set of fields
     */
    var addMissingWrtData = function(collection, offset) {
      log('checking for missing WRT data', this.xhrStatusMap);

      for (var url in this.xhrStatusMap) {
        if (this.xhrStatusMap.hasOwnProperty(url)) {
          var responses = this.xhrStatusMap[url];

          if (responses && responses.length > 0) {
            do {
              var response = responses.shift();
              log('checking response', response);

              if (!shouldIgnoreResourceByName(response.baseUrl)) {
                log('adding missing WRT data for url');

                collection.push({
                  url: response.baseUrl,
                  statusCode: response.status,
                  timing: { 
                    du: maxFiveMinutes(response.duration).toFixed(2), 
                    a: offset.toFixed(2),
                    t: Timings.XHR 
                  },
                });
              }
            } while (responses.length > 0);
          }

          delete this.xhrStatusMap[url];
        }
      }
    }.bind(this);

    function getPrimaryTimingData() {
      var pathName = window.location.pathname;

      if (self.ignoreUrlCasing) {
        pathName = pathName.toLowerCase();
      }

      var url = window.location.protocol + '//' + window.location.host + pathName;

      if (url.length > 800) {
        url = url.substring(0, 800);
      }

      return {
        url: url,
        userAgent: navigator.userAgent,
        timing: getEncodedTimingData(),
        size: 0,
      };
    }

    function getVirtualPrimaryTimingData(virtualPage, virtualPageStartTime) {
      if (self.ignoreUrlCasing) {
        virtualPage = virtualPage.toLowerCase();
      }

      if (virtualPage.indexOf('?') !== -1) {
        virtualPage = virtualPage.split('?')[0];
      }

      var url = window.location.protocol + '//' + window.location.host + virtualPage;

      if (url.length > 800) {
        url = url.substring(0, 800);
      }

      return {
        url: url,
        userAgent: navigator.userAgent,
        timing: prepareVirtualEncodedTimingData(virtualPageStartTime),
        size: 0,
      };
    }

    var getTimingUrl = function(timing) {
      var url = timing.name.split('?')[0];

      if (self.ignoreUrlCasing) {
        url = url.toLowerCase();
      }

      if (url.length > 800) {
        url = url.substring(0, 800);
      }

      return url;
    }.bind(this);

    /**
     * Stops sending through timing information if a XHR request has been made by the response handler hasn't been fired. 
     * This is to prevent issues where multiple timings for the same asset can be sent. 
     * Once for the performance timing and another for the missing request (if the captureMissingRequests option is enabled)
     */
    var waitingForResourceToFinishLoading = function(timing) {
      var url = getTimingUrl(timing);
      var request = this.xhrRequestMap[url];

      return request && request.length > 0;
    }.bind(this);

    var getSecondaryTimingData = function(timing, offset) {
      var url = getTimingUrl(timing);

      var timingData = {
        url: url,
        timing: getSecondaryEncodedTimingData(
          timing,
          offset
        ),
        size: timing.decodedBodySize || 0,
      };

      log('retrieving secondary timing data for', timing.name);

      var xhrStatusesForName = this.xhrStatusMap[url];
      if (xhrStatusesForName && xhrStatusesForName.length > 0) {
        timingData.statusCode = this.xhrStatusMap[url].shift().status;

        log('found status for timing', timingData.statusCode);
        if (this.xhrStatusMap[url].length === 0) {
          delete this.xhrStatusMap[url];
        }
      } else {
        log('no status found for timing', this.xhrStatusMap);
      }

      return timingData;
    }.bind(this);

    function getEncodedTimingData() {
      var timing = window.performance.timing;

      var data = {
        du: timing.duration,
        t: Timings.Page,
      };

      data.a = timing.fetchStart;

      if (timing.domainLookupStart && timing.domainLookupStart > 0) {
        data.b = timing.domainLookupStart - data.a;
      }

      if (timing.domainLookupEnd && timing.domainLookupEnd > 0) {
        data.c = timing.domainLookupEnd - data.a;
      }

      if (timing.connectStart && timing.connectStart > 0) {
        data.d = timing.connectStart - data.a;
      }

      if (timing.connectEnd && timing.connectEnd > 0) {
        data.e = timing.connectEnd - data.a;
      }

      if (timing.responseStart && timing.responseStart > 0) {
        data.f = timing.responseStart - data.a;
      }

      if (timing.responseEnd && timing.responseEnd > 0) {
        data.g = timing.responseEnd - data.a;
      }

      if (timing.domLoading && timing.domLoading > 0) {
        data.h = timing.domLoading - data.a;
      }

      if (timing.domInteractive && timing.domInteractive > 0) {
        data.i = timing.domInteractive - data.a;
      }

      if (timing.domContentLoadedEventEnd && timing.domContentLoadedEventEnd > 0) {
        data.j = timing.domContentLoadedEventEnd - data.a;
      }

      if (timing.domComplete && timing.domComplete > 0) {
        data.k = maxFiveMinutes(timing.domComplete - data.a);
      }

      if (timing.loadEventStart && timing.loadEventStart > 0) {
        data.l = timing.loadEventStart - data.a;
      }

      if (timing.loadEventEnd && timing.loadEventEnd > 0) {
        data.m = timing.loadEventEnd - data.a;
      }

      if (timing.secureConnectionStart && timing.secureConnectionStart > 0) {
        data.n = (timing.secureConnectionStart - timing.connectStart) - data.a;
      }

      data = sanitizeNaNs(data);

      data = addPaintTimings(data);

      return data;
    }

    /**
     * Adds first-paint and first-contentful-paint timings onto the main page timing. 
     * The performance API is used as it's a more standard method only supported in Chrome.
     * `msFirstPaint` is used for Edge/IE browsers and returns a Unix timestamp. We calculate 
     * the difference between 'msFirstPaint' and 'connectStart' to get first-paint for Edge/IE.
     */
    function addPaintTimings(data) {
      if(!performanceEntryExists('getEntriesByName', 'function')) {
        return data;
      }

      var firstPaint = window.performance.getEntriesByName('first-paint');

      if(firstPaint.length > 0 && firstPaint[0].startTime > 0) {
        data.fp = firstPaint[0].startTime.toFixed(2); 
      } else if(window.performance.timing && !!window.performance.timing.msFirstPaint) {
        data.fp = (window.performance.timing.msFirstPaint - window.performance.timing.fetchStart).toFixed(2);
      }

      var firstContentfulPaint = window.performance.getEntriesByName('first-contentful-paint');

      if(firstContentfulPaint.length > 0 && firstContentfulPaint[0].startTime > 0) {
        data.fcp = firstContentfulPaint[0].startTime.toFixed(2); 
      }

      return data;
    }

    function getSecondaryEncodedTimingData(timing, offset) {
      var data = {
        du: maxFiveMinutes(getTimingDuration(timing)).toFixed(2),
        t: getSecondaryTimingType(timing),
        a: offset + timing.fetchStart,
      };

      if (timing.domainLookupStart && timing.domainLookupStart > 0) {
        data.b = offset + timing.domainLookupStart - data.a;
      }

      if (timing.domainLookupEnd && timing.domainLookupEnd > 0) {
        data.c = offset + timing.domainLookupEnd - data.a;
      }

      if (timing.connectStart && timing.connectStart > 0) {
        data.d = offset + timing.connectStart - data.a;
      }

      if (timing.connectEnd && timing.connectEnd > 0) {
        data.e = offset + timing.connectEnd - data.a;
      }

      if (timing.responseStart && timing.responseStart > 0) {
        data.f = offset + timing.responseStart - data.a;
      }

      if (timing.responseEnd && timing.responseEnd > 0) {
        data.g = offset + timing.responseEnd - data.a;
      }

      if (timing.secureConnectionStart && timing.secureConnectionStart > 0) {
        data.n = offset + (timing.secureConnectionStart - timing.connectStart) - data.a;
      }

      data.a = data.a.toFixed(2);
      data = sanitizeNaNs(data);

      return data;
    }

    function generateVirtualEncodedTimingData(timingData) {
      var now = getPerformanceNow(0);

      return {
        t: timingData.t,
        du: Math.min(self.maxVirtualPageDuration, now - timingData.startTime),
        o: Math.min(self.maxVirtualPageDuration, now - timingData.staticLoad),
      };
    }

    function prepareVirtualEncodedTimingData(virtualPageStartTime) {
      return {
        t: Timings.VirtualPage,
        startTime: virtualPageStartTime,
        staticLoad: self.initalStaticPageLoadTimestamp,
        pending: true,
      };
    }

    // ================================================================================
    // =                                                                              =
    // =                                Networking                                    =
    // =                                                                              =
    // ================================================================================

    function postPayload(payload, _successCallback, _errorCallback) {
      if (typeof _successCallback !== 'function') {
        _successCallback = function() {};
      }

      if (typeof _errorCallback !== 'function') {
        _errorCallback = function() {};
      }

      makePostCorsRequestRum(
        self.apiUrl + '/events?apikey=' + encodeURIComponent(self.apiKey),
        payload,
        _successCallback,
        _errorCallback
      );
    }

    function makePostCorsRequestRum(url, data, successCallback, errorCallback) {
      if (self.excludedUserAgents instanceof Array) {
        for (var userAgentIndex in self.excludedUserAgents) {
          if (self.excludedUserAgents.hasOwnProperty(userAgentIndex)) {
            if (navigator.userAgent.match(self.excludedUserAgents[userAgentIndex])) {
              log('Raygun4JS: cancelling send as error originates from an excluded user agent');
              return;
            }
          }
        }
      }

      if (self.excludedHostNames instanceof Array) {
        for (var hostIndex in self.excludedHostNames) {
          if (self.excludedHostNames.hasOwnProperty(hostIndex)) {
            if (
              window.location.hostname &&
              window.location.hostname.match(self.excludedHostNames[hostIndex])
            ) {
              log('Raygun4JS: cancelling send as error originates from an excluded hostname');

              return;
            }
          }
        }
      }

      if (navigator.userAgent.match('RaygunPulseInsightsCrawler')) {
        return;
      }

      var payload = self.beforeSend(data);
      if (!payload) {
        log('Raygun4JS: cancelling send because onBeforeSendRUM returned falsy value');
        return;
      }

      if (!!payload.eventData) {
        for (var i = 0; i < payload.eventData.length; i++) {
          if (!!payload.eventData[i].data && typeof payload.eventData[i].data !== 'string') {
            payload.eventData[i].data = JSON.stringify(payload.eventData[i].data);
          }
        }
      }

      var stringifiedPayload = JSON.stringify(payload);

      /** 
       * Use the navigator.sendBeacon method instead of a XHR requests when transmitting data
       * This occurs mostly when the document is about to be discarded or hidden as 
       * all inflight XHR requests either will be or can be canceled.
       */ 
      if (self.sendUsingNavigatorBeacon && navigator.sendBeacon) {
        navigator.sendBeacon(url, stringifiedPayload);
        return;
      } 

      makePostCorsRequest(url, stringifiedPayload, successCallback, errorCallback);
    }

    // ================================================================================
    // =                                                                              =
    // =                                  Utilities                                   =
    // =                                                                              =
    // ================================================================================

    function getTimingDuration(timing) {
      /**
       * Safari timing entries (predominantly 'fetch' types) can have a 
       * duration value of 0. 
       * 
       * This utility fallsback to using the responseEnd - startTime when 
       * that is the case.
       */
      var duration = timing.duration;

      if(duration !== 0) {
        return duration;
      }

      return timing.responseEnd - timing.startTime;
    }
    this.Utilities["getTimingDuration"] = getTimingDuration;

    function resumeCollectingMetrics() {
      if(self.stopCollectingMetrics) {
        self.offset = window.performance.getEntries().length;
        self.stopCollectingMetrics = false;
      }
    }

    /**
     * Returns true if the resources entry type is set to "measure"
     */
    function isCustomTimingMeasurement(resource) {
      return !!(resource && resource.entryType === "measure");
    }    
    this.Utilities["isCustomTimingMeasurement"] = isCustomTimingMeasurement;

    /**
     * Creates a custom timing measurement from a ResourceMeasure value passed.
     * The ResourceMeasure object passed in should be retrieved from the window.performance API
     */
    function getCustomTimingMeasurement(resource) {
      return createCustomTimingMeasurement(resource.name, resource.duration, resource.startTime);
    }
    this.Utilities["getCustomTimingMeasurement"] = getCustomTimingMeasurement;

    /**
     * Creates a custom timing measurement for a name and duration passed.
     * This can be used to create custom timings separate to the window.performance API
     */
    function createCustomTimingMeasurement(name, duration, offset) {
      return {
        url: name,
        timing: {
          t: Timings.CustomTiming,
          du: duration.toFixed(2),
          a: (offset || 0).toFixed(2)
        }
      };
    }
    this.Utilities["createCustomTimingMeasurement"] = createCustomTimingMeasurement;

    /**
     * Add to the requestMap. This marks the request as being in "flight" 
     * and stops collecting metrics until this request has completed. 
     */
    function xhrRequestHandler(request) {
      if(!this.xhrRequestMap[request.baseUrl]) {
        this.xhrRequestMap[request.baseUrl] = [];
      }

      log('adding request to xhr request map', request);

      this.xhrRequestMap[request.baseUrl].push(request);
    }
    
    /**
     * Removes the request from the requestMap so that metric collection can be resumed. 
     */
    function xhrErrorHandler(response) {
      var request = this.xhrRequestMap[response.baseUrl];

      if(request && request.length > 0) {
        this.xhrRequestMap[response.baseUrl].shift();
        log('request encountered an error', response);
      }	      
    }

    /**
     * Removes the asset from the requestMap if found and adds the response to the 
     * statusMap so that the status code can be associated with the request. 
     * 
     * If the 'captureMissingRequests' option is enabled and the timing metric is missing 
     * the duration will also be used to create a new XHR timing.    
     */
    function xhrResponseHandler(response) {
      var request = this.xhrRequestMap[response.baseUrl];

      if(request && request.length > 0) {
        this.xhrRequestMap[response.baseUrl].shift();

        if(this.xhrRequestMap[response.baseUrl].length === 0) {
          delete this.xhrRequestMap[response.baseUrl];
        }

        if (!this.xhrStatusMap[response.baseUrl]) {
          this.xhrStatusMap[response.baseUrl] = [];
        }

        log('adding response to xhr status map', response);
        this.xhrStatusMap[response.baseUrl].push(response);
      } else {
        log('response fired from non-handled request');
      }
    }	    

    function shouldIgnoreResource(resource) {
      var name = resource.name.split('?')[0];

      return shouldIgnoreResourceByName(name) || resource.entryType === "paint" || resource.entryType === "navigation" || resource.entryType === "mark";
    }

    function shouldIgnoreResourceByName(name) {
      if (name.indexOf(self.apiUrl) === 0) {
        return true;
      }
      if (name.indexOf('favicon.ico') > 0) {
        return true;
      }
      if (name.indexOf('about:blank') === 0) {
        return true;
      }
      if (name[0] === 'j' && name.indexOf('avascript:') === 1) {
        return true;
      }
      if (name.indexOf('chrome-extension://') === 0) {
        return true;
      }
      if (name.indexOf('res://') === 0) {
        return true;
      }
      if (name.indexOf('file://') === 0) {
        return true;
      }

      return false;
    }

    function sanitizeNaNs(data) {
      for (var i in data) {
        if (isNaN(data[i]) && typeof data[i] !== 'string') {
          data[i] = 0;
        }
      }

      return data;
    }

    function randomKey(length) {
      return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))
        .toString(36)
        .slice(1);
    }

    function performanceEntryExists(entry, entryType) {
      return (
        typeof window.performance === 'object' &&
        (!entry || (entry && typeof window.performance[entry] === entryType))
      );
    }

    function getPerformanceNow(fallbackValue) {
      if (performanceEntryExists('now', 'function')) {
        return window.performance.now();
      } else {
        return fallbackValue;
      }
    }

    function maxFiveMinutes(milliseconds) {
      return Math.min(milliseconds, 300000);
    }

    function log(message, data) {
      if (self.debugMode && window.console && window.console.log) {
        if (data) {
          window.console.log(message, data);
        } else {
          window.console.log(message);
        }
      }
    }

    function createTimingPayload(data) {
      return {
        sessionId: self.sessionId,
        requestId: self.requestId,
        timestamp: new Date().toISOString(),
        type: 'web_request_timing',
        user: self.user,
        version: self.version || 'Not supplied',
        device: navigator.userAgent,
        tags: self.tags,
        data: data,
      };
    }

    function createRequestId() {
      self.requestId = randomKey(16);
    }

    function saveToStorage(value) {
      var lastActivityTimestamp = new Date().toISOString();
      var updatedValue = 'id|' + value + '&timestamp|' + lastActivityTimestamp;

      if(Raygun.Utilities.localStorageAvailable()) {
        localStorage.setItem(self.cookieName, updatedValue);
      } else {
        Raygun.Utilities.createCookie(self.cookieName, updatedValue, null, self.setCookieAsSecure);
      }
    }

    function getFromStorage() {
      /**
       * Attempt to get the value from local storage, 
       * If that doesn't contain a value then try from a cookie as previous versions saved it here
       */
      var value; 

      if(Raygun.Utilities.localStorageAvailable()) {
        value = localStorage.getItem(self.cookieName);
        if(value !== null) {
          return value;
        }
      }

      if(Raygun.Utilities.sessionStorageAvailable()) {
        value = sessionStorage.getItem(self.cookieName);
        if(value !== null) {
          saveToStorage(value);
          return value;
        }
      }

      value = Raygun.Utilities.readCookie(self.cookieName);

      /**
       * If there was a cookie and localStorage is avaliable then  
       * clear the cookie as sessionStorage will be the storage mechanism going forward
       */  
      if(value !== null && Raygun.Utilities.localStorageAvailable()) {
        Raygun.Utilities.clearCookie(self.cookieName);
        localStorage.setItem(self.cookieName, value);
      }

      return value;
    }

    function readStorageElement(cookieString, element) {
      var set = cookieString.split(/[|&]/);

      if (element === 'id') {
        return set[1];
      } else if (element === 'timestamp') {
        return set[3];
      }
    }

    function getSecondaryTimingType(timing) {
      if (isXHRTiming(timing.initiatorType)) {
        return Timings.XHR;
      } else if (isChildAsset(timing)) {
        return getTypeForChildAsset(timing);
      } else if (isChromeFetchCall(timing)) {
        return Timings.XHR;
      } else {
        return getTypeForChildAsset(timing);
      }
    }

    function isXHRTiming(initiatorType) {
      return (
        initiatorType === 'xmlhttprequest' || 
        initiatorType === 'fetch' || 
        initiatorType === 'preflight' || // 'preflight' initatorType used by Edge for CORS POST/DELETE requests
        initiatorType === 'beacon' // for navigator.sendBeacon calls in Chrome/Edge. Safari doesn't record the timings and Firefox marks them as 'other' 
      ); 
    }

    function isChromeFetchCall(timing) {
      // Chrome doesn't report "initiatorType" as fetch
      return typeof timing.initiatorType === 'string' && timing.initiatorType === '';
    }

    function isChildAsset(timing) {
      switch (timing.initiatorType) {
        case 'img':
        case 'css':
        case 'script':
        case 'link':
        case 'other':
        case 'use':
          return true;
      }
      return false;
    }

    function getTypeForChildAsset(timing) {
      if (timing.duration === 0) {
        return Timings.CachedChildAsset;
      } else {
        return Timings.ChildAsset;
      }
    }

    /**
     * getCompareFunction() returns a predicate function to pass into the Array.sort() function
     * The predicate function checks for the property on each item being compared and returns the appropriate integer required by the sort function
     *
     * @param {string} property
     * @return {function} (a, b) => number
     */
    function getCompareFunction(property) {
      return function(a, b) {
        if (!a.hasOwnProperty(property) || !b.hasOwnProperty(property)) {
          log('Raygun4JS: Property "' + property + '" not found in items in this collection');
          return 0;
        }

        var propA = a[property];
        var propB = b[property];

        var comparison = 0;
        if (propA > propB) {
          comparison = 1;
        } else if (propA < propB) {
          comparison = -1;
        }
        return comparison;
      };
    }

    /**
     * sortCollectionByProperty() returns an array of objects sorted by a given property on those objects
     *
     * @param {array} collection
     * @param {string} property
     * @return {array} collection
     */
    function sortCollectionByProperty(collection, property) {
      return collection.sort(getCompareFunction(property));
    }

    _private.updateStorageTimestamp = updateStorageTimestamp;
  };
};

raygunRumFactory(window, window.jQuery, window.__instantiatedRaygun);

(function(window, Raygun) {
  if (!window['RaygunObject'] || !window[window['RaygunObject']]) {
    return;
  }

  var snippetOptions = window[window['RaygunObject']].o;
  var globalExecutorInstalled = false,
    errorQueue,
    delayedCommands = [],
    apiKey,
    options,
    attach,
    enablePulse,
    noConflict;

  var snippetOnErrorSignature = ['function (b,c,d,f,g){', '||(g=new Error(b)),a[e].q=a[e].q||[]'];

  errorQueue = window[window['RaygunObject']].q;
  var rg = Raygun;

  var delayedExecutionFunctions = ['trackEvent', 'send', 'recordBreadcrumb'];

  var parseSnippetOptions = function() {
    snippetOptions = window[window['RaygunObject']].o;

    for (var i in snippetOptions) {  
      if (snippetOptions.hasOwnProperty(i)) {  
        var pair = snippetOptions[i];  
        if (pair) {
          if (delayedExecutionFunctions.indexOf(pair[0]) === -1) {
            // Config pair, can execute immediately
            executor(pair);
          } else {
            // Action (posting) pair which requires lib to be fully parsed, delay till after Raygun obj has been init'd
            delayedCommands.push(pair);
          }
        }
      }
    }
  };

  var executor = function(pair) {
    var key = pair[0];
    var value = pair[1];

    if (key) {
      switch (key) {
        // React Native only
        case 'boot':
          onLoadHandler();
          break;
        // Immediate execution config functions
        case 'noConflict':
          noConflict = value;
          break;
        case 'apiKey':
          apiKey = value;
          break;
        case 'options':
          options = value;
          break;
        case 'attach':
        case 'enableCrashReporting':
          attach = value;
          break;
        case 'enablePulse':
          enablePulse = value;
          break;
        case 'detach':
          rg.detach();
          break;
        case 'getRaygunInstance':
          return rg;
        case 'setUser':
          rg.setUser(
            value.identifier,
            value.isAnonymous,
            value.email,
            value.fullName,
            value.firstName,
            value.uuid
          );
          break;
        case 'onBeforeSend':
          rg.onBeforeSend(value);
          break;
        case 'onBeforeSendRUM':
          rg.onBeforeSendRum(value);
          break;
        case 'onBeforeXHR':
          rg.onBeforeXHR(value);
          break;
        case 'onAfterSend':
          rg.onAfterSend(value);
          break;
        case 'withCustomData':
          rg.withCustomData(value);
          break;
        case 'withTags':
          rg.withTags(value);
          break;
        case 'setVersion':
          rg.setVersion(value);
          break;
        case 'filterSensitiveData':
          rg.filterSensitiveData(value);
          break;
        case 'setFilterScope':
          rg.setFilterScope(value);
          break;
        case 'whitelistCrossOriginDomains':
          rg.whitelistCrossOriginDomains(value);
          break;
        case 'saveIfOffline':
          if (typeof value === 'boolean') {
            rg.saveIfOffline(value);
          }
          break;
        case 'groupingKey':
          rg.groupingKey(value);
          break;
        case 'endSession':
          rg.endSession();
          break;

        // Delayed execution functions
        case 'send':
          var error, tags, customData;
          if (value.error) {
            error = value.error;

            if (value.tags) {
              tags = value.tags;
            }
            if (value.customData) {
              customData = value.customData;
            }
          } else {
            error = value;
          }
          rg.send(error, customData, tags);
          break;
        case 'trackEvent':
          if (value.type && value.path) {
            rg.trackEvent(value.type, { path: value.path });
          } else if(value.type && value.name && value.duration) {
            rg.trackEvent(value.type, { name: value.name, duration: value.duration, offset: value.offset });
          } else if (value.type && value.timings) {
            rg.trackEvent(value.type, { timings: value.timings });
          }
          break;
        case 'recordBreadcrumb':
          rg.recordBreadcrumb(pair[1], pair[2]);
          break;
        case 'enableAutoBreadcrumbs':
          rg.enableAutoBreadcrumbs();
          break;
        case 'disableAutoBreadcrumbs':
          rg.disableAutoBreadcrumbs();
          break;
        case 'enableAutoBreadcrumbsConsole':
          rg.enableAutoBreadcrumbs('Console');
          break;
        case 'disableAutoBreadcrumbsConsole':
          rg.disableAutoBreadcrumbs('Console');
          break;
        case 'enableAutoBreadcrumbsNavigation':
          rg.enableAutoBreadcrumbs('Navigation');
          break;
        case 'disableAutoBreadcrumbsNavigation':
          rg.disableAutoBreadcrumbs('Navigation');
          break;
        case 'enableAutoBreadcrumbsClicks':
          rg.enableAutoBreadcrumbs('Clicks');
          break;
        case 'disableAutoBreadcrumbsClicks':
          rg.disableAutoBreadcrumbs('Clicks');
          break;
        case 'enableAutoBreadcrumbsXHR':
          rg.enableAutoBreadcrumbs('XHR');
          break;
        case 'disableAutoBreadcrumbsXHR':
          rg.disableAutoBreadcrumbs('XHR');
          break;
        case 'setBreadcrumbLevel':
          rg.setBreadcrumbOption('breadcrumbsLevel', pair[1]);
          break;
        case 'setAutoBreadcrumbsXHRIgnoredHosts':
          rg.setBreadcrumbOption('xhrIgnoredHosts', pair[1]);
          break;
        case 'logContentsOfXhrCalls':
          rg.setBreadcrumbOption('logXhrContents', pair[1]);
          break;
        case 'clientIp':
          rg.setClientIp(value);
          break;
        case 'captureMissingRequests': 
          rg.captureMissingRequests(value);
          break;
      }
    }
  };

  var installGlobalExecutor = function() {
    window[window['RaygunObject']] = function() {
      return executor(arguments);
    };

    globalExecutorInstalled = true;
  };

  var onLoadHandler = function() {
    parseSnippetOptions();

    if (noConflict) {
      rg = Raygun.noConflict();
    }

    if (apiKey) {
      if (!options) {
        options = {};
      }

      if (enablePulse) {
        options.disablePulse = false;
      }

      options.from = 'onLoad';
      rg.init(apiKey, options, null);
    }

    if (attach) {
      rg.attach();

      errorQueue = window[window['RaygunObject']].q;
      for (var j in errorQueue) {
        rg.send(errorQueue[j].e, { handler: 'From Raygun4JS snippet global error handler' });
      }
    } else if (typeof window.onerror === 'function') {
      var onerrorSignature = window.onerror.toString();
      if (
        onerrorSignature.indexOf(snippetOnErrorSignature[0]) !== -1 &&
        onerrorSignature.indexOf(snippetOnErrorSignature[1]) !== -1
      ) {
        window.onerror = null;
      }
    }

    for (var commandIndex in delayedCommands) {
      if (delayedCommands.hasOwnProperty(commandIndex)) {
        executor(delayedCommands[commandIndex]);
      }
    }

    delayedCommands = [];

    if (!globalExecutorInstalled) {
      installGlobalExecutor();
    }

    window[window['RaygunObject']].q = errorQueue;
  };

  if (!Raygun.Utilities.isReactNative()) {
    if (document.readyState === 'complete') {
      onLoadHandler();
    } else if (window.addEventListener) {
      window.addEventListener('load', onLoadHandler);
    } else {
      window.attachEvent('onload', onLoadHandler);
    }
  } else {
    // Special case for React Native: set up the executor immediately,
    // then a manual rg4js('boot') call will trigger onLoadHandler, as the above events aren't available
    installGlobalExecutor();
  }
})(window, window.__instantiatedRaygun);

try {
  delete window.__instantiatedRaygun;
} catch (e) {
  window['__instantiatedRaygun'] = undefined;
}

    
    return window.rg4js;
}));
});

var reactHotjar = function(id, sv) {
	(function(h, o, t, j, a, r) {
		h.hj =
			h.hj ||
			function() {
				(h.hj.q = h.hj.q || []).push(arguments);
			};
		h._hjSettings = { hjid: id, hjsv: sv };
		h._scriptPath = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
		if(!document.querySelector(
			'script[src*="' + h._scriptPath + '"]'
		)){
			a = o.getElementsByTagName('head')[0];
			r = o.createElement('script');
			r.async = 1;
			r.src = h._scriptPath;
			a.appendChild(r);
		}
	})(window, document, '//static.hotjar.com/c/hotjar-', '.js?sv=');
};

var reactHotjar$1 = {
	hotjar: {
		initialize: function initialize(id, sv) {
			reactHotjar(id, sv);
		}
	}
};
var reactHotjar_1 = reactHotjar$1.hotjar;

function initRaygun() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localhost';
  var enableCrashReporting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var enablePulse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (hostname.indexOf('localhost') === -1) {
    raygun_umd('apiKey', 'Jc6lCwmwDcjImFHm5r5zA');
    raygun_umd('enableCrashReporting', enableCrashReporting);
    raygun_umd('enablePulse', enablePulse);
    raygun_umd('options', {
      disableAnonymousUserTracking: true,
      excludeHostNames: ['.local', 'localhost', 'ngrok.com']
    });
  }
} // Hotjar user interaction tracking - https://insights.hotjar.com

function initHotjar() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localhost';
  var dashboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

  if (hostname.indexOf('localhost') === -1) {
    reactHotjar_1.initialize(1470311, dashboard);
  }
}

function isUserAdmin(account) {
  return account && account.authorities && (account.authorities.indexOf('ROLE_ADMIN') > -1 || account.authorities.indexOf('ROLE_COMPANY_ADMIN') > -1);
}
function isUserLSAdmin(account) {
  return account && account.authorities.indexOf('ROLE_ADMIN') > -1;
}
function getUserAuthorities(account) {
  return account && account.authorities;
}

exports.AVAILABLE_COLORS = AVAILABLE_COLORS;
exports.AssignedCompletionRateGraph = AssignedCompletionRate;
exports.AssignmentCard = AssignmentCard;
exports.AssignmentsBanner = AssignmentsBanner;
exports.Avatar = Avatar;
exports.Banner = Banner;
exports.BottomRank = BottomRank;
exports.Button = Button;
exports.Card = Card;
exports.CardBody = CardBody;
exports.CardFooter = CardFooter;
exports.CardImage = CardImage;
exports.ConfigDropdown = ConfigDropdown;
exports.ContentFilterDropdowns = ContentFilterDropdowns;
exports.DatePicker = DatePicker;
exports.Dropdown = Drodown;
exports.Dropzone = Dropzone$1;
exports.DynamicImport = DynamicImport;
exports.EmptyPlaceholder = EmptyPlaceholder;
exports.ErrorWrapper = ErrorBoundary;
exports.GraphPlaceholder = GraphPlaceholder;
exports.HighRiskParticipantsGraph = HighRiskParticipants;
exports.IconButton = IconButton;
exports.Image = Img$1;
exports.Input = Input$2;
exports.Leaderboard = Leaderboard;
exports.LeaderboardDropdowns = LeaderboardDropdowns;
exports.LicenseDistributionGraph = LicenseDistribution;
exports.Logo = Logo;
exports.LowProgressAssignedGraph = LowProgressAssigned;
exports.Navbar = Navbar;
exports.NumAbbr = NumAbbr;
exports.PaginatedTable = PaginatedTable;
exports.ParticipantProgressGraph = ParticipantProgress;
exports.ParticipantProgressOverTimeGraph = ParticipantProgressOverTime;
exports.PercentChangeFooter = PercentChangeFooter;
exports.PercentLabel = PercentLabel;
exports.Puzzle = Puzzle;
exports.PuzzleInstructionModal = PuzzleInstructionModal;
exports.PuzzleModal = PuzzleModal;
exports.PuzzleNav = PuzzleNav;
exports.PuzzleProviders = PuzzleProviders;
exports.PuzzleStates = PuzzleStates;
exports.PuzzleWrapper = PuzzleWrapper;
exports.ReportsDatePicker = DatePicker$1;
exports.ReportsFilter = ReportsFilter;
exports.SINGLE_LIST_ITEM = SINGLE_LIST_ITEM;
exports.SecurityScoreByCategoryGraph = SecurityScoreByCategoryGraph;
exports.SecurityScoreGraph = SecurityScoreGraph;
exports.SecurityScoreLegend = SecurityScoreLegend;
exports.SecurityScoreOverTimeGraph = SecurityScoreOverTime;
exports.Spinner = Spinner;
exports.Subnav = Subnav;
exports.SubnavItem = SubnavItem;
exports.SubnavSection = SubnavTitle;
exports.SubnavTitle = SubnavTitle$1;
exports.Switcher = Switcher;
exports.TableActionSidebar = TableActionSidebar;
exports.Textarea = index$1;
exports.ToggleBar = ToggleBar;
exports.UserStats = UserStats;
exports.detectMobile = detectMobile;
exports.getRandomInt = getRandomInt$1;
exports.getUserAuthorities = getUserAuthorities;
exports.initHotjar = initHotjar;
exports.initRaygun = initRaygun;
exports.isMobile = isMobile;
exports.isUserAdmin = isUserAdmin;
exports.isUserLSAdmin = isUserLSAdmin;
exports.useInterval = useInterval;
exports.useOutsideClick = useOutsideClickHook;
exports.useTimer = useTimer;
exports.useToggleBoolean = useToggleBoolean;
//# sourceMappingURL=index.js.map
